/**
 * This file is generated. Do not modify it manually.
 *
 * @generated Codelock<<xap+kVl8Zhf0I/iR0Tnk4rXBHyDQndwB>>
 */

const p = (city, state) => ({ city, state });
const map = {
  "99553": p("AK", "Akutan"),
  "99571": p("AK", "Cold Bay"),
  "99583": p("AK", "False Pass"),
  "99612": p("AK", "King Cove"),
  "99661": p("AK", "Sand Point"),
  "99546": p("AK", "Adak"),
  "99547": p("AK", "Atka"),
  "99591": p("AK", "Saint George Island"),
  "99638": p("AK", "Nikolski"),
  "99660": p("AK", "Saint Paul Island"),
  "99685": p("AK", "Unalaska"),
  "99692": p("AK", "Dutch Harbor"),
  "99501": p("AK", "Anchorage"),
  "99502": p("AK", "Anchorage"),
  "99503": p("AK", "Anchorage"),
  "99504": p("AK", "Anchorage"),
  "99505": p("AK", "Jber"),
  "99506": p("AK", "Jber"),
  "99507": p("AK", "Anchorage"),
  "99508": p("AK", "Anchorage"),
  "99509": p("AK", "Anchorage"),
  "99510": p("AK", "Anchorage"),
  "99511": p("AK", "Anchorage"),
  "99513": p("AK", "Anchorage"),
  "99514": p("AK", "Anchorage"),
  "99515": p("AK", "Anchorage"),
  "99516": p("AK", "Anchorage"),
  "99517": p("AK", "Anchorage"),
  "99518": p("AK", "Anchorage"),
  "99519": p("AK", "Anchorage"),
  "99520": p("AK", "Anchorage"),
  "99521": p("AK", "Anchorage"),
  "99522": p("AK", "Anchorage"),
  "99523": p("AK", "Anchorage"),
  "99524": p("AK", "Anchorage"),
  "99529": p("AK", "Anchorage"),
  "99530": p("AK", "Anchorage"),
  "99540": p("AK", "Indian"),
  "99567": p("AK", "Chugiak"),
  "99577": p("AK", "Eagle River"),
  "99587": p("AK", "Girdwood"),
  "99599": p("AK", "Anchorage"),
  "99695": p("AK", "Anchorage"),
  "99545": p("AK", "Kongiganak"),
  "99551": p("AK", "Akiachak"),
  "99552": p("AK", "Akiak"),
  "99557": p("AK", "Aniak"),
  "99559": p("AK", "Bethel"),
  "99561": p("AK", "Chefornak"),
  "99575": p("AK", "Crooked Creek"),
  "99578": p("AK", "Eek"),
  "99589": p("AK", "Goodnews Bay"),
  "99607": p("AK", "Kalskag"),
  "99609": p("AK", "Kasigluk"),
  "99614": p("AK", "Kipnuk"),
  "99621": p("AK", "Kwethluk"),
  "99622": p("AK", "Kwigillingok"),
  "99626": p("AK", "Lower Kalskag"),
  "99630": p("AK", "Mekoryuk"),
  "99634": p("AK", "Napakiak"),
  "99637": p("AK", "Toksook Bay"),
  "99641": p("AK", "Nunapitchuk"),
  "99651": p("AK", "Platinum"),
  "99655": p("AK", "Quinhagak"),
  "99656": p("AK", "Red Devil"),
  "99668": p("AK", "Sleetmute"),
  "99679": p("AK", "Tuluksak"),
  "99680": p("AK", "Tuntutuliak"),
  "99681": p("AK", "Tununak"),
  "99690": p("AK", "Nightmute"),
  "99613": p("AK", "King Salmon"),
  "99633": p("AK", "Naknek"),
  "99670": p("AK", "South Naknek"),
  "99704": p("AK", "Clear"),
  "99729": p("AK", "Cantwell"),
  "99743": p("AK", "Healy"),
  "99744": p("AK", "Anderson"),
  "99755": p("AK", "Denali National Park"),
  "99555": p("AK", "Aleknagik"),
  "99569": p("AK", "Clarks Point"),
  "99576": p("AK", "Dillingham"),
  "99580": p("AK", "Ekwok"),
  "99628": p("AK", "Manokotak"),
  "99636": p("AK", "New Stuyahok"),
  "99678": p("AK", "Togiak"),
  "99701": p("AK", "Fairbanks"),
  "99702": p("AK", "Eielson Afb"),
  "99703": p("AK", "Fort Wainwright"),
  "99705": p("AK", "North Pole"),
  "99706": p("AK", "Fairbanks"),
  "99707": p("AK", "Fairbanks"),
  "99708": p("AK", "Fairbanks"),
  "99709": p("AK", "Fairbanks"),
  "99710": p("AK", "Fairbanks"),
  "99711": p("AK", "Fairbanks"),
  "99712": p("AK", "Fairbanks"),
  "99714": p("AK", "Salcha"),
  "99716": p("AK", "Two Rivers"),
  "99725": p("AK", "Ester"),
  "99775": p("AK", "Fairbanks"),
  "99790": p("AK", "Fairbanks"),
  "99827": p("AK", "Haines"),
  "99801": p("AK", "Juneau"),
  "99802": p("AK", "Juneau"),
  "99803": p("AK", "Juneau"),
  "99811": p("AK", "Juneau"),
  "99812": p("AK", "Juneau"),
  "99821": p("AK", "Auke Bay"),
  "99824": p("AK", "Douglas"),
  "99850": p("AK", "Juneau"),
  "99556": p("AK", "Anchor Point"),
  "99568": p("AK", "Clam Gulch"),
  "99572": p("AK", "Cooper Landing"),
  "99603": p("AK", "Homer"),
  "99605": p("AK", "Hope"),
  "99610": p("AK", "Kasilof"),
  "99611": p("AK", "Kenai"),
  "99631": p("AK", "Moose Pass"),
  "99635": p("AK", "Nikiski"),
  "99639": p("AK", "Ninilchik"),
  "99663": p("AK", "Seldovia"),
  "99664": p("AK", "Seward"),
  "99669": p("AK", "Soldotna"),
  "99672": p("AK", "Sterling"),
  "99682": p("AK", "Tyonek"),
  "99901": p("AK", "Ketchikan"),
  "99928": p("AK", "Ward Cove"),
  "99950": p("AK", "Ketchikan"),
  "99550": p("AK", "Port Lions"),
  "99608": p("AK", "Karluk"),
  "99615": p("AK", "Kodiak"),
  "99619": p("AK", "Kodiak"),
  "99624": p("AK", "Larsen Bay"),
  "99643": p("AK", "Old Harbor"),
  "99644": p("AK", "Ouzinkie"),
  "99697": p("AK", "Kodiak"),
  "99554": p("AK", "Alakanuk"),
  "99563": p("AK", "Chevak"),
  "99581": p("AK", "Emmonak"),
  "99585": p("AK", "Marshall"),
  "99604": p("AK", "Hooper Bay"),
  "99620": p("AK", "Kotlik"),
  "99632": p("AK", "Mountain Village"),
  "99650": p("AK", "Pilot Station"),
  "99657": p("AK", "Russian Mission"),
  "99658": p("AK", "Saint Marys"),
  "99662": p("AK", "Scammon Bay"),
  "99666": p("AK", "Nunam Iqua"),
  "99548": p("AK", "Chignik Lake"),
  "99549": p("AK", "Port Heiden"),
  "99564": p("AK", "Chignik"),
  "99565": p("AK", "Chignik Lagoon"),
  "99579": p("AK", "Egegik"),
  "99606": p("AK", "Iliamna"),
  "99625": p("AK", "Levelock"),
  "99640": p("AK", "Nondalton"),
  "99647": p("AK", "Pedro Bay"),
  "99648": p("AK", "Perryville"),
  "99649": p("AK", "Pilot Point"),
  "99653": p("AK", "Port Alsworth"),
  "99623": p("AK", "Wasilla"),
  "99629": p("AK", "Wasilla"),
  "99645": p("AK", "Palmer"),
  "99652": p("AK", "Big Lake"),
  "99654": p("AK", "Wasilla"),
  "99667": p("AK", "Skwentna"),
  "99674": p("AK", "Sutton"),
  "99676": p("AK", "Talkeetna"),
  "99683": p("AK", "Trapper Creek"),
  "99687": p("AK", "Wasilla"),
  "99688": p("AK", "Willow"),
  "99694": p("AK", "Houston"),
  "99659": p("AK", "Saint Michael"),
  "99671": p("AK", "Stebbins"),
  "99684": p("AK", "Unalakleet"),
  "99739": p("AK", "Elim"),
  "99742": p("AK", "Gambell"),
  "99753": p("AK", "Koyuk"),
  "99762": p("AK", "Nome"),
  "99769": p("AK", "Savoonga"),
  "99771": p("AK", "Shaktoolik"),
  "99772": p("AK", "Shishmaref"),
  "99778": p("AK", "Teller"),
  "99783": p("AK", "Wales"),
  "99784": p("AK", "White Mountain"),
  "99785": p("AK", "Brevig Mission"),
  "99721": p("AK", "Anaktuvuk Pass"),
  "99723": p("AK", "Barrow"),
  "99734": p("AK", "Prudhoe Bay"),
  "99747": p("AK", "Kaktovik"),
  "99759": p("AK", "Point Lay"),
  "99766": p("AK", "Point Hope"),
  "99782": p("AK", "Wainwright"),
  "99789": p("AK", "Nuiqsut"),
  "99791": p("AK", "Atqasuk"),
  "99727": p("AK", "Buckland"),
  "99736": p("AK", "Deering"),
  "99749": p("AK", "Kiana"),
  "99750": p("AK", "Kivalina"),
  "99751": p("AK", "Kobuk"),
  "99752": p("AK", "Kotzebue"),
  "99761": p("AK", "Noatak"),
  "99763": p("AK", "Noorvik"),
  "99770": p("AK", "Selawik"),
  "99773": p("AK", "Shungnak"),
  "99786": p("AK", "Ambler"),
  "99903": p("AK", "Meyers Chuck"),
  "99918": p("AK", "Coffman Cove"),
  "99919": p("AK", "Thorne Bay"),
  "99921": p("AK", "Craig"),
  "99922": p("AK", "Hydaburg"),
  "99923": p("AK", "Hyder"),
  "99925": p("AK", "Klawock"),
  "99926": p("AK", "Metlakatla"),
  "99927": p("AK", "Point Baker"),
  "99835": p("AK", "Sitka"),
  "99689": p("AK", "Yakutat"),
  "99820": p("AK", "Angoon"),
  "99825": p("AK", "Elfin Cove"),
  "99826": p("AK", "Gustavus"),
  "99829": p("AK", "Hoonah"),
  "99832": p("AK", "Pelican"),
  "99840": p("AK", "Skagway"),
  "99841": p("AK", "Tenakee Springs"),
  "99731": p("AK", "Fort Greely"),
  "99732": p("AK", "Chicken"),
  "99737": p("AK", "Delta Junction"),
  "99738": p("AK", "Eagle"),
  "99764": p("AK", "Northway"),
  "99776": p("AK", "Tanacross"),
  "99780": p("AK", "Tok"),
  "99566": p("AK", "Chitina"),
  "99573": p("AK", "Copper Center"),
  "99574": p("AK", "Cordova"),
  "99586": p("AK", "Gakona"),
  "99588": p("AK", "Glennallen"),
  "99677": p("AK", "Tatitlek"),
  "99686": p("AK", "Valdez"),
  "99693": p("AK", "Whittier"),
  "99830": p("AK", "Kake"),
  "99833": p("AK", "Petersburg"),
  "99836": p("AK", "Port Alexander"),
  "99929": p("AK", "Wrangell"),
  "99558": p("AK", "Anvik"),
  "99590": p("AK", "Grayling"),
  "99602": p("AK", "Holy Cross"),
  "99627": p("AK", "Mc Grath"),
  "99665": p("AK", "Shageluk"),
  "99675": p("AK", "Takotna"),
  "99691": p("AK", "Nikolai"),
  "99720": p("AK", "Allakaket"),
  "99722": p("AK", "Arctic Village"),
  "99724": p("AK", "Beaver"),
  "99726": p("AK", "Bettles Field"),
  "99730": p("AK", "Central"),
  "99733": p("AK", "Circle"),
  "99740": p("AK", "Fort Yukon"),
  "99741": p("AK", "Galena"),
  "99745": p("AK", "Hughes"),
  "99746": p("AK", "Huslia"),
  "99748": p("AK", "Kaltag"),
  "99754": p("AK", "Koyukuk"),
  "99756": p("AK", "Manley Hot Springs"),
  "99757": p("AK", "Lake Minchumina"),
  "99758": p("AK", "Minto"),
  "99760": p("AK", "Nenana"),
  "99765": p("AK", "Nulato"),
  "99767": p("AK", "Rampart"),
  "99768": p("AK", "Ruby"),
  "99774": p("AK", "Stevens Village"),
  "99777": p("AK", "Tanana"),
  "99781": p("AK", "Venetie"),
  "99788": p("AK", "Chalkyitsik"),
  "36003": p("AL", "Autaugaville"),
  "36006": p("AL", "Billingsley"),
  "36008": p("AL", "Booth"),
  "36051": p("AL", "Marbury"),
  "36066": p("AL", "Prattville"),
  "36067": p("AL", "Prattville"),
  "36068": p("AL", "Prattville"),
  "36749": p("AL", "Jones"),
  "36507": p("AL", "Bay Minette"),
  "36511": p("AL", "Bon Secour"),
  "36526": p("AL", "Daphne"),
  "36527": p("AL", "Spanish Fort"),
  "36530": p("AL", "Elberta"),
  "36532": p("AL", "Fairhope"),
  "36533": p("AL", "Fairhope"),
  "36535": p("AL", "Foley"),
  "36536": p("AL", "Foley"),
  "36542": p("AL", "Gulf Shores"),
  "36547": p("AL", "Gulf Shores"),
  "36549": p("AL", "Lillian"),
  "36550": p("AL", "Little River"),
  "36551": p("AL", "Loxley"),
  "36555": p("AL", "Magnolia Springs"),
  "36559": p("AL", "Montrose"),
  "36561": p("AL", "Orange Beach"),
  "36562": p("AL", "Perdido"),
  "36564": p("AL", "Point Clear"),
  "36567": p("AL", "Robertsdale"),
  "36574": p("AL", "Seminole"),
  "36576": p("AL", "Silverhill"),
  "36577": p("AL", "Spanish Fort"),
  "36578": p("AL", "Stapleton"),
  "36579": p("AL", "Stockton"),
  "36580": p("AL", "Summerdale"),
  "36016": p("AL", "Clayton"),
  "36017": p("AL", "Clio"),
  "36027": p("AL", "Eufaula"),
  "36048": p("AL", "Louisville"),
  "36072": p("AL", "Eufaula"),
  "35034": p("AL", "Brent"),
  "35035": p("AL", "Brierfield"),
  "35042": p("AL", "Centreville"),
  "35074": p("AL", "Green Pond"),
  "35184": p("AL", "West Blocton"),
  "35188": p("AL", "Woodstock"),
  "36792": p("AL", "Randolph"),
  "36793": p("AL", "Lawley"),
  "35013": p("AL", "Allgood"),
  "35031": p("AL", "Blountsville"),
  "35049": p("AL", "Cleveland"),
  "35079": p("AL", "Hayden"),
  "35097": p("AL", "Locust Fork"),
  "35121": p("AL", "Oneonta"),
  "35133": p("AL", "Remlap"),
  "36029": p("AL", "Fitzpatrick"),
  "36053": p("AL", "Midway"),
  "36061": p("AL", "Perote"),
  "36089": p("AL", "Union Springs"),
  "36015": p("AL", "Chapman"),
  "36030": p("AL", "Forest Home"),
  "36033": p("AL", "Georgiana"),
  "36037": p("AL", "Greenville"),
  "36456": p("AL", "Mc Kenzie"),
  "36201": p("AL", "Anniston"),
  "36202": p("AL", "Anniston"),
  "36203": p("AL", "Oxford"),
  "36204": p("AL", "Anniston"),
  "36205": p("AL", "Anniston"),
  "36206": p("AL", "Anniston"),
  "36207": p("AL", "Anniston"),
  "36250": p("AL", "Alexandria"),
  "36253": p("AL", "Bynum"),
  "36254": p("AL", "Choccolocco"),
  "36257": p("AL", "De Armanville"),
  "36260": p("AL", "Eastaboga"),
  "36265": p("AL", "Jacksonville"),
  "36271": p("AL", "Ohatchee"),
  "36272": p("AL", "Piedmont"),
  "36277": p("AL", "Weaver"),
  "36279": p("AL", "Wellington"),
  "36852": p("AL", "Cusseta"),
  "36854": p("AL", "Valley"),
  "36855": p("AL", "Five Points"),
  "36862": p("AL", "Lafayette"),
  "36863": p("AL", "Lanett"),
  "35959": p("AL", "Cedar Bluff"),
  "35960": p("AL", "Centre"),
  "35973": p("AL", "Gaylesville"),
  "35983": p("AL", "Leesburg"),
  "36275": p("AL", "Spring Garden"),
  "35045": p("AL", "Clanton"),
  "35046": p("AL", "Clanton"),
  "35085": p("AL", "Jemison"),
  "35171": p("AL", "Thorsby"),
  "36091": p("AL", "Verbena"),
  "36750": p("AL", "Maplesville"),
  "36790": p("AL", "Stanton"),
  "36904": p("AL", "Butler"),
  "36908": p("AL", "Gilbertown"),
  "36910": p("AL", "Jachin"),
  "36912": p("AL", "Lisman"),
  "36913": p("AL", "Melvin"),
  "36915": p("AL", "Needham"),
  "36916": p("AL", "Pennington"),
  "36919": p("AL", "Silas"),
  "36921": p("AL", "Toxey"),
  "36922": p("AL", "Ward"),
  "36436": p("AL", "Dickinson"),
  "36446": p("AL", "Fulton"),
  "36451": p("AL", "Grove Hill"),
  "36482": p("AL", "Whatley"),
  "36524": p("AL", "Coffeeville"),
  "36540": p("AL", "Gainestown"),
  "36545": p("AL", "Jackson"),
  "36727": p("AL", "Campbell"),
  "36784": p("AL", "Thomasville"),
  "35082": p("AL", "Hollins"),
  "36251": p("AL", "Ashland"),
  "36255": p("AL", "Cragford"),
  "36258": p("AL", "Delta"),
  "36266": p("AL", "Lineville"),
  "36267": p("AL", "Millerville"),
  "36261": p("AL", "Edwardsville"),
  "36262": p("AL", "Fruithurst"),
  "36264": p("AL", "Heflin"),
  "36269": p("AL", "Muscadine"),
  "36273": p("AL", "Ranburne"),
  "36323": p("AL", "Elba"),
  "36330": p("AL", "Enterprise"),
  "36331": p("AL", "Enterprise"),
  "36346": p("AL", "Jack"),
  "36351": p("AL", "New Brockton"),
  "36453": p("AL", "Kinston"),
  "35616": p("AL", "Cherokee"),
  "35646": p("AL", "Leighton"),
  "35660": p("AL", "Sheffield"),
  "35661": p("AL", "Muscle Shoals"),
  "35662": p("AL", "Muscle Shoals"),
  "35674": p("AL", "Tuscumbia"),
  "36401": p("AL", "Evergreen"),
  "36429": p("AL", "Brooklyn"),
  "36432": p("AL", "Castleberry"),
  "36454": p("AL", "Lenox"),
  "36473": p("AL", "Range"),
  "36475": p("AL", "Repton"),
  "35072": p("AL", "Goodwater"),
  "35089": p("AL", "Kellyton"),
  "35136": p("AL", "Rockford"),
  "35183": p("AL", "Weogufka"),
  "36026": p("AL", "Equality"),
  "36038": p("AL", "Gantt"),
  "36420": p("AL", "Andalusia"),
  "36442": p("AL", "Florala"),
  "36455": p("AL", "Lockhart"),
  "36467": p("AL", "Opp"),
  "36474": p("AL", "Red Level"),
  "36476": p("AL", "River Falls"),
  "36483": p("AL", "Wing"),
  "36009": p("AL", "Brantley"),
  "36028": p("AL", "Dozier"),
  "36034": p("AL", "Glenwood"),
  "36041": p("AL", "Highland Home"),
  "36042": p("AL", "Honoraville"),
  "36049": p("AL", "Luverne"),
  "36062": p("AL", "Petrey"),
  "36071": p("AL", "Rutledge"),
  "35019": p("AL", "Baileyton"),
  "35033": p("AL", "Bremen"),
  "35053": p("AL", "Crane Hill"),
  "35055": p("AL", "Cullman"),
  "35056": p("AL", "Cullman"),
  "35057": p("AL", "Cullman"),
  "35058": p("AL", "Cullman"),
  "35070": p("AL", "Garden City"),
  "35077": p("AL", "Hanceville"),
  "35083": p("AL", "Holly Pond"),
  "35087": p("AL", "Joppa"),
  "35098": p("AL", "Logan"),
  "35179": p("AL", "Vinemont"),
  "36311": p("AL", "Ariton"),
  "36317": p("AL", "Clopton"),
  "36322": p("AL", "Daleville"),
  "36350": p("AL", "Midland City"),
  "36352": p("AL", "Newton"),
  "36360": p("AL", "Ozark"),
  "36361": p("AL", "Ozark"),
  "36362": p("AL", "Fort Rucker"),
  "36371": p("AL", "Pinckard"),
  "36374": p("AL", "Skipperville"),
  "36701": p("AL", "Selma"),
  "36702": p("AL", "Selma"),
  "36703": p("AL", "Selma"),
  "36758": p("AL", "Plantersville"),
  "36759": p("AL", "Marion Junction"),
  "36761": p("AL", "Minter"),
  "36767": p("AL", "Orrville"),
  "36773": p("AL", "Safford"),
  "36775": p("AL", "Sardis"),
  "36785": p("AL", "Tyler"),
  "35961": p("AL", "Collinsville"),
  "35962": p("AL", "Crossville"),
  "35963": p("AL", "Dawson"),
  "35967": p("AL", "Fort Payne"),
  "35968": p("AL", "Fort Payne"),
  "35971": p("AL", "Fyffe"),
  "35974": p("AL", "Geraldine"),
  "35975": p("AL", "Groveoak"),
  "35978": p("AL", "Henagar"),
  "35981": p("AL", "Ider"),
  "35984": p("AL", "Mentone"),
  "35986": p("AL", "Rainsville"),
  "35988": p("AL", "Sylvania"),
  "35989": p("AL", "Valley Head"),
  "36020": p("AL", "Coosada"),
  "36022": p("AL", "Deatsville"),
  "36024": p("AL", "Eclectic"),
  "36025": p("AL", "Elmore"),
  "36045": p("AL", "Kent"),
  "36054": p("AL", "Millbrook"),
  "36078": p("AL", "Tallassee"),
  "36080": p("AL", "Titus"),
  "36092": p("AL", "Wetumpka"),
  "36093": p("AL", "Wetumpka"),
  "36426": p("AL", "Brewton"),
  "36427": p("AL", "Brewton"),
  "36441": p("AL", "Flomaton"),
  "36502": p("AL", "Atmore"),
  "36503": p("AL", "Atmore"),
  "36504": p("AL", "Atmore"),
  "36543": p("AL", "Huxford"),
  "35901": p("AL", "Gadsden"),
  "35902": p("AL", "Gadsden"),
  "35903": p("AL", "Gadsden"),
  "35904": p("AL", "Gadsden"),
  "35905": p("AL", "Gadsden"),
  "35906": p("AL", "Rainbow City"),
  "35907": p("AL", "Gadsden"),
  "35952": p("AL", "Altoona"),
  "35954": p("AL", "Attalla"),
  "35972": p("AL", "Gallant"),
  "35990": p("AL", "Walnut Grove"),
  "35542": p("AL", "Bankston"),
  "35545": p("AL", "Belk"),
  "35546": p("AL", "Berry"),
  "35555": p("AL", "Fayette"),
  "35559": p("AL", "Glen Allen"),
  "35571": p("AL", "Hodges"),
  "35581": p("AL", "Phil Campbell"),
  "35582": p("AL", "Red Bay"),
  "35585": p("AL", "Spruce Pine"),
  "35593": p("AL", "Vina"),
  "35653": p("AL", "Russellville"),
  "35654": p("AL", "Russellville"),
  "36313": p("AL", "Bellwood"),
  "36314": p("AL", "Black"),
  "36316": p("AL", "Chancellor"),
  "36318": p("AL", "Coffee Springs"),
  "36340": p("AL", "Geneva"),
  "36344": p("AL", "Hartford"),
  "36349": p("AL", "Malvern"),
  "36375": p("AL", "Slocomb"),
  "36477": p("AL", "Samson"),
  "35443": p("AL", "Boligee"),
  "35448": p("AL", "Clinton"),
  "35462": p("AL", "Eutaw"),
  "35469": p("AL", "Knoxville"),
  "35491": p("AL", "West Greene"),
  "36740": p("AL", "Forkland"),
  "35441": p("AL", "Akron"),
  "35474": p("AL", "Moundville"),
  "36742": p("AL", "Gallion"),
  "36744": p("AL", "Greensboro"),
  "36765": p("AL", "Newbern"),
  "36776": p("AL", "Sawyerville"),
  "36310": p("AL", "Abbeville"),
  "36345": p("AL", "Headland"),
  "36353": p("AL", "Newville"),
  "36373": p("AL", "Shorterville"),
  "36301": p("AL", "Dothan"),
  "36302": p("AL", "Dothan"),
  "36303": p("AL", "Dothan"),
  "36304": p("AL", "Dothan"),
  "36305": p("AL", "Dothan"),
  "36312": p("AL", "Ashford"),
  "36319": p("AL", "Columbia"),
  "36320": p("AL", "Cottonwood"),
  "36321": p("AL", "Cowarts"),
  "36343": p("AL", "Gordon"),
  "36370": p("AL", "Pansey"),
  "36376": p("AL", "Webb"),
  "35740": p("AL", "Bridgeport"),
  "35744": p("AL", "Dutton"),
  "35745": p("AL", "Estillfork"),
  "35746": p("AL", "Fackler"),
  "35751": p("AL", "Hollytree"),
  "35752": p("AL", "Hollywood"),
  "35755": p("AL", "Langston"),
  "35764": p("AL", "Paint Rock"),
  "35765": p("AL", "Pisgah"),
  "35766": p("AL", "Princeton"),
  "35768": p("AL", "Scottsboro"),
  "35769": p("AL", "Scottsboro"),
  "35771": p("AL", "Section"),
  "35772": p("AL", "Stevenson"),
  "35774": p("AL", "Trenton"),
  "35776": p("AL", "Woodville"),
  "35958": p("AL", "Bryant"),
  "35966": p("AL", "Flat Rock"),
  "35979": p("AL", "Higdon"),
  "35005": p("AL", "Adamsville"),
  "35006": p("AL", "Adger"),
  "35015": p("AL", "Alton"),
  "35020": p("AL", "Bessemer"),
  "35021": p("AL", "Bessemer"),
  "35022": p("AL", "Bessemer"),
  "35023": p("AL", "Bessemer"),
  "35036": p("AL", "Brookside"),
  "35048": p("AL", "Clay"),
  "35060": p("AL", "Docena"),
  "35061": p("AL", "Dolomite"),
  "35064": p("AL", "Fairfield"),
  "35068": p("AL", "Fultondale"),
  "35071": p("AL", "Gardendale"),
  "35073": p("AL", "Graysville"),
  "35091": p("AL", "Kimberly"),
  "35094": p("AL", "Leeds"),
  "35111": p("AL", "Mc Calla"),
  "35116": p("AL", "Morris"),
  "35117": p("AL", "Mount Olive"),
  "35118": p("AL", "Mulga"),
  "35119": p("AL", "New Castle"),
  "35123": p("AL", "Palmerdale"),
  "35126": p("AL", "Pinson"),
  "35127": p("AL", "Pleasant Grove"),
  "35139": p("AL", "Sayre"),
  "35142": p("AL", "Shannon"),
  "35172": p("AL", "Trafford"),
  "35173": p("AL", "Trussville"),
  "35180": p("AL", "Warrior"),
  "35181": p("AL", "Watson"),
  "35201": p("AL", "Birmingham"),
  "35202": p("AL", "Birmingham"),
  "35203": p("AL", "Birmingham"),
  "35204": p("AL", "Birmingham"),
  "35205": p("AL", "Birmingham"),
  "35206": p("AL", "Birmingham"),
  "35207": p("AL", "Birmingham"),
  "35208": p("AL", "Birmingham"),
  "35209": p("AL", "Birmingham"),
  "35210": p("AL", "Birmingham"),
  "35211": p("AL", "Birmingham"),
  "35212": p("AL", "Birmingham"),
  "35213": p("AL", "Birmingham"),
  "35214": p("AL", "Birmingham"),
  "35215": p("AL", "Birmingham"),
  "35216": p("AL", "Birmingham"),
  "35217": p("AL", "Birmingham"),
  "35218": p("AL", "Birmingham"),
  "35219": p("AL", "Birmingham"),
  "35220": p("AL", "Birmingham"),
  "35221": p("AL", "Birmingham"),
  "35222": p("AL", "Birmingham"),
  "35223": p("AL", "Birmingham"),
  "35224": p("AL", "Birmingham"),
  "35226": p("AL", "Birmingham"),
  "35228": p("AL", "Birmingham"),
  "35229": p("AL", "Birmingham"),
  "35231": p("AL", "Birmingham"),
  "35232": p("AL", "Birmingham"),
  "35233": p("AL", "Birmingham"),
  "35234": p("AL", "Birmingham"),
  "35235": p("AL", "Birmingham"),
  "35236": p("AL", "Birmingham"),
  "35237": p("AL", "Birmingham"),
  "35238": p("AL", "Birmingham"),
  "35243": p("AL", "Birmingham"),
  "35244": p("AL", "Birmingham"),
  "35246": p("AL", "Birmingham"),
  "35249": p("AL", "Birmingham"),
  "35253": p("AL", "Birmingham"),
  "35254": p("AL", "Birmingham"),
  "35255": p("AL", "Birmingham"),
  "35259": p("AL", "Birmingham"),
  "35260": p("AL", "Birmingham"),
  "35261": p("AL", "Birmingham"),
  "35266": p("AL", "Birmingham"),
  "35270": p("AL", "Birmingham"),
  "35282": p("AL", "Birmingham"),
  "35283": p("AL", "Birmingham"),
  "35285": p("AL", "Birmingham"),
  "35287": p("AL", "Birmingham"),
  "35288": p("AL", "Birmingham"),
  "35290": p("AL", "Birmingham"),
  "35291": p("AL", "Birmingham"),
  "35292": p("AL", "Birmingham"),
  "35293": p("AL", "Birmingham"),
  "35294": p("AL", "Birmingham"),
  "35295": p("AL", "Birmingham"),
  "35296": p("AL", "Birmingham"),
  "35297": p("AL", "Birmingham"),
  "35298": p("AL", "Birmingham"),
  "35544": p("AL", "Beaverton"),
  "35552": p("AL", "Detroit"),
  "35574": p("AL", "Kennedy"),
  "35576": p("AL", "Millport"),
  "35586": p("AL", "Sulligent"),
  "35592": p("AL", "Vernon"),
  "35610": p("AL", "Anderson"),
  "35617": p("AL", "Cloverdale"),
  "35630": p("AL", "Florence"),
  "35631": p("AL", "Florence"),
  "35632": p("AL", "Florence"),
  "35633": p("AL", "Florence"),
  "35634": p("AL", "Florence"),
  "35645": p("AL", "Killen"),
  "35648": p("AL", "Lexington"),
  "35652": p("AL", "Rogersville"),
  "35677": p("AL", "Waterloo"),
  "35618": p("AL", "Courtland"),
  "35643": p("AL", "Hillsboro"),
  "35650": p("AL", "Moulton"),
  "35651": p("AL", "Mount Hope"),
  "35672": p("AL", "Town Creek"),
  "36801": p("AL", "Opelika"),
  "36802": p("AL", "Opelika"),
  "36803": p("AL", "Opelika"),
  "36804": p("AL", "Opelika"),
  "36830": p("AL", "Auburn"),
  "36831": p("AL", "Auburn"),
  "36832": p("AL", "Auburn"),
  "36849": p("AL", "Auburn University"),
  "36865": p("AL", "Loachapoka"),
  "36872": p("AL", "Valley"),
  "36874": p("AL", "Salem"),
  "36877": p("AL", "Smiths Station"),
  "36879": p("AL", "Waverly"),
  "35611": p("AL", "Athens"),
  "35612": p("AL", "Athens"),
  "35613": p("AL", "Athens"),
  "35614": p("AL", "Athens"),
  "35615": p("AL", "Belle Mina"),
  "35620": p("AL", "Elkmont"),
  "35647": p("AL", "Lester"),
  "35649": p("AL", "Mooresville"),
  "35671": p("AL", "Tanner"),
  "35739": p("AL", "Ardmore"),
  "35742": p("AL", "Capshaw"),
  "36032": p("AL", "Fort Deposit"),
  "36040": p("AL", "Hayneville"),
  "36047": p("AL", "Letohatchee"),
  "36752": p("AL", "Lowndesboro"),
  "36031": p("AL", "Fort Davis"),
  "36039": p("AL", "Hardaway"),
  "36075": p("AL", "Shorter"),
  "36083": p("AL", "Tuskegee"),
  "36087": p("AL", "Tuskegee Institute"),
  "36088": p("AL", "Tuskegee Institute"),
  "36866": p("AL", "Notasulga"),
  "35741": p("AL", "Brownsboro"),
  "35748": p("AL", "Gurley"),
  "35749": p("AL", "Harvest"),
  "35750": p("AL", "Hazel Green"),
  "35756": p("AL", "Madison"),
  "35757": p("AL", "Madison"),
  "35758": p("AL", "Madison"),
  "35759": p("AL", "Meridianville"),
  "35760": p("AL", "New Hope"),
  "35761": p("AL", "New Market"),
  "35762": p("AL", "Normal"),
  "35763": p("AL", "Owens Cross Roads"),
  "35767": p("AL", "Ryland"),
  "35773": p("AL", "Toney"),
  "35801": p("AL", "Huntsville"),
  "35802": p("AL", "Huntsville"),
  "35803": p("AL", "Huntsville"),
  "35804": p("AL", "Huntsville"),
  "35805": p("AL", "Huntsville"),
  "35806": p("AL", "Huntsville"),
  "35807": p("AL", "Huntsville"),
  "35808": p("AL", "Huntsville"),
  "35809": p("AL", "Huntsville"),
  "35810": p("AL", "Huntsville"),
  "35811": p("AL", "Huntsville"),
  "35812": p("AL", "Huntsville"),
  "35813": p("AL", "Huntsville"),
  "35814": p("AL", "Huntsville"),
  "35815": p("AL", "Huntsville"),
  "35816": p("AL", "Huntsville"),
  "35824": p("AL", "Huntsville"),
  "35893": p("AL", "Huntsville"),
  "35894": p("AL", "Huntsville"),
  "35895": p("AL", "Huntsville"),
  "35896": p("AL", "Huntsville"),
  "35897": p("AL", "Huntsville"),
  "35898": p("AL", "Huntsville"),
  "35899": p("AL", "Huntsville"),
  "36732": p("AL", "Demopolis"),
  "36736": p("AL", "Dixons Mills"),
  "36738": p("AL", "Faunsdale"),
  "36745": p("AL", "Jefferson"),
  "36748": p("AL", "Linden"),
  "36754": p("AL", "Magnolia"),
  "36763": p("AL", "Myrtlewood"),
  "36764": p("AL", "Nanafalia"),
  "36782": p("AL", "Sweet Water"),
  "36783": p("AL", "Thomaston"),
  "35543": p("AL", "Bear Creek"),
  "35548": p("AL", "Brilliant"),
  "35563": p("AL", "Guin"),
  "35564": p("AL", "Hackleburg"),
  "35570": p("AL", "Hamilton"),
  "35594": p("AL", "Winfield"),
  "35016": p("AL", "Arab"),
  "35175": p("AL", "Union Grove"),
  "35747": p("AL", "Grant"),
  "35950": p("AL", "Albertville"),
  "35951": p("AL", "Albertville"),
  "35956": p("AL", "Boaz"),
  "35957": p("AL", "Boaz"),
  "35964": p("AL", "Douglas"),
  "35976": p("AL", "Guntersville"),
  "35980": p("AL", "Horton"),
  "36421": p("AL", "Andalusia"),
  "36505": p("AL", "Axis"),
  "36509": p("AL", "Bayou La Batre"),
  "36512": p("AL", "Bucks"),
  "36521": p("AL", "Chunchula"),
  "36522": p("AL", "Citronelle"),
  "36523": p("AL", "Coden"),
  "36525": p("AL", "Creola"),
  "36528": p("AL", "Dauphin Island"),
  "36541": p("AL", "Grand Bay"),
  "36544": p("AL", "Irvington"),
  "36560": p("AL", "Mount Vernon"),
  "36568": p("AL", "Saint Elmo"),
  "36571": p("AL", "Saraland"),
  "36572": p("AL", "Satsuma"),
  "36575": p("AL", "Semmes"),
  "36582": p("AL", "Theodore"),
  "36587": p("AL", "Wilmer"),
  "36590": p("AL", "Theodore"),
  "36601": p("AL", "Mobile"),
  "36602": p("AL", "Mobile"),
  "36603": p("AL", "Mobile"),
  "36604": p("AL", "Mobile"),
  "36605": p("AL", "Mobile"),
  "36606": p("AL", "Mobile"),
  "36607": p("AL", "Mobile"),
  "36608": p("AL", "Mobile"),
  "36609": p("AL", "Mobile"),
  "36610": p("AL", "Mobile"),
  "36611": p("AL", "Mobile"),
  "36612": p("AL", "Mobile"),
  "36613": p("AL", "Eight Mile"),
  "36615": p("AL", "Mobile"),
  "36616": p("AL", "Mobile"),
  "36617": p("AL", "Mobile"),
  "36618": p("AL", "Mobile"),
  "36619": p("AL", "Mobile"),
  "36628": p("AL", "Mobile"),
  "36633": p("AL", "Mobile"),
  "36640": p("AL", "Mobile"),
  "36641": p("AL", "Mobile"),
  "36644": p("AL", "Mobile"),
  "36652": p("AL", "Mobile"),
  "36660": p("AL", "Mobile"),
  "36663": p("AL", "Mobile"),
  "36670": p("AL", "Mobile"),
  "36671": p("AL", "Mobile"),
  "36675": p("AL", "Mobile"),
  "36685": p("AL", "Mobile"),
  "36688": p("AL", "Mobile"),
  "36689": p("AL", "Mobile"),
  "36691": p("AL", "Mobile"),
  "36693": p("AL", "Mobile"),
  "36695": p("AL", "Mobile"),
  "36425": p("AL", "Beatrice"),
  "36439": p("AL", "Excel"),
  "36444": p("AL", "Franklin"),
  "36445": p("AL", "Frisco City"),
  "36449": p("AL", "Goodway"),
  "36457": p("AL", "Megargel"),
  "36458": p("AL", "Mexia"),
  "36460": p("AL", "Monroeville"),
  "36461": p("AL", "Monroeville"),
  "36470": p("AL", "Perdue Hill"),
  "36471": p("AL", "Peterman"),
  "36480": p("AL", "Uriah"),
  "36481": p("AL", "Vredenburgh"),
  "36013": p("AL", "Cecil"),
  "36036": p("AL", "Grady"),
  "36043": p("AL", "Hope Hull"),
  "36046": p("AL", "Lapine"),
  "36052": p("AL", "Mathews"),
  "36057": p("AL", "Mount Meigs"),
  "36064": p("AL", "Pike Road"),
  "36065": p("AL", "Pine Level"),
  "36069": p("AL", "Ramer"),
  "36101": p("AL", "Montgomery"),
  "36102": p("AL", "Montgomery"),
  "36103": p("AL", "Montgomery"),
  "36104": p("AL", "Montgomery"),
  "36105": p("AL", "Montgomery"),
  "36106": p("AL", "Montgomery"),
  "36107": p("AL", "Montgomery"),
  "36108": p("AL", "Montgomery"),
  "36109": p("AL", "Montgomery"),
  "36110": p("AL", "Montgomery"),
  "36111": p("AL", "Montgomery"),
  "36112": p("AL", "Montgomery"),
  "36113": p("AL", "Montgomery"),
  "36114": p("AL", "Montgomery"),
  "36115": p("AL", "Montgomery"),
  "36116": p("AL", "Montgomery"),
  "36117": p("AL", "Montgomery"),
  "36118": p("AL", "Montgomery"),
  "36119": p("AL", "Montgomery"),
  "36120": p("AL", "Montgomery"),
  "36121": p("AL", "Montgomery"),
  "36123": p("AL", "Montgomery"),
  "36124": p("AL", "Montgomery"),
  "36125": p("AL", "Montgomery"),
  "36130": p("AL", "Montgomery"),
  "36131": p("AL", "Montgomery"),
  "36132": p("AL", "Montgomery"),
  "36135": p("AL", "Montgomery"),
  "36140": p("AL", "Montgomery"),
  "36141": p("AL", "Montgomery"),
  "36142": p("AL", "Montgomery"),
  "36177": p("AL", "Montgomery"),
  "36191": p("AL", "Montgomery"),
  "35601": p("AL", "Decatur"),
  "35602": p("AL", "Decatur"),
  "35603": p("AL", "Decatur"),
  "35609": p("AL", "Decatur"),
  "35619": p("AL", "Danville"),
  "35621": p("AL", "Eva"),
  "35622": p("AL", "Falkville"),
  "35640": p("AL", "Hartselle"),
  "35670": p("AL", "Somerville"),
  "35673": p("AL", "Trinity"),
  "35699": p("AL", "Decatur"),
  "35754": p("AL", "Laceys Spring"),
  "35775": p("AL", "Valhermoso Springs"),
  "36756": p("AL", "Marion"),
  "36786": p("AL", "Uniontown"),
  "35442": p("AL", "Aliceville"),
  "35447": p("AL", "Carrollton"),
  "35461": p("AL", "Ethelsville"),
  "35466": p("AL", "Gordo"),
  "35471": p("AL", "Mc Shan"),
  "35481": p("AL", "Reform"),
  "36005": p("AL", "Banks"),
  "36010": p("AL", "Brundidge"),
  "36035": p("AL", "Goshen"),
  "36079": p("AL", "Troy"),
  "36081": p("AL", "Troy"),
  "36082": p("AL", "Troy"),
  "36263": p("AL", "Graham"),
  "36274": p("AL", "Roanoke"),
  "36276": p("AL", "Wadley"),
  "36278": p("AL", "Wedowee"),
  "36280": p("AL", "Woodland"),
  "36851": p("AL", "Cottonton"),
  "36856": p("AL", "Fort Mitchell"),
  "36858": p("AL", "Hatchechubbee"),
  "36859": p("AL", "Holy Trinity"),
  "36860": p("AL", "Hurtsboro"),
  "36867": p("AL", "Phenix City"),
  "36868": p("AL", "Phenix City"),
  "36869": p("AL", "Phenix City"),
  "36870": p("AL", "Phenix City"),
  "36871": p("AL", "Pittsview"),
  "36875": p("AL", "Seale"),
  "35004": p("AL", "Moody"),
  "35052": p("AL", "Cook Springs"),
  "35054": p("AL", "Cropwell"),
  "35112": p("AL", "Margaret"),
  "35120": p("AL", "Odenville"),
  "35125": p("AL", "Pell City"),
  "35128": p("AL", "Pell City"),
  "35131": p("AL", "Ragland"),
  "35135": p("AL", "Riverside"),
  "35146": p("AL", "Springville"),
  "35182": p("AL", "Wattsville"),
  "35953": p("AL", "Ashville"),
  "35987": p("AL", "Steele"),
  "35007": p("AL", "Alabaster"),
  "35040": p("AL", "Calera"),
  "35043": p("AL", "Chelsea"),
  "35051": p("AL", "Columbiana"),
  "35078": p("AL", "Harpersville"),
  "35080": p("AL", "Helena"),
  "35114": p("AL", "Maylene"),
  "35115": p("AL", "Montevallo"),
  "35124": p("AL", "Pelham"),
  "35137": p("AL", "Saginaw"),
  "35143": p("AL", "Shelby"),
  "35144": p("AL", "Siluria"),
  "35147": p("AL", "Sterrett"),
  "35176": p("AL", "Vandiver"),
  "35178": p("AL", "Vincent"),
  "35185": p("AL", "Westover"),
  "35186": p("AL", "Wilsonville"),
  "35187": p("AL", "Wilton"),
  "35242": p("AL", "Birmingham"),
  "35459": p("AL", "Emelle"),
  "35460": p("AL", "Epes"),
  "35464": p("AL", "Gainesville"),
  "35470": p("AL", "Livingston"),
  "35477": p("AL", "Panola"),
  "36901": p("AL", "Bellamy"),
  "36907": p("AL", "Cuba"),
  "36925": p("AL", "York"),
  "35014": p("AL", "Alpine"),
  "35032": p("AL", "Bon Air"),
  "35044": p("AL", "Childersburg"),
  "35096": p("AL", "Lincoln"),
  "35149": p("AL", "Sycamore"),
  "35150": p("AL", "Sylacauga"),
  "35151": p("AL", "Sylacauga"),
  "35160": p("AL", "Talladega"),
  "35161": p("AL", "Talladega"),
  "36268": p("AL", "Munford"),
  "35010": p("AL", "Alexander City"),
  "35011": p("AL", "Alexander City"),
  "36023": p("AL", "East Tallassee"),
  "36256": p("AL", "Daviston"),
  "36850": p("AL", "Camp Hill"),
  "36853": p("AL", "Dadeville"),
  "36861": p("AL", "Jacksons Gap"),
  "35401": p("AL", "Tuscaloosa"),
  "35402": p("AL", "Tuscaloosa"),
  "35403": p("AL", "Tuscaloosa"),
  "35404": p("AL", "Tuscaloosa"),
  "35405": p("AL", "Tuscaloosa"),
  "35406": p("AL", "Tuscaloosa"),
  "35407": p("AL", "Tuscaloosa"),
  "35440": p("AL", "Abernant"),
  "35444": p("AL", "Brookwood"),
  "35446": p("AL", "Buhl"),
  "35449": p("AL", "Coaling"),
  "35452": p("AL", "Coker"),
  "35453": p("AL", "Cottondale"),
  "35456": p("AL", "Duncanville"),
  "35457": p("AL", "Echola"),
  "35458": p("AL", "Elrod"),
  "35463": p("AL", "Fosters"),
  "35468": p("AL", "Kellerman"),
  "35473": p("AL", "Northport"),
  "35475": p("AL", "Northport"),
  "35476": p("AL", "Northport"),
  "35478": p("AL", "Peterson"),
  "35480": p("AL", "Ralph"),
  "35482": p("AL", "Samantha"),
  "35486": p("AL", "Tuscaloosa"),
  "35487": p("AL", "Tuscaloosa"),
  "35490": p("AL", "Vance"),
  "35038": p("AL", "Burnwell"),
  "35062": p("AL", "Dora"),
  "35063": p("AL", "Empire"),
  "35130": p("AL", "Quinton"),
  "35148": p("AL", "Sumiton"),
  "35501": p("AL", "Jasper"),
  "35502": p("AL", "Jasper"),
  "35503": p("AL", "Jasper"),
  "35504": p("AL", "Jasper"),
  "35549": p("AL", "Carbon Hill"),
  "35550": p("AL", "Cordova"),
  "35554": p("AL", "Eldridge"),
  "35560": p("AL", "Goodsprings"),
  "35573": p("AL", "Kansas"),
  "35578": p("AL", "Nauvoo"),
  "35579": p("AL", "Oakman"),
  "35580": p("AL", "Parrish"),
  "35584": p("AL", "Sipsey"),
  "35587": p("AL", "Townley"),
  "36513": p("AL", "Calvert"),
  "36518": p("AL", "Chatom"),
  "36529": p("AL", "Deer Park"),
  "36538": p("AL", "Frankville"),
  "36539": p("AL", "Fruitdale"),
  "36548": p("AL", "Leroy"),
  "36553": p("AL", "Mc Intosh"),
  "36556": p("AL", "Malcolm"),
  "36558": p("AL", "Millry"),
  "36569": p("AL", "Saint Stephens"),
  "36581": p("AL", "Sunflower"),
  "36583": p("AL", "Tibbie"),
  "36584": p("AL", "Vinegar Bend"),
  "36585": p("AL", "Wagarville"),
  "36435": p("AL", "Coy"),
  "36720": p("AL", "Alberta"),
  "36722": p("AL", "Arlington"),
  "36723": p("AL", "Boykin"),
  "36726": p("AL", "Camden"),
  "36728": p("AL", "Catherine"),
  "36741": p("AL", "Furman"),
  "36751": p("AL", "Lower Peach Tree"),
  "36753": p("AL", "Mc Williams"),
  "36766": p("AL", "Oak Hill"),
  "36768": p("AL", "Pine Apple"),
  "36769": p("AL", "Pine Hill"),
  "35540": p("AL", "Addison"),
  "35541": p("AL", "Arley"),
  "35551": p("AL", "Delmar"),
  "35553": p("AL", "Double Springs"),
  "35565": p("AL", "Haleyville"),
  "35572": p("AL", "Houston"),
  "35575": p("AL", "Lynn"),
  "35577": p("AL", "Natural Bridge"),
  "72003": p("AR", "Almyra"),
  "72026": p("AR", "Casscoe"),
  "72038": p("AR", "Crocketts Bluff"),
  "72042": p("AR", "De Witt"),
  "72048": p("AR", "Ethel"),
  "72055": p("AR", "Gillett"),
  "72073": p("AR", "Humphrey"),
  "72140": p("AR", "Saint Charles"),
  "72160": p("AR", "Stuttgart"),
  "72166": p("AR", "Tichnor"),
  "71635": p("AR", "Crossett"),
  "71642": p("AR", "Fountain Hill"),
  "71646": p("AR", "Hamburg"),
  "71658": p("AR", "Montrose"),
  "71661": p("AR", "Parkdale"),
  "71663": p("AR", "Portland"),
  "71676": p("AR", "Wilmot"),
  "72537": p("AR", "Gamaliel"),
  "72544": p("AR", "Henderson"),
  "72617": p("AR", "Big Flat"),
  "72623": p("AR", "Clarkridge"),
  "72626": p("AR", "Cotter"),
  "72635": p("AR", "Gassville"),
  "72642": p("AR", "Lakeview"),
  "72651": p("AR", "Midway"),
  "72653": p("AR", "Mountain Home"),
  "72654": p("AR", "Mountain Home"),
  "72658": p("AR", "Norfork"),
  "72659": p("AR", "Norfork"),
  "72711": p("AR", "Avoca"),
  "72712": p("AR", "Bentonville"),
  "72713": p("AR", "Bentonville"),
  "72714": p("AR", "Bella Vista"),
  "72715": p("AR", "Bella Vista"),
  "72716": p("AR", "Bentonville"),
  "72718": p("AR", "Cave Springs"),
  "72719": p("AR", "Centerton"),
  "72722": p("AR", "Decatur"),
  "72732": p("AR", "Garfield"),
  "72733": p("AR", "Gateway"),
  "72734": p("AR", "Gentry"),
  "72736": p("AR", "Gravette"),
  "72739": p("AR", "Hiwasse"),
  "72745": p("AR", "Lowell"),
  "72747": p("AR", "Maysville"),
  "72751": p("AR", "Pea Ridge"),
  "72756": p("AR", "Rogers"),
  "72757": p("AR", "Rogers"),
  "72758": p("AR", "Rogers"),
  "72761": p("AR", "Siloam Springs"),
  "72768": p("AR", "Sulphur Springs"),
  "72260": p("AR", "Little Rock"),
  "72601": p("AR", "Harrison"),
  "72602": p("AR", "Harrison"),
  "72611": p("AR", "Alpena"),
  "72615": p("AR", "Bergman"),
  "72630": p("AR", "Diamond City"),
  "72633": p("AR", "Everton"),
  "72644": p("AR", "Lead Hill"),
  "72662": p("AR", "Omaha"),
  "72682": p("AR", "Valley Springs"),
  "71631": p("AR", "Banks"),
  "71647": p("AR", "Hermitage"),
  "71651": p("AR", "Jersey"),
  "71671": p("AR", "Warren"),
  "71744": p("AR", "Hampton"),
  "71745": p("AR", "Harrell"),
  "71766": p("AR", "Thornton"),
  "72613": p("AR", "Beaver"),
  "72616": p("AR", "Berryville"),
  "72631": p("AR", "Eureka Springs"),
  "72632": p("AR", "Eureka Springs"),
  "72638": p("AR", "Green Forest"),
  "72660": p("AR", "Oak Grove"),
  "71638": p("AR", "Dermott"),
  "71640": p("AR", "Eudora"),
  "71653": p("AR", "Lake Village"),
  "71721": p("AR", "Beirne"),
  "71728": p("AR", "Curtis"),
  "71743": p("AR", "Gurdon"),
  "71772": p("AR", "Whelen Springs"),
  "71920": p("AR", "Alpine"),
  "71921": p("AR", "Amity"),
  "71923": p("AR", "Arkadelphia"),
  "71962": p("AR", "Okolona"),
  "71998": p("AR", "Arkadelphia"),
  "71999": p("AR", "Arkadelphia"),
  "72422": p("AR", "Corning"),
  "72424": p("AR", "Datto"),
  "72430": p("AR", "Greenway"),
  "72435": p("AR", "Knobel"),
  "72441": p("AR", "Mc Dougal"),
  "72453": p("AR", "Peach Orchard"),
  "72454": p("AR", "Piggott"),
  "72456": p("AR", "Pollard"),
  "72461": p("AR", "Rector"),
  "72464": p("AR", "Saint Francis"),
  "72470": p("AR", "Success"),
  "72044": p("AR", "Edgemont"),
  "72067": p("AR", "Higden"),
  "72130": p("AR", "Prim"),
  "72131": p("AR", "Quitman"),
  "72179": p("AR", "Wilburn"),
  "72523": p("AR", "Concord"),
  "72530": p("AR", "Drasco"),
  "72543": p("AR", "Heber Springs"),
  "72545": p("AR", "Heber Springs"),
  "72546": p("AR", "Ida"),
  "72581": p("AR", "Tumbling Shoals"),
  "71652": p("AR", "Kingsland"),
  "71660": p("AR", "New Edinburg"),
  "71665": p("AR", "Rison"),
  "71740": p("AR", "Emerson"),
  "71752": p("AR", "Mc Neil"),
  "71753": p("AR", "Magnolia"),
  "71754": p("AR", "Magnolia"),
  "71770": p("AR", "Waldo"),
  "71861": p("AR", "Taylor"),
  "72027": p("AR", "Center Ridge"),
  "72030": p("AR", "Cleveland"),
  "72063": p("AR", "Hattieville"),
  "72080": p("AR", "Jerusalem"),
  "72107": p("AR", "Menifee"),
  "72110": p("AR", "Morrilton"),
  "72127": p("AR", "Plumerville"),
  "72156": p("AR", "Solgohachia"),
  "72157": p("AR", "Springfield"),
  "72401": p("AR", "Jonesboro"),
  "72402": p("AR", "Jonesboro"),
  "72403": p("AR", "Jonesboro"),
  "72404": p("AR", "Jonesboro"),
  "72405": p("AR", "Jonesboro"),
  "72411": p("AR", "Bay"),
  "72414": p("AR", "Black Oak"),
  "72416": p("AR", "Bono"),
  "72417": p("AR", "Brookland"),
  "72419": p("AR", "Caraway"),
  "72421": p("AR", "Cash"),
  "72427": p("AR", "Egypt"),
  "72437": p("AR", "Lake City"),
  "72447": p("AR", "Monette"),
  "72467": p("AR", "State University"),
  "72921": p("AR", "Alma"),
  "72932": p("AR", "Cedarville"),
  "72934": p("AR", "Chester"),
  "72935": p("AR", "Dyer"),
  "72946": p("AR", "Mountainburg"),
  "72947": p("AR", "Mulberry"),
  "72948": p("AR", "Natural Dam"),
  "72952": p("AR", "Rudy"),
  "72955": p("AR", "Uniontown"),
  "72956": p("AR", "Van Buren"),
  "72957": p("AR", "Van Buren"),
  "72301": p("AR", "West Memphis"),
  "72303": p("AR", "West Memphis"),
  "72325": p("AR", "Clarkedale"),
  "72327": p("AR", "Crawfordsville"),
  "72331": p("AR", "Earle"),
  "72332": p("AR", "Edmondson"),
  "72339": p("AR", "Gilmore"),
  "72364": p("AR", "Marion"),
  "72376": p("AR", "Proctor"),
  "72384": p("AR", "Turrell"),
  "72324": p("AR", "Cherry Valley"),
  "72347": p("AR", "Hickory Ridge"),
  "72373": p("AR", "Parkin"),
  "72387": p("AR", "Vanndale"),
  "72396": p("AR", "Wynne"),
  "71725": p("AR", "Carthage"),
  "71742": p("AR", "Fordyce"),
  "71748": p("AR", "Ivan"),
  "71763": p("AR", "Sparkman"),
  "71630": p("AR", "Arkansas City"),
  "71639": p("AR", "Dumas"),
  "71654": p("AR", "Mc Gehee"),
  "71662": p("AR", "Pickens"),
  "71666": p("AR", "Rohwer"),
  "71670": p("AR", "Tillar"),
  "71674": p("AR", "Watson"),
  "72379": p("AR", "Snow Lake"),
  "71655": p("AR", "Monticello"),
  "71656": p("AR", "Monticello"),
  "71657": p("AR", "Monticello"),
  "71675": p("AR", "Wilmar"),
  "71677": p("AR", "Winchester"),
  "72032": p("AR", "Conway"),
  "72033": p("AR", "Conway"),
  "72034": p("AR", "Conway"),
  "72035": p("AR", "Conway"),
  "72039": p("AR", "Damascus"),
  "72047": p("AR", "Enola"),
  "72058": p("AR", "Greenbrier"),
  "72061": p("AR", "Guy"),
  "72106": p("AR", "Mayflower"),
  "72111": p("AR", "Mount Vernon"),
  "72173": p("AR", "Vilonia"),
  "72181": p("AR", "Wooster"),
  "72820": p("AR", "Alix"),
  "72821": p("AR", "Altus"),
  "72928": p("AR", "Branch"),
  "72930": p("AR", "Cecil"),
  "72933": p("AR", "Charleston"),
  "72949": p("AR", "Ozark"),
  "72515": p("AR", "Bexar"),
  "72520": p("AR", "Camp"),
  "72531": p("AR", "Elizabeth"),
  "72538": p("AR", "Gepp"),
  "72539": p("AR", "Glencoe"),
  "72554": p("AR", "Mammoth Spring"),
  "72576": p("AR", "Salem"),
  "72578": p("AR", "Sturkie"),
  "72583": p("AR", "Viola"),
  "71901": p("AR", "Hot Springs National Park"),
  "71902": p("AR", "Hot Springs National Park"),
  "71903": p("AR", "Hot Springs National Park"),
  "71909": p("AR", "Hot Springs Village"),
  "71910": p("AR", "Hot Springs Village"),
  "71913": p("AR", "Hot Springs National Park"),
  "71914": p("AR", "Hot Springs National Park"),
  "71949": p("AR", "Jessieville"),
  "71956": p("AR", "Mountain Pine"),
  "71964": p("AR", "Pearcy"),
  "71968": p("AR", "Royal"),
  "72087": p("AR", "Lonsdale"),
  "72057": p("AR", "Grapevine"),
  "72084": p("AR", "Leola"),
  "72128": p("AR", "Poyen"),
  "72129": p("AR", "Prattsville"),
  "72150": p("AR", "Sheridan"),
  "72412": p("AR", "Beech Grove"),
  "72425": p("AR", "Delaplaine"),
  "72436": p("AR", "Lafe"),
  "72443": p("AR", "Marmaduke"),
  "72450": p("AR", "Paragould"),
  "72451": p("AR", "Paragould"),
  "72474": p("AR", "Walcott"),
  "71801": p("AR", "Hope"),
  "71802": p("AR", "Hope"),
  "71825": p("AR", "Blevins"),
  "71831": p("AR", "Columbus"),
  "71838": p("AR", "Fulton"),
  "71847": p("AR", "Mc Caskill"),
  "71855": p("AR", "Ozan"),
  "71862": p("AR", "Washington"),
  "71929": p("AR", "Bismarck"),
  "71933": p("AR", "Bonnerdale"),
  "71941": p("AR", "Donaldson"),
  "71942": p("AR", "Friendship"),
  "72019": p("AR", "Benton"),
  "72104": p("AR", "Malvern"),
  "72105": p("AR", "Jones Mill"),
  "71833": p("AR", "Dierks"),
  "71851": p("AR", "Mineral Springs"),
  "71852": p("AR", "Nashville"),
  "71859": p("AR", "Saratoga"),
  "71971": p("AR", "Umpire"),
  "72165": p("AR", "Thida"),
  "72501": p("AR", "Batesville"),
  "72503": p("AR", "Batesville"),
  "72522": p("AR", "Charlotte"),
  "72524": p("AR", "Cord"),
  "72526": p("AR", "Cushman"),
  "72527": p("AR", "Desha"),
  "72534": p("AR", "Floral"),
  "72550": p("AR", "Locust Grove"),
  "72553": p("AR", "Magness"),
  "72562": p("AR", "Newark"),
  "72564": p("AR", "Oil Trough"),
  "72568": p("AR", "Pleasant Plains"),
  "72571": p("AR", "Rosie"),
  "72575": p("AR", "Salado"),
  "72579": p("AR", "Sulphur Rock"),
  "72512": p("AR", "Horseshoe Bend"),
  "72517": p("AR", "Brockwell"),
  "72519": p("AR", "Calico Rock"),
  "72528": p("AR", "Dolph"),
  "72536": p("AR", "Franklin"),
  "72540": p("AR", "Guion"),
  "72556": p("AR", "Melbourne"),
  "72561": p("AR", "Mount Pleasant"),
  "72565": p("AR", "Oxford"),
  "72566": p("AR", "Pineville"),
  "72573": p("AR", "Sage"),
  "72584": p("AR", "Violet Hill"),
  "72585": p("AR", "Wideman"),
  "72587": p("AR", "Wiseman"),
  "72005": p("AR", "Amagon"),
  "72014": p("AR", "Beedeville"),
  "72043": p("AR", "Diaz"),
  "72075": p("AR", "Jacksonport"),
  "72112": p("AR", "Newport"),
  "72169": p("AR", "Tupelo"),
  "72431": p("AR", "Grubbs"),
  "72471": p("AR", "Swifton"),
  "72473": p("AR", "Tuckerman"),
  "71601": p("AR", "Pine Bluff"),
  "71602": p("AR", "White Hall"),
  "71603": p("AR", "Pine Bluff"),
  "71611": p("AR", "Pine Bluff"),
  "71612": p("AR", "White Hall"),
  "71613": p("AR", "Pine Bluff"),
  "71659": p("AR", "Moscow"),
  "72004": p("AR", "Altheimer"),
  "72079": p("AR", "Jefferson"),
  "72132": p("AR", "Redfield"),
  "72133": p("AR", "Reydell"),
  "72152": p("AR", "Sherrill"),
  "72168": p("AR", "Tucker"),
  "72175": p("AR", "Wabbaseka"),
  "72182": p("AR", "Wright"),
  "72830": p("AR", "Clarksville"),
  "72832": p("AR", "Coal Hill"),
  "72839": p("AR", "Hagarville"),
  "72840": p("AR", "Hartman"),
  "72845": p("AR", "Knoxville"),
  "72846": p("AR", "Lamar"),
  "72852": p("AR", "Oark"),
  "72854": p("AR", "Ozone"),
  "71826": p("AR", "Bradley"),
  "71827": p("AR", "Buckner"),
  "71839": p("AR", "Garland City"),
  "71845": p("AR", "Lewisville"),
  "71860": p("AR", "Stamps"),
  "72410": p("AR", "Alicia"),
  "72415": p("AR", "Black Rock"),
  "72433": p("AR", "Hoxie"),
  "72434": p("AR", "Imboden"),
  "72440": p("AR", "Lynn"),
  "72445": p("AR", "Minturn"),
  "72457": p("AR", "Portia"),
  "72458": p("AR", "Powhatan"),
  "72459": p("AR", "Ravenden"),
  "72465": p("AR", "Sedgwick"),
  "72466": p("AR", "Smithville"),
  "72469": p("AR", "Strawberry"),
  "72476": p("AR", "Walnut Ridge"),
  "72572": p("AR", "Saffell"),
  "72311": p("AR", "Aubrey"),
  "72320": p("AR", "Brickeys"),
  "72341": p("AR", "Haynes"),
  "72352": p("AR", "La Grange"),
  "72360": p("AR", "Marianna"),
  "72368": p("AR", "Moro"),
  "71643": p("AR", "Gould"),
  "71644": p("AR", "Grady"),
  "71667": p("AR", "Star City"),
  "71678": p("AR", "Yorktown"),
  "71820": p("AR", "Alleene"),
  "71822": p("AR", "Ashdown"),
  "71836": p("AR", "Foreman"),
  "71853": p("AR", "Ogden"),
  "71865": p("AR", "Wilton"),
  "71866": p("AR", "Winthrop"),
  "72826": p("AR", "Blue Mountain"),
  "72835": p("AR", "Delaware"),
  "72851": p("AR", "New Blaine"),
  "72855": p("AR", "Paris"),
  "72863": p("AR", "Scranton"),
  "72865": p("AR", "Subiaco"),
  "72927": p("AR", "Booneville"),
  "72943": p("AR", "Magazine"),
  "72951": p("AR", "Ratcliff"),
  "72007": p("AR", "Austin"),
  "72023": p("AR", "Cabot"),
  "72024": p("AR", "Carlisle"),
  "72037": p("AR", "Coy"),
  "72046": p("AR", "England"),
  "72072": p("AR", "Humnoke"),
  "72083": p("AR", "Keo"),
  "72086": p("AR", "Lonoke"),
  "72176": p("AR", "Ward"),
  "72721": p("AR", "Combs"),
  "72738": p("AR", "Hindsville"),
  "72740": p("AR", "Huntsville"),
  "72742": p("AR", "Kingston"),
  "72752": p("AR", "Pettigrew"),
  "72760": p("AR", "Saint Paul"),
  "72773": p("AR", "Wesley"),
  "72776": p("AR", "Witter"),
  "72619": p("AR", "Bull Shoals"),
  "72634": p("AR", "Flippin"),
  "72661": p("AR", "Oakland"),
  "72668": p("AR", "Peel"),
  "72672": p("AR", "Pyatt"),
  "72677": p("AR", "Summit"),
  "72687": p("AR", "Yellville"),
  "71834": p("AR", "Doddridge"),
  "71837": p("AR", "Fouke"),
  "71840": p("AR", "Genoa"),
  "71854": p("AR", "Texarkana"),
  "72310": p("AR", "Armorel"),
  "72313": p("AR", "Bassett"),
  "72315": p("AR", "Blytheville"),
  "72316": p("AR", "Blytheville"),
  "72319": p("AR", "Gosnell"),
  "72321": p("AR", "Burdette"),
  "72329": p("AR", "Driver"),
  "72330": p("AR", "Dyess"),
  "72338": p("AR", "Frenchmans Bayou"),
  "72350": p("AR", "Joiner"),
  "72351": p("AR", "Keiser"),
  "72358": p("AR", "Luxora"),
  "72370": p("AR", "Osceola"),
  "72391": p("AR", "West Ridge"),
  "72395": p("AR", "Wilson"),
  "72426": p("AR", "Dell"),
  "72428": p("AR", "Etowah"),
  "72438": p("AR", "Leachville"),
  "72442": p("AR", "Manila"),
  "72021": p("AR", "Brinkley"),
  "72029": p("AR", "Clarendon"),
  "72069": p("AR", "Holly Grove"),
  "72108": p("AR", "Monroe"),
  "72134": p("AR", "Roe"),
  "71935": p("AR", "Caddo Gap"),
  "71957": p("AR", "Mount Ida"),
  "71960": p("AR", "Norman"),
  "71961": p("AR", "Oden"),
  "71965": p("AR", "Pencil Bluff"),
  "71966": p("AR", "Oden"),
  "71969": p("AR", "Sims"),
  "71970": p("AR", "Story"),
  "71722": p("AR", "Bluff City"),
  "71828": p("AR", "Cale"),
  "71835": p("AR", "Emmet"),
  "71857": p("AR", "Prescott"),
  "71858": p("AR", "Rosston"),
  "71864": p("AR", "Willisville"),
  "72624": p("AR", "Compton"),
  "72628": p("AR", "Deer"),
  "72640": p("AR", "Hasty"),
  "72641": p("AR", "Jasper"),
  "72648": p("AR", "Marble Falls"),
  "72655": p("AR", "Mount Judea"),
  "72666": p("AR", "Parthenon"),
  "72670": p("AR", "Ponca"),
  "72683": p("AR", "Vendor"),
  "72685": p("AR", "Western Grove"),
  "71701": p("AR", "Camden"),
  "71711": p("AR", "Camden"),
  "71720": p("AR", "Bearden"),
  "71726": p("AR", "Chidester"),
  "71751": p("AR", "Louann"),
  "71764": p("AR", "Stephens"),
  "72001": p("AR", "Adona"),
  "72016": p("AR", "Bigelow"),
  "72025": p("AR", "Casa"),
  "72070": p("AR", "Houston"),
  "72125": p("AR", "Perry"),
  "72126": p("AR", "Perryville"),
  "72312": p("AR", "Barton"),
  "72328": p("AR", "Crumrod"),
  "72333": p("AR", "Elaine"),
  "72342": p("AR", "Helena"),
  "72353": p("AR", "Lambrook"),
  "72355": p("AR", "Lexa"),
  "72366": p("AR", "Marvell"),
  "72367": p("AR", "Mellwood"),
  "72369": p("AR", "Oneida"),
  "72374": p("AR", "Poplar Grove"),
  "72383": p("AR", "Turner"),
  "72389": p("AR", "Wabash"),
  "72390": p("AR", "West Helena"),
  "71922": p("AR", "Antoine"),
  "71940": p("AR", "Delight"),
  "71943": p("AR", "Glenwood"),
  "71950": p("AR", "Kirby"),
  "71952": p("AR", "Langley"),
  "71958": p("AR", "Murfreesboro"),
  "71959": p("AR", "Newhope"),
  "72354": p("AR", "Lepanto"),
  "72365": p("AR", "Marked Tree"),
  "72377": p("AR", "Rivervale"),
  "72386": p("AR", "Tyronza"),
  "72429": p("AR", "Fisher"),
  "72432": p("AR", "Harrisburg"),
  "72472": p("AR", "Trumann"),
  "72475": p("AR", "Waldenburg"),
  "72479": p("AR", "Weiner"),
  "71932": p("AR", "Board Camp"),
  "71937": p("AR", "Cove"),
  "71944": p("AR", "Grannis"),
  "71945": p("AR", "Hatfield"),
  "71953": p("AR", "Mena"),
  "71972": p("AR", "Vandervoort"),
  "71973": p("AR", "Wickes"),
  "72679": p("AR", "Tilly"),
  "72801": p("AR", "Russellville"),
  "72802": p("AR", "Russellville"),
  "72811": p("AR", "Russellville"),
  "72812": p("AR", "Russellville"),
  "72823": p("AR", "Atkins"),
  "72837": p("AR", "Dover"),
  "72843": p("AR", "Hector"),
  "72847": p("AR", "London"),
  "72856": p("AR", "Pelsor"),
  "72858": p("AR", "Pottsville"),
  "72017": p("AR", "Biscoe"),
  "72040": p("AR", "Des Arc"),
  "72041": p("AR", "De Valls Bluff"),
  "72064": p("AR", "Hazen"),
  "72066": p("AR", "Hickory Plains"),
  "72170": p("AR", "Ulm"),
  "72002": p("AR", "Alexander"),
  "72053": p("AR", "College Station"),
  "72065": p("AR", "Hensley"),
  "72076": p("AR", "Jacksonville"),
  "72078": p("AR", "Jacksonville"),
  "72099": p("AR", "Little Rock Air Force Base"),
  "72103": p("AR", "Mabelvale"),
  "72113": p("AR", "Maumelle"),
  "72114": p("AR", "North Little Rock"),
  "72115": p("AR", "North Little Rock"),
  "72116": p("AR", "North Little Rock"),
  "72117": p("AR", "North Little Rock"),
  "72118": p("AR", "North Little Rock"),
  "72119": p("AR", "North Little Rock"),
  "72120": p("AR", "Sherwood"),
  "72124": p("AR", "North Little Rock"),
  "72135": p("AR", "Roland"),
  "72142": p("AR", "Scott"),
  "72164": p("AR", "Sweet Home"),
  "72180": p("AR", "Woodson"),
  "72183": p("AR", "Wrightsville"),
  "72190": p("AR", "North Little Rock"),
  "72199": p("AR", "North Little Rock"),
  "72201": p("AR", "Little Rock"),
  "72202": p("AR", "Little Rock"),
  "72203": p("AR", "Little Rock"),
  "72204": p("AR", "Little Rock"),
  "72205": p("AR", "Little Rock"),
  "72206": p("AR", "Little Rock"),
  "72207": p("AR", "Little Rock"),
  "72209": p("AR", "Little Rock"),
  "72210": p("AR", "Little Rock"),
  "72211": p("AR", "Little Rock"),
  "72212": p("AR", "Little Rock"),
  "72214": p("AR", "Little Rock"),
  "72215": p("AR", "Little Rock"),
  "72216": p("AR", "Little Rock"),
  "72217": p("AR", "Little Rock"),
  "72219": p("AR", "Little Rock"),
  "72221": p("AR", "Little Rock"),
  "72222": p("AR", "Little Rock"),
  "72223": p("AR", "Little Rock"),
  "72225": p("AR", "Little Rock"),
  "72227": p("AR", "Little Rock"),
  "72231": p("AR", "Little Rock"),
  "72255": p("AR", "Little Rock"),
  "72295": p("AR", "Little Rock"),
  "72413": p("AR", "Biggers"),
  "72444": p("AR", "Maynard"),
  "72449": p("AR", "O Kean"),
  "72455": p("AR", "Pocahontas"),
  "72460": p("AR", "Ravenden Springs"),
  "72462": p("AR", "Reyno"),
  "72478": p("AR", "Warm Springs"),
  "72322": p("AR", "Caldwell"),
  "72326": p("AR", "Colt"),
  "72335": p("AR", "Forrest City"),
  "72336": p("AR", "Forrest City"),
  "72340": p("AR", "Goodwin"),
  "72346": p("AR", "Heth"),
  "72348": p("AR", "Hughes"),
  "72359": p("AR", "Madison"),
  "72372": p("AR", "Palestine"),
  "72392": p("AR", "Wheatley"),
  "72394": p("AR", "Widener"),
  "72011": p("AR", "Bauxite"),
  "72015": p("AR", "Benton"),
  "72018": p("AR", "Benton"),
  "72022": p("AR", "Bryant"),
  "72089": p("AR", "Bryant"),
  "72122": p("AR", "Paron"),
  "72158": p("AR", "Benton"),
  "72167": p("AR", "Traskwood"),
  "72841": p("AR", "Harvey"),
  "72926": p("AR", "Boles"),
  "72944": p("AR", "Mansfield"),
  "72950": p("AR", "Parks"),
  "72958": p("AR", "Waldron"),
  "72636": p("AR", "Gilbert"),
  "72639": p("AR", "Harriet"),
  "72645": p("AR", "Leslie"),
  "72650": p("AR", "Marshall"),
  "72669": p("AR", "Pindall"),
  "72675": p("AR", "Saint Joe"),
  "72686": p("AR", "Witts Springs"),
  "72901": p("AR", "Fort Smith"),
  "72902": p("AR", "Fort Smith"),
  "72903": p("AR", "Fort Smith"),
  "72904": p("AR", "Fort Smith"),
  "72905": p("AR", "Fort Smith"),
  "72906": p("AR", "Fort Smith"),
  "72908": p("AR", "Fort Smith"),
  "72913": p("AR", "Fort Smith"),
  "72914": p("AR", "Fort Smith"),
  "72916": p("AR", "Fort Smith"),
  "72917": p("AR", "Fort Smith"),
  "72918": p("AR", "Fort Smith"),
  "72919": p("AR", "Fort Smith"),
  "72923": p("AR", "Barling"),
  "72936": p("AR", "Greenwood"),
  "72937": p("AR", "Hackett"),
  "72938": p("AR", "Hartford"),
  "72940": p("AR", "Huntington"),
  "72941": p("AR", "Lavaca"),
  "72945": p("AR", "Midland"),
  "71823": p("AR", "Ben Lomond"),
  "71832": p("AR", "De Queen"),
  "71841": p("AR", "Gillham"),
  "71842": p("AR", "Horatio"),
  "71846": p("AR", "Lockesburg"),
  "72482": p("AR", "Williford"),
  "72513": p("AR", "Ash Flat"),
  "72521": p("AR", "Cave City"),
  "72525": p("AR", "Cherokee Village"),
  "72529": p("AR", "Cherokee Village"),
  "72532": p("AR", "Evening Shade"),
  "72542": p("AR", "Hardy"),
  "72569": p("AR", "Poughkeepsie"),
  "72577": p("AR", "Sidney"),
  "72051": p("AR", "Fox"),
  "72533": p("AR", "Fifty Six"),
  "72555": p("AR", "Marcella"),
  "72560": p("AR", "Mountain View"),
  "72567": p("AR", "Pleasant Grove"),
  "72657": p("AR", "Timbo"),
  "72663": p("AR", "Onia"),
  "72680": p("AR", "Timbo"),
  "71724": p("AR", "Calion"),
  "71730": p("AR", "El Dorado"),
  "71731": p("AR", "El Dorado"),
  "71747": p("AR", "Huttig"),
  "71749": p("AR", "Junction City"),
  "71750": p("AR", "Lawson"),
  "71758": p("AR", "Mount Holly"),
  "71759": p("AR", "Norphlet"),
  "71762": p("AR", "Smackover"),
  "71765": p("AR", "Strong"),
  "72013": p("AR", "Bee Branch"),
  "72028": p("AR", "Choctaw"),
  "72031": p("AR", "Clinton"),
  "72088": p("AR", "Fairfield Bay"),
  "72141": p("AR", "Scotland"),
  "72153": p("AR", "Shirley"),
  "72629": p("AR", "Dennard"),
  "72701": p("AR", "Fayetteville"),
  "72702": p("AR", "Fayetteville"),
  "72703": p("AR", "Fayetteville"),
  "72704": p("AR", "Fayetteville"),
  "72717": p("AR", "Canehill"),
  "72727": p("AR", "Elkins"),
  "72728": p("AR", "Elm Springs"),
  "72729": p("AR", "Evansville"),
  "72730": p("AR", "Farmington"),
  "72735": p("AR", "Goshen"),
  "72737": p("AR", "Greenland"),
  "72741": p("AR", "Johnson"),
  "72744": p("AR", "Lincoln"),
  "72749": p("AR", "Morrow"),
  "72753": p("AR", "Prairie Grove"),
  "72762": p("AR", "Springdale"),
  "72764": p("AR", "Springdale"),
  "72765": p("AR", "Springdale"),
  "72766": p("AR", "Springdale"),
  "72769": p("AR", "Summers"),
  "72770": p("AR", "Tontitown"),
  "72774": p("AR", "West Fork"),
  "72959": p("AR", "Winslow"),
  "72010": p("AR", "Bald Knob"),
  "72012": p("AR", "Beebe"),
  "72020": p("AR", "Bradford"),
  "72045": p("AR", "El Paso"),
  "72052": p("AR", "Garner"),
  "72060": p("AR", "Griffithville"),
  "72068": p("AR", "Higginson"),
  "72081": p("AR", "Judsonia"),
  "72082": p("AR", "Kensett"),
  "72085": p("AR", "Letona"),
  "72102": p("AR", "Mc Rae"),
  "72121": p("AR", "Pangburn"),
  "72136": p("AR", "Romance"),
  "72137": p("AR", "Rose Bud"),
  "72139": p("AR", "Russell"),
  "72143": p("AR", "Searcy"),
  "72145": p("AR", "Searcy"),
  "72149": p("AR", "Searcy"),
  "72178": p("AR", "West Point"),
  "72006": p("AR", "Augusta"),
  "72036": p("AR", "Cotton Plant"),
  "72059": p("AR", "Gregory"),
  "72074": p("AR", "Hunter"),
  "72101": p("AR", "Mc Crory"),
  "72123": p("AR", "Patterson"),
  "72824": p("AR", "Belleville"),
  "72827": p("AR", "Bluffton"),
  "72828": p("AR", "Briggsville"),
  "72829": p("AR", "Centerville"),
  "72833": p("AR", "Danville"),
  "72834": p("AR", "Dardanelle"),
  "72838": p("AR", "Gravelly"),
  "72842": p("AR", "Havana"),
  "72853": p("AR", "Ola"),
  "72857": p("AR", "Plainview"),
  "72860": p("AR", "Rover"),
  "85920": p("AZ", "Alpine"),
  "85924": p("AZ", "Concho"),
  "85925": p("AZ", "Eagar"),
  "85927": p("AZ", "Greer"),
  "85930": p("AZ", "Mcnary"),
  "85932": p("AZ", "Nutrioso"),
  "85936": p("AZ", "Saint Johns"),
  "85938": p("AZ", "Springerville"),
  "85940": p("AZ", "Vernon"),
  "86028": p("AZ", "Petrified Forest Natl Pk"),
  "86502": p("AZ", "Chambers"),
  "86503": p("AZ", "Chinle"),
  "86504": p("AZ", "Fort Defiance"),
  "86505": p("AZ", "Ganado"),
  "86506": p("AZ", "Houck"),
  "86507": p("AZ", "Lukachukai"),
  "86508": p("AZ", "Lupton"),
  "86511": p("AZ", "Saint Michaels"),
  "86512": p("AZ", "Sanders"),
  "86514": p("AZ", "Teec Nos Pos"),
  "86515": p("AZ", "Window Rock"),
  "86535": p("AZ", "Dennehotso"),
  "86538": p("AZ", "Many Farms"),
  "86540": p("AZ", "Nazlini"),
  "86544": p("AZ", "Red Valley"),
  "86545": p("AZ", "Rock Point"),
  "86547": p("AZ", "Round Rock"),
  "86556": p("AZ", "Tsaile"),
  "85602": p("AZ", "Benson"),
  "85603": p("AZ", "Bisbee"),
  "85605": p("AZ", "Bowie"),
  "85606": p("AZ", "Cochise"),
  "85607": p("AZ", "Douglas"),
  "85608": p("AZ", "Douglas"),
  "85609": p("AZ", "Dragoon"),
  "85610": p("AZ", "Elfrida"),
  "85613": p("AZ", "Fort Huachuca"),
  "85615": p("AZ", "Hereford"),
  "85616": p("AZ", "Huachuca City"),
  "85617": p("AZ", "Mc Neal"),
  "85620": p("AZ", "Naco"),
  "85625": p("AZ", "Pearce"),
  "85626": p("AZ", "Pirtleville"),
  "85627": p("AZ", "Pomerene"),
  "85630": p("AZ", "Saint David"),
  "85632": p("AZ", "San Simon"),
  "85635": p("AZ", "Sierra Vista"),
  "85636": p("AZ", "Sierra Vista"),
  "85638": p("AZ", "Tombstone"),
  "85643": p("AZ", "Willcox"),
  "85644": p("AZ", "Willcox"),
  "85650": p("AZ", "Sierra Vista"),
  "85655": p("AZ", "Douglas"),
  "85670": p("AZ", "Fort Huachuca"),
  "85671": p("AZ", "Sierra Vista"),
  "85931": p("AZ", "Forest Lakes"),
  "86001": p("AZ", "Flagstaff"),
  "86002": p("AZ", "Flagstaff"),
  "86003": p("AZ", "Flagstaff"),
  "86004": p("AZ", "Flagstaff"),
  "86005": p("AZ", "Flagstaff"),
  "86011": p("AZ", "Flagstaff"),
  "86015": p("AZ", "Bellemont"),
  "86016": p("AZ", "Gray Mountain"),
  "86017": p("AZ", "Munds Park"),
  "86018": p("AZ", "Parks"),
  "86020": p("AZ", "Cameron"),
  "86022": p("AZ", "Fredonia"),
  "86023": p("AZ", "Grand Canyon"),
  "86024": p("AZ", "Happy Jack"),
  "86035": p("AZ", "Leupp"),
  "86036": p("AZ", "Marble Canyon"),
  "86038": p("AZ", "Mormon Lake"),
  "86040": p("AZ", "Page"),
  "86044": p("AZ", "Tonalea"),
  "86045": p("AZ", "Tuba City"),
  "86046": p("AZ", "Williams"),
  "86052": p("AZ", "North Rim"),
  "86053": p("AZ", "Kaibeto"),
  "86336": p("AZ", "Sedona"),
  "86339": p("AZ", "Sedona"),
  "86351": p("AZ", "Sedona"),
  "86435": p("AZ", "Supai"),
  "85135": p("AZ", "Hayden"),
  "85192": p("AZ", "Winkelman"),
  "85501": p("AZ", "Globe"),
  "85502": p("AZ", "Globe"),
  "85532": p("AZ", "Claypool"),
  "85539": p("AZ", "Miami"),
  "85541": p("AZ", "Payson"),
  "85542": p("AZ", "Peridot"),
  "85544": p("AZ", "Pine"),
  "85545": p("AZ", "Roosevelt"),
  "85547": p("AZ", "Payson"),
  "85550": p("AZ", "San Carlos"),
  "85553": p("AZ", "Tonto Basin"),
  "85554": p("AZ", "Young"),
  "85530": p("AZ", "Bylas"),
  "85531": p("AZ", "Central"),
  "85535": p("AZ", "Eden"),
  "85536": p("AZ", "Fort Thomas"),
  "85543": p("AZ", "Pima"),
  "85546": p("AZ", "Safford"),
  "85548": p("AZ", "Safford"),
  "85551": p("AZ", "Solomon"),
  "85552": p("AZ", "Thatcher"),
  "85533": p("AZ", "Clifton"),
  "85534": p("AZ", "Duncan"),
  "85540": p("AZ", "Morenci"),
  "85922": p("AZ", "Blue"),
  "85325": p("AZ", "Bouse"),
  "85328": p("AZ", "Cibola"),
  "85334": p("AZ", "Ehrenberg"),
  "85344": p("AZ", "Parker"),
  "85346": p("AZ", "Quartzsite"),
  "85348": p("AZ", "Salome"),
  "85357": p("AZ", "Wenden"),
  "85359": p("AZ", "Quartzsite"),
  "85371": p("AZ", "Poston"),
  "85001": p("AZ", "Phoenix"),
  "85002": p("AZ", "Phoenix"),
  "85003": p("AZ", "Phoenix"),
  "85004": p("AZ", "Phoenix"),
  "85005": p("AZ", "Phoenix"),
  "85006": p("AZ", "Phoenix"),
  "85007": p("AZ", "Phoenix"),
  "85008": p("AZ", "Phoenix"),
  "85009": p("AZ", "Phoenix"),
  "85010": p("AZ", "Phoenix"),
  "85011": p("AZ", "Phoenix"),
  "85012": p("AZ", "Phoenix"),
  "85013": p("AZ", "Phoenix"),
  "85014": p("AZ", "Phoenix"),
  "85015": p("AZ", "Phoenix"),
  "85016": p("AZ", "Phoenix"),
  "85017": p("AZ", "Phoenix"),
  "85018": p("AZ", "Phoenix"),
  "85019": p("AZ", "Phoenix"),
  "85020": p("AZ", "Phoenix"),
  "85021": p("AZ", "Phoenix"),
  "85022": p("AZ", "Phoenix"),
  "85023": p("AZ", "Phoenix"),
  "85024": p("AZ", "Phoenix"),
  "85025": p("AZ", "Phoenix"),
  "85026": p("AZ", "Phoenix"),
  "85027": p("AZ", "Phoenix"),
  "85028": p("AZ", "Phoenix"),
  "85029": p("AZ", "Phoenix"),
  "85030": p("AZ", "Phoenix"),
  "85031": p("AZ", "Phoenix"),
  "85032": p("AZ", "Phoenix"),
  "85033": p("AZ", "Phoenix"),
  "85034": p("AZ", "Phoenix"),
  "85035": p("AZ", "Phoenix"),
  "85036": p("AZ", "Phoenix"),
  "85037": p("AZ", "Phoenix"),
  "85038": p("AZ", "Phoenix"),
  "85039": p("AZ", "Phoenix"),
  "85040": p("AZ", "Phoenix"),
  "85041": p("AZ", "Phoenix"),
  "85042": p("AZ", "Phoenix"),
  "85043": p("AZ", "Phoenix"),
  "85044": p("AZ", "Phoenix"),
  "85045": p("AZ", "Phoenix"),
  "85046": p("AZ", "Phoenix"),
  "85048": p("AZ", "Phoenix"),
  "85050": p("AZ", "Phoenix"),
  "85051": p("AZ", "Phoenix"),
  "85053": p("AZ", "Phoenix"),
  "85054": p("AZ", "Phoenix"),
  "85060": p("AZ", "Phoenix"),
  "85061": p("AZ", "Phoenix"),
  "85062": p("AZ", "Phoenix"),
  "85063": p("AZ", "Phoenix"),
  "85064": p("AZ", "Phoenix"),
  "85065": p("AZ", "Phoenix"),
  "85066": p("AZ", "Phoenix"),
  "85067": p("AZ", "Phoenix"),
  "85068": p("AZ", "Phoenix"),
  "85069": p("AZ", "Phoenix"),
  "85070": p("AZ", "Phoenix"),
  "85071": p("AZ", "Phoenix"),
  "85072": p("AZ", "Phoenix"),
  "85073": p("AZ", "Phoenix"),
  "85074": p("AZ", "Phoenix"),
  "85075": p("AZ", "Phoenix"),
  "85076": p("AZ", "Phoenix"),
  "85078": p("AZ", "Phoenix"),
  "85079": p("AZ", "Phoenix"),
  "85080": p("AZ", "Phoenix"),
  "85082": p("AZ", "Phoenix"),
  "85083": p("AZ", "Phoenix"),
  "85085": p("AZ", "Phoenix"),
  "85086": p("AZ", "Phoenix"),
  "85087": p("AZ", "New River"),
  "85097": p("AZ", "Phoenix"),
  "85098": p("AZ", "Phoenix"),
  "85127": p("AZ", "Chandler Heights"),
  "85142": p("AZ", "Queen Creek"),
  "85190": p("AZ", "Tortilla Flat"),
  "85201": p("AZ", "Mesa"),
  "85202": p("AZ", "Mesa"),
  "85203": p("AZ", "Mesa"),
  "85204": p("AZ", "Mesa"),
  "85205": p("AZ", "Mesa"),
  "85206": p("AZ", "Mesa"),
  "85207": p("AZ", "Mesa"),
  "85208": p("AZ", "Mesa"),
  "85209": p("AZ", "Mesa"),
  "85210": p("AZ", "Mesa"),
  "85211": p("AZ", "Mesa"),
  "85212": p("AZ", "Mesa"),
  "85213": p("AZ", "Mesa"),
  "85214": p("AZ", "Mesa"),
  "85215": p("AZ", "Mesa"),
  "85216": p("AZ", "Mesa"),
  "85224": p("AZ", "Chandler"),
  "85225": p("AZ", "Chandler"),
  "85226": p("AZ", "Chandler"),
  "85233": p("AZ", "Gilbert"),
  "85234": p("AZ", "Gilbert"),
  "85236": p("AZ", "Higley"),
  "85244": p("AZ", "Chandler"),
  "85246": p("AZ", "Chandler"),
  "85248": p("AZ", "Chandler"),
  "85249": p("AZ", "Chandler"),
  "85250": p("AZ", "Scottsdale"),
  "85251": p("AZ", "Scottsdale"),
  "85252": p("AZ", "Scottsdale"),
  "85253": p("AZ", "Paradise Valley"),
  "85254": p("AZ", "Scottsdale"),
  "85255": p("AZ", "Scottsdale"),
  "85256": p("AZ", "Scottsdale"),
  "85257": p("AZ", "Scottsdale"),
  "85258": p("AZ", "Scottsdale"),
  "85259": p("AZ", "Scottsdale"),
  "85260": p("AZ", "Scottsdale"),
  "85261": p("AZ", "Scottsdale"),
  "85262": p("AZ", "Scottsdale"),
  "85263": p("AZ", "Rio Verde"),
  "85264": p("AZ", "Fort Mcdowell"),
  "85266": p("AZ", "Scottsdale"),
  "85267": p("AZ", "Scottsdale"),
  "85268": p("AZ", "Fountain Hills"),
  "85269": p("AZ", "Fountain Hills"),
  "85271": p("AZ", "Scottsdale"),
  "85274": p("AZ", "Mesa"),
  "85275": p("AZ", "Mesa"),
  "85277": p("AZ", "Mesa"),
  "85280": p("AZ", "Tempe"),
  "85281": p("AZ", "Tempe"),
  "85282": p("AZ", "Tempe"),
  "85283": p("AZ", "Tempe"),
  "85284": p("AZ", "Tempe"),
  "85285": p("AZ", "Tempe"),
  "85286": p("AZ", "Chandler"),
  "85287": p("AZ", "Tempe"),
  "85295": p("AZ", "Gilbert"),
  "85296": p("AZ", "Gilbert"),
  "85297": p("AZ", "Gilbert"),
  "85298": p("AZ", "Gilbert"),
  "85299": p("AZ", "Gilbert"),
  "85301": p("AZ", "Glendale"),
  "85302": p("AZ", "Glendale"),
  "85303": p("AZ", "Glendale"),
  "85304": p("AZ", "Glendale"),
  "85305": p("AZ", "Glendale"),
  "85306": p("AZ", "Glendale"),
  "85307": p("AZ", "Glendale"),
  "85308": p("AZ", "Glendale"),
  "85309": p("AZ", "Luke Air Force Base"),
  "85310": p("AZ", "Glendale"),
  "85311": p("AZ", "Glendale"),
  "85312": p("AZ", "Glendale"),
  "85318": p("AZ", "Glendale"),
  "85320": p("AZ", "Aguila"),
  "85322": p("AZ", "Arlington"),
  "85323": p("AZ", "Avondale"),
  "85326": p("AZ", "Buckeye"),
  "85327": p("AZ", "Cave Creek"),
  "85329": p("AZ", "Cashion"),
  "85331": p("AZ", "Cave Creek"),
  "85335": p("AZ", "El Mirage"),
  "85337": p("AZ", "Gila Bend"),
  "85338": p("AZ", "Goodyear"),
  "85339": p("AZ", "Laveen"),
  "85340": p("AZ", "Litchfield Park"),
  "85342": p("AZ", "Morristown"),
  "85343": p("AZ", "Palo Verde"),
  "85345": p("AZ", "Peoria"),
  "85351": p("AZ", "Sun City"),
  "85353": p("AZ", "Tolleson"),
  "85354": p("AZ", "Tonopah"),
  "85355": p("AZ", "Waddell"),
  "85358": p("AZ", "Wickenburg"),
  "85361": p("AZ", "Wittmann"),
  "85363": p("AZ", "Youngtown"),
  "85372": p("AZ", "Sun City"),
  "85373": p("AZ", "Sun City"),
  "85374": p("AZ", "Surprise"),
  "85375": p("AZ", "Sun City West"),
  "85376": p("AZ", "Sun City West"),
  "85377": p("AZ", "Carefree"),
  "85378": p("AZ", "Surprise"),
  "85379": p("AZ", "Surprise"),
  "85380": p("AZ", "Peoria"),
  "85381": p("AZ", "Peoria"),
  "85382": p("AZ", "Peoria"),
  "85383": p("AZ", "Peoria"),
  "85385": p("AZ", "Peoria"),
  "85387": p("AZ", "Surprise"),
  "85388": p("AZ", "Surprise"),
  "85390": p("AZ", "Wickenburg"),
  "85392": p("AZ", "Avondale"),
  "85395": p("AZ", "Goodyear"),
  "85396": p("AZ", "Buckeye"),
  "85360": p("AZ", "Wikieup"),
  "86021": p("AZ", "Colorado City"),
  "86401": p("AZ", "Kingman"),
  "86402": p("AZ", "Kingman"),
  "86403": p("AZ", "Lake Havasu City"),
  "86404": p("AZ", "Lake Havasu City"),
  "86405": p("AZ", "Lake Havasu City"),
  "86406": p("AZ", "Lake Havasu City"),
  "86409": p("AZ", "Kingman"),
  "86411": p("AZ", "Hackberry"),
  "86412": p("AZ", "Hualapai"),
  "86413": p("AZ", "Golden Valley"),
  "86426": p("AZ", "Fort Mohave"),
  "86427": p("AZ", "Fort Mohave"),
  "86429": p("AZ", "Bullhead City"),
  "86430": p("AZ", "Bullhead City"),
  "86431": p("AZ", "Chloride"),
  "86432": p("AZ", "Littlefield"),
  "86433": p("AZ", "Oatman"),
  "86434": p("AZ", "Peach Springs"),
  "86436": p("AZ", "Topock"),
  "86437": p("AZ", "Valentine"),
  "86438": p("AZ", "Yucca"),
  "86439": p("AZ", "Bullhead City"),
  "86440": p("AZ", "Mohave Valley"),
  "86441": p("AZ", "Dolan Springs"),
  "86442": p("AZ", "Bullhead City"),
  "86443": p("AZ", "Temple Bar Marina"),
  "86444": p("AZ", "Meadview"),
  "86445": p("AZ", "Willow Beach"),
  "86446": p("AZ", "Mohave Valley"),
  "85901": p("AZ", "Show Low"),
  "85902": p("AZ", "Show Low"),
  "85911": p("AZ", "Cibecue"),
  "85912": p("AZ", "White Mountain Lake"),
  "85923": p("AZ", "Clay Springs"),
  "85926": p("AZ", "Fort Apache"),
  "85928": p("AZ", "Heber"),
  "85929": p("AZ", "Lakeside"),
  "85933": p("AZ", "Overgaard"),
  "85934": p("AZ", "Pinedale"),
  "85935": p("AZ", "Pinetop"),
  "85937": p("AZ", "Snowflake"),
  "85939": p("AZ", "Taylor"),
  "85941": p("AZ", "Whiteriver"),
  "85942": p("AZ", "Woodruff"),
  "86025": p("AZ", "Holbrook"),
  "86029": p("AZ", "Sun Valley"),
  "86030": p("AZ", "Hotevilla"),
  "86031": p("AZ", "Indian Wells"),
  "86032": p("AZ", "Joseph City"),
  "86033": p("AZ", "Kayenta"),
  "86034": p("AZ", "Keams Canyon"),
  "86039": p("AZ", "Kykotsmovi Village"),
  "86042": p("AZ", "Polacca"),
  "86043": p("AZ", "Second Mesa"),
  "86047": p("AZ", "Winslow"),
  "86054": p("AZ", "Shonto"),
  "86510": p("AZ", "Pinon"),
  "86520": p("AZ", "Blue Gap"),
  "85321": p("AZ", "Ajo"),
  "85341": p("AZ", "Lukeville"),
  "85601": p("AZ", "Arivaca"),
  "85614": p("AZ", "Green Valley"),
  "85619": p("AZ", "Mount Lemmon"),
  "85622": p("AZ", "Green Valley"),
  "85629": p("AZ", "Sahuarita"),
  "85633": p("AZ", "Sasabe"),
  "85634": p("AZ", "Sells"),
  "85639": p("AZ", "Topawa"),
  "85641": p("AZ", "Vail"),
  "85652": p("AZ", "Cortaro"),
  "85653": p("AZ", "Marana"),
  "85654": p("AZ", "Rillito"),
  "85701": p("AZ", "Tucson"),
  "85702": p("AZ", "Tucson"),
  "85703": p("AZ", "Tucson"),
  "85704": p("AZ", "Tucson"),
  "85705": p("AZ", "Tucson"),
  "85706": p("AZ", "Tucson"),
  "85707": p("AZ", "Tucson"),
  "85708": p("AZ", "Tucson"),
  "85709": p("AZ", "Tucson"),
  "85710": p("AZ", "Tucson"),
  "85711": p("AZ", "Tucson"),
  "85712": p("AZ", "Tucson"),
  "85713": p("AZ", "Tucson"),
  "85714": p("AZ", "Tucson"),
  "85715": p("AZ", "Tucson"),
  "85716": p("AZ", "Tucson"),
  "85717": p("AZ", "Tucson"),
  "85718": p("AZ", "Tucson"),
  "85719": p("AZ", "Tucson"),
  "85720": p("AZ", "Tucson"),
  "85721": p("AZ", "Tucson"),
  "85722": p("AZ", "Tucson"),
  "85723": p("AZ", "Tucson"),
  "85724": p("AZ", "Tucson"),
  "85725": p("AZ", "Tucson"),
  "85726": p("AZ", "Tucson"),
  "85728": p("AZ", "Tucson"),
  "85730": p("AZ", "Tucson"),
  "85731": p("AZ", "Tucson"),
  "85732": p("AZ", "Tucson"),
  "85733": p("AZ", "Tucson"),
  "85734": p("AZ", "Tucson"),
  "85735": p("AZ", "Tucson"),
  "85736": p("AZ", "Tucson"),
  "85737": p("AZ", "Tucson"),
  "85738": p("AZ", "Catalina"),
  "85739": p("AZ", "Tucson"),
  "85740": p("AZ", "Tucson"),
  "85741": p("AZ", "Tucson"),
  "85742": p("AZ", "Tucson"),
  "85743": p("AZ", "Tucson"),
  "85744": p("AZ", "Tucson"),
  "85745": p("AZ", "Tucson"),
  "85746": p("AZ", "Tucson"),
  "85747": p("AZ", "Tucson"),
  "85748": p("AZ", "Tucson"),
  "85749": p("AZ", "Tucson"),
  "85750": p("AZ", "Tucson"),
  "85751": p("AZ", "Tucson"),
  "85752": p("AZ", "Tucson"),
  "85754": p("AZ", "Tucson"),
  "85755": p("AZ", "Tucson"),
  "85756": p("AZ", "Tucson"),
  "85757": p("AZ", "Tucson"),
  "85775": p("AZ", "Tucson"),
  "85117": p("AZ", "Apache Junction"),
  "85118": p("AZ", "Gold Canyon"),
  "85119": p("AZ", "Apache Junction"),
  "85120": p("AZ", "Apache Junction"),
  "85121": p("AZ", "Bapchule"),
  "85122": p("AZ", "Casa Grande"),
  "85123": p("AZ", "Arizona City"),
  "85128": p("AZ", "Coolidge"),
  "85130": p("AZ", "Casa Grande"),
  "85131": p("AZ", "Eloy"),
  "85132": p("AZ", "Florence"),
  "85137": p("AZ", "Kearny"),
  "85138": p("AZ", "Maricopa"),
  "85139": p("AZ", "Maricopa"),
  "85140": p("AZ", "San Tan Valley"),
  "85141": p("AZ", "Picacho"),
  "85143": p("AZ", "San Tan Valley"),
  "85145": p("AZ", "Red Rock"),
  "85147": p("AZ", "Sacaton"),
  "85172": p("AZ", "Stanfield"),
  "85173": p("AZ", "Superior"),
  "85178": p("AZ", "Apache Junction"),
  "85191": p("AZ", "Valley Farms"),
  "85193": p("AZ", "Casa Grande"),
  "85194": p("AZ", "Casa Grande"),
  "85618": p("AZ", "Mammoth"),
  "85623": p("AZ", "Oracle"),
  "85631": p("AZ", "San Manuel"),
  "85658": p("AZ", "Marana"),
  "85611": p("AZ", "Elgin"),
  "85621": p("AZ", "Nogales"),
  "85624": p("AZ", "Patagonia"),
  "85628": p("AZ", "Nogales"),
  "85637": p("AZ", "Sonoita"),
  "85640": p("AZ", "Tumacacori"),
  "85645": p("AZ", "Amado"),
  "85646": p("AZ", "Tubac"),
  "85648": p("AZ", "Rio Rico"),
  "85662": p("AZ", "Nogales"),
  "85324": p("AZ", "Black Canyon City"),
  "85332": p("AZ", "Congress"),
  "85362": p("AZ", "Yarnell"),
  "86301": p("AZ", "Prescott"),
  "86302": p("AZ", "Prescott"),
  "86303": p("AZ", "Prescott"),
  "86304": p("AZ", "Prescott"),
  "86305": p("AZ", "Prescott"),
  "86312": p("AZ", "Prescott Valley"),
  "86313": p("AZ", "Prescott"),
  "86314": p("AZ", "Prescott Valley"),
  "86315": p("AZ", "Prescott Valley"),
  "86320": p("AZ", "Ash Fork"),
  "86321": p("AZ", "Bagdad"),
  "86322": p("AZ", "Camp Verde"),
  "86323": p("AZ", "Chino Valley"),
  "86324": p("AZ", "Clarkdale"),
  "86325": p("AZ", "Cornville"),
  "86326": p("AZ", "Cottonwood"),
  "86327": p("AZ", "Dewey"),
  "86329": p("AZ", "Humboldt"),
  "86331": p("AZ", "Jerome"),
  "86332": p("AZ", "Kirkland"),
  "86333": p("AZ", "Mayer"),
  "86334": p("AZ", "Paulden"),
  "86335": p("AZ", "Rimrock"),
  "86337": p("AZ", "Seligman"),
  "86338": p("AZ", "Skull Valley"),
  "86340": p("AZ", "Sedona"),
  "86341": p("AZ", "Sedona"),
  "86342": p("AZ", "Lake Montezuma"),
  "86343": p("AZ", "Crown King"),
  "85333": p("AZ", "Dateland"),
  "85336": p("AZ", "Gadsden"),
  "85347": p("AZ", "Roll"),
  "85349": p("AZ", "San Luis"),
  "85350": p("AZ", "Somerton"),
  "85352": p("AZ", "Tacna"),
  "85356": p("AZ", "Wellton"),
  "85364": p("AZ", "Yuma"),
  "85365": p("AZ", "Yuma"),
  "85366": p("AZ", "Yuma"),
  "85367": p("AZ", "Yuma"),
  "85369": p("AZ", "Yuma"),
  "94501": p("CA", "Alameda"),
  "94502": p("CA", "Alameda"),
  "94536": p("CA", "Fremont"),
  "94537": p("CA", "Fremont"),
  "94538": p("CA", "Fremont"),
  "94539": p("CA", "Fremont"),
  "94540": p("CA", "Hayward"),
  "94541": p("CA", "Hayward"),
  "94542": p("CA", "Hayward"),
  "94543": p("CA", "Hayward"),
  "94544": p("CA", "Hayward"),
  "94545": p("CA", "Hayward"),
  "94546": p("CA", "Castro Valley"),
  "94550": p("CA", "Livermore"),
  "94551": p("CA", "Livermore"),
  "94552": p("CA", "Castro Valley"),
  "94555": p("CA", "Fremont"),
  "94557": p("CA", "Hayward"),
  "94560": p("CA", "Newark"),
  "94566": p("CA", "Pleasanton"),
  "94568": p("CA", "Dublin"),
  "94577": p("CA", "San Leandro"),
  "94578": p("CA", "San Leandro"),
  "94579": p("CA", "San Leandro"),
  "94580": p("CA", "San Lorenzo"),
  "94586": p("CA", "Sunol"),
  "94587": p("CA", "Union City"),
  "94588": p("CA", "Pleasanton"),
  "94601": p("CA", "Oakland"),
  "94602": p("CA", "Oakland"),
  "94603": p("CA", "Oakland"),
  "94604": p("CA", "Oakland"),
  "94605": p("CA", "Oakland"),
  "94606": p("CA", "Oakland"),
  "94607": p("CA", "Oakland"),
  "94608": p("CA", "Emeryville"),
  "94609": p("CA", "Oakland"),
  "94610": p("CA", "Oakland"),
  "94611": p("CA", "Oakland"),
  "94612": p("CA", "Oakland"),
  "94613": p("CA", "Oakland"),
  "94614": p("CA", "Oakland"),
  "94615": p("CA", "Oakland"),
  "94617": p("CA", "Oakland"),
  "94618": p("CA", "Oakland"),
  "94619": p("CA", "Oakland"),
  "94620": p("CA", "Piedmont"),
  "94621": p("CA", "Oakland"),
  "94622": p("CA", "Oakland"),
  "94623": p("CA", "Oakland"),
  "94624": p("CA", "Oakland"),
  "94649": p("CA", "Oakland"),
  "94659": p("CA", "Oakland"),
  "94660": p("CA", "Oakland"),
  "94661": p("CA", "Oakland"),
  "94662": p("CA", "Emeryville"),
  "94666": p("CA", "Oakland"),
  "94701": p("CA", "Berkeley"),
  "94702": p("CA", "Berkeley"),
  "94703": p("CA", "Berkeley"),
  "94704": p("CA", "Berkeley"),
  "94705": p("CA", "Berkeley"),
  "94706": p("CA", "Albany"),
  "94707": p("CA", "Berkeley"),
  "94708": p("CA", "Berkeley"),
  "94709": p("CA", "Berkeley"),
  "94710": p("CA", "Berkeley"),
  "94712": p("CA", "Berkeley"),
  "94720": p("CA", "Berkeley"),
  "95646": p("CA", "Kirkwood"),
  "96120": p("CA", "Markleeville"),
  "95601": p("CA", "Amador City"),
  "95629": p("CA", "Fiddletown"),
  "95640": p("CA", "Ione"),
  "95642": p("CA", "Jackson"),
  "95644": p("CA", "Kit Carson"),
  "95654": p("CA", "Martell"),
  "95665": p("CA", "Pine Grove"),
  "95666": p("CA", "Pioneer"),
  "95669": p("CA", "Plymouth"),
  "95675": p("CA", "River Pines"),
  "95685": p("CA", "Sutter Creek"),
  "95689": p("CA", "Volcano"),
  "95699": p("CA", "Drytown"),
  "95914": p("CA", "Bangor"),
  "95916": p("CA", "Berry Creek"),
  "95917": p("CA", "Biggs"),
  "95926": p("CA", "Chico"),
  "95927": p("CA", "Chico"),
  "95928": p("CA", "Chico"),
  "95929": p("CA", "Chico"),
  "95930": p("CA", "Clipper Mills"),
  "95938": p("CA", "Durham"),
  "95940": p("CA", "Feather Falls"),
  "95941": p("CA", "Forbestown"),
  "95942": p("CA", "Forest Ranch"),
  "95948": p("CA", "Gridley"),
  "95954": p("CA", "Magalia"),
  "95958": p("CA", "Nelson"),
  "95965": p("CA", "Oroville"),
  "95966": p("CA", "Oroville"),
  "95967": p("CA", "Paradise"),
  "95968": p("CA", "Palermo"),
  "95969": p("CA", "Paradise"),
  "95973": p("CA", "Chico"),
  "95974": p("CA", "Richvale"),
  "95976": p("CA", "Chico"),
  "95978": p("CA", "Stirling City"),
  "95221": p("CA", "Altaville"),
  "95222": p("CA", "Angels Camp"),
  "95223": p("CA", "Arnold"),
  "95224": p("CA", "Avery"),
  "95225": p("CA", "Burson"),
  "95226": p("CA", "Campo Seco"),
  "95228": p("CA", "Copperopolis"),
  "95229": p("CA", "Douglas Flat"),
  "95232": p("CA", "Glencoe"),
  "95233": p("CA", "Hathaway Pines"),
  "95245": p("CA", "Mokelumne Hill"),
  "95246": p("CA", "Mountain Ranch"),
  "95247": p("CA", "Murphys"),
  "95248": p("CA", "Rail Road Flat"),
  "95249": p("CA", "San Andreas"),
  "95251": p("CA", "Vallecito"),
  "95252": p("CA", "Valley Springs"),
  "95254": p("CA", "Wallace"),
  "95255": p("CA", "West Point"),
  "95257": p("CA", "Wilseyville"),
  "95912": p("CA", "Arbuckle"),
  "95932": p("CA", "Colusa"),
  "95950": p("CA", "Grimes"),
  "95955": p("CA", "Maxwell"),
  "95970": p("CA", "Princeton"),
  "95979": p("CA", "Stonyford"),
  "95987": p("CA", "Williams"),
  "94505": p("CA", "Discovery Bay"),
  "94506": p("CA", "Danville"),
  "94507": p("CA", "Alamo"),
  "94509": p("CA", "Antioch"),
  "94511": p("CA", "Bethel Island"),
  "94513": p("CA", "Brentwood"),
  "94514": p("CA", "Byron"),
  "94516": p("CA", "Canyon"),
  "94517": p("CA", "Clayton"),
  "94518": p("CA", "Concord"),
  "94519": p("CA", "Concord"),
  "94520": p("CA", "Concord"),
  "94521": p("CA", "Concord"),
  "94522": p("CA", "Concord"),
  "94523": p("CA", "Pleasant Hill"),
  "94524": p("CA", "Concord"),
  "94525": p("CA", "Crockett"),
  "94526": p("CA", "Danville"),
  "94527": p("CA", "Concord"),
  "94528": p("CA", "Diablo"),
  "94529": p("CA", "Concord"),
  "94530": p("CA", "El Cerrito"),
  "94531": p("CA", "Antioch"),
  "94547": p("CA", "Hercules"),
  "94548": p("CA", "Knightsen"),
  "94549": p("CA", "Lafayette"),
  "94553": p("CA", "Martinez"),
  "94556": p("CA", "Moraga"),
  "94561": p("CA", "Oakley"),
  "94563": p("CA", "Orinda"),
  "94564": p("CA", "Pinole"),
  "94565": p("CA", "Pittsburg"),
  "94569": p("CA", "Port Costa"),
  "94570": p("CA", "Moraga"),
  "94572": p("CA", "Rodeo"),
  "94575": p("CA", "Moraga"),
  "94582": p("CA", "San Ramon"),
  "94583": p("CA", "San Ramon"),
  "94595": p("CA", "Walnut Creek"),
  "94596": p("CA", "Walnut Creek"),
  "94597": p("CA", "Walnut Creek"),
  "94598": p("CA", "Walnut Creek"),
  "94801": p("CA", "Richmond"),
  "94802": p("CA", "Richmond"),
  "94803": p("CA", "El Sobrante"),
  "94804": p("CA", "Richmond"),
  "94805": p("CA", "Richmond"),
  "94806": p("CA", "San Pablo"),
  "94807": p("CA", "Richmond"),
  "94808": p("CA", "Richmond"),
  "94820": p("CA", "El Sobrante"),
  "94850": p("CA", "Richmond"),
  "95531": p("CA", "Crescent City"),
  "95532": p("CA", "Crescent City"),
  "95538": p("CA", "Fort Dick"),
  "95543": p("CA", "Gasquet"),
  "95548": p("CA", "Klamath"),
  "95567": p("CA", "Smith River"),
  "95613": p("CA", "Coloma"),
  "95614": p("CA", "Cool"),
  "95619": p("CA", "Diamond Springs"),
  "95623": p("CA", "El Dorado"),
  "95633": p("CA", "Garden Valley"),
  "95634": p("CA", "Georgetown"),
  "95635": p("CA", "Greenwood"),
  "95636": p("CA", "Grizzly Flats"),
  "95651": p("CA", "Lotus"),
  "95656": p("CA", "Mount Aukum"),
  "95664": p("CA", "Pilot Hill"),
  "95667": p("CA", "Placerville"),
  "95672": p("CA", "Rescue"),
  "95682": p("CA", "Shingle Springs"),
  "95684": p("CA", "Somerset"),
  "95709": p("CA", "Camino"),
  "95720": p("CA", "Kyburz"),
  "95721": p("CA", "Echo Lake"),
  "95726": p("CA", "Pollock Pines"),
  "95735": p("CA", "Twin Bridges"),
  "95762": p("CA", "El Dorado Hills"),
  "96142": p("CA", "Tahoma"),
  "96150": p("CA", "South Lake Tahoe"),
  "96151": p("CA", "South Lake Tahoe"),
  "96152": p("CA", "South Lake Tahoe"),
  "96154": p("CA", "South Lake Tahoe"),
  "96155": p("CA", "South Lake Tahoe"),
  "96156": p("CA", "South Lake Tahoe"),
  "96157": p("CA", "South Lake Tahoe"),
  "96158": p("CA", "South Lake Tahoe"),
  "93210": p("CA", "Coalinga"),
  "93234": p("CA", "Huron"),
  "93242": p("CA", "Laton"),
  "93602": p("CA", "Auberry"),
  "93605": p("CA", "Big Creek"),
  "93606": p("CA", "Biola"),
  "93607": p("CA", "Burrel"),
  "93608": p("CA", "Cantua Creek"),
  "93609": p("CA", "Caruthers"),
  "93611": p("CA", "Clovis"),
  "93612": p("CA", "Clovis"),
  "93613": p("CA", "Clovis"),
  "93616": p("CA", "Del Rey"),
  "93621": p("CA", "Dunlap"),
  "93622": p("CA", "Firebaugh"),
  "93624": p("CA", "Five Points"),
  "93625": p("CA", "Fowler"),
  "93626": p("CA", "Friant"),
  "93627": p("CA", "Helm"),
  "93628": p("CA", "Hume"),
  "93630": p("CA", "Kerman"),
  "93631": p("CA", "Kingsburg"),
  "93634": p("CA", "Lakeshore"),
  "93640": p("CA", "Mendota"),
  "93641": p("CA", "Miramonte"),
  "93642": p("CA", "Mono Hot Springs"),
  "93646": p("CA", "Orange Cove"),
  "93648": p("CA", "Parlier"),
  "93649": p("CA", "Piedra"),
  "93650": p("CA", "Fresno"),
  "93651": p("CA", "Prather"),
  "93652": p("CA", "Raisin City"),
  "93654": p("CA", "Reedley"),
  "93656": p("CA", "Riverdale"),
  "93657": p("CA", "Sanger"),
  "93660": p("CA", "San Joaquin"),
  "93662": p("CA", "Selma"),
  "93664": p("CA", "Shaver Lake"),
  "93667": p("CA", "Tollhouse"),
  "93668": p("CA", "Tranquillity"),
  "93675": p("CA", "Squaw Valley"),
  "93701": p("CA", "Fresno"),
  "93702": p("CA", "Fresno"),
  "93703": p("CA", "Fresno"),
  "93704": p("CA", "Fresno"),
  "93705": p("CA", "Fresno"),
  "93706": p("CA", "Fresno"),
  "93707": p("CA", "Fresno"),
  "93708": p("CA", "Fresno"),
  "93709": p("CA", "Fresno"),
  "93710": p("CA", "Fresno"),
  "93711": p("CA", "Fresno"),
  "93712": p("CA", "Fresno"),
  "93714": p("CA", "Fresno"),
  "93715": p("CA", "Fresno"),
  "93716": p("CA", "Fresno"),
  "93717": p("CA", "Fresno"),
  "93718": p("CA", "Fresno"),
  "93720": p("CA", "Fresno"),
  "93721": p("CA", "Fresno"),
  "93722": p("CA", "Fresno"),
  "93723": p("CA", "Fresno"),
  "93724": p("CA", "Fresno"),
  "93725": p("CA", "Fresno"),
  "93726": p("CA", "Fresno"),
  "93727": p("CA", "Fresno"),
  "93728": p("CA", "Fresno"),
  "93729": p("CA", "Fresno"),
  "93730": p("CA", "Fresno"),
  "93737": p("CA", "Fresno"),
  "93740": p("CA", "Fresno"),
  "93741": p("CA", "Fresno"),
  "93744": p("CA", "Fresno"),
  "93745": p("CA", "Fresno"),
  "93747": p("CA", "Fresno"),
  "93750": p("CA", "Fresno"),
  "93755": p("CA", "Fresno"),
  "93760": p("CA", "Fresno"),
  "93761": p("CA", "Fresno"),
  "93764": p("CA", "Fresno"),
  "93765": p("CA", "Fresno"),
  "93771": p("CA", "Fresno"),
  "93772": p("CA", "Fresno"),
  "93773": p("CA", "Fresno"),
  "93774": p("CA", "Fresno"),
  "93775": p("CA", "Fresno"),
  "93776": p("CA", "Fresno"),
  "93777": p("CA", "Fresno"),
  "93778": p("CA", "Fresno"),
  "93779": p("CA", "Fresno"),
  "93786": p("CA", "Fresno"),
  "93790": p("CA", "Fresno"),
  "93791": p("CA", "Fresno"),
  "93792": p("CA", "Fresno"),
  "93793": p("CA", "Fresno"),
  "93794": p("CA", "Fresno"),
  "93844": p("CA", "Fresno"),
  "93888": p("CA", "Fresno"),
  "95913": p("CA", "Artois"),
  "95920": p("CA", "Butte City"),
  "95939": p("CA", "Elk Creek"),
  "95943": p("CA", "Glenn"),
  "95951": p("CA", "Hamilton City"),
  "95963": p("CA", "Orland"),
  "95988": p("CA", "Willows"),
  "95501": p("CA", "Eureka"),
  "95502": p("CA", "Eureka"),
  "95503": p("CA", "Eureka"),
  "95511": p("CA", "Alderpoint"),
  "95514": p("CA", "Blocksburg"),
  "95518": p("CA", "Arcata"),
  "95519": p("CA", "Mckinleyville"),
  "95521": p("CA", "Arcata"),
  "95524": p("CA", "Bayside"),
  "95525": p("CA", "Blue Lake"),
  "95526": p("CA", "Bridgeville"),
  "95528": p("CA", "Carlotta"),
  "95534": p("CA", "Cutten"),
  "95536": p("CA", "Ferndale"),
  "95537": p("CA", "Fields Landing"),
  "95540": p("CA", "Fortuna"),
  "95542": p("CA", "Garberville"),
  "95545": p("CA", "Honeydew"),
  "95546": p("CA", "Hoopa"),
  "95547": p("CA", "Hydesville"),
  "95549": p("CA", "Kneeland"),
  "95550": p("CA", "Korbel"),
  "95551": p("CA", "Loleta"),
  "95553": p("CA", "Miranda"),
  "95554": p("CA", "Myers Flat"),
  "95555": p("CA", "Orick"),
  "95556": p("CA", "Orleans"),
  "95558": p("CA", "Petrolia"),
  "95559": p("CA", "Phillipsville"),
  "95560": p("CA", "Redway"),
  "95562": p("CA", "Rio Dell"),
  "95564": p("CA", "Samoa"),
  "95565": p("CA", "Scotia"),
  "95569": p("CA", "Redcrest"),
  "95570": p("CA", "Trinidad"),
  "95571": p("CA", "Weott"),
  "95573": p("CA", "Willow Creek"),
  "95589": p("CA", "Whitethorn"),
  "92222": p("CA", "Bard"),
  "92227": p("CA", "Brawley"),
  "92231": p("CA", "Calexico"),
  "92232": p("CA", "Calexico"),
  "92233": p("CA", "Calipatria"),
  "92243": p("CA", "El Centro"),
  "92244": p("CA", "El Centro"),
  "92249": p("CA", "Heber"),
  "92250": p("CA", "Holtville"),
  "92251": p("CA", "Imperial"),
  "92257": p("CA", "Niland"),
  "92259": p("CA", "Ocotillo"),
  "92266": p("CA", "Palo Verde"),
  "92273": p("CA", "Seeley"),
  "92275": p("CA", "Salton City"),
  "92281": p("CA", "Westmorland"),
  "92283": p("CA", "Winterhaven"),
  "92331": p("CA", "Fontana"),
  "92328": p("CA", "Death Valley"),
  "92384": p("CA", "Shoshone"),
  "92389": p("CA", "Tecopa"),
  "93513": p("CA", "Big Pine"),
  "93514": p("CA", "Bishop"),
  "93515": p("CA", "Bishop"),
  "93522": p("CA", "Darwin"),
  "93526": p("CA", "Independence"),
  "93530": p("CA", "Keeler"),
  "93542": p("CA", "Little Lake"),
  "93545": p("CA", "Lone Pine"),
  "93549": p("CA", "Olancha"),
  "93203": p("CA", "Arvin"),
  "93205": p("CA", "Bodfish"),
  "93206": p("CA", "Buttonwillow"),
  "93215": p("CA", "Delano"),
  "93216": p("CA", "Delano"),
  "93220": p("CA", "Edison"),
  "93222": p("CA", "Pine Mountain Club"),
  "93224": p("CA", "Fellows"),
  "93225": p("CA", "Frazier Park"),
  "93226": p("CA", "Glennville"),
  "93238": p("CA", "Kernville"),
  "93240": p("CA", "Lake Isabella"),
  "93241": p("CA", "Lamont"),
  "93243": p("CA", "Lebec"),
  "93249": p("CA", "Lost Hills"),
  "93250": p("CA", "Mc Farland"),
  "93251": p("CA", "Mc Kittrick"),
  "93252": p("CA", "Maricopa"),
  "93255": p("CA", "Onyx"),
  "93263": p("CA", "Shafter"),
  "93268": p("CA", "Taft"),
  "93276": p("CA", "Tupman"),
  "93280": p("CA", "Wasco"),
  "93283": p("CA", "Weldon"),
  "93285": p("CA", "Wofford Heights"),
  "93287": p("CA", "Woody"),
  "93301": p("CA", "Bakersfield"),
  "93302": p("CA", "Bakersfield"),
  "93303": p("CA", "Bakersfield"),
  "93304": p("CA", "Bakersfield"),
  "93305": p("CA", "Bakersfield"),
  "93306": p("CA", "Bakersfield"),
  "93307": p("CA", "Bakersfield"),
  "93308": p("CA", "Bakersfield"),
  "93309": p("CA", "Bakersfield"),
  "93311": p("CA", "Bakersfield"),
  "93312": p("CA", "Bakersfield"),
  "93313": p("CA", "Bakersfield"),
  "93314": p("CA", "Bakersfield"),
  "93380": p("CA", "Bakersfield"),
  "93383": p("CA", "Bakersfield"),
  "93384": p("CA", "Bakersfield"),
  "93385": p("CA", "Bakersfield"),
  "93386": p("CA", "Bakersfield"),
  "93387": p("CA", "Bakersfield"),
  "93388": p("CA", "Bakersfield"),
  "93389": p("CA", "Bakersfield"),
  "93390": p("CA", "Bakersfield"),
  "93501": p("CA", "Mojave"),
  "93502": p("CA", "Mojave"),
  "93504": p("CA", "California City"),
  "93505": p("CA", "California City"),
  "93516": p("CA", "Boron"),
  "93518": p("CA", "Caliente"),
  "93519": p("CA", "Cantil"),
  "93523": p("CA", "Edwards"),
  "93524": p("CA", "Edwards"),
  "93527": p("CA", "Inyokern"),
  "93528": p("CA", "Johannesburg"),
  "93531": p("CA", "Keene"),
  "93554": p("CA", "Randsburg"),
  "93555": p("CA", "Ridgecrest"),
  "93556": p("CA", "Ridgecrest"),
  "93560": p("CA", "Rosamond"),
  "93561": p("CA", "Tehachapi"),
  "93581": p("CA", "Tehachapi"),
  "93596": p("CA", "Boron"),
  "93202": p("CA", "Armona"),
  "93204": p("CA", "Avenal"),
  "93212": p("CA", "Corcoran"),
  "93230": p("CA", "Hanford"),
  "93232": p("CA", "Hanford"),
  "93239": p("CA", "Kettleman City"),
  "93245": p("CA", "Lemoore"),
  "93246": p("CA", "Lemoore"),
  "93266": p("CA", "Stratford"),
  "95422": p("CA", "Clearlake"),
  "95423": p("CA", "Clearlake Oaks"),
  "95424": p("CA", "Clearlake Park"),
  "95426": p("CA", "Cobb"),
  "95435": p("CA", "Finley"),
  "95443": p("CA", "Glenhaven"),
  "95451": p("CA", "Kelseyville"),
  "95453": p("CA", "Lakeport"),
  "95457": p("CA", "Lower Lake"),
  "95458": p("CA", "Lucerne"),
  "95461": p("CA", "Middletown"),
  "95464": p("CA", "Nice"),
  "95467": p("CA", "Hidden Valley Lake"),
  "95485": p("CA", "Upper Lake"),
  "95493": p("CA", "Witter Springs"),
  "96009": p("CA", "Bieber"),
  "96068": p("CA", "Nubieber"),
  "96109": p("CA", "Doyle"),
  "96113": p("CA", "Herlong"),
  "96114": p("CA", "Janesville"),
  "96117": p("CA", "Litchfield"),
  "96119": p("CA", "Madeline"),
  "96121": p("CA", "Milford"),
  "96123": p("CA", "Ravendale"),
  "96127": p("CA", "Susanville"),
  "96128": p("CA", "Standish"),
  "96130": p("CA", "Susanville"),
  "96132": p("CA", "Termo"),
  "96136": p("CA", "Wendel"),
  "96137": p("CA", "Westwood"),
  "90001": p("CA", "Los Angeles"),
  "90002": p("CA", "Los Angeles"),
  "90003": p("CA", "Los Angeles"),
  "90004": p("CA", "Los Angeles"),
  "90005": p("CA", "Los Angeles"),
  "90006": p("CA", "Los Angeles"),
  "90007": p("CA", "Los Angeles"),
  "90008": p("CA", "Los Angeles"),
  "90009": p("CA", "Los Angeles"),
  "90010": p("CA", "Los Angeles"),
  "90011": p("CA", "Los Angeles"),
  "90012": p("CA", "Los Angeles"),
  "90013": p("CA", "Los Angeles"),
  "90014": p("CA", "Los Angeles"),
  "90015": p("CA", "Los Angeles"),
  "90016": p("CA", "Los Angeles"),
  "90017": p("CA", "Los Angeles"),
  "90018": p("CA", "Los Angeles"),
  "90019": p("CA", "Los Angeles"),
  "90020": p("CA", "Los Angeles"),
  "90021": p("CA", "Los Angeles"),
  "90022": p("CA", "Los Angeles"),
  "90023": p("CA", "Los Angeles"),
  "90024": p("CA", "Los Angeles"),
  "90025": p("CA", "Los Angeles"),
  "90026": p("CA", "Los Angeles"),
  "90027": p("CA", "Los Angeles"),
  "90028": p("CA", "Los Angeles"),
  "90029": p("CA", "Los Angeles"),
  "90030": p("CA", "Los Angeles"),
  "90031": p("CA", "Los Angeles"),
  "90032": p("CA", "Los Angeles"),
  "90033": p("CA", "Los Angeles"),
  "90034": p("CA", "Los Angeles"),
  "90035": p("CA", "Los Angeles"),
  "90036": p("CA", "Los Angeles"),
  "90037": p("CA", "Los Angeles"),
  "90038": p("CA", "Los Angeles"),
  "90039": p("CA", "Los Angeles"),
  "90040": p("CA", "Los Angeles"),
  "90041": p("CA", "Los Angeles"),
  "90042": p("CA", "Los Angeles"),
  "90043": p("CA", "Los Angeles"),
  "90044": p("CA", "Los Angeles"),
  "90045": p("CA", "Los Angeles"),
  "90046": p("CA", "Los Angeles"),
  "90047": p("CA", "Los Angeles"),
  "90048": p("CA", "Los Angeles"),
  "90049": p("CA", "Los Angeles"),
  "90050": p("CA", "Los Angeles"),
  "90051": p("CA", "Los Angeles"),
  "90052": p("CA", "Los Angeles"),
  "90053": p("CA", "Los Angeles"),
  "90054": p("CA", "Los Angeles"),
  "90055": p("CA", "Los Angeles"),
  "90056": p("CA", "Los Angeles"),
  "90057": p("CA", "Los Angeles"),
  "90058": p("CA", "Los Angeles"),
  "90059": p("CA", "Los Angeles"),
  "90060": p("CA", "Los Angeles"),
  "90061": p("CA", "Los Angeles"),
  "90062": p("CA", "Los Angeles"),
  "90063": p("CA", "Los Angeles"),
  "90064": p("CA", "Los Angeles"),
  "90065": p("CA", "Los Angeles"),
  "90066": p("CA", "Los Angeles"),
  "90067": p("CA", "Los Angeles"),
  "90068": p("CA", "Los Angeles"),
  "90069": p("CA", "West Hollywood"),
  "90070": p("CA", "Los Angeles"),
  "90071": p("CA", "Los Angeles"),
  "90072": p("CA", "Los Angeles"),
  "90073": p("CA", "Los Angeles"),
  "90074": p("CA", "Los Angeles"),
  "90075": p("CA", "Los Angeles"),
  "90076": p("CA", "Los Angeles"),
  "90077": p("CA", "Los Angeles"),
  "90078": p("CA", "Los Angeles"),
  "90079": p("CA", "Los Angeles"),
  "90080": p("CA", "Los Angeles"),
  "90081": p("CA", "Los Angeles"),
  "90082": p("CA", "Los Angeles"),
  "90083": p("CA", "Los Angeles"),
  "90084": p("CA", "Los Angeles"),
  "90086": p("CA", "Los Angeles"),
  "90087": p("CA", "Los Angeles"),
  "90088": p("CA", "Los Angeles"),
  "90089": p("CA", "Los Angeles"),
  "90090": p("CA", "Dodgertown"),
  "90091": p("CA", "Los Angeles"),
  "90093": p("CA", "Los Angeles"),
  "90094": p("CA", "Playa Vista"),
  "90095": p("CA", "Los Angeles"),
  "90096": p("CA", "Los Angeles"),
  "90099": p("CA", "Los Angeles"),
  "90134": p("CA", "Los Angeles"),
  "90189": p("CA", "Los Angeles"),
  "90201": p("CA", "Bell Gardens"),
  "90202": p("CA", "Bell"),
  "90209": p("CA", "Beverly Hills"),
  "90210": p("CA", "Beverly Hills"),
  "90211": p("CA", "Beverly Hills"),
  "90212": p("CA", "Beverly Hills"),
  "90213": p("CA", "Beverly Hills"),
  "90220": p("CA", "Compton"),
  "90221": p("CA", "Compton"),
  "90222": p("CA", "Compton"),
  "90223": p("CA", "Compton"),
  "90224": p("CA", "Compton"),
  "90230": p("CA", "Culver City"),
  "90231": p("CA", "Culver City"),
  "90232": p("CA", "Culver City"),
  "90233": p("CA", "Culver City"),
  "90239": p("CA", "Downey"),
  "90240": p("CA", "Downey"),
  "90241": p("CA", "Downey"),
  "90242": p("CA", "Downey"),
  "90245": p("CA", "El Segundo"),
  "90247": p("CA", "Gardena"),
  "90248": p("CA", "Gardena"),
  "90249": p("CA", "Gardena"),
  "90250": p("CA", "Hawthorne"),
  "90251": p("CA", "Hawthorne"),
  "90254": p("CA", "Hermosa Beach"),
  "90255": p("CA", "Huntington Park"),
  "90260": p("CA", "Lawndale"),
  "90261": p("CA", "Lawndale"),
  "90262": p("CA", "Lynwood"),
  "90263": p("CA", "Malibu"),
  "90264": p("CA", "Malibu"),
  "90265": p("CA", "Malibu"),
  "90266": p("CA", "Manhattan Beach"),
  "90267": p("CA", "Manhattan Beach"),
  "90270": p("CA", "Maywood"),
  "90272": p("CA", "Pacific Palisades"),
  "90274": p("CA", "Palos Verdes Peninsula"),
  "90275": p("CA", "Rancho Palos Verdes"),
  "90277": p("CA", "Redondo Beach"),
  "90278": p("CA", "Redondo Beach"),
  "90280": p("CA", "South Gate"),
  "90290": p("CA", "Topanga"),
  "90291": p("CA", "Venice"),
  "90292": p("CA", "Marina Del Rey"),
  "90293": p("CA", "Playa Del Rey"),
  "90294": p("CA", "Venice"),
  "90295": p("CA", "Marina Del Rey"),
  "90296": p("CA", "Playa Del Rey"),
  "90301": p("CA", "Inglewood"),
  "90302": p("CA", "Inglewood"),
  "90303": p("CA", "Inglewood"),
  "90304": p("CA", "Inglewood"),
  "90305": p("CA", "Inglewood"),
  "90306": p("CA", "Inglewood"),
  "90307": p("CA", "Inglewood"),
  "90308": p("CA", "Inglewood"),
  "90309": p("CA", "Inglewood"),
  "90310": p("CA", "Inglewood"),
  "90311": p("CA", "Inglewood"),
  "90312": p("CA", "Inglewood"),
  "90401": p("CA", "Santa Monica"),
  "90402": p("CA", "Santa Monica"),
  "90403": p("CA", "Santa Monica"),
  "90404": p("CA", "Santa Monica"),
  "90405": p("CA", "Santa Monica"),
  "90406": p("CA", "Santa Monica"),
  "90407": p("CA", "Santa Monica"),
  "90408": p("CA", "Santa Monica"),
  "90409": p("CA", "Santa Monica"),
  "90410": p("CA", "Santa Monica"),
  "90411": p("CA", "Santa Monica"),
  "90501": p("CA", "Torrance"),
  "90502": p("CA", "Torrance"),
  "90503": p("CA", "Torrance"),
  "90504": p("CA", "Torrance"),
  "90505": p("CA", "Torrance"),
  "90506": p("CA", "Torrance"),
  "90507": p("CA", "Torrance"),
  "90508": p("CA", "Torrance"),
  "90509": p("CA", "Torrance"),
  "90510": p("CA", "Torrance"),
  "90601": p("CA", "Whittier"),
  "90602": p("CA", "Whittier"),
  "90603": p("CA", "Whittier"),
  "90604": p("CA", "Whittier"),
  "90605": p("CA", "Whittier"),
  "90606": p("CA", "Whittier"),
  "90607": p("CA", "Whittier"),
  "90608": p("CA", "Whittier"),
  "90609": p("CA", "Whittier"),
  "90610": p("CA", "Whittier"),
  "90637": p("CA", "La Mirada"),
  "90638": p("CA", "La Mirada"),
  "90639": p("CA", "La Mirada"),
  "90640": p("CA", "Montebello"),
  "90650": p("CA", "Norwalk"),
  "90651": p("CA", "Norwalk"),
  "90652": p("CA", "Norwalk"),
  "90660": p("CA", "Pico Rivera"),
  "90661": p("CA", "Pico Rivera"),
  "90662": p("CA", "Pico Rivera"),
  "90670": p("CA", "Santa Fe Springs"),
  "90671": p("CA", "Santa Fe Springs"),
  "90701": p("CA", "Artesia"),
  "90702": p("CA", "Artesia"),
  "90703": p("CA", "Cerritos"),
  "90704": p("CA", "Avalon"),
  "90706": p("CA", "Bellflower"),
  "90707": p("CA", "Bellflower"),
  "90710": p("CA", "Harbor City"),
  "90711": p("CA", "Lakewood"),
  "90712": p("CA", "Lakewood"),
  "90713": p("CA", "Lakewood"),
  "90714": p("CA", "Lakewood"),
  "90715": p("CA", "Lakewood"),
  "90716": p("CA", "Hawaiian Gardens"),
  "90717": p("CA", "Lomita"),
  "90723": p("CA", "Paramount"),
  "90731": p("CA", "San Pedro"),
  "90732": p("CA", "San Pedro"),
  "90733": p("CA", "San Pedro"),
  "90734": p("CA", "San Pedro"),
  "90744": p("CA", "Wilmington"),
  "90745": p("CA", "Carson"),
  "90746": p("CA", "Carson"),
  "90747": p("CA", "Carson"),
  "90748": p("CA", "Wilmington"),
  "90749": p("CA", "Carson"),
  "90755": p("CA", "Signal Hill"),
  "90801": p("CA", "Long Beach"),
  "90802": p("CA", "Long Beach"),
  "90803": p("CA", "Long Beach"),
  "90804": p("CA", "Long Beach"),
  "90805": p("CA", "Long Beach"),
  "90806": p("CA", "Long Beach"),
  "90807": p("CA", "Long Beach"),
  "90808": p("CA", "Long Beach"),
  "90809": p("CA", "Long Beach"),
  "90810": p("CA", "Long Beach"),
  "90813": p("CA", "Long Beach"),
  "90814": p("CA", "Long Beach"),
  "90815": p("CA", "Long Beach"),
  "90822": p("CA", "Long Beach"),
  "90831": p("CA", "Long Beach"),
  "90832": p("CA", "Long Beach"),
  "90833": p("CA", "Long Beach"),
  "90834": p("CA", "Long Beach"),
  "90835": p("CA", "Long Beach"),
  "90840": p("CA", "Long Beach"),
  "90842": p("CA", "Long Beach"),
  "90844": p("CA", "Long Beach"),
  "90846": p("CA", "Long Beach"),
  "90847": p("CA", "Long Beach"),
  "90848": p("CA", "Long Beach"),
  "90853": p("CA", "Long Beach"),
  "90895": p("CA", "Carson"),
  "90899": p("CA", "Long Beach"),
  "91001": p("CA", "Altadena"),
  "91003": p("CA", "Altadena"),
  "91006": p("CA", "Arcadia"),
  "91007": p("CA", "Arcadia"),
  "91008": p("CA", "Duarte"),
  "91009": p("CA", "Duarte"),
  "91010": p("CA", "Duarte"),
  "91011": p("CA", "La Canada Flintridge"),
  "91012": p("CA", "La Canada Flintridge"),
  "91016": p("CA", "Monrovia"),
  "91017": p("CA", "Monrovia"),
  "91020": p("CA", "Montrose"),
  "91021": p("CA", "Montrose"),
  "91023": p("CA", "Mount Wilson"),
  "91024": p("CA", "Sierra Madre"),
  "91025": p("CA", "Sierra Madre"),
  "91030": p("CA", "South Pasadena"),
  "91031": p("CA", "South Pasadena"),
  "91040": p("CA", "Sunland"),
  "91041": p("CA", "Sunland"),
  "91042": p("CA", "Tujunga"),
  "91043": p("CA", "Tujunga"),
  "91046": p("CA", "Verdugo City"),
  "91066": p("CA", "Arcadia"),
  "91077": p("CA", "Arcadia"),
  "91101": p("CA", "Pasadena"),
  "91102": p("CA", "Pasadena"),
  "91103": p("CA", "Pasadena"),
  "91104": p("CA", "Pasadena"),
  "91105": p("CA", "Pasadena"),
  "91106": p("CA", "Pasadena"),
  "91107": p("CA", "Pasadena"),
  "91108": p("CA", "San Marino"),
  "91109": p("CA", "Pasadena"),
  "91110": p("CA", "Pasadena"),
  "91114": p("CA", "Pasadena"),
  "91115": p("CA", "Pasadena"),
  "91116": p("CA", "Pasadena"),
  "91117": p("CA", "Pasadena"),
  "91118": p("CA", "San Marino"),
  "91121": p("CA", "Pasadena"),
  "91123": p("CA", "Pasadena"),
  "91124": p("CA", "Pasadena"),
  "91125": p("CA", "Pasadena"),
  "91126": p("CA", "Pasadena"),
  "91129": p("CA", "Pasadena"),
  "91182": p("CA", "Pasadena"),
  "91184": p("CA", "Pasadena"),
  "91185": p("CA", "Pasadena"),
  "91188": p("CA", "Pasadena"),
  "91189": p("CA", "Pasadena"),
  "91199": p("CA", "Pasadena"),
  "91201": p("CA", "Glendale"),
  "91202": p("CA", "Glendale"),
  "91203": p("CA", "Glendale"),
  "91204": p("CA", "Glendale"),
  "91205": p("CA", "Glendale"),
  "91206": p("CA", "Glendale"),
  "91207": p("CA", "Glendale"),
  "91208": p("CA", "Glendale"),
  "91209": p("CA", "Glendale"),
  "91210": p("CA", "Glendale"),
  "91214": p("CA", "La Crescenta"),
  "91221": p("CA", "Glendale"),
  "91222": p("CA", "Glendale"),
  "91224": p("CA", "La Crescenta"),
  "91225": p("CA", "Glendale"),
  "91226": p("CA", "Glendale"),
  "91301": p("CA", "Agoura Hills"),
  "91302": p("CA", "Calabasas"),
  "91303": p("CA", "Canoga Park"),
  "91304": p("CA", "Canoga Park"),
  "91305": p("CA", "Canoga Park"),
  "91306": p("CA", "Winnetka"),
  "91307": p("CA", "West Hills"),
  "91308": p("CA", "West Hills"),
  "91309": p("CA", "Canoga Park"),
  "91310": p("CA", "Castaic"),
  "91311": p("CA", "Chatsworth"),
  "91313": p("CA", "Chatsworth"),
  "91316": p("CA", "Encino"),
  "91321": p("CA", "Newhall"),
  "91322": p("CA", "Newhall"),
  "91324": p("CA", "Northridge"),
  "91325": p("CA", "Northridge"),
  "91326": p("CA", "Porter Ranch"),
  "91327": p("CA", "Northridge"),
  "91328": p("CA", "Northridge"),
  "91329": p("CA", "Northridge"),
  "91330": p("CA", "Northridge"),
  "91331": p("CA", "Pacoima"),
  "91333": p("CA", "Pacoima"),
  "91334": p("CA", "Pacoima"),
  "91335": p("CA", "Reseda"),
  "91337": p("CA", "Reseda"),
  "91340": p("CA", "San Fernando"),
  "91341": p("CA", "San Fernando"),
  "91342": p("CA", "Sylmar"),
  "91343": p("CA", "North Hills"),
  "91344": p("CA", "Granada Hills"),
  "91345": p("CA", "Mission Hills"),
  "91346": p("CA", "Mission Hills"),
  "91350": p("CA", "Santa Clarita"),
  "91351": p("CA", "Canyon Country"),
  "91352": p("CA", "Sun Valley"),
  "91353": p("CA", "Sun Valley"),
  "91354": p("CA", "Valencia"),
  "91355": p("CA", "Valencia"),
  "91356": p("CA", "Tarzana"),
  "91357": p("CA", "Tarzana"),
  "91364": p("CA", "Woodland Hills"),
  "91365": p("CA", "Woodland Hills"),
  "91367": p("CA", "Woodland Hills"),
  "91371": p("CA", "Woodland Hills"),
  "91372": p("CA", "Calabasas"),
  "91376": p("CA", "Agoura Hills"),
  "91380": p("CA", "Santa Clarita"),
  "91381": p("CA", "Stevenson Ranch"),
  "91382": p("CA", "Santa Clarita"),
  "91383": p("CA", "Santa Clarita"),
  "91384": p("CA", "Castaic"),
  "91385": p("CA", "Valencia"),
  "91386": p("CA", "Canyon Country"),
  "91387": p("CA", "Canyon Country"),
  "91390": p("CA", "Santa Clarita"),
  "91392": p("CA", "Sylmar"),
  "91393": p("CA", "North Hills"),
  "91394": p("CA", "Granada Hills"),
  "91395": p("CA", "Mission Hills"),
  "91396": p("CA", "Winnetka"),
  "91401": p("CA", "Van Nuys"),
  "91402": p("CA", "Panorama City"),
  "91403": p("CA", "Sherman Oaks"),
  "91404": p("CA", "Van Nuys"),
  "91405": p("CA", "Van Nuys"),
  "91406": p("CA", "Van Nuys"),
  "91407": p("CA", "Van Nuys"),
  "91408": p("CA", "Van Nuys"),
  "91409": p("CA", "Van Nuys"),
  "91410": p("CA", "Van Nuys"),
  "91411": p("CA", "Van Nuys"),
  "91412": p("CA", "Panorama City"),
  "91413": p("CA", "Sherman Oaks"),
  "91416": p("CA", "Encino"),
  "91423": p("CA", "Sherman Oaks"),
  "91426": p("CA", "Encino"),
  "91436": p("CA", "Encino"),
  "91470": p("CA", "Van Nuys"),
  "91482": p("CA", "Van Nuys"),
  "91495": p("CA", "Sherman Oaks"),
  "91496": p("CA", "Van Nuys"),
  "91499": p("CA", "Van Nuys"),
  "91501": p("CA", "Burbank"),
  "91502": p("CA", "Burbank"),
  "91503": p("CA", "Burbank"),
  "91504": p("CA", "Burbank"),
  "91505": p("CA", "Burbank"),
  "91506": p("CA", "Burbank"),
  "91507": p("CA", "Burbank"),
  "91508": p("CA", "Burbank"),
  "91510": p("CA", "Burbank"),
  "91521": p("CA", "Burbank"),
  "91522": p("CA", "Burbank"),
  "91523": p("CA", "Burbank"),
  "91526": p("CA", "Burbank"),
  "91601": p("CA", "North Hollywood"),
  "91602": p("CA", "North Hollywood"),
  "91603": p("CA", "North Hollywood"),
  "91604": p("CA", "Studio City"),
  "91605": p("CA", "North Hollywood"),
  "91606": p("CA", "North Hollywood"),
  "91607": p("CA", "Valley Village"),
  "91608": p("CA", "Universal City"),
  "91609": p("CA", "North Hollywood"),
  "91610": p("CA", "Toluca Lake"),
  "91611": p("CA", "North Hollywood"),
  "91612": p("CA", "North Hollywood"),
  "91614": p("CA", "Studio City"),
  "91615": p("CA", "North Hollywood"),
  "91616": p("CA", "North Hollywood"),
  "91617": p("CA", "Valley Village"),
  "91618": p("CA", "North Hollywood"),
  "91702": p("CA", "Azusa"),
  "91706": p("CA", "Baldwin Park"),
  "91711": p("CA", "Claremont"),
  "91714": p("CA", "City Of Industry"),
  "91715": p("CA", "City Of Industry"),
  "91716": p("CA", "City Of Industry"),
  "91722": p("CA", "Covina"),
  "91723": p("CA", "Covina"),
  "91724": p("CA", "Covina"),
  "91731": p("CA", "El Monte"),
  "91732": p("CA", "El Monte"),
  "91733": p("CA", "South El Monte"),
  "91734": p("CA", "El Monte"),
  "91735": p("CA", "El Monte"),
  "91740": p("CA", "Glendora"),
  "91741": p("CA", "Glendora"),
  "91744": p("CA", "La Puente"),
  "91745": p("CA", "Hacienda Heights"),
  "91746": p("CA", "La Puente"),
  "91747": p("CA", "La Puente"),
  "91748": p("CA", "Rowland Heights"),
  "91749": p("CA", "La Puente"),
  "91750": p("CA", "La Verne"),
  "91754": p("CA", "Monterey Park"),
  "91755": p("CA", "Monterey Park"),
  "91756": p("CA", "Monterey Park"),
  "91759": p("CA", "Mount Baldy"),
  "91765": p("CA", "Diamond Bar"),
  "91766": p("CA", "Pomona"),
  "91767": p("CA", "Pomona"),
  "91768": p("CA", "Pomona"),
  "91769": p("CA", "Pomona"),
  "91770": p("CA", "Rosemead"),
  "91771": p("CA", "Rosemead"),
  "91772": p("CA", "Rosemead"),
  "91773": p("CA", "San Dimas"),
  "91775": p("CA", "San Gabriel"),
  "91776": p("CA", "San Gabriel"),
  "91778": p("CA", "San Gabriel"),
  "91780": p("CA", "Temple City"),
  "91788": p("CA", "Walnut"),
  "91789": p("CA", "Walnut"),
  "91790": p("CA", "West Covina"),
  "91791": p("CA", "West Covina"),
  "91792": p("CA", "West Covina"),
  "91793": p("CA", "West Covina"),
  "91801": p("CA", "Alhambra"),
  "91802": p("CA", "Alhambra"),
  "91803": p("CA", "Alhambra"),
  "91804": p("CA", "Alhambra"),
  "91896": p("CA", "Alhambra"),
  "91899": p("CA", "Alhambra"),
  "93510": p("CA", "Acton"),
  "93532": p("CA", "Lake Hughes"),
  "93534": p("CA", "Lancaster"),
  "93535": p("CA", "Lancaster"),
  "93536": p("CA", "Lancaster"),
  "93539": p("CA", "Lancaster"),
  "93543": p("CA", "Littlerock"),
  "93544": p("CA", "Llano"),
  "93550": p("CA", "Palmdale"),
  "93551": p("CA", "Palmdale"),
  "93552": p("CA", "Palmdale"),
  "93553": p("CA", "Pearblossom"),
  "93563": p("CA", "Valyermo"),
  "93584": p("CA", "Lancaster"),
  "93586": p("CA", "Lancaster"),
  "93590": p("CA", "Palmdale"),
  "93591": p("CA", "Palmdale"),
  "93599": p("CA", "Palmdale"),
  "93601": p("CA", "Ahwahnee"),
  "93604": p("CA", "Bass Lake"),
  "93610": p("CA", "Chowchilla"),
  "93614": p("CA", "Coarsegold"),
  "93637": p("CA", "Madera"),
  "93638": p("CA", "Madera"),
  "93639": p("CA", "Madera"),
  "93643": p("CA", "North Fork"),
  "93644": p("CA", "Oakhurst"),
  "93645": p("CA", "O Neals"),
  "93653": p("CA", "Raymond"),
  "93669": p("CA", "Wishon"),
  "94901": p("CA", "San Rafael"),
  "94903": p("CA", "San Rafael"),
  "94904": p("CA", "Greenbrae"),
  "94912": p("CA", "San Rafael"),
  "94913": p("CA", "San Rafael"),
  "94914": p("CA", "Kentfield"),
  "94915": p("CA", "San Rafael"),
  "94920": p("CA", "Belvedere Tiburon"),
  "94924": p("CA", "Bolinas"),
  "94925": p("CA", "Corte Madera"),
  "94929": p("CA", "Dillon Beach"),
  "94930": p("CA", "Fairfax"),
  "94933": p("CA", "Forest Knolls"),
  "94937": p("CA", "Inverness"),
  "94938": p("CA", "Lagunitas"),
  "94939": p("CA", "Larkspur"),
  "94940": p("CA", "Marshall"),
  "94941": p("CA", "Mill Valley"),
  "94942": p("CA", "Mill Valley"),
  "94945": p("CA", "Novato"),
  "94946": p("CA", "Nicasio"),
  "94947": p("CA", "Novato"),
  "94948": p("CA", "Novato"),
  "94949": p("CA", "Novato"),
  "94950": p("CA", "Olema"),
  "94956": p("CA", "Point Reyes Station"),
  "94957": p("CA", "Ross"),
  "94960": p("CA", "San Anselmo"),
  "94963": p("CA", "San Geronimo"),
  "94964": p("CA", "San Quentin"),
  "94965": p("CA", "Sausalito"),
  "94966": p("CA", "Sausalito"),
  "94970": p("CA", "Stinson Beach"),
  "94971": p("CA", "Tomales"),
  "94973": p("CA", "Woodacre"),
  "94974": p("CA", "San Quentin"),
  "94976": p("CA", "Corte Madera"),
  "94977": p("CA", "Larkspur"),
  "94978": p("CA", "Fairfax"),
  "94979": p("CA", "San Anselmo"),
  "94998": p("CA", "Novato"),
  "93623": p("CA", "Fish Camp"),
  "95306": p("CA", "Catheys Valley"),
  "95311": p("CA", "Coulterville"),
  "95318": p("CA", "El Portal"),
  "95325": p("CA", "Hornitos"),
  "95338": p("CA", "Mariposa"),
  "95345": p("CA", "Midpines"),
  "95389": p("CA", "Yosemite National Park"),
  "95410": p("CA", "Albion"),
  "95415": p("CA", "Boonville"),
  "95417": p("CA", "Branscomb"),
  "95418": p("CA", "Calpella"),
  "95420": p("CA", "Caspar"),
  "95427": p("CA", "Comptche"),
  "95428": p("CA", "Covelo"),
  "95429": p("CA", "Dos Rios"),
  "95432": p("CA", "Elk"),
  "95437": p("CA", "Fort Bragg"),
  "95445": p("CA", "Gualala"),
  "95449": p("CA", "Hopland"),
  "95454": p("CA", "Laytonville"),
  "95456": p("CA", "Little River"),
  "95459": p("CA", "Manchester"),
  "95460": p("CA", "Mendocino"),
  "95463": p("CA", "Navarro"),
  "95466": p("CA", "Philo"),
  "95468": p("CA", "Point Arena"),
  "95469": p("CA", "Potter Valley"),
  "95470": p("CA", "Redwood Valley"),
  "95481": p("CA", "Talmage"),
  "95482": p("CA", "Ukiah"),
  "95488": p("CA", "Westport"),
  "95490": p("CA", "Willits"),
  "95494": p("CA", "Yorkville"),
  "95585": p("CA", "Leggett"),
  "95587": p("CA", "Piercy"),
  "93620": p("CA", "Dos Palos"),
  "93635": p("CA", "Los Banos"),
  "93636": p("CA", "Madera"),
  "93661": p("CA", "Santa Rita Park"),
  "93665": p("CA", "South Dos Palos"),
  "95301": p("CA", "Atwater"),
  "95303": p("CA", "Ballico"),
  "95312": p("CA", "Cressey"),
  "95315": p("CA", "Delhi"),
  "95317": p("CA", "El Nido"),
  "95322": p("CA", "Gustine"),
  "95324": p("CA", "Hilmar"),
  "95333": p("CA", "Le Grand"),
  "95334": p("CA", "Livingston"),
  "95340": p("CA", "Merced"),
  "95341": p("CA", "Merced"),
  "95343": p("CA", "Merced"),
  "95344": p("CA", "Merced"),
  "95348": p("CA", "Merced"),
  "95365": p("CA", "Planada"),
  "95369": p("CA", "Snelling"),
  "95374": p("CA", "Stevinson"),
  "95388": p("CA", "Winton"),
  "96006": p("CA", "Adin"),
  "96015": p("CA", "Canby"),
  "96054": p("CA", "Lookout"),
  "96101": p("CA", "Alturas"),
  "96104": p("CA", "Cedarville"),
  "96108": p("CA", "Davis Creek"),
  "96110": p("CA", "Eagleville"),
  "96112": p("CA", "Fort Bidwell"),
  "96115": p("CA", "Lake City"),
  "96116": p("CA", "Likely"),
  "93512": p("CA", "Benton"),
  "93517": p("CA", "Bridgeport"),
  "93529": p("CA", "June Lake"),
  "93541": p("CA", "Lee Vining"),
  "93546": p("CA", "Mammoth Lakes"),
  "96107": p("CA", "Coleville"),
  "96133": p("CA", "Topaz"),
  "93426": p("CA", "Bradley"),
  "93450": p("CA", "San Ardo"),
  "93901": p("CA", "Salinas"),
  "93902": p("CA", "Salinas"),
  "93905": p("CA", "Salinas"),
  "93906": p("CA", "Salinas"),
  "93907": p("CA", "Salinas"),
  "93908": p("CA", "Salinas"),
  "93912": p("CA", "Salinas"),
  "93915": p("CA", "Salinas"),
  "93920": p("CA", "Big Sur"),
  "93921": p("CA", "Carmel By The Sea"),
  "93922": p("CA", "Carmel"),
  "93923": p("CA", "Carmel"),
  "93924": p("CA", "Carmel Valley"),
  "93925": p("CA", "Chualar"),
  "93926": p("CA", "Gonzales"),
  "93927": p("CA", "Greenfield"),
  "93928": p("CA", "Jolon"),
  "93930": p("CA", "King City"),
  "93932": p("CA", "Lockwood"),
  "93933": p("CA", "Marina"),
  "93940": p("CA", "Monterey"),
  "93942": p("CA", "Monterey"),
  "93943": p("CA", "Monterey"),
  "93944": p("CA", "Monterey"),
  "93950": p("CA", "Pacific Grove"),
  "93953": p("CA", "Pebble Beach"),
  "93954": p("CA", "San Lucas"),
  "93955": p("CA", "Seaside"),
  "93960": p("CA", "Soledad"),
  "93962": p("CA", "Spreckels"),
  "95004": p("CA", "Aromas"),
  "95012": p("CA", "Castroville"),
  "95039": p("CA", "Moss Landing"),
  "94503": p("CA", "American Canyon"),
  "94508": p("CA", "Angwin"),
  "94515": p("CA", "Calistoga"),
  "94558": p("CA", "Napa"),
  "94559": p("CA", "Napa"),
  "94562": p("CA", "Oakville"),
  "94567": p("CA", "Pope Valley"),
  "94573": p("CA", "Rutherford"),
  "94574": p("CA", "Saint Helena"),
  "94576": p("CA", "Deer Park"),
  "94581": p("CA", "Napa"),
  "94599": p("CA", "Yountville"),
  "95712": p("CA", "Chicago Park"),
  "95724": p("CA", "Norden"),
  "95728": p("CA", "Soda Springs"),
  "95924": p("CA", "Cedar Ridge"),
  "95945": p("CA", "Grass Valley"),
  "95946": p("CA", "Penn Valley"),
  "95949": p("CA", "Grass Valley"),
  "95959": p("CA", "Nevada City"),
  "95960": p("CA", "North San Juan"),
  "95975": p("CA", "Rough And Ready"),
  "95977": p("CA", "Smartsville"),
  "95986": p("CA", "Washington"),
  "96111": p("CA", "Floriston"),
  "96160": p("CA", "Truckee"),
  "96161": p("CA", "Truckee"),
  "96162": p("CA", "Truckee"),
  "90620": p("CA", "Buena Park"),
  "90621": p("CA", "Buena Park"),
  "90622": p("CA", "Buena Park"),
  "90623": p("CA", "La Palma"),
  "90624": p("CA", "Buena Park"),
  "90630": p("CA", "Cypress"),
  "90631": p("CA", "La Habra"),
  "90632": p("CA", "La Habra"),
  "90633": p("CA", "La Habra"),
  "90680": p("CA", "Stanton"),
  "90720": p("CA", "Los Alamitos"),
  "90721": p("CA", "Los Alamitos"),
  "90740": p("CA", "Seal Beach"),
  "90742": p("CA", "Sunset Beach"),
  "90743": p("CA", "Surfside"),
  "92602": p("CA", "Irvine"),
  "92603": p("CA", "Irvine"),
  "92604": p("CA", "Irvine"),
  "92605": p("CA", "Huntington Beach"),
  "92606": p("CA", "Irvine"),
  "92607": p("CA", "Laguna Niguel"),
  "92609": p("CA", "El Toro"),
  "92610": p("CA", "Foothill Ranch"),
  "92612": p("CA", "Irvine"),
  "92614": p("CA", "Irvine"),
  "92615": p("CA", "Huntington Beach"),
  "92616": p("CA", "Irvine"),
  "92617": p("CA", "Irvine"),
  "92618": p("CA", "Irvine"),
  "92619": p("CA", "Irvine"),
  "92620": p("CA", "Irvine"),
  "92623": p("CA", "Irvine"),
  "92624": p("CA", "Capistrano Beach"),
  "92625": p("CA", "Corona Del Mar"),
  "92626": p("CA", "Costa Mesa"),
  "92627": p("CA", "Costa Mesa"),
  "92628": p("CA", "Costa Mesa"),
  "92629": p("CA", "Dana Point"),
  "92630": p("CA", "Lake Forest"),
  "92637": p("CA", "Laguna Woods"),
  "92646": p("CA", "Huntington Beach"),
  "92647": p("CA", "Huntington Beach"),
  "92648": p("CA", "Huntington Beach"),
  "92649": p("CA", "Huntington Beach"),
  "92650": p("CA", "East Irvine"),
  "92651": p("CA", "Laguna Beach"),
  "92652": p("CA", "Laguna Beach"),
  "92653": p("CA", "Laguna Hills"),
  "92654": p("CA", "Laguna Hills"),
  "92655": p("CA", "Midway City"),
  "92656": p("CA", "Aliso Viejo"),
  "92657": p("CA", "Newport Coast"),
  "92658": p("CA", "Newport Beach"),
  "92659": p("CA", "Newport Beach"),
  "92660": p("CA", "Newport Beach"),
  "92661": p("CA", "Newport Beach"),
  "92662": p("CA", "Newport Beach"),
  "92663": p("CA", "Newport Beach"),
  "92672": p("CA", "San Clemente"),
  "92673": p("CA", "San Clemente"),
  "92674": p("CA", "San Clemente"),
  "92675": p("CA", "San Juan Capistrano"),
  "92676": p("CA", "Silverado"),
  "92677": p("CA", "Laguna Niguel"),
  "92678": p("CA", "Trabuco Canyon"),
  "92679": p("CA", "Trabuco Canyon"),
  "92683": p("CA", "Westminster"),
  "92684": p("CA", "Westminster"),
  "92685": p("CA", "Westminster"),
  "92688": p("CA", "Rancho Santa Margarita"),
  "92690": p("CA", "Mission Viejo"),
  "92691": p("CA", "Mission Viejo"),
  "92692": p("CA", "Mission Viejo"),
  "92693": p("CA", "San Juan Capistrano"),
  "92694": p("CA", "Ladera Ranch"),
  "92697": p("CA", "Irvine"),
  "92698": p("CA", "Aliso Viejo"),
  "92701": p("CA", "Santa Ana"),
  "92702": p("CA", "Santa Ana"),
  "92703": p("CA", "Santa Ana"),
  "92704": p("CA", "Santa Ana"),
  "92705": p("CA", "Santa Ana"),
  "92706": p("CA", "Santa Ana"),
  "92707": p("CA", "Santa Ana"),
  "92708": p("CA", "Fountain Valley"),
  "92711": p("CA", "Santa Ana"),
  "92712": p("CA", "Santa Ana"),
  "92728": p("CA", "Fountain Valley"),
  "92735": p("CA", "Santa Ana"),
  "92780": p("CA", "Tustin"),
  "92781": p("CA", "Tustin"),
  "92782": p("CA", "Tustin"),
  "92799": p("CA", "Santa Ana"),
  "92801": p("CA", "Anaheim"),
  "92802": p("CA", "Anaheim"),
  "92803": p("CA", "Anaheim"),
  "92804": p("CA", "Anaheim"),
  "92805": p("CA", "Anaheim"),
  "92806": p("CA", "Anaheim"),
  "92807": p("CA", "Anaheim"),
  "92808": p("CA", "Anaheim"),
  "92809": p("CA", "Anaheim"),
  "92811": p("CA", "Atwood"),
  "92812": p("CA", "Anaheim"),
  "92814": p("CA", "Anaheim"),
  "92815": p("CA", "Anaheim"),
  "92816": p("CA", "Anaheim"),
  "92817": p("CA", "Anaheim"),
  "92821": p("CA", "Brea"),
  "92822": p("CA", "Brea"),
  "92823": p("CA", "Brea"),
  "92825": p("CA", "Anaheim"),
  "92831": p("CA", "Fullerton"),
  "92832": p("CA", "Fullerton"),
  "92833": p("CA", "Fullerton"),
  "92834": p("CA", "Fullerton"),
  "92835": p("CA", "Fullerton"),
  "92836": p("CA", "Fullerton"),
  "92837": p("CA", "Fullerton"),
  "92838": p("CA", "Fullerton"),
  "92840": p("CA", "Garden Grove"),
  "92841": p("CA", "Garden Grove"),
  "92842": p("CA", "Garden Grove"),
  "92843": p("CA", "Garden Grove"),
  "92844": p("CA", "Garden Grove"),
  "92845": p("CA", "Garden Grove"),
  "92846": p("CA", "Garden Grove"),
  "92850": p("CA", "Anaheim"),
  "92856": p("CA", "Orange"),
  "92857": p("CA", "Orange"),
  "92859": p("CA", "Orange"),
  "92861": p("CA", "Villa Park"),
  "92862": p("CA", "Orange"),
  "92863": p("CA", "Orange"),
  "92864": p("CA", "Orange"),
  "92865": p("CA", "Orange"),
  "92866": p("CA", "Orange"),
  "92867": p("CA", "Orange"),
  "92868": p("CA", "Orange"),
  "92869": p("CA", "Orange"),
  "92870": p("CA", "Placentia"),
  "92871": p("CA", "Placentia"),
  "92885": p("CA", "Yorba Linda"),
  "92886": p("CA", "Yorba Linda"),
  "92887": p("CA", "Yorba Linda"),
  "92899": p("CA", "Anaheim"),
  "95602": p("CA", "Auburn"),
  "95603": p("CA", "Auburn"),
  "95604": p("CA", "Auburn"),
  "95631": p("CA", "Foresthill"),
  "95648": p("CA", "Lincoln"),
  "95650": p("CA", "Loomis"),
  "95658": p("CA", "Newcastle"),
  "95661": p("CA", "Roseville"),
  "95663": p("CA", "Penryn"),
  "95677": p("CA", "Rocklin"),
  "95678": p("CA", "Roseville"),
  "95681": p("CA", "Sheridan"),
  "95701": p("CA", "Alta"),
  "95703": p("CA", "Applegate"),
  "95713": p("CA", "Colfax"),
  "95714": p("CA", "Dutch Flat"),
  "95715": p("CA", "Emigrant Gap"),
  "95717": p("CA", "Gold Run"),
  "95722": p("CA", "Meadow Vista"),
  "95736": p("CA", "Weimar"),
  "95746": p("CA", "Granite Bay"),
  "95747": p("CA", "Roseville"),
  "95765": p("CA", "Rocklin"),
  "96140": p("CA", "Carnelian Bay"),
  "96141": p("CA", "Homewood"),
  "96143": p("CA", "Kings Beach"),
  "96145": p("CA", "Tahoe City"),
  "96146": p("CA", "Olympic Valley"),
  "96148": p("CA", "Tahoe Vista"),
  "95915": p("CA", "Belden"),
  "95923": p("CA", "Canyon Dam"),
  "95934": p("CA", "Crescent Mills"),
  "95947": p("CA", "Greenville"),
  "95956": p("CA", "Meadow Valley"),
  "95971": p("CA", "Quincy"),
  "95980": p("CA", "Storrie"),
  "95983": p("CA", "Taylorsville"),
  "95984": p("CA", "Twain"),
  "96020": p("CA", "Chester"),
  "96103": p("CA", "Blairsden Graeagle"),
  "96105": p("CA", "Chilcoot"),
  "96106": p("CA", "Clio"),
  "96122": p("CA", "Portola"),
  "96129": p("CA", "Beckwourth"),
  "96135": p("CA", "Vinton"),
  "91752": p("CA", "Mira Loma"),
  "92201": p("CA", "Indio"),
  "92202": p("CA", "Indio"),
  "92203": p("CA", "Indio"),
  "92210": p("CA", "Indian Wells"),
  "92211": p("CA", "Palm Desert"),
  "92220": p("CA", "Banning"),
  "92223": p("CA", "Beaumont"),
  "92225": p("CA", "Blythe"),
  "92226": p("CA", "Blythe"),
  "92230": p("CA", "Cabazon"),
  "92234": p("CA", "Cathedral City"),
  "92235": p("CA", "Cathedral City"),
  "92236": p("CA", "Coachella"),
  "92239": p("CA", "Desert Center"),
  "92240": p("CA", "Desert Hot Springs"),
  "92241": p("CA", "Desert Hot Springs"),
  "92247": p("CA", "La Quinta"),
  "92253": p("CA", "La Quinta"),
  "92254": p("CA", "Mecca"),
  "92255": p("CA", "Palm Desert"),
  "92258": p("CA", "North Palm Springs"),
  "92260": p("CA", "Palm Desert"),
  "92261": p("CA", "Palm Desert"),
  "92262": p("CA", "Palm Springs"),
  "92263": p("CA", "Palm Springs"),
  "92264": p("CA", "Palm Springs"),
  "92270": p("CA", "Rancho Mirage"),
  "92274": p("CA", "Thermal"),
  "92276": p("CA", "Thousand Palms"),
  "92282": p("CA", "Whitewater"),
  "92320": p("CA", "Calimesa"),
  "92501": p("CA", "Riverside"),
  "92502": p("CA", "Riverside"),
  "92503": p("CA", "Riverside"),
  "92504": p("CA", "Riverside"),
  "92505": p("CA", "Riverside"),
  "92506": p("CA", "Riverside"),
  "92507": p("CA", "Riverside"),
  "92508": p("CA", "Riverside"),
  "92509": p("CA", "Riverside"),
  "92513": p("CA", "Riverside"),
  "92514": p("CA", "Riverside"),
  "92515": p("CA", "Riverside"),
  "92516": p("CA", "Riverside"),
  "92517": p("CA", "Riverside"),
  "92518": p("CA", "March Air Reserve Base"),
  "92519": p("CA", "Riverside"),
  "92521": p("CA", "Riverside"),
  "92522": p("CA", "Riverside"),
  "92530": p("CA", "Lake Elsinore"),
  "92531": p("CA", "Lake Elsinore"),
  "92532": p("CA", "Lake Elsinore"),
  "92536": p("CA", "Aguanga"),
  "92539": p("CA", "Anza"),
  "92543": p("CA", "Hemet"),
  "92544": p("CA", "Hemet"),
  "92545": p("CA", "Hemet"),
  "92546": p("CA", "Hemet"),
  "92548": p("CA", "Homeland"),
  "92549": p("CA", "Idyllwild"),
  "92551": p("CA", "Moreno Valley"),
  "92552": p("CA", "Moreno Valley"),
  "92553": p("CA", "Moreno Valley"),
  "92554": p("CA", "Moreno Valley"),
  "92555": p("CA", "Moreno Valley"),
  "92556": p("CA", "Moreno Valley"),
  "92557": p("CA", "Moreno Valley"),
  "92561": p("CA", "Mountain Center"),
  "92562": p("CA", "Murrieta"),
  "92563": p("CA", "Murrieta"),
  "92564": p("CA", "Murrieta"),
  "92567": p("CA", "Nuevo"),
  "92570": p("CA", "Perris"),
  "92571": p("CA", "Perris"),
  "92572": p("CA", "Perris"),
  "92581": p("CA", "San Jacinto"),
  "92582": p("CA", "San Jacinto"),
  "92583": p("CA", "San Jacinto"),
  "92584": p("CA", "Menifee"),
  "92585": p("CA", "Sun City"),
  "92586": p("CA", "Sun City"),
  "92587": p("CA", "Quail Valley"),
  "92589": p("CA", "Temecula"),
  "92590": p("CA", "Temecula"),
  "92591": p("CA", "Temecula"),
  "92592": p("CA", "Temecula"),
  "92593": p("CA", "Temecula"),
  "92595": p("CA", "Wildomar"),
  "92596": p("CA", "Winchester"),
  "92599": p("CA", "Perris"),
  "92860": p("CA", "Norco"),
  "92877": p("CA", "Corona"),
  "92878": p("CA", "Corona"),
  "92879": p("CA", "Corona"),
  "92880": p("CA", "Corona"),
  "92881": p("CA", "Corona"),
  "92882": p("CA", "Corona"),
  "92883": p("CA", "Corona"),
  "94203": p("CA", "Sacramento"),
  "94204": p("CA", "Sacramento"),
  "94205": p("CA", "Sacramento"),
  "94206": p("CA", "Sacramento"),
  "94207": p("CA", "Sacramento"),
  "94208": p("CA", "Sacramento"),
  "94209": p("CA", "Sacramento"),
  "94211": p("CA", "Sacramento"),
  "94229": p("CA", "Sacramento"),
  "94230": p("CA", "Sacramento"),
  "94232": p("CA", "Sacramento"),
  "94234": p("CA", "Sacramento"),
  "94235": p("CA", "Sacramento"),
  "94236": p("CA", "Sacramento"),
  "94237": p("CA", "Sacramento"),
  "94239": p("CA", "Sacramento"),
  "94240": p("CA", "Sacramento"),
  "94244": p("CA", "Sacramento"),
  "94245": p("CA", "Sacramento"),
  "94247": p("CA", "Sacramento"),
  "94248": p("CA", "Sacramento"),
  "94249": p("CA", "Sacramento"),
  "94250": p("CA", "Sacramento"),
  "94252": p("CA", "Sacramento"),
  "94254": p("CA", "Sacramento"),
  "94256": p("CA", "Sacramento"),
  "94257": p("CA", "Sacramento"),
  "94258": p("CA", "Sacramento"),
  "94259": p("CA", "Sacramento"),
  "94261": p("CA", "Sacramento"),
  "94262": p("CA", "Sacramento"),
  "94263": p("CA", "Sacramento"),
  "94267": p("CA", "Sacramento"),
  "94268": p("CA", "Sacramento"),
  "94269": p("CA", "Sacramento"),
  "94271": p("CA", "Sacramento"),
  "94273": p("CA", "Sacramento"),
  "94274": p("CA", "Sacramento"),
  "94277": p("CA", "Sacramento"),
  "94278": p("CA", "Sacramento"),
  "94279": p("CA", "Sacramento"),
  "94280": p("CA", "Sacramento"),
  "94282": p("CA", "Sacramento"),
  "94283": p("CA", "Sacramento"),
  "94284": p("CA", "Sacramento"),
  "94285": p("CA", "Sacramento"),
  "94286": p("CA", "Sacramento"),
  "94287": p("CA", "Sacramento"),
  "94288": p("CA", "Sacramento"),
  "94289": p("CA", "Sacramento"),
  "94290": p("CA", "Sacramento"),
  "94291": p("CA", "Sacramento"),
  "94293": p("CA", "Sacramento"),
  "94294": p("CA", "Sacramento"),
  "94295": p("CA", "Sacramento"),
  "94296": p("CA", "Sacramento"),
  "94297": p("CA", "Sacramento"),
  "94298": p("CA", "Sacramento"),
  "94299": p("CA", "Sacramento"),
  "95608": p("CA", "Carmichael"),
  "95609": p("CA", "Carmichael"),
  "95610": p("CA", "Citrus Heights"),
  "95611": p("CA", "Citrus Heights"),
  "95615": p("CA", "Courtland"),
  "95621": p("CA", "Citrus Heights"),
  "95624": p("CA", "Elk Grove"),
  "95626": p("CA", "Elverta"),
  "95628": p("CA", "Fair Oaks"),
  "95630": p("CA", "Folsom"),
  "95632": p("CA", "Galt"),
  "95638": p("CA", "Herald"),
  "95639": p("CA", "Hood"),
  "95641": p("CA", "Isleton"),
  "95652": p("CA", "Mcclellan"),
  "95655": p("CA", "Mather"),
  "95660": p("CA", "North Highlands"),
  "95662": p("CA", "Orangevale"),
  "95670": p("CA", "Rancho Cordova"),
  "95671": p("CA", "Represa"),
  "95673": p("CA", "Rio Linda"),
  "95680": p("CA", "Ryde"),
  "95683": p("CA", "Sloughhouse"),
  "95690": p("CA", "Walnut Grove"),
  "95693": p("CA", "Wilton"),
  "95741": p("CA", "Rancho Cordova"),
  "95742": p("CA", "Rancho Cordova"),
  "95757": p("CA", "Elk Grove"),
  "95758": p("CA", "Elk Grove"),
  "95759": p("CA", "Elk Grove"),
  "95763": p("CA", "Folsom"),
  "95811": p("CA", "Sacramento"),
  "95812": p("CA", "Sacramento"),
  "95813": p("CA", "Sacramento"),
  "95814": p("CA", "Sacramento"),
  "95815": p("CA", "Sacramento"),
  "95816": p("CA", "Sacramento"),
  "95817": p("CA", "Sacramento"),
  "95818": p("CA", "Sacramento"),
  "95819": p("CA", "Sacramento"),
  "95820": p("CA", "Sacramento"),
  "95821": p("CA", "Sacramento"),
  "95822": p("CA", "Sacramento"),
  "95823": p("CA", "Sacramento"),
  "95824": p("CA", "Sacramento"),
  "95825": p("CA", "Sacramento"),
  "95826": p("CA", "Sacramento"),
  "95827": p("CA", "Sacramento"),
  "95828": p("CA", "Sacramento"),
  "95829": p("CA", "Sacramento"),
  "95830": p("CA", "Sacramento"),
  "95831": p("CA", "Sacramento"),
  "95832": p("CA", "Sacramento"),
  "95833": p("CA", "Sacramento"),
  "95834": p("CA", "Sacramento"),
  "95835": p("CA", "Sacramento"),
  "95836": p("CA", "Sacramento"),
  "95837": p("CA", "Sacramento"),
  "95838": p("CA", "Sacramento"),
  "95840": p("CA", "Sacramento"),
  "95841": p("CA", "Sacramento"),
  "95842": p("CA", "Sacramento"),
  "95843": p("CA", "Antelope"),
  "95851": p("CA", "Sacramento"),
  "95852": p("CA", "Sacramento"),
  "95853": p("CA", "Sacramento"),
  "95860": p("CA", "Sacramento"),
  "95864": p("CA", "Sacramento"),
  "95865": p("CA", "Sacramento"),
  "95866": p("CA", "Sacramento"),
  "95867": p("CA", "Sacramento"),
  "95894": p("CA", "Sacramento"),
  "95899": p("CA", "Sacramento"),
  "95023": p("CA", "Hollister"),
  "95024": p("CA", "Hollister"),
  "95043": p("CA", "Paicines"),
  "95045": p("CA", "San Juan Bautista"),
  "95075": p("CA", "Tres Pinos"),
  "91701": p("CA", "Rancho Cucamonga"),
  "91708": p("CA", "Chino"),
  "91709": p("CA", "Chino Hills"),
  "91710": p("CA", "Chino"),
  "91729": p("CA", "Rancho Cucamonga"),
  "91730": p("CA", "Rancho Cucamonga"),
  "91737": p("CA", "Rancho Cucamonga"),
  "91739": p("CA", "Rancho Cucamonga"),
  "91743": p("CA", "Guasti"),
  "91758": p("CA", "Ontario"),
  "91761": p("CA", "Ontario"),
  "91762": p("CA", "Ontario"),
  "91763": p("CA", "Montclair"),
  "91764": p("CA", "Ontario"),
  "91784": p("CA", "Upland"),
  "91785": p("CA", "Upland"),
  "91786": p("CA", "Upland"),
  "92242": p("CA", "Earp"),
  "92248": p("CA", "La Quinta"),
  "92252": p("CA", "Joshua Tree"),
  "92256": p("CA", "Morongo Valley"),
  "92267": p("CA", "Parker Dam"),
  "92268": p("CA", "Pioneertown"),
  "92277": p("CA", "Twentynine Palms"),
  "92278": p("CA", "Twentynine Palms"),
  "92280": p("CA", "Vidal"),
  "92284": p("CA", "Yucca Valley"),
  "92285": p("CA", "Landers"),
  "92286": p("CA", "Yucca Valley"),
  "92301": p("CA", "Adelanto"),
  "92304": p("CA", "Amboy"),
  "92305": p("CA", "Angelus Oaks"),
  "92307": p("CA", "Apple Valley"),
  "92308": p("CA", "Apple Valley"),
  "92309": p("CA", "Baker"),
  "92310": p("CA", "Fort Irwin"),
  "92311": p("CA", "Barstow"),
  "92312": p("CA", "Barstow"),
  "92313": p("CA", "Grand Terrace"),
  "92314": p("CA", "Big Bear City"),
  "92315": p("CA", "Big Bear Lake"),
  "92316": p("CA", "Bloomington"),
  "92317": p("CA", "Blue Jay"),
  "92318": p("CA", "Bryn Mawr"),
  "92321": p("CA", "Cedar Glen"),
  "92322": p("CA", "Cedarpines Park"),
  "92323": p("CA", "Cima"),
  "92324": p("CA", "Colton"),
  "92325": p("CA", "Crestline"),
  "92327": p("CA", "Daggett"),
  "92329": p("CA", "Phelan"),
  "92332": p("CA", "Essex"),
  "92333": p("CA", "Fawnskin"),
  "92334": p("CA", "Fontana"),
  "92335": p("CA", "Fontana"),
  "92336": p("CA", "Fontana"),
  "92337": p("CA", "Fontana"),
  "92338": p("CA", "Ludlow"),
  "92339": p("CA", "Forest Falls"),
  "92340": p("CA", "Hesperia"),
  "92341": p("CA", "Green Valley Lake"),
  "92342": p("CA", "Helendale"),
  "92344": p("CA", "Hesperia"),
  "92345": p("CA", "Hesperia"),
  "92346": p("CA", "Highland"),
  "92347": p("CA", "Hinkley"),
  "92350": p("CA", "Loma Linda"),
  "92352": p("CA", "Lake Arrowhead"),
  "92354": p("CA", "Loma Linda"),
  "92356": p("CA", "Lucerne Valley"),
  "92357": p("CA", "Loma Linda"),
  "92358": p("CA", "Lytle Creek"),
  "92359": p("CA", "Mentone"),
  "92363": p("CA", "Needles"),
  "92364": p("CA", "Nipton"),
  "92365": p("CA", "Newberry Springs"),
  "92366": p("CA", "Mountain Pass"),
  "92368": p("CA", "Oro Grande"),
  "92369": p("CA", "Patton"),
  "92371": p("CA", "Phelan"),
  "92372": p("CA", "Pinon Hills"),
  "92373": p("CA", "Redlands"),
  "92374": p("CA", "Redlands"),
  "92375": p("CA", "Redlands"),
  "92376": p("CA", "Rialto"),
  "92377": p("CA", "Rialto"),
  "92378": p("CA", "Rimforest"),
  "92382": p("CA", "Running Springs"),
  "92385": p("CA", "Skyforest"),
  "92386": p("CA", "Sugarloaf"),
  "92391": p("CA", "Twin Peaks"),
  "92392": p("CA", "Victorville"),
  "92393": p("CA", "Victorville"),
  "92394": p("CA", "Victorville"),
  "92395": p("CA", "Victorville"),
  "92397": p("CA", "Wrightwood"),
  "92398": p("CA", "Yermo"),
  "92399": p("CA", "Yucaipa"),
  "92401": p("CA", "San Bernardino"),
  "92402": p("CA", "San Bernardino"),
  "92403": p("CA", "San Bernardino"),
  "92404": p("CA", "San Bernardino"),
  "92405": p("CA", "San Bernardino"),
  "92406": p("CA", "San Bernardino"),
  "92407": p("CA", "San Bernardino"),
  "92408": p("CA", "San Bernardino"),
  "92410": p("CA", "San Bernardino"),
  "92411": p("CA", "San Bernardino"),
  "92413": p("CA", "San Bernardino"),
  "92415": p("CA", "San Bernardino"),
  "92418": p("CA", "San Bernardino"),
  "92423": p("CA", "San Bernardino"),
  "92427": p("CA", "San Bernardino"),
  "93558": p("CA", "Red Mountain"),
  "93562": p("CA", "Trona"),
  "93592": p("CA", "Trona"),
  "91901": p("CA", "Alpine"),
  "91902": p("CA", "Bonita"),
  "91903": p("CA", "Alpine"),
  "91905": p("CA", "Boulevard"),
  "91906": p("CA", "Campo"),
  "91908": p("CA", "Bonita"),
  "91909": p("CA", "Chula Vista"),
  "91910": p("CA", "Chula Vista"),
  "91911": p("CA", "Chula Vista"),
  "91912": p("CA", "Chula Vista"),
  "91913": p("CA", "Chula Vista"),
  "91914": p("CA", "Chula Vista"),
  "91915": p("CA", "Chula Vista"),
  "91916": p("CA", "Descanso"),
  "91917": p("CA", "Dulzura"),
  "91921": p("CA", "Chula Vista"),
  "91931": p("CA", "Guatay"),
  "91932": p("CA", "Imperial Beach"),
  "91933": p("CA", "Imperial Beach"),
  "91934": p("CA", "Jacumba"),
  "91935": p("CA", "Jamul"),
  "91941": p("CA", "La Mesa"),
  "91942": p("CA", "La Mesa"),
  "91943": p("CA", "La Mesa"),
  "91944": p("CA", "La Mesa"),
  "91945": p("CA", "Lemon Grove"),
  "91946": p("CA", "Lemon Grove"),
  "91948": p("CA", "Mount Laguna"),
  "91950": p("CA", "National City"),
  "91951": p("CA", "National City"),
  "91962": p("CA", "Pine Valley"),
  "91963": p("CA", "Potrero"),
  "91976": p("CA", "Spring Valley"),
  "91977": p("CA", "Spring Valley"),
  "91978": p("CA", "Spring Valley"),
  "91979": p("CA", "Spring Valley"),
  "91980": p("CA", "Tecate"),
  "91987": p("CA", "Tecate"),
  "92003": p("CA", "Bonsall"),
  "92004": p("CA", "Borrego Springs"),
  "92007": p("CA", "Cardiff By The Sea"),
  "92008": p("CA", "Carlsbad"),
  "92009": p("CA", "Carlsbad"),
  "92010": p("CA", "Carlsbad"),
  "92011": p("CA", "Carlsbad"),
  "92013": p("CA", "Carlsbad"),
  "92014": p("CA", "Del Mar"),
  "92018": p("CA", "Carlsbad"),
  "92019": p("CA", "El Cajon"),
  "92020": p("CA", "El Cajon"),
  "92021": p("CA", "El Cajon"),
  "92022": p("CA", "El Cajon"),
  "92023": p("CA", "Encinitas"),
  "92024": p("CA", "Encinitas"),
  "92025": p("CA", "Escondido"),
  "92026": p("CA", "Escondido"),
  "92027": p("CA", "Escondido"),
  "92028": p("CA", "Fallbrook"),
  "92029": p("CA", "Escondido"),
  "92030": p("CA", "Escondido"),
  "92033": p("CA", "Escondido"),
  "92036": p("CA", "Julian"),
  "92037": p("CA", "La Jolla"),
  "92038": p("CA", "La Jolla"),
  "92039": p("CA", "La Jolla"),
  "92040": p("CA", "Lakeside"),
  "92046": p("CA", "Escondido"),
  "92049": p("CA", "Oceanside"),
  "92051": p("CA", "Oceanside"),
  "92052": p("CA", "Oceanside"),
  "92054": p("CA", "Oceanside"),
  "92055": p("CA", "Camp Pendleton"),
  "92056": p("CA", "Oceanside"),
  "92057": p("CA", "Oceanside"),
  "92058": p("CA", "Oceanside"),
  "92059": p("CA", "Pala"),
  "92060": p("CA", "Palomar Mountain"),
  "92061": p("CA", "Pauma Valley"),
  "92064": p("CA", "Poway"),
  "92065": p("CA", "Ramona"),
  "92066": p("CA", "Ranchita"),
  "92067": p("CA", "Rancho Santa Fe"),
  "92068": p("CA", "San Luis Rey"),
  "92069": p("CA", "San Marcos"),
  "92070": p("CA", "Santa Ysabel"),
  "92071": p("CA", "Santee"),
  "92072": p("CA", "Santee"),
  "92074": p("CA", "Poway"),
  "92075": p("CA", "Solana Beach"),
  "92078": p("CA", "San Marcos"),
  "92079": p("CA", "San Marcos"),
  "92081": p("CA", "Vista"),
  "92082": p("CA", "Valley Center"),
  "92083": p("CA", "Vista"),
  "92084": p("CA", "Vista"),
  "92085": p("CA", "Vista"),
  "92086": p("CA", "Warner Springs"),
  "92088": p("CA", "Fallbrook"),
  "92091": p("CA", "Rancho Santa Fe"),
  "92092": p("CA", "La Jolla"),
  "92093": p("CA", "La Jolla"),
  "92096": p("CA", "San Marcos"),
  "92101": p("CA", "San Diego"),
  "92102": p("CA", "San Diego"),
  "92103": p("CA", "San Diego"),
  "92104": p("CA", "San Diego"),
  "92105": p("CA", "San Diego"),
  "92106": p("CA", "San Diego"),
  "92107": p("CA", "San Diego"),
  "92108": p("CA", "San Diego"),
  "92109": p("CA", "San Diego"),
  "92110": p("CA", "San Diego"),
  "92111": p("CA", "San Diego"),
  "92112": p("CA", "San Diego"),
  "92113": p("CA", "San Diego"),
  "92114": p("CA", "San Diego"),
  "92115": p("CA", "San Diego"),
  "92116": p("CA", "San Diego"),
  "92117": p("CA", "San Diego"),
  "92118": p("CA", "Coronado"),
  "92119": p("CA", "San Diego"),
  "92120": p("CA", "San Diego"),
  "92121": p("CA", "San Diego"),
  "92122": p("CA", "San Diego"),
  "92123": p("CA", "San Diego"),
  "92124": p("CA", "San Diego"),
  "92126": p("CA", "San Diego"),
  "92127": p("CA", "San Diego"),
  "92128": p("CA", "San Diego"),
  "92129": p("CA", "San Diego"),
  "92130": p("CA", "San Diego"),
  "92131": p("CA", "San Diego"),
  "92132": p("CA", "San Diego"),
  "92134": p("CA", "San Diego"),
  "92135": p("CA", "San Diego"),
  "92136": p("CA", "San Diego"),
  "92137": p("CA", "San Diego"),
  "92138": p("CA", "San Diego"),
  "92139": p("CA", "San Diego"),
  "92140": p("CA", "San Diego"),
  "92142": p("CA", "San Diego"),
  "92143": p("CA", "San Ysidro"),
  "92145": p("CA", "San Diego"),
  "92147": p("CA", "San Diego"),
  "92149": p("CA", "San Diego"),
  "92150": p("CA", "San Diego"),
  "92152": p("CA", "San Diego"),
  "92153": p("CA", "San Diego"),
  "92154": p("CA", "San Diego"),
  "92155": p("CA", "San Diego"),
  "92158": p("CA", "San Diego"),
  "92159": p("CA", "San Diego"),
  "92160": p("CA", "San Diego"),
  "92161": p("CA", "San Diego"),
  "92163": p("CA", "San Diego"),
  "92165": p("CA", "San Diego"),
  "92166": p("CA", "San Diego"),
  "92167": p("CA", "San Diego"),
  "92168": p("CA", "San Diego"),
  "92169": p("CA", "San Diego"),
  "92170": p("CA", "San Diego"),
  "92171": p("CA", "San Diego"),
  "92172": p("CA", "San Diego"),
  "92173": p("CA", "San Ysidro"),
  "92174": p("CA", "San Diego"),
  "92175": p("CA", "San Diego"),
  "92176": p("CA", "San Diego"),
  "92177": p("CA", "San Diego"),
  "92178": p("CA", "Coronado"),
  "92179": p("CA", "San Diego"),
  "92182": p("CA", "San Diego"),
  "92186": p("CA", "San Diego"),
  "92187": p("CA", "San Diego"),
  "92190": p("CA", "San Diego"),
  "92191": p("CA", "San Diego"),
  "92192": p("CA", "San Diego"),
  "92193": p("CA", "San Diego"),
  "92195": p("CA", "San Diego"),
  "92196": p("CA", "San Diego"),
  "92197": p("CA", "San Diego"),
  "92198": p("CA", "San Diego"),
  "92199": p("CA", "San Diego"),
  "94102": p("CA", "San Francisco"),
  "94103": p("CA", "San Francisco"),
  "94104": p("CA", "San Francisco"),
  "94105": p("CA", "San Francisco"),
  "94107": p("CA", "San Francisco"),
  "94108": p("CA", "San Francisco"),
  "94109": p("CA", "San Francisco"),
  "94110": p("CA", "San Francisco"),
  "94111": p("CA", "San Francisco"),
  "94112": p("CA", "San Francisco"),
  "94114": p("CA", "San Francisco"),
  "94115": p("CA", "San Francisco"),
  "94116": p("CA", "San Francisco"),
  "94117": p("CA", "San Francisco"),
  "94118": p("CA", "San Francisco"),
  "94119": p("CA", "San Francisco"),
  "94120": p("CA", "San Francisco"),
  "94121": p("CA", "San Francisco"),
  "94122": p("CA", "San Francisco"),
  "94123": p("CA", "San Francisco"),
  "94124": p("CA", "San Francisco"),
  "94125": p("CA", "San Francisco"),
  "94126": p("CA", "San Francisco"),
  "94127": p("CA", "San Francisco"),
  "94129": p("CA", "San Francisco"),
  "94130": p("CA", "San Francisco"),
  "94131": p("CA", "San Francisco"),
  "94132": p("CA", "San Francisco"),
  "94133": p("CA", "San Francisco"),
  "94134": p("CA", "San Francisco"),
  "94137": p("CA", "San Francisco"),
  "94139": p("CA", "San Francisco"),
  "94140": p("CA", "San Francisco"),
  "94141": p("CA", "San Francisco"),
  "94142": p("CA", "San Francisco"),
  "94143": p("CA", "San Francisco"),
  "94144": p("CA", "San Francisco"),
  "94145": p("CA", "San Francisco"),
  "94146": p("CA", "San Francisco"),
  "94147": p("CA", "San Francisco"),
  "94151": p("CA", "San Francisco"),
  "94158": p("CA", "San Francisco"),
  "94159": p("CA", "San Francisco"),
  "94160": p("CA", "San Francisco"),
  "94161": p("CA", "San Francisco"),
  "94163": p("CA", "San Francisco"),
  "94164": p("CA", "San Francisco"),
  "94172": p("CA", "San Francisco"),
  "94177": p("CA", "San Francisco"),
  "94188": p("CA", "San Francisco"),
  "95201": p("CA", "Stockton"),
  "95202": p("CA", "Stockton"),
  "95203": p("CA", "Stockton"),
  "95204": p("CA", "Stockton"),
  "95205": p("CA", "Stockton"),
  "95206": p("CA", "Stockton"),
  "95207": p("CA", "Stockton"),
  "95208": p("CA", "Stockton"),
  "95209": p("CA", "Stockton"),
  "95210": p("CA", "Stockton"),
  "95211": p("CA", "Stockton"),
  "95212": p("CA", "Stockton"),
  "95213": p("CA", "Stockton"),
  "95214": p("CA", "Stockton"),
  "95215": p("CA", "Stockton"),
  "95219": p("CA", "Stockton"),
  "95220": p("CA", "Acampo"),
  "95227": p("CA", "Clements"),
  "95230": p("CA", "Farmington"),
  "95231": p("CA", "French Camp"),
  "95234": p("CA", "Holt"),
  "95236": p("CA", "Linden"),
  "95237": p("CA", "Lockeford"),
  "95240": p("CA", "Lodi"),
  "95241": p("CA", "Lodi"),
  "95242": p("CA", "Lodi"),
  "95253": p("CA", "Victor"),
  "95258": p("CA", "Woodbridge"),
  "95267": p("CA", "Stockton"),
  "95269": p("CA", "Stockton"),
  "95296": p("CA", "Stockton"),
  "95297": p("CA", "Stockton"),
  "95304": p("CA", "Tracy"),
  "95320": p("CA", "Escalon"),
  "95330": p("CA", "Lathrop"),
  "95336": p("CA", "Manteca"),
  "95337": p("CA", "Manteca"),
  "95366": p("CA", "Ripon"),
  "95376": p("CA", "Tracy"),
  "95377": p("CA", "Tracy"),
  "95378": p("CA", "Tracy"),
  "95385": p("CA", "Vernalis"),
  "95391": p("CA", "Tracy"),
  "95686": p("CA", "Thornton"),
  "93401": p("CA", "San Luis Obispo"),
  "93402": p("CA", "Los Osos"),
  "93403": p("CA", "San Luis Obispo"),
  "93405": p("CA", "San Luis Obispo"),
  "93406": p("CA", "San Luis Obispo"),
  "93407": p("CA", "San Luis Obispo"),
  "93408": p("CA", "San Luis Obispo"),
  "93409": p("CA", "San Luis Obispo"),
  "93410": p("CA", "San Luis Obispo"),
  "93412": p("CA", "Los Osos"),
  "93420": p("CA", "Arroyo Grande"),
  "93421": p("CA", "Arroyo Grande"),
  "93422": p("CA", "Atascadero"),
  "93423": p("CA", "Atascadero"),
  "93424": p("CA", "Avila Beach"),
  "93428": p("CA", "Cambria"),
  "93430": p("CA", "Cayucos"),
  "93432": p("CA", "Creston"),
  "93433": p("CA", "Grover Beach"),
  "93435": p("CA", "Harmony"),
  "93442": p("CA", "Morro Bay"),
  "93443": p("CA", "Morro Bay"),
  "93444": p("CA", "Nipomo"),
  "93445": p("CA", "Oceano"),
  "93446": p("CA", "Paso Robles"),
  "93447": p("CA", "Paso Robles"),
  "93448": p("CA", "Pismo Beach"),
  "93449": p("CA", "Pismo Beach"),
  "93451": p("CA", "San Miguel"),
  "93452": p("CA", "San Simeon"),
  "93453": p("CA", "Santa Margarita"),
  "93461": p("CA", "Shandon"),
  "93465": p("CA", "Templeton"),
  "93475": p("CA", "Oceano"),
  "93483": p("CA", "Grover Beach"),
  "94002": p("CA", "Belmont"),
  "94005": p("CA", "Brisbane"),
  "94010": p("CA", "Burlingame"),
  "94011": p("CA", "Burlingame"),
  "94014": p("CA", "Daly City"),
  "94015": p("CA", "Daly City"),
  "94016": p("CA", "Daly City"),
  "94017": p("CA", "Daly City"),
  "94018": p("CA", "El Granada"),
  "94019": p("CA", "Half Moon Bay"),
  "94020": p("CA", "La Honda"),
  "94021": p("CA", "Loma Mar"),
  "94025": p("CA", "Menlo Park"),
  "94026": p("CA", "Menlo Park"),
  "94027": p("CA", "Atherton"),
  "94028": p("CA", "Portola Valley"),
  "94030": p("CA", "Millbrae"),
  "94037": p("CA", "Montara"),
  "94038": p("CA", "Moss Beach"),
  "94044": p("CA", "Pacifica"),
  "94060": p("CA", "Pescadero"),
  "94061": p("CA", "Redwood City"),
  "94062": p("CA", "Redwood City"),
  "94063": p("CA", "Redwood City"),
  "94064": p("CA", "Redwood City"),
  "94065": p("CA", "Redwood City"),
  "94066": p("CA", "San Bruno"),
  "94070": p("CA", "San Carlos"),
  "94074": p("CA", "San Gregorio"),
  "94080": p("CA", "South San Francisco"),
  "94083": p("CA", "South San Francisco"),
  "94128": p("CA", "San Francisco"),
  "94303": p("CA", "Palo Alto"),
  "94401": p("CA", "San Mateo"),
  "94402": p("CA", "San Mateo"),
  "94403": p("CA", "San Mateo"),
  "94404": p("CA", "San Mateo"),
  "94497": p("CA", "San Mateo"),
  "93013": p("CA", "Carpinteria"),
  "93014": p("CA", "Carpinteria"),
  "93067": p("CA", "Summerland"),
  "93101": p("CA", "Santa Barbara"),
  "93102": p("CA", "Santa Barbara"),
  "93103": p("CA", "Santa Barbara"),
  "93105": p("CA", "Santa Barbara"),
  "93106": p("CA", "Santa Barbara"),
  "93107": p("CA", "Santa Barbara"),
  "93108": p("CA", "Santa Barbara"),
  "93109": p("CA", "Santa Barbara"),
  "93110": p("CA", "Santa Barbara"),
  "93111": p("CA", "Santa Barbara"),
  "93116": p("CA", "Goleta"),
  "93117": p("CA", "Goleta"),
  "93118": p("CA", "Goleta"),
  "93120": p("CA", "Santa Barbara"),
  "93121": p("CA", "Santa Barbara"),
  "93130": p("CA", "Santa Barbara"),
  "93140": p("CA", "Santa Barbara"),
  "93150": p("CA", "Santa Barbara"),
  "93160": p("CA", "Santa Barbara"),
  "93190": p("CA", "Santa Barbara"),
  "93199": p("CA", "Goleta"),
  "93254": p("CA", "New Cuyama"),
  "93427": p("CA", "Buellton"),
  "93429": p("CA", "Casmalia"),
  "93434": p("CA", "Guadalupe"),
  "93436": p("CA", "Lompoc"),
  "93437": p("CA", "Lompoc"),
  "93438": p("CA", "Lompoc"),
  "93440": p("CA", "Los Alamos"),
  "93441": p("CA", "Los Olivos"),
  "93454": p("CA", "Santa Maria"),
  "93455": p("CA", "Santa Maria"),
  "93456": p("CA", "Santa Maria"),
  "93457": p("CA", "Santa Maria"),
  "93458": p("CA", "Santa Maria"),
  "93460": p("CA", "Santa Ynez"),
  "93463": p("CA", "Solvang"),
  "93464": p("CA", "Solvang"),
  "94022": p("CA", "Los Altos"),
  "94023": p("CA", "Los Altos"),
  "94024": p("CA", "Los Altos"),
  "94035": p("CA", "Mountain View"),
  "94039": p("CA", "Mountain View"),
  "94040": p("CA", "Mountain View"),
  "94041": p("CA", "Mountain View"),
  "94042": p("CA", "Mountain View"),
  "94043": p("CA", "Mountain View"),
  "94085": p("CA", "Sunnyvale"),
  "94086": p("CA", "Sunnyvale"),
  "94087": p("CA", "Sunnyvale"),
  "94088": p("CA", "Sunnyvale"),
  "94089": p("CA", "Sunnyvale"),
  "94301": p("CA", "Palo Alto"),
  "94302": p("CA", "Palo Alto"),
  "94304": p("CA", "Palo Alto"),
  "94305": p("CA", "Stanford"),
  "94306": p("CA", "Palo Alto"),
  "94309": p("CA", "Palo Alto"),
  "95002": p("CA", "Alviso"),
  "95008": p("CA", "Campbell"),
  "95009": p("CA", "Campbell"),
  "95011": p("CA", "Campbell"),
  "95013": p("CA", "Coyote"),
  "95014": p("CA", "Cupertino"),
  "95015": p("CA", "Cupertino"),
  "95020": p("CA", "Gilroy"),
  "95021": p("CA", "Gilroy"),
  "95026": p("CA", "Holy City"),
  "95030": p("CA", "Los Gatos"),
  "95031": p("CA", "Los Gatos"),
  "95032": p("CA", "Los Gatos"),
  "95033": p("CA", "Los Gatos"),
  "95035": p("CA", "Milpitas"),
  "95036": p("CA", "Milpitas"),
  "95037": p("CA", "Morgan Hill"),
  "95038": p("CA", "Morgan Hill"),
  "95042": p("CA", "New Almaden"),
  "95044": p("CA", "Redwood Estates"),
  "95046": p("CA", "San Martin"),
  "95050": p("CA", "Santa Clara"),
  "95051": p("CA", "Santa Clara"),
  "95052": p("CA", "Santa Clara"),
  "95053": p("CA", "Santa Clara"),
  "95054": p("CA", "Santa Clara"),
  "95055": p("CA", "Santa Clara"),
  "95056": p("CA", "Santa Clara"),
  "95070": p("CA", "Saratoga"),
  "95071": p("CA", "Saratoga"),
  "95101": p("CA", "San Jose"),
  "95103": p("CA", "San Jose"),
  "95106": p("CA", "San Jose"),
  "95108": p("CA", "San Jose"),
  "95109": p("CA", "San Jose"),
  "95110": p("CA", "San Jose"),
  "95111": p("CA", "San Jose"),
  "95112": p("CA", "San Jose"),
  "95113": p("CA", "San Jose"),
  "95115": p("CA", "San Jose"),
  "95116": p("CA", "San Jose"),
  "95117": p("CA", "San Jose"),
  "95118": p("CA", "San Jose"),
  "95119": p("CA", "San Jose"),
  "95120": p("CA", "San Jose"),
  "95121": p("CA", "San Jose"),
  "95122": p("CA", "San Jose"),
  "95123": p("CA", "San Jose"),
  "95124": p("CA", "San Jose"),
  "95125": p("CA", "San Jose"),
  "95126": p("CA", "San Jose"),
  "95127": p("CA", "San Jose"),
  "95128": p("CA", "San Jose"),
  "95129": p("CA", "San Jose"),
  "95130": p("CA", "San Jose"),
  "95131": p("CA", "San Jose"),
  "95132": p("CA", "San Jose"),
  "95133": p("CA", "San Jose"),
  "95134": p("CA", "San Jose"),
  "95135": p("CA", "San Jose"),
  "95136": p("CA", "San Jose"),
  "95138": p("CA", "San Jose"),
  "95139": p("CA", "San Jose"),
  "95140": p("CA", "Mount Hamilton"),
  "95141": p("CA", "San Jose"),
  "95148": p("CA", "San Jose"),
  "95150": p("CA", "San Jose"),
  "95151": p("CA", "San Jose"),
  "95152": p("CA", "San Jose"),
  "95153": p("CA", "San Jose"),
  "95154": p("CA", "San Jose"),
  "95155": p("CA", "San Jose"),
  "95156": p("CA", "San Jose"),
  "95157": p("CA", "San Jose"),
  "95158": p("CA", "San Jose"),
  "95159": p("CA", "San Jose"),
  "95160": p("CA", "San Jose"),
  "95161": p("CA", "San Jose"),
  "95164": p("CA", "San Jose"),
  "95170": p("CA", "San Jose"),
  "95172": p("CA", "San Jose"),
  "95173": p("CA", "San Jose"),
  "95190": p("CA", "San Jose"),
  "95191": p("CA", "San Jose"),
  "95192": p("CA", "San Jose"),
  "95193": p("CA", "San Jose"),
  "95194": p("CA", "San Jose"),
  "95196": p("CA", "San Jose"),
  "95001": p("CA", "Aptos"),
  "95003": p("CA", "Aptos"),
  "95005": p("CA", "Ben Lomond"),
  "95006": p("CA", "Boulder Creek"),
  "95007": p("CA", "Brookdale"),
  "95010": p("CA", "Capitola"),
  "95017": p("CA", "Davenport"),
  "95018": p("CA", "Felton"),
  "95019": p("CA", "Freedom"),
  "95041": p("CA", "Mount Hermon"),
  "95060": p("CA", "Santa Cruz"),
  "95061": p("CA", "Santa Cruz"),
  "95062": p("CA", "Santa Cruz"),
  "95063": p("CA", "Santa Cruz"),
  "95064": p("CA", "Santa Cruz"),
  "95065": p("CA", "Santa Cruz"),
  "95066": p("CA", "Scotts Valley"),
  "95067": p("CA", "Scotts Valley"),
  "95073": p("CA", "Soquel"),
  "95076": p("CA", "Watsonville"),
  "95077": p("CA", "Watsonville"),
  "96001": p("CA", "Redding"),
  "96002": p("CA", "Redding"),
  "96003": p("CA", "Redding"),
  "96007": p("CA", "Anderson"),
  "96008": p("CA", "Bella Vista"),
  "96011": p("CA", "Big Bend"),
  "96013": p("CA", "Burney"),
  "96016": p("CA", "Cassel"),
  "96017": p("CA", "Castella"),
  "96019": p("CA", "Shasta Lake"),
  "96022": p("CA", "Cottonwood"),
  "96028": p("CA", "Fall River Mills"),
  "96033": p("CA", "French Gulch"),
  "96040": p("CA", "Hat Creek"),
  "96047": p("CA", "Igo"),
  "96049": p("CA", "Redding"),
  "96051": p("CA", "Lakehead"),
  "96056": p("CA", "Mcarthur"),
  "96062": p("CA", "Millville"),
  "96065": p("CA", "Montgomery Creek"),
  "96069": p("CA", "Oak Run"),
  "96070": p("CA", "Obrien"),
  "96071": p("CA", "Old Station"),
  "96073": p("CA", "Palo Cedro"),
  "96076": p("CA", "Platina"),
  "96079": p("CA", "Shasta Lake"),
  "96084": p("CA", "Round Mountain"),
  "96087": p("CA", "Shasta"),
  "96088": p("CA", "Shingletown"),
  "96089": p("CA", "Shasta Lake"),
  "96095": p("CA", "Whiskeytown"),
  "96096": p("CA", "Whitmore"),
  "96099": p("CA", "Redding"),
  "95910": p("CA", "Alleghany"),
  "95936": p("CA", "Downieville"),
  "95944": p("CA", "Goodyears Bar"),
  "96118": p("CA", "Loyalton"),
  "96124": p("CA", "Calpine"),
  "96125": p("CA", "Sierra City"),
  "96126": p("CA", "Sierraville"),
  "95568": p("CA", "Somes Bar"),
  "96014": p("CA", "Callahan"),
  "96023": p("CA", "Dorris"),
  "96025": p("CA", "Dunsmuir"),
  "96027": p("CA", "Etna"),
  "96031": p("CA", "Forks Of Salmon"),
  "96032": p("CA", "Fort Jones"),
  "96034": p("CA", "Gazelle"),
  "96037": p("CA", "Greenview"),
  "96038": p("CA", "Grenada"),
  "96039": p("CA", "Happy Camp"),
  "96044": p("CA", "Hornbrook"),
  "96050": p("CA", "Klamath River"),
  "96057": p("CA", "Mccloud"),
  "96058": p("CA", "Macdoel"),
  "96064": p("CA", "Montague"),
  "96067": p("CA", "Mount Shasta"),
  "96085": p("CA", "Scott Bar"),
  "96086": p("CA", "Seiad Valley"),
  "96094": p("CA", "Weed"),
  "96097": p("CA", "Yreka"),
  "96134": p("CA", "Tulelake"),
  "94510": p("CA", "Benicia"),
  "94512": p("CA", "Birds Landing"),
  "94533": p("CA", "Fairfield"),
  "94534": p("CA", "Fairfield"),
  "94535": p("CA", "Travis Afb"),
  "94571": p("CA", "Rio Vista"),
  "94585": p("CA", "Suisun City"),
  "94589": p("CA", "Vallejo"),
  "94590": p("CA", "Vallejo"),
  "94591": p("CA", "Vallejo"),
  "94592": p("CA", "Vallejo"),
  "95620": p("CA", "Dixon"),
  "95625": p("CA", "Elmira"),
  "95687": p("CA", "Vacaville"),
  "95688": p("CA", "Vacaville"),
  "95696": p("CA", "Vacaville"),
  "94922": p("CA", "Bodega"),
  "94923": p("CA", "Bodega Bay"),
  "94926": p("CA", "Rohnert Park"),
  "94927": p("CA", "Rohnert Park"),
  "94928": p("CA", "Rohnert Park"),
  "94931": p("CA", "Cotati"),
  "94951": p("CA", "Penngrove"),
  "94952": p("CA", "Petaluma"),
  "94953": p("CA", "Petaluma"),
  "94954": p("CA", "Petaluma"),
  "94955": p("CA", "Petaluma"),
  "94972": p("CA", "Valley Ford"),
  "94975": p("CA", "Petaluma"),
  "94999": p("CA", "Petaluma"),
  "95401": p("CA", "Santa Rosa"),
  "95402": p("CA", "Santa Rosa"),
  "95403": p("CA", "Santa Rosa"),
  "95404": p("CA", "Santa Rosa"),
  "95405": p("CA", "Santa Rosa"),
  "95406": p("CA", "Santa Rosa"),
  "95407": p("CA", "Santa Rosa"),
  "95409": p("CA", "Santa Rosa"),
  "95412": p("CA", "Annapolis"),
  "95416": p("CA", "Boyes Hot Springs"),
  "95419": p("CA", "Camp Meeker"),
  "95421": p("CA", "Cazadero"),
  "95425": p("CA", "Cloverdale"),
  "95430": p("CA", "Duncans Mills"),
  "95431": p("CA", "Eldridge"),
  "95433": p("CA", "El Verano"),
  "95436": p("CA", "Forestville"),
  "95439": p("CA", "Fulton"),
  "95441": p("CA", "Geyserville"),
  "95442": p("CA", "Glen Ellen"),
  "95444": p("CA", "Graton"),
  "95446": p("CA", "Guerneville"),
  "95448": p("CA", "Healdsburg"),
  "95450": p("CA", "Jenner"),
  "95452": p("CA", "Kenwood"),
  "95462": p("CA", "Monte Rio"),
  "95465": p("CA", "Occidental"),
  "95471": p("CA", "Rio Nido"),
  "95472": p("CA", "Sebastopol"),
  "95473": p("CA", "Sebastopol"),
  "95476": p("CA", "Sonoma"),
  "95480": p("CA", "Stewarts Point"),
  "95486": p("CA", "Villa Grande"),
  "95487": p("CA", "Vineburg"),
  "95492": p("CA", "Windsor"),
  "95497": p("CA", "The Sea Ranch"),
  "95307": p("CA", "Ceres"),
  "95313": p("CA", "Crows Landing"),
  "95316": p("CA", "Denair"),
  "95319": p("CA", "Empire"),
  "95323": p("CA", "Hickman"),
  "95326": p("CA", "Hughson"),
  "95328": p("CA", "Keyes"),
  "95329": p("CA", "La Grange"),
  "95350": p("CA", "Modesto"),
  "95351": p("CA", "Modesto"),
  "95352": p("CA", "Modesto"),
  "95353": p("CA", "Modesto"),
  "95354": p("CA", "Modesto"),
  "95355": p("CA", "Modesto"),
  "95356": p("CA", "Modesto"),
  "95357": p("CA", "Modesto"),
  "95358": p("CA", "Modesto"),
  "95360": p("CA", "Newman"),
  "95361": p("CA", "Oakdale"),
  "95363": p("CA", "Patterson"),
  "95367": p("CA", "Riverbank"),
  "95368": p("CA", "Salida"),
  "95380": p("CA", "Turlock"),
  "95381": p("CA", "Turlock"),
  "95382": p("CA", "Turlock"),
  "95386": p("CA", "Waterford"),
  "95387": p("CA", "Westley"),
  "95397": p("CA", "Modesto"),
  "95659": p("CA", "Nicolaus"),
  "95668": p("CA", "Pleasant Grove"),
  "95674": p("CA", "Rio Oso"),
  "95676": p("CA", "Robbins"),
  "95953": p("CA", "Live Oak"),
  "95957": p("CA", "Meridian"),
  "95982": p("CA", "Sutter"),
  "95991": p("CA", "Yuba City"),
  "95992": p("CA", "Yuba City"),
  "95993": p("CA", "Yuba City"),
  "96021": p("CA", "Corning"),
  "96029": p("CA", "Flournoy"),
  "96035": p("CA", "Gerber"),
  "96055": p("CA", "Los Molinos"),
  "96059": p("CA", "Manton"),
  "96061": p("CA", "Mill Creek"),
  "96063": p("CA", "Mineral"),
  "96074": p("CA", "Paskenta"),
  "96075": p("CA", "Paynes Creek"),
  "96078": p("CA", "Proberta"),
  "96080": p("CA", "Red Bluff"),
  "96090": p("CA", "Tehama"),
  "96092": p("CA", "Vina"),
  "95527": p("CA", "Burnt Ranch"),
  "95552": p("CA", "Mad River"),
  "95563": p("CA", "Salyer"),
  "95595": p("CA", "Zenia"),
  "96010": p("CA", "Big Bar"),
  "96024": p("CA", "Douglas City"),
  "96041": p("CA", "Hayfork"),
  "96046": p("CA", "Hyampom"),
  "96048": p("CA", "Junction City"),
  "96052": p("CA", "Lewiston"),
  "96091": p("CA", "Trinity Center"),
  "96093": p("CA", "Weaverville"),
  "93201": p("CA", "Alpaugh"),
  "93207": p("CA", "California Hot Springs"),
  "93208": p("CA", "Camp Nelson"),
  "93218": p("CA", "Ducor"),
  "93219": p("CA", "Earlimart"),
  "93221": p("CA", "Exeter"),
  "93223": p("CA", "Farmersville"),
  "93227": p("CA", "Goshen"),
  "93235": p("CA", "Ivanhoe"),
  "93237": p("CA", "Kaweah"),
  "93244": p("CA", "Lemon Cove"),
  "93247": p("CA", "Lindsay"),
  "93256": p("CA", "Pixley"),
  "93257": p("CA", "Porterville"),
  "93258": p("CA", "Porterville"),
  "93260": p("CA", "Posey"),
  "93261": p("CA", "Richgrove"),
  "93262": p("CA", "Sequoia National Park"),
  "93265": p("CA", "Springville"),
  "93267": p("CA", "Strathmore"),
  "93270": p("CA", "Terra Bella"),
  "93271": p("CA", "Three Rivers"),
  "93272": p("CA", "Tipton"),
  "93274": p("CA", "Tulare"),
  "93275": p("CA", "Tulare"),
  "93277": p("CA", "Visalia"),
  "93278": p("CA", "Visalia"),
  "93279": p("CA", "Visalia"),
  "93282": p("CA", "Waukena"),
  "93286": p("CA", "Woodlake"),
  "93290": p("CA", "Visalia"),
  "93291": p("CA", "Visalia"),
  "93292": p("CA", "Visalia"),
  "93603": p("CA", "Badger"),
  "93615": p("CA", "Cutler"),
  "93618": p("CA", "Dinuba"),
  "93619": p("CA", "Clovis"),
  "93633": p("CA", "Kings Canyon National Pk"),
  "93647": p("CA", "Orosi"),
  "93666": p("CA", "Sultana"),
  "93670": p("CA", "Yettem"),
  "93673": p("CA", "Traver"),
  "95305": p("CA", "Big Oak Flat"),
  "95309": p("CA", "Chinese Camp"),
  "95310": p("CA", "Columbia"),
  "95321": p("CA", "Groveland"),
  "95327": p("CA", "Jamestown"),
  "95335": p("CA", "Long Barn"),
  "95346": p("CA", "Mi Wuk Village"),
  "95347": p("CA", "Moccasin"),
  "95364": p("CA", "Pinecrest"),
  "95370": p("CA", "Sonora"),
  "95372": p("CA", "Soulsbyville"),
  "95373": p("CA", "Standard"),
  "95375": p("CA", "Strawberry"),
  "95379": p("CA", "Tuolumne"),
  "95383": p("CA", "Twain Harte"),
  "91319": p("CA", "Newbury Park"),
  "91320": p("CA", "Newbury Park"),
  "91358": p("CA", "Thousand Oaks"),
  "91359": p("CA", "Westlake Village"),
  "91360": p("CA", "Thousand Oaks"),
  "91361": p("CA", "Westlake Village"),
  "91362": p("CA", "Thousand Oaks"),
  "91377": p("CA", "Oak Park"),
  "93001": p("CA", "Ventura"),
  "93002": p("CA", "Ventura"),
  "93003": p("CA", "Ventura"),
  "93004": p("CA", "Ventura"),
  "93005": p("CA", "Ventura"),
  "93006": p("CA", "Ventura"),
  "93007": p("CA", "Ventura"),
  "93009": p("CA", "Ventura"),
  "93010": p("CA", "Camarillo"),
  "93011": p("CA", "Camarillo"),
  "93012": p("CA", "Camarillo"),
  "93015": p("CA", "Fillmore"),
  "93016": p("CA", "Fillmore"),
  "93020": p("CA", "Moorpark"),
  "93021": p("CA", "Moorpark"),
  "93022": p("CA", "Oak View"),
  "93023": p("CA", "Ojai"),
  "93024": p("CA", "Ojai"),
  "93030": p("CA", "Oxnard"),
  "93031": p("CA", "Oxnard"),
  "93032": p("CA", "Oxnard"),
  "93033": p("CA", "Oxnard"),
  "93034": p("CA", "Oxnard"),
  "93035": p("CA", "Oxnard"),
  "93036": p("CA", "Oxnard"),
  "93040": p("CA", "Piru"),
  "93041": p("CA", "Port Hueneme"),
  "93042": p("CA", "Point Mugu Nawc"),
  "93043": p("CA", "Port Hueneme Cbc Base"),
  "93044": p("CA", "Port Hueneme"),
  "93060": p("CA", "Santa Paula"),
  "93061": p("CA", "Santa Paula"),
  "93062": p("CA", "Simi Valley"),
  "93063": p("CA", "Simi Valley"),
  "93064": p("CA", "Brandeis"),
  "93065": p("CA", "Simi Valley"),
  "93066": p("CA", "Somis"),
  "93094": p("CA", "Simi Valley"),
  "93099": p("CA", "Simi Valley"),
  "95605": p("CA", "West Sacramento"),
  "95606": p("CA", "Brooks"),
  "95607": p("CA", "Capay"),
  "95612": p("CA", "Clarksburg"),
  "95616": p("CA", "Davis"),
  "95617": p("CA", "Davis"),
  "95618": p("CA", "Davis"),
  "95627": p("CA", "Esparto"),
  "95637": p("CA", "Guinda"),
  "95645": p("CA", "Knights Landing"),
  "95653": p("CA", "Madison"),
  "95679": p("CA", "Rumsey"),
  "95691": p("CA", "West Sacramento"),
  "95694": p("CA", "Winters"),
  "95695": p("CA", "Woodland"),
  "95697": p("CA", "Yolo"),
  "95698": p("CA", "Zamora"),
  "95776": p("CA", "Woodland"),
  "95798": p("CA", "West Sacramento"),
  "95799": p("CA", "West Sacramento"),
  "95937": p("CA", "Dunnigan"),
  "95692": p("CA", "Wheatland"),
  "95901": p("CA", "Marysville"),
  "95903": p("CA", "Beale Afb"),
  "95918": p("CA", "Browns Valley"),
  "95919": p("CA", "Brownsville"),
  "95922": p("CA", "Camptonville"),
  "95925": p("CA", "Challenge"),
  "95935": p("CA", "Dobbins"),
  "95961": p("CA", "Olivehurst"),
  "95962": p("CA", "Oregon House"),
  "95972": p("CA", "Rackerby"),
  "95981": p("CA", "Strawberry Valley"),
  "80011": p("CO", "Aurora"),
  "80019": p("CO", "Aurora"),
  "80022": p("CO", "Commerce City"),
  "80024": p("CO", "Dupont"),
  "80030": p("CO", "Westminster"),
  "80031": p("CO", "Westminster"),
  "80035": p("CO", "Westminster"),
  "80036": p("CO", "Westminster"),
  "80037": p("CO", "Commerce City"),
  "80040": p("CO", "Aurora"),
  "80042": p("CO", "Aurora"),
  "80045": p("CO", "Aurora"),
  "80102": p("CO", "Bennett"),
  "80136": p("CO", "Strasburg"),
  "80137": p("CO", "Watkins"),
  "80221": p("CO", "Denver"),
  "80229": p("CO", "Denver"),
  "80233": p("CO", "Denver"),
  "80234": p("CO", "Denver"),
  "80241": p("CO", "Thornton"),
  "80260": p("CO", "Denver"),
  "80601": p("CO", "Brighton"),
  "80602": p("CO", "Brighton"),
  "80603": p("CO", "Brighton"),
  "80614": p("CO", "Eastlake"),
  "80640": p("CO", "Henderson"),
  "81101": p("CO", "Alamosa"),
  "81102": p("CO", "Alamosa"),
  "81136": p("CO", "Hooper"),
  "81146": p("CO", "Mosca"),
  "80010": p("CO", "Aurora"),
  "80012": p("CO", "Aurora"),
  "80013": p("CO", "Aurora"),
  "80014": p("CO", "Aurora"),
  "80015": p("CO", "Aurora"),
  "80016": p("CO", "Aurora"),
  "80017": p("CO", "Aurora"),
  "80018": p("CO", "Aurora"),
  "80041": p("CO", "Aurora"),
  "80044": p("CO", "Aurora"),
  "80046": p("CO", "Aurora"),
  "80047": p("CO", "Aurora"),
  "80103": p("CO", "Byers"),
  "80105": p("CO", "Deer Trail"),
  "80110": p("CO", "Englewood"),
  "80111": p("CO", "Englewood"),
  "80112": p("CO", "Englewood"),
  "80113": p("CO", "Englewood"),
  "80120": p("CO", "Littleton"),
  "80121": p("CO", "Littleton"),
  "80122": p("CO", "Littleton"),
  "80150": p("CO", "Englewood"),
  "80151": p("CO", "Englewood"),
  "80155": p("CO", "Englewood"),
  "80160": p("CO", "Littleton"),
  "80161": p("CO", "Littleton"),
  "80165": p("CO", "Littleton"),
  "80166": p("CO", "Littleton"),
  "81121": p("CO", "Arboles"),
  "81128": p("CO", "Chromo"),
  "81147": p("CO", "Pagosa Springs"),
  "81157": p("CO", "Pagosa Springs"),
  "81029": p("CO", "Campo"),
  "81064": p("CO", "Pritchett"),
  "81073": p("CO", "Springfield"),
  "81084": p("CO", "Two Buttes"),
  "81087": p("CO", "Vilas"),
  "81090": p("CO", "Walsh"),
  "81038": p("CO", "Fort Lyon"),
  "81044": p("CO", "Hasty"),
  "81054": p("CO", "Las Animas"),
  "81057": p("CO", "Mc Clave"),
  "80020": p("CO", "Broomfield"),
  "80025": p("CO", "Eldorado Springs"),
  "80026": p("CO", "Lafayette"),
  "80027": p("CO", "Louisville"),
  "80038": p("CO", "Broomfield"),
  "80301": p("CO", "Boulder"),
  "80302": p("CO", "Boulder"),
  "80303": p("CO", "Boulder"),
  "80304": p("CO", "Boulder"),
  "80305": p("CO", "Boulder"),
  "80306": p("CO", "Boulder"),
  "80307": p("CO", "Boulder"),
  "80308": p("CO", "Boulder"),
  "80309": p("CO", "Boulder"),
  "80310": p("CO", "Boulder"),
  "80314": p("CO", "Boulder"),
  "80455": p("CO", "Jamestown"),
  "80466": p("CO", "Nederland"),
  "80471": p("CO", "Pinecliffe"),
  "80481": p("CO", "Ward"),
  "80501": p("CO", "Longmont"),
  "80502": p("CO", "Longmont"),
  "80503": p("CO", "Longmont"),
  "80510": p("CO", "Allenspark"),
  "80533": p("CO", "Hygiene"),
  "80540": p("CO", "Lyons"),
  "80544": p("CO", "Niwot"),
  "80023": p("CO", "Broomfield"),
  "81201": p("CO", "Salida"),
  "81211": p("CO", "Buena Vista"),
  "81227": p("CO", "Monarch"),
  "81228": p("CO", "Granite"),
  "81236": p("CO", "Nathrop"),
  "81242": p("CO", "Poncha Springs"),
  "80802": p("CO", "Arapahoe"),
  "80810": p("CO", "Cheyenne Wells"),
  "80825": p("CO", "Kit Carson"),
  "80862": p("CO", "Wild Horse"),
  "80436": p("CO", "Dumont"),
  "80438": p("CO", "Empire"),
  "80444": p("CO", "Georgetown"),
  "80452": p("CO", "Idaho Springs"),
  "80476": p("CO", "Silver Plume"),
  "81120": p("CO", "Antonito"),
  "81124": p("CO", "Capulin"),
  "81129": p("CO", "Conejos"),
  "81140": p("CO", "La Jara"),
  "81141": p("CO", "Manassa"),
  "81148": p("CO", "Romeo"),
  "81151": p("CO", "Sanford"),
  "81123": p("CO", "Blanca"),
  "81126": p("CO", "Chama"),
  "81133": p("CO", "Fort Garland"),
  "81138": p("CO", "Jaroso"),
  "81152": p("CO", "San Luis"),
  "81033": p("CO", "Crowley"),
  "81034": p("CO", "Crowley"),
  "81062": p("CO", "Olney Springs"),
  "81063": p("CO", "Ordway"),
  "81076": p("CO", "Sugar City"),
  "81252": p("CO", "Westcliffe"),
  "81253": p("CO", "Wetmore"),
  "81410": p("CO", "Austin"),
  "81413": p("CO", "Cedaredge"),
  "81414": p("CO", "Cory"),
  "81415": p("CO", "Crawford"),
  "81416": p("CO", "Delta"),
  "81418": p("CO", "Eckert"),
  "81419": p("CO", "Hotchkiss"),
  "81420": p("CO", "Lazear"),
  "81428": p("CO", "Paonia"),
  "80201": p("CO", "Denver"),
  "80202": p("CO", "Denver"),
  "80203": p("CO", "Denver"),
  "80204": p("CO", "Denver"),
  "80205": p("CO", "Denver"),
  "80206": p("CO", "Denver"),
  "80207": p("CO", "Denver"),
  "80208": p("CO", "Denver"),
  "80209": p("CO", "Denver"),
  "80210": p("CO", "Denver"),
  "80211": p("CO", "Denver"),
  "80212": p("CO", "Denver"),
  "80216": p("CO", "Denver"),
  "80217": p("CO", "Denver"),
  "80218": p("CO", "Denver"),
  "80219": p("CO", "Denver"),
  "80220": p("CO", "Denver"),
  "80222": p("CO", "Denver"),
  "80223": p("CO", "Denver"),
  "80224": p("CO", "Denver"),
  "80227": p("CO", "Denver"),
  "80230": p("CO", "Denver"),
  "80231": p("CO", "Denver"),
  "80235": p("CO", "Denver"),
  "80236": p("CO", "Denver"),
  "80237": p("CO", "Denver"),
  "80238": p("CO", "Denver"),
  "80239": p("CO", "Denver"),
  "80243": p("CO", "Denver"),
  "80244": p("CO", "Denver"),
  "80246": p("CO", "Denver"),
  "80247": p("CO", "Denver"),
  "80248": p("CO", "Denver"),
  "80249": p("CO", "Denver"),
  "80250": p("CO", "Denver"),
  "80251": p("CO", "Denver"),
  "80252": p("CO", "Denver"),
  "80256": p("CO", "Denver"),
  "80257": p("CO", "Denver"),
  "80259": p("CO", "Denver"),
  "80261": p("CO", "Denver"),
  "80262": p("CO", "Denver"),
  "80263": p("CO", "Denver"),
  "80264": p("CO", "Denver"),
  "80265": p("CO", "Denver"),
  "80266": p("CO", "Denver"),
  "80271": p("CO", "Denver"),
  "80273": p("CO", "Denver"),
  "80274": p("CO", "Denver"),
  "80281": p("CO", "Denver"),
  "80290": p("CO", "Denver"),
  "80291": p("CO", "Denver"),
  "80293": p("CO", "Denver"),
  "80294": p("CO", "Denver"),
  "80299": p("CO", "Denver"),
  "81320": p("CO", "Cahone"),
  "81324": p("CO", "Dove Creek"),
  "81332": p("CO", "Rico"),
  "80104": p("CO", "Castle Rock"),
  "80108": p("CO", "Castle Rock"),
  "80109": p("CO", "Castle Rock"),
  "80116": p("CO", "Franktown"),
  "80118": p("CO", "Larkspur"),
  "80124": p("CO", "Lone Tree"),
  "80125": p("CO", "Littleton"),
  "80126": p("CO", "Littleton"),
  "80129": p("CO", "Littleton"),
  "80130": p("CO", "Littleton"),
  "80131": p("CO", "Louviers"),
  "80134": p("CO", "Parker"),
  "80135": p("CO", "Sedalia"),
  "80138": p("CO", "Parker"),
  "80163": p("CO", "Littleton"),
  "80423": p("CO", "Bond"),
  "80426": p("CO", "Burns"),
  "80463": p("CO", "Mc Coy"),
  "81620": p("CO", "Avon"),
  "81621": p("CO", "Basalt"),
  "81631": p("CO", "Eagle"),
  "81632": p("CO", "Edwards"),
  "81637": p("CO", "Gypsum"),
  "81645": p("CO", "Minturn"),
  "81649": p("CO", "Red Cliff"),
  "81655": p("CO", "Wolcott"),
  "81657": p("CO", "Vail"),
  "81658": p("CO", "Vail"),
  "80101": p("CO", "Agate"),
  "80106": p("CO", "Elbert"),
  "80107": p("CO", "Elizabeth"),
  "80117": p("CO", "Kiowa"),
  "80830": p("CO", "Matheson"),
  "80835": p("CO", "Simla"),
  "80132": p("CO", "Monument"),
  "80133": p("CO", "Palmer Lake"),
  "80808": p("CO", "Calhan"),
  "80809": p("CO", "Cascade"),
  "80817": p("CO", "Fountain"),
  "80819": p("CO", "Green Mountain Falls"),
  "80829": p("CO", "Manitou Springs"),
  "80831": p("CO", "Peyton"),
  "80832": p("CO", "Ramah"),
  "80833": p("CO", "Rush"),
  "80840": p("CO", "Usaf Academy"),
  "80841": p("CO", "Usaf Academy"),
  "80864": p("CO", "Yoder"),
  "80901": p("CO", "Colorado Springs"),
  "80902": p("CO", "Colorado Springs"),
  "80903": p("CO", "Colorado Springs"),
  "80904": p("CO", "Colorado Springs"),
  "80905": p("CO", "Colorado Springs"),
  "80906": p("CO", "Colorado Springs"),
  "80907": p("CO", "Colorado Springs"),
  "80908": p("CO", "Colorado Springs"),
  "80909": p("CO", "Colorado Springs"),
  "80910": p("CO", "Colorado Springs"),
  "80911": p("CO", "Colorado Springs"),
  "80912": p("CO", "Colorado Springs"),
  "80913": p("CO", "Colorado Springs"),
  "80914": p("CO", "Colorado Springs"),
  "80915": p("CO", "Colorado Springs"),
  "80916": p("CO", "Colorado Springs"),
  "80917": p("CO", "Colorado Springs"),
  "80918": p("CO", "Colorado Springs"),
  "80919": p("CO", "Colorado Springs"),
  "80920": p("CO", "Colorado Springs"),
  "80921": p("CO", "Colorado Springs"),
  "80922": p("CO", "Colorado Springs"),
  "80923": p("CO", "Colorado Springs"),
  "80924": p("CO", "Colorado Springs"),
  "80925": p("CO", "Colorado Springs"),
  "80926": p("CO", "Colorado Springs"),
  "80927": p("CO", "Colorado Springs"),
  "80928": p("CO", "Colorado Springs"),
  "80929": p("CO", "Colorado Springs"),
  "80930": p("CO", "Colorado Springs"),
  "80931": p("CO", "Colorado Springs"),
  "80932": p("CO", "Colorado Springs"),
  "80933": p("CO", "Colorado Springs"),
  "80934": p("CO", "Colorado Springs"),
  "80935": p("CO", "Colorado Springs"),
  "80936": p("CO", "Colorado Springs"),
  "80937": p("CO", "Colorado Springs"),
  "80938": p("CO", "Colorado Springs"),
  "80939": p("CO", "Colorado Springs"),
  "80941": p("CO", "Colorado Springs"),
  "80942": p("CO", "Colorado Springs"),
  "80944": p("CO", "Colorado Springs"),
  "80946": p("CO", "Colorado Springs"),
  "80947": p("CO", "Colorado Springs"),
  "80949": p("CO", "Colorado Springs"),
  "80950": p("CO", "Colorado Springs"),
  "80951": p("CO", "Colorado Springs"),
  "80960": p("CO", "Colorado Springs"),
  "80962": p("CO", "Colorado Springs"),
  "80970": p("CO", "Colorado Springs"),
  "80977": p("CO", "Colorado Springs"),
  "80995": p("CO", "Colorado Springs"),
  "80997": p("CO", "Colorado Springs"),
  "81212": p("CO", "Canon City"),
  "81215": p("CO", "Canon City"),
  "81221": p("CO", "Coal Creek"),
  "81222": p("CO", "Coaldale"),
  "81223": p("CO", "Cotopaxi"),
  "81226": p("CO", "Florence"),
  "81232": p("CO", "Hillside"),
  "81233": p("CO", "Howard"),
  "81240": p("CO", "Penrose"),
  "81244": p("CO", "Rockvale"),
  "81290": p("CO", "Florence"),
  "81601": p("CO", "Glenwood Springs"),
  "81602": p("CO", "Glenwood Springs"),
  "81623": p("CO", "Carbondale"),
  "81635": p("CO", "Parachute"),
  "81636": p("CO", "Battlement Mesa"),
  "81647": p("CO", "New Castle"),
  "81650": p("CO", "Rifle"),
  "81652": p("CO", "Silt"),
  "80422": p("CO", "Black Hawk"),
  "80427": p("CO", "Central City"),
  "80474": p("CO", "Rollinsville"),
  "80442": p("CO", "Fraser"),
  "80446": p("CO", "Granby"),
  "80447": p("CO", "Grand Lake"),
  "80451": p("CO", "Hot Sulphur Springs"),
  "80459": p("CO", "Kremmling"),
  "80468": p("CO", "Parshall"),
  "80478": p("CO", "Tabernash"),
  "80482": p("CO", "Winter Park"),
  "81210": p("CO", "Almont"),
  "81224": p("CO", "Crested Butte"),
  "81225": p("CO", "Crested Butte"),
  "81230": p("CO", "Gunnison"),
  "81231": p("CO", "Gunnison"),
  "81237": p("CO", "Ohio City"),
  "81239": p("CO", "Parlin"),
  "81241": p("CO", "Pitkin"),
  "81243": p("CO", "Powderhorn"),
  "81434": p("CO", "Somerset"),
  "81235": p("CO", "Lake City"),
  "81040": p("CO", "Gardner"),
  "81055": p("CO", "La Veta"),
  "81089": p("CO", "Walsenburg"),
  "80430": p("CO", "Coalmont"),
  "80434": p("CO", "Cowdrey"),
  "80473": p("CO", "Rand"),
  "80480": p("CO", "Walden"),
  "80001": p("CO", "Arvada"),
  "80002": p("CO", "Arvada"),
  "80003": p("CO", "Arvada"),
  "80004": p("CO", "Arvada"),
  "80005": p("CO", "Arvada"),
  "80006": p("CO", "Arvada"),
  "80007": p("CO", "Arvada"),
  "80021": p("CO", "Broomfield"),
  "80033": p("CO", "Wheat Ridge"),
  "80034": p("CO", "Wheat Ridge"),
  "80123": p("CO", "Littleton"),
  "80127": p("CO", "Littleton"),
  "80128": p("CO", "Littleton"),
  "80162": p("CO", "Littleton"),
  "80214": p("CO", "Denver"),
  "80215": p("CO", "Denver"),
  "80225": p("CO", "Denver"),
  "80226": p("CO", "Denver"),
  "80228": p("CO", "Denver"),
  "80232": p("CO", "Denver"),
  "80401": p("CO", "Golden"),
  "80402": p("CO", "Golden"),
  "80403": p("CO", "Golden"),
  "80419": p("CO", "Golden"),
  "80425": p("CO", "Buffalo Creek"),
  "80433": p("CO", "Conifer"),
  "80437": p("CO", "Evergreen"),
  "80439": p("CO", "Evergreen"),
  "80453": p("CO", "Idledale"),
  "80454": p("CO", "Indian Hills"),
  "80457": p("CO", "Kittredge"),
  "80465": p("CO", "Morrison"),
  "80470": p("CO", "Pine"),
  "81021": p("CO", "Arlington"),
  "81036": p("CO", "Eads"),
  "81045": p("CO", "Haswell"),
  "81071": p("CO", "Sheridan Lake"),
  "80805": p("CO", "Bethune"),
  "80807": p("CO", "Burlington"),
  "80815": p("CO", "Flagler"),
  "80834": p("CO", "Seibert"),
  "80836": p("CO", "Stratton"),
  "80861": p("CO", "Vona"),
  "80429": p("CO", "Climax"),
  "80461": p("CO", "Leadville"),
  "81251": p("CO", "Twin Lakes"),
  "81122": p("CO", "Bayfield"),
  "81137": p("CO", "Ignacio"),
  "81301": p("CO", "Durango"),
  "81302": p("CO", "Durango"),
  "81303": p("CO", "Durango"),
  "81326": p("CO", "Hesperus"),
  "81329": p("CO", "Marvel"),
  "80511": p("CO", "Estes Park"),
  "80512": p("CO", "Bellvue"),
  "80513": p("CO", "Berthoud"),
  "80515": p("CO", "Drake"),
  "80517": p("CO", "Estes Park"),
  "80521": p("CO", "Fort Collins"),
  "80522": p("CO", "Fort Collins"),
  "80523": p("CO", "Fort Collins"),
  "80524": p("CO", "Fort Collins"),
  "80525": p("CO", "Fort Collins"),
  "80526": p("CO", "Fort Collins"),
  "80527": p("CO", "Fort Collins"),
  "80528": p("CO", "Fort Collins"),
  "80532": p("CO", "Glen Haven"),
  "80535": p("CO", "Laporte"),
  "80536": p("CO", "Livermore"),
  "80537": p("CO", "Loveland"),
  "80538": p("CO", "Loveland"),
  "80539": p("CO", "Loveland"),
  "80541": p("CO", "Masonville"),
  "80545": p("CO", "Red Feather Lakes"),
  "80547": p("CO", "Timnath"),
  "80549": p("CO", "Wellington"),
  "80553": p("CO", "Fort Collins"),
  "81020": p("CO", "Aguilar"),
  "81024": p("CO", "Boncarbo"),
  "81027": p("CO", "Branson"),
  "81046": p("CO", "Hoehne"),
  "81049": p("CO", "Kim"),
  "81059": p("CO", "Model"),
  "81081": p("CO", "Trinchera"),
  "81082": p("CO", "Trinidad"),
  "81091": p("CO", "Weston"),
  "80804": p("CO", "Arriba"),
  "80818": p("CO", "Genoa"),
  "80821": p("CO", "Hugo"),
  "80823": p("CO", "Karval"),
  "80826": p("CO", "Limon"),
  "80828": p("CO", "Limon"),
  "80722": p("CO", "Atwood"),
  "80726": p("CO", "Crook"),
  "80728": p("CO", "Fleming"),
  "80736": p("CO", "Iliff"),
  "80741": p("CO", "Merino"),
  "80745": p("CO", "Padroni"),
  "80747": p("CO", "Peetz"),
  "80751": p("CO", "Sterling"),
  "81501": p("CO", "Grand Junction"),
  "81502": p("CO", "Grand Junction"),
  "81503": p("CO", "Grand Junction"),
  "81504": p("CO", "Grand Junction"),
  "81505": p("CO", "Grand Junction"),
  "81506": p("CO", "Grand Junction"),
  "81507": p("CO", "Grand Junction"),
  "81520": p("CO", "Clifton"),
  "81521": p("CO", "Fruita"),
  "81522": p("CO", "Gateway"),
  "81523": p("CO", "Glade Park"),
  "81524": p("CO", "Loma"),
  "81525": p("CO", "Mack"),
  "81526": p("CO", "Palisade"),
  "81527": p("CO", "Whitewater"),
  "81624": p("CO", "Collbran"),
  "81630": p("CO", "De Beque"),
  "81643": p("CO", "Mesa"),
  "81646": p("CO", "Molina"),
  "81130": p("CO", "Creede"),
  "81610": p("CO", "Dinosaur"),
  "81625": p("CO", "Craig"),
  "81626": p("CO", "Craig"),
  "81633": p("CO", "Dinosaur"),
  "81638": p("CO", "Hamilton"),
  "81640": p("CO", "Maybell"),
  "81653": p("CO", "Slater"),
  "81321": p("CO", "Cortez"),
  "81323": p("CO", "Dolores"),
  "81327": p("CO", "Lewis"),
  "81328": p("CO", "Mancos"),
  "81330": p("CO", "Mesa Verde National Park"),
  "81331": p("CO", "Pleasant View"),
  "81334": p("CO", "Towaoc"),
  "81335": p("CO", "Yellow Jacket"),
  "81220": p("CO", "Cimarron"),
  "81401": p("CO", "Montrose"),
  "81402": p("CO", "Montrose"),
  "81403": p("CO", "Montrose"),
  "81411": p("CO", "Bedrock"),
  "81422": p("CO", "Naturita"),
  "81424": p("CO", "Nucla"),
  "81425": p("CO", "Olathe"),
  "81429": p("CO", "Paradox"),
  "81431": p("CO", "Redvale"),
  "80649": p("CO", "Orchard"),
  "80653": p("CO", "Weldona"),
  "80654": p("CO", "Wiggins"),
  "80701": p("CO", "Fort Morgan"),
  "80705": p("CO", "Log Lane Village"),
  "80723": p("CO", "Brush"),
  "80733": p("CO", "Hillrose"),
  "80750": p("CO", "Snyder"),
  "81030": p("CO", "Cheraw"),
  "81039": p("CO", "Fowler"),
  "81050": p("CO", "La Junta"),
  "81058": p("CO", "Manzanola"),
  "81067": p("CO", "Rocky Ford"),
  "81077": p("CO", "Swink"),
  "81427": p("CO", "Ouray"),
  "81432": p("CO", "Ridgway"),
  "80420": p("CO", "Alma"),
  "80421": p("CO", "Bailey"),
  "80432": p("CO", "Como"),
  "80440": p("CO", "Fairplay"),
  "80448": p("CO", "Grant"),
  "80449": p("CO", "Hartsel"),
  "80456": p("CO", "Jefferson"),
  "80475": p("CO", "Shawnee"),
  "80820": p("CO", "Guffey"),
  "80827": p("CO", "Lake George"),
  "80721": p("CO", "Amherst"),
  "80731": p("CO", "Haxtun"),
  "80734": p("CO", "Holyoke"),
  "80746": p("CO", "Paoli"),
  "81611": p("CO", "Aspen"),
  "81612": p("CO", "Aspen"),
  "81615": p("CO", "Snowmass Village"),
  "81642": p("CO", "Meredith"),
  "81654": p("CO", "Snowmass"),
  "81656": p("CO", "Woody Creek"),
  "81041": p("CO", "Granada"),
  "81043": p("CO", "Hartman"),
  "81047": p("CO", "Holly"),
  "81052": p("CO", "Lamar"),
  "81092": p("CO", "Wiley"),
  "81001": p("CO", "Pueblo"),
  "81002": p("CO", "Pueblo"),
  "81003": p("CO", "Pueblo"),
  "81004": p("CO", "Pueblo"),
  "81005": p("CO", "Pueblo"),
  "81006": p("CO", "Pueblo"),
  "81007": p("CO", "Pueblo"),
  "81008": p("CO", "Pueblo"),
  "81009": p("CO", "Pueblo"),
  "81010": p("CO", "Pueblo"),
  "81011": p("CO", "Pueblo"),
  "81012": p("CO", "Pueblo"),
  "81019": p("CO", "Colorado City"),
  "81022": p("CO", "Avondale"),
  "81023": p("CO", "Beulah"),
  "81025": p("CO", "Boone"),
  "81069": p("CO", "Rye"),
  "81641": p("CO", "Meeker"),
  "81648": p("CO", "Rangely"),
  "81132": p("CO", "Del Norte"),
  "81135": p("CO", "Homelake"),
  "81144": p("CO", "Monte Vista"),
  "81154": p("CO", "South Fork"),
  "80428": p("CO", "Clark"),
  "80467": p("CO", "Oak Creek"),
  "80469": p("CO", "Phippsburg"),
  "80477": p("CO", "Steamboat Springs"),
  "80479": p("CO", "Toponas"),
  "80483": p("CO", "Yampa"),
  "80487": p("CO", "Steamboat Springs"),
  "80488": p("CO", "Steamboat Springs"),
  "81639": p("CO", "Hayden"),
  "81125": p("CO", "Center"),
  "81131": p("CO", "Crestone"),
  "81143": p("CO", "Moffat"),
  "81149": p("CO", "Saguache"),
  "81155": p("CO", "Villa Grove"),
  "81248": p("CO", "Sargents"),
  "81433": p("CO", "Silverton"),
  "81325": p("CO", "Egnar"),
  "81423": p("CO", "Norwood"),
  "81426": p("CO", "Ophir"),
  "81430": p("CO", "Placerville"),
  "81435": p("CO", "Telluride"),
  "80737": p("CO", "Julesburg"),
  "80744": p("CO", "Ovid"),
  "80749": p("CO", "Sedgwick"),
  "80424": p("CO", "Breckenridge"),
  "80435": p("CO", "Dillon"),
  "80443": p("CO", "Frisco"),
  "80497": p("CO", "Silverthorne"),
  "80498": p("CO", "Silverthorne"),
  "80813": p("CO", "Cripple Creek"),
  "80814": p("CO", "Divide"),
  "80816": p("CO", "Florissant"),
  "80860": p("CO", "Victor"),
  "80863": p("CO", "Woodland Park"),
  "80866": p("CO", "Woodland Park"),
  "80720": p("CO", "Akron"),
  "80740": p("CO", "Lindon"),
  "80743": p("CO", "Otis"),
  "80757": p("CO", "Woodrow"),
  "80801": p("CO", "Anton"),
  "80812": p("CO", "Cope"),
  "80504": p("CO", "Longmont"),
  "80514": p("CO", "Dacono"),
  "80516": p("CO", "Erie"),
  "80520": p("CO", "Firestone"),
  "80530": p("CO", "Frederick"),
  "80534": p("CO", "Johnstown"),
  "80542": p("CO", "Mead"),
  "80543": p("CO", "Milliken"),
  "80546": p("CO", "Severance"),
  "80550": p("CO", "Windsor"),
  "80551": p("CO", "Windsor"),
  "80610": p("CO", "Ault"),
  "80611": p("CO", "Briggsdale"),
  "80612": p("CO", "Carr"),
  "80615": p("CO", "Eaton"),
  "80620": p("CO", "Evans"),
  "80621": p("CO", "Fort Lupton"),
  "80622": p("CO", "Galeton"),
  "80623": p("CO", "Gilcrest"),
  "80624": p("CO", "Gill"),
  "80631": p("CO", "Greeley"),
  "80632": p("CO", "Greeley"),
  "80633": p("CO", "Greeley"),
  "80634": p("CO", "Greeley"),
  "80638": p("CO", "Greeley"),
  "80639": p("CO", "Greeley"),
  "80642": p("CO", "Hudson"),
  "80643": p("CO", "Keenesburg"),
  "80644": p("CO", "Kersey"),
  "80645": p("CO", "La Salle"),
  "80646": p("CO", "Lucerne"),
  "80648": p("CO", "Nunn"),
  "80650": p("CO", "Pierce"),
  "80651": p("CO", "Platteville"),
  "80652": p("CO", "Roggen"),
  "80729": p("CO", "Grover"),
  "80732": p("CO", "Hereford"),
  "80742": p("CO", "New Raymer"),
  "80754": p("CO", "Stoneham"),
  "80727": p("CO", "Eckley"),
  "80735": p("CO", "Idalia"),
  "80755": p("CO", "Vernon"),
  "80758": p("CO", "Wray"),
  "80759": p("CO", "Yuma"),
  "80822": p("CO", "Joes"),
  "80824": p("CO", "Kirk"),
  "06404": p("CT", "Botsford"),
  "06440": p("CT", "Hawleyville"),
  "06468": p("CT", "Monroe"),
  "06470": p("CT", "Newtown"),
  "06482": p("CT", "Sandy Hook"),
  "06484": p("CT", "Shelton"),
  "06491": p("CT", "Stevenson"),
  "06601": p("CT", "Bridgeport"),
  "06602": p("CT", "Bridgeport"),
  "06604": p("CT", "Bridgeport"),
  "06605": p("CT", "Bridgeport"),
  "06606": p("CT", "Bridgeport"),
  "06607": p("CT", "Bridgeport"),
  "06608": p("CT", "Bridgeport"),
  "06610": p("CT", "Bridgeport"),
  "06611": p("CT", "Trumbull"),
  "06612": p("CT", "Easton"),
  "06614": p("CT", "Stratford"),
  "06615": p("CT", "Stratford"),
  "06673": p("CT", "Bridgeport"),
  "06699": p("CT", "Bridgeport"),
  "06784": p("CT", "Sherman"),
  "06801": p("CT", "Bethel"),
  "06804": p("CT", "Brookfield"),
  "06807": p("CT", "Cos Cob"),
  "06810": p("CT", "Danbury"),
  "06811": p("CT", "Danbury"),
  "06812": p("CT", "New Fairfield"),
  "06813": p("CT", "Danbury"),
  "06814": p("CT", "Danbury"),
  "06816": p("CT", "Danbury"),
  "06817": p("CT", "Danbury"),
  "06820": p("CT", "Darien"),
  "06824": p("CT", "Fairfield"),
  "06825": p("CT", "Fairfield"),
  "06828": p("CT", "Fairfield"),
  "06829": p("CT", "Georgetown"),
  "06830": p("CT", "Greenwich"),
  "06831": p("CT", "Greenwich"),
  "06836": p("CT", "Greenwich"),
  "06838": p("CT", "Greens Farms"),
  "06840": p("CT", "New Canaan"),
  "06850": p("CT", "Norwalk"),
  "06851": p("CT", "Norwalk"),
  "06852": p("CT", "Norwalk"),
  "06853": p("CT", "Norwalk"),
  "06854": p("CT", "Norwalk"),
  "06855": p("CT", "Norwalk"),
  "06856": p("CT", "Norwalk"),
  "06857": p("CT", "Norwalk"),
  "06858": p("CT", "Norwalk"),
  "06860": p("CT", "Norwalk"),
  "06870": p("CT", "Old Greenwich"),
  "06875": p("CT", "Redding Center"),
  "06876": p("CT", "Redding Ridge"),
  "06877": p("CT", "Ridgefield"),
  "06878": p("CT", "Riverside"),
  "06879": p("CT", "Ridgefield"),
  "06880": p("CT", "Westport"),
  "06881": p("CT", "Westport"),
  "06883": p("CT", "Weston"),
  "06888": p("CT", "Westport"),
  "06889": p("CT", "Westport"),
  "06890": p("CT", "Southport"),
  "06896": p("CT", "Redding"),
  "06897": p("CT", "Wilton"),
  "06901": p("CT", "Stamford"),
  "06902": p("CT", "Stamford"),
  "06903": p("CT", "Stamford"),
  "06904": p("CT", "Stamford"),
  "06905": p("CT", "Stamford"),
  "06906": p("CT", "Stamford"),
  "06907": p("CT", "Stamford"),
  "06910": p("CT", "Stamford"),
  "06911": p("CT", "Stamford"),
  "06912": p("CT", "Stamford"),
  "06913": p("CT", "Stamford"),
  "06914": p("CT", "Stamford"),
  "06920": p("CT", "Stamford"),
  "06921": p("CT", "Stamford"),
  "06922": p("CT", "Stamford"),
  "06926": p("CT", "Stamford"),
  "06927": p("CT", "Stamford"),
  "06001": p("CT", "Avon"),
  "06002": p("CT", "Bloomfield"),
  "06006": p("CT", "Windsor"),
  "06010": p("CT", "Bristol"),
  "06011": p("CT", "Bristol"),
  "06013": p("CT", "Burlington"),
  "06016": p("CT", "Broad Brook"),
  "06019": p("CT", "Canton"),
  "06020": p("CT", "Canton Center"),
  "06022": p("CT", "Collinsville"),
  "06023": p("CT", "East Berlin"),
  "06025": p("CT", "East Glastonbury"),
  "06026": p("CT", "East Granby"),
  "06027": p("CT", "East Hartland"),
  "06028": p("CT", "East Windsor Hill"),
  "06030": p("CT", "Farmington"),
  "06032": p("CT", "Farmington"),
  "06033": p("CT", "Glastonbury"),
  "06034": p("CT", "Farmington"),
  "06035": p("CT", "Granby"),
  "06037": p("CT", "Berlin"),
  "06040": p("CT", "Manchester"),
  "06041": p("CT", "Manchester"),
  "06042": p("CT", "Manchester"),
  "06045": p("CT", "Manchester"),
  "06050": p("CT", "New Britain"),
  "06051": p("CT", "New Britain"),
  "06052": p("CT", "New Britain"),
  "06053": p("CT", "New Britain"),
  "06059": p("CT", "North Canton"),
  "06060": p("CT", "North Granby"),
  "06062": p("CT", "Plainville"),
  "06064": p("CT", "Poquonock"),
  "06067": p("CT", "Rocky Hill"),
  "06070": p("CT", "Simsbury"),
  "06073": p("CT", "South Glastonbury"),
  "06074": p("CT", "South Windsor"),
  "06078": p("CT", "Suffield"),
  "06080": p("CT", "Suffield"),
  "06081": p("CT", "Tariffville"),
  "06082": p("CT", "Enfield"),
  "06083": p("CT", "Enfield"),
  "06085": p("CT", "Unionville"),
  "06087": p("CT", "Unionville"),
  "06088": p("CT", "East Windsor"),
  "06089": p("CT", "Weatogue"),
  "06090": p("CT", "West Granby"),
  "06091": p("CT", "West Hartland"),
  "06092": p("CT", "West Simsbury"),
  "06093": p("CT", "West Suffield"),
  "06095": p("CT", "Windsor"),
  "06096": p("CT", "Windsor Locks"),
  "06101": p("CT", "Hartford"),
  "06102": p("CT", "Hartford"),
  "06103": p("CT", "Hartford"),
  "06104": p("CT", "Hartford"),
  "06105": p("CT", "Hartford"),
  "06106": p("CT", "Hartford"),
  "06107": p("CT", "West Hartford"),
  "06108": p("CT", "East Hartford"),
  "06109": p("CT", "Wethersfield"),
  "06110": p("CT", "West Hartford"),
  "06111": p("CT", "Newington"),
  "06112": p("CT", "Hartford"),
  "06114": p("CT", "Hartford"),
  "06115": p("CT", "Hartford"),
  "06117": p("CT", "West Hartford"),
  "06118": p("CT", "East Hartford"),
  "06119": p("CT", "West Hartford"),
  "06120": p("CT", "Hartford"),
  "06123": p("CT", "Hartford"),
  "06126": p("CT", "Hartford"),
  "06127": p("CT", "West Hartford"),
  "06128": p("CT", "East Hartford"),
  "06129": p("CT", "Wethersfield"),
  "06131": p("CT", "Newington"),
  "06132": p("CT", "Hartford"),
  "06133": p("CT", "West Hartford"),
  "06134": p("CT", "Hartford"),
  "06137": p("CT", "West Hartford"),
  "06138": p("CT", "East Hartford"),
  "06140": p("CT", "Hartford"),
  "06141": p("CT", "Hartford"),
  "06142": p("CT", "Hartford"),
  "06143": p("CT", "Hartford"),
  "06144": p("CT", "Hartford"),
  "06145": p("CT", "Hartford"),
  "06146": p("CT", "Hartford"),
  "06147": p("CT", "Hartford"),
  "06150": p("CT", "Hartford"),
  "06151": p("CT", "Hartford"),
  "06152": p("CT", "Hartford"),
  "06153": p("CT", "Hartford"),
  "06154": p("CT", "Hartford"),
  "06155": p("CT", "Hartford"),
  "06156": p("CT", "Hartford"),
  "06160": p("CT", "Hartford"),
  "06161": p("CT", "Hartford"),
  "06167": p("CT", "Hartford"),
  "06176": p("CT", "Hartford"),
  "06180": p("CT", "Hartford"),
  "06183": p("CT", "Hartford"),
  "06199": p("CT", "Hartford"),
  "06444": p("CT", "Marion"),
  "06447": p("CT", "Marlborough"),
  "06467": p("CT", "Milldale"),
  "06479": p("CT", "Plantsville"),
  "06489": p("CT", "Southington"),
  "06018": p("CT", "Canaan"),
  "06021": p("CT", "Colebrook"),
  "06024": p("CT", "East Canaan"),
  "06031": p("CT", "Falls Village"),
  "06039": p("CT", "Lakeville"),
  "06057": p("CT", "New Hartford"),
  "06058": p("CT", "Norfolk"),
  "06061": p("CT", "Pine Meadow"),
  "06063": p("CT", "Barkhamsted"),
  "06065": p("CT", "Riverton"),
  "06068": p("CT", "Salisbury"),
  "06069": p("CT", "Sharon"),
  "06079": p("CT", "Taconic"),
  "06094": p("CT", "Winchester Center"),
  "06098": p("CT", "Winsted"),
  "06750": p("CT", "Bantam"),
  "06751": p("CT", "Bethlehem"),
  "06752": p("CT", "Bridgewater"),
  "06753": p("CT", "Cornwall"),
  "06754": p("CT", "Cornwall Bridge"),
  "06755": p("CT", "Gaylordsville"),
  "06756": p("CT", "Goshen"),
  "06757": p("CT", "Kent"),
  "06758": p("CT", "Lakeside"),
  "06759": p("CT", "Litchfield"),
  "06763": p("CT", "Morris"),
  "06776": p("CT", "New Milford"),
  "06777": p("CT", "New Preston Marble Dale"),
  "06778": p("CT", "Northfield"),
  "06779": p("CT", "Oakville"),
  "06781": p("CT", "Pequabuck"),
  "06782": p("CT", "Plymouth"),
  "06783": p("CT", "Roxbury"),
  "06785": p("CT", "South Kent"),
  "06786": p("CT", "Terryville"),
  "06787": p("CT", "Thomaston"),
  "06790": p("CT", "Torrington"),
  "06791": p("CT", "Harwinton"),
  "06792": p("CT", "Torrington"),
  "06793": p("CT", "Washington"),
  "06794": p("CT", "Washington Depot"),
  "06795": p("CT", "Watertown"),
  "06796": p("CT", "West Cornwall"),
  "06798": p("CT", "Woodbury"),
  "06409": p("CT", "Centerbrook"),
  "06412": p("CT", "Chester"),
  "06413": p("CT", "Clinton"),
  "06414": p("CT", "Cobalt"),
  "06416": p("CT", "Cromwell"),
  "06417": p("CT", "Deep River"),
  "06419": p("CT", "Killingworth"),
  "06422": p("CT", "Durham"),
  "06423": p("CT", "East Haddam"),
  "06424": p("CT", "East Hampton"),
  "06426": p("CT", "Essex"),
  "06438": p("CT", "Haddam"),
  "06441": p("CT", "Higganum"),
  "06442": p("CT", "Ivoryton"),
  "06455": p("CT", "Middlefield"),
  "06456": p("CT", "Middle Haddam"),
  "06457": p("CT", "Middletown"),
  "06459": p("CT", "Middletown"),
  "06469": p("CT", "Moodus"),
  "06475": p("CT", "Old Saybrook"),
  "06480": p("CT", "Portland"),
  "06481": p("CT", "Rockfall"),
  "06498": p("CT", "Westbrook"),
  "06401": p("CT", "Ansonia"),
  "06403": p("CT", "Beacon Falls"),
  "06405": p("CT", "Branford"),
  "06408": p("CT", "Cheshire"),
  "06410": p("CT", "Cheshire"),
  "06411": p("CT", "Cheshire"),
  "06418": p("CT", "Derby"),
  "06437": p("CT", "Guilford"),
  "06443": p("CT", "Madison"),
  "06450": p("CT", "Meriden"),
  "06451": p("CT", "Meriden"),
  "06460": p("CT", "Milford"),
  "06461": p("CT", "Milford"),
  "06471": p("CT", "North Branford"),
  "06472": p("CT", "Northford"),
  "06473": p("CT", "North Haven"),
  "06477": p("CT", "Orange"),
  "06478": p("CT", "Oxford"),
  "06483": p("CT", "Seymour"),
  "06487": p("CT", "South Britain"),
  "06488": p("CT", "Southbury"),
  "06492": p("CT", "Wallingford"),
  "06493": p("CT", "Wallingford"),
  "06494": p("CT", "Wallingford"),
  "06495": p("CT", "Wallingford"),
  "06501": p("CT", "New Haven"),
  "06502": p("CT", "New Haven"),
  "06503": p("CT", "New Haven"),
  "06504": p("CT", "New Haven"),
  "06505": p("CT", "New Haven"),
  "06506": p("CT", "New Haven"),
  "06507": p("CT", "New Haven"),
  "06508": p("CT", "New Haven"),
  "06509": p("CT", "New Haven"),
  "06510": p("CT", "New Haven"),
  "06511": p("CT", "New Haven"),
  "06512": p("CT", "New Haven"),
  "06513": p("CT", "New Haven"),
  "06514": p("CT", "Hamden"),
  "06515": p("CT", "New Haven"),
  "06516": p("CT", "West Haven"),
  "06517": p("CT", "Hamden"),
  "06518": p("CT", "Hamden"),
  "06519": p("CT", "New Haven"),
  "06520": p("CT", "New Haven"),
  "06521": p("CT", "New Haven"),
  "06524": p("CT", "Bethany"),
  "06525": p("CT", "New Haven"),
  "06530": p("CT", "New Haven"),
  "06531": p("CT", "New Haven"),
  "06532": p("CT", "New Haven"),
  "06533": p("CT", "New Haven"),
  "06534": p("CT", "New Haven"),
  "06535": p("CT", "New Haven"),
  "06536": p("CT", "New Haven"),
  "06537": p("CT", "New Haven"),
  "06538": p("CT", "New Haven"),
  "06540": p("CT", "New Haven"),
  "06701": p("CT", "Waterbury"),
  "06702": p("CT", "Waterbury"),
  "06703": p("CT", "Waterbury"),
  "06704": p("CT", "Waterbury"),
  "06705": p("CT", "Waterbury"),
  "06706": p("CT", "Waterbury"),
  "06708": p("CT", "Waterbury"),
  "06710": p("CT", "Waterbury"),
  "06712": p("CT", "Prospect"),
  "06716": p("CT", "Wolcott"),
  "06720": p("CT", "Waterbury"),
  "06721": p("CT", "Waterbury"),
  "06722": p("CT", "Waterbury"),
  "06723": p("CT", "Waterbury"),
  "06724": p("CT", "Waterbury"),
  "06725": p("CT", "Waterbury"),
  "06726": p("CT", "Waterbury"),
  "06749": p("CT", "Waterbury"),
  "06762": p("CT", "Middlebury"),
  "06770": p("CT", "Naugatuck"),
  "06249": p("CT", "Lebanon"),
  "06254": p("CT", "North Franklin"),
  "06320": p("CT", "New London"),
  "06330": p("CT", "Baltic"),
  "06333": p("CT", "East Lyme"),
  "06334": p("CT", "Bozrah"),
  "06335": p("CT", "Gales Ferry"),
  "06336": p("CT", "Gilman"),
  "06338": p("CT", "Mashantucket"),
  "06339": p("CT", "Ledyard"),
  "06340": p("CT", "Groton"),
  "06349": p("CT", "Groton"),
  "06350": p("CT", "Hanover"),
  "06351": p("CT", "Jewett City"),
  "06353": p("CT", "Montville"),
  "06355": p("CT", "Mystic"),
  "06357": p("CT", "Niantic"),
  "06359": p("CT", "North Stonington"),
  "06360": p("CT", "Norwich"),
  "06365": p("CT", "Preston"),
  "06370": p("CT", "Oakdale"),
  "06371": p("CT", "Old Lyme"),
  "06372": p("CT", "Old Mystic"),
  "06375": p("CT", "Quaker Hill"),
  "06376": p("CT", "South Lyme"),
  "06378": p("CT", "Stonington"),
  "06379": p("CT", "Pawcatuck"),
  "06380": p("CT", "Taftville"),
  "06382": p("CT", "Uncasville"),
  "06383": p("CT", "Versailles"),
  "06384": p("CT", "Voluntown"),
  "06385": p("CT", "Waterford"),
  "06388": p("CT", "West Mystic"),
  "06389": p("CT", "Yantic"),
  "06415": p("CT", "Colchester"),
  "06420": p("CT", "Salem"),
  "06439": p("CT", "Hadlyme"),
  "06474": p("CT", "North Westchester"),
  "06029": p("CT", "Ellington"),
  "06043": p("CT", "Bolton"),
  "06066": p("CT", "Vernon Rockville"),
  "06071": p("CT", "Somers"),
  "06072": p("CT", "Somersville"),
  "06075": p("CT", "Stafford"),
  "06076": p("CT", "Stafford Springs"),
  "06077": p("CT", "Staffordville"),
  "06084": p("CT", "Tolland"),
  "06231": p("CT", "Amston"),
  "06232": p("CT", "Andover"),
  "06237": p("CT", "Columbia"),
  "06238": p("CT", "Coventry"),
  "06248": p("CT", "Hebron"),
  "06250": p("CT", "Mansfield Center"),
  "06251": p("CT", "Mansfield Depot"),
  "06265": p("CT", "South Willington"),
  "06268": p("CT", "Storrs Mansfield"),
  "06269": p("CT", "Storrs Mansfield"),
  "06279": p("CT", "Willington"),
  "06226": p("CT", "Willimantic"),
  "06230": p("CT", "Abington"),
  "06233": p("CT", "Ballouville"),
  "06234": p("CT", "Brooklyn"),
  "06235": p("CT", "Chaplin"),
  "06239": p("CT", "Danielson"),
  "06241": p("CT", "Dayville"),
  "06242": p("CT", "Eastford"),
  "06243": p("CT", "East Killingly"),
  "06244": p("CT", "East Woodstock"),
  "06245": p("CT", "Fabyan"),
  "06246": p("CT", "Grosvenor Dale"),
  "06247": p("CT", "Hampton"),
  "06255": p("CT", "North Grosvenordale"),
  "06256": p("CT", "North Windham"),
  "06258": p("CT", "Pomfret"),
  "06259": p("CT", "Pomfret Center"),
  "06260": p("CT", "Putnam"),
  "06262": p("CT", "Quinebaug"),
  "06263": p("CT", "Rogers"),
  "06264": p("CT", "Scotland"),
  "06266": p("CT", "South Windham"),
  "06267": p("CT", "South Woodstock"),
  "06277": p("CT", "Thompson"),
  "06278": p("CT", "Ashford"),
  "06280": p("CT", "Windham"),
  "06281": p("CT", "Woodstock"),
  "06282": p("CT", "Woodstock Valley"),
  "06331": p("CT", "Canterbury"),
  "06332": p("CT", "Central Village"),
  "06354": p("CT", "Moosup"),
  "06373": p("CT", "Oneco"),
  "06374": p("CT", "Plainfield"),
  "06377": p("CT", "Sterling"),
  "06387": p("CT", "Wauregan"),
  "20001": p("DC", "Washington"),
  "20002": p("DC", "Washington"),
  "20003": p("DC", "Washington"),
  "20004": p("DC", "Washington"),
  "20005": p("DC", "Washington"),
  "20006": p("DC", "Washington"),
  "20007": p("DC", "Washington"),
  "20008": p("DC", "Washington"),
  "20009": p("DC", "Washington"),
  "20010": p("DC", "Washington"),
  "20011": p("DC", "Washington"),
  "20012": p("DC", "Washington"),
  "20013": p("DC", "Washington"),
  "20015": p("DC", "Washington"),
  "20016": p("DC", "Washington"),
  "20017": p("DC", "Washington"),
  "20018": p("DC", "Washington"),
  "20019": p("DC", "Washington"),
  "20020": p("DC", "Washington"),
  "20022": p("DC", "Washington"),
  "20024": p("DC", "Washington"),
  "20026": p("DC", "Washington"),
  "20027": p("DC", "Washington"),
  "20029": p("DC", "Washington"),
  "20030": p("DC", "Washington"),
  "20032": p("DC", "Washington"),
  "20033": p("DC", "Washington"),
  "20035": p("DC", "Washington"),
  "20036": p("DC", "Washington"),
  "20037": p("DC", "Washington"),
  "20038": p("DC", "Washington"),
  "20039": p("DC", "Washington"),
  "20040": p("DC", "Washington"),
  "20041": p("DC", "Washington"),
  "20042": p("DC", "Washington"),
  "20043": p("DC", "Washington"),
  "20044": p("DC", "Washington"),
  "20045": p("DC", "Washington"),
  "20047": p("DC", "Washington"),
  "20049": p("DC", "Washington"),
  "20050": p("DC", "Washington"),
  "20052": p("DC", "Washington"),
  "20053": p("DC", "Washington"),
  "20055": p("DC", "Washington"),
  "20056": p("DC", "Washington"),
  "20057": p("DC", "Washington"),
  "20058": p("DC", "Washington"),
  "20059": p("DC", "Washington"),
  "20060": p("DC", "Washington"),
  "20061": p("DC", "Washington"),
  "20062": p("DC", "Washington"),
  "20063": p("DC", "Washington"),
  "20064": p("DC", "Washington"),
  "20065": p("DC", "Washington"),
  "20066": p("DC", "Washington"),
  "20067": p("DC", "Washington"),
  "20068": p("DC", "Washington"),
  "20069": p("DC", "Washington"),
  "20070": p("DC", "Washington"),
  "20071": p("DC", "Washington"),
  "20073": p("DC", "Washington"),
  "20074": p("DC", "Washington"),
  "20075": p("DC", "Washington"),
  "20076": p("DC", "Washington"),
  "20077": p("DC", "Washington"),
  "20078": p("DC", "Washington"),
  "20080": p("DC", "Washington"),
  "20081": p("DC", "Washington"),
  "20082": p("DC", "Washington"),
  "20090": p("DC", "Washington"),
  "20091": p("DC", "Washington"),
  "20201": p("DC", "Washington"),
  "20202": p("DC", "Washington"),
  "20203": p("DC", "Washington"),
  "20204": p("DC", "Washington"),
  "20206": p("DC", "Washington"),
  "20207": p("DC", "Washington"),
  "20208": p("DC", "Washington"),
  "20210": p("DC", "Washington"),
  "20211": p("DC", "Washington"),
  "20212": p("DC", "Washington"),
  "20213": p("DC", "Washington"),
  "20214": p("DC", "Washington"),
  "20215": p("DC", "Washington"),
  "20216": p("DC", "Washington"),
  "20217": p("DC", "Washington"),
  "20218": p("DC", "Washington"),
  "20219": p("DC", "Washington"),
  "20220": p("DC", "Washington"),
  "20221": p("DC", "Washington"),
  "20222": p("DC", "Washington"),
  "20223": p("DC", "Washington"),
  "20224": p("DC", "Washington"),
  "20226": p("DC", "Washington"),
  "20227": p("DC", "Washington"),
  "20228": p("DC", "Washington"),
  "20229": p("DC", "Washington"),
  "20230": p("DC", "Washington"),
  "20232": p("DC", "Washington"),
  "20233": p("DC", "Washington"),
  "20235": p("DC", "Washington"),
  "20237": p("DC", "Washington"),
  "20238": p("DC", "Washington"),
  "20239": p("DC", "Washington"),
  "20240": p("DC", "Washington"),
  "20241": p("DC", "Washington"),
  "20242": p("DC", "Washington"),
  "20244": p("DC", "Washington"),
  "20245": p("DC", "Washington"),
  "20250": p("DC", "Washington"),
  "20251": p("DC", "Washington"),
  "20252": p("DC", "Washington"),
  "20254": p("DC", "Washington"),
  "20260": p("DC", "Washington"),
  "20261": p("DC", "Washington"),
  "20262": p("DC", "Washington"),
  "20265": p("DC", "Washington"),
  "20266": p("DC", "Washington"),
  "20268": p("DC", "Washington"),
  "20270": p("DC", "Washington"),
  "20277": p("DC", "Washington"),
  "20289": p("DC", "Washington"),
  "20299": p("DC", "Washington"),
  "20301": p("DC", "Washington"),
  "20303": p("DC", "Washington"),
  "20306": p("DC", "Washington"),
  "20310": p("DC", "Washington"),
  "20314": p("DC", "Washington"),
  "20317": p("DC", "Washington"),
  "20318": p("DC", "Washington"),
  "20319": p("DC", "Washington"),
  "20330": p("DC", "Washington"),
  "20340": p("DC", "Washington"),
  "20350": p("DC", "Washington"),
  "20355": p("DC", "Washington"),
  "20370": p("DC", "Washington"),
  "20372": p("DC", "Washington"),
  "20373": p("DC", "Naval Anacost Annex"),
  "20374": p("DC", "Washington Navy Yard"),
  "20375": p("DC", "Washington"),
  "20376": p("DC", "Washington Navy Yard"),
  "20380": p("DC", "Washington"),
  "20388": p("DC", "Washington Navy Yard"),
  "20389": p("DC", "Washington"),
  "20390": p("DC", "Washington"),
  "20391": p("DC", "Washington Navy Yard"),
  "20392": p("DC", "Washington"),
  "20393": p("DC", "Washington"),
  "20394": p("DC", "Washington"),
  "20395": p("DC", "Washington"),
  "20398": p("DC", "Washington Navy Yard"),
  "20401": p("DC", "Washington"),
  "20402": p("DC", "Washington"),
  "20403": p("DC", "Washington"),
  "20404": p("DC", "Washington"),
  "20405": p("DC", "Washington"),
  "20406": p("DC", "Washington"),
  "20407": p("DC", "Washington"),
  "20408": p("DC", "Washington"),
  "20409": p("DC", "Washington"),
  "20410": p("DC", "Washington"),
  "20411": p("DC", "Washington"),
  "20412": p("DC", "Washington"),
  "20413": p("DC", "Washington"),
  "20414": p("DC", "Washington"),
  "20415": p("DC", "Washington"),
  "20416": p("DC", "Washington"),
  "20417": p("DC", "Washington"),
  "20418": p("DC", "Washington"),
  "20419": p("DC", "Washington"),
  "20420": p("DC", "Washington"),
  "20421": p("DC", "Washington"),
  "20422": p("DC", "Washington"),
  "20423": p("DC", "Washington"),
  "20424": p("DC", "Washington"),
  "20425": p("DC", "Washington"),
  "20426": p("DC", "Washington"),
  "20427": p("DC", "Washington"),
  "20428": p("DC", "Washington"),
  "20429": p("DC", "Washington"),
  "20431": p("DC", "Washington"),
  "20433": p("DC", "Washington"),
  "20434": p("DC", "Washington"),
  "20435": p("DC", "Washington"),
  "20436": p("DC", "Washington"),
  "20437": p("DC", "Washington"),
  "20439": p("DC", "Washington"),
  "20440": p("DC", "Washington"),
  "20441": p("DC", "Washington"),
  "20442": p("DC", "Washington"),
  "20444": p("DC", "Washington"),
  "20447": p("DC", "Washington"),
  "20451": p("DC", "Washington"),
  "20453": p("DC", "Washington"),
  "20456": p("DC", "Washington"),
  "20460": p("DC", "Washington"),
  "20463": p("DC", "Washington"),
  "20468": p("DC", "Washington"),
  "20469": p("DC", "Washington"),
  "20470": p("DC", "Washington"),
  "20472": p("DC", "Washington"),
  "20500": p("DC", "Washington"),
  "20501": p("DC", "Washington"),
  "20502": p("DC", "Washington"),
  "20503": p("DC", "Washington"),
  "20504": p("DC", "Washington"),
  "20505": p("DC", "Washington"),
  "20506": p("DC", "Washington"),
  "20507": p("DC", "Washington"),
  "20508": p("DC", "Washington"),
  "20509": p("DC", "Washington"),
  "20510": p("DC", "Washington"),
  "20511": p("DC", "Washington"),
  "20515": p("DC", "Washington"),
  "20520": p("DC", "Washington"),
  "20521": p("DC", "Washington"),
  "20522": p("DC", "Washington"),
  "20523": p("DC", "Washington"),
  "20524": p("DC", "Washington"),
  "20525": p("DC", "Washington"),
  "20526": p("DC", "Washington"),
  "20527": p("DC", "Washington"),
  "20528": p("DC", "Washington"),
  "20529": p("DC", "Washington"),
  "20530": p("DC", "Washington"),
  "20531": p("DC", "Washington"),
  "20533": p("DC", "Washington"),
  "20534": p("DC", "Washington"),
  "20535": p("DC", "Washington"),
  "20536": p("DC", "Washington"),
  "20537": p("DC", "Washington"),
  "20538": p("DC", "Washington"),
  "20539": p("DC", "Washington"),
  "20540": p("DC", "Washington"),
  "20541": p("DC", "Washington"),
  "20542": p("DC", "Washington"),
  "20543": p("DC", "Washington"),
  "20544": p("DC", "Washington"),
  "20546": p("DC", "Washington"),
  "20547": p("DC", "Washington"),
  "20548": p("DC", "Washington"),
  "20549": p("DC", "Washington"),
  "20551": p("DC", "Washington"),
  "20552": p("DC", "Washington"),
  "20553": p("DC", "Washington"),
  "20554": p("DC", "Washington"),
  "20555": p("DC", "Washington"),
  "20557": p("DC", "Washington"),
  "20559": p("DC", "Washington"),
  "20560": p("DC", "Washington"),
  "20565": p("DC", "Washington"),
  "20566": p("DC", "Washington"),
  "20570": p("DC", "Washington"),
  "20571": p("DC", "Washington"),
  "20572": p("DC", "Washington"),
  "20573": p("DC", "Washington"),
  "20575": p("DC", "Washington"),
  "20576": p("DC", "Washington"),
  "20577": p("DC", "Washington"),
  "20578": p("DC", "Washington"),
  "20579": p("DC", "Washington"),
  "20580": p("DC", "Washington"),
  "20581": p("DC", "Washington"),
  "20585": p("DC", "Washington"),
  "20586": p("DC", "Washington"),
  "20590": p("DC", "Washington"),
  "20591": p("DC", "Washington"),
  "20593": p("DC", "Washington"),
  "20594": p("DC", "Washington"),
  "20597": p("DC", "Washington"),
  "20599": p("DC", "Washington"),
  "56901": p("DC", "Washington"),
  "56915": p("DC", "Washington"),
  "56920": p("DC", "Washington"),
  "56933": p("DC", "Washington"),
  "56944": p("DC", "Washington"),
  "56972": p("DC", "Washington"),
  "19901": p("DE", "Dover"),
  "19902": p("DE", "Dover Afb"),
  "19903": p("DE", "Dover"),
  "19904": p("DE", "Dover"),
  "19905": p("DE", "Dover"),
  "19906": p("DE", "Dover"),
  "19934": p("DE", "Camden Wyoming"),
  "19936": p("DE", "Cheswold"),
  "19938": p("DE", "Clayton"),
  "19943": p("DE", "Felton"),
  "19946": p("DE", "Frederica"),
  "19952": p("DE", "Harrington"),
  "19953": p("DE", "Hartly"),
  "19954": p("DE", "Houston"),
  "19955": p("DE", "Kenton"),
  "19961": p("DE", "Little Creek"),
  "19962": p("DE", "Magnolia"),
  "19964": p("DE", "Marydel"),
  "19977": p("DE", "Smyrna"),
  "19979": p("DE", "Viola"),
  "19980": p("DE", "Woodside"),
  "19701": p("DE", "Bear"),
  "19702": p("DE", "Newark"),
  "19703": p("DE", "Claymont"),
  "19706": p("DE", "Delaware City"),
  "19707": p("DE", "Hockessin"),
  "19708": p("DE", "Kirkwood"),
  "19709": p("DE", "Middletown"),
  "19710": p("DE", "Montchanin"),
  "19711": p("DE", "Newark"),
  "19712": p("DE", "Newark"),
  "19713": p("DE", "Newark"),
  "19714": p("DE", "Newark"),
  "19715": p("DE", "Newark"),
  "19716": p("DE", "Newark"),
  "19717": p("DE", "Newark"),
  "19718": p("DE", "Newark"),
  "19720": p("DE", "New Castle"),
  "19721": p("DE", "New Castle"),
  "19725": p("DE", "Newark"),
  "19726": p("DE", "New Castle"),
  "19730": p("DE", "Odessa"),
  "19731": p("DE", "Port Penn"),
  "19732": p("DE", "Rockland"),
  "19733": p("DE", "Saint Georges"),
  "19734": p("DE", "Townsend"),
  "19735": p("DE", "Winterthur"),
  "19736": p("DE", "Yorklyn"),
  "19801": p("DE", "Wilmington"),
  "19802": p("DE", "Wilmington"),
  "19803": p("DE", "Wilmington"),
  "19804": p("DE", "Wilmington"),
  "19805": p("DE", "Wilmington"),
  "19806": p("DE", "Wilmington"),
  "19807": p("DE", "Wilmington"),
  "19808": p("DE", "Wilmington"),
  "19809": p("DE", "Wilmington"),
  "19810": p("DE", "Wilmington"),
  "19850": p("DE", "Wilmington"),
  "19880": p("DE", "Wilmington"),
  "19884": p("DE", "Wilmington"),
  "19885": p("DE", "Wilmington"),
  "19886": p("DE", "Wilmington"),
  "19890": p("DE", "Wilmington"),
  "19891": p("DE", "Wilmington"),
  "19892": p("DE", "Wilmington"),
  "19893": p("DE", "Wilmington"),
  "19894": p("DE", "Wilmington"),
  "19895": p("DE", "Wilmington"),
  "19896": p("DE", "Wilmington"),
  "19897": p("DE", "Wilmington"),
  "19898": p("DE", "Wilmington"),
  "19899": p("DE", "Wilmington"),
  "19930": p("DE", "Bethany Beach"),
  "19931": p("DE", "Bethel"),
  "19933": p("DE", "Bridgeville"),
  "19939": p("DE", "Dagsboro"),
  "19940": p("DE", "Delmar"),
  "19941": p("DE", "Ellendale"),
  "19944": p("DE", "Fenwick Island"),
  "19945": p("DE", "Frankford"),
  "19947": p("DE", "Georgetown"),
  "19950": p("DE", "Greenwood"),
  "19951": p("DE", "Harbeson"),
  "19956": p("DE", "Laurel"),
  "19958": p("DE", "Lewes"),
  "19960": p("DE", "Lincoln"),
  "19963": p("DE", "Milford"),
  "19966": p("DE", "Millsboro"),
  "19967": p("DE", "Millville"),
  "19968": p("DE", "Milton"),
  "19969": p("DE", "Nassau"),
  "19970": p("DE", "Ocean View"),
  "19971": p("DE", "Rehoboth Beach"),
  "19973": p("DE", "Seaford"),
  "19975": p("DE", "Selbyville"),
  "32601": p("FL", "Gainesville"),
  "32602": p("FL", "Gainesville"),
  "32603": p("FL", "Gainesville"),
  "32604": p("FL", "Gainesville"),
  "32605": p("FL", "Gainesville"),
  "32606": p("FL", "Gainesville"),
  "32607": p("FL", "Gainesville"),
  "32608": p("FL", "Gainesville"),
  "32609": p("FL", "Gainesville"),
  "32610": p("FL", "Gainesville"),
  "32611": p("FL", "Gainesville"),
  "32612": p("FL", "Gainesville"),
  "32614": p("FL", "Gainesville"),
  "32615": p("FL", "Alachua"),
  "32616": p("FL", "Alachua"),
  "32618": p("FL", "Archer"),
  "32627": p("FL", "Gainesville"),
  "32631": p("FL", "Earleton"),
  "32633": p("FL", "Evinston"),
  "32635": p("FL", "Gainesville"),
  "32640": p("FL", "Hawthorne"),
  "32641": p("FL", "Gainesville"),
  "32643": p("FL", "High Springs"),
  "32653": p("FL", "Gainesville"),
  "32654": p("FL", "Island Grove"),
  "32655": p("FL", "High Springs"),
  "32658": p("FL", "La Crosse"),
  "32662": p("FL", "Lochloosa"),
  "32667": p("FL", "Micanopy"),
  "32669": p("FL", "Newberry"),
  "32694": p("FL", "Waldo"),
  "32040": p("FL", "Glen Saint Mary"),
  "32063": p("FL", "Macclenny"),
  "32072": p("FL", "Olustee"),
  "32087": p("FL", "Sanderson"),
  "32401": p("FL", "Panama City"),
  "32402": p("FL", "Panama City"),
  "32403": p("FL", "Panama City"),
  "32404": p("FL", "Panama City"),
  "32405": p("FL", "Panama City"),
  "32406": p("FL", "Panama City"),
  "32407": p("FL", "Panama City Beach"),
  "32408": p("FL", "Panama City"),
  "32409": p("FL", "Panama City"),
  "32410": p("FL", "Mexico Beach"),
  "32411": p("FL", "Panama City"),
  "32412": p("FL", "Panama City"),
  "32413": p("FL", "Panama City Beach"),
  "32417": p("FL", "Panama City"),
  "32438": p("FL", "Fountain"),
  "32444": p("FL", "Lynn Haven"),
  "32466": p("FL", "Youngstown"),
  "32042": p("FL", "Graham"),
  "32044": p("FL", "Hampton"),
  "32058": p("FL", "Lawtey"),
  "32091": p("FL", "Starke"),
  "32622": p("FL", "Brooker"),
  "32754": p("FL", "Mims"),
  "32775": p("FL", "Scottsmoor"),
  "32780": p("FL", "Titusville"),
  "32781": p("FL", "Titusville"),
  "32783": p("FL", "Titusville"),
  "32796": p("FL", "Titusville"),
  "32815": p("FL", "Orlando"),
  "32899": p("FL", "Orlando"),
  "32901": p("FL", "Melbourne"),
  "32902": p("FL", "Melbourne"),
  "32903": p("FL", "Indialantic"),
  "32904": p("FL", "Melbourne"),
  "32905": p("FL", "Palm Bay"),
  "32906": p("FL", "Palm Bay"),
  "32907": p("FL", "Palm Bay"),
  "32908": p("FL", "Palm Bay"),
  "32909": p("FL", "Palm Bay"),
  "32910": p("FL", "Palm Bay"),
  "32911": p("FL", "Palm Bay"),
  "32912": p("FL", "Melbourne"),
  "32919": p("FL", "Melbourne"),
  "32920": p("FL", "Cape Canaveral"),
  "32922": p("FL", "Cocoa"),
  "32923": p("FL", "Cocoa"),
  "32924": p("FL", "Cocoa"),
  "32925": p("FL", "Patrick Afb"),
  "32926": p("FL", "Cocoa"),
  "32927": p("FL", "Cocoa"),
  "32931": p("FL", "Cocoa Beach"),
  "32932": p("FL", "Cocoa Beach"),
  "32934": p("FL", "Melbourne"),
  "32935": p("FL", "Melbourne"),
  "32936": p("FL", "Melbourne"),
  "32937": p("FL", "Satellite Beach"),
  "32940": p("FL", "Melbourne"),
  "32941": p("FL", "Melbourne"),
  "32949": p("FL", "Grant"),
  "32950": p("FL", "Malabar"),
  "32951": p("FL", "Melbourne Beach"),
  "32952": p("FL", "Merritt Island"),
  "32953": p("FL", "Merritt Island"),
  "32954": p("FL", "Merritt Island"),
  "32955": p("FL", "Rockledge"),
  "32956": p("FL", "Rockledge"),
  "32959": p("FL", "Sharpes"),
  "32976": p("FL", "Sebastian"),
  "33004": p("FL", "Dania"),
  "33008": p("FL", "Hallandale"),
  "33009": p("FL", "Hallandale"),
  "33019": p("FL", "Hollywood"),
  "33020": p("FL", "Hollywood"),
  "33021": p("FL", "Hollywood"),
  "33022": p("FL", "Hollywood"),
  "33023": p("FL", "Hollywood"),
  "33024": p("FL", "Hollywood"),
  "33025": p("FL", "Hollywood"),
  "33026": p("FL", "Hollywood"),
  "33027": p("FL", "Hollywood"),
  "33028": p("FL", "Pembroke Pines"),
  "33029": p("FL", "Hollywood"),
  "33060": p("FL", "Pompano Beach"),
  "33061": p("FL", "Pompano Beach"),
  "33062": p("FL", "Pompano Beach"),
  "33063": p("FL", "Pompano Beach"),
  "33064": p("FL", "Pompano Beach"),
  "33065": p("FL", "Pompano Beach"),
  "33066": p("FL", "Pompano Beach"),
  "33067": p("FL", "Pompano Beach"),
  "33068": p("FL", "Pompano Beach"),
  "33069": p("FL", "Pompano Beach"),
  "33071": p("FL", "Pompano Beach"),
  "33072": p("FL", "Pompano Beach"),
  "33073": p("FL", "Pompano Beach"),
  "33074": p("FL", "Pompano Beach"),
  "33075": p("FL", "Coral Springs"),
  "33076": p("FL", "Pompano Beach"),
  "33077": p("FL", "Pompano Beach"),
  "33081": p("FL", "Hollywood"),
  "33082": p("FL", "Pembroke Pines"),
  "33083": p("FL", "Hollywood"),
  "33084": p("FL", "Hollywood"),
  "33093": p("FL", "Margate"),
  "33097": p("FL", "Coconut Creek"),
  "33301": p("FL", "Fort Lauderdale"),
  "33302": p("FL", "Fort Lauderdale"),
  "33303": p("FL", "Fort Lauderdale"),
  "33304": p("FL", "Fort Lauderdale"),
  "33305": p("FL", "Fort Lauderdale"),
  "33306": p("FL", "Fort Lauderdale"),
  "33307": p("FL", "Fort Lauderdale"),
  "33308": p("FL", "Fort Lauderdale"),
  "33309": p("FL", "Fort Lauderdale"),
  "33310": p("FL", "Fort Lauderdale"),
  "33311": p("FL", "Fort Lauderdale"),
  "33312": p("FL", "Fort Lauderdale"),
  "33313": p("FL", "Fort Lauderdale"),
  "33314": p("FL", "Fort Lauderdale"),
  "33315": p("FL", "Fort Lauderdale"),
  "33316": p("FL", "Fort Lauderdale"),
  "33317": p("FL", "Fort Lauderdale"),
  "33318": p("FL", "Fort Lauderdale"),
  "33319": p("FL", "Fort Lauderdale"),
  "33320": p("FL", "Fort Lauderdale"),
  "33321": p("FL", "Fort Lauderdale"),
  "33322": p("FL", "Fort Lauderdale"),
  "33323": p("FL", "Fort Lauderdale"),
  "33324": p("FL", "Fort Lauderdale"),
  "33325": p("FL", "Fort Lauderdale"),
  "33326": p("FL", "Fort Lauderdale"),
  "33327": p("FL", "Fort Lauderdale"),
  "33328": p("FL", "Fort Lauderdale"),
  "33329": p("FL", "Fort Lauderdale"),
  "33330": p("FL", "Fort Lauderdale"),
  "33331": p("FL", "Fort Lauderdale"),
  "33332": p("FL", "Fort Lauderdale"),
  "33334": p("FL", "Fort Lauderdale"),
  "33335": p("FL", "Fort Lauderdale"),
  "33336": p("FL", "Fort Lauderdale"),
  "33337": p("FL", "Fort Lauderdale"),
  "33338": p("FL", "Fort Lauderdale"),
  "33339": p("FL", "Fort Lauderdale"),
  "33340": p("FL", "Fort Lauderdale"),
  "33345": p("FL", "Fort Lauderdale"),
  "33346": p("FL", "Fort Lauderdale"),
  "33348": p("FL", "Fort Lauderdale"),
  "33349": p("FL", "Fort Lauderdale"),
  "33351": p("FL", "Fort Lauderdale"),
  "33355": p("FL", "Fort Lauderdale"),
  "33359": p("FL", "Fort Lauderdale"),
  "33388": p("FL", "Plantation"),
  "33394": p("FL", "Fort Lauderdale"),
  "33441": p("FL", "Deerfield Beach"),
  "33442": p("FL", "Deerfield Beach"),
  "33443": p("FL", "Deerfield Beach"),
  "33973": p("FL", "Lehigh Acres"),
  "32421": p("FL", "Altha"),
  "32424": p("FL", "Blountstown"),
  "32430": p("FL", "Clarksville"),
  "32449": p("FL", "Wewahitchka"),
  "33927": p("FL", "El Jobean"),
  "33938": p("FL", "Murdock"),
  "33946": p("FL", "Placida"),
  "33947": p("FL", "Rotonda West"),
  "33948": p("FL", "Port Charlotte"),
  "33949": p("FL", "Port Charlotte"),
  "33950": p("FL", "Punta Gorda"),
  "33951": p("FL", "Punta Gorda"),
  "33952": p("FL", "Port Charlotte"),
  "33953": p("FL", "Port Charlotte"),
  "33954": p("FL", "Port Charlotte"),
  "33955": p("FL", "Punta Gorda"),
  "33980": p("FL", "Punta Gorda"),
  "33981": p("FL", "Port Charlotte"),
  "33982": p("FL", "Punta Gorda"),
  "33983": p("FL", "Punta Gorda"),
  "34423": p("FL", "Crystal River"),
  "34428": p("FL", "Crystal River"),
  "34429": p("FL", "Crystal River"),
  "34433": p("FL", "Dunnellon"),
  "34434": p("FL", "Dunnellon"),
  "34436": p("FL", "Floral City"),
  "34441": p("FL", "Hernando"),
  "34442": p("FL", "Hernando"),
  "34445": p("FL", "Holder"),
  "34446": p("FL", "Homosassa"),
  "34447": p("FL", "Homosassa Springs"),
  "34448": p("FL", "Homosassa"),
  "34450": p("FL", "Inverness"),
  "34451": p("FL", "Inverness"),
  "34452": p("FL", "Inverness"),
  "34453": p("FL", "Inverness"),
  "34460": p("FL", "Lecanto"),
  "34461": p("FL", "Lecanto"),
  "34464": p("FL", "Beverly Hills"),
  "34465": p("FL", "Beverly Hills"),
  "34487": p("FL", "Homosassa"),
  "32003": p("FL", "Fleming Island"),
  "32006": p("FL", "Fleming Island"),
  "32030": p("FL", "Doctors Inlet"),
  "32043": p("FL", "Green Cove Springs"),
  "32050": p("FL", "Middleburg"),
  "32065": p("FL", "Orange Park"),
  "32067": p("FL", "Orange Park"),
  "32068": p("FL", "Middleburg"),
  "32073": p("FL", "Orange Park"),
  "32079": p("FL", "Penney Farms"),
  "32160": p("FL", "Lake Geneva"),
  "32656": p("FL", "Keystone Heights"),
  "34101": p("FL", "Naples"),
  "34102": p("FL", "Naples"),
  "34103": p("FL", "Naples"),
  "34104": p("FL", "Naples"),
  "34105": p("FL", "Naples"),
  "34106": p("FL", "Naples"),
  "34107": p("FL", "Naples"),
  "34108": p("FL", "Naples"),
  "34109": p("FL", "Naples"),
  "34110": p("FL", "Naples"),
  "34112": p("FL", "Naples"),
  "34113": p("FL", "Naples"),
  "34114": p("FL", "Naples"),
  "34116": p("FL", "Naples"),
  "34117": p("FL", "Naples"),
  "34119": p("FL", "Naples"),
  "34120": p("FL", "Naples"),
  "34137": p("FL", "Copeland"),
  "34138": p("FL", "Chokoloskee"),
  "34139": p("FL", "Everglades City"),
  "34140": p("FL", "Goodland"),
  "34141": p("FL", "Ochopee"),
  "34142": p("FL", "Immokalee"),
  "34143": p("FL", "Immokalee"),
  "34145": p("FL", "Marco Island"),
  "34146": p("FL", "Marco Island"),
  "32024": p("FL", "Lake City"),
  "32025": p("FL", "Lake City"),
  "32038": p("FL", "Fort White"),
  "32055": p("FL", "Lake City"),
  "32056": p("FL", "Lake City"),
  "32061": p("FL", "Lulu"),
  "34265": p("FL", "Arcadia"),
  "34266": p("FL", "Arcadia"),
  "34267": p("FL", "Fort Ogden"),
  "34268": p("FL", "Nocatee"),
  "34269": p("FL", "Arcadia"),
  "32628": p("FL", "Cross City"),
  "32648": p("FL", "Horseshoe Beach"),
  "32680": p("FL", "Old Town"),
  "32692": p("FL", "Suwannee"),
  "32099": p("FL", "Jacksonville"),
  "32201": p("FL", "Jacksonville"),
  "32202": p("FL", "Jacksonville"),
  "32203": p("FL", "Jacksonville"),
  "32204": p("FL", "Jacksonville"),
  "32205": p("FL", "Jacksonville"),
  "32206": p("FL", "Jacksonville"),
  "32207": p("FL", "Jacksonville"),
  "32208": p("FL", "Jacksonville"),
  "32209": p("FL", "Jacksonville"),
  "32210": p("FL", "Jacksonville"),
  "32211": p("FL", "Jacksonville"),
  "32212": p("FL", "Jacksonville"),
  "32214": p("FL", "Jacksonville"),
  "32216": p("FL", "Jacksonville"),
  "32217": p("FL", "Jacksonville"),
  "32218": p("FL", "Jacksonville"),
  "32219": p("FL", "Jacksonville"),
  "32220": p("FL", "Jacksonville"),
  "32221": p("FL", "Jacksonville"),
  "32222": p("FL", "Jacksonville"),
  "32223": p("FL", "Jacksonville"),
  "32224": p("FL", "Jacksonville"),
  "32225": p("FL", "Jacksonville"),
  "32226": p("FL", "Jacksonville"),
  "32227": p("FL", "Jacksonville"),
  "32228": p("FL", "Jacksonville"),
  "32229": p("FL", "Jacksonville"),
  "32231": p("FL", "Jacksonville"),
  "32232": p("FL", "Jacksonville"),
  "32233": p("FL", "Atlantic Beach"),
  "32234": p("FL", "Jacksonville"),
  "32235": p("FL", "Jacksonville"),
  "32236": p("FL", "Jacksonville"),
  "32237": p("FL", "Jacksonville"),
  "32238": p("FL", "Jacksonville"),
  "32239": p("FL", "Jacksonville"),
  "32240": p("FL", "Jacksonville Beach"),
  "32241": p("FL", "Jacksonville"),
  "32244": p("FL", "Jacksonville"),
  "32245": p("FL", "Jacksonville"),
  "32246": p("FL", "Jacksonville"),
  "32247": p("FL", "Jacksonville"),
  "32250": p("FL", "Jacksonville Beach"),
  "32254": p("FL", "Jacksonville"),
  "32255": p("FL", "Jacksonville"),
  "32256": p("FL", "Jacksonville"),
  "32257": p("FL", "Jacksonville"),
  "32258": p("FL", "Jacksonville"),
  "32266": p("FL", "Neptune Beach"),
  "32277": p("FL", "Jacksonville"),
  "32501": p("FL", "Pensacola"),
  "32502": p("FL", "Pensacola"),
  "32503": p("FL", "Pensacola"),
  "32504": p("FL", "Pensacola"),
  "32505": p("FL", "Pensacola"),
  "32506": p("FL", "Pensacola"),
  "32507": p("FL", "Pensacola"),
  "32508": p("FL", "Pensacola"),
  "32509": p("FL", "Pensacola"),
  "32511": p("FL", "Pensacola"),
  "32512": p("FL", "Pensacola"),
  "32513": p("FL", "Pensacola"),
  "32514": p("FL", "Pensacola"),
  "32516": p("FL", "Pensacola"),
  "32520": p("FL", "Pensacola"),
  "32521": p("FL", "Pensacola"),
  "32522": p("FL", "Pensacola"),
  "32523": p("FL", "Pensacola"),
  "32524": p("FL", "Pensacola"),
  "32526": p("FL", "Pensacola"),
  "32533": p("FL", "Cantonment"),
  "32534": p("FL", "Pensacola"),
  "32535": p("FL", "Century"),
  "32559": p("FL", "Pensacola"),
  "32560": p("FL", "Gonzalez"),
  "32568": p("FL", "Mc David"),
  "32577": p("FL", "Molino"),
  "32591": p("FL", "Pensacola"),
  "32110": p("FL", "Bunnell"),
  "32135": p("FL", "Palm Coast"),
  "32136": p("FL", "Flagler Beach"),
  "32137": p("FL", "Palm Coast"),
  "32142": p("FL", "Palm Coast"),
  "32143": p("FL", "Palm Coast"),
  "32164": p("FL", "Palm Coast"),
  "32318": p("FL", "Tallahassee"),
  "32320": p("FL", "Apalachicola"),
  "32322": p("FL", "Carrabelle"),
  "32323": p("FL", "Lanark Village"),
  "32328": p("FL", "Eastpoint"),
  "32329": p("FL", "Apalachicola"),
  "32324": p("FL", "Chattahoochee"),
  "32330": p("FL", "Greensboro"),
  "32332": p("FL", "Gretna"),
  "32333": p("FL", "Havana"),
  "32343": p("FL", "Midway"),
  "32351": p("FL", "Quincy"),
  "32352": p("FL", "Quincy"),
  "32353": p("FL", "Quincy"),
  "32619": p("FL", "Bell"),
  "32693": p("FL", "Trenton"),
  "33471": p("FL", "Moore Haven"),
  "33944": p("FL", "Palmdale"),
  "32456": p("FL", "Port Saint Joe"),
  "32457": p("FL", "Port Saint Joe"),
  "32465": p("FL", "Wewahitchka"),
  "32052": p("FL", "Jasper"),
  "32053": p("FL", "Jennings"),
  "32096": p("FL", "White Springs"),
  "33834": p("FL", "Bowling Green"),
  "33865": p("FL", "Ona"),
  "33873": p("FL", "Wauchula"),
  "33890": p("FL", "Zolfo Springs"),
  "33440": p("FL", "Clewiston"),
  "33930": p("FL", "Felda"),
  "33935": p("FL", "Labelle"),
  "33975": p("FL", "Labelle"),
  "34601": p("FL", "Brooksville"),
  "34602": p("FL", "Brooksville"),
  "34603": p("FL", "Brooksville"),
  "34604": p("FL", "Brooksville"),
  "34605": p("FL", "Brooksville"),
  "34606": p("FL", "Spring Hill"),
  "34607": p("FL", "Spring Hill"),
  "34608": p("FL", "Spring Hill"),
  "34609": p("FL", "Spring Hill"),
  "34611": p("FL", "Spring Hill"),
  "34613": p("FL", "Brooksville"),
  "34614": p("FL", "Brooksville"),
  "34636": p("FL", "Istachatta"),
  "34661": p("FL", "Nobleton"),
  "33825": p("FL", "Avon Park"),
  "33826": p("FL", "Avon Park"),
  "33852": p("FL", "Lake Placid"),
  "33857": p("FL", "Lorida"),
  "33862": p("FL", "Lake Placid"),
  "33870": p("FL", "Sebring"),
  "33871": p("FL", "Sebring"),
  "33872": p("FL", "Sebring"),
  "33875": p("FL", "Sebring"),
  "33876": p("FL", "Sebring"),
  "33960": p("FL", "Venus"),
  "33503": p("FL", "Balm"),
  "33508": p("FL", "Brandon"),
  "33509": p("FL", "Brandon"),
  "33510": p("FL", "Brandon"),
  "33511": p("FL", "Brandon"),
  "33527": p("FL", "Dover"),
  "33530": p("FL", "Durant"),
  "33534": p("FL", "Gibsonton"),
  "33547": p("FL", "Lithia"),
  "33548": p("FL", "Lutz"),
  "33549": p("FL", "Lutz"),
  "33550": p("FL", "Mango"),
  "33556": p("FL", "Odessa"),
  "33558": p("FL", "Lutz"),
  "33563": p("FL", "Plant City"),
  "33564": p("FL", "Plant City"),
  "33565": p("FL", "Plant City"),
  "33566": p("FL", "Plant City"),
  "33567": p("FL", "Plant City"),
  "33568": p("FL", "Riverview"),
  "33569": p("FL", "Riverview"),
  "33570": p("FL", "Ruskin"),
  "33571": p("FL", "Sun City Center"),
  "33572": p("FL", "Apollo Beach"),
  "33573": p("FL", "Sun City Center"),
  "33575": p("FL", "Ruskin"),
  "33579": p("FL", "Riverview"),
  "33583": p("FL", "Seffner"),
  "33584": p("FL", "Seffner"),
  "33586": p("FL", "Sun City"),
  "33587": p("FL", "Sydney"),
  "33592": p("FL", "Thonotosassa"),
  "33594": p("FL", "Valrico"),
  "33595": p("FL", "Valrico"),
  "33596": p("FL", "Valrico"),
  "33598": p("FL", "Wimauma"),
  "33601": p("FL", "Tampa"),
  "33602": p("FL", "Tampa"),
  "33603": p("FL", "Tampa"),
  "33604": p("FL", "Tampa"),
  "33605": p("FL", "Tampa"),
  "33606": p("FL", "Tampa"),
  "33607": p("FL", "Tampa"),
  "33608": p("FL", "Tampa"),
  "33609": p("FL", "Tampa"),
  "33610": p("FL", "Tampa"),
  "33611": p("FL", "Tampa"),
  "33612": p("FL", "Tampa"),
  "33613": p("FL", "Tampa"),
  "33614": p("FL", "Tampa"),
  "33615": p("FL", "Tampa"),
  "33616": p("FL", "Tampa"),
  "33617": p("FL", "Tampa"),
  "33618": p("FL", "Tampa"),
  "33619": p("FL", "Tampa"),
  "33620": p("FL", "Tampa"),
  "33621": p("FL", "Tampa"),
  "33622": p("FL", "Tampa"),
  "33623": p("FL", "Tampa"),
  "33624": p("FL", "Tampa"),
  "33625": p("FL", "Tampa"),
  "33626": p("FL", "Tampa"),
  "33629": p("FL", "Tampa"),
  "33630": p("FL", "Tampa"),
  "33631": p("FL", "Tampa"),
  "33633": p("FL", "Tampa"),
  "33634": p("FL", "Tampa"),
  "33635": p("FL", "Tampa"),
  "33637": p("FL", "Tampa"),
  "33646": p("FL", "Tampa"),
  "33647": p("FL", "Tampa"),
  "33650": p("FL", "Tampa"),
  "33655": p("FL", "Tampa"),
  "33660": p("FL", "Tampa"),
  "33661": p("FL", "Tampa"),
  "33662": p("FL", "Tampa"),
  "33663": p("FL", "Tampa"),
  "33664": p("FL", "Tampa"),
  "33672": p("FL", "Tampa"),
  "33673": p("FL", "Tampa"),
  "33674": p("FL", "Tampa"),
  "33675": p("FL", "Tampa"),
  "33677": p("FL", "Tampa"),
  "33679": p("FL", "Tampa"),
  "33680": p("FL", "Tampa"),
  "33681": p("FL", "Tampa"),
  "33682": p("FL", "Tampa"),
  "33684": p("FL", "Tampa"),
  "33685": p("FL", "Tampa"),
  "33686": p("FL", "Tampa"),
  "33687": p("FL", "Tampa"),
  "33688": p("FL", "Tampa"),
  "33689": p("FL", "Tampa"),
  "33694": p("FL", "Tampa"),
  "32425": p("FL", "Bonifay"),
  "32452": p("FL", "Noma"),
  "32455": p("FL", "Ponce De Leon"),
  "32464": p("FL", "Westville"),
  "32948": p("FL", "Fellsmere"),
  "32957": p("FL", "Roseland"),
  "32958": p("FL", "Sebastian"),
  "32960": p("FL", "Vero Beach"),
  "32961": p("FL", "Vero Beach"),
  "32962": p("FL", "Vero Beach"),
  "32963": p("FL", "Vero Beach"),
  "32964": p("FL", "Vero Beach"),
  "32965": p("FL", "Vero Beach"),
  "32966": p("FL", "Vero Beach"),
  "32967": p("FL", "Vero Beach"),
  "32968": p("FL", "Vero Beach"),
  "32969": p("FL", "Vero Beach"),
  "32970": p("FL", "Wabasso"),
  "32971": p("FL", "Winter Beach"),
  "32978": p("FL", "Sebastian"),
  "32420": p("FL", "Alford"),
  "32423": p("FL", "Bascom"),
  "32426": p("FL", "Campbellton"),
  "32431": p("FL", "Cottondale"),
  "32432": p("FL", "Cypress"),
  "32440": p("FL", "Graceville"),
  "32442": p("FL", "Grand Ridge"),
  "32443": p("FL", "Greenwood"),
  "32445": p("FL", "Malone"),
  "32446": p("FL", "Marianna"),
  "32447": p("FL", "Marianna"),
  "32448": p("FL", "Marianna"),
  "32460": p("FL", "Sneads"),
  "32336": p("FL", "Lamont"),
  "32337": p("FL", "Lloyd"),
  "32344": p("FL", "Monticello"),
  "32345": p("FL", "Monticello"),
  "32361": p("FL", "Wacissa"),
  "32753": p("FL", "Debary"),
  "32013": p("FL", "Day"),
  "32066": p("FL", "Mayo"),
  "32102": p("FL", "Astor"),
  "32158": p("FL", "Lady Lake"),
  "32159": p("FL", "Lady Lake"),
  "32702": p("FL", "Altoona"),
  "32726": p("FL", "Eustis"),
  "32727": p("FL", "Eustis"),
  "32735": p("FL", "Grand Island"),
  "32736": p("FL", "Eustis"),
  "32756": p("FL", "Mount Dora"),
  "32757": p("FL", "Mount Dora"),
  "32767": p("FL", "Paisley"),
  "32776": p("FL", "Sorrento"),
  "32778": p("FL", "Tavares"),
  "32784": p("FL", "Umatilla"),
  "34705": p("FL", "Astatula"),
  "34711": p("FL", "Clermont"),
  "34712": p("FL", "Clermont"),
  "34713": p("FL", "Clermont"),
  "34715": p("FL", "Clermont"),
  "34729": p("FL", "Ferndale"),
  "34731": p("FL", "Fruitland Park"),
  "34736": p("FL", "Groveland"),
  "34737": p("FL", "Howey In The Hills"),
  "34748": p("FL", "Leesburg"),
  "34749": p("FL", "Leesburg"),
  "34753": p("FL", "Mascotte"),
  "34755": p("FL", "Minneola"),
  "34756": p("FL", "Montverde"),
  "34762": p("FL", "Okahumpka"),
  "34788": p("FL", "Leesburg"),
  "34789": p("FL", "Leesburg"),
  "34797": p("FL", "Yalaha"),
  "33901": p("FL", "Fort Myers"),
  "33902": p("FL", "Fort Myers"),
  "33903": p("FL", "North Fort Myers"),
  "33904": p("FL", "Cape Coral"),
  "33905": p("FL", "Fort Myers"),
  "33906": p("FL", "Fort Myers"),
  "33907": p("FL", "Fort Myers"),
  "33908": p("FL", "Fort Myers"),
  "33909": p("FL", "Cape Coral"),
  "33910": p("FL", "Cape Coral"),
  "33911": p("FL", "Fort Myers"),
  "33912": p("FL", "Fort Myers"),
  "33913": p("FL", "Fort Myers"),
  "33914": p("FL", "Cape Coral"),
  "33915": p("FL", "Cape Coral"),
  "33916": p("FL", "Fort Myers"),
  "33917": p("FL", "North Fort Myers"),
  "33918": p("FL", "North Fort Myers"),
  "33919": p("FL", "Fort Myers"),
  "33920": p("FL", "Alva"),
  "33921": p("FL", "Boca Grande"),
  "33922": p("FL", "Bokeelia"),
  "33924": p("FL", "Captiva"),
  "33928": p("FL", "Estero"),
  "33929": p("FL", "Estero"),
  "33931": p("FL", "Fort Myers Beach"),
  "33932": p("FL", "Fort Myers Beach"),
  "33936": p("FL", "Lehigh Acres"),
  "33945": p("FL", "Pineland"),
  "33956": p("FL", "Saint James City"),
  "33957": p("FL", "Sanibel"),
  "33965": p("FL", "Fort Myers"),
  "33966": p("FL", "Fort Myers"),
  "33970": p("FL", "Lehigh Acres"),
  "33971": p("FL", "Lehigh Acres"),
  "33972": p("FL", "Lehigh Acres"),
  "33974": p("FL", "Lehigh Acres"),
  "33976": p("FL", "Lehigh Acres"),
  "33990": p("FL", "Cape Coral"),
  "33991": p("FL", "Cape Coral"),
  "33993": p("FL", "Cape Coral"),
  "33994": p("FL", "Fort Myers"),
  "34133": p("FL", "Bonita Springs"),
  "34134": p("FL", "Bonita Springs"),
  "34135": p("FL", "Bonita Springs"),
  "34136": p("FL", "Bonita Springs"),
  "32301": p("FL", "Tallahassee"),
  "32302": p("FL", "Tallahassee"),
  "32303": p("FL", "Tallahassee"),
  "32304": p("FL", "Tallahassee"),
  "32305": p("FL", "Tallahassee"),
  "32306": p("FL", "Tallahassee"),
  "32307": p("FL", "Tallahassee"),
  "32308": p("FL", "Tallahassee"),
  "32309": p("FL", "Tallahassee"),
  "32310": p("FL", "Tallahassee"),
  "32311": p("FL", "Tallahassee"),
  "32312": p("FL", "Tallahassee"),
  "32313": p("FL", "Tallahassee"),
  "32314": p("FL", "Tallahassee"),
  "32315": p("FL", "Tallahassee"),
  "32316": p("FL", "Tallahassee"),
  "32317": p("FL", "Tallahassee"),
  "32362": p("FL", "Woodville"),
  "32395": p("FL", "Tallahassee"),
  "32399": p("FL", "Tallahassee"),
  "32621": p("FL", "Bronson"),
  "32625": p("FL", "Cedar Key"),
  "32626": p("FL", "Chiefland"),
  "32639": p("FL", "Gulf Hammock"),
  "32644": p("FL", "Chiefland"),
  "32668": p("FL", "Morriston"),
  "32683": p("FL", "Otter Creek"),
  "32696": p("FL", "Williston"),
  "34449": p("FL", "Inglis"),
  "34498": p("FL", "Yankeetown"),
  "32321": p("FL", "Bristol"),
  "32334": p("FL", "Hosford"),
  "32335": p("FL", "Sumatra"),
  "32360": p("FL", "Telogia"),
  "32059": p("FL", "Lee"),
  "32331": p("FL", "Greenville"),
  "32340": p("FL", "Madison"),
  "32341": p("FL", "Madison"),
  "32350": p("FL", "Pinetta"),
  "34201": p("FL", "Bradenton"),
  "34202": p("FL", "Bradenton"),
  "34203": p("FL", "Bradenton"),
  "34204": p("FL", "Bradenton"),
  "34205": p("FL", "Bradenton"),
  "34206": p("FL", "Bradenton"),
  "34207": p("FL", "Bradenton"),
  "34208": p("FL", "Bradenton"),
  "34209": p("FL", "Bradenton"),
  "34210": p("FL", "Bradenton"),
  "34211": p("FL", "Bradenton"),
  "34212": p("FL", "Bradenton"),
  "34215": p("FL", "Cortez"),
  "34216": p("FL", "Anna Maria"),
  "34217": p("FL", "Bradenton Beach"),
  "34218": p("FL", "Holmes Beach"),
  "34219": p("FL", "Parrish"),
  "34220": p("FL", "Palmetto"),
  "34221": p("FL", "Palmetto"),
  "34222": p("FL", "Ellenton"),
  "34228": p("FL", "Longboat Key"),
  "34243": p("FL", "Sarasota"),
  "34250": p("FL", "Terra Ceia"),
  "34251": p("FL", "Myakka City"),
  "34260": p("FL", "Manasota"),
  "34264": p("FL", "Oneco"),
  "34270": p("FL", "Tallevast"),
  "34280": p("FL", "Bradenton"),
  "34281": p("FL", "Bradenton"),
  "34282": p("FL", "Bradenton"),
  "32111": p("FL", "Candler"),
  "32113": p("FL", "Citra"),
  "32133": p("FL", "Eastlake Weir"),
  "32134": p("FL", "Fort Mc Coy"),
  "32179": p("FL", "Ocklawaha"),
  "32182": p("FL", "Orange Springs"),
  "32183": p("FL", "Ocklawaha"),
  "32192": p("FL", "Sparr"),
  "32195": p("FL", "Weirsdale"),
  "32617": p("FL", "Anthony"),
  "32634": p("FL", "Fairfield"),
  "32663": p("FL", "Lowell"),
  "32664": p("FL", "Mc Intosh"),
  "32681": p("FL", "Orange Lake"),
  "32686": p("FL", "Reddick"),
  "34420": p("FL", "Belleview"),
  "34421": p("FL", "Belleview"),
  "34430": p("FL", "Dunnellon"),
  "34431": p("FL", "Dunnellon"),
  "34432": p("FL", "Dunnellon"),
  "34470": p("FL", "Ocala"),
  "34471": p("FL", "Ocala"),
  "34472": p("FL", "Ocala"),
  "34473": p("FL", "Ocala"),
  "34474": p("FL", "Ocala"),
  "34475": p("FL", "Ocala"),
  "34476": p("FL", "Ocala"),
  "34477": p("FL", "Ocala"),
  "34478": p("FL", "Ocala"),
  "34479": p("FL", "Ocala"),
  "34480": p("FL", "Ocala"),
  "34481": p("FL", "Ocala"),
  "34482": p("FL", "Ocala"),
  "34483": p("FL", "Ocala"),
  "34488": p("FL", "Silver Springs"),
  "34489": p("FL", "Silver Springs"),
  "34491": p("FL", "Summerfield"),
  "34492": p("FL", "Summerfield"),
  "33455": p("FL", "Hobe Sound"),
  "33475": p("FL", "Hobe Sound"),
  "34956": p("FL", "Indiantown"),
  "34957": p("FL", "Jensen Beach"),
  "34958": p("FL", "Jensen Beach"),
  "34990": p("FL", "Palm City"),
  "34991": p("FL", "Palm City"),
  "34992": p("FL", "Port Salerno"),
  "34994": p("FL", "Stuart"),
  "34995": p("FL", "Stuart"),
  "34996": p("FL", "Stuart"),
  "34997": p("FL", "Stuart"),
  "33002": p("FL", "Hialeah"),
  "33010": p("FL", "Hialeah"),
  "33011": p("FL", "Hialeah"),
  "33012": p("FL", "Hialeah"),
  "33013": p("FL", "Hialeah"),
  "33014": p("FL", "Hialeah"),
  "33015": p("FL", "Hialeah"),
  "33016": p("FL", "Hialeah"),
  "33017": p("FL", "Hialeah"),
  "33018": p("FL", "Hialeah"),
  "33030": p("FL", "Homestead"),
  "33031": p("FL", "Homestead"),
  "33032": p("FL", "Homestead"),
  "33033": p("FL", "Homestead"),
  "33034": p("FL", "Homestead"),
  "33035": p("FL", "Homestead"),
  "33039": p("FL", "Homestead"),
  "33054": p("FL", "Opa Locka"),
  "33055": p("FL", "Opa Locka"),
  "33056": p("FL", "Miami Gardens"),
  "33090": p("FL", "Homestead"),
  "33092": p("FL", "Homestead"),
  "33101": p("FL", "Miami"),
  "33102": p("FL", "Miami"),
  "33106": p("FL", "Miami"),
  "33109": p("FL", "Miami Beach"),
  "33111": p("FL", "Miami"),
  "33114": p("FL", "Coral Gables"),
  "33116": p("FL", "Miami"),
  "33119": p("FL", "Miami Beach"),
  "33122": p("FL", "Miami"),
  "33124": p("FL", "Miami"),
  "33125": p("FL", "Miami"),
  "33126": p("FL", "Miami"),
  "33127": p("FL", "Miami"),
  "33128": p("FL", "Miami"),
  "33129": p("FL", "Miami"),
  "33130": p("FL", "Miami"),
  "33131": p("FL", "Miami"),
  "33132": p("FL", "Miami"),
  "33133": p("FL", "Miami"),
  "33134": p("FL", "Miami"),
  "33135": p("FL", "Miami"),
  "33136": p("FL", "Miami"),
  "33137": p("FL", "Miami"),
  "33138": p("FL", "Miami"),
  "33139": p("FL", "Miami Beach"),
  "33140": p("FL", "Miami Beach"),
  "33141": p("FL", "Miami Beach"),
  "33142": p("FL", "Miami"),
  "33143": p("FL", "Miami"),
  "33144": p("FL", "Miami"),
  "33145": p("FL", "Miami"),
  "33146": p("FL", "Miami"),
  "33147": p("FL", "Miami"),
  "33149": p("FL", "Key Biscayne"),
  "33150": p("FL", "Miami"),
  "33151": p("FL", "Miami"),
  "33152": p("FL", "Miami"),
  "33153": p("FL", "Miami"),
  "33154": p("FL", "Miami Beach"),
  "33155": p("FL", "Miami"),
  "33156": p("FL", "Miami"),
  "33157": p("FL", "Miami"),
  "33158": p("FL", "Miami"),
  "33160": p("FL", "North Miami Beach"),
  "33161": p("FL", "Miami"),
  "33162": p("FL", "Miami"),
  "33163": p("FL", "Miami"),
  "33164": p("FL", "Miami"),
  "33165": p("FL", "Miami"),
  "33166": p("FL", "Miami"),
  "33167": p("FL", "Miami"),
  "33168": p("FL", "Miami"),
  "33169": p("FL", "Miami"),
  "33170": p("FL", "Miami"),
  "33172": p("FL", "Miami"),
  "33173": p("FL", "Miami"),
  "33174": p("FL", "Miami"),
  "33175": p("FL", "Miami"),
  "33176": p("FL", "Miami"),
  "33177": p("FL", "Miami"),
  "33178": p("FL", "Miami"),
  "33179": p("FL", "Miami"),
  "33180": p("FL", "Miami"),
  "33181": p("FL", "Miami"),
  "33182": p("FL", "Miami"),
  "33183": p("FL", "Miami"),
  "33184": p("FL", "Miami"),
  "33185": p("FL", "Miami"),
  "33186": p("FL", "Miami"),
  "33187": p("FL", "Miami"),
  "33188": p("FL", "Miami"),
  "33189": p("FL", "Miami"),
  "33190": p("FL", "Miami"),
  "33191": p("FL", "Miami"),
  "33192": p("FL", "Miami"),
  "33193": p("FL", "Miami"),
  "33194": p("FL", "Miami"),
  "33195": p("FL", "Miami"),
  "33196": p("FL", "Miami"),
  "33197": p("FL", "Miami"),
  "33198": p("FL", "Miami"),
  "33199": p("FL", "Miami"),
  "33206": p("FL", "Miami"),
  "33222": p("FL", "Miami"),
  "33231": p("FL", "Miami"),
  "33233": p("FL", "Miami"),
  "33234": p("FL", "Miami"),
  "33238": p("FL", "Miami"),
  "33239": p("FL", "Miami Beach"),
  "33242": p("FL", "Miami"),
  "33243": p("FL", "Miami"),
  "33245": p("FL", "Miami"),
  "33247": p("FL", "Miami"),
  "33255": p("FL", "Miami"),
  "33256": p("FL", "Miami"),
  "33257": p("FL", "Miami"),
  "33261": p("FL", "Miami"),
  "33265": p("FL", "Miami"),
  "33266": p("FL", "Miami"),
  "33269": p("FL", "Miami"),
  "33280": p("FL", "Miami"),
  "33283": p("FL", "Miami"),
  "33296": p("FL", "Miami"),
  "33299": p("FL", "Miami"),
  "33001": p("FL", "Long Key"),
  "33036": p("FL", "Islamorada"),
  "33037": p("FL", "Key Largo"),
  "33040": p("FL", "Key West"),
  "33041": p("FL", "Key West"),
  "33042": p("FL", "Summerland Key"),
  "33043": p("FL", "Big Pine Key"),
  "33045": p("FL", "Key West"),
  "33050": p("FL", "Marathon"),
  "33051": p("FL", "Key Colony Beach"),
  "33052": p("FL", "Marathon Shores"),
  "33070": p("FL", "Tavernier"),
  "32009": p("FL", "Bryceville"),
  "32011": p("FL", "Callahan"),
  "32034": p("FL", "Fernandina Beach"),
  "32035": p("FL", "Fernandina Beach"),
  "32041": p("FL", "Yulee"),
  "32046": p("FL", "Hilliard"),
  "32097": p("FL", "Yulee"),
  "32531": p("FL", "Baker"),
  "32536": p("FL", "Crestview"),
  "32537": p("FL", "Milligan"),
  "32539": p("FL", "Crestview"),
  "32540": p("FL", "Destin"),
  "32541": p("FL", "Destin"),
  "32542": p("FL", "Eglin Afb"),
  "32544": p("FL", "Hurlburt Field"),
  "32547": p("FL", "Fort Walton Beach"),
  "32548": p("FL", "Fort Walton Beach"),
  "32549": p("FL", "Fort Walton Beach"),
  "32564": p("FL", "Holt"),
  "32567": p("FL", "Laurel Hill"),
  "32569": p("FL", "Mary Esther"),
  "32578": p("FL", "Niceville"),
  "32579": p("FL", "Shalimar"),
  "32580": p("FL", "Valparaiso"),
  "32588": p("FL", "Niceville"),
  "34972": p("FL", "Okeechobee"),
  "34973": p("FL", "Okeechobee"),
  "34974": p("FL", "Okeechobee"),
  "32703": p("FL", "Apopka"),
  "32704": p("FL", "Apopka"),
  "32709": p("FL", "Christmas"),
  "32710": p("FL", "Clarcona"),
  "32712": p("FL", "Apopka"),
  "32751": p("FL", "Maitland"),
  "32768": p("FL", "Plymouth"),
  "32777": p("FL", "Tangerine"),
  "32789": p("FL", "Winter Park"),
  "32790": p("FL", "Winter Park"),
  "32792": p("FL", "Winter Park"),
  "32793": p("FL", "Winter Park"),
  "32794": p("FL", "Maitland"),
  "32798": p("FL", "Zellwood"),
  "32801": p("FL", "Orlando"),
  "32802": p("FL", "Orlando"),
  "32803": p("FL", "Orlando"),
  "32804": p("FL", "Orlando"),
  "32805": p("FL", "Orlando"),
  "32806": p("FL", "Orlando"),
  "32807": p("FL", "Orlando"),
  "32808": p("FL", "Orlando"),
  "32809": p("FL", "Orlando"),
  "32810": p("FL", "Orlando"),
  "32811": p("FL", "Orlando"),
  "32812": p("FL", "Orlando"),
  "32814": p("FL", "Orlando"),
  "32816": p("FL", "Orlando"),
  "32817": p("FL", "Orlando"),
  "32818": p("FL", "Orlando"),
  "32819": p("FL", "Orlando"),
  "32820": p("FL", "Orlando"),
  "32821": p("FL", "Orlando"),
  "32822": p("FL", "Orlando"),
  "32824": p("FL", "Orlando"),
  "32825": p("FL", "Orlando"),
  "32826": p("FL", "Orlando"),
  "32827": p("FL", "Orlando"),
  "32828": p("FL", "Orlando"),
  "32829": p("FL", "Orlando"),
  "32830": p("FL", "Orlando"),
  "32831": p("FL", "Orlando"),
  "32832": p("FL", "Orlando"),
  "32833": p("FL", "Orlando"),
  "32834": p("FL", "Orlando"),
  "32835": p("FL", "Orlando"),
  "32836": p("FL", "Orlando"),
  "32837": p("FL", "Orlando"),
  "32839": p("FL", "Orlando"),
  "32853": p("FL", "Orlando"),
  "32854": p("FL", "Orlando"),
  "32855": p("FL", "Orlando"),
  "32856": p("FL", "Orlando"),
  "32857": p("FL", "Orlando"),
  "32858": p("FL", "Orlando"),
  "32859": p("FL", "Orlando"),
  "32860": p("FL", "Orlando"),
  "32861": p("FL", "Orlando"),
  "32862": p("FL", "Orlando"),
  "32867": p("FL", "Orlando"),
  "32868": p("FL", "Orlando"),
  "32869": p("FL", "Orlando"),
  "32872": p("FL", "Orlando"),
  "32877": p("FL", "Orlando"),
  "32878": p("FL", "Orlando"),
  "32885": p("FL", "Orlando"),
  "32886": p("FL", "Orlando"),
  "32887": p("FL", "Orlando"),
  "32891": p("FL", "Orlando"),
  "32896": p("FL", "Orlando"),
  "32897": p("FL", "Orlando"),
  "34734": p("FL", "Gotha"),
  "34740": p("FL", "Killarney"),
  "34760": p("FL", "Oakland"),
  "34761": p("FL", "Ocoee"),
  "34777": p("FL", "Winter Garden"),
  "34778": p("FL", "Winter Garden"),
  "34786": p("FL", "Windermere"),
  "34787": p("FL", "Winter Garden"),
  "33848": p("FL", "Intercession City"),
  "34739": p("FL", "Kenansville"),
  "34741": p("FL", "Kissimmee"),
  "34742": p("FL", "Kissimmee"),
  "34743": p("FL", "Kissimmee"),
  "34744": p("FL", "Kissimmee"),
  "34745": p("FL", "Kissimmee"),
  "34746": p("FL", "Kissimmee"),
  "34747": p("FL", "Kissimmee"),
  "34758": p("FL", "Kissimmee"),
  "34769": p("FL", "Saint Cloud"),
  "34770": p("FL", "Saint Cloud"),
  "34771": p("FL", "Saint Cloud"),
  "34772": p("FL", "Saint Cloud"),
  "34773": p("FL", "Saint Cloud"),
  "33401": p("FL", "West Palm Beach"),
  "33402": p("FL", "West Palm Beach"),
  "33403": p("FL", "West Palm Beach"),
  "33404": p("FL", "West Palm Beach"),
  "33405": p("FL", "West Palm Beach"),
  "33406": p("FL", "West Palm Beach"),
  "33407": p("FL", "West Palm Beach"),
  "33408": p("FL", "North Palm Beach"),
  "33409": p("FL", "West Palm Beach"),
  "33410": p("FL", "Palm Beach Gardens"),
  "33411": p("FL", "West Palm Beach"),
  "33412": p("FL", "West Palm Beach"),
  "33413": p("FL", "West Palm Beach"),
  "33414": p("FL", "Wellington"),
  "33415": p("FL", "West Palm Beach"),
  "33416": p("FL", "West Palm Beach"),
  "33417": p("FL", "West Palm Beach"),
  "33418": p("FL", "Palm Beach Gardens"),
  "33419": p("FL", "West Palm Beach"),
  "33420": p("FL", "West Palm Beach"),
  "33421": p("FL", "Royal Palm Beach"),
  "33422": p("FL", "West Palm Beach"),
  "33424": p("FL", "Boynton Beach"),
  "33425": p("FL", "Boynton Beach"),
  "33426": p("FL", "Boynton Beach"),
  "33427": p("FL", "Boca Raton"),
  "33428": p("FL", "Boca Raton"),
  "33429": p("FL", "Boca Raton"),
  "33430": p("FL", "Belle Glade"),
  "33431": p("FL", "Boca Raton"),
  "33432": p("FL", "Boca Raton"),
  "33433": p("FL", "Boca Raton"),
  "33434": p("FL", "Boca Raton"),
  "33435": p("FL", "Boynton Beach"),
  "33436": p("FL", "Boynton Beach"),
  "33437": p("FL", "Boynton Beach"),
  "33438": p("FL", "Canal Point"),
  "33444": p("FL", "Delray Beach"),
  "33445": p("FL", "Delray Beach"),
  "33446": p("FL", "Delray Beach"),
  "33448": p("FL", "Delray Beach"),
  "33449": p("FL", "Lake Worth"),
  "33454": p("FL", "Greenacres"),
  "33458": p("FL", "Jupiter"),
  "33459": p("FL", "Lake Harbor"),
  "33460": p("FL", "Lake Worth"),
  "33461": p("FL", "Lake Worth"),
  "33462": p("FL", "Lake Worth"),
  "33463": p("FL", "Lake Worth"),
  "33464": p("FL", "Boca Raton"),
  "33465": p("FL", "Lake Worth"),
  "33466": p("FL", "Lake Worth"),
  "33467": p("FL", "Lake Worth"),
  "33468": p("FL", "Jupiter"),
  "33469": p("FL", "Jupiter"),
  "33470": p("FL", "Loxahatchee"),
  "33472": p("FL", "Boynton Beach"),
  "33473": p("FL", "Boynton Beach"),
  "33474": p("FL", "Boynton Beach"),
  "33476": p("FL", "Pahokee"),
  "33477": p("FL", "Jupiter"),
  "33478": p("FL", "Jupiter"),
  "33480": p("FL", "Palm Beach"),
  "33481": p("FL", "Boca Raton"),
  "33482": p("FL", "Delray Beach"),
  "33483": p("FL", "Delray Beach"),
  "33484": p("FL", "Delray Beach"),
  "33486": p("FL", "Boca Raton"),
  "33487": p("FL", "Boca Raton"),
  "33488": p("FL", "Boca Raton"),
  "33493": p("FL", "South Bay"),
  "33496": p("FL", "Boca Raton"),
  "33497": p("FL", "Boca Raton"),
  "33498": p("FL", "Boca Raton"),
  "33499": p("FL", "Boca Raton"),
  "33523": p("FL", "Dade City"),
  "33524": p("FL", "Crystal Springs"),
  "33525": p("FL", "Dade City"),
  "33526": p("FL", "Dade City"),
  "33537": p("FL", "Lacoochee"),
  "33539": p("FL", "Zephyrhills"),
  "33540": p("FL", "Zephyrhills"),
  "33541": p("FL", "Zephyrhills"),
  "33542": p("FL", "Zephyrhills"),
  "33543": p("FL", "Wesley Chapel"),
  "33544": p("FL", "Wesley Chapel"),
  "33545": p("FL", "Wesley Chapel"),
  "33559": p("FL", "Lutz"),
  "33574": p("FL", "Saint Leo"),
  "33576": p("FL", "San Antonio"),
  "33578": p("FL", "Riverview"),
  "33593": p("FL", "Trilby"),
  "34610": p("FL", "Spring Hill"),
  "34637": p("FL", "Land O Lakes"),
  "34638": p("FL", "Land O Lakes"),
  "34639": p("FL", "Land O Lakes"),
  "34652": p("FL", "New Port Richey"),
  "34653": p("FL", "New Port Richey"),
  "34654": p("FL", "New Port Richey"),
  "34655": p("FL", "New Port Richey"),
  "34656": p("FL", "New Port Richey"),
  "34667": p("FL", "Hudson"),
  "34668": p("FL", "Port Richey"),
  "34669": p("FL", "Hudson"),
  "34673": p("FL", "Port Richey"),
  "34674": p("FL", "Hudson"),
  "34679": p("FL", "Aripeka"),
  "34680": p("FL", "Elfers"),
  "34690": p("FL", "Holiday"),
  "34691": p("FL", "Holiday"),
  "34692": p("FL", "Holiday"),
  "33701": p("FL", "Saint Petersburg"),
  "33702": p("FL", "Saint Petersburg"),
  "33703": p("FL", "Saint Petersburg"),
  "33704": p("FL", "Saint Petersburg"),
  "33705": p("FL", "Saint Petersburg"),
  "33706": p("FL", "Saint Petersburg"),
  "33707": p("FL", "Saint Petersburg"),
  "33708": p("FL", "Saint Petersburg"),
  "33709": p("FL", "Saint Petersburg"),
  "33710": p("FL", "Saint Petersburg"),
  "33711": p("FL", "Saint Petersburg"),
  "33712": p("FL", "Saint Petersburg"),
  "33713": p("FL", "Saint Petersburg"),
  "33714": p("FL", "Saint Petersburg"),
  "33715": p("FL", "Saint Petersburg"),
  "33716": p("FL", "Saint Petersburg"),
  "33729": p("FL", "Saint Petersburg"),
  "33730": p("FL", "Saint Petersburg"),
  "33731": p("FL", "Saint Petersburg"),
  "33732": p("FL", "Saint Petersburg"),
  "33733": p("FL", "Saint Petersburg"),
  "33734": p("FL", "Saint Petersburg"),
  "33736": p("FL", "Saint Petersburg"),
  "33737": p("FL", "Saint Petersburg"),
  "33738": p("FL", "Saint Petersburg"),
  "33740": p("FL", "Saint Petersburg"),
  "33741": p("FL", "Saint Petersburg"),
  "33742": p("FL", "Saint Petersburg"),
  "33743": p("FL", "Saint Petersburg"),
  "33744": p("FL", "Bay Pines"),
  "33747": p("FL", "Saint Petersburg"),
  "33755": p("FL", "Clearwater"),
  "33756": p("FL", "Clearwater"),
  "33757": p("FL", "Clearwater"),
  "33758": p("FL", "Clearwater"),
  "33759": p("FL", "Clearwater"),
  "33760": p("FL", "Clearwater"),
  "33761": p("FL", "Clearwater"),
  "33762": p("FL", "Clearwater"),
  "33763": p("FL", "Clearwater"),
  "33764": p("FL", "Clearwater"),
  "33765": p("FL", "Clearwater"),
  "33766": p("FL", "Clearwater"),
  "33767": p("FL", "Clearwater Beach"),
  "33769": p("FL", "Clearwater"),
  "33770": p("FL", "Largo"),
  "33771": p("FL", "Largo"),
  "33772": p("FL", "Seminole"),
  "33773": p("FL", "Largo"),
  "33774": p("FL", "Largo"),
  "33775": p("FL", "Seminole"),
  "33776": p("FL", "Seminole"),
  "33777": p("FL", "Seminole"),
  "33778": p("FL", "Largo"),
  "33779": p("FL", "Largo"),
  "33780": p("FL", "Pinellas Park"),
  "33781": p("FL", "Pinellas Park"),
  "33782": p("FL", "Pinellas Park"),
  "33784": p("FL", "Saint Petersburg"),
  "33785": p("FL", "Indian Rocks Beach"),
  "33786": p("FL", "Belleair Beach"),
  "34660": p("FL", "Ozona"),
  "34677": p("FL", "Oldsmar"),
  "34681": p("FL", "Crystal Beach"),
  "34682": p("FL", "Palm Harbor"),
  "34683": p("FL", "Palm Harbor"),
  "34684": p("FL", "Palm Harbor"),
  "34685": p("FL", "Palm Harbor"),
  "34688": p("FL", "Tarpon Springs"),
  "34689": p("FL", "Tarpon Springs"),
  "34695": p("FL", "Safety Harbor"),
  "34697": p("FL", "Dunedin"),
  "34698": p("FL", "Dunedin"),
  "33801": p("FL", "Lakeland"),
  "33802": p("FL", "Lakeland"),
  "33803": p("FL", "Lakeland"),
  "33804": p("FL", "Lakeland"),
  "33805": p("FL", "Lakeland"),
  "33806": p("FL", "Lakeland"),
  "33807": p("FL", "Lakeland"),
  "33809": p("FL", "Lakeland"),
  "33810": p("FL", "Lakeland"),
  "33811": p("FL", "Lakeland"),
  "33812": p("FL", "Lakeland"),
  "33813": p("FL", "Lakeland"),
  "33815": p("FL", "Lakeland"),
  "33820": p("FL", "Alturas"),
  "33823": p("FL", "Auburndale"),
  "33827": p("FL", "Babson Park"),
  "33830": p("FL", "Bartow"),
  "33831": p("FL", "Bartow"),
  "33835": p("FL", "Bradley"),
  "33836": p("FL", "Davenport"),
  "33837": p("FL", "Davenport"),
  "33838": p("FL", "Dundee"),
  "33839": p("FL", "Eagle Lake"),
  "33840": p("FL", "Eaton Park"),
  "33841": p("FL", "Fort Meade"),
  "33843": p("FL", "Frostproof"),
  "33844": p("FL", "Haines City"),
  "33845": p("FL", "Haines City"),
  "33846": p("FL", "Highland City"),
  "33847": p("FL", "Homeland"),
  "33849": p("FL", "Kathleen"),
  "33850": p("FL", "Lake Alfred"),
  "33851": p("FL", "Lake Hamilton"),
  "33853": p("FL", "Lake Wales"),
  "33854": p("FL", "Lakeshore"),
  "33855": p("FL", "Indian Lake Estates"),
  "33856": p("FL", "Nalcrest"),
  "33858": p("FL", "Loughman"),
  "33859": p("FL", "Lake Wales"),
  "33860": p("FL", "Mulberry"),
  "33863": p("FL", "Nichols"),
  "33867": p("FL", "River Ranch"),
  "33868": p("FL", "Polk City"),
  "33877": p("FL", "Waverly"),
  "33880": p("FL", "Winter Haven"),
  "33881": p("FL", "Winter Haven"),
  "33882": p("FL", "Winter Haven"),
  "33883": p("FL", "Winter Haven"),
  "33884": p("FL", "Winter Haven"),
  "33885": p("FL", "Winter Haven"),
  "33888": p("FL", "Winter Haven"),
  "33896": p("FL", "Davenport"),
  "33897": p("FL", "Davenport"),
  "33898": p("FL", "Lake Wales"),
  "33967": p("FL", "Fort Myers"),
  "34714": p("FL", "Clermont"),
  "34759": p("FL", "Kissimmee"),
  "32007": p("FL", "Bostwick"),
  "32112": p("FL", "Crescent City"),
  "32131": p("FL", "East Palatka"),
  "32138": p("FL", "Grandin"),
  "32139": p("FL", "Georgetown"),
  "32140": p("FL", "Florahome"),
  "32147": p("FL", "Hollister"),
  "32148": p("FL", "Interlachen"),
  "32149": p("FL", "Interlachen"),
  "32157": p("FL", "Lake Como"),
  "32177": p("FL", "Palatka"),
  "32178": p("FL", "Palatka"),
  "32181": p("FL", "Pomona Park"),
  "32185": p("FL", "Putnam Hall"),
  "32187": p("FL", "San Mateo"),
  "32189": p("FL", "Satsuma"),
  "32193": p("FL", "Welaka"),
  "32666": p("FL", "Melrose"),
  "33112": p("FL", "Miami"),
  "32004": p("FL", "Ponte Vedra Beach"),
  "32033": p("FL", "Elkton"),
  "32080": p("FL", "Saint Augustine"),
  "32081": p("FL", "Ponte Vedra"),
  "32082": p("FL", "Ponte Vedra Beach"),
  "32084": p("FL", "Saint Augustine"),
  "32085": p("FL", "Saint Augustine"),
  "32086": p("FL", "Saint Augustine"),
  "32092": p("FL", "Saint Augustine"),
  "32095": p("FL", "Saint Augustine"),
  "32145": p("FL", "Hastings"),
  "32259": p("FL", "Saint Johns"),
  "32260": p("FL", "Jacksonville"),
  "34945": p("FL", "Fort Pierce"),
  "34946": p("FL", "Fort Pierce"),
  "34947": p("FL", "Fort Pierce"),
  "34948": p("FL", "Fort Pierce"),
  "34949": p("FL", "Fort Pierce"),
  "34950": p("FL", "Fort Pierce"),
  "34951": p("FL", "Fort Pierce"),
  "34952": p("FL", "Port Saint Lucie"),
  "34953": p("FL", "Port Saint Lucie"),
  "34954": p("FL", "Fort Pierce"),
  "34979": p("FL", "Fort Pierce"),
  "34981": p("FL", "Fort Pierce"),
  "34982": p("FL", "Fort Pierce"),
  "34983": p("FL", "Port Saint Lucie"),
  "34984": p("FL", "Port Saint Lucie"),
  "34985": p("FL", "Port Saint Lucie"),
  "34986": p("FL", "Port Saint Lucie"),
  "34987": p("FL", "Port Saint Lucie"),
  "34988": p("FL", "Port Saint Lucie"),
  "32530": p("FL", "Bagdad"),
  "32561": p("FL", "Gulf Breeze"),
  "32562": p("FL", "Gulf Breeze"),
  "32563": p("FL", "Gulf Breeze"),
  "32565": p("FL", "Jay"),
  "32566": p("FL", "Navarre"),
  "32570": p("FL", "Milton"),
  "32571": p("FL", "Milton"),
  "32572": p("FL", "Milton"),
  "32583": p("FL", "Milton"),
  "34223": p("FL", "Englewood"),
  "34224": p("FL", "Englewood"),
  "34229": p("FL", "Osprey"),
  "34230": p("FL", "Sarasota"),
  "34231": p("FL", "Sarasota"),
  "34232": p("FL", "Sarasota"),
  "34233": p("FL", "Sarasota"),
  "34234": p("FL", "Sarasota"),
  "34235": p("FL", "Sarasota"),
  "34236": p("FL", "Sarasota"),
  "34237": p("FL", "Sarasota"),
  "34238": p("FL", "Sarasota"),
  "34239": p("FL", "Sarasota"),
  "34240": p("FL", "Sarasota"),
  "34241": p("FL", "Sarasota"),
  "34242": p("FL", "Sarasota"),
  "34249": p("FL", "Sarasota"),
  "34272": p("FL", "Laurel"),
  "34274": p("FL", "Nokomis"),
  "34275": p("FL", "Nokomis"),
  "34276": p("FL", "Sarasota"),
  "34277": p("FL", "Sarasota"),
  "34278": p("FL", "Sarasota"),
  "34284": p("FL", "Venice"),
  "34285": p("FL", "Venice"),
  "34286": p("FL", "North Port"),
  "34287": p("FL", "North Port"),
  "34288": p("FL", "North Port"),
  "34289": p("FL", "North Port"),
  "34290": p("FL", "North Port"),
  "34291": p("FL", "North Port"),
  "34292": p("FL", "Venice"),
  "34293": p("FL", "Venice"),
  "34295": p("FL", "Englewood"),
  "32701": p("FL", "Altamonte Springs"),
  "32707": p("FL", "Casselberry"),
  "32708": p("FL", "Winter Springs"),
  "32714": p("FL", "Altamonte Springs"),
  "32715": p("FL", "Altamonte Springs"),
  "32716": p("FL", "Altamonte Springs"),
  "32718": p("FL", "Casselberry"),
  "32719": p("FL", "Winter Springs"),
  "32730": p("FL", "Casselberry"),
  "32732": p("FL", "Geneva"),
  "32733": p("FL", "Goldenrod"),
  "32746": p("FL", "Lake Mary"),
  "32747": p("FL", "Lake Monroe"),
  "32750": p("FL", "Longwood"),
  "32752": p("FL", "Longwood"),
  "32762": p("FL", "Oviedo"),
  "32765": p("FL", "Oviedo"),
  "32766": p("FL", "Oviedo"),
  "32771": p("FL", "Sanford"),
  "32772": p("FL", "Sanford"),
  "32773": p("FL", "Sanford"),
  "32779": p("FL", "Longwood"),
  "32791": p("FL", "Longwood"),
  "32795": p("FL", "Lake Mary"),
  "32799": p("FL", "Mid Florida"),
  "32162": p("FL", "The Villages"),
  "32163": p("FL", "The Villages"),
  "33513": p("FL", "Bushnell"),
  "33514": p("FL", "Center Hill"),
  "33521": p("FL", "Coleman"),
  "33538": p("FL", "Lake Panasoffkee"),
  "33585": p("FL", "Sumterville"),
  "33597": p("FL", "Webster"),
  "34484": p("FL", "Oxford"),
  "34785": p("FL", "Wildwood"),
  "32008": p("FL", "Branford"),
  "32060": p("FL", "Live Oak"),
  "32062": p("FL", "Mc Alpin"),
  "32064": p("FL", "Live Oak"),
  "32071": p("FL", "O Brien"),
  "32094": p("FL", "Wellborn"),
  "32347": p("FL", "Perry"),
  "32348": p("FL", "Perry"),
  "32356": p("FL", "Salem"),
  "32357": p("FL", "Shady Grove"),
  "32359": p("FL", "Steinhatchee"),
  "32026": p("FL", "Raiford"),
  "32054": p("FL", "Lake Butler"),
  "32083": p("FL", "Raiford"),
  "32697": p("FL", "Worthington Springs"),
  "32105": p("FL", "Barberville"),
  "32114": p("FL", "Daytona Beach"),
  "32115": p("FL", "Daytona Beach"),
  "32116": p("FL", "Daytona Beach"),
  "32117": p("FL", "Daytona Beach"),
  "32118": p("FL", "Daytona Beach"),
  "32119": p("FL", "Daytona Beach"),
  "32120": p("FL", "Daytona Beach"),
  "32121": p("FL", "Daytona Beach"),
  "32122": p("FL", "Daytona Beach"),
  "32123": p("FL", "Port Orange"),
  "32124": p("FL", "Daytona Beach"),
  "32125": p("FL", "Daytona Beach"),
  "32126": p("FL", "Daytona Beach"),
  "32127": p("FL", "Port Orange"),
  "32128": p("FL", "Port Orange"),
  "32129": p("FL", "Port Orange"),
  "32130": p("FL", "De Leon Springs"),
  "32132": p("FL", "Edgewater"),
  "32141": p("FL", "Edgewater"),
  "32168": p("FL", "New Smyrna Beach"),
  "32169": p("FL", "New Smyrna Beach"),
  "32170": p("FL", "New Smyrna Beach"),
  "32173": p("FL", "Ormond Beach"),
  "32174": p("FL", "Ormond Beach"),
  "32175": p("FL", "Ormond Beach"),
  "32176": p("FL", "Ormond Beach"),
  "32180": p("FL", "Pierson"),
  "32190": p("FL", "Seville"),
  "32198": p("FL", "Daytona Beach"),
  "32706": p("FL", "Cassadaga"),
  "32713": p("FL", "Debary"),
  "32720": p("FL", "Deland"),
  "32721": p("FL", "Deland"),
  "32722": p("FL", "Glenwood"),
  "32723": p("FL", "Deland"),
  "32724": p("FL", "Deland"),
  "32725": p("FL", "Deltona"),
  "32728": p("FL", "Deltona"),
  "32738": p("FL", "Deltona"),
  "32739": p("FL", "Deltona"),
  "32744": p("FL", "Lake Helen"),
  "32745": p("FL", "Mid Florida"),
  "32759": p("FL", "Oak Hill"),
  "32763": p("FL", "Orange City"),
  "32764": p("FL", "Osteen"),
  "32774": p("FL", "Orange City"),
  "32326": p("FL", "Crawfordville"),
  "32327": p("FL", "Crawfordville"),
  "32346": p("FL", "Panacea"),
  "32355": p("FL", "Saint Marks"),
  "32358": p("FL", "Sopchoppy"),
  "32422": p("FL", "Argyle"),
  "32433": p("FL", "Defuniak Springs"),
  "32434": p("FL", "Mossy Head"),
  "32435": p("FL", "Defuniak Springs"),
  "32439": p("FL", "Freeport"),
  "32459": p("FL", "Santa Rosa Beach"),
  "32461": p("FL", "Rosemary Beach"),
  "32538": p("FL", "Paxton"),
  "32550": p("FL", "Miramar Beach"),
  "32427": p("FL", "Caryville"),
  "32428": p("FL", "Chipley"),
  "32437": p("FL", "Ebro"),
  "32462": p("FL", "Vernon"),
  "32463": p("FL", "Wausau"),
  "31513": p("GA", "Baxley"),
  "31515": p("GA", "Baxley"),
  "31562": p("GA", "Saint George"),
  "31563": p("GA", "Surrency"),
  "31624": p("GA", "Axson"),
  "31642": p("GA", "Pearson"),
  "31650": p("GA", "Willacoochee"),
  "31510": p("GA", "Alma"),
  "31721": p("GA", "Albany"),
  "39837": p("GA", "Colquitt"),
  "39841": p("GA", "Damascus"),
  "39845": p("GA", "Donalsonville"),
  "39862": p("GA", "Leary"),
  "39870": p("GA", "Newton"),
  "31034": p("GA", "Hardwick"),
  "31059": p("GA", "Milledgeville"),
  "31061": p("GA", "Milledgeville"),
  "31062": p("GA", "Milledgeville"),
  "30511": p("GA", "Baldwin"),
  "30547": p("GA", "Homer"),
  "30558": p("GA", "Maysville"),
  "30011": p("GA", "Auburn"),
  "30620": p("GA", "Bethlehem"),
  "30666": p("GA", "Statham"),
  "30680": p("GA", "Winder"),
  "30103": p("GA", "Adairsville"),
  "30120": p("GA", "Cartersville"),
  "30121": p("GA", "Cartersville"),
  "30123": p("GA", "Cassville"),
  "30137": p("GA", "Emerson"),
  "30145": p("GA", "Kingston"),
  "30171": p("GA", "Rydal"),
  "30178": p("GA", "Taylorsville"),
  "30184": p("GA", "White"),
  "31750": p("GA", "Fitzgerald"),
  "39840": p("GA", "Cuthbert"),
  "31622": p("GA", "Alapaha"),
  "31639": p("GA", "Nashville"),
  "31645": p("GA", "Ray City"),
  "31749": p("GA", "Enigma"),
  "31052": p("GA", "Lizella"),
  "31201": p("GA", "Macon"),
  "31202": p("GA", "Macon"),
  "31203": p("GA", "Macon"),
  "31204": p("GA", "Macon"),
  "31205": p("GA", "Macon"),
  "31206": p("GA", "Macon"),
  "31207": p("GA", "Macon"),
  "31208": p("GA", "Macon"),
  "31209": p("GA", "Macon"),
  "31210": p("GA", "Macon"),
  "31211": p("GA", "Macon"),
  "31213": p("GA", "Macon"),
  "31216": p("GA", "Macon"),
  "31217": p("GA", "Macon"),
  "31220": p("GA", "Macon"),
  "31221": p("GA", "Macon"),
  "31294": p("GA", "Macon"),
  "31295": p("GA", "Macon"),
  "31296": p("GA", "Macon"),
  "31297": p("GA", "Macon"),
  "31014": p("GA", "Cochran"),
  "31542": p("GA", "Hoboken"),
  "31543": p("GA", "Hortense"),
  "31553": p("GA", "Nahunta"),
  "31566": p("GA", "Waynesville"),
  "31625": p("GA", "Barney"),
  "31629": p("GA", "Dixie"),
  "31638": p("GA", "Morven"),
  "31643": p("GA", "Quitman"),
  "31720": p("GA", "Barwick"),
  "31308": p("GA", "Ellabell"),
  "31321": p("GA", "Pembroke"),
  "31324": p("GA", "Richmond Hill"),
  "30415": p("GA", "Brooklet"),
  "30450": p("GA", "Portal"),
  "30452": p("GA", "Register"),
  "30458": p("GA", "Statesboro"),
  "30459": p("GA", "Statesboro"),
  "30460": p("GA", "Statesboro"),
  "30461": p("GA", "Statesboro"),
  "30426": p("GA", "Girard"),
  "30441": p("GA", "Midville"),
  "30456": p("GA", "Sardis"),
  "30811": p("GA", "Gough"),
  "30816": p("GA", "Keysville"),
  "30830": p("GA", "Waynesboro"),
  "30216": p("GA", "Flovilla"),
  "30233": p("GA", "Jackson"),
  "30234": p("GA", "Jenkinsburg"),
  "39842": p("GA", "Dawson"),
  "39866": p("GA", "Morgan"),
  "39886": p("GA", "Shellman"),
  "31547": p("GA", "Kings Bay"),
  "31548": p("GA", "Kingsland"),
  "31558": p("GA", "Saint Marys"),
  "31565": p("GA", "Waverly"),
  "31568": p("GA", "White Oak"),
  "31569": p("GA", "Woodbine"),
  "30439": p("GA", "Metter"),
  "30451": p("GA", "Pulaski"),
  "30108": p("GA", "Bowdon"),
  "30109": p("GA", "Bowdon Junction"),
  "30112": p("GA", "Carrollton"),
  "30116": p("GA", "Carrollton"),
  "30117": p("GA", "Carrollton"),
  "30118": p("GA", "Carrollton"),
  "30119": p("GA", "Carrollton"),
  "30150": p("GA", "Mount Zion"),
  "30170": p("GA", "Roopville"),
  "30179": p("GA", "Temple"),
  "30180": p("GA", "Villa Rica"),
  "30185": p("GA", "Whitesburg"),
  "30726": p("GA", "Graysville"),
  "30736": p("GA", "Ringgold"),
  "30742": p("GA", "Fort Oglethorpe"),
  "31537": p("GA", "Folkston"),
  "31302": p("GA", "Bloomingdale"),
  "31322": p("GA", "Pooler"),
  "31328": p("GA", "Tybee Island"),
  "31401": p("GA", "Savannah"),
  "31402": p("GA", "Savannah"),
  "31403": p("GA", "Savannah"),
  "31404": p("GA", "Savannah"),
  "31405": p("GA", "Savannah"),
  "31406": p("GA", "Savannah"),
  "31407": p("GA", "Port Wentworth"),
  "31408": p("GA", "Savannah"),
  "31409": p("GA", "Savannah"),
  "31410": p("GA", "Savannah"),
  "31411": p("GA", "Savannah"),
  "31412": p("GA", "Savannah"),
  "31414": p("GA", "Savannah"),
  "31415": p("GA", "Savannah"),
  "31416": p("GA", "Savannah"),
  "31418": p("GA", "Savannah"),
  "31419": p("GA", "Savannah"),
  "31420": p("GA", "Savannah"),
  "31421": p("GA", "Savannah"),
  "31805": p("GA", "Cusseta"),
  "30730": p("GA", "Lyerly"),
  "30731": p("GA", "Menlo"),
  "30747": p("GA", "Summerville"),
  "30753": p("GA", "Trion"),
  "30107": p("GA", "Ball Ground"),
  "30114": p("GA", "Canton"),
  "30115": p("GA", "Canton"),
  "30142": p("GA", "Holly Springs"),
  "30146": p("GA", "Lebanon"),
  "30151": p("GA", "Nelson"),
  "30169": p("GA", "Canton"),
  "30183": p("GA", "Waleska"),
  "30188": p("GA", "Woodstock"),
  "30189": p("GA", "Woodstock"),
  "30601": p("GA", "Athens"),
  "30602": p("GA", "Athens"),
  "30603": p("GA", "Athens"),
  "30604": p("GA", "Athens"),
  "30605": p("GA", "Athens"),
  "30606": p("GA", "Athens"),
  "30607": p("GA", "Athens"),
  "30608": p("GA", "Athens"),
  "30609": p("GA", "Athens"),
  "30612": p("GA", "Athens"),
  "30683": p("GA", "Winterville"),
  "39823": p("GA", "Blakely"),
  "39824": p("GA", "Bluffton"),
  "39836": p("GA", "Coleman"),
  "39846": p("GA", "Edison"),
  "39851": p("GA", "Fort Gaines"),
  "39854": p("GA", "Georgetown"),
  "39867": p("GA", "Morris"),
  "30236": p("GA", "Jonesboro"),
  "30237": p("GA", "Jonesboro"),
  "30238": p("GA", "Jonesboro"),
  "30250": p("GA", "Lovejoy"),
  "30260": p("GA", "Morrow"),
  "30273": p("GA", "Rex"),
  "30274": p("GA", "Riverdale"),
  "30287": p("GA", "Morrow"),
  "30288": p("GA", "Conley"),
  "30294": p("GA", "Ellenwood"),
  "30296": p("GA", "Riverdale"),
  "30297": p("GA", "Forest Park"),
  "30298": p("GA", "Forest Park"),
  "31623": p("GA", "Argyle"),
  "31630": p("GA", "Du Pont"),
  "31631": p("GA", "Fargo"),
  "31634": p("GA", "Homerville"),
  "30006": p("GA", "Marietta"),
  "30007": p("GA", "Marietta"),
  "30008": p("GA", "Marietta"),
  "30060": p("GA", "Marietta"),
  "30061": p("GA", "Marietta"),
  "30062": p("GA", "Marietta"),
  "30063": p("GA", "Marietta"),
  "30064": p("GA", "Marietta"),
  "30065": p("GA", "Marietta"),
  "30066": p("GA", "Marietta"),
  "30067": p("GA", "Marietta"),
  "30068": p("GA", "Marietta"),
  "30069": p("GA", "Marietta"),
  "30080": p("GA", "Smyrna"),
  "30081": p("GA", "Smyrna"),
  "30082": p("GA", "Smyrna"),
  "30090": p("GA", "Marietta"),
  "30101": p("GA", "Acworth"),
  "30102": p("GA", "Acworth"),
  "30106": p("GA", "Austell"),
  "30111": p("GA", "Clarkdale"),
  "30126": p("GA", "Mableton"),
  "30127": p("GA", "Powder Springs"),
  "30144": p("GA", "Kennesaw"),
  "30152": p("GA", "Kennesaw"),
  "30156": p("GA", "Kennesaw"),
  "30160": p("GA", "Kennesaw"),
  "30168": p("GA", "Austell"),
  "31144": p("GA", "Kennesaw"),
  "31512": p("GA", "Ambrose"),
  "31519": p("GA", "Broxton"),
  "31533": p("GA", "Douglas"),
  "31534": p("GA", "Douglas"),
  "31535": p("GA", "Douglas"),
  "31554": p("GA", "Nicholls"),
  "31567": p("GA", "West Green"),
  "31722": p("GA", "Berlin"),
  "31744": p("GA", "Doerun"),
  "31747": p("GA", "Ellenton"),
  "31753": p("GA", "Funston"),
  "31756": p("GA", "Hartsfield"),
  "31768": p("GA", "Moultrie"),
  "31771": p("GA", "Norman Park"),
  "31776": p("GA", "Moultrie"),
  "31788": p("GA", "Moultrie"),
  "30802": p("GA", "Appling"),
  "30809": p("GA", "Evans"),
  "30813": p("GA", "Grovetown"),
  "30814": p("GA", "Harlem"),
  "30917": p("GA", "Augusta"),
  "39813": p("GA", "Arlington"),
  "31620": p("GA", "Adel"),
  "31627": p("GA", "Cecil"),
  "31637": p("GA", "Lenox"),
  "31647": p("GA", "Sparks"),
  "30220": p("GA", "Grantville"),
  "30229": p("GA", "Haralson"),
  "30259": p("GA", "Moreland"),
  "30263": p("GA", "Newnan"),
  "30264": p("GA", "Newnan"),
  "30265": p("GA", "Newnan"),
  "30271": p("GA", "Newnan"),
  "30275": p("GA", "Sargent"),
  "30276": p("GA", "Senoia"),
  "30277": p("GA", "Sharpsburg"),
  "30289": p("GA", "Turin"),
  "31050": p("GA", "Knoxville"),
  "31066": p("GA", "Musella"),
  "31078": p("GA", "Roberta"),
  "31010": p("GA", "Cordele"),
  "31015": p("GA", "Cordele"),
  "31712": p("GA", "Arabi"),
  "30738": p("GA", "Rising Fawn"),
  "30752": p("GA", "Trenton"),
  "30757": p("GA", "Wildwood"),
  "30534": p("GA", "Dawsonville"),
  "39815": p("GA", "Attapulgus"),
  "39818": p("GA", "Bainbridge"),
  "39819": p("GA", "Bainbridge"),
  "39852": p("GA", "Fowlstown"),
  "30002": p("GA", "Avondale Estates"),
  "30021": p("GA", "Clarkston"),
  "30030": p("GA", "Decatur"),
  "30031": p("GA", "Decatur"),
  "30032": p("GA", "Decatur"),
  "30033": p("GA", "Decatur"),
  "30034": p("GA", "Decatur"),
  "30035": p("GA", "Decatur"),
  "30036": p("GA", "Decatur"),
  "30037": p("GA", "Decatur"),
  "30038": p("GA", "Lithonia"),
  "30058": p("GA", "Lithonia"),
  "30072": p("GA", "Pine Lake"),
  "30074": p("GA", "Redan"),
  "30079": p("GA", "Scottdale"),
  "30083": p("GA", "Stone Mountain"),
  "30084": p("GA", "Tucker"),
  "30085": p("GA", "Tucker"),
  "30086": p("GA", "Stone Mountain"),
  "30087": p("GA", "Stone Mountain"),
  "30088": p("GA", "Stone Mountain"),
  "30319": p("GA", "Atlanta"),
  "30322": p("GA", "Atlanta"),
  "30329": p("GA", "Atlanta"),
  "30333": p("GA", "Atlanta"),
  "30340": p("GA", "Atlanta"),
  "30341": p("GA", "Atlanta"),
  "30345": p("GA", "Atlanta"),
  "30346": p("GA", "Atlanta"),
  "30350": p("GA", "Atlanta"),
  "30356": p("GA", "Atlanta"),
  "30359": p("GA", "Atlanta"),
  "30360": p("GA", "Atlanta"),
  "30362": p("GA", "Atlanta"),
  "30366": p("GA", "Atlanta"),
  "31119": p("GA", "Atlanta"),
  "31141": p("GA", "Atlanta"),
  "31145": p("GA", "Atlanta"),
  "31146": p("GA", "Atlanta"),
  "39901": p("GA", "Atlanta"),
  "31011": p("GA", "Chauncey"),
  "31012": p("GA", "Chester"),
  "31023": p("GA", "Eastman"),
  "31077": p("GA", "Rhine"),
  "31007": p("GA", "Byromville"),
  "31051": p("GA", "Lilly"),
  "31063": p("GA", "Montezuma"),
  "31070": p("GA", "Pinehurst"),
  "31091": p("GA", "Unadilla"),
  "31092": p("GA", "Vienna"),
  "31701": p("GA", "Albany"),
  "31702": p("GA", "Albany"),
  "31703": p("GA", "Albany"),
  "31704": p("GA", "Albany"),
  "31705": p("GA", "Albany"),
  "31706": p("GA", "Albany"),
  "31707": p("GA", "Albany"),
  "31708": p("GA", "Albany"),
  "31782": p("GA", "Putney"),
  "30122": p("GA", "Lithia Springs"),
  "30133": p("GA", "Douglasville"),
  "30134": p("GA", "Douglasville"),
  "30135": p("GA", "Douglasville"),
  "30154": p("GA", "Douglasville"),
  "30187": p("GA", "Winston"),
  "39832": p("GA", "Cedar Springs"),
  "39834": p("GA", "Climax"),
  "31648": p("GA", "Statenville"),
  "31303": p("GA", "Clyo"),
  "31307": p("GA", "Eden"),
  "31312": p("GA", "Guyton"),
  "31318": p("GA", "Meldrim"),
  "31326": p("GA", "Rincon"),
  "31329": p("GA", "Springfield"),
  "30624": p("GA", "Bowman"),
  "30634": p("GA", "Dewy Rose"),
  "30635": p("GA", "Elberton"),
  "30401": p("GA", "Swainsboro"),
  "30425": p("GA", "Garfield"),
  "30447": p("GA", "Norristown"),
  "30448": p("GA", "Nunez"),
  "30464": p("GA", "Stillmore"),
  "30471": p("GA", "Twin City"),
  "31002": p("GA", "Adrian"),
  "30414": p("GA", "Bellville"),
  "30417": p("GA", "Claxton"),
  "30423": p("GA", "Daisy"),
  "30429": p("GA", "Hagan"),
  "30513": p("GA", "Blue Ridge"),
  "30541": p("GA", "Epworth"),
  "30555": p("GA", "Mc Caysville"),
  "30559": p("GA", "Mineral Bluff"),
  "30560": p("GA", "Morganton"),
  "30205": p("GA", "Brooks"),
  "30214": p("GA", "Fayetteville"),
  "30215": p("GA", "Fayetteville"),
  "30269": p("GA", "Peachtree City"),
  "30290": p("GA", "Tyrone"),
  "31169": p("GA", "Peachtree City"),
  "30105": p("GA", "Armuchee"),
  "30124": p("GA", "Cave Spring"),
  "30129": p("GA", "Coosa"),
  "30147": p("GA", "Lindale"),
  "30149": p("GA", "Mount Berry"),
  "30161": p("GA", "Rome"),
  "30162": p("GA", "Rome"),
  "30163": p("GA", "Rome"),
  "30164": p("GA", "Rome"),
  "30165": p("GA", "Rome"),
  "30172": p("GA", "Shannon"),
  "30173": p("GA", "Silver Creek"),
  "30028": p("GA", "Cumming"),
  "30040": p("GA", "Cumming"),
  "30041": p("GA", "Cumming"),
  "30520": p("GA", "Canon"),
  "30521": p("GA", "Carnesville"),
  "30553": p("GA", "Lavonia"),
  "30639": p("GA", "Franklin Springs"),
  "30662": p("GA", "Royston"),
  "30004": p("GA", "Alpharetta"),
  "30005": p("GA", "Alpharetta"),
  "30009": p("GA", "Alpharetta"),
  "30022": p("GA", "Alpharetta"),
  "30023": p("GA", "Alpharetta"),
  "30075": p("GA", "Roswell"),
  "30076": p("GA", "Roswell"),
  "30077": p("GA", "Roswell"),
  "30213": p("GA", "Fairburn"),
  "30268": p("GA", "Palmetto"),
  "30272": p("GA", "Red Oak"),
  "30291": p("GA", "Union City"),
  "30301": p("GA", "Atlanta"),
  "30302": p("GA", "Atlanta"),
  "30303": p("GA", "Atlanta"),
  "30304": p("GA", "Atlanta"),
  "30305": p("GA", "Atlanta"),
  "30306": p("GA", "Atlanta"),
  "30307": p("GA", "Atlanta"),
  "30308": p("GA", "Atlanta"),
  "30309": p("GA", "Atlanta"),
  "30310": p("GA", "Atlanta"),
  "30311": p("GA", "Atlanta"),
  "30312": p("GA", "Atlanta"),
  "30313": p("GA", "Atlanta"),
  "30314": p("GA", "Atlanta"),
  "30315": p("GA", "Atlanta"),
  "30316": p("GA", "Atlanta"),
  "30317": p("GA", "Atlanta"),
  "30318": p("GA", "Atlanta"),
  "30320": p("GA", "Atlanta"),
  "30321": p("GA", "Atlanta"),
  "30324": p("GA", "Atlanta"),
  "30325": p("GA", "Atlanta"),
  "30326": p("GA", "Atlanta"),
  "30327": p("GA", "Atlanta"),
  "30328": p("GA", "Atlanta"),
  "30331": p("GA", "Atlanta"),
  "30332": p("GA", "Atlanta"),
  "30334": p("GA", "Atlanta"),
  "30336": p("GA", "Atlanta"),
  "30337": p("GA", "Atlanta"),
  "30338": p("GA", "Atlanta"),
  "30339": p("GA", "Atlanta"),
  "30342": p("GA", "Atlanta"),
  "30343": p("GA", "Atlanta"),
  "30344": p("GA", "Atlanta"),
  "30348": p("GA", "Atlanta"),
  "30349": p("GA", "Atlanta"),
  "30353": p("GA", "Atlanta"),
  "30354": p("GA", "Atlanta"),
  "30355": p("GA", "Atlanta"),
  "30357": p("GA", "Atlanta"),
  "30358": p("GA", "Atlanta"),
  "30361": p("GA", "Atlanta"),
  "30363": p("GA", "Atlanta"),
  "30364": p("GA", "Atlanta"),
  "30368": p("GA", "Atlanta"),
  "30369": p("GA", "Atlanta"),
  "30370": p("GA", "Atlanta"),
  "30371": p("GA", "Atlanta"),
  "30374": p("GA", "Atlanta"),
  "30375": p("GA", "Atlanta"),
  "30377": p("GA", "Atlanta"),
  "30378": p("GA", "Atlanta"),
  "30380": p("GA", "Atlanta"),
  "30384": p("GA", "Atlanta"),
  "30385": p("GA", "Atlanta"),
  "30388": p("GA", "Atlanta"),
  "30392": p("GA", "Atlanta"),
  "30394": p("GA", "Atlanta"),
  "30396": p("GA", "Atlanta"),
  "30398": p("GA", "Atlanta"),
  "31106": p("GA", "Atlanta"),
  "31107": p("GA", "Atlanta"),
  "31126": p("GA", "Atlanta"),
  "31131": p("GA", "Atlanta"),
  "31136": p("GA", "Atlanta"),
  "31139": p("GA", "Atlanta"),
  "31150": p("GA", "Atlanta"),
  "31156": p("GA", "Atlanta"),
  "31192": p("GA", "Atlanta"),
  "31193": p("GA", "Atlanta"),
  "31195": p("GA", "Atlanta"),
  "31196": p("GA", "Atlanta"),
  "30522": p("GA", "Cherry Log"),
  "30536": p("GA", "Ellijay"),
  "30539": p("GA", "East Ellijay"),
  "30540": p("GA", "Ellijay"),
  "30810": p("GA", "Gibson"),
  "30820": p("GA", "Mitchell"),
  "31520": p("GA", "Brunswick"),
  "31521": p("GA", "Brunswick"),
  "31522": p("GA", "Saint Simons Island"),
  "31523": p("GA", "Brunswick"),
  "31524": p("GA", "Brunswick"),
  "31525": p("GA", "Brunswick"),
  "31527": p("GA", "Jekyll Island"),
  "31561": p("GA", "Sea Island"),
  "30139": p("GA", "Fairmount"),
  "30701": p("GA", "Calhoun"),
  "30703": p("GA", "Calhoun"),
  "30732": p("GA", "Oakman"),
  "30733": p("GA", "Plainville"),
  "30734": p("GA", "Ranger"),
  "30735": p("GA", "Resaca"),
  "30746": p("GA", "Sugar Valley"),
  "39827": p("GA", "Cairo"),
  "39829": p("GA", "Calvary"),
  "39897": p("GA", "Whigham"),
  "30642": p("GA", "Greensboro"),
  "30665": p("GA", "Siloam"),
  "30669": p("GA", "Union Point"),
  "30678": p("GA", "White Plains"),
  "30003": p("GA", "Norcross"),
  "30010": p("GA", "Norcross"),
  "30017": p("GA", "Grayson"),
  "30019": p("GA", "Dacula"),
  "30024": p("GA", "Suwanee"),
  "30026": p("GA", "North Metro"),
  "30029": p("GA", "North Metro"),
  "30039": p("GA", "Snellville"),
  "30042": p("GA", "Lawrenceville"),
  "30043": p("GA", "Lawrenceville"),
  "30044": p("GA", "Lawrenceville"),
  "30045": p("GA", "Lawrenceville"),
  "30046": p("GA", "Lawrenceville"),
  "30047": p("GA", "Lilburn"),
  "30048": p("GA", "Lilburn"),
  "30049": p("GA", "Lawrenceville"),
  "30052": p("GA", "Loganville"),
  "30071": p("GA", "Norcross"),
  "30078": p("GA", "Snellville"),
  "30091": p("GA", "Norcross"),
  "30092": p("GA", "Peachtree Corners"),
  "30093": p("GA", "Norcross"),
  "30095": p("GA", "Duluth"),
  "30096": p("GA", "Duluth"),
  "30097": p("GA", "Duluth"),
  "30098": p("GA", "Duluth"),
  "30099": p("GA", "Duluth"),
  "30515": p("GA", "Buford"),
  "30518": p("GA", "Buford"),
  "30519": p("GA", "Buford"),
  "30510": p("GA", "Alto"),
  "30523": p("GA", "Clarkesville"),
  "30531": p("GA", "Cornelia"),
  "30535": p("GA", "Demorest"),
  "30563": p("GA", "Mount Airy"),
  "30580": p("GA", "Turnerville"),
  "30501": p("GA", "Gainesville"),
  "30502": p("GA", "Chestnut Mountain"),
  "30503": p("GA", "Gainesville"),
  "30504": p("GA", "Gainesville"),
  "30506": p("GA", "Gainesville"),
  "30507": p("GA", "Gainesville"),
  "30527": p("GA", "Clermont"),
  "30542": p("GA", "Flowery Branch"),
  "30543": p("GA", "Gillsville"),
  "30554": p("GA", "Lula"),
  "30564": p("GA", "Murrayville"),
  "30566": p("GA", "Oakwood"),
  "31087": p("GA", "Sparta"),
  "30110": p("GA", "Bremen"),
  "30113": p("GA", "Buchanan"),
  "30140": p("GA", "Felton"),
  "30176": p("GA", "Tallapoosa"),
  "30182": p("GA", "Waco"),
  "31804": p("GA", "Cataula"),
  "31807": p("GA", "Ellerslie"),
  "31811": p("GA", "Hamilton"),
  "31822": p("GA", "Pine Mountain"),
  "31823": p("GA", "Pine Mountain Valley"),
  "31826": p("GA", "Shiloh"),
  "31831": p("GA", "Waverly Hall"),
  "30516": p("GA", "Bowersville"),
  "30643": p("GA", "Hartwell"),
  "30217": p("GA", "Franklin"),
  "30228": p("GA", "Hampton"),
  "30248": p("GA", "Locust Grove"),
  "30252": p("GA", "Mcdonough"),
  "30253": p("GA", "Mcdonough"),
  "30281": p("GA", "Stockbridge"),
  "31005": p("GA", "Bonaire"),
  "31013": p("GA", "Clinchfield"),
  "31025": p("GA", "Elko"),
  "31028": p("GA", "Centerville"),
  "31047": p("GA", "Kathleen"),
  "31069": p("GA", "Perry"),
  "31088": p("GA", "Warner Robins"),
  "31093": p("GA", "Warner Robins"),
  "31095": p("GA", "Warner Robins"),
  "31098": p("GA", "Warner Robins"),
  "31099": p("GA", "Warner Robins"),
  "31760": p("GA", "Irwinville"),
  "31769": p("GA", "Mystic"),
  "31774": p("GA", "Ocilla"),
  "31798": p("GA", "Wray"),
  "30517": p("GA", "Braselton"),
  "30529": p("GA", "Commerce"),
  "30530": p("GA", "Commerce"),
  "30548": p("GA", "Hoschton"),
  "30549": p("GA", "Jefferson"),
  "30565": p("GA", "Nicholson"),
  "30567": p("GA", "Pendergrass"),
  "30575": p("GA", "Talmo"),
  "30599": p("GA", "Commerce"),
  "30055": p("GA", "Mansfield"),
  "31038": p("GA", "Hillsboro"),
  "31064": p("GA", "Monticello"),
  "31085": p("GA", "Shady Dale"),
  "31532": p("GA", "Denton"),
  "31539": p("GA", "Hazlehurst"),
  "30413": p("GA", "Bartow"),
  "30434": p("GA", "Louisville"),
  "30477": p("GA", "Wadley"),
  "30803": p("GA", "Avera"),
  "30818": p("GA", "Matthews"),
  "30823": p("GA", "Stapleton"),
  "30833": p("GA", "Wrens"),
  "30442": p("GA", "Millen"),
  "30822": p("GA", "Perkins"),
  "31049": p("GA", "Kite"),
  "31096": p("GA", "Wrightsville"),
  "31032": p("GA", "Gray"),
  "31033": p("GA", "Haddock"),
  "30204": p("GA", "Barnesville"),
  "30257": p("GA", "Milner"),
  "31635": p("GA", "Lakeland"),
  "31649": p("GA", "Stockton"),
  "30454": p("GA", "Rockledge"),
  "31009": p("GA", "Cadwell"),
  "31019": p("GA", "Dexter"),
  "31021": p("GA", "Dublin"),
  "31022": p("GA", "Dudley"),
  "31027": p("GA", "East Dublin"),
  "31040": p("GA", "Dublin"),
  "31065": p("GA", "Montrose"),
  "31075": p("GA", "Rentz"),
  "31763": p("GA", "Leesburg"),
  "31787": p("GA", "Smithville"),
  "31301": p("GA", "Allenhurst"),
  "31309": p("GA", "Fleming"),
  "31310": p("GA", "Hinesville"),
  "31313": p("GA", "Hinesville"),
  "31314": p("GA", "Fort Stewart"),
  "31315": p("GA", "Fort Stewart"),
  "31320": p("GA", "Midway"),
  "31323": p("GA", "Riceboro"),
  "31333": p("GA", "Walthourville"),
  "30817": p("GA", "Lincolnton"),
  "31316": p("GA", "Ludowici"),
  "31601": p("GA", "Valdosta"),
  "31602": p("GA", "Valdosta"),
  "31603": p("GA", "Valdosta"),
  "31604": p("GA", "Valdosta"),
  "31605": p("GA", "Valdosta"),
  "31606": p("GA", "Valdosta"),
  "31632": p("GA", "Hahira"),
  "31636": p("GA", "Lake Park"),
  "31641": p("GA", "Naylor"),
  "31698": p("GA", "Valdosta"),
  "31699": p("GA", "Moody Afb"),
  "30533": p("GA", "Dahlonega"),
  "30597": p("GA", "Dahlonega"),
  "30806": p("GA", "Boneville"),
  "30808": p("GA", "Dearing"),
  "30824": p("GA", "Thomson"),
  "31304": p("GA", "Crescent"),
  "31305": p("GA", "Darien"),
  "31319": p("GA", "Meridian"),
  "31327": p("GA", "Sapelo Island"),
  "31331": p("GA", "Townsend"),
  "31041": p("GA", "Ideal"),
  "31057": p("GA", "Marshallville"),
  "31068": p("GA", "Oglethorpe"),
  "30627": p("GA", "Carlton"),
  "30628": p("GA", "Colbert"),
  "30629": p("GA", "Comer"),
  "30633": p("GA", "Danielsville"),
  "30646": p("GA", "Hull"),
  "30647": p("GA", "Ila"),
  "31803": p("GA", "Buena Vista"),
  "30218": p("GA", "Gay"),
  "30222": p("GA", "Greenville"),
  "30251": p("GA", "Luthersville"),
  "30293": p("GA", "Woodbury"),
  "31816": p("GA", "Manchester"),
  "31830": p("GA", "Warm Springs"),
  "39817": p("GA", "Bainbridge"),
  "31716": p("GA", "Baconton"),
  "31730": p("GA", "Camilla"),
  "31739": p("GA", "Cotton"),
  "31779": p("GA", "Pelham"),
  "31784": p("GA", "Sale City"),
  "31004": p("GA", "Bolingbroke"),
  "31016": p("GA", "Culloden"),
  "31029": p("GA", "Forsyth"),
  "31046": p("GA", "Juliette"),
  "31086": p("GA", "Smarr"),
  "30410": p("GA", "Ailey"),
  "30412": p("GA", "Alston"),
  "30445": p("GA", "Mount Vernon"),
  "30470": p("GA", "Tarrytown"),
  "30473": p("GA", "Uvalda"),
  "30623": p("GA", "Bostwick"),
  "30625": p("GA", "Buckhead"),
  "30645": p("GA", "High Shoals"),
  "30650": p("GA", "Madison"),
  "30663": p("GA", "Rutledge"),
  "30705": p("GA", "Chatsworth"),
  "30708": p("GA", "Cisco"),
  "30711": p("GA", "Crandall"),
  "30724": p("GA", "Eton"),
  "30751": p("GA", "Tennga"),
  "31808": p("GA", "Fortson"),
  "31820": p("GA", "Midland"),
  "31829": p("GA", "Upatoi"),
  "31901": p("GA", "Columbus"),
  "31902": p("GA", "Columbus"),
  "31903": p("GA", "Columbus"),
  "31904": p("GA", "Columbus"),
  "31905": p("GA", "Fort Benning"),
  "31906": p("GA", "Columbus"),
  "31907": p("GA", "Columbus"),
  "31908": p("GA", "Columbus"),
  "31909": p("GA", "Columbus"),
  "31914": p("GA", "Columbus"),
  "31917": p("GA", "Columbus"),
  "31993": p("GA", "Columbus"),
  "31995": p("GA", "Fort Benning"),
  "31997": p("GA", "Columbus"),
  "31998": p("GA", "Columbus"),
  "31999": p("GA", "Columbus"),
  "30014": p("GA", "Covington"),
  "30015": p("GA", "Covington"),
  "30016": p("GA", "Covington"),
  "30054": p("GA", "Oxford"),
  "30056": p("GA", "Newborn"),
  "30070": p("GA", "Porterdale"),
  "30621": p("GA", "Bishop"),
  "30622": p("GA", "Bogart"),
  "30638": p("GA", "Farmington"),
  "30677": p("GA", "Watkinsville"),
  "30619": p("GA", "Arnoldsville"),
  "30630": p("GA", "Crawford"),
  "30648": p("GA", "Lexington"),
  "30667": p("GA", "Stephens"),
  "30671": p("GA", "Maxeys"),
  "30132": p("GA", "Dallas"),
  "30141": p("GA", "Hiram"),
  "30157": p("GA", "Dallas"),
  "31008": p("GA", "Byron"),
  "31030": p("GA", "Fort Valley"),
  "30143": p("GA", "Jasper"),
  "30148": p("GA", "Marble Hill"),
  "30175": p("GA", "Talking Rock"),
  "30177": p("GA", "Tate"),
  "31516": p("GA", "Blackshear"),
  "31518": p("GA", "Bristol"),
  "31551": p("GA", "Mershon"),
  "31556": p("GA", "Offerman"),
  "31557": p("GA", "Patterson"),
  "30206": p("GA", "Concord"),
  "30256": p("GA", "Meansville"),
  "30258": p("GA", "Molena"),
  "30292": p("GA", "Williamson"),
  "30295": p("GA", "Zebulon"),
  "30104": p("GA", "Aragon"),
  "30125": p("GA", "Cedartown"),
  "30138": p("GA", "Esom Hill"),
  "30153": p("GA", "Rockmart"),
  "31036": p("GA", "Hawkinsville"),
  "31024": p("GA", "Eatonton"),
  "31026": p("GA", "Eatonton"),
  "30525": p("GA", "Clayton"),
  "30537": p("GA", "Dillard"),
  "30552": p("GA", "Lakemont"),
  "30562": p("GA", "Mountain City"),
  "30568": p("GA", "Rabun Gap"),
  "30573": p("GA", "Tallulah Falls"),
  "30576": p("GA", "Tiger"),
  "30581": p("GA", "Wiley"),
  "30805": p("GA", "Blythe"),
  "30812": p("GA", "Gracewood"),
  "30815": p("GA", "Hephzibah"),
  "30901": p("GA", "Augusta"),
  "30903": p("GA", "Augusta"),
  "30904": p("GA", "Augusta"),
  "30905": p("GA", "Augusta"),
  "30906": p("GA", "Augusta"),
  "30907": p("GA", "Augusta"),
  "30909": p("GA", "Augusta"),
  "30912": p("GA", "Augusta"),
  "30914": p("GA", "Augusta"),
  "30916": p("GA", "Augusta"),
  "30919": p("GA", "Augusta"),
  "30999": p("GA", "Augusta"),
  "30012": p("GA", "Conyers"),
  "30013": p("GA", "Conyers"),
  "30094": p("GA", "Conyers"),
  "31806": p("GA", "Ellaville"),
  "30424": p("GA", "Dover"),
  "30446": p("GA", "Newington"),
  "30449": p("GA", "Oliver"),
  "30455": p("GA", "Rocky Ford"),
  "30467": p("GA", "Sylvania"),
  "39825": p("GA", "Brinson"),
  "39859": p("GA", "Iron City"),
  "39861": p("GA", "Jakin"),
  "30212": p("GA", "Experiment"),
  "30223": p("GA", "Griffin"),
  "30224": p("GA", "Griffin"),
  "30266": p("GA", "Orchard Hill"),
  "30284": p("GA", "Sunny Side"),
  "30538": p("GA", "Eastanollee"),
  "30557": p("GA", "Martin"),
  "30577": p("GA", "Toccoa"),
  "30598": p("GA", "Toccoa Falls"),
  "31814": p("GA", "Louvale"),
  "31815": p("GA", "Lumpkin"),
  "31821": p("GA", "Omaha"),
  "31825": p("GA", "Richland"),
  "31709": p("GA", "Americus"),
  "31711": p("GA", "Andersonville"),
  "31719": p("GA", "Americus"),
  "31735": p("GA", "Cobb"),
  "31743": p("GA", "De Soto"),
  "31764": p("GA", "Leslie"),
  "31780": p("GA", "Plains"),
  "31801": p("GA", "Box Springs"),
  "31810": p("GA", "Geneva"),
  "31812": p("GA", "Junction City"),
  "31827": p("GA", "Talbotton"),
  "31836": p("GA", "Woodland"),
  "30631": p("GA", "Crawfordville"),
  "30664": p("GA", "Sharon"),
  "30420": p("GA", "Cobbtown"),
  "30421": p("GA", "Collins"),
  "30427": p("GA", "Glennville"),
  "30438": p("GA", "Manassas"),
  "30453": p("GA", "Reidsville"),
  "30499": p("GA", "Reidsville"),
  "31006": p("GA", "Butler"),
  "31039": p("GA", "Howard"),
  "31058": p("GA", "Mauk"),
  "31076": p("GA", "Reynolds"),
  "31081": p("GA", "Rupert"),
  "31037": p("GA", "Mc Rae Helena"),
  "31055": p("GA", "Mc Rae Helena"),
  "31060": p("GA", "Milan"),
  "31083": p("GA", "Scotland"),
  "31544": p("GA", "Jacksonville"),
  "31549": p("GA", "Lumber City"),
  "39826": p("GA", "Bronwood"),
  "39828": p("GA", "Cairo"),
  "39885": p("GA", "Sasser"),
  "31626": p("GA", "Boston"),
  "31738": p("GA", "Coolidge"),
  "31757": p("GA", "Thomasville"),
  "31758": p("GA", "Thomasville"),
  "31765": p("GA", "Meigs"),
  "31773": p("GA", "Ochlocknee"),
  "31778": p("GA", "Pavo"),
  "31792": p("GA", "Thomasville"),
  "31799": p("GA", "Thomasville"),
  "31727": p("GA", "Brookfield"),
  "31733": p("GA", "Chula"),
  "31775": p("GA", "Omega"),
  "31793": p("GA", "Tifton"),
  "31794": p("GA", "Tifton"),
  "31795": p("GA", "Ty Ty"),
  "30436": p("GA", "Lyons"),
  "30474": p("GA", "Vidalia"),
  "30475": p("GA", "Vidalia"),
  "30546": p("GA", "Hiawassee"),
  "30582": p("GA", "Young Harris"),
  "30457": p("GA", "Soperton"),
  "30230": p("GA", "Hogansville"),
  "30240": p("GA", "Lagrange"),
  "30241": p("GA", "Lagrange"),
  "30261": p("GA", "Lagrange"),
  "31833": p("GA", "West Point"),
  "31714": p("GA", "Ashburn"),
  "31783": p("GA", "Rebecca"),
  "31790": p("GA", "Sycamore"),
  "31017": p("GA", "Danville"),
  "31020": p("GA", "Dry Branch"),
  "31044": p("GA", "Jeffersonville"),
  "30512": p("GA", "Blairsville"),
  "30514": p("GA", "Blairsville"),
  "30572": p("GA", "Suches"),
  "30285": p("GA", "The Rock"),
  "30286": p("GA", "Thomaston"),
  "31097": p("GA", "Yatesville"),
  "30707": p("GA", "Chickamauga"),
  "30725": p("GA", "Flintstone"),
  "30728": p("GA", "La Fayette"),
  "30739": p("GA", "Rock Spring"),
  "30741": p("GA", "Rossville"),
  "30750": p("GA", "Lookout Mountain"),
  "30018": p("GA", "Jersey"),
  "30025": p("GA", "Social Circle"),
  "30641": p("GA", "Good Hope"),
  "30655": p("GA", "Monroe"),
  "30656": p("GA", "Monroe"),
  "31501": p("GA", "Waycross"),
  "31502": p("GA", "Waycross"),
  "31503": p("GA", "Waycross"),
  "31550": p("GA", "Manor"),
  "31552": p("GA", "Millwood"),
  "31564": p("GA", "Waresboro"),
  "30807": p("GA", "Camak"),
  "30819": p("GA", "Mesena"),
  "30821": p("GA", "Norwood"),
  "30828": p("GA", "Warrenton"),
  "31045": p("GA", "Jewell"),
  "31018": p("GA", "Davisboro"),
  "31035": p("GA", "Harrison"),
  "31067": p("GA", "Oconee"),
  "31082": p("GA", "Sandersville"),
  "31089": p("GA", "Tennille"),
  "31094": p("GA", "Warthen"),
  "31545": p("GA", "Jesup"),
  "31546": p("GA", "Jesup"),
  "31555": p("GA", "Odum"),
  "31560": p("GA", "Screven"),
  "31598": p("GA", "Jesup"),
  "31599": p("GA", "Jesup"),
  "31824": p("GA", "Preston"),
  "31832": p("GA", "Weston"),
  "39877": p("GA", "Parrott"),
  "30411": p("GA", "Alamo"),
  "30428": p("GA", "Glenwood"),
  "30528": p("GA", "Cleveland"),
  "30545": p("GA", "Helen"),
  "30571": p("GA", "Sautee Nacoochee"),
  "30270": p("GA", "Peachtree City"),
  "30710": p("GA", "Cohutta"),
  "30719": p("GA", "Dalton"),
  "30720": p("GA", "Dalton"),
  "30721": p("GA", "Dalton"),
  "30722": p("GA", "Dalton"),
  "30740": p("GA", "Rocky Face"),
  "30755": p("GA", "Tunnel Hill"),
  "30756": p("GA", "Varnell"),
  "31001": p("GA", "Abbeville"),
  "31071": p("GA", "Pineview"),
  "31072": p("GA", "Pitts"),
  "31079": p("GA", "Rochelle"),
  "31084": p("GA", "Seville"),
  "30660": p("GA", "Rayle"),
  "30668": p("GA", "Tignall"),
  "30673": p("GA", "Washington"),
  "31003": p("GA", "Allentown"),
  "31031": p("GA", "Gordon"),
  "31042": p("GA", "Irwinton"),
  "31054": p("GA", "Mc Intyre"),
  "31090": p("GA", "Toomsboro"),
  "31772": p("GA", "Oakfield"),
  "31781": p("GA", "Poulan"),
  "31789": p("GA", "Sumner"),
  "31791": p("GA", "Sylvester"),
  "31796": p("GA", "Warwick"),
  "96704": p("HI", "Captain Cook"),
  "96710": p("HI", "Hakalau"),
  "96718": p("HI", "Hawaii National Park"),
  "96719": p("HI", "Hawi"),
  "96720": p("HI", "Hilo"),
  "96721": p("HI", "Hilo"),
  "96725": p("HI", "Holualoa"),
  "96726": p("HI", "Honaunau"),
  "96727": p("HI", "Honokaa"),
  "96728": p("HI", "Honomu"),
  "96737": p("HI", "Ocean View"),
  "96738": p("HI", "Waikoloa"),
  "96739": p("HI", "Keauhou"),
  "96740": p("HI", "Kailua Kona"),
  "96743": p("HI", "Kamuela"),
  "96745": p("HI", "Kailua Kona"),
  "96749": p("HI", "Keaau"),
  "96750": p("HI", "Kealakekua"),
  "96755": p("HI", "Kapaau"),
  "96760": p("HI", "Kurtistown"),
  "96764": p("HI", "Laupahoehoe"),
  "96771": p("HI", "Mountain View"),
  "96772": p("HI", "Naalehu"),
  "96773": p("HI", "Ninole"),
  "96774": p("HI", "Ookala"),
  "96776": p("HI", "Paauilo"),
  "96777": p("HI", "Pahala"),
  "96778": p("HI", "Pahoa"),
  "96780": p("HI", "Papaaloa"),
  "96781": p("HI", "Papaikou"),
  "96783": p("HI", "Pepeekeo"),
  "96785": p("HI", "Volcano"),
  "96701": p("HI", "Aiea"),
  "96706": p("HI", "Ewa Beach"),
  "96707": p("HI", "Kapolei"),
  "96709": p("HI", "Kapolei"),
  "96712": p("HI", "Haleiwa"),
  "96717": p("HI", "Hauula"),
  "96730": p("HI", "Kaaawa"),
  "96731": p("HI", "Kahuku"),
  "96734": p("HI", "Kailua"),
  "96744": p("HI", "Kaneohe"),
  "96759": p("HI", "Kunia"),
  "96762": p("HI", "Laie"),
  "96782": p("HI", "Pearl City"),
  "96786": p("HI", "Wahiawa"),
  "96789": p("HI", "Mililani"),
  "96791": p("HI", "Waialua"),
  "96792": p("HI", "Waianae"),
  "96795": p("HI", "Waimanalo"),
  "96797": p("HI", "Waipahu"),
  "96801": p("HI", "Honolulu"),
  "96802": p("HI", "Honolulu"),
  "96803": p("HI", "Honolulu"),
  "96804": p("HI", "Honolulu"),
  "96805": p("HI", "Honolulu"),
  "96806": p("HI", "Honolulu"),
  "96807": p("HI", "Honolulu"),
  "96808": p("HI", "Honolulu"),
  "96809": p("HI", "Honolulu"),
  "96810": p("HI", "Honolulu"),
  "96811": p("HI", "Honolulu"),
  "96812": p("HI", "Honolulu"),
  "96813": p("HI", "Honolulu"),
  "96814": p("HI", "Honolulu"),
  "96815": p("HI", "Honolulu"),
  "96816": p("HI", "Honolulu"),
  "96817": p("HI", "Honolulu"),
  "96818": p("HI", "Honolulu"),
  "96819": p("HI", "Honolulu"),
  "96820": p("HI", "Honolulu"),
  "96821": p("HI", "Honolulu"),
  "96822": p("HI", "Honolulu"),
  "96823": p("HI", "Honolulu"),
  "96824": p("HI", "Honolulu"),
  "96825": p("HI", "Honolulu"),
  "96826": p("HI", "Honolulu"),
  "96828": p("HI", "Honolulu"),
  "96830": p("HI", "Honolulu"),
  "96836": p("HI", "Honolulu"),
  "96837": p("HI", "Honolulu"),
  "96838": p("HI", "Honolulu"),
  "96839": p("HI", "Honolulu"),
  "96840": p("HI", "Honolulu"),
  "96841": p("HI", "Honolulu"),
  "96843": p("HI", "Honolulu"),
  "96844": p("HI", "Honolulu"),
  "96846": p("HI", "Honolulu"),
  "96847": p("HI", "Honolulu"),
  "96848": p("HI", "Honolulu"),
  "96849": p("HI", "Honolulu"),
  "96850": p("HI", "Honolulu"),
  "96853": p("HI", "Jbphh"),
  "96854": p("HI", "Wheeler Army Airfield"),
  "96857": p("HI", "Schofield Barracks"),
  "96858": p("HI", "Fort Shafter"),
  "96859": p("HI", "Tripler Army Medical Center"),
  "96860": p("HI", "Jbphh"),
  "96861": p("HI", "Camp H M Smith"),
  "96863": p("HI", "Mcbh Kaneohe Bay"),
  "96898": p("HI", "Wake Island"),
  "96703": p("HI", "Anahola"),
  "96705": p("HI", "Eleele"),
  "96714": p("HI", "Hanalei"),
  "96715": p("HI", "Hanamaulu"),
  "96716": p("HI", "Hanapepe"),
  "96722": p("HI", "Princeville"),
  "96741": p("HI", "Kalaheo"),
  "96746": p("HI", "Kapaa"),
  "96747": p("HI", "Kaumakani"),
  "96751": p("HI", "Kealia"),
  "96752": p("HI", "Kekaha"),
  "96754": p("HI", "Kilauea"),
  "96756": p("HI", "Koloa"),
  "96765": p("HI", "Lawai"),
  "96766": p("HI", "Lihue"),
  "96769": p("HI", "Makaweli"),
  "96796": p("HI", "Waimea"),
  "96708": p("HI", "Haiku"),
  "96713": p("HI", "Hana"),
  "96729": p("HI", "Hoolehua"),
  "96732": p("HI", "Kahului"),
  "96733": p("HI", "Kahului"),
  "96742": p("HI", "Kalaupapa"),
  "96748": p("HI", "Kaunakakai"),
  "96753": p("HI", "Kihei"),
  "96757": p("HI", "Kualapuu"),
  "96761": p("HI", "Lahaina"),
  "96763": p("HI", "Lanai City"),
  "96767": p("HI", "Lahaina"),
  "96768": p("HI", "Makawao"),
  "96770": p("HI", "Maunaloa"),
  "96779": p("HI", "Paia"),
  "96784": p("HI", "Puunene"),
  "96788": p("HI", "Pukalani"),
  "96790": p("HI", "Kula"),
  "96793": p("HI", "Wailuku"),
  "50002": p("IA", "Adair"),
  "50837": p("IA", "Bridgewater"),
  "50846": p("IA", "Fontanelle"),
  "50849": p("IA", "Greenfield"),
  "50858": p("IA", "Orient"),
  "50839": p("IA", "Carbon"),
  "50841": p("IA", "Corning"),
  "50857": p("IA", "Nodaway"),
  "50859": p("IA", "Prescott"),
  "52140": p("IA", "Dorchester"),
  "52146": p("IA", "Harpers Ferry"),
  "52151": p("IA", "Lansing"),
  "52160": p("IA", "New Albin"),
  "52162": p("IA", "Postville"),
  "52170": p("IA", "Waterville"),
  "52172": p("IA", "Waukon"),
  "52544": p("IA", "Centerville"),
  "52549": p("IA", "Cincinnati"),
  "52555": p("IA", "Exline"),
  "52571": p("IA", "Moravia"),
  "52572": p("IA", "Moulton"),
  "52574": p("IA", "Mystic"),
  "52581": p("IA", "Plano"),
  "52593": p("IA", "Udell"),
  "52594": p("IA", "Unionville"),
  "50025": p("IA", "Audubon"),
  "50042": p("IA", "Brayton"),
  "50076": p("IA", "Exira"),
  "50110": p("IA", "Gray"),
  "50117": p("IA", "Hamlin"),
  "51543": p("IA", "Kimballton"),
  "52206": p("IA", "Atkins"),
  "52208": p("IA", "Belle Plaine"),
  "52209": p("IA", "Blairstown"),
  "52229": p("IA", "Garrison"),
  "52249": p("IA", "Keystone"),
  "52257": p("IA", "Luzerne"),
  "52313": p("IA", "Mount Auburn"),
  "52315": p("IA", "Newhall"),
  "52318": p("IA", "Norway"),
  "52332": p("IA", "Shellsburg"),
  "52345": p("IA", "Urbana"),
  "52346": p("IA", "Van Horne"),
  "52349": p("IA", "Vinton"),
  "52351": p("IA", "Walford"),
  "52354": p("IA", "Watkins"),
  "50613": p("IA", "Cedar Falls"),
  "50614": p("IA", "Cedar Falls"),
  "50623": p("IA", "Dewar"),
  "50626": p("IA", "Dunkerton"),
  "50634": p("IA", "Gilbertville"),
  "50643": p("IA", "Hudson"),
  "50651": p("IA", "La Porte City"),
  "50667": p("IA", "Raymond"),
  "50701": p("IA", "Waterloo"),
  "50702": p("IA", "Waterloo"),
  "50703": p("IA", "Waterloo"),
  "50704": p("IA", "Waterloo"),
  "50707": p("IA", "Evansdale"),
  "50031": p("IA", "Beaver"),
  "50036": p("IA", "Boone"),
  "50037": p("IA", "Boone"),
  "50040": p("IA", "Boxholm"),
  "50099": p("IA", "Boone"),
  "50152": p("IA", "Luther"),
  "50156": p("IA", "Madrid"),
  "50212": p("IA", "Ogden"),
  "50223": p("IA", "Pilot Mound"),
  "50622": p("IA", "Denver"),
  "50631": p("IA", "Frederika"),
  "50647": p("IA", "Janesville"),
  "50666": p("IA", "Plainfield"),
  "50668": p("IA", "Readlyn"),
  "50674": p("IA", "Sumner"),
  "50676": p("IA", "Tripoli"),
  "50677": p("IA", "Waverly"),
  "50607": p("IA", "Aurora"),
  "50629": p("IA", "Fairbank"),
  "50641": p("IA", "Hazleton"),
  "50644": p("IA", "Independence"),
  "50648": p("IA", "Jesup"),
  "50650": p("IA", "Lamont"),
  "50671": p("IA", "Stanley"),
  "50682": p("IA", "Winthrop"),
  "52210": p("IA", "Brandon"),
  "52326": p("IA", "Quasqueton"),
  "52329": p("IA", "Rowley"),
  "50510": p("IA", "Albert City"),
  "50565": p("IA", "Marathon"),
  "50568": p("IA", "Newell"),
  "50576": p("IA", "Rembrandt"),
  "50585": p("IA", "Sioux Rapids"),
  "50588": p("IA", "Storm Lake"),
  "50592": p("IA", "Truesdale"),
  "51002": p("IA", "Alta"),
  "51033": p("IA", "Linn Grove"),
  "50602": p("IA", "Allison"),
  "50604": p("IA", "Aplington"),
  "50605": p("IA", "Aredale"),
  "50608": p("IA", "Austinville"),
  "50611": p("IA", "Bristow"),
  "50619": p("IA", "Clarksville"),
  "50625": p("IA", "Dumont"),
  "50636": p("IA", "Greene"),
  "50649": p("IA", "Kesley"),
  "50660": p("IA", "New Hartford"),
  "50665": p("IA", "Parkersburg"),
  "50670": p("IA", "Shell Rock"),
  "50538": p("IA", "Farnhamville"),
  "50551": p("IA", "Jolley"),
  "50552": p("IA", "Knierim"),
  "50561": p("IA", "Lytton"),
  "50563": p("IA", "Manson"),
  "50575": p("IA", "Pomeroy"),
  "50579": p("IA", "Rockwell City"),
  "50586": p("IA", "Somers"),
  "51449": p("IA", "Lake City"),
  "51453": p("IA", "Lohrville"),
  "50058": p("IA", "Coon Rapids"),
  "51401": p("IA", "Carroll"),
  "51430": p("IA", "Arcadia"),
  "51436": p("IA", "Breda"),
  "51440": p("IA", "Dedham"),
  "51443": p("IA", "Glidden"),
  "51444": p("IA", "Halbur"),
  "51451": p("IA", "Lanesboro"),
  "51452": p("IA", "Lidderdale"),
  "51455": p("IA", "Manning"),
  "51459": p("IA", "Ralston"),
  "51463": p("IA", "Templeton"),
  "50020": p("IA", "Anita"),
  "50022": p("IA", "Atlantic"),
  "50274": p("IA", "Wiota"),
  "50843": p("IA", "Cumberland"),
  "50853": p("IA", "Massena"),
  "51535": p("IA", "Griswold"),
  "51544": p("IA", "Lewis"),
  "51552": p("IA", "Marne"),
  "52216": p("IA", "Clarence"),
  "52255": p("IA", "Lowden"),
  "52306": p("IA", "Mechanicsville"),
  "52337": p("IA", "Stanwood"),
  "52358": p("IA", "West Branch"),
  "52721": p("IA", "Bennett"),
  "52747": p("IA", "Durant"),
  "52772": p("IA", "Tipton"),
  "50401": p("IA", "Mason City"),
  "50402": p("IA", "Mason City"),
  "50428": p("IA", "Clear Lake"),
  "50433": p("IA", "Dougherty"),
  "50457": p("IA", "Meservey"),
  "50464": p("IA", "Plymouth"),
  "50467": p("IA", "Rock Falls"),
  "50469": p("IA", "Rockwell"),
  "50477": p("IA", "Swaledale"),
  "50479": p("IA", "Thornton"),
  "50482": p("IA", "Ventura"),
  "51005": p("IA", "Aurelia"),
  "51012": p("IA", "Cherokee"),
  "51014": p("IA", "Cleghorn"),
  "51029": p("IA", "Larrabee"),
  "51035": p("IA", "Marcus"),
  "51037": p("IA", "Meriden"),
  "51049": p("IA", "Quimby"),
  "51061": p("IA", "Washta"),
  "50603": p("IA", "Alta Vista"),
  "50630": p("IA", "Fredericksburg"),
  "50645": p("IA", "Ionia"),
  "50658": p("IA", "Nashua"),
  "50659": p("IA", "New Hampton"),
  "50661": p("IA", "North Washington"),
  "52154": p("IA", "Lawler"),
  "50174": p("IA", "Murray"),
  "50213": p("IA", "Osceola"),
  "50275": p("IA", "Woodburn"),
  "51047": p("IA", "Peterson"),
  "51301": p("IA", "Spencer"),
  "51333": p("IA", "Dickens"),
  "51338": p("IA", "Everly"),
  "51340": p("IA", "Fostoria"),
  "51341": p("IA", "Gillett Grove"),
  "51343": p("IA", "Greenville"),
  "51357": p("IA", "Royal"),
  "51366": p("IA", "Webb"),
  "52042": p("IA", "Edgewood"),
  "52043": p("IA", "Elkader"),
  "52044": p("IA", "Elkport"),
  "52047": p("IA", "Farmersburg"),
  "52048": p("IA", "Garber"),
  "52049": p("IA", "Garnavillo"),
  "52052": p("IA", "Guttenberg"),
  "52066": p("IA", "North Buena Vista"),
  "52072": p("IA", "Saint Olaf"),
  "52076": p("IA", "Strawberry Point"),
  "52077": p("IA", "Volga"),
  "52156": p("IA", "Luana"),
  "52157": p("IA", "Mc Gregor"),
  "52158": p("IA", "Marquette"),
  "52159": p("IA", "Monona"),
  "52037": p("IA", "Delmar"),
  "52254": p("IA", "Lost Nation"),
  "52701": p("IA", "Andover"),
  "52727": p("IA", "Bryant"),
  "52729": p("IA", "Calamus"),
  "52730": p("IA", "Camanche"),
  "52731": p("IA", "Charlotte"),
  "52732": p("IA", "Clinton"),
  "52733": p("IA", "Clinton"),
  "52734": p("IA", "Clinton"),
  "52736": p("IA", "Clinton"),
  "52742": p("IA", "De Witt"),
  "52750": p("IA", "Goose Lake"),
  "52751": p("IA", "Grand Mound"),
  "52757": p("IA", "Low Moor"),
  "52771": p("IA", "Teeds Grove"),
  "52774": p("IA", "Welton"),
  "52777": p("IA", "Wheatland"),
  "51432": p("IA", "Aspinwall"),
  "51439": p("IA", "Charter Oak"),
  "51441": p("IA", "Deloit"),
  "51442": p("IA", "Denison"),
  "51448": p("IA", "Kiron"),
  "51454": p("IA", "Manilla"),
  "51460": p("IA", "Ricketts"),
  "51461": p("IA", "Schleswig"),
  "51465": p("IA", "Vail"),
  "51467": p("IA", "Westside"),
  "51520": p("IA", "Arion"),
  "51528": p("IA", "Dow City"),
  "50003": p("IA", "Adel"),
  "50038": p("IA", "Booneville"),
  "50039": p("IA", "Bouton"),
  "50063": p("IA", "Dallas Center"),
  "50066": p("IA", "Dawson"),
  "50069": p("IA", "De Soto"),
  "50070": p("IA", "Dexter"),
  "50109": p("IA", "Granger"),
  "50146": p("IA", "Linden"),
  "50167": p("IA", "Minburn"),
  "50220": p("IA", "Perry"),
  "50233": p("IA", "Redfield"),
  "50261": p("IA", "Van Meter"),
  "50263": p("IA", "Waukee"),
  "50276": p("IA", "Woodward"),
  "52537": p("IA", "Bloomfield"),
  "52552": p("IA", "Drakesville"),
  "52560": p("IA", "Floris"),
  "52584": p("IA", "Pulaski"),
  "50065": p("IA", "Davis City"),
  "50067": p("IA", "Decatur"),
  "50103": p("IA", "Garden Grove"),
  "50108": p("IA", "Grand River"),
  "50140": p("IA", "Lamoni"),
  "50144": p("IA", "Leon"),
  "50262": p("IA", "Van Wert"),
  "50264": p("IA", "Weldon"),
  "50654": p("IA", "Masonville"),
  "52035": p("IA", "Colesburg"),
  "52036": p("IA", "Delaware"),
  "52038": p("IA", "Dundee"),
  "52041": p("IA", "Earlville"),
  "52050": p("IA", "Greeley"),
  "52057": p("IA", "Manchester"),
  "52223": p("IA", "Delhi"),
  "52237": p("IA", "Hopkinton"),
  "52330": p("IA", "Ryan"),
  "52601": p("IA", "Burlington"),
  "52623": p("IA", "Danville"),
  "52637": p("IA", "Mediapolis"),
  "52638": p("IA", "Middletown"),
  "52650": p("IA", "Sperry"),
  "52655": p("IA", "West Burlington"),
  "52660": p("IA", "Yarmouth"),
  "51331": p("IA", "Arnolds Park"),
  "51347": p("IA", "Lake Park"),
  "51351": p("IA", "Milford"),
  "51355": p("IA", "Okoboji"),
  "51360": p("IA", "Spirit Lake"),
  "51363": p("IA", "Superior"),
  "51364": p("IA", "Terril"),
  "52001": p("IA", "Dubuque"),
  "52002": p("IA", "Dubuque"),
  "52003": p("IA", "Dubuque"),
  "52004": p("IA", "Dubuque"),
  "52032": p("IA", "Bernard"),
  "52033": p("IA", "Cascade"),
  "52039": p("IA", "Durango"),
  "52040": p("IA", "Dyersville"),
  "52045": p("IA", "Epworth"),
  "52046": p("IA", "Farley"),
  "52053": p("IA", "Holy Cross"),
  "52056": p("IA", "Luxemburg"),
  "52065": p("IA", "New Vienna"),
  "52068": p("IA", "Peosta"),
  "52073": p("IA", "Sherrill"),
  "52078": p("IA", "Worthington"),
  "52079": p("IA", "Zwingle"),
  "52099": p("IA", "Dubuque"),
  "50514": p("IA", "Armstrong"),
  "50531": p("IA", "Dolliver"),
  "50578": p("IA", "Ringsted"),
  "51334": p("IA", "Estherville"),
  "51365": p("IA", "Wallingford"),
  "50606": p("IA", "Arlington"),
  "50655": p("IA", "Maynard"),
  "50662": p("IA", "Oelwein"),
  "50664": p("IA", "Oran"),
  "50681": p("IA", "Westgate"),
  "52135": p("IA", "Clermont"),
  "52141": p("IA", "Elgin"),
  "52142": p("IA", "Fayette"),
  "52147": p("IA", "Hawkeye"),
  "52164": p("IA", "Randalia"),
  "52166": p("IA", "Saint Lucas"),
  "52169": p("IA", "Wadena"),
  "52171": p("IA", "Waucoma"),
  "52175": p("IA", "West Union"),
  "50435": p("IA", "Floyd"),
  "50458": p("IA", "Nora Springs"),
  "50468": p("IA", "Rockford"),
  "50471": p("IA", "Rudd"),
  "50616": p("IA", "Charles City"),
  "50620": p("IA", "Colwell"),
  "50653": p("IA", "Marble Rock"),
  "50041": p("IA", "Bradford"),
  "50227": p("IA", "Popejoy"),
  "50420": p("IA", "Alexander"),
  "50427": p("IA", "Chapin"),
  "50431": p("IA", "Coulter"),
  "50441": p("IA", "Hampton"),
  "50452": p("IA", "Latimer"),
  "50475": p("IA", "Sheffield"),
  "50633": p("IA", "Geneva"),
  "51639": p("IA", "Farragut"),
  "51640": p("IA", "Hamburg"),
  "51645": p("IA", "Imogene"),
  "51648": p("IA", "Percival"),
  "51649": p("IA", "Randolph"),
  "51650": p("IA", "Riverton"),
  "51652": p("IA", "Sidney"),
  "51653": p("IA", "Tabor"),
  "51654": p("IA", "Thurman"),
  "50050": p("IA", "Churdan"),
  "50059": p("IA", "Cooper"),
  "50064": p("IA", "Dana"),
  "50107": p("IA", "Grand Junction"),
  "50129": p("IA", "Jefferson"),
  "50217": p("IA", "Paton"),
  "50235": p("IA", "Rippey"),
  "51462": p("IA", "Scranton"),
  "50609": p("IA", "Beaman"),
  "50621": p("IA", "Conrad"),
  "50624": p("IA", "Dike"),
  "50638": p("IA", "Grundy Center"),
  "50642": p("IA", "Holland"),
  "50657": p("IA", "Morrison"),
  "50669": p("IA", "Reinbeck"),
  "50673": p("IA", "Stout"),
  "50680": p("IA", "Wellsburg"),
  "50026": p("IA", "Bagley"),
  "50029": p("IA", "Bayard"),
  "50048": p("IA", "Casey"),
  "50115": p("IA", "Guthrie Center"),
  "50128": p("IA", "Jamaica"),
  "50164": p("IA", "Menlo"),
  "50216": p("IA", "Panora"),
  "50250": p("IA", "Stuart"),
  "50277": p("IA", "Yale"),
  "50034": p("IA", "Blairsburg"),
  "50075": p("IA", "Ellsworth"),
  "50130": p("IA", "Jewell"),
  "50132": p("IA", "Kamrar"),
  "50231": p("IA", "Randall"),
  "50246": p("IA", "Stanhope"),
  "50249": p("IA", "Stratford"),
  "50271": p("IA", "Williams"),
  "50595": p("IA", "Webster City"),
  "50423": p("IA", "Britt"),
  "50430": p("IA", "Corwith"),
  "50432": p("IA", "Crystal Lake"),
  "50438": p("IA", "Garner"),
  "50439": p("IA", "Goodell"),
  "50447": p("IA", "Kanawha"),
  "50449": p("IA", "Klemme"),
  "50484": p("IA", "Woden"),
  "50006": p("IA", "Alden"),
  "50043": p("IA", "Buckeye"),
  "50102": p("IA", "Garden City"),
  "50122": p("IA", "Hubbard"),
  "50126": p("IA", "Iowa Falls"),
  "50206": p("IA", "New Providence"),
  "50230": p("IA", "Radcliffe"),
  "50258": p("IA", "Union"),
  "50259": p("IA", "Gifford"),
  "50269": p("IA", "Whitten"),
  "50601": p("IA", "Ackley"),
  "50627": p("IA", "Eldora"),
  "50672": p("IA", "Steamboat Rock"),
  "51529": p("IA", "Dunlap"),
  "51545": p("IA", "Little Sioux"),
  "51546": p("IA", "Logan"),
  "51550": p("IA", "Magnolia"),
  "51555": p("IA", "Missouri Valley"),
  "51556": p("IA", "Modale"),
  "51557": p("IA", "Mondamin"),
  "51563": p("IA", "Persia"),
  "51564": p("IA", "Pisgah"),
  "51579": p("IA", "Woodbine"),
  "52630": p("IA", "Hillsboro"),
  "52641": p("IA", "Mount Pleasant"),
  "52642": p("IA", "Rome"),
  "52644": p("IA", "Mount Union"),
  "52645": p("IA", "New London"),
  "52647": p("IA", "Olds"),
  "52649": p("IA", "Salem"),
  "52652": p("IA", "Swedesburg"),
  "52654": p("IA", "Wayland"),
  "52659": p("IA", "Winfield"),
  "50466": p("IA", "Riceville"),
  "50628": p("IA", "Elma"),
  "52134": p("IA", "Chester"),
  "52136": p("IA", "Cresco"),
  "52155": p("IA", "Lime Springs"),
  "52163": p("IA", "Protivin"),
  "50519": p("IA", "Bode"),
  "50520": p("IA", "Bradgate"),
  "50529": p("IA", "Dakota City"),
  "50541": p("IA", "Gilmore City"),
  "50545": p("IA", "Hardy"),
  "50548": p("IA", "Humboldt"),
  "50558": p("IA", "Livermore"),
  "50570": p("IA", "Ottosen"),
  "50577": p("IA", "Renwick"),
  "50582": p("IA", "Rutland"),
  "50591": p("IA", "Thor"),
  "51006": p("IA", "Battle Creek"),
  "51020": p("IA", "Galva"),
  "51025": p("IA", "Holstein"),
  "51431": p("IA", "Arthur"),
  "51445": p("IA", "Ida Grove"),
  "52203": p("IA", "Amana"),
  "52204": p("IA", "Amana"),
  "52220": p("IA", "Conroy"),
  "52236": p("IA", "Homestead"),
  "52251": p("IA", "Ladora"),
  "52301": p("IA", "Marengo"),
  "52307": p("IA", "Middle Amana"),
  "52308": p("IA", "Millersburg"),
  "52316": p("IA", "North English"),
  "52325": p("IA", "Parnell"),
  "52334": p("IA", "South Amana"),
  "52347": p("IA", "Victor"),
  "52361": p("IA", "Williamsburg"),
  "52030": p("IA", "Andrew"),
  "52031": p("IA", "Bellevue"),
  "52054": p("IA", "La Motte"),
  "52060": p("IA", "Maquoketa"),
  "52064": p("IA", "Miles"),
  "52069": p("IA", "Preston"),
  "52070": p("IA", "Sabula"),
  "52071": p("IA", "Saint Donatus"),
  "52074": p("IA", "Spragueville"),
  "52075": p("IA", "Springbrook"),
  "52207": p("IA", "Baldwin"),
  "52309": p("IA", "Monmouth"),
  "50028": p("IA", "Baxter"),
  "50054": p("IA", "Colfax"),
  "50127": p("IA", "Ira"),
  "50135": p("IA", "Kellogg"),
  "50137": p("IA", "Killduff"),
  "50153": p("IA", "Lynnville"),
  "50168": p("IA", "Mingo"),
  "50170": p("IA", "Monroe"),
  "50208": p("IA", "Newton"),
  "50228": p("IA", "Prairie City"),
  "50232": p("IA", "Reasnor"),
  "50251": p("IA", "Sully"),
  "52533": p("IA", "Batavia"),
  "52556": p("IA", "Fairfield"),
  "52557": p("IA", "Fairfield"),
  "52567": p("IA", "Libertyville"),
  "52580": p("IA", "Packwood"),
  "52635": p("IA", "Lockridge"),
  "52235": p("IA", "Hills"),
  "52240": p("IA", "Iowa City"),
  "52241": p("IA", "Coralville"),
  "52242": p("IA", "Iowa City"),
  "52243": p("IA", "Iowa City"),
  "52244": p("IA", "Iowa City"),
  "52245": p("IA", "Iowa City"),
  "52246": p("IA", "Iowa City"),
  "52317": p("IA", "North Liberty"),
  "52322": p("IA", "Oxford"),
  "52333": p("IA", "Solon"),
  "52338": p("IA", "Swisher"),
  "52340": p("IA", "Tiffin"),
  "52755": p("IA", "Lone Tree"),
  "52205": p("IA", "Anamosa"),
  "52212": p("IA", "Center Junction"),
  "52252": p("IA", "Langworthy"),
  "52305": p("IA", "Martelle"),
  "52310": p("IA", "Monticello"),
  "52312": p("IA", "Morley"),
  "52320": p("IA", "Olin"),
  "52321": p("IA", "Onslow"),
  "52323": p("IA", "Oxford Junction"),
  "52362": p("IA", "Wyoming"),
  "50104": p("IA", "Gibson"),
  "50136": p("IA", "Keswick"),
  "50255": p("IA", "Thornburg"),
  "50268": p("IA", "What Cheer"),
  "52231": p("IA", "Harper"),
  "52248": p("IA", "Keota"),
  "52335": p("IA", "South English"),
  "52355": p("IA", "Webster"),
  "52550": p("IA", "Delta"),
  "52562": p("IA", "Hayesville"),
  "52563": p("IA", "Hedrick"),
  "52568": p("IA", "Martinsburg"),
  "52576": p("IA", "Ollie"),
  "52585": p("IA", "Richland"),
  "52591": p("IA", "Sigourney"),
  "50451": p("IA", "Lakota"),
  "50480": p("IA", "Titonka"),
  "50483": p("IA", "Wesley"),
  "50511": p("IA", "Algona"),
  "50517": p("IA", "Bancroft"),
  "50522": p("IA", "Burt"),
  "50539": p("IA", "Fenton"),
  "50556": p("IA", "Ledyard"),
  "50559": p("IA", "Lone Rock"),
  "50560": p("IA", "Lu Verne"),
  "50590": p("IA", "Swea City"),
  "50598": p("IA", "Whittemore"),
  "52619": p("IA", "Argyle"),
  "52624": p("IA", "Denmark"),
  "52625": p("IA", "Donnellson"),
  "52627": p("IA", "Fort Madison"),
  "52631": p("IA", "Houghton"),
  "52632": p("IA", "Keokuk"),
  "52639": p("IA", "Montrose"),
  "52648": p("IA", "Pilot Grove"),
  "52656": p("IA", "West Point"),
  "52657": p("IA", "Saint Paul"),
  "52658": p("IA", "Wever"),
  "52202": p("IA", "Alburnett"),
  "52213": p("IA", "Center Point"),
  "52214": p("IA", "Central City"),
  "52218": p("IA", "Coggon"),
  "52219": p("IA", "Prairieburg"),
  "52227": p("IA", "Ely"),
  "52228": p("IA", "Fairfax"),
  "52233": p("IA", "Hiawatha"),
  "52253": p("IA", "Lisbon"),
  "52302": p("IA", "Marion"),
  "52314": p("IA", "Mount Vernon"),
  "52324": p("IA", "Palo"),
  "52328": p("IA", "Robins"),
  "52336": p("IA", "Springville"),
  "52341": p("IA", "Toddville"),
  "52344": p("IA", "Troy Mills"),
  "52352": p("IA", "Walker"),
  "52401": p("IA", "Cedar Rapids"),
  "52402": p("IA", "Cedar Rapids"),
  "52403": p("IA", "Cedar Rapids"),
  "52404": p("IA", "Cedar Rapids"),
  "52405": p("IA", "Cedar Rapids"),
  "52406": p("IA", "Cedar Rapids"),
  "52407": p("IA", "Cedar Rapids"),
  "52408": p("IA", "Cedar Rapids"),
  "52409": p("IA", "Cedar Rapids"),
  "52410": p("IA", "Cedar Rapids"),
  "52411": p("IA", "Cedar Rapids"),
  "52497": p("IA", "Cedar Rapids"),
  "52498": p("IA", "Cedar Rapids"),
  "52499": p("IA", "Cedar Rapids"),
  "52640": p("IA", "Morning Sun"),
  "52646": p("IA", "Oakville"),
  "52653": p("IA", "Wapello"),
  "52737": p("IA", "Columbus City"),
  "52738": p("IA", "Columbus Junction"),
  "52752": p("IA", "Grandview"),
  "52754": p("IA", "Letts"),
  "50049": p("IA", "Chariton"),
  "50068": p("IA", "Derby"),
  "50151": p("IA", "Lucas"),
  "50238": p("IA", "Russell"),
  "50272": p("IA", "Williamson"),
  "51230": p("IA", "Alvord"),
  "51235": p("IA", "Doon"),
  "51237": p("IA", "George"),
  "51240": p("IA", "Inwood"),
  "51241": p("IA", "Larchwood"),
  "51242": p("IA", "Lester"),
  "51243": p("IA", "Little Rock"),
  "51246": p("IA", "Rock Rapids"),
  "50033": p("IA", "Bevington"),
  "50072": p("IA", "Earlham"),
  "50155": p("IA", "Macksburg"),
  "50218": p("IA", "Patterson"),
  "50222": p("IA", "Peru"),
  "50240": p("IA", "Saint Charles"),
  "50257": p("IA", "Truro"),
  "50273": p("IA", "Winterset"),
  "50027": p("IA", "Barnes City"),
  "50143": p("IA", "Leighton"),
  "50207": p("IA", "New Sharon"),
  "52534": p("IA", "Beacon"),
  "52543": p("IA", "Cedar"),
  "52561": p("IA", "Fremont"),
  "52577": p("IA", "Oskaloosa"),
  "52586": p("IA", "Rose Hill"),
  "52595": p("IA", "University Park"),
  "50044": p("IA", "Bussey"),
  "50057": p("IA", "Columbia"),
  "50062": p("IA", "Melcher Dallas"),
  "50116": p("IA", "Hamilton"),
  "50119": p("IA", "Harvey"),
  "50138": p("IA", "Knoxville"),
  "50163": p("IA", "Melcher Dallas"),
  "50214": p("IA", "Otley"),
  "50219": p("IA", "Pella"),
  "50225": p("IA", "Pleasantville"),
  "50252": p("IA", "Swan"),
  "50256": p("IA", "Tracy"),
  "50005": p("IA", "Albion"),
  "50051": p("IA", "Clemons"),
  "50078": p("IA", "Ferguson"),
  "50106": p("IA", "Gilman"),
  "50120": p("IA", "Haverhill"),
  "50141": p("IA", "Laurel"),
  "50142": p("IA", "Le Grand"),
  "50148": p("IA", "Liscomb"),
  "50158": p("IA", "Marshalltown"),
  "50162": p("IA", "Melbourne"),
  "50234": p("IA", "Rhodes"),
  "50239": p("IA", "Saint Anthony"),
  "50247": p("IA", "State Center"),
  "51533": p("IA", "Emerson"),
  "51534": p("IA", "Glenwood"),
  "51540": p("IA", "Hastings"),
  "51541": p("IA", "Henderson"),
  "51551": p("IA", "Malvern"),
  "51554": p("IA", "Mineola"),
  "51561": p("IA", "Pacific Junction"),
  "51571": p("IA", "Silver City"),
  "50426": p("IA", "Carpenter"),
  "50454": p("IA", "Little Cedar"),
  "50455": p("IA", "Mc Intire"),
  "50460": p("IA", "Orchard"),
  "50461": p("IA", "Osage"),
  "50472": p("IA", "Saint Ansgar"),
  "50476": p("IA", "Stacyville"),
  "50481": p("IA", "Toeterville"),
  "51010": p("IA", "Castana"),
  "51034": p("IA", "Mapleton"),
  "51040": p("IA", "Onawa"),
  "51051": p("IA", "Rodney"),
  "51060": p("IA", "Ute"),
  "51063": p("IA", "Whiting"),
  "51523": p("IA", "Blencoe"),
  "51558": p("IA", "Moorhead"),
  "51572": p("IA", "Soldier"),
  "50150": p("IA", "Lovilia"),
  "52531": p("IA", "Albia"),
  "52569": p("IA", "Melrose"),
  "50847": p("IA", "Grant"),
  "50864": p("IA", "Villisca"),
  "51532": p("IA", "Elliott"),
  "51566": p("IA", "Red Oak"),
  "51573": p("IA", "Stanton"),
  "51591": p("IA", "Red Oak"),
  "52720": p("IA", "Atalissa"),
  "52739": p("IA", "Conesville"),
  "52749": p("IA", "Fruitland"),
  "52759": p("IA", "Montpelier"),
  "52760": p("IA", "Moscow"),
  "52761": p("IA", "Muscatine"),
  "52766": p("IA", "Nichols"),
  "52769": p("IA", "Stockton"),
  "52776": p("IA", "West Liberty"),
  "52778": p("IA", "Wilton"),
  "51009": p("IA", "Calumet"),
  "51046": p("IA", "Paullina"),
  "51058": p("IA", "Sutherland"),
  "51201": p("IA", "Sheldon"),
  "51231": p("IA", "Archer"),
  "51245": p("IA", "Primghar"),
  "51248": p("IA", "Sanborn"),
  "51346": p("IA", "Hartley"),
  "51232": p("IA", "Ashton"),
  "51249": p("IA", "Sibley"),
  "51345": p("IA", "Harris"),
  "51350": p("IA", "Melvin"),
  "51354": p("IA", "Ocheyedan"),
  "51601": p("IA", "Shenandoah"),
  "51603": p("IA", "Shenandoah"),
  "51630": p("IA", "Blanchard"),
  "51631": p("IA", "Braddyville"),
  "51632": p("IA", "Clarinda"),
  "51636": p("IA", "Coin"),
  "51637": p("IA", "College Springs"),
  "51638": p("IA", "Essex"),
  "51647": p("IA", "Northboro"),
  "51651": p("IA", "Shambaugh"),
  "51656": p("IA", "Yorktown"),
  "50515": p("IA", "Ayrshire"),
  "50527": p("IA", "Curlew"),
  "50528": p("IA", "Cylinder"),
  "50536": p("IA", "Emmetsburg"),
  "50562": p("IA", "Mallard"),
  "50597": p("IA", "West Bend"),
  "51342": p("IA", "Graettinger"),
  "51358": p("IA", "Ruthven"),
  "51001": p("IA", "Akron"),
  "51008": p("IA", "Brunsville"),
  "51024": p("IA", "Hinton"),
  "51028": p("IA", "Kingsley"),
  "51031": p("IA", "Le Mars"),
  "51038": p("IA", "Merrill"),
  "51045": p("IA", "Oyens"),
  "51050": p("IA", "Remsen"),
  "51062": p("IA", "Westfield"),
  "50540": p("IA", "Fonda"),
  "50546": p("IA", "Havelock"),
  "50554": p("IA", "Laurens"),
  "50571": p("IA", "Palmer"),
  "50573": p("IA", "Plover"),
  "50574": p("IA", "Pocahontas"),
  "50581": p("IA", "Rolfe"),
  "50593": p("IA", "Varina"),
  "50007": p("IA", "Alleman"),
  "50009": p("IA", "Altoona"),
  "50021": p("IA", "Ankeny"),
  "50023": p("IA", "Ankeny"),
  "50032": p("IA", "Berwick"),
  "50035": p("IA", "Bondurant"),
  "50073": p("IA", "Elkhart"),
  "50111": p("IA", "Grimes"),
  "50131": p("IA", "Johnston"),
  "50169": p("IA", "Mitchellville"),
  "50226": p("IA", "Polk City"),
  "50237": p("IA", "Runnells"),
  "50243": p("IA", "Sheldahl"),
  "50265": p("IA", "West Des Moines"),
  "50266": p("IA", "West Des Moines"),
  "50301": p("IA", "Des Moines"),
  "50302": p("IA", "Des Moines"),
  "50303": p("IA", "Des Moines"),
  "50304": p("IA", "Des Moines"),
  "50305": p("IA", "Des Moines"),
  "50306": p("IA", "Des Moines"),
  "50307": p("IA", "Des Moines"),
  "50308": p("IA", "Des Moines"),
  "50309": p("IA", "Des Moines"),
  "50310": p("IA", "Des Moines"),
  "50311": p("IA", "Des Moines"),
  "50312": p("IA", "Des Moines"),
  "50313": p("IA", "Des Moines"),
  "50314": p("IA", "Des Moines"),
  "50315": p("IA", "Des Moines"),
  "50316": p("IA", "Des Moines"),
  "50317": p("IA", "Des Moines"),
  "50318": p("IA", "Des Moines"),
  "50319": p("IA", "Des Moines"),
  "50320": p("IA", "Des Moines"),
  "50321": p("IA", "Des Moines"),
  "50322": p("IA", "Urbandale"),
  "50323": p("IA", "Urbandale"),
  "50324": p("IA", "Windsor Heights"),
  "50325": p("IA", "Clive"),
  "50327": p("IA", "Pleasant Hill"),
  "50328": p("IA", "Des Moines"),
  "50329": p("IA", "Des Moines"),
  "50330": p("IA", "Des Moines"),
  "50331": p("IA", "Des Moines"),
  "50332": p("IA", "Des Moines"),
  "50333": p("IA", "Des Moines"),
  "50334": p("IA", "Des Moines"),
  "50335": p("IA", "Des Moines"),
  "50336": p("IA", "Des Moines"),
  "50339": p("IA", "Des Moines"),
  "50340": p("IA", "Des Moines"),
  "50359": p("IA", "Des Moines"),
  "50360": p("IA", "Des Moines"),
  "50361": p("IA", "Des Moines"),
  "50362": p("IA", "Des Moines"),
  "50363": p("IA", "Des Moines"),
  "50364": p("IA", "Des Moines"),
  "50367": p("IA", "Des Moines"),
  "50368": p("IA", "Des Moines"),
  "50369": p("IA", "Des Moines"),
  "50380": p("IA", "Des Moines"),
  "50381": p("IA", "Des Moines"),
  "50391": p("IA", "Des Moines"),
  "50392": p("IA", "Des Moines"),
  "50393": p("IA", "Des Moines"),
  "50394": p("IA", "Des Moines"),
  "50395": p("IA", "Des Moines"),
  "50396": p("IA", "Des Moines"),
  "50398": p("IA", "Urbandale"),
  "50936": p("IA", "Des Moines"),
  "50940": p("IA", "Des Moines"),
  "50947": p("IA", "Des Moines"),
  "50950": p("IA", "Des Moines"),
  "50980": p("IA", "Des Moines"),
  "50981": p("IA", "Des Moines"),
  "50982": p("IA", "Des Moines"),
  "50983": p("IA", "Des Moines"),
  "51501": p("IA", "Council Bluffs"),
  "51502": p("IA", "Council Bluffs"),
  "51503": p("IA", "Council Bluffs"),
  "51510": p("IA", "Carter Lake"),
  "51521": p("IA", "Avoca"),
  "51525": p("IA", "Carson"),
  "51526": p("IA", "Crescent"),
  "51536": p("IA", "Hancock"),
  "51542": p("IA", "Honey Creek"),
  "51548": p("IA", "Mc Clelland"),
  "51549": p("IA", "Macedonia"),
  "51553": p("IA", "Minden"),
  "51559": p("IA", "Neola"),
  "51560": p("IA", "Oakland"),
  "51570": p("IA", "Shelby"),
  "51575": p("IA", "Treynor"),
  "51576": p("IA", "Underwood"),
  "51577": p("IA", "Walnut"),
  "51593": p("IA", "Harlan"),
  "50112": p("IA", "Grinnell"),
  "50157": p("IA", "Malcom"),
  "50171": p("IA", "Montezuma"),
  "50242": p("IA", "Searsboro"),
  "52211": p("IA", "Brooklyn"),
  "52221": p("IA", "Guernsey"),
  "52222": p("IA", "Deep River"),
  "52232": p("IA", "Hartwick"),
  "50074": p("IA", "Ellston"),
  "50133": p("IA", "Kellerton"),
  "50835": p("IA", "Benton"),
  "50845": p("IA", "Diagonal"),
  "50854": p("IA", "Mount Ayr"),
  "50860": p("IA", "Redding"),
  "50863": p("IA", "Tingley"),
  "50535": p("IA", "Early"),
  "50567": p("IA", "Nemaha"),
  "50583": p("IA", "Sac City"),
  "51053": p("IA", "Schaller"),
  "51433": p("IA", "Auburn"),
  "51450": p("IA", "Lake View"),
  "51458": p("IA", "Odebolt"),
  "51466": p("IA", "Wall Lake"),
  "52722": p("IA", "Bettendorf"),
  "52726": p("IA", "Blue Grass"),
  "52728": p("IA", "Buffalo"),
  "52745": p("IA", "Dixon"),
  "52746": p("IA", "Donahue"),
  "52748": p("IA", "Eldridge"),
  "52753": p("IA", "Le Claire"),
  "52756": p("IA", "Long Grove"),
  "52758": p("IA", "Mc Causland"),
  "52765": p("IA", "New Liberty"),
  "52767": p("IA", "Pleasant Valley"),
  "52768": p("IA", "Princeton"),
  "52773": p("IA", "Walcott"),
  "52801": p("IA", "Davenport"),
  "52802": p("IA", "Davenport"),
  "52803": p("IA", "Davenport"),
  "52804": p("IA", "Davenport"),
  "52805": p("IA", "Davenport"),
  "52806": p("IA", "Davenport"),
  "52807": p("IA", "Davenport"),
  "52808": p("IA", "Davenport"),
  "52809": p("IA", "Davenport"),
  "51446": p("IA", "Irwin"),
  "51447": p("IA", "Kirkman"),
  "51527": p("IA", "Defiance"),
  "51530": p("IA", "Earling"),
  "51531": p("IA", "Elk Horn"),
  "51537": p("IA", "Harlan"),
  "51562": p("IA", "Panama"),
  "51565": p("IA", "Portsmouth"),
  "51578": p("IA", "Westphalia"),
  "51003": p("IA", "Alton"),
  "51011": p("IA", "Chatsworth"),
  "51022": p("IA", "Granville"),
  "51023": p("IA", "Hawarden"),
  "51027": p("IA", "Ireton"),
  "51036": p("IA", "Maurice"),
  "51041": p("IA", "Orange City"),
  "51234": p("IA", "Boyden"),
  "51238": p("IA", "Hospers"),
  "51239": p("IA", "Hull"),
  "51244": p("IA", "Matlock"),
  "51247": p("IA", "Rock Valley"),
  "51250": p("IA", "Sioux Center"),
  "50010": p("IA", "Ames"),
  "50011": p("IA", "Ames"),
  "50012": p("IA", "Ames"),
  "50013": p("IA", "Ames"),
  "50014": p("IA", "Ames"),
  "50046": p("IA", "Cambridge"),
  "50055": p("IA", "Collins"),
  "50056": p("IA", "Colo"),
  "50105": p("IA", "Gilbert"),
  "50124": p("IA", "Huxley"),
  "50134": p("IA", "Kelley"),
  "50154": p("IA", "Mc Callsburg"),
  "50161": p("IA", "Maxwell"),
  "50201": p("IA", "Nevada"),
  "50236": p("IA", "Roland"),
  "50244": p("IA", "Slater"),
  "50248": p("IA", "Story City"),
  "50278": p("IA", "Zearing"),
  "50173": p("IA", "Montour"),
  "50612": p("IA", "Buckingham"),
  "50632": p("IA", "Garwin"),
  "50635": p("IA", "Gladbrook"),
  "50652": p("IA", "Lincoln"),
  "50675": p("IA", "Traer"),
  "52215": p("IA", "Chelsea"),
  "52217": p("IA", "Clutier"),
  "52224": p("IA", "Dysart"),
  "52225": p("IA", "Elberon"),
  "52339": p("IA", "Tama"),
  "52342": p("IA", "Toledo"),
  "52348": p("IA", "Vining"),
  "50833": p("IA", "Bedford"),
  "50836": p("IA", "Blockton"),
  "50840": p("IA", "Clearfield"),
  "50848": p("IA", "Gravity"),
  "50851": p("IA", "Lenox"),
  "50862": p("IA", "Sharpsburg"),
  "51646": p("IA", "New Market"),
  "50149": p("IA", "Lorimor"),
  "50254": p("IA", "Thayer"),
  "50801": p("IA", "Creston"),
  "50830": p("IA", "Afton"),
  "50831": p("IA", "Arispe"),
  "50842": p("IA", "Cromwell"),
  "50861": p("IA", "Shannon City"),
  "52535": p("IA", "Birmingham"),
  "52542": p("IA", "Cantril"),
  "52551": p("IA", "Douds"),
  "52565": p("IA", "Keosauqua"),
  "52570": p("IA", "Milton"),
  "52573": p("IA", "Mount Sterling"),
  "52588": p("IA", "Selma"),
  "52620": p("IA", "Bonaparte"),
  "52626": p("IA", "Farmington"),
  "52651": p("IA", "Stockport"),
  "52501": p("IA", "Ottumwa"),
  "52530": p("IA", "Agency"),
  "52536": p("IA", "Blakesburg"),
  "52548": p("IA", "Chillicothe"),
  "52553": p("IA", "Eddyville"),
  "52554": p("IA", "Eldon"),
  "52566": p("IA", "Kirkville"),
  "50001": p("IA", "Ackworth"),
  "50047": p("IA", "Carlisle"),
  "50061": p("IA", "Cumming"),
  "50118": p("IA", "Hartford"),
  "50125": p("IA", "Indianola"),
  "50139": p("IA", "Lacona"),
  "50145": p("IA", "Liberty Center"),
  "50160": p("IA", "Martensdale"),
  "50166": p("IA", "Milo"),
  "50210": p("IA", "New Virginia"),
  "50211": p("IA", "Norwalk"),
  "50229": p("IA", "Prole"),
  "50241": p("IA", "Saint Marys"),
  "52201": p("IA", "Ainsworth"),
  "52247": p("IA", "Kalona"),
  "52327": p("IA", "Riverside"),
  "52353": p("IA", "Washington"),
  "52356": p("IA", "Wellman"),
  "52359": p("IA", "West Chester"),
  "52540": p("IA", "Brighton"),
  "52621": p("IA", "Crawfordsville"),
  "50008": p("IA", "Allerton"),
  "50052": p("IA", "Clio"),
  "50060": p("IA", "Corydon"),
  "50123": p("IA", "Humeston"),
  "50147": p("IA", "Lineville"),
  "50165": p("IA", "Millerton"),
  "52583": p("IA", "Promise City"),
  "52590": p("IA", "Seymour"),
  "50501": p("IA", "Fort Dodge"),
  "50516": p("IA", "Badger"),
  "50518": p("IA", "Barnum"),
  "50521": p("IA", "Burnside"),
  "50523": p("IA", "Callender"),
  "50524": p("IA", "Clare"),
  "50530": p("IA", "Dayton"),
  "50532": p("IA", "Duncombe"),
  "50543": p("IA", "Gowrie"),
  "50544": p("IA", "Harcourt"),
  "50557": p("IA", "Lehigh"),
  "50566": p("IA", "Moorland"),
  "50569": p("IA", "Otho"),
  "50594": p("IA", "Vincent"),
  "50424": p("IA", "Buffalo Center"),
  "50436": p("IA", "Forest City"),
  "50450": p("IA", "Lake Mills"),
  "50453": p("IA", "Leland"),
  "50465": p("IA", "Rake"),
  "50473": p("IA", "Scarville"),
  "50478": p("IA", "Thompson"),
  "52101": p("IA", "Decorah"),
  "52132": p("IA", "Calmar"),
  "52133": p("IA", "Castalia"),
  "52144": p("IA", "Fort Atkinson"),
  "52149": p("IA", "Highlandville"),
  "52161": p("IA", "Ossian"),
  "52165": p("IA", "Ridgeway"),
  "52168": p("IA", "Spillville"),
  "51004": p("IA", "Anthon"),
  "51007": p("IA", "Bronson"),
  "51015": p("IA", "Climbing Hill"),
  "51016": p("IA", "Correctionville"),
  "51018": p("IA", "Cushing"),
  "51019": p("IA", "Danbury"),
  "51026": p("IA", "Hornick"),
  "51030": p("IA", "Lawton"),
  "51039": p("IA", "Moville"),
  "51044": p("IA", "Oto"),
  "51048": p("IA", "Pierson"),
  "51052": p("IA", "Salix"),
  "51054": p("IA", "Sergeant Bluff"),
  "51055": p("IA", "Sloan"),
  "51056": p("IA", "Smithland"),
  "51101": p("IA", "Sioux City"),
  "51102": p("IA", "Sioux City"),
  "51103": p("IA", "Sioux City"),
  "51104": p("IA", "Sioux City"),
  "51105": p("IA", "Sioux City"),
  "51106": p("IA", "Sioux City"),
  "51108": p("IA", "Sioux City"),
  "51109": p("IA", "Sioux City"),
  "51111": p("IA", "Sioux City"),
  "50434": p("IA", "Fertile"),
  "50440": p("IA", "Grafton"),
  "50444": p("IA", "Hanlontown"),
  "50446": p("IA", "Joice"),
  "50448": p("IA", "Kensett"),
  "50456": p("IA", "Manly"),
  "50459": p("IA", "Northwood"),
  "50071": p("IA", "Dows"),
  "50101": p("IA", "Galt"),
  "50421": p("IA", "Belmond"),
  "50470": p("IA", "Rowan"),
  "50525": p("IA", "Clarion"),
  "50526": p("IA", "Clarion"),
  "50533": p("IA", "Eagle Grove"),
  "50542": p("IA", "Goldfield"),
  "50599": p("IA", "Woolstock"),
  "83616": p("ID", "Eagle"),
  "83634": p("ID", "Kuna"),
  "83642": p("ID", "Meridian"),
  "83669": p("ID", "Star"),
  "83680": p("ID", "Meridian"),
  "83701": p("ID", "Boise"),
  "83702": p("ID", "Boise"),
  "83703": p("ID", "Boise"),
  "83704": p("ID", "Boise"),
  "83705": p("ID", "Boise"),
  "83706": p("ID", "Boise"),
  "83707": p("ID", "Boise"),
  "83708": p("ID", "Boise"),
  "83709": p("ID", "Boise"),
  "83711": p("ID", "Boise"),
  "83712": p("ID", "Boise"),
  "83713": p("ID", "Boise"),
  "83714": p("ID", "Garden City"),
  "83715": p("ID", "Boise"),
  "83716": p("ID", "Boise"),
  "83717": p("ID", "Boise"),
  "83719": p("ID", "Boise"),
  "83720": p("ID", "Boise"),
  "83722": p("ID", "Boise"),
  "83724": p("ID", "Boise"),
  "83725": p("ID", "Boise"),
  "83726": p("ID", "Boise"),
  "83728": p("ID", "Boise"),
  "83729": p("ID", "Boise"),
  "83731": p("ID", "Boise"),
  "83732": p("ID", "Boise"),
  "83735": p("ID", "Boise"),
  "83756": p("ID", "Boise"),
  "83799": p("ID", "Boise"),
  "83612": p("ID", "Council"),
  "83632": p("ID", "Indian Valley"),
  "83643": p("ID", "Mesa"),
  "83654": p("ID", "New Meadows"),
  "83201": p("ID", "Pocatello"),
  "83202": p("ID", "Pocatello"),
  "83204": p("ID", "Pocatello"),
  "83205": p("ID", "Pocatello"),
  "83206": p("ID", "Pocatello"),
  "83209": p("ID", "Pocatello"),
  "83214": p("ID", "Arimo"),
  "83234": p("ID", "Downey"),
  "83245": p("ID", "Inkom"),
  "83246": p("ID", "Lava Hot Springs"),
  "83250": p("ID", "McCammon"),
  "83281": p("ID", "Swanlake"),
  "83220": p("ID", "Bern"),
  "83223": p("ID", "Bloomington"),
  "83233": p("ID", "Dingle"),
  "83238": p("ID", "Geneva"),
  "83239": p("ID", "Georgetown"),
  "83254": p("ID", "Montpelier"),
  "83261": p("ID", "Paris"),
  "83272": p("ID", "Saint Charles"),
  "83287": p("ID", "Fish Haven"),
  "83824": p("ID", "Desmet"),
  "83830": p("ID", "Fernwood"),
  "83851": p("ID", "Plummer"),
  "83861": p("ID", "Saint Maries"),
  "83866": p("ID", "Santa"),
  "83870": p("ID", "Tensed"),
  "83203": p("ID", "Fort Hall"),
  "83210": p("ID", "Aberdeen"),
  "83215": p("ID", "Atomic City"),
  "83218": p("ID", "Basalt"),
  "83221": p("ID", "Blackfoot"),
  "83236": p("ID", "Firth"),
  "83256": p("ID", "Moreland"),
  "83262": p("ID", "Pingree"),
  "83274": p("ID", "Shelley"),
  "83277": p("ID", "Springfield"),
  "83313": p("ID", "Bellevue"),
  "83320": p("ID", "Carey"),
  "83333": p("ID", "Hailey"),
  "83340": p("ID", "Ketchum"),
  "83348": p("ID", "Picabo"),
  "83353": p("ID", "Sun Valley"),
  "83354": p("ID", "Sun Valley"),
  "83602": p("ID", "Banks"),
  "83622": p("ID", "Garden Valley"),
  "83629": p("ID", "Horseshoe Bend"),
  "83631": p("ID", "Idaho City"),
  "83637": p("ID", "Lowman"),
  "83646": p("ID", "Meridian"),
  "83666": p("ID", "Placerville"),
  "83804": p("ID", "Blanchard"),
  "83809": p("ID", "Careywood"),
  "83811": p("ID", "Clark Fork"),
  "83813": p("ID", "Cocolalla"),
  "83821": p("ID", "Coolin"),
  "83822": p("ID", "Oldtown"),
  "83825": p("ID", "Dover"),
  "83836": p("ID", "Hope"),
  "83840": p("ID", "Kootenai"),
  "83841": p("ID", "Laclede"),
  "83848": p("ID", "Nordman"),
  "83852": p("ID", "Ponderay"),
  "83856": p("ID", "Priest River"),
  "83860": p("ID", "Sagle"),
  "83864": p("ID", "Sandpoint"),
  "83865": p("ID", "Colburn"),
  "83401": p("ID", "Idaho Falls"),
  "83402": p("ID", "Idaho Falls"),
  "83403": p("ID", "Idaho Falls"),
  "83404": p("ID", "Idaho Falls"),
  "83405": p("ID", "Idaho Falls"),
  "83406": p("ID", "Idaho Falls"),
  "83415": p("ID", "Idaho Falls"),
  "83427": p("ID", "Iona"),
  "83428": p("ID", "Irwin"),
  "83449": p("ID", "Swan Valley"),
  "83454": p("ID", "Ucon"),
  "83805": p("ID", "Bonners Ferry"),
  "83826": p("ID", "Eastport"),
  "83845": p("ID", "Moyie Springs"),
  "83847": p("ID", "Naples"),
  "83853": p("ID", "Porthill"),
  "83213": p("ID", "Arco"),
  "83244": p("ID", "Howe"),
  "83255": p("ID", "Moore"),
  "83322": p("ID", "Corral"),
  "83327": p("ID", "Fairfield"),
  "83337": p("ID", "Hill City"),
  "83605": p("ID", "Caldwell"),
  "83606": p("ID", "Caldwell"),
  "83607": p("ID", "Caldwell"),
  "83626": p("ID", "Greenleaf"),
  "83630": p("ID", "Huston"),
  "83641": p("ID", "Melba"),
  "83644": p("ID", "Middleton"),
  "83651": p("ID", "Nampa"),
  "83652": p("ID", "Nampa"),
  "83653": p("ID", "Nampa"),
  "83656": p("ID", "Notus"),
  "83660": p("ID", "Parma"),
  "83676": p("ID", "Wilder"),
  "83686": p("ID", "Nampa"),
  "83687": p("ID", "Nampa"),
  "83217": p("ID", "Bancroft"),
  "83230": p("ID", "Conda"),
  "83241": p("ID", "Grace"),
  "83276": p("ID", "Soda Springs"),
  "83285": p("ID", "Wayan"),
  "83311": p("ID", "Albion"),
  "83312": p("ID", "Almo"),
  "83318": p("ID", "Burley"),
  "83323": p("ID", "Declo"),
  "83342": p("ID", "Malta"),
  "83346": p("ID", "Oakley"),
  "83423": p("ID", "Dubois"),
  "83446": p("ID", "Spencer"),
  "83520": p("ID", "Ahsahka"),
  "83541": p("ID", "Lenore"),
  "83544": p("ID", "Orofino"),
  "83546": p("ID", "Pierce"),
  "83553": p("ID", "Weippe"),
  "83827": p("ID", "Elk River"),
  "83226": p("ID", "Challis"),
  "83227": p("ID", "Clayton"),
  "83235": p("ID", "Ellis"),
  "83251": p("ID", "Mackay"),
  "83278": p("ID", "Stanley"),
  "83601": p("ID", "Atlanta"),
  "83623": p("ID", "Glenns Ferry"),
  "83627": p("ID", "Hammett"),
  "83633": p("ID", "King Hill"),
  "83647": p("ID", "Mountain Home"),
  "83648": p("ID", "Mountain Home Afb"),
  "83228": p("ID", "Clifton"),
  "83232": p("ID", "Dayton"),
  "83237": p("ID", "Franklin"),
  "83263": p("ID", "Preston"),
  "83283": p("ID", "Thatcher"),
  "83286": p("ID", "Weston"),
  "83420": p("ID", "Ashton"),
  "83421": p("ID", "Chester"),
  "83429": p("ID", "Island Park"),
  "83433": p("ID", "Macks Inn"),
  "83436": p("ID", "Newdale"),
  "83438": p("ID", "Parker"),
  "83445": p("ID", "Saint Anthony"),
  "83451": p("ID", "Teton"),
  "83617": p("ID", "Emmett"),
  "83636": p("ID", "Letha"),
  "83657": p("ID", "Ola"),
  "83670": p("ID", "Sweet"),
  "83314": p("ID", "Bliss"),
  "83330": p("ID", "Gooding"),
  "83332": p("ID", "Hagerman"),
  "83355": p("ID", "Wendell"),
  "83522": p("ID", "Cottonwood"),
  "83525": p("ID", "Elk City"),
  "83526": p("ID", "Ferdinand"),
  "83530": p("ID", "Grangeville"),
  "83531": p("ID", "Fenn"),
  "83533": p("ID", "Greencreek"),
  "83539": p("ID", "Kooskia"),
  "83542": p("ID", "Lucile"),
  "83547": p("ID", "Pollock"),
  "83549": p("ID", "Riggins"),
  "83552": p("ID", "Stites"),
  "83554": p("ID", "White Bird"),
  "83671": p("ID", "Warren"),
  "83425": p("ID", "Hamer"),
  "83431": p("ID", "Lewisville"),
  "83434": p("ID", "Menan"),
  "83435": p("ID", "Monteview"),
  "83442": p("ID", "Rigby"),
  "83443": p("ID", "Ririe"),
  "83444": p("ID", "Roberts"),
  "83450": p("ID", "Terreton"),
  "83325": p("ID", "Eden"),
  "83335": p("ID", "Hazelton"),
  "83338": p("ID", "Jerome"),
  "83801": p("ID", "Athol"),
  "83803": p("ID", "Bayview"),
  "83810": p("ID", "Cataldo"),
  "83814": p("ID", "Coeur d'Alene"),
  "83815": p("ID", "Coeur d'Alene"),
  "83816": p("ID", "Coeur d'Alene"),
  "83833": p("ID", "Harrison"),
  "83835": p("ID", "Hayden"),
  "83842": p("ID", "Medimont"),
  "83854": p("ID", "Post Falls"),
  "83858": p("ID", "Rathdrum"),
  "83869": p("ID", "Spirit Lake"),
  "83876": p("ID", "Worley"),
  "83877": p("ID", "Post Falls"),
  "83535": p("ID", "Juliaetta"),
  "83537": p("ID", "Kendrick"),
  "83806": p("ID", "Bovill"),
  "83823": p("ID", "Deary"),
  "83832": p("ID", "Genesee"),
  "83834": p("ID", "Harvard"),
  "83843": p("ID", "Moscow"),
  "83844": p("ID", "Moscow"),
  "83855": p("ID", "Potlatch"),
  "83857": p("ID", "Princeton"),
  "83871": p("ID", "Troy"),
  "83872": p("ID", "Viola"),
  "83229": p("ID", "Cobalt"),
  "83253": p("ID", "May"),
  "83462": p("ID", "Carmen"),
  "83463": p("ID", "Gibbonsville"),
  "83464": p("ID", "Leadore"),
  "83465": p("ID", "Lemhi"),
  "83466": p("ID", "North Fork"),
  "83467": p("ID", "Salmon"),
  "83468": p("ID", "Tendoy"),
  "83469": p("ID", "Shoup"),
  "83523": p("ID", "Craigmont"),
  "83536": p("ID", "Kamiah"),
  "83543": p("ID", "Nezperce"),
  "83548": p("ID", "Reubens"),
  "83555": p("ID", "Winchester"),
  "83324": p("ID", "Dietrich"),
  "83349": p("ID", "Richfield"),
  "83352": p("ID", "Shoshone"),
  "83440": p("ID", "Rexburg"),
  "83441": p("ID", "Rexburg"),
  "83448": p("ID", "Sugar City"),
  "83460": p("ID", "Rexburg"),
  "83336": p("ID", "Heyburn"),
  "83343": p("ID", "Minidoka"),
  "83347": p("ID", "Paul"),
  "83350": p("ID", "Rupert"),
  "83501": p("ID", "Lewiston"),
  "83524": p("ID", "Culdesac"),
  "83540": p("ID", "Lapwai"),
  "83545": p("ID", "Peck"),
  "83243": p("ID", "Holbrook"),
  "83252": p("ID", "Malad City"),
  "83604": p("ID", "Bruneau"),
  "83624": p("ID", "Grand View"),
  "83628": p("ID", "Homedale"),
  "83639": p("ID", "Marsing"),
  "83650": p("ID", "Murphy"),
  "83619": p("ID", "Fruitland"),
  "83655": p("ID", "New Plymouth"),
  "83661": p("ID", "Payette"),
  "83211": p("ID", "American Falls"),
  "83212": p("ID", "Arbon"),
  "83271": p("ID", "Rockland"),
  "83802": p("ID", "Avery"),
  "83808": p("ID", "Calder"),
  "83812": p("ID", "Clarkia"),
  "83837": p("ID", "Kellogg"),
  "83839": p("ID", "Kingston"),
  "83846": p("ID", "Mullan"),
  "83849": p("ID", "Osburn"),
  "83850": p("ID", "Pinehurst"),
  "83867": p("ID", "Silverton"),
  "83868": p("ID", "Smelterville"),
  "83873": p("ID", "Wallace"),
  "83874": p("ID", "Murray"),
  "83422": p("ID", "Driggs"),
  "83424": p("ID", "Felt"),
  "83452": p("ID", "Tetonia"),
  "83455": p("ID", "Victor"),
  "83301": p("ID", "Twin Falls"),
  "83302": p("ID", "Rogerson"),
  "83303": p("ID", "Twin Falls"),
  "83316": p("ID", "Buhl"),
  "83321": p("ID", "Castleford"),
  "83328": p("ID", "Filer"),
  "83334": p("ID", "Hansen"),
  "83341": p("ID", "Kimberly"),
  "83344": p("ID", "Murtaugh"),
  "83611": p("ID", "Cascade"),
  "83615": p("ID", "Donnelly"),
  "83635": p("ID", "Lake Fork"),
  "83638": p("ID", "McCall"),
  "83677": p("ID", "Yellow Pine"),
  "83610": p("ID", "Cambridge"),
  "83645": p("ID", "Midvale"),
  "83672": p("ID", "Weiser"),
  "62301": p("IL", "Quincy"),
  "62305": p("IL", "Quincy"),
  "62306": p("IL", "Quincy"),
  "62320": p("IL", "Camp Point"),
  "62324": p("IL", "Clayton"),
  "62325": p("IL", "Coatsburg"),
  "62338": p("IL", "Fowler"),
  "62339": p("IL", "Golden"),
  "62346": p("IL", "La Prairie"),
  "62347": p("IL", "Liberty"),
  "62348": p("IL", "Lima"),
  "62349": p("IL", "Loraine"),
  "62351": p("IL", "Mendon"),
  "62359": p("IL", "Paloma"),
  "62360": p("IL", "Payson"),
  "62365": p("IL", "Plainville"),
  "62376": p("IL", "Ursa"),
  "62914": p("IL", "Cairo"),
  "62957": p("IL", "Mc Clure"),
  "62962": p("IL", "Miller City"),
  "62969": p("IL", "Olive Branch"),
  "62988": p("IL", "Tamms"),
  "62990": p("IL", "Thebes"),
  "62993": p("IL", "Unity"),
  "62019": p("IL", "Donnellson"),
  "62086": p("IL", "Sorento"),
  "62246": p("IL", "Greenville"),
  "62262": p("IL", "Mulberry Grove"),
  "62273": p("IL", "Pierron"),
  "62275": p("IL", "Pocahontas"),
  "62284": p("IL", "Smithboro"),
  "61008": p("IL", "Belvidere"),
  "61011": p("IL", "Caledonia"),
  "61012": p("IL", "Capron"),
  "61038": p("IL", "Garden Prairie"),
  "61065": p("IL", "Poplar Grove"),
  "62353": p("IL", "Mount Sterling"),
  "62375": p("IL", "Timewell"),
  "62378": p("IL", "Versailles"),
  "61312": p("IL", "Arlington"),
  "61314": p("IL", "Buda"),
  "61315": p("IL", "Bureau"),
  "61317": p("IL", "Cherry"),
  "61320": p("IL", "Dalzell"),
  "61322": p("IL", "Depue"),
  "61323": p("IL", "Dover"),
  "61328": p("IL", "Kasbeer"),
  "61329": p("IL", "Ladd"),
  "61330": p("IL", "La Moille"),
  "61337": p("IL", "Malden"),
  "61338": p("IL", "Manlius"),
  "61344": p("IL", "Mineral"),
  "61345": p("IL", "Neponset"),
  "61346": p("IL", "New Bedford"),
  "61349": p("IL", "Ohio"),
  "61356": p("IL", "Princeton"),
  "61359": p("IL", "Seatonville"),
  "61361": p("IL", "Sheffield"),
  "61362": p("IL", "Spring Valley"),
  "61368": p("IL", "Tiskilwa"),
  "61374": p("IL", "Van Orin"),
  "61376": p("IL", "Walnut"),
  "61379": p("IL", "Wyanet"),
  "62006": p("IL", "Batchtown"),
  "62013": p("IL", "Brussels"),
  "62036": p("IL", "Golden Eagle"),
  "62045": p("IL", "Hamburg"),
  "62047": p("IL", "Hardin"),
  "62053": p("IL", "Kampsville"),
  "62065": p("IL", "Michael"),
  "62070": p("IL", "Mozier"),
  "61014": p("IL", "Chadwick"),
  "61046": p("IL", "Lanark"),
  "61051": p("IL", "Milledgeville"),
  "61053": p("IL", "Mount Carroll"),
  "61074": p("IL", "Savanna"),
  "61078": p("IL", "Shannon"),
  "61285": p("IL", "Thomson"),
  "62611": p("IL", "Arenzville"),
  "62612": p("IL", "Ashland"),
  "62618": p("IL", "Beardstown"),
  "62622": p("IL", "Bluff Springs"),
  "62627": p("IL", "Chandlerville"),
  "62691": p("IL", "Virginia"),
  "60949": p("IL", "Ludlow"),
  "61801": p("IL", "Urbana"),
  "61802": p("IL", "Urbana"),
  "61803": p("IL", "Urbana"),
  "61815": p("IL", "Bondville"),
  "61816": p("IL", "Broadlands"),
  "61820": p("IL", "Champaign"),
  "61821": p("IL", "Champaign"),
  "61822": p("IL", "Champaign"),
  "61824": p("IL", "Champaign"),
  "61825": p("IL", "Champaign"),
  "61826": p("IL", "Champaign"),
  "61840": p("IL", "Dewey"),
  "61843": p("IL", "Fisher"),
  "61845": p("IL", "Foosland"),
  "61847": p("IL", "Gifford"),
  "61849": p("IL", "Homer"),
  "61851": p("IL", "Ivesdale"),
  "61852": p("IL", "Longview"),
  "61853": p("IL", "Mahomet"),
  "61859": p("IL", "Ogden"),
  "61862": p("IL", "Penfield"),
  "61863": p("IL", "Pesotum"),
  "61864": p("IL", "Philo"),
  "61866": p("IL", "Rantoul"),
  "61871": p("IL", "Royal"),
  "61872": p("IL", "Sadorus"),
  "61873": p("IL", "Saint Joseph"),
  "61874": p("IL", "Savoy"),
  "61875": p("IL", "Seymour"),
  "61877": p("IL", "Sidney"),
  "61878": p("IL", "Thomasboro"),
  "61880": p("IL", "Tolono"),
  "62083": p("IL", "Rosamond"),
  "62510": p("IL", "Assumption"),
  "62517": p("IL", "Bulpitt"),
  "62531": p("IL", "Edinburg"),
  "62540": p("IL", "Kincaid"),
  "62546": p("IL", "Morrisonville"),
  "62547": p("IL", "Mount Auburn"),
  "62555": p("IL", "Owaneco"),
  "62556": p("IL", "Palmer"),
  "62557": p("IL", "Pana"),
  "62567": p("IL", "Stonington"),
  "62568": p("IL", "Taylorville"),
  "62570": p("IL", "Tovey"),
  "62420": p("IL", "Casey"),
  "62423": p("IL", "Dennison"),
  "62441": p("IL", "Marshall"),
  "62442": p("IL", "Martinsville"),
  "62474": p("IL", "Westfield"),
  "62477": p("IL", "West Union"),
  "62434": p("IL", "Ingraham"),
  "62824": p("IL", "Clay City"),
  "62839": p("IL", "Flora"),
  "62858": p("IL", "Louisville"),
  "62879": p("IL", "Sailor Springs"),
  "62899": p("IL", "Xenia"),
  "62215": p("IL", "Albers"),
  "62216": p("IL", "Aviston"),
  "62218": p("IL", "Bartelso"),
  "62219": p("IL", "Beckemeyer"),
  "62230": p("IL", "Breese"),
  "62231": p("IL", "Carlyle"),
  "62245": p("IL", "Germantown"),
  "62250": p("IL", "Hoffman"),
  "62252": p("IL", "Huey"),
  "62253": p("IL", "Keyesport"),
  "62265": p("IL", "New Baden"),
  "62266": p("IL", "New Memphis"),
  "62293": p("IL", "Trenton"),
  "61912": p("IL", "Ashmore"),
  "61920": p("IL", "Charleston"),
  "61931": p("IL", "Humboldt"),
  "61938": p("IL", "Mattoon"),
  "61943": p("IL", "Oakland"),
  "62440": p("IL", "Lerna"),
  "62469": p("IL", "Trilla"),
  "60004": p("IL", "Arlington Heights"),
  "60005": p("IL", "Arlington Heights"),
  "60006": p("IL", "Arlington Heights"),
  "60007": p("IL", "Elk Grove Village"),
  "60008": p("IL", "Rolling Meadows"),
  "60009": p("IL", "Elk Grove Village"),
  "60016": p("IL", "Des Plaines"),
  "60017": p("IL", "Des Plaines"),
  "60018": p("IL", "Des Plaines"),
  "60019": p("IL", "Des Plaines"),
  "60022": p("IL", "Glencoe"),
  "60025": p("IL", "Glenview"),
  "60026": p("IL", "Glenview"),
  "60029": p("IL", "Golf"),
  "60038": p("IL", "Palatine"),
  "60043": p("IL", "Kenilworth"),
  "60053": p("IL", "Morton Grove"),
  "60055": p("IL", "Palatine"),
  "60056": p("IL", "Mount Prospect"),
  "60062": p("IL", "Northbrook"),
  "60065": p("IL", "Northbrook"),
  "60067": p("IL", "Palatine"),
  "60068": p("IL", "Park Ridge"),
  "60070": p("IL", "Prospect Heights"),
  "60074": p("IL", "Palatine"),
  "60076": p("IL", "Skokie"),
  "60077": p("IL", "Skokie"),
  "60078": p("IL", "Palatine"),
  "60082": p("IL", "Techny"),
  "60090": p("IL", "Wheeling"),
  "60091": p("IL", "Wilmette"),
  "60093": p("IL", "Winnetka"),
  "60094": p("IL", "Palatine"),
  "60095": p("IL", "Palatine"),
  "60103": p("IL", "Bartlett"),
  "60104": p("IL", "Bellwood"),
  "60107": p("IL", "Streamwood"),
  "60130": p("IL", "Forest Park"),
  "60131": p("IL", "Franklin Park"),
  "60141": p("IL", "Hines"),
  "60153": p("IL", "Maywood"),
  "60154": p("IL", "Westchester"),
  "60155": p("IL", "Broadview"),
  "60159": p("IL", "Schaumburg"),
  "60160": p("IL", "Melrose Park"),
  "60161": p("IL", "Melrose Park"),
  "60162": p("IL", "Hillside"),
  "60163": p("IL", "Berkeley"),
  "60164": p("IL", "Melrose Park"),
  "60165": p("IL", "Stone Park"),
  "60168": p("IL", "Schaumburg"),
  "60169": p("IL", "Hoffman Estates"),
  "60171": p("IL", "River Grove"),
  "60173": p("IL", "Schaumburg"),
  "60176": p("IL", "Schiller Park"),
  "60179": p("IL", "Hoffman Estates"),
  "60192": p("IL", "Hoffman Estates"),
  "60193": p("IL", "Schaumburg"),
  "60194": p("IL", "Schaumburg"),
  "60195": p("IL", "Schaumburg"),
  "60196": p("IL", "Schaumburg"),
  "60201": p("IL", "Evanston"),
  "60202": p("IL", "Evanston"),
  "60203": p("IL", "Evanston"),
  "60204": p("IL", "Evanston"),
  "60208": p("IL", "Evanston"),
  "60209": p("IL", "Evanston"),
  "60301": p("IL", "Oak Park"),
  "60302": p("IL", "Oak Park"),
  "60303": p("IL", "Oak Park"),
  "60304": p("IL", "Oak Park"),
  "60305": p("IL", "River Forest"),
  "60402": p("IL", "Berwyn"),
  "60406": p("IL", "Blue Island"),
  "60409": p("IL", "Calumet City"),
  "60411": p("IL", "Chicago Heights"),
  "60412": p("IL", "Chicago Heights"),
  "60415": p("IL", "Chicago Ridge"),
  "60418": p("IL", "Crestwood"),
  "60419": p("IL", "Dolton"),
  "60422": p("IL", "Flossmoor"),
  "60425": p("IL", "Glenwood"),
  "60426": p("IL", "Harvey"),
  "60429": p("IL", "Hazel Crest"),
  "60430": p("IL", "Homewood"),
  "60438": p("IL", "Lansing"),
  "60443": p("IL", "Matteson"),
  "60445": p("IL", "Midlothian"),
  "60452": p("IL", "Oak Forest"),
  "60453": p("IL", "Oak Lawn"),
  "60454": p("IL", "Oak Lawn"),
  "60455": p("IL", "Bridgeview"),
  "60456": p("IL", "Hometown"),
  "60457": p("IL", "Hickory Hills"),
  "60458": p("IL", "Justice"),
  "60459": p("IL", "Burbank"),
  "60461": p("IL", "Olympia Fields"),
  "60462": p("IL", "Orland Park"),
  "60463": p("IL", "Palos Heights"),
  "60464": p("IL", "Palos Park"),
  "60465": p("IL", "Palos Hills"),
  "60466": p("IL", "Park Forest"),
  "60467": p("IL", "Orland Park"),
  "60469": p("IL", "Posen"),
  "60471": p("IL", "Richton Park"),
  "60472": p("IL", "Robbins"),
  "60473": p("IL", "South Holland"),
  "60475": p("IL", "Steger"),
  "60476": p("IL", "Thornton"),
  "60477": p("IL", "Tinley Park"),
  "60478": p("IL", "Country Club Hills"),
  "60480": p("IL", "Willow Springs"),
  "60482": p("IL", "Worth"),
  "60499": p("IL", "Bedford Park"),
  "60501": p("IL", "Summit Argo"),
  "60513": p("IL", "Brookfield"),
  "60525": p("IL", "La Grange"),
  "60526": p("IL", "La Grange Park"),
  "60534": p("IL", "Lyons"),
  "60546": p("IL", "Riverside"),
  "60558": p("IL", "Western Springs"),
  "60601": p("IL", "Chicago"),
  "60602": p("IL", "Chicago"),
  "60603": p("IL", "Chicago"),
  "60604": p("IL", "Chicago"),
  "60605": p("IL", "Chicago"),
  "60606": p("IL", "Chicago"),
  "60607": p("IL", "Chicago"),
  "60608": p("IL", "Chicago"),
  "60609": p("IL", "Chicago"),
  "60610": p("IL", "Chicago"),
  "60611": p("IL", "Chicago"),
  "60612": p("IL", "Chicago"),
  "60613": p("IL", "Chicago"),
  "60614": p("IL", "Chicago"),
  "60615": p("IL", "Chicago"),
  "60616": p("IL", "Chicago"),
  "60617": p("IL", "Chicago"),
  "60618": p("IL", "Chicago"),
  "60619": p("IL", "Chicago"),
  "60620": p("IL", "Chicago"),
  "60621": p("IL", "Chicago"),
  "60622": p("IL", "Chicago"),
  "60623": p("IL", "Chicago"),
  "60624": p("IL", "Chicago"),
  "60625": p("IL", "Chicago"),
  "60626": p("IL", "Chicago"),
  "60628": p("IL", "Chicago"),
  "60629": p("IL", "Chicago"),
  "60630": p("IL", "Chicago"),
  "60631": p("IL", "Chicago"),
  "60632": p("IL", "Chicago"),
  "60633": p("IL", "Chicago"),
  "60634": p("IL", "Chicago"),
  "60636": p("IL", "Chicago"),
  "60637": p("IL", "Chicago"),
  "60638": p("IL", "Chicago"),
  "60639": p("IL", "Chicago"),
  "60640": p("IL", "Chicago"),
  "60641": p("IL", "Chicago"),
  "60642": p("IL", "Chicago"),
  "60643": p("IL", "Chicago"),
  "60644": p("IL", "Chicago"),
  "60645": p("IL", "Chicago"),
  "60646": p("IL", "Chicago"),
  "60647": p("IL", "Chicago"),
  "60649": p("IL", "Chicago"),
  "60651": p("IL", "Chicago"),
  "60652": p("IL", "Chicago"),
  "60653": p("IL", "Chicago"),
  "60654": p("IL", "Chicago"),
  "60655": p("IL", "Chicago"),
  "60656": p("IL", "Chicago"),
  "60657": p("IL", "Chicago"),
  "60659": p("IL", "Chicago"),
  "60660": p("IL", "Chicago"),
  "60661": p("IL", "Chicago"),
  "60664": p("IL", "Chicago"),
  "60666": p("IL", "Chicago"),
  "60668": p("IL", "Chicago"),
  "60669": p("IL", "Chicago"),
  "60670": p("IL", "Chicago"),
  "60673": p("IL", "Chicago"),
  "60674": p("IL", "Chicago"),
  "60675": p("IL", "Chicago"),
  "60677": p("IL", "Chicago"),
  "60678": p("IL", "Chicago"),
  "60680": p("IL", "Chicago"),
  "60681": p("IL", "Chicago"),
  "60682": p("IL", "Chicago"),
  "60684": p("IL", "Chicago"),
  "60685": p("IL", "Chicago"),
  "60686": p("IL", "Chicago"),
  "60687": p("IL", "Chicago"),
  "60688": p("IL", "Chicago"),
  "60689": p("IL", "Chicago"),
  "60690": p("IL", "Chicago"),
  "60691": p("IL", "Chicago"),
  "60693": p("IL", "Chicago"),
  "60694": p("IL", "Chicago"),
  "60695": p("IL", "Chicago"),
  "60696": p("IL", "Chicago"),
  "60697": p("IL", "Chicago"),
  "60699": p("IL", "Chicago"),
  "60701": p("IL", "Chicago"),
  "60706": p("IL", "Harwood Heights"),
  "60707": p("IL", "Elmwood Park"),
  "60712": p("IL", "Lincolnwood"),
  "60714": p("IL", "Niles"),
  "60803": p("IL", "Alsip"),
  "60804": p("IL", "Cicero"),
  "60805": p("IL", "Evergreen Park"),
  "60827": p("IL", "Riverdale"),
  "62413": p("IL", "Annapolis"),
  "62427": p("IL", "Flat Rock"),
  "62433": p("IL", "Hutsonville"),
  "62449": p("IL", "Oblong"),
  "62451": p("IL", "Palestine"),
  "62454": p("IL", "Robinson"),
  "62464": p("IL", "Stoy"),
  "62478": p("IL", "West York"),
  "62428": p("IL", "Greenup"),
  "62435": p("IL", "Janesville"),
  "62436": p("IL", "Jewett"),
  "62447": p("IL", "Neoga"),
  "62468": p("IL", "Toledo"),
  "60111": p("IL", "Clare"),
  "60112": p("IL", "Cortland"),
  "60115": p("IL", "Dekalb"),
  "60129": p("IL", "Esmond"),
  "60135": p("IL", "Genoa"),
  "60145": p("IL", "Kingston"),
  "60146": p("IL", "Kirkland"),
  "60150": p("IL", "Malta"),
  "60178": p("IL", "Sycamore"),
  "60520": p("IL", "Hinckley"),
  "60548": p("IL", "Sandwich"),
  "60550": p("IL", "Shabbona"),
  "60552": p("IL", "Somonauk"),
  "60556": p("IL", "Waterman"),
  "61727": p("IL", "Clinton"),
  "61735": p("IL", "Dewitt"),
  "61749": p("IL", "Kenney"),
  "61750": p("IL", "Lane"),
  "61777": p("IL", "Wapella"),
  "61778": p("IL", "Waynesville"),
  "61842": p("IL", "Farmer City"),
  "61882": p("IL", "Weldon"),
  "61910": p("IL", "Arcola"),
  "61911": p("IL", "Arthur"),
  "61913": p("IL", "Atwood"),
  "61919": p("IL", "Camargo"),
  "61930": p("IL", "Hindsboro"),
  "61941": p("IL", "Murdock"),
  "61942": p("IL", "Newman"),
  "61953": p("IL", "Tuscola"),
  "61956": p("IL", "Villa Grove"),
  "60101": p("IL", "Addison"),
  "60105": p("IL", "Bensenville"),
  "60106": p("IL", "Bensenville"),
  "60108": p("IL", "Bloomingdale"),
  "60116": p("IL", "Carol Stream"),
  "60117": p("IL", "Bloomingdale"),
  "60126": p("IL", "Elmhurst"),
  "60128": p("IL", "Carol Stream"),
  "60132": p("IL", "Carol Stream"),
  "60133": p("IL", "Hanover Park"),
  "60137": p("IL", "Glen Ellyn"),
  "60138": p("IL", "Glen Ellyn"),
  "60139": p("IL", "Glendale Heights"),
  "60143": p("IL", "Itasca"),
  "60148": p("IL", "Lombard"),
  "60157": p("IL", "Medinah"),
  "60172": p("IL", "Roselle"),
  "60181": p("IL", "Villa Park"),
  "60184": p("IL", "Wayne"),
  "60185": p("IL", "West Chicago"),
  "60186": p("IL", "West Chicago"),
  "60187": p("IL", "Wheaton"),
  "60188": p("IL", "Carol Stream"),
  "60189": p("IL", "Wheaton"),
  "60190": p("IL", "Winfield"),
  "60191": p("IL", "Wood Dale"),
  "60197": p("IL", "Carol Stream"),
  "60199": p("IL", "Carol Stream"),
  "60399": p("IL", "Wood Dale"),
  "60439": p("IL", "Lemont"),
  "60504": p("IL", "Aurora"),
  "60514": p("IL", "Clarendon Hills"),
  "60515": p("IL", "Downers Grove"),
  "60516": p("IL", "Downers Grove"),
  "60517": p("IL", "Woodridge"),
  "60519": p("IL", "Eola"),
  "60521": p("IL", "Hinsdale"),
  "60522": p("IL", "Hinsdale"),
  "60523": p("IL", "Oak Brook"),
  "60527": p("IL", "Willowbrook"),
  "60532": p("IL", "Lisle"),
  "60540": p("IL", "Naperville"),
  "60555": p("IL", "Warrenville"),
  "60559": p("IL", "Westmont"),
  "60561": p("IL", "Darien"),
  "60563": p("IL", "Naperville"),
  "60565": p("IL", "Naperville"),
  "60566": p("IL", "Naperville"),
  "60567": p("IL", "Naperville"),
  "60569": p("IL", "Aurora"),
  "60572": p("IL", "Aurora"),
  "60598": p("IL", "Aurora"),
  "60599": p("IL", "Fox Valley"),
  "61917": p("IL", "Brocton"),
  "61924": p("IL", "Chrisman"),
  "61932": p("IL", "Hume"),
  "61933": p("IL", "Kansas"),
  "61940": p("IL", "Metcalf"),
  "61944": p("IL", "Paris"),
  "61949": p("IL", "Redmon"),
  "61955": p("IL", "Vermilion"),
  "62476": p("IL", "West Salem"),
  "62806": p("IL", "Albion"),
  "62815": p("IL", "Bone Gap"),
  "62818": p("IL", "Browns"),
  "62833": p("IL", "Ellery"),
  "62401": p("IL", "Effingham"),
  "62411": p("IL", "Altamont"),
  "62414": p("IL", "Beecher City"),
  "62424": p("IL", "Dieterich"),
  "62426": p("IL", "Edgewood"),
  "62443": p("IL", "Mason"),
  "62445": p("IL", "Montrose"),
  "62461": p("IL", "Shumway"),
  "62467": p("IL", "Teutopolis"),
  "62473": p("IL", "Watson"),
  "62011": p("IL", "Bingham"),
  "62080": p("IL", "Ramsey"),
  "62247": p("IL", "Hagarstown"),
  "62418": p("IL", "Brownstown"),
  "62458": p("IL", "Saint Elmo"),
  "62471": p("IL", "Vandalia"),
  "62838": p("IL", "Farina"),
  "62880": p("IL", "Saint Peter"),
  "62885": p("IL", "Shobonier"),
  "60919": p("IL", "Cabery"),
  "60933": p("IL", "Elliott"),
  "60936": p("IL", "Gibson City"),
  "60946": p("IL", "Kempton"),
  "60952": p("IL", "Melvin"),
  "60957": p("IL", "Paxton"),
  "60959": p("IL", "Piper City"),
  "60962": p("IL", "Roberts"),
  "61773": p("IL", "Sibley"),
  "62812": p("IL", "Benton"),
  "62819": p("IL", "Buckner"),
  "62822": p("IL", "Christopher"),
  "62825": p("IL", "Coello"),
  "62836": p("IL", "Ewing"),
  "62840": p("IL", "Frankfort Heights"),
  "62856": p("IL", "Logan"),
  "62865": p("IL", "Mulkeytown"),
  "62874": p("IL", "Orient"),
  "62884": p("IL", "Sesser"),
  "62890": p("IL", "Thompsonville"),
  "62891": p("IL", "Valier"),
  "62896": p("IL", "West Frankfort"),
  "62897": p("IL", "Whittington"),
  "62983": p("IL", "Royalton"),
  "62999": p("IL", "Zeigler"),
  "61415": p("IL", "Avon"),
  "61427": p("IL", "Cuba"),
  "61431": p("IL", "Ellisville"),
  "61432": p("IL", "Fairview"),
  "61433": p("IL", "Fiatt"),
  "61441": p("IL", "Ipava"),
  "61459": p("IL", "Marietta"),
  "61477": p("IL", "Smithfield"),
  "61482": p("IL", "Table Grove"),
  "61484": p("IL", "Vermont"),
  "61501": p("IL", "Astoria"),
  "61519": p("IL", "Bryant"),
  "61520": p("IL", "Canton"),
  "61524": p("IL", "Dunfermline"),
  "61531": p("IL", "Farmington"),
  "61542": p("IL", "Lewistown"),
  "61543": p("IL", "Liverpool"),
  "61544": p("IL", "London Mills"),
  "61553": p("IL", "Norris"),
  "61563": p("IL", "Saint David"),
  "62867": p("IL", "New Haven"),
  "62871": p("IL", "Omaha"),
  "62934": p("IL", "Equality"),
  "62954": p("IL", "Junction"),
  "62979": p("IL", "Ridgway"),
  "62984": p("IL", "Shawneetown"),
  "62016": p("IL", "Carrollton"),
  "62027": p("IL", "Eldred"),
  "62044": p("IL", "Greenfield"),
  "62050": p("IL", "Hillview"),
  "62054": p("IL", "Kane"),
  "62078": p("IL", "Patterson"),
  "62081": p("IL", "Rockbridge"),
  "62082": p("IL", "Roodhouse"),
  "62092": p("IL", "White Hall"),
  "62098": p("IL", "Wrights"),
  "60407": p("IL", "Braceville"),
  "60416": p("IL", "Coal City"),
  "60424": p("IL", "Gardner"),
  "60437": p("IL", "Kinsman"),
  "60444": p("IL", "Mazon"),
  "60447": p("IL", "Minooka"),
  "60450": p("IL", "Morris"),
  "60474": p("IL", "South Wilmington"),
  "60479": p("IL", "Verona"),
  "62817": p("IL", "Broughton"),
  "62828": p("IL", "Dahlgren"),
  "62829": p("IL", "Dale"),
  "62859": p("IL", "Mc Leansboro"),
  "62860": p("IL", "Macedonia"),
  "61450": p("IL", "La Harpe"),
  "62311": p("IL", "Augusta"),
  "62313": p("IL", "Basco"),
  "62316": p("IL", "Bowen"),
  "62321": p("IL", "Carthage"),
  "62329": p("IL", "Colusa"),
  "62330": p("IL", "Dallas City"),
  "62334": p("IL", "Elvaston"),
  "62336": p("IL", "Ferris"),
  "62341": p("IL", "Hamilton"),
  "62354": p("IL", "Nauvoo"),
  "62358": p("IL", "Niota"),
  "62367": p("IL", "Plymouth"),
  "62373": p("IL", "Sutter"),
  "62379": p("IL", "Warsaw"),
  "62380": p("IL", "West Point"),
  "62919": p("IL", "Cave In Rock"),
  "62931": p("IL", "Elizabethtown"),
  "62955": p("IL", "Karbers Ridge"),
  "62982": p("IL", "Rosiclare"),
  "61418": p("IL", "Biggsville"),
  "61425": p("IL", "Carman"),
  "61437": p("IL", "Gladstone"),
  "61454": p("IL", "Lomax"),
  "61460": p("IL", "Media"),
  "61469": p("IL", "Oquawka"),
  "61471": p("IL", "Raritan"),
  "61480": p("IL", "Stronghurst"),
  "61233": p("IL", "Andover"),
  "61234": p("IL", "Annawan"),
  "61235": p("IL", "Atkinson"),
  "61238": p("IL", "Cambridge"),
  "61241": p("IL", "Colona"),
  "61254": p("IL", "Geneseo"),
  "61258": p("IL", "Hooppole"),
  "61262": p("IL", "Lynn Center"),
  "61273": p("IL", "Orion"),
  "61274": p("IL", "Osco"),
  "61413": p("IL", "Alpha"),
  "61419": p("IL", "Bishop Hill"),
  "61434": p("IL", "Galva"),
  "61443": p("IL", "Kewanee"),
  "61468": p("IL", "Ophiem"),
  "61490": p("IL", "Woodhull"),
  "60911": p("IL", "Ashkum"),
  "60912": p("IL", "Beaverville"),
  "60918": p("IL", "Buckley"),
  "60922": p("IL", "Chebanse"),
  "60924": p("IL", "Cissna Park"),
  "60926": p("IL", "Claytonville"),
  "60927": p("IL", "Clifton"),
  "60928": p("IL", "Crescent City"),
  "60930": p("IL", "Danforth"),
  "60931": p("IL", "Donovan"),
  "60938": p("IL", "Gilman"),
  "60939": p("IL", "Goodwine"),
  "60945": p("IL", "Iroquois"),
  "60948": p("IL", "Loda"),
  "60951": p("IL", "Martinton"),
  "60953": p("IL", "Milford"),
  "60955": p("IL", "Onarga"),
  "60956": p("IL", "Papineau"),
  "60966": p("IL", "Sheldon"),
  "60967": p("IL", "Stockland"),
  "60968": p("IL", "Thawville"),
  "60970": p("IL", "Watseka"),
  "60973": p("IL", "Wellington"),
  "60974": p("IL", "Woodland"),
  "62901": p("IL", "Carbondale"),
  "62902": p("IL", "Carbondale"),
  "62903": p("IL", "Carbondale"),
  "62907": p("IL", "Ava"),
  "62916": p("IL", "Campbell Hill"),
  "62924": p("IL", "De Soto"),
  "62927": p("IL", "Dowell"),
  "62932": p("IL", "Elkville"),
  "62940": p("IL", "Gorham"),
  "62942": p("IL", "Grand Tower"),
  "62950": p("IL", "Jacob"),
  "62958": p("IL", "Makanda"),
  "62966": p("IL", "Murphysboro"),
  "62971": p("IL", "Oraville"),
  "62975": p("IL", "Pomona"),
  "62994": p("IL", "Vergennes"),
  "62432": p("IL", "Hidalgo"),
  "62448": p("IL", "Newton"),
  "62459": p("IL", "Sainte Marie"),
  "62475": p("IL", "West Liberty"),
  "62479": p("IL", "Wheeler"),
  "62480": p("IL", "Willow Hill"),
  "62481": p("IL", "Yale"),
  "62810": p("IL", "Belle Rive"),
  "62814": p("IL", "Bluford"),
  "62816": p("IL", "Bonnie"),
  "62830": p("IL", "Dix"),
  "62846": p("IL", "Ina"),
  "62864": p("IL", "Mount Vernon"),
  "62866": p("IL", "Nason"),
  "62872": p("IL", "Opdyke"),
  "62883": p("IL", "Scheller"),
  "62889": p("IL", "Texico"),
  "62894": p("IL", "Waltonville"),
  "62898": p("IL", "Woodlawn"),
  "62012": p("IL", "Brighton"),
  "62022": p("IL", "Dow"),
  "62028": p("IL", "Elsah"),
  "62030": p("IL", "Fidelity"),
  "62031": p("IL", "Fieldon"),
  "62037": p("IL", "Grafton"),
  "62052": p("IL", "Jerseyville"),
  "62063": p("IL", "Medora"),
  "61001": p("IL", "Apple River"),
  "61025": p("IL", "East Dubuque"),
  "61028": p("IL", "Elizabeth"),
  "61036": p("IL", "Galena"),
  "61041": p("IL", "Hanover"),
  "61059": p("IL", "Nora"),
  "61075": p("IL", "Scales Mound"),
  "61085": p("IL", "Stockton"),
  "61087": p("IL", "Warren"),
  "62908": p("IL", "Belknap"),
  "62909": p("IL", "Boles"),
  "62912": p("IL", "Buncombe"),
  "62923": p("IL", "Cypress"),
  "62939": p("IL", "Goreville"),
  "62943": p("IL", "Grantsburg"),
  "62967": p("IL", "New Burnside"),
  "62972": p("IL", "Ozark"),
  "62985": p("IL", "Simpson"),
  "62995": p("IL", "Vienna"),
  "60109": p("IL", "Burlington"),
  "60110": p("IL", "Carpentersville"),
  "60118": p("IL", "Dundee"),
  "60119": p("IL", "Elburn"),
  "60120": p("IL", "Elgin"),
  "60121": p("IL", "Elgin"),
  "60122": p("IL", "Elgin"),
  "60123": p("IL", "Elgin"),
  "60124": p("IL", "Elgin"),
  "60134": p("IL", "Geneva"),
  "60136": p("IL", "Gilberts"),
  "60140": p("IL", "Hampshire"),
  "60144": p("IL", "Kaneville"),
  "60147": p("IL", "Lafox"),
  "60151": p("IL", "Maple Park"),
  "60174": p("IL", "Saint Charles"),
  "60175": p("IL", "Saint Charles"),
  "60177": p("IL", "South Elgin"),
  "60183": p("IL", "Wasco"),
  "60502": p("IL", "Aurora"),
  "60505": p("IL", "Aurora"),
  "60506": p("IL", "Aurora"),
  "60507": p("IL", "Aurora"),
  "60510": p("IL", "Batavia"),
  "60511": p("IL", "Big Rock"),
  "60539": p("IL", "Mooseheart"),
  "60542": p("IL", "North Aurora"),
  "60554": p("IL", "Sugar Grove"),
  "60568": p("IL", "Aurora"),
  "60901": p("IL", "Kankakee"),
  "60910": p("IL", "Aroma Park"),
  "60913": p("IL", "Bonfield"),
  "60914": p("IL", "Bourbonnais"),
  "60915": p("IL", "Bradley"),
  "60917": p("IL", "Buckingham"),
  "60935": p("IL", "Essex"),
  "60940": p("IL", "Grant Park"),
  "60941": p("IL", "Herscher"),
  "60944": p("IL", "Hopkins Park"),
  "60950": p("IL", "Manteno"),
  "60954": p("IL", "Momence"),
  "60958": p("IL", "Pembroke Township"),
  "60961": p("IL", "Reddick"),
  "60964": p("IL", "Saint Anne"),
  "60969": p("IL", "Union Hill"),
  "60512": p("IL", "Bristol"),
  "60536": p("IL", "Millbrook"),
  "60537": p("IL", "Millington"),
  "60538": p("IL", "Montgomery"),
  "60541": p("IL", "Newark"),
  "60543": p("IL", "Oswego"),
  "60545": p("IL", "Plano"),
  "60560": p("IL", "Yorkville"),
  "61401": p("IL", "Galesburg"),
  "61402": p("IL", "Galesburg"),
  "61410": p("IL", "Abingdon"),
  "61414": p("IL", "Altona"),
  "61428": p("IL", "Dahinda"),
  "61430": p("IL", "East Galesburg"),
  "61436": p("IL", "Gilson"),
  "61439": p("IL", "Henderson"),
  "61448": p("IL", "Knoxville"),
  "61458": p("IL", "Maquon"),
  "61467": p("IL", "Oneida"),
  "61472": p("IL", "Rio"),
  "61474": p("IL", "Saint Augustine"),
  "61485": p("IL", "Victoria"),
  "61488": p("IL", "Wataga"),
  "61489": p("IL", "Williamsfield"),
  "61572": p("IL", "Yates City"),
  "60002": p("IL", "Antioch"),
  "60010": p("IL", "Barrington"),
  "60011": p("IL", "Barrington"),
  "60015": p("IL", "Deerfield"),
  "60020": p("IL", "Fox Lake"),
  "60030": p("IL", "Grayslake"),
  "60031": p("IL", "Gurnee"),
  "60035": p("IL", "Highland Park"),
  "60037": p("IL", "Fort Sheridan"),
  "60040": p("IL", "Highwood"),
  "60041": p("IL", "Ingleside"),
  "60042": p("IL", "Island Lake"),
  "60044": p("IL", "Lake Bluff"),
  "60045": p("IL", "Lake Forest"),
  "60046": p("IL", "Lake Villa"),
  "60047": p("IL", "Lake Zurich"),
  "60048": p("IL", "Libertyville"),
  "60060": p("IL", "Mundelein"),
  "60061": p("IL", "Vernon Hills"),
  "60064": p("IL", "North Chicago"),
  "60069": p("IL", "Lincolnshire"),
  "60073": p("IL", "Round Lake"),
  "60075": p("IL", "Russell"),
  "60079": p("IL", "Waukegan"),
  "60083": p("IL", "Wadsworth"),
  "60084": p("IL", "Wauconda"),
  "60085": p("IL", "Waukegan"),
  "60086": p("IL", "North Chicago"),
  "60087": p("IL", "Waukegan"),
  "60088": p("IL", "Great Lakes"),
  "60089": p("IL", "Buffalo Grove"),
  "60096": p("IL", "Winthrop Harbor"),
  "60099": p("IL", "Zion"),
  "60470": p("IL", "Ransom"),
  "60518": p("IL", "Earlville"),
  "60531": p("IL", "Leland"),
  "60549": p("IL", "Serena"),
  "60551": p("IL", "Sheridan"),
  "60557": p("IL", "Wedron"),
  "61301": p("IL", "La Salle"),
  "61316": p("IL", "Cedar Point"),
  "61321": p("IL", "Dana"),
  "61325": p("IL", "Grand Ridge"),
  "61332": p("IL", "Leonore"),
  "61334": p("IL", "Lostant"),
  "61341": p("IL", "Marseilles"),
  "61342": p("IL", "Mendota"),
  "61348": p("IL", "Oglesby"),
  "61350": p("IL", "Ottawa"),
  "61354": p("IL", "Peru"),
  "61358": p("IL", "Rutland"),
  "61360": p("IL", "Seneca"),
  "61364": p("IL", "Streator"),
  "61370": p("IL", "Tonica"),
  "61371": p("IL", "Triumph"),
  "61372": p("IL", "Troy Grove"),
  "61373": p("IL", "Utica"),
  "62417": p("IL", "Bridgeport"),
  "62439": p("IL", "Lawrenceville"),
  "62460": p("IL", "Saint Francisville"),
  "62466": p("IL", "Sumner"),
  "60530": p("IL", "Lee"),
  "60553": p("IL", "Steward"),
  "61006": p("IL", "Ashton"),
  "61021": p("IL", "Dixon"),
  "61031": p("IL", "Franklin Grove"),
  "61042": p("IL", "Harmon"),
  "61057": p("IL", "Nachusa"),
  "61310": p("IL", "Amboy"),
  "61318": p("IL", "Compton"),
  "61324": p("IL", "Eldena"),
  "61331": p("IL", "Lee Center"),
  "61353": p("IL", "Paw Paw"),
  "61367": p("IL", "Sublette"),
  "61378": p("IL", "West Brooklyn"),
  "60420": p("IL", "Dwight"),
  "60460": p("IL", "Odell"),
  "60920": p("IL", "Campus"),
  "60921": p("IL", "Chatsworth"),
  "60929": p("IL", "Cullom"),
  "60934": p("IL", "Emington"),
  "61311": p("IL", "Ancona"),
  "61313": p("IL", "Blackstone"),
  "61319": p("IL", "Cornell"),
  "61333": p("IL", "Long Point"),
  "61739": p("IL", "Fairbury"),
  "61740": p("IL", "Flanagan"),
  "61741": p("IL", "Forrest"),
  "61743": p("IL", "Graymont"),
  "61764": p("IL", "Pontiac"),
  "61769": p("IL", "Saunemin"),
  "61775": p("IL", "Strawn"),
  "61723": p("IL", "Atlanta"),
  "61751": p("IL", "Lawndale"),
  "62512": p("IL", "Beason"),
  "62518": p("IL", "Chestnut"),
  "62519": p("IL", "Cornland"),
  "62541": p("IL", "Lake Fork"),
  "62543": p("IL", "Latham"),
  "62548": p("IL", "Mount Pulaski"),
  "62634": p("IL", "Elkhart"),
  "62635": p("IL", "Emden"),
  "62643": p("IL", "Hartsburg"),
  "62656": p("IL", "Lincoln"),
  "62666": p("IL", "Middletown"),
  "62671": p("IL", "New Holland"),
  "61411": p("IL", "Adair"),
  "61416": p("IL", "Bardolph"),
  "61420": p("IL", "Blandinsville"),
  "61422": p("IL", "Bushnell"),
  "61438": p("IL", "Good Hope"),
  "61440": p("IL", "Industry"),
  "61455": p("IL", "Macomb"),
  "61470": p("IL", "Prairie City"),
  "61475": p("IL", "Sciota"),
  "62326": p("IL", "Colchester"),
  "62374": p("IL", "Tennessee"),
  "60001": p("IL", "Alden"),
  "60012": p("IL", "Crystal Lake"),
  "60013": p("IL", "Cary"),
  "60014": p("IL", "Crystal Lake"),
  "60021": p("IL", "Fox River Grove"),
  "60033": p("IL", "Harvard"),
  "60034": p("IL", "Hebron"),
  "60039": p("IL", "Crystal Lake"),
  "60050": p("IL", "Mchenry"),
  "60051": p("IL", "Mchenry"),
  "60071": p("IL", "Richmond"),
  "60072": p("IL", "Ringwood"),
  "60081": p("IL", "Spring Grove"),
  "60097": p("IL", "Wonder Lake"),
  "60098": p("IL", "Woodstock"),
  "60102": p("IL", "Algonquin"),
  "60142": p("IL", "Huntley"),
  "60152": p("IL", "Marengo"),
  "60156": p("IL", "Lake In The Hills"),
  "60180": p("IL", "Union"),
  "61701": p("IL", "Bloomington"),
  "61702": p("IL", "Bloomington"),
  "61704": p("IL", "Bloomington"),
  "61705": p("IL", "Bloomington"),
  "61709": p("IL", "Bloomington"),
  "61710": p("IL", "Bloomington"),
  "61720": p("IL", "Anchor"),
  "61722": p("IL", "Arrowsmith"),
  "61724": p("IL", "Bellflower"),
  "61725": p("IL", "Carlock"),
  "61726": p("IL", "Chenoa"),
  "61728": p("IL", "Colfax"),
  "61730": p("IL", "Cooksville"),
  "61731": p("IL", "Cropsey"),
  "61732": p("IL", "Danvers"),
  "61736": p("IL", "Downs"),
  "61737": p("IL", "Ellsworth"),
  "61744": p("IL", "Gridley"),
  "61745": p("IL", "Heyworth"),
  "61748": p("IL", "Hudson"),
  "61752": p("IL", "Le Roy"),
  "61753": p("IL", "Lexington"),
  "61754": p("IL", "Mc Lean"),
  "61758": p("IL", "Merna"),
  "61761": p("IL", "Normal"),
  "61770": p("IL", "Saybrook"),
  "61772": p("IL", "Shirley"),
  "61774": p("IL", "Stanford"),
  "61776": p("IL", "Towanda"),
  "61790": p("IL", "Normal"),
  "61791": p("IL", "Bloomington"),
  "61799": p("IL", "Bloomington"),
  "61756": p("IL", "Maroa"),
  "62501": p("IL", "Argenta"),
  "62513": p("IL", "Blue Mound"),
  "62514": p("IL", "Boody"),
  "62521": p("IL", "Decatur"),
  "62522": p("IL", "Decatur"),
  "62523": p("IL", "Decatur"),
  "62524": p("IL", "Decatur"),
  "62525": p("IL", "Decatur"),
  "62526": p("IL", "Decatur"),
  "62532": p("IL", "Elwin"),
  "62535": p("IL", "Forsyth"),
  "62537": p("IL", "Harristown"),
  "62544": p("IL", "Macon"),
  "62549": p("IL", "Mt Zion"),
  "62551": p("IL", "Niantic"),
  "62554": p("IL", "Oreana"),
  "62573": p("IL", "Warrensburg"),
  "62009": p("IL", "Benld"),
  "62014": p("IL", "Bunker Hill"),
  "62023": p("IL", "Eagarville"),
  "62033": p("IL", "Gillespie"),
  "62069": p("IL", "Mount Olive"),
  "62079": p("IL", "Piasa"),
  "62085": p("IL", "Sawyerville"),
  "62088": p("IL", "Staunton"),
  "62093": p("IL", "Wilsonville"),
  "62626": p("IL", "Carlinville"),
  "62630": p("IL", "Chesterfield"),
  "62640": p("IL", "Girard"),
  "62649": p("IL", "Hettick"),
  "62667": p("IL", "Modesto"),
  "62672": p("IL", "Nilwood"),
  "62674": p("IL", "Palmyra"),
  "62683": p("IL", "Scottville"),
  "62685": p("IL", "Shipman"),
  "62690": p("IL", "Virden"),
  "62001": p("IL", "Alhambra"),
  "62002": p("IL", "Alton"),
  "62010": p("IL", "Bethalto"),
  "62018": p("IL", "Cottage Hills"),
  "62021": p("IL", "Dorsey"),
  "62024": p("IL", "East Alton"),
  "62025": p("IL", "Edwardsville"),
  "62026": p("IL", "Edwardsville"),
  "62034": p("IL", "Glen Carbon"),
  "62035": p("IL", "Godfrey"),
  "62040": p("IL", "Granite City"),
  "62046": p("IL", "Hamel"),
  "62048": p("IL", "Hartford"),
  "62058": p("IL", "Livingston"),
  "62060": p("IL", "Madison"),
  "62061": p("IL", "Marine"),
  "62062": p("IL", "Maryville"),
  "62067": p("IL", "Moro"),
  "62074": p("IL", "New Douglas"),
  "62084": p("IL", "Roxana"),
  "62087": p("IL", "South Roxana"),
  "62090": p("IL", "Venice"),
  "62095": p("IL", "Wood River"),
  "62097": p("IL", "Worden"),
  "62234": p("IL", "Collinsville"),
  "62249": p("IL", "Highland"),
  "62281": p("IL", "Saint Jacob"),
  "62294": p("IL", "Troy"),
  "62801": p("IL", "Centralia"),
  "62807": p("IL", "Alma"),
  "62849": p("IL", "Iuka"),
  "62853": p("IL", "Kell"),
  "62854": p("IL", "Kinmundy"),
  "62870": p("IL", "Odin"),
  "62875": p("IL", "Patoka"),
  "62881": p("IL", "Salem"),
  "62882": p("IL", "Sandoval"),
  "62892": p("IL", "Vernon"),
  "62893": p("IL", "Walnut Hill"),
  "61369": p("IL", "Toluca"),
  "61375": p("IL", "Varna"),
  "61377": p("IL", "Wenona"),
  "61424": p("IL", "Camp Grove"),
  "61537": p("IL", "Henry"),
  "61540": p("IL", "Lacon"),
  "61541": p("IL", "La Rose"),
  "61565": p("IL", "Sparland"),
  "61570": p("IL", "Washburn"),
  "61532": p("IL", "Forest City"),
  "61546": p("IL", "Manito"),
  "61567": p("IL", "Topeka"),
  "62617": p("IL", "Bath"),
  "62633": p("IL", "Easton"),
  "62644": p("IL", "Havana"),
  "62655": p("IL", "Kilbourne"),
  "62664": p("IL", "Mason City"),
  "62682": p("IL", "San Jose"),
  "62910": p("IL", "Brookport"),
  "62953": p("IL", "Joppa"),
  "62960": p("IL", "Metropolis"),
  "62613": p("IL", "Athens"),
  "62642": p("IL", "Greenview"),
  "62659": p("IL", "Lincoln'S New Salem"),
  "62673": p("IL", "Oakford"),
  "62675": p("IL", "Petersburg"),
  "62688": p("IL", "Tallula"),
  "61231": p("IL", "Aledo"),
  "61260": p("IL", "Joy"),
  "61263": p("IL", "Matherville"),
  "61272": p("IL", "New Boston"),
  "61276": p("IL", "Preemption"),
  "61281": p("IL", "Sherrard"),
  "61412": p("IL", "Alexis"),
  "61442": p("IL", "Keithsburg"),
  "61465": p("IL", "New Windsor"),
  "61466": p("IL", "North Henderson"),
  "61476": p("IL", "Seaton"),
  "61486": p("IL", "Viola"),
  "62236": p("IL", "Columbia"),
  "62244": p("IL", "Fults"),
  "62248": p("IL", "Hecker"),
  "62256": p("IL", "Maeystown"),
  "62279": p("IL", "Renault"),
  "62295": p("IL", "Valmeyer"),
  "62298": p("IL", "Waterloo"),
  "62015": p("IL", "Butler"),
  "62017": p("IL", "Coffeen"),
  "62032": p("IL", "Fillmore"),
  "62049": p("IL", "Hillsboro"),
  "62051": p("IL", "Irving"),
  "62056": p("IL", "Litchfield"),
  "62075": p("IL", "Nokomis"),
  "62076": p("IL", "Ohlman"),
  "62077": p("IL", "Panama"),
  "62089": p("IL", "Taylor Springs"),
  "62091": p("IL", "Walshville"),
  "62094": p("IL", "Witt"),
  "62533": p("IL", "Farmersville"),
  "62538": p("IL", "Harvel"),
  "62560": p("IL", "Raymond"),
  "62572": p("IL", "Waggoner"),
  "62601": p("IL", "Alexander"),
  "62628": p("IL", "Chapin"),
  "62631": p("IL", "Concord"),
  "62638": p("IL", "Franklin"),
  "62650": p("IL", "Jacksonville"),
  "62651": p("IL", "Jacksonville"),
  "62660": p("IL", "Literberry"),
  "62665": p("IL", "Meredosia"),
  "62668": p("IL", "Murrayville"),
  "62692": p("IL", "Waverly"),
  "62695": p("IL", "Woodson"),
  "61914": p("IL", "Bethany"),
  "61925": p("IL", "Dalton City"),
  "61928": p("IL", "Gays"),
  "61937": p("IL", "Lovington"),
  "61951": p("IL", "Sullivan"),
  "60113": p("IL", "Creston"),
  "61007": p("IL", "Baileyville"),
  "61010": p("IL", "Byron"),
  "61015": p("IL", "Chana"),
  "61020": p("IL", "Davis Junction"),
  "61030": p("IL", "Forreston"),
  "61043": p("IL", "Holcomb"),
  "61047": p("IL", "Leaf River"),
  "61049": p("IL", "Lindenwood"),
  "61052": p("IL", "Monroe Center"),
  "61054": p("IL", "Mount Morris"),
  "61061": p("IL", "Oregon"),
  "61064": p("IL", "Polo"),
  "61068": p("IL", "Rochelle"),
  "61084": p("IL", "Stillman Valley"),
  "61091": p("IL", "Woosung"),
  "61451": p("IL", "Laura"),
  "61517": p("IL", "Brimfield"),
  "61523": p("IL", "Chillicothe"),
  "61525": p("IL", "Dunlap"),
  "61526": p("IL", "Edelstein"),
  "61528": p("IL", "Edwards"),
  "61529": p("IL", "Elmwood"),
  "61533": p("IL", "Glasford"),
  "61536": p("IL", "Hanna City"),
  "61539": p("IL", "Kingston Mines"),
  "61547": p("IL", "Mapleton"),
  "61552": p("IL", "Mossville"),
  "61562": p("IL", "Rome"),
  "61569": p("IL", "Trivoli"),
  "61601": p("IL", "Peoria"),
  "61602": p("IL", "Peoria"),
  "61603": p("IL", "Peoria"),
  "61604": p("IL", "Peoria"),
  "61605": p("IL", "Peoria"),
  "61606": p("IL", "Peoria"),
  "61607": p("IL", "Peoria"),
  "61612": p("IL", "Peoria"),
  "61613": p("IL", "Peoria"),
  "61614": p("IL", "Peoria"),
  "61615": p("IL", "Peoria"),
  "61616": p("IL", "Peoria Heights"),
  "61625": p("IL", "Peoria"),
  "61629": p("IL", "Peoria"),
  "61630": p("IL", "Peoria"),
  "61633": p("IL", "Peoria"),
  "61634": p("IL", "Peoria"),
  "61636": p("IL", "Peoria"),
  "61637": p("IL", "Peoria"),
  "61638": p("IL", "Peoria"),
  "61639": p("IL", "Peoria"),
  "61641": p("IL", "Peoria"),
  "61643": p("IL", "Peoria"),
  "61650": p("IL", "Peoria"),
  "61651": p("IL", "Peoria"),
  "61652": p("IL", "Peoria"),
  "61653": p("IL", "Peoria"),
  "61654": p("IL", "Peoria"),
  "61655": p("IL", "Peoria"),
  "61656": p("IL", "Peoria"),
  "62238": p("IL", "Cutler"),
  "62274": p("IL", "Pinckneyville"),
  "62832": p("IL", "Du Quoin"),
  "62888": p("IL", "Tamaroa"),
  "62997": p("IL", "Willisville"),
  "61813": p("IL", "Bement"),
  "61818": p("IL", "Cerro Gordo"),
  "61830": p("IL", "Cisco"),
  "61839": p("IL", "De Land"),
  "61854": p("IL", "Mansfield"),
  "61855": p("IL", "Milmine"),
  "61856": p("IL", "Monticello"),
  "61884": p("IL", "White Heath"),
  "61929": p("IL", "Hammond"),
  "61936": p("IL", "La Place"),
  "62312": p("IL", "Barry"),
  "62314": p("IL", "Baylis"),
  "62323": p("IL", "Chambersburg"),
  "62340": p("IL", "Griggsville"),
  "62343": p("IL", "Hull"),
  "62345": p("IL", "Kinderhook"),
  "62352": p("IL", "Milton"),
  "62355": p("IL", "Nebo"),
  "62356": p("IL", "New Canton"),
  "62357": p("IL", "New Salem"),
  "62361": p("IL", "Pearl"),
  "62362": p("IL", "Perry"),
  "62363": p("IL", "Pittsfield"),
  "62366": p("IL", "Pleasant Hill"),
  "62370": p("IL", "Rockport"),
  "62928": p("IL", "Eddyville"),
  "62938": p("IL", "Golconda"),
  "62947": p("IL", "Herod"),
  "62941": p("IL", "Grand Chain"),
  "62956": p("IL", "Karnak"),
  "62963": p("IL", "Mound City"),
  "62964": p("IL", "Mounds"),
  "62970": p("IL", "Olmsted"),
  "62973": p("IL", "Perks"),
  "62976": p("IL", "Pulaski"),
  "62992": p("IL", "Ullin"),
  "62996": p("IL", "Villa Ridge"),
  "61326": p("IL", "Granville"),
  "61327": p("IL", "Hennepin"),
  "61335": p("IL", "Mc Nabb"),
  "61336": p("IL", "Magnolia"),
  "61340": p("IL", "Mark"),
  "61363": p("IL", "Standard"),
  "61560": p("IL", "Putnam"),
  "62217": p("IL", "Baldwin"),
  "62233": p("IL", "Chester"),
  "62237": p("IL", "Coulterville"),
  "62241": p("IL", "Ellis Grove"),
  "62242": p("IL", "Evansville"),
  "62259": p("IL", "Menard"),
  "62261": p("IL", "Modoc"),
  "62272": p("IL", "Percy"),
  "62277": p("IL", "Prairie Du Rocher"),
  "62278": p("IL", "Red Bud"),
  "62280": p("IL", "Rockwood"),
  "62286": p("IL", "Sparta"),
  "62288": p("IL", "Steeleville"),
  "62292": p("IL", "Tilden"),
  "62297": p("IL", "Walsh"),
  "62419": p("IL", "Calhoun"),
  "62421": p("IL", "Claremont"),
  "62425": p("IL", "Dundas"),
  "62450": p("IL", "Olney"),
  "62452": p("IL", "Parkersburg"),
  "62868": p("IL", "Noble"),
  "61201": p("IL", "Rock Island"),
  "61204": p("IL", "Rock Island"),
  "61232": p("IL", "Andalusia"),
  "61236": p("IL", "Barstow"),
  "61237": p("IL", "Buffalo Prairie"),
  "61239": p("IL", "Carbon Cliff"),
  "61240": p("IL", "Coal Valley"),
  "61242": p("IL", "Cordova"),
  "61244": p("IL", "East Moline"),
  "61256": p("IL", "Hampton"),
  "61257": p("IL", "Hillsdale"),
  "61259": p("IL", "Illinois City"),
  "61264": p("IL", "Milan"),
  "61265": p("IL", "Moline"),
  "61266": p("IL", "Moline"),
  "61275": p("IL", "Port Byron"),
  "61278": p("IL", "Rapids City"),
  "61279": p("IL", "Reynolds"),
  "61282": p("IL", "Silvis"),
  "61284": p("IL", "Taylor Ridge"),
  "61299": p("IL", "Rock Island"),
  "62059": p("IL", "Lovejoy"),
  "62071": p("IL", "National Stock Yards"),
  "62201": p("IL", "East Saint Louis"),
  "62202": p("IL", "East Saint Louis"),
  "62203": p("IL", "East Saint Louis"),
  "62204": p("IL", "East Saint Louis"),
  "62205": p("IL", "East Saint Louis"),
  "62206": p("IL", "East Saint Louis"),
  "62207": p("IL", "East Saint Louis"),
  "62208": p("IL", "Fairview Heights"),
  "62220": p("IL", "Belleville"),
  "62221": p("IL", "Belleville"),
  "62222": p("IL", "Belleville"),
  "62223": p("IL", "Belleville"),
  "62225": p("IL", "Scott Air Force Base"),
  "62226": p("IL", "Belleville"),
  "62232": p("IL", "Caseyville"),
  "62239": p("IL", "Dupo"),
  "62240": p("IL", "East Carondelet"),
  "62243": p("IL", "Freeburg"),
  "62254": p("IL", "Lebanon"),
  "62255": p("IL", "Lenzburg"),
  "62257": p("IL", "Marissa"),
  "62258": p("IL", "Mascoutah"),
  "62260": p("IL", "Millstadt"),
  "62264": p("IL", "New Athens"),
  "62269": p("IL", "O Fallon"),
  "62282": p("IL", "Saint Libory"),
  "62285": p("IL", "Smithton"),
  "62289": p("IL", "Summerfield"),
  "62917": p("IL", "Carrier Mills"),
  "62930": p("IL", "Eldorado"),
  "62935": p("IL", "Galatia"),
  "62946": p("IL", "Harrisburg"),
  "62965": p("IL", "Muddy"),
  "62977": p("IL", "Raleigh"),
  "62987": p("IL", "Stonefort"),
  "62515": p("IL", "Buffalo"),
  "62520": p("IL", "Dawson"),
  "62530": p("IL", "Divernon"),
  "62536": p("IL", "Glenarm"),
  "62539": p("IL", "Illiopolis"),
  "62545": p("IL", "Mechanicsburg"),
  "62558": p("IL", "Pawnee"),
  "62561": p("IL", "Riverton"),
  "62563": p("IL", "Rochester"),
  "62615": p("IL", "Auburn"),
  "62625": p("IL", "Cantrall"),
  "62629": p("IL", "Chatham"),
  "62661": p("IL", "Loami"),
  "62662": p("IL", "Lowder"),
  "62670": p("IL", "New Berlin"),
  "62677": p("IL", "Pleasant Plains"),
  "62684": p("IL", "Sherman"),
  "62689": p("IL", "Thayer"),
  "62693": p("IL", "Williamsville"),
  "62701": p("IL", "Springfield"),
  "62702": p("IL", "Springfield"),
  "62703": p("IL", "Springfield"),
  "62704": p("IL", "Springfield"),
  "62705": p("IL", "Springfield"),
  "62706": p("IL", "Springfield"),
  "62707": p("IL", "Springfield"),
  "62708": p("IL", "Springfield"),
  "62711": p("IL", "Springfield"),
  "62712": p("IL", "Springfield"),
  "62715": p("IL", "Springfield"),
  "62716": p("IL", "Springfield"),
  "62719": p("IL", "Springfield"),
  "62722": p("IL", "Springfield"),
  "62723": p("IL", "Springfield"),
  "62726": p("IL", "Springfield"),
  "62736": p("IL", "Springfield"),
  "62739": p("IL", "Springfield"),
  "62756": p("IL", "Springfield"),
  "62757": p("IL", "Springfield"),
  "62761": p("IL", "Springfield"),
  "62762": p("IL", "Springfield"),
  "62763": p("IL", "Springfield"),
  "62764": p("IL", "Springfield"),
  "62765": p("IL", "Springfield"),
  "62766": p("IL", "Springfield"),
  "62767": p("IL", "Springfield"),
  "62769": p("IL", "Springfield"),
  "62776": p("IL", "Springfield"),
  "62777": p("IL", "Springfield"),
  "62781": p("IL", "Springfield"),
  "62786": p("IL", "Springfield"),
  "62791": p("IL", "Springfield"),
  "62794": p("IL", "Springfield"),
  "62796": p("IL", "Springfield"),
  "61452": p("IL", "Littleton"),
  "62319": p("IL", "Camden"),
  "62344": p("IL", "Huntsville"),
  "62624": p("IL", "Browning"),
  "62639": p("IL", "Frederick"),
  "62681": p("IL", "Rushville"),
  "62610": p("IL", "Alsey"),
  "62621": p("IL", "Bluffs"),
  "62663": p("IL", "Manchester"),
  "62694": p("IL", "Winchester"),
  "61957": p("IL", "Windsor"),
  "62422": p("IL", "Cowden"),
  "62431": p("IL", "Herrick"),
  "62438": p("IL", "Lakewood"),
  "62444": p("IL", "Mode"),
  "62462": p("IL", "Sigel"),
  "62463": p("IL", "Stewardson"),
  "62465": p("IL", "Strasburg"),
  "62534": p("IL", "Findlay"),
  "62550": p("IL", "Moweaqua"),
  "62553": p("IL", "Oconee"),
  "62565": p("IL", "Shelbyville"),
  "62571": p("IL", "Tower Hill"),
  "61421": p("IL", "Bradford"),
  "61426": p("IL", "Castleton"),
  "61449": p("IL", "La Fayette"),
  "61479": p("IL", "Speer"),
  "61483": p("IL", "Toulon"),
  "61491": p("IL", "Wyoming"),
  "61559": p("IL", "Princeville"),
  "61013": p("IL", "Cedarville"),
  "61018": p("IL", "Dakota"),
  "61019": p("IL", "Davis"),
  "61027": p("IL", "Eleroy"),
  "61032": p("IL", "Freeport"),
  "61039": p("IL", "German Valley"),
  "61044": p("IL", "Kent"),
  "61048": p("IL", "Lena"),
  "61050": p("IL", "Mc Connell"),
  "61060": p("IL", "Orangeville"),
  "61062": p("IL", "Pearl City"),
  "61067": p("IL", "Ridott"),
  "61070": p("IL", "Rock City"),
  "61089": p("IL", "Winslow"),
  "61534": p("IL", "Green Valley"),
  "61535": p("IL", "Groveland"),
  "61550": p("IL", "Morton"),
  "61554": p("IL", "Pekin"),
  "61555": p("IL", "Pekin"),
  "61558": p("IL", "Pekin"),
  "61564": p("IL", "South Pekin"),
  "61568": p("IL", "Tremont"),
  "61571": p("IL", "Washington"),
  "61610": p("IL", "Creve Coeur"),
  "61611": p("IL", "East Peoria"),
  "61635": p("IL", "East Peoria"),
  "61721": p("IL", "Armington"),
  "61733": p("IL", "Deer Creek"),
  "61734": p("IL", "Delavan"),
  "61747": p("IL", "Hopedale"),
  "61755": p("IL", "Mackinaw"),
  "61759": p("IL", "Minier"),
  "62905": p("IL", "Alto Pass"),
  "62906": p("IL", "Anna"),
  "62920": p("IL", "Cobden"),
  "62926": p("IL", "Dongola"),
  "62952": p("IL", "Jonesboro"),
  "62961": p("IL", "Millcreek"),
  "62998": p("IL", "Wolf Lake"),
  "60932": p("IL", "East Lynn"),
  "60942": p("IL", "Hoopeston"),
  "60960": p("IL", "Rankin"),
  "60963": p("IL", "Rossville"),
  "61810": p("IL", "Allerton"),
  "61811": p("IL", "Alvin"),
  "61812": p("IL", "Armstrong"),
  "61814": p("IL", "Bismarck"),
  "61817": p("IL", "Catlin"),
  "61831": p("IL", "Collison"),
  "61832": p("IL", "Danville"),
  "61833": p("IL", "Tilton"),
  "61834": p("IL", "Danville"),
  "61841": p("IL", "Fairmount"),
  "61844": p("IL", "Fithian"),
  "61846": p("IL", "Georgetown"),
  "61848": p("IL", "Henning"),
  "61850": p("IL", "Indianola"),
  "61857": p("IL", "Muncie"),
  "61858": p("IL", "Oakwood"),
  "61865": p("IL", "Potomac"),
  "61870": p("IL", "Ridge Farm"),
  "61876": p("IL", "Sidell"),
  "61883": p("IL", "Westville"),
  "62410": p("IL", "Allendale"),
  "62811": p("IL", "Bellmont"),
  "62852": p("IL", "Keensburg"),
  "62855": p("IL", "Lancaster"),
  "62863": p("IL", "Mount Carmel"),
  "61417": p("IL", "Berwick"),
  "61423": p("IL", "Cameron"),
  "61435": p("IL", "Gerlaw"),
  "61447": p("IL", "Kirkwood"),
  "61453": p("IL", "Little York"),
  "61462": p("IL", "Monmouth"),
  "61473": p("IL", "Roseville"),
  "61478": p("IL", "Smithshire"),
  "62214": p("IL", "Addieville"),
  "62263": p("IL", "Nashville"),
  "62268": p("IL", "Oakdale"),
  "62271": p("IL", "Okawville"),
  "62803": p("IL", "Hoyleton"),
  "62808": p("IL", "Ashley"),
  "62831": p("IL", "Du Bois"),
  "62848": p("IL", "Irvington"),
  "62876": p("IL", "Radom"),
  "62877": p("IL", "Richview"),
  "62446": p("IL", "Mount Erie"),
  "62809": p("IL", "Barnhill"),
  "62823": p("IL", "Cisne"),
  "62837": p("IL", "Fairfield"),
  "62842": p("IL", "Geff"),
  "62843": p("IL", "Golden Gate"),
  "62850": p("IL", "Johnsonville"),
  "62851": p("IL", "Keenes"),
  "62878": p("IL", "Rinard"),
  "62886": p("IL", "Sims"),
  "62895": p("IL", "Wayne City"),
  "62820": p("IL", "Burnt Prairie"),
  "62821": p("IL", "Carmi"),
  "62827": p("IL", "Crossville"),
  "62834": p("IL", "Emma"),
  "62835": p("IL", "Enfield"),
  "62844": p("IL", "Grayville"),
  "62861": p("IL", "Maunie"),
  "62862": p("IL", "Mill Shoals"),
  "62869": p("IL", "Norris City"),
  "62887": p("IL", "Springerton"),
  "61037": p("IL", "Galt"),
  "61071": p("IL", "Rock Falls"),
  "61081": p("IL", "Sterling"),
  "61230": p("IL", "Albany"),
  "61243": p("IL", "Deer Grove"),
  "61250": p("IL", "Erie"),
  "61251": p("IL", "Fenton"),
  "61252": p("IL", "Fulton"),
  "61261": p("IL", "Lyndon"),
  "61270": p("IL", "Morrison"),
  "61277": p("IL", "Prophetstown"),
  "61283": p("IL", "Tampico"),
  "60401": p("IL", "Beecher"),
  "60403": p("IL", "Crest Hill"),
  "60404": p("IL", "Shorewood"),
  "60408": p("IL", "Braidwood"),
  "60410": p("IL", "Channahon"),
  "60417": p("IL", "Crete"),
  "60421": p("IL", "Elwood"),
  "60423": p("IL", "Frankfort"),
  "60428": p("IL", "Markham"),
  "60431": p("IL", "Joliet"),
  "60432": p("IL", "Joliet"),
  "60433": p("IL", "Joliet"),
  "60434": p("IL", "Joliet"),
  "60435": p("IL", "Joliet"),
  "60436": p("IL", "Joliet"),
  "60440": p("IL", "Bolingbrook"),
  "60441": p("IL", "Lockport"),
  "60442": p("IL", "Manhattan"),
  "60446": p("IL", "Romeoville"),
  "60448": p("IL", "Mokena"),
  "60449": p("IL", "Monee"),
  "60451": p("IL", "New Lenox"),
  "60468": p("IL", "Peotone"),
  "60481": p("IL", "Wilmington"),
  "60484": p("IL", "University Park"),
  "60487": p("IL", "Tinley Park"),
  "60490": p("IL", "Bolingbrook"),
  "60491": p("IL", "Homer Glen"),
  "60503": p("IL", "Aurora"),
  "60544": p("IL", "Plainfield"),
  "60564": p("IL", "Naperville"),
  "60585": p("IL", "Plainfield"),
  "60586": p("IL", "Plainfield"),
  "62841": p("IL", "Freeman Spur"),
  "62915": p("IL", "Cambria"),
  "62918": p("IL", "Carterville"),
  "62921": p("IL", "Colp"),
  "62922": p("IL", "Creal Springs"),
  "62933": p("IL", "Energy"),
  "62948": p("IL", "Herrin"),
  "62949": p("IL", "Hurst"),
  "62951": p("IL", "Johnston City"),
  "62959": p("IL", "Marion"),
  "62974": p("IL", "Pittsburg"),
  "61016": p("IL", "Cherry Valley"),
  "61024": p("IL", "Durand"),
  "61063": p("IL", "Pecatonica"),
  "61072": p("IL", "Rockton"),
  "61073": p("IL", "Roscoe"),
  "61077": p("IL", "Seward"),
  "61079": p("IL", "Shirland"),
  "61080": p("IL", "South Beloit"),
  "61088": p("IL", "Winnebago"),
  "61101": p("IL", "Rockford"),
  "61102": p("IL", "Rockford"),
  "61103": p("IL", "Rockford"),
  "61104": p("IL", "Rockford"),
  "61105": p("IL", "Rockford"),
  "61106": p("IL", "Rockford"),
  "61107": p("IL", "Rockford"),
  "61108": p("IL", "Rockford"),
  "61109": p("IL", "Rockford"),
  "61110": p("IL", "Rockford"),
  "61111": p("IL", "Loves Park"),
  "61112": p("IL", "Rockford"),
  "61114": p("IL", "Rockford"),
  "61115": p("IL", "Machesney Park"),
  "61125": p("IL", "Rockford"),
  "61126": p("IL", "Rockford"),
  "61130": p("IL", "Loves Park"),
  "61131": p("IL", "Loves Park"),
  "61132": p("IL", "Loves Park"),
  "61516": p("IL", "Benson"),
  "61530": p("IL", "Eureka"),
  "61545": p("IL", "Lowpoint"),
  "61548": p("IL", "Metamora"),
  "61561": p("IL", "Roanoke"),
  "61729": p("IL", "Congerville"),
  "61738": p("IL", "El Paso"),
  "61742": p("IL", "Goodfield"),
  "61760": p("IL", "Minonk"),
  "61771": p("IL", "Secor"),
  "46711": p("IN", "Berne"),
  "46733": p("IN", "Decatur"),
  "46740": p("IN", "Geneva"),
  "46769": p("IN", "Linn Grove"),
  "46772": p("IN", "Monroe"),
  "46780": p("IN", "Pleasant Mills"),
  "46782": p("IN", "Preble"),
  "46704": p("IN", "Arcola"),
  "46741": p("IN", "Grabill"),
  "46743": p("IN", "Harlan"),
  "46745": p("IN", "Hoagland"),
  "46748": p("IN", "Huntertown"),
  "46765": p("IN", "Leo"),
  "46773": p("IN", "Monroeville"),
  "46774": p("IN", "New Haven"),
  "46797": p("IN", "Woodburn"),
  "46798": p("IN", "Yoder"),
  "46799": p("IN", "Zanesville"),
  "46801": p("IN", "Fort Wayne"),
  "46802": p("IN", "Fort Wayne"),
  "46803": p("IN", "Fort Wayne"),
  "46804": p("IN", "Fort Wayne"),
  "46805": p("IN", "Fort Wayne"),
  "46806": p("IN", "Fort Wayne"),
  "46807": p("IN", "Fort Wayne"),
  "46808": p("IN", "Fort Wayne"),
  "46809": p("IN", "Fort Wayne"),
  "46814": p("IN", "Fort Wayne"),
  "46815": p("IN", "Fort Wayne"),
  "46816": p("IN", "Fort Wayne"),
  "46818": p("IN", "Fort Wayne"),
  "46819": p("IN", "Fort Wayne"),
  "46825": p("IN", "Fort Wayne"),
  "46835": p("IN", "Fort Wayne"),
  "46845": p("IN", "Fort Wayne"),
  "46850": p("IN", "Fort Wayne"),
  "46851": p("IN", "Fort Wayne"),
  "46852": p("IN", "Fort Wayne"),
  "46853": p("IN", "Fort Wayne"),
  "46854": p("IN", "Fort Wayne"),
  "46855": p("IN", "Fort Wayne"),
  "46856": p("IN", "Fort Wayne"),
  "46857": p("IN", "Fort Wayne"),
  "46858": p("IN", "Fort Wayne"),
  "46859": p("IN", "Fort Wayne"),
  "46860": p("IN", "Fort Wayne"),
  "46861": p("IN", "Fort Wayne"),
  "46862": p("IN", "Fort Wayne"),
  "46863": p("IN", "Fort Wayne"),
  "46864": p("IN", "Fort Wayne"),
  "46865": p("IN", "Fort Wayne"),
  "46866": p("IN", "Fort Wayne"),
  "46867": p("IN", "Fort Wayne"),
  "46868": p("IN", "Fort Wayne"),
  "46869": p("IN", "Fort Wayne"),
  "46885": p("IN", "Fort Wayne"),
  "46895": p("IN", "Fort Wayne"),
  "46896": p("IN", "Fort Wayne"),
  "46897": p("IN", "Fort Wayne"),
  "46898": p("IN", "Fort Wayne"),
  "46899": p("IN", "Fort Wayne"),
  "47201": p("IN", "Columbus"),
  "47202": p("IN", "Columbus"),
  "47203": p("IN", "Columbus"),
  "47226": p("IN", "Clifford"),
  "47232": p("IN", "Elizabethtown"),
  "47236": p("IN", "Grammer"),
  "47244": p("IN", "Hartsville"),
  "47246": p("IN", "Hope"),
  "47247": p("IN", "Jonesville"),
  "47280": p("IN", "Taylorsville"),
  "47917": p("IN", "Ambia"),
  "47921": p("IN", "Boswell"),
  "47942": p("IN", "Earl Park"),
  "47944": p("IN", "Fowler"),
  "47970": p("IN", "Otterbein"),
  "47971": p("IN", "Oxford"),
  "47984": p("IN", "Talbot"),
  "47986": p("IN", "Templeton"),
  "47348": p("IN", "Hartford City"),
  "47359": p("IN", "Montpelier"),
  "46052": p("IN", "Lebanon"),
  "46071": p("IN", "Thorntown"),
  "46075": p("IN", "Whitestown"),
  "46077": p("IN", "Zionsville"),
  "46102": p("IN", "Advance"),
  "46147": p("IN", "Jamestown"),
  "46160": p("IN", "Morgantown"),
  "47435": p("IN", "Helmsburg"),
  "47448": p("IN", "Nashville"),
  "46913": p("IN", "Bringhurst"),
  "46915": p("IN", "Burlington"),
  "46916": p("IN", "Burrows"),
  "46917": p("IN", "Camden"),
  "46920": p("IN", "Cutler"),
  "46923": p("IN", "Delphi"),
  "46929": p("IN", "Flora"),
  "46977": p("IN", "Rockfield"),
  "47997": p("IN", "Yeoman"),
  "46932": p("IN", "Galveston"),
  "46942": p("IN", "Lake Cicott"),
  "46947": p("IN", "Logansport"),
  "46950": p("IN", "Lucerne"),
  "46961": p("IN", "New Waverly"),
  "46967": p("IN", "Onward"),
  "46978": p("IN", "Royal Center"),
  "46988": p("IN", "Twelve Mile"),
  "46994": p("IN", "Walton"),
  "46998": p("IN", "Young America"),
  "47104": p("IN", "Bethlehem"),
  "47106": p("IN", "Borden"),
  "47111": p("IN", "Charlestown"),
  "47126": p("IN", "Henryville"),
  "47129": p("IN", "Clarksville"),
  "47130": p("IN", "Jeffersonville"),
  "47131": p("IN", "Jeffersonville"),
  "47132": p("IN", "Jeffersonville"),
  "47133": p("IN", "Jeffersonville"),
  "47134": p("IN", "Jeffersonville"),
  "47141": p("IN", "Marysville"),
  "47143": p("IN", "Memphis"),
  "47144": p("IN", "Jeffersonville"),
  "47147": p("IN", "Nabb"),
  "47162": p("IN", "New Washington"),
  "47163": p("IN", "Otisco"),
  "47172": p("IN", "Sellersburg"),
  "47177": p("IN", "Underwood"),
  "47190": p("IN", "Jeffersonville"),
  "47199": p("IN", "Jeffersonville"),
  "47833": p("IN", "Bowling Green"),
  "47834": p("IN", "Brazil"),
  "47837": p("IN", "Carbon"),
  "47840": p("IN", "Centerpoint"),
  "47841": p("IN", "Clay City"),
  "47845": p("IN", "Coalmont"),
  "47846": p("IN", "Cory"),
  "47853": p("IN", "Harmony"),
  "47857": p("IN", "Knightsville"),
  "47868": p("IN", "Poland"),
  "47881": p("IN", "Staunton"),
  "46035": p("IN", "Colfax"),
  "46039": p("IN", "Forest"),
  "46041": p("IN", "Frankfort"),
  "46050": p("IN", "Kirklin"),
  "46057": p("IN", "Michigantown"),
  "46058": p("IN", "Mulberry"),
  "46065": p("IN", "Rossville"),
  "46067": p("IN", "Sedalia"),
  "47116": p("IN", "Eckerty"),
  "47118": p("IN", "English"),
  "47123": p("IN", "Grantsburg"),
  "47137": p("IN", "Leavenworth"),
  "47140": p("IN", "Marengo"),
  "47145": p("IN", "Milltown"),
  "47174": p("IN", "Sulphur"),
  "47175": p("IN", "Taswell"),
  "47501": p("IN", "Washington"),
  "47519": p("IN", "Cannelburg"),
  "47529": p("IN", "Elnora"),
  "47558": p("IN", "Montgomery"),
  "47562": p("IN", "Odon"),
  "47568": p("IN", "Plainville"),
  "47001": p("IN", "Aurora"),
  "47018": p("IN", "Dillsboro"),
  "47022": p("IN", "Guilford"),
  "47025": p("IN", "Lawrenceburg"),
  "47032": p("IN", "Moores Hill"),
  "47060": p("IN", "West Harrison"),
  "47225": p("IN", "Clarksburg"),
  "47240": p("IN", "Greensburg"),
  "47261": p("IN", "Millhousen"),
  "47263": p("IN", "New Point"),
  "47272": p("IN", "Saint Paul"),
  "47283": p("IN", "Westport"),
  "46705": p("IN", "Ashley"),
  "46706": p("IN", "Auburn"),
  "46721": p("IN", "Butler"),
  "46730": p("IN", "Corunna"),
  "46738": p("IN", "Garrett"),
  "46785": p("IN", "Saint Joe"),
  "46788": p("IN", "Spencerville"),
  "46793": p("IN", "Waterloo"),
  "47302": p("IN", "Muncie"),
  "47303": p("IN", "Muncie"),
  "47304": p("IN", "Muncie"),
  "47305": p("IN", "Muncie"),
  "47306": p("IN", "Muncie"),
  "47307": p("IN", "Muncie"),
  "47308": p("IN", "Muncie"),
  "47320": p("IN", "Albany"),
  "47334": p("IN", "Daleville"),
  "47338": p("IN", "Eaton"),
  "47342": p("IN", "Gaston"),
  "47367": p("IN", "Oakville"),
  "47383": p("IN", "Selma"),
  "47396": p("IN", "Yorktown"),
  "47513": p("IN", "Birdseye"),
  "47521": p("IN", "Celestine"),
  "47527": p("IN", "Dubois"),
  "47532": p("IN", "Ferdinand"),
  "47541": p("IN", "Holland"),
  "47542": p("IN", "Huntingburg"),
  "47545": p("IN", "Ireland"),
  "47546": p("IN", "Jasper"),
  "47547": p("IN", "Jasper"),
  "47549": p("IN", "Jasper"),
  "47575": p("IN", "Saint Anthony"),
  "47580": p("IN", "Schnellville"),
  "46507": p("IN", "Bristol"),
  "46514": p("IN", "Elkhart"),
  "46515": p("IN", "Elkhart"),
  "46516": p("IN", "Elkhart"),
  "46517": p("IN", "Elkhart"),
  "46526": p("IN", "Goshen"),
  "46527": p("IN", "Goshen"),
  "46528": p("IN", "Goshen"),
  "46540": p("IN", "Middlebury"),
  "46543": p("IN", "Millersburg"),
  "46550": p("IN", "Nappanee"),
  "46553": p("IN", "New Paris"),
  "46573": p("IN", "Wakarusa"),
  "46133": p("IN", "Glenwood"),
  "47322": p("IN", "Bentonville"),
  "47331": p("IN", "Connersville"),
  "47119": p("IN", "Floyds Knobs"),
  "47122": p("IN", "Georgetown"),
  "47124": p("IN", "Greenville"),
  "47146": p("IN", "Mount Saint Francis"),
  "47150": p("IN", "New Albany"),
  "47151": p("IN", "New Albany"),
  "47918": p("IN", "Attica"),
  "47932": p("IN", "Covington"),
  "47949": p("IN", "Hillsboro"),
  "47952": p("IN", "Kingman"),
  "47958": p("IN", "Mellott"),
  "47969": p("IN", "Newtown"),
  "47987": p("IN", "Veedersburg"),
  "47988": p("IN", "Wallace"),
  "47003": p("IN", "West College Corner"),
  "47010": p("IN", "Bath"),
  "47012": p("IN", "Brookville"),
  "47016": p("IN", "Cedar Grove"),
  "47024": p("IN", "Laurel"),
  "47030": p("IN", "Metamora"),
  "47035": p("IN", "New Trenton"),
  "47036": p("IN", "Oldenburg"),
  "46910": p("IN", "Akron"),
  "46912": p("IN", "Athens"),
  "46922": p("IN", "Delong"),
  "46931": p("IN", "Fulton"),
  "46935": p("IN", "Grass Creek"),
  "46939": p("IN", "Kewanna"),
  "46945": p("IN", "Leiters Ford"),
  "46975": p("IN", "Rochester"),
  "47639": p("IN", "Haubstadt"),
  "47640": p("IN", "Hazleton"),
  "47647": p("IN", "Buckskin"),
  "47648": p("IN", "Fort Branch"),
  "47649": p("IN", "Francisco"),
  "47654": p("IN", "Mackey"),
  "47660": p("IN", "Oakland City"),
  "47665": p("IN", "Owensville"),
  "47666": p("IN", "Patoka"),
  "47670": p("IN", "Princeton"),
  "47683": p("IN", "Somerville"),
  "46928": p("IN", "Fairmount"),
  "46930": p("IN", "Fowlerton"),
  "46933": p("IN", "Gas City"),
  "46938": p("IN", "Jonesboro"),
  "46952": p("IN", "Marion"),
  "46953": p("IN", "Marion"),
  "46957": p("IN", "Matthews"),
  "46986": p("IN", "Swayzee"),
  "46987": p("IN", "Sweetser"),
  "46989": p("IN", "Upland"),
  "46991": p("IN", "Van Buren"),
  "47424": p("IN", "Bloomfield"),
  "47438": p("IN", "Jasonville"),
  "47439": p("IN", "Koleen"),
  "47441": p("IN", "Linton"),
  "47443": p("IN", "Lyons"),
  "47445": p("IN", "Midland"),
  "47449": p("IN", "Newberry"),
  "47453": p("IN", "Owensburg"),
  "47457": p("IN", "Scotland"),
  "47459": p("IN", "Solsberry"),
  "47465": p("IN", "Switz City"),
  "47471": p("IN", "Worthington"),
  "46030": p("IN", "Arcadia"),
  "46031": p("IN", "Atlanta"),
  "46032": p("IN", "Carmel"),
  "46033": p("IN", "Carmel"),
  "46034": p("IN", "Cicero"),
  "46037": p("IN", "Fishers"),
  "46038": p("IN", "Fishers"),
  "46060": p("IN", "Noblesville"),
  "46061": p("IN", "Noblesville"),
  "46062": p("IN", "Noblesville"),
  "46069": p("IN", "Sheridan"),
  "46074": p("IN", "Westfield"),
  "46082": p("IN", "Carmel"),
  "46085": p("IN", "Fishers"),
  "46262": p("IN", "Indianapolis"),
  "46280": p("IN", "Indianapolis"),
  "46288": p("IN", "Indianapolis"),
  "46290": p("IN", "Indianapolis"),
  "46040": p("IN", "Fortville"),
  "46055": p("IN", "Mccordsville"),
  "46117": p("IN", "Charlottesville"),
  "46129": p("IN", "Finly"),
  "46140": p("IN", "Greenfield"),
  "46154": p("IN", "Maxwell"),
  "46163": p("IN", "New Palestine"),
  "46186": p("IN", "Wilkinson"),
  "47107": p("IN", "Bradford"),
  "47110": p("IN", "Central"),
  "47112": p("IN", "Corydon"),
  "47114": p("IN", "Crandall"),
  "47115": p("IN", "Depauw"),
  "47117": p("IN", "Elizabeth"),
  "47135": p("IN", "Laconia"),
  "47136": p("IN", "Lanesville"),
  "47142": p("IN", "Mauckport"),
  "47160": p("IN", "New Middletown"),
  "47161": p("IN", "New Salisbury"),
  "47164": p("IN", "Palmyra"),
  "47166": p("IN", "Ramsey"),
  "46103": p("IN", "Amo"),
  "46112": p("IN", "Brownsburg"),
  "46118": p("IN", "Clayton"),
  "46121": p("IN", "Coatesville"),
  "46122": p("IN", "Danville"),
  "46123": p("IN", "Avon"),
  "46149": p("IN", "Lizton"),
  "46165": p("IN", "North Salem"),
  "46167": p("IN", "Pittsboro"),
  "46168": p("IN", "Plainfield"),
  "46180": p("IN", "Stilesville"),
  "46148": p("IN", "Knightstown"),
  "47337": p("IN", "Dunreith"),
  "47344": p("IN", "Greensboro"),
  "47351": p("IN", "Kennard"),
  "47352": p("IN", "Lewisville"),
  "47356": p("IN", "Middletown"),
  "47360": p("IN", "Mooreland"),
  "47361": p("IN", "Mount Summit"),
  "47362": p("IN", "New Castle"),
  "47366": p("IN", "New Lisbon"),
  "47384": p("IN", "Shirley"),
  "47385": p("IN", "Spiceland"),
  "47386": p("IN", "Springport"),
  "47387": p("IN", "Straughn"),
  "47388": p("IN", "Sulphur Springs"),
  "46901": p("IN", "Kokomo"),
  "46902": p("IN", "Kokomo"),
  "46903": p("IN", "Kokomo"),
  "46904": p("IN", "Kokomo"),
  "46936": p("IN", "Greentown"),
  "46937": p("IN", "Hemlock"),
  "46965": p("IN", "Oakford"),
  "46979": p("IN", "Russiaville"),
  "46995": p("IN", "West Middleton"),
  "46702": p("IN", "Andrews"),
  "46713": p("IN", "Bippus"),
  "46750": p("IN", "Huntington"),
  "46770": p("IN", "Markle"),
  "46783": p("IN", "Roanoke"),
  "46792": p("IN", "Warren"),
  "47220": p("IN", "Brownstown"),
  "47228": p("IN", "Cortland"),
  "47229": p("IN", "Crothersville"),
  "47235": p("IN", "Freetown"),
  "47249": p("IN", "Kurtz"),
  "47260": p("IN", "Medora"),
  "47264": p("IN", "Norman"),
  "47274": p("IN", "Seymour"),
  "47281": p("IN", "Vallonia"),
  "46310": p("IN", "Demotte"),
  "46380": p("IN", "Tefft"),
  "46392": p("IN", "Wheatfield"),
  "47943": p("IN", "Fair Oaks"),
  "47977": p("IN", "Remington"),
  "47978": p("IN", "Rensselaer"),
  "47326": p("IN", "Bryant"),
  "47336": p("IN", "Dunkirk"),
  "47369": p("IN", "Pennville"),
  "47371": p("IN", "Portland"),
  "47373": p("IN", "Redkey"),
  "47381": p("IN", "Salamonia"),
  "47224": p("IN", "Canaan"),
  "47230": p("IN", "Deputy"),
  "47231": p("IN", "Dupont"),
  "47243": p("IN", "Hanover"),
  "47250": p("IN", "Madison"),
  "47223": p("IN", "Butlerville"),
  "47227": p("IN", "Commiskey"),
  "47245": p("IN", "Hayden"),
  "47265": p("IN", "North Vernon"),
  "47270": p("IN", "Paris Crossing"),
  "47273": p("IN", "Scipio"),
  "47282": p("IN", "Vernon"),
  "46106": p("IN", "Bargersville"),
  "46124": p("IN", "Edinburgh"),
  "46131": p("IN", "Franklin"),
  "46142": p("IN", "Greenwood"),
  "46143": p("IN", "Greenwood"),
  "46162": p("IN", "Needham"),
  "46164": p("IN", "Nineveh"),
  "46181": p("IN", "Trafalgar"),
  "46184": p("IN", "Whiteland"),
  "47512": p("IN", "Bicknell"),
  "47516": p("IN", "Bruceville"),
  "47524": p("IN", "Decker"),
  "47528": p("IN", "Edwardsport"),
  "47535": p("IN", "Freelandville"),
  "47557": p("IN", "Monroe City"),
  "47561": p("IN", "Oaktown"),
  "47573": p("IN", "Ragsdale"),
  "47578": p("IN", "Sandborn"),
  "47591": p("IN", "Vincennes"),
  "47596": p("IN", "Westphalia"),
  "47597": p("IN", "Wheatland"),
  "46502": p("IN", "Atwood"),
  "46508": p("IN", "Burket"),
  "46510": p("IN", "Claypool"),
  "46524": p("IN", "Etna Green"),
  "46538": p("IN", "Leesburg"),
  "46539": p("IN", "Mentone"),
  "46542": p("IN", "Milford"),
  "46555": p("IN", "North Webster"),
  "46562": p("IN", "Pierceton"),
  "46567": p("IN", "Syracuse"),
  "46580": p("IN", "Warsaw"),
  "46581": p("IN", "Warsaw"),
  "46582": p("IN", "Warsaw"),
  "46590": p("IN", "Winona Lake"),
  "46982": p("IN", "Silver Lake"),
  "46565": p("IN", "Shipshewana"),
  "46571": p("IN", "Topeka"),
  "46746": p("IN", "Howe"),
  "46761": p("IN", "Lagrange"),
  "46771": p("IN", "Mongo"),
  "46786": p("IN", "South Milford"),
  "46789": p("IN", "Stroh"),
  "46795": p("IN", "Wolcottville"),
  "46303": p("IN", "Cedar Lake"),
  "46307": p("IN", "Crown Point"),
  "46308": p("IN", "Crown Point"),
  "46311": p("IN", "Dyer"),
  "46312": p("IN", "East Chicago"),
  "46319": p("IN", "Griffith"),
  "46320": p("IN", "Hammond"),
  "46321": p("IN", "Munster"),
  "46322": p("IN", "Highland"),
  "46323": p("IN", "Hammond"),
  "46324": p("IN", "Hammond"),
  "46325": p("IN", "Hammond"),
  "46327": p("IN", "Hammond"),
  "46342": p("IN", "Hobart"),
  "46355": p("IN", "Leroy"),
  "46356": p("IN", "Lowell"),
  "46373": p("IN", "Saint John"),
  "46375": p("IN", "Schererville"),
  "46376": p("IN", "Schneider"),
  "46377": p("IN", "Shelby"),
  "46394": p("IN", "Whiting"),
  "46401": p("IN", "Gary"),
  "46402": p("IN", "Gary"),
  "46403": p("IN", "Gary"),
  "46404": p("IN", "Gary"),
  "46405": p("IN", "Lake Station"),
  "46406": p("IN", "Gary"),
  "46407": p("IN", "Gary"),
  "46408": p("IN", "Gary"),
  "46409": p("IN", "Gary"),
  "46410": p("IN", "Merrillville"),
  "46411": p("IN", "Merrillville"),
  "46340": p("IN", "Hanna"),
  "46345": p("IN", "Kingsbury"),
  "46346": p("IN", "Kingsford Heights"),
  "46348": p("IN", "La Crosse"),
  "46350": p("IN", "La Porte"),
  "46352": p("IN", "La Porte"),
  "46360": p("IN", "Michigan City"),
  "46361": p("IN", "Michigan City"),
  "46365": p("IN", "Mill Creek"),
  "46371": p("IN", "Rolling Prairie"),
  "46382": p("IN", "Union Mills"),
  "46390": p("IN", "Wanatah"),
  "46391": p("IN", "Westville"),
  "47420": p("IN", "Avoca"),
  "47421": p("IN", "Bedford"),
  "47436": p("IN", "Heltonville"),
  "47437": p("IN", "Huron"),
  "47446": p("IN", "Mitchell"),
  "47451": p("IN", "Oolitic"),
  "47462": p("IN", "Springville"),
  "47467": p("IN", "Tunnelton"),
  "47470": p("IN", "Williams"),
  "46001": p("IN", "Alexandria"),
  "46011": p("IN", "Anderson"),
  "46012": p("IN", "Anderson"),
  "46013": p("IN", "Anderson"),
  "46014": p("IN", "Anderson"),
  "46015": p("IN", "Anderson"),
  "46016": p("IN", "Anderson"),
  "46017": p("IN", "Anderson"),
  "46018": p("IN", "Anderson"),
  "46036": p("IN", "Elwood"),
  "46044": p("IN", "Frankton"),
  "46048": p("IN", "Ingalls"),
  "46051": p("IN", "Lapel"),
  "46056": p("IN", "Markleville"),
  "46063": p("IN", "Orestes"),
  "46064": p("IN", "Pendleton"),
  "46070": p("IN", "Summitville"),
  "46107": p("IN", "Beech Grove"),
  "46113": p("IN", "Camby"),
  "46183": p("IN", "West Newton"),
  "46201": p("IN", "Indianapolis"),
  "46202": p("IN", "Indianapolis"),
  "46203": p("IN", "Indianapolis"),
  "46204": p("IN", "Indianapolis"),
  "46205": p("IN", "Indianapolis"),
  "46206": p("IN", "Indianapolis"),
  "46207": p("IN", "Indianapolis"),
  "46208": p("IN", "Indianapolis"),
  "46209": p("IN", "Indianapolis"),
  "46211": p("IN", "Indianapolis"),
  "46213": p("IN", "Indianapolis"),
  "46214": p("IN", "Indianapolis"),
  "46216": p("IN", "Indianapolis"),
  "46217": p("IN", "Indianapolis"),
  "46218": p("IN", "Indianapolis"),
  "46219": p("IN", "Indianapolis"),
  "46220": p("IN", "Indianapolis"),
  "46221": p("IN", "Indianapolis"),
  "46222": p("IN", "Indianapolis"),
  "46224": p("IN", "Indianapolis"),
  "46225": p("IN", "Indianapolis"),
  "46226": p("IN", "Indianapolis"),
  "46227": p("IN", "Indianapolis"),
  "46228": p("IN", "Indianapolis"),
  "46229": p("IN", "Indianapolis"),
  "46230": p("IN", "Indianapolis"),
  "46231": p("IN", "Indianapolis"),
  "46234": p("IN", "Indianapolis"),
  "46235": p("IN", "Indianapolis"),
  "46236": p("IN", "Indianapolis"),
  "46237": p("IN", "Indianapolis"),
  "46239": p("IN", "Indianapolis"),
  "46240": p("IN", "Indianapolis"),
  "46241": p("IN", "Indianapolis"),
  "46242": p("IN", "Indianapolis"),
  "46244": p("IN", "Indianapolis"),
  "46247": p("IN", "Indianapolis"),
  "46249": p("IN", "Indianapolis"),
  "46250": p("IN", "Indianapolis"),
  "46251": p("IN", "Indianapolis"),
  "46253": p("IN", "Indianapolis"),
  "46254": p("IN", "Indianapolis"),
  "46255": p("IN", "Indianapolis"),
  "46256": p("IN", "Indianapolis"),
  "46259": p("IN", "Indianapolis"),
  "46260": p("IN", "Indianapolis"),
  "46266": p("IN", "Indianapolis"),
  "46268": p("IN", "Indianapolis"),
  "46274": p("IN", "Indianapolis"),
  "46275": p("IN", "Indianapolis"),
  "46277": p("IN", "Indianapolis"),
  "46278": p("IN", "Indianapolis"),
  "46282": p("IN", "Indianapolis"),
  "46283": p("IN", "Indianapolis"),
  "46285": p("IN", "Indianapolis"),
  "46291": p("IN", "Indianapolis"),
  "46295": p("IN", "Indianapolis"),
  "46296": p("IN", "Indianapolis"),
  "46298": p("IN", "Indianapolis"),
  "46501": p("IN", "Argos"),
  "46504": p("IN", "Bourbon"),
  "46506": p("IN", "Bremen"),
  "46511": p("IN", "Culver"),
  "46513": p("IN", "Donaldson"),
  "46537": p("IN", "Lapaz"),
  "46563": p("IN", "Plymouth"),
  "46570": p("IN", "Tippecanoe"),
  "46572": p("IN", "Tyner"),
  "47522": p("IN", "Crane"),
  "47553": p("IN", "Loogootee"),
  "47581": p("IN", "Shoals"),
  "46911": p("IN", "Amboy"),
  "46914": p("IN", "Bunker Hill"),
  "46919": p("IN", "Converse"),
  "46921": p("IN", "Deedsville"),
  "46926": p("IN", "Denver"),
  "46951": p("IN", "Macy"),
  "46958": p("IN", "Mexico"),
  "46959": p("IN", "Miami"),
  "46970": p("IN", "Peru"),
  "46971": p("IN", "Grissom Arb"),
  "47401": p("IN", "Bloomington"),
  "47402": p("IN", "Bloomington"),
  "47403": p("IN", "Bloomington"),
  "47404": p("IN", "Bloomington"),
  "47405": p("IN", "Bloomington"),
  "47406": p("IN", "Bloomington"),
  "47407": p("IN", "Bloomington"),
  "47408": p("IN", "Bloomington"),
  "47426": p("IN", "Clear Creek"),
  "47429": p("IN", "Ellettsville"),
  "47434": p("IN", "Harrodsburg"),
  "47458": p("IN", "Smithville"),
  "47463": p("IN", "Stanford"),
  "47464": p("IN", "Stinesville"),
  "47468": p("IN", "Unionville"),
  "47916": p("IN", "Alamo"),
  "47933": p("IN", "Crawfordsville"),
  "47940": p("IN", "Darlington"),
  "47954": p("IN", "Ladoga"),
  "47955": p("IN", "Linden"),
  "47965": p("IN", "New Market"),
  "47967": p("IN", "New Richmond"),
  "47968": p("IN", "New Ross"),
  "47989": p("IN", "Waveland"),
  "47990": p("IN", "Waynetown"),
  "47994": p("IN", "Wingate"),
  "46111": p("IN", "Brooklyn"),
  "46125": p("IN", "Eminence"),
  "46151": p("IN", "Martinsville"),
  "46157": p("IN", "Monrovia"),
  "46158": p("IN", "Mooresville"),
  "46166": p("IN", "Paragon"),
  "46349": p("IN", "Lake Village"),
  "46372": p("IN", "Roselawn"),
  "46379": p("IN", "Sumava Resorts"),
  "46381": p("IN", "Thayer"),
  "47922": p("IN", "Brook"),
  "47948": p("IN", "Goodland"),
  "47951": p("IN", "Kentland"),
  "47963": p("IN", "Morocco"),
  "47964": p("IN", "Mount Ayr"),
  "46701": p("IN", "Albion"),
  "46710": p("IN", "Avilla"),
  "46732": p("IN", "Cromwell"),
  "46755": p("IN", "Kendallville"),
  "46760": p("IN", "Kimmell"),
  "46763": p("IN", "Laotto"),
  "46767": p("IN", "Ligonier"),
  "46784": p("IN", "Rome City"),
  "46794": p("IN", "Wawaka"),
  "46796": p("IN", "Wolflake"),
  "47040": p("IN", "Rising Sun"),
  "47432": p("IN", "French Lick"),
  "47452": p("IN", "Orleans"),
  "47454": p("IN", "Paoli"),
  "47469": p("IN", "West Baden Springs"),
  "47427": p("IN", "Coal City"),
  "47431": p("IN", "Freedom"),
  "47433": p("IN", "Gosport"),
  "47455": p("IN", "Patricksburg"),
  "47456": p("IN", "Quincy"),
  "47460": p("IN", "Spencer"),
  "47830": p("IN", "Bellmore"),
  "47832": p("IN", "Bloomingdale"),
  "47836": p("IN", "Bridgeton"),
  "47859": p("IN", "Marshall"),
  "47860": p("IN", "Mecca"),
  "47862": p("IN", "Montezuma"),
  "47872": p("IN", "Rockville"),
  "47874": p("IN", "Rosedale"),
  "47514": p("IN", "Branchville"),
  "47515": p("IN", "Bristow"),
  "47520": p("IN", "Cannelton"),
  "47525": p("IN", "Derby"),
  "47551": p("IN", "Leopold"),
  "47574": p("IN", "Rome"),
  "47576": p("IN", "Saint Croix"),
  "47586": p("IN", "Tell City"),
  "47564": p("IN", "Otwell"),
  "47567": p("IN", "Petersburg"),
  "47584": p("IN", "Spurgeon"),
  "47585": p("IN", "Stendal"),
  "47590": p("IN", "Velpen"),
  "47598": p("IN", "Winslow"),
  "46301": p("IN", "Beverly Shores"),
  "46302": p("IN", "Boone Grove"),
  "46304": p("IN", "Chesterton"),
  "46341": p("IN", "Hebron"),
  "46347": p("IN", "Kouts"),
  "46368": p("IN", "Portage"),
  "46383": p("IN", "Valparaiso"),
  "46384": p("IN", "Valparaiso"),
  "46385": p("IN", "Valparaiso"),
  "46393": p("IN", "Wheeler"),
  "47612": p("IN", "Cynthiana"),
  "47616": p("IN", "Griffin"),
  "47620": p("IN", "Mount Vernon"),
  "47631": p("IN", "New Harmony"),
  "47633": p("IN", "Poseyville"),
  "47638": p("IN", "Wadesville"),
  "46960": p("IN", "Monterey"),
  "46985": p("IN", "Star City"),
  "46996": p("IN", "Winamac"),
  "47946": p("IN", "Francesville"),
  "47957": p("IN", "Medaryville"),
  "46105": p("IN", "Bainbridge"),
  "46120": p("IN", "Cloverdale"),
  "46128": p("IN", "Fillmore"),
  "46135": p("IN", "Greencastle"),
  "46170": p("IN", "Putnamville"),
  "46171": p("IN", "Reelsville"),
  "46172": p("IN", "Roachdale"),
  "46175": p("IN", "Russellville"),
  "47340": p("IN", "Farmland"),
  "47354": p("IN", "Losantville"),
  "47355": p("IN", "Lynn"),
  "47358": p("IN", "Modoc"),
  "47368": p("IN", "Parker City"),
  "47380": p("IN", "Ridgeville"),
  "47382": p("IN", "Saratoga"),
  "47390": p("IN", "Union City"),
  "47394": p("IN", "Winchester"),
  "47006": p("IN", "Batesville"),
  "47017": p("IN", "Cross Plains"),
  "47021": p("IN", "Friendship"),
  "47023": p("IN", "Holton"),
  "47031": p("IN", "Milan"),
  "47033": p("IN", "Morris"),
  "47034": p("IN", "Napoleon"),
  "47037": p("IN", "Osgood"),
  "47039": p("IN", "Pierceville"),
  "47041": p("IN", "Sunman"),
  "47042": p("IN", "Versailles"),
  "46104": p("IN", "Arlington"),
  "46115": p("IN", "Carthage"),
  "46127": p("IN", "Falmouth"),
  "46146": p("IN", "Homer"),
  "46150": p("IN", "Manilla"),
  "46155": p("IN", "Mays"),
  "46156": p("IN", "Milroy"),
  "46173": p("IN", "Rushville"),
  "46530": p("IN", "Granger"),
  "46536": p("IN", "Lakeville"),
  "46544": p("IN", "Mishawaka"),
  "46545": p("IN", "Mishawaka"),
  "46546": p("IN", "Mishawaka"),
  "46552": p("IN", "New Carlisle"),
  "46554": p("IN", "North Liberty"),
  "46556": p("IN", "Notre Dame"),
  "46561": p("IN", "Osceola"),
  "46574": p("IN", "Walkerton"),
  "46595": p("IN", "Wyatt"),
  "46601": p("IN", "South Bend"),
  "46613": p("IN", "South Bend"),
  "46614": p("IN", "South Bend"),
  "46615": p("IN", "South Bend"),
  "46616": p("IN", "South Bend"),
  "46617": p("IN", "South Bend"),
  "46619": p("IN", "South Bend"),
  "46624": p("IN", "South Bend"),
  "46626": p("IN", "South Bend"),
  "46628": p("IN", "South Bend"),
  "46634": p("IN", "South Bend"),
  "46635": p("IN", "South Bend"),
  "46637": p("IN", "South Bend"),
  "46660": p("IN", "South Bend"),
  "46680": p("IN", "South Bend"),
  "46699": p("IN", "South Bend"),
  "47102": p("IN", "Austin"),
  "47138": p("IN", "Lexington"),
  "47170": p("IN", "Scottsburg"),
  "46110": p("IN", "Boggstown"),
  "46126": p("IN", "Fairland"),
  "46130": p("IN", "Fountaintown"),
  "46144": p("IN", "Gwynneville"),
  "46161": p("IN", "Morristown"),
  "46176": p("IN", "Shelbyville"),
  "46182": p("IN", "Waldron"),
  "47234": p("IN", "Flat Rock"),
  "47523": p("IN", "Dale"),
  "47531": p("IN", "Evanston"),
  "47536": p("IN", "Fulda"),
  "47537": p("IN", "Gentryville"),
  "47550": p("IN", "Lamar"),
  "47552": p("IN", "Lincoln City"),
  "47556": p("IN", "Mariah Hill"),
  "47577": p("IN", "Saint Meinrad"),
  "47579": p("IN", "Santa Claus"),
  "47588": p("IN", "Troy"),
  "47611": p("IN", "Chrisney"),
  "47615": p("IN", "Grandview"),
  "47617": p("IN", "Hatfield"),
  "47634": p("IN", "Richland"),
  "47635": p("IN", "Rockport"),
  "46366": p("IN", "North Judson"),
  "46374": p("IN", "San Pierre"),
  "46531": p("IN", "Grovertown"),
  "46532": p("IN", "Hamlet"),
  "46534": p("IN", "Knox"),
  "46968": p("IN", "Ora"),
  "46703": p("IN", "Angola"),
  "46737": p("IN", "Fremont"),
  "46742": p("IN", "Hamilton"),
  "46747": p("IN", "Hudson"),
  "46776": p("IN", "Orland"),
  "46779": p("IN", "Pleasant Lake"),
  "47838": p("IN", "Carlisle"),
  "47848": p("IN", "Dugger"),
  "47849": p("IN", "Fairbanks"),
  "47850": p("IN", "Farmersburg"),
  "47852": p("IN", "Graysville"),
  "47855": p("IN", "Hymera"),
  "47861": p("IN", "Merom"),
  "47865": p("IN", "Paxton"),
  "47879": p("IN", "Shelburn"),
  "47882": p("IN", "Sullivan"),
  "47011": p("IN", "Bennington"),
  "47019": p("IN", "East Enterprise"),
  "47020": p("IN", "Florence"),
  "47038": p("IN", "Patriot"),
  "47043": p("IN", "Vevay"),
  "47901": p("IN", "Lafayette"),
  "47902": p("IN", "Lafayette"),
  "47903": p("IN", "Lafayette"),
  "47904": p("IN", "Lafayette"),
  "47905": p("IN", "Lafayette"),
  "47906": p("IN", "West Lafayette"),
  "47907": p("IN", "West Lafayette"),
  "47909": p("IN", "Lafayette"),
  "47920": p("IN", "Battle Ground"),
  "47924": p("IN", "Buck Creek"),
  "47930": p("IN", "Clarks Hill"),
  "47941": p("IN", "Dayton"),
  "47962": p("IN", "Montmorenci"),
  "47981": p("IN", "Romney"),
  "47983": p("IN", "Stockwell"),
  "47992": p("IN", "Westpoint"),
  "47996": p("IN", "West Lafayette"),
  "46045": p("IN", "Goldsmith"),
  "46047": p("IN", "Hobbs"),
  "46049": p("IN", "Kempton"),
  "46068": p("IN", "Sharpsville"),
  "46072": p("IN", "Tipton"),
  "46076": p("IN", "Windfall"),
  "47325": p("IN", "Brownsville"),
  "47353": p("IN", "Liberty"),
  "47618": p("IN", "Inglefield"),
  "47701": p("IN", "Evansville"),
  "47702": p("IN", "Evansville"),
  "47703": p("IN", "Evansville"),
  "47704": p("IN", "Evansville"),
  "47705": p("IN", "Evansville"),
  "47706": p("IN", "Evansville"),
  "47708": p("IN", "Evansville"),
  "47710": p("IN", "Evansville"),
  "47711": p("IN", "Evansville"),
  "47712": p("IN", "Evansville"),
  "47713": p("IN", "Evansville"),
  "47714": p("IN", "Evansville"),
  "47715": p("IN", "Evansville"),
  "47716": p("IN", "Evansville"),
  "47719": p("IN", "Evansville"),
  "47720": p("IN", "Evansville"),
  "47721": p("IN", "Evansville"),
  "47722": p("IN", "Evansville"),
  "47724": p("IN", "Evansville"),
  "47725": p("IN", "Evansville"),
  "47728": p("IN", "Evansville"),
  "47730": p("IN", "Evansville"),
  "47731": p("IN", "Evansville"),
  "47732": p("IN", "Evansville"),
  "47733": p("IN", "Evansville"),
  "47734": p("IN", "Evansville"),
  "47735": p("IN", "Evansville"),
  "47736": p("IN", "Evansville"),
  "47737": p("IN", "Evansville"),
  "47740": p("IN", "Evansville"),
  "47747": p("IN", "Evansville"),
  "47750": p("IN", "Evansville"),
  "47831": p("IN", "Blanford"),
  "47842": p("IN", "Clinton"),
  "47847": p("IN", "Dana"),
  "47854": p("IN", "Hillsdale"),
  "47875": p("IN", "Saint Bernice"),
  "47884": p("IN", "Universal"),
  "47928": p("IN", "Cayuga"),
  "47966": p("IN", "Newport"),
  "47974": p("IN", "Perrysville"),
  "47801": p("IN", "Terre Haute"),
  "47802": p("IN", "Terre Haute"),
  "47803": p("IN", "Terre Haute"),
  "47804": p("IN", "Terre Haute"),
  "47805": p("IN", "Terre Haute"),
  "47807": p("IN", "Terre Haute"),
  "47808": p("IN", "Terre Haute"),
  "47809": p("IN", "Terre Haute"),
  "47851": p("IN", "Fontanet"),
  "47858": p("IN", "Lewis"),
  "47863": p("IN", "New Goshen"),
  "47866": p("IN", "Pimento"),
  "47869": p("IN", "Prairie Creek"),
  "47870": p("IN", "Prairieton"),
  "47871": p("IN", "Riley"),
  "47876": p("IN", "Saint Mary Of The Woods"),
  "47878": p("IN", "Seelyville"),
  "47880": p("IN", "Shepardsville"),
  "47885": p("IN", "West Terre Haute"),
  "46940": p("IN", "La Fontaine"),
  "46941": p("IN", "Lagro"),
  "46943": p("IN", "Laketon"),
  "46946": p("IN", "Liberty Mills"),
  "46962": p("IN", "North Manchester"),
  "46974": p("IN", "Roann"),
  "46980": p("IN", "Servia"),
  "46984": p("IN", "Somerset"),
  "46990": p("IN", "Urbana"),
  "46992": p("IN", "Wabash"),
  "47975": p("IN", "Pine Village"),
  "47982": p("IN", "State Line"),
  "47991": p("IN", "West Lebanon"),
  "47993": p("IN", "Williamsport"),
  "47601": p("IN", "Boonville"),
  "47610": p("IN", "Chandler"),
  "47613": p("IN", "Elberfeld"),
  "47619": p("IN", "Lynnville"),
  "47629": p("IN", "Newburgh"),
  "47630": p("IN", "Newburgh"),
  "47637": p("IN", "Tennyson"),
  "47108": p("IN", "Campbellsburg"),
  "47120": p("IN", "Fredericksburg"),
  "47125": p("IN", "Hardinsburg"),
  "47165": p("IN", "Pekin"),
  "47167": p("IN", "Salem"),
  "47324": p("IN", "Boston"),
  "47327": p("IN", "Cambridge City"),
  "47330": p("IN", "Centerville"),
  "47335": p("IN", "Dublin"),
  "47339": p("IN", "Economy"),
  "47341": p("IN", "Fountain City"),
  "47345": p("IN", "Greens Fork"),
  "47346": p("IN", "Hagerstown"),
  "47357": p("IN", "Milton"),
  "47370": p("IN", "Pershing"),
  "47374": p("IN", "Richmond"),
  "47375": p("IN", "Richmond"),
  "47392": p("IN", "Webster"),
  "47393": p("IN", "Williamsburg"),
  "46714": p("IN", "Bluffton"),
  "46731": p("IN", "Craigville"),
  "46759": p("IN", "Keystone"),
  "46766": p("IN", "Liberty Center"),
  "46777": p("IN", "Ossian"),
  "46778": p("IN", "Petroleum"),
  "46781": p("IN", "Poneto"),
  "46791": p("IN", "Uniondale"),
  "47923": p("IN", "Brookston"),
  "47925": p("IN", "Buffalo"),
  "47926": p("IN", "Burnettsville"),
  "47929": p("IN", "Chalmers"),
  "47950": p("IN", "Idaville"),
  "47959": p("IN", "Monon"),
  "47960": p("IN", "Monticello"),
  "47980": p("IN", "Reynolds"),
  "47995": p("IN", "Wolcott"),
  "46723": p("IN", "Churubusco"),
  "46725": p("IN", "Columbia City"),
  "46764": p("IN", "Larwill"),
  "46787": p("IN", "South Whitley"),
  "66732": p("KS", "Elsmore"),
  "66742": p("KS", "Gas"),
  "66748": p("KS", "Humboldt"),
  "66749": p("KS", "Iola"),
  "66751": p("KS", "La Harpe"),
  "66755": p("KS", "Moran"),
  "66772": p("KS", "Savonburg"),
  "66015": p("KS", "Colony"),
  "66032": p("KS", "Garnett"),
  "66033": p("KS", "Greeley"),
  "66039": p("KS", "Kincaid"),
  "66091": p("KS", "Welda"),
  "66093": p("KS", "Westphalia"),
  "66002": p("KS", "Atchison"),
  "66016": p("KS", "Cummings"),
  "66023": p("KS", "Effingham"),
  "66041": p("KS", "Lancaster"),
  "66058": p("KS", "Muscotah"),
  "67057": p("KS", "Hardtner"),
  "67061": p("KS", "Hazelton"),
  "67065": p("KS", "Isabel"),
  "67070": p("KS", "Kiowa"),
  "67071": p("KS", "Lake City"),
  "67104": p("KS", "Medicine Lodge"),
  "67138": p("KS", "Sharon"),
  "67143": p("KS", "Sun City"),
  "67511": p("KS", "Albert"),
  "67525": p("KS", "Claflin"),
  "67526": p("KS", "Ellinwood"),
  "67530": p("KS", "Great Bend"),
  "67544": p("KS", "Hoisington"),
  "67564": p("KS", "Olmitz"),
  "67567": p("KS", "Pawnee Rock"),
  "66701": p("KS", "Fort Scott"),
  "66716": p("KS", "Bronson"),
  "66738": p("KS", "Fulton"),
  "66741": p("KS", "Garland"),
  "66754": p("KS", "Mapleton"),
  "66769": p("KS", "Redfield"),
  "66779": p("KS", "Uniontown"),
  "66424": p("KS", "Everest"),
  "66425": p("KS", "Fairview"),
  "66434": p("KS", "Hiawatha"),
  "66439": p("KS", "Horton"),
  "66515": p("KS", "Morrill"),
  "66527": p("KS", "Powhattan"),
  "66532": p("KS", "Robinson"),
  "66842": p("KS", "Cassoday"),
  "67002": p("KS", "Andover"),
  "67010": p("KS", "Augusta"),
  "67012": p("KS", "Beaumont"),
  "67017": p("KS", "Benton"),
  "67039": p("KS", "Douglass"),
  "67041": p("KS", "Elbing"),
  "67042": p("KS", "El Dorado"),
  "67072": p("KS", "Latham"),
  "67074": p("KS", "Leon"),
  "67123": p("KS", "Potwin"),
  "67132": p("KS", "Rosalia"),
  "67133": p("KS", "Rose Hill"),
  "67144": p("KS", "Towanda"),
  "67154": p("KS", "Whitewater"),
  "66843": p("KS", "Cedar Point"),
  "66845": p("KS", "Cottonwood Falls"),
  "66850": p("KS", "Elmdale"),
  "66862": p("KS", "Matfield Green"),
  "66869": p("KS", "Strong City"),
  "67024": p("KS", "Cedar Vale"),
  "67334": p("KS", "Chautauqua"),
  "67355": p("KS", "Niotaze"),
  "67360": p("KS", "Peru"),
  "67361": p("KS", "Sedan"),
  "66713": p("KS", "Baxter Springs"),
  "66725": p("KS", "Columbus"),
  "66728": p("KS", "Crestline"),
  "66739": p("KS", "Galena"),
  "66770": p("KS", "Riverton"),
  "66773": p("KS", "Scammon"),
  "66778": p("KS", "Treece"),
  "66781": p("KS", "Weir"),
  "66782": p("KS", "West Mineral"),
  "67731": p("KS", "Bird City"),
  "67756": p("KS", "Saint Francis"),
  "67831": p("KS", "Ashland"),
  "67840": p("KS", "Englewood"),
  "67865": p("KS", "Minneola"),
  "67432": p("KS", "Clay Center"),
  "67447": p("KS", "Green"),
  "67458": p("KS", "Longford"),
  "67468": p("KS", "Morganville"),
  "67487": p("KS", "Wakefield"),
  "66901": p("KS", "Concordia"),
  "66938": p("KS", "Clyde"),
  "66948": p("KS", "Jamestown"),
  "67417": p("KS", "Aurora"),
  "67445": p("KS", "Glasco"),
  "67466": p("KS", "Miltonvale"),
  "66839": p("KS", "Burlington"),
  "66852": p("KS", "Gridley"),
  "66856": p("KS", "Lebo"),
  "66857": p("KS", "Le Roy"),
  "66871": p("KS", "Waverly"),
  "67029": p("KS", "Coldwater"),
  "67127": p("KS", "Protection"),
  "67155": p("KS", "Wilmore"),
  "67005": p("KS", "Arkansas City"),
  "67008": p("KS", "Atlanta"),
  "67019": p("KS", "Burden"),
  "67023": p("KS", "Cambridge"),
  "67038": p("KS", "Dexter"),
  "67102": p("KS", "Maple City"),
  "67131": p("KS", "Rock"),
  "67146": p("KS", "Udall"),
  "67156": p("KS", "Winfield"),
  "66711": p("KS", "Arcadia"),
  "66712": p("KS", "Arma"),
  "66724": p("KS", "Cherokee"),
  "66734": p("KS", "Farlington"),
  "66735": p("KS", "Franklin"),
  "66743": p("KS", "Girard"),
  "66746": p("KS", "Hepler"),
  "66753": p("KS", "Mc Cune"),
  "66756": p("KS", "Mulberry"),
  "66760": p("KS", "Opolis"),
  "66762": p("KS", "Pittsburg"),
  "66763": p("KS", "Frontenac"),
  "66780": p("KS", "Walnut"),
  "67635": p("KS", "Dresden"),
  "67643": p("KS", "Jennings"),
  "67653": p("KS", "Norcatur"),
  "67749": p("KS", "Oberlin"),
  "67410": p("KS", "Abilene"),
  "67431": p("KS", "Chapman"),
  "67441": p("KS", "Enterprise"),
  "67449": p("KS", "Herington"),
  "67451": p("KS", "Hope"),
  "67480": p("KS", "Solomon"),
  "67482": p("KS", "Talmage"),
  "67492": p("KS", "Woodbine"),
  "66008": p("KS", "Bendena"),
  "66017": p("KS", "Denton"),
  "66024": p("KS", "Elwood"),
  "66035": p("KS", "Highland"),
  "66087": p("KS", "Troy"),
  "66090": p("KS", "Wathena"),
  "66094": p("KS", "White Cloud"),
  "66006": p("KS", "Baldwin City"),
  "66025": p("KS", "Eudora"),
  "66044": p("KS", "Lawrence"),
  "66045": p("KS", "Lawrence"),
  "66046": p("KS", "Lawrence"),
  "66047": p("KS", "Lawrence"),
  "66049": p("KS", "Lawrence"),
  "66050": p("KS", "Lecompton"),
  "67519": p("KS", "Belpre"),
  "67547": p("KS", "Kinsley"),
  "67552": p("KS", "Lewis"),
  "67563": p("KS", "Offerle"),
  "67345": p("KS", "Elk Falls"),
  "67346": p("KS", "Grenola"),
  "67349": p("KS", "Howard"),
  "67352": p("KS", "Longton"),
  "67353": p("KS", "Moline"),
  "67601": p("KS", "Hays"),
  "67627": p("KS", "Catharine"),
  "67637": p("KS", "Ellis"),
  "67660": p("KS", "Pfeifer"),
  "67667": p("KS", "Schoenchen"),
  "67671": p("KS", "Victoria"),
  "67674": p("KS", "Walker"),
  "67439": p("KS", "Ellsworth"),
  "67450": p("KS", "Holyrood"),
  "67454": p("KS", "Kanopolis"),
  "67459": p("KS", "Lorraine"),
  "67490": p("KS", "Wilson"),
  "67846": p("KS", "Garden City"),
  "67851": p("KS", "Holcomb"),
  "67868": p("KS", "Pierceville"),
  "67801": p("KS", "Dodge City"),
  "67834": p("KS", "Bucklin"),
  "67842": p("KS", "Ford"),
  "67843": p("KS", "Fort Dodge"),
  "67876": p("KS", "Spearville"),
  "67882": p("KS", "Wright"),
  "66042": p("KS", "Lane"),
  "66067": p("KS", "Ottawa"),
  "66076": p("KS", "Pomona"),
  "66078": p("KS", "Princeton"),
  "66079": p("KS", "Rantoul"),
  "66080": p("KS", "Richmond"),
  "66092": p("KS", "Wellsville"),
  "66095": p("KS", "Williamsburg"),
  "66441": p("KS", "Junction City"),
  "66442": p("KS", "Fort Riley"),
  "66514": p("KS", "Milford"),
  "67736": p("KS", "Gove"),
  "67737": p("KS", "Grainfield"),
  "67738": p("KS", "Grinnell"),
  "67751": p("KS", "Park"),
  "67752": p("KS", "Quinter"),
  "67625": p("KS", "Bogue"),
  "67642": p("KS", "Hill City"),
  "67650": p("KS", "Morland"),
  "67659": p("KS", "Penokee"),
  "67880": p("KS", "Ulysses"),
  "67835": p("KS", "Cimarron"),
  "67837": p("KS", "Copeland"),
  "67841": p("KS", "Ensign"),
  "67853": p("KS", "Ingalls"),
  "67867": p("KS", "Montezuma"),
  "67879": p("KS", "Tribune"),
  "66853": p("KS", "Hamilton"),
  "66855": p("KS", "Lamont"),
  "66860": p("KS", "Madison"),
  "66863": p("KS", "Neal"),
  "66870": p("KS", "Virgil"),
  "67045": p("KS", "Eureka"),
  "67047": p("KS", "Fall River"),
  "67122": p("KS", "Piedmont"),
  "67137": p("KS", "Severy"),
  "67836": p("KS", "Coolidge"),
  "67857": p("KS", "Kendall"),
  "67878": p("KS", "Syracuse"),
  "67003": p("KS", "Anthony"),
  "67009": p("KS", "Attica"),
  "67018": p("KS", "Bluff City"),
  "67036": p("KS", "Danville"),
  "67049": p("KS", "Freeport"),
  "67058": p("KS", "Harper"),
  "67150": p("KS", "Waldron"),
  "67020": p("KS", "Burrton"),
  "67056": p("KS", "Halstead"),
  "67062": p("KS", "Hesston"),
  "67114": p("KS", "Newton"),
  "67117": p("KS", "North Newton"),
  "67135": p("KS", "Sedgwick"),
  "67151": p("KS", "Walton"),
  "67870": p("KS", "Satanta"),
  "67877": p("KS", "Sublette"),
  "67849": p("KS", "Hanston"),
  "67854": p("KS", "Jetmore"),
  "66416": p("KS", "Circleville"),
  "66418": p("KS", "Delia"),
  "66419": p("KS", "Denison"),
  "66436": p("KS", "Holton"),
  "66440": p("KS", "Hoyt"),
  "66509": p("KS", "Mayetta"),
  "66516": p("KS", "Netawaka"),
  "66540": p("KS", "Soldier"),
  "66552": p("KS", "Whiting"),
  "66054": p("KS", "Mc Louth"),
  "66060": p("KS", "Nortonville"),
  "66066": p("KS", "Oskaloosa"),
  "66070": p("KS", "Ozawkie"),
  "66073": p("KS", "Perry"),
  "66088": p("KS", "Valley Falls"),
  "66097": p("KS", "Winchester"),
  "66429": p("KS", "Grantville"),
  "66512": p("KS", "Meriden"),
  "66936": p("KS", "Burr Oak"),
  "66941": p("KS", "Esbon"),
  "66942": p("KS", "Formoso"),
  "66949": p("KS", "Jewell"),
  "66956": p("KS", "Mankato"),
  "66963": p("KS", "Randall"),
  "66970": p("KS", "Webber"),
  "66018": p("KS", "De Soto"),
  "66021": p("KS", "Edgerton"),
  "66030": p("KS", "Gardner"),
  "66031": p("KS", "New Century"),
  "66051": p("KS", "Olathe"),
  "66061": p("KS", "Olathe"),
  "66062": p("KS", "Olathe"),
  "66063": p("KS", "Olathe"),
  "66083": p("KS", "Spring Hill"),
  "66085": p("KS", "Stilwell"),
  "66201": p("KS", "Mission"),
  "66202": p("KS", "Mission"),
  "66203": p("KS", "Shawnee"),
  "66204": p("KS", "Overland Park"),
  "66205": p("KS", "Mission"),
  "66206": p("KS", "Leawood"),
  "66207": p("KS", "Overland Park"),
  "66208": p("KS", "Prairie Village"),
  "66209": p("KS", "Leawood"),
  "66210": p("KS", "Overland Park"),
  "66211": p("KS", "Leawood"),
  "66212": p("KS", "Overland Park"),
  "66213": p("KS", "Overland Park"),
  "66214": p("KS", "Overland Park"),
  "66215": p("KS", "Lenexa"),
  "66216": p("KS", "Shawnee"),
  "66217": p("KS", "Shawnee"),
  "66218": p("KS", "Shawnee"),
  "66219": p("KS", "Lenexa"),
  "66220": p("KS", "Lenexa"),
  "66221": p("KS", "Overland Park"),
  "66222": p("KS", "Mission"),
  "66223": p("KS", "Overland Park"),
  "66224": p("KS", "Overland Park"),
  "66225": p("KS", "Overland Park"),
  "66226": p("KS", "Shawnee"),
  "66227": p("KS", "Lenexa"),
  "66250": p("KS", "Lenexa"),
  "66251": p("KS", "Overland Park"),
  "66276": p("KS", "Shawnee Mission"),
  "66282": p("KS", "Overland Park"),
  "66283": p("KS", "Overland Park"),
  "66285": p("KS", "Lenexa"),
  "66286": p("KS", "Shawnee"),
  "67838": p("KS", "Deerfield"),
  "67860": p("KS", "Lakin"),
  "67035": p("KS", "Cunningham"),
  "67068": p("KS", "Kingman"),
  "67111": p("KS", "Murdock"),
  "67112": p("KS", "Nashville"),
  "67118": p("KS", "Norwich"),
  "67142": p("KS", "Spivey"),
  "67159": p("KS", "Zenda"),
  "67054": p("KS", "Greensburg"),
  "67059": p("KS", "Haviland"),
  "67109": p("KS", "Mullinville"),
  "67330": p("KS", "Altamont"),
  "67332": p("KS", "Bartlett"),
  "67336": p("KS", "Chetopa"),
  "67341": p("KS", "Dennis"),
  "67342": p("KS", "Edna"),
  "67354": p("KS", "Mound Valley"),
  "67356": p("KS", "Oswego"),
  "67357": p("KS", "Parsons"),
  "67839": p("KS", "Dighton"),
  "67850": p("KS", "Healy"),
  "66007": p("KS", "Basehor"),
  "66020": p("KS", "Easton"),
  "66027": p("KS", "Fort Leavenworth"),
  "66043": p("KS", "Lansing"),
  "66048": p("KS", "Leavenworth"),
  "66052": p("KS", "Linwood"),
  "66086": p("KS", "Tonganoxie"),
  "67418": p("KS", "Barnard"),
  "67423": p("KS", "Beverly"),
  "67455": p("KS", "Lincoln"),
  "67481": p("KS", "Sylvan Grove"),
  "66010": p("KS", "Blue Mound"),
  "66014": p("KS", "Centerville"),
  "66040": p("KS", "Lacygne"),
  "66056": p("KS", "Mound City"),
  "66072": p("KS", "Parker"),
  "66075": p("KS", "Pleasanton"),
  "66767": p("KS", "Prescott"),
  "67747": p("KS", "Monument"),
  "67748": p("KS", "Oakley"),
  "67764": p("KS", "Winona"),
  "66801": p("KS", "Emporia"),
  "66830": p("KS", "Admire"),
  "66833": p("KS", "Allen"),
  "66835": p("KS", "Americus"),
  "66854": p("KS", "Hartford"),
  "66864": p("KS", "Neosho Rapids"),
  "66865": p("KS", "Olpe"),
  "66868": p("KS", "Reading"),
  "67107": p("KS", "Moundridge"),
  "67428": p("KS", "Canton"),
  "67443": p("KS", "Galva"),
  "67456": p("KS", "Lindsborg"),
  "67460": p("KS", "Mcpherson"),
  "67464": p("KS", "Marquette"),
  "67476": p("KS", "Roxbury"),
  "67491": p("KS", "Windom"),
  "67546": p("KS", "Inman"),
  "66840": p("KS", "Burns"),
  "66851": p("KS", "Florence"),
  "66858": p("KS", "Lincolnville"),
  "66859": p("KS", "Lost Springs"),
  "66861": p("KS", "Marion"),
  "66866": p("KS", "Peabody"),
  "67053": p("KS", "Goessel"),
  "67063": p("KS", "Hillsboro"),
  "67073": p("KS", "Lehigh"),
  "67438": p("KS", "Durham"),
  "67475": p("KS", "Ramona"),
  "67483": p("KS", "Tampa"),
  "66403": p("KS", "Axtell"),
  "66406": p("KS", "Beattie"),
  "66411": p("KS", "Blue Rapids"),
  "66412": p("KS", "Bremen"),
  "66427": p("KS", "Frankfort"),
  "66438": p("KS", "Home"),
  "66508": p("KS", "Marysville"),
  "66518": p("KS", "Oketo"),
  "66541": p("KS", "Summerfield"),
  "66544": p("KS", "Vermillion"),
  "66548": p("KS", "Waterville"),
  "67844": p("KS", "Fowler"),
  "67864": p("KS", "Meade"),
  "67869": p("KS", "Plains"),
  "66013": p("KS", "Bucyrus"),
  "66026": p("KS", "Fontana"),
  "66036": p("KS", "Hillsdale"),
  "66053": p("KS", "Louisburg"),
  "66064": p("KS", "Osawatomie"),
  "66071": p("KS", "Paola"),
  "67420": p("KS", "Beloit"),
  "67430": p("KS", "Cawker City"),
  "67446": p("KS", "Glen Elder"),
  "67452": p("KS", "Hunter"),
  "67478": p("KS", "Simpson"),
  "67485": p("KS", "Tipton"),
  "67301": p("KS", "Independence"),
  "67333": p("KS", "Caney"),
  "67335": p("KS", "Cherryvale"),
  "67337": p("KS", "Coffeyville"),
  "67340": p("KS", "Dearing"),
  "67344": p("KS", "Elk City"),
  "67347": p("KS", "Havana"),
  "67351": p("KS", "Liberty"),
  "67363": p("KS", "Sycamore"),
  "67364": p("KS", "Tyro"),
  "66838": p("KS", "Burdick"),
  "66846": p("KS", "Council Grove"),
  "66849": p("KS", "Dwight"),
  "66872": p("KS", "White City"),
  "66873": p("KS", "Wilsey"),
  "67950": p("KS", "Elkhart"),
  "67953": p("KS", "Richfield"),
  "67954": p("KS", "Rolla"),
  "66404": p("KS", "Baileyville"),
  "66408": p("KS", "Bern"),
  "66415": p("KS", "Centralia"),
  "66417": p("KS", "Corning"),
  "66428": p("KS", "Goff"),
  "66522": p("KS", "Oneida"),
  "66534": p("KS", "Sabetha"),
  "66538": p("KS", "Seneca"),
  "66550": p("KS", "Wetmore"),
  "66720": p("KS", "Chanute"),
  "66733": p("KS", "Erie"),
  "66740": p("KS", "Galesburg"),
  "66771": p("KS", "Saint Paul"),
  "66775": p("KS", "Stark"),
  "66776": p("KS", "Thayer"),
  "67515": p("KS", "Arnold"),
  "67516": p("KS", "Bazine"),
  "67518": p("KS", "Beeler"),
  "67521": p("KS", "Brownell"),
  "67560": p("KS", "Ness City"),
  "67572": p("KS", "Ransom"),
  "67584": p("KS", "Utica"),
  "67622": p("KS", "Almena"),
  "67629": p("KS", "Clayton"),
  "67645": p("KS", "Lenora"),
  "67654": p("KS", "Norton"),
  "66413": p("KS", "Burlingame"),
  "66414": p("KS", "Carbondale"),
  "66451": p("KS", "Lyndon"),
  "66510": p("KS", "Melvern"),
  "66523": p("KS", "Osage City"),
  "66524": p("KS", "Overbrook"),
  "66528": p("KS", "Quenemo"),
  "66537": p("KS", "Scranton"),
  "66543": p("KS", "Vassar"),
  "67437": p("KS", "Downs"),
  "67473": p("KS", "Osborne"),
  "67474": p("KS", "Portis"),
  "67623": p("KS", "Alton"),
  "67651": p("KS", "Natoma"),
  "67422": p("KS", "Bennington"),
  "67436": p("KS", "Delphos"),
  "67467": p("KS", "Minneapolis"),
  "67484": p("KS", "Tescott"),
  "67523": p("KS", "Burdett"),
  "67529": p("KS", "Garfield"),
  "67550": p("KS", "Larned"),
  "67574": p("KS", "Rozel"),
  "67621": p("KS", "Agra"),
  "67639": p("KS", "Glade"),
  "67644": p("KS", "Kirwin"),
  "67646": p("KS", "Logan"),
  "67647": p("KS", "Long Island"),
  "67661": p("KS", "Phillipsburg"),
  "67664": p("KS", "Prairie View"),
  "66407": p("KS", "Belvue"),
  "66422": p("KS", "Emmett"),
  "66426": p("KS", "Fostoria"),
  "66432": p("KS", "Havensville"),
  "66520": p("KS", "Olsburg"),
  "66521": p("KS", "Onaga"),
  "66535": p("KS", "Saint George"),
  "66536": p("KS", "Saint Marys"),
  "66547": p("KS", "Wamego"),
  "66549": p("KS", "Westmoreland"),
  "67021": p("KS", "Byers"),
  "67028": p("KS", "Coats"),
  "67066": p("KS", "Iuka"),
  "67124": p("KS", "Pratt"),
  "67134": p("KS", "Sawyer"),
  "67730": p("KS", "Atwood"),
  "67739": p("KS", "Herndon"),
  "67744": p("KS", "Ludell"),
  "67745": p("KS", "Mc Donald"),
  "67501": p("KS", "Hutchinson"),
  "67502": p("KS", "Hutchinson"),
  "67504": p("KS", "Hutchinson"),
  "67505": p("KS", "South Hutchinson"),
  "67510": p("KS", "Abbyville"),
  "67514": p("KS", "Arlington"),
  "67522": p("KS", "Buhler"),
  "67543": p("KS", "Haven"),
  "67561": p("KS", "Nickerson"),
  "67566": p("KS", "Partridge"),
  "67568": p("KS", "Plevna"),
  "67570": p("KS", "Pretty Prairie"),
  "67581": p("KS", "Sylvia"),
  "67583": p("KS", "Turon"),
  "67585": p("KS", "Yoder"),
  "66930": p("KS", "Agenda"),
  "66935": p("KS", "Belleville"),
  "66939": p("KS", "Courtland"),
  "66940": p("KS", "Cuba"),
  "66959": p("KS", "Munden"),
  "66960": p("KS", "Narka"),
  "66961": p("KS", "Norway"),
  "66964": p("KS", "Republic"),
  "66966": p("KS", "Scandia"),
  "67427": p("KS", "Bushton"),
  "67444": p("KS", "Geneseo"),
  "67457": p("KS", "Little River"),
  "67512": p("KS", "Alden"),
  "67524": p("KS", "Chase"),
  "67554": p("KS", "Lyons"),
  "67573": p("KS", "Raymond"),
  "67579": p("KS", "Sterling"),
  "66449": p("KS", "Leonardville"),
  "66502": p("KS", "Manhattan"),
  "66503": p("KS", "Manhattan"),
  "66505": p("KS", "Manhattan"),
  "66506": p("KS", "Manhattan"),
  "66517": p("KS", "Ogden"),
  "66531": p("KS", "Riley"),
  "66554": p("KS", "Randolph"),
  "67632": p("KS", "Damar"),
  "67657": p("KS", "Palco"),
  "67663": p("KS", "Plainville"),
  "67669": p("KS", "Stockton"),
  "67675": p("KS", "Woodston"),
  "67513": p("KS", "Alexander"),
  "67520": p("KS", "Bison"),
  "67548": p("KS", "La Crosse"),
  "67553": p("KS", "Liebenthal"),
  "67556": p("KS", "Mc Cracken"),
  "67559": p("KS", "Nekoma"),
  "67565": p("KS", "Otis"),
  "67575": p("KS", "Rush Center"),
  "67626": p("KS", "Bunker Hill"),
  "67634": p("KS", "Dorrance"),
  "67640": p("KS", "Gorham"),
  "67648": p("KS", "Lucas"),
  "67649": p("KS", "Luray"),
  "67658": p("KS", "Paradise"),
  "67665": p("KS", "Russell"),
  "67673": p("KS", "Waldo"),
  "67401": p("KS", "Salina"),
  "67402": p("KS", "Salina"),
  "67416": p("KS", "Assaria"),
  "67425": p("KS", "Brookville"),
  "67442": p("KS", "Falun"),
  "67448": p("KS", "Gypsum"),
  "67470": p("KS", "New Cambria"),
  "67871": p("KS", "Scott City"),
  "67001": p("KS", "Andale"),
  "67016": p("KS", "Bentley"),
  "67025": p("KS", "Cheney"),
  "67026": p("KS", "Clearwater"),
  "67030": p("KS", "Colwich"),
  "67037": p("KS", "Derby"),
  "67050": p("KS", "Garden Plain"),
  "67052": p("KS", "Goddard"),
  "67055": p("KS", "Greenwich"),
  "67060": p("KS", "Haysville"),
  "67067": p("KS", "Kechi"),
  "67101": p("KS", "Maize"),
  "67108": p("KS", "Mount Hope"),
  "67120": p("KS", "Peck"),
  "67147": p("KS", "Valley Center"),
  "67149": p("KS", "Viola"),
  "67201": p("KS", "Wichita"),
  "67202": p("KS", "Wichita"),
  "67203": p("KS", "Wichita"),
  "67204": p("KS", "Wichita"),
  "67205": p("KS", "Wichita"),
  "67206": p("KS", "Wichita"),
  "67207": p("KS", "Wichita"),
  "67208": p("KS", "Wichita"),
  "67209": p("KS", "Wichita"),
  "67210": p("KS", "Wichita"),
  "67211": p("KS", "Wichita"),
  "67212": p("KS", "Wichita"),
  "67213": p("KS", "Wichita"),
  "67214": p("KS", "Wichita"),
  "67215": p("KS", "Wichita"),
  "67216": p("KS", "Wichita"),
  "67217": p("KS", "Wichita"),
  "67218": p("KS", "Wichita"),
  "67219": p("KS", "Wichita"),
  "67220": p("KS", "Wichita"),
  "67221": p("KS", "Mcconnell Afb"),
  "67223": p("KS", "Wichita"),
  "67226": p("KS", "Wichita"),
  "67227": p("KS", "Wichita"),
  "67228": p("KS", "Wichita"),
  "67230": p("KS", "Wichita"),
  "67232": p("KS", "Wichita"),
  "67235": p("KS", "Wichita"),
  "67260": p("KS", "Wichita"),
  "67275": p("KS", "Wichita"),
  "67276": p("KS", "Wichita"),
  "67277": p("KS", "Wichita"),
  "67278": p("KS", "Wichita"),
  "67859": p("KS", "Kismet"),
  "67901": p("KS", "Liberal"),
  "67905": p("KS", "Liberal"),
  "66402": p("KS", "Auburn"),
  "66409": p("KS", "Berryton"),
  "66420": p("KS", "Dover"),
  "66533": p("KS", "Rossville"),
  "66539": p("KS", "Silver Lake"),
  "66542": p("KS", "Tecumseh"),
  "66546": p("KS", "Wakarusa"),
  "66601": p("KS", "Topeka"),
  "66603": p("KS", "Topeka"),
  "66604": p("KS", "Topeka"),
  "66605": p("KS", "Topeka"),
  "66606": p("KS", "Topeka"),
  "66607": p("KS", "Topeka"),
  "66608": p("KS", "Topeka"),
  "66609": p("KS", "Topeka"),
  "66610": p("KS", "Topeka"),
  "66611": p("KS", "Topeka"),
  "66612": p("KS", "Topeka"),
  "66614": p("KS", "Topeka"),
  "66615": p("KS", "Topeka"),
  "66616": p("KS", "Topeka"),
  "66617": p("KS", "Topeka"),
  "66618": p("KS", "Topeka"),
  "66619": p("KS", "Topeka"),
  "66620": p("KS", "Topeka"),
  "66621": p("KS", "Topeka"),
  "66622": p("KS", "Topeka"),
  "66624": p("KS", "Topeka"),
  "66625": p("KS", "Topeka"),
  "66626": p("KS", "Topeka"),
  "66629": p("KS", "Topeka"),
  "66630": p("KS", "Topeka"),
  "66636": p("KS", "Topeka"),
  "66647": p("KS", "Topeka"),
  "66667": p("KS", "Topeka"),
  "66675": p("KS", "Topeka"),
  "66683": p("KS", "Topeka"),
  "66699": p("KS", "Topeka"),
  "67740": p("KS", "Hoxie"),
  "67757": p("KS", "Selden"),
  "67733": p("KS", "Edson"),
  "67735": p("KS", "Goodland"),
  "67741": p("KS", "Kanorado"),
  "66932": p("KS", "Athol"),
  "66951": p("KS", "Kensington"),
  "66952": p("KS", "Lebanon"),
  "66967": p("KS", "Smith Center"),
  "67628": p("KS", "Cedar"),
  "67638": p("KS", "Gaylord"),
  "67545": p("KS", "Hudson"),
  "67557": p("KS", "Macksville"),
  "67576": p("KS", "St John"),
  "67578": p("KS", "Stafford"),
  "67855": p("KS", "Johnson"),
  "67862": p("KS", "Manter"),
  "67951": p("KS", "Hugoton"),
  "67952": p("KS", "Moscow"),
  "67004": p("KS", "Argonia"),
  "67013": p("KS", "Belle Plaine"),
  "67022": p("KS", "Caldwell"),
  "67031": p("KS", "Conway Springs"),
  "67051": p("KS", "Geuda Springs"),
  "67103": p("KS", "Mayfield"),
  "67105": p("KS", "Milan"),
  "67106": p("KS", "Milton"),
  "67110": p("KS", "Mulvane"),
  "67119": p("KS", "Oxford"),
  "67140": p("KS", "South Haven"),
  "67152": p("KS", "Wellington"),
  "67701": p("KS", "Colby"),
  "67732": p("KS", "Brewster"),
  "67734": p("KS", "Gem"),
  "67743": p("KS", "Levant"),
  "67753": p("KS", "Rexford"),
  "67631": p("KS", "Collyer"),
  "67656": p("KS", "Ogallah"),
  "67672": p("KS", "Wakeeney"),
  "66401": p("KS", "Alma"),
  "66423": p("KS", "Eskridge"),
  "66431": p("KS", "Harveyville"),
  "66501": p("KS", "Mc Farland"),
  "66507": p("KS", "Maple Hill"),
  "66526": p("KS", "Paxico"),
  "66834": p("KS", "Alta Vista"),
  "67758": p("KS", "Sharon Springs"),
  "67761": p("KS", "Wallace"),
  "67762": p("KS", "Weskan"),
  "66933": p("KS", "Barnes"),
  "66937": p("KS", "Clifton"),
  "66943": p("KS", "Greenleaf"),
  "66944": p("KS", "Haddam"),
  "66945": p("KS", "Hanover"),
  "66946": p("KS", "Hollenberg"),
  "66953": p("KS", "Linn"),
  "66955": p("KS", "Mahaska"),
  "66958": p("KS", "Morrowville"),
  "66962": p("KS", "Palmer"),
  "66968": p("KS", "Washington"),
  "67861": p("KS", "Leoti"),
  "67863": p("KS", "Marienthal"),
  "66710": p("KS", "Altoona"),
  "66714": p("KS", "Benedict"),
  "66717": p("KS", "Buffalo"),
  "66736": p("KS", "Fredonia"),
  "66757": p("KS", "Neodesha"),
  "66759": p("KS", "New Albany"),
  "66758": p("KS", "Neosho Falls"),
  "66761": p("KS", "Piqua"),
  "66777": p("KS", "Toronto"),
  "66783": p("KS", "Yates Center"),
  "66012": p("KS", "Bonner Springs"),
  "66101": p("KS", "Kansas City"),
  "66102": p("KS", "Kansas City"),
  "66103": p("KS", "Kansas City"),
  "66104": p("KS", "Kansas City"),
  "66105": p("KS", "Kansas City"),
  "66106": p("KS", "Kansas City"),
  "66109": p("KS", "Kansas City"),
  "66110": p("KS", "Kansas City"),
  "66111": p("KS", "Kansas City"),
  "66112": p("KS", "Kansas City"),
  "66113": p("KS", "Edwardsville"),
  "66115": p("KS", "Kansas City"),
  "66117": p("KS", "Kansas City"),
  "66118": p("KS", "Kansas City"),
  "66119": p("KS", "Kansas City"),
  "66160": p("KS", "Kansas City"),
  "42715": p("KY", "Breeding"),
  "42720": p("KY", "Cane Valley"),
  "42728": p("KY", "Columbia"),
  "42741": p("KY", "Glens Fork"),
  "42742": p("KY", "Gradyville"),
  "42753": p("KY", "Knifley"),
  "42120": p("KY", "Adolphus"),
  "42153": p("KY", "Holland"),
  "42164": p("KY", "Scottsville"),
  "40342": p("KY", "Lawrenceburg"),
  "42022": p("KY", "Bandana"),
  "42024": p("KY", "Barlow"),
  "42056": p("KY", "La Center"),
  "42060": p("KY", "Lovelaceville"),
  "42087": p("KY", "Wickliffe"),
  "42123": p("KY", "Austin"),
  "42127": p("KY", "Cave City"),
  "42130": p("KY", "Eighty Eight"),
  "42131": p("KY", "Etoile"),
  "42141": p("KY", "Glasgow"),
  "42142": p("KY", "Glasgow"),
  "42152": p("KY", "Hiseville"),
  "42156": p("KY", "Lucas"),
  "42160": p("KY", "Park City"),
  "40358": p("KY", "Olympia"),
  "40360": p("KY", "Owingsville"),
  "40366": p("KY", "Preston"),
  "40371": p("KY", "Salt Lick"),
  "40374": p("KY", "Sharpsburg"),
  "40813": p("KY", "Calvin"),
  "40845": p("KY", "Hulen"),
  "40856": p("KY", "Miracle"),
  "40902": p("KY", "Arjay"),
  "40913": p("KY", "Beverly"),
  "40940": p("KY", "Frakes"),
  "40955": p("KY", "Ingram"),
  "40958": p("KY", "Kettle Island"),
  "40965": p("KY", "Middlesboro"),
  "40977": p("KY", "Pineville"),
  "40988": p("KY", "Stoney Fork"),
  "41005": p("KY", "Burlington"),
  "41021": p("KY", "Hebron"),
  "41022": p("KY", "Florence"),
  "41042": p("KY", "Florence"),
  "41048": p("KY", "Hebron"),
  "41080": p("KY", "Petersburg"),
  "41091": p("KY", "Union"),
  "41092": p("KY", "Verona"),
  "41094": p("KY", "Walton"),
  "40348": p("KY", "Millersburg"),
  "40357": p("KY", "North Middletown"),
  "40361": p("KY", "Paris"),
  "40362": p("KY", "Paris"),
  "41101": p("KY", "Ashland"),
  "41102": p("KY", "Ashland"),
  "41105": p("KY", "Ashland"),
  "41114": p("KY", "Ashland"),
  "41129": p("KY", "Catlettsburg"),
  "41168": p("KY", "Rush"),
  "40422": p("KY", "Danville"),
  "40423": p("KY", "Danville"),
  "40440": p("KY", "Junction City"),
  "40452": p("KY", "Mitchellsburg"),
  "40464": p("KY", "Parksville"),
  "40468": p("KY", "Perryville"),
  "41002": p("KY", "Augusta"),
  "41004": p("KY", "Brooksville"),
  "41043": p("KY", "Foster"),
  "41044": p("KY", "Germantown"),
  "41061": p("KY", "Milford"),
  "41310": p("KY", "Bays"),
  "41317": p("KY", "Clayhole"),
  "41339": p("KY", "Jackson"),
  "41348": p("KY", "Lost Creek"),
  "41366": p("KY", "Rousseau"),
  "41385": p("KY", "Vancleve"),
  "41390": p("KY", "Whick"),
  "40111": p("KY", "Cloverport"),
  "40115": p("KY", "Custer"),
  "40140": p("KY", "Garfield"),
  "40143": p("KY", "Hardinsburg"),
  "40144": p("KY", "Harned"),
  "40145": p("KY", "Hudson"),
  "40146": p("KY", "Irvington"),
  "40152": p("KY", "Mc Daniels"),
  "40153": p("KY", "Mc Quady"),
  "40170": p("KY", "Stephensport"),
  "40171": p("KY", "Union Star"),
  "40176": p("KY", "Webster"),
  "40178": p("KY", "Westview"),
  "40047": p("KY", "Mount Washington"),
  "40109": p("KY", "Brooks"),
  "40110": p("KY", "Clermont"),
  "40129": p("KY", "Hillview"),
  "40150": p("KY", "Lebanon Junction"),
  "40165": p("KY", "Shepherdsville"),
  "40166": p("KY", "Shepherdsville"),
  "42201": p("KY", "Aberdeen"),
  "42219": p("KY", "Dunbar"),
  "42252": p("KY", "Jetson"),
  "42261": p("KY", "Morgantown"),
  "42273": p("KY", "Rochester"),
  "42288": p("KY", "Woodbury"),
  "42411": p("KY", "Fredonia"),
  "42445": p("KY", "Princeton"),
  "42020": p("KY", "Almo"),
  "42036": p("KY", "Dexter"),
  "42049": p("KY", "Hazel"),
  "42054": p("KY", "Kirksey"),
  "42071": p("KY", "Murray"),
  "42076": p("KY", "New Concord"),
  "41001": p("KY", "Alexandria"),
  "41007": p("KY", "California"),
  "41059": p("KY", "Melbourne"),
  "41071": p("KY", "Newport"),
  "41072": p("KY", "Newport"),
  "41073": p("KY", "Bellevue"),
  "41074": p("KY", "Dayton"),
  "41075": p("KY", "Fort Thomas"),
  "41076": p("KY", "Newport"),
  "41085": p("KY", "Silver Grove"),
  "41099": p("KY", "Newport"),
  "42021": p("KY", "Arlington"),
  "42023": p("KY", "Bardwell"),
  "42035": p("KY", "Cunningham"),
  "42070": p("KY", "Milburn"),
  "41008": p("KY", "Carrollton"),
  "41045": p("KY", "Ghent"),
  "41083": p("KY", "Sanders"),
  "41098": p("KY", "Worthville"),
  "41128": p("KY", "Carter"),
  "41132": p("KY", "Denton"),
  "41142": p("KY", "Grahn"),
  "41143": p("KY", "Grayson"),
  "41146": p("KY", "Hitchins"),
  "41164": p("KY", "Olive Hill"),
  "41173": p("KY", "Soldier"),
  "41181": p("KY", "Willard"),
  "42516": p("KY", "Bethelridge"),
  "42528": p("KY", "Dunnville"),
  "42539": p("KY", "Liberty"),
  "42541": p("KY", "Middleburg"),
  "42565": p("KY", "Windsor"),
  "42566": p("KY", "Yosemite"),
  "42217": p("KY", "Crofton"),
  "42221": p("KY", "Fairview"),
  "42223": p("KY", "Fort Campbell"),
  "42232": p("KY", "Gracey"),
  "42236": p("KY", "Herndon"),
  "42240": p("KY", "Hopkinsville"),
  "42241": p("KY", "Hopkinsville"),
  "42254": p("KY", "La Fayette"),
  "42262": p("KY", "Oak Grove"),
  "42266": p("KY", "Pembroke"),
  "40391": p("KY", "Winchester"),
  "40392": p("KY", "Winchester"),
  "40914": p("KY", "Big Creek"),
  "40932": p("KY", "Fall Rock"),
  "40941": p("KY", "Garrard"),
  "40944": p("KY", "Goose Rock"),
  "40951": p("KY", "Hima"),
  "40962": p("KY", "Manchester"),
  "40972": p("KY", "Oneida"),
  "40983": p("KY", "Sextons Creek"),
  "42602": p("KY", "Albany"),
  "42603": p("KY", "Alpha"),
  "42033": p("KY", "Crayne"),
  "42037": p("KY", "Dycusburg"),
  "42064": p("KY", "Marion"),
  "42717": p("KY", "Burkesville"),
  "42759": p("KY", "Marrowbone"),
  "42301": p("KY", "Owensboro"),
  "42302": p("KY", "Owensboro"),
  "42303": p("KY", "Owensboro"),
  "42304": p("KY", "Owensboro"),
  "42334": p("KY", "Curdsville"),
  "42355": p("KY", "Maceo"),
  "42356": p("KY", "Maple Mount"),
  "42366": p("KY", "Philpot"),
  "42376": p("KY", "Utica"),
  "42377": p("KY", "West Louisville"),
  "42378": p("KY", "Whitesville"),
  "42163": p("KY", "Rocky Hill"),
  "42207": p("KY", "Bee Spring"),
  "42210": p("KY", "Brownsville"),
  "42259": p("KY", "Mammoth Cave"),
  "42275": p("KY", "Roundhill"),
  "42285": p("KY", "Sweeden"),
  "41149": p("KY", "Isonville"),
  "41171": p("KY", "Sandy Hook"),
  "40336": p("KY", "Irvine"),
  "40472": p("KY", "Ravenna"),
  "40502": p("KY", "Lexington"),
  "40503": p("KY", "Lexington"),
  "40504": p("KY", "Lexington"),
  "40505": p("KY", "Lexington"),
  "40506": p("KY", "Lexington"),
  "40507": p("KY", "Lexington"),
  "40508": p("KY", "Lexington"),
  "40509": p("KY", "Lexington"),
  "40510": p("KY", "Lexington"),
  "40511": p("KY", "Lexington"),
  "40512": p("KY", "Lexington"),
  "40513": p("KY", "Lexington"),
  "40514": p("KY", "Lexington"),
  "40515": p("KY", "Lexington"),
  "40516": p("KY", "Lexington"),
  "40517": p("KY", "Lexington"),
  "40522": p("KY", "Lexington"),
  "40523": p("KY", "Lexington"),
  "40524": p("KY", "Lexington"),
  "40526": p("KY", "Lexington"),
  "40533": p("KY", "Lexington"),
  "40536": p("KY", "Lexington"),
  "40544": p("KY", "Lexington"),
  "40546": p("KY", "Lexington"),
  "40550": p("KY", "Lexington"),
  "40555": p("KY", "Lexington"),
  "40574": p("KY", "Lexington"),
  "40575": p("KY", "Lexington"),
  "40576": p("KY", "Lexington"),
  "40577": p("KY", "Lexington"),
  "40578": p("KY", "Lexington"),
  "40579": p("KY", "Lexington"),
  "40580": p("KY", "Lexington"),
  "40581": p("KY", "Lexington"),
  "40582": p("KY", "Lexington"),
  "40583": p("KY", "Lexington"),
  "40588": p("KY", "Lexington"),
  "40591": p("KY", "Lexington"),
  "40598": p("KY", "Lexington"),
  "41037": p("KY", "Elizaville"),
  "41039": p("KY", "Ewing"),
  "41041": p("KY", "Flemingsburg"),
  "41049": p("KY", "Hillsboro"),
  "41065": p("KY", "Muses Mills"),
  "41081": p("KY", "Plummers Landing"),
  "41093": p("KY", "Wallingford"),
  "41601": p("KY", "Allen"),
  "41602": p("KY", "Auxier"),
  "41603": p("KY", "Banner"),
  "41604": p("KY", "Beaver"),
  "41605": p("KY", "Betsy Layne"),
  "41606": p("KY", "Bevinsville"),
  "41607": p("KY", "Blue River"),
  "41612": p("KY", "Bypro"),
  "41615": p("KY", "Dana"),
  "41616": p("KY", "David"),
  "41619": p("KY", "Drift"),
  "41621": p("KY", "Dwale"),
  "41622": p("KY", "Eastern"),
  "41630": p("KY", "Garrett"),
  "41631": p("KY", "Grethel"),
  "41635": p("KY", "Harold"),
  "41636": p("KY", "Hi Hat"),
  "41640": p("KY", "Hueysville"),
  "41642": p("KY", "Ivel"),
  "41643": p("KY", "Lackey"),
  "41645": p("KY", "Langley"),
  "41647": p("KY", "Mc Dowell"),
  "41649": p("KY", "Martin"),
  "41650": p("KY", "Melvin"),
  "41651": p("KY", "Minnie"),
  "41653": p("KY", "Prestonsburg"),
  "41655": p("KY", "Printer"),
  "41659": p("KY", "Stanville"),
  "41660": p("KY", "Teaberry"),
  "41663": p("KY", "Tram"),
  "41666": p("KY", "Wayland"),
  "41667": p("KY", "Weeksbury"),
  "41669": p("KY", "Wheelwright"),
  "40601": p("KY", "Frankfort"),
  "40602": p("KY", "Frankfort"),
  "40603": p("KY", "Frankfort"),
  "40604": p("KY", "Frankfort"),
  "40618": p("KY", "Frankfort"),
  "40619": p("KY", "Frankfort"),
  "40620": p("KY", "Frankfort"),
  "40621": p("KY", "Frankfort"),
  "40622": p("KY", "Frankfort"),
  "42041": p("KY", "Fulton"),
  "42050": p("KY", "Hickman"),
  "41046": p("KY", "Glencoe"),
  "41086": p("KY", "Sparta"),
  "41095": p("KY", "Warsaw"),
  "40410": p("KY", "Bryantsville"),
  "40444": p("KY", "Lancaster"),
  "40461": p("KY", "Paint Lick"),
  "41010": p("KY", "Corinth"),
  "41030": p("KY", "Crittenden"),
  "41035": p("KY", "Dry Ridge"),
  "41052": p("KY", "Jonesville"),
  "41054": p("KY", "Mason"),
  "41097": p("KY", "Williamstown"),
  "42027": p("KY", "Boaz"),
  "42039": p("KY", "Fancy Farm"),
  "42040": p("KY", "Farmington"),
  "42051": p("KY", "Hickory"),
  "42061": p("KY", "Lowes"),
  "42063": p("KY", "Lynnville"),
  "42066": p("KY", "Mayfield"),
  "42069": p("KY", "Melber"),
  "42079": p("KY", "Sedalia"),
  "42082": p("KY", "Symsonia"),
  "42085": p("KY", "Water Valley"),
  "42088": p("KY", "Wingo"),
  "40119": p("KY", "Falls Of Rough"),
  "42712": p("KY", "Big Clifty"),
  "42721": p("KY", "Caneyville"),
  "42726": p("KY", "Clarkson"),
  "42754": p("KY", "Leitchfield"),
  "42755": p("KY", "Leitchfield"),
  "42762": p("KY", "Millwood"),
  "42743": p("KY", "Greensburg"),
  "42782": p("KY", "Summersville"),
  "41121": p("KY", "Argillite"),
  "41139": p("KY", "Flatwoods"),
  "41144": p("KY", "Greenup"),
  "41169": p("KY", "Russell"),
  "41174": p("KY", "South Portsmouth"),
  "41175": p("KY", "South Shore"),
  "41183": p("KY", "Worthington"),
  "42348": p("KY", "Hawesville"),
  "42351": p("KY", "Lewisport"),
  "42364": p("KY", "Pellville"),
  "42368": p("KY", "Reynolds Station"),
  "40121": p("KY", "Fort Knox"),
  "40122": p("KY", "Fort Knox"),
  "40159": p("KY", "Radcliff"),
  "40160": p("KY", "Radcliff"),
  "40162": p("KY", "Rineyville"),
  "40175": p("KY", "Vine Grove"),
  "40177": p("KY", "West Point"),
  "42701": p("KY", "Elizabethtown"),
  "42702": p("KY", "Elizabethtown"),
  "42724": p("KY", "Cecilia"),
  "42732": p("KY", "Eastview"),
  "42740": p("KY", "Glendale"),
  "42776": p("KY", "Sonora"),
  "42784": p("KY", "Upton"),
  "42788": p("KY", "White Mills"),
  "40801": p("KY", "Ages Brookside"),
  "40806": p("KY", "Baxter"),
  "40807": p("KY", "Benham"),
  "40808": p("KY", "Big Laurel"),
  "40810": p("KY", "Bledsoe"),
  "40815": p("KY", "Cawood"),
  "40818": p("KY", "Coalgood"),
  "40819": p("KY", "Coldiron"),
  "40820": p("KY", "Cranks"),
  "40823": p("KY", "Cumberland"),
  "40824": p("KY", "Dayhoit"),
  "40828": p("KY", "Evarts"),
  "40829": p("KY", "Grays Knob"),
  "40830": p("KY", "Gulston"),
  "40831": p("KY", "Harlan"),
  "40843": p("KY", "Holmes Mill"),
  "40847": p("KY", "Kenvir"),
  "40849": p("KY", "Lejunior"),
  "40854": p("KY", "Loyall"),
  "40855": p("KY", "Lynch"),
  "40863": p("KY", "Pathfork"),
  "40865": p("KY", "Putney"),
  "40870": p("KY", "Totz"),
  "40873": p("KY", "Wallins Creek"),
  "40927": p("KY", "Closplint"),
  "40964": p("KY", "Mary Alice"),
  "41003": p("KY", "Berry"),
  "41031": p("KY", "Cynthiana"),
  "42713": p("KY", "Bonnieville"),
  "42722": p("KY", "Canmer"),
  "42729": p("KY", "Cub Run"),
  "42746": p("KY", "Hardyville"),
  "42749": p("KY", "Horse Cave"),
  "42765": p("KY", "Munfordville"),
  "42402": p("KY", "Baskett"),
  "42406": p("KY", "Corydon"),
  "42419": p("KY", "Henderson"),
  "42420": p("KY", "Henderson"),
  "42451": p("KY", "Reed"),
  "42452": p("KY", "Robards"),
  "42457": p("KY", "Smith Mills"),
  "42458": p("KY", "Spottsville"),
  "40007": p("KY", "Bethlehem"),
  "40011": p("KY", "Campbellsburg"),
  "40019": p("KY", "Eminence"),
  "40036": p("KY", "Lockport"),
  "40050": p("KY", "New Castle"),
  "40055": p("KY", "Pendleton"),
  "40057": p("KY", "Pleasureville"),
  "40058": p("KY", "Port Royal"),
  "40068": p("KY", "Smithfield"),
  "40070": p("KY", "Sulphur"),
  "40075": p("KY", "Turners Station"),
  "42031": p("KY", "Clinton"),
  "42032": p("KY", "Columbus"),
  "42408": p("KY", "Dawson Springs"),
  "42410": p("KY", "Earlington"),
  "42413": p("KY", "Hanson"),
  "42431": p("KY", "Madisonville"),
  "42436": p("KY", "Manitou"),
  "42440": p("KY", "Mortons Gap"),
  "42441": p("KY", "Nebo"),
  "42442": p("KY", "Nortonville"),
  "42453": p("KY", "Saint Charles"),
  "42464": p("KY", "White Plains"),
  "40402": p("KY", "Annville"),
  "40434": p("KY", "Gray Hawk"),
  "40447": p("KY", "Mc Kee"),
  "40481": p("KY", "Sandgap"),
  "40486": p("KY", "Tyner"),
  "40488": p("KY", "Waneta"),
  "40018": p("KY", "Eastwood"),
  "40023": p("KY", "Fisherville"),
  "40025": p("KY", "Glenview"),
  "40027": p("KY", "Harrods Creek"),
  "40041": p("KY", "Masonic Home"),
  "40059": p("KY", "Prospect"),
  "40118": p("KY", "Fairdale"),
  "40201": p("KY", "Louisville"),
  "40202": p("KY", "Louisville"),
  "40203": p("KY", "Louisville"),
  "40204": p("KY", "Louisville"),
  "40205": p("KY", "Louisville"),
  "40206": p("KY", "Louisville"),
  "40207": p("KY", "Louisville"),
  "40208": p("KY", "Louisville"),
  "40209": p("KY", "Louisville"),
  "40210": p("KY", "Louisville"),
  "40211": p("KY", "Louisville"),
  "40212": p("KY", "Louisville"),
  "40213": p("KY", "Louisville"),
  "40214": p("KY", "Louisville"),
  "40215": p("KY", "Louisville"),
  "40216": p("KY", "Louisville"),
  "40217": p("KY", "Louisville"),
  "40218": p("KY", "Louisville"),
  "40219": p("KY", "Louisville"),
  "40220": p("KY", "Louisville"),
  "40221": p("KY", "Louisville"),
  "40222": p("KY", "Louisville"),
  "40223": p("KY", "Louisville"),
  "40224": p("KY", "Louisville"),
  "40225": p("KY", "Louisville"),
  "40228": p("KY", "Louisville"),
  "40229": p("KY", "Louisville"),
  "40231": p("KY", "Louisville"),
  "40232": p("KY", "Louisville"),
  "40233": p("KY", "Louisville"),
  "40241": p("KY", "Louisville"),
  "40242": p("KY", "Louisville"),
  "40243": p("KY", "Louisville"),
  "40245": p("KY", "Louisville"),
  "40250": p("KY", "Louisville"),
  "40251": p("KY", "Louisville"),
  "40252": p("KY", "Louisville"),
  "40253": p("KY", "Louisville"),
  "40255": p("KY", "Louisville"),
  "40256": p("KY", "Louisville"),
  "40257": p("KY", "Louisville"),
  "40258": p("KY", "Louisville"),
  "40259": p("KY", "Louisville"),
  "40261": p("KY", "Louisville"),
  "40266": p("KY", "Louisville"),
  "40268": p("KY", "Louisville"),
  "40269": p("KY", "Louisville"),
  "40270": p("KY", "Louisville"),
  "40272": p("KY", "Louisville"),
  "40280": p("KY", "Louisville"),
  "40281": p("KY", "Louisville"),
  "40282": p("KY", "Louisville"),
  "40283": p("KY", "Louisville"),
  "40285": p("KY", "Louisville"),
  "40287": p("KY", "Louisville"),
  "40289": p("KY", "Louisville"),
  "40290": p("KY", "Louisville"),
  "40291": p("KY", "Louisville"),
  "40292": p("KY", "Louisville"),
  "40293": p("KY", "Louisville"),
  "40294": p("KY", "Louisville"),
  "40295": p("KY", "Louisville"),
  "40296": p("KY", "Louisville"),
  "40297": p("KY", "Louisville"),
  "40298": p("KY", "Louisville"),
  "40299": p("KY", "Louisville"),
  "40339": p("KY", "Keene"),
  "40340": p("KY", "Nicholasville"),
  "40356": p("KY", "Nicholasville"),
  "40390": p("KY", "Wilmore"),
  "41204": p("KY", "Boons Camp"),
  "41216": p("KY", "East Point"),
  "41219": p("KY", "Flatgap"),
  "41222": p("KY", "Hagerhill"),
  "41226": p("KY", "Keaton"),
  "41234": p("KY", "Meally"),
  "41238": p("KY", "Oil Springs"),
  "41240": p("KY", "Paintsville"),
  "41254": p("KY", "River"),
  "41255": p("KY", "Sitka"),
  "41256": p("KY", "Staffordsville"),
  "41257": p("KY", "Stambaugh"),
  "41260": p("KY", "Thelma"),
  "41263": p("KY", "Tutor Key"),
  "41265": p("KY", "Van Lear"),
  "41268": p("KY", "West Van Lear"),
  "41271": p("KY", "Williamsport"),
  "41274": p("KY", "Wittensville"),
  "41011": p("KY", "Covington"),
  "41012": p("KY", "Covington"),
  "41014": p("KY", "Covington"),
  "41015": p("KY", "Latonia"),
  "41016": p("KY", "Covington"),
  "41017": p("KY", "Ft Mitchell"),
  "41018": p("KY", "Erlanger"),
  "41019": p("KY", "Covington"),
  "41025": p("KY", "Erlanger"),
  "41051": p("KY", "Independence"),
  "41053": p("KY", "Kenton"),
  "41063": p("KY", "Morning View"),
  "41725": p("KY", "Carrie"),
  "41740": p("KY", "Emmalena"),
  "41743": p("KY", "Fisty"),
  "41759": p("KY", "Sassafras"),
  "41772": p("KY", "Vest"),
  "41817": p("KY", "Garner"),
  "41822": p("KY", "Hindman"),
  "41828": p("KY", "Kite"),
  "41831": p("KY", "Leburn"),
  "41834": p("KY", "Littcarr"),
  "41836": p("KY", "Mallie"),
  "41839": p("KY", "Mousie"),
  "41843": p("KY", "Pine Top"),
  "41844": p("KY", "Pippa Passes"),
  "41847": p("KY", "Redfox"),
  "41859": p("KY", "Dema"),
  "41861": p("KY", "Raven"),
  "41862": p("KY", "Topmost"),
  "40734": p("KY", "Gray"),
  "40771": p("KY", "Woodbine"),
  "40903": p("KY", "Artemus"),
  "40906": p("KY", "Barbourville"),
  "40915": p("KY", "Bimble"),
  "40921": p("KY", "Bryants Store"),
  "40923": p("KY", "Cannon"),
  "40930": p("KY", "Dewitt"),
  "40935": p("KY", "Flat Lick"),
  "40939": p("KY", "Fourmile"),
  "40943": p("KY", "Girdler"),
  "40946": p("KY", "Green Road"),
  "40949": p("KY", "Heidrick"),
  "40953": p("KY", "Hinkle"),
  "40982": p("KY", "Scalf"),
  "40995": p("KY", "Trosper"),
  "40997": p("KY", "Walker"),
  "42716": p("KY", "Buffalo"),
  "42748": p("KY", "Hodgenville"),
  "42757": p("KY", "Magnolia"),
  "42764": p("KY", "Mount Sherman"),
  "40724": p("KY", "Bush"),
  "40729": p("KY", "East Bernstadt"),
  "40737": p("KY", "Keavy"),
  "40740": p("KY", "Lily"),
  "40741": p("KY", "London"),
  "40742": p("KY", "London"),
  "40743": p("KY", "London"),
  "40744": p("KY", "London"),
  "40745": p("KY", "London"),
  "40750": p("KY", "London"),
  "40755": p("KY", "Pittsburg"),
  "41124": p("KY", "Blaine"),
  "41159": p("KY", "Martha"),
  "41160": p("KY", "Mazie"),
  "41180": p("KY", "Webbville"),
  "41201": p("KY", "Adams"),
  "41230": p("KY", "Louisa"),
  "41232": p("KY", "Lowmansville"),
  "41264": p("KY", "Ulysses"),
  "41311": p("KY", "Beattyville"),
  "41347": p("KY", "Lone"),
  "41368": p("KY", "Saint Helens"),
  "41397": p("KY", "Zoe"),
  "40803": p("KY", "Asher"),
  "40816": p("KY", "Chappell"),
  "40827": p("KY", "Essie"),
  "40840": p("KY", "Helton"),
  "40844": p("KY", "Hoskinston"),
  "40858": p("KY", "Mozelle"),
  "40868": p("KY", "Stinnett"),
  "40874": p("KY", "Warbranch"),
  "40979": p("KY", "Roark"),
  "41714": p("KY", "Bear Branch"),
  "41749": p("KY", "Hyden"),
  "41762": p("KY", "Sizerock"),
  "41764": p("KY", "Smilax"),
  "41766": p("KY", "Thousandsticks"),
  "41775": p("KY", "Wendover"),
  "41776": p("KY", "Wooton"),
  "41777": p("KY", "Yeaddiss"),
  "40826": p("KY", "Eolia"),
  "40862": p("KY", "Partridge"),
  "41517": p("KY", "Burdine"),
  "41537": p("KY", "Jenkins"),
  "41804": p("KY", "Blackey"),
  "41810": p("KY", "Cromona"),
  "41812": p("KY", "Deane"),
  "41815": p("KY", "Ermine"),
  "41819": p("KY", "Gordon"),
  "41821": p("KY", "Hallie"),
  "41824": p("KY", "Isom"),
  "41825": p("KY", "Jackhorn"),
  "41826": p("KY", "Jeremiah"),
  "41832": p("KY", "Letcher"),
  "41833": p("KY", "Linefork"),
  "41835": p("KY", "Mc Roberts"),
  "41837": p("KY", "Mayking"),
  "41838": p("KY", "Millstone"),
  "41840": p("KY", "Neon"),
  "41845": p("KY", "Premium"),
  "41848": p("KY", "Roxana"),
  "41849": p("KY", "Seco"),
  "41855": p("KY", "Thornton"),
  "41858": p("KY", "Whitesburg"),
  "41135": p("KY", "Emerson"),
  "41141": p("KY", "Garrison"),
  "41166": p("KY", "Quincy"),
  "41179": p("KY", "Vanceburg"),
  "41189": p("KY", "Tollesboro"),
  "40419": p("KY", "Crab Orchard"),
  "40437": p("KY", "Hustonville"),
  "40442": p("KY", "Kings Mountain"),
  "40448": p("KY", "Mc Kinney"),
  "40484": p("KY", "Stanford"),
  "40489": p("KY", "Waynesburg"),
  "42028": p("KY", "Burna"),
  "42045": p("KY", "Grand Rivers"),
  "42047": p("KY", "Hampton"),
  "42058": p("KY", "Ledbetter"),
  "42078": p("KY", "Salem"),
  "42081": p("KY", "Smithland"),
  "42083": p("KY", "Tiline"),
  "42202": p("KY", "Adairville"),
  "42206": p("KY", "Auburn"),
  "42256": p("KY", "Lewisburg"),
  "42265": p("KY", "Olmstead"),
  "42276": p("KY", "Russellville"),
  "42038": p("KY", "Eddyville"),
  "42055": p("KY", "Kuttawa"),
  "42001": p("KY", "Paducah"),
  "42002": p("KY", "Paducah"),
  "42003": p("KY", "Paducah"),
  "42053": p("KY", "Kevil"),
  "42086": p("KY", "West Paducah"),
  "42631": p("KY", "Marshes Siding"),
  "42634": p("KY", "Parkers Lake"),
  "42635": p("KY", "Pine Knot"),
  "42638": p("KY", "Revelo"),
  "42647": p("KY", "Stearns"),
  "42649": p("KY", "Strunk"),
  "42653": p("KY", "Whitley City"),
  "42322": p("KY", "Beech Grove"),
  "42327": p("KY", "Calhoun"),
  "42350": p("KY", "Island"),
  "42352": p("KY", "Livermore"),
  "42371": p("KY", "Rumsey"),
  "42372": p("KY", "Sacramento"),
  "40385": p("KY", "Waco"),
  "40403": p("KY", "Berea"),
  "40404": p("KY", "Berea"),
  "40405": p("KY", "Bighill"),
  "40475": p("KY", "Richmond"),
  "40476": p("KY", "Richmond"),
  "41426": p("KY", "Falcon"),
  "41464": p("KY", "Royalton"),
  "41465": p("KY", "Salyersville"),
  "41632": p("KY", "Gunlock"),
  "40009": p("KY", "Bradfordsville"),
  "40033": p("KY", "Lebanon"),
  "40037": p("KY", "Loretto"),
  "40049": p("KY", "Nerinx"),
  "40060": p("KY", "Raywick"),
  "40062": p("KY", "Saint Francis"),
  "40063": p("KY", "Saint Mary"),
  "40328": p("KY", "Gravel Switch"),
  "42025": p("KY", "Benton"),
  "42029": p("KY", "Calvert City"),
  "42044": p("KY", "Gilbertsville"),
  "42048": p("KY", "Hardin"),
  "41203": p("KY", "Beauty"),
  "41214": p("KY", "Debord"),
  "41224": p("KY", "Inez"),
  "41231": p("KY", "Lovely"),
  "41250": p("KY", "Pilgrim"),
  "41262": p("KY", "Tomahawk"),
  "41267": p("KY", "Warfield"),
  "41034": p("KY", "Dover"),
  "41055": p("KY", "Mayslick"),
  "41056": p("KY", "Maysville"),
  "41062": p("KY", "Minerva"),
  "41096": p("KY", "Washington"),
  "40104": p("KY", "Battletown"),
  "40108": p("KY", "Brandenburg"),
  "40117": p("KY", "Ekron"),
  "40142": p("KY", "Guston"),
  "40155": p("KY", "Muldraugh"),
  "40157": p("KY", "Payneville"),
  "40161": p("KY", "Rhodelia"),
  "40316": p("KY", "Denniston"),
  "40322": p("KY", "Frenchburg"),
  "40346": p("KY", "Means"),
  "40387": p("KY", "Wellington"),
  "40310": p("KY", "Burgin"),
  "40330": p("KY", "Harrodsburg"),
  "40372": p("KY", "Salvisa"),
  "42124": p("KY", "Beaumont"),
  "42129": p("KY", "Edmonton"),
  "42154": p("KY", "Knob Lick"),
  "42166": p("KY", "Summer Shade"),
  "42214": p("KY", "Center"),
  "42133": p("KY", "Fountain Run"),
  "42140": p("KY", "Gamaliel"),
  "42151": p("KY", "Hestand"),
  "42157": p("KY", "Mount Hermon"),
  "42167": p("KY", "Tompkinsville"),
  "40334": p("KY", "Hope"),
  "40337": p("KY", "Jeffersonville"),
  "40353": p("KY", "Mount Sterling"),
  "41352": p("KY", "Mize"),
  "41408": p("KY", "Cannel City"),
  "41413": p("KY", "Crockett"),
  "41421": p("KY", "Elkfork"),
  "41425": p("KY", "Ezel"),
  "41451": p("KY", "Malone"),
  "41472": p("KY", "West Liberty"),
  "41477": p("KY", "Wrigley"),
  "42321": p("KY", "Beech Creek"),
  "42323": p("KY", "Beechmont"),
  "42324": p("KY", "Belton"),
  "42325": p("KY", "Bremen"),
  "42326": p("KY", "Browder"),
  "42330": p("KY", "Central City"),
  "42332": p("KY", "Cleaton"),
  "42337": p("KY", "Drakesboro"),
  "42339": p("KY", "Dunmor"),
  "42344": p("KY", "Graham"),
  "42345": p("KY", "Greenville"),
  "42367": p("KY", "Powderly"),
  "42374": p("KY", "South Carrollton"),
  "40004": p("KY", "Bardstown"),
  "40008": p("KY", "Bloomfield"),
  "40012": p("KY", "Chaplin"),
  "40013": p("KY", "Coxs Creek"),
  "40020": p("KY", "Fairfield"),
  "40048": p("KY", "Nazareth"),
  "40051": p("KY", "New Haven"),
  "40052": p("KY", "New Hope"),
  "40107": p("KY", "Boston"),
  "40311": p("KY", "Carlisle"),
  "40350": p("KY", "Moorefield"),
  "42320": p("KY", "Beaver Dam"),
  "42328": p("KY", "Centertown"),
  "42333": p("KY", "Cromwell"),
  "42338": p("KY", "Dundee"),
  "42343": p("KY", "Fordsville"),
  "42347": p("KY", "Hartford"),
  "42349": p("KY", "Horse Branch"),
  "42354": p("KY", "Mc Henry"),
  "42361": p("KY", "Olaton"),
  "42369": p("KY", "Rockport"),
  "42370": p("KY", "Rosine"),
  "40010": p("KY", "Buckner"),
  "40014": p("KY", "Crestwood"),
  "40026": p("KY", "Goshen"),
  "40031": p("KY", "La Grange"),
  "40032": p("KY", "La Grange"),
  "40056": p("KY", "Pewee Valley"),
  "40077": p("KY", "Westport"),
  "40355": p("KY", "New Liberty"),
  "40359": p("KY", "Owenton"),
  "40363": p("KY", "Perry Park"),
  "41314": p("KY", "Booneville"),
  "41351": p("KY", "Mistletoe"),
  "41364": p("KY", "Ricetown"),
  "41386": p("KY", "Vincent"),
  "41006": p("KY", "Butler"),
  "41033": p("KY", "De Mossville"),
  "41040": p("KY", "Falmouth"),
  "40981": p("KY", "Saul"),
  "41367": p("KY", "Rowdy"),
  "41701": p("KY", "Hazard"),
  "41702": p("KY", "Hazard"),
  "41712": p("KY", "Ary"),
  "41713": p("KY", "Avawam"),
  "41719": p("KY", "Bonnyman"),
  "41721": p("KY", "Buckhorn"),
  "41722": p("KY", "Bulan"),
  "41723": p("KY", "Busy"),
  "41727": p("KY", "Chavies"),
  "41729": p("KY", "Combs"),
  "41731": p("KY", "Cornettsville"),
  "41735": p("KY", "Delphia"),
  "41736": p("KY", "Dice"),
  "41739": p("KY", "Dwarf"),
  "41745": p("KY", "Gays Creek"),
  "41746": p("KY", "Happy"),
  "41751": p("KY", "Jeff"),
  "41754": p("KY", "Krypton"),
  "41760": p("KY", "Scuddy"),
  "41763": p("KY", "Slemp"),
  "41773": p("KY", "Vicco"),
  "41774": p("KY", "Viper"),
  "41778": p("KY", "Yerkes"),
  "41501": p("KY", "Pikeville"),
  "41502": p("KY", "Pikeville"),
  "41503": p("KY", "South Williamson"),
  "41512": p("KY", "Ashcamp"),
  "41513": p("KY", "Belcher"),
  "41514": p("KY", "Belfry"),
  "41519": p("KY", "Canada"),
  "41520": p("KY", "Dorton"),
  "41522": p("KY", "Elkhorn City"),
  "41524": p("KY", "Fedscreek"),
  "41526": p("KY", "Fords Branch"),
  "41527": p("KY", "Forest Hills"),
  "41528": p("KY", "Freeburn"),
  "41531": p("KY", "Hardy"),
  "41534": p("KY", "Hellier"),
  "41535": p("KY", "Huddy"),
  "41538": p("KY", "Jonancy"),
  "41539": p("KY", "Kimper"),
  "41540": p("KY", "Lick Creek"),
  "41542": p("KY", "Lookout"),
  "41543": p("KY", "Mc Andrews"),
  "41544": p("KY", "Mc Carr"),
  "41547": p("KY", "Majestic"),
  "41548": p("KY", "Mouthcard"),
  "41549": p("KY", "Myra"),
  "41553": p("KY", "Phelps"),
  "41554": p("KY", "Phyllis"),
  "41555": p("KY", "Pinsonfork"),
  "41557": p("KY", "Raccoon"),
  "41558": p("KY", "Ransom"),
  "41559": p("KY", "Regina"),
  "41560": p("KY", "Robinson Creek"),
  "41561": p("KY", "Rockhouse"),
  "41562": p("KY", "Shelbiana"),
  "41563": p("KY", "Shelby Gap"),
  "41564": p("KY", "Sidney"),
  "41566": p("KY", "Steele"),
  "41567": p("KY", "Stone"),
  "41568": p("KY", "Stopover"),
  "41571": p("KY", "Varney"),
  "41572": p("KY", "Virgie"),
  "40312": p("KY", "Clay City"),
  "40376": p("KY", "Slade"),
  "40380": p("KY", "Stanton"),
  "42501": p("KY", "Somerset"),
  "42502": p("KY", "Somerset"),
  "42503": p("KY", "Somerset"),
  "42518": p("KY", "Bronston"),
  "42519": p("KY", "Burnside"),
  "42533": p("KY", "Ferguson"),
  "42544": p("KY", "Nancy"),
  "42553": p("KY", "Science Hill"),
  "42558": p("KY", "Tateville"),
  "42564": p("KY", "West Somerset"),
  "42567": p("KY", "Eubank"),
  "41064": p("KY", "Mount Olivet"),
  "40409": p("KY", "Brodhead"),
  "40445": p("KY", "Livingston"),
  "40456": p("KY", "Mount Vernon"),
  "40460": p("KY", "Orlando"),
  "40473": p("KY", "Renfro Valley"),
  "40492": p("KY", "Wildie"),
  "40313": p("KY", "Clearfield"),
  "40317": p("KY", "Elliottville"),
  "40319": p("KY", "Farmers"),
  "40351": p("KY", "Morehead"),
  "42629": p("KY", "Jamestown"),
  "42642": p("KY", "Russell Springs"),
  "40324": p("KY", "Georgetown"),
  "40370": p("KY", "Sadieville"),
  "40379": p("KY", "Stamping Ground"),
  "40003": p("KY", "Bagdad"),
  "40022": p("KY", "Finchville"),
  "40065": p("KY", "Shelbyville"),
  "40066": p("KY", "Shelbyville"),
  "40067": p("KY", "Simpsonville"),
  "40076": p("KY", "Waddy"),
  "42134": p("KY", "Franklin"),
  "42135": p("KY", "Franklin"),
  "40046": p("KY", "Mount Eden"),
  "40071": p("KY", "Taylorsville"),
  "42718": p("KY", "Campbellsville"),
  "42719": p("KY", "Campbellsville"),
  "42733": p("KY", "Elk Horn"),
  "42758": p("KY", "Mannsville"),
  "42204": p("KY", "Allensville"),
  "42216": p("KY", "Clifty"),
  "42220": p("KY", "Elkton"),
  "42234": p("KY", "Guthrie"),
  "42280": p("KY", "Sharon Grove"),
  "42286": p("KY", "Trenton"),
  "42211": p("KY", "Cadiz"),
  "42215": p("KY", "Cerulean"),
  "40006": p("KY", "Bedford"),
  "40045": p("KY", "Milton"),
  "42437": p("KY", "Morganfield"),
  "42459": p("KY", "Sturgis"),
  "42460": p("KY", "Sullivan"),
  "42461": p("KY", "Uniontown"),
  "42462": p("KY", "Waverly"),
  "42101": p("KY", "Bowling Green"),
  "42102": p("KY", "Bowling Green"),
  "42103": p("KY", "Bowling Green"),
  "42104": p("KY", "Bowling Green"),
  "42122": p("KY", "Alvaton"),
  "42128": p("KY", "Drake"),
  "42159": p("KY", "Oakland"),
  "42170": p("KY", "Woodburn"),
  "42171": p("KY", "Smiths Grove"),
  "42274": p("KY", "Rockfield"),
  "40040": p("KY", "Mackville"),
  "40061": p("KY", "Saint Catharine"),
  "40069": p("KY", "Springfield"),
  "40078": p("KY", "Willisburg"),
  "42633": p("KY", "Monticello"),
  "42404": p("KY", "Clay"),
  "42409": p("KY", "Dixon"),
  "42444": p("KY", "Poole"),
  "42450": p("KY", "Providence"),
  "42455": p("KY", "Sebree"),
  "42456": p("KY", "Slaughters"),
  "42463": p("KY", "Wheatcroft"),
  "40701": p("KY", "Corbin"),
  "40702": p("KY", "Corbin"),
  "40730": p("KY", "Emlyn"),
  "40759": p("KY", "Rockholds"),
  "40763": p("KY", "Siler"),
  "40769": p("KY", "Williamsburg"),
  "41301": p("KY", "Campton"),
  "41332": p("KY", "Hazel Green"),
  "41360": p("KY", "Pine Ridge"),
  "41365": p("KY", "Rogers"),
  "40347": p("KY", "Midway"),
  "40383": p("KY", "Versailles"),
  "40384": p("KY", "Versailles"),
  "70516": p("LA", "Branch"),
  "70525": p("LA", "Church Point"),
  "70526": p("LA", "Crowley"),
  "70527": p("LA", "Crowley"),
  "70531": p("LA", "Egan"),
  "70534": p("LA", "Estherwood"),
  "70537": p("LA", "Evangeline"),
  "70543": p("LA", "Iota"),
  "70556": p("LA", "Mermentau"),
  "70559": p("LA", "Morse"),
  "70578": p("LA", "Rayne"),
  "70638": p("LA", "Elizabeth"),
  "70644": p("LA", "Grant"),
  "70648": p("LA", "Kinder"),
  "70651": p("LA", "Leblanc"),
  "70654": p("LA", "Mittie"),
  "70655": p("LA", "Oberlin"),
  "70658": p("LA", "Reeves"),
  "71463": p("LA", "Oakdale"),
  "70346": p("LA", "Donaldsonville"),
  "70707": p("LA", "Gonzales"),
  "70718": p("LA", "Brittany"),
  "70725": p("LA", "Darrow"),
  "70728": p("LA", "Duplessis"),
  "70734": p("LA", "Geismar"),
  "70737": p("LA", "Gonzales"),
  "70738": p("LA", "Burnside"),
  "70769": p("LA", "Prairieville"),
  "70774": p("LA", "Saint Amant"),
  "70778": p("LA", "Sorrento"),
  "70339": p("LA", "Pierre Part"),
  "70341": p("LA", "Belle Rose"),
  "70372": p("LA", "Labadieville"),
  "70390": p("LA", "Napoleonville"),
  "70391": p("LA", "Paincourtville"),
  "70393": p("LA", "Plattenville"),
  "71320": p("LA", "Bordelonville"),
  "71322": p("LA", "Bunkie"),
  "71323": p("LA", "Center Point"),
  "71327": p("LA", "Cottonport"),
  "71329": p("LA", "Dupont"),
  "71331": p("LA", "Effie"),
  "71333": p("LA", "Evergreen"),
  "71339": p("LA", "Hamburg"),
  "71341": p("LA", "Hessmer"),
  "71350": p("LA", "Mansura"),
  "71351": p("LA", "Marksville"),
  "71355": p("LA", "Moreauville"),
  "71362": p("LA", "Plaucheville"),
  "71369": p("LA", "Simmesport"),
  "70634": p("LA", "Deridder"),
  "70637": p("LA", "Dry Creek"),
  "70652": p("LA", "Longville"),
  "70653": p("LA", "Merryville"),
  "70657": p("LA", "Ragley"),
  "70660": p("LA", "Singer"),
  "70662": p("LA", "Sugartown"),
  "71001": p("LA", "Arcadia"),
  "71008": p("LA", "Bienville"),
  "71016": p("LA", "Castor"),
  "71028": p("LA", "Gibsland"),
  "71045": p("LA", "Jamestown"),
  "71068": p("LA", "Ringgold"),
  "71070": p("LA", "Saline"),
  "71080": p("LA", "Taylor"),
  "71006": p("LA", "Benton"),
  "71037": p("LA", "Haughton"),
  "71051": p("LA", "Elm Grove"),
  "71064": p("LA", "Plain Dealing"),
  "71067": p("LA", "Princeton"),
  "71110": p("LA", "Barksdale Afb"),
  "71111": p("LA", "Bossier City"),
  "71112": p("LA", "Bossier City"),
  "71113": p("LA", "Bossier City"),
  "71171": p("LA", "Bossier City"),
  "71172": p("LA", "Bossier City"),
  "71004": p("LA", "Belcher"),
  "71007": p("LA", "Bethany"),
  "71009": p("LA", "Blanchard"),
  "71029": p("LA", "Gilliam"),
  "71033": p("LA", "Greenwood"),
  "71043": p("LA", "Hosston"),
  "71044": p("LA", "Ida"),
  "71047": p("LA", "Keithville"),
  "71060": p("LA", "Mooringsport"),
  "71061": p("LA", "Oil City"),
  "71069": p("LA", "Rodessa"),
  "71082": p("LA", "Vivian"),
  "71101": p("LA", "Shreveport"),
  "71102": p("LA", "Shreveport"),
  "71103": p("LA", "Shreveport"),
  "71104": p("LA", "Shreveport"),
  "71105": p("LA", "Shreveport"),
  "71106": p("LA", "Shreveport"),
  "71107": p("LA", "Shreveport"),
  "71108": p("LA", "Shreveport"),
  "71109": p("LA", "Shreveport"),
  "71115": p("LA", "Shreveport"),
  "71118": p("LA", "Shreveport"),
  "71119": p("LA", "Shreveport"),
  "71120": p("LA", "Shreveport"),
  "71129": p("LA", "Shreveport"),
  "71130": p("LA", "Shreveport"),
  "71133": p("LA", "Shreveport"),
  "71134": p("LA", "Shreveport"),
  "71135": p("LA", "Shreveport"),
  "71136": p("LA", "Shreveport"),
  "71137": p("LA", "Shreveport"),
  "71138": p("LA", "Shreveport"),
  "71148": p("LA", "Shreveport"),
  "71149": p("LA", "Shreveport"),
  "71150": p("LA", "Shreveport"),
  "71151": p("LA", "Shreveport"),
  "71152": p("LA", "Shreveport"),
  "71153": p("LA", "Shreveport"),
  "71154": p("LA", "Shreveport"),
  "71156": p("LA", "Shreveport"),
  "71161": p("LA", "Shreveport"),
  "71162": p("LA", "Shreveport"),
  "71163": p("LA", "Shreveport"),
  "71164": p("LA", "Shreveport"),
  "71165": p("LA", "Shreveport"),
  "71166": p("LA", "Shreveport"),
  "70601": p("LA", "Lake Charles"),
  "70602": p("LA", "Lake Charles"),
  "70605": p("LA", "Lake Charles"),
  "70606": p("LA", "Lake Charles"),
  "70607": p("LA", "Lake Charles"),
  "70609": p("LA", "Lake Charles"),
  "70611": p("LA", "Lake Charles"),
  "70612": p("LA", "Lake Charles"),
  "70615": p("LA", "Lake Charles"),
  "70616": p("LA", "Lake Charles"),
  "70629": p("LA", "Lake Charles"),
  "70630": p("LA", "Bell City"),
  "70633": p("LA", "Dequincy"),
  "70646": p("LA", "Hayes"),
  "70647": p("LA", "Iowa"),
  "70661": p("LA", "Starks"),
  "70663": p("LA", "Sulphur"),
  "70664": p("LA", "Sulphur"),
  "70665": p("LA", "Sulphur"),
  "70668": p("LA", "Vinton"),
  "70669": p("LA", "Westlake"),
  "71415": p("LA", "Clarks"),
  "71418": p("LA", "Columbia"),
  "71435": p("LA", "Grayson"),
  "71441": p("LA", "Kelly"),
  "70631": p("LA", "Cameron"),
  "70632": p("LA", "Creole"),
  "70643": p("LA", "Grand Chenier"),
  "70645": p("LA", "Hackberry"),
  "71340": p("LA", "Harrisonburg"),
  "71343": p("LA", "Jonesville"),
  "71363": p("LA", "Rhinehart"),
  "71368": p("LA", "Sicily Island"),
  "71401": p("LA", "Aimwell"),
  "71425": p("LA", "Enterprise"),
  "71003": p("LA", "Athens"),
  "71038": p("LA", "Haynesville"),
  "71040": p("LA", "Homer"),
  "71048": p("LA", "Lisbon"),
  "71079": p("LA", "Summerfield"),
  "71316": p("LA", "Acme"),
  "71326": p("LA", "Clayton"),
  "71334": p("LA", "Ferriday"),
  "71354": p("LA", "Monterey"),
  "71373": p("LA", "Vidalia"),
  "71377": p("LA", "Wildsville"),
  "71027": p("LA", "Frierson"),
  "71030": p("LA", "Gloster"),
  "71032": p("LA", "Grand Cane"),
  "71046": p("LA", "Keatchie"),
  "71049": p("LA", "Logansport"),
  "71050": p("LA", "Longstreet"),
  "71052": p("LA", "Mansfield"),
  "71063": p("LA", "Pelican"),
  "71078": p("LA", "Stonewall"),
  "70704": p("LA", "Baker"),
  "70714": p("LA", "Baker"),
  "70739": p("LA", "Greenwell Springs"),
  "70770": p("LA", "Pride"),
  "70791": p("LA", "Zachary"),
  "70801": p("LA", "Baton Rouge"),
  "70802": p("LA", "Baton Rouge"),
  "70803": p("LA", "Baton Rouge"),
  "70804": p("LA", "Baton Rouge"),
  "70805": p("LA", "Baton Rouge"),
  "70806": p("LA", "Baton Rouge"),
  "70807": p("LA", "Baton Rouge"),
  "70808": p("LA", "Baton Rouge"),
  "70809": p("LA", "Baton Rouge"),
  "70810": p("LA", "Baton Rouge"),
  "70811": p("LA", "Baton Rouge"),
  "70812": p("LA", "Baton Rouge"),
  "70813": p("LA", "Baton Rouge"),
  "70814": p("LA", "Baton Rouge"),
  "70815": p("LA", "Baton Rouge"),
  "70816": p("LA", "Baton Rouge"),
  "70817": p("LA", "Baton Rouge"),
  "70818": p("LA", "Baton Rouge"),
  "70819": p("LA", "Baton Rouge"),
  "70820": p("LA", "Baton Rouge"),
  "70821": p("LA", "Baton Rouge"),
  "70822": p("LA", "Baton Rouge"),
  "70823": p("LA", "Baton Rouge"),
  "70825": p("LA", "Baton Rouge"),
  "70826": p("LA", "Baton Rouge"),
  "70827": p("LA", "Baton Rouge"),
  "70831": p("LA", "Baton Rouge"),
  "70833": p("LA", "Baton Rouge"),
  "70835": p("LA", "Baton Rouge"),
  "70836": p("LA", "Baton Rouge"),
  "70837": p("LA", "Baton Rouge"),
  "70873": p("LA", "Baton Rouge"),
  "70874": p("LA", "Baton Rouge"),
  "70879": p("LA", "Baton Rouge"),
  "70884": p("LA", "Baton Rouge"),
  "70891": p("LA", "Baton Rouge"),
  "70892": p("LA", "Baton Rouge"),
  "70893": p("LA", "Baton Rouge"),
  "70894": p("LA", "Baton Rouge"),
  "70895": p("LA", "Baton Rouge"),
  "70896": p("LA", "Baton Rouge"),
  "70898": p("LA", "Baton Rouge"),
  "71254": p("LA", "Lake Providence"),
  "71276": p("LA", "Sondheimer"),
  "71286": p("LA", "Transylvania"),
  "70722": p("LA", "Clinton"),
  "70730": p("LA", "Ethel"),
  "70748": p("LA", "Jackson"),
  "70761": p("LA", "Norwood"),
  "70777": p("LA", "Slaughter"),
  "70789": p("LA", "Wilson"),
  "70515": p("LA", "Basile"),
  "70524": p("LA", "Chataignier"),
  "70554": p("LA", "Mamou"),
  "70576": p("LA", "Pine Prairie"),
  "70580": p("LA", "Reddell"),
  "70585": p("LA", "Turkey Creek"),
  "70586": p("LA", "Ville Platte"),
  "71367": p("LA", "Saint Landry"),
  "71219": p("LA", "Baskin"),
  "71230": p("LA", "Crowville"),
  "71243": p("LA", "Fort Necessity"),
  "71249": p("LA", "Jigger"),
  "71295": p("LA", "Winnsboro"),
  "71324": p("LA", "Chase"),
  "71336": p("LA", "Gilbert"),
  "71378": p("LA", "Wisner"),
  "71407": p("LA", "Bentley"),
  "71417": p("LA", "Colfax"),
  "71423": p("LA", "Dry Prong"),
  "71432": p("LA", "Georgetown"),
  "71454": p("LA", "Montgomery"),
  "71467": p("LA", "Pollock"),
  "70513": p("LA", "Avery Island"),
  "70544": p("LA", "Jeanerette"),
  "70552": p("LA", "Loreauville"),
  "70560": p("LA", "New Iberia"),
  "70562": p("LA", "New Iberia"),
  "70563": p("LA", "New Iberia"),
  "70569": p("LA", "Lydia"),
  "70721": p("LA", "Carville"),
  "70740": p("LA", "Grosse Tete"),
  "70757": p("LA", "Maringouin"),
  "70764": p("LA", "Plaquemine"),
  "70765": p("LA", "Plaquemine"),
  "70772": p("LA", "Rosedale"),
  "70776": p("LA", "Saint Gabriel"),
  "70780": p("LA", "Sunshine"),
  "70788": p("LA", "White Castle"),
  "71226": p("LA", "Chatham"),
  "71238": p("LA", "Eros"),
  "71247": p("LA", "Hodge"),
  "71251": p("LA", "Jonesboro"),
  "71268": p("LA", "Quitman"),
  "70001": p("LA", "Metairie"),
  "70002": p("LA", "Metairie"),
  "70003": p("LA", "Metairie"),
  "70004": p("LA", "Metairie"),
  "70005": p("LA", "Metairie"),
  "70006": p("LA", "Metairie"),
  "70009": p("LA", "Metairie"),
  "70010": p("LA", "Metairie"),
  "70011": p("LA", "Metairie"),
  "70033": p("LA", "Metairie"),
  "70036": p("LA", "Barataria"),
  "70053": p("LA", "Gretna"),
  "70054": p("LA", "Gretna"),
  "70055": p("LA", "Metairie"),
  "70056": p("LA", "Gretna"),
  "70058": p("LA", "Harvey"),
  "70059": p("LA", "Harvey"),
  "70060": p("LA", "Metairie"),
  "70062": p("LA", "Kenner"),
  "70063": p("LA", "Kenner"),
  "70064": p("LA", "Kenner"),
  "70065": p("LA", "Kenner"),
  "70067": p("LA", "Lafitte"),
  "70072": p("LA", "Marrero"),
  "70073": p("LA", "Marrero"),
  "70094": p("LA", "Westwego"),
  "70096": p("LA", "Westwego"),
  "70097": p("LA", "Kenner"),
  "70121": p("LA", "New Orleans"),
  "70123": p("LA", "New Orleans"),
  "70141": p("LA", "New Orleans"),
  "70181": p("LA", "New Orleans"),
  "70183": p("LA", "New Orleans"),
  "70358": p("LA", "Grand Isle"),
  "70532": p("LA", "Elton"),
  "70546": p("LA", "Jennings"),
  "70549": p("LA", "Lake Arthur"),
  "70581": p("LA", "Roanoke"),
  "70591": p("LA", "Welsh"),
  "70640": p("LA", "Fenton"),
  "70650": p("LA", "Lacassine"),
  "70501": p("LA", "Lafayette"),
  "70502": p("LA", "Lafayette"),
  "70503": p("LA", "Lafayette"),
  "70504": p("LA", "Lafayette"),
  "70505": p("LA", "Lafayette"),
  "70506": p("LA", "Lafayette"),
  "70507": p("LA", "Lafayette"),
  "70508": p("LA", "Lafayette"),
  "70509": p("LA", "Lafayette"),
  "70518": p("LA", "Broussard"),
  "70520": p("LA", "Carencro"),
  "70529": p("LA", "Duson"),
  "70558": p("LA", "Milton"),
  "70583": p("LA", "Scott"),
  "70592": p("LA", "Youngsville"),
  "70593": p("LA", "Lafayette"),
  "70596": p("LA", "Lafayette"),
  "70598": p("LA", "Lafayette"),
  "70301": p("LA", "Thibodaux"),
  "70302": p("LA", "Thibodaux"),
  "70310": p("LA", "Thibodaux"),
  "70345": p("LA", "Cut Off"),
  "70354": p("LA", "Galliano"),
  "70355": p("LA", "Gheens"),
  "70357": p("LA", "Golden Meadow"),
  "70371": p("LA", "Kraemer"),
  "70373": p("LA", "Larose"),
  "70374": p("LA", "Lockport"),
  "70375": p("LA", "Mathews"),
  "70394": p("LA", "Raceland"),
  "71342": p("LA", "Jena"),
  "71371": p("LA", "Trout"),
  "71465": p("LA", "Olla"),
  "71479": p("LA", "Tullos"),
  "71480": p("LA", "Urania"),
  "71227": p("LA", "Choudrant"),
  "71235": p("LA", "Dubach"),
  "71245": p("LA", "Grambling"),
  "71270": p("LA", "Ruston"),
  "71272": p("LA", "Ruston"),
  "71273": p("LA", "Ruston"),
  "71275": p("LA", "Simsboro"),
  "70449": p("LA", "Maurepas"),
  "70462": p("LA", "Springfield"),
  "70706": p("LA", "Denham Springs"),
  "70711": p("LA", "Albany"),
  "70726": p("LA", "Denham Springs"),
  "70727": p("LA", "Denham Springs"),
  "70733": p("LA", "French Settlement"),
  "70744": p("LA", "Holden"),
  "70754": p("LA", "Livingston"),
  "70785": p("LA", "Walker"),
  "70786": p("LA", "Watson"),
  "71233": p("LA", "Delta"),
  "71282": p("LA", "Tallulah"),
  "71284": p("LA", "Tallulah"),
  "71220": p("LA", "Bastrop"),
  "71221": p("LA", "Bastrop"),
  "71223": p("LA", "Bonita"),
  "71229": p("LA", "Collinston"),
  "71250": p("LA", "Jones"),
  "71261": p("LA", "Mer Rouge"),
  "71264": p("LA", "Oak Ridge"),
  "71002": p("LA", "Ashland"),
  "71031": p("LA", "Goldonna"),
  "71066": p("LA", "Powhatan"),
  "71411": p("LA", "Campti"),
  "71414": p("LA", "Clarence"),
  "71416": p("LA", "Cloutierville"),
  "71428": p("LA", "Flora"),
  "71434": p("LA", "Gorum"),
  "71450": p("LA", "Marthaville"),
  "71452": p("LA", "Melrose"),
  "71455": p("LA", "Mora"),
  "71456": p("LA", "Natchez"),
  "71457": p("LA", "Natchitoches"),
  "71458": p("LA", "Natchitoches"),
  "71468": p("LA", "Provencal"),
  "71469": p("LA", "Robeline"),
  "71497": p("LA", "Natchitoches"),
  "70112": p("LA", "New Orleans"),
  "70113": p("LA", "New Orleans"),
  "70114": p("LA", "New Orleans"),
  "70115": p("LA", "New Orleans"),
  "70116": p("LA", "New Orleans"),
  "70117": p("LA", "New Orleans"),
  "70118": p("LA", "New Orleans"),
  "70119": p("LA", "New Orleans"),
  "70122": p("LA", "New Orleans"),
  "70124": p("LA", "New Orleans"),
  "70125": p("LA", "New Orleans"),
  "70126": p("LA", "New Orleans"),
  "70127": p("LA", "New Orleans"),
  "70128": p("LA", "New Orleans"),
  "70129": p("LA", "New Orleans"),
  "70130": p("LA", "New Orleans"),
  "70131": p("LA", "New Orleans"),
  "70139": p("LA", "New Orleans"),
  "70142": p("LA", "New Orleans"),
  "70143": p("LA", "New Orleans"),
  "70145": p("LA", "New Orleans"),
  "70146": p("LA", "New Orleans"),
  "70148": p("LA", "New Orleans"),
  "70150": p("LA", "New Orleans"),
  "70151": p("LA", "New Orleans"),
  "70152": p("LA", "New Orleans"),
  "70153": p("LA", "New Orleans"),
  "70154": p("LA", "New Orleans"),
  "70156": p("LA", "New Orleans"),
  "70157": p("LA", "New Orleans"),
  "70158": p("LA", "New Orleans"),
  "70159": p("LA", "New Orleans"),
  "70160": p("LA", "New Orleans"),
  "70161": p("LA", "New Orleans"),
  "70162": p("LA", "New Orleans"),
  "70163": p("LA", "New Orleans"),
  "70164": p("LA", "New Orleans"),
  "70165": p("LA", "New Orleans"),
  "70166": p("LA", "New Orleans"),
  "70167": p("LA", "New Orleans"),
  "70170": p("LA", "New Orleans"),
  "70172": p("LA", "New Orleans"),
  "70174": p("LA", "New Orleans"),
  "70175": p("LA", "New Orleans"),
  "70176": p("LA", "New Orleans"),
  "70177": p("LA", "New Orleans"),
  "70178": p("LA", "New Orleans"),
  "70179": p("LA", "New Orleans"),
  "70182": p("LA", "New Orleans"),
  "70184": p("LA", "New Orleans"),
  "70185": p("LA", "New Orleans"),
  "70186": p("LA", "New Orleans"),
  "70187": p("LA", "New Orleans"),
  "70189": p("LA", "New Orleans"),
  "70190": p("LA", "New Orleans"),
  "70195": p("LA", "New Orleans"),
  "71201": p("LA", "Monroe"),
  "71202": p("LA", "Monroe"),
  "71203": p("LA", "Monroe"),
  "71207": p("LA", "Monroe"),
  "71209": p("LA", "Monroe"),
  "71210": p("LA", "Monroe"),
  "71211": p("LA", "Monroe"),
  "71212": p("LA", "Monroe"),
  "71213": p("LA", "Monroe"),
  "71217": p("LA", "Monroe"),
  "71225": p("LA", "Calhoun"),
  "71240": p("LA", "Fairbanks"),
  "71280": p("LA", "Sterlington"),
  "71281": p("LA", "Swartz"),
  "71291": p("LA", "West Monroe"),
  "71292": p("LA", "West Monroe"),
  "71294": p("LA", "West Monroe"),
  "70037": p("LA", "Belle Chasse"),
  "70038": p("LA", "Boothville"),
  "70040": p("LA", "Braithwaite"),
  "70041": p("LA", "Buras"),
  "70050": p("LA", "Empire"),
  "70081": p("LA", "Pilottown"),
  "70082": p("LA", "Pointe A La Hache"),
  "70083": p("LA", "Port Sulphur"),
  "70091": p("LA", "Venice"),
  "70093": p("LA", "Belle Chasse"),
  "70715": p("LA", "Batchelor"),
  "70732": p("LA", "Fordoche"),
  "70736": p("LA", "Glynn"),
  "70747": p("LA", "Innis"),
  "70749": p("LA", "Jarreau"),
  "70752": p("LA", "Lakeland"),
  "70753": p("LA", "Lettsworth"),
  "70755": p("LA", "Livonia"),
  "70756": p("LA", "Lottie"),
  "70759": p("LA", "Morganza"),
  "70760": p("LA", "New Roads"),
  "70762": p("LA", "Oscar"),
  "70773": p("LA", "Rougon"),
  "70783": p("LA", "Ventress"),
  "71301": p("LA", "Alexandria"),
  "71302": p("LA", "Alexandria"),
  "71303": p("LA", "Alexandria"),
  "71306": p("LA", "Alexandria"),
  "71307": p("LA", "Alexandria"),
  "71309": p("LA", "Alexandria"),
  "71315": p("LA", "Alexandria"),
  "71325": p("LA", "Cheneyville"),
  "71328": p("LA", "Deville"),
  "71330": p("LA", "Echo"),
  "71346": p("LA", "Lecompte"),
  "71348": p("LA", "Libuse"),
  "71359": p("LA", "Pineville"),
  "71360": p("LA", "Pineville"),
  "71361": p("LA", "Pineville"),
  "71365": p("LA", "Ruby"),
  "71405": p("LA", "Ball"),
  "71409": p("LA", "Boyce"),
  "71424": p("LA", "Elmer"),
  "71427": p("LA", "Flatwoods"),
  "71430": p("LA", "Forest Hill"),
  "71431": p("LA", "Gardner"),
  "71433": p("LA", "Glenmora"),
  "71438": p("LA", "Hineston"),
  "71447": p("LA", "Lena"),
  "71448": p("LA", "Longleaf"),
  "71466": p("LA", "Otis"),
  "71472": p("LA", "Sieper"),
  "71477": p("LA", "Tioga"),
  "71485": p("LA", "Woodworth"),
  "71019": p("LA", "Coushatta"),
  "71034": p("LA", "Hall Summit"),
  "71218": p("LA", "Archibald"),
  "71232": p("LA", "Delhi"),
  "71259": p("LA", "Mangham"),
  "71269": p("LA", "Rayville"),
  "71279": p("LA", "Start"),
  "71065": p("LA", "Pleasant Hill"),
  "71406": p("LA", "Belmont"),
  "71419": p("LA", "Converse"),
  "71426": p("LA", "Fisher"),
  "71429": p("LA", "Florien"),
  "71449": p("LA", "Many"),
  "71460": p("LA", "Negreet"),
  "71462": p("LA", "Noble"),
  "71486": p("LA", "Zwolle"),
  "70032": p("LA", "Arabi"),
  "70043": p("LA", "Chalmette"),
  "70044": p("LA", "Chalmette"),
  "70075": p("LA", "Meraux"),
  "70085": p("LA", "Saint Bernard"),
  "70092": p("LA", "Violet"),
  "70030": p("LA", "Des Allemands"),
  "70031": p("LA", "Ama"),
  "70039": p("LA", "Boutte"),
  "70047": p("LA", "Destrehan"),
  "70057": p("LA", "Hahnville"),
  "70070": p("LA", "Luling"),
  "70078": p("LA", "New Sarpy"),
  "70079": p("LA", "Norco"),
  "70080": p("LA", "Paradis"),
  "70087": p("LA", "Saint Rose"),
  "70441": p("LA", "Greensburg"),
  "70453": p("LA", "Pine Grove"),
  "70052": p("LA", "Gramercy"),
  "70071": p("LA", "Lutcher"),
  "70086": p("LA", "Saint James"),
  "70090": p("LA", "Vacherie"),
  "70723": p("LA", "Convent"),
  "70743": p("LA", "Hester"),
  "70763": p("LA", "Paulina"),
  "70792": p("LA", "Uncle Sam"),
  "70049": p("LA", "Edgard"),
  "70051": p("LA", "Garyville"),
  "70068": p("LA", "La Place"),
  "70069": p("LA", "La Place"),
  "70076": p("LA", "Mount Airy"),
  "70084": p("LA", "Reserve"),
  "70512": p("LA", "Arnaudville"),
  "70535": p("LA", "Eunice"),
  "70541": p("LA", "Grand Coteau"),
  "70550": p("LA", "Lawtell"),
  "70551": p("LA", "Leonville"),
  "70570": p("LA", "Opelousas"),
  "70571": p("LA", "Opelousas"),
  "70577": p("LA", "Port Barre"),
  "70584": p("LA", "Sunset"),
  "70589": p("LA", "Washington"),
  "70750": p("LA", "Krotz Springs"),
  "71345": p("LA", "Lebeau"),
  "71353": p("LA", "Melville"),
  "71356": p("LA", "Morrow"),
  "71358": p("LA", "Palmetto"),
  "70517": p("LA", "Breaux Bridge"),
  "70519": p("LA", "Cade"),
  "70521": p("LA", "Cecilia"),
  "70582": p("LA", "Saint Martinville"),
  "70340": p("LA", "Amelia"),
  "70342": p("LA", "Berwick"),
  "70380": p("LA", "Morgan City"),
  "70381": p("LA", "Morgan City"),
  "70392": p("LA", "Patterson"),
  "70514": p("LA", "Baldwin"),
  "70522": p("LA", "Centerville"),
  "70523": p("LA", "Charenton"),
  "70538": p("LA", "Franklin"),
  "70540": p("LA", "Garden City"),
  "70420": p("LA", "Abita Springs"),
  "70431": p("LA", "Bush"),
  "70433": p("LA", "Covington"),
  "70434": p("LA", "Covington"),
  "70435": p("LA", "Covington"),
  "70437": p("LA", "Folsom"),
  "70445": p("LA", "Lacombe"),
  "70447": p("LA", "Madisonville"),
  "70448": p("LA", "Mandeville"),
  "70452": p("LA", "Pearl River"),
  "70457": p("LA", "Saint Benedict"),
  "70458": p("LA", "Slidell"),
  "70459": p("LA", "Slidell"),
  "70460": p("LA", "Slidell"),
  "70461": p("LA", "Slidell"),
  "70463": p("LA", "Sun"),
  "70464": p("LA", "Talisheek"),
  "70469": p("LA", "Slidell"),
  "70470": p("LA", "Mandeville"),
  "70471": p("LA", "Mandeville"),
  "70401": p("LA", "Hammond"),
  "70402": p("LA", "Hammond"),
  "70403": p("LA", "Hammond"),
  "70404": p("LA", "Hammond"),
  "70421": p("LA", "Akers"),
  "70422": p("LA", "Amite"),
  "70436": p("LA", "Fluker"),
  "70442": p("LA", "Husser"),
  "70443": p("LA", "Independence"),
  "70444": p("LA", "Kentwood"),
  "70446": p("LA", "Loranger"),
  "70451": p("LA", "Natalbany"),
  "70454": p("LA", "Ponchatoula"),
  "70455": p("LA", "Robert"),
  "70456": p("LA", "Roseland"),
  "70465": p("LA", "Tangipahoa"),
  "70466": p("LA", "Tickfaw"),
  "71357": p("LA", "Newellton"),
  "71366": p("LA", "Saint Joseph"),
  "71375": p("LA", "Waterproof"),
  "70343": p("LA", "Bourg"),
  "70344": p("LA", "Chauvin"),
  "70352": p("LA", "Donner"),
  "70353": p("LA", "Dulac"),
  "70356": p("LA", "Gibson"),
  "70359": p("LA", "Gray"),
  "70360": p("LA", "Houma"),
  "70361": p("LA", "Houma"),
  "70363": p("LA", "Houma"),
  "70364": p("LA", "Houma"),
  "70377": p("LA", "Montegut"),
  "70395": p("LA", "Schriever"),
  "70397": p("LA", "Theriot"),
  "71222": p("LA", "Bernice"),
  "71234": p("LA", "Downsville"),
  "71241": p("LA", "Farmerville"),
  "71256": p("LA", "Lillie"),
  "71260": p("LA", "Marion"),
  "71277": p("LA", "Spearsville"),
  "70510": p("LA", "Abbeville"),
  "70511": p("LA", "Abbeville"),
  "70528": p("LA", "Delcambre"),
  "70533": p("LA", "Erath"),
  "70542": p("LA", "Gueydan"),
  "70548": p("LA", "Kaplan"),
  "70555": p("LA", "Maurice"),
  "70575": p("LA", "Perry"),
  "70639": p("LA", "Evans"),
  "70656": p("LA", "Pitkin"),
  "70659": p("LA", "Rosepine"),
  "71403": p("LA", "Anacoco"),
  "71439": p("LA", "Hornbeck"),
  "71443": p("LA", "Kurthwood"),
  "71446": p("LA", "Leesville"),
  "71459": p("LA", "Fort Polk"),
  "71461": p("LA", "New Llano"),
  "71474": p("LA", "Simpson"),
  "71475": p("LA", "Slagle"),
  "71496": p("LA", "Leesville"),
  "70426": p("LA", "Angie"),
  "70427": p("LA", "Bogalusa"),
  "70429": p("LA", "Bogalusa"),
  "70438": p("LA", "Franklinton"),
  "70450": p("LA", "Mount Hermon"),
  "70467": p("LA", "Varnado"),
  "71018": p("LA", "Cotton Valley"),
  "71021": p("LA", "Cullen"),
  "71023": p("LA", "Doyline"),
  "71024": p("LA", "Dubberly"),
  "71039": p("LA", "Heflin"),
  "71055": p("LA", "Minden"),
  "71058": p("LA", "Minden"),
  "71071": p("LA", "Sarepta"),
  "71072": p("LA", "Shongaloo"),
  "71073": p("LA", "Sibley"),
  "71075": p("LA", "Springhill"),
  "70710": p("LA", "Addis"),
  "70719": p("LA", "Brusly"),
  "70729": p("LA", "Erwinville"),
  "70767": p("LA", "Port Allen"),
  "71237": p("LA", "Epps"),
  "71242": p("LA", "Forest"),
  "71253": p("LA", "Kilbourne"),
  "71263": p("LA", "Oak Grove"),
  "71266": p("LA", "Pioneer"),
  "70712": p("LA", "Angola"),
  "70775": p("LA", "Saint Francisville"),
  "70782": p("LA", "Tunica"),
  "70784": p("LA", "Wakefield"),
  "70787": p("LA", "Weyanoke"),
  "71404": p("LA", "Atlanta"),
  "71410": p("LA", "Calvin"),
  "71422": p("LA", "Dodson"),
  "71440": p("LA", "Joyce"),
  "71471": p("LA", "Saint Maurice"),
  "71473": p("LA", "Sikes"),
  "71483": p("LA", "Winnfield"),
  "02532": p("MA", "Buzzards Bay"),
  "02534": p("MA", "Cataumet"),
  "02536": p("MA", "East Falmouth"),
  "02537": p("MA", "East Sandwich"),
  "02540": p("MA", "Falmouth"),
  "02541": p("MA", "Falmouth"),
  "02542": p("MA", "Buzzards Bay"),
  "02543": p("MA", "Woods Hole"),
  "02553": p("MA", "Monument Beach"),
  "02556": p("MA", "North Falmouth"),
  "02559": p("MA", "Pocasset"),
  "02561": p("MA", "Sagamore"),
  "02562": p("MA", "Sagamore Beach"),
  "02563": p("MA", "Sandwich"),
  "02574": p("MA", "West Falmouth"),
  "02601": p("MA", "Hyannis"),
  "02630": p("MA", "Barnstable"),
  "02631": p("MA", "Brewster"),
  "02632": p("MA", "Centerville"),
  "02633": p("MA", "Chatham"),
  "02634": p("MA", "Centerville"),
  "02635": p("MA", "Cotuit"),
  "02637": p("MA", "Cummaquid"),
  "02638": p("MA", "Dennis"),
  "02639": p("MA", "Dennis Port"),
  "02641": p("MA", "East Dennis"),
  "02642": p("MA", "Eastham"),
  "02643": p("MA", "East Orleans"),
  "02644": p("MA", "Forestdale"),
  "02645": p("MA", "Harwich"),
  "02646": p("MA", "Harwich Port"),
  "02647": p("MA", "Hyannis Port"),
  "02648": p("MA", "Marstons Mills"),
  "02649": p("MA", "Mashpee"),
  "02650": p("MA", "North Chatham"),
  "02651": p("MA", "North Eastham"),
  "02652": p("MA", "North Truro"),
  "02653": p("MA", "Orleans"),
  "02655": p("MA", "Osterville"),
  "02657": p("MA", "Provincetown"),
  "02659": p("MA", "South Chatham"),
  "02660": p("MA", "South Dennis"),
  "02661": p("MA", "South Harwich"),
  "02662": p("MA", "South Orleans"),
  "02663": p("MA", "South Wellfleet"),
  "02664": p("MA", "South Yarmouth"),
  "02666": p("MA", "Truro"),
  "02667": p("MA", "Wellfleet"),
  "02668": p("MA", "West Barnstable"),
  "02669": p("MA", "West Chatham"),
  "02670": p("MA", "West Dennis"),
  "02671": p("MA", "West Harwich"),
  "02672": p("MA", "West Hyannisport"),
  "02673": p("MA", "West Yarmouth"),
  "02675": p("MA", "Yarmouth Port"),
  "01029": p("MA", "East Otis"),
  "01201": p("MA", "Pittsfield"),
  "01202": p("MA", "Pittsfield"),
  "01203": p("MA", "Pittsfield"),
  "01220": p("MA", "Adams"),
  "01222": p("MA", "Ashley Falls"),
  "01223": p("MA", "Becket"),
  "01224": p("MA", "Berkshire"),
  "01225": p("MA", "Cheshire"),
  "01226": p("MA", "Dalton"),
  "01227": p("MA", "Dalton"),
  "01229": p("MA", "Glendale"),
  "01230": p("MA", "Great Barrington"),
  "01235": p("MA", "Hinsdale"),
  "01236": p("MA", "Housatonic"),
  "01237": p("MA", "Lanesborough"),
  "01238": p("MA", "Lee"),
  "01240": p("MA", "Lenox"),
  "01242": p("MA", "Lenox Dale"),
  "01244": p("MA", "Mill River"),
  "01245": p("MA", "Monterey"),
  "01247": p("MA", "North Adams"),
  "01252": p("MA", "North Egremont"),
  "01253": p("MA", "Otis"),
  "01254": p("MA", "Richmond"),
  "01255": p("MA", "Sandisfield"),
  "01256": p("MA", "Savoy"),
  "01257": p("MA", "Sheffield"),
  "01258": p("MA", "South Egremont"),
  "01259": p("MA", "Southfield"),
  "01260": p("MA", "South Lee"),
  "01262": p("MA", "Stockbridge"),
  "01263": p("MA", "Stockbridge"),
  "01264": p("MA", "Tyringham"),
  "01266": p("MA", "West Stockbridge"),
  "01267": p("MA", "Williamstown"),
  "01270": p("MA", "Windsor"),
  "01343": p("MA", "Drury"),
  "02048": p("MA", "Mansfield"),
  "02334": p("MA", "Easton"),
  "02356": p("MA", "North Easton"),
  "02357": p("MA", "North Easton"),
  "02375": p("MA", "South Easton"),
  "02702": p("MA", "Assonet"),
  "02703": p("MA", "Attleboro"),
  "02712": p("MA", "Chartley"),
  "02714": p("MA", "Dartmouth"),
  "02715": p("MA", "Dighton"),
  "02717": p("MA", "East Freetown"),
  "02718": p("MA", "East Taunton"),
  "02719": p("MA", "Fairhaven"),
  "02720": p("MA", "Fall River"),
  "02721": p("MA", "Fall River"),
  "02722": p("MA", "Fall River"),
  "02723": p("MA", "Fall River"),
  "02724": p("MA", "Fall River"),
  "02725": p("MA", "Somerset"),
  "02726": p("MA", "Somerset"),
  "02740": p("MA", "New Bedford"),
  "02741": p("MA", "New Bedford"),
  "02742": p("MA", "New Bedford"),
  "02743": p("MA", "Acushnet"),
  "02744": p("MA", "New Bedford"),
  "02745": p("MA", "New Bedford"),
  "02746": p("MA", "New Bedford"),
  "02747": p("MA", "North Dartmouth"),
  "02748": p("MA", "South Dartmouth"),
  "02760": p("MA", "North Attleboro"),
  "02761": p("MA", "North Attleboro"),
  "02763": p("MA", "Attleboro Falls"),
  "02764": p("MA", "North Dighton"),
  "02766": p("MA", "Norton"),
  "02767": p("MA", "Raynham"),
  "02768": p("MA", "Raynham Center"),
  "02769": p("MA", "Rehoboth"),
  "02771": p("MA", "Seekonk"),
  "02777": p("MA", "Swansea"),
  "02779": p("MA", "Berkley"),
  "02780": p("MA", "Taunton"),
  "02783": p("MA", "Taunton"),
  "02790": p("MA", "Westport"),
  "02791": p("MA", "Westport Point"),
  "02535": p("MA", "Chilmark"),
  "02539": p("MA", "Edgartown"),
  "02552": p("MA", "Menemsha"),
  "02557": p("MA", "Oak Bluffs"),
  "02568": p("MA", "Vineyard Haven"),
  "02575": p("MA", "West Tisbury"),
  "02713": p("MA", "Cuttyhunk"),
  "01810": p("MA", "Andover"),
  "01812": p("MA", "Andover"),
  "01830": p("MA", "Haverhill"),
  "01831": p("MA", "Haverhill"),
  "01832": p("MA", "Haverhill"),
  "01833": p("MA", "Georgetown"),
  "01834": p("MA", "Groveland"),
  "01835": p("MA", "Haverhill"),
  "01840": p("MA", "Lawrence"),
  "01841": p("MA", "Lawrence"),
  "01842": p("MA", "Lawrence"),
  "01843": p("MA", "Lawrence"),
  "01844": p("MA", "Methuen"),
  "01845": p("MA", "North Andover"),
  "01860": p("MA", "Merrimac"),
  "01885": p("MA", "West Boxford"),
  "01899": p("MA", "Andover"),
  "01901": p("MA", "Lynn"),
  "01902": p("MA", "Lynn"),
  "01903": p("MA", "Lynn"),
  "01904": p("MA", "Lynn"),
  "01905": p("MA", "Lynn"),
  "01906": p("MA", "Saugus"),
  "01907": p("MA", "Swampscott"),
  "01908": p("MA", "Nahant"),
  "01910": p("MA", "Lynn"),
  "01913": p("MA", "Amesbury"),
  "01915": p("MA", "Beverly"),
  "01921": p("MA", "Boxford"),
  "01922": p("MA", "Byfield"),
  "01923": p("MA", "Danvers"),
  "01929": p("MA", "Essex"),
  "01930": p("MA", "Gloucester"),
  "01931": p("MA", "Gloucester"),
  "01936": p("MA", "Hamilton"),
  "01937": p("MA", "Hathorne"),
  "01938": p("MA", "Ipswich"),
  "01940": p("MA", "Lynnfield"),
  "01944": p("MA", "Manchester"),
  "01945": p("MA", "Marblehead"),
  "01949": p("MA", "Middleton"),
  "01950": p("MA", "Newburyport"),
  "01951": p("MA", "Newbury"),
  "01952": p("MA", "Salisbury"),
  "01960": p("MA", "Peabody"),
  "01961": p("MA", "Peabody"),
  "01965": p("MA", "Prides Crossing"),
  "01966": p("MA", "Rockport"),
  "01969": p("MA", "Rowley"),
  "01970": p("MA", "Salem"),
  "01971": p("MA", "Salem"),
  "01982": p("MA", "South Hamilton"),
  "01983": p("MA", "Topsfield"),
  "01984": p("MA", "Wenham"),
  "01985": p("MA", "West Newbury"),
  "05501": p("MA", "Andover"),
  "05544": p("MA", "Andover"),
  "01054": p("MA", "Leverett"),
  "01072": p("MA", "Shutesbury"),
  "01093": p("MA", "Whately"),
  "01301": p("MA", "Greenfield"),
  "01302": p("MA", "Greenfield"),
  "01330": p("MA", "Ashfield"),
  "01337": p("MA", "Bernardston"),
  "01338": p("MA", "Buckland"),
  "01339": p("MA", "Charlemont"),
  "01340": p("MA", "Colrain"),
  "01341": p("MA", "Conway"),
  "01342": p("MA", "Deerfield"),
  "01344": p("MA", "Erving"),
  "01346": p("MA", "Heath"),
  "01347": p("MA", "Lake Pleasant"),
  "01349": p("MA", "Millers Falls"),
  "01350": p("MA", "Monroe Bridge"),
  "01351": p("MA", "Montague"),
  "01354": p("MA", "Gill"),
  "01355": p("MA", "New Salem"),
  "01360": p("MA", "Northfield"),
  "01364": p("MA", "Orange"),
  "01367": p("MA", "Rowe"),
  "01370": p("MA", "Shelburne Falls"),
  "01373": p("MA", "South Deerfield"),
  "01375": p("MA", "Sunderland"),
  "01376": p("MA", "Turners Falls"),
  "01378": p("MA", "Warwick"),
  "01379": p("MA", "Wendell"),
  "01380": p("MA", "Wendell Depot"),
  "01001": p("MA", "Agawam"),
  "01008": p("MA", "Blandford"),
  "01009": p("MA", "Bondsville"),
  "01010": p("MA", "Brimfield"),
  "01011": p("MA", "Chester"),
  "01013": p("MA", "Chicopee"),
  "01014": p("MA", "Chicopee"),
  "01020": p("MA", "Chicopee"),
  "01021": p("MA", "Chicopee"),
  "01022": p("MA", "Chicopee"),
  "01028": p("MA", "East Longmeadow"),
  "01030": p("MA", "Feeding Hills"),
  "01034": p("MA", "Granville"),
  "01036": p("MA", "Hampden"),
  "01040": p("MA", "Holyoke"),
  "01041": p("MA", "Holyoke"),
  "01056": p("MA", "Ludlow"),
  "01057": p("MA", "Monson"),
  "01069": p("MA", "Palmer"),
  "01071": p("MA", "Russell"),
  "01077": p("MA", "Southwick"),
  "01079": p("MA", "Thorndike"),
  "01080": p("MA", "Three Rivers"),
  "01081": p("MA", "Wales"),
  "01085": p("MA", "Westfield"),
  "01086": p("MA", "Westfield"),
  "01089": p("MA", "West Springfield"),
  "01090": p("MA", "West Springfield"),
  "01095": p("MA", "Wilbraham"),
  "01097": p("MA", "Woronoco"),
  "01101": p("MA", "Springfield"),
  "01102": p("MA", "Springfield"),
  "01103": p("MA", "Springfield"),
  "01104": p("MA", "Springfield"),
  "01105": p("MA", "Springfield"),
  "01106": p("MA", "Longmeadow"),
  "01107": p("MA", "Springfield"),
  "01108": p("MA", "Springfield"),
  "01109": p("MA", "Springfield"),
  "01111": p("MA", "Springfield"),
  "01115": p("MA", "Springfield"),
  "01116": p("MA", "Longmeadow"),
  "01118": p("MA", "Springfield"),
  "01119": p("MA", "Springfield"),
  "01128": p("MA", "Springfield"),
  "01129": p("MA", "Springfield"),
  "01138": p("MA", "Springfield"),
  "01139": p("MA", "Springfield"),
  "01144": p("MA", "Springfield"),
  "01151": p("MA", "Indian Orchard"),
  "01152": p("MA", "Springfield"),
  "01199": p("MA", "Springfield"),
  "01521": p("MA", "Holland"),
  "01002": p("MA", "Amherst"),
  "01003": p("MA", "Amherst"),
  "01004": p("MA", "Amherst"),
  "01007": p("MA", "Belchertown"),
  "01012": p("MA", "Chesterfield"),
  "01026": p("MA", "Cummington"),
  "01027": p("MA", "Easthampton"),
  "01032": p("MA", "Goshen"),
  "01033": p("MA", "Granby"),
  "01035": p("MA", "Hadley"),
  "01038": p("MA", "Hatfield"),
  "01039": p("MA", "Haydenville"),
  "01050": p("MA", "Huntington"),
  "01053": p("MA", "Leeds"),
  "01059": p("MA", "North Amherst"),
  "01060": p("MA", "Northampton"),
  "01061": p("MA", "Northampton"),
  "01062": p("MA", "Florence"),
  "01063": p("MA", "Northampton"),
  "01066": p("MA", "North Hatfield"),
  "01070": p("MA", "Plainfield"),
  "01073": p("MA", "Southampton"),
  "01075": p("MA", "South Hadley"),
  "01082": p("MA", "Ware"),
  "01084": p("MA", "West Chesterfield"),
  "01088": p("MA", "West Hatfield"),
  "01096": p("MA", "Williamsburg"),
  "01098": p("MA", "Worthington"),
  "01243": p("MA", "Middlefield"),
  "01431": p("MA", "Ashby"),
  "01432": p("MA", "Ayer"),
  "01450": p("MA", "Groton"),
  "01460": p("MA", "Littleton"),
  "01463": p("MA", "Pepperell"),
  "01464": p("MA", "Shirley"),
  "01469": p("MA", "Townsend"),
  "01470": p("MA", "Groton"),
  "01471": p("MA", "Groton"),
  "01472": p("MA", "West Groton"),
  "01474": p("MA", "West Townsend"),
  "01701": p("MA", "Framingham"),
  "01702": p("MA", "Framingham"),
  "01703": p("MA", "Framingham"),
  "01704": p("MA", "Framingham"),
  "01705": p("MA", "Framingham"),
  "01718": p("MA", "Acton"),
  "01719": p("MA", "Boxborough"),
  "01720": p("MA", "Acton"),
  "01721": p("MA", "Ashland"),
  "01730": p("MA", "Bedford"),
  "01731": p("MA", "Hanscom Afb"),
  "01741": p("MA", "Carlisle"),
  "01742": p("MA", "Concord"),
  "01746": p("MA", "Holliston"),
  "01748": p("MA", "Hopkinton"),
  "01749": p("MA", "Hudson"),
  "01752": p("MA", "Marlborough"),
  "01754": p("MA", "Maynard"),
  "01760": p("MA", "Natick"),
  "01770": p("MA", "Sherborn"),
  "01773": p("MA", "Lincoln"),
  "01775": p("MA", "Stow"),
  "01776": p("MA", "Sudbury"),
  "01778": p("MA", "Wayland"),
  "01784": p("MA", "Woodville"),
  "01801": p("MA", "Woburn"),
  "01803": p("MA", "Burlington"),
  "01805": p("MA", "Burlington"),
  "01813": p("MA", "Woburn"),
  "01815": p("MA", "Woburn"),
  "01821": p("MA", "Billerica"),
  "01822": p("MA", "Billerica"),
  "01824": p("MA", "Chelmsford"),
  "01826": p("MA", "Dracut"),
  "01827": p("MA", "Dunstable"),
  "01850": p("MA", "Lowell"),
  "01851": p("MA", "Lowell"),
  "01852": p("MA", "Lowell"),
  "01853": p("MA", "Lowell"),
  "01854": p("MA", "Lowell"),
  "01862": p("MA", "North Billerica"),
  "01863": p("MA", "North Chelmsford"),
  "01864": p("MA", "North Reading"),
  "01865": p("MA", "Nutting Lake"),
  "01866": p("MA", "Pinehurst"),
  "01867": p("MA", "Reading"),
  "01876": p("MA", "Tewksbury"),
  "01879": p("MA", "Tyngsboro"),
  "01880": p("MA", "Wakefield"),
  "01886": p("MA", "Westford"),
  "01887": p("MA", "Wilmington"),
  "01888": p("MA", "Woburn"),
  "01889": p("MA", "North Reading"),
  "01890": p("MA", "Winchester"),
  "02138": p("MA", "Cambridge"),
  "02139": p("MA", "Cambridge"),
  "02140": p("MA", "Cambridge"),
  "02141": p("MA", "Cambridge"),
  "02142": p("MA", "Cambridge"),
  "02143": p("MA", "Somerville"),
  "02144": p("MA", "Somerville"),
  "02145": p("MA", "Somerville"),
  "02148": p("MA", "Malden"),
  "02149": p("MA", "Everett"),
  "02153": p("MA", "Medford"),
  "02155": p("MA", "Medford"),
  "02156": p("MA", "West Medford"),
  "02176": p("MA", "Melrose"),
  "02180": p("MA", "Stoneham"),
  "02212": p("MA", "Boston"),
  "02238": p("MA", "Cambridge"),
  "02420": p("MA", "Lexington"),
  "02421": p("MA", "Lexington"),
  "02451": p("MA", "Waltham"),
  "02452": p("MA", "Waltham"),
  "02453": p("MA", "Waltham"),
  "02454": p("MA", "Waltham"),
  "02455": p("MA", "North Waltham"),
  "02456": p("MA", "New Town"),
  "02458": p("MA", "Newton"),
  "02459": p("MA", "Newton Center"),
  "02460": p("MA", "Newtonville"),
  "02461": p("MA", "Newton Highlands"),
  "02462": p("MA", "Newton Lower Falls"),
  "02464": p("MA", "Newton Upper Falls"),
  "02465": p("MA", "West Newton"),
  "02466": p("MA", "Auburndale"),
  "02467": p("MA", "Chestnut Hill"),
  "02468": p("MA", "Waban"),
  "02471": p("MA", "Watertown"),
  "02472": p("MA", "Watertown"),
  "02474": p("MA", "Arlington"),
  "02475": p("MA", "Arlington Heights"),
  "02476": p("MA", "Arlington"),
  "02477": p("MA", "Watertown"),
  "02478": p("MA", "Belmont"),
  "02479": p("MA", "Waverley"),
  "02493": p("MA", "Weston"),
  "02495": p("MA", "Nonantum"),
  "02554": p("MA", "Nantucket"),
  "02564": p("MA", "Siasconset"),
  "02584": p("MA", "Nantucket"),
  "02019": p("MA", "Bellingham"),
  "02021": p("MA", "Canton"),
  "02025": p("MA", "Cohasset"),
  "02026": p("MA", "Dedham"),
  "02027": p("MA", "Dedham"),
  "02030": p("MA", "Dover"),
  "02032": p("MA", "East Walpole"),
  "02035": p("MA", "Foxboro"),
  "02038": p("MA", "Franklin"),
  "02052": p("MA", "Medfield"),
  "02053": p("MA", "Medway"),
  "02054": p("MA", "Millis"),
  "02056": p("MA", "Norfolk"),
  "02062": p("MA", "Norwood"),
  "02067": p("MA", "Sharon"),
  "02070": p("MA", "Sheldonville"),
  "02071": p("MA", "South Walpole"),
  "02072": p("MA", "Stoughton"),
  "02081": p("MA", "Walpole"),
  "02090": p("MA", "Westwood"),
  "02093": p("MA", "Wrentham"),
  "02169": p("MA", "Quincy"),
  "02170": p("MA", "Quincy"),
  "02171": p("MA", "Quincy"),
  "02184": p("MA", "Braintree"),
  "02185": p("MA", "Braintree"),
  "02186": p("MA", "Milton"),
  "02187": p("MA", "Milton Village"),
  "02188": p("MA", "Weymouth"),
  "02189": p("MA", "East Weymouth"),
  "02190": p("MA", "South Weymouth"),
  "02191": p("MA", "North Weymouth"),
  "02269": p("MA", "Quincy"),
  "02322": p("MA", "Avon"),
  "02343": p("MA", "Holbrook"),
  "02368": p("MA", "Randolph"),
  "02445": p("MA", "Brookline"),
  "02446": p("MA", "Brookline"),
  "02447": p("MA", "Brookline Village"),
  "02457": p("MA", "Babson Park"),
  "02481": p("MA", "Wellesley Hills"),
  "02482": p("MA", "Wellesley"),
  "02492": p("MA", "Needham"),
  "02494": p("MA", "Needham Heights"),
  "02762": p("MA", "Plainville"),
  "02018": p("MA", "Accord"),
  "02020": p("MA", "Brant Rock"),
  "02040": p("MA", "Greenbush"),
  "02041": p("MA", "Green Harbor"),
  "02043": p("MA", "Hingham"),
  "02044": p("MA", "Hingham"),
  "02045": p("MA", "Hull"),
  "02047": p("MA", "Humarock"),
  "02050": p("MA", "Marshfield"),
  "02051": p("MA", "Marshfield Hills"),
  "02055": p("MA", "Minot"),
  "02059": p("MA", "North Marshfield"),
  "02060": p("MA", "North Scituate"),
  "02061": p("MA", "Norwell"),
  "02065": p("MA", "Ocean Bluff"),
  "02066": p("MA", "Scituate"),
  "02301": p("MA", "Brockton"),
  "02302": p("MA", "Brockton"),
  "02303": p("MA", "Brockton"),
  "02304": p("MA", "Brockton"),
  "02305": p("MA", "Brockton"),
  "02324": p("MA", "Bridgewater"),
  "02325": p("MA", "Bridgewater"),
  "02327": p("MA", "Bryantville"),
  "02330": p("MA", "Carver"),
  "02331": p("MA", "Duxbury"),
  "02332": p("MA", "Duxbury"),
  "02333": p("MA", "East Bridgewater"),
  "02337": p("MA", "Elmwood"),
  "02338": p("MA", "Halifax"),
  "02339": p("MA", "Hanover"),
  "02340": p("MA", "Hanover"),
  "02341": p("MA", "Hanson"),
  "02344": p("MA", "Middleboro"),
  "02345": p("MA", "Manomet"),
  "02346": p("MA", "Middleboro"),
  "02347": p("MA", "Lakeville"),
  "02348": p("MA", "Lakeville"),
  "02349": p("MA", "Middleboro"),
  "02350": p("MA", "Monponsett"),
  "02351": p("MA", "Abington"),
  "02355": p("MA", "North Carver"),
  "02358": p("MA", "North Pembroke"),
  "02359": p("MA", "Pembroke"),
  "02360": p("MA", "Plymouth"),
  "02361": p("MA", "Plymouth"),
  "02362": p("MA", "Plymouth"),
  "02364": p("MA", "Kingston"),
  "02366": p("MA", "South Carver"),
  "02367": p("MA", "Plympton"),
  "02370": p("MA", "Rockland"),
  "02379": p("MA", "West Bridgewater"),
  "02381": p("MA", "White Horse Beach"),
  "02382": p("MA", "Whitman"),
  "02538": p("MA", "East Wareham"),
  "02558": p("MA", "Onset"),
  "02571": p("MA", "Wareham"),
  "02576": p("MA", "West Wareham"),
  "02738": p("MA", "Marion"),
  "02739": p("MA", "Mattapoisett"),
  "02770": p("MA", "Rochester"),
  "02108": p("MA", "Boston"),
  "02109": p("MA", "Boston"),
  "02110": p("MA", "Boston"),
  "02111": p("MA", "Boston"),
  "02112": p("MA", "Boston"),
  "02113": p("MA", "Boston"),
  "02114": p("MA", "Boston"),
  "02115": p("MA", "Boston"),
  "02116": p("MA", "Boston"),
  "02117": p("MA", "Boston"),
  "02118": p("MA", "Boston"),
  "02119": p("MA", "Roxbury"),
  "02120": p("MA", "Roxbury Crossing"),
  "02121": p("MA", "Dorchester"),
  "02122": p("MA", "Dorchester"),
  "02123": p("MA", "Boston"),
  "02124": p("MA", "Dorchester Center"),
  "02125": p("MA", "Dorchester"),
  "02126": p("MA", "Mattapan"),
  "02127": p("MA", "Boston"),
  "02128": p("MA", "Boston"),
  "02129": p("MA", "Charlestown"),
  "02130": p("MA", "Jamaica Plain"),
  "02131": p("MA", "Roslindale"),
  "02132": p("MA", "West Roxbury"),
  "02133": p("MA", "Boston"),
  "02134": p("MA", "Allston"),
  "02135": p("MA", "Brighton"),
  "02136": p("MA", "Hyde Park"),
  "02137": p("MA", "Readville"),
  "02150": p("MA", "Chelsea"),
  "02151": p("MA", "Revere"),
  "02152": p("MA", "Winthrop"),
  "02163": p("MA", "Boston"),
  "02196": p("MA", "Boston"),
  "02199": p("MA", "Boston"),
  "02201": p("MA", "Boston"),
  "02203": p("MA", "Boston"),
  "02204": p("MA", "Boston"),
  "02205": p("MA", "Boston"),
  "02206": p("MA", "Boston"),
  "02210": p("MA", "Boston"),
  "02211": p("MA", "Boston"),
  "02215": p("MA", "Boston"),
  "02217": p("MA", "Boston"),
  "02222": p("MA", "Boston"),
  "02241": p("MA", "Boston"),
  "02266": p("MA", "Boston"),
  "02283": p("MA", "Boston"),
  "02284": p("MA", "Boston"),
  "02293": p("MA", "Boston"),
  "02297": p("MA", "Boston"),
  "02298": p("MA", "Boston"),
  "01005": p("MA", "Barre"),
  "01031": p("MA", "Gilbertville"),
  "01037": p("MA", "Hardwick"),
  "01068": p("MA", "Oakham"),
  "01074": p("MA", "South Barre"),
  "01083": p("MA", "Warren"),
  "01092": p("MA", "West Warren"),
  "01094": p("MA", "Wheelwright"),
  "01331": p("MA", "Athol"),
  "01366": p("MA", "Petersham"),
  "01368": p("MA", "Royalston"),
  "01420": p("MA", "Fitchburg"),
  "01430": p("MA", "Ashburnham"),
  "01434": p("MA", "Devens"),
  "01436": p("MA", "Baldwinville"),
  "01438": p("MA", "East Templeton"),
  "01440": p("MA", "Gardner"),
  "01441": p("MA", "Westminster"),
  "01451": p("MA", "Harvard"),
  "01452": p("MA", "Hubbardston"),
  "01453": p("MA", "Leominster"),
  "01462": p("MA", "Lunenburg"),
  "01467": p("MA", "Still River"),
  "01468": p("MA", "Templeton"),
  "01473": p("MA", "Westminster"),
  "01475": p("MA", "Winchendon"),
  "01501": p("MA", "Auburn"),
  "01503": p("MA", "Berlin"),
  "01504": p("MA", "Blackstone"),
  "01505": p("MA", "Boylston"),
  "01506": p("MA", "Brookfield"),
  "01507": p("MA", "Charlton"),
  "01508": p("MA", "Charlton City"),
  "01509": p("MA", "Charlton Depot"),
  "01510": p("MA", "Clinton"),
  "01515": p("MA", "East Brookfield"),
  "01516": p("MA", "Douglas"),
  "01518": p("MA", "Fiskdale"),
  "01519": p("MA", "Grafton"),
  "01520": p("MA", "Holden"),
  "01522": p("MA", "Jefferson"),
  "01523": p("MA", "Lancaster"),
  "01524": p("MA", "Leicester"),
  "01525": p("MA", "Linwood"),
  "01526": p("MA", "Manchaug"),
  "01527": p("MA", "Millbury"),
  "01529": p("MA", "Millville"),
  "01531": p("MA", "New Braintree"),
  "01532": p("MA", "Northborough"),
  "01534": p("MA", "Northbridge"),
  "01535": p("MA", "North Brookfield"),
  "01536": p("MA", "North Grafton"),
  "01537": p("MA", "North Oxford"),
  "01538": p("MA", "North Uxbridge"),
  "01540": p("MA", "Oxford"),
  "01541": p("MA", "Princeton"),
  "01542": p("MA", "Rochdale"),
  "01543": p("MA", "Rutland"),
  "01545": p("MA", "Shrewsbury"),
  "01546": p("MA", "Shrewsbury"),
  "01550": p("MA", "Southbridge"),
  "01560": p("MA", "South Grafton"),
  "01561": p("MA", "South Lancaster"),
  "01562": p("MA", "Spencer"),
  "01564": p("MA", "Sterling"),
  "01566": p("MA", "Sturbridge"),
  "01568": p("MA", "Upton"),
  "01569": p("MA", "Uxbridge"),
  "01570": p("MA", "Webster"),
  "01571": p("MA", "Dudley"),
  "01581": p("MA", "Westborough"),
  "01583": p("MA", "West Boylston"),
  "01585": p("MA", "West Brookfield"),
  "01586": p("MA", "West Millbury"),
  "01588": p("MA", "Whitinsville"),
  "01590": p("MA", "Sutton"),
  "01601": p("MA", "Worcester"),
  "01602": p("MA", "Worcester"),
  "01603": p("MA", "Worcester"),
  "01604": p("MA", "Worcester"),
  "01605": p("MA", "Worcester"),
  "01606": p("MA", "Worcester"),
  "01607": p("MA", "Worcester"),
  "01608": p("MA", "Worcester"),
  "01609": p("MA", "Worcester"),
  "01610": p("MA", "Worcester"),
  "01611": p("MA", "Cherry Valley"),
  "01612": p("MA", "Paxton"),
  "01613": p("MA", "Worcester"),
  "01614": p("MA", "Worcester"),
  "01615": p("MA", "Worcester"),
  "01653": p("MA", "Worcester"),
  "01655": p("MA", "Worcester"),
  "01740": p("MA", "Bolton"),
  "01745": p("MA", "Fayville"),
  "01747": p("MA", "Hopedale"),
  "01756": p("MA", "Mendon"),
  "01757": p("MA", "Milford"),
  "01772": p("MA", "Southborough"),
  "21501": p("MD", "Cumberland"),
  "21502": p("MD", "Cumberland"),
  "21503": p("MD", "Cumberland"),
  "21504": p("MD", "Cumberland"),
  "21505": p("MD", "Cumberland"),
  "21521": p("MD", "Barton"),
  "21524": p("MD", "Corriganville"),
  "21528": p("MD", "Eckhart Mines"),
  "21529": p("MD", "Ellerslie"),
  "21530": p("MD", "Flintstone"),
  "21532": p("MD", "Frostburg"),
  "21539": p("MD", "Lonaconing"),
  "21540": p("MD", "Luke"),
  "21542": p("MD", "Midland"),
  "21543": p("MD", "Midlothian"),
  "21545": p("MD", "Mount Savage"),
  "21555": p("MD", "Oldtown"),
  "21556": p("MD", "Pinto"),
  "21557": p("MD", "Rawlings"),
  "21560": p("MD", "Spring Gap"),
  "21562": p("MD", "Westernport"),
  "21766": p("MD", "Little Orleans"),
  "20711": p("MD", "Lothian"),
  "20724": p("MD", "Laurel"),
  "20733": p("MD", "Churchton"),
  "20751": p("MD", "Deale"),
  "20755": p("MD", "Fort George G Meade"),
  "20758": p("MD", "Friendship"),
  "20764": p("MD", "Shady Side"),
  "20765": p("MD", "Galesville"),
  "20776": p("MD", "Harwood"),
  "20778": p("MD", "West River"),
  "20779": p("MD", "Tracys Landing"),
  "21012": p("MD", "Arnold"),
  "21032": p("MD", "Crownsville"),
  "21035": p("MD", "Davidsonville"),
  "21037": p("MD", "Edgewater"),
  "21054": p("MD", "Gambrills"),
  "21056": p("MD", "Gibson Island"),
  "21060": p("MD", "Glen Burnie"),
  "21061": p("MD", "Glen Burnie"),
  "21062": p("MD", "Glen Burnie"),
  "21076": p("MD", "Hanover"),
  "21077": p("MD", "Harmans"),
  "21090": p("MD", "Linthicum Heights"),
  "21106": p("MD", "Mayo"),
  "21108": p("MD", "Millersville"),
  "21113": p("MD", "Odenton"),
  "21114": p("MD", "Crofton"),
  "21122": p("MD", "Pasadena"),
  "21123": p("MD", "Pasadena"),
  "21140": p("MD", "Riva"),
  "21144": p("MD", "Severn"),
  "21146": p("MD", "Severna Park"),
  "21225": p("MD", "Brooklyn"),
  "21226": p("MD", "Curtis Bay"),
  "21240": p("MD", "Baltimore"),
  "21401": p("MD", "Annapolis"),
  "21402": p("MD", "Annapolis"),
  "21403": p("MD", "Annapolis"),
  "21404": p("MD", "Annapolis"),
  "21405": p("MD", "Annapolis"),
  "21409": p("MD", "Annapolis"),
  "21411": p("MD", "Annapolis"),
  "21412": p("MD", "Annapolis"),
  "21013": p("MD", "Baldwin"),
  "21020": p("MD", "Boring"),
  "21022": p("MD", "Brooklandville"),
  "21023": p("MD", "Butler"),
  "21027": p("MD", "Chase"),
  "21030": p("MD", "Cockeysville"),
  "21031": p("MD", "Hunt Valley"),
  "21051": p("MD", "Fork"),
  "21052": p("MD", "Fort Howard"),
  "21053": p("MD", "Freeland"),
  "21057": p("MD", "Glen Arm"),
  "21065": p("MD", "Hunt Valley"),
  "21071": p("MD", "Glyndon"),
  "21082": p("MD", "Hydes"),
  "21087": p("MD", "Kingsville"),
  "21092": p("MD", "Long Green"),
  "21093": p("MD", "Lutherville Timonium"),
  "21094": p("MD", "Lutherville Timonium"),
  "21105": p("MD", "Maryland Line"),
  "21111": p("MD", "Monkton"),
  "21117": p("MD", "Owings Mills"),
  "21120": p("MD", "Parkton"),
  "21128": p("MD", "Perry Hall"),
  "21131": p("MD", "Phoenix"),
  "21133": p("MD", "Randallstown"),
  "21136": p("MD", "Reisterstown"),
  "21139": p("MD", "Riderwood"),
  "21152": p("MD", "Sparks Glencoe"),
  "21153": p("MD", "Stevenson"),
  "21155": p("MD", "Upperco"),
  "21156": p("MD", "Upper Falls"),
  "21162": p("MD", "White Marsh"),
  "21163": p("MD", "Woodstock"),
  "21204": p("MD", "Towson"),
  "21207": p("MD", "Gwynn Oak"),
  "21208": p("MD", "Pikesville"),
  "21219": p("MD", "Sparrows Point"),
  "21220": p("MD", "Middle River"),
  "21221": p("MD", "Essex"),
  "21222": p("MD", "Dundalk"),
  "21227": p("MD", "Halethorpe"),
  "21228": p("MD", "Catonsville"),
  "21234": p("MD", "Parkville"),
  "21236": p("MD", "Nottingham"),
  "21237": p("MD", "Rosedale"),
  "21244": p("MD", "Windsor Mill"),
  "21250": p("MD", "Baltimore"),
  "21251": p("MD", "Baltimore"),
  "21252": p("MD", "Towson"),
  "21282": p("MD", "Pikesville"),
  "21284": p("MD", "Towson"),
  "21285": p("MD", "Towson"),
  "21286": p("MD", "Towson"),
  "20610": p("MD", "Barstow"),
  "20615": p("MD", "Broomes Island"),
  "20629": p("MD", "Dowell"),
  "20639": p("MD", "Huntingtown"),
  "20657": p("MD", "Lusby"),
  "20676": p("MD", "Port Republic"),
  "20678": p("MD", "Prince Frederick"),
  "20685": p("MD", "Saint Leonard"),
  "20688": p("MD", "Solomons"),
  "20689": p("MD", "Sunderland"),
  "20714": p("MD", "North Beach"),
  "20732": p("MD", "Chesapeake Beach"),
  "20736": p("MD", "Owings"),
  "20754": p("MD", "Dunkirk"),
  "21609": p("MD", "Bethlehem"),
  "21629": p("MD", "Denton"),
  "21632": p("MD", "Federalsburg"),
  "21636": p("MD", "Goldsboro"),
  "21639": p("MD", "Greensboro"),
  "21640": p("MD", "Henderson"),
  "21641": p("MD", "Hillsboro"),
  "21649": p("MD", "Marydel"),
  "21655": p("MD", "Preston"),
  "21660": p("MD", "Ridgely"),
  "21670": p("MD", "Templeville"),
  "21048": p("MD", "Finksburg"),
  "21074": p("MD", "Hampstead"),
  "21088": p("MD", "Lineboro"),
  "21102": p("MD", "Manchester"),
  "21104": p("MD", "Marriottsville"),
  "21157": p("MD", "Westminster"),
  "21158": p("MD", "Westminster"),
  "21757": p("MD", "Keymar"),
  "21776": p("MD", "New Windsor"),
  "21784": p("MD", "Sykesville"),
  "21787": p("MD", "Taneytown"),
  "21791": p("MD", "Union Bridge"),
  "21797": p("MD", "Woodbine"),
  "21901": p("MD", "North East"),
  "21902": p("MD", "Perry Point"),
  "21903": p("MD", "Perryville"),
  "21904": p("MD", "Port Deposit"),
  "21911": p("MD", "Rising Sun"),
  "21912": p("MD", "Warwick"),
  "21913": p("MD", "Cecilton"),
  "21914": p("MD", "Charlestown"),
  "21915": p("MD", "Chesapeake City"),
  "21916": p("MD", "Childs"),
  "21917": p("MD", "Colora"),
  "21918": p("MD", "Conowingo"),
  "21919": p("MD", "Earleville"),
  "21920": p("MD", "Elk Mills"),
  "21921": p("MD", "Elkton"),
  "21922": p("MD", "Elkton"),
  "21930": p("MD", "Georgetown"),
  "20601": p("MD", "Waldorf"),
  "20602": p("MD", "Waldorf"),
  "20603": p("MD", "Waldorf"),
  "20604": p("MD", "Waldorf"),
  "20611": p("MD", "Bel Alton"),
  "20612": p("MD", "Benedict"),
  "20616": p("MD", "Bryans Road"),
  "20617": p("MD", "Bryantown"),
  "20625": p("MD", "Cobb Island"),
  "20632": p("MD", "Faulkner"),
  "20637": p("MD", "Hughesville"),
  "20640": p("MD", "Indian Head"),
  "20643": p("MD", "Ironsides"),
  "20645": p("MD", "Issue"),
  "20646": p("MD", "La Plata"),
  "20658": p("MD", "Marbury"),
  "20661": p("MD", "Mount Victoria"),
  "20662": p("MD", "Nanjemoy"),
  "20664": p("MD", "Newburg"),
  "20675": p("MD", "Pomfret"),
  "20677": p("MD", "Port Tobacco"),
  "20682": p("MD", "Rock Point"),
  "20693": p("MD", "Welcome"),
  "20695": p("MD", "White Plains"),
  "21613": p("MD", "Cambridge"),
  "21622": p("MD", "Church Creek"),
  "21626": p("MD", "Crapo"),
  "21627": p("MD", "Crocheron"),
  "21631": p("MD", "East New Market"),
  "21634": p("MD", "Fishing Creek"),
  "21643": p("MD", "Hurlock"),
  "21648": p("MD", "Madison"),
  "21659": p("MD", "Rhodesdale"),
  "21664": p("MD", "Secretary"),
  "21669": p("MD", "Taylors Island"),
  "21672": p("MD", "Toddville"),
  "21675": p("MD", "Wingate"),
  "21677": p("MD", "Woolford"),
  "21835": p("MD", "Linkwood"),
  "21869": p("MD", "Vienna"),
  "21701": p("MD", "Frederick"),
  "21702": p("MD", "Frederick"),
  "21703": p("MD", "Frederick"),
  "21704": p("MD", "Frederick"),
  "21705": p("MD", "Frederick"),
  "21709": p("MD", "Frederick"),
  "21710": p("MD", "Adamstown"),
  "21714": p("MD", "Braddock Heights"),
  "21716": p("MD", "Brunswick"),
  "21717": p("MD", "Buckeystown"),
  "21718": p("MD", "Burkittsville"),
  "21727": p("MD", "Emmitsburg"),
  "21754": p("MD", "Ijamsville"),
  "21755": p("MD", "Jefferson"),
  "21758": p("MD", "Knoxville"),
  "21759": p("MD", "Ladiesburg"),
  "21762": p("MD", "Libertytown"),
  "21769": p("MD", "Middletown"),
  "21770": p("MD", "Monrovia"),
  "21771": p("MD", "Mount Airy"),
  "21773": p("MD", "Myersville"),
  "21774": p("MD", "New Market"),
  "21775": p("MD", "New Midway"),
  "21777": p("MD", "Point Of Rocks"),
  "21778": p("MD", "Rocky Ridge"),
  "21780": p("MD", "Sabillasville"),
  "21788": p("MD", "Thurmont"),
  "21790": p("MD", "Tuscarora"),
  "21792": p("MD", "Unionville"),
  "21793": p("MD", "Walkersville"),
  "21798": p("MD", "Woodsboro"),
  "21520": p("MD", "Accident"),
  "21522": p("MD", "Bittinger"),
  "21523": p("MD", "Bloomington"),
  "21531": p("MD", "Friendsville"),
  "21536": p("MD", "Grantsville"),
  "21538": p("MD", "Kitzmiller"),
  "21541": p("MD", "Mc Henry"),
  "21550": p("MD", "Oakland"),
  "21561": p("MD", "Swanton"),
  "21001": p("MD", "Aberdeen"),
  "21005": p("MD", "Aberdeen Proving Ground"),
  "21009": p("MD", "Abingdon"),
  "21010": p("MD", "Gunpowder"),
  "21014": p("MD", "Bel Air"),
  "21015": p("MD", "Bel Air"),
  "21017": p("MD", "Belcamp"),
  "21018": p("MD", "Benson"),
  "21028": p("MD", "Churchville"),
  "21034": p("MD", "Darlington"),
  "21040": p("MD", "Edgewood"),
  "21047": p("MD", "Fallston"),
  "21050": p("MD", "Forest Hill"),
  "21078": p("MD", "Havre De Grace"),
  "21084": p("MD", "Jarrettsville"),
  "21085": p("MD", "Joppa"),
  "21130": p("MD", "Perryman"),
  "21132": p("MD", "Pylesville"),
  "21154": p("MD", "Street"),
  "21160": p("MD", "Whiteford"),
  "21161": p("MD", "White Hall"),
  "20588": p("MD", "Dhs"),
  "20701": p("MD", "Annapolis Junction"),
  "20723": p("MD", "Laurel"),
  "20759": p("MD", "Fulton"),
  "20763": p("MD", "Savage"),
  "20777": p("MD", "Highland"),
  "20794": p("MD", "Jessup"),
  "21029": p("MD", "Clarksville"),
  "21036": p("MD", "Dayton"),
  "21041": p("MD", "Ellicott City"),
  "21042": p("MD", "Ellicott City"),
  "21043": p("MD", "Ellicott City"),
  "21044": p("MD", "Columbia"),
  "21045": p("MD", "Columbia"),
  "21046": p("MD", "Columbia"),
  "21075": p("MD", "Elkridge"),
  "21150": p("MD", "Simpsonville"),
  "21723": p("MD", "Cooksville"),
  "21737": p("MD", "Glenelg"),
  "21738": p("MD", "Glenwood"),
  "21765": p("MD", "Lisbon"),
  "21794": p("MD", "West Friendship"),
  "21610": p("MD", "Betterton"),
  "21620": p("MD", "Chestertown"),
  "21635": p("MD", "Galena"),
  "21645": p("MD", "Kennedyville"),
  "21650": p("MD", "Massey"),
  "21651": p("MD", "Millington"),
  "21661": p("MD", "Rock Hall"),
  "21667": p("MD", "Still Pond"),
  "21678": p("MD", "Worton"),
  "20810": p("MD", "Bethesda"),
  "20811": p("MD", "Bethesda"),
  "20812": p("MD", "Glen Echo"),
  "20813": p("MD", "Bethesda"),
  "20814": p("MD", "Bethesda"),
  "20815": p("MD", "Chevy Chase"),
  "20816": p("MD", "Bethesda"),
  "20817": p("MD", "Bethesda"),
  "20818": p("MD", "Cabin John"),
  "20824": p("MD", "Bethesda"),
  "20825": p("MD", "Chevy Chase"),
  "20827": p("MD", "Bethesda"),
  "20830": p("MD", "Olney"),
  "20832": p("MD", "Olney"),
  "20833": p("MD", "Brookeville"),
  "20837": p("MD", "Poolesville"),
  "20838": p("MD", "Barnesville"),
  "20839": p("MD", "Beallsville"),
  "20841": p("MD", "Boyds"),
  "20842": p("MD", "Dickerson"),
  "20847": p("MD", "Rockville"),
  "20848": p("MD", "Rockville"),
  "20849": p("MD", "Rockville"),
  "20850": p("MD", "Rockville"),
  "20851": p("MD", "Rockville"),
  "20852": p("MD", "Rockville"),
  "20853": p("MD", "Rockville"),
  "20854": p("MD", "Potomac"),
  "20855": p("MD", "Derwood"),
  "20857": p("MD", "Rockville"),
  "20859": p("MD", "Potomac"),
  "20860": p("MD", "Sandy Spring"),
  "20861": p("MD", "Ashton"),
  "20862": p("MD", "Brinklow"),
  "20866": p("MD", "Burtonsville"),
  "20868": p("MD", "Spencerville"),
  "20871": p("MD", "Clarksburg"),
  "20872": p("MD", "Damascus"),
  "20874": p("MD", "Germantown"),
  "20875": p("MD", "Germantown"),
  "20876": p("MD", "Germantown"),
  "20877": p("MD", "Gaithersburg"),
  "20878": p("MD", "Gaithersburg"),
  "20879": p("MD", "Gaithersburg"),
  "20880": p("MD", "Washington Grove"),
  "20882": p("MD", "Gaithersburg"),
  "20883": p("MD", "Gaithersburg"),
  "20884": p("MD", "Gaithersburg"),
  "20885": p("MD", "Gaithersburg"),
  "20886": p("MD", "Montgomery Village"),
  "20889": p("MD", "Bethesda"),
  "20891": p("MD", "Kensington"),
  "20892": p("MD", "Bethesda"),
  "20894": p("MD", "Bethesda"),
  "20895": p("MD", "Kensington"),
  "20896": p("MD", "Garrett Park"),
  "20897": p("MD", "Suburb Maryland Fac"),
  "20898": p("MD", "Gaithersburg"),
  "20899": p("MD", "Gaithersburg"),
  "20901": p("MD", "Silver Spring"),
  "20902": p("MD", "Silver Spring"),
  "20903": p("MD", "Silver Spring"),
  "20904": p("MD", "Silver Spring"),
  "20905": p("MD", "Silver Spring"),
  "20906": p("MD", "Silver Spring"),
  "20907": p("MD", "Silver Spring"),
  "20908": p("MD", "Silver Spring"),
  "20910": p("MD", "Silver Spring"),
  "20911": p("MD", "Silver Spring"),
  "20912": p("MD", "Takoma Park"),
  "20914": p("MD", "Silver Spring"),
  "20915": p("MD", "Silver Spring"),
  "20916": p("MD", "Silver Spring"),
  "20918": p("MD", "Silver Spring"),
  "20993": p("MD", "Silver Spring"),
  "20997": p("MD", "Silver Spring"),
  "20607": p("MD", "Accokeek"),
  "20608": p("MD", "Aquasco"),
  "20613": p("MD", "Brandywine"),
  "20623": p("MD", "Cheltenham"),
  "20697": p("MD", "Southern Md Facility"),
  "20703": p("MD", "Lanham"),
  "20704": p("MD", "Beltsville"),
  "20705": p("MD", "Beltsville"),
  "20706": p("MD", "Lanham"),
  "20707": p("MD", "Laurel"),
  "20708": p("MD", "Laurel"),
  "20709": p("MD", "Laurel"),
  "20710": p("MD", "Bladensburg"),
  "20712": p("MD", "Mount Rainier"),
  "20715": p("MD", "Bowie"),
  "20716": p("MD", "Bowie"),
  "20717": p("MD", "Bowie"),
  "20718": p("MD", "Bowie"),
  "20719": p("MD", "Bowie"),
  "20720": p("MD", "Bowie"),
  "20721": p("MD", "Bowie"),
  "20722": p("MD", "Brentwood"),
  "20725": p("MD", "Laurel"),
  "20726": p("MD", "Laurel"),
  "20731": p("MD", "Capitol Heights"),
  "20735": p("MD", "Clinton"),
  "20737": p("MD", "Riverdale"),
  "20738": p("MD", "Riverdale"),
  "20740": p("MD", "College Park"),
  "20741": p("MD", "College Park"),
  "20742": p("MD", "College Park"),
  "20743": p("MD", "Capitol Heights"),
  "20744": p("MD", "Fort Washington"),
  "20745": p("MD", "Oxon Hill"),
  "20746": p("MD", "Suitland"),
  "20747": p("MD", "District Heights"),
  "20748": p("MD", "Temple Hills"),
  "20749": p("MD", "Fort Washington"),
  "20750": p("MD", "Oxon Hill"),
  "20752": p("MD", "Suitland"),
  "20753": p("MD", "District Heights"),
  "20757": p("MD", "Temple Hills"),
  "20762": p("MD", "Andrews Air Force Base"),
  "20768": p("MD", "Greenbelt"),
  "20769": p("MD", "Glenn Dale"),
  "20770": p("MD", "Greenbelt"),
  "20771": p("MD", "Greenbelt"),
  "20772": p("MD", "Upper Marlboro"),
  "20773": p("MD", "Upper Marlboro"),
  "20774": p("MD", "Upper Marlboro"),
  "20775": p("MD", "Upper Marlboro"),
  "20781": p("MD", "Hyattsville"),
  "20782": p("MD", "Hyattsville"),
  "20783": p("MD", "Hyattsville"),
  "20784": p("MD", "Hyattsville"),
  "20785": p("MD", "Hyattsville"),
  "20787": p("MD", "Hyattsville"),
  "20788": p("MD", "Hyattsville"),
  "20790": p("MD", "Capitol Heights"),
  "20791": p("MD", "Capitol Heights"),
  "20792": p("MD", "Upper Marlboro"),
  "20797": p("MD", "Southern Md Facility"),
  "20799": p("MD", "Capitol Heights"),
  "20913": p("MD", "Takoma Park"),
  "21607": p("MD", "Barclay"),
  "21617": p("MD", "Centreville"),
  "21619": p("MD", "Chester"),
  "21623": p("MD", "Church Hill"),
  "21628": p("MD", "Crumpton"),
  "21638": p("MD", "Grasonville"),
  "21644": p("MD", "Ingleside"),
  "21656": p("MD", "Price"),
  "21657": p("MD", "Queen Anne"),
  "21658": p("MD", "Queenstown"),
  "21666": p("MD", "Stevensville"),
  "21668": p("MD", "Sudlersville"),
  "21690": p("MD", "Chestertown"),
  "20606": p("MD", "Abell"),
  "20609": p("MD", "Avenue"),
  "20618": p("MD", "Bushwood"),
  "20619": p("MD", "California"),
  "20620": p("MD", "Callaway"),
  "20621": p("MD", "Chaptico"),
  "20622": p("MD", "Charlotte Hall"),
  "20624": p("MD", "Clements"),
  "20626": p("MD", "Coltons Point"),
  "20627": p("MD", "Compton"),
  "20628": p("MD", "Dameron"),
  "20630": p("MD", "Drayden"),
  "20634": p("MD", "Great Mills"),
  "20635": p("MD", "Helen"),
  "20636": p("MD", "Hollywood"),
  "20650": p("MD", "Leonardtown"),
  "20653": p("MD", "Lexington Park"),
  "20656": p("MD", "Loveville"),
  "20659": p("MD", "Mechanicsville"),
  "20660": p("MD", "Morganza"),
  "20667": p("MD", "Park Hall"),
  "20670": p("MD", "Patuxent River"),
  "20674": p("MD", "Piney Point"),
  "20680": p("MD", "Ridge"),
  "20684": p("MD", "Saint Inigoes"),
  "20686": p("MD", "Saint Marys City"),
  "20687": p("MD", "Scotland"),
  "20690": p("MD", "Tall Timbers"),
  "20692": p("MD", "Valley Lee"),
  "21817": p("MD", "Crisfield"),
  "21821": p("MD", "Deal Island"),
  "21824": p("MD", "Ewell"),
  "21836": p("MD", "Manokin"),
  "21838": p("MD", "Marion Station"),
  "21853": p("MD", "Princess Anne"),
  "21857": p("MD", "Rehobeth"),
  "21866": p("MD", "Tylerton"),
  "21867": p("MD", "Upper Fairmount"),
  "21871": p("MD", "Westover"),
  "21890": p("MD", "Westover"),
  "21601": p("MD", "Easton"),
  "21612": p("MD", "Bozman"),
  "21624": p("MD", "Claiborne"),
  "21625": p("MD", "Cordova"),
  "21647": p("MD", "Mcdaniel"),
  "21652": p("MD", "Neavitt"),
  "21653": p("MD", "Newcomb"),
  "21654": p("MD", "Oxford"),
  "21662": p("MD", "Royal Oak"),
  "21663": p("MD", "Saint Michaels"),
  "21665": p("MD", "Sherwood"),
  "21671": p("MD", "Tilghman"),
  "21673": p("MD", "Trappe"),
  "21676": p("MD", "Wittman"),
  "21679": p("MD", "Wye Mills"),
  "21711": p("MD", "Big Pool"),
  "21713": p("MD", "Boonsboro"),
  "21715": p("MD", "Brownsville"),
  "21719": p("MD", "Cascade"),
  "21720": p("MD", "Cavetown"),
  "21721": p("MD", "Chewsville"),
  "21722": p("MD", "Clear Spring"),
  "21733": p("MD", "Fairplay"),
  "21734": p("MD", "Funkstown"),
  "21740": p("MD", "Hagerstown"),
  "21741": p("MD", "Hagerstown"),
  "21742": p("MD", "Hagerstown"),
  "21746": p("MD", "Hagerstown"),
  "21747": p("MD", "Hagerstown"),
  "21749": p("MD", "Hagerstown"),
  "21750": p("MD", "Hancock"),
  "21756": p("MD", "Keedysville"),
  "21767": p("MD", "Maugansville"),
  "21779": p("MD", "Rohrersville"),
  "21781": p("MD", "Saint James"),
  "21782": p("MD", "Sharpsburg"),
  "21783": p("MD", "Smithsburg"),
  "21795": p("MD", "Williamsport"),
  "21801": p("MD", "Salisbury"),
  "21802": p("MD", "Salisbury"),
  "21803": p("MD", "Salisbury"),
  "21804": p("MD", "Salisbury"),
  "21810": p("MD", "Allen"),
  "21814": p("MD", "Bivalve"),
  "21826": p("MD", "Fruitland"),
  "21830": p("MD", "Hebron"),
  "21837": p("MD", "Mardela Springs"),
  "21840": p("MD", "Nanticoke"),
  "21849": p("MD", "Parsonsburg"),
  "21850": p("MD", "Pittsville"),
  "21852": p("MD", "Powellville"),
  "21856": p("MD", "Quantico"),
  "21861": p("MD", "Sharptown"),
  "21865": p("MD", "Tyaskin"),
  "21874": p("MD", "Willards"),
  "21875": p("MD", "Delmar"),
  "21811": p("MD", "Berlin"),
  "21813": p("MD", "Bishopville"),
  "21822": p("MD", "Eden"),
  "21829": p("MD", "Girdletree"),
  "21841": p("MD", "Newark"),
  "21842": p("MD", "Ocean City"),
  "21843": p("MD", "Ocean City"),
  "21851": p("MD", "Pocomoke City"),
  "21862": p("MD", "Showell"),
  "21863": p("MD", "Snow Hill"),
  "21864": p("MD", "Stockton"),
  "21872": p("MD", "Whaleyville"),
  "21201": p("MD", "Baltimore"),
  "21202": p("MD", "Baltimore"),
  "21203": p("MD", "Baltimore"),
  "21205": p("MD", "Baltimore"),
  "21206": p("MD", "Baltimore"),
  "21209": p("MD", "Baltimore"),
  "21210": p("MD", "Baltimore"),
  "21211": p("MD", "Baltimore"),
  "21212": p("MD", "Baltimore"),
  "21213": p("MD", "Baltimore"),
  "21214": p("MD", "Baltimore"),
  "21215": p("MD", "Baltimore"),
  "21216": p("MD", "Baltimore"),
  "21217": p("MD", "Baltimore"),
  "21218": p("MD", "Baltimore"),
  "21223": p("MD", "Baltimore"),
  "21224": p("MD", "Baltimore"),
  "21229": p("MD", "Baltimore"),
  "21230": p("MD", "Baltimore"),
  "21231": p("MD", "Baltimore"),
  "21233": p("MD", "Baltimore"),
  "21235": p("MD", "Baltimore"),
  "21239": p("MD", "Baltimore"),
  "21241": p("MD", "Baltimore"),
  "21263": p("MD", "Baltimore"),
  "21264": p("MD", "Baltimore"),
  "21270": p("MD", "Baltimore"),
  "21273": p("MD", "Baltimore"),
  "21275": p("MD", "Baltimore"),
  "21278": p("MD", "Baltimore"),
  "21279": p("MD", "Baltimore"),
  "21280": p("MD", "Baltimore"),
  "21281": p("MD", "Baltimore"),
  "21287": p("MD", "Baltimore"),
  "21288": p("MD", "Baltimore"),
  "21289": p("MD", "Baltimore"),
  "21290": p("MD", "Baltimore"),
  "21297": p("MD", "Baltimore"),
  "21298": p("MD", "Baltimore"),
  "04210": p("ME", "Auburn"),
  "04211": p("ME", "Auburn"),
  "04212": p("ME", "Auburn"),
  "04222": p("ME", "Durham"),
  "04223": p("ME", "Danville"),
  "04228": p("ME", "East Livermore"),
  "04230": p("ME", "East Poland"),
  "04236": p("ME", "Greene"),
  "04240": p("ME", "Lewiston"),
  "04241": p("ME", "Lewiston"),
  "04243": p("ME", "Lewiston"),
  "04250": p("ME", "Lisbon"),
  "04252": p("ME", "Lisbon Falls"),
  "04253": p("ME", "Livermore"),
  "04254": p("ME", "Livermore Falls"),
  "04256": p("ME", "Mechanic Falls"),
  "04258": p("ME", "Minot"),
  "04263": p("ME", "Leeds"),
  "04266": p("ME", "North Turner"),
  "04274": p("ME", "Poland"),
  "04280": p("ME", "Sabattus"),
  "04282": p("ME", "Turner"),
  "04288": p("ME", "West Minot"),
  "04291": p("ME", "West Poland"),
  "04471": p("ME", "Orient"),
  "04497": p("ME", "Wytopitlock"),
  "04730": p("ME", "Houlton"),
  "04732": p("ME", "Ashland"),
  "04733": p("ME", "Benedicta"),
  "04734": p("ME", "Blaine"),
  "04735": p("ME", "Bridgewater"),
  "04736": p("ME", "Caribou"),
  "04737": p("ME", "Clayton Lake"),
  "04738": p("ME", "Crouseville"),
  "04739": p("ME", "Eagle Lake"),
  "04740": p("ME", "Easton"),
  "04741": p("ME", "Estcourt Station"),
  "04742": p("ME", "Fort Fairfield"),
  "04743": p("ME", "Fort Kent"),
  "04744": p("ME", "Fort Kent Mills"),
  "04745": p("ME", "Frenchville"),
  "04746": p("ME", "Grand Isle"),
  "04747": p("ME", "Island Falls"),
  "04750": p("ME", "Limestone"),
  "04751": p("ME", "Limestone"),
  "04756": p("ME", "Madawaska"),
  "04757": p("ME", "Mapleton"),
  "04758": p("ME", "Mars Hill"),
  "04760": p("ME", "Monticello"),
  "04761": p("ME", "New Limerick"),
  "04762": p("ME", "New Sweden"),
  "04763": p("ME", "Oakfield"),
  "04764": p("ME", "Oxbow"),
  "04766": p("ME", "Perham"),
  "04768": p("ME", "Portage"),
  "04769": p("ME", "Presque Isle"),
  "04772": p("ME", "Saint Agatha"),
  "04773": p("ME", "Saint David"),
  "04774": p("ME", "Saint Francis"),
  "04775": p("ME", "Sheridan"),
  "04776": p("ME", "Sherman"),
  "04779": p("ME", "Sinclair"),
  "04780": p("ME", "Smyrna Mills"),
  "04781": p("ME", "Wallagrass"),
  "04783": p("ME", "Stockholm"),
  "04785": p("ME", "Van Buren"),
  "04786": p("ME", "Washburn"),
  "04787": p("ME", "Westfield"),
  "04003": p("ME", "Bailey Island"),
  "04009": p("ME", "Bridgton"),
  "04011": p("ME", "Brunswick"),
  "04013": p("ME", "Bustins Island"),
  "04015": p("ME", "Casco"),
  "04017": p("ME", "Chebeague Island"),
  "04019": p("ME", "Cliff Island"),
  "04021": p("ME", "Cumberland Center"),
  "04024": p("ME", "East Baldwin"),
  "04029": p("ME", "Sebago"),
  "04032": p("ME", "Freeport"),
  "04033": p("ME", "Freeport"),
  "04034": p("ME", "Freeport"),
  "04038": p("ME", "Gorham"),
  "04039": p("ME", "Gray"),
  "04040": p("ME", "Harrison"),
  "04050": p("ME", "Long Island"),
  "04055": p("ME", "Naples"),
  "04057": p("ME", "North Bridgton"),
  "04062": p("ME", "Windham"),
  "04066": p("ME", "Orrs Island"),
  "04069": p("ME", "Pownal"),
  "04070": p("ME", "Scarborough"),
  "04071": p("ME", "Raymond"),
  "04074": p("ME", "Scarborough"),
  "04077": p("ME", "South Casco"),
  "04078": p("ME", "South Freeport"),
  "04079": p("ME", "Harpswell"),
  "04082": p("ME", "South Windham"),
  "04084": p("ME", "Standish"),
  "04085": p("ME", "Steep Falls"),
  "04091": p("ME", "West Baldwin"),
  "04092": p("ME", "Westbrook"),
  "04096": p("ME", "Yarmouth"),
  "04097": p("ME", "North Yarmouth"),
  "04098": p("ME", "Westbrook"),
  "04101": p("ME", "Portland"),
  "04102": p("ME", "Portland"),
  "04103": p("ME", "Portland"),
  "04104": p("ME", "Portland"),
  "04105": p("ME", "Falmouth"),
  "04106": p("ME", "South Portland"),
  "04107": p("ME", "Cape Elizabeth"),
  "04108": p("ME", "Peaks Island"),
  "04109": p("ME", "Portland"),
  "04110": p("ME", "Cumberland Foreside"),
  "04112": p("ME", "Portland"),
  "04116": p("ME", "South Portland"),
  "04122": p("ME", "Portland"),
  "04123": p("ME", "Portland"),
  "04124": p("ME", "Portland"),
  "04260": p("ME", "New Gloucester"),
  "04225": p("ME", "Dryden"),
  "04227": p("ME", "East Dixfield"),
  "04234": p("ME", "East Wilton"),
  "04239": p("ME", "Jay"),
  "04262": p("ME", "North Jay"),
  "04285": p("ME", "Weld"),
  "04294": p("ME", "Wilton"),
  "04936": p("ME", "Eustis"),
  "04938": p("ME", "Farmington"),
  "04940": p("ME", "Farmington Falls"),
  "04947": p("ME", "Kingfield"),
  "04955": p("ME", "New Sharon"),
  "04956": p("ME", "New Vineyard"),
  "04964": p("ME", "Oquossoc"),
  "04966": p("ME", "Phillips"),
  "04970": p("ME", "Rangeley"),
  "04982": p("ME", "Stratton"),
  "04983": p("ME", "Strong"),
  "04984": p("ME", "Temple"),
  "04992": p("ME", "West Farmington"),
  "04408": p("ME", "Aurora"),
  "04416": p("ME", "Bucksport"),
  "04420": p("ME", "Castine"),
  "04421": p("ME", "Castine"),
  "04431": p("ME", "East Orland"),
  "04472": p("ME", "Orland"),
  "04476": p("ME", "Penobscot"),
  "04605": p("ME", "Ellsworth"),
  "04607": p("ME", "Gouldsboro"),
  "04609": p("ME", "Bar Harbor"),
  "04612": p("ME", "Bernard"),
  "04613": p("ME", "Birch Harbor"),
  "04614": p("ME", "Blue Hill"),
  "04616": p("ME", "Brooklin"),
  "04617": p("ME", "Brooksville"),
  "04624": p("ME", "Corea"),
  "04625": p("ME", "Cranberry Isles"),
  "04627": p("ME", "Deer Isle"),
  "04629": p("ME", "East Blue Hill"),
  "04634": p("ME", "Franklin"),
  "04635": p("ME", "Frenchboro"),
  "04640": p("ME", "Hancock"),
  "04642": p("ME", "Harborside"),
  "04644": p("ME", "Hulls Cove"),
  "04646": p("ME", "Islesford"),
  "04650": p("ME", "Little Deer Isle"),
  "04653": p("ME", "Bass Harbor"),
  "04660": p("ME", "Mount Desert"),
  "04662": p("ME", "Northeast Harbor"),
  "04664": p("ME", "Sullivan"),
  "04669": p("ME", "Prospect Harbor"),
  "04672": p("ME", "Salsbury Cove"),
  "04673": p("ME", "Sargentville"),
  "04674": p("ME", "Seal Cove"),
  "04675": p("ME", "Seal Harbor"),
  "04676": p("ME", "Sedgwick"),
  "04677": p("ME", "Sorrento"),
  "04679": p("ME", "Southwest Harbor"),
  "04681": p("ME", "Stonington"),
  "04683": p("ME", "Sunset"),
  "04684": p("ME", "Surry"),
  "04685": p("ME", "Swans Island"),
  "04693": p("ME", "Winter Harbor"),
  "04259": p("ME", "Monmouth"),
  "04265": p("ME", "North Monmouth"),
  "04284": p("ME", "Wayne"),
  "04330": p("ME", "Augusta"),
  "04332": p("ME", "Augusta"),
  "04333": p("ME", "Augusta"),
  "04336": p("ME", "Augusta"),
  "04338": p("ME", "Augusta"),
  "04343": p("ME", "East Winthrop"),
  "04344": p("ME", "Farmingdale"),
  "04345": p("ME", "Gardiner"),
  "04346": p("ME", "Randolph"),
  "04347": p("ME", "Hallowell"),
  "04349": p("ME", "Kents Hill"),
  "04350": p("ME", "Litchfield"),
  "04351": p("ME", "Manchester"),
  "04352": p("ME", "Mount Vernon"),
  "04355": p("ME", "Readfield"),
  "04358": p("ME", "South China"),
  "04359": p("ME", "South Gardiner"),
  "04360": p("ME", "Vienna"),
  "04363": p("ME", "Windsor"),
  "04364": p("ME", "Winthrop"),
  "04901": p("ME", "Waterville"),
  "04903": p("ME", "Waterville"),
  "04910": p("ME", "Albion"),
  "04917": p("ME", "Belgrade"),
  "04918": p("ME", "Belgrade Lakes"),
  "04926": p("ME", "China Village"),
  "04927": p("ME", "Clinton"),
  "04935": p("ME", "East Vassalboro"),
  "04962": p("ME", "North Vassalboro"),
  "04963": p("ME", "Oakland"),
  "04989": p("ME", "Vassalboro"),
  "04547": p("ME", "Friendship"),
  "04563": p("ME", "Cushing"),
  "04574": p("ME", "Washington"),
  "04645": p("ME", "Isle Au Haut"),
  "04841": p("ME", "Rockland"),
  "04843": p("ME", "Camden"),
  "04847": p("ME", "Hope"),
  "04851": p("ME", "Matinicus"),
  "04853": p("ME", "North Haven"),
  "04854": p("ME", "Owls Head"),
  "04855": p("ME", "Port Clyde"),
  "04856": p("ME", "Rockport"),
  "04858": p("ME", "South Thomaston"),
  "04859": p("ME", "Spruce Head"),
  "04860": p("ME", "Tenants Harbor"),
  "04861": p("ME", "Thomaston"),
  "04862": p("ME", "Union"),
  "04863": p("ME", "Vinalhaven"),
  "04864": p("ME", "Warren"),
  "04865": p("ME", "West Rockport"),
  "04341": p("ME", "Coopers Mills"),
  "04342": p("ME", "Dresden"),
  "04348": p("ME", "Jefferson"),
  "04353": p("ME", "Whitefield"),
  "04535": p("ME", "Alna"),
  "04537": p("ME", "Boothbay"),
  "04538": p("ME", "Boothbay Harbor"),
  "04539": p("ME", "Bristol"),
  "04541": p("ME", "Chamberlain"),
  "04543": p("ME", "Damariscotta"),
  "04544": p("ME", "East Boothbay"),
  "04549": p("ME", "Isle Of Springs"),
  "04551": p("ME", "Bremen"),
  "04553": p("ME", "Newcastle"),
  "04554": p("ME", "New Harbor"),
  "04555": p("ME", "Nobleboro"),
  "04556": p("ME", "Edgecomb"),
  "04558": p("ME", "Pemaquid"),
  "04564": p("ME", "Round Pond"),
  "04568": p("ME", "South Bristol"),
  "04570": p("ME", "Squirrel Island"),
  "04571": p("ME", "Trevett"),
  "04572": p("ME", "Waldoboro"),
  "04573": p("ME", "Walpole"),
  "04575": p("ME", "West Boothbay Harbor"),
  "04576": p("ME", "Southport"),
  "04578": p("ME", "Wiscasset"),
  "04852": p("ME", "Monhegan"),
  "04010": p("ME", "Brownfield"),
  "04016": p("ME", "Center Lovell"),
  "04022": p("ME", "Denmark"),
  "04037": p("ME", "Fryeburg"),
  "04041": p("ME", "Hiram"),
  "04051": p("ME", "Lovell"),
  "04068": p("ME", "Porter"),
  "04088": p("ME", "Waterford"),
  "04216": p("ME", "Andover"),
  "04217": p("ME", "Bethel"),
  "04219": p("ME", "Bryant Pond"),
  "04220": p("ME", "Buckfield"),
  "04221": p("ME", "Canton"),
  "04224": p("ME", "Dixfield"),
  "04226": p("ME", "East Andover"),
  "04231": p("ME", "Stoneham"),
  "04237": p("ME", "Hanover"),
  "04238": p("ME", "Hebron"),
  "04255": p("ME", "Greenwood"),
  "04257": p("ME", "Mexico"),
  "04261": p("ME", "Newry"),
  "04267": p("ME", "North Waterford"),
  "04268": p("ME", "Norway"),
  "04270": p("ME", "Oxford"),
  "04271": p("ME", "Paris"),
  "04275": p("ME", "Roxbury"),
  "04276": p("ME", "Rumford"),
  "04281": p("ME", "South Paris"),
  "04286": p("ME", "West Bethel"),
  "04289": p("ME", "West Paris"),
  "04290": p("ME", "Peru"),
  "04292": p("ME", "Sumner"),
  "04401": p("ME", "Bangor"),
  "04402": p("ME", "Bangor"),
  "04410": p("ME", "Bradford"),
  "04411": p("ME", "Bradley"),
  "04412": p("ME", "Brewer"),
  "04417": p("ME", "Burlington"),
  "04418": p("ME", "Greenbush"),
  "04419": p("ME", "Carmel"),
  "04422": p("ME", "Charleston"),
  "04427": p("ME", "Corinth"),
  "04428": p("ME", "Eddington"),
  "04429": p("ME", "Holden"),
  "04430": p("ME", "East Millinocket"),
  "04434": p("ME", "Etna"),
  "04435": p("ME", "Exeter"),
  "04444": p("ME", "Hampden"),
  "04448": p("ME", "Howland"),
  "04449": p("ME", "Hudson"),
  "04450": p("ME", "Kenduskeag"),
  "04451": p("ME", "Kingman"),
  "04453": p("ME", "Lagrange"),
  "04455": p("ME", "Lee"),
  "04456": p("ME", "Levant"),
  "04457": p("ME", "Lincoln"),
  "04459": p("ME", "Mattawamkeag"),
  "04460": p("ME", "Medway"),
  "04461": p("ME", "Milford"),
  "04462": p("ME", "Millinocket"),
  "04468": p("ME", "Old Town"),
  "04469": p("ME", "Orono"),
  "04473": p("ME", "Orono"),
  "04474": p("ME", "Orrington"),
  "04475": p("ME", "Passadumkeag"),
  "04487": p("ME", "Springfield"),
  "04488": p("ME", "Stetson"),
  "04489": p("ME", "Stillwater"),
  "04493": p("ME", "West Enfield"),
  "04495": p("ME", "Winn"),
  "04765": p("ME", "Patten"),
  "04777": p("ME", "Stacyville"),
  "04928": p("ME", "Corinna"),
  "04930": p("ME", "Dexter"),
  "04932": p("ME", "Dixmont"),
  "04933": p("ME", "East Newport"),
  "04939": p("ME", "Garland"),
  "04953": p("ME", "Newport"),
  "04969": p("ME", "Plymouth"),
  "04406": p("ME", "Abbot"),
  "04414": p("ME", "Brownville"),
  "04415": p("ME", "Brownville Junction"),
  "04426": p("ME", "Dover Foxcroft"),
  "04441": p("ME", "Greenville"),
  "04442": p("ME", "Greenville Junction"),
  "04443": p("ME", "Guilford"),
  "04463": p("ME", "Milo"),
  "04464": p("ME", "Monson"),
  "04479": p("ME", "Sangerville"),
  "04481": p("ME", "Sebec"),
  "04485": p("ME", "Shirley Mills"),
  "04008": p("ME", "Bowdoinham"),
  "04086": p("ME", "Topsham"),
  "04287": p("ME", "Bowdoin"),
  "04357": p("ME", "Richmond"),
  "04530": p("ME", "Bath"),
  "04548": p("ME", "Georgetown"),
  "04562": p("ME", "Phippsburg"),
  "04565": p("ME", "Sebasco Estates"),
  "04579": p("ME", "Woolwich"),
  "04478": p("ME", "Rockwood"),
  "04911": p("ME", "Anson"),
  "04912": p("ME", "Athens"),
  "04920": p("ME", "Bingham"),
  "04923": p("ME", "Cambridge"),
  "04924": p("ME", "Canaan"),
  "04925": p("ME", "Caratunk"),
  "04929": p("ME", "Detroit"),
  "04937": p("ME", "Fairfield"),
  "04942": p("ME", "Harmony"),
  "04943": p("ME", "Hartland"),
  "04944": p("ME", "Hinckley"),
  "04945": p("ME", "Jackman"),
  "04950": p("ME", "Madison"),
  "04954": p("ME", "New Portland"),
  "04957": p("ME", "Norridgewock"),
  "04958": p("ME", "North Anson"),
  "04961": p("ME", "New Portland"),
  "04965": p("ME", "Palmyra"),
  "04967": p("ME", "Pittsfield"),
  "04971": p("ME", "Saint Albans"),
  "04975": p("ME", "Shawmut"),
  "04976": p("ME", "Skowhegan"),
  "04978": p("ME", "Smithfield"),
  "04979": p("ME", "Solon"),
  "04985": p("ME", "West Forks"),
  "04354": p("ME", "Palermo"),
  "04438": p("ME", "Frankfort"),
  "04496": p("ME", "Winterport"),
  "04848": p("ME", "Islesboro"),
  "04849": p("ME", "Lincolnville"),
  "04850": p("ME", "Lincolnville Center"),
  "04915": p("ME", "Belfast"),
  "04921": p("ME", "Brooks"),
  "04922": p("ME", "Burnham"),
  "04941": p("ME", "Freedom"),
  "04949": p("ME", "Liberty"),
  "04951": p("ME", "Monroe"),
  "04952": p("ME", "Morrill"),
  "04972": p("ME", "Sandy Point"),
  "04973": p("ME", "Searsmont"),
  "04974": p("ME", "Searsport"),
  "04981": p("ME", "Stockton Springs"),
  "04986": p("ME", "Thorndike"),
  "04987": p("ME", "Troy"),
  "04988": p("ME", "Unity"),
  "04413": p("ME", "Brookton"),
  "04424": p("ME", "Danforth"),
  "04454": p("ME", "Lambert Lake"),
  "04490": p("ME", "Topsfield"),
  "04491": p("ME", "Vanceboro"),
  "04492": p("ME", "Waite"),
  "04606": p("ME", "Addison"),
  "04611": p("ME", "Beals"),
  "04619": p("ME", "Calais"),
  "04622": p("ME", "Cherryfield"),
  "04623": p("ME", "Columbia Falls"),
  "04626": p("ME", "Cutler"),
  "04628": p("ME", "Dennysville"),
  "04630": p("ME", "East Machias"),
  "04631": p("ME", "Eastport"),
  "04637": p("ME", "Grand Lake Stream"),
  "04643": p("ME", "Harrington"),
  "04648": p("ME", "Jonesboro"),
  "04649": p("ME", "Jonesport"),
  "04652": p("ME", "Lubec"),
  "04654": p("ME", "Machias"),
  "04655": p("ME", "Machiasport"),
  "04657": p("ME", "Meddybemps"),
  "04658": p("ME", "Milbridge"),
  "04666": p("ME", "Pembroke"),
  "04667": p("ME", "Perry"),
  "04668": p("ME", "Princeton"),
  "04671": p("ME", "Robbinston"),
  "04680": p("ME", "Steuben"),
  "04686": p("ME", "Wesley"),
  "04691": p("ME", "Whiting"),
  "04694": p("ME", "Baileyville"),
  "03901": p("ME", "Berwick"),
  "03902": p("ME", "Cape Neddick"),
  "03903": p("ME", "Eliot"),
  "03904": p("ME", "Kittery"),
  "03905": p("ME", "Kittery Point"),
  "03906": p("ME", "North Berwick"),
  "03907": p("ME", "Ogunquit"),
  "03908": p("ME", "South Berwick"),
  "03909": p("ME", "York"),
  "03910": p("ME", "York Beach"),
  "03911": p("ME", "York Harbor"),
  "04001": p("ME", "Acton"),
  "04002": p("ME", "Alfred"),
  "04004": p("ME", "Bar Mills"),
  "04005": p("ME", "Biddeford"),
  "04006": p("ME", "Biddeford Pool"),
  "04007": p("ME", "Biddeford"),
  "04014": p("ME", "Cape Porpoise"),
  "04020": p("ME", "Cornish"),
  "04027": p("ME", "Lebanon"),
  "04028": p("ME", "East Parsonsfield"),
  "04030": p("ME", "East Waterboro"),
  "04042": p("ME", "Hollis Center"),
  "04043": p("ME", "Kennebunk"),
  "04046": p("ME", "Kennebunkport"),
  "04047": p("ME", "Parsonsfield"),
  "04048": p("ME", "Limerick"),
  "04049": p("ME", "Limington"),
  "04054": p("ME", "Moody"),
  "04056": p("ME", "Newfield"),
  "04061": p("ME", "North Waterboro"),
  "04063": p("ME", "Ocean Park"),
  "04064": p("ME", "Old Orchard Beach"),
  "04072": p("ME", "Saco"),
  "04073": p("ME", "Sanford"),
  "04076": p("ME", "Shapleigh"),
  "04083": p("ME", "Springvale"),
  "04087": p("ME", "Waterboro"),
  "04090": p("ME", "Wells"),
  "04093": p("ME", "Buxton"),
  "04094": p("ME", "West Kennebunk"),
  "04095": p("ME", "West Newfield"),
  "96960": p("MH", "Marshall Islands"),
  "96970": p("MH", "Ebeye"),
  "48705": p("MI", "Barton City"),
  "48721": p("MI", "Black River"),
  "48728": p("MI", "Curran"),
  "48737": p("MI", "Glennie"),
  "48738": p("MI", "Greenbush"),
  "48740": p("MI", "Harrisville"),
  "48742": p("MI", "Lincoln"),
  "48745": p("MI", "Mikado"),
  "48762": p("MI", "Spruce"),
  "49806": p("MI", "Au Train"),
  "49816": p("MI", "Chatham"),
  "49822": p("MI", "Deerton"),
  "49825": p("MI", "Eben Junction"),
  "49826": p("MI", "Rumely"),
  "49839": p("MI", "Grand Marais"),
  "49862": p("MI", "Munising"),
  "49884": p("MI", "Shingleton"),
  "49891": p("MI", "Trenary"),
  "49895": p("MI", "Wetmore"),
  "49010": p("MI", "Allegan"),
  "49070": p("MI", "Martin"),
  "49078": p("MI", "Otsego"),
  "49080": p("MI", "Plainwell"),
  "49311": p("MI", "Bradley"),
  "49314": p("MI", "Burnips"),
  "49323": p("MI", "Dorr"),
  "49328": p("MI", "Hopkins"),
  "49335": p("MI", "Moline"),
  "49344": p("MI", "Shelbyville"),
  "49348": p("MI", "Wayland"),
  "49406": p("MI", "Douglas"),
  "49408": p("MI", "Fennville"),
  "49416": p("MI", "Glenn"),
  "49419": p("MI", "Hamilton"),
  "49450": p("MI", "Pullman"),
  "49453": p("MI", "Saugatuck"),
  "49707": p("MI", "Alpena"),
  "49744": p("MI", "Herron"),
  "49747": p("MI", "Hubbard Lake"),
  "49753": p("MI", "Lachine"),
  "49766": p("MI", "Ossineke"),
  "49611": p("MI", "Alba"),
  "49612": p("MI", "Alden"),
  "49615": p("MI", "Bellaire"),
  "49622": p("MI", "Central Lake"),
  "49627": p("MI", "Eastport"),
  "49629": p("MI", "Elk Rapids"),
  "49648": p("MI", "Kewadin"),
  "49659": p("MI", "Mancelona"),
  "49729": p("MI", "Ellsworth"),
  "48658": p("MI", "Standish"),
  "48659": p("MI", "Sterling"),
  "48703": p("MI", "Au Gres"),
  "48749": p("MI", "Omer"),
  "48765": p("MI", "Turner"),
  "48766": p("MI", "Twining"),
  "49908": p("MI", "Baraga"),
  "49919": p("MI", "Covington"),
  "49946": p("MI", "Lanse"),
  "49962": p("MI", "Skanee"),
  "49970": p("MI", "Watton"),
  "48897": p("MI", "Woodland"),
  "49035": p("MI", "Cloverdale"),
  "49046": p("MI", "Delton"),
  "49050": p("MI", "Dowling"),
  "49058": p("MI", "Hastings"),
  "49060": p("MI", "Hickory Corners"),
  "49073": p("MI", "Nashville"),
  "49325": p("MI", "Freeport"),
  "49333": p("MI", "Middleville"),
  "48611": p("MI", "Auburn"),
  "48613": p("MI", "Bentley"),
  "48631": p("MI", "Kawkawlin"),
  "48634": p("MI", "Linwood"),
  "48650": p("MI", "Pinconning"),
  "48706": p("MI", "Bay City"),
  "48707": p("MI", "Bay City"),
  "48708": p("MI", "Bay City"),
  "48710": p("MI", "University Center"),
  "48732": p("MI", "Essexville"),
  "48747": p("MI", "Munger"),
  "49616": p("MI", "Benzonia"),
  "49617": p("MI", "Beulah"),
  "49628": p("MI", "Elberta"),
  "49635": p("MI", "Frankfort"),
  "49640": p("MI", "Honor"),
  "49650": p("MI", "Lake Ann"),
  "49683": p("MI", "Thompsonville"),
  "49022": p("MI", "Benton Harbor"),
  "49023": p("MI", "Benton Harbor"),
  "49038": p("MI", "Coloma"),
  "49039": p("MI", "Hagar Shores"),
  "49084": p("MI", "Riverside"),
  "49085": p("MI", "Saint Joseph"),
  "49098": p("MI", "Watervliet"),
  "49101": p("MI", "Baroda"),
  "49102": p("MI", "Berrien Center"),
  "49103": p("MI", "Berrien Springs"),
  "49104": p("MI", "Berrien Springs"),
  "49106": p("MI", "Bridgman"),
  "49107": p("MI", "Buchanan"),
  "49111": p("MI", "Eau Claire"),
  "49113": p("MI", "Galien"),
  "49115": p("MI", "Harbert"),
  "49116": p("MI", "Lakeside"),
  "49117": p("MI", "New Buffalo"),
  "49119": p("MI", "New Troy"),
  "49120": p("MI", "Niles"),
  "49125": p("MI", "Sawyer"),
  "49126": p("MI", "Sodus"),
  "49127": p("MI", "Stevensville"),
  "49128": p("MI", "Three Oaks"),
  "49129": p("MI", "Union Pier"),
  "49028": p("MI", "Bronson"),
  "49036": p("MI", "Coldwater"),
  "49082": p("MI", "Quincy"),
  "49089": p("MI", "Sherwood"),
  "49094": p("MI", "Union City"),
  "49255": p("MI", "Montgomery"),
  "49011": p("MI", "Athens"),
  "49014": p("MI", "Battle Creek"),
  "49015": p("MI", "Battle Creek"),
  "49016": p("MI", "Battle Creek"),
  "49017": p("MI", "Battle Creek"),
  "49018": p("MI", "Battle Creek"),
  "49020": p("MI", "Bedford"),
  "49029": p("MI", "Burlington"),
  "49033": p("MI", "Ceresco"),
  "49037": p("MI", "Battle Creek"),
  "49051": p("MI", "East Leroy"),
  "49068": p("MI", "Marshall"),
  "49092": p("MI", "Tekonsha"),
  "49224": p("MI", "Albion"),
  "49245": p("MI", "Homer"),
  "49031": p("MI", "Cassopolis"),
  "49047": p("MI", "Dowagiac"),
  "49061": p("MI", "Jones"),
  "49067": p("MI", "Marcellus"),
  "49095": p("MI", "Vandalia"),
  "49112": p("MI", "Edwardsburg"),
  "49130": p("MI", "Union"),
  "49711": p("MI", "Bay Shore"),
  "49712": p("MI", "Boyne City"),
  "49713": p("MI", "Boyne Falls"),
  "49720": p("MI", "Charlevoix"),
  "49727": p("MI", "East Jordan"),
  "49782": p("MI", "Beaver Island"),
  "49796": p("MI", "Walloon Lake"),
  "49701": p("MI", "Mackinaw City"),
  "49705": p("MI", "Afton"),
  "49716": p("MI", "Brutus"),
  "49717": p("MI", "Burt Lake"),
  "49721": p("MI", "Cheboygan"),
  "49749": p("MI", "Indian River"),
  "49761": p("MI", "Mullett Lake"),
  "49791": p("MI", "Topinabee"),
  "49792": p("MI", "Tower"),
  "49799": p("MI", "Wolverine"),
  "49710": p("MI", "Barbeau"),
  "49715": p("MI", "Brimley"),
  "49724": p("MI", "Dafter"),
  "49725": p("MI", "De Tour Village"),
  "49726": p("MI", "Drummond Island"),
  "49728": p("MI", "Eckerman"),
  "49736": p("MI", "Goetzville"),
  "49748": p("MI", "Hulbert"),
  "49752": p("MI", "Kinross"),
  "49768": p("MI", "Paradise"),
  "49774": p("MI", "Pickford"),
  "49780": p("MI", "Rudyard"),
  "49783": p("MI", "Sault Sainte Marie"),
  "49784": p("MI", "Kincheloe"),
  "49785": p("MI", "Kincheloe"),
  "49786": p("MI", "Kincheloe"),
  "49788": p("MI", "Kincheloe"),
  "49793": p("MI", "Trout Lake"),
  "48617": p("MI", "Clare"),
  "48622": p("MI", "Farwell"),
  "48625": p("MI", "Harrison"),
  "48632": p("MI", "Lake"),
  "48633": p("MI", "Lake George"),
  "48808": p("MI", "Bath"),
  "48820": p("MI", "Dewitt"),
  "48822": p("MI", "Eagle"),
  "48831": p("MI", "Elsie"),
  "48833": p("MI", "Eureka"),
  "48835": p("MI", "Fowler"),
  "48853": p("MI", "Maple Rapids"),
  "48866": p("MI", "Ovid"),
  "48879": p("MI", "Saint Johns"),
  "48894": p("MI", "Westphalia"),
  "49733": p("MI", "Frederic"),
  "49738": p("MI", "Grayling"),
  "49739": p("MI", "Grayling"),
  "49807": p("MI", "Bark River"),
  "49818": p("MI", "Cornell"),
  "49829": p("MI", "Escanaba"),
  "49835": p("MI", "Garden"),
  "49837": p("MI", "Gladstone"),
  "49864": p("MI", "Nahma"),
  "49872": p("MI", "Perkins"),
  "49878": p("MI", "Rapid River"),
  "49880": p("MI", "Rock"),
  "49894": p("MI", "Wells"),
  "49801": p("MI", "Iron Mountain"),
  "49802": p("MI", "Kingsford"),
  "49815": p("MI", "Channing"),
  "49831": p("MI", "Felch"),
  "49834": p("MI", "Foster City"),
  "49852": p("MI", "Loretto"),
  "49870": p("MI", "Norway"),
  "49876": p("MI", "Quinnesec"),
  "49877": p("MI", "Ralph"),
  "49881": p("MI", "Sagola"),
  "49892": p("MI", "Vulcan"),
  "48813": p("MI", "Charlotte"),
  "48821": p("MI", "Dimondale"),
  "48827": p("MI", "Eaton Rapids"),
  "48837": p("MI", "Grand Ledge"),
  "48861": p("MI", "Mulliken"),
  "48876": p("MI", "Potterville"),
  "48890": p("MI", "Sunfield"),
  "48908": p("MI", "Lansing"),
  "48917": p("MI", "Lansing"),
  "49021": p("MI", "Bellevue"),
  "49076": p("MI", "Olivet"),
  "49096": p("MI", "Vermontville"),
  "49706": p("MI", "Alanson"),
  "49718": p("MI", "Carp Lake"),
  "49722": p("MI", "Conway"),
  "49723": p("MI", "Cross Village"),
  "49737": p("MI", "Good Hart"),
  "49740": p("MI", "Harbor Springs"),
  "49755": p("MI", "Levering"),
  "49764": p("MI", "Oden"),
  "49769": p("MI", "Pellston"),
  "49770": p("MI", "Petoskey"),
  "48411": p("MI", "Atlas"),
  "48420": p("MI", "Clio"),
  "48423": p("MI", "Davison"),
  "48430": p("MI", "Fenton"),
  "48433": p("MI", "Flushing"),
  "48436": p("MI", "Gaines"),
  "48437": p("MI", "Genesee"),
  "48438": p("MI", "Goodrich"),
  "48439": p("MI", "Grand Blanc"),
  "48449": p("MI", "Lennon"),
  "48451": p("MI", "Linden"),
  "48457": p("MI", "Montrose"),
  "48458": p("MI", "Mount Morris"),
  "48463": p("MI", "Otisville"),
  "48473": p("MI", "Swartz Creek"),
  "48480": p("MI", "Grand Blanc"),
  "48501": p("MI", "Flint"),
  "48502": p("MI", "Flint"),
  "48503": p("MI", "Flint"),
  "48504": p("MI", "Flint"),
  "48505": p("MI", "Flint"),
  "48506": p("MI", "Flint"),
  "48507": p("MI", "Flint"),
  "48509": p("MI", "Burton"),
  "48519": p("MI", "Burton"),
  "48529": p("MI", "Burton"),
  "48531": p("MI", "Flint"),
  "48532": p("MI", "Flint"),
  "48550": p("MI", "Flint"),
  "48551": p("MI", "Flint"),
  "48552": p("MI", "Flint"),
  "48553": p("MI", "Flint"),
  "48554": p("MI", "Flint"),
  "48555": p("MI", "Flint"),
  "48556": p("MI", "Flint"),
  "48557": p("MI", "Flint"),
  "48612": p("MI", "Beaverton"),
  "48624": p("MI", "Gladwin"),
  "48638": p("MI", "Saginaw"),
  "48652": p("MI", "Rhodes"),
  "49911": p("MI", "Bessemer"),
  "49938": p("MI", "Ironwood"),
  "49947": p("MI", "Marenisco"),
  "49959": p("MI", "Ramsay"),
  "49968": p("MI", "Wakefield"),
  "49969": p("MI", "Watersmeet"),
  "49610": p("MI", "Acme"),
  "49633": p("MI", "Fife Lake"),
  "49637": p("MI", "Grawn"),
  "49643": p("MI", "Interlochen"),
  "49649": p("MI", "Kingsley"),
  "49666": p("MI", "Mayfield"),
  "49673": p("MI", "Old Mission"),
  "49684": p("MI", "Traverse City"),
  "49685": p("MI", "Traverse City"),
  "49686": p("MI", "Traverse City"),
  "49690": p("MI", "Williamsburg"),
  "49696": p("MI", "Traverse City"),
  "48615": p("MI", "Breckenridge"),
  "48662": p("MI", "Wheeler"),
  "48801": p("MI", "Alma"),
  "48806": p("MI", "Ashley"),
  "48807": p("MI", "Bannister"),
  "48830": p("MI", "Elm Hall"),
  "48832": p("MI", "Elwell"),
  "48847": p("MI", "Ithaca"),
  "48856": p("MI", "Middleton"),
  "48862": p("MI", "North Star"),
  "48871": p("MI", "Perrinton"),
  "48874": p("MI", "Pompeii"),
  "48877": p("MI", "Riverdale"),
  "48880": p("MI", "Saint Louis"),
  "48889": p("MI", "Sumner"),
  "49227": p("MI", "Allen"),
  "49232": p("MI", "Camden"),
  "49239": p("MI", "Frontier"),
  "49242": p("MI", "Hillsdale"),
  "49249": p("MI", "Jerome"),
  "49250": p("MI", "Jonesville"),
  "49252": p("MI", "Litchfield"),
  "49257": p("MI", "Moscow"),
  "49258": p("MI", "Mosherville"),
  "49262": p("MI", "North Adams"),
  "49266": p("MI", "Osseo"),
  "49271": p("MI", "Pittsford"),
  "49274": p("MI", "Reading"),
  "49281": p("MI", "Somerset"),
  "49282": p("MI", "Somerset Center"),
  "49288": p("MI", "Waldron"),
  "49905": p("MI", "Atlantic Mine"),
  "49913": p("MI", "Calumet"),
  "49916": p("MI", "Chassell"),
  "49917": p("MI", "Copper City"),
  "49921": p("MI", "Dodgeville"),
  "49922": p("MI", "Dollar Bay"),
  "49930": p("MI", "Hancock"),
  "49931": p("MI", "Houghton"),
  "49934": p("MI", "Hubbell"),
  "49942": p("MI", "Kearsarge"),
  "49945": p("MI", "Lake Linden"),
  "49952": p("MI", "Nisula"),
  "49955": p("MI", "Painesdale"),
  "49958": p("MI", "Pelkie"),
  "49961": p("MI", "Sidnaw"),
  "49963": p("MI", "South Range"),
  "49965": p("MI", "Toivola"),
  "48413": p("MI", "Bad Axe"),
  "48432": p("MI", "Filion"),
  "48441": p("MI", "Harbor Beach"),
  "48445": p("MI", "Kinde"),
  "48467": p("MI", "Port Austin"),
  "48468": p("MI", "Port Hope"),
  "48470": p("MI", "Ruth"),
  "48475": p("MI", "Ubly"),
  "48720": p("MI", "Bay Port"),
  "48725": p("MI", "Caseville"),
  "48731": p("MI", "Elkton"),
  "48754": p("MI", "Owendale"),
  "48755": p("MI", "Pigeon"),
  "48759": p("MI", "Sebewaing"),
  "48805": p("MI", "Okemos"),
  "48819": p("MI", "Dansville"),
  "48823": p("MI", "East Lansing"),
  "48824": p("MI", "East Lansing"),
  "48825": p("MI", "East Lansing"),
  "48826": p("MI", "East Lansing"),
  "48840": p("MI", "Haslett"),
  "48842": p("MI", "Holt"),
  "48854": p("MI", "Mason"),
  "48864": p("MI", "Okemos"),
  "48892": p("MI", "Webberville"),
  "48895": p("MI", "Williamston"),
  "48901": p("MI", "Lansing"),
  "48906": p("MI", "Lansing"),
  "48909": p("MI", "Lansing"),
  "48910": p("MI", "Lansing"),
  "48911": p("MI", "Lansing"),
  "48912": p("MI", "Lansing"),
  "48913": p("MI", "Lansing"),
  "48915": p("MI", "Lansing"),
  "48916": p("MI", "Lansing"),
  "48918": p("MI", "Lansing"),
  "48919": p("MI", "Lansing"),
  "48922": p("MI", "Lansing"),
  "48924": p("MI", "Lansing"),
  "48929": p("MI", "Lansing"),
  "48930": p("MI", "Lansing"),
  "48933": p("MI", "Lansing"),
  "48937": p("MI", "Lansing"),
  "48951": p("MI", "Lansing"),
  "48956": p("MI", "Lansing"),
  "48980": p("MI", "Lansing"),
  "49251": p("MI", "Leslie"),
  "49264": p("MI", "Onondaga"),
  "49285": p("MI", "Stockbridge"),
  "48809": p("MI", "Belding"),
  "48815": p("MI", "Clarksville"),
  "48845": p("MI", "Hubbardston"),
  "48846": p("MI", "Ionia"),
  "48849": p("MI", "Lake Odessa"),
  "48851": p("MI", "Lyons"),
  "48860": p("MI", "Muir"),
  "48865": p("MI", "Orleans"),
  "48870": p("MI", "Palo"),
  "48873": p("MI", "Pewamo"),
  "48875": p("MI", "Portland"),
  "48881": p("MI", "Saranac"),
  "48887": p("MI", "Smyrna"),
  "48730": p("MI", "East Tawas"),
  "48739": p("MI", "Hale"),
  "48743": p("MI", "Long Lake"),
  "48748": p("MI", "National City"),
  "48750": p("MI", "Oscoda"),
  "48763": p("MI", "Tawas City"),
  "48764": p("MI", "Tawas City"),
  "48770": p("MI", "Whittemore"),
  "49902": p("MI", "Alpha"),
  "49903": p("MI", "Amasa"),
  "49915": p("MI", "Caspian"),
  "49920": p("MI", "Crystal Falls"),
  "49927": p("MI", "Gaastra"),
  "49935": p("MI", "Iron River"),
  "49964": p("MI", "Stambaugh"),
  "48804": p("MI", "Mount Pleasant"),
  "48858": p("MI", "Mount Pleasant"),
  "48859": p("MI", "Mount Pleasant"),
  "48878": p("MI", "Rosebush"),
  "48883": p("MI", "Shepherd"),
  "48893": p("MI", "Weidman"),
  "48896": p("MI", "Winn"),
  "49310": p("MI", "Blanchard"),
  "49201": p("MI", "Jackson"),
  "49202": p("MI", "Jackson"),
  "49203": p("MI", "Jackson"),
  "49204": p("MI", "Jackson"),
  "49230": p("MI", "Brooklyn"),
  "49234": p("MI", "Clarklake"),
  "49237": p("MI", "Concord"),
  "49240": p("MI", "Grass Lake"),
  "49241": p("MI", "Hanover"),
  "49246": p("MI", "Horton"),
  "49254": p("MI", "Michigan Center"),
  "49259": p("MI", "Munith"),
  "49261": p("MI", "Napoleon"),
  "49263": p("MI", "Norvell"),
  "49269": p("MI", "Parma"),
  "49272": p("MI", "Pleasant Lake"),
  "49277": p("MI", "Rives Junction"),
  "49283": p("MI", "Spring Arbor"),
  "49284": p("MI", "Springport"),
  "49001": p("MI", "Kalamazoo"),
  "49002": p("MI", "Portage"),
  "49003": p("MI", "Kalamazoo"),
  "49004": p("MI", "Kalamazoo"),
  "49005": p("MI", "Kalamazoo"),
  "49006": p("MI", "Kalamazoo"),
  "49007": p("MI", "Kalamazoo"),
  "49008": p("MI", "Kalamazoo"),
  "49009": p("MI", "Kalamazoo"),
  "49012": p("MI", "Augusta"),
  "49019": p("MI", "Kalamazoo"),
  "49024": p("MI", "Portage"),
  "49034": p("MI", "Climax"),
  "49041": p("MI", "Comstock"),
  "49048": p("MI", "Kalamazoo"),
  "49052": p("MI", "Fulton"),
  "49053": p("MI", "Galesburg"),
  "49074": p("MI", "Nazareth"),
  "49077": p("MI", "Oshtemo"),
  "49081": p("MI", "Portage"),
  "49083": p("MI", "Richland"),
  "49087": p("MI", "Schoolcraft"),
  "49088": p("MI", "Scotts"),
  "49097": p("MI", "Vicksburg"),
  "49646": p("MI", "Kalkaska"),
  "49676": p("MI", "Rapid City"),
  "49680": p("MI", "South Boardman"),
  "49301": p("MI", "Ada"),
  "49302": p("MI", "Alto"),
  "49306": p("MI", "Belmont"),
  "49315": p("MI", "Byron Center"),
  "49316": p("MI", "Caledonia"),
  "49317": p("MI", "Cannonsburg"),
  "49319": p("MI", "Cedar Springs"),
  "49321": p("MI", "Comstock Park"),
  "49330": p("MI", "Kent City"),
  "49331": p("MI", "Lowell"),
  "49341": p("MI", "Rockford"),
  "49343": p("MI", "Sand Lake"),
  "49345": p("MI", "Sparta"),
  "49351": p("MI", "Rockford"),
  "49355": p("MI", "Ada"),
  "49356": p("MI", "Ada"),
  "49357": p("MI", "Ada"),
  "49418": p("MI", "Grandville"),
  "49468": p("MI", "Grandville"),
  "49501": p("MI", "Grand Rapids"),
  "49502": p("MI", "Grand Rapids"),
  "49503": p("MI", "Grand Rapids"),
  "49504": p("MI", "Grand Rapids"),
  "49505": p("MI", "Grand Rapids"),
  "49506": p("MI", "Grand Rapids"),
  "49507": p("MI", "Grand Rapids"),
  "49508": p("MI", "Grand Rapids"),
  "49509": p("MI", "Wyoming"),
  "49510": p("MI", "Grand Rapids"),
  "49512": p("MI", "Grand Rapids"),
  "49514": p("MI", "Grand Rapids"),
  "49515": p("MI", "Grand Rapids"),
  "49516": p("MI", "Grand Rapids"),
  "49518": p("MI", "Grand Rapids"),
  "49519": p("MI", "Wyoming"),
  "49523": p("MI", "Grand Rapids"),
  "49525": p("MI", "Grand Rapids"),
  "49528": p("MI", "Grand Rapids"),
  "49530": p("MI", "Grand Rapids"),
  "49544": p("MI", "Grand Rapids"),
  "49546": p("MI", "Grand Rapids"),
  "49548": p("MI", "Grand Rapids"),
  "49555": p("MI", "Grand Rapids"),
  "49560": p("MI", "Grand Rapids"),
  "49588": p("MI", "Grand Rapids"),
  "49599": p("MI", "Grand Rapids"),
  "49805": p("MI", "Allouez"),
  "49901": p("MI", "Ahmeek"),
  "49918": p("MI", "Copper Harbor"),
  "49950": p("MI", "Mohawk"),
  "49304": p("MI", "Baldwin"),
  "49402": p("MI", "Branch"),
  "49623": p("MI", "Chase"),
  "49642": p("MI", "Idlewild"),
  "49644": p("MI", "Irons"),
  "49656": p("MI", "Luther"),
  "48003": p("MI", "Almont"),
  "48412": p("MI", "Attica"),
  "48421": p("MI", "Columbiaville"),
  "48428": p("MI", "Dryden"),
  "48440": p("MI", "Hadley"),
  "48444": p("MI", "Imlay City"),
  "48446": p("MI", "Lapeer"),
  "48455": p("MI", "Metamora"),
  "48461": p("MI", "North Branch"),
  "48464": p("MI", "Otter Lake"),
  "48727": p("MI", "Clifford"),
  "48760": p("MI", "Silverwood"),
  "49621": p("MI", "Cedar"),
  "49630": p("MI", "Empire"),
  "49636": p("MI", "Glen Arbor"),
  "49653": p("MI", "Lake Leelanau"),
  "49654": p("MI", "Leland"),
  "49664": p("MI", "Maple City"),
  "49670": p("MI", "Northport"),
  "49674": p("MI", "Omena"),
  "49682": p("MI", "Suttons Bay"),
  "49220": p("MI", "Addison"),
  "49221": p("MI", "Adrian"),
  "49228": p("MI", "Blissfield"),
  "49229": p("MI", "Britton"),
  "49233": p("MI", "Cement City"),
  "49235": p("MI", "Clayton"),
  "49236": p("MI", "Clinton"),
  "49238": p("MI", "Deerfield"),
  "49247": p("MI", "Hudson"),
  "49248": p("MI", "Jasper"),
  "49253": p("MI", "Manitou Beach"),
  "49256": p("MI", "Morenci"),
  "49265": p("MI", "Onsted"),
  "49268": p("MI", "Palmyra"),
  "49276": p("MI", "Riga"),
  "49279": p("MI", "Sand Creek"),
  "49286": p("MI", "Tecumseh"),
  "49287": p("MI", "Tipton"),
  "49289": p("MI", "Weston"),
  "48114": p("MI", "Brighton"),
  "48116": p("MI", "Brighton"),
  "48137": p("MI", "Gregory"),
  "48139": p("MI", "Hamburg"),
  "48143": p("MI", "Lakeland"),
  "48169": p("MI", "Pinckney"),
  "48353": p("MI", "Hartland"),
  "48816": p("MI", "Cohoctah"),
  "48836": p("MI", "Fowlerville"),
  "48843": p("MI", "Howell"),
  "48844": p("MI", "Howell"),
  "48855": p("MI", "Howell"),
  "49853": p("MI", "Mc Millan"),
  "49868": p("MI", "Newberry"),
  "49719": p("MI", "Cedarville"),
  "49745": p("MI", "Hessel"),
  "49757": p("MI", "Mackinac Island"),
  "49760": p("MI", "Moran"),
  "49762": p("MI", "Naubinway"),
  "49775": p("MI", "Pointe Aux Pins"),
  "49781": p("MI", "Saint Ignace"),
  "49820": p("MI", "Curtis"),
  "49827": p("MI", "Engadine"),
  "49838": p("MI", "Gould City"),
  "48005": p("MI", "Armada"),
  "48015": p("MI", "Center Line"),
  "48021": p("MI", "Eastpointe"),
  "48026": p("MI", "Fraser"),
  "48035": p("MI", "Clinton Township"),
  "48036": p("MI", "Clinton Township"),
  "48038": p("MI", "Clinton Township"),
  "48042": p("MI", "Macomb"),
  "48043": p("MI", "Mount Clemens"),
  "48044": p("MI", "Macomb"),
  "48045": p("MI", "Harrison Township"),
  "48046": p("MI", "Mount Clemens"),
  "48047": p("MI", "New Baltimore"),
  "48048": p("MI", "New Haven"),
  "48050": p("MI", "New Haven"),
  "48051": p("MI", "New Baltimore"),
  "48062": p("MI", "Richmond"),
  "48065": p("MI", "Romeo"),
  "48066": p("MI", "Roseville"),
  "48080": p("MI", "Saint Clair Shores"),
  "48081": p("MI", "Saint Clair Shores"),
  "48082": p("MI", "Saint Clair Shores"),
  "48088": p("MI", "Warren"),
  "48089": p("MI", "Warren"),
  "48090": p("MI", "Warren"),
  "48091": p("MI", "Warren"),
  "48092": p("MI", "Warren"),
  "48093": p("MI", "Warren"),
  "48094": p("MI", "Washington"),
  "48095": p("MI", "Washington"),
  "48096": p("MI", "Ray"),
  "48310": p("MI", "Sterling Heights"),
  "48311": p("MI", "Sterling Heights"),
  "48312": p("MI", "Sterling Heights"),
  "48313": p("MI", "Sterling Heights"),
  "48314": p("MI", "Sterling Heights"),
  "48315": p("MI", "Utica"),
  "48316": p("MI", "Utica"),
  "48317": p("MI", "Utica"),
  "48318": p("MI", "Utica"),
  "48397": p("MI", "Warren"),
  "49613": p("MI", "Arcadia"),
  "49614": p("MI", "Bear Lake"),
  "49619": p("MI", "Brethren"),
  "49625": p("MI", "Copemish"),
  "49626": p("MI", "Eastlake"),
  "49634": p("MI", "Filer City"),
  "49645": p("MI", "Kaleva"),
  "49660": p("MI", "Manistee"),
  "49675": p("MI", "Onekama"),
  "49689": p("MI", "Wellston"),
  "49808": p("MI", "Big Bay"),
  "49814": p("MI", "Champion"),
  "49819": p("MI", "Arnold"),
  "49833": p("MI", "Little Lake"),
  "49841": p("MI", "Gwinn"),
  "49849": p("MI", "Ishpeming"),
  "49855": p("MI", "Marquette"),
  "49861": p("MI", "Michigamme"),
  "49865": p("MI", "National Mine"),
  "49866": p("MI", "Negaunee"),
  "49871": p("MI", "Palmer"),
  "49879": p("MI", "Republic"),
  "49885": p("MI", "Skandia"),
  "49405": p("MI", "Custer"),
  "49410": p("MI", "Fountain"),
  "49411": p("MI", "Free Soil"),
  "49431": p("MI", "Ludington"),
  "49454": p("MI", "Scottville"),
  "49458": p("MI", "Walhalla"),
  "49305": p("MI", "Barryton"),
  "49307": p("MI", "Big Rapids"),
  "49320": p("MI", "Chippewa Lake"),
  "49332": p("MI", "Mecosta"),
  "49336": p("MI", "Morley"),
  "49338": p("MI", "Paris"),
  "49340": p("MI", "Remus"),
  "49342": p("MI", "Rodney"),
  "49346": p("MI", "Stanwood"),
  "49812": p("MI", "Carney"),
  "49821": p("MI", "Daggett"),
  "49845": p("MI", "Harris"),
  "49847": p("MI", "Hermansville"),
  "49848": p("MI", "Ingalls"),
  "49858": p("MI", "Menominee"),
  "49863": p("MI", "Nadeau"),
  "49873": p("MI", "Perronville"),
  "49874": p("MI", "Powers"),
  "49886": p("MI", "Spalding"),
  "49887": p("MI", "Stephenson"),
  "49893": p("MI", "Wallace"),
  "49896": p("MI", "Wilson"),
  "48618": p("MI", "Coleman"),
  "48620": p("MI", "Edenville"),
  "48628": p("MI", "Hope"),
  "48640": p("MI", "Midland"),
  "48641": p("MI", "Midland"),
  "48642": p("MI", "Midland"),
  "48657": p("MI", "Sanford"),
  "48667": p("MI", "Midland"),
  "48670": p("MI", "Midland"),
  "48674": p("MI", "Midland"),
  "48686": p("MI", "Midland"),
  "49632": p("MI", "Falmouth"),
  "49651": p("MI", "Lake City"),
  "49657": p("MI", "Mc Bain"),
  "49667": p("MI", "Merritt"),
  "48110": p("MI", "Azalia"),
  "48117": p("MI", "Carleton"),
  "48131": p("MI", "Dundee"),
  "48133": p("MI", "Erie"),
  "48140": p("MI", "Ida"),
  "48144": p("MI", "Lambertville"),
  "48145": p("MI", "La Salle"),
  "48157": p("MI", "Luna Pier"),
  "48159": p("MI", "Maybee"),
  "48160": p("MI", "Milan"),
  "48161": p("MI", "Monroe"),
  "48162": p("MI", "Monroe"),
  "48166": p("MI", "Newport"),
  "48177": p("MI", "Samaria"),
  "48179": p("MI", "South Rockwood"),
  "48182": p("MI", "Temperance"),
  "49267": p("MI", "Ottawa Lake"),
  "49270": p("MI", "Petersburg"),
  "48811": p("MI", "Carson City"),
  "48812": p("MI", "Cedar Lake"),
  "48818": p("MI", "Crystal"),
  "48829": p("MI", "Edmore"),
  "48834": p("MI", "Fenwick"),
  "48838": p("MI", "Greenville"),
  "48850": p("MI", "Lakeview"),
  "48852": p("MI", "Mcbrides"),
  "48884": p("MI", "Sheridan"),
  "48885": p("MI", "Sidney"),
  "48886": p("MI", "Six Lakes"),
  "48888": p("MI", "Stanton"),
  "48891": p("MI", "Vestaburg"),
  "49322": p("MI", "Coral"),
  "49326": p("MI", "Gowen"),
  "49329": p("MI", "Howard City"),
  "49339": p("MI", "Pierson"),
  "49347": p("MI", "Trufant"),
  "49709": p("MI", "Atlanta"),
  "49746": p("MI", "Hillman"),
  "49756": p("MI", "Lewiston"),
  "49303": p("MI", "Bailey"),
  "49318": p("MI", "Casnovia"),
  "49415": p("MI", "Fruitport"),
  "49425": p("MI", "Holton"),
  "49437": p("MI", "Montague"),
  "49440": p("MI", "Muskegon"),
  "49441": p("MI", "Muskegon"),
  "49442": p("MI", "Muskegon"),
  "49443": p("MI", "Muskegon"),
  "49444": p("MI", "Muskegon"),
  "49445": p("MI", "Muskegon"),
  "49451": p("MI", "Ravenna"),
  "49457": p("MI", "Twin Lake"),
  "49461": p("MI", "Whitehall"),
  "49463": p("MI", "Sylvan Beach"),
  "49309": p("MI", "Bitely"),
  "49312": p("MI", "Brohman"),
  "49327": p("MI", "Grant"),
  "49337": p("MI", "Newaygo"),
  "49349": p("MI", "White Cloud"),
  "49412": p("MI", "Fremont"),
  "49413": p("MI", "Fremont"),
  "48007": p("MI", "Troy"),
  "48009": p("MI", "Birmingham"),
  "48012": p("MI", "Birmingham"),
  "48017": p("MI", "Clawson"),
  "48025": p("MI", "Franklin"),
  "48030": p("MI", "Hazel Park"),
  "48033": p("MI", "Southfield"),
  "48034": p("MI", "Southfield"),
  "48037": p("MI", "Southfield"),
  "48067": p("MI", "Royal Oak"),
  "48068": p("MI", "Royal Oak"),
  "48069": p("MI", "Pleasant Ridge"),
  "48070": p("MI", "Huntington Woods"),
  "48071": p("MI", "Madison Heights"),
  "48072": p("MI", "Berkley"),
  "48073": p("MI", "Royal Oak"),
  "48075": p("MI", "Southfield"),
  "48076": p("MI", "Southfield"),
  "48083": p("MI", "Troy"),
  "48084": p("MI", "Troy"),
  "48085": p("MI", "Troy"),
  "48086": p("MI", "Southfield"),
  "48098": p("MI", "Troy"),
  "48099": p("MI", "Troy"),
  "48165": p("MI", "New Hudson"),
  "48178": p("MI", "South Lyon"),
  "48220": p("MI", "Ferndale"),
  "48237": p("MI", "Oak Park"),
  "48301": p("MI", "Bloomfield Hills"),
  "48302": p("MI", "Bloomfield Hills"),
  "48303": p("MI", "Bloomfield Hills"),
  "48304": p("MI", "Bloomfield Hills"),
  "48306": p("MI", "Rochester"),
  "48307": p("MI", "Rochester"),
  "48308": p("MI", "Rochester"),
  "48309": p("MI", "Rochester"),
  "48320": p("MI", "Keego Harbor"),
  "48321": p("MI", "Auburn Hills"),
  "48322": p("MI", "West Bloomfield"),
  "48323": p("MI", "West Bloomfield"),
  "48324": p("MI", "West Bloomfield"),
  "48325": p("MI", "West Bloomfield"),
  "48326": p("MI", "Auburn Hills"),
  "48327": p("MI", "Waterford"),
  "48328": p("MI", "Waterford"),
  "48329": p("MI", "Waterford"),
  "48330": p("MI", "Drayton Plains"),
  "48331": p("MI", "Farmington"),
  "48332": p("MI", "Farmington"),
  "48333": p("MI", "Farmington"),
  "48334": p("MI", "Farmington"),
  "48335": p("MI", "Farmington"),
  "48336": p("MI", "Farmington"),
  "48340": p("MI", "Pontiac"),
  "48341": p("MI", "Pontiac"),
  "48342": p("MI", "Pontiac"),
  "48343": p("MI", "Pontiac"),
  "48346": p("MI", "Clarkston"),
  "48347": p("MI", "Clarkston"),
  "48348": p("MI", "Clarkston"),
  "48350": p("MI", "Davisburg"),
  "48356": p("MI", "Highland"),
  "48357": p("MI", "Highland"),
  "48359": p("MI", "Lake Orion"),
  "48360": p("MI", "Lake Orion"),
  "48361": p("MI", "Lake Orion"),
  "48362": p("MI", "Lake Orion"),
  "48363": p("MI", "Oakland"),
  "48366": p("MI", "Lakeville"),
  "48367": p("MI", "Leonard"),
  "48370": p("MI", "Oxford"),
  "48371": p("MI", "Oxford"),
  "48374": p("MI", "Novi"),
  "48375": p("MI", "Novi"),
  "48376": p("MI", "Novi"),
  "48377": p("MI", "Novi"),
  "48380": p("MI", "Milford"),
  "48381": p("MI", "Milford"),
  "48382": p("MI", "Commerce Township"),
  "48383": p("MI", "White Lake"),
  "48386": p("MI", "White Lake"),
  "48387": p("MI", "Union Lake"),
  "48390": p("MI", "Walled Lake"),
  "48391": p("MI", "Walled Lake"),
  "48393": p("MI", "Wixom"),
  "48442": p("MI", "Holly"),
  "48462": p("MI", "Ortonville"),
  "49420": p("MI", "Hart"),
  "49421": p("MI", "Hesperia"),
  "49436": p("MI", "Mears"),
  "49446": p("MI", "New Era"),
  "49449": p("MI", "Pentwater"),
  "49452": p("MI", "Rothbury"),
  "49455": p("MI", "Shelby"),
  "49459": p("MI", "Walkerville"),
  "48610": p("MI", "Alger"),
  "48635": p("MI", "Lupton"),
  "48654": p("MI", "Rose City"),
  "48661": p("MI", "West Branch"),
  "48756": p("MI", "Prescott"),
  "48761": p("MI", "South Branch"),
  "49910": p("MI", "Bergland"),
  "49912": p("MI", "Bruce Crossing"),
  "49925": p("MI", "Ewen"),
  "49929": p("MI", "Greenland"),
  "49948": p("MI", "Mass City"),
  "49953": p("MI", "Ontonagon"),
  "49960": p("MI", "Rockland"),
  "49967": p("MI", "Trout Creek"),
  "49971": p("MI", "White Pine"),
  "49631": p("MI", "Evart"),
  "49639": p("MI", "Hersey"),
  "49655": p("MI", "Leroy"),
  "49665": p("MI", "Marion"),
  "49677": p("MI", "Reed City"),
  "49679": p("MI", "Sears"),
  "49688": p("MI", "Tustin"),
  "48619": p("MI", "Comins"),
  "48621": p("MI", "Fairview"),
  "48636": p("MI", "Luzerne"),
  "48647": p("MI", "Mio"),
  "49730": p("MI", "Elmira"),
  "49734": p("MI", "Gaylord"),
  "49735": p("MI", "Gaylord"),
  "49751": p("MI", "Johannesburg"),
  "49795": p("MI", "Vanderbilt"),
  "49797": p("MI", "Waters"),
  "49401": p("MI", "Allendale"),
  "49403": p("MI", "Conklin"),
  "49404": p("MI", "Coopersville"),
  "49409": p("MI", "Ferrysburg"),
  "49417": p("MI", "Grand Haven"),
  "49422": p("MI", "Holland"),
  "49423": p("MI", "Holland"),
  "49424": p("MI", "Holland"),
  "49426": p("MI", "Hudsonville"),
  "49427": p("MI", "Jamestown"),
  "49428": p("MI", "Jenison"),
  "49429": p("MI", "Jenison"),
  "49430": p("MI", "Lamont"),
  "49434": p("MI", "Macatawa"),
  "49435": p("MI", "Marne"),
  "49448": p("MI", "Nunica"),
  "49456": p("MI", "Spring Lake"),
  "49460": p("MI", "West Olive"),
  "49464": p("MI", "Zeeland"),
  "49534": p("MI", "Grand Rapids"),
  "49743": p("MI", "Hawks"),
  "49759": p("MI", "Millersburg"),
  "49765": p("MI", "Onaway"),
  "49776": p("MI", "Posen"),
  "49777": p("MI", "Presque Isle"),
  "49779": p("MI", "Rogers City"),
  "48627": p("MI", "Higgins Lake"),
  "48629": p("MI", "Houghton Lake"),
  "48630": p("MI", "Houghton Lake Heights"),
  "48651": p("MI", "Prudenville"),
  "48653": p("MI", "Roscommon"),
  "48656": p("MI", "Saint Helen"),
  "48415": p("MI", "Birch Run"),
  "48417": p("MI", "Burt"),
  "48601": p("MI", "Saginaw"),
  "48602": p("MI", "Saginaw"),
  "48603": p("MI", "Saginaw"),
  "48604": p("MI", "Saginaw"),
  "48605": p("MI", "Saginaw"),
  "48606": p("MI", "Saginaw"),
  "48607": p("MI", "Saginaw"),
  "48608": p("MI", "Saginaw"),
  "48609": p("MI", "Saginaw"),
  "48614": p("MI", "Brant"),
  "48616": p("MI", "Chesaning"),
  "48623": p("MI", "Freeland"),
  "48626": p("MI", "Hemlock"),
  "48637": p("MI", "Merrill"),
  "48649": p("MI", "Oakley"),
  "48655": p("MI", "Saint Charles"),
  "48663": p("MI", "Saginaw"),
  "48722": p("MI", "Bridgeport"),
  "48724": p("MI", "Carrollton"),
  "48734": p("MI", "Frankenmuth"),
  "48787": p("MI", "Frankenmuth"),
  "48001": p("MI", "Algonac"),
  "48002": p("MI", "Allenton"),
  "48004": p("MI", "Anchorville"),
  "48006": p("MI", "Avoca"),
  "48014": p("MI", "Capac"),
  "48022": p("MI", "Emmett"),
  "48023": p("MI", "Fair Haven"),
  "48027": p("MI", "Goodells"),
  "48028": p("MI", "Harsens Island"),
  "48032": p("MI", "Jeddo"),
  "48039": p("MI", "Marine City"),
  "48040": p("MI", "Marysville"),
  "48041": p("MI", "Memphis"),
  "48049": p("MI", "North Street"),
  "48054": p("MI", "East China"),
  "48059": p("MI", "Fort Gratiot"),
  "48060": p("MI", "Port Huron"),
  "48061": p("MI", "Port Huron"),
  "48063": p("MI", "Columbus"),
  "48064": p("MI", "Casco"),
  "48074": p("MI", "Smiths Creek"),
  "48079": p("MI", "Saint Clair"),
  "48097": p("MI", "Yale"),
  "49030": p("MI", "Burr Oak"),
  "49032": p("MI", "Centreville"),
  "49040": p("MI", "Colon"),
  "49042": p("MI", "Constantine"),
  "49066": p("MI", "Leonidas"),
  "49072": p("MI", "Mendon"),
  "49075": p("MI", "Nottawa"),
  "49091": p("MI", "Sturgis"),
  "49093": p("MI", "Three Rivers"),
  "49099": p("MI", "White Pigeon"),
  "48401": p("MI", "Applegate"),
  "48410": p("MI", "Argyle"),
  "48416": p("MI", "Brown City"),
  "48419": p("MI", "Carsonville"),
  "48422": p("MI", "Croswell"),
  "48426": p("MI", "Decker"),
  "48427": p("MI", "Deckerville"),
  "48434": p("MI", "Forestville"),
  "48450": p("MI", "Lexington"),
  "48453": p("MI", "Marlette"),
  "48454": p("MI", "Melvin"),
  "48456": p("MI", "Minden City"),
  "48465": p("MI", "Palms"),
  "48466": p("MI", "Peck"),
  "48469": p("MI", "Port Sanilac"),
  "48471": p("MI", "Sandusky"),
  "48472": p("MI", "Snover"),
  "49817": p("MI", "Cooks"),
  "49836": p("MI", "Germfask"),
  "49840": p("MI", "Gulliver"),
  "49854": p("MI", "Manistique"),
  "49883": p("MI", "Seney"),
  "48414": p("MI", "Bancroft"),
  "48418": p("MI", "Byron"),
  "48429": p("MI", "Durand"),
  "48460": p("MI", "New Lothrop"),
  "48476": p("MI", "Vernon"),
  "48817": p("MI", "Corunna"),
  "48841": p("MI", "Henderson"),
  "48848": p("MI", "Laingsburg"),
  "48857": p("MI", "Morrice"),
  "48867": p("MI", "Owosso"),
  "48872": p("MI", "Perry"),
  "48882": p("MI", "Shaftsburg"),
  "48435": p("MI", "Fostoria"),
  "48701": p("MI", "Akron"),
  "48723": p("MI", "Caro"),
  "48726": p("MI", "Cass City"),
  "48729": p("MI", "Deford"),
  "48733": p("MI", "Fairgrove"),
  "48735": p("MI", "Gagetown"),
  "48741": p("MI", "Kingston"),
  "48744": p("MI", "Mayville"),
  "48746": p("MI", "Millington"),
  "48757": p("MI", "Reese"),
  "48758": p("MI", "Richville"),
  "48767": p("MI", "Unionville"),
  "48768": p("MI", "Vassar"),
  "49013": p("MI", "Bangor"),
  "49026": p("MI", "Bloomingdale"),
  "49027": p("MI", "Breedsville"),
  "49043": p("MI", "Covert"),
  "49045": p("MI", "Decatur"),
  "49055": p("MI", "Gobles"),
  "49056": p("MI", "Grand Junction"),
  "49057": p("MI", "Hartford"),
  "49062": p("MI", "Kendall"),
  "49063": p("MI", "Lacota"),
  "49064": p("MI", "Lawrence"),
  "49065": p("MI", "Lawton"),
  "49071": p("MI", "Mattawan"),
  "49079": p("MI", "Paw Paw"),
  "49090": p("MI", "South Haven"),
  "48103": p("MI", "Ann Arbor"),
  "48104": p("MI", "Ann Arbor"),
  "48105": p("MI", "Ann Arbor"),
  "48106": p("MI", "Ann Arbor"),
  "48107": p("MI", "Ann Arbor"),
  "48108": p("MI", "Ann Arbor"),
  "48109": p("MI", "Ann Arbor"),
  "48113": p("MI", "Ann Arbor"),
  "48115": p("MI", "Bridgewater"),
  "48118": p("MI", "Chelsea"),
  "48130": p("MI", "Dexter"),
  "48158": p("MI", "Manchester"),
  "48175": p("MI", "Salem"),
  "48176": p("MI", "Saline"),
  "48189": p("MI", "Whitmore Lake"),
  "48190": p("MI", "Whittaker"),
  "48191": p("MI", "Willis"),
  "48197": p("MI", "Ypsilanti"),
  "48198": p("MI", "Ypsilanti"),
  "48101": p("MI", "Allen Park"),
  "48111": p("MI", "Belleville"),
  "48112": p("MI", "Belleville"),
  "48120": p("MI", "Dearborn"),
  "48121": p("MI", "Dearborn"),
  "48122": p("MI", "Melvindale"),
  "48123": p("MI", "Dearborn"),
  "48124": p("MI", "Dearborn"),
  "48125": p("MI", "Dearborn Heights"),
  "48126": p("MI", "Dearborn"),
  "48127": p("MI", "Dearborn Heights"),
  "48128": p("MI", "Dearborn"),
  "48134": p("MI", "Flat Rock"),
  "48135": p("MI", "Garden City"),
  "48136": p("MI", "Garden City"),
  "48138": p("MI", "Grosse Ile"),
  "48141": p("MI", "Inkster"),
  "48146": p("MI", "Lincoln Park"),
  "48150": p("MI", "Livonia"),
  "48151": p("MI", "Livonia"),
  "48152": p("MI", "Livonia"),
  "48153": p("MI", "Livonia"),
  "48154": p("MI", "Livonia"),
  "48164": p("MI", "New Boston"),
  "48167": p("MI", "Northville"),
  "48168": p("MI", "Northville"),
  "48170": p("MI", "Plymouth"),
  "48173": p("MI", "Rockwood"),
  "48174": p("MI", "Romulus"),
  "48180": p("MI", "Taylor"),
  "48183": p("MI", "Trenton"),
  "48184": p("MI", "Wayne"),
  "48185": p("MI", "Westland"),
  "48186": p("MI", "Westland"),
  "48187": p("MI", "Canton"),
  "48188": p("MI", "Canton"),
  "48192": p("MI", "Wyandotte"),
  "48193": p("MI", "Riverview"),
  "48195": p("MI", "Southgate"),
  "48201": p("MI", "Detroit"),
  "48202": p("MI", "Detroit"),
  "48203": p("MI", "Highland Park"),
  "48204": p("MI", "Detroit"),
  "48205": p("MI", "Detroit"),
  "48206": p("MI", "Detroit"),
  "48207": p("MI", "Detroit"),
  "48208": p("MI", "Detroit"),
  "48209": p("MI", "Detroit"),
  "48210": p("MI", "Detroit"),
  "48211": p("MI", "Detroit"),
  "48212": p("MI", "Hamtramck"),
  "48213": p("MI", "Detroit"),
  "48214": p("MI", "Detroit"),
  "48215": p("MI", "Detroit"),
  "48216": p("MI", "Detroit"),
  "48217": p("MI", "Detroit"),
  "48218": p("MI", "River Rouge"),
  "48219": p("MI", "Detroit"),
  "48221": p("MI", "Detroit"),
  "48222": p("MI", "Detroit"),
  "48223": p("MI", "Detroit"),
  "48224": p("MI", "Detroit"),
  "48225": p("MI", "Harper Woods"),
  "48226": p("MI", "Detroit"),
  "48227": p("MI", "Detroit"),
  "48228": p("MI", "Detroit"),
  "48229": p("MI", "Ecorse"),
  "48230": p("MI", "Grosse Pointe"),
  "48231": p("MI", "Detroit"),
  "48232": p("MI", "Detroit"),
  "48233": p("MI", "Detroit"),
  "48234": p("MI", "Detroit"),
  "48235": p("MI", "Detroit"),
  "48236": p("MI", "Grosse Pointe"),
  "48238": p("MI", "Detroit"),
  "48239": p("MI", "Redford"),
  "48240": p("MI", "Redford"),
  "48242": p("MI", "Detroit"),
  "48243": p("MI", "Detroit"),
  "48244": p("MI", "Detroit"),
  "48255": p("MI", "Detroit"),
  "48260": p("MI", "Detroit"),
  "48264": p("MI", "Detroit"),
  "48265": p("MI", "Detroit"),
  "48266": p("MI", "Detroit"),
  "48267": p("MI", "Detroit"),
  "48268": p("MI", "Detroit"),
  "48269": p("MI", "Detroit"),
  "48272": p("MI", "Detroit"),
  "48275": p("MI", "Detroit"),
  "48277": p("MI", "Detroit"),
  "48278": p("MI", "Detroit"),
  "48279": p("MI", "Detroit"),
  "48288": p("MI", "Detroit"),
  "49601": p("MI", "Cadillac"),
  "49618": p("MI", "Boon"),
  "49620": p("MI", "Buckley"),
  "49638": p("MI", "Harrietta"),
  "49663": p("MI", "Manton"),
  "49668": p("MI", "Mesick"),
  "55748": p("MN", "Hill City"),
  "55752": p("MN", "Jacobson"),
  "55760": p("MN", "Mcgregor"),
  "55785": p("MN", "Swatara"),
  "55787": p("MN", "Tamarack"),
  "56350": p("MN", "Mc Grath"),
  "56431": p("MN", "Aitkin"),
  "56469": p("MN", "Palisade"),
  "55005": p("MN", "Bethel"),
  "55011": p("MN", "Cedar"),
  "55014": p("MN", "Circle Pines"),
  "55070": p("MN", "Saint Francis"),
  "55303": p("MN", "Anoka"),
  "55304": p("MN", "Andover"),
  "55421": p("MN", "Minneapolis"),
  "55432": p("MN", "Minneapolis"),
  "55433": p("MN", "Minneapolis"),
  "55434": p("MN", "Minneapolis"),
  "55448": p("MN", "Minneapolis"),
  "55449": p("MN", "Minneapolis"),
  "56501": p("MN", "Detroit Lakes"),
  "56502": p("MN", "Detroit Lakes"),
  "56511": p("MN", "Audubon"),
  "56521": p("MN", "Callaway"),
  "56544": p("MN", "Frazee"),
  "56554": p("MN", "Lake Park"),
  "56569": p("MN", "Ogema"),
  "56570": p("MN", "Osage"),
  "56575": p("MN", "Ponsford"),
  "56577": p("MN", "Richwood"),
  "56578": p("MN", "Rochert"),
  "56591": p("MN", "White Earth"),
  "56593": p("MN", "Wolf Lake"),
  "56601": p("MN", "Bemidji"),
  "56619": p("MN", "Bemidji"),
  "56630": p("MN", "Blackduck"),
  "56647": p("MN", "Hines"),
  "56650": p("MN", "Kelliher"),
  "56663": p("MN", "Pennington"),
  "56666": p("MN", "Ponemah"),
  "56667": p("MN", "Puposky"),
  "56670": p("MN", "Redby"),
  "56671": p("MN", "Redlake"),
  "56678": p("MN", "Solway"),
  "56683": p("MN", "Tenstrike"),
  "56685": p("MN", "Waskish"),
  "56687": p("MN", "Wilton"),
  "56329": p("MN", "Foley"),
  "56333": p("MN", "Gilman"),
  "56357": p("MN", "Oak Park"),
  "56367": p("MN", "Rice"),
  "56379": p("MN", "Sauk Rapids"),
  "56210": p("MN", "Barry"),
  "56211": p("MN", "Beardsley"),
  "56225": p("MN", "Clinton"),
  "56227": p("MN", "Correll"),
  "56240": p("MN", "Graceville"),
  "56276": p("MN", "Odessa"),
  "56278": p("MN", "Ortonville"),
  "56001": p("MN", "Mankato"),
  "56002": p("MN", "Mankato"),
  "56010": p("MN", "Amboy"),
  "56024": p("MN", "Eagle Lake"),
  "56034": p("MN", "Garden City"),
  "56037": p("MN", "Good Thunder"),
  "56055": p("MN", "Lake Crystal"),
  "56063": p("MN", "Madison Lake"),
  "56065": p("MN", "Mapleton"),
  "56078": p("MN", "Pemberton"),
  "56080": p("MN", "Saint Clair"),
  "56090": p("MN", "Vernon Center"),
  "56019": p("MN", "Comfrey"),
  "56030": p("MN", "Essig"),
  "56041": p("MN", "Hanska"),
  "56073": p("MN", "New Ulm"),
  "56084": p("MN", "Searles"),
  "56085": p("MN", "Sleepy Eye"),
  "56087": p("MN", "Springfield"),
  "55707": p("MN", "Barnum"),
  "55718": p("MN", "Carlton"),
  "55720": p("MN", "Cloquet"),
  "55726": p("MN", "Cromwell"),
  "55733": p("MN", "Esko"),
  "55749": p("MN", "Holyoke"),
  "55757": p("MN", "Kettle River"),
  "55767": p("MN", "Moose Lake"),
  "55780": p("MN", "Sawyer"),
  "55797": p("MN", "Wrenshall"),
  "55798": p("MN", "Wright"),
  "55315": p("MN", "Carver"),
  "55317": p("MN", "Chanhassen"),
  "55318": p("MN", "Chaska"),
  "55322": p("MN", "Cologne"),
  "55339": p("MN", "Hamburg"),
  "55360": p("MN", "Mayer"),
  "55367": p("MN", "New Germany"),
  "55368": p("MN", "Norwood Young America"),
  "55383": p("MN", "Norwood"),
  "55386": p("MN", "Victoria"),
  "55387": p("MN", "Waconia"),
  "55388": p("MN", "Watertown"),
  "55397": p("MN", "Young America"),
  "55473": p("MN", "Minneapolis"),
  "55550": p("MN", "Young America"),
  "55551": p("MN", "Young America"),
  "55553": p("MN", "Young America"),
  "55554": p("MN", "Norwood"),
  "55558": p("MN", "Young America"),
  "55568": p("MN", "Young America"),
  "55583": p("MN", "Norwood"),
  "55594": p("MN", "Young America"),
  "56430": p("MN", "Ah Gwah Ching"),
  "56435": p("MN", "Backus"),
  "56452": p("MN", "Hackensack"),
  "56473": p("MN", "Pillager"),
  "56474": p("MN", "Pine River"),
  "56484": p("MN", "Walker"),
  "56626": p("MN", "Bena"),
  "56633": p("MN", "Cass Lake"),
  "56641": p("MN", "Federal Dam"),
  "56655": p("MN", "Longville"),
  "56662": p("MN", "Outing"),
  "56672": p("MN", "Remer"),
  "56222": p("MN", "Clara City"),
  "56260": p("MN", "Maynard"),
  "56262": p("MN", "Milan"),
  "56265": p("MN", "Montevideo"),
  "56295": p("MN", "Watson"),
  "55002": p("MN", "Almelund"),
  "55012": p("MN", "Center City"),
  "55013": p("MN", "Chisago City"),
  "55032": p("MN", "Harris"),
  "55045": p("MN", "Lindstrom"),
  "55056": p("MN", "North Branch"),
  "55069": p("MN", "Rush City"),
  "55074": p("MN", "Shafer"),
  "55078": p("MN", "Stacy"),
  "55079": p("MN", "Stacy"),
  "55084": p("MN", "Taylors Falls"),
  "55092": p("MN", "Wyoming"),
  "56514": p("MN", "Barnesville"),
  "56525": p("MN", "Comstock"),
  "56529": p("MN", "Dilworth"),
  "56536": p("MN", "Felton"),
  "56546": p("MN", "Georgetown"),
  "56547": p("MN", "Glyndon"),
  "56549": p("MN", "Hawley"),
  "56552": p("MN", "Hitterdal"),
  "56560": p("MN", "Moorhead"),
  "56561": p("MN", "Moorhead"),
  "56562": p("MN", "Moorhead"),
  "56563": p("MN", "Moorhead"),
  "56580": p("MN", "Sabin"),
  "56585": p("MN", "Ulen"),
  "56621": p("MN", "Bagley"),
  "56634": p("MN", "Clearbrook"),
  "56644": p("MN", "Gonvick"),
  "56652": p("MN", "Leonard"),
  "56676": p("MN", "Shevlin"),
  "55604": p("MN", "Grand Marais"),
  "55605": p("MN", "Grand Portage"),
  "55606": p("MN", "Hovland"),
  "55612": p("MN", "Lutsen"),
  "55613": p("MN", "Schroeder"),
  "55615": p("MN", "Tofte"),
  "56101": p("MN", "Windom"),
  "56118": p("MN", "Bingham Lake"),
  "56145": p("MN", "Jeffers"),
  "56159": p("MN", "Mountain Lake"),
  "56174": p("MN", "Storden"),
  "56183": p("MN", "Westbrook"),
  "56401": p("MN", "Brainerd"),
  "56425": p("MN", "Baxter"),
  "56441": p("MN", "Crosby"),
  "56442": p("MN", "Crosslake"),
  "56444": p("MN", "Deerwood"),
  "56447": p("MN", "Emily"),
  "56448": p("MN", "Fifty Lakes"),
  "56449": p("MN", "Fort Ripley"),
  "56450": p("MN", "Garrison"),
  "56455": p("MN", "Ironton"),
  "56456": p("MN", "Jenkins"),
  "56459": p("MN", "Lake Hubert"),
  "56465": p("MN", "Merrifield"),
  "56468": p("MN", "Nisswa"),
  "56472": p("MN", "Pequot Lakes"),
  "55010": p("MN", "Castle Rock"),
  "55024": p("MN", "Farmington"),
  "55031": p("MN", "Hampton"),
  "55033": p("MN", "Hastings"),
  "55044": p("MN", "Lakeville"),
  "55065": p("MN", "Randolph"),
  "55068": p("MN", "Rosemount"),
  "55075": p("MN", "South Saint Paul"),
  "55076": p("MN", "Inver Grove Heights"),
  "55077": p("MN", "Inver Grove Heights"),
  "55085": p("MN", "Vermillion"),
  "55118": p("MN", "Saint Paul"),
  "55120": p("MN", "Saint Paul"),
  "55121": p("MN", "Saint Paul"),
  "55122": p("MN", "Saint Paul"),
  "55123": p("MN", "Saint Paul"),
  "55124": p("MN", "Saint Paul"),
  "55150": p("MN", "Mendota"),
  "55306": p("MN", "Burnsville"),
  "55337": p("MN", "Burnsville"),
  "55924": p("MN", "Claremont"),
  "55927": p("MN", "Dodge Center"),
  "55940": p("MN", "Hayfield"),
  "55944": p("MN", "Kasson"),
  "55955": p("MN", "Mantorville"),
  "55985": p("MN", "West Concord"),
  "56308": p("MN", "Alexandria"),
  "56315": p("MN", "Brandon"),
  "56319": p("MN", "Carlos"),
  "56326": p("MN", "Evansville"),
  "56332": p("MN", "Garfield"),
  "56341": p("MN", "Holmes City"),
  "56343": p("MN", "Kensington"),
  "56354": p("MN", "Miltona"),
  "56355": p("MN", "Nelson"),
  "56360": p("MN", "Osakis"),
  "56013": p("MN", "Blue Earth"),
  "56014": p("MN", "Bricelyn"),
  "56023": p("MN", "Delavan"),
  "56025": p("MN", "Easton"),
  "56027": p("MN", "Elmore"),
  "56033": p("MN", "Frost"),
  "56047": p("MN", "Huntley"),
  "56051": p("MN", "Kiester"),
  "56068": p("MN", "Minnesota Lake"),
  "56097": p("MN", "Wells"),
  "56098": p("MN", "Winnebago"),
  "55922": p("MN", "Canton"),
  "55923": p("MN", "Chatfield"),
  "55935": p("MN", "Fountain"),
  "55939": p("MN", "Harmony"),
  "55949": p("MN", "Lanesboro"),
  "55954": p("MN", "Mabel"),
  "55961": p("MN", "Ostrander"),
  "55962": p("MN", "Peterson"),
  "55965": p("MN", "Preston"),
  "55971": p("MN", "Rushford"),
  "55975": p("MN", "Spring Valley"),
  "55990": p("MN", "Wykoff"),
  "56007": p("MN", "Albert Lea"),
  "56009": p("MN", "Alden"),
  "56016": p("MN", "Clarks Grove"),
  "56020": p("MN", "Conger"),
  "56029": p("MN", "Emmons"),
  "56032": p("MN", "Freeborn"),
  "56035": p("MN", "Geneva"),
  "56036": p("MN", "Glenville"),
  "56042": p("MN", "Hartland"),
  "56043": p("MN", "Hayward"),
  "56045": p("MN", "Hollandale"),
  "56089": p("MN", "Twin Lakes"),
  "55009": p("MN", "Cannon Falls"),
  "55018": p("MN", "Dennison"),
  "55026": p("MN", "Frontenac"),
  "55027": p("MN", "Goodhue"),
  "55066": p("MN", "Red Wing"),
  "55089": p("MN", "Welch"),
  "55946": p("MN", "Kenyon"),
  "55963": p("MN", "Pine Island"),
  "55983": p("MN", "Wanamingo"),
  "55992": p("MN", "Zumbrota"),
  "56248": p("MN", "Herman"),
  "56274": p("MN", "Norcross"),
  "56309": p("MN", "Ashby"),
  "56311": p("MN", "Barrett"),
  "56339": p("MN", "Hoffman"),
  "56531": p("MN", "Elbow Lake"),
  "56590": p("MN", "Wendell"),
  "55111": p("MN", "Saint Paul"),
  "55305": p("MN", "Hopkins"),
  "55311": p("MN", "Maple Grove"),
  "55316": p("MN", "Champlin"),
  "55323": p("MN", "Crystal Bay"),
  "55327": p("MN", "Dayton"),
  "55331": p("MN", "Excelsior"),
  "55340": p("MN", "Hamel"),
  "55343": p("MN", "Hopkins"),
  "55344": p("MN", "Eden Prairie"),
  "55345": p("MN", "Minnetonka"),
  "55346": p("MN", "Eden Prairie"),
  "55347": p("MN", "Eden Prairie"),
  "55348": p("MN", "Maple Plain"),
  "55356": p("MN", "Long Lake"),
  "55357": p("MN", "Loretto"),
  "55359": p("MN", "Maple Plain"),
  "55361": p("MN", "Minnetonka Beach"),
  "55364": p("MN", "Mound"),
  "55369": p("MN", "Osseo"),
  "55374": p("MN", "Rogers"),
  "55375": p("MN", "Saint Bonifacius"),
  "55384": p("MN", "Spring Park"),
  "55391": p("MN", "Wayzata"),
  "55392": p("MN", "Navarre"),
  "55401": p("MN", "Minneapolis"),
  "55402": p("MN", "Minneapolis"),
  "55403": p("MN", "Minneapolis"),
  "55404": p("MN", "Minneapolis"),
  "55405": p("MN", "Minneapolis"),
  "55406": p("MN", "Minneapolis"),
  "55407": p("MN", "Minneapolis"),
  "55408": p("MN", "Minneapolis"),
  "55409": p("MN", "Minneapolis"),
  "55410": p("MN", "Minneapolis"),
  "55411": p("MN", "Minneapolis"),
  "55412": p("MN", "Minneapolis"),
  "55413": p("MN", "Minneapolis"),
  "55414": p("MN", "Minneapolis"),
  "55415": p("MN", "Minneapolis"),
  "55416": p("MN", "Minneapolis"),
  "55417": p("MN", "Minneapolis"),
  "55418": p("MN", "Minneapolis"),
  "55419": p("MN", "Minneapolis"),
  "55420": p("MN", "Minneapolis"),
  "55422": p("MN", "Minneapolis"),
  "55423": p("MN", "Minneapolis"),
  "55424": p("MN", "Minneapolis"),
  "55425": p("MN", "Minneapolis"),
  "55426": p("MN", "Minneapolis"),
  "55427": p("MN", "Minneapolis"),
  "55428": p("MN", "Minneapolis"),
  "55429": p("MN", "Minneapolis"),
  "55430": p("MN", "Minneapolis"),
  "55431": p("MN", "Minneapolis"),
  "55435": p("MN", "Minneapolis"),
  "55436": p("MN", "Minneapolis"),
  "55437": p("MN", "Minneapolis"),
  "55438": p("MN", "Minneapolis"),
  "55439": p("MN", "Minneapolis"),
  "55440": p("MN", "Minneapolis"),
  "55441": p("MN", "Minneapolis"),
  "55442": p("MN", "Minneapolis"),
  "55443": p("MN", "Minneapolis"),
  "55444": p("MN", "Minneapolis"),
  "55445": p("MN", "Minneapolis"),
  "55446": p("MN", "Minneapolis"),
  "55447": p("MN", "Minneapolis"),
  "55450": p("MN", "Minneapolis"),
  "55454": p("MN", "Minneapolis"),
  "55455": p("MN", "Minneapolis"),
  "55458": p("MN", "Minneapolis"),
  "55459": p("MN", "Minneapolis"),
  "55460": p("MN", "Minneapolis"),
  "55467": p("MN", "Minneapolis"),
  "55470": p("MN", "Minneapolis"),
  "55472": p("MN", "Minneapolis"),
  "55474": p("MN", "Minneapolis"),
  "55478": p("MN", "Minneapolis"),
  "55479": p("MN", "Minneapolis"),
  "55480": p("MN", "Minneapolis"),
  "55483": p("MN", "Minneapolis"),
  "55484": p("MN", "Minneapolis"),
  "55485": p("MN", "Minneapolis"),
  "55486": p("MN", "Minneapolis"),
  "55487": p("MN", "Minneapolis"),
  "55488": p("MN", "Minneapolis"),
  "55569": p("MN", "Osseo"),
  "55570": p("MN", "Maple Plain"),
  "55571": p("MN", "Maple Plain"),
  "55572": p("MN", "Rockford"),
  "55573": p("MN", "Young America"),
  "55574": p("MN", "Maple Plain"),
  "55575": p("MN", "Howard Lake"),
  "55576": p("MN", "Maple Plain"),
  "55577": p("MN", "Maple Plain"),
  "55578": p("MN", "Maple Plain"),
  "55579": p("MN", "Maple Plain"),
  "55593": p("MN", "Maple Plain"),
  "55595": p("MN", "Loretto"),
  "55596": p("MN", "Loretto"),
  "55597": p("MN", "Loretto"),
  "55598": p("MN", "Loretto"),
  "55599": p("MN", "Loretto"),
  "55919": p("MN", "Brownsville"),
  "55921": p("MN", "Caledonia"),
  "55931": p("MN", "Eitzen"),
  "55941": p("MN", "Hokah"),
  "55943": p("MN", "Houston"),
  "55947": p("MN", "La Crescent"),
  "55974": p("MN", "Spring Grove"),
  "56433": p("MN", "Akeley"),
  "56436": p("MN", "Benedict"),
  "56458": p("MN", "Lake George"),
  "56461": p("MN", "Laporte"),
  "56467": p("MN", "Nevis"),
  "56470": p("MN", "Park Rapids"),
  "55006": p("MN", "Braham"),
  "55008": p("MN", "Cambridge"),
  "55017": p("MN", "Dalbo"),
  "55029": p("MN", "Grandy"),
  "55040": p("MN", "Isanti"),
  "55080": p("MN", "Stanchfield"),
  "55709": p("MN", "Bovey"),
  "55716": p("MN", "Calumet"),
  "55721": p("MN", "Cohasset"),
  "55722": p("MN", "Coleraine"),
  "55730": p("MN", "Grand Rapids"),
  "55742": p("MN", "Goodland"),
  "55744": p("MN", "Grand Rapids"),
  "55745": p("MN", "Grand Rapids"),
  "55753": p("MN", "Keewatin"),
  "55764": p("MN", "Marble"),
  "55769": p("MN", "Nashwauk"),
  "55775": p("MN", "Pengilly"),
  "55784": p("MN", "Swan River"),
  "55786": p("MN", "Taconite"),
  "55793": p("MN", "Warba"),
  "56628": p("MN", "Bigfork"),
  "56631": p("MN", "Bowstring"),
  "56636": p("MN", "Deer River"),
  "56637": p("MN", "Talmoon"),
  "56639": p("MN", "Effie"),
  "56657": p("MN", "Marcell"),
  "56659": p("MN", "Max"),
  "56680": p("MN", "Spring Lake"),
  "56681": p("MN", "Squaw Lake"),
  "56688": p("MN", "Wirt"),
  "56111": p("MN", "Alpha"),
  "56137": p("MN", "Heron Lake"),
  "56143": p("MN", "Jackson"),
  "56150": p("MN", "Lakefield"),
  "56161": p("MN", "Okabena"),
  "55051": p("MN", "Mora"),
  "56358": p("MN", "Ogilvie"),
  "56201": p("MN", "Willmar"),
  "56209": p("MN", "Atwater"),
  "56216": p("MN", "Blomkest"),
  "56251": p("MN", "Kandiyohi"),
  "56253": p("MN", "Lake Lillian"),
  "56273": p("MN", "New London"),
  "56279": p("MN", "Pennock"),
  "56281": p("MN", "Prinsburg"),
  "56282": p("MN", "Raymond"),
  "56288": p("MN", "Spicer"),
  "56289": p("MN", "Sunburg"),
  "56720": p("MN", "Donaldson"),
  "56728": p("MN", "Hallock"),
  "56729": p("MN", "Halma"),
  "56731": p("MN", "Humboldt"),
  "56732": p("MN", "Karlstad"),
  "56733": p("MN", "Kennedy"),
  "56734": p("MN", "Lake Bronson"),
  "56735": p("MN", "Lancaster"),
  "56740": p("MN", "Noyes"),
  "56755": p("MN", "Saint Vincent"),
  "56627": p("MN", "Big Falls"),
  "56629": p("MN", "Birchdale"),
  "56649": p("MN", "International Falls"),
  "56653": p("MN", "Littlefork"),
  "56654": p("MN", "Loman"),
  "56658": p("MN", "Margie"),
  "56660": p("MN", "Mizpah"),
  "56661": p("MN", "Northome"),
  "56668": p("MN", "Ranier"),
  "56669": p("MN", "Kabetogama"),
  "56679": p("MN", "South International Falls"),
  "56212": p("MN", "Bellingham"),
  "56218": p("MN", "Boyd"),
  "56232": p("MN", "Dawson"),
  "56256": p("MN", "Madison"),
  "56257": p("MN", "Marietta"),
  "55601": p("MN", "Beaver Bay"),
  "55603": p("MN", "Finland"),
  "55607": p("MN", "Isabella"),
  "55609": p("MN", "Knife River"),
  "55614": p("MN", "Silver Bay"),
  "55616": p("MN", "Two Harbors"),
  "56623": p("MN", "Baudette"),
  "56686": p("MN", "Williams"),
  "56711": p("MN", "Angle Inlet"),
  "56741": p("MN", "Oak Island"),
  "56017": p("MN", "Cleveland"),
  "56028": p("MN", "Elysian"),
  "56050": p("MN", "Kasota"),
  "56052": p("MN", "Kilkenny"),
  "56057": p("MN", "Le Center"),
  "56058": p("MN", "Le Sueur"),
  "56069": p("MN", "Montgomery"),
  "56071": p("MN", "New Prague"),
  "56096": p("MN", "Waterville"),
  "56113": p("MN", "Arco"),
  "56136": p("MN", "Hendricks"),
  "56142": p("MN", "Ivanhoe"),
  "56149": p("MN", "Lake Benton"),
  "56178": p("MN", "Tyler"),
  "56115": p("MN", "Balaton"),
  "56132": p("MN", "Garvin"),
  "56157": p("MN", "Lynd"),
  "56169": p("MN", "Russell"),
  "56175": p("MN", "Tracy"),
  "56229": p("MN", "Cottonwood"),
  "56239": p("MN", "Ghent"),
  "56258": p("MN", "Marshall"),
  "56264": p("MN", "Minneota"),
  "56291": p("MN", "Taunton"),
  "55312": p("MN", "Brownton"),
  "55336": p("MN", "Glencoe"),
  "55350": p("MN", "Hutchinson"),
  "55354": p("MN", "Lester Prairie"),
  "55370": p("MN", "Plato"),
  "55381": p("MN", "Silver Lake"),
  "55385": p("MN", "Stewart"),
  "55395": p("MN", "Winsted"),
  "56516": p("MN", "Bejou"),
  "56557": p("MN", "Mahnomen"),
  "56566": p("MN", "Naytahwaush"),
  "56589": p("MN", "Waubun"),
  "56710": p("MN", "Alvarado"),
  "56713": p("MN", "Argyle"),
  "56724": p("MN", "Gatzke"),
  "56727": p("MN", "Grygla"),
  "56737": p("MN", "Middle River"),
  "56738": p("MN", "Newfolden"),
  "56744": p("MN", "Oslo"),
  "56757": p("MN", "Stephen"),
  "56758": p("MN", "Strandquist"),
  "56760": p("MN", "Viking"),
  "56762": p("MN", "Warren"),
  "56031": p("MN", "Fairmont"),
  "56039": p("MN", "Granada"),
  "56075": p("MN", "Northrop"),
  "56088": p("MN", "Truman"),
  "56121": p("MN", "Ceylon"),
  "56127": p("MN", "Dunnell"),
  "56162": p("MN", "Ormsby"),
  "56171": p("MN", "Sherburn"),
  "56176": p("MN", "Trimont"),
  "56181": p("MN", "Welcome"),
  "55324": p("MN", "Darwin"),
  "55325": p("MN", "Dassel"),
  "55329": p("MN", "Eden Valley"),
  "55355": p("MN", "Litchfield"),
  "55389": p("MN", "Watkins"),
  "56228": p("MN", "Cosmos"),
  "56243": p("MN", "Grove City"),
  "55371": p("MN", "Princeton"),
  "56313": p("MN", "Bock"),
  "56330": p("MN", "Foreston"),
  "56342": p("MN", "Isle"),
  "56353": p("MN", "Milaca"),
  "56359": p("MN", "Onamia"),
  "56363": p("MN", "Pease"),
  "56386": p("MN", "Wahkon"),
  "56314": p("MN", "Bowlus"),
  "56317": p("MN", "Buckman"),
  "56328": p("MN", "Flensburg"),
  "56338": p("MN", "Hillman"),
  "56344": p("MN", "Lastrup"),
  "56345": p("MN", "Little Falls"),
  "56364": p("MN", "Pierz"),
  "56373": p("MN", "Royalton"),
  "56382": p("MN", "Swanville"),
  "56384": p("MN", "Upsala"),
  "56388": p("MN", "Waite Park"),
  "56443": p("MN", "Cushing"),
  "56466": p("MN", "Motley"),
  "56475": p("MN", "Randall"),
  "55909": p("MN", "Adams"),
  "55912": p("MN", "Austin"),
  "55918": p("MN", "Brownsdale"),
  "55926": p("MN", "Dexter"),
  "55933": p("MN", "Elkton"),
  "55936": p("MN", "Grand Meadow"),
  "55950": p("MN", "Lansing"),
  "55951": p("MN", "Le Roy"),
  "55953": p("MN", "Lyle"),
  "55967": p("MN", "Racine"),
  "55970": p("MN", "Rose Creek"),
  "55973": p("MN", "Sargeant"),
  "55977": p("MN", "Taopi"),
  "55982": p("MN", "Waltham"),
  "56114": p("MN", "Avoca"),
  "56122": p("MN", "Chandler"),
  "56123": p("MN", "Currie"),
  "56125": p("MN", "Dovray"),
  "56131": p("MN", "Fulda"),
  "56141": p("MN", "Iona"),
  "56151": p("MN", "Lake Wilson"),
  "56172": p("MN", "Slayton"),
  "56003": p("MN", "Mankato"),
  "56021": p("MN", "Courtland"),
  "56054": p("MN", "Lafayette"),
  "56074": p("MN", "Nicollet"),
  "56082": p("MN", "Saint Peter"),
  "56110": p("MN", "Adrian"),
  "56117": p("MN", "Bigelow"),
  "56119": p("MN", "Brewster"),
  "56129": p("MN", "Ellsworth"),
  "56153": p("MN", "Leota"),
  "56155": p("MN", "Lismore"),
  "56165": p("MN", "Reading"),
  "56167": p("MN", "Round Lake"),
  "56168": p("MN", "Rushmore"),
  "56185": p("MN", "Wilmont"),
  "56187": p("MN", "Worthington"),
  "56510": p("MN", "Ada"),
  "56519": p("MN", "Borup"),
  "56541": p("MN", "Flom"),
  "56545": p("MN", "Gary"),
  "56548": p("MN", "Halstad"),
  "56550": p("MN", "Hendrum"),
  "56574": p("MN", "Perley"),
  "56581": p("MN", "Shelly"),
  "56584": p("MN", "Twin Valley"),
  "55901": p("MN", "Rochester"),
  "55902": p("MN", "Rochester"),
  "55903": p("MN", "Rochester"),
  "55904": p("MN", "Rochester"),
  "55905": p("MN", "Rochester"),
  "55906": p("MN", "Rochester"),
  "55920": p("MN", "Byron"),
  "55929": p("MN", "Dover"),
  "55934": p("MN", "Eyota"),
  "55960": p("MN", "Oronoco"),
  "55976": p("MN", "Stewartville"),
  "56324": p("MN", "Dalton"),
  "56361": p("MN", "Parkers Prairie"),
  "56515": p("MN", "Battle Lake"),
  "56518": p("MN", "Bluffton"),
  "56524": p("MN", "Clitherall"),
  "56527": p("MN", "Deer Creek"),
  "56528": p("MN", "Dent"),
  "56533": p("MN", "Elizabeth"),
  "56534": p("MN", "Erhard"),
  "56537": p("MN", "Fergus Falls"),
  "56538": p("MN", "Fergus Falls"),
  "56551": p("MN", "Henning"),
  "56567": p("MN", "New York Mills"),
  "56571": p("MN", "Ottertail"),
  "56572": p("MN", "Pelican Rapids"),
  "56573": p("MN", "Perham"),
  "56576": p("MN", "Richville"),
  "56586": p("MN", "Underwood"),
  "56587": p("MN", "Vergas"),
  "56588": p("MN", "Vining"),
  "56701": p("MN", "Thief River Falls"),
  "56725": p("MN", "Goodridge"),
  "56754": p("MN", "Saint Hilaire"),
  "55007": p("MN", "Brook Park"),
  "55030": p("MN", "Grasston"),
  "55036": p("MN", "Henriette"),
  "55037": p("MN", "Hinckley"),
  "55063": p("MN", "Pine City"),
  "55067": p("MN", "Rock Creek"),
  "55072": p("MN", "Sandstone"),
  "55704": p("MN", "Askov"),
  "55712": p("MN", "Bruno"),
  "55735": p("MN", "Finlayson"),
  "55756": p("MN", "Kerrick"),
  "55783": p("MN", "Sturgeon Lake"),
  "55795": p("MN", "Willow River"),
  "56128": p("MN", "Edgerton"),
  "56139": p("MN", "Holland"),
  "56140": p("MN", "Ihlen"),
  "56144": p("MN", "Jasper"),
  "56164": p("MN", "Pipestone"),
  "56170": p("MN", "Ruthton"),
  "56186": p("MN", "Woodstock"),
  "56517": p("MN", "Beltrami"),
  "56523": p("MN", "Climax"),
  "56535": p("MN", "Erskine"),
  "56540": p("MN", "Fertile"),
  "56542": p("MN", "Fosston"),
  "56556": p("MN", "Mcintosh"),
  "56568": p("MN", "Nielsville"),
  "56592": p("MN", "Winger"),
  "56646": p("MN", "Gully"),
  "56651": p("MN", "Lengby"),
  "56684": p("MN", "Trail"),
  "56716": p("MN", "Crookston"),
  "56721": p("MN", "East Grand Forks"),
  "56722": p("MN", "Euclid"),
  "56723": p("MN", "Fisher"),
  "56736": p("MN", "Mentor"),
  "56323": p("MN", "Cyrus"),
  "56327": p("MN", "Farwell"),
  "56334": p("MN", "Glenwood"),
  "56349": p("MN", "Lowry"),
  "56381": p("MN", "Starbuck"),
  "56385": p("MN", "Villard"),
  "55101": p("MN", "Saint Paul"),
  "55102": p("MN", "Saint Paul"),
  "55103": p("MN", "Saint Paul"),
  "55104": p("MN", "Saint Paul"),
  "55105": p("MN", "Saint Paul"),
  "55106": p("MN", "Saint Paul"),
  "55107": p("MN", "Saint Paul"),
  "55108": p("MN", "Saint Paul"),
  "55109": p("MN", "Saint Paul"),
  "55110": p("MN", "Saint Paul"),
  "55112": p("MN", "Saint Paul"),
  "55113": p("MN", "Saint Paul"),
  "55114": p("MN", "Saint Paul"),
  "55116": p("MN", "Saint Paul"),
  "55117": p("MN", "Saint Paul"),
  "55119": p("MN", "Saint Paul"),
  "55126": p("MN", "Saint Paul"),
  "55127": p("MN", "Saint Paul"),
  "55130": p("MN", "Saint Paul"),
  "55131": p("MN", "Saint Paul"),
  "55133": p("MN", "Saint Paul"),
  "55144": p("MN", "Saint Paul"),
  "55145": p("MN", "Saint Paul"),
  "55146": p("MN", "Saint Paul"),
  "55155": p("MN", "Saint Paul"),
  "55164": p("MN", "Saint Paul"),
  "55165": p("MN", "Saint Paul"),
  "55170": p("MN", "Saint Paul"),
  "55172": p("MN", "Saint Paul"),
  "55175": p("MN", "Saint Paul"),
  "55187": p("MN", "Saint Paul"),
  "55188": p("MN", "Saint Paul"),
  "56715": p("MN", "Brooks"),
  "56742": p("MN", "Oklee"),
  "56748": p("MN", "Plummer"),
  "56750": p("MN", "Red Lake Falls"),
  "56083": p("MN", "Sanborn"),
  "56152": p("MN", "Lamberton"),
  "56166": p("MN", "Revere"),
  "56180": p("MN", "Walnut Grove"),
  "56214": p("MN", "Belview"),
  "56224": p("MN", "Clements"),
  "56255": p("MN", "Lucan"),
  "56263": p("MN", "Milroy"),
  "56266": p("MN", "Morgan"),
  "56283": p("MN", "Redwood Falls"),
  "56287": p("MN", "Seaforth"),
  "56292": p("MN", "Vesta"),
  "56293": p("MN", "Wabasso"),
  "56294": p("MN", "Wanda"),
  "55310": p("MN", "Bird Island"),
  "55314": p("MN", "Buffalo Lake"),
  "55332": p("MN", "Fairfax"),
  "55333": p("MN", "Franklin"),
  "55342": p("MN", "Hector"),
  "56230": p("MN", "Danube"),
  "56270": p("MN", "Morton"),
  "56277": p("MN", "Olivia"),
  "56284": p("MN", "Renville"),
  "56285": p("MN", "Sacred Heart"),
  "55019": p("MN", "Dundas"),
  "55021": p("MN", "Faribault"),
  "55046": p("MN", "Lonsdale"),
  "55052": p("MN", "Morristown"),
  "55053": p("MN", "Nerstrand"),
  "55057": p("MN", "Northfield"),
  "55087": p("MN", "Warsaw"),
  "55088": p("MN", "Webster"),
  "56116": p("MN", "Beaver Creek"),
  "56134": p("MN", "Hardwick"),
  "56138": p("MN", "Hills"),
  "56146": p("MN", "Kanaranzi"),
  "56147": p("MN", "Kenneth"),
  "56156": p("MN", "Luverne"),
  "56158": p("MN", "Magnolia"),
  "56173": p("MN", "Steen"),
  "56673": p("MN", "Roosevelt"),
  "56682": p("MN", "Swift"),
  "56714": p("MN", "Badger"),
  "56726": p("MN", "Greenbush"),
  "56751": p("MN", "Roseau"),
  "56756": p("MN", "Salol"),
  "56759": p("MN", "Strathcona"),
  "56761": p("MN", "Wannaska"),
  "56763": p("MN", "Warroad"),
  "55602": p("MN", "Brimson"),
  "55702": p("MN", "Alborn"),
  "55703": p("MN", "Angora"),
  "55705": p("MN", "Aurora"),
  "55706": p("MN", "Babbitt"),
  "55708": p("MN", "Biwabik"),
  "55710": p("MN", "Britt"),
  "55711": p("MN", "Brookston"),
  "55713": p("MN", "Buhl"),
  "55717": p("MN", "Canyon"),
  "55719": p("MN", "Chisholm"),
  "55723": p("MN", "Cook"),
  "55724": p("MN", "Cotton"),
  "55725": p("MN", "Crane Lake"),
  "55731": p("MN", "Ely"),
  "55732": p("MN", "Embarrass"),
  "55734": p("MN", "Eveleth"),
  "55736": p("MN", "Floodwood"),
  "55738": p("MN", "Forbes"),
  "55741": p("MN", "Gilbert"),
  "55746": p("MN", "Hibbing"),
  "55747": p("MN", "Hibbing"),
  "55750": p("MN", "Hoyt Lakes"),
  "55751": p("MN", "Iron"),
  "55758": p("MN", "Kinney"),
  "55763": p("MN", "Makinen"),
  "55765": p("MN", "Meadowlands"),
  "55766": p("MN", "Melrude"),
  "55768": p("MN", "Mountain Iron"),
  "55771": p("MN", "Orr"),
  "55772": p("MN", "Nett Lake"),
  "55777": p("MN", "Virginia"),
  "55779": p("MN", "Saginaw"),
  "55781": p("MN", "Side Lake"),
  "55782": p("MN", "Soudan"),
  "55790": p("MN", "Tower"),
  "55791": p("MN", "Twig"),
  "55792": p("MN", "Virginia"),
  "55796": p("MN", "Winton"),
  "55801": p("MN", "Duluth"),
  "55802": p("MN", "Duluth"),
  "55803": p("MN", "Duluth"),
  "55804": p("MN", "Duluth"),
  "55805": p("MN", "Duluth"),
  "55806": p("MN", "Duluth"),
  "55807": p("MN", "Duluth"),
  "55808": p("MN", "Duluth"),
  "55810": p("MN", "Duluth"),
  "55811": p("MN", "Duluth"),
  "55812": p("MN", "Duluth"),
  "55814": p("MN", "Duluth"),
  "55815": p("MN", "Duluth"),
  "55816": p("MN", "Duluth"),
  "55020": p("MN", "Elko New Market"),
  "55054": p("MN", "Elko New Market"),
  "55352": p("MN", "Jordan"),
  "55372": p("MN", "Prior Lake"),
  "55378": p("MN", "Savage"),
  "55379": p("MN", "Shakopee"),
  "56011": p("MN", "Belle Plaine"),
  "55308": p("MN", "Becker"),
  "55309": p("MN", "Big Lake"),
  "55319": p("MN", "Clear Lake"),
  "55330": p("MN", "Elk River"),
  "55377": p("MN", "Santiago"),
  "55398": p("MN", "Zimmerman"),
  "55307": p("MN", "Arlington"),
  "55334": p("MN", "Gaylord"),
  "55335": p("MN", "Gibbon"),
  "55338": p("MN", "Green Isle"),
  "55366": p("MN", "New Auburn"),
  "55396": p("MN", "Winthrop"),
  "56044": p("MN", "Henderson"),
  "55353": p("MN", "Kimball"),
  "56301": p("MN", "Saint Cloud"),
  "56302": p("MN", "Saint Cloud"),
  "56303": p("MN", "Saint Cloud"),
  "56304": p("MN", "Saint Cloud"),
  "56307": p("MN", "Albany"),
  "56310": p("MN", "Avon"),
  "56312": p("MN", "Belgrade"),
  "56316": p("MN", "Brooten"),
  "56320": p("MN", "Cold Spring"),
  "56321": p("MN", "Collegeville"),
  "56325": p("MN", "Elrosa"),
  "56331": p("MN", "Freeport"),
  "56335": p("MN", "Greenwald"),
  "56340": p("MN", "Holdingford"),
  "56352": p("MN", "Melrose"),
  "56356": p("MN", "New Munich"),
  "56362": p("MN", "Paynesville"),
  "56368": p("MN", "Richmond"),
  "56369": p("MN", "Rockville"),
  "56371": p("MN", "Roscoe"),
  "56372": p("MN", "Saint Cloud"),
  "56374": p("MN", "Saint Joseph"),
  "56375": p("MN", "Saint Stephen"),
  "56376": p("MN", "Saint Martin"),
  "56377": p("MN", "Sartell"),
  "56378": p("MN", "Sauk Centre"),
  "56387": p("MN", "Waite Park"),
  "56393": p("MN", "Saint Cloud"),
  "56395": p("MN", "Saint Cloud"),
  "56396": p("MN", "Saint Cloud"),
  "56397": p("MN", "Saint Cloud"),
  "56398": p("MN", "Saint Cloud"),
  "56399": p("MN", "Saint Cloud"),
  "55049": p("MN", "Medford"),
  "55060": p("MN", "Owatonna"),
  "55917": p("MN", "Blooming Prairie"),
  "56026": p("MN", "Ellendale"),
  "56046": p("MN", "Hope"),
  "56207": p("MN", "Alberta"),
  "56221": p("MN", "Chokio"),
  "56235": p("MN", "Donnelly"),
  "56244": p("MN", "Hancock"),
  "56267": p("MN", "Morris"),
  "56208": p("MN", "Appleton"),
  "56215": p("MN", "Benson"),
  "56226": p("MN", "Clontarf"),
  "56231": p("MN", "Danvers"),
  "56249": p("MN", "Holloway"),
  "56252": p("MN", "Kerkhoven"),
  "56271": p("MN", "Murdock"),
  "56318": p("MN", "Burtrum"),
  "56336": p("MN", "Grey Eagle"),
  "56347": p("MN", "Long Prairie"),
  "56389": p("MN", "West Union"),
  "56437": p("MN", "Bertha"),
  "56438": p("MN", "Browerville"),
  "56440": p("MN", "Clarissa"),
  "56446": p("MN", "Eagle Bend"),
  "56453": p("MN", "Hewitt"),
  "56479": p("MN", "Staples"),
  "56219": p("MN", "Browns Valley"),
  "56236": p("MN", "Dumont"),
  "56296": p("MN", "Wheaton"),
  "56583": p("MN", "Tintah"),
  "55041": p("MN", "Lake City"),
  "55932": p("MN", "Elgin"),
  "55945": p("MN", "Kellogg"),
  "55956": p("MN", "Mazeppa"),
  "55957": p("MN", "Millville"),
  "55964": p("MN", "Plainview"),
  "55968": p("MN", "Reads Landing"),
  "55981": p("MN", "Wabasha"),
  "55991": p("MN", "Zumbro Falls"),
  "56434": p("MN", "Aldrich"),
  "56464": p("MN", "Menahga"),
  "56477": p("MN", "Sebeka"),
  "56481": p("MN", "Verndale"),
  "56482": p("MN", "Wadena"),
  "56048": p("MN", "Janesville"),
  "56072": p("MN", "New Richland"),
  "56091": p("MN", "Waldorf"),
  "56093": p("MN", "Waseca"),
  "55001": p("MN", "Afton"),
  "55003": p("MN", "Bayport"),
  "55016": p("MN", "Cottage Grove"),
  "55025": p("MN", "Forest Lake"),
  "55038": p("MN", "Hugo"),
  "55042": p("MN", "Lake Elmo"),
  "55043": p("MN", "Lakeland"),
  "55047": p("MN", "Marine On Saint Croix"),
  "55055": p("MN", "Newport"),
  "55071": p("MN", "Saint Paul Park"),
  "55073": p("MN", "Scandia"),
  "55082": p("MN", "Stillwater"),
  "55083": p("MN", "Stillwater"),
  "55090": p("MN", "Willernie"),
  "55115": p("MN", "Saint Paul"),
  "55125": p("MN", "Saint Paul"),
  "55128": p("MN", "Saint Paul"),
  "55129": p("MN", "Saint Paul"),
  "56022": p("MN", "Darfur"),
  "56056": p("MN", "La Salle"),
  "56060": p("MN", "Lewisville"),
  "56062": p("MN", "Madelia"),
  "56081": p("MN", "Saint James"),
  "56120": p("MN", "Butterfield"),
  "56160": p("MN", "Odin"),
  "56520": p("MN", "Breckenridge"),
  "56522": p("MN", "Campbell"),
  "56543": p("MN", "Foxhome"),
  "56553": p("MN", "Kent"),
  "56565": p("MN", "Nashua"),
  "56579": p("MN", "Rothsay"),
  "56594": p("MN", "Wolverton"),
  "55910": p("MN", "Altura"),
  "55925": p("MN", "Dakota"),
  "55942": p("MN", "Homer"),
  "55952": p("MN", "Lewiston"),
  "55959": p("MN", "Minnesota City"),
  "55969": p("MN", "Rollingstone"),
  "55972": p("MN", "Saint Charles"),
  "55979": p("MN", "Utica"),
  "55987": p("MN", "Winona"),
  "55988": p("MN", "Stockton"),
  "55301": p("MN", "Albertville"),
  "55302": p("MN", "Annandale"),
  "55313": p("MN", "Buffalo"),
  "55320": p("MN", "Clearwater"),
  "55321": p("MN", "Cokato"),
  "55328": p("MN", "Delano"),
  "55341": p("MN", "Hanover"),
  "55349": p("MN", "Howard Lake"),
  "55358": p("MN", "Maple Lake"),
  "55362": p("MN", "Monticello"),
  "55363": p("MN", "Montrose"),
  "55373": p("MN", "Rockford"),
  "55376": p("MN", "Saint Michael"),
  "55380": p("MN", "Silver Creek"),
  "55382": p("MN", "South Haven"),
  "55390": p("MN", "Waverly"),
  "55592": p("MN", "Maple Plain"),
  "56220": p("MN", "Canby"),
  "56223": p("MN", "Clarkfield"),
  "56237": p("MN", "Echo"),
  "56241": p("MN", "Granite Falls"),
  "56245": p("MN", "Hanley Falls"),
  "56280": p("MN", "Porter"),
  "56297": p("MN", "Wood Lake"),
  "63501": p("MO", "Kirksville"),
  "63533": p("MO", "Brashear"),
  "63540": p("MO", "Gibbs"),
  "63546": p("MO", "Greentop"),
  "63559": p("MO", "Novinger"),
  "64421": p("MO", "Amazonia"),
  "64427": p("MO", "Bolckow"),
  "64436": p("MO", "Cosby"),
  "64449": p("MO", "Fillmore"),
  "64459": p("MO", "Helena"),
  "64480": p("MO", "Rea"),
  "64483": p("MO", "Rosendale"),
  "64485": p("MO", "Savannah"),
  "64506": p("MO", "Saint Joseph"),
  "64446": p("MO", "Fairfax"),
  "64482": p("MO", "Rock Port"),
  "64491": p("MO", "Tarkio"),
  "64496": p("MO", "Watson"),
  "64498": p("MO", "Westboro"),
  "63345": p("MO", "Farber"),
  "63352": p("MO", "Laddonia"),
  "63382": p("MO", "Vandalia"),
  "65232": p("MO", "Benton City"),
  "65264": p("MO", "Martinsburg"),
  "65265": p("MO", "Mexico"),
  "65280": p("MO", "Rush Hill"),
  "65285": p("MO", "Thompson"),
  "64874": p("MO", "Wheaton"),
  "65623": p("MO", "Butterfield"),
  "65625": p("MO", "Cassville"),
  "65641": p("MO", "Eagle Rock"),
  "65647": p("MO", "Exeter"),
  "65658": p("MO", "Golden"),
  "65708": p("MO", "Monett"),
  "65734": p("MO", "Purdy"),
  "65745": p("MO", "Seligman"),
  "65747": p("MO", "Shell Knob"),
  "65772": p("MO", "Washburn"),
  "64748": p("MO", "Golden City"),
  "64759": p("MO", "Lamar"),
  "64762": p("MO", "Liberal"),
  "64766": p("MO", "Milford"),
  "64769": p("MO", "Mindenmines"),
  "64720": p("MO", "Adrian"),
  "64722": p("MO", "Amoret"),
  "64723": p("MO", "Amsterdam"),
  "64730": p("MO", "Butler"),
  "64742": p("MO", "Drexel"),
  "64745": p("MO", "Foster"),
  "64752": p("MO", "Hume"),
  "64779": p("MO", "Rich Hill"),
  "64780": p("MO", "Rockville"),
  "65325": p("MO", "Cole Camp"),
  "65326": p("MO", "Edwards"),
  "65335": p("MO", "Ionia"),
  "65338": p("MO", "Lincoln"),
  "65355": p("MO", "Warsaw"),
  "63662": p("MO", "Patton"),
  "63750": p("MO", "Gipsy"),
  "63751": p("MO", "Glenallen"),
  "63760": p("MO", "Leopold"),
  "63764": p("MO", "Marble Hill"),
  "63781": p("MO", "Sedgewickville"),
  "63782": p("MO", "Sturdivant"),
  "63787": p("MO", "Zalma"),
  "65010": p("MO", "Ashland"),
  "65039": p("MO", "Hartsburg"),
  "65201": p("MO", "Columbia"),
  "65202": p("MO", "Columbia"),
  "65203": p("MO", "Columbia"),
  "65205": p("MO", "Columbia"),
  "65211": p("MO", "Columbia"),
  "65212": p("MO", "Columbia"),
  "65215": p("MO", "Columbia"),
  "65216": p("MO", "Columbia"),
  "65217": p("MO", "Columbia"),
  "65218": p("MO", "Columbia"),
  "65240": p("MO", "Centralia"),
  "65255": p("MO", "Hallsville"),
  "65256": p("MO", "Harrisburg"),
  "65279": p("MO", "Rocheport"),
  "65284": p("MO", "Sturgeon"),
  "65299": p("MO", "Mid Missouri"),
  "64401": p("MO", "Agency"),
  "64440": p("MO", "De Kalb"),
  "64443": p("MO", "Easton"),
  "64448": p("MO", "Faucett"),
  "64484": p("MO", "Rushville"),
  "64501": p("MO", "Saint Joseph"),
  "64502": p("MO", "Saint Joseph"),
  "64503": p("MO", "Saint Joseph"),
  "64504": p("MO", "Saint Joseph"),
  "64505": p("MO", "Saint Joseph"),
  "64507": p("MO", "Saint Joseph"),
  "64508": p("MO", "Saint Joseph"),
  "63901": p("MO", "Poplar Bluff"),
  "63902": p("MO", "Poplar Bluff"),
  "63932": p("MO", "Broseley"),
  "63938": p("MO", "Fagus"),
  "63940": p("MO", "Fisk"),
  "63945": p("MO", "Harviell"),
  "63954": p("MO", "Neelyville"),
  "63961": p("MO", "Qulin"),
  "63962": p("MO", "Rombauer"),
  "64624": p("MO", "Braymer"),
  "64625": p("MO", "Breckenridge"),
  "64637": p("MO", "Cowgill"),
  "64644": p("MO", "Hamilton"),
  "64649": p("MO", "Kidder"),
  "64650": p("MO", "Kingston"),
  "64671": p("MO", "Polo"),
  "63388": p("MO", "Williamsburg"),
  "65043": p("MO", "Holts Summit"),
  "65059": p("MO", "Mokane"),
  "65063": p("MO", "New Bloomfield"),
  "65067": p("MO", "Portland"),
  "65077": p("MO", "Steedman"),
  "65080": p("MO", "Tebbetts"),
  "65231": p("MO", "Auxvasse"),
  "65251": p("MO", "Fulton"),
  "65262": p("MO", "Kingdom City"),
  "65020": p("MO", "Camdenton"),
  "65049": p("MO", "Lake Ozark"),
  "65052": p("MO", "Linn Creek"),
  "65065": p("MO", "Osage Beach"),
  "65079": p("MO", "Sunrise Beach"),
  "65324": p("MO", "Climax Springs"),
  "65567": p("MO", "Stoutland"),
  "65591": p("MO", "Montreal"),
  "65786": p("MO", "Macks Creek"),
  "65787": p("MO", "Roach"),
  "63701": p("MO", "Cape Girardeau"),
  "63702": p("MO", "Cape Girardeau"),
  "63703": p("MO", "Cape Girardeau"),
  "63739": p("MO", "Burfordville"),
  "63743": p("MO", "Daisy"),
  "63744": p("MO", "Delta"),
  "63745": p("MO", "Dutchtown"),
  "63747": p("MO", "Friedheim"),
  "63752": p("MO", "Gordonville"),
  "63755": p("MO", "Jackson"),
  "63766": p("MO", "Millersville"),
  "63769": p("MO", "Oak Ridge"),
  "63770": p("MO", "Old Appleton"),
  "63779": p("MO", "Pocahontas"),
  "63785": p("MO", "Whitewater"),
  "64622": p("MO", "Bogard"),
  "64623": p("MO", "Bosworth"),
  "64633": p("MO", "Carrollton"),
  "64639": p("MO", "De Witt"),
  "64643": p("MO", "Hale"),
  "64668": p("MO", "Norborne"),
  "64680": p("MO", "Stet"),
  "64682": p("MO", "Tina"),
  "63937": p("MO", "Ellsinore"),
  "63941": p("MO", "Fremont"),
  "63943": p("MO", "Grandin"),
  "63965": p("MO", "Van Buren"),
  "64012": p("MO", "Belton"),
  "64078": p("MO", "Peculiar"),
  "64080": p("MO", "Pleasant Hill"),
  "64083": p("MO", "Raymore"),
  "64090": p("MO", "Strasburg"),
  "64701": p("MO", "Harrisonville"),
  "64725": p("MO", "Archie"),
  "64734": p("MO", "Cleveland"),
  "64739": p("MO", "Creighton"),
  "64743": p("MO", "East Lynne"),
  "64746": p("MO", "Freeman"),
  "64747": p("MO", "Garden City"),
  "64744": p("MO", "El Dorado Springs"),
  "64756": p("MO", "Jerico Springs"),
  "65607": p("MO", "Caplinger Mills"),
  "65785": p("MO", "Stockton"),
  "64660": p("MO", "Mendon"),
  "64676": p("MO", "Rothville"),
  "64681": p("MO", "Sumner"),
  "65236": p("MO", "Brunswick"),
  "65246": p("MO", "Dalton"),
  "65261": p("MO", "Keytesville"),
  "65281": p("MO", "Salisbury"),
  "65286": p("MO", "Triplett"),
  "65610": p("MO", "Billings"),
  "65620": p("MO", "Bruner"),
  "65629": p("MO", "Chadwick"),
  "65630": p("MO", "Chestnutridge"),
  "65631": p("MO", "Clever"),
  "65657": p("MO", "Garrison"),
  "65669": p("MO", "Highlandville"),
  "65714": p("MO", "Nixa"),
  "65720": p("MO", "Oldfield"),
  "65721": p("MO", "Ozark"),
  "65753": p("MO", "Sparta"),
  "65754": p("MO", "Spokane"),
  "72643": p("MO", "Lead Hill"),
  "63430": p("MO", "Alexandria"),
  "63445": p("MO", "Kahoka"),
  "63453": p("MO", "Luray"),
  "63465": p("MO", "Revere"),
  "63466": p("MO", "Saint Patrick"),
  "63472": p("MO", "Wayland"),
  "63474": p("MO", "Wyaconda"),
  "64024": p("MO", "Excelsior Springs"),
  "64048": p("MO", "Holt"),
  "64060": p("MO", "Kearney"),
  "64068": p("MO", "Liberty"),
  "64069": p("MO", "Liberty"),
  "64072": p("MO", "Missouri City"),
  "64073": p("MO", "Mosby"),
  "64089": p("MO", "Smithville"),
  "64116": p("MO", "Kansas City"),
  "64117": p("MO", "Kansas City"),
  "64118": p("MO", "Kansas City"),
  "64119": p("MO", "Kansas City"),
  "64144": p("MO", "Kansas City"),
  "64155": p("MO", "Kansas City"),
  "64156": p("MO", "Kansas City"),
  "64157": p("MO", "Kansas City"),
  "64158": p("MO", "Kansas City"),
  "64161": p("MO", "Kansas City"),
  "64162": p("MO", "Kansas City"),
  "64165": p("MO", "Kansas City"),
  "64166": p("MO", "Kansas City"),
  "64167": p("MO", "Kansas City"),
  "64429": p("MO", "Cameron"),
  "64454": p("MO", "Gower"),
  "64465": p("MO", "Lathrop"),
  "64477": p("MO", "Plattsburg"),
  "64492": p("MO", "Trimble"),
  "64493": p("MO", "Turney"),
  "65023": p("MO", "Centertown"),
  "65032": p("MO", "Eugene"),
  "65040": p("MO", "Henley"),
  "65053": p("MO", "Lohman"),
  "65074": p("MO", "Russellville"),
  "65076": p("MO", "Saint Thomas"),
  "65101": p("MO", "Jefferson City"),
  "65102": p("MO", "Jefferson City"),
  "65103": p("MO", "Jefferson City"),
  "65104": p("MO", "Jefferson City"),
  "65105": p("MO", "Jefferson City"),
  "65106": p("MO", "Jefferson City"),
  "65107": p("MO", "Jefferson City"),
  "65108": p("MO", "Jefferson City"),
  "65109": p("MO", "Jefferson City"),
  "65110": p("MO", "Jefferson City"),
  "65111": p("MO", "Jefferson City"),
  "65068": p("MO", "Prairie Home"),
  "65233": p("MO", "Boonville"),
  "65237": p("MO", "Bunceton"),
  "65276": p("MO", "Pilot Grove"),
  "65287": p("MO", "Wooldridge"),
  "65322": p("MO", "Blackwater"),
  "65348": p("MO", "Otterville"),
  "65441": p("MO", "Bourbon"),
  "65446": p("MO", "Cherryville"),
  "65449": p("MO", "Cook Sta"),
  "65453": p("MO", "Cuba"),
  "65456": p("MO", "Davisville"),
  "65535": p("MO", "Leasburg"),
  "65565": p("MO", "Steelville"),
  "65586": p("MO", "Wesco"),
  "65603": p("MO", "Arcola"),
  "65635": p("MO", "Dadeville"),
  "65646": p("MO", "Everton"),
  "65661": p("MO", "Greenfield"),
  "65682": p("MO", "Lockwood"),
  "65752": p("MO", "South Greenfield"),
  "65590": p("MO", "Long Lane"),
  "65622": p("MO", "Buffalo"),
  "65685": p("MO", "Louisburg"),
  "65764": p("MO", "Tunas"),
  "65767": p("MO", "Urbana"),
  "65783": p("MO", "Windyville"),
  "64620": p("MO", "Altamont"),
  "64636": p("MO", "Coffey"),
  "64640": p("MO", "Gallatin"),
  "64642": p("MO", "Gilman City"),
  "64647": p("MO", "Jameson"),
  "64648": p("MO", "Jamesport"),
  "64654": p("MO", "Lock Springs"),
  "64670": p("MO", "Pattonsburg"),
  "64689": p("MO", "Winston"),
  "64422": p("MO", "Amity"),
  "64430": p("MO", "Clarksdale"),
  "64469": p("MO", "Maysville"),
  "64474": p("MO", "Osborn"),
  "64490": p("MO", "Stewartsville"),
  "64494": p("MO", "Union Star"),
  "64497": p("MO", "Weatherby"),
  "65440": p("MO", "Boss"),
  "65501": p("MO", "Jadwin"),
  "65532": p("MO", "Lake Spring"),
  "65541": p("MO", "Lenox"),
  "65560": p("MO", "Salem"),
  "65608": p("MO", "Ava"),
  "65638": p("MO", "Drury"),
  "65755": p("MO", "Squires"),
  "65768": p("MO", "Vanzant"),
  "63821": p("MO", "Arbyrd"),
  "63829": p("MO", "Cardwell"),
  "63837": p("MO", "Clarkton"),
  "63847": p("MO", "Gibson"),
  "63852": p("MO", "Holcomb"),
  "63855": p("MO", "Hornersville"),
  "63857": p("MO", "Kennett"),
  "63863": p("MO", "Malden"),
  "63875": p("MO", "Rives"),
  "63876": p("MO", "Senath"),
  "63880": p("MO", "Whiteoak"),
  "63933": p("MO", "Campbell"),
  "63013": p("MO", "Beaufort"),
  "63014": p("MO", "Berger"),
  "63015": p("MO", "Catawissa"),
  "63037": p("MO", "Gerald"),
  "63039": p("MO", "Gray Summit"),
  "63055": p("MO", "Labadie"),
  "63056": p("MO", "Leslie"),
  "63060": p("MO", "Lonedell"),
  "63061": p("MO", "Luebbering"),
  "63068": p("MO", "New Haven"),
  "63069": p("MO", "Pacific"),
  "63072": p("MO", "Robertsville"),
  "63073": p("MO", "Saint Albans"),
  "63077": p("MO", "Saint Clair"),
  "63079": p("MO", "Stanton"),
  "63080": p("MO", "Sullivan"),
  "63084": p("MO", "Union"),
  "63089": p("MO", "Villa Ridge"),
  "63090": p("MO", "Washington"),
  "63091": p("MO", "Rosebud"),
  "65014": p("MO", "Bland"),
  "65036": p("MO", "Gasconade"),
  "65041": p("MO", "Hermann"),
  "65061": p("MO", "Morrison"),
  "65062": p("MO", "Mount Sterling"),
  "65066": p("MO", "Owensville"),
  "64402": p("MO", "Albany"),
  "64438": p("MO", "Darlington"),
  "64453": p("MO", "Gentry"),
  "64463": p("MO", "King City"),
  "64489": p("MO", "Stanberry"),
  "64657": p("MO", "Mc Fall"),
  "65604": p("MO", "Ash Grove"),
  "65612": p("MO", "Bois D Arc"),
  "65619": p("MO", "Brookline"),
  "65648": p("MO", "Fair Grove"),
  "65738": p("MO", "Republic"),
  "65757": p("MO", "Strafford"),
  "65765": p("MO", "Turners"),
  "65770": p("MO", "Walnut Grove"),
  "65781": p("MO", "Willard"),
  "65801": p("MO", "Springfield"),
  "65802": p("MO", "Springfield"),
  "65803": p("MO", "Springfield"),
  "65804": p("MO", "Springfield"),
  "65805": p("MO", "Springfield"),
  "65806": p("MO", "Springfield"),
  "65807": p("MO", "Springfield"),
  "65808": p("MO", "Springfield"),
  "65809": p("MO", "Springfield"),
  "65810": p("MO", "Springfield"),
  "65814": p("MO", "Springfield"),
  "65817": p("MO", "Springfield"),
  "65890": p("MO", "Springfield"),
  "65897": p("MO", "Springfield"),
  "65898": p("MO", "Springfield"),
  "65899": p("MO", "Springfield"),
  "64641": p("MO", "Galt"),
  "64652": p("MO", "Laredo"),
  "64679": p("MO", "Spickard"),
  "64683": p("MO", "Trenton"),
  "64424": p("MO", "Bethany"),
  "64426": p("MO", "Blythedale"),
  "64442": p("MO", "Eagleville"),
  "64458": p("MO", "Hatfield"),
  "64467": p("MO", "Martinsville"),
  "64471": p("MO", "New Hampton"),
  "64481": p("MO", "Ridgeway"),
  "64632": p("MO", "Cainsville"),
  "64726": p("MO", "Blairstown"),
  "64735": p("MO", "Clinton"),
  "64740": p("MO", "Deepwater"),
  "64770": p("MO", "Montrose"),
  "64788": p("MO", "Urich"),
  "65323": p("MO", "Calhoun"),
  "65360": p("MO", "Windsor"),
  "65634": p("MO", "Cross Timbers"),
  "65668": p("MO", "Hermitage"),
  "65724": p("MO", "Pittsburg"),
  "65732": p("MO", "Preston"),
  "65735": p("MO", "Quincy"),
  "65774": p("MO", "Weaubleau"),
  "65779": p("MO", "Wheatland"),
  "64437": p("MO", "Craig"),
  "64451": p("MO", "Forest City"),
  "64466": p("MO", "Maitland"),
  "64470": p("MO", "Mound City"),
  "64473": p("MO", "Oregon"),
  "65230": p("MO", "Armstrong"),
  "65248": p("MO", "Fayette"),
  "65250": p("MO", "Franklin"),
  "65254": p("MO", "Glasgow"),
  "65274": p("MO", "New Franklin"),
  "65548": p("MO", "Mountain View"),
  "65626": p("MO", "Caulfield"),
  "65688": p("MO", "Brandsville"),
  "65775": p("MO", "West Plains"),
  "65777": p("MO", "Moody"),
  "65788": p("MO", "Peace Valley"),
  "65789": p("MO", "Pomona"),
  "65790": p("MO", "Pottersville"),
  "65793": p("MO", "Willow Springs"),
  "63620": p("MO", "Annapolis"),
  "63621": p("MO", "Arcadia"),
  "63623": p("MO", "Belleview"),
  "63636": p("MO", "Des Arc"),
  "63650": p("MO", "Ironton"),
  "63656": p("MO", "Middle Brook"),
  "63663": p("MO", "Pilot Knob"),
  "63675": p("MO", "Vulcan"),
  "65439": p("MO", "Bixby"),
  "65566": p("MO", "Viburnum"),
  "64002": p("MO", "Lees Summit"),
  "64013": p("MO", "Blue Springs"),
  "64014": p("MO", "Blue Springs"),
  "64015": p("MO", "Blue Springs"),
  "64016": p("MO", "Buckner"),
  "64029": p("MO", "Grain Valley"),
  "64030": p("MO", "Grandview"),
  "64034": p("MO", "Greenwood"),
  "64050": p("MO", "Independence"),
  "64051": p("MO", "Independence"),
  "64052": p("MO", "Independence"),
  "64053": p("MO", "Independence"),
  "64054": p("MO", "Independence"),
  "64055": p("MO", "Independence"),
  "64056": p("MO", "Independence"),
  "64057": p("MO", "Independence"),
  "64058": p("MO", "Independence"),
  "64063": p("MO", "Lees Summit"),
  "64064": p("MO", "Lees Summit"),
  "64065": p("MO", "Lees Summit"),
  "64066": p("MO", "Levasy"),
  "64070": p("MO", "Lone Jack"),
  "64075": p("MO", "Oak Grove"),
  "64081": p("MO", "Lees Summit"),
  "64082": p("MO", "Lees Summit"),
  "64086": p("MO", "Lees Summit"),
  "64088": p("MO", "Sibley"),
  "64101": p("MO", "Kansas City"),
  "64102": p("MO", "Kansas City"),
  "64105": p("MO", "Kansas City"),
  "64106": p("MO", "Kansas City"),
  "64108": p("MO", "Kansas City"),
  "64109": p("MO", "Kansas City"),
  "64110": p("MO", "Kansas City"),
  "64111": p("MO", "Kansas City"),
  "64112": p("MO", "Kansas City"),
  "64113": p("MO", "Kansas City"),
  "64114": p("MO", "Kansas City"),
  "64120": p("MO", "Kansas City"),
  "64121": p("MO", "Kansas City"),
  "64123": p("MO", "Kansas City"),
  "64124": p("MO", "Kansas City"),
  "64125": p("MO", "Kansas City"),
  "64126": p("MO", "Kansas City"),
  "64127": p("MO", "Kansas City"),
  "64128": p("MO", "Kansas City"),
  "64129": p("MO", "Kansas City"),
  "64130": p("MO", "Kansas City"),
  "64131": p("MO", "Kansas City"),
  "64132": p("MO", "Kansas City"),
  "64133": p("MO", "Kansas City"),
  "64134": p("MO", "Kansas City"),
  "64136": p("MO", "Kansas City"),
  "64137": p("MO", "Kansas City"),
  "64138": p("MO", "Kansas City"),
  "64139": p("MO", "Kansas City"),
  "64141": p("MO", "Kansas City"),
  "64145": p("MO", "Kansas City"),
  "64146": p("MO", "Kansas City"),
  "64147": p("MO", "Kansas City"),
  "64148": p("MO", "Kansas City"),
  "64149": p("MO", "Kansas City"),
  "64170": p("MO", "Kansas City"),
  "64171": p("MO", "Kansas City"),
  "64179": p("MO", "Kansas City"),
  "64180": p("MO", "Kansas City"),
  "64184": p("MO", "Kansas City"),
  "64187": p("MO", "Kansas City"),
  "64188": p("MO", "Kansas City"),
  "64191": p("MO", "Kansas City"),
  "64196": p("MO", "Kansas City"),
  "64197": p("MO", "Kansas City"),
  "64198": p("MO", "Kansas City"),
  "64199": p("MO", "Kansas City"),
  "64999": p("MO", "Kansas City"),
  "64755": p("MO", "Jasper"),
  "64801": p("MO", "Joplin"),
  "64802": p("MO", "Joplin"),
  "64803": p("MO", "Joplin"),
  "64804": p("MO", "Joplin"),
  "64830": p("MO", "Alba"),
  "64832": p("MO", "Asbury"),
  "64833": p("MO", "Avilla"),
  "64834": p("MO", "Carl Junction"),
  "64835": p("MO", "Carterville"),
  "64836": p("MO", "Carthage"),
  "64841": p("MO", "Duenweg"),
  "64848": p("MO", "La Russell"),
  "64849": p("MO", "Neck City"),
  "64855": p("MO", "Oronogo"),
  "64857": p("MO", "Purcell"),
  "64859": p("MO", "Reeds"),
  "64862": p("MO", "Sarcoxie"),
  "64870": p("MO", "Webb City"),
  "63010": p("MO", "Arnold"),
  "63012": p("MO", "Barnhart"),
  "63016": p("MO", "Cedar Hill"),
  "63019": p("MO", "Crystal City"),
  "63020": p("MO", "De Soto"),
  "63023": p("MO", "Dittmer"),
  "63028": p("MO", "Festus"),
  "63030": p("MO", "Fletcher"),
  "63041": p("MO", "Grubville"),
  "63047": p("MO", "Hematite"),
  "63048": p("MO", "Herculaneum"),
  "63049": p("MO", "High Ridge"),
  "63050": p("MO", "Hillsboro"),
  "63051": p("MO", "House Springs"),
  "63052": p("MO", "Imperial"),
  "63053": p("MO", "Kimmswick"),
  "63057": p("MO", "Liguori"),
  "63065": p("MO", "Mapaville"),
  "63066": p("MO", "Morse Mill"),
  "63070": p("MO", "Pevely"),
  "64019": p("MO", "Centerview"),
  "64040": p("MO", "Holden"),
  "64061": p("MO", "Kingsville"),
  "64093": p("MO", "Warrensburg"),
  "64733": p("MO", "Chilhowee"),
  "64761": p("MO", "Leeton"),
  "65305": p("MO", "Whiteman Air Force Base"),
  "65336": p("MO", "Knob Noster"),
  "63446": p("MO", "Knox City"),
  "63458": p("MO", "Newark"),
  "63460": p("MO", "Novelty"),
  "63464": p("MO", "Plevna"),
  "63531": p("MO", "Baring"),
  "63537": p("MO", "Edina"),
  "63547": p("MO", "Hurdland"),
  "65463": p("MO", "Eldridge"),
  "65470": p("MO", "Falcon"),
  "65536": p("MO", "Lebanon"),
  "65543": p("MO", "Lynchburg"),
  "65632": p("MO", "Conway"),
  "65722": p("MO", "Phillipsburg"),
  "64001": p("MO", "Alma"),
  "64011": p("MO", "Bates City"),
  "64020": p("MO", "Concordia"),
  "64021": p("MO", "Corder"),
  "64022": p("MO", "Dover"),
  "64037": p("MO", "Higginsville"),
  "64067": p("MO", "Lexington"),
  "64071": p("MO", "Mayview"),
  "64074": p("MO", "Napoleon"),
  "64076": p("MO", "Odessa"),
  "64096": p("MO", "Waverly"),
  "64097": p("MO", "Wellington"),
  "65327": p("MO", "Emma"),
  "65605": p("MO", "Aurora"),
  "65654": p("MO", "Freistatt"),
  "65664": p("MO", "Halltown"),
  "65705": p("MO", "Marionville"),
  "65707": p("MO", "Miller"),
  "65712": p("MO", "Mount Vernon"),
  "65723": p("MO", "Pierce City"),
  "65756": p("MO", "Stotts City"),
  "65769": p("MO", "Verona"),
  "63435": p("MO", "Canton"),
  "63438": p("MO", "Durham"),
  "63440": p("MO", "Ewing"),
  "63447": p("MO", "La Belle"),
  "63448": p("MO", "La Grange"),
  "63452": p("MO", "Lewistown"),
  "63457": p("MO", "Monticello"),
  "63473": p("MO", "Williamstown"),
  "63343": p("MO", "Elsberry"),
  "63347": p("MO", "Foley"),
  "63349": p("MO", "Hawk Point"),
  "63362": p("MO", "Moscow Mills"),
  "63369": p("MO", "Old Monroe"),
  "63370": p("MO", "Olney"),
  "63377": p("MO", "Silex"),
  "63379": p("MO", "Troy"),
  "63381": p("MO", "Truxton"),
  "63387": p("MO", "Whiteside"),
  "63389": p("MO", "Winfield"),
  "63557": p("MO", "New Boston"),
  "64628": p("MO", "Brookfield"),
  "64630": p("MO", "Browning"),
  "64631": p("MO", "Bucklin"),
  "64651": p("MO", "Laclede"),
  "64653": p("MO", "Linneus"),
  "64658": p("MO", "Marceline"),
  "64659": p("MO", "Meadville"),
  "64674": p("MO", "Purdin"),
  "64601": p("MO", "Chillicothe"),
  "64635": p("MO", "Chula"),
  "64638": p("MO", "Dawn"),
  "64656": p("MO", "Ludlow"),
  "64664": p("MO", "Mooresville"),
  "64686": p("MO", "Utica"),
  "64688": p("MO", "Wheeling"),
  "64831": p("MO", "Anderson"),
  "64843": p("MO", "Goodman"),
  "64847": p("MO", "Lanagan"),
  "64854": p("MO", "Noel"),
  "64856": p("MO", "Pineville"),
  "64861": p("MO", "Rocky Comfort"),
  "64863": p("MO", "South West City"),
  "64868": p("MO", "Tiff City"),
  "65730": p("MO", "Powell"),
  "63431": p("MO", "Anabel"),
  "63530": p("MO", "Atlanta"),
  "63532": p("MO", "Bevier"),
  "63534": p("MO", "Callao"),
  "63538": p("MO", "Elmer"),
  "63539": p("MO", "Ethel"),
  "63549": p("MO", "La Plata"),
  "63552": p("MO", "Macon"),
  "63558": p("MO", "New Cambria"),
  "65247": p("MO", "Excello"),
  "63645": p("MO", "Fredericktown"),
  "63655": p("MO", "Marquand"),
  "65013": p("MO", "Belle"),
  "65443": p("MO", "Brinktown"),
  "65580": p("MO", "Vichy"),
  "65582": p("MO", "Vienna"),
  "63401": p("MO", "Hannibal"),
  "63454": p("MO", "Maywood"),
  "63461": p("MO", "Palmyra"),
  "63463": p("MO", "Philadelphia"),
  "63471": p("MO", "Taylor"),
  "64661": p("MO", "Mercer"),
  "64673": p("MO", "Princeton"),
  "65017": p("MO", "Brumley"),
  "65026": p("MO", "Eldon"),
  "65047": p("MO", "Kaiser"),
  "65064": p("MO", "Olean"),
  "65075": p("MO", "Saint Elizabeth"),
  "65082": p("MO", "Tuscumbia"),
  "65083": p("MO", "Ulman"),
  "65486": p("MO", "Iberia"),
  "63820": p("MO", "Anniston"),
  "63823": p("MO", "Bertrand"),
  "63834": p("MO", "Charleston"),
  "63845": p("MO", "East Prairie"),
  "63881": p("MO", "Wolf Island"),
  "63882": p("MO", "Wyatt"),
  "65018": p("MO", "California"),
  "65025": p("MO", "Clarksburg"),
  "65034": p("MO", "Fortuna"),
  "65042": p("MO", "High Point"),
  "65046": p("MO", "Jamestown"),
  "65050": p("MO", "Latham"),
  "65055": p("MO", "Mc Girk"),
  "65081": p("MO", "Tipton"),
  "63456": p("MO", "Monroe City"),
  "65258": p("MO", "Holliday"),
  "65263": p("MO", "Madison"),
  "65275": p("MO", "Paris"),
  "65282": p("MO", "Santa Fe"),
  "65283": p("MO", "Stoutsville"),
  "63333": p("MO", "Bellflower"),
  "63350": p("MO", "High Hill"),
  "63351": p("MO", "Jonesburg"),
  "63359": p("MO", "Middletown"),
  "63361": p("MO", "Montgomery City"),
  "63363": p("MO", "New Florence"),
  "63384": p("MO", "Wellsville"),
  "65069": p("MO", "Rhineland"),
  "65011": p("MO", "Barnett"),
  "65037": p("MO", "Gravois Mills"),
  "65038": p("MO", "Laurie"),
  "65072": p("MO", "Rocky Mount"),
  "65078": p("MO", "Stover"),
  "65084": p("MO", "Versailles"),
  "65329": p("MO", "Florence"),
  "65354": p("MO", "Syracuse"),
  "63828": p("MO", "Canalou"),
  "63833": p("MO", "Catron"),
  "63848": p("MO", "Gideon"),
  "63860": p("MO", "Kewanee"),
  "63862": p("MO", "Lilbourn"),
  "63866": p("MO", "Marston"),
  "63867": p("MO", "Matthews"),
  "63868": p("MO", "Morehouse"),
  "63869": p("MO", "New Madrid"),
  "63870": p("MO", "Parma"),
  "63873": p("MO", "Portageville"),
  "63874": p("MO", "Risco"),
  "63878": p("MO", "Tallapoosa"),
  "64840": p("MO", "Diamond"),
  "64842": p("MO", "Fairview"),
  "64844": p("MO", "Granby"),
  "64850": p("MO", "Neosho"),
  "64853": p("MO", "Newtonia"),
  "64858": p("MO", "Racine"),
  "64864": p("MO", "Saginaw"),
  "64865": p("MO", "Seneca"),
  "64866": p("MO", "Stark City"),
  "64867": p("MO", "Stella"),
  "64873": p("MO", "Wentworth"),
  "64423": p("MO", "Barnard"),
  "64428": p("MO", "Burlington Junction"),
  "64431": p("MO", "Clearmont"),
  "64432": p("MO", "Clyde"),
  "64433": p("MO", "Conception"),
  "64434": p("MO", "Conception Junction"),
  "64445": p("MO", "Elmo"),
  "64455": p("MO", "Graham"),
  "64457": p("MO", "Guilford"),
  "64461": p("MO", "Hopkins"),
  "64468": p("MO", "Maryville"),
  "64475": p("MO", "Parnell"),
  "64476": p("MO", "Pickering"),
  "64479": p("MO", "Ravenwood"),
  "64487": p("MO", "Skidmore"),
  "65606": p("MO", "Alton"),
  "65690": p("MO", "Couch"),
  "65692": p("MO", "Koshkonong"),
  "65778": p("MO", "Myrtle"),
  "65791": p("MO", "Thayer"),
  "65001": p("MO", "Argyle"),
  "65016": p("MO", "Bonnots Mill"),
  "65024": p("MO", "Chamois"),
  "65035": p("MO", "Freeburg"),
  "65048": p("MO", "Koeltztown"),
  "65051": p("MO", "Linn"),
  "65054": p("MO", "Loose Creek"),
  "65058": p("MO", "Meta"),
  "65085": p("MO", "Westphalia"),
  "65609": p("MO", "Bakersfield"),
  "65618": p("MO", "Brixey"),
  "65637": p("MO", "Dora"),
  "65655": p("MO", "Gainesville"),
  "65666": p("MO", "Hardenville"),
  "65676": p("MO", "Isabella"),
  "65715": p("MO", "Noble"),
  "65729": p("MO", "Pontiac"),
  "65741": p("MO", "Rockbridge"),
  "65760": p("MO", "Tecumseh"),
  "65761": p("MO", "Theodosia"),
  "65762": p("MO", "Thornfield"),
  "65766": p("MO", "Udall"),
  "65773": p("MO", "Wasola"),
  "65784": p("MO", "Zanoni"),
  "63826": p("MO", "Braggadocio"),
  "63827": p("MO", "Bragg City"),
  "63830": p("MO", "Caruthersville"),
  "63839": p("MO", "Cooter"),
  "63840": p("MO", "Deering"),
  "63849": p("MO", "Gobler"),
  "63851": p("MO", "Hayti"),
  "63853": p("MO", "Holland"),
  "63877": p("MO", "Steele"),
  "63879": p("MO", "Wardell"),
  "63732": p("MO", "Altenburg"),
  "63737": p("MO", "Brazeau"),
  "63746": p("MO", "Farrar"),
  "63748": p("MO", "Frohna"),
  "63775": p("MO", "Perryville"),
  "63776": p("MO", "Mc Bride"),
  "63783": p("MO", "Uniontown"),
  "65301": p("MO", "Sedalia"),
  "65302": p("MO", "Sedalia"),
  "65332": p("MO", "Green Ridge"),
  "65333": p("MO", "Houstonia"),
  "65334": p("MO", "Hughesville"),
  "65337": p("MO", "La Monte"),
  "65345": p("MO", "Mora"),
  "65350": p("MO", "Smithton"),
  "65401": p("MO", "Rolla"),
  "65402": p("MO", "Rolla"),
  "65409": p("MO", "Rolla"),
  "65436": p("MO", "Beulah"),
  "65461": p("MO", "Duke"),
  "65462": p("MO", "Edgar Springs"),
  "65529": p("MO", "Jerome"),
  "65550": p("MO", "Newburg"),
  "65559": p("MO", "Saint James"),
  "63330": p("MO", "Annada"),
  "63334": p("MO", "Bowling Green"),
  "63336": p("MO", "Clarksville"),
  "63339": p("MO", "Curryville"),
  "63344": p("MO", "Eolia"),
  "63353": p("MO", "Louisiana"),
  "63433": p("MO", "Ashburn"),
  "63441": p("MO", "Frankford"),
  "64018": p("MO", "Camden Point"),
  "64028": p("MO", "Farley"),
  "64079": p("MO", "Platte City"),
  "64092": p("MO", "Waldron"),
  "64098": p("MO", "Weston"),
  "64150": p("MO", "Riverside"),
  "64151": p("MO", "Kansas City"),
  "64152": p("MO", "Kansas City"),
  "64153": p("MO", "Kansas City"),
  "64154": p("MO", "Kansas City"),
  "64163": p("MO", "Kansas City"),
  "64164": p("MO", "Kansas City"),
  "64168": p("MO", "Kansas City"),
  "64190": p("MO", "Kansas City"),
  "64195": p("MO", "Kansas City"),
  "64439": p("MO", "Dearborn"),
  "64444": p("MO", "Edgerton"),
  "65601": p("MO", "Aldrich"),
  "65613": p("MO", "Bolivar"),
  "65617": p("MO", "Brighton"),
  "65640": p("MO", "Dunnegan"),
  "65645": p("MO", "Eudora"),
  "65649": p("MO", "Fair Play"),
  "65650": p("MO", "Flemington"),
  "65663": p("MO", "Half Way"),
  "65674": p("MO", "Humansville"),
  "65710": p("MO", "Morrisville"),
  "65725": p("MO", "Pleasant Hope"),
  "65727": p("MO", "Polk"),
  "65452": p("MO", "Crocker"),
  "65457": p("MO", "Devils Elbow"),
  "65459": p("MO", "Dixon"),
  "65473": p("MO", "Fort Leonard Wood"),
  "65534": p("MO", "Laquey"),
  "65556": p("MO", "Richland"),
  "65583": p("MO", "Waynesville"),
  "65584": p("MO", "Saint Robert"),
  "63551": p("MO", "Livonia"),
  "63565": p("MO", "Unionville"),
  "63567": p("MO", "Worthington"),
  "64655": p("MO", "Lucerne"),
  "64672": p("MO", "Powersville"),
  "63436": p("MO", "Center"),
  "63459": p("MO", "New London"),
  "63462": p("MO", "Perry"),
  "63467": p("MO", "Saverton"),
  "65239": p("MO", "Cairo"),
  "65243": p("MO", "Clark"),
  "65244": p("MO", "Clifton Hill"),
  "65257": p("MO", "Higbee"),
  "65259": p("MO", "Huntsville"),
  "65260": p("MO", "Jacksonville"),
  "65270": p("MO", "Moberly"),
  "65278": p("MO", "Renick"),
  "64017": p("MO", "Camden"),
  "64035": p("MO", "Hardin"),
  "64036": p("MO", "Henrietta"),
  "64062": p("MO", "Lawson"),
  "64077": p("MO", "Orrick"),
  "64084": p("MO", "Rayville"),
  "64085": p("MO", "Richmond"),
  "63625": p("MO", "Black"),
  "63629": p("MO", "Bunker"),
  "63633": p("MO", "Centerville"),
  "63638": p("MO", "Ellington"),
  "63654": p("MO", "Lesterville"),
  "63665": p("MO", "Redford"),
  "63666": p("MO", "Reynolds"),
  "63931": p("MO", "Briar"),
  "63935": p("MO", "Doniphan"),
  "63939": p("MO", "Fairdealing"),
  "63942": p("MO", "Gatewood"),
  "63953": p("MO", "Naylor"),
  "63955": p("MO", "Oxly"),
  "63301": p("MO", "Saint Charles"),
  "63302": p("MO", "Saint Charles"),
  "63303": p("MO", "Saint Charles"),
  "63304": p("MO", "Saint Charles"),
  "63332": p("MO", "Augusta"),
  "63338": p("MO", "Cottleville"),
  "63341": p("MO", "Defiance"),
  "63346": p("MO", "Flinthill"),
  "63348": p("MO", "Foristell"),
  "63365": p("MO", "New Melle"),
  "63366": p("MO", "O Fallon"),
  "63367": p("MO", "Lake Saint Louis"),
  "63368": p("MO", "O Fallon"),
  "63373": p("MO", "Portage Des Sioux"),
  "63376": p("MO", "Saint Peters"),
  "63385": p("MO", "Wentzville"),
  "63386": p("MO", "West Alton"),
  "64724": p("MO", "Appleton City"),
  "64738": p("MO", "Collins"),
  "64763": p("MO", "Lowry City"),
  "64776": p("MO", "Osceola"),
  "64781": p("MO", "Roscoe"),
  "63627": p("MO", "Bloomsdale"),
  "63670": p("MO", "Sainte Genevieve"),
  "63673": p("MO", "Saint Mary"),
  "63036": p("MO", "French Village"),
  "63087": p("MO", "Valles Mines"),
  "63601": p("MO", "Park Hills"),
  "63624": p("MO", "Bismarck"),
  "63626": p("MO", "Blackwell"),
  "63628": p("MO", "Bonne Terre"),
  "63637": p("MO", "Doe Run"),
  "63640": p("MO", "Farmington"),
  "63651": p("MO", "Knob Lick"),
  "63653": p("MO", "Leadwood"),
  "63005": p("MO", "Chesterfield"),
  "63006": p("MO", "Chesterfield"),
  "63011": p("MO", "Ballwin"),
  "63017": p("MO", "Chesterfield"),
  "63021": p("MO", "Ballwin"),
  "63022": p("MO", "Ballwin"),
  "63024": p("MO", "Ballwin"),
  "63025": p("MO", "Eureka"),
  "63026": p("MO", "Fenton"),
  "63031": p("MO", "Florissant"),
  "63032": p("MO", "Florissant"),
  "63033": p("MO", "Florissant"),
  "63034": p("MO", "Florissant"),
  "63038": p("MO", "Glencoe"),
  "63040": p("MO", "Grover"),
  "63042": p("MO", "Hazelwood"),
  "63043": p("MO", "Maryland Heights"),
  "63044": p("MO", "Bridgeton"),
  "63045": p("MO", "Earth City"),
  "63074": p("MO", "Saint Ann"),
  "63088": p("MO", "Valley Park"),
  "63099": p("MO", "Fenton"),
  "63105": p("MO", "Saint Louis"),
  "63114": p("MO", "Saint Louis"),
  "63117": p("MO", "Saint Louis"),
  "63119": p("MO", "Saint Louis"),
  "63121": p("MO", "Saint Louis"),
  "63122": p("MO", "Saint Louis"),
  "63123": p("MO", "Saint Louis"),
  "63124": p("MO", "Saint Louis"),
  "63125": p("MO", "Saint Louis"),
  "63126": p("MO", "Saint Louis"),
  "63127": p("MO", "Saint Louis"),
  "63128": p("MO", "Saint Louis"),
  "63129": p("MO", "Saint Louis"),
  "63130": p("MO", "Saint Louis"),
  "63131": p("MO", "Saint Louis"),
  "63132": p("MO", "Saint Louis"),
  "63133": p("MO", "Saint Louis"),
  "63134": p("MO", "Saint Louis"),
  "63135": p("MO", "Saint Louis"),
  "63136": p("MO", "Saint Louis"),
  "63137": p("MO", "Saint Louis"),
  "63138": p("MO", "Saint Louis"),
  "63140": p("MO", "Saint Louis"),
  "63141": p("MO", "Saint Louis"),
  "63143": p("MO", "Saint Louis"),
  "63144": p("MO", "Saint Louis"),
  "63145": p("MO", "Saint Louis"),
  "63146": p("MO", "Saint Louis"),
  "63151": p("MO", "Saint Louis"),
  "63167": p("MO", "Saint Louis"),
  "65320": p("MO", "Arrow Rock"),
  "65321": p("MO", "Blackburn"),
  "65330": p("MO", "Gilliam"),
  "65339": p("MO", "Malta Bend"),
  "65340": p("MO", "Marshall"),
  "65344": p("MO", "Miami"),
  "65347": p("MO", "Nelson"),
  "65349": p("MO", "Slater"),
  "65351": p("MO", "Sweet Springs"),
  "63535": p("MO", "Coatsville"),
  "63536": p("MO", "Downing"),
  "63541": p("MO", "Glenwood"),
  "63548": p("MO", "Lancaster"),
  "63561": p("MO", "Queen City"),
  "63432": p("MO", "Arbela"),
  "63442": p("MO", "Granger"),
  "63543": p("MO", "Gorin"),
  "63555": p("MO", "Memphis"),
  "63563": p("MO", "Rutledge"),
  "63736": p("MO", "Benton"),
  "63740": p("MO", "Chaffee"),
  "63742": p("MO", "Commerce"),
  "63758": p("MO", "Kelso"),
  "63767": p("MO", "Morley"),
  "63771": p("MO", "Oran"),
  "63774": p("MO", "Perkins"),
  "63780": p("MO", "Scott City"),
  "63784": p("MO", "Vanduser"),
  "63801": p("MO", "Sikeston"),
  "63824": p("MO", "Blodgett"),
  "65438": p("MO", "Birch Tree"),
  "65466": p("MO", "Eminence"),
  "65546": p("MO", "Montier"),
  "65588": p("MO", "Winona"),
  "63434": p("MO", "Bethel"),
  "63437": p("MO", "Clarence"),
  "63439": p("MO", "Emden"),
  "63443": p("MO", "Hunnewell"),
  "63450": p("MO", "Lentner"),
  "63451": p("MO", "Leonard"),
  "63468": p("MO", "Shelbina"),
  "63469": p("MO", "Shelbyville"),
  "63730": p("MO", "Advance"),
  "63735": p("MO", "Bell City"),
  "63738": p("MO", "Brownwood"),
  "63822": p("MO", "Bernie"),
  "63825": p("MO", "Bloomfield"),
  "63841": p("MO", "Dexter"),
  "63846": p("MO", "Essex"),
  "63850": p("MO", "Grayridge"),
  "63936": p("MO", "Dudley"),
  "63960": p("MO", "Puxico"),
  "65611": p("MO", "Blue Eye"),
  "65624": p("MO", "Cape Fair"),
  "65633": p("MO", "Crane"),
  "65656": p("MO", "Galena"),
  "65675": p("MO", "Hurley"),
  "65681": p("MO", "Lampe"),
  "65686": p("MO", "Kimberling City"),
  "65728": p("MO", "Ponce De Leon"),
  "65737": p("MO", "Reeds Spring"),
  "63544": p("MO", "Green Castle"),
  "63545": p("MO", "Green City"),
  "63556": p("MO", "Milan"),
  "63560": p("MO", "Pollock"),
  "63566": p("MO", "Winigan"),
  "64645": p("MO", "Harris"),
  "64646": p("MO", "Humphreys"),
  "64667": p("MO", "Newtown"),
  "65614": p("MO", "Bradleyville"),
  "65615": p("MO", "Branson"),
  "65616": p("MO", "Branson"),
  "65627": p("MO", "Cedarcreek"),
  "65653": p("MO", "Forsyth"),
  "65672": p("MO", "Hollister"),
  "65673": p("MO", "Hollister"),
  "65679": p("MO", "Kirbyville"),
  "65680": p("MO", "Kissee Mills"),
  "65726": p("MO", "Point Lookout"),
  "65731": p("MO", "Powersite"),
  "65733": p("MO", "Protem"),
  "65739": p("MO", "Ridgedale"),
  "65740": p("MO", "Rockaway Beach"),
  "65744": p("MO", "Rueter"),
  "65759": p("MO", "Taneyville"),
  "65771": p("MO", "Walnut Shade"),
  "65444": p("MO", "Bucyrus"),
  "65464": p("MO", "Elk Creek"),
  "65468": p("MO", "Eunice"),
  "65479": p("MO", "Hartshorn"),
  "65483": p("MO", "Houston"),
  "65484": p("MO", "Huggins"),
  "65542": p("MO", "Licking"),
  "65552": p("MO", "Plato"),
  "65555": p("MO", "Raymondville"),
  "65557": p("MO", "Roby"),
  "65564": p("MO", "Solo"),
  "65570": p("MO", "Success"),
  "65571": p("MO", "Summersville"),
  "65589": p("MO", "Yukon"),
  "65689": p("MO", "Cabool"),
  "64728": p("MO", "Bronaugh"),
  "64741": p("MO", "Deerfield"),
  "64750": p("MO", "Harwood"),
  "64765": p("MO", "Metz"),
  "64767": p("MO", "Milo"),
  "64771": p("MO", "Moundville"),
  "64772": p("MO", "Nevada"),
  "64778": p("MO", "Richards"),
  "64783": p("MO", "Schell City"),
  "64784": p("MO", "Sheldon"),
  "64790": p("MO", "Walker"),
  "63342": p("MO", "Dutzow"),
  "63357": p("MO", "Marthasville"),
  "63378": p("MO", "Treloar"),
  "63380": p("MO", "Truesdale"),
  "63383": p("MO", "Warrenton"),
  "63390": p("MO", "Wright City"),
  "63071": p("MO", "Richwoods"),
  "63622": p("MO", "Belgrade"),
  "63630": p("MO", "Cadet"),
  "63631": p("MO", "Caledonia"),
  "63648": p("MO", "Irondale"),
  "63660": p("MO", "Mineral Point"),
  "63664": p("MO", "Potosi"),
  "63674": p("MO", "Tiff"),
  "63632": p("MO", "Cascade"),
  "63763": p("MO", "Mc Gee"),
  "63934": p("MO", "Clubb"),
  "63944": p("MO", "Greenville"),
  "63950": p("MO", "Lodi"),
  "63951": p("MO", "Lowndes"),
  "63952": p("MO", "Mill Spring"),
  "63956": p("MO", "Patterson"),
  "63957": p("MO", "Piedmont"),
  "63964": p("MO", "Silva"),
  "63966": p("MO", "Wappapello"),
  "63967": p("MO", "Williamsville"),
  "65636": p("MO", "Diggins"),
  "65644": p("MO", "Elkland"),
  "65652": p("MO", "Fordland"),
  "65706": p("MO", "Marshfield"),
  "65713": p("MO", "Niangua"),
  "65742": p("MO", "Rogersville"),
  "65746": p("MO", "Seymour"),
  "64420": p("MO", "Allendale"),
  "64441": p("MO", "Denver"),
  "64456": p("MO", "Grant City"),
  "64486": p("MO", "Sheridan"),
  "64499": p("MO", "Worth"),
  "65660": p("MO", "Graff"),
  "65662": p("MO", "Grovespring"),
  "65667": p("MO", "Hartville"),
  "65702": p("MO", "Macomb"),
  "65704": p("MO", "Mansfield"),
  "65711": p("MO", "Mountain Grove"),
  "65717": p("MO", "Norwood"),
  "63101": p("MO", "Saint Louis"),
  "63102": p("MO", "Saint Louis"),
  "63103": p("MO", "Saint Louis"),
  "63104": p("MO", "Saint Louis"),
  "63106": p("MO", "Saint Louis"),
  "63107": p("MO", "Saint Louis"),
  "63108": p("MO", "Saint Louis"),
  "63109": p("MO", "Saint Louis"),
  "63110": p("MO", "Saint Louis"),
  "63111": p("MO", "Saint Louis"),
  "63112": p("MO", "Saint Louis"),
  "63113": p("MO", "Saint Louis"),
  "63115": p("MO", "Saint Louis"),
  "63116": p("MO", "Saint Louis"),
  "63118": p("MO", "Saint Louis"),
  "63120": p("MO", "Saint Louis"),
  "63139": p("MO", "Saint Louis"),
  "63147": p("MO", "Saint Louis"),
  "63150": p("MO", "Saint Louis"),
  "63155": p("MO", "Saint Louis"),
  "63156": p("MO", "Saint Louis"),
  "63157": p("MO", "Saint Louis"),
  "63158": p("MO", "Saint Louis"),
  "63160": p("MO", "Saint Louis"),
  "63163": p("MO", "Saint Louis"),
  "63164": p("MO", "Saint Louis"),
  "63166": p("MO", "Saint Louis"),
  "63169": p("MO", "Saint Louis"),
  "63171": p("MO", "Saint Louis"),
  "63177": p("MO", "Saint Louis"),
  "63178": p("MO", "Saint Louis"),
  "63179": p("MO", "Saint Louis"),
  "63180": p("MO", "Saint Louis"),
  "63182": p("MO", "Saint Louis"),
  "63188": p("MO", "Saint Louis"),
  "63195": p("MO", "Saint Louis"),
  "63197": p("MO", "Saint Louis"),
  "63199": p("MO", "Saint Louis"),
  "39120": p("MS", "Natchez"),
  "39121": p("MS", "Natchez"),
  "39122": p("MS", "Natchez"),
  "39165": p("MS", "Sibley"),
  "39190": p("MS", "Washington"),
  "38834": p("MS", "Corinth"),
  "38835": p("MS", "Corinth"),
  "38846": p("MS", "Glen"),
  "38865": p("MS", "Rienzi"),
  "39633": p("MS", "Crosby"),
  "39638": p("MS", "Gloster"),
  "39645": p("MS", "Liberty"),
  "39664": p("MS", "Smithdale"),
  "39067": p("MS", "Ethel"),
  "39090": p("MS", "Kosciusko"),
  "39107": p("MS", "Mc Adams"),
  "39108": p("MS", "Mc Cool"),
  "39160": p("MS", "Sallis"),
  "38603": p("MS", "Ashland"),
  "38633": p("MS", "Hickory Flat"),
  "38647": p("MS", "Michigan City"),
  "38720": p("MS", "Alligator"),
  "38725": p("MS", "Benoit"),
  "38726": p("MS", "Beulah"),
  "38730": p("MS", "Boyle"),
  "38732": p("MS", "Cleveland"),
  "38733": p("MS", "Cleveland"),
  "38740": p("MS", "Duncan"),
  "38746": p("MS", "Gunnison"),
  "38759": p("MS", "Merigold"),
  "38762": p("MS", "Mound Bayou"),
  "38764": p("MS", "Pace"),
  "38769": p("MS", "Rosedale"),
  "38772": p("MS", "Scott"),
  "38773": p("MS", "Shaw"),
  "38774": p("MS", "Shelby"),
  "38781": p("MS", "Winstonville"),
  "38839": p("MS", "Derma"),
  "38878": p("MS", "Vardaman"),
  "38913": p("MS", "Banner"),
  "38914": p("MS", "Big Creek"),
  "38915": p("MS", "Bruce"),
  "38916": p("MS", "Calhoun City"),
  "38951": p("MS", "Pittsboro"),
  "38955": p("MS", "Slate Spring"),
  "39751": p("MS", "Mantee"),
  "38917": p("MS", "Carrollton"),
  "38923": p("MS", "Coila"),
  "38943": p("MS", "Mc Carley"),
  "38947": p("MS", "North Carrollton"),
  "38954": p("MS", "Sidon"),
  "39176": p("MS", "Vaiden"),
  "38850": p("MS", "Houlka"),
  "38851": p("MS", "Houston"),
  "38860": p("MS", "Okolona"),
  "38875": p("MS", "Trebloc"),
  "38877": p("MS", "Van Vleet"),
  "39776": p("MS", "Woodland"),
  "39735": p("MS", "Ackerman"),
  "39745": p("MS", "French Camp"),
  "39772": p("MS", "Weir"),
  "39086": p("MS", "Hermanville"),
  "39144": p("MS", "Pattison"),
  "39150": p("MS", "Port Gibson"),
  "39330": p("MS", "Enterprise"),
  "39347": p("MS", "Pachuta"),
  "39355": p("MS", "Quitman"),
  "39360": p("MS", "Shubuta"),
  "39363": p("MS", "Stonewall"),
  "39741": p("MS", "Cedarbluff"),
  "39754": p("MS", "Montpelier"),
  "39755": p("MS", "Pheba"),
  "39773": p("MS", "West Point"),
  "38614": p("MS", "Clarksdale"),
  "38617": p("MS", "Coahoma"),
  "38630": p("MS", "Farrell"),
  "38631": p("MS", "Friars Point"),
  "38639": p("MS", "Jonestown"),
  "38644": p("MS", "Lula"),
  "38645": p("MS", "Lyon"),
  "38669": p("MS", "Sherard"),
  "38739": p("MS", "Dublin"),
  "38767": p("MS", "Rena Lara"),
  "39059": p("MS", "Crystal Springs"),
  "39077": p("MS", "Gallman"),
  "39078": p("MS", "Georgetown"),
  "39083": p("MS", "Hazlehurst"),
  "39191": p("MS", "Wesson"),
  "39119": p("MS", "Mount Olive"),
  "39428": p("MS", "Collins"),
  "39479": p("MS", "Seminary"),
  "38632": p("MS", "Hernando"),
  "38637": p("MS", "Horn Lake"),
  "38641": p("MS", "Lake Cormorant"),
  "38651": p("MS", "Nesbit"),
  "38654": p("MS", "Olive Branch"),
  "38671": p("MS", "Southaven"),
  "38672": p("MS", "Southaven"),
  "38680": p("MS", "Walls"),
  "38686": p("MS", "Walls"),
  "39401": p("MS", "Hattiesburg"),
  "39402": p("MS", "Hattiesburg"),
  "39403": p("MS", "Hattiesburg"),
  "39404": p("MS", "Hattiesburg"),
  "39406": p("MS", "Hattiesburg"),
  "39407": p("MS", "Hattiesburg"),
  "39425": p("MS", "Brooklyn"),
  "39465": p("MS", "Petal"),
  "39630": p("MS", "Bude"),
  "39647": p("MS", "Mc Call Creek"),
  "39653": p("MS", "Meadville"),
  "39661": p("MS", "Roxie"),
  "39452": p("MS", "Lucedale"),
  "39362": p("MS", "State Line"),
  "39451": p("MS", "Leakesville"),
  "39456": p("MS", "Mc Lain"),
  "39461": p("MS", "Neely"),
  "38901": p("MS", "Grenada"),
  "38902": p("MS", "Grenada"),
  "38926": p("MS", "Elliott"),
  "38929": p("MS", "Gore Springs"),
  "38940": p("MS", "Holcomb"),
  "38960": p("MS", "Tie Plant"),
  "39520": p("MS", "Bay Saint Louis"),
  "39521": p("MS", "Bay Saint Louis"),
  "39522": p("MS", "Stennis Space Center"),
  "39525": p("MS", "Diamondhead"),
  "39529": p("MS", "Stennis Space Center"),
  "39556": p("MS", "Kiln"),
  "39558": p("MS", "Lakeshore"),
  "39572": p("MS", "Pearlington"),
  "39576": p("MS", "Waveland"),
  "39501": p("MS", "Gulfport"),
  "39502": p("MS", "Gulfport"),
  "39503": p("MS", "Gulfport"),
  "39505": p("MS", "Gulfport"),
  "39506": p("MS", "Gulfport"),
  "39507": p("MS", "Gulfport"),
  "39530": p("MS", "Biloxi"),
  "39531": p("MS", "Biloxi"),
  "39532": p("MS", "Biloxi"),
  "39533": p("MS", "Biloxi"),
  "39534": p("MS", "Biloxi"),
  "39535": p("MS", "Biloxi"),
  "39540": p("MS", "Diberville"),
  "39560": p("MS", "Long Beach"),
  "39571": p("MS", "Pass Christian"),
  "39574": p("MS", "Saucier"),
  "39041": p("MS", "Bolton"),
  "39056": p("MS", "Clinton"),
  "39058": p("MS", "Clinton"),
  "39060": p("MS", "Clinton"),
  "39066": p("MS", "Edwards"),
  "39154": p("MS", "Raymond"),
  "39170": p("MS", "Terry"),
  "39174": p("MS", "Tougaloo"),
  "39175": p("MS", "Utica"),
  "39201": p("MS", "Jackson"),
  "39202": p("MS", "Jackson"),
  "39203": p("MS", "Jackson"),
  "39204": p("MS", "Jackson"),
  "39205": p("MS", "Jackson"),
  "39206": p("MS", "Jackson"),
  "39207": p("MS", "Jackson"),
  "39209": p("MS", "Jackson"),
  "39210": p("MS", "Jackson"),
  "39211": p("MS", "Jackson"),
  "39212": p("MS", "Jackson"),
  "39213": p("MS", "Jackson"),
  "39215": p("MS", "Jackson"),
  "39216": p("MS", "Jackson"),
  "39217": p("MS", "Jackson"),
  "39225": p("MS", "Jackson"),
  "39236": p("MS", "Jackson"),
  "39250": p("MS", "Jackson"),
  "39269": p("MS", "Jackson"),
  "39271": p("MS", "Jackson"),
  "39272": p("MS", "Byram"),
  "39282": p("MS", "Jackson"),
  "39283": p("MS", "Jackson"),
  "39284": p("MS", "Jackson"),
  "39286": p("MS", "Jackson"),
  "39289": p("MS", "Jackson"),
  "39296": p("MS", "Jackson"),
  "38924": p("MS", "Cruger"),
  "39063": p("MS", "Durant"),
  "39079": p("MS", "Goodman"),
  "39095": p("MS", "Lexington"),
  "39146": p("MS", "Pickens"),
  "39169": p("MS", "Tchula"),
  "39192": p("MS", "West"),
  "38754": p("MS", "Isola"),
  "39038": p("MS", "Belzoni"),
  "39097": p("MS", "Louise"),
  "39115": p("MS", "Midnight"),
  "39166": p("MS", "Silver City"),
  "38745": p("MS", "Grace"),
  "39113": p("MS", "Mayersville"),
  "39177": p("MS", "Valley Park"),
  "38843": p("MS", "Fulton"),
  "38847": p("MS", "Golden"),
  "38855": p("MS", "Mantachie"),
  "38858": p("MS", "Nettleton"),
  "38876": p("MS", "Tremont"),
  "39552": p("MS", "Escatawpa"),
  "39553": p("MS", "Gautier"),
  "39555": p("MS", "Hurley"),
  "39562": p("MS", "Moss Point"),
  "39563": p("MS", "Moss Point"),
  "39564": p("MS", "Ocean Springs"),
  "39565": p("MS", "Vancleave"),
  "39566": p("MS", "Ocean Springs"),
  "39567": p("MS", "Pascagoula"),
  "39568": p("MS", "Pascagoula"),
  "39569": p("MS", "Pascagoula"),
  "39581": p("MS", "Pascagoula"),
  "39595": p("MS", "Pascagoula"),
  "39338": p("MS", "Louin"),
  "39348": p("MS", "Paulding"),
  "39356": p("MS", "Rose Hill"),
  "39366": p("MS", "Vossburg"),
  "39422": p("MS", "Bay Springs"),
  "39439": p("MS", "Heidelberg"),
  "39460": p("MS", "Moss"),
  "39481": p("MS", "Stringer"),
  "39069": p("MS", "Fayette"),
  "39081": p("MS", "Harriston"),
  "39096": p("MS", "Lorman"),
  "39668": p("MS", "Union Church"),
  "39421": p("MS", "Bassfield"),
  "39427": p("MS", "Carson"),
  "39474": p("MS", "Prentiss"),
  "39436": p("MS", "Eastabuchie"),
  "39437": p("MS", "Ellisville"),
  "39440": p("MS", "Laurel"),
  "39441": p("MS", "Laurel"),
  "39442": p("MS", "Laurel"),
  "39443": p("MS", "Laurel"),
  "39459": p("MS", "Moselle"),
  "39477": p("MS", "Sandersville"),
  "39480": p("MS", "Soso"),
  "39328": p("MS", "De Kalb"),
  "39352": p("MS", "Porterville"),
  "39354": p("MS", "Preston"),
  "39358": p("MS", "Scooba"),
  "38601": p("MS", "Abbeville"),
  "38655": p("MS", "Oxford"),
  "38673": p("MS", "Taylor"),
  "38675": p("MS", "Tula"),
  "38677": p("MS", "University"),
  "38685": p("MS", "Waterford"),
  "38874": p("MS", "Toccopola"),
  "38949": p("MS", "Paris"),
  "39455": p("MS", "Lumberton"),
  "39475": p("MS", "Purvis"),
  "39482": p("MS", "Sumrall"),
  "39301": p("MS", "Meridian"),
  "39302": p("MS", "Meridian"),
  "39303": p("MS", "Meridian"),
  "39304": p("MS", "Meridian"),
  "39305": p("MS", "Meridian"),
  "39307": p("MS", "Meridian"),
  "39309": p("MS", "Meridian"),
  "39320": p("MS", "Bailey"),
  "39325": p("MS", "Collinsville"),
  "39326": p("MS", "Daleville"),
  "39335": p("MS", "Lauderdale"),
  "39342": p("MS", "Marion"),
  "39364": p("MS", "Toomsuba"),
  "39140": p("MS", "Newhebron"),
  "39641": p("MS", "Jayess"),
  "39654": p("MS", "Monticello"),
  "39656": p("MS", "Oak Vale"),
  "39663": p("MS", "Silver Creek"),
  "39665": p("MS", "Sontag"),
  "39051": p("MS", "Carthage"),
  "39094": p("MS", "Lena"),
  "39109": p("MS", "Madden"),
  "39171": p("MS", "Thomastown"),
  "39189": p("MS", "Walnut Grove"),
  "38801": p("MS", "Tupelo"),
  "38802": p("MS", "Tupelo"),
  "38803": p("MS", "Tupelo"),
  "38804": p("MS", "Tupelo"),
  "38824": p("MS", "Baldwyn"),
  "38826": p("MS", "Belden"),
  "38849": p("MS", "Guntown"),
  "38857": p("MS", "Mooreville"),
  "38862": p("MS", "Plantersville"),
  "38866": p("MS", "Saltillo"),
  "38868": p("MS", "Shannon"),
  "38879": p("MS", "Verona"),
  "38930": p("MS", "Greenwood"),
  "38935": p("MS", "Greenwood"),
  "38941": p("MS", "Itta Bena"),
  "38944": p("MS", "Minter City"),
  "38945": p("MS", "Money"),
  "38946": p("MS", "Morgan City"),
  "38952": p("MS", "Schlater"),
  "38959": p("MS", "Swiftown"),
  "39601": p("MS", "Brookhaven"),
  "39602": p("MS", "Brookhaven"),
  "39603": p("MS", "Brookhaven"),
  "39629": p("MS", "Bogue Chitto"),
  "39662": p("MS", "Ruth"),
  "39701": p("MS", "Columbus"),
  "39702": p("MS", "Columbus"),
  "39703": p("MS", "Columbus"),
  "39704": p("MS", "Columbus"),
  "39705": p("MS", "Columbus"),
  "39710": p("MS", "Columbus"),
  "39736": p("MS", "Artesia"),
  "39743": p("MS", "Crawford"),
  "39753": p("MS", "Mayhew"),
  "39766": p("MS", "Steens"),
  "39045": p("MS", "Camden"),
  "39046": p("MS", "Canton"),
  "39071": p("MS", "Flora"),
  "39110": p("MS", "Madison"),
  "39130": p("MS", "Madison"),
  "39157": p("MS", "Ridgeland"),
  "39158": p("MS", "Ridgeland"),
  "39163": p("MS", "Sharon"),
  "39429": p("MS", "Columbia"),
  "39478": p("MS", "Sandy Hook"),
  "39483": p("MS", "Foxworth"),
  "39643": p("MS", "Kokomo"),
  "38611": p("MS", "Byhalia"),
  "38634": p("MS", "Holly Springs"),
  "38635": p("MS", "Holly Springs"),
  "38642": p("MS", "Lamar"),
  "38649": p("MS", "Mount Pleasant"),
  "38659": p("MS", "Potts Camp"),
  "38661": p("MS", "Red Banks"),
  "38679": p("MS", "Victoria"),
  "38821": p("MS", "Amory"),
  "38825": p("MS", "Becker"),
  "38844": p("MS", "Gattman"),
  "38848": p("MS", "Greenwood Springs"),
  "38870": p("MS", "Smithville"),
  "39730": p("MS", "Aberdeen"),
  "39740": p("MS", "Caledonia"),
  "39746": p("MS", "Hamilton"),
  "39756": p("MS", "Prairie"),
  "38925": p("MS", "Duck Hill"),
  "38967": p("MS", "Winona"),
  "39747": p("MS", "Kilmichael"),
  "39767": p("MS", "Stewart"),
  "39350": p("MS", "Philadelphia"),
  "39365": p("MS", "Union"),
  "39057": p("MS", "Conehatta"),
  "39323": p("MS", "Chunky"),
  "39327": p("MS", "Decatur"),
  "39332": p("MS", "Hickory"),
  "39336": p("MS", "Lawrence"),
  "39337": p("MS", "Little Rock"),
  "39345": p("MS", "Newton"),
  "39341": p("MS", "Macon"),
  "39361": p("MS", "Shuqualak"),
  "39739": p("MS", "Brooksville"),
  "39759": p("MS", "Starkville"),
  "39760": p("MS", "Starkville"),
  "39762": p("MS", "Mississippi State"),
  "39769": p("MS", "Sturgis"),
  "38606": p("MS", "Batesville"),
  "38619": p("MS", "Como"),
  "38620": p("MS", "Courtland"),
  "38621": p("MS", "Crenshaw"),
  "38658": p("MS", "Pope"),
  "38665": p("MS", "Sarah"),
  "38666": p("MS", "Sardis"),
  "39426": p("MS", "Carriere"),
  "39457": p("MS", "Mc Neill"),
  "39463": p("MS", "Nicholson"),
  "39466": p("MS", "Picayune"),
  "39470": p("MS", "Poplarville"),
  "39423": p("MS", "Beaumont"),
  "39462": p("MS", "New Augusta"),
  "39464": p("MS", "Ovett"),
  "39476": p("MS", "Richton"),
  "39632": p("MS", "Chatawa"),
  "39635": p("MS", "Fernwood"),
  "39648": p("MS", "Mccomb"),
  "39649": p("MS", "Mccomb"),
  "39652": p("MS", "Magnolia"),
  "39657": p("MS", "Osyka"),
  "39666": p("MS", "Summit"),
  "38820": p("MS", "Algoma"),
  "38841": p("MS", "Ecru"),
  "38863": p("MS", "Pontotoc"),
  "38864": p("MS", "Randolph"),
  "38869": p("MS", "Sherman"),
  "38871": p("MS", "Thaxton"),
  "38829": p("MS", "Booneville"),
  "38856": p("MS", "Marietta"),
  "38859": p("MS", "New Site"),
  "38880": p("MS", "Wheeler"),
  "38609": p("MS", "Belen"),
  "38622": p("MS", "Crowder"),
  "38623": p("MS", "Darling"),
  "38628": p("MS", "Falcon"),
  "38643": p("MS", "Lambert"),
  "38646": p("MS", "Marks"),
  "38964": p("MS", "Vance"),
  "39042": p("MS", "Brandon"),
  "39043": p("MS", "Brandon"),
  "39047": p("MS", "Brandon"),
  "39073": p("MS", "Florence"),
  "39145": p("MS", "Pelahatchie"),
  "39148": p("MS", "Piney Woods"),
  "39151": p("MS", "Puckett"),
  "39161": p("MS", "Sandhill"),
  "39167": p("MS", "Star"),
  "39193": p("MS", "Whitfield"),
  "39208": p("MS", "Pearl"),
  "39218": p("MS", "Richland"),
  "39232": p("MS", "Flowood"),
  "39288": p("MS", "Pearl"),
  "39298": p("MS", "Jackson"),
  "39074": p("MS", "Forest"),
  "39080": p("MS", "Harperville"),
  "39087": p("MS", "Hillsboro"),
  "39092": p("MS", "Lake"),
  "39098": p("MS", "Ludlow"),
  "39117": p("MS", "Morton"),
  "39152": p("MS", "Pulaski"),
  "39359": p("MS", "Sebastopol"),
  "38721": p("MS", "Anguilla"),
  "38765": p("MS", "Panther Burn"),
  "39054": p("MS", "Cary"),
  "39061": p("MS", "Delta City"),
  "39159": p("MS", "Rolling Fork"),
  "39044": p("MS", "Braxton"),
  "39062": p("MS", "D Lo"),
  "39082": p("MS", "Harrisville"),
  "39111": p("MS", "Magee"),
  "39114": p("MS", "Mendenhall"),
  "39149": p("MS", "Pinola"),
  "39116": p("MS", "Mize"),
  "39153": p("MS", "Raleigh"),
  "39168": p("MS", "Taylorsville"),
  "39561": p("MS", "Mc Henry"),
  "39573": p("MS", "Perkinston"),
  "39577": p("MS", "Wiggins"),
  "38736": p("MS", "Doddsville"),
  "38737": p("MS", "Drew"),
  "38738": p("MS", "Parchman"),
  "38749": p("MS", "Indianola"),
  "38751": p("MS", "Indianola"),
  "38753": p("MS", "Inverness"),
  "38761": p("MS", "Moorhead"),
  "38768": p("MS", "Rome"),
  "38771": p("MS", "Ruleville"),
  "38778": p("MS", "Sunflower"),
  "38920": p("MS", "Cascilla"),
  "38921": p("MS", "Charleston"),
  "38927": p("MS", "Enid"),
  "38928": p("MS", "Glendora"),
  "38950": p("MS", "Philipp"),
  "38957": p("MS", "Sumner"),
  "38958": p("MS", "Swan Lake"),
  "38962": p("MS", "Tippo"),
  "38963": p("MS", "Tutwiler"),
  "38966": p("MS", "Webb"),
  "38602": p("MS", "Arkabutla"),
  "38618": p("MS", "Coldwater"),
  "38638": p("MS", "Independence"),
  "38668": p("MS", "Senatobia"),
  "38610": p("MS", "Blue Mountain"),
  "38625": p("MS", "Dumas"),
  "38629": p("MS", "Falkner"),
  "38663": p("MS", "Ripley"),
  "38674": p("MS", "Tiplersville"),
  "38683": p("MS", "Walnut"),
  "38827": p("MS", "Belmont"),
  "38833": p("MS", "Burnsville"),
  "38838": p("MS", "Dennis"),
  "38852": p("MS", "Iuka"),
  "38873": p("MS", "Tishomingo"),
  "38626": p("MS", "Dundee"),
  "38664": p("MS", "Robinsonville"),
  "38670": p("MS", "Sledge"),
  "38676": p("MS", "Tunica"),
  "38627": p("MS", "Etta"),
  "38650": p("MS", "Myrtle"),
  "38652": p("MS", "New Albany"),
  "38828": p("MS", "Blue Springs"),
  "39667": p("MS", "Tylertown"),
  "39156": p("MS", "Redwood"),
  "39180": p("MS", "Vicksburg"),
  "39181": p("MS", "Vicksburg"),
  "39182": p("MS", "Vicksburg"),
  "39183": p("MS", "Vicksburg"),
  "38701": p("MS", "Greenville"),
  "38702": p("MS", "Greenville"),
  "38703": p("MS", "Greenville"),
  "38704": p("MS", "Greenville"),
  "38722": p("MS", "Arcola"),
  "38723": p("MS", "Avon"),
  "38731": p("MS", "Chatham"),
  "38744": p("MS", "Glen Allan"),
  "38748": p("MS", "Hollandale"),
  "38756": p("MS", "Leland"),
  "38760": p("MS", "Metcalfe"),
  "38776": p("MS", "Stoneville"),
  "38780": p("MS", "Wayside"),
  "38782": p("MS", "Winterville"),
  "39322": p("MS", "Buckatunna"),
  "39324": p("MS", "Clara"),
  "39367": p("MS", "Waynesboro"),
  "39737": p("MS", "Bellefontaine"),
  "39744": p("MS", "Eupora"),
  "39750": p("MS", "Maben"),
  "39752": p("MS", "Mathiston"),
  "39771": p("MS", "Walthall"),
  "39631": p("MS", "Centreville"),
  "39669": p("MS", "Woodville"),
  "39339": p("MS", "Louisville"),
  "39346": p("MS", "Noxapater"),
  "38922": p("MS", "Coffeeville"),
  "38948": p("MS", "Oakland"),
  "38953": p("MS", "Scobey"),
  "38961": p("MS", "Tillatoba"),
  "38965": p("MS", "Water Valley"),
  "39039": p("MS", "Benton"),
  "39040": p("MS", "Bentonia"),
  "39088": p("MS", "Holly Bluff"),
  "39162": p("MS", "Satartia"),
  "39173": p("MS", "Tinsley"),
  "39179": p("MS", "Vaughan"),
  "39194": p("MS", "Yazoo City"),
  "59724": p("MT", "Dell"),
  "59725": p("MT", "Dillon"),
  "59732": p("MT", "Glen"),
  "59736": p("MT", "Jackson"),
  "59739": p("MT", "Lima"),
  "59746": p("MT", "Polaris"),
  "59761": p("MT", "Wisdom"),
  "59762": p("MT", "Wise River"),
  "59016": p("MT", "Busby"),
  "59022": p("MT", "Crow Agency"),
  "59025": p("MT", "Decker"),
  "59031": p("MT", "Garryowen"),
  "59034": p("MT", "Hardin"),
  "59035": p("MT", "Fort Smith"),
  "59050": p("MT", "Lodge Grass"),
  "59066": p("MT", "Pryor"),
  "59075": p("MT", "Saint Xavier"),
  "59089": p("MT", "Wyola"),
  "59523": p("MT", "Chinook"),
  "59526": p("MT", "Harlem"),
  "59527": p("MT", "Hays"),
  "59529": p("MT", "Hogeland"),
  "59535": p("MT", "Lloyd"),
  "59542": p("MT", "Turner"),
  "59547": p("MT", "Zurich"),
  "59641": p("MT", "Radersburg"),
  "59643": p("MT", "Toston"),
  "59644": p("MT", "Townsend"),
  "59647": p("MT", "Winston"),
  "59007": p("MT", "Bearcreek"),
  "59008": p("MT", "Belfry"),
  "59013": p("MT", "Boyd"),
  "59014": p("MT", "Bridger"),
  "59026": p("MT", "Edgar"),
  "59029": p("MT", "Fromberg"),
  "59041": p("MT", "Joliet"),
  "59068": p("MT", "Red Lodge"),
  "59070": p("MT", "Roberts"),
  "59071": p("MT", "Roscoe"),
  "59311": p("MT", "Alzada"),
  "59316": p("MT", "Boyes"),
  "59319": p("MT", "Capitol"),
  "59324": p("MT", "Ekalaka"),
  "59332": p("MT", "Hammond"),
  "59401": p("MT", "Great Falls"),
  "59402": p("MT", "Malmstrom Afb"),
  "59403": p("MT", "Great Falls"),
  "59404": p("MT", "Great Falls"),
  "59405": p("MT", "Great Falls"),
  "59406": p("MT", "Great Falls"),
  "59412": p("MT", "Belt"),
  "59414": p("MT", "Black Eagle"),
  "59421": p("MT", "Cascade"),
  "59443": p("MT", "Fort Shaw"),
  "59463": p("MT", "Monarch"),
  "59465": p("MT", "Neihart"),
  "59472": p("MT", "Sand Coulee"),
  "59477": p("MT", "Simms"),
  "59480": p("MT", "Stockett"),
  "59483": p("MT", "Sun River"),
  "59485": p("MT", "Ulm"),
  "59487": p("MT", "Vaughn"),
  "59420": p("MT", "Carter"),
  "59440": p("MT", "Floweree"),
  "59442": p("MT", "Fort Benton"),
  "59446": p("MT", "Geraldine"),
  "59450": p("MT", "Highwood"),
  "59460": p("MT", "Loma"),
  "59520": p("MT", "Big Sandy"),
  "59301": p("MT", "Miles City"),
  "59336": p("MT", "Ismay"),
  "59338": p("MT", "Kinsey"),
  "59351": p("MT", "Volborg"),
  "59222": p("MT", "Flaxville"),
  "59253": p("MT", "Peerless"),
  "59263": p("MT", "Scobey"),
  "59276": p("MT", "Whitetail"),
  "59259": p("MT", "Richey"),
  "59315": p("MT", "Bloomfield"),
  "59330": p("MT", "Glendive"),
  "59339": p("MT", "Lindsay"),
  "59711": p("MT", "Anaconda"),
  "59756": p("MT", "Warm Springs"),
  "59313": p("MT", "Baker"),
  "59344": p("MT", "Plevna"),
  "59354": p("MT", "Willard"),
  "59032": p("MT", "Grass Range"),
  "59418": p("MT", "Buffalo"),
  "59424": p("MT", "Coffee Creek"),
  "59430": p("MT", "Denton"),
  "59441": p("MT", "Forest Grove"),
  "59451": p("MT", "Hilger"),
  "59457": p("MT", "Lewistown"),
  "59464": p("MT", "Moore"),
  "59471": p("MT", "Roy"),
  "59489": p("MT", "Winifred"),
  "59901": p("MT", "Kalispell"),
  "59903": p("MT", "Kalispell"),
  "59904": p("MT", "Kalispell"),
  "59911": p("MT", "Bigfork"),
  "59912": p("MT", "Columbia Falls"),
  "59913": p("MT", "Coram"),
  "59916": p("MT", "Essex"),
  "59919": p("MT", "Hungry Horse"),
  "59920": p("MT", "Kila"),
  "59921": p("MT", "Lake Mc Donald"),
  "59922": p("MT", "Lakeside"),
  "59925": p("MT", "Marion"),
  "59926": p("MT", "Martin City"),
  "59927": p("MT", "Olney"),
  "59928": p("MT", "Polebridge"),
  "59932": p("MT", "Somers"),
  "59936": p("MT", "West Glacier"),
  "59937": p("MT", "Whitefish"),
  "59714": p("MT", "Belgrade"),
  "59715": p("MT", "Bozeman"),
  "59716": p("MT", "Big Sky"),
  "59717": p("MT", "Bozeman"),
  "59718": p("MT", "Bozeman"),
  "59719": p("MT", "Bozeman"),
  "59730": p("MT", "Gallatin Gateway"),
  "59741": p("MT", "Manhattan"),
  "59752": p("MT", "Three Forks"),
  "59758": p("MT", "West Yellowstone"),
  "59760": p("MT", "Willow Creek"),
  "59771": p("MT", "Bozeman"),
  "59772": p("MT", "Bozeman"),
  "59058": p("MT", "Mosby"),
  "59077": p("MT", "Sand Springs"),
  "59318": p("MT", "Brusett"),
  "59322": p("MT", "Cohagen"),
  "59337": p("MT", "Jordan"),
  "59411": p("MT", "Babb"),
  "59417": p("MT", "Browning"),
  "59427": p("MT", "Cut Bank"),
  "59434": p("MT", "East Glacier Park"),
  "59046": p("MT", "Lavina"),
  "59074": p("MT", "Ryegate"),
  "59832": p("MT", "Drummond"),
  "59837": p("MT", "Hall"),
  "59858": p("MT", "Philipsburg"),
  "59501": p("MT", "Havre"),
  "59521": p("MT", "Box Elder"),
  "59525": p("MT", "Gildford"),
  "59528": p("MT", "Hingham"),
  "59530": p("MT", "Inverness"),
  "59532": p("MT", "Kremlin"),
  "59540": p("MT", "Rudyard"),
  "59631": p("MT", "Basin"),
  "59632": p("MT", "Boulder"),
  "59634": p("MT", "Clancy"),
  "59638": p("MT", "Jefferson City"),
  "59721": p("MT", "Cardwell"),
  "59759": p("MT", "Whitehall"),
  "59447": p("MT", "Geyser"),
  "59452": p("MT", "Hobson"),
  "59462": p("MT", "Moccasin"),
  "59469": p("MT", "Raynesford"),
  "59479": p("MT", "Stanford"),
  "59821": p("MT", "Arlee"),
  "59824": p("MT", "Charlo"),
  "59855": p("MT", "Pablo"),
  "59860": p("MT", "Polson"),
  "59863": p("MT", "Ravalli"),
  "59864": p("MT", "Ronan"),
  "59865": p("MT", "Saint Ignatius"),
  "59910": p("MT", "Big Arm"),
  "59914": p("MT", "Dayton"),
  "59915": p("MT", "Elmo"),
  "59929": p("MT", "Proctor"),
  "59931": p("MT", "Rollins"),
  "59410": p("MT", "Augusta"),
  "59601": p("MT", "Helena"),
  "59602": p("MT", "Helena"),
  "59604": p("MT", "Helena"),
  "59620": p("MT", "Helena"),
  "59623": p("MT", "Helena"),
  "59624": p("MT", "Helena"),
  "59625": p("MT", "Helena"),
  "59626": p("MT", "Helena"),
  "59633": p("MT", "Canyon Creek"),
  "59635": p("MT", "East Helena"),
  "59636": p("MT", "Fort Harrison"),
  "59639": p("MT", "Lincoln"),
  "59640": p("MT", "Marysville"),
  "59648": p("MT", "Wolf Creek"),
  "59522": p("MT", "Chester"),
  "59531": p("MT", "Joplin"),
  "59545": p("MT", "Whitlash"),
  "59917": p("MT", "Eureka"),
  "59918": p("MT", "Fortine"),
  "59923": p("MT", "Libby"),
  "59930": p("MT", "Rexford"),
  "59933": p("MT", "Stryker"),
  "59934": p("MT", "Trego"),
  "59935": p("MT", "Troy"),
  "59214": p("MT", "Brockway"),
  "59215": p("MT", "Circle"),
  "59274": p("MT", "Vida"),
  "59710": p("MT", "Alder"),
  "59720": p("MT", "Cameron"),
  "59729": p("MT", "Ennis"),
  "59735": p("MT", "Harrison"),
  "59740": p("MT", "Mc Allister"),
  "59745": p("MT", "Norris"),
  "59747": p("MT", "Pony"),
  "59749": p("MT", "Sheridan"),
  "59751": p("MT", "Silver Star"),
  "59754": p("MT", "Twin Bridges"),
  "59755": p("MT", "Virginia City"),
  "59053": p("MT", "Martinsdale"),
  "59642": p("MT", "Ringling"),
  "59645": p("MT", "White Sulphur Springs"),
  "59820": p("MT", "Alberton"),
  "59830": p("MT", "De Borgia"),
  "59842": p("MT", "Haugan"),
  "59866": p("MT", "Saint Regis"),
  "59867": p("MT", "Saltese"),
  "59872": p("MT", "Superior"),
  "59801": p("MT", "Missoula"),
  "59802": p("MT", "Missoula"),
  "59803": p("MT", "Missoula"),
  "59804": p("MT", "Missoula"),
  "59806": p("MT", "Missoula"),
  "59807": p("MT", "Missoula"),
  "59808": p("MT", "Missoula"),
  "59812": p("MT", "Missoula"),
  "59823": p("MT", "Bonner"),
  "59825": p("MT", "Clinton"),
  "59826": p("MT", "Condon"),
  "59834": p("MT", "Frenchtown"),
  "59846": p("MT", "Huson"),
  "59847": p("MT", "Lolo"),
  "59851": p("MT", "Milltown"),
  "59868": p("MT", "Seeley Lake"),
  "59054": p("MT", "Melstone"),
  "59059": p("MT", "Musselshell"),
  "59072": p("MT", "Roundup"),
  "59073": p("MT", "Roundup"),
  "59018": p("MT", "Clyde Park"),
  "59020": p("MT", "Cooke City"),
  "59027": p("MT", "Emigrant"),
  "59030": p("MT", "Gardiner"),
  "59047": p("MT", "Livingston"),
  "59065": p("MT", "Pray"),
  "59081": p("MT", "Silver Gate"),
  "59082": p("MT", "Springdale"),
  "59086": p("MT", "Wilsall"),
  "59084": p("MT", "Teigen"),
  "59087": p("MT", "Winnett"),
  "59261": p("MT", "Saco"),
  "59524": p("MT", "Dodson"),
  "59537": p("MT", "Loring"),
  "59538": p("MT", "Malta"),
  "59544": p("MT", "Whitewater"),
  "59546": p("MT", "Zortman"),
  "59416": p("MT", "Brady"),
  "59425": p("MT", "Conrad"),
  "59432": p("MT", "Dupuyer"),
  "59448": p("MT", "Heart Butte"),
  "59456": p("MT", "Ledger"),
  "59486": p("MT", "Valier"),
  "59062": p("MT", "Otter"),
  "59314": p("MT", "Biddle"),
  "59317": p("MT", "Broadus"),
  "59343": p("MT", "Olive"),
  "59345": p("MT", "Powderville"),
  "59713": p("MT", "Avon"),
  "59722": p("MT", "Deer Lodge"),
  "59728": p("MT", "Elliston"),
  "59731": p("MT", "Garrison"),
  "59733": p("MT", "Gold Creek"),
  "59843": p("MT", "Helmville"),
  "59854": p("MT", "Ovando"),
  "59326": p("MT", "Fallon"),
  "59341": p("MT", "Mildred"),
  "59349": p("MT", "Terry"),
  "59827": p("MT", "Conner"),
  "59828": p("MT", "Corvallis"),
  "59829": p("MT", "Darby"),
  "59833": p("MT", "Florence"),
  "59835": p("MT", "Grantsdale"),
  "59840": p("MT", "Hamilton"),
  "59841": p("MT", "Pinesdale"),
  "59870": p("MT", "Stevensville"),
  "59871": p("MT", "Sula"),
  "59875": p("MT", "Victor"),
  "59217": p("MT", "Crane"),
  "59221": p("MT", "Fairview"),
  "59243": p("MT", "Lambert"),
  "59262": p("MT", "Savage"),
  "59270": p("MT", "Sidney"),
  "59201": p("MT", "Wolf Point"),
  "59212": p("MT", "Bainville"),
  "59213": p("MT", "Brockton"),
  "59218": p("MT", "Culbertson"),
  "59226": p("MT", "Froid"),
  "59242": p("MT", "Homestead"),
  "59255": p("MT", "Poplar"),
  "59003": p("MT", "Ashland"),
  "59004": p("MT", "Ashland"),
  "59012": p("MT", "Birney"),
  "59039": p("MT", "Ingomar"),
  "59043": p("MT", "Lame Deer"),
  "59083": p("MT", "Sumatra"),
  "59312": p("MT", "Angela"),
  "59323": p("MT", "Colstrip"),
  "59327": p("MT", "Forsyth"),
  "59333": p("MT", "Hathaway"),
  "59347": p("MT", "Rosebud"),
  "59831": p("MT", "Dixon"),
  "59844": p("MT", "Heron"),
  "59845": p("MT", "Hot Springs"),
  "59848": p("MT", "Lonepine"),
  "59853": p("MT", "Noxon"),
  "59856": p("MT", "Paradise"),
  "59859": p("MT", "Plains"),
  "59873": p("MT", "Thompson Falls"),
  "59874": p("MT", "Trout Creek"),
  "59211": p("MT", "Antelope"),
  "59219": p("MT", "Dagmar"),
  "59247": p("MT", "Medicine Lake"),
  "59252": p("MT", "Outlook"),
  "59254": p("MT", "Plentywood"),
  "59256": p("MT", "Raymond"),
  "59257": p("MT", "Redstone"),
  "59258": p("MT", "Reserve"),
  "59275": p("MT", "Westby"),
  "59701": p("MT", "Butte"),
  "59702": p("MT", "Butte"),
  "59703": p("MT", "Butte"),
  "59707": p("MT", "Butte"),
  "59727": p("MT", "Divide"),
  "59743": p("MT", "Melrose"),
  "59748": p("MT", "Ramsay"),
  "59750": p("MT", "Butte"),
  "59001": p("MT", "Absarokee"),
  "59019": p("MT", "Columbus"),
  "59028": p("MT", "Fishtail"),
  "59057": p("MT", "Molt"),
  "59061": p("MT", "Nye"),
  "59063": p("MT", "Park City"),
  "59067": p("MT", "Rapelje"),
  "59069": p("MT", "Reed Point"),
  "59011": p("MT", "Big Timber"),
  "59033": p("MT", "Greycliff"),
  "59052": p("MT", "Mc Leod"),
  "59055": p("MT", "Melville"),
  "59419": p("MT", "Bynum"),
  "59422": p("MT", "Choteau"),
  "59433": p("MT", "Dutton"),
  "59436": p("MT", "Fairfield"),
  "59467": p("MT", "Pendroy"),
  "59468": p("MT", "Power"),
  "59435": p("MT", "Ethridge"),
  "59444": p("MT", "Galata"),
  "59454": p("MT", "Kevin"),
  "59461": p("MT", "Lothair"),
  "59466": p("MT", "Oilmont"),
  "59474": p("MT", "Shelby"),
  "59482": p("MT", "Sunburst"),
  "59484": p("MT", "Sweet Grass"),
  "59010": p("MT", "Bighorn"),
  "59038": p("MT", "Hysham"),
  "59076": p("MT", "Sanders"),
  "59223": p("MT", "Fort Peck"),
  "59225": p("MT", "Frazer"),
  "59230": p("MT", "Glasgow"),
  "59231": p("MT", "Saint Marie"),
  "59240": p("MT", "Glentana"),
  "59241": p("MT", "Hinsdale"),
  "59244": p("MT", "Larslan"),
  "59248": p("MT", "Nashua"),
  "59250": p("MT", "Opheim"),
  "59260": p("MT", "Richland"),
  "59273": p("MT", "Vandalia"),
  "59036": p("MT", "Harlowton"),
  "59078": p("MT", "Shawmut"),
  "59085": p("MT", "Two Dot"),
  "59453": p("MT", "Judith Gap"),
  "59353": p("MT", "Wibaux"),
  "59002": p("MT", "Acton"),
  "59006": p("MT", "Ballantine"),
  "59015": p("MT", "Broadview"),
  "59024": p("MT", "Custer"),
  "59037": p("MT", "Huntley"),
  "59044": p("MT", "Laurel"),
  "59064": p("MT", "Pompeys Pillar"),
  "59079": p("MT", "Shepherd"),
  "59088": p("MT", "Worden"),
  "59101": p("MT", "Billings"),
  "59102": p("MT", "Billings"),
  "59103": p("MT", "Billings"),
  "59104": p("MT", "Billings"),
  "59105": p("MT", "Billings"),
  "59106": p("MT", "Billings"),
  "59107": p("MT", "Billings"),
  "59108": p("MT", "Billings"),
  "59111": p("MT", "Billings"),
  "59112": p("MT", "Billings"),
  "59114": p("MT", "Billings"),
  "59115": p("MT", "Billings"),
  "59116": p("MT", "Billings"),
  "59117": p("MT", "Billings"),
  "27201": p("NC", "Alamance"),
  "27202": p("NC", "Altamahaw"),
  "27215": p("NC", "Burlington"),
  "27216": p("NC", "Burlington"),
  "27217": p("NC", "Burlington"),
  "27244": p("NC", "Elon"),
  "27253": p("NC", "Graham"),
  "27258": p("NC", "Haw River"),
  "27302": p("NC", "Mebane"),
  "27340": p("NC", "Saxapahaw"),
  "27349": p("NC", "Snow Camp"),
  "27359": p("NC", "Swepsonville"),
  "28636": p("NC", "Hiddenite"),
  "28678": p("NC", "Stony Point"),
  "28681": p("NC", "Taylorsville"),
  "28623": p("NC", "Ennice"),
  "28627": p("NC", "Glade Valley"),
  "28663": p("NC", "Piney Creek"),
  "28668": p("NC", "Roaring Gap"),
  "28675": p("NC", "Sparta"),
  "28007": p("NC", "Ansonville"),
  "28091": p("NC", "Lilesville"),
  "28102": p("NC", "Mc Farlan"),
  "28119": p("NC", "Morven"),
  "28133": p("NC", "Peachland"),
  "28135": p("NC", "Polkton"),
  "28170": p("NC", "Wadesboro"),
  "28615": p("NC", "Creston"),
  "28617": p("NC", "Crumpler"),
  "28626": p("NC", "Fleetwood"),
  "28629": p("NC", "Glendale Springs"),
  "28631": p("NC", "Grassy Creek"),
  "28640": p("NC", "Jefferson"),
  "28643": p("NC", "Lansing"),
  "28644": p("NC", "Laurel Springs"),
  "28672": p("NC", "Scottville"),
  "28684": p("NC", "Todd"),
  "28693": p("NC", "Warrensville"),
  "28694": p("NC", "West Jefferson"),
  "28604": p("NC", "Banner Elk"),
  "28616": p("NC", "Crossnore"),
  "28622": p("NC", "Elk Park"),
  "28646": p("NC", "Linville"),
  "28652": p("NC", "Minneapolis"),
  "28653": p("NC", "Montezuma"),
  "28657": p("NC", "Newland"),
  "28662": p("NC", "Pineola"),
  "28664": p("NC", "Plumtree"),
  "27806": p("NC", "Aurora"),
  "27808": p("NC", "Bath"),
  "27810": p("NC", "Belhaven"),
  "27814": p("NC", "Blounts Creek"),
  "27817": p("NC", "Chocowinity"),
  "27821": p("NC", "Edward"),
  "27860": p("NC", "Pantego"),
  "27865": p("NC", "Pinetown"),
  "27889": p("NC", "Washington"),
  "27805": p("NC", "Aulander"),
  "27847": p("NC", "Kelford"),
  "27849": p("NC", "Lewiston Woodville"),
  "27872": p("NC", "Roxobel"),
  "27924": p("NC", "Colerain"),
  "27957": p("NC", "Merry Hill"),
  "27967": p("NC", "Powellsville"),
  "27983": p("NC", "Windsor"),
  "28320": p("NC", "Bladenboro"),
  "28332": p("NC", "Dublin"),
  "28337": p("NC", "Elizabethtown"),
  "28392": p("NC", "Tar Heel"),
  "28399": p("NC", "White Oak"),
  "28433": p("NC", "Clarkton"),
  "28434": p("NC", "Council"),
  "28448": p("NC", "Kelly"),
  "28404": p("NC", "Wilmington"),
  "28420": p("NC", "Ash"),
  "28422": p("NC", "Bolivia"),
  "28451": p("NC", "Leland"),
  "28452": p("NC", "Longwood"),
  "28459": p("NC", "Shallotte"),
  "28461": p("NC", "Southport"),
  "28462": p("NC", "Supply"),
  "28465": p("NC", "Oak Island"),
  "28467": p("NC", "Calabash"),
  "28468": p("NC", "Sunset Beach"),
  "28469": p("NC", "Ocean Isle Beach"),
  "28470": p("NC", "Shallotte"),
  "28479": p("NC", "Winnabow"),
  "28701": p("NC", "Alexander"),
  "28704": p("NC", "Arden"),
  "28709": p("NC", "Barnardsville"),
  "28711": p("NC", "Black Mountain"),
  "28715": p("NC", "Candler"),
  "28728": p("NC", "Enka"),
  "28730": p("NC", "Fairview"),
  "28748": p("NC", "Leicester"),
  "28757": p("NC", "Montreat"),
  "28759": p("NC", "Mills River"),
  "28770": p("NC", "Ridgecrest"),
  "28776": p("NC", "Skyland"),
  "28778": p("NC", "Swannanoa"),
  "28787": p("NC", "Weaverville"),
  "28801": p("NC", "Asheville"),
  "28802": p("NC", "Asheville"),
  "28803": p("NC", "Asheville"),
  "28804": p("NC", "Asheville"),
  "28805": p("NC", "Asheville"),
  "28806": p("NC", "Asheville"),
  "28810": p("NC", "Asheville"),
  "28813": p("NC", "Asheville"),
  "28814": p("NC", "Asheville"),
  "28815": p("NC", "Asheville"),
  "28816": p("NC", "Asheville"),
  "28612": p("NC", "Connelly Springs"),
  "28619": p("NC", "Drexel"),
  "28628": p("NC", "Glen Alpine"),
  "28637": p("NC", "Hildebran"),
  "28641": p("NC", "Jonas Ridge"),
  "28647": p("NC", "Linville Falls"),
  "28655": p("NC", "Morganton"),
  "28666": p("NC", "Icard"),
  "28671": p("NC", "Rutherford College"),
  "28680": p("NC", "Morganton"),
  "28690": p("NC", "Valdese"),
  "28025": p("NC", "Concord"),
  "28026": p("NC", "Concord"),
  "28027": p("NC", "Concord"),
  "28075": p("NC", "Harrisburg"),
  "28081": p("NC", "Kannapolis"),
  "28082": p("NC", "Kannapolis"),
  "28083": p("NC", "Kannapolis"),
  "28107": p("NC", "Midland"),
  "28124": p("NC", "Mount Pleasant"),
  "28611": p("NC", "Collettsville"),
  "28630": p("NC", "Granite Falls"),
  "28633": p("NC", "Lenoir"),
  "28638": p("NC", "Hudson"),
  "28645": p("NC", "Lenoir"),
  "28661": p("NC", "Patterson"),
  "28667": p("NC", "Rhodhiss"),
  "27921": p("NC", "Camden"),
  "27974": p("NC", "Shiloh"),
  "27976": p("NC", "South Mills"),
  "28511": p("NC", "Atlantic"),
  "28512": p("NC", "Atlantic Beach"),
  "28516": p("NC", "Beaufort"),
  "28520": p("NC", "Cedar Island"),
  "28524": p("NC", "Davis"),
  "28528": p("NC", "Gloucester"),
  "28531": p("NC", "Harkers Island"),
  "28553": p("NC", "Marshallberg"),
  "28557": p("NC", "Morehead City"),
  "28570": p("NC", "Newport"),
  "28575": p("NC", "Salter Path"),
  "28577": p("NC", "Sealevel"),
  "28579": p("NC", "Smyrna"),
  "28581": p("NC", "Stacy"),
  "28582": p("NC", "Stella"),
  "28589": p("NC", "Williston"),
  "28594": p("NC", "Emerald Isle"),
  "27212": p("NC", "Blanch"),
  "27291": p("NC", "Leasburg"),
  "27305": p("NC", "Milton"),
  "27311": p("NC", "Pelham"),
  "27314": p("NC", "Prospect Hill"),
  "27315": p("NC", "Providence"),
  "27379": p("NC", "Yanceyville"),
  "28601": p("NC", "Hickory"),
  "28602": p("NC", "Hickory"),
  "28603": p("NC", "Hickory"),
  "28609": p("NC", "Catawba"),
  "28610": p("NC", "Claremont"),
  "28613": p("NC", "Conover"),
  "28650": p("NC", "Maiden"),
  "28658": p("NC", "Newton"),
  "28673": p("NC", "Sherrills Ford"),
  "28682": p("NC", "Terrell"),
  "27207": p("NC", "Bear Creek"),
  "27208": p("NC", "Bennett"),
  "27213": p("NC", "Bonlee"),
  "27228": p("NC", "Bynum"),
  "27252": p("NC", "Goldston"),
  "27256": p("NC", "Gulf"),
  "27312": p("NC", "Pittsboro"),
  "27344": p("NC", "Siler City"),
  "27559": p("NC", "Moncure"),
  "28781": p("NC", "Topton"),
  "28901": p("NC", "Andrews"),
  "28903": p("NC", "Culberson"),
  "28905": p("NC", "Marble"),
  "28906": p("NC", "Murphy"),
  "27932": p("NC", "Edenton"),
  "27980": p("NC", "Tyner"),
  "28902": p("NC", "Brasstown"),
  "28904": p("NC", "Hayesville"),
  "28909": p("NC", "Warne"),
  "28017": p("NC", "Boiling Springs"),
  "28020": p("NC", "Casar"),
  "28038": p("NC", "Earl"),
  "28042": p("NC", "Fallston"),
  "28073": p("NC", "Grover"),
  "28086": p("NC", "Kings Mountain"),
  "28089": p("NC", "Lattimore"),
  "28090": p("NC", "Lawndale"),
  "28114": p("NC", "Mooresboro"),
  "28136": p("NC", "Polkville"),
  "28150": p("NC", "Shelby"),
  "28151": p("NC", "Shelby"),
  "28152": p("NC", "Shelby"),
  "28169": p("NC", "Waco"),
  "28423": p("NC", "Bolton"),
  "28424": p("NC", "Brunswick"),
  "28430": p("NC", "Cerro Gordo"),
  "28431": p("NC", "Chadbourn"),
  "28432": p("NC", "Clarendon"),
  "28436": p("NC", "Delco"),
  "28438": p("NC", "Evergreen"),
  "28439": p("NC", "Fair Bluff"),
  "28442": p("NC", "Hallsboro"),
  "28450": p("NC", "Lake Waccamaw"),
  "28455": p("NC", "Nakina"),
  "28456": p("NC", "Riegelwood"),
  "28463": p("NC", "Tabor City"),
  "28472": p("NC", "Whiteville"),
  "28519": p("NC", "Bridgeton"),
  "28523": p("NC", "Cove City"),
  "28526": p("NC", "Dover"),
  "28527": p("NC", "Ernul"),
  "28532": p("NC", "Havelock"),
  "28533": p("NC", "Cherry Point"),
  "28560": p("NC", "New Bern"),
  "28561": p("NC", "New Bern"),
  "28562": p("NC", "New Bern"),
  "28563": p("NC", "New Bern"),
  "28564": p("NC", "New Bern"),
  "28586": p("NC", "Vanceboro"),
  "28301": p("NC", "Fayetteville"),
  "28302": p("NC", "Fayetteville"),
  "28303": p("NC", "Fayetteville"),
  "28304": p("NC", "Fayetteville"),
  "28305": p("NC", "Fayetteville"),
  "28306": p("NC", "Fayetteville"),
  "28307": p("NC", "Fort Bragg"),
  "28308": p("NC", "Pope Army Airfield"),
  "28309": p("NC", "Fayetteville"),
  "28310": p("NC", "Fort Bragg"),
  "28311": p("NC", "Fayetteville"),
  "28312": p("NC", "Fayetteville"),
  "28314": p("NC", "Fayetteville"),
  "28331": p("NC", "Cumberland"),
  "28342": p("NC", "Falcon"),
  "28344": p("NC", "Godwin"),
  "28348": p("NC", "Hope Mills"),
  "28356": p("NC", "Linden"),
  "28390": p("NC", "Spring Lake"),
  "28391": p("NC", "Stedman"),
  "28395": p("NC", "Wade"),
  "27916": p("NC", "Aydlett"),
  "27917": p("NC", "Barco"),
  "27923": p("NC", "Coinjock"),
  "27927": p("NC", "Corolla"),
  "27929": p("NC", "Currituck"),
  "27939": p("NC", "Grandy"),
  "27941": p("NC", "Harbinger"),
  "27947": p("NC", "Jarvisburg"),
  "27950": p("NC", "Knotts Island"),
  "27956": p("NC", "Maple"),
  "27958": p("NC", "Moyock"),
  "27964": p("NC", "Point Harbor"),
  "27965": p("NC", "Poplar Branch"),
  "27966": p("NC", "Powells Point"),
  "27973": p("NC", "Shawboro"),
  "27915": p("NC", "Avon"),
  "27920": p("NC", "Buxton"),
  "27936": p("NC", "Frisco"),
  "27943": p("NC", "Hatteras"),
  "27948": p("NC", "Kill Devil Hills"),
  "27949": p("NC", "Kitty Hawk"),
  "27953": p("NC", "Manns Harbor"),
  "27954": p("NC", "Manteo"),
  "27959": p("NC", "Nags Head"),
  "27968": p("NC", "Rodanthe"),
  "27972": p("NC", "Salvo"),
  "27978": p("NC", "Stumpy Point"),
  "27981": p("NC", "Wanchese"),
  "27982": p("NC", "Waves"),
  "27239": p("NC", "Denton"),
  "27292": p("NC", "Lexington"),
  "27293": p("NC", "Lexington"),
  "27294": p("NC", "Lexington"),
  "27295": p("NC", "Lexington"),
  "27299": p("NC", "Linwood"),
  "27351": p("NC", "Southmont"),
  "27360": p("NC", "Thomasville"),
  "27361": p("NC", "Thomasville"),
  "27373": p("NC", "Wallburg"),
  "27374": p("NC", "Welcome"),
  "27006": p("NC", "Advance"),
  "27014": p("NC", "Cooleemee"),
  "27028": p("NC", "Mocksville"),
  "28325": p("NC", "Calypso"),
  "28341": p("NC", "Faison"),
  "28349": p("NC", "Kenansville"),
  "28398": p("NC", "Warsaw"),
  "28453": p("NC", "Magnolia"),
  "28458": p("NC", "Rose Hill"),
  "28464": p("NC", "Teachey"),
  "28466": p("NC", "Wallace"),
  "28508": p("NC", "Albertson"),
  "28518": p("NC", "Beulaville"),
  "28521": p("NC", "Chinquapin"),
  "27503": p("NC", "Bahama"),
  "27572": p("NC", "Rougemont"),
  "27701": p("NC", "Durham"),
  "27702": p("NC", "Durham"),
  "27703": p("NC", "Durham"),
  "27704": p("NC", "Durham"),
  "27705": p("NC", "Durham"),
  "27706": p("NC", "Durham"),
  "27707": p("NC", "Durham"),
  "27708": p("NC", "Durham"),
  "27709": p("NC", "Durham"),
  "27710": p("NC", "Durham"),
  "27711": p("NC", "Durham"),
  "27712": p("NC", "Durham"),
  "27713": p("NC", "Durham"),
  "27715": p("NC", "Durham"),
  "27717": p("NC", "Durham"),
  "27722": p("NC", "Durham"),
  "27801": p("NC", "Rocky Mount"),
  "27802": p("NC", "Rocky Mount"),
  "27809": p("NC", "Battleboro"),
  "27819": p("NC", "Conetoe"),
  "27852": p("NC", "Macclesfield"),
  "27864": p("NC", "Pinetops"),
  "27881": p("NC", "Speed"),
  "27886": p("NC", "Tarboro"),
  "27009": p("NC", "Belews Creek"),
  "27010": p("NC", "Bethania"),
  "27012": p("NC", "Clemmons"),
  "27023": p("NC", "Lewisville"),
  "27040": p("NC", "Pfafftown"),
  "27045": p("NC", "Rural Hall"),
  "27050": p("NC", "Tobaccoville"),
  "27051": p("NC", "Walkertown"),
  "27094": p("NC", "Rural Hall"),
  "27098": p("NC", "Rural Hall"),
  "27099": p("NC", "Rural Hall"),
  "27101": p("NC", "Winston-Salem"),
  "27102": p("NC", "Winston-Salem"),
  "27103": p("NC", "Winston-Salem"),
  "27104": p("NC", "Winston-Salem"),
  "27105": p("NC", "Winston-Salem"),
  "27106": p("NC", "Winston-Salem"),
  "27107": p("NC", "Winston-Salem"),
  "27108": p("NC", "Winston-Salem"),
  "27109": p("NC", "Winston-Salem"),
  "27110": p("NC", "Winston-Salem"),
  "27111": p("NC", "Winston-Salem"),
  "27113": p("NC", "Winston-Salem"),
  "27114": p("NC", "Winston-Salem"),
  "27115": p("NC", "Winston-Salem"),
  "27116": p("NC", "Winston-Salem"),
  "27117": p("NC", "Winston-Salem"),
  "27120": p("NC", "Winston-Salem"),
  "27127": p("NC", "Winston-Salem"),
  "27130": p("NC", "Winston-Salem"),
  "27150": p("NC", "Winston-Salem"),
  "27152": p("NC", "Winston-Salem"),
  "27155": p("NC", "Winston-Salem"),
  "27157": p("NC", "Winston-Salem"),
  "27198": p("NC", "Winston-Salem"),
  "27199": p("NC", "Winston-Salem"),
  "27284": p("NC", "Kernersville"),
  "27285": p("NC", "Kernersville"),
  "27508": p("NC", "Bunn"),
  "27525": p("NC", "Franklinton"),
  "27549": p("NC", "Louisburg"),
  "27596": p("NC", "Youngsville"),
  "28006": p("NC", "Alexis"),
  "28012": p("NC", "Belmont"),
  "28016": p("NC", "Bessemer City"),
  "28021": p("NC", "Cherryville"),
  "28032": p("NC", "Cramerton"),
  "28034": p("NC", "Dallas"),
  "28035": p("NC", "Davidson"),
  "28052": p("NC", "Gastonia"),
  "28053": p("NC", "Gastonia"),
  "28054": p("NC", "Gastonia"),
  "28055": p("NC", "Gastonia"),
  "28056": p("NC", "Gastonia"),
  "28077": p("NC", "High Shoals"),
  "28098": p("NC", "Lowell"),
  "28101": p("NC", "Mc Adenville"),
  "28120": p("NC", "Mount Holly"),
  "28164": p("NC", "Stanley"),
  "27926": p("NC", "Corapeake"),
  "27935": p("NC", "Eure"),
  "27937": p("NC", "Gates"),
  "27938": p("NC", "Gatesville"),
  "27946": p("NC", "Hobbsville"),
  "27969": p("NC", "Roduco"),
  "27979": p("NC", "Sunbury"),
  "28733": p("NC", "Fontana Dam"),
  "28771": p("NC", "Robbinsville"),
  "27507": p("NC", "Bullock"),
  "27509": p("NC", "Butner"),
  "27522": p("NC", "Creedmoor"),
  "27527": p("NC", "Clayton"),
  "27528": p("NC", "Clayton"),
  "27565": p("NC", "Oxford"),
  "27574": p("NC", "Roxboro"),
  "27581": p("NC", "Stem"),
  "27582": p("NC", "Stovall"),
  "27888": p("NC", "Walstonburg"),
  "28538": p("NC", "Hookerton"),
  "28554": p("NC", "Maury"),
  "28580": p("NC", "Snow Hill"),
  "27214": p("NC", "Browns Summit"),
  "27233": p("NC", "Climax"),
  "27235": p("NC", "Colfax"),
  "27249": p("NC", "Gibsonville"),
  "27260": p("NC", "High Point"),
  "27261": p("NC", "High Point"),
  "27262": p("NC", "High Point"),
  "27263": p("NC", "High Point"),
  "27264": p("NC", "High Point"),
  "27265": p("NC", "High Point"),
  "27268": p("NC", "High Point"),
  "27282": p("NC", "Jamestown"),
  "27283": p("NC", "Julian"),
  "27301": p("NC", "Mc Leansville"),
  "27310": p("NC", "Oak Ridge"),
  "27313": p("NC", "Pleasant Garden"),
  "27342": p("NC", "Sedalia"),
  "27357": p("NC", "Stokesdale"),
  "27358": p("NC", "Summerfield"),
  "27377": p("NC", "Whitsett"),
  "27401": p("NC", "Greensboro"),
  "27402": p("NC", "Greensboro"),
  "27403": p("NC", "Greensboro"),
  "27404": p("NC", "Greensboro"),
  "27405": p("NC", "Greensboro"),
  "27406": p("NC", "Greensboro"),
  "27407": p("NC", "Greensboro"),
  "27408": p("NC", "Greensboro"),
  "27409": p("NC", "Greensboro"),
  "27410": p("NC", "Greensboro"),
  "27411": p("NC", "Greensboro"),
  "27412": p("NC", "Greensboro"),
  "27413": p("NC", "Greensboro"),
  "27415": p("NC", "Greensboro"),
  "27416": p("NC", "Greensboro"),
  "27417": p("NC", "Greensboro"),
  "27419": p("NC", "Greensboro"),
  "27420": p("NC", "Greensboro"),
  "27425": p("NC", "Greensboro"),
  "27427": p("NC", "Greensboro"),
  "27429": p("NC", "Greensboro"),
  "27435": p("NC", "Greensboro"),
  "27438": p("NC", "Greensboro"),
  "27455": p("NC", "Greensboro"),
  "27495": p("NC", "Greensboro"),
  "27497": p("NC", "Greensboro"),
  "27498": p("NC", "Greensboro"),
  "27499": p("NC", "Greensboro"),
  "27823": p("NC", "Enfield"),
  "27839": p("NC", "Halifax"),
  "27843": p("NC", "Hobgood"),
  "27844": p("NC", "Hollister"),
  "27850": p("NC", "Littleton"),
  "27870": p("NC", "Roanoke Rapids"),
  "27874": p("NC", "Scotland Neck"),
  "27887": p("NC", "Tillery"),
  "27890": p("NC", "Weldon"),
  "27501": p("NC", "Angier"),
  "27506": p("NC", "Buies Creek"),
  "27521": p("NC", "Coats"),
  "27543": p("NC", "Kipling"),
  "27546": p("NC", "Lillington"),
  "27552": p("NC", "Mamers"),
  "28323": p("NC", "Bunnlevel"),
  "28334": p("NC", "Dunn"),
  "28335": p("NC", "Dunn"),
  "28339": p("NC", "Erwin"),
  "28368": p("NC", "Olivia"),
  "28716": p("NC", "Canton"),
  "28721": p("NC", "Clyde"),
  "28738": p("NC", "Hazelwood"),
  "28745": p("NC", "Lake Junaluska"),
  "28751": p("NC", "Maggie Valley"),
  "28785": p("NC", "Waynesville"),
  "28786": p("NC", "Waynesville"),
  "28710": p("NC", "Bat Cave"),
  "28724": p("NC", "Dana"),
  "28726": p("NC", "East Flat Rock"),
  "28727": p("NC", "Edneyville"),
  "28729": p("NC", "Etowah"),
  "28731": p("NC", "Flat Rock"),
  "28732": p("NC", "Fletcher"),
  "28735": p("NC", "Gerton"),
  "28739": p("NC", "Hendersonville"),
  "28742": p("NC", "Horse Shoe"),
  "28758": p("NC", "Mountain Home"),
  "28760": p("NC", "Naples"),
  "28784": p("NC", "Tuxedo"),
  "28790": p("NC", "Zirconia"),
  "28791": p("NC", "Hendersonville"),
  "28792": p("NC", "Hendersonville"),
  "28793": p("NC", "Hendersonville"),
  "27818": p("NC", "Como"),
  "27855": p("NC", "Murfreesboro"),
  "27910": p("NC", "Ahoskie"),
  "27922": p("NC", "Cofield"),
  "27942": p("NC", "Harrellsville"),
  "27986": p("NC", "Winton"),
  "28376": p("NC", "Raeford"),
  "27824": p("NC", "Engelhard"),
  "27826": p("NC", "Fairfield"),
  "27875": p("NC", "Scranton"),
  "27885": p("NC", "Swanquarter"),
  "27960": p("NC", "Ocracoke"),
  "28010": p("NC", "Barium Springs"),
  "28115": p("NC", "Mooresville"),
  "28117": p("NC", "Mooresville"),
  "28123": p("NC", "Mount Mourne"),
  "28166": p("NC", "Troutman"),
  "28625": p("NC", "Statesville"),
  "28634": p("NC", "Harmony"),
  "28660": p("NC", "Olin"),
  "28677": p("NC", "Statesville"),
  "28687": p("NC", "Statesville"),
  "28688": p("NC", "Turnersburg"),
  "28689": p("NC", "Union Grove"),
  "28699": p("NC", "Scotts"),
  "28707": p("NC", "Balsam"),
  "28717": p("NC", "Cashiers"),
  "28723": p("NC", "Cullowhee"),
  "28725": p("NC", "Dillsboro"),
  "28736": p("NC", "Glenville"),
  "28779": p("NC", "Sylva"),
  "28783": p("NC", "Tuckasegee"),
  "28788": p("NC", "Webster"),
  "28789": p("NC", "Whittier"),
  "27504": p("NC", "Benson"),
  "27520": p("NC", "Clayton"),
  "27524": p("NC", "Four Oaks"),
  "27542": p("NC", "Kenly"),
  "27555": p("NC", "Micro"),
  "27557": p("NC", "Middlesex"),
  "27568": p("NC", "Pine Level"),
  "27569": p("NC", "Princeton"),
  "27576": p("NC", "Selma"),
  "27577": p("NC", "Smithfield"),
  "27593": p("NC", "Wilsons Mills"),
  "28522": p("NC", "Comfort"),
  "28555": p("NC", "Maysville"),
  "28573": p("NC", "Pollocksville"),
  "28585": p("NC", "Trenton"),
  "27237": p("NC", "Cumnock"),
  "27330": p("NC", "Sanford"),
  "27331": p("NC", "Sanford"),
  "27332": p("NC", "Sanford"),
  "27505": p("NC", "Broadway"),
  "28355": p("NC", "Lemon Springs"),
  "28501": p("NC", "Kinston"),
  "28502": p("NC", "Kinston"),
  "28503": p("NC", "Kinston"),
  "28504": p("NC", "Kinston"),
  "28525": p("NC", "Deep Run"),
  "28551": p("NC", "La Grange"),
  "28572": p("NC", "Pink Hill"),
  "28033": p("NC", "Crouse"),
  "28037": p("NC", "Denver"),
  "28080": p("NC", "Iron Station"),
  "28092": p("NC", "Lincolnton"),
  "28093": p("NC", "Lincolnton"),
  "28168": p("NC", "Vale"),
  "28737": p("NC", "Glenwood"),
  "28749": p("NC", "Little Switzerland"),
  "28752": p("NC", "Marion"),
  "28761": p("NC", "Nebo"),
  "28762": p("NC", "Old Fort"),
  "28734": p("NC", "Franklin"),
  "28741": p("NC", "Highlands"),
  "28744": p("NC", "Franklin"),
  "28763": p("NC", "Otto"),
  "28775": p("NC", "Scaly Mountain"),
  "28743": p("NC", "Hot Springs"),
  "28753": p("NC", "Marshall"),
  "28754": p("NC", "Mars Hill"),
  "27825": p("NC", "Everetts"),
  "27840": p("NC", "Hamilton"),
  "27841": p("NC", "Hassell"),
  "27846": p("NC", "Jamesville"),
  "27857": p("NC", "Oak City"),
  "27861": p("NC", "Parmele"),
  "27871": p("NC", "Robersonville"),
  "27892": p("NC", "Williamston"),
  "28031": p("NC", "Cornelius"),
  "28036": p("NC", "Davidson"),
  "28070": p("NC", "Huntersville"),
  "28078": p("NC", "Huntersville"),
  "28104": p("NC", "Matthews"),
  "28105": p("NC", "Matthews"),
  "28106": p("NC", "Matthews"),
  "28126": p("NC", "Newell"),
  "28130": p("NC", "Paw Creek"),
  "28134": p("NC", "Pineville"),
  "28201": p("NC", "Charlotte"),
  "28202": p("NC", "Charlotte"),
  "28203": p("NC", "Charlotte"),
  "28204": p("NC", "Charlotte"),
  "28205": p("NC", "Charlotte"),
  "28206": p("NC", "Charlotte"),
  "28207": p("NC", "Charlotte"),
  "28208": p("NC", "Charlotte"),
  "28209": p("NC", "Charlotte"),
  "28210": p("NC", "Charlotte"),
  "28211": p("NC", "Charlotte"),
  "28212": p("NC", "Charlotte"),
  "28213": p("NC", "Charlotte"),
  "28214": p("NC", "Charlotte"),
  "28215": p("NC", "Charlotte"),
  "28216": p("NC", "Charlotte"),
  "28217": p("NC", "Charlotte"),
  "28218": p("NC", "Charlotte"),
  "28219": p("NC", "Charlotte"),
  "28220": p("NC", "Charlotte"),
  "28221": p("NC", "Charlotte"),
  "28222": p("NC", "Charlotte"),
  "28223": p("NC", "Charlotte"),
  "28224": p("NC", "Charlotte"),
  "28226": p("NC", "Charlotte"),
  "28227": p("NC", "Charlotte"),
  "28228": p("NC", "Charlotte"),
  "28229": p("NC", "Charlotte"),
  "28230": p("NC", "Charlotte"),
  "28231": p("NC", "Charlotte"),
  "28232": p("NC", "Charlotte"),
  "28233": p("NC", "Charlotte"),
  "28234": p("NC", "Charlotte"),
  "28235": p("NC", "Charlotte"),
  "28236": p("NC", "Charlotte"),
  "28237": p("NC", "Charlotte"),
  "28241": p("NC", "Charlotte"),
  "28242": p("NC", "Charlotte"),
  "28243": p("NC", "Charlotte"),
  "28244": p("NC", "Charlotte"),
  "28246": p("NC", "Charlotte"),
  "28247": p("NC", "Charlotte"),
  "28250": p("NC", "Charlotte"),
  "28253": p("NC", "Charlotte"),
  "28254": p("NC", "Charlotte"),
  "28255": p("NC", "Charlotte"),
  "28256": p("NC", "Charlotte"),
  "28258": p("NC", "Charlotte"),
  "28260": p("NC", "Charlotte"),
  "28262": p("NC", "Charlotte"),
  "28263": p("NC", "Charlotte"),
  "28265": p("NC", "Charlotte"),
  "28266": p("NC", "Charlotte"),
  "28269": p("NC", "Charlotte"),
  "28270": p("NC", "Charlotte"),
  "28272": p("NC", "Charlotte"),
  "28273": p("NC", "Charlotte"),
  "28274": p("NC", "Charlotte"),
  "28275": p("NC", "Charlotte"),
  "28277": p("NC", "Charlotte"),
  "28278": p("NC", "Charlotte"),
  "28280": p("NC", "Charlotte"),
  "28281": p("NC", "Charlotte"),
  "28282": p("NC", "Charlotte"),
  "28284": p("NC", "Charlotte"),
  "28285": p("NC", "Charlotte"),
  "28287": p("NC", "Charlotte"),
  "28288": p("NC", "Charlotte"),
  "28289": p("NC", "Charlotte"),
  "28290": p("NC", "Charlotte"),
  "28296": p("NC", "Charlotte"),
  "28297": p("NC", "Charlotte"),
  "28299": p("NC", "Charlotte"),
  "28705": p("NC", "Bakersville"),
  "28765": p("NC", "Penland"),
  "28777": p("NC", "Spruce Pine"),
  "27209": p("NC", "Biscoe"),
  "27229": p("NC", "Candor"),
  "27247": p("NC", "Ether"),
  "27306": p("NC", "Mount Gilead"),
  "27356": p("NC", "Star"),
  "27371": p("NC", "Troy"),
  "27242": p("NC", "Eagle Springs"),
  "27259": p("NC", "Highfalls"),
  "27281": p("NC", "Jackson Springs"),
  "27325": p("NC", "Robbins"),
  "27376": p("NC", "West End"),
  "28315": p("NC", "Aberdeen"),
  "28326": p("NC", "Cameron"),
  "28327": p("NC", "Carthage"),
  "28350": p("NC", "Lakeview"),
  "28370": p("NC", "Pinehurst"),
  "28373": p("NC", "Pinebluff"),
  "28374": p("NC", "Pinehurst"),
  "28387": p("NC", "Southern Pines"),
  "28388": p("NC", "Southern Pines"),
  "28394": p("NC", "Vass"),
  "27803": p("NC", "Rocky Mount"),
  "27804": p("NC", "Rocky Mount"),
  "27807": p("NC", "Bailey"),
  "27815": p("NC", "Rocky Mount"),
  "27816": p("NC", "Castalia"),
  "27856": p("NC", "Nashville"),
  "27868": p("NC", "Red Oak"),
  "27878": p("NC", "Sharpsburg"),
  "27882": p("NC", "Spring Hope"),
  "27891": p("NC", "Whitakers"),
  "28401": p("NC", "Wilmington"),
  "28402": p("NC", "Wilmington"),
  "28403": p("NC", "Wilmington"),
  "28405": p("NC", "Wilmington"),
  "28406": p("NC", "Wilmington"),
  "28407": p("NC", "Wilmington"),
  "28408": p("NC", "Wilmington"),
  "28409": p("NC", "Wilmington"),
  "28410": p("NC", "Wilmington"),
  "28411": p("NC", "Wilmington"),
  "28412": p("NC", "Wilmington"),
  "28428": p("NC", "Carolina Beach"),
  "28429": p("NC", "Castle Hayne"),
  "28449": p("NC", "Kure Beach"),
  "28480": p("NC", "Wrightsville Beach"),
  "27820": p("NC", "Conway"),
  "27831": p("NC", "Garysburg"),
  "27832": p("NC", "Gaston"),
  "27842": p("NC", "Henrico"),
  "27845": p("NC", "Jackson"),
  "27853": p("NC", "Margarettsville"),
  "27862": p("NC", "Pendleton"),
  "27866": p("NC", "Pleasant Hill"),
  "27867": p("NC", "Potecasi"),
  "27869": p("NC", "Rich Square"),
  "27876": p("NC", "Seaboard"),
  "27877": p("NC", "Severn"),
  "27897": p("NC", "Woodland"),
  "28445": p("NC", "Holly Ridge"),
  "28460": p("NC", "Sneads Ferry"),
  "28539": p("NC", "Hubert"),
  "28540": p("NC", "Jacksonville"),
  "28541": p("NC", "Jacksonville"),
  "28542": p("NC", "Camp Lejeune"),
  "28543": p("NC", "Tarawa Terrace"),
  "28544": p("NC", "Midway Park"),
  "28545": p("NC", "Mccutcheon Field"),
  "28546": p("NC", "Jacksonville"),
  "28547": p("NC", "Camp Lejeune"),
  "28574": p("NC", "Richlands"),
  "28584": p("NC", "Swansboro"),
  "27231": p("NC", "Cedar Grove"),
  "27243": p("NC", "Efland"),
  "27278": p("NC", "Hillsborough"),
  "27510": p("NC", "Carrboro"),
  "27514": p("NC", "Chapel Hill"),
  "27515": p("NC", "Chapel Hill"),
  "27516": p("NC", "Chapel Hill"),
  "27517": p("NC", "Chapel Hill"),
  "27599": p("NC", "Chapel Hill"),
  "28509": p("NC", "Alliance"),
  "28510": p("NC", "Arapahoe"),
  "28515": p("NC", "Bayboro"),
  "28529": p("NC", "Grantsboro"),
  "28537": p("NC", "Hobucken"),
  "28552": p("NC", "Lowland"),
  "28556": p("NC", "Merritt"),
  "28571": p("NC", "Oriental"),
  "28583": p("NC", "Stonewall"),
  "28587": p("NC", "Vandemere"),
  "27906": p("NC", "Elizabeth City"),
  "27907": p("NC", "Elizabeth City"),
  "27909": p("NC", "Elizabeth City"),
  "28421": p("NC", "Atkinson"),
  "28425": p("NC", "Burgaw"),
  "28435": p("NC", "Currie"),
  "28443": p("NC", "Hampstead"),
  "28454": p("NC", "Maple Hill"),
  "28457": p("NC", "Rocky Point"),
  "28478": p("NC", "Willard"),
  "27919": p("NC", "Belvidere"),
  "27930": p("NC", "Hertford"),
  "27944": p("NC", "Hertford"),
  "27985": p("NC", "Winfall"),
  "27343": p("NC", "Semora"),
  "27541": p("NC", "Hurdle Mills"),
  "27573": p("NC", "Roxboro"),
  "27583": p("NC", "Timberlake"),
  "27811": p("NC", "Bellarthur"),
  "27812": p("NC", "Bethel"),
  "27827": p("NC", "Falkland"),
  "27828": p("NC", "Farmville"),
  "27829": p("NC", "Fountain"),
  "27833": p("NC", "Greenville"),
  "27834": p("NC", "Greenville"),
  "27835": p("NC", "Greenville"),
  "27836": p("NC", "Greenville"),
  "27837": p("NC", "Grimesland"),
  "27858": p("NC", "Greenville"),
  "27879": p("NC", "Simpson"),
  "27884": p("NC", "Stokes"),
  "28513": p("NC", "Ayden"),
  "28530": p("NC", "Grifton"),
  "28590": p("NC", "Winterville"),
  "28722": p("NC", "Columbus"),
  "28750": p("NC", "Lynn"),
  "28756": p("NC", "Mill Spring"),
  "28773": p("NC", "Saluda"),
  "28782": p("NC", "Tryon"),
  "27203": p("NC", "Asheboro"),
  "27204": p("NC", "Asheboro"),
  "27205": p("NC", "Asheboro"),
  "27230": p("NC", "Cedar Falls"),
  "27248": p("NC", "Franklinville"),
  "27298": p("NC", "Liberty"),
  "27316": p("NC", "Ramseur"),
  "27317": p("NC", "Randleman"),
  "27341": p("NC", "Seagrove"),
  "27350": p("NC", "Sophia"),
  "27355": p("NC", "Staley"),
  "27370": p("NC", "Trinity"),
  "28330": p("NC", "Cordova"),
  "28338": p("NC", "Ellerbe"),
  "28345": p("NC", "Hamlet"),
  "28347": p("NC", "Hoffman"),
  "28363": p("NC", "Marston"),
  "28367": p("NC", "Norman"),
  "28379": p("NC", "Rockingham"),
  "28380": p("NC", "Rockingham"),
  "28271": p("NC", "Charlotte"),
  "28319": p("NC", "Barnesville"),
  "28340": p("NC", "Fairmont"),
  "28357": p("NC", "Lumber Bridge"),
  "28358": p("NC", "Lumberton"),
  "28359": p("NC", "Lumberton"),
  "28360": p("NC", "Lumberton"),
  "28362": p("NC", "Marietta"),
  "28364": p("NC", "Maxton"),
  "28369": p("NC", "Orrum"),
  "28371": p("NC", "Parkton"),
  "28372": p("NC", "Pembroke"),
  "28375": p("NC", "Proctorville"),
  "28377": p("NC", "Red Springs"),
  "28378": p("NC", "Rex"),
  "28383": p("NC", "Rowland"),
  "28384": p("NC", "Saint Pauls"),
  "28386": p("NC", "Shannon"),
  "27025": p("NC", "Madison"),
  "27027": p("NC", "Mayodan"),
  "27048": p("NC", "Stoneville"),
  "27288": p("NC", "Eden"),
  "27289": p("NC", "Eden"),
  "27320": p("NC", "Reidsville"),
  "27323": p("NC", "Reidsville"),
  "27326": p("NC", "Ruffin"),
  "27375": p("NC", "Wentworth"),
  "27013": p("NC", "Cleveland"),
  "27054": p("NC", "Woodleaf"),
  "28023": p("NC", "China Grove"),
  "28039": p("NC", "East Spencer"),
  "28041": p("NC", "Faith"),
  "28071": p("NC", "Gold Hill"),
  "28072": p("NC", "Granite Quarry"),
  "28088": p("NC", "Landis"),
  "28125": p("NC", "Mount Ulla"),
  "28138": p("NC", "Rockwell"),
  "28144": p("NC", "Salisbury"),
  "28145": p("NC", "Salisbury"),
  "28146": p("NC", "Salisbury"),
  "28147": p("NC", "Salisbury"),
  "28159": p("NC", "Spencer"),
  "28018": p("NC", "Bostic"),
  "28019": p("NC", "Caroleen"),
  "28024": p("NC", "Cliffside"),
  "28040": p("NC", "Ellenboro"),
  "28043": p("NC", "Forest City"),
  "28074": p("NC", "Harris"),
  "28076": p("NC", "Henrietta"),
  "28139": p("NC", "Rutherfordton"),
  "28160": p("NC", "Spindale"),
  "28167": p("NC", "Union Mills"),
  "28720": p("NC", "Chimney Rock"),
  "28746": p("NC", "Lake Lure"),
  "28318": p("NC", "Autryville"),
  "28328": p("NC", "Clinton"),
  "28329": p("NC", "Clinton"),
  "28366": p("NC", "Newton Grove"),
  "28382": p("NC", "Roseboro"),
  "28385": p("NC", "Salemburg"),
  "28393": p("NC", "Turkey"),
  "28441": p("NC", "Garland"),
  "28444": p("NC", "Harrells"),
  "28447": p("NC", "Ivanhoe"),
  "28343": p("NC", "Gibson"),
  "28351": p("NC", "Laurel Hill"),
  "28352": p("NC", "Laurinburg"),
  "28353": p("NC", "Laurinburg"),
  "28396": p("NC", "Wagram"),
  "28001": p("NC", "Albemarle"),
  "28002": p("NC", "Albemarle"),
  "28009": p("NC", "Badin"),
  "28097": p("NC", "Locust"),
  "28109": p("NC", "Misenheimer"),
  "28127": p("NC", "New London"),
  "28128": p("NC", "Norwood"),
  "28129": p("NC", "Oakboro"),
  "28137": p("NC", "Richfield"),
  "28163": p("NC", "Stanfield"),
  "27016": p("NC", "Danbury"),
  "27019": p("NC", "Germanton"),
  "27021": p("NC", "King"),
  "27022": p("NC", "Lawsonville"),
  "27042": p("NC", "Pine Hall"),
  "27043": p("NC", "Pinnacle"),
  "27046": p("NC", "Sandy Ridge"),
  "27052": p("NC", "Walnut Cove"),
  "27007": p("NC", "Ararat"),
  "27017": p("NC", "Dobson"),
  "27024": p("NC", "Lowgap"),
  "27030": p("NC", "Mount Airy"),
  "27031": p("NC", "White Plains"),
  "27041": p("NC", "Pilot Mountain"),
  "27047": p("NC", "Siloam"),
  "27049": p("NC", "Toast"),
  "27053": p("NC", "Westfield"),
  "28621": p("NC", "Elkin"),
  "28676": p("NC", "State Road"),
  "28702": p("NC", "Almond"),
  "28713": p("NC", "Bryson City"),
  "28719": p("NC", "Cherokee"),
  "28708": p("NC", "Balsam Grove"),
  "28712": p("NC", "Brevard"),
  "28718": p("NC", "Cedar Mountain"),
  "28747": p("NC", "Lake Toxaway"),
  "28766": p("NC", "Penrose"),
  "28768": p("NC", "Pisgah Forest"),
  "28772": p("NC", "Rosman"),
  "28774": p("NC", "Sapphire"),
  "27925": p("NC", "Columbia"),
  "28079": p("NC", "Indian Trail"),
  "28103": p("NC", "Marshville"),
  "28108": p("NC", "Mineral Springs"),
  "28110": p("NC", "Monroe"),
  "28111": p("NC", "Monroe"),
  "28112": p("NC", "Monroe"),
  "28173": p("NC", "Waxhaw"),
  "28174": p("NC", "Wingate"),
  "27536": p("NC", "Henderson"),
  "27537": p("NC", "Henderson"),
  "27544": p("NC", "Kittrell"),
  "27553": p("NC", "Manson"),
  "27556": p("NC", "Middleburg"),
  "27584": p("NC", "Townsville"),
  "27502": p("NC", "Apex"),
  "27511": p("NC", "Cary"),
  "27512": p("NC", "Cary"),
  "27513": p("NC", "Cary"),
  "27518": p("NC", "Cary"),
  "27519": p("NC", "Cary"),
  "27523": p("NC", "Apex"),
  "27526": p("NC", "Fuquay Varina"),
  "27529": p("NC", "Garner"),
  "27539": p("NC", "Apex"),
  "27540": p("NC", "Holly Springs"),
  "27545": p("NC", "Knightdale"),
  "27560": p("NC", "Morrisville"),
  "27562": p("NC", "New Hill"),
  "27571": p("NC", "Rolesville"),
  "27587": p("NC", "Wake Forest"),
  "27588": p("NC", "Wake Forest"),
  "27591": p("NC", "Wendell"),
  "27592": p("NC", "Willow Spring"),
  "27597": p("NC", "Zebulon"),
  "27601": p("NC", "Raleigh"),
  "27602": p("NC", "Raleigh"),
  "27603": p("NC", "Raleigh"),
  "27604": p("NC", "Raleigh"),
  "27605": p("NC", "Raleigh"),
  "27606": p("NC", "Raleigh"),
  "27607": p("NC", "Raleigh"),
  "27608": p("NC", "Raleigh"),
  "27609": p("NC", "Raleigh"),
  "27610": p("NC", "Raleigh"),
  "27611": p("NC", "Raleigh"),
  "27612": p("NC", "Raleigh"),
  "27613": p("NC", "Raleigh"),
  "27614": p("NC", "Raleigh"),
  "27615": p("NC", "Raleigh"),
  "27616": p("NC", "Raleigh"),
  "27617": p("NC", "Raleigh"),
  "27619": p("NC", "Raleigh"),
  "27620": p("NC", "Raleigh"),
  "27621": p("NC", "Raleigh"),
  "27622": p("NC", "Raleigh"),
  "27623": p("NC", "Raleigh"),
  "27624": p("NC", "Raleigh"),
  "27625": p("NC", "Raleigh"),
  "27626": p("NC", "Raleigh"),
  "27627": p("NC", "Raleigh"),
  "27628": p("NC", "Raleigh"),
  "27629": p("NC", "Raleigh"),
  "27634": p("NC", "Raleigh"),
  "27635": p("NC", "Raleigh"),
  "27636": p("NC", "Raleigh"),
  "27640": p("NC", "Raleigh"),
  "27650": p("NC", "Raleigh"),
  "27656": p("NC", "Raleigh"),
  "27658": p("NC", "Raleigh"),
  "27661": p("NC", "Raleigh"),
  "27668": p("NC", "Raleigh"),
  "27675": p("NC", "Raleigh"),
  "27676": p("NC", "Raleigh"),
  "27690": p("NC", "Raleigh"),
  "27695": p("NC", "Raleigh"),
  "27697": p("NC", "Raleigh"),
  "27698": p("NC", "Raleigh"),
  "27699": p("NC", "Raleigh"),
  "27551": p("NC", "Macon"),
  "27563": p("NC", "Norlina"),
  "27570": p("NC", "Ridgeway"),
  "27586": p("NC", "Vaughan"),
  "27589": p("NC", "Warrenton"),
  "27594": p("NC", "Wise"),
  "27928": p("NC", "Creswell"),
  "27962": p("NC", "Plymouth"),
  "27970": p("NC", "Roper"),
  "28605": p("NC", "Blowing Rock"),
  "28607": p("NC", "Boone"),
  "28608": p("NC", "Boone"),
  "28618": p("NC", "Deep Gap"),
  "28679": p("NC", "Sugar Grove"),
  "28691": p("NC", "Valle Crucis"),
  "28692": p("NC", "Vilas"),
  "28698": p("NC", "Zionville"),
  "27530": p("NC", "Goldsboro"),
  "27531": p("NC", "Goldsboro"),
  "27532": p("NC", "Goldsboro"),
  "27533": p("NC", "Goldsboro"),
  "27534": p("NC", "Goldsboro"),
  "27830": p("NC", "Fremont"),
  "27863": p("NC", "Pikeville"),
  "28333": p("NC", "Dudley"),
  "28365": p("NC", "Mount Olive"),
  "28578": p("NC", "Seven Springs"),
  "28606": p("NC", "Boomer"),
  "28624": p("NC", "Ferguson"),
  "28635": p("NC", "Hays"),
  "28649": p("NC", "Mc Grady"),
  "28651": p("NC", "Millers Creek"),
  "28654": p("NC", "Moravian Falls"),
  "28656": p("NC", "North Wilkesboro"),
  "28659": p("NC", "North Wilkesboro"),
  "28665": p("NC", "Purlear"),
  "28669": p("NC", "Roaring River"),
  "28670": p("NC", "Ronda"),
  "28683": p("NC", "Thurmond"),
  "28685": p("NC", "Traphill"),
  "28697": p("NC", "Wilkesboro"),
  "27813": p("NC", "Black Creek"),
  "27822": p("NC", "Elm City"),
  "27851": p("NC", "Lucama"),
  "27873": p("NC", "Saratoga"),
  "27880": p("NC", "Sims"),
  "27883": p("NC", "Stantonsburg"),
  "27893": p("NC", "Wilson"),
  "27894": p("NC", "Wilson"),
  "27895": p("NC", "Wilson"),
  "27896": p("NC", "Wilson"),
  "27011": p("NC", "Boonville"),
  "27018": p("NC", "East Bend"),
  "27020": p("NC", "Hamptonville"),
  "27055": p("NC", "Yadkinville"),
  "28642": p("NC", "Jonesville"),
  "28714": p("NC", "Burnsville"),
  "28740": p("NC", "Green Mountain"),
  "28755": p("NC", "Micaville"),
  "58639": p("ND", "Hettinger"),
  "58649": p("ND", "Reeder"),
  "58031": p("ND", "Fingal"),
  "58049": p("ND", "Kathryn"),
  "58062": p("ND", "Nome"),
  "58063": p("ND", "Oriska"),
  "58065": p("ND", "Pillsbury"),
  "58072": p("ND", "Valley City"),
  "58429": p("ND", "Dazey"),
  "58461": p("ND", "Litchville"),
  "58479": p("ND", "Rogers"),
  "58480": p("ND", "Sanborn"),
  "58492": p("ND", "Wimbledon"),
  "58332": p("ND", "Esmond"),
  "58335": p("ND", "Fort Totten"),
  "58343": p("ND", "Knox"),
  "58346": p("ND", "Leeds"),
  "58348": p("ND", "Maddock"),
  "58351": p("ND", "Minnewaukan"),
  "58357": p("ND", "Oberon"),
  "58370": p("ND", "Saint Michael"),
  "58379": p("ND", "Tokio"),
  "58381": p("ND", "Warwick"),
  "58386": p("ND", "York"),
  "58627": p("ND", "Fairfield"),
  "58645": p("ND", "Medora"),
  "58318": p("ND", "Bottineau"),
  "58384": p("ND", "Willow City"),
  "58711": p("ND", "Antler"),
  "58748": p("ND", "Kramer"),
  "58750": p("ND", "Lansford"),
  "58760": p("ND", "Maxbass"),
  "58762": p("ND", "Newburg"),
  "58783": p("ND", "Souris"),
  "58793": p("ND", "Westhope"),
  "58623": p("ND", "Bowman"),
  "58651": p("ND", "Rhame"),
  "58653": p("ND", "Scranton"),
  "58721": p("ND", "Bowbells"),
  "58727": p("ND", "Columbus"),
  "58737": p("ND", "Flaxton"),
  "58752": p("ND", "Lignite"),
  "58772": p("ND", "Portal"),
  "58773": p("ND", "Powers Lake"),
  "58477": p("ND", "Regan"),
  "58494": p("ND", "Wing"),
  "58501": p("ND", "Bismarck"),
  "58502": p("ND", "Bismarck"),
  "58503": p("ND", "Bismarck"),
  "58504": p("ND", "Bismarck"),
  "58505": p("ND", "Bismarck"),
  "58506": p("ND", "Bismarck"),
  "58507": p("ND", "Bismarck"),
  "58521": p("ND", "Baldwin"),
  "58532": p("ND", "Driscoll"),
  "58558": p("ND", "Menoken"),
  "58560": p("ND", "Moffit"),
  "58572": p("ND", "Sterling"),
  "58002": p("ND", "Absaraka"),
  "58004": p("ND", "Amenia"),
  "58005": p("ND", "Argusville"),
  "58006": p("ND", "Arthur"),
  "58007": p("ND", "Ayr"),
  "58011": p("ND", "Buffalo"),
  "58012": p("ND", "Casselton"),
  "58021": p("ND", "Davenport"),
  "58029": p("ND", "Erie"),
  "58036": p("ND", "Gardner"),
  "58038": p("ND", "Grandin"),
  "58042": p("ND", "Harwood"),
  "58047": p("ND", "Horace"),
  "58048": p("ND", "Hunter"),
  "58051": p("ND", "Kindred"),
  "58052": p("ND", "Leonard"),
  "58059": p("ND", "Mapleton"),
  "58064": p("ND", "Page"),
  "58071": p("ND", "Tower City"),
  "58078": p("ND", "West Fargo"),
  "58079": p("ND", "Wheatland"),
  "58102": p("ND", "Fargo"),
  "58103": p("ND", "Fargo"),
  "58104": p("ND", "Fargo"),
  "58105": p("ND", "Fargo"),
  "58106": p("ND", "Fargo"),
  "58107": p("ND", "Fargo"),
  "58108": p("ND", "Fargo"),
  "58109": p("ND", "Fargo"),
  "58121": p("ND", "Fargo"),
  "58122": p("ND", "Fargo"),
  "58124": p("ND", "Fargo"),
  "58125": p("ND", "Fargo"),
  "58126": p("ND", "Fargo"),
  "58239": p("ND", "Hannah"),
  "58249": p("ND", "Langdon"),
  "58255": p("ND", "Maida"),
  "58260": p("ND", "Milton"),
  "58269": p("ND", "Osnabrock"),
  "58281": p("ND", "Wales"),
  "58311": p("ND", "Alsen"),
  "58323": p("ND", "Calvin"),
  "58352": p("ND", "Munich"),
  "58355": p("ND", "Nekoma"),
  "58372": p("ND", "Sarles"),
  "58436": p("ND", "Ellendale"),
  "58439": p("ND", "Forbes"),
  "58441": p("ND", "Fullerton"),
  "58474": p("ND", "Oakes"),
  "58730": p("ND", "Crosby"),
  "58765": p("ND", "Noonan"),
  "58833": p("ND", "Ambrose"),
  "58844": p("ND", "Fortuna"),
  "58625": p("ND", "Dodge"),
  "58626": p("ND", "Dunn Center"),
  "58636": p("ND", "Halliday"),
  "58640": p("ND", "Killdeer"),
  "58642": p("ND", "Manning"),
  "58644": p("ND", "Marshall"),
  "58356": p("ND", "New Rockford"),
  "58374": p("ND", "Sheyenne"),
  "58524": p("ND", "Braddock"),
  "58542": p("ND", "Hague"),
  "58544": p("ND", "Hazelton"),
  "58549": p("ND", "Kintyre"),
  "58552": p("ND", "Linton"),
  "58573": p("ND", "Strasburg"),
  "58421": p("ND", "Carrington"),
  "58443": p("ND", "Glenfield"),
  "58445": p("ND", "Grace City"),
  "58464": p("ND", "Mchenry"),
  "58621": p("ND", "Beach"),
  "58632": p("ND", "Golva"),
  "58654": p("ND", "Sentinel Butte"),
  "58201": p("ND", "Grand Forks"),
  "58202": p("ND", "Grand Forks"),
  "58203": p("ND", "Grand Forks"),
  "58204": p("ND", "Grand Forks Afb"),
  "58205": p("ND", "Grand Forks Afb"),
  "58206": p("ND", "Grand Forks"),
  "58207": p("ND", "Grand Forks"),
  "58208": p("ND", "Grand Forks"),
  "58214": p("ND", "Arvilla"),
  "58228": p("ND", "Emerado"),
  "58235": p("ND", "Gilby"),
  "58244": p("ND", "Inkster"),
  "58251": p("ND", "Larimore"),
  "58256": p("ND", "Manvel"),
  "58258": p("ND", "Mekinock"),
  "58266": p("ND", "Niagara"),
  "58267": p("ND", "Northwood"),
  "58275": p("ND", "Reynolds"),
  "58278": p("ND", "Thompson"),
  "58529": p("ND", "Carson"),
  "58533": p("ND", "Elgin"),
  "58562": p("ND", "New Leipzig"),
  "58564": p("ND", "Raleigh"),
  "58569": p("ND", "Shields"),
  "58416": p("ND", "Binford"),
  "58425": p("ND", "Cooperstown"),
  "58448": p("ND", "Hannaford"),
  "58452": p("ND", "Jessie"),
  "58484": p("ND", "Sutton"),
  "58646": p("ND", "Mott"),
  "58647": p("ND", "New England"),
  "58650": p("ND", "Regent"),
  "58428": p("ND", "Dawson"),
  "58475": p("ND", "Pettibone"),
  "58478": p("ND", "Robinson"),
  "58482": p("ND", "Steele"),
  "58487": p("ND", "Tappen"),
  "58488": p("ND", "Tuttle"),
  "58415": p("ND", "Berlin"),
  "58431": p("ND", "Dickey"),
  "58433": p("ND", "Edgeley"),
  "58454": p("ND", "Jud"),
  "58456": p("ND", "Kulm"),
  "58458": p("ND", "Lamoure"),
  "58466": p("ND", "Marion"),
  "58490": p("ND", "Verona"),
  "58440": p("ND", "Fredonia"),
  "58442": p("ND", "Gackle"),
  "58561": p("ND", "Napoleon"),
  "58710": p("ND", "Anamoose"),
  "58712": p("ND", "Balfour"),
  "58713": p("ND", "Bantry"),
  "58731": p("ND", "Deering"),
  "58736": p("ND", "Drake"),
  "58741": p("ND", "Granville"),
  "58744": p("ND", "Karlsruhe"),
  "58768": p("ND", "Norwich"),
  "58788": p("ND", "Towner"),
  "58789": p("ND", "Upham"),
  "58790": p("ND", "Velva"),
  "58792": p("ND", "Voltaire"),
  "58413": p("ND", "Ashley"),
  "58460": p("ND", "Lehr"),
  "58495": p("ND", "Wishek"),
  "58581": p("ND", "Zeeland"),
  "58634": p("ND", "Grassy Butte"),
  "58757": p("ND", "Mandaree"),
  "58831": p("ND", "Alexander"),
  "58835": p("ND", "Arnegard"),
  "58838": p("ND", "Cartwright"),
  "58847": p("ND", "Keene"),
  "58854": p("ND", "Watford City"),
  "58531": p("ND", "Coleharbor"),
  "58540": p("ND", "Garrison"),
  "58559": p("ND", "Mercer"),
  "58565": p("ND", "Riverdale"),
  "58575": p("ND", "Turtle Lake"),
  "58576": p("ND", "Underwood"),
  "58577": p("ND", "Washburn"),
  "58579": p("ND", "Wilton"),
  "58716": p("ND", "Benedict"),
  "58723": p("ND", "Butte"),
  "58759": p("ND", "Max"),
  "58775": p("ND", "Roseglen"),
  "58778": p("ND", "Ruso"),
  "58523": p("ND", "Beulah"),
  "58541": p("ND", "Golden Valley"),
  "58545": p("ND", "Hazen"),
  "58571": p("ND", "Stanton"),
  "58580": p("ND", "Zap"),
  "58520": p("ND", "Almont"),
  "58535": p("ND", "Flasher"),
  "58554": p("ND", "Mandan"),
  "58563": p("ND", "New Salem"),
  "58566": p("ND", "Saint Anthony"),
  "58631": p("ND", "Glen Ullin"),
  "58638": p("ND", "Hebron"),
  "58763": p("ND", "New Town"),
  "58769": p("ND", "Palermo"),
  "58770": p("ND", "Parshall"),
  "58771": p("ND", "Plaza"),
  "58776": p("ND", "Ross"),
  "58784": p("ND", "Stanley"),
  "58794": p("ND", "White Earth"),
  "58212": p("ND", "Aneta"),
  "58224": p("ND", "Dahlen"),
  "58254": p("ND", "Mcville"),
  "58259": p("ND", "Michigan"),
  "58272": p("ND", "Petersburg"),
  "58344": p("ND", "Lakota"),
  "58361": p("ND", "Pekin"),
  "58380": p("ND", "Tolna"),
  "58530": p("ND", "Center"),
  "58216": p("ND", "Bathgate"),
  "58220": p("ND", "Cavalier"),
  "58222": p("ND", "Crystal"),
  "58225": p("ND", "Drayton"),
  "58236": p("ND", "Glasston"),
  "58238": p("ND", "Hamilton"),
  "58241": p("ND", "Hensel"),
  "58262": p("ND", "Mountain"),
  "58265": p("ND", "Neche"),
  "58271": p("ND", "Pembina"),
  "58276": p("ND", "Saint Thomas"),
  "58282": p("ND", "Walhalla"),
  "58313": p("ND", "Balta"),
  "58368": p("ND", "Rugby"),
  "58385": p("ND", "Wolford"),
  "58301": p("ND", "Devils Lake"),
  "58321": p("ND", "Brocket"),
  "58325": p("ND", "Churchs Ferry"),
  "58327": p("ND", "Crary"),
  "58330": p("ND", "Edmore"),
  "58338": p("ND", "Hampden"),
  "58345": p("ND", "Lawton"),
  "58362": p("ND", "Penn"),
  "58377": p("ND", "Starkweather"),
  "58382": p("ND", "Webster"),
  "58027": p("ND", "Enderlin"),
  "58033": p("ND", "Fort Ransom"),
  "58054": p("ND", "Lisbon"),
  "58057": p("ND", "Mcleod"),
  "58068": p("ND", "Sheldon"),
  "58740": p("ND", "Glenburn"),
  "58761": p("ND", "Mohall"),
  "58782": p("ND", "Sherwood"),
  "58787": p("ND", "Tolley"),
  "58001": p("ND", "Abercrombie"),
  "58008": p("ND", "Barney"),
  "58015": p("ND", "Christine"),
  "58018": p("ND", "Colfax"),
  "58030": p("ND", "Fairmount"),
  "58041": p("ND", "Hankinson"),
  "58053": p("ND", "Lidgerwood"),
  "58058": p("ND", "Mantador"),
  "58061": p("ND", "Mooreton"),
  "58074": p("ND", "Wahpeton"),
  "58075": p("ND", "Wahpeton"),
  "58076": p("ND", "Wahpeton"),
  "58077": p("ND", "Walcott"),
  "58081": p("ND", "Wyndmere"),
  "58310": p("ND", "Agate"),
  "58316": p("ND", "Belcourt"),
  "58329": p("ND", "Dunseith"),
  "58353": p("ND", "Mylo"),
  "58366": p("ND", "Rolette"),
  "58367": p("ND", "Rolla"),
  "58369": p("ND", "Saint John"),
  "58013": p("ND", "Cayuga"),
  "58017": p("ND", "Cogswell"),
  "58032": p("ND", "Forman"),
  "58040": p("ND", "Gwinner"),
  "58043": p("ND", "Havana"),
  "58060": p("ND", "Milnor"),
  "58067": p("ND", "Rutland"),
  "58069": p("ND", "Stirum"),
  "58430": p("ND", "Denhoff"),
  "58444": p("ND", "Goodrich"),
  "58463": p("ND", "Mcclusky"),
  "58758": p("ND", "Martin"),
  "58528": p("ND", "Cannon Ball"),
  "58538": p("ND", "Fort Yates"),
  "58568": p("ND", "Selfridge"),
  "58570": p("ND", "Solen"),
  "58620": p("ND", "Amidon"),
  "58643": p("ND", "Marmarth"),
  "58601": p("ND", "Dickinson"),
  "58602": p("ND", "Dickinson"),
  "58622": p("ND", "Belfield"),
  "58630": p("ND", "Gladstone"),
  "58641": p("ND", "Lefor"),
  "58652": p("ND", "Richardton"),
  "58655": p("ND", "South Heart"),
  "58656": p("ND", "Taylor"),
  "58046": p("ND", "Hope"),
  "58056": p("ND", "Luverne"),
  "58230": p("ND", "Finley"),
  "58277": p("ND", "Sharon"),
  "58401": p("ND", "Jamestown"),
  "58402": p("ND", "Jamestown"),
  "58405": p("ND", "Jamestown"),
  "58420": p("ND", "Buchanan"),
  "58424": p("ND", "Cleveland"),
  "58426": p("ND", "Courtenay"),
  "58455": p("ND", "Kensal"),
  "58467": p("ND", "Medina"),
  "58472": p("ND", "Montpelier"),
  "58476": p("ND", "Pingree"),
  "58481": p("ND", "Spiritwood"),
  "58483": p("ND", "Streeter"),
  "58496": p("ND", "Woodworth"),
  "58497": p("ND", "Ypsilanti"),
  "58317": p("ND", "Bisbee"),
  "58324": p("ND", "Cando"),
  "58331": p("ND", "Egeland"),
  "58339": p("ND", "Hansboro"),
  "58363": p("ND", "Perth"),
  "58365": p("ND", "Rocklake"),
  "58009": p("ND", "Blanchard"),
  "58016": p("ND", "Clifford"),
  "58035": p("ND", "Galesburg"),
  "58045": p("ND", "Hillsboro"),
  "58218": p("ND", "Buxton"),
  "58219": p("ND", "Caledonia"),
  "58223": p("ND", "Cummings"),
  "58240": p("ND", "Hatton"),
  "58257": p("ND", "Mayville"),
  "58274": p("ND", "Portland"),
  "58210": p("ND", "Adams"),
  "58227": p("ND", "Edinburg"),
  "58229": p("ND", "Fairdale"),
  "58231": p("ND", "Fordville"),
  "58233": p("ND", "Forest River"),
  "58237": p("ND", "Grafton"),
  "58243": p("ND", "Hoople"),
  "58250": p("ND", "Lankin"),
  "58261": p("ND", "Minto"),
  "58270": p("ND", "Park River"),
  "58273": p("ND", "Pisek"),
  "58701": p("ND", "Minot"),
  "58702": p("ND", "Minot"),
  "58703": p("ND", "Minot"),
  "58704": p("ND", "Minot Afb"),
  "58705": p("ND", "Minot Afb"),
  "58707": p("ND", "Minot"),
  "58718": p("ND", "Berthold"),
  "58722": p("ND", "Burlington"),
  "58725": p("ND", "Carpio"),
  "58733": p("ND", "Des Lacs"),
  "58734": p("ND", "Donnybrook"),
  "58735": p("ND", "Douglas"),
  "58746": p("ND", "Kenmare"),
  "58756": p("ND", "Makoti"),
  "58779": p("ND", "Ryder"),
  "58781": p("ND", "Sawyer"),
  "58785": p("ND", "Surrey"),
  "58341": p("ND", "Harvey"),
  "58418": p("ND", "Bowdon"),
  "58422": p("ND", "Cathay"),
  "58423": p("ND", "Chaseley"),
  "58438": p("ND", "Fessenden"),
  "58451": p("ND", "Hurdsfield"),
  "58486": p("ND", "Sykeston"),
  "58755": p("ND", "Mcgregor"),
  "58795": p("ND", "Wildrose"),
  "58801": p("ND", "Williston"),
  "58802": p("ND", "Williston"),
  "58803": p("ND", "Williston"),
  "58830": p("ND", "Alamo"),
  "58843": p("ND", "Epping"),
  "58845": p("ND", "Grenora"),
  "58849": p("ND", "Ray"),
  "58852": p("ND", "Tioga"),
  "58853": p("ND", "Trenton"),
  "58856": p("ND", "Zahl"),
  "68901": p("NE", "Hastings"),
  "68902": p("NE", "Hastings"),
  "68925": p("NE", "Ayr"),
  "68950": p("NE", "Holstein"),
  "68955": p("NE", "Juniata"),
  "68956": p("NE", "Kenesaw"),
  "68973": p("NE", "Roseland"),
  "68636": p("NE", "Elgin"),
  "68720": p("NE", "Brunswick"),
  "68726": p("NE", "Clearwater"),
  "68756": p("NE", "Neligh"),
  "68761": p("NE", "Oakdale"),
  "68764": p("NE", "Orchard"),
  "68773": p("NE", "Royal"),
  "69121": p("NE", "Arthur"),
  "69345": p("NE", "Harrisburg"),
  "68821": p("NE", "Brewster"),
  "68833": p("NE", "Dunning"),
  "69157": p("NE", "Purdum"),
  "68620": p("NE", "Albion"),
  "68627": p("NE", "Cedar Rapids"),
  "68652": p("NE", "Petersburg"),
  "68655": p("NE", "Primrose"),
  "68660": p("NE", "Saint Edward"),
  "69301": p("NE", "Alliance"),
  "69348": p("NE", "Hemingford"),
  "68719": p("NE", "Bristow"),
  "68722": p("NE", "Butte"),
  "68746": p("NE", "Lynch"),
  "68755": p("NE", "Naper"),
  "68777": p("NE", "Spencer"),
  "69210": p("NE", "Ainsworth"),
  "69214": p("NE", "Johnstown"),
  "69217": p("NE", "Long Pine"),
  "68812": p("NE", "Amherst"),
  "68836": p("NE", "Elm Creek"),
  "68840": p("NE", "Gibbon"),
  "68845": p("NE", "Kearney"),
  "68847": p("NE", "Kearney"),
  "68848": p("NE", "Kearney"),
  "68849": p("NE", "Kearney"),
  "68858": p("NE", "Miller"),
  "68861": p("NE", "Odessa"),
  "68866": p("NE", "Pleasanton"),
  "68869": p("NE", "Ravenna"),
  "68870": p("NE", "Riverdale"),
  "68876": p("NE", "Shelton"),
  "68019": p("NE", "Craig"),
  "68020": p("NE", "Decatur"),
  "68038": p("NE", "Lyons"),
  "68045": p("NE", "Oakland"),
  "68061": p("NE", "Tekamah"),
  "68001": p("NE", "Abie"),
  "68014": p("NE", "Bruno"),
  "68036": p("NE", "Linwood"),
  "68624": p("NE", "Bellwood"),
  "68626": p("NE", "Brainard"),
  "68632": p("NE", "David City"),
  "68635": p("NE", "Dwight"),
  "68658": p("NE", "Rising City"),
  "68667": p("NE", "Surprise"),
  "68669": p("NE", "Ulysses"),
  "68016": p("NE", "Cedar Creek"),
  "68037": p("NE", "Louisville"),
  "68048": p("NE", "Plattsmouth"),
  "68058": p("NE", "South Bend"),
  "68304": p("NE", "Alvo"),
  "68307": p("NE", "Avoca"),
  "68347": p("NE", "Eagle"),
  "68349": p("NE", "Elmwood"),
  "68366": p("NE", "Greenwood"),
  "68403": p("NE", "Manley"),
  "68407": p("NE", "Murdock"),
  "68409": p("NE", "Murray"),
  "68413": p("NE", "Nehawka"),
  "68455": p("NE", "Union"),
  "68463": p("NE", "Weeping Water"),
  "68717": p("NE", "Belden"),
  "68727": p("NE", "Coleridge"),
  "68736": p("NE", "Fordyce"),
  "68739": p("NE", "Hartington"),
  "68745": p("NE", "Laurel"),
  "68749": p("NE", "Magnet"),
  "68771": p("NE", "Randolph"),
  "68774": p("NE", "Saint Helena"),
  "68792": p("NE", "Wynot"),
  "69023": p("NE", "Champion"),
  "69027": p("NE", "Enders"),
  "69033": p("NE", "Imperial"),
  "69045": p("NE", "Wauneta"),
  "69135": p("NE", "Elsmere"),
  "69201": p("NE", "Valentine"),
  "69211": p("NE", "Cody"),
  "69212": p("NE", "Crookston"),
  "69216": p("NE", "Kilgore"),
  "69218": p("NE", "Merriman"),
  "69219": p("NE", "Nenzel"),
  "69220": p("NE", "Sparks"),
  "69221": p("NE", "Wood Lake"),
  "69131": p("NE", "Dalton"),
  "69141": p("NE", "Gurley"),
  "69149": p("NE", "Lodgepole"),
  "69156": p("NE", "Potter"),
  "69160": p("NE", "Sidney"),
  "69162": p("NE", "Sidney"),
  "68452": p("NE", "Ong"),
  "68933": p("NE", "Clay Center"),
  "68934": p("NE", "Deweese"),
  "68935": p("NE", "Edgar"),
  "68938": p("NE", "Fairfield"),
  "68941": p("NE", "Glenvil"),
  "68944": p("NE", "Harvard"),
  "68954": p("NE", "Inland"),
  "68975": p("NE", "Saronville"),
  "68979": p("NE", "Sutton"),
  "68980": p("NE", "Trumbull"),
  "68629": p("NE", "Clarkson"),
  "68641": p("NE", "Howells"),
  "68643": p("NE", "Leigh"),
  "68659": p("NE", "Rogers"),
  "68661": p("NE", "Schuyler"),
  "68004": p("NE", "Bancroft"),
  "68716": p("NE", "Beemer"),
  "68788": p("NE", "West Point"),
  "68791": p("NE", "Wisner"),
  "68813": p("NE", "Anselmo"),
  "68814": p("NE", "Ansley"),
  "68822": p("NE", "Broken Bow"),
  "68825": p("NE", "Callaway"),
  "68828": p("NE", "Comstock"),
  "68855": p("NE", "Mason City"),
  "68856": p("NE", "Merna"),
  "68860": p("NE", "Oconto"),
  "68874": p("NE", "Sargent"),
  "68881": p("NE", "Westerville"),
  "69120": p("NE", "Arnold"),
  "68030": p("NE", "Homer"),
  "68731": p("NE", "Dakota City"),
  "68733": p("NE", "Emerson"),
  "68741": p("NE", "Hubbard"),
  "68743": p("NE", "Jackson"),
  "68776": p("NE", "South Sioux City"),
  "69337": p("NE", "Chadron"),
  "69339": p("NE", "Crawford"),
  "69354": p("NE", "Marsland"),
  "69367": p("NE", "Whitney"),
  "68834": p("NE", "Eddyville"),
  "68850": p("NE", "Lexington"),
  "68863": p("NE", "Overton"),
  "68878": p("NE", "Sumner"),
  "69029": p("NE", "Farnam"),
  "69130": p("NE", "Cozad"),
  "69138": p("NE", "Gothenburg"),
  "69171": p("NE", "Willow Island"),
  "69122": p("NE", "Big Springs"),
  "69129": p("NE", "Chappell"),
  "68710": p("NE", "Allen"),
  "68728": p("NE", "Concord"),
  "68732": p("NE", "Dixon"),
  "68751": p("NE", "Maskell"),
  "68757": p("NE", "Newcastle"),
  "68770": p("NE", "Ponca"),
  "68784": p("NE", "Wakefield"),
  "68785": p("NE", "Waterbury"),
  "68025": p("NE", "Fremont"),
  "68026": p("NE", "Fremont"),
  "68031": p("NE", "Hooper"),
  "68044": p("NE", "Nickerson"),
  "68057": p("NE", "Scribner"),
  "68063": p("NE", "Uehling"),
  "68072": p("NE", "Winslow"),
  "68621": p("NE", "Ames"),
  "68633": p("NE", "Dodge"),
  "68649": p("NE", "North Bend"),
  "68664": p("NE", "Snyder"),
  "68007": p("NE", "Bennington"),
  "68010": p("NE", "Boys Town"),
  "68022": p("NE", "Elkhorn"),
  "68064": p("NE", "Valley"),
  "68069": p("NE", "Waterloo"),
  "68101": p("NE", "Omaha"),
  "68102": p("NE", "Omaha"),
  "68103": p("NE", "Omaha"),
  "68104": p("NE", "Omaha"),
  "68105": p("NE", "Omaha"),
  "68106": p("NE", "Omaha"),
  "68107": p("NE", "Omaha"),
  "68108": p("NE", "Omaha"),
  "68109": p("NE", "Omaha"),
  "68110": p("NE", "Omaha"),
  "68111": p("NE", "Omaha"),
  "68112": p("NE", "Omaha"),
  "68114": p("NE", "Omaha"),
  "68116": p("NE", "Omaha"),
  "68117": p("NE", "Omaha"),
  "68118": p("NE", "Omaha"),
  "68119": p("NE", "Omaha"),
  "68120": p("NE", "Omaha"),
  "68122": p("NE", "Omaha"),
  "68124": p("NE", "Omaha"),
  "68127": p("NE", "Omaha"),
  "68130": p("NE", "Omaha"),
  "68131": p("NE", "Omaha"),
  "68132": p("NE", "Omaha"),
  "68134": p("NE", "Omaha"),
  "68135": p("NE", "Omaha"),
  "68137": p("NE", "Omaha"),
  "68139": p("NE", "Omaha"),
  "68142": p("NE", "Omaha"),
  "68144": p("NE", "Omaha"),
  "68145": p("NE", "Omaha"),
  "68152": p("NE", "Omaha"),
  "68154": p("NE", "Omaha"),
  "68155": p("NE", "Omaha"),
  "68164": p("NE", "Omaha"),
  "68172": p("NE", "Omaha"),
  "68175": p("NE", "Omaha"),
  "68176": p("NE", "Omaha"),
  "68178": p("NE", "Omaha"),
  "68179": p("NE", "Omaha"),
  "68180": p("NE", "Omaha"),
  "68182": p("NE", "Omaha"),
  "68183": p("NE", "Omaha"),
  "68197": p("NE", "Omaha"),
  "68198": p("NE", "Omaha"),
  "69021": p("NE", "Benkelman"),
  "69030": p("NE", "Haigler"),
  "69037": p("NE", "Max"),
  "69041": p("NE", "Parks"),
  "68351": p("NE", "Exeter"),
  "68354": p("NE", "Fairmont"),
  "68361": p("NE", "Geneva"),
  "68365": p("NE", "Grafton"),
  "68406": p("NE", "Milligan"),
  "68416": p("NE", "Ohiowa"),
  "68436": p("NE", "Shickley"),
  "68444": p("NE", "Strang"),
  "68929": p("NE", "Bloomington"),
  "68932": p("NE", "Campbell"),
  "68939": p("NE", "Franklin"),
  "68947": p("NE", "Hildreth"),
  "68960": p("NE", "Naponee"),
  "68972": p("NE", "Riverton"),
  "68981": p("NE", "Upland"),
  "69025": p("NE", "Curtis"),
  "69028": p("NE", "Eustis"),
  "69038": p("NE", "Maywood"),
  "69039": p("NE", "Moorefield"),
  "69042": p("NE", "Stockville"),
  "68922": p("NE", "Arapahoe"),
  "68926": p("NE", "Beaver City"),
  "68936": p("NE", "Edison"),
  "68946": p("NE", "Hendley"),
  "68948": p("NE", "Holbrook"),
  "68967": p("NE", "Oxford"),
  "69022": p("NE", "Cambridge"),
  "69046": p("NE", "Wilsonville"),
  "68301": p("NE", "Adams"),
  "68309": p("NE", "Barneston"),
  "68310": p("NE", "Beatrice"),
  "68318": p("NE", "Blue Springs"),
  "68328": p("NE", "Clatonia"),
  "68331": p("NE", "Cortland"),
  "68357": p("NE", "Filley"),
  "68381": p("NE", "Liberty"),
  "68415": p("NE", "Odell"),
  "68422": p("NE", "Pickrell"),
  "68458": p("NE", "Virginia"),
  "68466": p("NE", "Wymore"),
  "69147": p("NE", "Lewellen"),
  "69148": p("NE", "Lisco"),
  "69154": p("NE", "Oshkosh"),
  "69190": p("NE", "Oshkosh"),
  "68823": p("NE", "Burwell"),
  "68937": p("NE", "Elwood"),
  "68976": p("NE", "Smithfield"),
  "69333": p("NE", "Ashby"),
  "69350": p("NE", "Hyannis"),
  "69366": p("NE", "Whitman"),
  "68665": p("NE", "Spalding"),
  "68842": p("NE", "Greeley"),
  "68875": p("NE", "Scotia"),
  "68882": p("NE", "Wolbach"),
  "68801": p("NE", "Grand Island"),
  "68802": p("NE", "Grand Island"),
  "68803": p("NE", "Grand Island"),
  "68810": p("NE", "Alda"),
  "68824": p("NE", "Cairo"),
  "68832": p("NE", "Doniphan"),
  "68883": p("NE", "Wood River"),
  "68818": p("NE", "Aurora"),
  "68841": p("NE", "Giltner"),
  "68843": p("NE", "Hampton"),
  "68846": p("NE", "Hordville"),
  "68854": p("NE", "Marquette"),
  "68865": p("NE", "Phillips"),
  "68920": p("NE", "Alma"),
  "68966": p("NE", "Orleans"),
  "68969": p("NE", "Ragan"),
  "68971": p("NE", "Republican City"),
  "68977": p("NE", "Stamford"),
  "69032": p("NE", "Hayes Center"),
  "69024": p("NE", "Culbertson"),
  "69040": p("NE", "Palisade"),
  "69043": p("NE", "Stratton"),
  "69044": p("NE", "Trenton"),
  "68711": p("NE", "Amelia"),
  "68713": p("NE", "Atkinson"),
  "68725": p("NE", "Chambers"),
  "68734": p("NE", "Emmet"),
  "68735": p("NE", "Ewing"),
  "68742": p("NE", "Inman"),
  "68763": p("NE", "Oneill"),
  "68766": p("NE", "Page"),
  "68780": p("NE", "Stuart"),
  "69152": p("NE", "Mullen"),
  "68820": p("NE", "Boelus"),
  "68831": p("NE", "Dannebrog"),
  "68835": p("NE", "Elba"),
  "68838": p("NE", "Farwell"),
  "68872": p("NE", "Saint Libory"),
  "68873": p("NE", "Saint Paul"),
  "68338": p("NE", "Daykin"),
  "68342": p("NE", "Diller"),
  "68350": p("NE", "Endicott"),
  "68352": p("NE", "Fairbury"),
  "68377": p("NE", "Jansen"),
  "68424": p("NE", "Plymouth"),
  "68440": p("NE", "Steele City"),
  "68329": p("NE", "Cook"),
  "68332": p("NE", "Crab Orchard"),
  "68348": p("NE", "Elk Creek"),
  "68443": p("NE", "Sterling"),
  "68450": p("NE", "Tecumseh"),
  "68924": p("NE", "Axtell"),
  "68945": p("NE", "Heartwell"),
  "68959": p("NE", "Minden"),
  "68982": p("NE", "Wilcox"),
  "69127": p("NE", "Brule"),
  "69144": p("NE", "Keystone"),
  "69146": p("NE", "Lemoyne"),
  "69153": p("NE", "Ogallala"),
  "69155": p("NE", "Paxton"),
  "68753": p("NE", "Mills"),
  "68759": p("NE", "Newport"),
  "68778": p("NE", "Springview"),
  "69128": p("NE", "Bushnell"),
  "69133": p("NE", "Dix"),
  "69145": p("NE", "Kimball"),
  "68718": p("NE", "Bloomfield"),
  "68724": p("NE", "Center"),
  "68729": p("NE", "Creighton"),
  "68730": p("NE", "Crofton"),
  "68760": p("NE", "Niobrara"),
  "68783": p("NE", "Verdigre"),
  "68786": p("NE", "Wausa"),
  "68789": p("NE", "Winnetoon"),
  "68317": p("NE", "Bennet"),
  "68336": p("NE", "Davey"),
  "68339": p("NE", "Denton"),
  "68358": p("NE", "Firth"),
  "68368": p("NE", "Hallam"),
  "68372": p("NE", "Hickman"),
  "68402": p("NE", "Malcolm"),
  "68404": p("NE", "Martell"),
  "68419": p("NE", "Panama"),
  "68428": p("NE", "Raymond"),
  "68430": p("NE", "Roca"),
  "68438": p("NE", "Sprague"),
  "68461": p("NE", "Walton"),
  "68462": p("NE", "Waverly"),
  "68501": p("NE", "Lincoln"),
  "68502": p("NE", "Lincoln"),
  "68503": p("NE", "Lincoln"),
  "68504": p("NE", "Lincoln"),
  "68505": p("NE", "Lincoln"),
  "68506": p("NE", "Lincoln"),
  "68507": p("NE", "Lincoln"),
  "68508": p("NE", "Lincoln"),
  "68509": p("NE", "Lincoln"),
  "68510": p("NE", "Lincoln"),
  "68512": p("NE", "Lincoln"),
  "68514": p("NE", "Lincoln"),
  "68516": p("NE", "Lincoln"),
  "68517": p("NE", "Lincoln"),
  "68520": p("NE", "Lincoln"),
  "68521": p("NE", "Lincoln"),
  "68522": p("NE", "Lincoln"),
  "68523": p("NE", "Lincoln"),
  "68524": p("NE", "Lincoln"),
  "68526": p("NE", "Lincoln"),
  "68527": p("NE", "Lincoln"),
  "68528": p("NE", "Lincoln"),
  "68529": p("NE", "Lincoln"),
  "68531": p("NE", "Lincoln"),
  "68532": p("NE", "Lincoln"),
  "68542": p("NE", "Lincoln"),
  "68544": p("NE", "Lincoln"),
  "68583": p("NE", "Lincoln"),
  "68588": p("NE", "Lincoln"),
  "69101": p("NE", "North Platte"),
  "69103": p("NE", "North Platte"),
  "69123": p("NE", "Brady"),
  "69132": p("NE", "Dickens"),
  "69143": p("NE", "Hershey"),
  "69151": p("NE", "Maxwell"),
  "69165": p("NE", "Sutherland"),
  "69169": p("NE", "Wallace"),
  "69170": p("NE", "Wellfleet"),
  "69163": p("NE", "Stapleton"),
  "68879": p("NE", "Taylor"),
  "69167": p("NE", "Tryon"),
  "68701": p("NE", "Norfolk"),
  "68702": p("NE", "Norfolk"),
  "68715": p("NE", "Battle Creek"),
  "68748": p("NE", "Madison"),
  "68752": p("NE", "Meadow Grove"),
  "68758": p("NE", "Newman Grove"),
  "68781": p("NE", "Tilden"),
  "68628": p("NE", "Clarks"),
  "68663": p("NE", "Silver Creek"),
  "68816": p("NE", "Archer"),
  "68826": p("NE", "Central City"),
  "68827": p("NE", "Chapman"),
  "68864": p("NE", "Palmer"),
  "69125": p("NE", "Broadwater"),
  "69331": p("NE", "Angora"),
  "69334": p("NE", "Bayard"),
  "69336": p("NE", "Bridgeport"),
  "68623": p("NE", "Belgrade"),
  "68638": p("NE", "Fullerton"),
  "68640": p("NE", "Genoa"),
  "68305": p("NE", "Auburn"),
  "68320": p("NE", "Brock"),
  "68321": p("NE", "Brownville"),
  "68378": p("NE", "Johnson"),
  "68379": p("NE", "Julian"),
  "68414": p("NE", "Nemaha"),
  "68421": p("NE", "Peru"),
  "68943": p("NE", "Hardy"),
  "68957": p("NE", "Lawrence"),
  "68961": p("NE", "Nelson"),
  "68964": p("NE", "Oak"),
  "68974": p("NE", "Ruskin"),
  "68978": p("NE", "Superior"),
  "68324": p("NE", "Burr"),
  "68344": p("NE", "Douglas"),
  "68346": p("NE", "Dunbar"),
  "68382": p("NE", "Lorton"),
  "68410": p("NE", "Nebraska City"),
  "68417": p("NE", "Otoe"),
  "68418": p("NE", "Palmyra"),
  "68446": p("NE", "Syracuse"),
  "68448": p("NE", "Talmage"),
  "68454": p("NE", "Unadilla"),
  "68323": p("NE", "Burchard"),
  "68345": p("NE", "Du Bois"),
  "68380": p("NE", "Lewiston"),
  "68420": p("NE", "Pawnee City"),
  "68441": p("NE", "Steinauer"),
  "68447": p("NE", "Table Rock"),
  "69134": p("NE", "Elsie"),
  "69140": p("NE", "Grant"),
  "69150": p("NE", "Madrid"),
  "69168": p("NE", "Venango"),
  "68923": p("NE", "Atlanta"),
  "68927": p("NE", "Bertrand"),
  "68940": p("NE", "Funk"),
  "68949": p("NE", "Holdrege"),
  "68958": p("NE", "Loomis"),
  "68738": p("NE", "Hadar"),
  "68747": p("NE", "Mclean"),
  "68765": p("NE", "Osmond"),
  "68767": p("NE", "Pierce"),
  "68769": p("NE", "Plainview"),
  "68601": p("NE", "Columbus"),
  "68602": p("NE", "Columbus"),
  "68631": p("NE", "Creston"),
  "68634": p("NE", "Duncan"),
  "68642": p("NE", "Humphrey"),
  "68644": p("NE", "Lindsay"),
  "68647": p("NE", "Monroe"),
  "68653": p("NE", "Platte Center"),
  "68651": p("NE", "Osceola"),
  "68654": p("NE", "Polk"),
  "68662": p("NE", "Shelby"),
  "68666": p("NE", "Stromsburg"),
  "69001": p("NE", "Mc Cook"),
  "69020": p("NE", "Bartley"),
  "69026": p("NE", "Danbury"),
  "69034": p("NE", "Indianola"),
  "69036": p("NE", "Lebanon"),
  "68337": p("NE", "Dawson"),
  "68355": p("NE", "Falls City"),
  "68376": p("NE", "Humboldt"),
  "68431": p("NE", "Rulo"),
  "68433": p("NE", "Salem"),
  "68437": p("NE", "Shubert"),
  "68442": p("NE", "Stella"),
  "68457": p("NE", "Verdon"),
  "68714": p("NE", "Bassett"),
  "68333": p("NE", "Crete"),
  "68341": p("NE", "De Witt"),
  "68343": p("NE", "Dorchester"),
  "68359": p("NE", "Friend"),
  "68445": p("NE", "Swanton"),
  "68453": p("NE", "Tobias"),
  "68464": p("NE", "Western"),
  "68465": p("NE", "Wilber"),
  "68005": p("NE", "Bellevue"),
  "68028": p("NE", "Gretna"),
  "68046": p("NE", "Papillion"),
  "68056": p("NE", "St Columbans"),
  "68059": p("NE", "Springfield"),
  "68113": p("NE", "Offutt Afb"),
  "68123": p("NE", "Bellevue"),
  "68128": p("NE", "La Vista"),
  "68133": p("NE", "Papillion"),
  "68136": p("NE", "Omaha"),
  "68138": p("NE", "Omaha"),
  "68147": p("NE", "Bellevue"),
  "68157": p("NE", "Omaha"),
  "68003": p("NE", "Ashland"),
  "68015": p("NE", "Cedar Bluffs"),
  "68017": p("NE", "Ceresco"),
  "68018": p("NE", "Colon"),
  "68033": p("NE", "Ithaca"),
  "68040": p("NE", "Malmo"),
  "68041": p("NE", "Mead"),
  "68042": p("NE", "Memphis"),
  "68050": p("NE", "Prague"),
  "68065": p("NE", "Valparaiso"),
  "68066": p("NE", "Wahoo"),
  "68070": p("NE", "Weston"),
  "68073": p("NE", "Yutan"),
  "68648": p("NE", "Morse Bluff"),
  "69341": p("NE", "Gering"),
  "69352": p("NE", "Lyman"),
  "69353": p("NE", "Mcgrew"),
  "69355": p("NE", "Melbeta"),
  "69356": p("NE", "Minatare"),
  "69357": p("NE", "Mitchell"),
  "69358": p("NE", "Morrill"),
  "69361": p("NE", "Scottsbluff"),
  "69363": p("NE", "Scottsbluff"),
  "68313": p("NE", "Beaver Crossing"),
  "68314": p("NE", "Bee"),
  "68330": p("NE", "Cordova"),
  "68360": p("NE", "Garland"),
  "68364": p("NE", "Goehner"),
  "68405": p("NE", "Milford"),
  "68423": p("NE", "Pleasant Dale"),
  "68434": p("NE", "Seward"),
  "68439": p("NE", "Staplehurst"),
  "68456": p("NE", "Utica"),
  "69335": p("NE", "Bingham"),
  "69340": p("NE", "Ellsworth"),
  "69343": p("NE", "Gordon"),
  "69347": p("NE", "Hay Springs"),
  "69351": p("NE", "Lakeside"),
  "69360": p("NE", "Rushville"),
  "69365": p("NE", "Whiteclay"),
  "68817": p("NE", "Ashton"),
  "68844": p("NE", "Hazard"),
  "68852": p("NE", "Litchfield"),
  "68853": p("NE", "Loup City"),
  "68871": p("NE", "Rockville"),
  "69346": p("NE", "Harrison"),
  "68768": p("NE", "Pilger"),
  "68779": p("NE", "Stanton"),
  "68303": p("NE", "Alexandria"),
  "68315": p("NE", "Belvidere"),
  "68322": p("NE", "Bruning"),
  "68325": p("NE", "Byron"),
  "68326": p("NE", "Carleton"),
  "68327": p("NE", "Chester"),
  "68335": p("NE", "Davenport"),
  "68340": p("NE", "Deshler"),
  "68362": p("NE", "Gilead"),
  "68370": p("NE", "Hebron"),
  "68375": p("NE", "Hubbell"),
  "68429": p("NE", "Reynolds"),
  "69142": p("NE", "Halsey"),
  "69161": p("NE", "Seneca"),
  "69166": p("NE", "Thedford"),
  "68039": p("NE", "Macy"),
  "68047": p("NE", "Pender"),
  "68055": p("NE", "Rosalie"),
  "68062": p("NE", "Thurston"),
  "68067": p("NE", "Walthill"),
  "68071": p("NE", "Winnebago"),
  "68815": p("NE", "Arcadia"),
  "68837": p("NE", "Elyria"),
  "68859": p("NE", "North Loup"),
  "68862": p("NE", "Ord"),
  "68002": p("NE", "Arlington"),
  "68008": p("NE", "Blair"),
  "68009": p("NE", "Blair"),
  "68023": p("NE", "Fort Calhoun"),
  "68029": p("NE", "Herman"),
  "68034": p("NE", "Kennard"),
  "68068": p("NE", "Washington"),
  "68723": p("NE", "Carroll"),
  "68740": p("NE", "Hoskins"),
  "68787": p("NE", "Wayne"),
  "68790": p("NE", "Winside"),
  "68928": p("NE", "Bladen"),
  "68930": p("NE", "Blue Hill"),
  "68942": p("NE", "Guide Rock"),
  "68952": p("NE", "Inavale"),
  "68970": p("NE", "Red Cloud"),
  "68622": p("NE", "Bartlett"),
  "68637": p("NE", "Ericson"),
  "68316": p("NE", "Benedict"),
  "68319": p("NE", "Bradshaw"),
  "68367": p("NE", "Gresham"),
  "68371": p("NE", "Henderson"),
  "68401": p("NE", "Mc Cool Junction"),
  "68460": p("NE", "Waco"),
  "68467": p("NE", "York"),
  "03218": p("NH", "Barnstead"),
  "03220": p("NH", "Belmont"),
  "03225": p("NH", "Center Barnstead"),
  "03226": p("NH", "Center Harbor"),
  "03237": p("NH", "Gilmanton"),
  "03246": p("NH", "Laconia"),
  "03247": p("NH", "Laconia"),
  "03249": p("NH", "Gilford"),
  "03252": p("NH", "Lochmere"),
  "03253": p("NH", "Meredith"),
  "03256": p("NH", "New Hampton"),
  "03269": p("NH", "Sanbornton"),
  "03276": p("NH", "Tilton"),
  "03289": p("NH", "Winnisquam"),
  "03298": p("NH", "Tilton"),
  "03299": p("NH", "Tilton"),
  "03809": p("NH", "Alton"),
  "03810": p("NH", "Alton Bay"),
  "03837": p("NH", "Gilmanton Iron Works"),
  "03227": p("NH", "Center Sandwich"),
  "03254": p("NH", "Moultonborough"),
  "03259": p("NH", "North Sandwich"),
  "03812": p("NH", "Bartlett"),
  "03813": p("NH", "Center Conway"),
  "03814": p("NH", "Center Ossipee"),
  "03816": p("NH", "Center Tuftonboro"),
  "03817": p("NH", "Chocorua"),
  "03818": p("NH", "Conway"),
  "03830": p("NH", "East Wakefield"),
  "03832": p("NH", "Eaton Center"),
  "03836": p("NH", "Freedom"),
  "03838": p("NH", "Glen"),
  "03845": p("NH", "Intervale"),
  "03846": p("NH", "Jackson"),
  "03847": p("NH", "Kearsarge"),
  "03849": p("NH", "Madison"),
  "03850": p("NH", "Melvin Village"),
  "03853": p("NH", "Mirror Lake"),
  "03860": p("NH", "North Conway"),
  "03861": p("NH", "Lee"),
  "03864": p("NH", "Ossipee"),
  "03872": p("NH", "Sanbornville"),
  "03875": p("NH", "Silver Lake"),
  "03882": p("NH", "Effingham"),
  "03883": p("NH", "South Tamworth"),
  "03886": p("NH", "Tamworth"),
  "03890": p("NH", "West Ossipee"),
  "03894": p("NH", "Wolfeboro"),
  "03896": p("NH", "Wolfeboro Falls"),
  "03897": p("NH", "Wonalancet"),
  "03431": p("NH", "Keene"),
  "03435": p("NH", "Keene"),
  "03441": p("NH", "Ashuelot"),
  "03443": p("NH", "Chesterfield"),
  "03444": p("NH", "Dublin"),
  "03445": p("NH", "Sullivan"),
  "03446": p("NH", "Swanzey"),
  "03447": p("NH", "Fitzwilliam"),
  "03448": p("NH", "Gilsum"),
  "03450": p("NH", "Harrisville"),
  "03451": p("NH", "Hinsdale"),
  "03452": p("NH", "Jaffrey"),
  "03455": p("NH", "Marlborough"),
  "03456": p("NH", "Marlow"),
  "03457": p("NH", "Nelson"),
  "03461": p("NH", "Rindge"),
  "03462": p("NH", "Spofford"),
  "03464": p("NH", "Stoddard"),
  "03465": p("NH", "Troy"),
  "03466": p("NH", "West Chesterfield"),
  "03467": p("NH", "Westmoreland"),
  "03469": p("NH", "West Swanzey"),
  "03470": p("NH", "Winchester"),
  "03602": p("NH", "Alstead"),
  "03604": p("NH", "Drewsville"),
  "03608": p("NH", "Walpole"),
  "03609": p("NH", "North Walpole"),
  "03570": p("NH", "Berlin"),
  "03575": p("NH", "Bretton Woods"),
  "03576": p("NH", "Colebrook"),
  "03579": p("NH", "Errol"),
  "03581": p("NH", "Gorham"),
  "03582": p("NH", "Groveton"),
  "03583": p("NH", "Jefferson"),
  "03584": p("NH", "Lancaster"),
  "03588": p("NH", "Milan"),
  "03589": p("NH", "Mount Washington"),
  "03590": p("NH", "North Stratford"),
  "03592": p("NH", "Pittsburg"),
  "03593": p("NH", "Randolph"),
  "03595": p("NH", "Twin Mountain"),
  "03597": p("NH", "West Stewartstown"),
  "03598": p("NH", "Whitefield"),
  "03215": p("NH", "Waterville Valley"),
  "03217": p("NH", "Ashland"),
  "03222": p("NH", "Bristol"),
  "03223": p("NH", "Campton"),
  "03238": p("NH", "Glencliff"),
  "03240": p("NH", "Grafton"),
  "03241": p("NH", "Hebron"),
  "03245": p("NH", "Holderness"),
  "03251": p("NH", "Lincoln"),
  "03258": p("NH", "Chichester"),
  "03262": p("NH", "North Woodstock"),
  "03264": p("NH", "Plymouth"),
  "03266": p("NH", "Rumney"),
  "03279": p("NH", "Warren"),
  "03282": p("NH", "Wentworth"),
  "03285": p("NH", "Thornton"),
  "03293": p("NH", "Woodstock"),
  "03561": p("NH", "Littleton"),
  "03574": p("NH", "Bethlehem"),
  "03580": p("NH", "Franconia"),
  "03585": p("NH", "Lisbon"),
  "03586": p("NH", "Sugar Hill"),
  "03740": p("NH", "Bath"),
  "03741": p("NH", "Canaan"),
  "03748": p("NH", "Enfield"),
  "03749": p("NH", "Enfield Center"),
  "03750": p("NH", "Etna"),
  "03755": p("NH", "Hanover"),
  "03756": p("NH", "Lebanon"),
  "03765": p("NH", "Haverhill"),
  "03766": p("NH", "Lebanon"),
  "03768": p("NH", "Lyme"),
  "03769": p("NH", "Lyme Center"),
  "03771": p("NH", "Monroe"),
  "03774": p("NH", "North Haverhill"),
  "03777": p("NH", "Orford"),
  "03779": p("NH", "Piermont"),
  "03780": p("NH", "Pike"),
  "03784": p("NH", "West Lebanon"),
  "03785": p("NH", "Woodsville"),
  "03031": p("NH", "Amherst"),
  "03033": p("NH", "Brookline"),
  "03043": p("NH", "Francestown"),
  "03045": p("NH", "Goffstown"),
  "03047": p("NH", "Greenfield"),
  "03048": p("NH", "Greenville"),
  "03049": p("NH", "Hollis"),
  "03051": p("NH", "Hudson"),
  "03052": p("NH", "Litchfield"),
  "03054": p("NH", "Merrimack"),
  "03055": p("NH", "Milford"),
  "03057": p("NH", "Mont Vernon"),
  "03060": p("NH", "Nashua"),
  "03061": p("NH", "Nashua"),
  "03062": p("NH", "Nashua"),
  "03063": p("NH", "Nashua"),
  "03064": p("NH", "Nashua"),
  "03070": p("NH", "New Boston"),
  "03071": p("NH", "New Ipswich"),
  "03076": p("NH", "Pelham"),
  "03082": p("NH", "Lyndeborough"),
  "03084": p("NH", "Temple"),
  "03086": p("NH", "Wilton"),
  "03101": p("NH", "Manchester"),
  "03102": p("NH", "Manchester"),
  "03103": p("NH", "Manchester"),
  "03104": p("NH", "Manchester"),
  "03105": p("NH", "Manchester"),
  "03108": p("NH", "Manchester"),
  "03109": p("NH", "Manchester"),
  "03110": p("NH", "Bedford"),
  "03111": p("NH", "Manchester"),
  "03244": p("NH", "Hillsborough"),
  "03281": p("NH", "Weare"),
  "03440": p("NH", "Antrim"),
  "03442": p("NH", "Bennington"),
  "03449": p("NH", "Hancock"),
  "03458": p("NH", "Peterborough"),
  "03468": p("NH", "West Peterborough"),
  "03046": p("NH", "Dunbarton"),
  "03106": p("NH", "Hooksett"),
  "03216": p("NH", "Andover"),
  "03221": p("NH", "Bradford"),
  "03224": p("NH", "Canterbury"),
  "03229": p("NH", "Contoocook"),
  "03230": p("NH", "Danbury"),
  "03231": p("NH", "East Andover"),
  "03233": p("NH", "Elkins"),
  "03234": p("NH", "Epsom"),
  "03235": p("NH", "Franklin"),
  "03242": p("NH", "Henniker"),
  "03243": p("NH", "Hill"),
  "03255": p("NH", "Newbury"),
  "03257": p("NH", "New London"),
  "03260": p("NH", "North Sutton"),
  "03263": p("NH", "Pittsfield"),
  "03268": p("NH", "Salisbury"),
  "03272": p("NH", "South Newbury"),
  "03273": p("NH", "South Sutton"),
  "03275": p("NH", "Suncook"),
  "03278": p("NH", "Warner"),
  "03287": p("NH", "Wilmot"),
  "03301": p("NH", "Concord"),
  "03302": p("NH", "Concord"),
  "03303": p("NH", "Concord"),
  "03304": p("NH", "Bow"),
  "03305": p("NH", "Concord"),
  "03307": p("NH", "Loudon"),
  "03032": p("NH", "Auburn"),
  "03034": p("NH", "Candia"),
  "03036": p("NH", "Chester"),
  "03037": p("NH", "Deerfield"),
  "03038": p("NH", "Derry"),
  "03040": p("NH", "East Candia"),
  "03041": p("NH", "East Derry"),
  "03042": p("NH", "Epping"),
  "03044": p("NH", "Fremont"),
  "03053": p("NH", "Londonderry"),
  "03073": p("NH", "North Salem"),
  "03077": p("NH", "Raymond"),
  "03079": p("NH", "Salem"),
  "03087": p("NH", "Windham"),
  "03261": p("NH", "Northwood"),
  "03290": p("NH", "Nottingham"),
  "03291": p("NH", "West Nottingham"),
  "03801": p("NH", "Portsmouth"),
  "03802": p("NH", "Portsmouth"),
  "03803": p("NH", "Portsmouth"),
  "03804": p("NH", "Portsmouth"),
  "03811": p("NH", "Atkinson"),
  "03819": p("NH", "Danville"),
  "03826": p("NH", "East Hampstead"),
  "03827": p("NH", "East Kingston"),
  "03833": p("NH", "Exeter"),
  "03840": p("NH", "Greenland"),
  "03841": p("NH", "Hampstead"),
  "03842": p("NH", "Hampton"),
  "03843": p("NH", "Hampton"),
  "03844": p("NH", "Hampton Falls"),
  "03848": p("NH", "Kingston"),
  "03854": p("NH", "New Castle"),
  "03856": p("NH", "Newfields"),
  "03857": p("NH", "Newmarket"),
  "03858": p("NH", "Newton"),
  "03859": p("NH", "Newton Junction"),
  "03862": p("NH", "North Hampton"),
  "03865": p("NH", "Plaistow"),
  "03870": p("NH", "Rye"),
  "03871": p("NH", "Rye Beach"),
  "03873": p("NH", "Sandown"),
  "03874": p("NH", "Seabrook"),
  "03885": p("NH", "Stratham"),
  "03815": p("NH", "Center Strafford"),
  "03820": p("NH", "Dover"),
  "03821": p("NH", "Dover"),
  "03822": p("NH", "Dover"),
  "03823": p("NH", "Madbury"),
  "03824": p("NH", "Durham"),
  "03825": p("NH", "Barrington"),
  "03835": p("NH", "Farmington"),
  "03839": p("NH", "Rochester"),
  "03851": p("NH", "Milton"),
  "03852": p("NH", "Milton Mills"),
  "03855": p("NH", "New Durham"),
  "03866": p("NH", "Rochester"),
  "03867": p("NH", "Rochester"),
  "03868": p("NH", "Rochester"),
  "03869": p("NH", "Rollinsford"),
  "03878": p("NH", "Somersworth"),
  "03884": p("NH", "Strafford"),
  "03887": p("NH", "Union"),
  "03280": p("NH", "Washington"),
  "03284": p("NH", "Springfield"),
  "03601": p("NH", "Acworth"),
  "03603": p("NH", "Charlestown"),
  "03605": p("NH", "Lempster"),
  "03607": p("NH", "South Acworth"),
  "03743": p("NH", "Claremont"),
  "03745": p("NH", "Cornish"),
  "03746": p("NH", "Cornish Flat"),
  "03751": p("NH", "Georges Mills"),
  "03752": p("NH", "Goshen"),
  "03753": p("NH", "Grantham"),
  "03754": p("NH", "Guild"),
  "03770": p("NH", "Meriden"),
  "03773": p("NH", "Newport"),
  "03781": p("NH", "Plainfield"),
  "03782": p("NH", "Sunapee"),
  "08037": p("NJ", "Hammonton"),
  "08201": p("NJ", "Absecon"),
  "08203": p("NJ", "Brigantine"),
  "08205": p("NJ", "Absecon"),
  "08213": p("NJ", "Cologne"),
  "08215": p("NJ", "Egg Harbor City"),
  "08217": p("NJ", "Elwood"),
  "08220": p("NJ", "Leeds Point"),
  "08221": p("NJ", "Linwood"),
  "08225": p("NJ", "Northfield"),
  "08231": p("NJ", "Oceanville"),
  "08232": p("NJ", "Pleasantville"),
  "08234": p("NJ", "Egg Harbor Township"),
  "08240": p("NJ", "Pomona"),
  "08241": p("NJ", "Port Republic"),
  "08244": p("NJ", "Somers Point"),
  "08310": p("NJ", "Buena"),
  "08317": p("NJ", "Dorothy"),
  "08319": p("NJ", "Estell Manor"),
  "08326": p("NJ", "Landisville"),
  "08330": p("NJ", "Mays Landing"),
  "08340": p("NJ", "Milmay"),
  "08341": p("NJ", "Minotola"),
  "08342": p("NJ", "Mizpah"),
  "08346": p("NJ", "Newtonville"),
  "08350": p("NJ", "Richland"),
  "08401": p("NJ", "Atlantic City"),
  "08402": p("NJ", "Margate City"),
  "08403": p("NJ", "Longport"),
  "08404": p("NJ", "Atlantic City"),
  "08405": p("NJ", "Atlantic City"),
  "08406": p("NJ", "Ventnor City"),
  "07010": p("NJ", "Cliffside Park"),
  "07020": p("NJ", "Edgewater"),
  "07022": p("NJ", "Fairview"),
  "07024": p("NJ", "Fort Lee"),
  "07026": p("NJ", "Garfield"),
  "07031": p("NJ", "North Arlington"),
  "07057": p("NJ", "Wallington"),
  "07070": p("NJ", "Rutherford"),
  "07071": p("NJ", "Lyndhurst"),
  "07072": p("NJ", "Carlstadt"),
  "07073": p("NJ", "East Rutherford"),
  "07074": p("NJ", "Moonachie"),
  "07075": p("NJ", "Wood Ridge"),
  "07401": p("NJ", "Allendale"),
  "07407": p("NJ", "Elmwood Park"),
  "07410": p("NJ", "Fair Lawn"),
  "07417": p("NJ", "Franklin Lakes"),
  "07423": p("NJ", "Ho Ho Kus"),
  "07430": p("NJ", "Mahwah"),
  "07432": p("NJ", "Midland Park"),
  "07436": p("NJ", "Oakland"),
  "07446": p("NJ", "Ramsey"),
  "07450": p("NJ", "Ridgewood"),
  "07451": p("NJ", "Ridgewood"),
  "07452": p("NJ", "Glen Rock"),
  "07458": p("NJ", "Saddle River"),
  "07463": p("NJ", "Waldwick"),
  "07481": p("NJ", "Wyckoff"),
  "07495": p("NJ", "Mahwah"),
  "07601": p("NJ", "Hackensack"),
  "07602": p("NJ", "Hackensack"),
  "07603": p("NJ", "Bogota"),
  "07604": p("NJ", "Hasbrouck Heights"),
  "07605": p("NJ", "Leonia"),
  "07606": p("NJ", "South Hackensack"),
  "07607": p("NJ", "Maywood"),
  "07608": p("NJ", "Teterboro"),
  "07620": p("NJ", "Alpine"),
  "07621": p("NJ", "Bergenfield"),
  "07624": p("NJ", "Closter"),
  "07626": p("NJ", "Cresskill"),
  "07627": p("NJ", "Demarest"),
  "07628": p("NJ", "Dumont"),
  "07630": p("NJ", "Emerson"),
  "07631": p("NJ", "Englewood"),
  "07632": p("NJ", "Englewood Cliffs"),
  "07640": p("NJ", "Harrington Park"),
  "07641": p("NJ", "Haworth"),
  "07642": p("NJ", "Hillsdale"),
  "07643": p("NJ", "Little Ferry"),
  "07644": p("NJ", "Lodi"),
  "07645": p("NJ", "Montvale"),
  "07646": p("NJ", "New Milford"),
  "07647": p("NJ", "Northvale"),
  "07648": p("NJ", "Norwood"),
  "07649": p("NJ", "Oradell"),
  "07650": p("NJ", "Palisades Park"),
  "07652": p("NJ", "Paramus"),
  "07653": p("NJ", "Paramus"),
  "07656": p("NJ", "Park Ridge"),
  "07657": p("NJ", "Ridgefield"),
  "07660": p("NJ", "Ridgefield Park"),
  "07661": p("NJ", "River Edge"),
  "07662": p("NJ", "Rochelle Park"),
  "07663": p("NJ", "Saddle Brook"),
  "07666": p("NJ", "Teaneck"),
  "07670": p("NJ", "Tenafly"),
  "07675": p("NJ", "Westwood"),
  "07676": p("NJ", "Township Of Washington"),
  "07677": p("NJ", "Woodcliff Lake"),
  "07699": p("NJ", "Teterboro"),
  "08010": p("NJ", "Beverly"),
  "08011": p("NJ", "Birmingham"),
  "08015": p("NJ", "Browns Mills"),
  "08016": p("NJ", "Burlington"),
  "08019": p("NJ", "Chatsworth"),
  "08022": p("NJ", "Columbus"),
  "08036": p("NJ", "Hainesport"),
  "08041": p("NJ", "Jobstown"),
  "08042": p("NJ", "Juliustown"),
  "08046": p("NJ", "Willingboro"),
  "08048": p("NJ", "Lumberton"),
  "08052": p("NJ", "Maple Shade"),
  "08053": p("NJ", "Marlton"),
  "08054": p("NJ", "Mount Laurel"),
  "08055": p("NJ", "Medford"),
  "08057": p("NJ", "Moorestown"),
  "08060": p("NJ", "Mount Holly"),
  "08064": p("NJ", "New Lisbon"),
  "08065": p("NJ", "Palmyra"),
  "08068": p("NJ", "Pemberton"),
  "08073": p("NJ", "Rancocas"),
  "08075": p("NJ", "Riverside"),
  "08076": p("NJ", "Riverton"),
  "08077": p("NJ", "Riverton"),
  "08088": p("NJ", "Vincentown"),
  "08224": p("NJ", "New Gretna"),
  "08505": p("NJ", "Bordentown"),
  "08511": p("NJ", "Cookstown"),
  "08515": p("NJ", "Chesterfield"),
  "08518": p("NJ", "Florence"),
  "08554": p("NJ", "Roebling"),
  "08562": p("NJ", "Wrightstown"),
  "08640": p("NJ", "Joint Base Mdl"),
  "08641": p("NJ", "Joint Base Mdl"),
  "08002": p("NJ", "Cherry Hill"),
  "08003": p("NJ", "Cherry Hill"),
  "08004": p("NJ", "Atco"),
  "08007": p("NJ", "Barrington"),
  "08009": p("NJ", "Berlin"),
  "08012": p("NJ", "Blackwood"),
  "08018": p("NJ", "Cedar Brook"),
  "08021": p("NJ", "Clementon"),
  "08026": p("NJ", "Gibbsboro"),
  "08029": p("NJ", "Glendora"),
  "08030": p("NJ", "Gloucester City"),
  "08031": p("NJ", "Bellmawr"),
  "08033": p("NJ", "Haddonfield"),
  "08034": p("NJ", "Cherry Hill"),
  "08035": p("NJ", "Haddon Heights"),
  "08043": p("NJ", "Voorhees"),
  "08045": p("NJ", "Lawnside"),
  "08049": p("NJ", "Magnolia"),
  "08059": p("NJ", "Mount Ephraim"),
  "08078": p("NJ", "Runnemede"),
  "08081": p("NJ", "Sicklerville"),
  "08083": p("NJ", "Somerdale"),
  "08084": p("NJ", "Stratford"),
  "08089": p("NJ", "Waterford Works"),
  "08091": p("NJ", "West Berlin"),
  "08095": p("NJ", "Winslow"),
  "08099": p("NJ", "Bellmawr"),
  "08101": p("NJ", "Camden"),
  "08102": p("NJ", "Camden"),
  "08103": p("NJ", "Camden"),
  "08104": p("NJ", "Camden"),
  "08105": p("NJ", "Camden"),
  "08106": p("NJ", "Audubon"),
  "08107": p("NJ", "Oaklyn"),
  "08108": p("NJ", "Collingswood"),
  "08109": p("NJ", "Merchantville"),
  "08110": p("NJ", "Pennsauken"),
  "08202": p("NJ", "Avalon"),
  "08204": p("NJ", "Cape May"),
  "08210": p("NJ", "Cape May Court House"),
  "08212": p("NJ", "Cape May Point"),
  "08214": p("NJ", "Dennisville"),
  "08218": p("NJ", "Goshen"),
  "08219": p("NJ", "Green Creek"),
  "08223": p("NJ", "Marmora"),
  "08226": p("NJ", "Ocean City"),
  "08230": p("NJ", "Ocean View"),
  "08242": p("NJ", "Rio Grande"),
  "08243": p("NJ", "Sea Isle City"),
  "08245": p("NJ", "South Dennis"),
  "08246": p("NJ", "South Seaville"),
  "08247": p("NJ", "Stone Harbor"),
  "08248": p("NJ", "Strathmere"),
  "08250": p("NJ", "Tuckahoe"),
  "08251": p("NJ", "Villas"),
  "08252": p("NJ", "Whitesboro"),
  "08260": p("NJ", "Wildwood"),
  "08270": p("NJ", "Woodbine"),
  "08302": p("NJ", "Bridgeton"),
  "08311": p("NJ", "Cedarville"),
  "08313": p("NJ", "Deerfield Street"),
  "08314": p("NJ", "Delmont"),
  "08315": p("NJ", "Dividing Creek"),
  "08316": p("NJ", "Dorchester"),
  "08320": p("NJ", "Fairton"),
  "08321": p("NJ", "Fortescue"),
  "08323": p("NJ", "Greenwich"),
  "08324": p("NJ", "Heislerville"),
  "08327": p("NJ", "Leesburg"),
  "08329": p("NJ", "Mauricetown"),
  "08332": p("NJ", "Millville"),
  "08345": p("NJ", "Newport"),
  "08348": p("NJ", "Port Elizabeth"),
  "08349": p("NJ", "Port Norris"),
  "08352": p("NJ", "Rosenhayn"),
  "08353": p("NJ", "Shiloh"),
  "08360": p("NJ", "Vineland"),
  "08361": p("NJ", "Vineland"),
  "08362": p("NJ", "Vineland"),
  "07003": p("NJ", "Bloomfield"),
  "07004": p("NJ", "Fairfield"),
  "07006": p("NJ", "Caldwell"),
  "07007": p("NJ", "Caldwell"),
  "07009": p("NJ", "Cedar Grove"),
  "07017": p("NJ", "East Orange"),
  "07018": p("NJ", "East Orange"),
  "07019": p("NJ", "East Orange"),
  "07021": p("NJ", "Essex Fells"),
  "07028": p("NJ", "Glen Ridge"),
  "07039": p("NJ", "Livingston"),
  "07040": p("NJ", "Maplewood"),
  "07041": p("NJ", "Millburn"),
  "07042": p("NJ", "Montclair"),
  "07043": p("NJ", "Montclair"),
  "07044": p("NJ", "Verona"),
  "07050": p("NJ", "Orange"),
  "07051": p("NJ", "Orange"),
  "07052": p("NJ", "West Orange"),
  "07068": p("NJ", "Roseland"),
  "07078": p("NJ", "Short Hills"),
  "07079": p("NJ", "South Orange"),
  "07101": p("NJ", "Newark"),
  "07102": p("NJ", "Newark"),
  "07103": p("NJ", "Newark"),
  "07104": p("NJ", "Newark"),
  "07105": p("NJ", "Newark"),
  "07106": p("NJ", "Newark"),
  "07107": p("NJ", "Newark"),
  "07108": p("NJ", "Newark"),
  "07109": p("NJ", "Belleville"),
  "07110": p("NJ", "Nutley"),
  "07111": p("NJ", "Irvington"),
  "07112": p("NJ", "Newark"),
  "07114": p("NJ", "Newark"),
  "07175": p("NJ", "Newark"),
  "07184": p("NJ", "Newark"),
  "07188": p("NJ", "Newark"),
  "07189": p("NJ", "Newark"),
  "07191": p("NJ", "Newark"),
  "07192": p("NJ", "Newark"),
  "07193": p("NJ", "Newark"),
  "07195": p("NJ", "Newark"),
  "07198": p("NJ", "Newark"),
  "07199": p("NJ", "Newark"),
  "08014": p("NJ", "Bridgeport"),
  "08020": p("NJ", "Clarksboro"),
  "08025": p("NJ", "Ewan"),
  "08027": p("NJ", "Gibbstown"),
  "08028": p("NJ", "Glassboro"),
  "08032": p("NJ", "Grenloch"),
  "08039": p("NJ", "Harrisonville"),
  "08051": p("NJ", "Mantua"),
  "08056": p("NJ", "Mickleton"),
  "08061": p("NJ", "Mount Royal"),
  "08062": p("NJ", "Mullica Hill"),
  "08063": p("NJ", "National Park"),
  "08066": p("NJ", "Paulsboro"),
  "08071": p("NJ", "Pitman"),
  "08074": p("NJ", "Richwood"),
  "08080": p("NJ", "Sewell"),
  "08085": p("NJ", "Swedesboro"),
  "08086": p("NJ", "Thorofare"),
  "08090": p("NJ", "Wenonah"),
  "08093": p("NJ", "Westville"),
  "08094": p("NJ", "Williamstown"),
  "08096": p("NJ", "Deptford"),
  "08097": p("NJ", "Woodbury Heights"),
  "08312": p("NJ", "Clayton"),
  "08322": p("NJ", "Franklinville"),
  "08328": p("NJ", "Malaga"),
  "08343": p("NJ", "Monroeville"),
  "08344": p("NJ", "Newfield"),
  "07002": p("NJ", "Bayonne"),
  "07029": p("NJ", "Harrison"),
  "07030": p("NJ", "Hoboken"),
  "07032": p("NJ", "Kearny"),
  "07047": p("NJ", "North Bergen"),
  "07086": p("NJ", "Weehawken"),
  "07087": p("NJ", "Union City"),
  "07093": p("NJ", "West New York"),
  "07094": p("NJ", "Secaucus"),
  "07096": p("NJ", "Secaucus"),
  "07097": p("NJ", "Jersey City"),
  "07099": p("NJ", "Kearny"),
  "07302": p("NJ", "Jersey City"),
  "07303": p("NJ", "Jersey City"),
  "07304": p("NJ", "Jersey City"),
  "07305": p("NJ", "Jersey City"),
  "07306": p("NJ", "Jersey City"),
  "07307": p("NJ", "Jersey City"),
  "07308": p("NJ", "Jersey City"),
  "07310": p("NJ", "Jersey City"),
  "07311": p("NJ", "Jersey City"),
  "07395": p("NJ", "Jersey City"),
  "07399": p("NJ", "Jersey City"),
  "07830": p("NJ", "Califon"),
  "07979": p("NJ", "Pottersville"),
  "08530": p("NJ", "Lambertville"),
  "08551": p("NJ", "Ringoes"),
  "08556": p("NJ", "Rosemont"),
  "08557": p("NJ", "Sergeantsville"),
  "08559": p("NJ", "Stockton"),
  "08801": p("NJ", "Annandale"),
  "08803": p("NJ", "Baptistown"),
  "08804": p("NJ", "Bloomsbury"),
  "08809": p("NJ", "Clinton"),
  "08822": p("NJ", "Flemington"),
  "08825": p("NJ", "Frenchtown"),
  "08826": p("NJ", "Glen Gardner"),
  "08827": p("NJ", "Hampton"),
  "08829": p("NJ", "High Bridge"),
  "08833": p("NJ", "Lebanon"),
  "08834": p("NJ", "Little York"),
  "08848": p("NJ", "Milford"),
  "08858": p("NJ", "Oldwick"),
  "08867": p("NJ", "Pittstown"),
  "08868": p("NJ", "Quakertown"),
  "08870": p("NJ", "Readington"),
  "08885": p("NJ", "Stanton"),
  "08887": p("NJ", "Three Bridges"),
  "08888": p("NJ", "Whitehouse"),
  "08889": p("NJ", "Whitehouse Station"),
  "08520": p("NJ", "Hightstown"),
  "08525": p("NJ", "Hopewell"),
  "08534": p("NJ", "Pennington"),
  "08540": p("NJ", "Princeton"),
  "08541": p("NJ", "Princeton"),
  "08542": p("NJ", "Princeton"),
  "08543": p("NJ", "Princeton"),
  "08544": p("NJ", "Princeton"),
  "08550": p("NJ", "Princeton Junction"),
  "08560": p("NJ", "Titusville"),
  "08561": p("NJ", "Windsor"),
  "08601": p("NJ", "Trenton"),
  "08602": p("NJ", "Trenton"),
  "08603": p("NJ", "Trenton"),
  "08604": p("NJ", "Trenton"),
  "08605": p("NJ", "Trenton"),
  "08606": p("NJ", "Trenton"),
  "08607": p("NJ", "Trenton"),
  "08608": p("NJ", "Trenton"),
  "08609": p("NJ", "Trenton"),
  "08610": p("NJ", "Trenton"),
  "08611": p("NJ", "Trenton"),
  "08618": p("NJ", "Trenton"),
  "08619": p("NJ", "Trenton"),
  "08620": p("NJ", "Trenton"),
  "08625": p("NJ", "Trenton"),
  "08628": p("NJ", "Trenton"),
  "08629": p("NJ", "Trenton"),
  "08638": p("NJ", "Trenton"),
  "08644": p("NJ", "Trenton"),
  "08645": p("NJ", "Trenton"),
  "08646": p("NJ", "Trenton"),
  "08647": p("NJ", "Trenton"),
  "08648": p("NJ", "Lawrence Township"),
  "08650": p("NJ", "Trenton"),
  "08666": p("NJ", "Trenton"),
  "08690": p("NJ", "Trenton"),
  "08691": p("NJ", "Trenton"),
  "08695": p("NJ", "Trenton"),
  "07001": p("NJ", "Avenel"),
  "07008": p("NJ", "Carteret"),
  "07064": p("NJ", "Port Reading"),
  "07067": p("NJ", "Colonia"),
  "07077": p("NJ", "Sewaren"),
  "07080": p("NJ", "South Plainfield"),
  "07095": p("NJ", "Woodbridge"),
  "08512": p("NJ", "Cranbury"),
  "08536": p("NJ", "Plainsboro"),
  "08810": p("NJ", "Dayton"),
  "08812": p("NJ", "Dunellen"),
  "08816": p("NJ", "East Brunswick"),
  "08817": p("NJ", "Edison"),
  "08818": p("NJ", "Edison"),
  "08820": p("NJ", "Edison"),
  "08824": p("NJ", "Kendall Park"),
  "08828": p("NJ", "Helmetta"),
  "08830": p("NJ", "Iselin"),
  "08831": p("NJ", "Monroe Township"),
  "08832": p("NJ", "Keasbey"),
  "08837": p("NJ", "Edison"),
  "08840": p("NJ", "Metuchen"),
  "08846": p("NJ", "Middlesex"),
  "08850": p("NJ", "Milltown"),
  "08852": p("NJ", "Monmouth Junction"),
  "08854": p("NJ", "Piscataway"),
  "08855": p("NJ", "Piscataway"),
  "08857": p("NJ", "Old Bridge"),
  "08859": p("NJ", "Parlin"),
  "08861": p("NJ", "Perth Amboy"),
  "08862": p("NJ", "Perth Amboy"),
  "08863": p("NJ", "Fords"),
  "08871": p("NJ", "Sayreville"),
  "08872": p("NJ", "Sayreville"),
  "08879": p("NJ", "South Amboy"),
  "08882": p("NJ", "South River"),
  "08884": p("NJ", "Spotswood"),
  "08899": p("NJ", "Edison"),
  "08901": p("NJ", "New Brunswick"),
  "08902": p("NJ", "North Brunswick"),
  "08903": p("NJ", "New Brunswick"),
  "08904": p("NJ", "Highland Park"),
  "08906": p("NJ", "New Brunswick"),
  "08933": p("NJ", "New Brunswick"),
  "08989": p("NJ", "New Brunswick"),
  "07701": p("NJ", "Red Bank"),
  "07702": p("NJ", "Shrewsbury"),
  "07703": p("NJ", "Fort Monmouth"),
  "07704": p("NJ", "Fair Haven"),
  "07710": p("NJ", "Adelphia"),
  "07711": p("NJ", "Allenhurst"),
  "07712": p("NJ", "Asbury Park"),
  "07715": p("NJ", "Belmar"),
  "07716": p("NJ", "Atlantic Highlands"),
  "07717": p("NJ", "Avon By The Sea"),
  "07718": p("NJ", "Belford"),
  "07719": p("NJ", "Belmar"),
  "07720": p("NJ", "Bradley Beach"),
  "07721": p("NJ", "Cliffwood"),
  "07722": p("NJ", "Colts Neck"),
  "07723": p("NJ", "Deal"),
  "07724": p("NJ", "Eatontown"),
  "07726": p("NJ", "Englishtown"),
  "07727": p("NJ", "Farmingdale"),
  "07728": p("NJ", "Freehold"),
  "07730": p("NJ", "Hazlet"),
  "07731": p("NJ", "Howell"),
  "07732": p("NJ", "Highlands"),
  "07733": p("NJ", "Holmdel"),
  "07734": p("NJ", "Keansburg"),
  "07735": p("NJ", "Keyport"),
  "07737": p("NJ", "Leonardo"),
  "07738": p("NJ", "Lincroft"),
  "07739": p("NJ", "Little Silver"),
  "07740": p("NJ", "Long Branch"),
  "07746": p("NJ", "Marlboro"),
  "07747": p("NJ", "Matawan"),
  "07748": p("NJ", "Middletown"),
  "07750": p("NJ", "Monmouth Beach"),
  "07751": p("NJ", "Morganville"),
  "07752": p("NJ", "Navesink"),
  "07753": p("NJ", "Neptune"),
  "07754": p("NJ", "Neptune"),
  "07755": p("NJ", "Oakhurst"),
  "07756": p("NJ", "Ocean Grove"),
  "07757": p("NJ", "Oceanport"),
  "07758": p("NJ", "Port Monmouth"),
  "07760": p("NJ", "Rumson"),
  "07762": p("NJ", "Spring Lake"),
  "07763": p("NJ", "Tennent"),
  "07764": p("NJ", "West Long Branch"),
  "07765": p("NJ", "Wickatunk"),
  "07799": p("NJ", "Eatontown"),
  "08501": p("NJ", "Allentown"),
  "08510": p("NJ", "Millstone Township"),
  "08514": p("NJ", "Cream Ridge"),
  "08526": p("NJ", "Imlaystown"),
  "08535": p("NJ", "Millstone Township"),
  "08555": p("NJ", "Roosevelt"),
  "08720": p("NJ", "Allenwood"),
  "08730": p("NJ", "Brielle"),
  "08736": p("NJ", "Manasquan"),
  "08750": p("NJ", "Sea Girt"),
  "07005": p("NJ", "Boonton"),
  "07034": p("NJ", "Lake Hiawatha"),
  "07035": p("NJ", "Lincoln Park"),
  "07045": p("NJ", "Montville"),
  "07046": p("NJ", "Mountain Lakes"),
  "07054": p("NJ", "Parsippany"),
  "07058": p("NJ", "Pine Brook"),
  "07082": p("NJ", "Towaco"),
  "07405": p("NJ", "Butler"),
  "07440": p("NJ", "Pequannock"),
  "07444": p("NJ", "Pompton Plains"),
  "07457": p("NJ", "Riverdale"),
  "07801": p("NJ", "Dover"),
  "07802": p("NJ", "Dover"),
  "07803": p("NJ", "Mine Hill"),
  "07806": p("NJ", "Picatinny Arsenal"),
  "07828": p("NJ", "Budd Lake"),
  "07834": p("NJ", "Denville"),
  "07836": p("NJ", "Flanders"),
  "07842": p("NJ", "Hibernia"),
  "07845": p("NJ", "Ironia"),
  "07847": p("NJ", "Kenvil"),
  "07849": p("NJ", "Lake Hopatcong"),
  "07850": p("NJ", "Landing"),
  "07852": p("NJ", "Ledgewood"),
  "07853": p("NJ", "Long Valley"),
  "07856": p("NJ", "Mount Arlington"),
  "07857": p("NJ", "Netcong"),
  "07866": p("NJ", "Rockaway"),
  "07869": p("NJ", "Randolph"),
  "07870": p("NJ", "Schooleys Mountain"),
  "07876": p("NJ", "Succasunna"),
  "07878": p("NJ", "Mount Tabor"),
  "07885": p("NJ", "Wharton"),
  "07926": p("NJ", "Brookside"),
  "07927": p("NJ", "Cedar Knolls"),
  "07928": p("NJ", "Chatham"),
  "07930": p("NJ", "Chester"),
  "07932": p("NJ", "Florham Park"),
  "07933": p("NJ", "Gillette"),
  "07935": p("NJ", "Green Village"),
  "07936": p("NJ", "East Hanover"),
  "07940": p("NJ", "Madison"),
  "07945": p("NJ", "Mendham"),
  "07946": p("NJ", "Millington"),
  "07950": p("NJ", "Morris Plains"),
  "07960": p("NJ", "Morristown"),
  "07961": p("NJ", "Convent Station"),
  "07962": p("NJ", "Morristown"),
  "07963": p("NJ", "Morristown"),
  "07970": p("NJ", "Mount Freedom"),
  "07976": p("NJ", "New Vernon"),
  "07980": p("NJ", "Stirling"),
  "07981": p("NJ", "Whippany"),
  "07999": p("NJ", "Whippany"),
  "08005": p("NJ", "Barnegat"),
  "08006": p("NJ", "Barnegat Light"),
  "08008": p("NJ", "Beach Haven"),
  "08050": p("NJ", "Manahawkin"),
  "08087": p("NJ", "Tuckerton"),
  "08092": p("NJ", "West Creek"),
  "08527": p("NJ", "Jackson"),
  "08533": p("NJ", "New Egypt"),
  "08701": p("NJ", "Lakewood"),
  "08721": p("NJ", "Bayville"),
  "08722": p("NJ", "Beachwood"),
  "08723": p("NJ", "Brick"),
  "08724": p("NJ", "Brick"),
  "08731": p("NJ", "Forked River"),
  "08732": p("NJ", "Island Heights"),
  "08733": p("NJ", "Lakehurst"),
  "08734": p("NJ", "Lanoka Harbor"),
  "08735": p("NJ", "Lavallette"),
  "08738": p("NJ", "Mantoloking"),
  "08739": p("NJ", "Normandy Beach"),
  "08740": p("NJ", "Ocean Gate"),
  "08741": p("NJ", "Pine Beach"),
  "08742": p("NJ", "Point Pleasant Beach"),
  "08751": p("NJ", "Seaside Heights"),
  "08752": p("NJ", "Seaside Park"),
  "08753": p("NJ", "Toms River"),
  "08754": p("NJ", "Toms River"),
  "08755": p("NJ", "Toms River"),
  "08756": p("NJ", "Toms River"),
  "08757": p("NJ", "Toms River"),
  "08758": p("NJ", "Waretown"),
  "08759": p("NJ", "Manchester Township"),
  "07011": p("NJ", "Clifton"),
  "07012": p("NJ", "Clifton"),
  "07013": p("NJ", "Clifton"),
  "07014": p("NJ", "Clifton"),
  "07015": p("NJ", "Clifton"),
  "07055": p("NJ", "Passaic"),
  "07403": p("NJ", "Bloomingdale"),
  "07420": p("NJ", "Haskell"),
  "07421": p("NJ", "Hewitt"),
  "07424": p("NJ", "Little Falls"),
  "07435": p("NJ", "Newfoundland"),
  "07438": p("NJ", "Oak Ridge"),
  "07442": p("NJ", "Pompton Lakes"),
  "07456": p("NJ", "Ringwood"),
  "07465": p("NJ", "Wanaque"),
  "07470": p("NJ", "Wayne"),
  "07474": p("NJ", "Wayne"),
  "07480": p("NJ", "West Milford"),
  "07501": p("NJ", "Paterson"),
  "07502": p("NJ", "Paterson"),
  "07503": p("NJ", "Paterson"),
  "07504": p("NJ", "Paterson"),
  "07505": p("NJ", "Paterson"),
  "07506": p("NJ", "Hawthorne"),
  "07507": p("NJ", "Hawthorne"),
  "07508": p("NJ", "Haledon"),
  "07509": p("NJ", "Paterson"),
  "07510": p("NJ", "Paterson"),
  "07511": p("NJ", "Totowa"),
  "07512": p("NJ", "Totowa"),
  "07513": p("NJ", "Paterson"),
  "07514": p("NJ", "Paterson"),
  "07522": p("NJ", "Paterson"),
  "07524": p("NJ", "Paterson"),
  "07533": p("NJ", "Paterson"),
  "07538": p("NJ", "Haledon"),
  "07543": p("NJ", "Paterson"),
  "07544": p("NJ", "Paterson"),
  "08001": p("NJ", "Alloway"),
  "08023": p("NJ", "Deepwater"),
  "08038": p("NJ", "Hancocks Bridge"),
  "08067": p("NJ", "Pedricktown"),
  "08069": p("NJ", "Penns Grove"),
  "08070": p("NJ", "Pennsville"),
  "08072": p("NJ", "Quinton"),
  "08079": p("NJ", "Salem"),
  "08098": p("NJ", "Woodstown"),
  "08318": p("NJ", "Elmer"),
  "08347": p("NJ", "Norma"),
  "07059": p("NJ", "Warren"),
  "07920": p("NJ", "Basking Ridge"),
  "07921": p("NJ", "Bedminster"),
  "07924": p("NJ", "Bernardsville"),
  "07931": p("NJ", "Far Hills"),
  "07934": p("NJ", "Gladstone"),
  "07938": p("NJ", "Liberty Corner"),
  "07939": p("NJ", "Lyons"),
  "07977": p("NJ", "Peapack"),
  "07978": p("NJ", "Pluckemin"),
  "08502": p("NJ", "Belle Mead"),
  "08504": p("NJ", "Blawenburg"),
  "08528": p("NJ", "Kingston"),
  "08553": p("NJ", "Rocky Hill"),
  "08558": p("NJ", "Skillman"),
  "08805": p("NJ", "Bound Brook"),
  "08807": p("NJ", "Bridgewater"),
  "08821": p("NJ", "Flagtown"),
  "08823": p("NJ", "Franklin Park"),
  "08835": p("NJ", "Manville"),
  "08836": p("NJ", "Martinsville"),
  "08844": p("NJ", "Hillsborough"),
  "08853": p("NJ", "Neshanic Station"),
  "08869": p("NJ", "Raritan"),
  "08873": p("NJ", "Somerset"),
  "08875": p("NJ", "Somerset"),
  "08876": p("NJ", "Somerville"),
  "08880": p("NJ", "South Bound Brook"),
  "08890": p("NJ", "Zarephath"),
  "07416": p("NJ", "Franklin"),
  "07418": p("NJ", "Glenwood"),
  "07419": p("NJ", "Hamburg"),
  "07422": p("NJ", "Highland Lakes"),
  "07428": p("NJ", "Mc Afee"),
  "07439": p("NJ", "Ogdensburg"),
  "07460": p("NJ", "Stockholm"),
  "07461": p("NJ", "Sussex"),
  "07462": p("NJ", "Vernon"),
  "07821": p("NJ", "Andover"),
  "07822": p("NJ", "Augusta"),
  "07826": p("NJ", "Branchville"),
  "07827": p("NJ", "Montague"),
  "07837": p("NJ", "Glasser"),
  "07839": p("NJ", "Greendell"),
  "07843": p("NJ", "Hopatcong"),
  "07848": p("NJ", "Lafayette"),
  "07851": p("NJ", "Layton"),
  "07855": p("NJ", "Middleville"),
  "07860": p("NJ", "Newton"),
  "07871": p("NJ", "Sparta"),
  "07874": p("NJ", "Stanhope"),
  "07875": p("NJ", "Stillwater"),
  "07877": p("NJ", "Swartswood"),
  "07879": p("NJ", "Tranquility"),
  "07881": p("NJ", "Wallpack Center"),
  "07890": p("NJ", "Branchville"),
  "07016": p("NJ", "Cranford"),
  "07023": p("NJ", "Fanwood"),
  "07027": p("NJ", "Garwood"),
  "07033": p("NJ", "Kenilworth"),
  "07036": p("NJ", "Linden"),
  "07060": p("NJ", "Plainfield"),
  "07061": p("NJ", "Plainfield"),
  "07062": p("NJ", "Plainfield"),
  "07063": p("NJ", "Plainfield"),
  "07065": p("NJ", "Rahway"),
  "07066": p("NJ", "Clark"),
  "07069": p("NJ", "Watchung"),
  "07076": p("NJ", "Scotch Plains"),
  "07081": p("NJ", "Springfield"),
  "07083": p("NJ", "Union"),
  "07088": p("NJ", "Vauxhall"),
  "07090": p("NJ", "Westfield"),
  "07091": p("NJ", "Westfield"),
  "07092": p("NJ", "Mountainside"),
  "07201": p("NJ", "Elizabeth"),
  "07202": p("NJ", "Elizabeth"),
  "07203": p("NJ", "Roselle"),
  "07204": p("NJ", "Roselle Park"),
  "07205": p("NJ", "Hillside"),
  "07206": p("NJ", "Elizabethport"),
  "07207": p("NJ", "Elizabeth"),
  "07208": p("NJ", "Elizabeth"),
  "07901": p("NJ", "Summit"),
  "07902": p("NJ", "Summit"),
  "07922": p("NJ", "Berkeley Heights"),
  "07974": p("NJ", "New Providence"),
  "07820": p("NJ", "Allamuchy"),
  "07823": p("NJ", "Belvidere"),
  "07825": p("NJ", "Blairstown"),
  "07829": p("NJ", "Buttzville"),
  "07831": p("NJ", "Changewater"),
  "07832": p("NJ", "Columbia"),
  "07833": p("NJ", "Delaware"),
  "07838": p("NJ", "Great Meadows"),
  "07840": p("NJ", "Hackettstown"),
  "07844": p("NJ", "Hope"),
  "07846": p("NJ", "Johnsonburg"),
  "07863": p("NJ", "Oxford"),
  "07865": p("NJ", "Port Murray"),
  "07880": p("NJ", "Vienna"),
  "07882": p("NJ", "Washington"),
  "08802": p("NJ", "Asbury"),
  "08808": p("NJ", "Broadway"),
  "08865": p("NJ", "Phillipsburg"),
  "08886": p("NJ", "Stewartsville"),
  "87008": p("NM", "Cedar Crest"),
  "87022": p("NM", "Isleta"),
  "87047": p("NM", "Sandia Park"),
  "87059": p("NM", "Tijeras"),
  "87101": p("NM", "Albuquerque"),
  "87102": p("NM", "Albuquerque"),
  "87103": p("NM", "Albuquerque"),
  "87104": p("NM", "Albuquerque"),
  "87105": p("NM", "Albuquerque"),
  "87106": p("NM", "Albuquerque"),
  "87107": p("NM", "Albuquerque"),
  "87108": p("NM", "Albuquerque"),
  "87109": p("NM", "Albuquerque"),
  "87110": p("NM", "Albuquerque"),
  "87111": p("NM", "Albuquerque"),
  "87112": p("NM", "Albuquerque"),
  "87113": p("NM", "Albuquerque"),
  "87114": p("NM", "Albuquerque"),
  "87115": p("NM", "Albuquerque"),
  "87116": p("NM", "Albuquerque"),
  "87117": p("NM", "Kirtland Afb"),
  "87119": p("NM", "Albuquerque"),
  "87120": p("NM", "Albuquerque"),
  "87121": p("NM", "Albuquerque"),
  "87122": p("NM", "Albuquerque"),
  "87123": p("NM", "Albuquerque"),
  "87125": p("NM", "Albuquerque"),
  "87131": p("NM", "Albuquerque"),
  "87151": p("NM", "Albuquerque"),
  "87153": p("NM", "Albuquerque"),
  "87154": p("NM", "Albuquerque"),
  "87158": p("NM", "Albuquerque"),
  "87174": p("NM", "Rio Rancho"),
  "87176": p("NM", "Albuquerque"),
  "87181": p("NM", "Albuquerque"),
  "87184": p("NM", "Albuquerque"),
  "87185": p("NM", "Albuquerque"),
  "87187": p("NM", "Albuquerque"),
  "87190": p("NM", "Albuquerque"),
  "87191": p("NM", "Albuquerque"),
  "87192": p("NM", "Albuquerque"),
  "87193": p("NM", "Albuquerque"),
  "87194": p("NM", "Albuquerque"),
  "87195": p("NM", "Albuquerque"),
  "87196": p("NM", "Albuquerque"),
  "87197": p("NM", "Albuquerque"),
  "87198": p("NM", "Albuquerque"),
  "87199": p("NM", "Albuquerque"),
  "87820": p("NM", "Aragon"),
  "87821": p("NM", "Datil"),
  "87824": p("NM", "Luna"),
  "87827": p("NM", "Pie Town"),
  "87829": p("NM", "Quemado"),
  "87830": p("NM", "Reserve"),
  "88039": p("NM", "Glenwood"),
  "88201": p("NM", "Roswell"),
  "88202": p("NM", "Roswell"),
  "88203": p("NM", "Roswell"),
  "88230": p("NM", "Dexter"),
  "88232": p("NM", "Hagerman"),
  "88253": p("NM", "Lake Arthur"),
  "87005": p("NM", "Bluewater"),
  "87007": p("NM", "Casa Blanca"),
  "87014": p("NM", "Cubero"),
  "87020": p("NM", "Grants"),
  "87021": p("NM", "Milan"),
  "87026": p("NM", "Laguna"),
  "87038": p("NM", "New Laguna"),
  "87040": p("NM", "Paguate"),
  "87049": p("NM", "San Fidel"),
  "87051": p("NM", "San Rafael"),
  "87315": p("NM", "Fence Lake"),
  "87357": p("NM", "Pinehill"),
  "87710": p("NM", "Angel Fire"),
  "87714": p("NM", "Cimarron"),
  "87718": p("NM", "Eagle Nest"),
  "87728": p("NM", "Maxwell"),
  "87729": p("NM", "Miami"),
  "87740": p("NM", "Raton"),
  "87747": p("NM", "Springer"),
  "87749": p("NM", "Ute Park"),
  "88101": p("NM", "Clovis"),
  "88102": p("NM", "Clovis"),
  "88103": p("NM", "Cannon Afb"),
  "88112": p("NM", "Broadview"),
  "88120": p("NM", "Grady"),
  "88124": p("NM", "Melrose"),
  "88133": p("NM", "Saint Vrain"),
  "88135": p("NM", "Texico"),
  "88119": p("NM", "Fort Sumner"),
  "88134": p("NM", "Taiban"),
  "88136": p("NM", "Yeso"),
  "87936": p("NM", "Garfield"),
  "87937": p("NM", "Hatch"),
  "87940": p("NM", "Rincon"),
  "87941": p("NM", "Salem"),
  "88001": p("NM", "Las Cruces"),
  "88002": p("NM", "White Sands Missile Range"),
  "88003": p("NM", "Las Cruces"),
  "88004": p("NM", "Las Cruces"),
  "88005": p("NM", "Las Cruces"),
  "88006": p("NM", "Las Cruces"),
  "88007": p("NM", "Las Cruces"),
  "88008": p("NM", "Santa Teresa"),
  "88011": p("NM", "Las Cruces"),
  "88012": p("NM", "Las Cruces"),
  "88013": p("NM", "Las Cruces"),
  "88021": p("NM", "Anthony"),
  "88024": p("NM", "Berino"),
  "88027": p("NM", "Chamberino"),
  "88032": p("NM", "Dona Ana"),
  "88033": p("NM", "Fairacres"),
  "88044": p("NM", "La Mesa"),
  "88046": p("NM", "Mesilla"),
  "88047": p("NM", "Mesilla Park"),
  "88048": p("NM", "Mesquite"),
  "88052": p("NM", "Organ"),
  "88054": p("NM", "Radium Springs"),
  "88058": p("NM", "San Miguel"),
  "88063": p("NM", "Sunland Park"),
  "88072": p("NM", "Vado"),
  "88210": p("NM", "Artesia"),
  "88211": p("NM", "Artesia"),
  "88220": p("NM", "Carlsbad"),
  "88221": p("NM", "Carlsbad"),
  "88250": p("NM", "Hope"),
  "88254": p("NM", "Lakewood"),
  "88255": p("NM", "Loco Hills"),
  "88256": p("NM", "Loving"),
  "88263": p("NM", "Malaga"),
  "88268": p("NM", "Whites City"),
  "88022": p("NM", "Arenas Valley"),
  "88023": p("NM", "Bayard"),
  "88025": p("NM", "Buckhorn"),
  "88026": p("NM", "Santa Clara"),
  "88028": p("NM", "Cliff"),
  "88034": p("NM", "Faywood"),
  "88036": p("NM", "Fort Bayard"),
  "88038": p("NM", "Gila"),
  "88040": p("NM", "Hachita"),
  "88041": p("NM", "Hanover"),
  "88043": p("NM", "Hurley"),
  "88049": p("NM", "Mimbres"),
  "88051": p("NM", "Mule Creek"),
  "88053": p("NM", "Pinos Altos"),
  "88055": p("NM", "Redrock"),
  "88061": p("NM", "Silver City"),
  "88062": p("NM", "Silver City"),
  "88065": p("NM", "Tyrone"),
  "87711": p("NM", "Anton Chico"),
  "87724": p("NM", "La Loma"),
  "88353": p("NM", "Vaughn"),
  "88417": p("NM", "Cuervo"),
  "88431": p("NM", "Newkirk"),
  "88435": p("NM", "Santa Rosa"),
  "87730": p("NM", "Mills"),
  "87733": p("NM", "Mosquero"),
  "87743": p("NM", "Roy"),
  "87746": p("NM", "Solano"),
  "88009": p("NM", "Playas"),
  "88020": p("NM", "Animas"),
  "88045": p("NM", "Lordsburg"),
  "88056": p("NM", "Rodeo"),
  "88114": p("NM", "Crossroads"),
  "88213": p("NM", "Caprock"),
  "88231": p("NM", "Eunice"),
  "88240": p("NM", "Hobbs"),
  "88241": p("NM", "Hobbs"),
  "88242": p("NM", "Hobbs"),
  "88244": p("NM", "Hobbs"),
  "88252": p("NM", "Jal"),
  "88260": p("NM", "Lovington"),
  "88262": p("NM", "Mcdonald"),
  "88264": p("NM", "Maljamar"),
  "88265": p("NM", "Monument"),
  "88267": p("NM", "Tatum"),
  "88301": p("NM", "Carrizozo"),
  "88312": p("NM", "Alto"),
  "88316": p("NM", "Capitan"),
  "88318": p("NM", "Corona"),
  "88323": p("NM", "Fort Stanton"),
  "88324": p("NM", "Glencoe"),
  "88336": p("NM", "Hondo"),
  "88338": p("NM", "Lincoln"),
  "88341": p("NM", "Nogal"),
  "88343": p("NM", "Picacho"),
  "88345": p("NM", "Ruidoso"),
  "88346": p("NM", "Ruidoso Downs"),
  "88348": p("NM", "San Patricio"),
  "88351": p("NM", "Tinnie"),
  "88355": p("NM", "Ruidoso"),
  "87544": p("NM", "Los Alamos"),
  "87545": p("NM", "Los Alamos"),
  "87547": p("NM", "White Rock"),
  "88029": p("NM", "Columbus"),
  "88030": p("NM", "Deming"),
  "88031": p("NM", "Deming"),
  "87045": p("NM", "Prewitt"),
  "87301": p("NM", "Gallup"),
  "87302": p("NM", "Gallup"),
  "87305": p("NM", "Gallup"),
  "87310": p("NM", "Brimhall"),
  "87311": p("NM", "Church Rock"),
  "87312": p("NM", "Continental Divide"),
  "87313": p("NM", "Crownpoint"),
  "87316": p("NM", "Fort Wingate"),
  "87317": p("NM", "Gamerco"),
  "87319": p("NM", "Mentmore"),
  "87320": p("NM", "Mexican Springs"),
  "87321": p("NM", "Ramah"),
  "87322": p("NM", "Rehoboth"),
  "87323": p("NM", "Thoreau"),
  "87325": p("NM", "Tohatchi"),
  "87326": p("NM", "Vanderwagen"),
  "87327": p("NM", "Zuni"),
  "87328": p("NM", "Navajo"),
  "87347": p("NM", "Jamestown"),
  "87365": p("NM", "Smith Lake"),
  "87375": p("NM", "Yatahey"),
  "87712": p("NM", "Buena Vista"),
  "87713": p("NM", "Chacon"),
  "87715": p("NM", "Cleveland"),
  "87722": p("NM", "Guadalupita"),
  "87723": p("NM", "Holman"),
  "87732": p("NM", "Mora"),
  "87734": p("NM", "Ocate"),
  "87735": p("NM", "Ojo Feliz"),
  "87736": p("NM", "Rainsville"),
  "87750": p("NM", "Valmora"),
  "87752": p("NM", "Wagon Mound"),
  "87753": p("NM", "Watrous"),
  "88081": p("NM", "Chaparral"),
  "88310": p("NM", "Alamogordo"),
  "88311": p("NM", "Alamogordo"),
  "88314": p("NM", "Bent"),
  "88317": p("NM", "Cloudcroft"),
  "88325": p("NM", "High Rolls Mountain Park"),
  "88330": p("NM", "Holloman Air Force Base"),
  "88337": p("NM", "La Luz"),
  "88339": p("NM", "Mayhill"),
  "88340": p("NM", "Mescalero"),
  "88342": p("NM", "Orogrande"),
  "88344": p("NM", "Pinon"),
  "88347": p("NM", "Sacramento"),
  "88349": p("NM", "Sunspot"),
  "88350": p("NM", "Timberon"),
  "88352": p("NM", "Tularosa"),
  "88354": p("NM", "Weed"),
  "88121": p("NM", "House"),
  "88401": p("NM", "Tucumcari"),
  "88411": p("NM", "Bard"),
  "88426": p("NM", "Logan"),
  "88427": p("NM", "Mcalister"),
  "88430": p("NM", "Nara Visa"),
  "88433": p("NM", "Quay"),
  "88434": p("NM", "San Jon"),
  "87012": p("NM", "Coyote"),
  "87017": p("NM", "Gallina"),
  "87029": p("NM", "Lindrith"),
  "87064": p("NM", "Youngsville"),
  "87510": p("NM", "Abiquiu"),
  "87511": p("NM", "Alcalde"),
  "87515": p("NM", "Canjilon"),
  "87516": p("NM", "Canones"),
  "87518": p("NM", "Cebolla"),
  "87520": p("NM", "Chama"),
  "87522": p("NM", "Chimayo"),
  "87523": p("NM", "Cordova"),
  "87527": p("NM", "Dixon"),
  "87528": p("NM", "Dulce"),
  "87530": p("NM", "El Rito"),
  "87531": p("NM", "Embudo"),
  "87532": p("NM", "Espanola"),
  "87533": p("NM", "Espanola"),
  "87537": p("NM", "Hernandez"),
  "87539": p("NM", "La Madera"),
  "87548": p("NM", "Medanales"),
  "87551": p("NM", "Los Ojos"),
  "87554": p("NM", "Petaca"),
  "87566": p("NM", "Ohkay Owingeh"),
  "87575": p("NM", "Tierra Amarilla"),
  "87578": p("NM", "Truchas"),
  "87581": p("NM", "Vallecitos"),
  "87582": p("NM", "Velarde"),
  "88113": p("NM", "Causey"),
  "88115": p("NM", "Dora"),
  "88116": p("NM", "Elida"),
  "88118": p("NM", "Floyd"),
  "88122": p("NM", "Kenna"),
  "88123": p("NM", "Lingo"),
  "88125": p("NM", "Milnesand"),
  "88126": p("NM", "Pep"),
  "88130": p("NM", "Portales"),
  "88132": p("NM", "Rogers"),
  "87001": p("NM", "Algodones"),
  "87004": p("NM", "Bernalillo"),
  "87013": p("NM", "Cuba"),
  "87018": p("NM", "Counselor"),
  "87024": p("NM", "Jemez Pueblo"),
  "87025": p("NM", "Jemez Springs"),
  "87027": p("NM", "La Jara"),
  "87041": p("NM", "Pena Blanca"),
  "87043": p("NM", "Placitas"),
  "87044": p("NM", "Ponderosa"),
  "87046": p("NM", "Regina"),
  "87048": p("NM", "Corrales"),
  "87052": p("NM", "Santo Domingo Pueblo"),
  "87053": p("NM", "San Ysidro"),
  "87072": p("NM", "Cochiti Pueblo"),
  "87083": p("NM", "Cochiti Lake"),
  "87124": p("NM", "Rio Rancho"),
  "87144": p("NM", "Rio Rancho"),
  "87037": p("NM", "Nageezi"),
  "87364": p("NM", "Sheep Springs"),
  "87401": p("NM", "Farmington"),
  "87402": p("NM", "Farmington"),
  "87410": p("NM", "Aztec"),
  "87412": p("NM", "Blanco"),
  "87413": p("NM", "Bloomfield"),
  "87415": p("NM", "Flora Vista"),
  "87416": p("NM", "Fruitland"),
  "87417": p("NM", "Kirtland"),
  "87418": p("NM", "La Plata"),
  "87419": p("NM", "Navajo Dam"),
  "87420": p("NM", "Shiprock"),
  "87421": p("NM", "Waterflow"),
  "87455": p("NM", "Newcomb"),
  "87461": p("NM", "Sanostee"),
  "87499": p("NM", "Farmington"),
  "87538": p("NM", "Ilfeld"),
  "87552": p("NM", "Pecos"),
  "87560": p("NM", "Ribera"),
  "87562": p("NM", "Rowe"),
  "87565": p("NM", "San Jose"),
  "87569": p("NM", "Serafina"),
  "87573": p("NM", "Tererro"),
  "87583": p("NM", "Villanueva"),
  "87701": p("NM", "Las Vegas"),
  "87731": p("NM", "Montezuma"),
  "87742": p("NM", "Rociada"),
  "87745": p("NM", "Sapello"),
  "88416": p("NM", "Conchas Dam"),
  "88421": p("NM", "Garita"),
  "88439": p("NM", "Trementina"),
  "87010": p("NM", "Cerrillos"),
  "87015": p("NM", "Edgewood"),
  "87056": p("NM", "Stanley"),
  "87501": p("NM", "Santa Fe"),
  "87502": p("NM", "Santa Fe"),
  "87503": p("NM", "Santa Fe"),
  "87504": p("NM", "Santa Fe"),
  "87505": p("NM", "Santa Fe"),
  "87506": p("NM", "Santa Fe"),
  "87507": p("NM", "Santa Fe"),
  "87508": p("NM", "Santa Fe"),
  "87509": p("NM", "Santa Fe"),
  "87535": p("NM", "Glorieta"),
  "87540": p("NM", "Lamy"),
  "87567": p("NM", "Santa Cruz"),
  "87574": p("NM", "Tesuque"),
  "87592": p("NM", "Santa Fe"),
  "87594": p("NM", "Santa Fe"),
  "87654": p("NM", "Spaceport City"),
  "87901": p("NM", "Truth Or Consequences"),
  "87930": p("NM", "Arrey"),
  "87931": p("NM", "Caballo"),
  "87933": p("NM", "Derry"),
  "87935": p("NM", "Elephant Butte"),
  "87939": p("NM", "Monticello"),
  "87942": p("NM", "Williamsburg"),
  "87943": p("NM", "Winston"),
  "88042": p("NM", "Hillsboro"),
  "87011": p("NM", "Claunch"),
  "87028": p("NM", "La Joya"),
  "87062": p("NM", "Veguita"),
  "87801": p("NM", "Socorro"),
  "87823": p("NM", "Lemitar"),
  "87825": p("NM", "Magdalena"),
  "87828": p("NM", "Polvadera"),
  "87831": p("NM", "San Acacia"),
  "87832": p("NM", "San Antonio"),
  "87512": p("NM", "Amalia"),
  "87513": p("NM", "Arroyo Hondo"),
  "87514": p("NM", "Arroyo Seco"),
  "87517": p("NM", "Carson"),
  "87519": p("NM", "Cerro"),
  "87521": p("NM", "Chamisal"),
  "87524": p("NM", "Costilla"),
  "87525": p("NM", "Taos Ski Valley"),
  "87529": p("NM", "El Prado"),
  "87543": p("NM", "Llano"),
  "87549": p("NM", "Ojo Caliente"),
  "87553": p("NM", "Penasco"),
  "87556": p("NM", "Questa"),
  "87557": p("NM", "Ranchos De Taos"),
  "87558": p("NM", "Red River"),
  "87564": p("NM", "San Cristobal"),
  "87571": p("NM", "Taos"),
  "87576": p("NM", "Trampas"),
  "87577": p("NM", "Tres Piedras"),
  "87579": p("NM", "Vadito"),
  "87580": p("NM", "Valdez"),
  "87009": p("NM", "Cedarvale"),
  "87016": p("NM", "Estancia"),
  "87032": p("NM", "Mcintosh"),
  "87035": p("NM", "Moriarty"),
  "87036": p("NM", "Mountainair"),
  "87061": p("NM", "Torreon"),
  "87063": p("NM", "Willard"),
  "87070": p("NM", "Clines Corners"),
  "88321": p("NM", "Encino"),
  "88410": p("NM", "Amistad"),
  "88414": p("NM", "Capulin"),
  "88415": p("NM", "Clayton"),
  "88418": p("NM", "Des Moines"),
  "88419": p("NM", "Folsom"),
  "88422": p("NM", "Gladstone"),
  "88424": p("NM", "Grenville"),
  "88436": p("NM", "Sedan"),
  "87002": p("NM", "Belen"),
  "87006": p("NM", "Bosque"),
  "87023": p("NM", "Jarales"),
  "87031": p("NM", "Los Lunas"),
  "87034": p("NM", "Pueblo Of Acoma"),
  "87042": p("NM", "Peralta"),
  "87060": p("NM", "Tome"),
  "87068": p("NM", "Bosque Farms"),
  "89406": p("NV", "Fallon"),
  "89407": p("NV", "Fallon"),
  "89496": p("NV", "Fallon"),
  "88901": p("NV", "The Lakes"),
  "88905": p("NV", "The Lakes"),
  "89002": p("NV", "Henderson"),
  "89004": p("NV", "Blue Diamond"),
  "89005": p("NV", "Boulder City"),
  "89006": p("NV", "Boulder City"),
  "89007": p("NV", "Bunkerville"),
  "89009": p("NV", "Henderson"),
  "89011": p("NV", "Henderson"),
  "89012": p("NV", "Henderson"),
  "89014": p("NV", "Henderson"),
  "89015": p("NV", "Henderson"),
  "89016": p("NV", "Henderson"),
  "89018": p("NV", "Indian Springs"),
  "89019": p("NV", "Jean"),
  "89021": p("NV", "Logandale"),
  "89024": p("NV", "Mesquite"),
  "89025": p("NV", "Moapa"),
  "89026": p("NV", "Jean"),
  "89027": p("NV", "Mesquite"),
  "89028": p("NV", "Laughlin"),
  "89029": p("NV", "Laughlin"),
  "89030": p("NV", "North Las Vegas"),
  "89031": p("NV", "North Las Vegas"),
  "89032": p("NV", "North Las Vegas"),
  "89033": p("NV", "North Las Vegas"),
  "89034": p("NV", "Mesquite"),
  "89036": p("NV", "North Las Vegas"),
  "89037": p("NV", "Coyote Springs"),
  "89039": p("NV", "Cal Nev Ari"),
  "89040": p("NV", "Overton"),
  "89046": p("NV", "Searchlight"),
  "89052": p("NV", "Henderson"),
  "89053": p("NV", "Henderson"),
  "89054": p("NV", "Sloan"),
  "89067": p("NV", "Moapa"),
  "89070": p("NV", "Indian Springs"),
  "89074": p("NV", "Henderson"),
  "89077": p("NV", "Henderson"),
  "89081": p("NV", "North Las Vegas"),
  "89084": p("NV", "North Las Vegas"),
  "89085": p("NV", "North Las Vegas"),
  "89086": p("NV", "North Las Vegas"),
  "89087": p("NV", "North Las Vegas"),
  "89101": p("NV", "Las Vegas"),
  "89102": p("NV", "Las Vegas"),
  "89103": p("NV", "Las Vegas"),
  "89104": p("NV", "Las Vegas"),
  "89105": p("NV", "Las Vegas"),
  "89106": p("NV", "Las Vegas"),
  "89107": p("NV", "Las Vegas"),
  "89108": p("NV", "Las Vegas"),
  "89109": p("NV", "Las Vegas"),
  "89110": p("NV", "Las Vegas"),
  "89111": p("NV", "Las Vegas"),
  "89112": p("NV", "Las Vegas"),
  "89113": p("NV", "Las Vegas"),
  "89114": p("NV", "Las Vegas"),
  "89115": p("NV", "Las Vegas"),
  "89116": p("NV", "Las Vegas"),
  "89117": p("NV", "Las Vegas"),
  "89118": p("NV", "Las Vegas"),
  "89119": p("NV", "Las Vegas"),
  "89120": p("NV", "Las Vegas"),
  "89121": p("NV", "Las Vegas"),
  "89122": p("NV", "Las Vegas"),
  "89123": p("NV", "Las Vegas"),
  "89124": p("NV", "Las Vegas"),
  "89125": p("NV", "Las Vegas"),
  "89126": p("NV", "Las Vegas"),
  "89127": p("NV", "Las Vegas"),
  "89128": p("NV", "Las Vegas"),
  "89129": p("NV", "Las Vegas"),
  "89130": p("NV", "Las Vegas"),
  "89131": p("NV", "Las Vegas"),
  "89132": p("NV", "Las Vegas"),
  "89133": p("NV", "Las Vegas"),
  "89134": p("NV", "Las Vegas"),
  "89135": p("NV", "Las Vegas"),
  "89136": p("NV", "Las Vegas"),
  "89137": p("NV", "Las Vegas"),
  "89138": p("NV", "Las Vegas"),
  "89139": p("NV", "Las Vegas"),
  "89140": p("NV", "Las Vegas"),
  "89141": p("NV", "Las Vegas"),
  "89142": p("NV", "Las Vegas"),
  "89143": p("NV", "Las Vegas"),
  "89144": p("NV", "Las Vegas"),
  "89145": p("NV", "Las Vegas"),
  "89146": p("NV", "Las Vegas"),
  "89147": p("NV", "Las Vegas"),
  "89148": p("NV", "Las Vegas"),
  "89149": p("NV", "Las Vegas"),
  "89150": p("NV", "Las Vegas"),
  "89151": p("NV", "Las Vegas"),
  "89152": p("NV", "Las Vegas"),
  "89153": p("NV", "Las Vegas"),
  "89154": p("NV", "Las Vegas"),
  "89155": p("NV", "Las Vegas"),
  "89156": p("NV", "Las Vegas"),
  "89157": p("NV", "Las Vegas"),
  "89158": p("NV", "Las Vegas"),
  "89159": p("NV", "Las Vegas"),
  "89160": p("NV", "Las Vegas"),
  "89161": p("NV", "Las Vegas"),
  "89162": p("NV", "Las Vegas"),
  "89163": p("NV", "The Lakes"),
  "89164": p("NV", "Las Vegas"),
  "89165": p("NV", "Las Vegas"),
  "89166": p("NV", "Las Vegas"),
  "89169": p("NV", "Las Vegas"),
  "89170": p("NV", "Las Vegas"),
  "89173": p("NV", "Las Vegas"),
  "89177": p("NV", "Las Vegas"),
  "89178": p("NV", "Las Vegas"),
  "89179": p("NV", "Las Vegas"),
  "89180": p("NV", "Las Vegas"),
  "89183": p("NV", "Las Vegas"),
  "89185": p("NV", "Las Vegas"),
  "89191": p("NV", "Nellis Afb"),
  "89193": p("NV", "Las Vegas"),
  "89195": p("NV", "Las Vegas"),
  "89199": p("NV", "Las Vegas"),
  "89410": p("NV", "Gardnerville"),
  "89411": p("NV", "Genoa"),
  "89413": p("NV", "Glenbrook"),
  "89423": p("NV", "Minden"),
  "89448": p("NV", "Zephyr Cove"),
  "89449": p("NV", "Stateline"),
  "89460": p("NV", "Gardnerville"),
  "89705": p("NV", "Carson City"),
  "89801": p("NV", "Elko"),
  "89802": p("NV", "Elko"),
  "89803": p("NV", "Elko"),
  "89815": p("NV", "Spring Creek"),
  "89822": p("NV", "Carlin"),
  "89823": p("NV", "Deeth"),
  "89825": p("NV", "Jackpot"),
  "89826": p("NV", "Jarbidge"),
  "89828": p("NV", "Lamoille"),
  "89830": p("NV", "Montello"),
  "89831": p("NV", "Mountain City"),
  "89832": p("NV", "Owyhee"),
  "89833": p("NV", "Ruby Valley"),
  "89834": p("NV", "Tuscarora"),
  "89835": p("NV", "Wells"),
  "89883": p("NV", "West Wendover"),
  "89010": p("NV", "Dyer"),
  "89013": p("NV", "Goldfield"),
  "89047": p("NV", "Silverpeak"),
  "89316": p("NV", "Eureka"),
  "89821": p("NV", "Crescent Valley"),
  "89404": p("NV", "Denio"),
  "89414": p("NV", "Golconda"),
  "89421": p("NV", "Mc Dermitt"),
  "89425": p("NV", "Orovada"),
  "89426": p("NV", "Paradise Valley"),
  "89438": p("NV", "Valmy"),
  "89445": p("NV", "Winnemucca"),
  "89446": p("NV", "Winnemucca"),
  "89310": p("NV", "Austin"),
  "89820": p("NV", "Battle Mountain"),
  "89001": p("NV", "Alamo"),
  "89008": p("NV", "Caliente"),
  "89017": p("NV", "Hiko"),
  "89042": p("NV", "Panaca"),
  "89043": p("NV", "Pioche"),
  "89044": p("NV", "Henderson"),
  "89403": p("NV", "Dayton"),
  "89408": p("NV", "Fernley"),
  "89428": p("NV", "Silver City"),
  "89429": p("NV", "Silver Springs"),
  "89430": p("NV", "Smith"),
  "89444": p("NV", "Wellington"),
  "89447": p("NV", "Yerington"),
  "89415": p("NV", "Hawthorne"),
  "89420": p("NV", "Luning"),
  "89422": p("NV", "Mina"),
  "89427": p("NV", "Schurz"),
  "89003": p("NV", "Beatty"),
  "89020": p("NV", "Amargosa Valley"),
  "89022": p("NV", "Manhattan"),
  "89023": p("NV", "Mercury"),
  "89041": p("NV", "Pahrump"),
  "89045": p("NV", "Round Mountain"),
  "89048": p("NV", "Pahrump"),
  "89049": p("NV", "Tonopah"),
  "89060": p("NV", "Pahrump"),
  "89061": p("NV", "Pahrump"),
  "89409": p("NV", "Gabbs"),
  "89418": p("NV", "Imlay"),
  "89419": p("NV", "Lovelock"),
  "89440": p("NV", "Virginia City"),
  "89402": p("NV", "Crystal Bay"),
  "89405": p("NV", "Empire"),
  "89412": p("NV", "Gerlach"),
  "89424": p("NV", "Nixon"),
  "89431": p("NV", "Sparks"),
  "89432": p("NV", "Sparks"),
  "89433": p("NV", "Sun Valley"),
  "89434": p("NV", "Sparks"),
  "89435": p("NV", "Sparks"),
  "89436": p("NV", "Sparks"),
  "89437": p("NV", "Sparks"),
  "89439": p("NV", "Verdi"),
  "89441": p("NV", "Sparks"),
  "89442": p("NV", "Wadsworth"),
  "89450": p("NV", "Incline Village"),
  "89451": p("NV", "Incline Village"),
  "89452": p("NV", "Incline Village"),
  "89501": p("NV", "Reno"),
  "89502": p("NV", "Reno"),
  "89503": p("NV", "Reno"),
  "89504": p("NV", "Reno"),
  "89505": p("NV", "Reno"),
  "89506": p("NV", "Reno"),
  "89507": p("NV", "Reno"),
  "89508": p("NV", "Reno"),
  "89509": p("NV", "Reno"),
  "89510": p("NV", "Reno"),
  "89511": p("NV", "Reno"),
  "89512": p("NV", "Reno"),
  "89513": p("NV", "Reno"),
  "89515": p("NV", "Reno"),
  "89519": p("NV", "Reno"),
  "89520": p("NV", "Reno"),
  "89521": p("NV", "Reno"),
  "89523": p("NV", "Reno"),
  "89533": p("NV", "Reno"),
  "89555": p("NV", "Reno"),
  "89557": p("NV", "Reno"),
  "89570": p("NV", "Reno"),
  "89595": p("NV", "Reno"),
  "89599": p("NV", "Reno"),
  "89704": p("NV", "Washoe Valley"),
  "89301": p("NV", "Ely"),
  "89311": p("NV", "Baker"),
  "89314": p("NV", "Duckwater"),
  "89315": p("NV", "Ely"),
  "89317": p("NV", "Lund"),
  "89318": p("NV", "Mc Gill"),
  "89319": p("NV", "Ruth"),
  "89701": p("NV", "Carson City"),
  "89702": p("NV", "Carson City"),
  "89703": p("NV", "Carson City"),
  "89706": p("NV", "Carson City"),
  "89711": p("NV", "Carson City"),
  "89712": p("NV", "Carson City"),
  "89713": p("NV", "Carson City"),
  "89714": p("NV", "Carson City"),
  "89721": p("NV", "Carson City"),
  "12007": p("NY", "Alcove"),
  "12009": p("NY", "Altamont"),
  "12023": p("NY", "Berne"),
  "12041": p("NY", "Clarksville"),
  "12045": p("NY", "Coeymans"),
  "12046": p("NY", "Coeymans Hollow"),
  "12047": p("NY", "Cohoes"),
  "12054": p("NY", "Delmar"),
  "12055": p("NY", "Dormansville"),
  "12059": p("NY", "East Berne"),
  "12067": p("NY", "Feura Bush"),
  "12077": p("NY", "Glenmont"),
  "12084": p("NY", "Guilderland"),
  "12085": p("NY", "Guilderland Center"),
  "12107": p("NY", "Knox"),
  "12110": p("NY", "Latham"),
  "12120": p("NY", "Medusa"),
  "12128": p("NY", "Newtonville"),
  "12143": p("NY", "Ravena"),
  "12147": p("NY", "Rensselaerville"),
  "12158": p("NY", "Selkirk"),
  "12159": p("NY", "Slingerlands"),
  "12161": p("NY", "South Bethlehem"),
  "12183": p("NY", "Troy"),
  "12186": p("NY", "Voorheesville"),
  "12189": p("NY", "Watervliet"),
  "12193": p("NY", "Westerlo"),
  "12201": p("NY", "Albany"),
  "12202": p("NY", "Albany"),
  "12203": p("NY", "Albany"),
  "12204": p("NY", "Albany"),
  "12205": p("NY", "Albany"),
  "12206": p("NY", "Albany"),
  "12207": p("NY", "Albany"),
  "12208": p("NY", "Albany"),
  "12209": p("NY", "Albany"),
  "12210": p("NY", "Albany"),
  "12211": p("NY", "Albany"),
  "12212": p("NY", "Albany"),
  "12214": p("NY", "Albany"),
  "12220": p("NY", "Albany"),
  "12222": p("NY", "Albany"),
  "12223": p("NY", "Albany"),
  "12224": p("NY", "Albany"),
  "12225": p("NY", "Albany"),
  "12226": p("NY", "Albany"),
  "12227": p("NY", "Albany"),
  "12228": p("NY", "Albany"),
  "12229": p("NY", "Albany"),
  "12230": p("NY", "Albany"),
  "12231": p("NY", "Albany"),
  "12232": p("NY", "Albany"),
  "12233": p("NY", "Albany"),
  "12234": p("NY", "Albany"),
  "12235": p("NY", "Albany"),
  "12236": p("NY", "Albany"),
  "12237": p("NY", "Albany"),
  "12238": p("NY", "Albany"),
  "12239": p("NY", "Albany"),
  "12240": p("NY", "Albany"),
  "12241": p("NY", "Albany"),
  "12242": p("NY", "Albany"),
  "12243": p("NY", "Albany"),
  "12244": p("NY", "Albany"),
  "12245": p("NY", "Albany"),
  "12246": p("NY", "Albany"),
  "12247": p("NY", "Albany"),
  "12248": p("NY", "Albany"),
  "12249": p("NY", "Albany"),
  "12250": p("NY", "Albany"),
  "12252": p("NY", "Albany"),
  "12255": p("NY", "Albany"),
  "12256": p("NY", "Albany"),
  "12257": p("NY", "Albany"),
  "12260": p("NY", "Albany"),
  "12261": p("NY", "Albany"),
  "12288": p("NY", "Albany"),
  "12469": p("NY", "Preston Hollow"),
  "14029": p("NY", "Centerville"),
  "14707": p("NY", "Allentown"),
  "14708": p("NY", "Alma"),
  "14709": p("NY", "Angelica"),
  "14711": p("NY", "Belfast"),
  "14714": p("NY", "Black Creek"),
  "14715": p("NY", "Bolivar"),
  "14717": p("NY", "Caneadea"),
  "14721": p("NY", "Ceres"),
  "14727": p("NY", "Cuba"),
  "14735": p("NY", "Fillmore"),
  "14739": p("NY", "Friendship"),
  "14744": p("NY", "Houghton"),
  "14745": p("NY", "Hume"),
  "14754": p("NY", "Little Genesee"),
  "14774": p("NY", "Richburg"),
  "14777": p("NY", "Rushford"),
  "14786": p("NY", "West Clarksville"),
  "14802": p("NY", "Alfred"),
  "14803": p("NY", "Alfred Station"),
  "14804": p("NY", "Almond"),
  "14806": p("NY", "Andover"),
  "14813": p("NY", "Belmont"),
  "14822": p("NY", "Canaseraga"),
  "14880": p("NY", "Scio"),
  "14884": p("NY", "Swain"),
  "14895": p("NY", "Wellsville"),
  "14897": p("NY", "Whitesville"),
  "10451": p("NY", "Bronx"),
  "10452": p("NY", "Bronx"),
  "10453": p("NY", "Bronx"),
  "10454": p("NY", "Bronx"),
  "10455": p("NY", "Bronx"),
  "10456": p("NY", "Bronx"),
  "10457": p("NY", "Bronx"),
  "10458": p("NY", "Bronx"),
  "10459": p("NY", "Bronx"),
  "10460": p("NY", "Bronx"),
  "10461": p("NY", "Bronx"),
  "10462": p("NY", "Bronx"),
  "10463": p("NY", "Bronx"),
  "10464": p("NY", "Bronx"),
  "10465": p("NY", "Bronx"),
  "10466": p("NY", "Bronx"),
  "10467": p("NY", "Bronx"),
  "10468": p("NY", "Bronx"),
  "10469": p("NY", "Bronx"),
  "10470": p("NY", "Bronx"),
  "10471": p("NY", "Bronx"),
  "10472": p("NY", "Bronx"),
  "10473": p("NY", "Bronx"),
  "10474": p("NY", "Bronx"),
  "10475": p("NY", "Bronx"),
  "13737": p("NY", "Bible School Park"),
  "13744": p("NY", "Castle Creek"),
  "13745": p("NY", "Chenango Bridge"),
  "13746": p("NY", "Chenango Forks"),
  "13748": p("NY", "Conklin"),
  "13749": p("NY", "Corbettsville"),
  "13754": p("NY", "Deposit"),
  "13760": p("NY", "Endicott"),
  "13761": p("NY", "Endicott"),
  "13762": p("NY", "Endwell"),
  "13763": p("NY", "Endicott"),
  "13777": p("NY", "Glen Aubrey"),
  "13787": p("NY", "Harpursville"),
  "13790": p("NY", "Johnson City"),
  "13794": p("NY", "Killawog"),
  "13795": p("NY", "Kirkwood"),
  "13797": p("NY", "Lisle"),
  "13802": p("NY", "Maine"),
  "13813": p("NY", "Nineveh"),
  "13826": p("NY", "Ouaquaga"),
  "13833": p("NY", "Port Crane"),
  "13848": p("NY", "Tunnel"),
  "13850": p("NY", "Vestal"),
  "13851": p("NY", "Vestal"),
  "13862": p("NY", "Whitney Point"),
  "13865": p("NY", "Windsor"),
  "13901": p("NY", "Binghamton"),
  "13902": p("NY", "Binghamton"),
  "13903": p("NY", "Binghamton"),
  "13904": p("NY", "Binghamton"),
  "13905": p("NY", "Binghamton"),
  "14041": p("NY", "Dayton"),
  "14042": p("NY", "Delevan"),
  "14060": p("NY", "Farmersville Station"),
  "14065": p("NY", "Freedom"),
  "14070": p("NY", "Gowanda"),
  "14101": p("NY", "Machias"),
  "14129": p("NY", "Perrysburg"),
  "14133": p("NY", "Sandusky"),
  "14138": p("NY", "South Dayton"),
  "14168": p("NY", "Versailles"),
  "14171": p("NY", "West Valley"),
  "14173": p("NY", "Yorkshire"),
  "14706": p("NY", "Allegany"),
  "14719": p("NY", "Cattaraugus"),
  "14726": p("NY", "Conewango Valley"),
  "14729": p("NY", "East Otto"),
  "14730": p("NY", "East Randolph"),
  "14731": p("NY", "Ellicottville"),
  "14737": p("NY", "Franklinville"),
  "14741": p("NY", "Great Valley"),
  "14743": p("NY", "Hinsdale"),
  "14748": p("NY", "Kill Buck"),
  "14751": p("NY", "Leon"),
  "14753": p("NY", "Limestone"),
  "14755": p("NY", "Little Valley"),
  "14760": p("NY", "Olean"),
  "14766": p("NY", "Otto"),
  "14770": p("NY", "Portville"),
  "14772": p("NY", "Randolph"),
  "14778": p("NY", "Saint Bonaventure"),
  "14779": p("NY", "Salamanca"),
  "14783": p("NY", "Steamburg"),
  "14788": p("NY", "Westons Mills"),
  "13021": p("NY", "Auburn"),
  "13022": p("NY", "Auburn"),
  "13024": p("NY", "Auburn"),
  "13026": p("NY", "Aurora"),
  "13033": p("NY", "Cato"),
  "13034": p("NY", "Cayuga"),
  "13071": p("NY", "Genoa"),
  "13081": p("NY", "King Ferry"),
  "13092": p("NY", "Locke"),
  "13111": p("NY", "Martville"),
  "13113": p("NY", "Meridian"),
  "13117": p("NY", "Montezuma"),
  "13118": p("NY", "Moravia"),
  "13139": p("NY", "Poplar Ridge"),
  "13140": p("NY", "Port Byron"),
  "13147": p("NY", "Scipio Center"),
  "13156": p("NY", "Sterling"),
  "13160": p("NY", "Union Springs"),
  "13166": p("NY", "Weedsport"),
  "14048": p("NY", "Dunkirk"),
  "14062": p("NY", "Forestville"),
  "14063": p("NY", "Fredonia"),
  "14081": p("NY", "Irving"),
  "14135": p("NY", "Sheridan"),
  "14136": p("NY", "Silver Creek"),
  "14166": p("NY", "Van Buren Point"),
  "14701": p("NY", "Jamestown"),
  "14702": p("NY", "Jamestown"),
  "14710": p("NY", "Ashville"),
  "14712": p("NY", "Bemus Point"),
  "14716": p("NY", "Brocton"),
  "14718": p("NY", "Cassadaga"),
  "14720": p("NY", "Celoron"),
  "14722": p("NY", "Chautauqua"),
  "14723": p("NY", "Cherry Creek"),
  "14724": p("NY", "Clymer"),
  "14728": p("NY", "Dewittville"),
  "14732": p("NY", "Ellington"),
  "14733": p("NY", "Falconer"),
  "14736": p("NY", "Findley Lake"),
  "14738": p("NY", "Frewsburg"),
  "14740": p("NY", "Gerry"),
  "14742": p("NY", "Greenhurst"),
  "14747": p("NY", "Kennedy"),
  "14750": p("NY", "Lakewood"),
  "14752": p("NY", "Lily Dale"),
  "14756": p("NY", "Maple Springs"),
  "14757": p("NY", "Mayville"),
  "14758": p("NY", "Niobe"),
  "14767": p("NY", "Panama"),
  "14769": p("NY", "Portland"),
  "14775": p("NY", "Ripley"),
  "14781": p("NY", "Sherman"),
  "14782": p("NY", "Sinclairville"),
  "14784": p("NY", "Stockton"),
  "14785": p("NY", "Stow"),
  "14787": p("NY", "Westfield"),
  "14814": p("NY", "Big Flats"),
  "14816": p("NY", "Breesport"),
  "14825": p("NY", "Chemung"),
  "14838": p("NY", "Erin"),
  "14845": p("NY", "Horseheads"),
  "14861": p("NY", "Lowman"),
  "14864": p("NY", "Millport"),
  "14871": p("NY", "Pine City"),
  "14872": p("NY", "Pine Valley"),
  "14889": p("NY", "Van Etten"),
  "14894": p("NY", "Wellsburg"),
  "14901": p("NY", "Elmira"),
  "14902": p("NY", "Elmira"),
  "14903": p("NY", "Elmira"),
  "14904": p("NY", "Elmira"),
  "14905": p("NY", "Elmira"),
  "13124": p("NY", "North Pitcher"),
  "13136": p("NY", "Pitcher"),
  "13155": p("NY", "South Otselic"),
  "13332": p("NY", "Earlville"),
  "13411": p("NY", "New Berlin"),
  "13460": p("NY", "Sherburne"),
  "13464": p("NY", "Smyrna"),
  "13730": p("NY", "Afton"),
  "13733": p("NY", "Bainbridge"),
  "13758": p("NY", "East Pharsalia"),
  "13778": p("NY", "Greene"),
  "13780": p("NY", "Guilford"),
  "13801": p("NY", "Mc Donough"),
  "13809": p("NY", "Mount Upton"),
  "13814": p("NY", "North Norwich"),
  "13815": p("NY", "Norwich"),
  "13830": p("NY", "Oxford"),
  "13832": p("NY", "Plymouth"),
  "13841": p("NY", "Smithville Flats"),
  "13843": p("NY", "South New Berlin"),
  "13844": p("NY", "South Plymouth"),
  "12901": p("NY", "Plattsburgh"),
  "12903": p("NY", "Plattsburgh"),
  "12910": p("NY", "Altona"),
  "12911": p("NY", "Keeseville"),
  "12912": p("NY", "Au Sable Forks"),
  "12918": p("NY", "Cadyville"),
  "12919": p("NY", "Champlain"),
  "12921": p("NY", "Chazy"),
  "12923": p("NY", "Churubusco"),
  "12924": p("NY", "Keeseville"),
  "12929": p("NY", "Dannemora"),
  "12933": p("NY", "Ellenburg"),
  "12934": p("NY", "Ellenburg Center"),
  "12935": p("NY", "Ellenburg Depot"),
  "12952": p("NY", "Lyon Mountain"),
  "12955": p("NY", "Lyon Mountain"),
  "12958": p("NY", "Mooers"),
  "12959": p("NY", "Mooers Forks"),
  "12962": p("NY", "Morrisonville"),
  "12972": p("NY", "Peru"),
  "12978": p("NY", "Redford"),
  "12979": p("NY", "Rouses Point"),
  "12981": p("NY", "Saranac"),
  "12985": p("NY", "Schuyler Falls"),
  "12992": p("NY", "West Chazy"),
  "12017": p("NY", "Austerlitz"),
  "12029": p("NY", "Canaan"),
  "12037": p("NY", "Chatham"),
  "12050": p("NY", "Columbiaville"),
  "12060": p("NY", "East Chatham"),
  "12075": p("NY", "Ghent"),
  "12106": p("NY", "Kinderhook"),
  "12115": p("NY", "Malden Bridge"),
  "12125": p("NY", "New Lebanon"),
  "12130": p("NY", "Niverville"),
  "12132": p("NY", "North Chatham"),
  "12136": p("NY", "Old Chatham"),
  "12165": p("NY", "Spencertown"),
  "12172": p("NY", "Stottville"),
  "12173": p("NY", "Stuyvesant"),
  "12174": p("NY", "Stuyvesant Falls"),
  "12184": p("NY", "Valatie"),
  "12195": p("NY", "West Lebanon"),
  "12502": p("NY", "Ancram"),
  "12503": p("NY", "Ancramdale"),
  "12513": p("NY", "Claverack"),
  "12516": p("NY", "Copake"),
  "12517": p("NY", "Copake Falls"),
  "12521": p("NY", "Craryville"),
  "12523": p("NY", "Elizaville"),
  "12526": p("NY", "Germantown"),
  "12529": p("NY", "Hillsdale"),
  "12530": p("NY", "Hollowville"),
  "12534": p("NY", "Hudson"),
  "12541": p("NY", "Livingston"),
  "12544": p("NY", "Mellenville"),
  "12565": p("NY", "Philmont"),
  "13040": p("NY", "Cincinnatus"),
  "13045": p("NY", "Cortland"),
  "13056": p("NY", "East Homer"),
  "13077": p("NY", "Homer"),
  "13087": p("NY", "Little York"),
  "13101": p("NY", "Mc Graw"),
  "13141": p("NY", "Preble"),
  "13158": p("NY", "Truxton"),
  "13738": p("NY", "Blodgett Mills"),
  "13784": p("NY", "Harford"),
  "13803": p("NY", "Marathon"),
  "13863": p("NY", "Willet"),
  "12167": p("NY", "Stamford"),
  "12406": p("NY", "Arkville"),
  "12421": p("NY", "Denver"),
  "12430": p("NY", "Fleischmanns"),
  "12434": p("NY", "Grand Gorge"),
  "12438": p("NY", "Halcottsville"),
  "12455": p("NY", "Margaretville"),
  "12459": p("NY", "New Kingston"),
  "12474": p("NY", "Roxbury"),
  "13731": p("NY", "Andes"),
  "13739": p("NY", "Bloomville"),
  "13740": p("NY", "Bovina Center"),
  "13750": p("NY", "Davenport"),
  "13751": p("NY", "Davenport Center"),
  "13752": p("NY", "Delancey"),
  "13753": p("NY", "Delhi"),
  "13755": p("NY", "Downsville"),
  "13756": p("NY", "East Branch"),
  "13757": p("NY", "East Meredith"),
  "13774": p("NY", "Fishs Eddy"),
  "13775": p("NY", "Franklin"),
  "13782": p("NY", "Hamden"),
  "13783": p("NY", "Hancock"),
  "13786": p("NY", "Harpersfield"),
  "13788": p("NY", "Hobart"),
  "13804": p("NY", "Masonville"),
  "13806": p("NY", "Meridale"),
  "13838": p("NY", "Sidney"),
  "13839": p("NY", "Sidney Center"),
  "13842": p("NY", "South Kortright"),
  "13846": p("NY", "Treadwell"),
  "13847": p("NY", "Trout Creek"),
  "13856": p("NY", "Walton"),
  "13860": p("NY", "West Davenport"),
  "12501": p("NY", "Amenia"),
  "12504": p("NY", "Annandale On Hudson"),
  "12506": p("NY", "Bangall"),
  "12507": p("NY", "Barrytown"),
  "12508": p("NY", "Beacon"),
  "12510": p("NY", "Billings"),
  "12511": p("NY", "Castle Point"),
  "12512": p("NY", "Chelsea"),
  "12514": p("NY", "Clinton Corners"),
  "12522": p("NY", "Dover Plains"),
  "12524": p("NY", "Fishkill"),
  "12527": p("NY", "Glenham"),
  "12531": p("NY", "Holmes"),
  "12533": p("NY", "Hopewell Junction"),
  "12537": p("NY", "Hughsonville"),
  "12538": p("NY", "Hyde Park"),
  "12540": p("NY", "Lagrangeville"),
  "12545": p("NY", "Millbrook"),
  "12546": p("NY", "Millerton"),
  "12564": p("NY", "Pawling"),
  "12567": p("NY", "Pine Plains"),
  "12569": p("NY", "Pleasant Valley"),
  "12570": p("NY", "Poughquag"),
  "12571": p("NY", "Red Hook"),
  "12572": p("NY", "Rhinebeck"),
  "12574": p("NY", "Rhinecliff"),
  "12578": p("NY", "Salt Point"),
  "12580": p("NY", "Staatsburg"),
  "12581": p("NY", "Stanfordville"),
  "12582": p("NY", "Stormville"),
  "12583": p("NY", "Tivoli"),
  "12585": p("NY", "Verbank"),
  "12590": p("NY", "Wappingers Falls"),
  "12592": p("NY", "Wassaic"),
  "12594": p("NY", "Wingdale"),
  "12601": p("NY", "Poughkeepsie"),
  "12602": p("NY", "Poughkeepsie"),
  "12603": p("NY", "Poughkeepsie"),
  "12604": p("NY", "Poughkeepsie"),
  "14001": p("NY", "Akron"),
  "14004": p("NY", "Alden"),
  "14006": p("NY", "Angola"),
  "14010": p("NY", "Athol Springs"),
  "14025": p("NY", "Boston"),
  "14026": p("NY", "Bowmansville"),
  "14027": p("NY", "Brant"),
  "14030": p("NY", "Chaffee"),
  "14031": p("NY", "Clarence"),
  "14032": p("NY", "Clarence Center"),
  "14033": p("NY", "Colden"),
  "14034": p("NY", "Collins"),
  "14035": p("NY", "Collins Center"),
  "14038": p("NY", "Crittenden"),
  "14043": p("NY", "Depew"),
  "14047": p("NY", "Derby"),
  "14051": p("NY", "East Amherst"),
  "14052": p("NY", "East Aurora"),
  "14055": p("NY", "East Concord"),
  "14057": p("NY", "Eden"),
  "14059": p("NY", "Elma"),
  "14061": p("NY", "Farnham"),
  "14068": p("NY", "Getzville"),
  "14069": p("NY", "Glenwood"),
  "14072": p("NY", "Grand Island"),
  "14075": p("NY", "Hamburg"),
  "14080": p("NY", "Holland"),
  "14085": p("NY", "Lake View"),
  "14086": p("NY", "Lancaster"),
  "14091": p("NY", "Lawtons"),
  "14102": p("NY", "Marilla"),
  "14110": p("NY", "North Boston"),
  "14111": p("NY", "North Collins"),
  "14112": p("NY", "North Evans"),
  "14127": p("NY", "Orchard Park"),
  "14134": p("NY", "Sardinia"),
  "14139": p("NY", "South Wales"),
  "14140": p("NY", "Spring Brook"),
  "14141": p("NY", "Springville"),
  "14150": p("NY", "Tonawanda"),
  "14151": p("NY", "Tonawanda"),
  "14169": p("NY", "Wales Center"),
  "14170": p("NY", "West Falls"),
  "14201": p("NY", "Buffalo"),
  "14202": p("NY", "Buffalo"),
  "14203": p("NY", "Buffalo"),
  "14204": p("NY", "Buffalo"),
  "14205": p("NY", "Buffalo"),
  "14206": p("NY", "Buffalo"),
  "14207": p("NY", "Buffalo"),
  "14208": p("NY", "Buffalo"),
  "14209": p("NY", "Buffalo"),
  "14210": p("NY", "Buffalo"),
  "14211": p("NY", "Buffalo"),
  "14212": p("NY", "Buffalo"),
  "14213": p("NY", "Buffalo"),
  "14214": p("NY", "Buffalo"),
  "14215": p("NY", "Buffalo"),
  "14216": p("NY", "Buffalo"),
  "14217": p("NY", "Buffalo"),
  "14218": p("NY", "Buffalo"),
  "14219": p("NY", "Buffalo"),
  "14220": p("NY", "Buffalo"),
  "14221": p("NY", "Buffalo"),
  "14222": p("NY", "Buffalo"),
  "14223": p("NY", "Buffalo"),
  "14224": p("NY", "Buffalo"),
  "14225": p("NY", "Buffalo"),
  "14226": p("NY", "Buffalo"),
  "14227": p("NY", "Buffalo"),
  "14228": p("NY", "Buffalo"),
  "14231": p("NY", "Buffalo"),
  "14233": p("NY", "Buffalo"),
  "14240": p("NY", "Buffalo"),
  "14241": p("NY", "Buffalo"),
  "14260": p("NY", "Buffalo"),
  "14261": p("NY", "Buffalo"),
  "14263": p("NY", "Buffalo"),
  "14264": p("NY", "Buffalo"),
  "14265": p("NY", "Buffalo"),
  "14267": p("NY", "Buffalo"),
  "14269": p("NY", "Buffalo"),
  "14270": p("NY", "Buffalo"),
  "14272": p("NY", "Buffalo"),
  "14273": p("NY", "Buffalo"),
  "14276": p("NY", "Buffalo"),
  "14280": p("NY", "Buffalo"),
  "12851": p("NY", "Minerva"),
  "12852": p("NY", "Newcomb"),
  "12855": p("NY", "North Hudson"),
  "12857": p("NY", "Olmstedville"),
  "12858": p("NY", "Paradox"),
  "12870": p("NY", "Schroon Lake"),
  "12872": p("NY", "Severance"),
  "12879": p("NY", "Newcomb"),
  "12883": p("NY", "Ticonderoga"),
  "12913": p("NY", "Bloomingdale"),
  "12928": p("NY", "Crown Point"),
  "12932": p("NY", "Elizabethtown"),
  "12936": p("NY", "Essex"),
  "12941": p("NY", "Jay"),
  "12942": p("NY", "Keene"),
  "12943": p("NY", "Keene Valley"),
  "12944": p("NY", "Keeseville"),
  "12946": p("NY", "Lake Placid"),
  "12950": p("NY", "Lewis"),
  "12956": p("NY", "Mineville"),
  "12960": p("NY", "Moriah"),
  "12961": p("NY", "Moriah Center"),
  "12964": p("NY", "New Russia"),
  "12974": p("NY", "Port Henry"),
  "12975": p("NY", "Port Kent"),
  "12977": p("NY", "Ray Brook"),
  "12987": p("NY", "Upper Jay"),
  "12993": p("NY", "Westport"),
  "12996": p("NY", "Willsboro"),
  "12997": p("NY", "Wilmington"),
  "12998": p("NY", "Witherbee"),
  "12914": p("NY", "Bombay"),
  "12915": p("NY", "Brainardsville"),
  "12916": p("NY", "Brushton"),
  "12917": p("NY", "Burke"),
  "12920": p("NY", "Chateaugay"),
  "12926": p("NY", "Constable"),
  "12930": p("NY", "Dickinson Center"),
  "12937": p("NY", "Fort Covington"),
  "12939": p("NY", "Gabriels"),
  "12945": p("NY", "Lake Clear"),
  "12953": p("NY", "Malone"),
  "12957": p("NY", "Moira"),
  "12966": p("NY", "North Bangor"),
  "12969": p("NY", "Owls Head"),
  "12970": p("NY", "Paul Smiths"),
  "12976": p("NY", "Rainbow Lake"),
  "12980": p("NY", "Saint Regis Falls"),
  "12983": p("NY", "Saranac Lake"),
  "12986": p("NY", "Tupper Lake"),
  "12989": p("NY", "Vermontville"),
  "12995": p("NY", "Whippleville"),
  "13655": p("NY", "Hogansburg"),
  "12025": p("NY", "Broadalbin"),
  "12032": p("NY", "Caroga Lake"),
  "12078": p("NY", "Gloversville"),
  "12095": p("NY", "Johnstown"),
  "12117": p("NY", "Mayfield"),
  "12134": p("NY", "Northville"),
  "13470": p("NY", "Stratford"),
  "14005": p("NY", "Alexander"),
  "14013": p("NY", "Basom"),
  "14020": p("NY", "Batavia"),
  "14021": p("NY", "Batavia"),
  "14036": p("NY", "Corfu"),
  "14040": p("NY", "Darien Center"),
  "14054": p("NY", "East Bethany"),
  "14056": p("NY", "East Pembroke"),
  "14058": p("NY", "Elba"),
  "14125": p("NY", "Oakfield"),
  "14143": p("NY", "Stafford"),
  "14416": p("NY", "Bergen"),
  "14422": p("NY", "Byron"),
  "14482": p("NY", "Le Roy"),
  "14486": p("NY", "Linwood"),
  "14525": p("NY", "Pavilion"),
  "14557": p("NY", "South Byron"),
  "12015": p("NY", "Athens"),
  "12042": p("NY", "Climax"),
  "12051": p("NY", "Coxsackie"),
  "12058": p("NY", "Earlton"),
  "12083": p("NY", "Greenville"),
  "12087": p("NY", "Hannacroix"),
  "12124": p("NY", "New Baltimore"),
  "12176": p("NY", "Surprise"),
  "12192": p("NY", "West Coxsackie"),
  "12405": p("NY", "Acra"),
  "12407": p("NY", "Ashland"),
  "12413": p("NY", "Cairo"),
  "12414": p("NY", "Catskill"),
  "12418": p("NY", "Cornwallville"),
  "12422": p("NY", "Durham"),
  "12423": p("NY", "East Durham"),
  "12424": p("NY", "East Jewett"),
  "12427": p("NY", "Elka Park"),
  "12431": p("NY", "Freehold"),
  "12436": p("NY", "Haines Falls"),
  "12439": p("NY", "Hensonville"),
  "12442": p("NY", "Hunter"),
  "12444": p("NY", "Jewett"),
  "12450": p("NY", "Lanesville"),
  "12451": p("NY", "Leeds"),
  "12452": p("NY", "Lexington"),
  "12454": p("NY", "Maplecrest"),
  "12460": p("NY", "Oak Hill"),
  "12463": p("NY", "Palenville"),
  "12468": p("NY", "Prattsville"),
  "12470": p("NY", "Purling"),
  "12473": p("NY", "Round Top"),
  "12482": p("NY", "South Cairo"),
  "12485": p("NY", "Tannersville"),
  "12492": p("NY", "West Kill"),
  "12496": p("NY", "Windham"),
  "12108": p("NY", "Lake Pleasant"),
  "12139": p("NY", "Piseco"),
  "12164": p("NY", "Speculator"),
  "12190": p("NY", "Wells"),
  "12812": p("NY", "Blue Mountain Lake"),
  "12842": p("NY", "Indian Lake"),
  "12847": p("NY", "Long Lake"),
  "12864": p("NY", "Sabael"),
  "13353": p("NY", "Hoffmeister"),
  "13360": p("NY", "Inlet"),
  "13436": p("NY", "Raquette Lake"),
  "13324": p("NY", "Cold Brook"),
  "13329": p("NY", "Dolgeville"),
  "13331": p("NY", "Eagle Bay"),
  "13340": p("NY", "Frankfort"),
  "13350": p("NY", "Herkimer"),
  "13357": p("NY", "Ilion"),
  "13361": p("NY", "Jordanville"),
  "13365": p("NY", "Little Falls"),
  "13406": p("NY", "Middleville"),
  "13407": p("NY", "Mohawk"),
  "13416": p("NY", "Newport"),
  "13420": p("NY", "Old Forge"),
  "13431": p("NY", "Poland"),
  "13454": p("NY", "Salisbury Center"),
  "13472": p("NY", "Thendara"),
  "13475": p("NY", "Van Hornesville"),
  "13491": p("NY", "West Winfield"),
  "13601": p("NY", "Watertown"),
  "13602": p("NY", "Fort Drum"),
  "13603": p("NY", "Watertown"),
  "13605": p("NY", "Adams"),
  "13606": p("NY", "Adams Center"),
  "13607": p("NY", "Alexandria Bay"),
  "13608": p("NY", "Antwerp"),
  "13611": p("NY", "Belleville"),
  "13612": p("NY", "Black River"),
  "13615": p("NY", "Brownville"),
  "13616": p("NY", "Calcium"),
  "13618": p("NY", "Cape Vincent"),
  "13619": p("NY", "Carthage"),
  "13622": p("NY", "Chaumont"),
  "13624": p("NY", "Clayton"),
  "13628": p("NY", "Deferiet"),
  "13632": p("NY", "Depauville"),
  "13634": p("NY", "Dexter"),
  "13636": p("NY", "Ellisburg"),
  "13637": p("NY", "Evans Mills"),
  "13638": p("NY", "Felts Mills"),
  "13640": p("NY", "Wellesley Island"),
  "13641": p("NY", "Fishers Landing"),
  "13643": p("NY", "Great Bend"),
  "13650": p("NY", "Henderson"),
  "13651": p("NY", "Henderson Harbor"),
  "13656": p("NY", "La Fargeville"),
  "13657": p("NY", "Limerick"),
  "13659": p("NY", "Lorraine"),
  "13661": p("NY", "Mannsville"),
  "13665": p("NY", "Natural Bridge"),
  "13671": p("NY", "Oxbow"),
  "13673": p("NY", "Philadelphia"),
  "13674": p("NY", "Pierrepont Manor"),
  "13675": p("NY", "Plessis"),
  "13679": p("NY", "Redwood"),
  "13682": p("NY", "Rodman"),
  "13685": p("NY", "Sackets Harbor"),
  "13691": p("NY", "Theresa"),
  "13692": p("NY", "Thousand Island Park"),
  "13693": p("NY", "Three Mile Bay"),
  "11201": p("NY", "Brooklyn"),
  "11202": p("NY", "Brooklyn"),
  "11203": p("NY", "Brooklyn"),
  "11204": p("NY", "Brooklyn"),
  "11205": p("NY", "Brooklyn"),
  "11206": p("NY", "Brooklyn"),
  "11207": p("NY", "Brooklyn"),
  "11208": p("NY", "Brooklyn"),
  "11209": p("NY", "Brooklyn"),
  "11210": p("NY", "Brooklyn"),
  "11211": p("NY", "Brooklyn"),
  "11212": p("NY", "Brooklyn"),
  "11213": p("NY", "Brooklyn"),
  "11214": p("NY", "Brooklyn"),
  "11215": p("NY", "Brooklyn"),
  "11216": p("NY", "Brooklyn"),
  "11217": p("NY", "Brooklyn"),
  "11218": p("NY", "Brooklyn"),
  "11219": p("NY", "Brooklyn"),
  "11220": p("NY", "Brooklyn"),
  "11221": p("NY", "Brooklyn"),
  "11222": p("NY", "Brooklyn"),
  "11223": p("NY", "Brooklyn"),
  "11224": p("NY", "Brooklyn"),
  "11225": p("NY", "Brooklyn"),
  "11226": p("NY", "Brooklyn"),
  "11228": p("NY", "Brooklyn"),
  "11229": p("NY", "Brooklyn"),
  "11230": p("NY", "Brooklyn"),
  "11231": p("NY", "Brooklyn"),
  "11232": p("NY", "Brooklyn"),
  "11233": p("NY", "Brooklyn"),
  "11234": p("NY", "Brooklyn"),
  "11235": p("NY", "Brooklyn"),
  "11236": p("NY", "Brooklyn"),
  "11237": p("NY", "Brooklyn"),
  "11238": p("NY", "Brooklyn"),
  "11239": p("NY", "Brooklyn"),
  "11241": p("NY", "Brooklyn"),
  "11242": p("NY", "Brooklyn"),
  "11243": p("NY", "Brooklyn"),
  "11245": p("NY", "Brooklyn"),
  "11247": p("NY", "Brooklyn"),
  "11249": p("NY", "Brooklyn"),
  "11251": p("NY", "Brooklyn"),
  "11252": p("NY", "Brooklyn"),
  "11256": p("NY", "Brooklyn"),
  "13305": p("NY", "Beaver Falls"),
  "13312": p("NY", "Brantingham"),
  "13325": p("NY", "Constableville"),
  "13327": p("NY", "Croghan"),
  "13343": p("NY", "Glenfield"),
  "13345": p("NY", "Greig"),
  "13367": p("NY", "Lowville"),
  "13368": p("NY", "Lyons Falls"),
  "13404": p("NY", "Martinsburg"),
  "13433": p("NY", "Port Leyden"),
  "13473": p("NY", "Turin"),
  "13489": p("NY", "West Leyden"),
  "13620": p("NY", "Castorland"),
  "13626": p("NY", "Copenhagen"),
  "13627": p("NY", "Deer River"),
  "13631": p("NY", "Denmark"),
  "13648": p("NY", "Harrisville"),
  "14414": p("NY", "Avon"),
  "14423": p("NY", "Caledonia"),
  "14435": p("NY", "Conesus"),
  "14437": p("NY", "Dansville"),
  "14454": p("NY", "Geneseo"),
  "14462": p("NY", "Groveland"),
  "14466": p("NY", "Hemlock"),
  "14480": p("NY", "Lakeville"),
  "14481": p("NY", "Leicester"),
  "14485": p("NY", "Lima"),
  "14487": p("NY", "Livonia"),
  "14488": p("NY", "Livonia Center"),
  "14510": p("NY", "Mount Morris"),
  "14517": p("NY", "Nunda"),
  "14533": p("NY", "Piffard"),
  "14539": p("NY", "Retsof"),
  "14545": p("NY", "Scottsburg"),
  "14556": p("NY", "Sonyea"),
  "14558": p("NY", "South Lima"),
  "14560": p("NY", "Springwater"),
  "14592": p("NY", "York"),
  "14836": p("NY", "Dalton"),
  "14846": p("NY", "Hunt"),
  "13032": p("NY", "Canastota"),
  "13035": p("NY", "Cazenovia"),
  "13037": p("NY", "Chittenango"),
  "13043": p("NY", "Clockville"),
  "13052": p("NY", "De Ruyter"),
  "13061": p("NY", "Erieville"),
  "13072": p("NY", "Georgetown"),
  "13122": p("NY", "New Woodstock"),
  "13134": p("NY", "Peterboro"),
  "13163": p("NY", "Wampsville"),
  "13310": p("NY", "Bouckville"),
  "13314": p("NY", "Brookfield"),
  "13334": p("NY", "Eaton"),
  "13346": p("NY", "Hamilton"),
  "13355": p("NY", "Hubbardsville"),
  "13364": p("NY", "Leonardsville"),
  "13402": p("NY", "Madison"),
  "13408": p("NY", "Morrisville"),
  "13409": p("NY", "Munnsville"),
  "13418": p("NY", "North Brookfield"),
  "13421": p("NY", "Oneida"),
  "13465": p("NY", "Solsville"),
  "13484": p("NY", "West Eaton"),
  "14410": p("NY", "Adams Basin"),
  "14420": p("NY", "Brockport"),
  "14428": p("NY", "Churchville"),
  "14430": p("NY", "Clarkson"),
  "14445": p("NY", "East Rochester"),
  "14450": p("NY", "Fairport"),
  "14464": p("NY", "Hamlin"),
  "14467": p("NY", "Henrietta"),
  "14468": p("NY", "Hilton"),
  "14472": p("NY", "Honeoye Falls"),
  "14506": p("NY", "Mendon"),
  "14511": p("NY", "Mumford"),
  "14514": p("NY", "North Chili"),
  "14515": p("NY", "North Greece"),
  "14526": p("NY", "Penfield"),
  "14534": p("NY", "Pittsford"),
  "14543": p("NY", "Rush"),
  "14546": p("NY", "Scottsville"),
  "14559": p("NY", "Spencerport"),
  "14580": p("NY", "Webster"),
  "14586": p("NY", "West Henrietta"),
  "14602": p("NY", "Rochester"),
  "14603": p("NY", "Rochester"),
  "14604": p("NY", "Rochester"),
  "14605": p("NY", "Rochester"),
  "14606": p("NY", "Rochester"),
  "14607": p("NY", "Rochester"),
  "14608": p("NY", "Rochester"),
  "14609": p("NY", "Rochester"),
  "14610": p("NY", "Rochester"),
  "14611": p("NY", "Rochester"),
  "14612": p("NY", "Rochester"),
  "14613": p("NY", "Rochester"),
  "14614": p("NY", "Rochester"),
  "14615": p("NY", "Rochester"),
  "14616": p("NY", "Rochester"),
  "14617": p("NY", "Rochester"),
  "14618": p("NY", "Rochester"),
  "14619": p("NY", "Rochester"),
  "14620": p("NY", "Rochester"),
  "14621": p("NY", "Rochester"),
  "14622": p("NY", "Rochester"),
  "14623": p("NY", "Rochester"),
  "14624": p("NY", "Rochester"),
  "14625": p("NY", "Rochester"),
  "14626": p("NY", "Rochester"),
  "14627": p("NY", "Rochester"),
  "14638": p("NY", "Rochester"),
  "14639": p("NY", "Rochester"),
  "14642": p("NY", "Rochester"),
  "14643": p("NY", "Rochester"),
  "14644": p("NY", "Rochester"),
  "14646": p("NY", "Rochester"),
  "14647": p("NY", "Rochester"),
  "14649": p("NY", "Rochester"),
  "14650": p("NY", "Rochester"),
  "14651": p("NY", "Rochester"),
  "14652": p("NY", "Rochester"),
  "14653": p("NY", "Rochester"),
  "14692": p("NY", "Rochester"),
  "14694": p("NY", "Rochester"),
  "12010": p("NY", "Amsterdam"),
  "12016": p("NY", "Auriesville"),
  "12066": p("NY", "Esperance"),
  "12068": p("NY", "Fonda"),
  "12069": p("NY", "Fort Hunter"),
  "12070": p("NY", "Fort Johnson"),
  "12072": p("NY", "Fultonville"),
  "12086": p("NY", "Hagaman"),
  "12166": p("NY", "Sprakers"),
  "12177": p("NY", "Tribes Hill"),
  "13317": p("NY", "Canajoharie"),
  "13339": p("NY", "Fort Plain"),
  "13410": p("NY", "Nelliston"),
  "13428": p("NY", "Palatine Bridge"),
  "13452": p("NY", "Saint Johnsville"),
  "11001": p("NY", "Floral Park"),
  "11002": p("NY", "Floral Park"),
  "11003": p("NY", "Elmont"),
  "11010": p("NY", "Franklin Square"),
  "11020": p("NY", "Great Neck"),
  "11021": p("NY", "Great Neck"),
  "11022": p("NY", "Great Neck"),
  "11023": p("NY", "Great Neck"),
  "11024": p("NY", "Great Neck"),
  "11026": p("NY", "Great Neck"),
  "11027": p("NY", "Great Neck"),
  "11030": p("NY", "Manhasset"),
  "11040": p("NY", "New Hyde Park"),
  "11042": p("NY", "New Hyde Park"),
  "11050": p("NY", "Port Washington"),
  "11051": p("NY", "Port Washington"),
  "11052": p("NY", "Port Washington"),
  "11053": p("NY", "Port Washington"),
  "11054": p("NY", "Port Washington"),
  "11055": p("NY", "Port Washington"),
  "11096": p("NY", "Inwood"),
  "11501": p("NY", "Mineola"),
  "11507": p("NY", "Albertson"),
  "11509": p("NY", "Atlantic Beach"),
  "11510": p("NY", "Baldwin"),
  "11514": p("NY", "Carle Place"),
  "11516": p("NY", "Cedarhurst"),
  "11518": p("NY", "East Rockaway"),
  "11520": p("NY", "Freeport"),
  "11530": p("NY", "Garden City"),
  "11531": p("NY", "Garden City"),
  "11542": p("NY", "Glen Cove"),
  "11545": p("NY", "Glen Head"),
  "11547": p("NY", "Glenwood Landing"),
  "11548": p("NY", "Greenvale"),
  "11549": p("NY", "Hempstead"),
  "11550": p("NY", "Hempstead"),
  "11551": p("NY", "Hempstead"),
  "11552": p("NY", "West Hempstead"),
  "11553": p("NY", "Uniondale"),
  "11554": p("NY", "East Meadow"),
  "11555": p("NY", "Uniondale"),
  "11556": p("NY", "Uniondale"),
  "11557": p("NY", "Hewlett"),
  "11558": p("NY", "Island Park"),
  "11559": p("NY", "Lawrence"),
  "11560": p("NY", "Locust Valley"),
  "11561": p("NY", "Long Beach"),
  "11563": p("NY", "Lynbrook"),
  "11565": p("NY", "Malverne"),
  "11566": p("NY", "Merrick"),
  "11568": p("NY", "Old Westbury"),
  "11569": p("NY", "Point Lookout"),
  "11570": p("NY", "Rockville Centre"),
  "11571": p("NY", "Rockville Centre"),
  "11572": p("NY", "Oceanside"),
  "11575": p("NY", "Roosevelt"),
  "11576": p("NY", "Roslyn"),
  "11577": p("NY", "Roslyn Heights"),
  "11579": p("NY", "Sea Cliff"),
  "11580": p("NY", "Valley Stream"),
  "11581": p("NY", "Valley Stream"),
  "11582": p("NY", "Valley Stream"),
  "11590": p("NY", "Westbury"),
  "11596": p("NY", "Williston Park"),
  "11598": p("NY", "Woodmere"),
  "11599": p("NY", "Garden City"),
  "11709": p("NY", "Bayville"),
  "11710": p("NY", "Bellmore"),
  "11714": p("NY", "Bethpage"),
  "11732": p("NY", "East Norwich"),
  "11735": p("NY", "Farmingdale"),
  "11737": p("NY", "Farmingdale"),
  "11753": p("NY", "Jericho"),
  "11756": p("NY", "Levittown"),
  "11758": p("NY", "Massapequa"),
  "11762": p("NY", "Massapequa Park"),
  "11765": p("NY", "Mill Neck"),
  "11771": p("NY", "Oyster Bay"),
  "11773": p("NY", "Syosset"),
  "11783": p("NY", "Seaford"),
  "11791": p("NY", "Syosset"),
  "11793": p("NY", "Wantagh"),
  "11797": p("NY", "Woodbury"),
  "11801": p("NY", "Hicksville"),
  "11802": p("NY", "Hicksville"),
  "11803": p("NY", "Plainview"),
  "11804": p("NY", "Old Bethpage"),
  "11815": p("NY", "Hicksville"),
  "11819": p("NY", "Hicksville"),
  "11853": p("NY", "Jericho"),
  "10001": p("NY", "New York"),
  "10002": p("NY", "New York"),
  "10003": p("NY", "New York"),
  "10004": p("NY", "New York"),
  "10005": p("NY", "New York"),
  "10006": p("NY", "New York"),
  "10007": p("NY", "New York"),
  "10008": p("NY", "New York"),
  "10009": p("NY", "New York"),
  "10010": p("NY", "New York"),
  "10011": p("NY", "New York"),
  "10012": p("NY", "New York"),
  "10013": p("NY", "New York"),
  "10014": p("NY", "New York"),
  "10016": p("NY", "New York"),
  "10017": p("NY", "New York"),
  "10018": p("NY", "New York"),
  "10019": p("NY", "New York"),
  "10020": p("NY", "New York"),
  "10021": p("NY", "New York"),
  "10022": p("NY", "New York"),
  "10023": p("NY", "New York"),
  "10024": p("NY", "New York"),
  "10025": p("NY", "New York"),
  "10026": p("NY", "New York"),
  "10027": p("NY", "New York"),
  "10028": p("NY", "New York"),
  "10029": p("NY", "New York"),
  "10030": p("NY", "New York"),
  "10031": p("NY", "New York"),
  "10032": p("NY", "New York"),
  "10033": p("NY", "New York"),
  "10034": p("NY", "New York"),
  "10035": p("NY", "New York"),
  "10036": p("NY", "New York"),
  "10037": p("NY", "New York"),
  "10038": p("NY", "New York"),
  "10039": p("NY", "New York"),
  "10040": p("NY", "New York"),
  "10041": p("NY", "New York"),
  "10043": p("NY", "New York"),
  "10044": p("NY", "New York"),
  "10045": p("NY", "New York"),
  "10055": p("NY", "New York"),
  "10060": p("NY", "New York"),
  "10065": p("NY", "New York"),
  "10069": p("NY", "New York"),
  "10075": p("NY", "New York"),
  "10080": p("NY", "New York"),
  "10081": p("NY", "New York"),
  "10087": p("NY", "New York"),
  "10090": p("NY", "New York"),
  "10101": p("NY", "New York"),
  "10102": p("NY", "New York"),
  "10103": p("NY", "New York"),
  "10104": p("NY", "New York"),
  "10105": p("NY", "New York"),
  "10106": p("NY", "New York"),
  "10107": p("NY", "New York"),
  "10108": p("NY", "New York"),
  "10109": p("NY", "New York"),
  "10110": p("NY", "New York"),
  "10111": p("NY", "New York"),
  "10112": p("NY", "New York"),
  "10113": p("NY", "New York"),
  "10114": p("NY", "New York"),
  "10115": p("NY", "New York"),
  "10116": p("NY", "New York"),
  "10117": p("NY", "New York"),
  "10118": p("NY", "New York"),
  "10119": p("NY", "New York"),
  "10120": p("NY", "New York"),
  "10121": p("NY", "New York"),
  "10122": p("NY", "New York"),
  "10123": p("NY", "New York"),
  "10124": p("NY", "New York"),
  "10125": p("NY", "New York"),
  "10126": p("NY", "New York"),
  "10128": p("NY", "New York"),
  "10129": p("NY", "New York"),
  "10130": p("NY", "New York"),
  "10131": p("NY", "New York"),
  "10132": p("NY", "New York"),
  "10133": p("NY", "New York"),
  "10138": p("NY", "New York"),
  "10150": p("NY", "New York"),
  "10151": p("NY", "New York"),
  "10152": p("NY", "New York"),
  "10153": p("NY", "New York"),
  "10154": p("NY", "New York"),
  "10155": p("NY", "New York"),
  "10156": p("NY", "New York"),
  "10157": p("NY", "New York"),
  "10158": p("NY", "New York"),
  "10159": p("NY", "New York"),
  "10160": p("NY", "New York"),
  "10161": p("NY", "New York"),
  "10162": p("NY", "New York"),
  "10163": p("NY", "New York"),
  "10164": p("NY", "New York"),
  "10165": p("NY", "New York"),
  "10166": p("NY", "New York"),
  "10167": p("NY", "New York"),
  "10168": p("NY", "New York"),
  "10169": p("NY", "New York"),
  "10170": p("NY", "New York"),
  "10171": p("NY", "New York"),
  "10172": p("NY", "New York"),
  "10173": p("NY", "New York"),
  "10174": p("NY", "New York"),
  "10175": p("NY", "New York"),
  "10176": p("NY", "New York"),
  "10177": p("NY", "New York"),
  "10178": p("NY", "New York"),
  "10179": p("NY", "New York"),
  "10185": p("NY", "New York"),
  "10199": p("NY", "New York"),
  "10203": p("NY", "New York"),
  "10211": p("NY", "New York"),
  "10212": p("NY", "New York"),
  "10213": p("NY", "New York"),
  "10242": p("NY", "New York"),
  "10249": p("NY", "New York"),
  "10256": p("NY", "New York"),
  "10258": p("NY", "New York"),
  "10259": p("NY", "New York"),
  "10260": p("NY", "New York"),
  "10261": p("NY", "New York"),
  "10265": p("NY", "New York"),
  "10268": p("NY", "New York"),
  "10269": p("NY", "New York"),
  "10270": p("NY", "New York"),
  "10271": p("NY", "New York"),
  "10272": p("NY", "New York"),
  "10273": p("NY", "New York"),
  "10274": p("NY", "New York"),
  "10275": p("NY", "New York"),
  "10276": p("NY", "New York"),
  "10277": p("NY", "New York"),
  "10278": p("NY", "New York"),
  "10279": p("NY", "New York"),
  "10280": p("NY", "New York"),
  "10281": p("NY", "New York"),
  "10282": p("NY", "New York"),
  "10285": p("NY", "New York"),
  "10286": p("NY", "New York"),
  "14008": p("NY", "Appleton"),
  "14012": p("NY", "Barker"),
  "14028": p("NY", "Burt"),
  "14067": p("NY", "Gasport"),
  "14092": p("NY", "Lewiston"),
  "14094": p("NY", "Lockport"),
  "14095": p("NY", "Lockport"),
  "14105": p("NY", "Middleport"),
  "14107": p("NY", "Model City"),
  "14108": p("NY", "Newfane"),
  "14109": p("NY", "Niagara University"),
  "14120": p("NY", "North Tonawanda"),
  "14126": p("NY", "Olcott"),
  "14131": p("NY", "Ransomville"),
  "14132": p("NY", "Sanborn"),
  "14144": p("NY", "Stella Niagara"),
  "14172": p("NY", "Wilson"),
  "14174": p("NY", "Youngstown"),
  "14301": p("NY", "Niagara Falls"),
  "14302": p("NY", "Niagara Falls"),
  "14303": p("NY", "Niagara Falls"),
  "14304": p("NY", "Niagara Falls"),
  "14305": p("NY", "Niagara Falls"),
  "13054": p("NY", "Durhamville"),
  "13123": p("NY", "North Bay"),
  "13157": p("NY", "Sylvan Beach"),
  "13162": p("NY", "Verona Beach"),
  "13301": p("NY", "Alder Creek"),
  "13303": p("NY", "Ava"),
  "13304": p("NY", "Barneveld"),
  "13308": p("NY", "Blossvale"),
  "13309": p("NY", "Boonville"),
  "13313": p("NY", "Bridgewater"),
  "13316": p("NY", "Camden"),
  "13318": p("NY", "Cassville"),
  "13319": p("NY", "Chadwicks"),
  "13321": p("NY", "Clark Mills"),
  "13322": p("NY", "Clayville"),
  "13323": p("NY", "Clinton"),
  "13328": p("NY", "Deansboro"),
  "13338": p("NY", "Forestport"),
  "13341": p("NY", "Franklin Springs"),
  "13352": p("NY", "Hinckley"),
  "13354": p("NY", "Holland Patent"),
  "13362": p("NY", "Knoxboro"),
  "13363": p("NY", "Lee Center"),
  "13401": p("NY", "Mc Connellsville"),
  "13403": p("NY", "Marcy"),
  "13413": p("NY", "New Hartford"),
  "13417": p("NY", "New York Mills"),
  "13424": p("NY", "Oriskany"),
  "13425": p("NY", "Oriskany Falls"),
  "13435": p("NY", "Prospect"),
  "13438": p("NY", "Remsen"),
  "13440": p("NY", "Rome"),
  "13441": p("NY", "Rome"),
  "13442": p("NY", "Rome"),
  "13449": p("NY", "Rome"),
  "13455": p("NY", "Sangerfield"),
  "13456": p("NY", "Sauquoit"),
  "13461": p("NY", "Sherrill"),
  "13469": p("NY", "Stittville"),
  "13471": p("NY", "Taberg"),
  "13476": p("NY", "Vernon"),
  "13477": p("NY", "Vernon Center"),
  "13478": p("NY", "Verona"),
  "13479": p("NY", "Washington Mills"),
  "13480": p("NY", "Waterville"),
  "13483": p("NY", "Westdale"),
  "13486": p("NY", "Westernville"),
  "13490": p("NY", "Westmoreland"),
  "13492": p("NY", "Whitesboro"),
  "13494": p("NY", "Woodgate"),
  "13495": p("NY", "Yorkville"),
  "13501": p("NY", "Utica"),
  "13502": p("NY", "Utica"),
  "13503": p("NY", "Utica"),
  "13504": p("NY", "Utica"),
  "13505": p("NY", "Utica"),
  "13599": p("NY", "Utica"),
  "13020": p("NY", "Apulia Station"),
  "13027": p("NY", "Baldwinsville"),
  "13029": p("NY", "Brewerton"),
  "13030": p("NY", "Bridgeport"),
  "13031": p("NY", "Camillus"),
  "13039": p("NY", "Cicero"),
  "13041": p("NY", "Clay"),
  "13051": p("NY", "Delphi Falls"),
  "13057": p("NY", "East Syracuse"),
  "13060": p("NY", "Elbridge"),
  "13063": p("NY", "Fabius"),
  "13066": p("NY", "Fayetteville"),
  "13078": p("NY", "Jamesville"),
  "13080": p("NY", "Jordan"),
  "13082": p("NY", "Kirkville"),
  "13084": p("NY", "La Fayette"),
  "13088": p("NY", "Liverpool"),
  "13089": p("NY", "Liverpool"),
  "13090": p("NY", "Liverpool"),
  "13104": p("NY", "Manlius"),
  "13108": p("NY", "Marcellus"),
  "13110": p("NY", "Marietta"),
  "13112": p("NY", "Memphis"),
  "13116": p("NY", "Minoa"),
  "13119": p("NY", "Mottville"),
  "13120": p("NY", "Nedrow"),
  "13137": p("NY", "Plainville"),
  "13138": p("NY", "Pompey"),
  "13152": p("NY", "Skaneateles"),
  "13153": p("NY", "Skaneateles Falls"),
  "13159": p("NY", "Tully"),
  "13164": p("NY", "Warners"),
  "13201": p("NY", "Syracuse"),
  "13202": p("NY", "Syracuse"),
  "13203": p("NY", "Syracuse"),
  "13204": p("NY", "Syracuse"),
  "13205": p("NY", "Syracuse"),
  "13206": p("NY", "Syracuse"),
  "13207": p("NY", "Syracuse"),
  "13208": p("NY", "Syracuse"),
  "13209": p("NY", "Syracuse"),
  "13210": p("NY", "Syracuse"),
  "13211": p("NY", "Syracuse"),
  "13212": p("NY", "Syracuse"),
  "13214": p("NY", "Syracuse"),
  "13215": p("NY", "Syracuse"),
  "13217": p("NY", "Syracuse"),
  "13218": p("NY", "Syracuse"),
  "13219": p("NY", "Syracuse"),
  "13220": p("NY", "Syracuse"),
  "13221": p("NY", "Syracuse"),
  "13224": p("NY", "Syracuse"),
  "13225": p("NY", "Syracuse"),
  "13235": p("NY", "Syracuse"),
  "13244": p("NY", "Syracuse"),
  "13250": p("NY", "Syracuse"),
  "13251": p("NY", "Syracuse"),
  "13252": p("NY", "Syracuse"),
  "13261": p("NY", "Syracuse"),
  "13290": p("NY", "Syracuse"),
  "14424": p("NY", "Canandaigua"),
  "14425": p("NY", "Farmington"),
  "14432": p("NY", "Clifton Springs"),
  "14443": p("NY", "East Bloomfield"),
  "14453": p("NY", "Fishers"),
  "14456": p("NY", "Geneva"),
  "14461": p("NY", "Gorham"),
  "14463": p("NY", "Hall"),
  "14469": p("NY", "Bloomfield"),
  "14471": p("NY", "Honeoye"),
  "14475": p("NY", "Ionia"),
  "14504": p("NY", "Manchester"),
  "14512": p("NY", "Naples"),
  "14518": p("NY", "Oaks Corners"),
  "14532": p("NY", "Phelps"),
  "14537": p("NY", "Port Gibson"),
  "14547": p("NY", "Seneca Castle"),
  "14548": p("NY", "Shortsville"),
  "14561": p("NY", "Stanley"),
  "14564": p("NY", "Victor"),
  "14585": p("NY", "West Bloomfield"),
  "10910": p("NY", "Arden"),
  "10912": p("NY", "Bellvale"),
  "10914": p("NY", "Blooming Grove"),
  "10915": p("NY", "Bullville"),
  "10916": p("NY", "Campbell Hall"),
  "10917": p("NY", "Central Valley"),
  "10918": p("NY", "Chester"),
  "10919": p("NY", "Circleville"),
  "10921": p("NY", "Florida"),
  "10922": p("NY", "Fort Montgomery"),
  "10924": p("NY", "Goshen"),
  "10925": p("NY", "Greenwood Lake"),
  "10926": p("NY", "Harriman"),
  "10928": p("NY", "Highland Falls"),
  "10930": p("NY", "Highland Mills"),
  "10932": p("NY", "Howells"),
  "10933": p("NY", "Johnson"),
  "10940": p("NY", "Middletown"),
  "10941": p("NY", "Middletown"),
  "10949": p("NY", "Monroe"),
  "10950": p("NY", "Monroe"),
  "10953": p("NY", "Mountainville"),
  "10958": p("NY", "New Hampton"),
  "10959": p("NY", "New Milford"),
  "10963": p("NY", "Otisville"),
  "10969": p("NY", "Pine Island"),
  "10973": p("NY", "Slate Hill"),
  "10975": p("NY", "Southfields"),
  "10979": p("NY", "Sterling Forest"),
  "10981": p("NY", "Sugar Loaf"),
  "10985": p("NY", "Thompson Ridge"),
  "10987": p("NY", "Tuxedo Park"),
  "10988": p("NY", "Unionville"),
  "10990": p("NY", "Warwick"),
  "10992": p("NY", "Washingtonville"),
  "10996": p("NY", "West Point"),
  "10997": p("NY", "West Point"),
  "10998": p("NY", "Westtown"),
  "12518": p("NY", "Cornwall"),
  "12520": p("NY", "Cornwall On Hudson"),
  "12543": p("NY", "Maybrook"),
  "12549": p("NY", "Montgomery"),
  "12550": p("NY", "Newburgh"),
  "12551": p("NY", "Newburgh"),
  "12552": p("NY", "Newburgh"),
  "12553": p("NY", "New Windsor"),
  "12555": p("NY", "Newburgh"),
  "12566": p("NY", "Pine Bush"),
  "12575": p("NY", "Rock Tavern"),
  "12577": p("NY", "Salisbury Mills"),
  "12584": p("NY", "Vails Gate"),
  "12586": p("NY", "Walden"),
  "12729": p("NY", "Cuddebackville"),
  "12746": p("NY", "Huguenot"),
  "12771": p("NY", "Port Jervis"),
  "12780": p("NY", "Sparrow Bush"),
  "14098": p("NY", "Lyndonville"),
  "14103": p("NY", "Medina"),
  "14411": p("NY", "Albion"),
  "14429": p("NY", "Clarendon"),
  "14452": p("NY", "Fancher"),
  "14470": p("NY", "Holley"),
  "14476": p("NY", "Kendall"),
  "14477": p("NY", "Kent"),
  "14479": p("NY", "Knowlesville"),
  "14508": p("NY", "Morton"),
  "14571": p("NY", "Waterport"),
  "13028": p("NY", "Bernhards Bay"),
  "13036": p("NY", "Central Square"),
  "13042": p("NY", "Cleveland"),
  "13044": p("NY", "Constantia"),
  "13064": p("NY", "Fair Haven"),
  "13069": p("NY", "Fulton"),
  "13074": p("NY", "Hannibal"),
  "13076": p("NY", "Hastings"),
  "13083": p("NY", "Lacona"),
  "13093": p("NY", "Lycoming"),
  "13103": p("NY", "Mallory"),
  "13107": p("NY", "Maple View"),
  "13114": p("NY", "Mexico"),
  "13115": p("NY", "Minetto"),
  "13121": p("NY", "New Haven"),
  "13126": p("NY", "Oswego"),
  "13131": p("NY", "Parish"),
  "13132": p("NY", "Pennellville"),
  "13135": p("NY", "Phoenix"),
  "13142": p("NY", "Pulaski"),
  "13144": p("NY", "Richland"),
  "13145": p("NY", "Sandy Creek"),
  "13167": p("NY", "West Monroe"),
  "13302": p("NY", "Altmar"),
  "13426": p("NY", "Orwell"),
  "13437": p("NY", "Redfield"),
  "13493": p("NY", "Williamstown"),
  "12064": p("NY", "East Worcester"),
  "12116": p("NY", "Maryland"),
  "12155": p("NY", "Schenevus"),
  "12197": p("NY", "Worcester"),
  "13315": p("NY", "Burlington Flats"),
  "13320": p("NY", "Cherry Valley"),
  "13326": p("NY", "Cooperstown"),
  "13333": p("NY", "East Springfield"),
  "13335": p("NY", "Edmeston"),
  "13337": p("NY", "Fly Creek"),
  "13342": p("NY", "Garrattsville"),
  "13348": p("NY", "Hartwick"),
  "13415": p("NY", "New Lisbon"),
  "13439": p("NY", "Richfield Springs"),
  "13450": p("NY", "Roseboom"),
  "13457": p("NY", "Schuyler Lake"),
  "13468": p("NY", "Springfield Center"),
  "13482": p("NY", "West Burlington"),
  "13485": p("NY", "West Edmeston"),
  "13488": p("NY", "Westford"),
  "13747": p("NY", "Colliersville"),
  "13776": p("NY", "Gilbertsville"),
  "13796": p("NY", "Laurens"),
  "13807": p("NY", "Milford"),
  "13808": p("NY", "Morris"),
  "13810": p("NY", "Mount Vision"),
  "13820": p("NY", "Oneonta"),
  "13825": p("NY", "Otego"),
  "13834": p("NY", "Portlandville"),
  "13849": p("NY", "Unadilla"),
  "13859": p("NY", "Wells Bridge"),
  "13861": p("NY", "West Oneonta"),
  "10509": p("NY", "Brewster"),
  "10512": p("NY", "Carmel"),
  "10516": p("NY", "Cold Spring"),
  "10524": p("NY", "Garrison"),
  "10537": p("NY", "Lake Peekskill"),
  "10541": p("NY", "Mahopac"),
  "10542": p("NY", "Mahopac Falls"),
  "10579": p("NY", "Putnam Valley"),
  "12563": p("NY", "Patterson"),
  "11004": p("NY", "Glen Oaks"),
  "11005": p("NY", "Floral Park"),
  "11101": p("NY", "Long Island City"),
  "11102": p("NY", "Astoria"),
  "11103": p("NY", "Astoria"),
  "11104": p("NY", "Sunnyside"),
  "11105": p("NY", "Astoria"),
  "11106": p("NY", "Astoria"),
  "11109": p("NY", "Long Island City"),
  "11120": p("NY", "Long Island City"),
  "11351": p("NY", "Flushing"),
  "11352": p("NY", "Flushing"),
  "11354": p("NY", "Flushing"),
  "11355": p("NY", "Flushing"),
  "11356": p("NY", "College Point"),
  "11357": p("NY", "Whitestone"),
  "11358": p("NY", "Flushing"),
  "11359": p("NY", "Bayside"),
  "11360": p("NY", "Bayside"),
  "11361": p("NY", "Bayside"),
  "11362": p("NY", "Little Neck"),
  "11363": p("NY", "Little Neck"),
  "11364": p("NY", "Oakland Gardens"),
  "11365": p("NY", "Fresh Meadows"),
  "11366": p("NY", "Fresh Meadows"),
  "11367": p("NY", "Flushing"),
  "11368": p("NY", "Corona"),
  "11369": p("NY", "East Elmhurst"),
  "11370": p("NY", "East Elmhurst"),
  "11371": p("NY", "Flushing"),
  "11372": p("NY", "Jackson Heights"),
  "11373": p("NY", "Elmhurst"),
  "11374": p("NY", "Rego Park"),
  "11375": p("NY", "Forest Hills"),
  "11377": p("NY", "Woodside"),
  "11378": p("NY", "Maspeth"),
  "11379": p("NY", "Middle Village"),
  "11380": p("NY", "Elmhurst"),
  "11381": p("NY", "Flushing"),
  "11385": p("NY", "Ridgewood"),
  "11386": p("NY", "Ridgewood"),
  "11405": p("NY", "Jamaica"),
  "11411": p("NY", "Cambria Heights"),
  "11412": p("NY", "Saint Albans"),
  "11413": p("NY", "Springfield Gardens"),
  "11414": p("NY", "Howard Beach"),
  "11415": p("NY", "Kew Gardens"),
  "11416": p("NY", "Ozone Park"),
  "11417": p("NY", "Ozone Park"),
  "11418": p("NY", "Richmond Hill"),
  "11419": p("NY", "South Richmond Hill"),
  "11420": p("NY", "South Ozone Park"),
  "11421": p("NY", "Woodhaven"),
  "11422": p("NY", "Rosedale"),
  "11423": p("NY", "Hollis"),
  "11424": p("NY", "Jamaica"),
  "11425": p("NY", "Jamaica"),
  "11426": p("NY", "Bellerose"),
  "11427": p("NY", "Queens Village"),
  "11428": p("NY", "Queens Village"),
  "11429": p("NY", "Queens Village"),
  "11430": p("NY", "Jamaica"),
  "11431": p("NY", "Jamaica"),
  "11432": p("NY", "Jamaica"),
  "11433": p("NY", "Jamaica"),
  "11434": p("NY", "Jamaica"),
  "11435": p("NY", "Jamaica"),
  "11436": p("NY", "Jamaica"),
  "11437": p("NY", "Jamaica"),
  "11439": p("NY", "Jamaica"),
  "11451": p("NY", "Jamaica"),
  "11499": p("NY", "Jamaica"),
  "11690": p("NY", "Far Rockaway"),
  "11691": p("NY", "Far Rockaway"),
  "11692": p("NY", "Arverne"),
  "11693": p("NY", "Far Rockaway"),
  "11694": p("NY", "Rockaway Park"),
  "11695": p("NY", "Far Rockaway"),
  "11697": p("NY", "Breezy Point"),
  "12018": p("NY", "Averill Park"),
  "12022": p("NY", "Berlin"),
  "12024": p("NY", "Brainard"),
  "12028": p("NY", "Buskirk"),
  "12033": p("NY", "Castleton On Hudson"),
  "12040": p("NY", "Cherry Plain"),
  "12052": p("NY", "Cropseyville"),
  "12061": p("NY", "East Greenbush"),
  "12062": p("NY", "East Nassau"),
  "12063": p("NY", "East Schodack"),
  "12082": p("NY", "Grafton"),
  "12089": p("NY", "Hoosick"),
  "12090": p("NY", "Hoosick Falls"),
  "12094": p("NY", "Johnsonville"),
  "12121": p("NY", "Melrose"),
  "12123": p("NY", "Nassau"),
  "12133": p("NY", "North Hoosick"),
  "12138": p("NY", "Petersburg"),
  "12140": p("NY", "Poestenkill"),
  "12144": p("NY", "Rensselaer"),
  "12153": p("NY", "Sand Lake"),
  "12154": p("NY", "Schaghticoke"),
  "12156": p("NY", "Schodack Landing"),
  "12168": p("NY", "Stephentown"),
  "12169": p("NY", "Stephentown"),
  "12180": p("NY", "Troy"),
  "12181": p("NY", "Troy"),
  "12182": p("NY", "Troy"),
  "12185": p("NY", "Valley Falls"),
  "12196": p("NY", "West Sand Lake"),
  "12198": p("NY", "Wynantskill"),
  "10301": p("NY", "Staten Island"),
  "10302": p("NY", "Staten Island"),
  "10303": p("NY", "Staten Island"),
  "10304": p("NY", "Staten Island"),
  "10305": p("NY", "Staten Island"),
  "10306": p("NY", "Staten Island"),
  "10307": p("NY", "Staten Island"),
  "10308": p("NY", "Staten Island"),
  "10309": p("NY", "Staten Island"),
  "10310": p("NY", "Staten Island"),
  "10311": p("NY", "Staten Island"),
  "10312": p("NY", "Staten Island"),
  "10313": p("NY", "Staten Island"),
  "10314": p("NY", "Staten Island"),
  "10901": p("NY", "Suffern"),
  "10911": p("NY", "Bear Mountain"),
  "10913": p("NY", "Blauvelt"),
  "10920": p("NY", "Congers"),
  "10923": p("NY", "Garnerville"),
  "10927": p("NY", "Haverstraw"),
  "10931": p("NY", "Hillburn"),
  "10952": p("NY", "Monsey"),
  "10954": p("NY", "Nanuet"),
  "10956": p("NY", "New City"),
  "10960": p("NY", "Nyack"),
  "10962": p("NY", "Orangeburg"),
  "10964": p("NY", "Palisades"),
  "10965": p("NY", "Pearl River"),
  "10968": p("NY", "Piermont"),
  "10970": p("NY", "Pomona"),
  "10974": p("NY", "Sloatsburg"),
  "10976": p("NY", "Sparkill"),
  "10977": p("NY", "Spring Valley"),
  "10980": p("NY", "Stony Point"),
  "10982": p("NY", "Tallman"),
  "10983": p("NY", "Tappan"),
  "10984": p("NY", "Thiells"),
  "10986": p("NY", "Tomkins Cove"),
  "10989": p("NY", "Valley Cottage"),
  "10993": p("NY", "West Haverstraw"),
  "10994": p("NY", "West Nyack"),
  "12922": p("NY", "Childwold"),
  "12927": p("NY", "Cranberry Lake"),
  "12949": p("NY", "Lawrenceville"),
  "12965": p("NY", "Nicholville"),
  "12967": p("NY", "North Lawrence"),
  "12973": p("NY", "Piercefield"),
  "13613": p("NY", "Brasher Falls"),
  "13614": p("NY", "Brier Hill"),
  "13617": p("NY", "Canton"),
  "13621": p("NY", "Chase Mills"),
  "13623": p("NY", "Chippewa Bay"),
  "13625": p("NY", "Colton"),
  "13630": p("NY", "De Kalb Junction"),
  "13633": p("NY", "De Peyster"),
  "13635": p("NY", "Edwards"),
  "13639": p("NY", "Fine"),
  "13642": p("NY", "Gouverneur"),
  "13645": p("NY", "Hailesboro"),
  "13646": p("NY", "Hammond"),
  "13647": p("NY", "Hannawa Falls"),
  "13649": p("NY", "Helena"),
  "13652": p("NY", "Hermon"),
  "13654": p("NY", "Heuvelton"),
  "13658": p("NY", "Lisbon"),
  "13660": p("NY", "Madrid"),
  "13662": p("NY", "Massena"),
  "13664": p("NY", "Morristown"),
  "13666": p("NY", "Newton Falls"),
  "13667": p("NY", "Norfolk"),
  "13668": p("NY", "Norwood"),
  "13669": p("NY", "Ogdensburg"),
  "13670": p("NY", "Oswegatchie"),
  "13672": p("NY", "Parishville"),
  "13676": p("NY", "Potsdam"),
  "13677": p("NY", "Pyrites"),
  "13678": p("NY", "Raymondville"),
  "13680": p("NY", "Rensselaer Falls"),
  "13681": p("NY", "Richville"),
  "13683": p("NY", "Rooseveltown"),
  "13684": p("NY", "Russell"),
  "13687": p("NY", "South Colton"),
  "13690": p("NY", "Star Lake"),
  "13694": p("NY", "Waddington"),
  "13695": p("NY", "Wanakena"),
  "13696": p("NY", "West Stockholm"),
  "13697": p("NY", "Winthrop"),
  "13699": p("NY", "Potsdam"),
  "12019": p("NY", "Ballston Lake"),
  "12020": p("NY", "Ballston Spa"),
  "12027": p("NY", "Burnt Hills"),
  "12065": p("NY", "Clifton Park"),
  "12074": p("NY", "Galway"),
  "12118": p("NY", "Mechanicville"),
  "12148": p("NY", "Rexford"),
  "12151": p("NY", "Round Lake"),
  "12170": p("NY", "Stillwater"),
  "12188": p("NY", "Waterford"),
  "12803": p("NY", "South Glens Falls"),
  "12822": p("NY", "Corinth"),
  "12831": p("NY", "Gansevoort"),
  "12833": p("NY", "Greenfield Center"),
  "12835": p("NY", "Hadley"),
  "12850": p("NY", "Middle Grove"),
  "12859": p("NY", "Porter Corners"),
  "12863": p("NY", "Rock City Falls"),
  "12866": p("NY", "Saratoga Springs"),
  "12871": p("NY", "Schuylerville"),
  "12884": p("NY", "Victory Mills"),
  "12008": p("NY", "Alplaus"),
  "12053": p("NY", "Delanson"),
  "12056": p("NY", "Duanesburg"),
  "12137": p("NY", "Pattersonville"),
  "12141": p("NY", "Quaker Street"),
  "12150": p("NY", "Rotterdam Junction"),
  "12301": p("NY", "Schenectady"),
  "12302": p("NY", "Schenectady"),
  "12303": p("NY", "Schenectady"),
  "12304": p("NY", "Schenectady"),
  "12305": p("NY", "Schenectady"),
  "12306": p("NY", "Schenectady"),
  "12307": p("NY", "Schenectady"),
  "12308": p("NY", "Schenectady"),
  "12309": p("NY", "Schenectady"),
  "12325": p("NY", "Schenectady"),
  "12345": p("NY", "Schenectady"),
  "12031": p("NY", "Carlisle"),
  "12035": p("NY", "Central Bridge"),
  "12036": p("NY", "Charlotteville"),
  "12043": p("NY", "Cobleskill"),
  "12071": p("NY", "Fultonham"),
  "12073": p("NY", "Gallupville"),
  "12076": p("NY", "Gilboa"),
  "12092": p("NY", "Howes Cave"),
  "12093": p("NY", "Jefferson"),
  "12122": p("NY", "Middleburgh"),
  "12131": p("NY", "North Blenheim"),
  "12149": p("NY", "Richmondville"),
  "12157": p("NY", "Schoharie"),
  "12160": p("NY", "Sloansville"),
  "12175": p("NY", "Summit"),
  "12187": p("NY", "Warnerville"),
  "12194": p("NY", "West Fulton"),
  "13459": p("NY", "Sharon Springs"),
  "14805": p("NY", "Alpine"),
  "14812": p("NY", "Beaver Dams"),
  "14818": p("NY", "Burdett"),
  "14824": p("NY", "Cayuta"),
  "14841": p("NY", "Hector"),
  "14863": p("NY", "Mecklenburg"),
  "14865": p("NY", "Montour Falls"),
  "14869": p("NY", "Odessa"),
  "14876": p("NY", "Reading Center"),
  "14887": p("NY", "Tyrone"),
  "14891": p("NY", "Watkins Glen"),
  "14893": p("NY", "Wayne"),
  "13065": p("NY", "Fayette"),
  "13148": p("NY", "Seneca Falls"),
  "13165": p("NY", "Waterloo"),
  "14521": p("NY", "Ovid"),
  "14541": p("NY", "Romulus"),
  "14588": p("NY", "Willard"),
  "14847": p("NY", "Interlaken"),
  "14860": p("NY", "Lodi"),
  "14529": p("NY", "Perkinsville"),
  "14572": p("NY", "Wayland"),
  "14801": p("NY", "Addison"),
  "14807": p("NY", "Arkport"),
  "14808": p("NY", "Atlanta"),
  "14809": p("NY", "Avoca"),
  "14810": p("NY", "Bath"),
  "14815": p("NY", "Bradford"),
  "14819": p("NY", "Cameron"),
  "14820": p("NY", "Cameron Mills"),
  "14821": p("NY", "Campbell"),
  "14823": p("NY", "Canisteo"),
  "14826": p("NY", "Cohocton"),
  "14827": p("NY", "Coopers Plains"),
  "14830": p("NY", "Corning"),
  "14831": p("NY", "Corning"),
  "14839": p("NY", "Greenwood"),
  "14840": p("NY", "Hammondsport"),
  "14843": p("NY", "Hornell"),
  "14855": p("NY", "Jasper"),
  "14856": p("NY", "Kanona"),
  "14858": p("NY", "Lindley"),
  "14870": p("NY", "Painted Post"),
  "14873": p("NY", "Prattsburgh"),
  "14874": p("NY", "Pulteney"),
  "14877": p("NY", "Rexville"),
  "14879": p("NY", "Savona"),
  "14885": p("NY", "Troupsburg"),
  "14898": p("NY", "Woodhull"),
  "00501": p("NY", "Holtsville"),
  "00544": p("NY", "Holtsville"),
  "06390": p("NY", "Fishers Island"),
  "11701": p("NY", "Amityville"),
  "11702": p("NY", "Babylon"),
  "11703": p("NY", "North Babylon"),
  "11704": p("NY", "West Babylon"),
  "11705": p("NY", "Bayport"),
  "11706": p("NY", "Bay Shore"),
  "11707": p("NY", "West Babylon"),
  "11713": p("NY", "Bellport"),
  "11715": p("NY", "Blue Point"),
  "11716": p("NY", "Bohemia"),
  "11717": p("NY", "Brentwood"),
  "11718": p("NY", "Brightwaters"),
  "11719": p("NY", "Brookhaven"),
  "11720": p("NY", "Centereach"),
  "11721": p("NY", "Centerport"),
  "11722": p("NY", "Central Islip"),
  "11724": p("NY", "Cold Spring Harbor"),
  "11725": p("NY", "Commack"),
  "11726": p("NY", "Copiague"),
  "11727": p("NY", "Coram"),
  "11729": p("NY", "Deer Park"),
  "11730": p("NY", "East Islip"),
  "11731": p("NY", "East Northport"),
  "11733": p("NY", "East Setauket"),
  "11738": p("NY", "Farmingville"),
  "11739": p("NY", "Great River"),
  "11740": p("NY", "Greenlawn"),
  "11741": p("NY", "Holbrook"),
  "11742": p("NY", "Holtsville"),
  "11743": p("NY", "Huntington"),
  "11746": p("NY", "Huntington Station"),
  "11747": p("NY", "Melville"),
  "11749": p("NY", "Islandia"),
  "11751": p("NY", "Islip"),
  "11752": p("NY", "Islip Terrace"),
  "11754": p("NY", "Kings Park"),
  "11755": p("NY", "Lake Grove"),
  "11757": p("NY", "Lindenhurst"),
  "11760": p("NY", "Melville"),
  "11763": p("NY", "Medford"),
  "11764": p("NY", "Miller Place"),
  "11766": p("NY", "Mount Sinai"),
  "11767": p("NY", "Nesconset"),
  "11768": p("NY", "Northport"),
  "11769": p("NY", "Oakdale"),
  "11770": p("NY", "Ocean Beach"),
  "11772": p("NY", "Patchogue"),
  "11775": p("NY", "Melville"),
  "11776": p("NY", "Port Jefferson Station"),
  "11777": p("NY", "Port Jefferson"),
  "11778": p("NY", "Rocky Point"),
  "11779": p("NY", "Ronkonkoma"),
  "11780": p("NY", "Saint James"),
  "11782": p("NY", "Sayville"),
  "11784": p("NY", "Selden"),
  "11786": p("NY", "Shoreham"),
  "11787": p("NY", "Smithtown"),
  "11788": p("NY", "Hauppauge"),
  "11789": p("NY", "Sound Beach"),
  "11790": p("NY", "Stony Brook"),
  "11792": p("NY", "Wading River"),
  "11794": p("NY", "Stony Brook"),
  "11795": p("NY", "West Islip"),
  "11796": p("NY", "West Sayville"),
  "11798": p("NY", "Wyandanch"),
  "11901": p("NY", "Riverhead"),
  "11930": p("NY", "Amagansett"),
  "11931": p("NY", "Aquebogue"),
  "11932": p("NY", "Bridgehampton"),
  "11933": p("NY", "Calverton"),
  "11934": p("NY", "Center Moriches"),
  "11935": p("NY", "Cutchogue"),
  "11937": p("NY", "East Hampton"),
  "11939": p("NY", "East Marion"),
  "11940": p("NY", "East Moriches"),
  "11941": p("NY", "Eastport"),
  "11942": p("NY", "East Quogue"),
  "11944": p("NY", "Greenport"),
  "11946": p("NY", "Hampton Bays"),
  "11947": p("NY", "Jamesport"),
  "11948": p("NY", "Laurel"),
  "11949": p("NY", "Manorville"),
  "11950": p("NY", "Mastic"),
  "11951": p("NY", "Mastic Beach"),
  "11952": p("NY", "Mattituck"),
  "11953": p("NY", "Middle Island"),
  "11954": p("NY", "Montauk"),
  "11955": p("NY", "Moriches"),
  "11956": p("NY", "New Suffolk"),
  "11957": p("NY", "Orient"),
  "11958": p("NY", "Peconic"),
  "11959": p("NY", "Quogue"),
  "11960": p("NY", "Remsenburg"),
  "11961": p("NY", "Ridge"),
  "11962": p("NY", "Sagaponack"),
  "11963": p("NY", "Sag Harbor"),
  "11964": p("NY", "Shelter Island"),
  "11965": p("NY", "Shelter Island Heights"),
  "11967": p("NY", "Shirley"),
  "11968": p("NY", "Southampton"),
  "11969": p("NY", "Southampton"),
  "11970": p("NY", "South Jamesport"),
  "11971": p("NY", "Southold"),
  "11972": p("NY", "Speonk"),
  "11973": p("NY", "Upton"),
  "11975": p("NY", "Wainscott"),
  "11976": p("NY", "Water Mill"),
  "11977": p("NY", "Westhampton"),
  "11978": p("NY", "Westhampton Beach"),
  "11980": p("NY", "Yaphank"),
  "12701": p("NY", "Monticello"),
  "12719": p("NY", "Barryville"),
  "12720": p("NY", "Bethel"),
  "12721": p("NY", "Bloomingburg"),
  "12722": p("NY", "Burlingham"),
  "12723": p("NY", "Callicoon"),
  "12724": p("NY", "Callicoon Center"),
  "12725": p("NY", "Claryville"),
  "12726": p("NY", "Cochecton"),
  "12727": p("NY", "Cochecton Center"),
  "12732": p("NY", "Eldred"),
  "12733": p("NY", "Fallsburg"),
  "12734": p("NY", "Ferndale"),
  "12736": p("NY", "Fremont Center"),
  "12737": p("NY", "Glen Spey"),
  "12738": p("NY", "Glen Wild"),
  "12740": p("NY", "Grahamsville"),
  "12741": p("NY", "Hankins"),
  "12742": p("NY", "Harris"),
  "12743": p("NY", "Highland Lake"),
  "12745": p("NY", "Hortonville"),
  "12747": p("NY", "Hurleyville"),
  "12748": p("NY", "Jeffersonville"),
  "12749": p("NY", "Kauneonga Lake"),
  "12750": p("NY", "Kenoza Lake"),
  "12751": p("NY", "Kiamesha Lake"),
  "12752": p("NY", "Lake Huntington"),
  "12754": p("NY", "Liberty"),
  "12758": p("NY", "Livingston Manor"),
  "12759": p("NY", "Loch Sheldrake"),
  "12760": p("NY", "Long Eddy"),
  "12762": p("NY", "Mongaup Valley"),
  "12763": p("NY", "Mountain Dale"),
  "12764": p("NY", "Narrowsburg"),
  "12765": p("NY", "Neversink"),
  "12766": p("NY", "North Branch"),
  "12767": p("NY", "Obernburg"),
  "12768": p("NY", "Parksville"),
  "12769": p("NY", "Phillipsport"),
  "12770": p("NY", "Pond Eddy"),
  "12775": p("NY", "Rock Hill"),
  "12776": p("NY", "Roscoe"),
  "12777": p("NY", "Forestburgh"),
  "12778": p("NY", "Smallwood"),
  "12779": p("NY", "South Fallsburg"),
  "12781": p("NY", "Summitville"),
  "12783": p("NY", "Swan Lake"),
  "12784": p("NY", "Thompsonville"),
  "12785": p("NY", "Westbrookville"),
  "12786": p("NY", "White Lake"),
  "12787": p("NY", "White Sulphur Springs"),
  "12788": p("NY", "Woodbourne"),
  "12789": p("NY", "Woodridge"),
  "12790": p("NY", "Wurtsboro"),
  "12791": p("NY", "Youngsville"),
  "12792": p("NY", "Yulan"),
  "13732": p("NY", "Apalachin"),
  "13734": p("NY", "Barton"),
  "13736": p("NY", "Berkshire"),
  "13743": p("NY", "Candor"),
  "13811": p("NY", "Newark Valley"),
  "13812": p("NY", "Nichols"),
  "13827": p("NY", "Owego"),
  "13835": p("NY", "Richford"),
  "13840": p("NY", "Smithboro"),
  "13845": p("NY", "Tioga Center"),
  "13864": p("NY", "Willseyville"),
  "14859": p("NY", "Lockwood"),
  "14883": p("NY", "Spencer"),
  "14892": p("NY", "Waverly"),
  "13053": p("NY", "Dryden"),
  "13062": p("NY", "Etna"),
  "13068": p("NY", "Freeville"),
  "13073": p("NY", "Groton"),
  "13102": p("NY", "Mc Lean"),
  "14817": p("NY", "Brooktondale"),
  "14850": p("NY", "Ithaca"),
  "14851": p("NY", "Ithaca"),
  "14852": p("NY", "Ithaca"),
  "14853": p("NY", "Ithaca"),
  "14854": p("NY", "Jacksonville"),
  "14867": p("NY", "Newfield"),
  "14881": p("NY", "Slaterville Springs"),
  "14882": p("NY", "Lansing"),
  "14886": p("NY", "Trumansburg"),
  "12401": p("NY", "Kingston"),
  "12402": p("NY", "Kingston"),
  "12404": p("NY", "Accord"),
  "12409": p("NY", "Bearsville"),
  "12410": p("NY", "Big Indian"),
  "12411": p("NY", "Bloomington"),
  "12412": p("NY", "Boiceville"),
  "12416": p("NY", "Chichester"),
  "12417": p("NY", "Connelly"),
  "12419": p("NY", "Cottekill"),
  "12420": p("NY", "Cragsmoor"),
  "12428": p("NY", "Ellenville"),
  "12429": p("NY", "Esopus"),
  "12432": p("NY", "Glasco"),
  "12433": p("NY", "Glenford"),
  "12435": p("NY", "Greenfield Park"),
  "12440": p("NY", "High Falls"),
  "12441": p("NY", "Highmount"),
  "12443": p("NY", "Hurley"),
  "12446": p("NY", "Kerhonkson"),
  "12448": p("NY", "Lake Hill"),
  "12449": p("NY", "Lake Katrine"),
  "12453": p("NY", "Malden On Hudson"),
  "12456": p("NY", "Mount Marion"),
  "12457": p("NY", "Mount Tremper"),
  "12458": p("NY", "Napanoch"),
  "12461": p("NY", "Olivebridge"),
  "12464": p("NY", "Phoenicia"),
  "12465": p("NY", "Pine Hill"),
  "12466": p("NY", "Port Ewen"),
  "12471": p("NY", "Rifton"),
  "12472": p("NY", "Rosendale"),
  "12475": p("NY", "Ruby"),
  "12477": p("NY", "Saugerties"),
  "12480": p("NY", "Shandaken"),
  "12481": p("NY", "Shokan"),
  "12483": p("NY", "Spring Glen"),
  "12484": p("NY", "Stone Ridge"),
  "12486": p("NY", "Tillson"),
  "12487": p("NY", "Ulster Park"),
  "12489": p("NY", "Wawarsing"),
  "12490": p("NY", "West Camp"),
  "12491": p("NY", "West Hurley"),
  "12493": p("NY", "West Park"),
  "12494": p("NY", "West Shokan"),
  "12495": p("NY", "Willow"),
  "12498": p("NY", "Woodstock"),
  "12515": p("NY", "Clintondale"),
  "12525": p("NY", "Gardiner"),
  "12528": p("NY", "Highland"),
  "12542": p("NY", "Marlboro"),
  "12547": p("NY", "Milton"),
  "12548": p("NY", "Modena"),
  "12561": p("NY", "New Paltz"),
  "12568": p("NY", "Plattekill"),
  "12588": p("NY", "Walker Valley"),
  "12589": p("NY", "Wallkill"),
  "12801": p("NY", "Glens Falls"),
  "12804": p("NY", "Queensbury"),
  "12808": p("NY", "Adirondack"),
  "12810": p("NY", "Athol"),
  "12811": p("NY", "Bakers Mills"),
  "12814": p("NY", "Bolton Landing"),
  "12815": p("NY", "Brant Lake"),
  "12817": p("NY", "Chestertown"),
  "12820": p("NY", "Cleverdale"),
  "12824": p("NY", "Diamond Point"),
  "12836": p("NY", "Hague"),
  "12843": p("NY", "Johnsburg"),
  "12844": p("NY", "Kattskill Bay"),
  "12845": p("NY", "Lake George"),
  "12846": p("NY", "Lake Luzerne"),
  "12853": p("NY", "North Creek"),
  "12856": p("NY", "North River"),
  "12860": p("NY", "Pottersville"),
  "12862": p("NY", "Riparius"),
  "12874": p("NY", "Silver Bay"),
  "12878": p("NY", "Stony Creek"),
  "12885": p("NY", "Warrensburg"),
  "12886": p("NY", "Wevertown"),
  "12057": p("NY", "Eagle Bridge"),
  "12809": p("NY", "Argyle"),
  "12816": p("NY", "Cambridge"),
  "12819": p("NY", "Clemons"),
  "12821": p("NY", "Comstock"),
  "12823": p("NY", "Cossayuna"),
  "12827": p("NY", "Fort Ann"),
  "12828": p("NY", "Fort Edward"),
  "12832": p("NY", "Granville"),
  "12834": p("NY", "Greenwich"),
  "12837": p("NY", "Hampton"),
  "12838": p("NY", "Hartford"),
  "12839": p("NY", "Hudson Falls"),
  "12841": p("NY", "Huletts Landing"),
  "12848": p("NY", "Middle Falls"),
  "12849": p("NY", "Middle Granville"),
  "12854": p("NY", "North Granville"),
  "12861": p("NY", "Putnam Station"),
  "12865": p("NY", "Salem"),
  "12873": p("NY", "Shushan"),
  "12887": p("NY", "Whitehall"),
  "13143": p("NY", "Red Creek"),
  "13146": p("NY", "Savannah"),
  "13154": p("NY", "South Butler"),
  "14413": p("NY", "Alton"),
  "14433": p("NY", "Clyde"),
  "14449": p("NY", "East Williamson"),
  "14489": p("NY", "Lyons"),
  "14502": p("NY", "Macedon"),
  "14505": p("NY", "Marion"),
  "14513": p("NY", "Newark"),
  "14516": p("NY", "North Rose"),
  "14519": p("NY", "Ontario"),
  "14520": p("NY", "Ontario Center"),
  "14522": p("NY", "Palmyra"),
  "14538": p("NY", "Pultneyville"),
  "14542": p("NY", "Rose"),
  "14551": p("NY", "Sodus"),
  "14555": p("NY", "Sodus Point"),
  "14563": p("NY", "Union Hill"),
  "14568": p("NY", "Walworth"),
  "14589": p("NY", "Williamson"),
  "14590": p("NY", "Wolcott"),
  "10501": p("NY", "Amawalk"),
  "10502": p("NY", "Ardsley"),
  "10503": p("NY", "Ardsley On Hudson"),
  "10504": p("NY", "Armonk"),
  "10505": p("NY", "Baldwin Place"),
  "10506": p("NY", "Bedford"),
  "10507": p("NY", "Bedford Hills"),
  "10510": p("NY", "Briarcliff Manor"),
  "10511": p("NY", "Buchanan"),
  "10514": p("NY", "Chappaqua"),
  "10517": p("NY", "Crompond"),
  "10518": p("NY", "Cross River"),
  "10519": p("NY", "Croton Falls"),
  "10520": p("NY", "Croton On Hudson"),
  "10521": p("NY", "Croton On Hudson"),
  "10522": p("NY", "Dobbs Ferry"),
  "10523": p("NY", "Elmsford"),
  "10526": p("NY", "Goldens Bridge"),
  "10527": p("NY", "Granite Springs"),
  "10528": p("NY", "Harrison"),
  "10530": p("NY", "Hartsdale"),
  "10532": p("NY", "Hawthorne"),
  "10533": p("NY", "Irvington"),
  "10535": p("NY", "Jefferson Valley"),
  "10536": p("NY", "Katonah"),
  "10538": p("NY", "Larchmont"),
  "10540": p("NY", "Lincolndale"),
  "10543": p("NY", "Mamaroneck"),
  "10545": p("NY", "Maryknoll"),
  "10546": p("NY", "Millwood"),
  "10547": p("NY", "Mohegan Lake"),
  "10548": p("NY", "Montrose"),
  "10549": p("NY", "Mount Kisco"),
  "10550": p("NY", "Mount Vernon"),
  "10551": p("NY", "Mount Vernon"),
  "10552": p("NY", "Mount Vernon"),
  "10553": p("NY", "Mount Vernon"),
  "10560": p("NY", "North Salem"),
  "10562": p("NY", "Ossining"),
  "10566": p("NY", "Peekskill"),
  "10567": p("NY", "Cortlandt Manor"),
  "10570": p("NY", "Pleasantville"),
  "10573": p("NY", "Port Chester"),
  "10576": p("NY", "Pound Ridge"),
  "10577": p("NY", "Purchase"),
  "10578": p("NY", "Purdys"),
  "10580": p("NY", "Rye"),
  "10583": p("NY", "Scarsdale"),
  "10587": p("NY", "Shenorock"),
  "10588": p("NY", "Shrub Oak"),
  "10589": p("NY", "Somers"),
  "10590": p("NY", "South Salem"),
  "10591": p("NY", "Tarrytown"),
  "10594": p("NY", "Thornwood"),
  "10595": p("NY", "Valhalla"),
  "10596": p("NY", "Verplanck"),
  "10597": p("NY", "Waccabuc"),
  "10598": p("NY", "Yorktown Heights"),
  "10601": p("NY", "White Plains"),
  "10602": p("NY", "White Plains"),
  "10603": p("NY", "White Plains"),
  "10604": p("NY", "West Harrison"),
  "10605": p("NY", "White Plains"),
  "10606": p("NY", "White Plains"),
  "10607": p("NY", "White Plains"),
  "10610": p("NY", "White Plains"),
  "10701": p("NY", "Yonkers"),
  "10702": p("NY", "Yonkers"),
  "10703": p("NY", "Yonkers"),
  "10704": p("NY", "Yonkers"),
  "10705": p("NY", "Yonkers"),
  "10706": p("NY", "Hastings On Hudson"),
  "10707": p("NY", "Tuckahoe"),
  "10708": p("NY", "Bronxville"),
  "10709": p("NY", "Eastchester"),
  "10710": p("NY", "Yonkers"),
  "10801": p("NY", "New Rochelle"),
  "10802": p("NY", "New Rochelle"),
  "10803": p("NY", "Pelham"),
  "10804": p("NY", "New Rochelle"),
  "10805": p("NY", "New Rochelle"),
  "14009": p("NY", "Arcade"),
  "14011": p("NY", "Attica"),
  "14024": p("NY", "Bliss"),
  "14037": p("NY", "Cowlesville"),
  "14039": p("NY", "Dale"),
  "14066": p("NY", "Gainesville"),
  "14082": p("NY", "Java Center"),
  "14083": p("NY", "Java Village"),
  "14113": p("NY", "North Java"),
  "14130": p("NY", "Pike"),
  "14145": p("NY", "Strykersville"),
  "14167": p("NY", "Varysburg"),
  "14427": p("NY", "Castile"),
  "14530": p("NY", "Perry"),
  "14536": p("NY", "Portageville"),
  "14549": p("NY", "Silver Lake"),
  "14550": p("NY", "Silver Springs"),
  "14569": p("NY", "Warsaw"),
  "14591": p("NY", "Wyoming"),
  "14415": p("NY", "Bellona"),
  "14418": p("NY", "Branchport"),
  "14441": p("NY", "Dresden"),
  "14478": p("NY", "Keuka Park"),
  "14507": p("NY", "Middlesex"),
  "14527": p("NY", "Penn Yan"),
  "14544": p("NY", "Rushville"),
  "14837": p("NY", "Dundee"),
  "14842": p("NY", "Himrod"),
  "14857": p("NY", "Lakemont"),
  "14878": p("NY", "Rock Stream"),
  "45105": p("OH", "Bentonville"),
  "45144": p("OH", "Manchester"),
  "45616": p("OH", "Blue Creek"),
  "45618": p("OH", "Cherry Fork"),
  "45650": p("OH", "Lynx"),
  "45660": p("OH", "Peebles"),
  "45679": p("OH", "Seaman"),
  "45693": p("OH", "West Union"),
  "45697": p("OH", "Winchester"),
  "45801": p("OH", "Lima"),
  "45802": p("OH", "Lima"),
  "45804": p("OH", "Lima"),
  "45805": p("OH", "Lima"),
  "45807": p("OH", "Lima"),
  "45808": p("OH", "Beaverdam"),
  "45809": p("OH", "Gomer"),
  "45817": p("OH", "Bluffton"),
  "45820": p("OH", "Cairo"),
  "45833": p("OH", "Delphos"),
  "45850": p("OH", "Harrod"),
  "45854": p("OH", "Lafayette"),
  "45887": p("OH", "Spencerville"),
  "44805": p("OH", "Ashland"),
  "44838": p("OH", "Hayesville"),
  "44840": p("OH", "Jeromesville"),
  "44842": p("OH", "Loudonville"),
  "44848": p("OH", "Nankin"),
  "44859": p("OH", "Nova"),
  "44864": p("OH", "Perrysville"),
  "44866": p("OH", "Polk"),
  "44874": p("OH", "Savannah"),
  "44880": p("OH", "Sullivan"),
  "44003": p("OH", "Andover"),
  "44004": p("OH", "Ashtabula"),
  "44005": p("OH", "Ashtabula"),
  "44010": p("OH", "Austinburg"),
  "44030": p("OH", "Conneaut"),
  "44032": p("OH", "Dorset"),
  "44041": p("OH", "Geneva"),
  "44047": p("OH", "Jefferson"),
  "44048": p("OH", "Kingsville"),
  "44068": p("OH", "North Kingsville"),
  "44076": p("OH", "Orwell"),
  "44082": p("OH", "Pierpont"),
  "44084": p("OH", "Rock Creek"),
  "44085": p("OH", "Rome"),
  "44088": p("OH", "Unionville"),
  "44093": p("OH", "Williamsfield"),
  "44099": p("OH", "Windsor"),
  "45701": p("OH", "Athens"),
  "45710": p("OH", "Albany"),
  "45711": p("OH", "Amesville"),
  "45716": p("OH", "Buchtel"),
  "45717": p("OH", "Carbondale"),
  "45719": p("OH", "Chauncey"),
  "45723": p("OH", "Coolville"),
  "45732": p("OH", "Glouster"),
  "45735": p("OH", "Guysville"),
  "45739": p("OH", "Hockingport"),
  "45740": p("OH", "Jacksonville"),
  "45761": p("OH", "Millfield"),
  "45764": p("OH", "Nelsonville"),
  "45766": p("OH", "New Marshfield"),
  "45776": p("OH", "Shade"),
  "45777": p("OH", "Sharpsburg"),
  "45778": p("OH", "Stewart"),
  "45780": p("OH", "The Plains"),
  "45782": p("OH", "Trimble"),
  "45806": p("OH", "Lima"),
  "45819": p("OH", "Buckland"),
  "45865": p("OH", "Minster"),
  "45869": p("OH", "New Bremen"),
  "45870": p("OH", "New Hampshire"),
  "45871": p("OH", "New Knoxville"),
  "45884": p("OH", "Saint Johns"),
  "45885": p("OH", "Saint Marys"),
  "45888": p("OH", "Uniopolis"),
  "45895": p("OH", "Wapakoneta"),
  "45896": p("OH", "Waynesfield"),
  "43713": p("OH", "Barnesville"),
  "43718": p("OH", "Belmont"),
  "43719": p("OH", "Bethesda"),
  "43759": p("OH", "Morristown"),
  "43902": p("OH", "Alledonia"),
  "43905": p("OH", "Barton"),
  "43906": p("OH", "Bellaire"),
  "43909": p("OH", "Blaine"),
  "43912": p("OH", "Bridgeport"),
  "43916": p("OH", "Colerain"),
  "43927": p("OH", "Fairpoint"),
  "43928": p("OH", "Glencoe"),
  "43933": p("OH", "Jacobsburg"),
  "43934": p("OH", "Lansing"),
  "43935": p("OH", "Martins Ferry"),
  "43937": p("OH", "Maynard"),
  "43940": p("OH", "Neffs"),
  "43942": p("OH", "Powhatan Point"),
  "43947": p("OH", "Shadyside"),
  "43950": p("OH", "Saint Clairsville"),
  "43951": p("OH", "Lafferty"),
  "43967": p("OH", "Warnock"),
  "43972": p("OH", "Bannock"),
  "43977": p("OH", "Flushing"),
  "43983": p("OH", "Piedmont"),
  "43985": p("OH", "Holloway"),
  "45101": p("OH", "Aberdeen"),
  "45115": p("OH", "Decatur"),
  "45118": p("OH", "Fayetteville"),
  "45119": p("OH", "Feesburg"),
  "45121": p("OH", "Georgetown"),
  "45130": p("OH", "Hamersville"),
  "45131": p("OH", "Higginsport"),
  "45154": p("OH", "Mount Orab"),
  "45167": p("OH", "Ripley"),
  "45168": p("OH", "Russellville"),
  "45171": p("OH", "Sardinia"),
  "45275": p("OH", "Cincinnati"),
  "45003": p("OH", "College Corner"),
  "45004": p("OH", "Collinsville"),
  "45011": p("OH", "Hamilton"),
  "45012": p("OH", "Hamilton"),
  "45013": p("OH", "Hamilton"),
  "45014": p("OH", "Fairfield"),
  "45015": p("OH", "Hamilton"),
  "45018": p("OH", "Fairfield"),
  "45042": p("OH", "Middletown"),
  "45044": p("OH", "Middletown"),
  "45050": p("OH", "Monroe"),
  "45053": p("OH", "Okeana"),
  "45055": p("OH", "Overpeck"),
  "45056": p("OH", "Oxford"),
  "45061": p("OH", "Ross"),
  "45062": p("OH", "Seven Mile"),
  "45063": p("OH", "Shandon"),
  "45064": p("OH", "Somerville"),
  "45067": p("OH", "Trenton"),
  "45069": p("OH", "West Chester"),
  "45071": p("OH", "West Chester"),
  "44607": p("OH", "Augusta"),
  "44615": p("OH", "Carrollton"),
  "44620": p("OH", "Dellroy"),
  "44639": p("OH", "Leesville"),
  "44644": p("OH", "Malvern"),
  "44651": p("OH", "Mechanicstown"),
  "44675": p("OH", "Sherrodsville"),
  "43009": p("OH", "Cable"),
  "43044": p("OH", "Mechanicsburg"),
  "43047": p("OH", "Mingo"),
  "43060": p("OH", "North Lewisburg"),
  "43070": p("OH", "Rosewood"),
  "43072": p("OH", "Saint Paris"),
  "43078": p("OH", "Urbana"),
  "43083": p("OH", "Westville"),
  "43084": p("OH", "Woodstock"),
  "45389": p("OH", "Christiansburg"),
  "43010": p("OH", "Catawba"),
  "45319": p("OH", "Donnelsville"),
  "45323": p("OH", "Enon"),
  "45341": p("OH", "Medway"),
  "45344": p("OH", "New Carlisle"),
  "45349": p("OH", "North Hampton"),
  "45368": p("OH", "South Charleston"),
  "45369": p("OH", "South Vienna"),
  "45372": p("OH", "Tremont City"),
  "45501": p("OH", "Springfield"),
  "45502": p("OH", "Springfield"),
  "45503": p("OH", "Springfield"),
  "45504": p("OH", "Springfield"),
  "45505": p("OH", "Springfield"),
  "45506": p("OH", "Springfield"),
  "45102": p("OH", "Amelia"),
  "45103": p("OH", "Batavia"),
  "45106": p("OH", "Bethel"),
  "45112": p("OH", "Chilo"),
  "45120": p("OH", "Felicity"),
  "45122": p("OH", "Goshen"),
  "45140": p("OH", "Loveland"),
  "45147": p("OH", "Miamiville"),
  "45150": p("OH", "Milford"),
  "45153": p("OH", "Moscow"),
  "45156": p("OH", "Neville"),
  "45157": p("OH", "New Richmond"),
  "45158": p("OH", "Newtonsville"),
  "45160": p("OH", "Owensville"),
  "45176": p("OH", "Williamsburg"),
  "45245": p("OH", "Cincinnati"),
  "45107": p("OH", "Blanchester"),
  "45113": p("OH", "Clarksville"),
  "45114": p("OH", "Cuba"),
  "45146": p("OH", "Martinsville"),
  "45148": p("OH", "Midland"),
  "45159": p("OH", "New Vienna"),
  "45164": p("OH", "Port William"),
  "45166": p("OH", "Reesville"),
  "45169": p("OH", "Sabina"),
  "45177": p("OH", "Wilmington"),
  "43920": p("OH", "East Liverpool"),
  "43945": p("OH", "Salineville"),
  "43962": p("OH", "Summitville"),
  "43968": p("OH", "Wellsville"),
  "44408": p("OH", "Columbiana"),
  "44413": p("OH", "East Palestine"),
  "44415": p("OH", "Elkton"),
  "44423": p("OH", "Hanoverton"),
  "44427": p("OH", "Kensington"),
  "44431": p("OH", "Leetonia"),
  "44432": p("OH", "Lisbon"),
  "44441": p("OH", "Negley"),
  "44445": p("OH", "New Waterford"),
  "44455": p("OH", "Rogers"),
  "44460": p("OH", "Salem"),
  "44490": p("OH", "Washingtonville"),
  "44492": p("OH", "West Point"),
  "44493": p("OH", "Winona"),
  "44625": p("OH", "East Rochester"),
  "44634": p("OH", "Homeworth"),
  "44665": p("OH", "North Georgetown"),
  "43803": p("OH", "Bakersville"),
  "43805": p("OH", "Blissfield"),
  "43811": p("OH", "Conesville"),
  "43812": p("OH", "Coshocton"),
  "43824": p("OH", "Fresno"),
  "43828": p("OH", "Keene"),
  "43836": p("OH", "Plainfield"),
  "43843": p("OH", "Walhonding"),
  "43844": p("OH", "Warsaw"),
  "43845": p("OH", "West Lafayette"),
  "44820": p("OH", "Bucyrus"),
  "44825": p("OH", "Chatfield"),
  "44827": p("OH", "Crestline"),
  "44833": p("OH", "Galion"),
  "44854": p("OH", "New Washington"),
  "44856": p("OH", "North Robinson"),
  "44860": p("OH", "Oceola"),
  "44881": p("OH", "Sulphur Springs"),
  "44887": p("OH", "Tiro"),
  "44017": p("OH", "Berea"),
  "44022": p("OH", "Chagrin Falls"),
  "44040": p("OH", "Gates Mills"),
  "44070": p("OH", "North Olmsted"),
  "44101": p("OH", "Cleveland"),
  "44102": p("OH", "Cleveland"),
  "44103": p("OH", "Cleveland"),
  "44104": p("OH", "Cleveland"),
  "44105": p("OH", "Cleveland"),
  "44106": p("OH", "Cleveland"),
  "44107": p("OH", "Lakewood"),
  "44108": p("OH", "Cleveland"),
  "44109": p("OH", "Cleveland"),
  "44110": p("OH", "Cleveland"),
  "44111": p("OH", "Cleveland"),
  "44112": p("OH", "Cleveland"),
  "44113": p("OH", "Cleveland"),
  "44114": p("OH", "Cleveland"),
  "44115": p("OH", "Cleveland"),
  "44116": p("OH", "Rocky River"),
  "44117": p("OH", "Euclid"),
  "44118": p("OH", "Cleveland"),
  "44119": p("OH", "Cleveland"),
  "44120": p("OH", "Cleveland"),
  "44121": p("OH", "Cleveland"),
  "44122": p("OH", "Beachwood"),
  "44123": p("OH", "Euclid"),
  "44124": p("OH", "Cleveland"),
  "44125": p("OH", "Cleveland"),
  "44126": p("OH", "Cleveland"),
  "44127": p("OH", "Cleveland"),
  "44128": p("OH", "Cleveland"),
  "44129": p("OH", "Cleveland"),
  "44130": p("OH", "Cleveland"),
  "44131": p("OH", "Independence"),
  "44132": p("OH", "Euclid"),
  "44133": p("OH", "North Royalton"),
  "44134": p("OH", "Cleveland"),
  "44135": p("OH", "Cleveland"),
  "44136": p("OH", "Strongsville"),
  "44137": p("OH", "Maple Heights"),
  "44138": p("OH", "Olmsted Falls"),
  "44139": p("OH", "Solon"),
  "44140": p("OH", "Bay Village"),
  "44141": p("OH", "Brecksville"),
  "44142": p("OH", "Brookpark"),
  "44143": p("OH", "Cleveland"),
  "44144": p("OH", "Cleveland"),
  "44145": p("OH", "Westlake"),
  "44146": p("OH", "Bedford"),
  "44147": p("OH", "Broadview Heights"),
  "44181": p("OH", "Cleveland"),
  "44188": p("OH", "Cleveland"),
  "44190": p("OH", "Cleveland"),
  "44191": p("OH", "Cleveland"),
  "44192": p("OH", "Cleveland"),
  "44193": p("OH", "Cleveland"),
  "44194": p("OH", "Cleveland"),
  "44195": p("OH", "Cleveland"),
  "44197": p("OH", "Cleveland"),
  "44198": p("OH", "Cleveland"),
  "44199": p("OH", "Cleveland"),
  "45303": p("OH", "Ansonia"),
  "45304": p("OH", "Arcanum"),
  "45328": p("OH", "Gettysburg"),
  "45331": p("OH", "Greenville"),
  "45332": p("OH", "Hollansburg"),
  "45346": p("OH", "New Madison"),
  "45348": p("OH", "New Weston"),
  "45350": p("OH", "North Star"),
  "45351": p("OH", "Osgood"),
  "45352": p("OH", "Palestine"),
  "45358": p("OH", "Pitsburg"),
  "45362": p("OH", "Rossburg"),
  "45380": p("OH", "Versailles"),
  "45388": p("OH", "Yorkshire"),
  "45390": p("OH", "Union City"),
  "43512": p("OH", "Defiance"),
  "43519": p("OH", "Evansport"),
  "43520": p("OH", "Farmer"),
  "43526": p("OH", "Hicksville"),
  "43530": p("OH", "Jewell"),
  "43536": p("OH", "Mark Center"),
  "43549": p("OH", "Ney"),
  "43556": p("OH", "Sherwood"),
  "43003": p("OH", "Ashley"),
  "43015": p("OH", "Delaware"),
  "43021": p("OH", "Galena"),
  "43032": p("OH", "Kilbourne"),
  "43035": p("OH", "Lewis Center"),
  "43061": p("OH", "Ostrander"),
  "43065": p("OH", "Powell"),
  "43066": p("OH", "Radnor"),
  "43074": p("OH", "Sunbury"),
  "43082": p("OH", "Westerville"),
  "43438": p("OH", "Kelleys Island"),
  "44089": p("OH", "Vermilion"),
  "44814": p("OH", "Berlin Heights"),
  "44816": p("OH", "Birmingham"),
  "44824": p("OH", "Castalia"),
  "44839": p("OH", "Huron"),
  "44846": p("OH", "Milan"),
  "44870": p("OH", "Sandusky"),
  "44871": p("OH", "Sandusky"),
  "43046": p("OH", "Millersport"),
  "43102": p("OH", "Amanda"),
  "43105": p("OH", "Baltimore"),
  "43107": p("OH", "Bremen"),
  "43110": p("OH", "Canal Winchester"),
  "43112": p("OH", "Carroll"),
  "43130": p("OH", "Lancaster"),
  "43136": p("OH", "Lithopolis"),
  "43147": p("OH", "Pickerington"),
  "43148": p("OH", "Pleasantville"),
  "43150": p("OH", "Rushville"),
  "43154": p("OH", "Stoutsville"),
  "43155": p("OH", "Sugar Grove"),
  "43157": p("OH", "Thurston"),
  "43106": p("OH", "Bloomingburg"),
  "43128": p("OH", "Jeffersonville"),
  "43142": p("OH", "Milledgeville"),
  "43160": p("OH", "Washington Court House"),
  "43002": p("OH", "Amlin"),
  "43004": p("OH", "Blacklick"),
  "43016": p("OH", "Dublin"),
  "43017": p("OH", "Dublin"),
  "43026": p("OH", "Hilliard"),
  "43054": p("OH", "New Albany"),
  "43068": p("OH", "Reynoldsburg"),
  "43069": p("OH", "Reynoldsburg"),
  "43081": p("OH", "Westerville"),
  "43085": p("OH", "Columbus"),
  "43086": p("OH", "Westerville"),
  "43109": p("OH", "Brice"),
  "43119": p("OH", "Galloway"),
  "43123": p("OH", "Grove City"),
  "43125": p("OH", "Groveport"),
  "43126": p("OH", "Harrisburg"),
  "43194": p("OH", "Lockbourne"),
  "43195": p("OH", "Groveport"),
  "43199": p("OH", "Groveport"),
  "43201": p("OH", "Columbus"),
  "43202": p("OH", "Columbus"),
  "43203": p("OH", "Columbus"),
  "43204": p("OH", "Columbus"),
  "43205": p("OH", "Columbus"),
  "43206": p("OH", "Columbus"),
  "43207": p("OH", "Columbus"),
  "43209": p("OH", "Columbus"),
  "43210": p("OH", "Columbus"),
  "43211": p("OH", "Columbus"),
  "43212": p("OH", "Columbus"),
  "43213": p("OH", "Columbus"),
  "43214": p("OH", "Columbus"),
  "43215": p("OH", "Columbus"),
  "43216": p("OH", "Columbus"),
  "43217": p("OH", "Columbus"),
  "43218": p("OH", "Columbus"),
  "43219": p("OH", "Columbus"),
  "43220": p("OH", "Columbus"),
  "43221": p("OH", "Columbus"),
  "43222": p("OH", "Columbus"),
  "43223": p("OH", "Columbus"),
  "43224": p("OH", "Columbus"),
  "43226": p("OH", "Columbus"),
  "43227": p("OH", "Columbus"),
  "43228": p("OH", "Columbus"),
  "43229": p("OH", "Columbus"),
  "43230": p("OH", "Columbus"),
  "43231": p("OH", "Columbus"),
  "43232": p("OH", "Columbus"),
  "43234": p("OH", "Columbus"),
  "43235": p("OH", "Columbus"),
  "43236": p("OH", "Columbus"),
  "43240": p("OH", "Columbus"),
  "43251": p("OH", "Columbus"),
  "43260": p("OH", "Columbus"),
  "43266": p("OH", "Columbus"),
  "43268": p("OH", "Columbus"),
  "43270": p("OH", "Columbus"),
  "43271": p("OH", "Columbus"),
  "43272": p("OH", "Columbus"),
  "43279": p("OH", "Columbus"),
  "43287": p("OH", "Columbus"),
  "43291": p("OH", "Columbus"),
  "43502": p("OH", "Archbold"),
  "43515": p("OH", "Delta"),
  "43521": p("OH", "Fayette"),
  "43533": p("OH", "Lyons"),
  "43540": p("OH", "Metamora"),
  "43553": p("OH", "Pettisville"),
  "43558": p("OH", "Swanton"),
  "43567": p("OH", "Wauseon"),
  "45614": p("OH", "Bidwell"),
  "45620": p("OH", "Cheshire"),
  "45623": p("OH", "Crown City"),
  "45631": p("OH", "Gallipolis"),
  "45643": p("OH", "Kerr"),
  "45658": p("OH", "Patriot"),
  "45674": p("OH", "Rio Grande"),
  "45685": p("OH", "Thurman"),
  "45686": p("OH", "Vinton"),
  "44021": p("OH", "Burton"),
  "44023": p("OH", "Chagrin Falls"),
  "44024": p("OH", "Chardon"),
  "44026": p("OH", "Chesterland"),
  "44033": p("OH", "East Claridon"),
  "44046": p("OH", "Huntsburg"),
  "44062": p("OH", "Middlefield"),
  "44064": p("OH", "Montville"),
  "44065": p("OH", "Newbury"),
  "44072": p("OH", "Novelty"),
  "44073": p("OH", "Novelty"),
  "44080": p("OH", "Parkman"),
  "44086": p("OH", "Thompson"),
  "45301": p("OH", "Alpha"),
  "45305": p("OH", "Bellbrook"),
  "45307": p("OH", "Bowersville"),
  "45314": p("OH", "Cedarville"),
  "45316": p("OH", "Clifton"),
  "45324": p("OH", "Fairborn"),
  "45335": p("OH", "Jamestown"),
  "45370": p("OH", "Spring Valley"),
  "45384": p("OH", "Wilberforce"),
  "45385": p("OH", "Xenia"),
  "45387": p("OH", "Yellow Springs"),
  "45431": p("OH", "Dayton"),
  "45433": p("OH", "Dayton"),
  "43722": p("OH", "Buffalo"),
  "43723": p("OH", "Byesville"),
  "43725": p("OH", "Cambridge"),
  "43732": p("OH", "Cumberland"),
  "43733": p("OH", "Derwent"),
  "43736": p("OH", "Fairview"),
  "43749": p("OH", "Kimbolton"),
  "43750": p("OH", "Kipling"),
  "43755": p("OH", "Lore City"),
  "43768": p("OH", "Old Washington"),
  "43772": p("OH", "Pleasant City"),
  "43773": p("OH", "Quaker City"),
  "43778": p("OH", "Salesville"),
  "43780": p("OH", "Senecaville"),
  "45001": p("OH", "Addyston"),
  "45002": p("OH", "Cleves"),
  "45030": p("OH", "Harrison"),
  "45033": p("OH", "Hooven"),
  "45041": p("OH", "Miamitown"),
  "45051": p("OH", "Mount Saint Joseph"),
  "45052": p("OH", "North Bend"),
  "45111": p("OH", "Camp Dennison"),
  "45174": p("OH", "Terrace Park"),
  "45201": p("OH", "Cincinnati"),
  "45202": p("OH", "Cincinnati"),
  "45203": p("OH", "Cincinnati"),
  "45204": p("OH", "Cincinnati"),
  "45205": p("OH", "Cincinnati"),
  "45206": p("OH", "Cincinnati"),
  "45207": p("OH", "Cincinnati"),
  "45208": p("OH", "Cincinnati"),
  "45209": p("OH", "Cincinnati"),
  "45211": p("OH", "Cincinnati"),
  "45212": p("OH", "Cincinnati"),
  "45213": p("OH", "Cincinnati"),
  "45214": p("OH", "Cincinnati"),
  "45215": p("OH", "Cincinnati"),
  "45216": p("OH", "Cincinnati"),
  "45217": p("OH", "Cincinnati"),
  "45218": p("OH", "Cincinnati"),
  "45219": p("OH", "Cincinnati"),
  "45220": p("OH", "Cincinnati"),
  "45221": p("OH", "Cincinnati"),
  "45222": p("OH", "Cincinnati"),
  "45223": p("OH", "Cincinnati"),
  "45224": p("OH", "Cincinnati"),
  "45225": p("OH", "Cincinnati"),
  "45226": p("OH", "Cincinnati"),
  "45227": p("OH", "Cincinnati"),
  "45229": p("OH", "Cincinnati"),
  "45230": p("OH", "Cincinnati"),
  "45231": p("OH", "Cincinnati"),
  "45232": p("OH", "Cincinnati"),
  "45233": p("OH", "Cincinnati"),
  "45234": p("OH", "Cincinnati"),
  "45235": p("OH", "Cincinnati"),
  "45236": p("OH", "Cincinnati"),
  "45237": p("OH", "Cincinnati"),
  "45238": p("OH", "Cincinnati"),
  "45239": p("OH", "Cincinnati"),
  "45240": p("OH", "Cincinnati"),
  "45241": p("OH", "Cincinnati"),
  "45242": p("OH", "Cincinnati"),
  "45243": p("OH", "Cincinnati"),
  "45244": p("OH", "Cincinnati"),
  "45246": p("OH", "Cincinnati"),
  "45247": p("OH", "Cincinnati"),
  "45248": p("OH", "Cincinnati"),
  "45249": p("OH", "Cincinnati"),
  "45250": p("OH", "Cincinnati"),
  "45251": p("OH", "Cincinnati"),
  "45252": p("OH", "Cincinnati"),
  "45253": p("OH", "Cincinnati"),
  "45254": p("OH", "Cincinnati"),
  "45255": p("OH", "Cincinnati"),
  "45258": p("OH", "Cincinnati"),
  "45262": p("OH", "Cincinnati"),
  "45263": p("OH", "Cincinnati"),
  "45264": p("OH", "Cincinnati"),
  "45267": p("OH", "Cincinnati"),
  "45268": p("OH", "Cincinnati"),
  "45269": p("OH", "Cincinnati"),
  "45270": p("OH", "Cincinnati"),
  "45271": p("OH", "Cincinnati"),
  "45273": p("OH", "Cincinnati"),
  "45274": p("OH", "Cincinnati"),
  "45277": p("OH", "Cincinnati"),
  "45280": p("OH", "Cincinnati"),
  "45296": p("OH", "Cincinnati"),
  "45298": p("OH", "Cincinnati"),
  "45299": p("OH", "Cincinnati"),
  "45999": p("OH", "Cincinnati"),
  "44804": p("OH", "Arcadia"),
  "45814": p("OH", "Arlington"),
  "45816": p("OH", "Benton Ridge"),
  "45839": p("OH", "Findlay"),
  "45840": p("OH", "Findlay"),
  "45841": p("OH", "Jenera"),
  "45858": p("OH", "Mc Comb"),
  "45867": p("OH", "Mount Blanchard"),
  "45868": p("OH", "Mount Cory"),
  "45881": p("OH", "Rawson"),
  "45889": p("OH", "Van Buren"),
  "45890": p("OH", "Vanlue"),
  "45897": p("OH", "Williamstown"),
  "43326": p("OH", "Kenton"),
  "43340": p("OH", "Mount Victory"),
  "43345": p("OH", "Ridgeway"),
  "43346": p("OH", "Roundhead"),
  "45810": p("OH", "Ada"),
  "45812": p("OH", "Alger"),
  "45835": p("OH", "Dola"),
  "45836": p("OH", "Dunkirk"),
  "45843": p("OH", "Forest"),
  "45859": p("OH", "Mc Guffey"),
  "43907": p("OH", "Cadiz"),
  "43973": p("OH", "Freeport"),
  "43974": p("OH", "Harrisville"),
  "43976": p("OH", "Hopedale"),
  "43981": p("OH", "New Athens"),
  "43984": p("OH", "New Rumley"),
  "43986": p("OH", "Jewett"),
  "43988": p("OH", "Scio"),
  "44693": p("OH", "Deersville"),
  "44695": p("OH", "Bowerston"),
  "44699": p("OH", "Tippecanoe"),
  "43510": p("OH", "Colton"),
  "43516": p("OH", "Deshler"),
  "43523": p("OH", "Grelton"),
  "43524": p("OH", "Hamler"),
  "43527": p("OH", "Holgate"),
  "43532": p("OH", "Liberty Center"),
  "43534": p("OH", "Mc Clure"),
  "43535": p("OH", "Malinta"),
  "43545": p("OH", "Napoleon"),
  "43548": p("OH", "New Bavaria"),
  "43550": p("OH", "Okolona"),
  "43555": p("OH", "Ridgeville Corners"),
  "45123": p("OH", "Greenfield"),
  "45132": p("OH", "Highland"),
  "45133": p("OH", "Hillsboro"),
  "45135": p("OH", "Leesburg"),
  "45142": p("OH", "Lynchburg"),
  "45155": p("OH", "Mowrystown"),
  "45172": p("OH", "Sinking Spring"),
  "43111": p("OH", "Carbon Hill"),
  "43127": p("OH", "Haydenville"),
  "43135": p("OH", "Laurelville"),
  "43138": p("OH", "Logan"),
  "43144": p("OH", "Murray City"),
  "43149": p("OH", "Rockbridge"),
  "43152": p("OH", "South Bloomingville"),
  "43158": p("OH", "Union Furnace"),
  "44610": p("OH", "Berlin"),
  "44611": p("OH", "Big Prairie"),
  "44617": p("OH", "Charm"),
  "44628": p("OH", "Glenmont"),
  "44633": p("OH", "Holmesville"),
  "44637": p("OH", "Killbuck"),
  "44638": p("OH", "Lakeville"),
  "44654": p("OH", "Millersburg"),
  "44660": p("OH", "Mount Hope"),
  "44661": p("OH", "Nashville"),
  "44687": p("OH", "Walnut Creek"),
  "44690": p("OH", "Winesburg"),
  "44811": p("OH", "Bellevue"),
  "44826": p("OH", "Collins"),
  "44837": p("OH", "Greenwich"),
  "44847": p("OH", "Monroeville"),
  "44850": p("OH", "New Haven"),
  "44851": p("OH", "New London"),
  "44855": p("OH", "North Fairfield"),
  "44857": p("OH", "Norwalk"),
  "44888": p("OH", "Willard"),
  "44889": p("OH", "Wakeman"),
  "44890": p("OH", "Willard"),
  "45621": p("OH", "Coalton"),
  "45640": p("OH", "Jackson"),
  "45656": p("OH", "Oak Hill"),
  "45692": p("OH", "Wellston"),
  "43901": p("OH", "Adena"),
  "43903": p("OH", "Amsterdam"),
  "43908": p("OH", "Bergholz"),
  "43910": p("OH", "Bloomingdale"),
  "43913": p("OH", "Brilliant"),
  "43917": p("OH", "Dillonvale"),
  "43925": p("OH", "East Springfield"),
  "43926": p("OH", "Empire"),
  "43930": p("OH", "Hammondsville"),
  "43932": p("OH", "Irondale"),
  "43938": p("OH", "Mingo Junction"),
  "43939": p("OH", "Mount Pleasant"),
  "43941": p("OH", "Piney Fork"),
  "43943": p("OH", "Rayland"),
  "43944": p("OH", "Richmond"),
  "43948": p("OH", "Smithfield"),
  "43952": p("OH", "Steubenville"),
  "43953": p("OH", "Steubenville"),
  "43961": p("OH", "Stratton"),
  "43963": p("OH", "Tiltonsville"),
  "43964": p("OH", "Toronto"),
  "43970": p("OH", "Wolf Run"),
  "43971": p("OH", "Yorkville"),
  "43005": p("OH", "Bladensburg"),
  "43006": p("OH", "Brinkhaven"),
  "43011": p("OH", "Centerburg"),
  "43014": p("OH", "Danville"),
  "43019": p("OH", "Fredericktown"),
  "43022": p("OH", "Gambier"),
  "43028": p("OH", "Howard"),
  "43037": p("OH", "Martinsburg"),
  "43048": p("OH", "Mount Liberty"),
  "43050": p("OH", "Mount Vernon"),
  "44045": p("OH", "Grand River"),
  "44057": p("OH", "Madison"),
  "44060": p("OH", "Mentor"),
  "44061": p("OH", "Mentor"),
  "44077": p("OH", "Painesville"),
  "44081": p("OH", "Perry"),
  "44092": p("OH", "Wickliffe"),
  "44094": p("OH", "Willoughby"),
  "44095": p("OH", "Eastlake"),
  "44096": p("OH", "Willoughby"),
  "44097": p("OH", "Eastlake"),
  "45619": p("OH", "Chesapeake"),
  "45638": p("OH", "Ironton"),
  "45645": p("OH", "Kitts Hill"),
  "45659": p("OH", "Pedro"),
  "45669": p("OH", "Proctorville"),
  "45675": p("OH", "Rock Camp"),
  "45678": p("OH", "Scottown"),
  "45680": p("OH", "South Point"),
  "45688": p("OH", "Waterloo"),
  "45696": p("OH", "Willow Wood"),
  "43001": p("OH", "Alexandria"),
  "43008": p("OH", "Buckeye Lake"),
  "43013": p("OH", "Croton"),
  "43018": p("OH", "Etna"),
  "43023": p("OH", "Granville"),
  "43025": p("OH", "Hebron"),
  "43027": p("OH", "Homer"),
  "43030": p("OH", "Jacksontown"),
  "43031": p("OH", "Johnstown"),
  "43033": p("OH", "Kirkersville"),
  "43055": p("OH", "Newark"),
  "43056": p("OH", "Heath"),
  "43058": p("OH", "Newark"),
  "43062": p("OH", "Pataskala"),
  "43071": p("OH", "Saint Louisville"),
  "43073": p("OH", "Summit Station"),
  "43080": p("OH", "Utica"),
  "43093": p("OH", "Newark"),
  "43721": p("OH", "Brownsville"),
  "43740": p("OH", "Gratiot"),
  "43310": p("OH", "Belle Center"),
  "43311": p("OH", "Bellefontaine"),
  "43318": p("OH", "De Graff"),
  "43319": p("OH", "East Liberty"),
  "43324": p("OH", "Huntsville"),
  "43331": p("OH", "Lakeview"),
  "43333": p("OH", "Lewistown"),
  "43336": p("OH", "Middleburg"),
  "43343": p("OH", "Quincy"),
  "43347": p("OH", "Rushsylvania"),
  "43348": p("OH", "Russells Point"),
  "43357": p("OH", "West Liberty"),
  "43358": p("OH", "West Mansfield"),
  "43360": p("OH", "Zanesfield"),
  "44001": p("OH", "Amherst"),
  "44011": p("OH", "Avon"),
  "44012": p("OH", "Avon Lake"),
  "44028": p("OH", "Columbia Station"),
  "44035": p("OH", "Elyria"),
  "44036": p("OH", "Elyria"),
  "44039": p("OH", "North Ridgeville"),
  "44044": p("OH", "Grafton"),
  "44049": p("OH", "Kipton"),
  "44050": p("OH", "Lagrange"),
  "44052": p("OH", "Lorain"),
  "44053": p("OH", "Lorain"),
  "44054": p("OH", "Sheffield Lake"),
  "44055": p("OH", "Lorain"),
  "44074": p("OH", "Oberlin"),
  "44090": p("OH", "Wellington"),
  "43434": p("OH", "Harbor View"),
  "43504": p("OH", "Berkey"),
  "43528": p("OH", "Holland"),
  "43537": p("OH", "Maumee"),
  "43542": p("OH", "Monclova"),
  "43547": p("OH", "Neapolis"),
  "43560": p("OH", "Sylvania"),
  "43566": p("OH", "Waterville"),
  "43571": p("OH", "Whitehouse"),
  "43601": p("OH", "Toledo"),
  "43603": p("OH", "Toledo"),
  "43604": p("OH", "Toledo"),
  "43605": p("OH", "Toledo"),
  "43606": p("OH", "Toledo"),
  "43607": p("OH", "Toledo"),
  "43608": p("OH", "Toledo"),
  "43609": p("OH", "Toledo"),
  "43610": p("OH", "Toledo"),
  "43611": p("OH", "Toledo"),
  "43612": p("OH", "Toledo"),
  "43613": p("OH", "Toledo"),
  "43614": p("OH", "Toledo"),
  "43615": p("OH", "Toledo"),
  "43616": p("OH", "Oregon"),
  "43617": p("OH", "Toledo"),
  "43620": p("OH", "Toledo"),
  "43623": p("OH", "Toledo"),
  "43635": p("OH", "Toledo"),
  "43652": p("OH", "Toledo"),
  "43654": p("OH", "Toledo"),
  "43656": p("OH", "Toledo"),
  "43657": p("OH", "Toledo"),
  "43659": p("OH", "Toledo"),
  "43660": p("OH", "Toledo"),
  "43661": p("OH", "Toledo"),
  "43666": p("OH", "Toledo"),
  "43667": p("OH", "Toledo"),
  "43681": p("OH", "Toledo"),
  "43682": p("OH", "Toledo"),
  "43697": p("OH", "Toledo"),
  "43699": p("OH", "Toledo"),
  "43064": p("OH", "Plain City"),
  "43140": p("OH", "London"),
  "43143": p("OH", "Mount Sterling"),
  "43151": p("OH", "Sedalia"),
  "43153": p("OH", "South Solon"),
  "43162": p("OH", "West Jefferson"),
  "44401": p("OH", "Berlin Center"),
  "44405": p("OH", "Campbell"),
  "44406": p("OH", "Canfield"),
  "44416": p("OH", "Ellsworth"),
  "44422": p("OH", "Greenford"),
  "44429": p("OH", "Lake Milton"),
  "44436": p("OH", "Lowellville"),
  "44442": p("OH", "New Middletown"),
  "44443": p("OH", "New Springfield"),
  "44449": p("OH", "North Benton"),
  "44451": p("OH", "North Jackson"),
  "44452": p("OH", "North Lima"),
  "44454": p("OH", "Petersburg"),
  "44471": p("OH", "Struthers"),
  "44501": p("OH", "Youngstown"),
  "44502": p("OH", "Youngstown"),
  "44503": p("OH", "Youngstown"),
  "44504": p("OH", "Youngstown"),
  "44505": p("OH", "Youngstown"),
  "44506": p("OH", "Youngstown"),
  "44507": p("OH", "Youngstown"),
  "44509": p("OH", "Youngstown"),
  "44510": p("OH", "Youngstown"),
  "44511": p("OH", "Youngstown"),
  "44512": p("OH", "Youngstown"),
  "44513": p("OH", "Youngstown"),
  "44514": p("OH", "Youngstown"),
  "44515": p("OH", "Youngstown"),
  "44555": p("OH", "Youngstown"),
  "44609": p("OH", "Beloit"),
  "44619": p("OH", "Damascus"),
  "44672": p("OH", "Sebring"),
  "43301": p("OH", "Marion"),
  "43302": p("OH", "Marion"),
  "43314": p("OH", "Caledonia"),
  "43322": p("OH", "Green Camp"),
  "43332": p("OH", "La Rue"),
  "43335": p("OH", "Martel"),
  "43337": p("OH", "Morral"),
  "43341": p("OH", "New Bloomington"),
  "43342": p("OH", "Prospect"),
  "43356": p("OH", "Waldo"),
  "44149": p("OH", "Strongsville"),
  "44212": p("OH", "Brunswick"),
  "44215": p("OH", "Chippewa Lake"),
  "44233": p("OH", "Hinckley"),
  "44235": p("OH", "Homerville"),
  "44251": p("OH", "Westfield Center"),
  "44253": p("OH", "Litchfield"),
  "44254": p("OH", "Lodi"),
  "44256": p("OH", "Medina"),
  "44258": p("OH", "Medina"),
  "44273": p("OH", "Seville"),
  "44274": p("OH", "Sharon Center"),
  "44275": p("OH", "Spencer"),
  "44280": p("OH", "Valley City"),
  "44281": p("OH", "Wadsworth"),
  "44282": p("OH", "Wadsworth"),
  "45720": p("OH", "Chester"),
  "45741": p("OH", "Langsville"),
  "45743": p("OH", "Long Bottom"),
  "45760": p("OH", "Middleport"),
  "45769": p("OH", "Pomeroy"),
  "45770": p("OH", "Portland"),
  "45771": p("OH", "Racine"),
  "45772": p("OH", "Reedsville"),
  "45775": p("OH", "Rutland"),
  "45779": p("OH", "Syracuse"),
  "45783": p("OH", "Tuppers Plains"),
  "45310": p("OH", "Burkettsville"),
  "45822": p("OH", "Celina"),
  "45826": p("OH", "Chickasaw"),
  "45828": p("OH", "Coldwater"),
  "45846": p("OH", "Fort Recovery"),
  "45860": p("OH", "Maria Stein"),
  "45862": p("OH", "Mendon"),
  "45866": p("OH", "Montezuma"),
  "45882": p("OH", "Rockford"),
  "45883": p("OH", "Saint Henry"),
  "45308": p("OH", "Bradford"),
  "45312": p("OH", "Casstown"),
  "45317": p("OH", "Conover"),
  "45318": p("OH", "Covington"),
  "45326": p("OH", "Fletcher"),
  "45337": p("OH", "Laura"),
  "45339": p("OH", "Ludlow Falls"),
  "45356": p("OH", "Piqua"),
  "45359": p("OH", "Pleasant Hill"),
  "45361": p("OH", "Potsdam"),
  "45371": p("OH", "Tipp City"),
  "45373": p("OH", "Troy"),
  "45374": p("OH", "Troy"),
  "45383": p("OH", "West Milton"),
  "43716": p("OH", "Beallsville"),
  "43747": p("OH", "Jerusalem"),
  "43752": p("OH", "Laings"),
  "43754": p("OH", "Lewisville"),
  "43757": p("OH", "Malaga"),
  "43786": p("OH", "Stafford"),
  "43793": p("OH", "Woodsfield"),
  "43914": p("OH", "Cameron"),
  "43915": p("OH", "Clarington"),
  "43931": p("OH", "Hannibal"),
  "43946": p("OH", "Sardis"),
  "45734": p("OH", "Graysville"),
  "45309": p("OH", "Brookville"),
  "45315": p("OH", "Clayton"),
  "45322": p("OH", "Englewood"),
  "45325": p("OH", "Farmersville"),
  "45327": p("OH", "Germantown"),
  "45342": p("OH", "Miamisburg"),
  "45343": p("OH", "Miamisburg"),
  "45345": p("OH", "New Lebanon"),
  "45354": p("OH", "Phillipsburg"),
  "45377": p("OH", "Vandalia"),
  "45401": p("OH", "Dayton"),
  "45402": p("OH", "Dayton"),
  "45403": p("OH", "Dayton"),
  "45404": p("OH", "Dayton"),
  "45405": p("OH", "Dayton"),
  "45406": p("OH", "Dayton"),
  "45409": p("OH", "Dayton"),
  "45410": p("OH", "Dayton"),
  "45412": p("OH", "Dayton"),
  "45413": p("OH", "Dayton"),
  "45414": p("OH", "Dayton"),
  "45415": p("OH", "Dayton"),
  "45416": p("OH", "Dayton"),
  "45417": p("OH", "Dayton"),
  "45419": p("OH", "Dayton"),
  "45420": p("OH", "Dayton"),
  "45422": p("OH", "Dayton"),
  "45423": p("OH", "Dayton"),
  "45424": p("OH", "Dayton"),
  "45426": p("OH", "Dayton"),
  "45428": p("OH", "Dayton"),
  "45429": p("OH", "Dayton"),
  "45430": p("OH", "Dayton"),
  "45432": p("OH", "Dayton"),
  "45434": p("OH", "Dayton"),
  "45435": p("OH", "Dayton"),
  "45437": p("OH", "Dayton"),
  "45439": p("OH", "Dayton"),
  "45440": p("OH", "Dayton"),
  "45441": p("OH", "Dayton"),
  "45448": p("OH", "Dayton"),
  "45449": p("OH", "Dayton"),
  "45458": p("OH", "Dayton"),
  "45459": p("OH", "Dayton"),
  "45469": p("OH", "Dayton"),
  "45470": p("OH", "Dayton"),
  "45475": p("OH", "Dayton"),
  "45479": p("OH", "Dayton"),
  "45481": p("OH", "Dayton"),
  "45482": p("OH", "Dayton"),
  "45490": p("OH", "Dayton"),
  "43728": p("OH", "Chesterhill"),
  "43756": p("OH", "Mcconnelsville"),
  "43758": p("OH", "Malta"),
  "43787": p("OH", "Stockport"),
  "43315": p("OH", "Cardington"),
  "43317": p("OH", "Chesterville"),
  "43320": p("OH", "Edison"),
  "43321": p("OH", "Fulton"),
  "43325": p("OH", "Iberia"),
  "43334": p("OH", "Marengo"),
  "43338": p("OH", "Mount Gilead"),
  "43349": p("OH", "Shauck"),
  "43350": p("OH", "Sparta"),
  "43701": p("OH", "Zanesville"),
  "43702": p("OH", "Zanesville"),
  "43720": p("OH", "Blue Rock"),
  "43727": p("OH", "Chandlersville"),
  "43734": p("OH", "Duncan Falls"),
  "43735": p("OH", "East Fultonham"),
  "43738": p("OH", "Fultonham"),
  "43746": p("OH", "Hopewell"),
  "43762": p("OH", "New Concord"),
  "43767": p("OH", "Norwich"),
  "43771": p("OH", "Philo"),
  "43777": p("OH", "Roseville"),
  "43791": p("OH", "White Cottage"),
  "43802": p("OH", "Adamsville"),
  "43821": p("OH", "Dresden"),
  "43822": p("OH", "Frazeysburg"),
  "43830": p("OH", "Nashport"),
  "43842": p("OH", "Trinway"),
  "43711": p("OH", "Ava"),
  "43717": p("OH", "Belle Valley"),
  "43724": p("OH", "Caldwell"),
  "43779": p("OH", "Sarahsville"),
  "43788": p("OH", "Summerfield"),
  "45727": p("OH", "Dexter City"),
  "43408": p("OH", "Clay Center"),
  "43412": p("OH", "Curtice"),
  "43416": p("OH", "Elmore"),
  "43430": p("OH", "Genoa"),
  "43432": p("OH", "Graytown"),
  "43433": p("OH", "Gypsum"),
  "43436": p("OH", "Isle Saint George"),
  "43439": p("OH", "Lacarne"),
  "43440": p("OH", "Lakeside Marblehead"),
  "43445": p("OH", "Martin"),
  "43446": p("OH", "Middle Bass"),
  "43449": p("OH", "Oak Harbor"),
  "43452": p("OH", "Port Clinton"),
  "43456": p("OH", "Put In Bay"),
  "43458": p("OH", "Rocky Ridge"),
  "43468": p("OH", "Williston"),
  "45813": p("OH", "Antwerp"),
  "45821": p("OH", "Cecil"),
  "45849": p("OH", "Grover Hill"),
  "45851": p("OH", "Haviland"),
  "45855": p("OH", "Latty"),
  "45861": p("OH", "Melrose"),
  "45873": p("OH", "Oakwood"),
  "45879": p("OH", "Paulding"),
  "45880": p("OH", "Payne"),
  "43076": p("OH", "Thornville"),
  "43730": p("OH", "Corning"),
  "43731": p("OH", "Crooksville"),
  "43739": p("OH", "Glenford"),
  "43748": p("OH", "Junction City"),
  "43760": p("OH", "Mount Perry"),
  "43761": p("OH", "Moxahala"),
  "43764": p("OH", "New Lexington"),
  "43766": p("OH", "New Straitsville"),
  "43782": p("OH", "Shawnee"),
  "43783": p("OH", "Somerset"),
  "43103": p("OH", "Ashville"),
  "43113": p("OH", "Circleville"),
  "43116": p("OH", "Commercial Point"),
  "43117": p("OH", "Derby"),
  "43137": p("OH", "Lockbourne"),
  "43145": p("OH", "New Holland"),
  "43146": p("OH", "Orient"),
  "43156": p("OH", "Tarlton"),
  "43164": p("OH", "Williamsport"),
  "45613": p("OH", "Beaver"),
  "45624": p("OH", "Cynthiana"),
  "45642": p("OH", "Jasper"),
  "45646": p("OH", "Latham"),
  "45661": p("OH", "Piketon"),
  "45683": p("OH", "Stockdale"),
  "45687": p("OH", "Wakefield"),
  "45690": p("OH", "Waverly"),
  "44201": p("OH", "Atwater"),
  "44202": p("OH", "Aurora"),
  "44211": p("OH", "Brady Lake"),
  "44231": p("OH", "Garrettsville"),
  "44234": p("OH", "Hiram"),
  "44240": p("OH", "Kent"),
  "44241": p("OH", "Streetsboro"),
  "44242": p("OH", "Kent"),
  "44243": p("OH", "Kent"),
  "44255": p("OH", "Mantua"),
  "44265": p("OH", "Randolph"),
  "44266": p("OH", "Ravenna"),
  "44272": p("OH", "Rootstown"),
  "44285": p("OH", "Wayland"),
  "44288": p("OH", "Windham"),
  "44411": p("OH", "Deerfield"),
  "44412": p("OH", "Diamond"),
  "45070": p("OH", "West Elkton"),
  "45311": p("OH", "Camden"),
  "45320": p("OH", "Eaton"),
  "45321": p("OH", "Eldorado"),
  "45330": p("OH", "Gratis"),
  "45338": p("OH", "Lewisburg"),
  "45347": p("OH", "New Paris"),
  "45378": p("OH", "Verona"),
  "45381": p("OH", "West Alexandria"),
  "45382": p("OH", "West Manchester"),
  "45815": p("OH", "Belmore"),
  "45827": p("OH", "Cloverdale"),
  "45830": p("OH", "Columbus Grove"),
  "45831": p("OH", "Continental"),
  "45837": p("OH", "Dupont"),
  "45844": p("OH", "Fort Jennings"),
  "45848": p("OH", "Glandorf"),
  "45853": p("OH", "Kalida"),
  "45856": p("OH", "Leipsic"),
  "45864": p("OH", "Miller City"),
  "45875": p("OH", "Ottawa"),
  "45876": p("OH", "Ottoville"),
  "45877": p("OH", "Pandora"),
  "45893": p("OH", "Vaughnsville"),
  "44813": p("OH", "Bellville"),
  "44822": p("OH", "Butler"),
  "44843": p("OH", "Lucas"),
  "44862": p("OH", "Ontario"),
  "44865": p("OH", "Plymouth"),
  "44875": p("OH", "Shelby"),
  "44878": p("OH", "Shiloh"),
  "44901": p("OH", "Mansfield"),
  "44902": p("OH", "Mansfield"),
  "44903": p("OH", "Mansfield"),
  "44904": p("OH", "Mansfield"),
  "44905": p("OH", "Mansfield"),
  "44906": p("OH", "Mansfield"),
  "44907": p("OH", "Mansfield"),
  "43101": p("OH", "Adelphi"),
  "43115": p("OH", "Clarksburg"),
  "45601": p("OH", "Chillicothe"),
  "45612": p("OH", "Bainbridge"),
  "45617": p("OH", "Bourneville"),
  "45628": p("OH", "Frankfort"),
  "45633": p("OH", "Hallsville"),
  "45644": p("OH", "Kingston"),
  "45647": p("OH", "Londonderry"),
  "45673": p("OH", "Richmond Dale"),
  "45681": p("OH", "South Salem"),
  "43407": p("OH", "Burgoon"),
  "43410": p("OH", "Clyde"),
  "43420": p("OH", "Fremont"),
  "43431": p("OH", "Gibsonburg"),
  "43435": p("OH", "Helena"),
  "43442": p("OH", "Lindsey"),
  "43464": p("OH", "Vickery"),
  "43469": p("OH", "Woodville"),
  "45629": p("OH", "Franklin Furnace"),
  "45630": p("OH", "Friendship"),
  "45636": p("OH", "Haverhill"),
  "45648": p("OH", "Lucasville"),
  "45652": p("OH", "Mc Dermott"),
  "45653": p("OH", "Minford"),
  "45657": p("OH", "Otway"),
  "45662": p("OH", "Portsmouth"),
  "45663": p("OH", "West Portsmouth"),
  "45671": p("OH", "Rarden"),
  "45677": p("OH", "Scioto Furnace"),
  "45682": p("OH", "South Webster"),
  "45684": p("OH", "Stout"),
  "45694": p("OH", "Wheelersburg"),
  "45699": p("OH", "Lucasville"),
  "44802": p("OH", "Alvada"),
  "44807": p("OH", "Attica"),
  "44809": p("OH", "Bascom"),
  "44815": p("OH", "Bettsville"),
  "44818": p("OH", "Bloomville"),
  "44828": p("OH", "Flat Rock"),
  "44830": p("OH", "Fostoria"),
  "44836": p("OH", "Green Springs"),
  "44841": p("OH", "Kansas"),
  "44845": p("OH", "Melmore"),
  "44853": p("OH", "New Riegel"),
  "44861": p("OH", "Old Fort"),
  "44867": p("OH", "Republic"),
  "44883": p("OH", "Tiffin"),
  "45302": p("OH", "Anna"),
  "45306": p("OH", "Botkins"),
  "45333": p("OH", "Houston"),
  "45334": p("OH", "Jackson Center"),
  "45336": p("OH", "Kettlersville"),
  "45340": p("OH", "Maplewood"),
  "45353": p("OH", "Pemberton"),
  "45360": p("OH", "Port Jefferson"),
  "45363": p("OH", "Russia"),
  "45365": p("OH", "Sidney"),
  "45367": p("OH", "Sidney"),
  "45845": p("OH", "Fort Loramie"),
  "44601": p("OH", "Alliance"),
  "44608": p("OH", "Beach City"),
  "44613": p("OH", "Brewster"),
  "44614": p("OH", "Canal Fulton"),
  "44626": p("OH", "East Sparta"),
  "44630": p("OH", "Greentown"),
  "44632": p("OH", "Hartville"),
  "44640": p("OH", "Limaville"),
  "44641": p("OH", "Louisville"),
  "44643": p("OH", "Magnolia"),
  "44646": p("OH", "Massillon"),
  "44647": p("OH", "Massillon"),
  "44648": p("OH", "Massillon"),
  "44650": p("OH", "Maximo"),
  "44652": p("OH", "Middlebranch"),
  "44657": p("OH", "Minerva"),
  "44662": p("OH", "Navarre"),
  "44666": p("OH", "North Lawrence"),
  "44669": p("OH", "Paris"),
  "44670": p("OH", "Robertsville"),
  "44688": p("OH", "Waynesburg"),
  "44689": p("OH", "Wilmot"),
  "44701": p("OH", "Canton"),
  "44702": p("OH", "Canton"),
  "44703": p("OH", "Canton"),
  "44704": p("OH", "Canton"),
  "44705": p("OH", "Canton"),
  "44706": p("OH", "Canton"),
  "44707": p("OH", "Canton"),
  "44708": p("OH", "Canton"),
  "44709": p("OH", "Canton"),
  "44710": p("OH", "Canton"),
  "44711": p("OH", "Canton"),
  "44714": p("OH", "Canton"),
  "44718": p("OH", "Canton"),
  "44720": p("OH", "North Canton"),
  "44721": p("OH", "Canton"),
  "44730": p("OH", "East Canton"),
  "44735": p("OH", "Canton"),
  "44750": p("OH", "Canton"),
  "44767": p("OH", "Canton"),
  "44799": p("OH", "Canton"),
  "44056": p("OH", "Macedonia"),
  "44067": p("OH", "Northfield"),
  "44087": p("OH", "Twinsburg"),
  "44203": p("OH", "Barberton"),
  "44210": p("OH", "Bath"),
  "44216": p("OH", "Clinton"),
  "44221": p("OH", "Cuyahoga Falls"),
  "44222": p("OH", "Cuyahoga Falls"),
  "44223": p("OH", "Cuyahoga Falls"),
  "44224": p("OH", "Stow"),
  "44232": p("OH", "Green"),
  "44236": p("OH", "Hudson"),
  "44237": p("OH", "Hudson"),
  "44250": p("OH", "Lakemore"),
  "44260": p("OH", "Mogadore"),
  "44262": p("OH", "Munroe Falls"),
  "44264": p("OH", "Peninsula"),
  "44278": p("OH", "Tallmadge"),
  "44286": p("OH", "Richfield"),
  "44301": p("OH", "Akron"),
  "44302": p("OH", "Akron"),
  "44303": p("OH", "Akron"),
  "44304": p("OH", "Akron"),
  "44305": p("OH", "Akron"),
  "44306": p("OH", "Akron"),
  "44307": p("OH", "Akron"),
  "44308": p("OH", "Akron"),
  "44309": p("OH", "Akron"),
  "44310": p("OH", "Akron"),
  "44311": p("OH", "Akron"),
  "44312": p("OH", "Akron"),
  "44313": p("OH", "Akron"),
  "44314": p("OH", "Akron"),
  "44315": p("OH", "Akron"),
  "44316": p("OH", "Akron"),
  "44317": p("OH", "Akron"),
  "44319": p("OH", "Akron"),
  "44320": p("OH", "Akron"),
  "44321": p("OH", "Akron"),
  "44325": p("OH", "Akron"),
  "44326": p("OH", "Akron"),
  "44328": p("OH", "Akron"),
  "44333": p("OH", "Akron"),
  "44334": p("OH", "Fairlawn"),
  "44372": p("OH", "Akron"),
  "44396": p("OH", "Akron"),
  "44398": p("OH", "Akron"),
  "44685": p("OH", "Uniontown"),
  "44402": p("OH", "Bristolville"),
  "44403": p("OH", "Brookfield"),
  "44404": p("OH", "Burghill"),
  "44410": p("OH", "Cortland"),
  "44417": p("OH", "Farmdale"),
  "44418": p("OH", "Fowler"),
  "44420": p("OH", "Girard"),
  "44424": p("OH", "Hartford"),
  "44425": p("OH", "Hubbard"),
  "44428": p("OH", "Kinsman"),
  "44430": p("OH", "Leavittsburg"),
  "44437": p("OH", "Mc Donald"),
  "44438": p("OH", "Masury"),
  "44439": p("OH", "Mesopotamia"),
  "44440": p("OH", "Mineral Ridge"),
  "44444": p("OH", "Newton Falls"),
  "44446": p("OH", "Niles"),
  "44450": p("OH", "North Bloomfield"),
  "44453": p("OH", "Orangeville"),
  "44470": p("OH", "Southington"),
  "44473": p("OH", "Vienna"),
  "44481": p("OH", "Warren"),
  "44482": p("OH", "Warren"),
  "44483": p("OH", "Warren"),
  "44484": p("OH", "Warren"),
  "44485": p("OH", "Warren"),
  "44486": p("OH", "Warren"),
  "44491": p("OH", "West Farmington"),
  "43804": p("OH", "Baltic"),
  "43832": p("OH", "Newcomerstown"),
  "43837": p("OH", "Port Washington"),
  "43840": p("OH", "Stone Creek"),
  "44612": p("OH", "Bolivar"),
  "44621": p("OH", "Dennison"),
  "44622": p("OH", "Dover"),
  "44624": p("OH", "Dundee"),
  "44629": p("OH", "Gnadenhutten"),
  "44653": p("OH", "Midvale"),
  "44656": p("OH", "Mineral City"),
  "44663": p("OH", "New Philadelphia"),
  "44671": p("OH", "Sandyville"),
  "44678": p("OH", "Somerdale"),
  "44679": p("OH", "Stillwater"),
  "44680": p("OH", "Strasburg"),
  "44681": p("OH", "Sugarcreek"),
  "44682": p("OH", "Tuscarawas"),
  "44683": p("OH", "Uhrichsville"),
  "44697": p("OH", "Zoar"),
  "43007": p("OH", "Broadway"),
  "43029": p("OH", "Irwin"),
  "43036": p("OH", "Magnetic Springs"),
  "43040": p("OH", "Marysville"),
  "43041": p("OH", "Marysville"),
  "43045": p("OH", "Milford Center"),
  "43067": p("OH", "Raymond"),
  "43077": p("OH", "Unionville Center"),
  "43344": p("OH", "Richwood"),
  "45832": p("OH", "Convoy"),
  "45838": p("OH", "Elgin"),
  "45863": p("OH", "Middle Point"),
  "45874": p("OH", "Ohio City"),
  "45886": p("OH", "Scott"),
  "45891": p("OH", "Van Wert"),
  "45894": p("OH", "Venedocia"),
  "45898": p("OH", "Willshire"),
  "45899": p("OH", "Wren"),
  "45622": p("OH", "Creola"),
  "45634": p("OH", "Hamden"),
  "45651": p("OH", "Mc Arthur"),
  "45654": p("OH", "New Plymouth"),
  "45672": p("OH", "Ray"),
  "45695": p("OH", "Wilkesville"),
  "45698": p("OH", "Zaleski"),
  "45005": p("OH", "Franklin"),
  "45032": p("OH", "Harveysburg"),
  "45034": p("OH", "Kings Mills"),
  "45036": p("OH", "Lebanon"),
  "45039": p("OH", "Maineville"),
  "45040": p("OH", "Mason"),
  "45054": p("OH", "Oregonia"),
  "45065": p("OH", "South Lebanon"),
  "45066": p("OH", "Springboro"),
  "45068": p("OH", "Waynesville"),
  "45152": p("OH", "Morrow"),
  "45162": p("OH", "Pleasant Plain"),
  "45712": p("OH", "Barlow"),
  "45713": p("OH", "Bartlett"),
  "45714": p("OH", "Belpre"),
  "45715": p("OH", "Beverly"),
  "45721": p("OH", "Coal Run"),
  "45724": p("OH", "Cutler"),
  "45729": p("OH", "Fleming"),
  "45742": p("OH", "Little Hocking"),
  "45744": p("OH", "Lowell"),
  "45745": p("OH", "Lower Salem"),
  "45746": p("OH", "Macksburg"),
  "45750": p("OH", "Marietta"),
  "45767": p("OH", "New Matamoras"),
  "45768": p("OH", "Newport"),
  "45773": p("OH", "Reno"),
  "45784": p("OH", "Vincent"),
  "45786": p("OH", "Waterford"),
  "45787": p("OH", "Watertown"),
  "45788": p("OH", "Whipple"),
  "45789": p("OH", "Wingett Run"),
  "44214": p("OH", "Burbank"),
  "44217": p("OH", "Creston"),
  "44230": p("OH", "Doylestown"),
  "44270": p("OH", "Rittman"),
  "44276": p("OH", "Sterling"),
  "44287": p("OH", "West Salem"),
  "44606": p("OH", "Apple Creek"),
  "44618": p("OH", "Dalton"),
  "44627": p("OH", "Fredericksburg"),
  "44636": p("OH", "Kidron"),
  "44645": p("OH", "Marshallville"),
  "44659": p("OH", "Mount Eaton"),
  "44667": p("OH", "Orrville"),
  "44676": p("OH", "Shreve"),
  "44677": p("OH", "Smithville"),
  "44691": p("OH", "Wooster"),
  "43501": p("OH", "Alvordton"),
  "43505": p("OH", "Blakeslee"),
  "43506": p("OH", "Bryan"),
  "43517": p("OH", "Edgerton"),
  "43518": p("OH", "Edon"),
  "43531": p("OH", "Kunkle"),
  "43543": p("OH", "Montpelier"),
  "43554": p("OH", "Pioneer"),
  "43557": p("OH", "Stryker"),
  "43570": p("OH", "West Unity"),
  "43402": p("OH", "Bowling Green"),
  "43403": p("OH", "Bowling Green"),
  "43406": p("OH", "Bradner"),
  "43413": p("OH", "Cygnet"),
  "43414": p("OH", "Dunbridge"),
  "43437": p("OH", "Jerry City"),
  "43441": p("OH", "Lemoyne"),
  "43443": p("OH", "Luckey"),
  "43447": p("OH", "Millbury"),
  "43450": p("OH", "Pemberville"),
  "43451": p("OH", "Portage"),
  "43457": p("OH", "Risingsun"),
  "43460": p("OH", "Rossford"),
  "43462": p("OH", "Rudolph"),
  "43463": p("OH", "Stony Ridge"),
  "43465": p("OH", "Walbridge"),
  "43466": p("OH", "Wayne"),
  "43467": p("OH", "West Millgrove"),
  "43511": p("OH", "Custar"),
  "43522": p("OH", "Grand Rapids"),
  "43525": p("OH", "Haskins"),
  "43529": p("OH", "Hoytville"),
  "43541": p("OH", "Milton Center"),
  "43551": p("OH", "Perrysburg"),
  "43552": p("OH", "Perrysburg"),
  "43565": p("OH", "Tontogany"),
  "43569": p("OH", "Weston"),
  "43619": p("OH", "Northwood"),
  "44817": p("OH", "Bloomdale"),
  "45872": p("OH", "North Baltimore"),
  "43316": p("OH", "Carey"),
  "43323": p("OH", "Harpster"),
  "43330": p("OH", "Kirby"),
  "43351": p("OH", "Upper Sandusky"),
  "43359": p("OH", "Wharton"),
  "44844": p("OH", "Mc Cutchenville"),
  "44849": p("OH", "Nevada"),
  "44882": p("OH", "Sycamore"),
  "74457": p("OK", "Proctor"),
  "74931": p("OK", "Bunch"),
  "74960": p("OK", "Stilwell"),
  "74964": p("OK", "Watts"),
  "74965": p("OK", "Westville"),
  "73716": p("OK", "Aline"),
  "73719": p("OK", "Amorita"),
  "73722": p("OK", "Burlington"),
  "73726": p("OK", "Carmen"),
  "73728": p("OK", "Cherokee"),
  "73739": p("OK", "Goltry"),
  "73741": p("OK", "Helena"),
  "73749": p("OK", "Jet"),
  "74525": p("OK", "Atoka"),
  "74533": p("OK", "Caney"),
  "74540": p("OK", "Daisy"),
  "74555": p("OK", "Lane"),
  "74569": p("OK", "Stringtown"),
  "73844": p("OK", "Gate"),
  "73931": p("OK", "Balko"),
  "73932": p("OK", "Beaver"),
  "73938": p("OK", "Forgan"),
  "73950": p("OK", "Turpin"),
  "73627": p("OK", "Carter"),
  "73644": p("OK", "Elk City"),
  "73645": p("OK", "Erick"),
  "73648": p("OK", "Elk City"),
  "73662": p("OK", "Sayre"),
  "73668": p("OK", "Texola"),
  "73040": p("OK", "Geary"),
  "73043": p("OK", "Greenfield"),
  "73724": p("OK", "Canton"),
  "73744": p("OK", "Hitchcock"),
  "73755": p("OK", "Longdale"),
  "73763": p("OK", "Okeene"),
  "73770": p("OK", "Southard"),
  "73772": p("OK", "Watonga"),
  "73449": p("OK", "Mead"),
  "74701": p("OK", "Durant"),
  "74702": p("OK", "Durant"),
  "74720": p("OK", "Achille"),
  "74721": p("OK", "Albany"),
  "74723": p("OK", "Bennington"),
  "74726": p("OK", "Bokchito"),
  "74729": p("OK", "Caddo"),
  "74730": p("OK", "Calera"),
  "74731": p("OK", "Cartwright"),
  "74733": p("OK", "Colbert"),
  "74741": p("OK", "Hendrix"),
  "74747": p("OK", "Kemp"),
  "74748": p("OK", "Kenefic"),
  "74753": p("OK", "Platter"),
  "73001": p("OK", "Albert"),
  "73005": p("OK", "Anadarko"),
  "73006": p("OK", "Apache"),
  "73009": p("OK", "Binger"),
  "73015": p("OK", "Carnegie"),
  "73017": p("OK", "Cement"),
  "73029": p("OK", "Cyril"),
  "73033": p("OK", "Eakly"),
  "73038": p("OK", "Fort Cobb"),
  "73042": p("OK", "Gracemont"),
  "73047": p("OK", "Hinton"),
  "73048": p("OK", "Hydro"),
  "73053": p("OK", "Lookeba"),
  "73014": p("OK", "Calumet"),
  "73022": p("OK", "Concho"),
  "73036": p("OK", "El Reno"),
  "73064": p("OK", "Mustang"),
  "73078": p("OK", "Piedmont"),
  "73085": p("OK", "Yukon"),
  "73090": p("OK", "Union City"),
  "73099": p("OK", "Yukon"),
  "73401": p("OK", "Ardmore"),
  "73402": p("OK", "Ardmore"),
  "73403": p("OK", "Ardmore"),
  "73435": p("OK", "Fox"),
  "73436": p("OK", "Gene Autry"),
  "73437": p("OK", "Graham"),
  "73438": p("OK", "Healdton"),
  "73443": p("OK", "Lone Grove"),
  "73458": p("OK", "Springer"),
  "73463": p("OK", "Wilson"),
  "73481": p("OK", "Ratliff City"),
  "73487": p("OK", "Tatums"),
  "73488": p("OK", "Tussy"),
  "74427": p("OK", "Cookson"),
  "74441": p("OK", "Hulbert"),
  "74444": p("OK", "Moodys"),
  "74451": p("OK", "Park Hill"),
  "74452": p("OK", "Peggs"),
  "74464": p("OK", "Tahlequah"),
  "74465": p("OK", "Tahlequah"),
  "74471": p("OK", "Welling"),
  "74727": p("OK", "Boswell"),
  "74735": p("OK", "Fort Towson"),
  "74738": p("OK", "Grant"),
  "74743": p("OK", "Hugo"),
  "74756": p("OK", "Sawyer"),
  "74759": p("OK", "Soper"),
  "74760": p("OK", "Spencerville"),
  "74761": p("OK", "Swink"),
  "73933": p("OK", "Boise City"),
  "73937": p("OK", "Felt"),
  "73946": p("OK", "Kenton"),
  "73947": p("OK", "Keyes"),
  "73019": p("OK", "Norman"),
  "73026": p("OK", "Norman"),
  "73051": p("OK", "Lexington"),
  "73068": p("OK", "Noble"),
  "73069": p("OK", "Norman"),
  "73070": p("OK", "Norman"),
  "73071": p("OK", "Norman"),
  "73072": p("OK", "Norman"),
  "73139": p("OK", "Oklahoma City"),
  "73160": p("OK", "Oklahoma City"),
  "73165": p("OK", "Oklahoma City"),
  "73170": p("OK", "Oklahoma City"),
  "73173": p("OK", "Oklahoma City"),
  "74534": p("OK", "Centrahoma"),
  "74535": p("OK", "Clarita"),
  "74538": p("OK", "Coalgate"),
  "74556": p("OK", "Lehigh"),
  "74572": p("OK", "Tupelo"),
  "73501": p("OK", "Lawton"),
  "73502": p("OK", "Lawton"),
  "73503": p("OK", "Fort Sill"),
  "73505": p("OK", "Lawton"),
  "73506": p("OK", "Lawton"),
  "73507": p("OK", "Lawton"),
  "73527": p("OK", "Cache"),
  "73528": p("OK", "Chattanooga"),
  "73538": p("OK", "Elgin"),
  "73540": p("OK", "Faxon"),
  "73541": p("OK", "Fletcher"),
  "73543": p("OK", "Geronimo"),
  "73552": p("OK", "Indiahoma"),
  "73557": p("OK", "Medicine Park"),
  "73558": p("OK", "Meers"),
  "73567": p("OK", "Sterling"),
  "73531": p("OK", "Devol"),
  "73562": p("OK", "Randlett"),
  "73568": p("OK", "Temple"),
  "73572": p("OK", "Walters"),
  "74301": p("OK", "Vinita"),
  "74332": p("OK", "Big Cabin"),
  "74333": p("OK", "Bluejacket"),
  "74369": p("OK", "Welch"),
  "74010": p("OK", "Bristow"),
  "74028": p("OK", "Depew"),
  "74030": p("OK", "Drumright"),
  "74039": p("OK", "Kellyville"),
  "74041": p("OK", "Kiefer"),
  "74044": p("OK", "Mannford"),
  "74046": p("OK", "Milfay"),
  "74047": p("OK", "Mounds"),
  "74052": p("OK", "Oilton"),
  "74066": p("OK", "Sapulpa"),
  "74067": p("OK", "Sapulpa"),
  "74068": p("OK", "Shamrock"),
  "74071": p("OK", "Slick"),
  "74131": p("OK", "Tulsa"),
  "73096": p("OK", "Weatherford"),
  "73601": p("OK", "Clinton"),
  "73620": p("OK", "Arapaho"),
  "73625": p("OK", "Butler"),
  "73639": p("OK", "Custer City"),
  "73669": p("OK", "Thomas"),
  "74338": p("OK", "Colcord"),
  "74342": p("OK", "Eucha"),
  "74344": p("OK", "Grove"),
  "74345": p("OK", "Grove"),
  "74346": p("OK", "Jay"),
  "74347": p("OK", "Kansas"),
  "74359": p("OK", "Oaks"),
  "74368": p("OK", "Twin Oaks"),
  "73646": p("OK", "Fay"),
  "73654": p("OK", "Leedey"),
  "73658": p("OK", "Oakwood"),
  "73659": p("OK", "Putnam"),
  "73663": p("OK", "Seiling"),
  "73667": p("OK", "Taloga"),
  "73835": p("OK", "Camargo"),
  "73859": p("OK", "Vici"),
  "73832": p("OK", "Arnett"),
  "73840": p("OK", "Fargo"),
  "73843": p("OK", "Gage"),
  "73858": p("OK", "Shattuck"),
  "73701": p("OK", "Enid"),
  "73702": p("OK", "Enid"),
  "73703": p("OK", "Enid"),
  "73705": p("OK", "Enid"),
  "73706": p("OK", "Enid"),
  "73720": p("OK", "Bison"),
  "73727": p("OK", "Carrier"),
  "73730": p("OK", "Covington"),
  "73733": p("OK", "Douglas"),
  "73735": p("OK", "Drummond"),
  "73736": p("OK", "Fairmont"),
  "73738": p("OK", "Garber"),
  "73743": p("OK", "Hillsdale"),
  "73753": p("OK", "Kremlin"),
  "73754": p("OK", "Lahoma"),
  "73773": p("OK", "Waukomis"),
  "74640": p("OK", "Hunter"),
  "73052": p("OK", "Lindsay"),
  "73057": p("OK", "Maysville"),
  "73074": p("OK", "Paoli"),
  "73075": p("OK", "Pauls Valley"),
  "73098": p("OK", "Wynnewood"),
  "73433": p("OK", "Elmore City"),
  "73444": p("OK", "Hennepin"),
  "74872": p("OK", "Stratford"),
  "73002": p("OK", "Alex"),
  "73004": p("OK", "Amber"),
  "73011": p("OK", "Bradley"),
  "73018": p("OK", "Chickasha"),
  "73023": p("OK", "Chickasha"),
  "73059": p("OK", "Minco"),
  "73067": p("OK", "Ninnekah"),
  "73079": p("OK", "Pocasset"),
  "73082": p("OK", "Rush Springs"),
  "73089": p("OK", "Tuttle"),
  "73092": p("OK", "Verden"),
  "73758": p("OK", "Manchester"),
  "73759": p("OK", "Medford"),
  "73761": p("OK", "Nash"),
  "73766": p("OK", "Pond Creek"),
  "73771": p("OK", "Wakita"),
  "74636": p("OK", "Deer Creek"),
  "74643": p("OK", "Lamont"),
  "73547": p("OK", "Granite"),
  "73554": p("OK", "Mangum"),
  "73673": p("OK", "Willow"),
  "73544": p("OK", "Gould"),
  "73550": p("OK", "Hollis"),
  "73571": p("OK", "Vinson"),
  "73834": p("OK", "Buffalo"),
  "73848": p("OK", "Laverne"),
  "73851": p("OK", "May"),
  "73855": p("OK", "Rosston"),
  "74440": p("OK", "Hoyt"),
  "74462": p("OK", "Stigler"),
  "74472": p("OK", "Whitefield"),
  "74552": p("OK", "Kinta"),
  "74941": p("OK", "Keota"),
  "74943": p("OK", "Lequire"),
  "74944": p("OK", "Mccurtain"),
  "74531": p("OK", "Calvin"),
  "74570": p("OK", "Stuart"),
  "74827": p("OK", "Atwood"),
  "74839": p("OK", "Dustin"),
  "74848": p("OK", "Holdenville"),
  "74850": p("OK", "Lamar"),
  "74883": p("OK", "Wetumka"),
  "73521": p("OK", "Altus"),
  "73522": p("OK", "Altus"),
  "73523": p("OK", "Altus Afb"),
  "73526": p("OK", "Blair"),
  "73532": p("OK", "Duke"),
  "73537": p("OK", "Eldorado"),
  "73539": p("OK", "Elmer"),
  "73549": p("OK", "Headrick"),
  "73556": p("OK", "Martha"),
  "73560": p("OK", "Olustee"),
  "73456": p("OK", "Ringling"),
  "73520": p("OK", "Addington"),
  "73548": p("OK", "Hastings"),
  "73561": p("OK", "Oscar"),
  "73565": p("OK", "Ryan"),
  "73569": p("OK", "Terral"),
  "73573": p("OK", "Waurika"),
  "73432": p("OK", "Coleman"),
  "73447": p("OK", "Mannsville"),
  "73450": p("OK", "Milburn"),
  "73455": p("OK", "Ravia"),
  "73460": p("OK", "Tishomingo"),
  "73461": p("OK", "Wapanucka"),
  "74530": p("OK", "Bromide"),
  "74836": p("OK", "Connerville"),
  "74856": p("OK", "Mill Creek"),
  "74601": p("OK", "Ponca City"),
  "74602": p("OK", "Ponca City"),
  "74604": p("OK", "Ponca City"),
  "74631": p("OK", "Blackwell"),
  "74632": p("OK", "Braman"),
  "74641": p("OK", "Kaw City"),
  "74646": p("OK", "Nardin"),
  "74647": p("OK", "Newkirk"),
  "74653": p("OK", "Tonkawa"),
  "73016": p("OK", "Cashion"),
  "73734": p("OK", "Dover"),
  "73742": p("OK", "Hennessey"),
  "73750": p("OK", "Kingfisher"),
  "73756": p("OK", "Loyal"),
  "73762": p("OK", "Okarche"),
  "73764": p("OK", "Omega"),
  "73041": p("OK", "Gotebo"),
  "73062": p("OK", "Mountain View"),
  "73559": p("OK", "Mountain Park"),
  "73564": p("OK", "Roosevelt"),
  "73566": p("OK", "Snyder"),
  "73651": p("OK", "Hobart"),
  "73655": p("OK", "Lone Wolf"),
  "74545": p("OK", "Gowen"),
  "74559": p("OK", "Panola"),
  "74563": p("OK", "Red Oak"),
  "74578": p("OK", "Wilburton"),
  "74549": p("OK", "Honobia"),
  "74571": p("OK", "Talihina"),
  "74577": p("OK", "Whitesboro"),
  "74901": p("OK", "Arkoma"),
  "74902": p("OK", "Pocola"),
  "74930": p("OK", "Bokoshe"),
  "74932": p("OK", "Cameron"),
  "74935": p("OK", "Fanshawe"),
  "74937": p("OK", "Heavener"),
  "74939": p("OK", "Hodgen"),
  "74940": p("OK", "Howe"),
  "74942": p("OK", "Leflore"),
  "74947": p("OK", "Monroe"),
  "74949": p("OK", "Muse"),
  "74951": p("OK", "Panama"),
  "74953": p("OK", "Poteau"),
  "74956": p("OK", "Shady Point"),
  "74959": p("OK", "Spiro"),
  "74966": p("OK", "Wister"),
  "74026": p("OK", "Davenport"),
  "74079": p("OK", "Stroud"),
  "74824": p("OK", "Agra"),
  "74832": p("OK", "Carney"),
  "74834": p("OK", "Chandler"),
  "74855": p("OK", "Meeker"),
  "74864": p("OK", "Prague"),
  "74869": p("OK", "Sparks"),
  "74875": p("OK", "Tryon"),
  "74881": p("OK", "Wellston"),
  "73027": p("OK", "Coyle"),
  "73028": p("OK", "Crescent"),
  "73044": p("OK", "Guthrie"),
  "73050": p("OK", "Langston"),
  "73056": p("OK", "Marshall"),
  "73058": p("OK", "Meridian"),
  "73063": p("OK", "Mulhall"),
  "73073": p("OK", "Orlando"),
  "73430": p("OK", "Burneyville"),
  "73441": p("OK", "Leon"),
  "73448": p("OK", "Marietta"),
  "73453": p("OK", "Overbrook"),
  "73459": p("OK", "Thackerville"),
  "73010": p("OK", "Blanchard"),
  "73031": p("OK", "Dibble"),
  "73065": p("OK", "Newcastle"),
  "73080": p("OK", "Purcell"),
  "73093": p("OK", "Washington"),
  "73095": p("OK", "Wayne"),
  "74831": p("OK", "Byars"),
  "74722": p("OK", "Battiest"),
  "74724": p("OK", "Bethel"),
  "74728": p("OK", "Broken Bow"),
  "74734": p("OK", "Eagletown"),
  "74736": p("OK", "Garvin"),
  "74737": p("OK", "Golden"),
  "74740": p("OK", "Haworth"),
  "74745": p("OK", "Idabel"),
  "74750": p("OK", "Millerton"),
  "74752": p("OK", "Pickens"),
  "74754": p("OK", "Ringold"),
  "74755": p("OK", "Rufe"),
  "74764": p("OK", "Valliant"),
  "74766": p("OK", "Wright City"),
  "74957": p("OK", "Smithville"),
  "74963": p("OK", "Watson"),
  "74426": p("OK", "Checotah"),
  "74432": p("OK", "Eufaula"),
  "74438": p("OK", "Hitchita"),
  "74459": p("OK", "Rentiesville"),
  "74461": p("OK", "Stidham"),
  "74845": p("OK", "Hanna"),
  "73718": p("OK", "Ames"),
  "73729": p("OK", "Cleo Springs"),
  "73737": p("OK", "Fairview"),
  "73747": p("OK", "Isabella"),
  "73760": p("OK", "Meno"),
  "73768": p("OK", "Ringwood"),
  "73838": p("OK", "Chester"),
  "73439": p("OK", "Kingston"),
  "73440": p("OK", "Lebanon"),
  "73446": p("OK", "Madill"),
  "74330": p("OK", "Adair"),
  "74337": p("OK", "Chouteau"),
  "74340": p("OK", "Disney"),
  "74349": p("OK", "Ketchum"),
  "74350": p("OK", "Langley"),
  "74352": p("OK", "Locust Grove"),
  "74361": p("OK", "Pryor"),
  "74362": p("OK", "Pryor"),
  "74364": p("OK", "Rose"),
  "74365": p("OK", "Salina"),
  "74366": p("OK", "Spavinaw"),
  "74367": p("OK", "Strang"),
  "73030": p("OK", "Davis"),
  "73032": p("OK", "Dougherty"),
  "73086": p("OK", "Sulphur"),
  "74401": p("OK", "Muskogee"),
  "74402": p("OK", "Muskogee"),
  "74403": p("OK", "Muskogee"),
  "74422": p("OK", "Boynton"),
  "74423": p("OK", "Braggs"),
  "74428": p("OK", "Council Hill"),
  "74434": p("OK", "Fort Gibson"),
  "74436": p("OK", "Haskell"),
  "74439": p("OK", "Braggs"),
  "74450": p("OK", "Oktaha"),
  "74455": p("OK", "Porum"),
  "74463": p("OK", "Taft"),
  "74468": p("OK", "Wainwright"),
  "74469": p("OK", "Warner"),
  "74470": p("OK", "Webbers Falls"),
  "73061": p("OK", "Morrison"),
  "73077": p("OK", "Perry"),
  "73757": p("OK", "Lucien"),
  "74630": p("OK", "Billings"),
  "74644": p("OK", "Marland"),
  "74651": p("OK", "Red Rock"),
  "74027": p("OK", "Delaware"),
  "74042": p("OK", "Lenapah"),
  "74048": p("OK", "Nowata"),
  "74072": p("OK", "S Coffeyville"),
  "74083": p("OK", "Wann"),
  "74829": p("OK", "Boley"),
  "74833": p("OK", "Castle"),
  "74859": p("OK", "Okemah"),
  "74860": p("OK", "Paden"),
  "74880": p("OK", "Weleetka"),
  "73003": p("OK", "Edmond"),
  "73007": p("OK", "Arcadia"),
  "73008": p("OK", "Bethany"),
  "73012": p("OK", "Edmond"),
  "73013": p("OK", "Edmond"),
  "73020": p("OK", "Choctaw"),
  "73025": p("OK", "Edmond"),
  "73034": p("OK", "Edmond"),
  "73039": p("OK", "Davis"),
  "73045": p("OK", "Harrah"),
  "73049": p("OK", "Jones"),
  "73054": p("OK", "Luther"),
  "73066": p("OK", "Nicoma Park"),
  "73083": p("OK", "Edmond"),
  "73084": p("OK", "Spencer"),
  "73097": p("OK", "Wheatland"),
  "73101": p("OK", "Oklahoma City"),
  "73102": p("OK", "Oklahoma City"),
  "73103": p("OK", "Oklahoma City"),
  "73104": p("OK", "Oklahoma City"),
  "73105": p("OK", "Oklahoma City"),
  "73106": p("OK", "Oklahoma City"),
  "73107": p("OK", "Oklahoma City"),
  "73108": p("OK", "Oklahoma City"),
  "73109": p("OK", "Oklahoma City"),
  "73110": p("OK", "Oklahoma City"),
  "73111": p("OK", "Oklahoma City"),
  "73112": p("OK", "Oklahoma City"),
  "73113": p("OK", "Oklahoma City"),
  "73114": p("OK", "Oklahoma City"),
  "73115": p("OK", "Oklahoma City"),
  "73116": p("OK", "Oklahoma City"),
  "73117": p("OK", "Oklahoma City"),
  "73118": p("OK", "Oklahoma City"),
  "73119": p("OK", "Oklahoma City"),
  "73120": p("OK", "Oklahoma City"),
  "73121": p("OK", "Oklahoma City"),
  "73122": p("OK", "Oklahoma City"),
  "73123": p("OK", "Oklahoma City"),
  "73124": p("OK", "Oklahoma City"),
  "73125": p("OK", "Oklahoma City"),
  "73126": p("OK", "Oklahoma City"),
  "73127": p("OK", "Oklahoma City"),
  "73128": p("OK", "Oklahoma City"),
  "73129": p("OK", "Oklahoma City"),
  "73130": p("OK", "Oklahoma City"),
  "73131": p("OK", "Oklahoma City"),
  "73132": p("OK", "Oklahoma City"),
  "73134": p("OK", "Oklahoma City"),
  "73135": p("OK", "Oklahoma City"),
  "73136": p("OK", "Oklahoma City"),
  "73137": p("OK", "Oklahoma City"),
  "73140": p("OK", "Oklahoma City"),
  "73141": p("OK", "Oklahoma City"),
  "73142": p("OK", "Oklahoma City"),
  "73143": p("OK", "Oklahoma City"),
  "73144": p("OK", "Oklahoma City"),
  "73145": p("OK", "Oklahoma City"),
  "73146": p("OK", "Oklahoma City"),
  "73147": p("OK", "Oklahoma City"),
  "73148": p("OK", "Oklahoma City"),
  "73149": p("OK", "Oklahoma City"),
  "73150": p("OK", "Oklahoma City"),
  "73151": p("OK", "Oklahoma City"),
  "73152": p("OK", "Oklahoma City"),
  "73153": p("OK", "Oklahoma City"),
  "73154": p("OK", "Oklahoma City"),
  "73155": p("OK", "Oklahoma City"),
  "73156": p("OK", "Oklahoma City"),
  "73157": p("OK", "Oklahoma City"),
  "73159": p("OK", "Oklahoma City"),
  "73162": p("OK", "Oklahoma City"),
  "73163": p("OK", "Oklahoma City"),
  "73164": p("OK", "Oklahoma City"),
  "73167": p("OK", "Oklahoma City"),
  "73169": p("OK", "Oklahoma City"),
  "73172": p("OK", "Oklahoma City"),
  "73178": p("OK", "Oklahoma City"),
  "73179": p("OK", "Oklahoma City"),
  "73184": p("OK", "Oklahoma City"),
  "73185": p("OK", "Oklahoma City"),
  "73189": p("OK", "Oklahoma City"),
  "73190": p("OK", "Oklahoma City"),
  "73194": p("OK", "Oklahoma City"),
  "73195": p("OK", "Oklahoma City"),
  "73196": p("OK", "Oklahoma City"),
  "74857": p("OK", "Newalla"),
  "74421": p("OK", "Beggs"),
  "74431": p("OK", "Dewar"),
  "74437": p("OK", "Henryetta"),
  "74445": p("OK", "Morris"),
  "74447": p("OK", "Okmulgee"),
  "74456": p("OK", "Preston"),
  "74460": p("OK", "Schulter"),
  "74001": p("OK", "Avant"),
  "74002": p("OK", "Barnsdall"),
  "74035": p("OK", "Hominy"),
  "74054": p("OK", "Osage"),
  "74056": p("OK", "Pawhuska"),
  "74060": p("OK", "Prue"),
  "74070": p("OK", "Skiatook"),
  "74084": p("OK", "Wynona"),
  "74127": p("OK", "Tulsa"),
  "74633": p("OK", "Burbank"),
  "74637": p("OK", "Fairfax"),
  "74652": p("OK", "Shidler"),
  "74331": p("OK", "Afton"),
  "74335": p("OK", "Cardin"),
  "74339": p("OK", "Commerce"),
  "74343": p("OK", "Fairland"),
  "74354": p("OK", "Miami"),
  "74355": p("OK", "Miami"),
  "74358": p("OK", "North Miami"),
  "74360": p("OK", "Picher"),
  "74363": p("OK", "Quapaw"),
  "74370": p("OK", "Wyandotte"),
  "74020": p("OK", "Cleveland"),
  "74034": p("OK", "Hallett"),
  "74038": p("OK", "Jennings"),
  "74045": p("OK", "Maramec"),
  "74058": p("OK", "Pawnee"),
  "74081": p("OK", "Terlton"),
  "74650": p("OK", "Ralston"),
  "74023": p("OK", "Cushing"),
  "74032": p("OK", "Glencoe"),
  "74059": p("OK", "Perkins"),
  "74062": p("OK", "Ripley"),
  "74074": p("OK", "Stillwater"),
  "74075": p("OK", "Stillwater"),
  "74076": p("OK", "Stillwater"),
  "74077": p("OK", "Stillwater"),
  "74078": p("OK", "Stillwater"),
  "74085": p("OK", "Yale"),
  "74425": p("OK", "Canadian"),
  "74430": p("OK", "Crowder"),
  "74442": p("OK", "Indianola"),
  "74501": p("OK", "Mcalester"),
  "74502": p("OK", "Mcalester"),
  "74522": p("OK", "Alderson"),
  "74528": p("OK", "Blanco"),
  "74529": p("OK", "Blocker"),
  "74546": p("OK", "Haileyville"),
  "74547": p("OK", "Hartshorne"),
  "74553": p("OK", "Kiowa"),
  "74554": p("OK", "Krebs"),
  "74560": p("OK", "Pittsburg"),
  "74561": p("OK", "Quinton"),
  "74565": p("OK", "Savanna"),
  "74576": p("OK", "Wardville"),
  "74820": p("OK", "Ada"),
  "74821": p("OK", "Ada"),
  "74825": p("OK", "Allen"),
  "74842": p("OK", "Fittstown"),
  "74843": p("OK", "Fitzhugh"),
  "74844": p("OK", "Francis"),
  "74865": p("OK", "Roff"),
  "74871": p("OK", "Stonewall"),
  "74801": p("OK", "Shawnee"),
  "74802": p("OK", "Shawnee"),
  "74804": p("OK", "Shawnee"),
  "74826": p("OK", "Asher"),
  "74840": p("OK", "Earlsboro"),
  "74851": p("OK", "Mcloud"),
  "74852": p("OK", "Macomb"),
  "74854": p("OK", "Maud"),
  "74866": p("OK", "Saint Louis"),
  "74873": p("OK", "Tecumseh"),
  "74878": p("OK", "Wanette"),
  "74521": p("OK", "Albion"),
  "74523": p("OK", "Antlers"),
  "74536": p("OK", "Clayton"),
  "74543": p("OK", "Finley"),
  "74557": p("OK", "Moyers"),
  "74558": p("OK", "Nashoba"),
  "74562": p("OK", "Rattan"),
  "74567": p("OK", "Snow"),
  "74574": p("OK", "Tuskahoma"),
  "73628": p("OK", "Cheyenne"),
  "73638": p("OK", "Crawford"),
  "73642": p("OK", "Durham"),
  "73650": p("OK", "Hammon"),
  "73660": p("OK", "Reydon"),
  "73666": p("OK", "Sweetwater"),
  "74015": p("OK", "Catoosa"),
  "74016": p("OK", "Chelsea"),
  "74017": p("OK", "Claremore"),
  "74018": p("OK", "Claremore"),
  "74031": p("OK", "Foyil"),
  "74036": p("OK", "Inola"),
  "74053": p("OK", "Oologah"),
  "74080": p("OK", "Talala"),
  "74818": p("OK", "Seminole"),
  "74830": p("OK", "Bowlegs"),
  "74837": p("OK", "Cromwell"),
  "74849": p("OK", "Konawa"),
  "74867": p("OK", "Sasakwa"),
  "74868": p("OK", "Seminole"),
  "74884": p("OK", "Wewoka"),
  "74435": p("OK", "Gore"),
  "74936": p("OK", "Gans"),
  "74945": p("OK", "Marble City"),
  "74946": p("OK", "Moffett"),
  "74948": p("OK", "Muldrow"),
  "74954": p("OK", "Roland"),
  "74955": p("OK", "Sallisaw"),
  "74962": p("OK", "Vian"),
  "73055": p("OK", "Marlow"),
  "73425": p("OK", "Countyline"),
  "73434": p("OK", "Foster"),
  "73442": p("OK", "Loco"),
  "73491": p("OK", "Velma"),
  "73529": p("OK", "Comanche"),
  "73533": p("OK", "Duncan"),
  "73534": p("OK", "Duncan"),
  "73536": p("OK", "Duncan"),
  "73901": p("OK", "Adams"),
  "73939": p("OK", "Goodwell"),
  "73942": p("OK", "Guymon"),
  "73944": p("OK", "Hardesty"),
  "73945": p("OK", "Hooker"),
  "73949": p("OK", "Texhoma"),
  "73951": p("OK", "Tyrone"),
  "73530": p("OK", "Davidson"),
  "73542": p("OK", "Frederick"),
  "73546": p("OK", "Grandfield"),
  "73551": p("OK", "Hollister"),
  "73553": p("OK", "Loveland"),
  "73555": p("OK", "Manitou"),
  "73570": p("OK", "Tipton"),
  "74008": p("OK", "Bixby"),
  "74011": p("OK", "Broken Arrow"),
  "74012": p("OK", "Broken Arrow"),
  "74013": p("OK", "Broken Arrow"),
  "74021": p("OK", "Collinsville"),
  "74033": p("OK", "Glenpool"),
  "74037": p("OK", "Jenks"),
  "74043": p("OK", "Leonard"),
  "74050": p("OK", "Oakhurst"),
  "74055": p("OK", "Owasso"),
  "74063": p("OK", "Sand Springs"),
  "74073": p("OK", "Sperry"),
  "74101": p("OK", "Tulsa"),
  "74102": p("OK", "Tulsa"),
  "74103": p("OK", "Tulsa"),
  "74104": p("OK", "Tulsa"),
  "74105": p("OK", "Tulsa"),
  "74106": p("OK", "Tulsa"),
  "74107": p("OK", "Tulsa"),
  "74108": p("OK", "Tulsa"),
  "74110": p("OK", "Tulsa"),
  "74112": p("OK", "Tulsa"),
  "74114": p("OK", "Tulsa"),
  "74115": p("OK", "Tulsa"),
  "74116": p("OK", "Tulsa"),
  "74117": p("OK", "Tulsa"),
  "74119": p("OK", "Tulsa"),
  "74120": p("OK", "Tulsa"),
  "74121": p("OK", "Tulsa"),
  "74126": p("OK", "Tulsa"),
  "74128": p("OK", "Tulsa"),
  "74129": p("OK", "Tulsa"),
  "74130": p("OK", "Tulsa"),
  "74132": p("OK", "Tulsa"),
  "74133": p("OK", "Tulsa"),
  "74134": p("OK", "Tulsa"),
  "74135": p("OK", "Tulsa"),
  "74136": p("OK", "Tulsa"),
  "74137": p("OK", "Tulsa"),
  "74141": p("OK", "Tulsa"),
  "74145": p("OK", "Tulsa"),
  "74146": p("OK", "Tulsa"),
  "74147": p("OK", "Tulsa"),
  "74148": p("OK", "Tulsa"),
  "74149": p("OK", "Tulsa"),
  "74150": p("OK", "Tulsa"),
  "74152": p("OK", "Tulsa"),
  "74153": p("OK", "Tulsa"),
  "74155": p("OK", "Tulsa"),
  "74156": p("OK", "Tulsa"),
  "74157": p("OK", "Tulsa"),
  "74158": p("OK", "Tulsa"),
  "74159": p("OK", "Tulsa"),
  "74169": p("OK", "Tulsa"),
  "74170": p("OK", "Tulsa"),
  "74171": p("OK", "Tulsa"),
  "74172": p("OK", "Tulsa"),
  "74182": p("OK", "Tulsa"),
  "74186": p("OK", "Tulsa"),
  "74187": p("OK", "Tulsa"),
  "74192": p("OK", "Tulsa"),
  "74193": p("OK", "Tulsa"),
  "74014": p("OK", "Broken Arrow"),
  "74019": p("OK", "Claremore"),
  "74429": p("OK", "Coweta"),
  "74446": p("OK", "Okay"),
  "74454": p("OK", "Porter"),
  "74458": p("OK", "Redbird"),
  "74467": p("OK", "Wagoner"),
  "74477": p("OK", "Wagoner"),
  "74003": p("OK", "Bartlesville"),
  "74004": p("OK", "Bartlesville"),
  "74005": p("OK", "Bartlesville"),
  "74006": p("OK", "Bartlesville"),
  "74022": p("OK", "Copan"),
  "74029": p("OK", "Dewey"),
  "74051": p("OK", "Ochelata"),
  "74061": p("OK", "Ramona"),
  "74082": p("OK", "Vera"),
  "73021": p("OK", "Colony"),
  "73024": p("OK", "Corn"),
  "73622": p("OK", "Bessie"),
  "73624": p("OK", "Burns Flat"),
  "73626": p("OK", "Canute"),
  "73632": p("OK", "Cordell"),
  "73641": p("OK", "Dill City"),
  "73647": p("OK", "Foss"),
  "73661": p("OK", "Rocky"),
  "73664": p("OK", "Sentinel"),
  "73717": p("OK", "Alva"),
  "73731": p("OK", "Dacoma"),
  "73746": p("OK", "Hopeton"),
  "73842": p("OK", "Freedom"),
  "73860": p("OK", "Waynoka"),
  "73801": p("OK", "Woodward"),
  "73802": p("OK", "Woodward"),
  "73841": p("OK", "Fort Supply"),
  "73852": p("OK", "Mooreland"),
  "73853": p("OK", "Mutual"),
  "73857": p("OK", "Sharon"),
  "97814": p("OR", "Baker City"),
  "97819": p("OR", "Bridgeport"),
  "97833": p("OR", "Haines"),
  "97834": p("OR", "Halfway"),
  "97837": p("OR", "Hereford"),
  "97840": p("OR", "Oxbow"),
  "97870": p("OR", "Richland"),
  "97877": p("OR", "Sumpter"),
  "97884": p("OR", "Unity"),
  "97905": p("OR", "Durkee"),
  "97907": p("OR", "Huntington"),
  "97324": p("OR", "Alsea"),
  "97326": p("OR", "Blodgett"),
  "97330": p("OR", "Corvallis"),
  "97331": p("OR", "Corvallis"),
  "97333": p("OR", "Corvallis"),
  "97339": p("OR", "Corvallis"),
  "97370": p("OR", "Philomath"),
  "97456": p("OR", "Monroe"),
  "97004": p("OR", "Beavercreek"),
  "97009": p("OR", "Boring"),
  "97011": p("OR", "Brightwood"),
  "97013": p("OR", "Canby"),
  "97015": p("OR", "Clackamas"),
  "97017": p("OR", "Colton"),
  "97022": p("OR", "Eagle Creek"),
  "97023": p("OR", "Estacada"),
  "97027": p("OR", "Gladstone"),
  "97028": p("OR", "Government Camp"),
  "97034": p("OR", "Lake Oswego"),
  "97035": p("OR", "Lake Oswego"),
  "97036": p("OR", "Marylhurst"),
  "97038": p("OR", "Molalla"),
  "97042": p("OR", "Mulino"),
  "97045": p("OR", "Oregon City"),
  "97049": p("OR", "Rhododendron"),
  "97055": p("OR", "Sandy"),
  "97067": p("OR", "Welches"),
  "97068": p("OR", "West Linn"),
  "97070": p("OR", "Wilsonville"),
  "97089": p("OR", "Damascus"),
  "97222": p("OR", "Portland"),
  "97267": p("OR", "Portland"),
  "97268": p("OR", "Portland"),
  "97269": p("OR", "Portland"),
  "97102": p("OR", "Arch Cape"),
  "97103": p("OR", "Astoria"),
  "97110": p("OR", "Cannon Beach"),
  "97121": p("OR", "Hammond"),
  "97138": p("OR", "Seaside"),
  "97145": p("OR", "Tolovana Park"),
  "97146": p("OR", "Warrenton"),
  "97016": p("OR", "Clatskanie"),
  "97018": p("OR", "Columbia City"),
  "97048": p("OR", "Rainier"),
  "97051": p("OR", "Saint Helens"),
  "97053": p("OR", "Warren"),
  "97054": p("OR", "Deer Island"),
  "97056": p("OR", "Scappoose"),
  "97064": p("OR", "Vernonia"),
  "97407": p("OR", "Allegany"),
  "97411": p("OR", "Bandon"),
  "97414": p("OR", "Broadbent"),
  "97420": p("OR", "Coos Bay"),
  "97423": p("OR", "Coquille"),
  "97449": p("OR", "Lakeside"),
  "97458": p("OR", "Myrtle Point"),
  "97459": p("OR", "North Bend"),
  "97466": p("OR", "Powers"),
  "97751": p("OR", "Paulina"),
  "97752": p("OR", "Post"),
  "97753": p("OR", "Powell Butte"),
  "97754": p("OR", "Prineville"),
  "97406": p("OR", "Agness"),
  "97415": p("OR", "Brookings"),
  "97444": p("OR", "Gold Beach"),
  "97450": p("OR", "Langlois"),
  "97464": p("OR", "Ophir"),
  "97465": p("OR", "Port Orford"),
  "97476": p("OR", "Sixes"),
  "97491": p("OR", "Wedderburn"),
  "97701": p("OR", "Bend"),
  "97702": p("OR", "Bend"),
  "97703": p("OR", "Bend"),
  "97707": p("OR", "Bend"),
  "97708": p("OR", "Bend"),
  "97709": p("OR", "Bend"),
  "97712": p("OR", "Brothers"),
  "97739": p("OR", "La Pine"),
  "97756": p("OR", "Redmond"),
  "97759": p("OR", "Sisters"),
  "97760": p("OR", "Terrebonne"),
  "97410": p("OR", "Azalea"),
  "97416": p("OR", "Camas Valley"),
  "97417": p("OR", "Canyonville"),
  "97429": p("OR", "Days Creek"),
  "97432": p("OR", "Dillard"),
  "97435": p("OR", "Drain"),
  "97436": p("OR", "Elkton"),
  "97441": p("OR", "Gardiner"),
  "97442": p("OR", "Glendale"),
  "97443": p("OR", "Glide"),
  "97447": p("OR", "Idleyld Park"),
  "97457": p("OR", "Myrtle Creek"),
  "97462": p("OR", "Oakland"),
  "97467": p("OR", "Reedsport"),
  "97469": p("OR", "Riddle"),
  "97470": p("OR", "Roseburg"),
  "97471": p("OR", "Roseburg"),
  "97473": p("OR", "Scottsburg"),
  "97479": p("OR", "Sutherlin"),
  "97481": p("OR", "Tenmile"),
  "97484": p("OR", "Tiller"),
  "97486": p("OR", "Umpqua"),
  "97494": p("OR", "Wilbur"),
  "97495": p("OR", "Winchester"),
  "97496": p("OR", "Winston"),
  "97499": p("OR", "Yoncalla"),
  "97812": p("OR", "Arlington"),
  "97823": p("OR", "Condon"),
  "97861": p("OR", "Mikkalo"),
  "97817": p("OR", "Bates"),
  "97820": p("OR", "Canyon City"),
  "97825": p("OR", "Dayville"),
  "97845": p("OR", "John Day"),
  "97848": p("OR", "Kimberly"),
  "97856": p("OR", "Long Creek"),
  "97864": p("OR", "Monument"),
  "97865": p("OR", "Mount Vernon"),
  "97869": p("OR", "Prairie City"),
  "97873": p("OR", "Seneca"),
  "97710": p("OR", "Fields"),
  "97720": p("OR", "Burns"),
  "97721": p("OR", "Princeton"),
  "97722": p("OR", "Diamond"),
  "97732": p("OR", "Crane"),
  "97736": p("OR", "Frenchglen"),
  "97738": p("OR", "Hines"),
  "97758": p("OR", "Riley"),
  "97904": p("OR", "Drewsey"),
  "97014": p("OR", "Cascade Locks"),
  "97031": p("OR", "Hood River"),
  "97041": p("OR", "Mount Hood Parkdale"),
  "97044": p("OR", "Odell"),
  "97501": p("OR", "Medford"),
  "97502": p("OR", "Central Point"),
  "97503": p("OR", "White City"),
  "97504": p("OR", "Medford"),
  "97520": p("OR", "Ashland"),
  "97522": p("OR", "Butte Falls"),
  "97524": p("OR", "Eagle Point"),
  "97525": p("OR", "Gold Hill"),
  "97530": p("OR", "Jacksonville"),
  "97535": p("OR", "Phoenix"),
  "97536": p("OR", "Prospect"),
  "97537": p("OR", "Rogue River"),
  "97539": p("OR", "Shady Cove"),
  "97540": p("OR", "Talent"),
  "97541": p("OR", "Trail"),
  "97711": p("OR", "Ashwood"),
  "97730": p("OR", "Camp Sherman"),
  "97734": p("OR", "Culver"),
  "97741": p("OR", "Madras"),
  "97761": p("OR", "Warm Springs"),
  "97497": p("OR", "Wolf Creek"),
  "97523": p("OR", "Cave Junction"),
  "97526": p("OR", "Grants Pass"),
  "97527": p("OR", "Grants Pass"),
  "97528": p("OR", "Grants Pass"),
  "97531": p("OR", "Kerby"),
  "97532": p("OR", "Merlin"),
  "97533": p("OR", "Murphy"),
  "97534": p("OR", "O Brien"),
  "97538": p("OR", "Selma"),
  "97543": p("OR", "Wilderville"),
  "97544": p("OR", "Williams"),
  "97601": p("OR", "Klamath Falls"),
  "97602": p("OR", "Klamath Falls"),
  "97603": p("OR", "Klamath Falls"),
  "97604": p("OR", "Crater Lake"),
  "97621": p("OR", "Beatty"),
  "97622": p("OR", "Bly"),
  "97623": p("OR", "Bonanza"),
  "97624": p("OR", "Chiloquin"),
  "97625": p("OR", "Dairy"),
  "97626": p("OR", "Fort Klamath"),
  "97627": p("OR", "Keno"),
  "97632": p("OR", "Malin"),
  "97633": p("OR", "Merrill"),
  "97634": p("OR", "Midland"),
  "97639": p("OR", "Sprague River"),
  "97731": p("OR", "Chemult"),
  "97733": p("OR", "Crescent"),
  "97737": p("OR", "Gilchrist"),
  "97620": p("OR", "Adel"),
  "97630": p("OR", "Lakeview"),
  "97635": p("OR", "New Pine Creek"),
  "97636": p("OR", "Paisley"),
  "97637": p("OR", "Plush"),
  "97638": p("OR", "Silver Lake"),
  "97640": p("OR", "Summer Lake"),
  "97641": p("OR", "Christmas Valley"),
  "97735": p("OR", "Fort Rock"),
  "97401": p("OR", "Eugene"),
  "97402": p("OR", "Eugene"),
  "97403": p("OR", "Eugene"),
  "97404": p("OR", "Eugene"),
  "97405": p("OR", "Eugene"),
  "97408": p("OR", "Eugene"),
  "97409": p("OR", "Alvadore"),
  "97412": p("OR", "Blachly"),
  "97413": p("OR", "Blue River"),
  "97419": p("OR", "Cheshire"),
  "97424": p("OR", "Cottage Grove"),
  "97426": p("OR", "Creswell"),
  "97430": p("OR", "Deadwood"),
  "97431": p("OR", "Dexter"),
  "97434": p("OR", "Dorena"),
  "97437": p("OR", "Elmira"),
  "97438": p("OR", "Fall Creek"),
  "97439": p("OR", "Florence"),
  "97440": p("OR", "Eugene"),
  "97448": p("OR", "Junction City"),
  "97451": p("OR", "Lorane"),
  "97452": p("OR", "Lowell"),
  "97453": p("OR", "Mapleton"),
  "97454": p("OR", "Marcola"),
  "97455": p("OR", "Pleasant Hill"),
  "97461": p("OR", "Noti"),
  "97463": p("OR", "Oakridge"),
  "97475": p("OR", "Springfield"),
  "97477": p("OR", "Springfield"),
  "97478": p("OR", "Springfield"),
  "97480": p("OR", "Swisshome"),
  "97487": p("OR", "Veneta"),
  "97488": p("OR", "Vida"),
  "97489": p("OR", "Walterville"),
  "97490": p("OR", "Walton"),
  "97492": p("OR", "Westfir"),
  "97493": p("OR", "Westlake"),
  "97341": p("OR", "Depoe Bay"),
  "97343": p("OR", "Eddyville"),
  "97357": p("OR", "Logsden"),
  "97364": p("OR", "Neotsu"),
  "97365": p("OR", "Newport"),
  "97366": p("OR", "South Beach"),
  "97367": p("OR", "Lincoln City"),
  "97368": p("OR", "Otis"),
  "97369": p("OR", "Otter Rock"),
  "97376": p("OR", "Seal Rock"),
  "97380": p("OR", "Siletz"),
  "97388": p("OR", "Gleneden Beach"),
  "97390": p("OR", "Tidewater"),
  "97391": p("OR", "Toledo"),
  "97394": p("OR", "Waldport"),
  "97498": p("OR", "Yachats"),
  "97321": p("OR", "Albany"),
  "97322": p("OR", "Albany"),
  "97327": p("OR", "Brownsville"),
  "97329": p("OR", "Cascadia"),
  "97335": p("OR", "Crabtree"),
  "97336": p("OR", "Crawfordsville"),
  "97345": p("OR", "Foster"),
  "97348": p("OR", "Halsey"),
  "97355": p("OR", "Lebanon"),
  "97358": p("OR", "Lyons"),
  "97360": p("OR", "Mill City"),
  "97374": p("OR", "Scio"),
  "97377": p("OR", "Shedd"),
  "97386": p("OR", "Sweet Home"),
  "97389": p("OR", "Tangent"),
  "97446": p("OR", "Harrisburg"),
  "97901": p("OR", "Adrian"),
  "97902": p("OR", "Arock"),
  "97903": p("OR", "Brogan"),
  "97906": p("OR", "Harper"),
  "97908": p("OR", "Ironside"),
  "97909": p("OR", "Jamieson"),
  "97910": p("OR", "Jordan Valley"),
  "97911": p("OR", "Juntura"),
  "97913": p("OR", "Nyssa"),
  "97914": p("OR", "Ontario"),
  "97917": p("OR", "Riverside"),
  "97918": p("OR", "Vale"),
  "97920": p("OR", "Westfall"),
  "97002": p("OR", "Aurora"),
  "97020": p("OR", "Donald"),
  "97026": p("OR", "Gervais"),
  "97032": p("OR", "Hubbard"),
  "97071": p("OR", "Woodburn"),
  "97137": p("OR", "Saint Paul"),
  "97301": p("OR", "Salem"),
  "97302": p("OR", "Salem"),
  "97303": p("OR", "Salem"),
  "97305": p("OR", "Salem"),
  "97306": p("OR", "Salem"),
  "97307": p("OR", "Keizer"),
  "97308": p("OR", "Salem"),
  "97309": p("OR", "Salem"),
  "97310": p("OR", "Salem"),
  "97311": p("OR", "Salem"),
  "97312": p("OR", "Salem"),
  "97313": p("OR", "Salem"),
  "97314": p("OR", "Salem"),
  "97317": p("OR", "Salem"),
  "97325": p("OR", "Aumsville"),
  "97342": p("OR", "Detroit"),
  "97346": p("OR", "Gates"),
  "97350": p("OR", "Idanha"),
  "97352": p("OR", "Jefferson"),
  "97362": p("OR", "Mount Angel"),
  "97373": p("OR", "Saint Benedict"),
  "97375": p("OR", "Scotts Mills"),
  "97381": p("OR", "Silverton"),
  "97383": p("OR", "Stayton"),
  "97384": p("OR", "Mehama"),
  "97385": p("OR", "Sublimity"),
  "97392": p("OR", "Turner"),
  "97818": p("OR", "Boardman"),
  "97836": p("OR", "Heppner"),
  "97839": p("OR", "Lexington"),
  "97843": p("OR", "Ione"),
  "97844": p("OR", "Irrigon"),
  "97010": p("OR", "Bridal Veil"),
  "97019": p("OR", "Corbett"),
  "97024": p("OR", "Fairview"),
  "97030": p("OR", "Gresham"),
  "97060": p("OR", "Troutdale"),
  "97080": p("OR", "Gresham"),
  "97086": p("OR", "Happy Valley"),
  "97201": p("OR", "Portland"),
  "97202": p("OR", "Portland"),
  "97203": p("OR", "Portland"),
  "97204": p("OR", "Portland"),
  "97205": p("OR", "Portland"),
  "97206": p("OR", "Portland"),
  "97207": p("OR", "Portland"),
  "97208": p("OR", "Portland"),
  "97209": p("OR", "Portland"),
  "97210": p("OR", "Portland"),
  "97211": p("OR", "Portland"),
  "97212": p("OR", "Portland"),
  "97213": p("OR", "Portland"),
  "97214": p("OR", "Portland"),
  "97215": p("OR", "Portland"),
  "97216": p("OR", "Portland"),
  "97217": p("OR", "Portland"),
  "97218": p("OR", "Portland"),
  "97219": p("OR", "Portland"),
  "97220": p("OR", "Portland"),
  "97221": p("OR", "Portland"),
  "97227": p("OR", "Portland"),
  "97228": p("OR", "Portland"),
  "97230": p("OR", "Portland"),
  "97231": p("OR", "Portland"),
  "97232": p("OR", "Portland"),
  "97233": p("OR", "Portland"),
  "97236": p("OR", "Portland"),
  "97238": p("OR", "Portland"),
  "97239": p("OR", "Portland"),
  "97240": p("OR", "Portland"),
  "97242": p("OR", "Portland"),
  "97250": p("OR", "Portland"),
  "97251": p("OR", "Portland"),
  "97252": p("OR", "Portland"),
  "97253": p("OR", "Portland"),
  "97254": p("OR", "Portland"),
  "97256": p("OR", "Portland"),
  "97258": p("OR", "Portland"),
  "97266": p("OR", "Portland"),
  "97280": p("OR", "Portland"),
  "97282": p("OR", "Portland"),
  "97283": p("OR", "Portland"),
  "97286": p("OR", "Portland"),
  "97290": p("OR", "Portland"),
  "97292": p("OR", "Portland"),
  "97293": p("OR", "Portland"),
  "97294": p("OR", "Portland"),
  "97296": p("OR", "Portland"),
  "97304": p("OR", "Salem"),
  "97338": p("OR", "Dallas"),
  "97344": p("OR", "Falls City"),
  "97347": p("OR", "Grand Ronde"),
  "97351": p("OR", "Independence"),
  "97361": p("OR", "Monmouth"),
  "97371": p("OR", "Rickreall"),
  "97029": p("OR", "Grass Valley"),
  "97033": p("OR", "Kent"),
  "97039": p("OR", "Moro"),
  "97050": p("OR", "Rufus"),
  "97065": p("OR", "Wasco"),
  "97107": p("OR", "Bay City"),
  "97108": p("OR", "Beaver"),
  "97112": p("OR", "Cloverdale"),
  "97118": p("OR", "Garibaldi"),
  "97122": p("OR", "Hebo"),
  "97130": p("OR", "Manzanita"),
  "97131": p("OR", "Nehalem"),
  "97134": p("OR", "Oceanside"),
  "97135": p("OR", "Pacific City"),
  "97136": p("OR", "Rockaway Beach"),
  "97141": p("OR", "Tillamook"),
  "97143": p("OR", "Netarts"),
  "97147": p("OR", "Wheeler"),
  "97149": p("OR", "Neskowin"),
  "97801": p("OR", "Pendleton"),
  "97810": p("OR", "Adams"),
  "97813": p("OR", "Athena"),
  "97826": p("OR", "Echo"),
  "97835": p("OR", "Helix"),
  "97838": p("OR", "Hermiston"),
  "97859": p("OR", "Meacham"),
  "97862": p("OR", "Milton Freewater"),
  "97868": p("OR", "Pilot Rock"),
  "97875": p("OR", "Stanfield"),
  "97880": p("OR", "Ukiah"),
  "97882": p("OR", "Umatilla"),
  "97886": p("OR", "Weston"),
  "97824": p("OR", "Cove"),
  "97827": p("OR", "Elgin"),
  "97841": p("OR", "Imbler"),
  "97850": p("OR", "La Grande"),
  "97867": p("OR", "North Powder"),
  "97876": p("OR", "Summerville"),
  "97883": p("OR", "Union"),
  "97828": p("OR", "Enterprise"),
  "97842": p("OR", "Imnaha"),
  "97846": p("OR", "Joseph"),
  "97857": p("OR", "Lostine"),
  "97885": p("OR", "Wallowa"),
  "97001": p("OR", "Antelope"),
  "97021": p("OR", "Dufur"),
  "97037": p("OR", "Maupin"),
  "97040": p("OR", "Mosier"),
  "97057": p("OR", "Shaniko"),
  "97058": p("OR", "The Dalles"),
  "97063": p("OR", "Tygh Valley"),
  "97003": p("OR", "Beaverton"),
  "97005": p("OR", "Beaverton"),
  "97006": p("OR", "Beaverton"),
  "97007": p("OR", "Beaverton"),
  "97008": p("OR", "Beaverton"),
  "97062": p("OR", "Tualatin"),
  "97075": p("OR", "Beaverton"),
  "97076": p("OR", "Beaverton"),
  "97077": p("OR", "Beaverton"),
  "97078": p("OR", "Beaverton"),
  "97079": p("OR", "Beaverton"),
  "97106": p("OR", "Banks"),
  "97109": p("OR", "Buxton"),
  "97113": p("OR", "Cornelius"),
  "97116": p("OR", "Forest Grove"),
  "97117": p("OR", "Gales Creek"),
  "97119": p("OR", "Gaston"),
  "97123": p("OR", "Hillsboro"),
  "97124": p("OR", "Hillsboro"),
  "97125": p("OR", "Manning"),
  "97129": p("OR", "Hillsboro"),
  "97133": p("OR", "North Plains"),
  "97140": p("OR", "Sherwood"),
  "97144": p("OR", "Timber"),
  "97223": p("OR", "Portland"),
  "97224": p("OR", "Portland"),
  "97225": p("OR", "Portland"),
  "97229": p("OR", "Portland"),
  "97281": p("OR", "Portland"),
  "97291": p("OR", "Portland"),
  "97298": p("OR", "Portland"),
  "97750": p("OR", "Mitchell"),
  "97830": p("OR", "Fossil"),
  "97874": p("OR", "Spray"),
  "97101": p("OR", "Amity"),
  "97111": p("OR", "Carlton"),
  "97114": p("OR", "Dayton"),
  "97115": p("OR", "Dundee"),
  "97127": p("OR", "Lafayette"),
  "97128": p("OR", "Mcminnville"),
  "97132": p("OR", "Newberg"),
  "97148": p("OR", "Yamhill"),
  "97378": p("OR", "Sheridan"),
  "97396": p("OR", "Willamina"),
  "17301": p("PA", "Abbottstown"),
  "17303": p("PA", "Arendtsville"),
  "17304": p("PA", "Aspers"),
  "17306": p("PA", "Bendersville"),
  "17307": p("PA", "Biglerville"),
  "17310": p("PA", "Cashtown"),
  "17316": p("PA", "East Berlin"),
  "17320": p("PA", "Fairfield"),
  "17324": p("PA", "Gardners"),
  "17325": p("PA", "Gettysburg"),
  "17337": p("PA", "Idaville"),
  "17340": p("PA", "Littlestown"),
  "17343": p("PA", "Mc Knightstown"),
  "17344": p("PA", "Mc Sherrystown"),
  "17350": p("PA", "New Oxford"),
  "17353": p("PA", "Orrtanna"),
  "17372": p("PA", "York Springs"),
  "17375": p("PA", "Peach Glen"),
  "15006": p("PA", "Bairdford"),
  "15007": p("PA", "Bakerstown"),
  "15014": p("PA", "Brackenridge"),
  "15015": p("PA", "Bradfordwoods"),
  "15017": p("PA", "Bridgeville"),
  "15018": p("PA", "Buena Vista"),
  "15020": p("PA", "Bunola"),
  "15024": p("PA", "Cheswick"),
  "15025": p("PA", "Clairton"),
  "15026": p("PA", "Clinton"),
  "15028": p("PA", "Coulters"),
  "15030": p("PA", "Creighton"),
  "15031": p("PA", "Cuddy"),
  "15032": p("PA", "Curtisville"),
  "15034": p("PA", "Dravosburg"),
  "15035": p("PA", "East Mc Keesport"),
  "15037": p("PA", "Elizabeth"),
  "15044": p("PA", "Gibsonia"),
  "15045": p("PA", "Glassport"),
  "15046": p("PA", "Crescent"),
  "15047": p("PA", "Greenock"),
  "15049": p("PA", "Harwick"),
  "15051": p("PA", "Indianola"),
  "15056": p("PA", "Leetsdale"),
  "15064": p("PA", "Morgan"),
  "15065": p("PA", "Natrona Heights"),
  "15071": p("PA", "Oakdale"),
  "15075": p("PA", "Rural Ridge"),
  "15076": p("PA", "Russellton"),
  "15082": p("PA", "Sturgeon"),
  "15084": p("PA", "Tarentum"),
  "15086": p("PA", "Warrendale"),
  "15088": p("PA", "West Elizabeth"),
  "15090": p("PA", "Wexford"),
  "15091": p("PA", "Wildwood"),
  "15095": p("PA", "Warrendale"),
  "15096": p("PA", "Warrendale"),
  "15101": p("PA", "Allison Park"),
  "15102": p("PA", "Bethel Park"),
  "15104": p("PA", "Braddock"),
  "15106": p("PA", "Carnegie"),
  "15108": p("PA", "Coraopolis"),
  "15110": p("PA", "Duquesne"),
  "15112": p("PA", "East Pittsburgh"),
  "15116": p("PA", "Glenshaw"),
  "15120": p("PA", "Homestead"),
  "15122": p("PA", "West Mifflin"),
  "15123": p("PA", "West Mifflin"),
  "15126": p("PA", "Imperial"),
  "15127": p("PA", "Ingomar"),
  "15129": p("PA", "South Park"),
  "15131": p("PA", "Mckeesport"),
  "15132": p("PA", "Mckeesport"),
  "15133": p("PA", "Mckeesport"),
  "15134": p("PA", "Mckeesport"),
  "15135": p("PA", "Mckeesport"),
  "15136": p("PA", "Mc Kees Rocks"),
  "15137": p("PA", "North Versailles"),
  "15139": p("PA", "Oakmont"),
  "15140": p("PA", "Pitcairn"),
  "15142": p("PA", "Presto"),
  "15143": p("PA", "Sewickley"),
  "15144": p("PA", "Springdale"),
  "15145": p("PA", "Turtle Creek"),
  "15146": p("PA", "Monroeville"),
  "15147": p("PA", "Verona"),
  "15148": p("PA", "Wilmerding"),
  "15201": p("PA", "Pittsburgh"),
  "15202": p("PA", "Pittsburgh"),
  "15203": p("PA", "Pittsburgh"),
  "15204": p("PA", "Pittsburgh"),
  "15205": p("PA", "Pittsburgh"),
  "15206": p("PA", "Pittsburgh"),
  "15207": p("PA", "Pittsburgh"),
  "15208": p("PA", "Pittsburgh"),
  "15209": p("PA", "Pittsburgh"),
  "15210": p("PA", "Pittsburgh"),
  "15211": p("PA", "Pittsburgh"),
  "15212": p("PA", "Pittsburgh"),
  "15213": p("PA", "Pittsburgh"),
  "15214": p("PA", "Pittsburgh"),
  "15215": p("PA", "Pittsburgh"),
  "15216": p("PA", "Pittsburgh"),
  "15217": p("PA", "Pittsburgh"),
  "15218": p("PA", "Pittsburgh"),
  "15219": p("PA", "Pittsburgh"),
  "15220": p("PA", "Pittsburgh"),
  "15221": p("PA", "Pittsburgh"),
  "15222": p("PA", "Pittsburgh"),
  "15223": p("PA", "Pittsburgh"),
  "15224": p("PA", "Pittsburgh"),
  "15225": p("PA", "Pittsburgh"),
  "15226": p("PA", "Pittsburgh"),
  "15227": p("PA", "Pittsburgh"),
  "15228": p("PA", "Pittsburgh"),
  "15229": p("PA", "Pittsburgh"),
  "15230": p("PA", "Pittsburgh"),
  "15231": p("PA", "Pittsburgh"),
  "15232": p("PA", "Pittsburgh"),
  "15233": p("PA", "Pittsburgh"),
  "15234": p("PA", "Pittsburgh"),
  "15235": p("PA", "Pittsburgh"),
  "15236": p("PA", "Pittsburgh"),
  "15237": p("PA", "Pittsburgh"),
  "15238": p("PA", "Pittsburgh"),
  "15239": p("PA", "Pittsburgh"),
  "15240": p("PA", "Pittsburgh"),
  "15241": p("PA", "Pittsburgh"),
  "15242": p("PA", "Pittsburgh"),
  "15243": p("PA", "Pittsburgh"),
  "15244": p("PA", "Pittsburgh"),
  "15250": p("PA", "Pittsburgh"),
  "15251": p("PA", "Pittsburgh"),
  "15252": p("PA", "Pittsburgh"),
  "15253": p("PA", "Pittsburgh"),
  "15254": p("PA", "Pittsburgh"),
  "15255": p("PA", "Pittsburgh"),
  "15257": p("PA", "Pittsburgh"),
  "15258": p("PA", "Pittsburgh"),
  "15259": p("PA", "Pittsburgh"),
  "15260": p("PA", "Pittsburgh"),
  "15261": p("PA", "Pittsburgh"),
  "15262": p("PA", "Pittsburgh"),
  "15264": p("PA", "Pittsburgh"),
  "15265": p("PA", "Pittsburgh"),
  "15267": p("PA", "Pittsburgh"),
  "15268": p("PA", "Pittsburgh"),
  "15270": p("PA", "Pittsburgh"),
  "15272": p("PA", "Pittsburgh"),
  "15274": p("PA", "Pittsburgh"),
  "15275": p("PA", "Pittsburgh"),
  "15276": p("PA", "Pittsburgh"),
  "15277": p("PA", "Pittsburgh"),
  "15278": p("PA", "Pittsburgh"),
  "15279": p("PA", "Pittsburgh"),
  "15281": p("PA", "Pittsburgh"),
  "15282": p("PA", "Pittsburgh"),
  "15283": p("PA", "Pittsburgh"),
  "15286": p("PA", "Pittsburgh"),
  "15289": p("PA", "Pittsburgh"),
  "15290": p("PA", "Pittsburgh"),
  "15295": p("PA", "Pittsburgh"),
  "15656": p("PA", "Leechburg"),
  "15673": p("PA", "North Apollo"),
  "15682": p("PA", "Schenley"),
  "15686": p("PA", "Spring Church"),
  "15736": p("PA", "Elderton"),
  "15774": p("PA", "Shelocta"),
  "16049": p("PA", "Parker"),
  "16201": p("PA", "Kittanning"),
  "16210": p("PA", "Adrian"),
  "16212": p("PA", "Cadogan"),
  "16218": p("PA", "Cowansville"),
  "16222": p("PA", "Dayton"),
  "16223": p("PA", "Distant"),
  "16226": p("PA", "Ford City"),
  "16228": p("PA", "Ford Cliff"),
  "16229": p("PA", "Freeport"),
  "16236": p("PA", "Mc Grann"),
  "16238": p("PA", "Manorville"),
  "16244": p("PA", "Nu Mine"),
  "16245": p("PA", "Oak Ridge"),
  "16249": p("PA", "Rural Valley"),
  "16250": p("PA", "Sagamore"),
  "16253": p("PA", "Seminole"),
  "16259": p("PA", "Templeton"),
  "16261": p("PA", "Widnoon"),
  "16262": p("PA", "Worthington"),
  "16263": p("PA", "Yatesboro"),
  "15001": p("PA", "Aliquippa"),
  "15003": p("PA", "Ambridge"),
  "15005": p("PA", "Baden"),
  "15009": p("PA", "Beaver"),
  "15010": p("PA", "Beaver Falls"),
  "15027": p("PA", "Conway"),
  "15042": p("PA", "Freedom"),
  "15043": p("PA", "Georgetown"),
  "15050": p("PA", "Hookstown"),
  "15052": p("PA", "Industry"),
  "15059": p("PA", "Midland"),
  "15061": p("PA", "Monaca"),
  "15066": p("PA", "New Brighton"),
  "15074": p("PA", "Rochester"),
  "15077": p("PA", "Shippingport"),
  "15081": p("PA", "South Heights"),
  "16115": p("PA", "Darlington"),
  "16123": p("PA", "Fombell"),
  "16136": p("PA", "Koppel"),
  "16141": p("PA", "New Galilee"),
  "15521": p("PA", "Alum Bank"),
  "15522": p("PA", "Bedford"),
  "15533": p("PA", "Breezewood"),
  "15534": p("PA", "Buffalo Mills"),
  "15535": p("PA", "Clearville"),
  "15537": p("PA", "Everett"),
  "15539": p("PA", "Fishertown"),
  "15545": p("PA", "Hyndman"),
  "15550": p("PA", "Manns Choice"),
  "15554": p("PA", "New Paris"),
  "15559": p("PA", "Schellsburg"),
  "16633": p("PA", "Defiance"),
  "16650": p("PA", "Hopewell"),
  "16655": p("PA", "Imler"),
  "16659": p("PA", "Loysburg"),
  "16664": p("PA", "New Enterprise"),
  "16667": p("PA", "Osterburg"),
  "16670": p("PA", "Queen"),
  "16672": p("PA", "Riddlesburg"),
  "16678": p("PA", "Saxton"),
  "16679": p("PA", "Six Mile Run"),
  "16694": p("PA", "Wood"),
  "16695": p("PA", "Woodbury"),
  "17211": p("PA", "Artemas"),
  "18056": p("PA", "Hereford"),
  "19503": p("PA", "Bally"),
  "19504": p("PA", "Barto"),
  "19505": p("PA", "Bechtelsville"),
  "19506": p("PA", "Bernville"),
  "19507": p("PA", "Bethel"),
  "19508": p("PA", "Birdsboro"),
  "19510": p("PA", "Blandon"),
  "19511": p("PA", "Bowers"),
  "19512": p("PA", "Boyertown"),
  "19516": p("PA", "Centerport"),
  "19518": p("PA", "Douglassville"),
  "19519": p("PA", "Earlville"),
  "19522": p("PA", "Fleetwood"),
  "19523": p("PA", "Geigertown"),
  "19526": p("PA", "Hamburg"),
  "19529": p("PA", "Kempton"),
  "19530": p("PA", "Kutztown"),
  "19533": p("PA", "Leesport"),
  "19534": p("PA", "Lenhartsville"),
  "19535": p("PA", "Limekiln"),
  "19536": p("PA", "Lyon Station"),
  "19538": p("PA", "Maxatawny"),
  "19539": p("PA", "Mertztown"),
  "19540": p("PA", "Mohnton"),
  "19541": p("PA", "Mohrsville"),
  "19543": p("PA", "Morgantown"),
  "19544": p("PA", "Mount Aetna"),
  "19545": p("PA", "New Berlinville"),
  "19547": p("PA", "Oley"),
  "19548": p("PA", "Pine Forge"),
  "19550": p("PA", "Rehrersburg"),
  "19551": p("PA", "Robesonia"),
  "19554": p("PA", "Shartlesville"),
  "19555": p("PA", "Shoemakersville"),
  "19559": p("PA", "Strausstown"),
  "19560": p("PA", "Temple"),
  "19562": p("PA", "Topton"),
  "19564": p("PA", "Virginville"),
  "19565": p("PA", "Wernersville"),
  "19567": p("PA", "Womelsdorf"),
  "19601": p("PA", "Reading"),
  "19602": p("PA", "Reading"),
  "19603": p("PA", "Reading"),
  "19604": p("PA", "Reading"),
  "19605": p("PA", "Reading"),
  "19606": p("PA", "Reading"),
  "19607": p("PA", "Reading"),
  "19608": p("PA", "Reading"),
  "19609": p("PA", "Reading"),
  "19610": p("PA", "Reading"),
  "19611": p("PA", "Reading"),
  "19612": p("PA", "Reading"),
  "16601": p("PA", "Altoona"),
  "16602": p("PA", "Altoona"),
  "16603": p("PA", "Altoona"),
  "16617": p("PA", "Bellwood"),
  "16625": p("PA", "Claysburg"),
  "16631": p("PA", "Curryville"),
  "16635": p("PA", "Duncansville"),
  "16637": p("PA", "East Freedom"),
  "16648": p("PA", "Hollidaysburg"),
  "16662": p("PA", "Martinsburg"),
  "16665": p("PA", "Newry"),
  "16673": p("PA", "Roaring Spring"),
  "16682": p("PA", "Sproul"),
  "16684": p("PA", "Tipton"),
  "16686": p("PA", "Tyrone"),
  "16693": p("PA", "Williamsburg"),
  "16910": p("PA", "Alba"),
  "16914": p("PA", "Columbia Cross Roads"),
  "16925": p("PA", "Gillett"),
  "16926": p("PA", "Granville Summit"),
  "16945": p("PA", "Sylvania"),
  "16947": p("PA", "Troy"),
  "17724": p("PA", "Canton"),
  "17735": p("PA", "Grover"),
  "18810": p("PA", "Athens"),
  "18814": p("PA", "Burlington"),
  "18815": p("PA", "Camptown"),
  "18817": p("PA", "East Smithfield"),
  "18829": p("PA", "Le Raysville"),
  "18831": p("PA", "Milan"),
  "18832": p("PA", "Monroeton"),
  "18833": p("PA", "New Albany"),
  "18837": p("PA", "Rome"),
  "18840": p("PA", "Sayre"),
  "18845": p("PA", "Stevensville"),
  "18846": p("PA", "Sugar Run"),
  "18848": p("PA", "Towanda"),
  "18850": p("PA", "Ulster"),
  "18851": p("PA", "Warren Center"),
  "18853": p("PA", "Wyalusing"),
  "18854": p("PA", "Wysox"),
  "18039": p("PA", "Durham"),
  "18077": p("PA", "Riegelsville"),
  "18081": p("PA", "Springtown"),
  "18901": p("PA", "Doylestown"),
  "18902": p("PA", "Doylestown"),
  "18910": p("PA", "Bedminster"),
  "18911": p("PA", "Blooming Glen"),
  "18912": p("PA", "Buckingham"),
  "18913": p("PA", "Carversville"),
  "18914": p("PA", "Chalfont"),
  "18916": p("PA", "Danboro"),
  "18917": p("PA", "Dublin"),
  "18920": p("PA", "Erwinna"),
  "18921": p("PA", "Ferndale"),
  "18922": p("PA", "Forest Grove"),
  "18923": p("PA", "Fountainville"),
  "18925": p("PA", "Furlong"),
  "18927": p("PA", "Hilltown"),
  "18928": p("PA", "Holicong"),
  "18929": p("PA", "Jamison"),
  "18930": p("PA", "Kintnersville"),
  "18931": p("PA", "Lahaska"),
  "18932": p("PA", "Line Lexington"),
  "18933": p("PA", "Lumberville"),
  "18934": p("PA", "Mechanicsville"),
  "18935": p("PA", "Milford Square"),
  "18938": p("PA", "New Hope"),
  "18940": p("PA", "Newtown"),
  "18942": p("PA", "Ottsville"),
  "18943": p("PA", "Penns Park"),
  "18944": p("PA", "Perkasie"),
  "18946": p("PA", "Pineville"),
  "18947": p("PA", "Pipersville"),
  "18949": p("PA", "Plumsteadville"),
  "18950": p("PA", "Point Pleasant"),
  "18951": p("PA", "Quakertown"),
  "18953": p("PA", "Revere"),
  "18954": p("PA", "Richboro"),
  "18955": p("PA", "Richlandtown"),
  "18956": p("PA", "Rushland"),
  "18960": p("PA", "Sellersville"),
  "18962": p("PA", "Silverdale"),
  "18963": p("PA", "Solebury"),
  "18966": p("PA", "Southampton"),
  "18968": p("PA", "Spinnerstown"),
  "18970": p("PA", "Trumbauersville"),
  "18972": p("PA", "Upper Black Eddy"),
  "18974": p("PA", "Warminster"),
  "18976": p("PA", "Warrington"),
  "18977": p("PA", "Washington Crossing"),
  "18980": p("PA", "Wycombe"),
  "18981": p("PA", "Zionhill"),
  "18991": p("PA", "Warminster"),
  "19007": p("PA", "Bristol"),
  "19020": p("PA", "Bensalem"),
  "19021": p("PA", "Croydon"),
  "19030": p("PA", "Fairless Hills"),
  "19047": p("PA", "Langhorne"),
  "19048": p("PA", "Langhorne"),
  "19049": p("PA", "Langhorne"),
  "19053": p("PA", "Feasterville Trevose"),
  "19054": p("PA", "Levittown"),
  "19055": p("PA", "Levittown"),
  "19056": p("PA", "Levittown"),
  "19057": p("PA", "Levittown"),
  "19058": p("PA", "Levittown"),
  "19067": p("PA", "Morrisville"),
  "16001": p("PA", "Butler"),
  "16002": p("PA", "Butler"),
  "16003": p("PA", "Butler"),
  "16016": p("PA", "Boyers"),
  "16017": p("PA", "Boyers"),
  "16018": p("PA", "Boyers"),
  "16020": p("PA", "Boyers"),
  "16021": p("PA", "Branchton"),
  "16022": p("PA", "Bruin"),
  "16023": p("PA", "Cabot"),
  "16024": p("PA", "Callery"),
  "16025": p("PA", "Chicora"),
  "16027": p("PA", "Connoquenessing"),
  "16029": p("PA", "East Butler"),
  "16030": p("PA", "Eau Claire"),
  "16033": p("PA", "Evans City"),
  "16034": p("PA", "Fenelton"),
  "16035": p("PA", "Forestville"),
  "16037": p("PA", "Harmony"),
  "16038": p("PA", "Harrisville"),
  "16039": p("PA", "Herman"),
  "16040": p("PA", "Hilliards"),
  "16041": p("PA", "Karns City"),
  "16045": p("PA", "Lyndora"),
  "16046": p("PA", "Mars"),
  "16048": p("PA", "North Washington"),
  "16050": p("PA", "Petrolia"),
  "16051": p("PA", "Portersville"),
  "16052": p("PA", "Prospect"),
  "16053": p("PA", "Renfrew"),
  "16055": p("PA", "Sarver"),
  "16056": p("PA", "Saxonburg"),
  "16057": p("PA", "Slippery Rock"),
  "16059": p("PA", "Valencia"),
  "16061": p("PA", "West Sunbury"),
  "16063": p("PA", "Zelienople"),
  "16066": p("PA", "Cranberry Township"),
  "15714": p("PA", "Northern Cambria"),
  "15722": p("PA", "Carrolltown"),
  "15737": p("PA", "Elmora"),
  "15738": p("PA", "Emeigh"),
  "15760": p("PA", "Marsteller"),
  "15762": p("PA", "Nicktown"),
  "15773": p("PA", "Saint Benedict"),
  "15775": p("PA", "Spangler"),
  "15901": p("PA", "Johnstown"),
  "15902": p("PA", "Johnstown"),
  "15904": p("PA", "Johnstown"),
  "15905": p("PA", "Johnstown"),
  "15906": p("PA", "Johnstown"),
  "15907": p("PA", "Johnstown"),
  "15909": p("PA", "Johnstown"),
  "15915": p("PA", "Johnstown"),
  "15921": p("PA", "Beaverdale"),
  "15922": p("PA", "Belsano"),
  "15925": p("PA", "Cassandra"),
  "15927": p("PA", "Colver"),
  "15930": p("PA", "Dunlo"),
  "15931": p("PA", "Ebensburg"),
  "15934": p("PA", "Elton"),
  "15938": p("PA", "Lilly"),
  "15940": p("PA", "Loretto"),
  "15942": p("PA", "Mineral Point"),
  "15943": p("PA", "Nanty Glo"),
  "15945": p("PA", "Parkhill"),
  "15946": p("PA", "Portage"),
  "15948": p("PA", "Revloc"),
  "15951": p("PA", "Saint Michael"),
  "15952": p("PA", "Salix"),
  "15955": p("PA", "Sidman"),
  "15956": p("PA", "South Fork"),
  "15958": p("PA", "Summerhill"),
  "15960": p("PA", "Twin Rocks"),
  "15961": p("PA", "Vintondale"),
  "15962": p("PA", "Wilmore"),
  "16613": p("PA", "Ashville"),
  "16619": p("PA", "Blandburg"),
  "16624": p("PA", "Chest Springs"),
  "16629": p("PA", "Coupon"),
  "16630": p("PA", "Cresson"),
  "16636": p("PA", "Dysart"),
  "16639": p("PA", "Fallentimber"),
  "16640": p("PA", "Flinton"),
  "16641": p("PA", "Gallitzin"),
  "16644": p("PA", "Glasgow"),
  "16646": p("PA", "Hastings"),
  "16668": p("PA", "Patton"),
  "16675": p("PA", "Saint Boniface"),
  "16699": p("PA", "Cresson"),
  "15832": p("PA", "Driftwood"),
  "15834": p("PA", "Emporium"),
  "15861": p("PA", "Sinnamahoning"),
  "18012": p("PA", "Aquashicola"),
  "18030": p("PA", "Bowmanstown"),
  "18071": p("PA", "Palmerton"),
  "18210": p("PA", "Albrightsville"),
  "18212": p("PA", "Ashfield"),
  "18216": p("PA", "Beaver Meadows"),
  "18229": p("PA", "Jim Thorpe"),
  "18230": p("PA", "Junedale"),
  "18232": p("PA", "Lansford"),
  "18235": p("PA", "Lehighton"),
  "18240": p("PA", "Nesquehoning"),
  "18244": p("PA", "Parryville"),
  "18250": p("PA", "Summit Hill"),
  "18254": p("PA", "Tresckow"),
  "18255": p("PA", "Weatherly"),
  "18624": p("PA", "Lake Harmony"),
  "16677": p("PA", "Sandy Ridge"),
  "16801": p("PA", "State College"),
  "16802": p("PA", "University Park"),
  "16803": p("PA", "State College"),
  "16804": p("PA", "State College"),
  "16805": p("PA", "State College"),
  "16820": p("PA", "Aaronsburg"),
  "16823": p("PA", "Bellefonte"),
  "16826": p("PA", "Blanchard"),
  "16827": p("PA", "Boalsburg"),
  "16828": p("PA", "Centre Hall"),
  "16829": p("PA", "Clarence"),
  "16832": p("PA", "Coburn"),
  "16835": p("PA", "Fleming"),
  "16841": p("PA", "Howard"),
  "16844": p("PA", "Julian"),
  "16851": p("PA", "Lemont"),
  "16852": p("PA", "Madisonburg"),
  "16853": p("PA", "Milesburg"),
  "16854": p("PA", "Millheim"),
  "16856": p("PA", "Mingoville"),
  "16859": p("PA", "Moshannon"),
  "16864": p("PA", "Orviston"),
  "16865": p("PA", "Pennsylvania Furnace"),
  "16866": p("PA", "Philipsburg"),
  "16868": p("PA", "Pine Grove Mills"),
  "16870": p("PA", "Port Matilda"),
  "16872": p("PA", "Rebersburg"),
  "16874": p("PA", "Snow Shoe"),
  "16875": p("PA", "Spring Mills"),
  "16882": p("PA", "Woodward"),
  "19301": p("PA", "Paoli"),
  "19310": p("PA", "Atglen"),
  "19311": p("PA", "Avondale"),
  "19312": p("PA", "Berwyn"),
  "19316": p("PA", "Brandamore"),
  "19318": p("PA", "Chatham"),
  "19320": p("PA", "Coatesville"),
  "19330": p("PA", "Cochranville"),
  "19333": p("PA", "Devon"),
  "19335": p("PA", "Downingtown"),
  "19341": p("PA", "Exton"),
  "19343": p("PA", "Glenmoore"),
  "19344": p("PA", "Honey Brook"),
  "19345": p("PA", "Immaculata"),
  "19346": p("PA", "Kelton"),
  "19347": p("PA", "Kemblesville"),
  "19348": p("PA", "Kennett Square"),
  "19350": p("PA", "Landenberg"),
  "19351": p("PA", "Lewisville"),
  "19352": p("PA", "Lincoln University"),
  "19353": p("PA", "Lionville"),
  "19354": p("PA", "Lyndell"),
  "19355": p("PA", "Malvern"),
  "19357": p("PA", "Mendenhall"),
  "19358": p("PA", "Modena"),
  "19360": p("PA", "New London"),
  "19362": p("PA", "Nottingham"),
  "19363": p("PA", "Oxford"),
  "19365": p("PA", "Parkesburg"),
  "19366": p("PA", "Pocopson"),
  "19367": p("PA", "Pomeroy"),
  "19369": p("PA", "Sadsburyville"),
  "19371": p("PA", "Suplee"),
  "19372": p("PA", "Thorndale"),
  "19374": p("PA", "Toughkenamon"),
  "19375": p("PA", "Unionville"),
  "19376": p("PA", "Wagontown"),
  "19380": p("PA", "West Chester"),
  "19381": p("PA", "West Chester"),
  "19382": p("PA", "West Chester"),
  "19383": p("PA", "West Chester"),
  "19390": p("PA", "West Grove"),
  "19395": p("PA", "Westtown"),
  "19397": p("PA", "Southeastern"),
  "19398": p("PA", "Southeastern"),
  "19399": p("PA", "Southeastern"),
  "19421": p("PA", "Birchrunville"),
  "19425": p("PA", "Chester Springs"),
  "19432": p("PA", "Devault"),
  "19442": p("PA", "Kimberton"),
  "19457": p("PA", "Parker Ford"),
  "19460": p("PA", "Phoenixville"),
  "19465": p("PA", "Pottstown"),
  "19470": p("PA", "Saint Peters"),
  "19475": p("PA", "Spring City"),
  "19480": p("PA", "Uwchland"),
  "19481": p("PA", "Valley Forge"),
  "19482": p("PA", "Valley Forge"),
  "19493": p("PA", "Valley Forge"),
  "19494": p("PA", "Valley Forge"),
  "19495": p("PA", "Valley Forge"),
  "19496": p("PA", "Valley Forge"),
  "19520": p("PA", "Elverson"),
  "16028": p("PA", "East Brady"),
  "16036": p("PA", "Foxburg"),
  "16054": p("PA", "Saint Petersburg"),
  "16058": p("PA", "Turkey City"),
  "16213": p("PA", "Callensburg"),
  "16214": p("PA", "Clarion"),
  "16220": p("PA", "Crown"),
  "16221": p("PA", "Curllsville"),
  "16224": p("PA", "Fairmount City"),
  "16225": p("PA", "Fisher"),
  "16230": p("PA", "Hawthorn"),
  "16232": p("PA", "Knox"),
  "16233": p("PA", "Leeper"),
  "16234": p("PA", "Limestone"),
  "16235": p("PA", "Lucinda"),
  "16240": p("PA", "Mayport"),
  "16242": p("PA", "New Bethlehem"),
  "16248": p("PA", "Rimersburg"),
  "16254": p("PA", "Shippenville"),
  "16255": p("PA", "Sligo"),
  "16257": p("PA", "Snydersburg"),
  "16258": p("PA", "Strattanville"),
  "16260": p("PA", "Vowinckel"),
  "16326": p("PA", "Fryburg"),
  "16331": p("PA", "Kossuth"),
  "16332": p("PA", "Lickingville"),
  "16334": p("PA", "Marble"),
  "16361": p("PA", "Tylersburg"),
  "16375": p("PA", "Lamartine"),
  "15721": p("PA", "Burnside"),
  "15753": p("PA", "La Jose"),
  "15757": p("PA", "Mahaffey"),
  "15801": p("PA", "Du Bois"),
  "15848": p("PA", "Luthersburg"),
  "15849": p("PA", "Penfield"),
  "15856": p("PA", "Rockton"),
  "15866": p("PA", "Troutville"),
  "16616": p("PA", "Beccaria"),
  "16620": p("PA", "Brisbin"),
  "16627": p("PA", "Coalport"),
  "16645": p("PA", "Glen Hope"),
  "16651": p("PA", "Houtzdale"),
  "16656": p("PA", "Irvona"),
  "16661": p("PA", "Madera"),
  "16663": p("PA", "Morann"),
  "16666": p("PA", "Osceola Mills"),
  "16671": p("PA", "Ramey"),
  "16680": p("PA", "Smithmill"),
  "16681": p("PA", "Smokerun"),
  "16692": p("PA", "Westover"),
  "16698": p("PA", "Houtzdale"),
  "16821": p("PA", "Allport"),
  "16825": p("PA", "Bigler"),
  "16830": p("PA", "Clearfield"),
  "16833": p("PA", "Curwensville"),
  "16834": p("PA", "Drifting"),
  "16836": p("PA", "Frenchville"),
  "16837": p("PA", "Glen Richey"),
  "16838": p("PA", "Grampian"),
  "16839": p("PA", "Grassflat"),
  "16840": p("PA", "Hawk Run"),
  "16843": p("PA", "Hyde"),
  "16845": p("PA", "Karthaus"),
  "16847": p("PA", "Kylertown"),
  "16849": p("PA", "Lanse"),
  "16850": p("PA", "Lecontes Mills"),
  "16855": p("PA", "Mineral Springs"),
  "16858": p("PA", "Morrisdale"),
  "16860": p("PA", "Munson"),
  "16861": p("PA", "New Millport"),
  "16863": p("PA", "Olanta"),
  "16871": p("PA", "Pottersdale"),
  "16873": p("PA", "Shawville"),
  "16876": p("PA", "Wallaceton"),
  "16878": p("PA", "West Decatur"),
  "16879": p("PA", "Winburne"),
  "16881": p("PA", "Woodland"),
  "16822": p("PA", "Beech Creek"),
  "16848": p("PA", "Lamar"),
  "17721": p("PA", "Avis"),
  "17726": p("PA", "Castanea"),
  "17745": p("PA", "Lock Haven"),
  "17747": p("PA", "Loganton"),
  "17748": p("PA", "Mc Elhattan"),
  "17750": p("PA", "Mackeyville"),
  "17751": p("PA", "Mill Hall"),
  "17760": p("PA", "North Bend"),
  "17764": p("PA", "Renovo"),
  "17778": p("PA", "Westport"),
  "17779": p("PA", "Woolrich"),
  "17814": p("PA", "Benton"),
  "17815": p("PA", "Bloomsburg"),
  "17820": p("PA", "Catawissa"),
  "17846": p("PA", "Millville"),
  "17858": p("PA", "Numidia"),
  "17859": p("PA", "Orangeville"),
  "17878": p("PA", "Stillwater"),
  "17888": p("PA", "Wilburton"),
  "17920": p("PA", "Aristes"),
  "18603": p("PA", "Berwick"),
  "18631": p("PA", "Mifflinville"),
  "16110": p("PA", "Adamsville"),
  "16111": p("PA", "Atlantic"),
  "16131": p("PA", "Hartstown"),
  "16314": p("PA", "Cochranton"),
  "16316": p("PA", "Conneaut Lake"),
  "16327": p("PA", "Guys Mills"),
  "16328": p("PA", "Hydetown"),
  "16335": p("PA", "Meadville"),
  "16354": p("PA", "Titusville"),
  "16360": p("PA", "Townville"),
  "16388": p("PA", "Meadville"),
  "16403": p("PA", "Cambridge Springs"),
  "16404": p("PA", "Centerville"),
  "16406": p("PA", "Conneautville"),
  "16422": p("PA", "Harmonsburg"),
  "16424": p("PA", "Linesville"),
  "16432": p("PA", "Riceville"),
  "16433": p("PA", "Saegertown"),
  "16434": p("PA", "Spartansburg"),
  "16435": p("PA", "Springboro"),
  "16440": p("PA", "Venango"),
  "17001": p("PA", "Camp Hill"),
  "17007": p("PA", "Boiling Springs"),
  "17011": p("PA", "Camp Hill"),
  "17012": p("PA", "Camp Hill"),
  "17013": p("PA", "Carlisle"),
  "17015": p("PA", "Carlisle"),
  "17025": p("PA", "Enola"),
  "17027": p("PA", "Grantham"),
  "17043": p("PA", "Lemoyne"),
  "17050": p("PA", "Mechanicsburg"),
  "17055": p("PA", "Mechanicsburg"),
  "17065": p("PA", "Mount Holly Springs"),
  "17070": p("PA", "New Cumberland"),
  "17072": p("PA", "New Kingstown"),
  "17081": p("PA", "Plainfield"),
  "17089": p("PA", "Camp Hill"),
  "17093": p("PA", "Summerdale"),
  "17240": p("PA", "Newburg"),
  "17241": p("PA", "Newville"),
  "17257": p("PA", "Shippensburg"),
  "17266": p("PA", "Walnut Bottom"),
  "17005": p("PA", "Berrysburg"),
  "17018": p("PA", "Dauphin"),
  "17023": p("PA", "Elizabethville"),
  "17028": p("PA", "Grantville"),
  "17030": p("PA", "Gratz"),
  "17032": p("PA", "Halifax"),
  "17033": p("PA", "Hershey"),
  "17034": p("PA", "Highspire"),
  "17036": p("PA", "Hummelstown"),
  "17048": p("PA", "Lykens"),
  "17057": p("PA", "Middletown"),
  "17061": p("PA", "Millersburg"),
  "17080": p("PA", "Pillow"),
  "17097": p("PA", "Wiconisco"),
  "17098": p("PA", "Williamstown"),
  "17101": p("PA", "Harrisburg"),
  "17102": p("PA", "Harrisburg"),
  "17103": p("PA", "Harrisburg"),
  "17104": p("PA", "Harrisburg"),
  "17105": p("PA", "Harrisburg"),
  "17106": p("PA", "Harrisburg"),
  "17107": p("PA", "Harrisburg"),
  "17108": p("PA", "Harrisburg"),
  "17109": p("PA", "Harrisburg"),
  "17110": p("PA", "Harrisburg"),
  "17111": p("PA", "Harrisburg"),
  "17112": p("PA", "Harrisburg"),
  "17113": p("PA", "Harrisburg"),
  "17120": p("PA", "Harrisburg"),
  "17121": p("PA", "Harrisburg"),
  "17122": p("PA", "Harrisburg"),
  "17123": p("PA", "Harrisburg"),
  "17124": p("PA", "Harrisburg"),
  "17125": p("PA", "Harrisburg"),
  "17126": p("PA", "Harrisburg"),
  "17127": p("PA", "Harrisburg"),
  "17128": p("PA", "Harrisburg"),
  "17129": p("PA", "Harrisburg"),
  "17130": p("PA", "Harrisburg"),
  "17140": p("PA", "Harrisburg"),
  "17177": p("PA", "Harrisburg"),
  "19003": p("PA", "Ardmore"),
  "19008": p("PA", "Broomall"),
  "19010": p("PA", "Bryn Mawr"),
  "19013": p("PA", "Chester"),
  "19014": p("PA", "Aston"),
  "19015": p("PA", "Brookhaven"),
  "19016": p("PA", "Chester"),
  "19017": p("PA", "Chester Heights"),
  "19018": p("PA", "Clifton Heights"),
  "19022": p("PA", "Crum Lynne"),
  "19023": p("PA", "Darby"),
  "19026": p("PA", "Drexel Hill"),
  "19028": p("PA", "Edgemont"),
  "19029": p("PA", "Essington"),
  "19032": p("PA", "Folcroft"),
  "19033": p("PA", "Folsom"),
  "19036": p("PA", "Glenolden"),
  "19037": p("PA", "Glen Riddle Lima"),
  "19039": p("PA", "Gradyville"),
  "19041": p("PA", "Haverford"),
  "19043": p("PA", "Holmes"),
  "19050": p("PA", "Lansdowne"),
  "19052": p("PA", "Lenni"),
  "19060": p("PA", "Garnet Valley"),
  "19061": p("PA", "Marcus Hook"),
  "19063": p("PA", "Media"),
  "19064": p("PA", "Springfield"),
  "19065": p("PA", "Media"),
  "19070": p("PA", "Morton"),
  "19073": p("PA", "Newtown Square"),
  "19074": p("PA", "Norwood"),
  "19076": p("PA", "Prospect Park"),
  "19078": p("PA", "Ridley Park"),
  "19079": p("PA", "Sharon Hill"),
  "19080": p("PA", "Wayne"),
  "19081": p("PA", "Swarthmore"),
  "19082": p("PA", "Upper Darby"),
  "19083": p("PA", "Havertown"),
  "19085": p("PA", "Villanova"),
  "19086": p("PA", "Wallingford"),
  "19087": p("PA", "Wayne"),
  "19088": p("PA", "Wayne"),
  "19089": p("PA", "Wayne"),
  "19091": p("PA", "Media"),
  "19094": p("PA", "Woodlyn"),
  "19098": p("PA", "Holmes"),
  "19113": p("PA", "Philadelphia"),
  "19317": p("PA", "Chadds Ford"),
  "19319": p("PA", "Cheyney"),
  "19331": p("PA", "Concordville"),
  "19339": p("PA", "Concordville"),
  "19340": p("PA", "Concordville"),
  "19342": p("PA", "Glen Mills"),
  "19373": p("PA", "Thornton"),
  "15821": p("PA", "Benezett"),
  "15822": p("PA", "Brandy Camp"),
  "15823": p("PA", "Brockport"),
  "15827": p("PA", "Byrnedale"),
  "15831": p("PA", "Dagus Mines"),
  "15841": p("PA", "Force"),
  "15845": p("PA", "Johnsonburg"),
  "15846": p("PA", "Kersey"),
  "15853": p("PA", "Ridgway"),
  "15857": p("PA", "Saint Marys"),
  "15868": p("PA", "Weedville"),
  "15870": p("PA", "Wilcox"),
  "16728": p("PA", "De Young"),
  "16734": p("PA", "James City"),
  "16401": p("PA", "Albion"),
  "16407": p("PA", "Corry"),
  "16410": p("PA", "Cranesville"),
  "16411": p("PA", "East Springfield"),
  "16412": p("PA", "Edinboro"),
  "16413": p("PA", "Elgin"),
  "16415": p("PA", "Fairview"),
  "16417": p("PA", "Girard"),
  "16421": p("PA", "Harborcreek"),
  "16423": p("PA", "Lake City"),
  "16426": p("PA", "Mc Kean"),
  "16427": p("PA", "Mill Village"),
  "16428": p("PA", "North East"),
  "16430": p("PA", "North Springfield"),
  "16438": p("PA", "Union City"),
  "16441": p("PA", "Waterford"),
  "16442": p("PA", "Wattsburg"),
  "16443": p("PA", "West Springfield"),
  "16444": p("PA", "Edinboro"),
  "16475": p("PA", "Albion"),
  "16501": p("PA", "Erie"),
  "16502": p("PA", "Erie"),
  "16503": p("PA", "Erie"),
  "16504": p("PA", "Erie"),
  "16505": p("PA", "Erie"),
  "16506": p("PA", "Erie"),
  "16507": p("PA", "Erie"),
  "16508": p("PA", "Erie"),
  "16509": p("PA", "Erie"),
  "16510": p("PA", "Erie"),
  "16511": p("PA", "Erie"),
  "16512": p("PA", "Erie"),
  "16514": p("PA", "Erie"),
  "16515": p("PA", "Erie"),
  "16522": p("PA", "Erie"),
  "16530": p("PA", "Erie"),
  "16531": p("PA", "Erie"),
  "16534": p("PA", "Erie"),
  "16538": p("PA", "Erie"),
  "16541": p("PA", "Erie"),
  "16544": p("PA", "Erie"),
  "16546": p("PA", "Erie"),
  "16550": p("PA", "Erie"),
  "16553": p("PA", "Erie"),
  "16563": p("PA", "Erie"),
  "16565": p("PA", "Erie"),
  "15012": p("PA", "Belle Vernon"),
  "15401": p("PA", "Uniontown"),
  "15410": p("PA", "Adah"),
  "15413": p("PA", "Allison"),
  "15415": p("PA", "Brier Hill"),
  "15416": p("PA", "Brownfield"),
  "15417": p("PA", "Brownsville"),
  "15420": p("PA", "Cardale"),
  "15421": p("PA", "Chalk Hill"),
  "15422": p("PA", "Chestnut Ridge"),
  "15425": p("PA", "Connellsville"),
  "15428": p("PA", "Dawson"),
  "15430": p("PA", "Dickerson Run"),
  "15431": p("PA", "Dunbar"),
  "15433": p("PA", "East Millsboro"),
  "15435": p("PA", "Fairbank"),
  "15436": p("PA", "Fairchance"),
  "15437": p("PA", "Farmington"),
  "15438": p("PA", "Fayette City"),
  "15439": p("PA", "Gans"),
  "15440": p("PA", "Gibbon Glade"),
  "15442": p("PA", "Grindstone"),
  "15443": p("PA", "Hibbs"),
  "15444": p("PA", "Hiller"),
  "15445": p("PA", "Hopwood"),
  "15446": p("PA", "Indian Head"),
  "15447": p("PA", "Isabella"),
  "15449": p("PA", "Keisterville"),
  "15450": p("PA", "La Belle"),
  "15451": p("PA", "Lake Lynn"),
  "15454": p("PA", "Leckrone"),
  "15455": p("PA", "Leisenring"),
  "15456": p("PA", "Lemont Furnace"),
  "15458": p("PA", "Mc Clellandtown"),
  "15459": p("PA", "Markleysburg"),
  "15460": p("PA", "Martin"),
  "15461": p("PA", "Masontown"),
  "15462": p("PA", "Melcroft"),
  "15463": p("PA", "Merrittstown"),
  "15464": p("PA", "Mill Run"),
  "15465": p("PA", "Mount Braddock"),
  "15466": p("PA", "Newell"),
  "15467": p("PA", "New Geneva"),
  "15468": p("PA", "New Salem"),
  "15469": p("PA", "Normalville"),
  "15470": p("PA", "Ohiopyle"),
  "15472": p("PA", "Oliver"),
  "15473": p("PA", "Perryopolis"),
  "15474": p("PA", "Point Marion"),
  "15475": p("PA", "Republic"),
  "15476": p("PA", "Ronco"),
  "15478": p("PA", "Smithfield"),
  "15480": p("PA", "Smock"),
  "15482": p("PA", "Star Junction"),
  "15484": p("PA", "Uledi"),
  "15486": p("PA", "Vanderbilt"),
  "15488": p("PA", "Waltersburg"),
  "15489": p("PA", "West Leisenring"),
  "15490": p("PA", "White"),
  "15492": p("PA", "Wickhaven"),
  "15631": p("PA", "Everson"),
  "15828": p("PA", "Clarington"),
  "16217": p("PA", "Cooksburg"),
  "16239": p("PA", "Marienville"),
  "16321": p("PA", "East Hickory"),
  "16322": p("PA", "Endeavor"),
  "16353": p("PA", "Tionesta"),
  "16370": p("PA", "West Hickory"),
  "17201": p("PA", "Chambersburg"),
  "17202": p("PA", "Chambersburg"),
  "17210": p("PA", "Amberson"),
  "17214": p("PA", "Blue Ridge Summit"),
  "17217": p("PA", "Concord"),
  "17219": p("PA", "Doylesburg"),
  "17220": p("PA", "Dry Run"),
  "17221": p("PA", "Fannettsburg"),
  "17222": p("PA", "Fayetteville"),
  "17224": p("PA", "Fort Loudon"),
  "17225": p("PA", "Greencastle"),
  "17231": p("PA", "Lemasters"),
  "17232": p("PA", "Lurgan"),
  "17235": p("PA", "Marion"),
  "17236": p("PA", "Mercersburg"),
  "17237": p("PA", "Mont Alto"),
  "17244": p("PA", "Orrstown"),
  "17246": p("PA", "Pleasant Hall"),
  "17247": p("PA", "Quincy"),
  "17250": p("PA", "Rouzerville"),
  "17251": p("PA", "Roxbury"),
  "17252": p("PA", "Saint Thomas"),
  "17254": p("PA", "Scotland"),
  "17256": p("PA", "Shady Grove"),
  "17261": p("PA", "South Mountain"),
  "17262": p("PA", "Spring Run"),
  "17263": p("PA", "State Line"),
  "17265": p("PA", "Upperstrasburg"),
  "17268": p("PA", "Waynesboro"),
  "17271": p("PA", "Willow Hill"),
  "17272": p("PA", "Zullinger"),
  "15536": p("PA", "Crystal Spring"),
  "16689": p("PA", "Waterfall"),
  "16691": p("PA", "Wells Tannery"),
  "17212": p("PA", "Big Cove Tannery"),
  "17215": p("PA", "Burnt Cabins"),
  "17223": p("PA", "Fort Littleton"),
  "17228": p("PA", "Harrisonville"),
  "17229": p("PA", "Hustontown"),
  "17233": p("PA", "Mc Connellsburg"),
  "17238": p("PA", "Needmore"),
  "17267": p("PA", "Warfordsburg"),
  "15310": p("PA", "Aleppo"),
  "15315": p("PA", "Bobtown"),
  "15316": p("PA", "Brave"),
  "15320": p("PA", "Carmichaels"),
  "15322": p("PA", "Clarksville"),
  "15325": p("PA", "Crucible"),
  "15327": p("PA", "Dilliner"),
  "15334": p("PA", "Garards Fort"),
  "15337": p("PA", "Graysville"),
  "15338": p("PA", "Greensboro"),
  "15341": p("PA", "Holbrook"),
  "15344": p("PA", "Jefferson"),
  "15346": p("PA", "Mather"),
  "15349": p("PA", "Mount Morris"),
  "15351": p("PA", "Nemacolin"),
  "15352": p("PA", "New Freeport"),
  "15353": p("PA", "Nineveh"),
  "15357": p("PA", "Rices Landing"),
  "15359": p("PA", "Rogersville"),
  "15362": p("PA", "Spraggs"),
  "15364": p("PA", "Sycamore"),
  "15370": p("PA", "Waynesburg"),
  "15380": p("PA", "Wind Ridge"),
  "16611": p("PA", "Alexandria"),
  "16621": p("PA", "Broad Top"),
  "16622": p("PA", "Calvin"),
  "16623": p("PA", "Cassville"),
  "16634": p("PA", "Dudley"),
  "16638": p("PA", "Entriken"),
  "16647": p("PA", "Hesston"),
  "16652": p("PA", "Huntingdon"),
  "16654": p("PA", "Huntingdon"),
  "16657": p("PA", "James Creek"),
  "16660": p("PA", "Mc Connellstown"),
  "16669": p("PA", "Petersburg"),
  "16674": p("PA", "Robertsdale"),
  "16683": p("PA", "Spruce Creek"),
  "16685": p("PA", "Todd"),
  "16877": p("PA", "Warriors Mark"),
  "17052": p("PA", "Mapleton Depot"),
  "17060": p("PA", "Mill Creek"),
  "17066": p("PA", "Mount Union"),
  "17213": p("PA", "Blairs Mills"),
  "17239": p("PA", "Neelyton"),
  "17243": p("PA", "Orbisonia"),
  "17249": p("PA", "Rockhill Furnace"),
  "17253": p("PA", "Saltillo"),
  "17255": p("PA", "Shade Gap"),
  "17260": p("PA", "Shirleysburg"),
  "17264": p("PA", "Three Springs"),
  "15681": p("PA", "Saltsburg"),
  "15701": p("PA", "Indiana"),
  "15705": p("PA", "Indiana"),
  "15710": p("PA", "Alverda"),
  "15712": p("PA", "Arcadia"),
  "15713": p("PA", "Aultman"),
  "15716": p("PA", "Black Lick"),
  "15717": p("PA", "Blairsville"),
  "15720": p("PA", "Brush Valley"),
  "15723": p("PA", "Chambersville"),
  "15724": p("PA", "Cherry Tree"),
  "15725": p("PA", "Clarksburg"),
  "15727": p("PA", "Clune"),
  "15728": p("PA", "Clymer"),
  "15729": p("PA", "Commodore"),
  "15731": p("PA", "Coral"),
  "15732": p("PA", "Creekside"),
  "15734": p("PA", "Dixonville"),
  "15739": p("PA", "Ernest"),
  "15741": p("PA", "Gipsy"),
  "15742": p("PA", "Glen Campbell"),
  "15745": p("PA", "Heilwood"),
  "15746": p("PA", "Hillsdale"),
  "15747": p("PA", "Home"),
  "15748": p("PA", "Homer City"),
  "15750": p("PA", "Josephine"),
  "15752": p("PA", "Kent"),
  "15754": p("PA", "Lucernemines"),
  "15756": p("PA", "Mc Intyre"),
  "15758": p("PA", "Marchand"),
  "15759": p("PA", "Marion Center"),
  "15761": p("PA", "Mentcle"),
  "15763": p("PA", "Northpoint"),
  "15765": p("PA", "Penn Run"),
  "15771": p("PA", "Rochester Mills"),
  "15772": p("PA", "Rossiter"),
  "15777": p("PA", "Starford"),
  "15783": p("PA", "West Lebanon"),
  "15920": p("PA", "Armagh"),
  "15929": p("PA", "Dilltown"),
  "15949": p("PA", "Robinson"),
  "15957": p("PA", "Strongstown"),
  "16211": p("PA", "Beyer"),
  "16246": p("PA", "Plumville"),
  "16256": p("PA", "Smicksburg"),
  "15711": p("PA", "Anita"),
  "15715": p("PA", "Big Run"),
  "15730": p("PA", "Coolspring"),
  "15733": p("PA", "De Lancey"),
  "15744": p("PA", "Hamilton"),
  "15764": p("PA", "Oliveburg"),
  "15767": p("PA", "Punxsutawney"),
  "15770": p("PA", "Ringgold"),
  "15776": p("PA", "Sprankle Mills"),
  "15778": p("PA", "Timblin"),
  "15780": p("PA", "Valier"),
  "15781": p("PA", "Walston"),
  "15784": p("PA", "Worthville"),
  "15824": p("PA", "Brockway"),
  "15825": p("PA", "Brookville"),
  "15829": p("PA", "Corsica"),
  "15840": p("PA", "Falls Creek"),
  "15847": p("PA", "Knox Dale"),
  "15851": p("PA", "Reynoldsville"),
  "15860": p("PA", "Sigel"),
  "15863": p("PA", "Stump Creek"),
  "15864": p("PA", "Summerville"),
  "15865": p("PA", "Sykesville"),
  "17014": p("PA", "Cocolamus"),
  "17021": p("PA", "East Waterford"),
  "17035": p("PA", "Honey Grove"),
  "17049": p("PA", "Mc Alisterville"),
  "17056": p("PA", "Mexico"),
  "17058": p("PA", "Mifflin"),
  "17059": p("PA", "Mifflintown"),
  "17076": p("PA", "Oakland Mills"),
  "17082": p("PA", "Port Royal"),
  "17086": p("PA", "Richfield"),
  "17094": p("PA", "Thompsontown"),
  "18403": p("PA", "Archbald"),
  "18407": p("PA", "Carbondale"),
  "18410": p("PA", "Chinchilla"),
  "18411": p("PA", "Clarks Summit"),
  "18414": p("PA", "Dalton"),
  "18416": p("PA", "Elmhurst"),
  "18420": p("PA", "Fleetville"),
  "18433": p("PA", "Jermyn"),
  "18434": p("PA", "Jessup"),
  "18440": p("PA", "La Plume"),
  "18444": p("PA", "Moscow"),
  "18447": p("PA", "Olyphant"),
  "18448": p("PA", "Olyphant"),
  "18452": p("PA", "Peckville"),
  "18471": p("PA", "Waverly"),
  "18501": p("PA", "Scranton"),
  "18502": p("PA", "Scranton"),
  "18503": p("PA", "Scranton"),
  "18504": p("PA", "Scranton"),
  "18505": p("PA", "Scranton"),
  "18507": p("PA", "Moosic"),
  "18508": p("PA", "Scranton"),
  "18509": p("PA", "Scranton"),
  "18510": p("PA", "Scranton"),
  "18512": p("PA", "Scranton"),
  "18515": p("PA", "Scranton"),
  "18517": p("PA", "Taylor"),
  "18518": p("PA", "Old Forge"),
  "18519": p("PA", "Scranton"),
  "18540": p("PA", "Scranton"),
  "18577": p("PA", "Scranton"),
  "18653": p("PA", "Ransom"),
  "17022": p("PA", "Elizabethtown"),
  "17501": p("PA", "Akron"),
  "17502": p("PA", "Bainbridge"),
  "17503": p("PA", "Bart"),
  "17504": p("PA", "Bausman"),
  "17505": p("PA", "Bird In Hand"),
  "17506": p("PA", "Blue Ball"),
  "17507": p("PA", "Bowmansville"),
  "17508": p("PA", "Brownstown"),
  "17509": p("PA", "Christiana"),
  "17512": p("PA", "Columbia"),
  "17516": p("PA", "Conestoga"),
  "17517": p("PA", "Denver"),
  "17518": p("PA", "Drumore"),
  "17519": p("PA", "East Earl"),
  "17520": p("PA", "East Petersburg"),
  "17521": p("PA", "Elm"),
  "17522": p("PA", "Ephrata"),
  "17527": p("PA", "Gap"),
  "17528": p("PA", "Goodville"),
  "17529": p("PA", "Gordonville"),
  "17532": p("PA", "Holtwood"),
  "17533": p("PA", "Hopeland"),
  "17534": p("PA", "Intercourse"),
  "17535": p("PA", "Kinzers"),
  "17536": p("PA", "Kirkwood"),
  "17537": p("PA", "Lampeter"),
  "17538": p("PA", "Landisville"),
  "17540": p("PA", "Leola"),
  "17543": p("PA", "Lititz"),
  "17545": p("PA", "Manheim"),
  "17547": p("PA", "Marietta"),
  "17549": p("PA", "Martindale"),
  "17550": p("PA", "Maytown"),
  "17551": p("PA", "Millersville"),
  "17552": p("PA", "Mount Joy"),
  "17554": p("PA", "Mountville"),
  "17555": p("PA", "Narvon"),
  "17557": p("PA", "New Holland"),
  "17560": p("PA", "New Providence"),
  "17562": p("PA", "Paradise"),
  "17563": p("PA", "Peach Bottom"),
  "17564": p("PA", "Penryn"),
  "17565": p("PA", "Pequea"),
  "17566": p("PA", "Quarryville"),
  "17567": p("PA", "Reamstown"),
  "17568": p("PA", "Refton"),
  "17569": p("PA", "Reinholds"),
  "17570": p("PA", "Rheems"),
  "17572": p("PA", "Ronks"),
  "17573": p("PA", "Ronks"),
  "17575": p("PA", "Silver Spring"),
  "17576": p("PA", "Smoketown"),
  "17578": p("PA", "Stevens"),
  "17579": p("PA", "Strasburg"),
  "17580": p("PA", "Talmage"),
  "17581": p("PA", "Terre Hill"),
  "17582": p("PA", "Washington Boro"),
  "17583": p("PA", "West Willow"),
  "17584": p("PA", "Willow Street"),
  "17585": p("PA", "Witmer"),
  "17601": p("PA", "Lancaster"),
  "17602": p("PA", "Lancaster"),
  "17603": p("PA", "Lancaster"),
  "17604": p("PA", "Lancaster"),
  "17605": p("PA", "Lancaster"),
  "17606": p("PA", "Lancaster"),
  "17607": p("PA", "Lancaster"),
  "17608": p("PA", "Lancaster"),
  "17611": p("PA", "Lancaster"),
  "17622": p("PA", "Lancaster"),
  "17699": p("PA", "Lancaster"),
  "19501": p("PA", "Adamstown"),
  "16101": p("PA", "New Castle"),
  "16102": p("PA", "New Castle"),
  "16103": p("PA", "New Castle"),
  "16105": p("PA", "New Castle"),
  "16107": p("PA", "New Castle"),
  "16108": p("PA", "New Castle"),
  "16112": p("PA", "Bessemer"),
  "16116": p("PA", "Edinburg"),
  "16117": p("PA", "Ellwood City"),
  "16120": p("PA", "Enon Valley"),
  "16132": p("PA", "Hillsville"),
  "16140": p("PA", "New Bedford"),
  "16142": p("PA", "New Wilmington"),
  "16143": p("PA", "Pulaski"),
  "16155": p("PA", "Villa Maria"),
  "16156": p("PA", "Volant"),
  "16157": p("PA", "Wampum"),
  "16160": p("PA", "West Pittsburg"),
  "16172": p("PA", "New Wilmington"),
  "17003": p("PA", "Annville"),
  "17010": p("PA", "Campbelltown"),
  "17016": p("PA", "Cornwall"),
  "17026": p("PA", "Fredericksburg"),
  "17038": p("PA", "Jonestown"),
  "17039": p("PA", "Kleinfeltersville"),
  "17041": p("PA", "Lawn"),
  "17042": p("PA", "Lebanon"),
  "17046": p("PA", "Lebanon"),
  "17064": p("PA", "Mount Gretna"),
  "17067": p("PA", "Myerstown"),
  "17073": p("PA", "Newmanstown"),
  "17077": p("PA", "Ono"),
  "17078": p("PA", "Palmyra"),
  "17083": p("PA", "Quentin"),
  "17085": p("PA", "Rexmont"),
  "17087": p("PA", "Richland"),
  "17088": p("PA", "Schaefferstown"),
  "18011": p("PA", "Alburtis"),
  "18025": p("PA", "Bethlehem"),
  "18031": p("PA", "Breinigsville"),
  "18032": p("PA", "Catasauqua"),
  "18034": p("PA", "Center Valley"),
  "18036": p("PA", "Coopersburg"),
  "18037": p("PA", "Coplay"),
  "18046": p("PA", "East Texas"),
  "18049": p("PA", "Emmaus"),
  "18051": p("PA", "Fogelsville"),
  "18052": p("PA", "Whitehall"),
  "18053": p("PA", "Germansville"),
  "18059": p("PA", "Laurys Station"),
  "18060": p("PA", "Limeport"),
  "18062": p("PA", "Macungie"),
  "18065": p("PA", "Neffs"),
  "18066": p("PA", "New Tripoli"),
  "18068": p("PA", "Old Zionsville"),
  "18069": p("PA", "Orefield"),
  "18078": p("PA", "Schnecksville"),
  "18079": p("PA", "Slatedale"),
  "18080": p("PA", "Slatington"),
  "18087": p("PA", "Trexlertown"),
  "18092": p("PA", "Zionsville"),
  "18098": p("PA", "Emmaus"),
  "18099": p("PA", "Emmaus"),
  "18101": p("PA", "Allentown"),
  "18102": p("PA", "Allentown"),
  "18103": p("PA", "Allentown"),
  "18104": p("PA", "Allentown"),
  "18105": p("PA", "Allentown"),
  "18106": p("PA", "Allentown"),
  "18109": p("PA", "Allentown"),
  "18195": p("PA", "Allentown"),
  "18201": p("PA", "Hazleton"),
  "18202": p("PA", "Hazleton"),
  "18219": p("PA", "Conyngham"),
  "18221": p("PA", "Drifton"),
  "18222": p("PA", "Drums"),
  "18223": p("PA", "Ebervale"),
  "18224": p("PA", "Freeland"),
  "18225": p("PA", "Harleigh"),
  "18234": p("PA", "Lattimer Mines"),
  "18239": p("PA", "Milnesville"),
  "18246": p("PA", "Rock Glen"),
  "18247": p("PA", "Saint Johns"),
  "18249": p("PA", "Sugarloaf"),
  "18251": p("PA", "Sybertsville"),
  "18256": p("PA", "Weston"),
  "18601": p("PA", "Beach Haven"),
  "18602": p("PA", "Bear Creek"),
  "18611": p("PA", "Cambra"),
  "18612": p("PA", "Dallas"),
  "18617": p("PA", "Glen Lyon"),
  "18618": p("PA", "Harveys Lake"),
  "18621": p("PA", "Hunlock Creek"),
  "18622": p("PA", "Huntington Mills"),
  "18627": p("PA", "Lehman"),
  "18634": p("PA", "Nanticoke"),
  "18635": p("PA", "Nescopeck"),
  "18640": p("PA", "Pittston"),
  "18641": p("PA", "Pittston"),
  "18642": p("PA", "Duryea"),
  "18643": p("PA", "Pittston"),
  "18644": p("PA", "Wyoming"),
  "18651": p("PA", "Plymouth"),
  "18654": p("PA", "Shawanese"),
  "18655": p("PA", "Shickshinny"),
  "18656": p("PA", "Sweet Valley"),
  "18660": p("PA", "Wapwallopen"),
  "18661": p("PA", "White Haven"),
  "18690": p("PA", "Dallas"),
  "18701": p("PA", "Wilkes Barre"),
  "18702": p("PA", "Wilkes Barre"),
  "18703": p("PA", "Wilkes Barre"),
  "18704": p("PA", "Kingston"),
  "18705": p("PA", "Wilkes Barre"),
  "18706": p("PA", "Wilkes Barre"),
  "18707": p("PA", "Mountain Top"),
  "18708": p("PA", "Shavertown"),
  "18709": p("PA", "Luzerne"),
  "18710": p("PA", "Wilkes Barre"),
  "18711": p("PA", "Wilkes Barre"),
  "18762": p("PA", "Wilkes Barre"),
  "18764": p("PA", "Wilkes Barre"),
  "18765": p("PA", "Wilkes Barre"),
  "18766": p("PA", "Wilkes Barre"),
  "18767": p("PA", "Wilkes Barre"),
  "18769": p("PA", "Wilkes Barre"),
  "18773": p("PA", "Wilkes Barre"),
  "17701": p("PA", "Williamsport"),
  "17702": p("PA", "Williamsport"),
  "17703": p("PA", "Williamsport"),
  "17705": p("PA", "Williamsport"),
  "17720": p("PA", "Antes Fort"),
  "17723": p("PA", "Jersey Shore"),
  "17727": p("PA", "Cedar Run"),
  "17728": p("PA", "Cogan Station"),
  "17737": p("PA", "Hughesville"),
  "17739": p("PA", "Jersey Mills"),
  "17740": p("PA", "Jersey Shore"),
  "17742": p("PA", "Lairdsville"),
  "17744": p("PA", "Linden"),
  "17752": p("PA", "Montgomery"),
  "17754": p("PA", "Montoursville"),
  "17756": p("PA", "Muncy"),
  "17762": p("PA", "Picture Rocks"),
  "17763": p("PA", "Ralston"),
  "17769": p("PA", "Slate Run"),
  "17771": p("PA", "Trout Run"),
  "17774": p("PA", "Unityville"),
  "17776": p("PA", "Waterville"),
  "16333": p("PA", "Ludlow"),
  "16701": p("PA", "Bradford"),
  "16724": p("PA", "Crosby"),
  "16725": p("PA", "Custer City"),
  "16726": p("PA", "Cyclone"),
  "16727": p("PA", "Derrick City"),
  "16729": p("PA", "Duke Center"),
  "16730": p("PA", "East Smethport"),
  "16731": p("PA", "Eldred"),
  "16732": p("PA", "Gifford"),
  "16733": p("PA", "Hazel Hurst"),
  "16735": p("PA", "Kane"),
  "16738": p("PA", "Lewis Run"),
  "16740": p("PA", "Mount Jewett"),
  "16743": p("PA", "Port Allegany"),
  "16744": p("PA", "Rew"),
  "16745": p("PA", "Rixford"),
  "16749": p("PA", "Smethport"),
  "16750": p("PA", "Turtlepoint"),
  "16113": p("PA", "Clark"),
  "16114": p("PA", "Clarks Mills"),
  "16121": p("PA", "Farrell"),
  "16124": p("PA", "Fredonia"),
  "16125": p("PA", "Greenville"),
  "16127": p("PA", "Grove City"),
  "16130": p("PA", "Hadley"),
  "16133": p("PA", "Jackson Center"),
  "16134": p("PA", "Jamestown"),
  "16137": p("PA", "Mercer"),
  "16145": p("PA", "Sandy Lake"),
  "16146": p("PA", "Sharon"),
  "16148": p("PA", "Hermitage"),
  "16150": p("PA", "Sharpsville"),
  "16151": p("PA", "Sheakleyville"),
  "16153": p("PA", "Stoneboro"),
  "16154": p("PA", "Transfer"),
  "16159": p("PA", "West Middlesex"),
  "16161": p("PA", "Wheatland"),
  "16311": p("PA", "Carlton"),
  "17002": p("PA", "Allensville"),
  "17004": p("PA", "Belleville"),
  "17009": p("PA", "Burnham"),
  "17029": p("PA", "Granville"),
  "17044": p("PA", "Lewistown"),
  "17051": p("PA", "Mc Veytown"),
  "17054": p("PA", "Mattawana"),
  "17063": p("PA", "Milroy"),
  "17075": p("PA", "Newton Hamilton"),
  "17084": p("PA", "Reedsville"),
  "17099": p("PA", "Yeagertown"),
  "18058": p("PA", "Kunkletown"),
  "18301": p("PA", "East Stroudsburg"),
  "18320": p("PA", "Analomink"),
  "18321": p("PA", "Bartonsville"),
  "18322": p("PA", "Brodheadsville"),
  "18323": p("PA", "Buck Hill Falls"),
  "18325": p("PA", "Canadensis"),
  "18326": p("PA", "Cresco"),
  "18327": p("PA", "Delaware Water Gap"),
  "18330": p("PA", "Effort"),
  "18331": p("PA", "Gilbert"),
  "18332": p("PA", "Henryville"),
  "18333": p("PA", "Kresgeville"),
  "18334": p("PA", "Long Pond"),
  "18335": p("PA", "Marshalls Creek"),
  "18341": p("PA", "Minisink Hills"),
  "18342": p("PA", "Mountainhome"),
  "18344": p("PA", "Mount Pocono"),
  "18346": p("PA", "Pocono Summit"),
  "18347": p("PA", "Pocono Lake"),
  "18348": p("PA", "Pocono Lake Preserve"),
  "18349": p("PA", "Pocono Manor"),
  "18350": p("PA", "Pocono Pines"),
  "18352": p("PA", "Reeders"),
  "18353": p("PA", "Saylorsburg"),
  "18354": p("PA", "Sciota"),
  "18355": p("PA", "Scotrun"),
  "18356": p("PA", "Shawnee On Delaware"),
  "18357": p("PA", "Skytop"),
  "18360": p("PA", "Stroudsburg"),
  "18370": p("PA", "Swiftwater"),
  "18372": p("PA", "Tannersville"),
  "18466": p("PA", "Tobyhanna"),
  "18610": p("PA", "Blakeslee"),
  "18041": p("PA", "East Greenville"),
  "18054": p("PA", "Green Lane"),
  "18070": p("PA", "Palm"),
  "18073": p("PA", "Pennsburg"),
  "18074": p("PA", "Perkiomenville"),
  "18076": p("PA", "Red Hill"),
  "18084": p("PA", "Sumneytown"),
  "18915": p("PA", "Colmar"),
  "18918": p("PA", "Earlington"),
  "18924": p("PA", "Franconia"),
  "18936": p("PA", "Montgomeryville"),
  "18957": p("PA", "Salford"),
  "18958": p("PA", "Salfordville"),
  "18964": p("PA", "Souderton"),
  "18969": p("PA", "Telford"),
  "18971": p("PA", "Tylersport"),
  "18979": p("PA", "Woxall"),
  "19001": p("PA", "Abington"),
  "19002": p("PA", "Ambler"),
  "19004": p("PA", "Bala Cynwyd"),
  "19006": p("PA", "Huntingdon Valley"),
  "19009": p("PA", "Bryn Athyn"),
  "19012": p("PA", "Cheltenham"),
  "19025": p("PA", "Dresher"),
  "19027": p("PA", "Elkins Park"),
  "19031": p("PA", "Flourtown"),
  "19034": p("PA", "Fort Washington"),
  "19035": p("PA", "Gladwyne"),
  "19038": p("PA", "Glenside"),
  "19040": p("PA", "Hatboro"),
  "19044": p("PA", "Horsham"),
  "19046": p("PA", "Jenkintown"),
  "19066": p("PA", "Merion Station"),
  "19072": p("PA", "Narberth"),
  "19075": p("PA", "Oreland"),
  "19090": p("PA", "Willow Grove"),
  "19095": p("PA", "Wyncote"),
  "19096": p("PA", "Wynnewood"),
  "19126": p("PA", "Philadelphia"),
  "19401": p("PA", "Norristown"),
  "19403": p("PA", "Norristown"),
  "19404": p("PA", "Norristown"),
  "19405": p("PA", "Bridgeport"),
  "19406": p("PA", "King Of Prussia"),
  "19407": p("PA", "Audubon"),
  "19408": p("PA", "Eagleville"),
  "19409": p("PA", "Fairview Village"),
  "19415": p("PA", "Eagleville"),
  "19422": p("PA", "Blue Bell"),
  "19423": p("PA", "Cedars"),
  "19424": p("PA", "Blue Bell"),
  "19426": p("PA", "Collegeville"),
  "19428": p("PA", "Conshohocken"),
  "19429": p("PA", "Conshohocken"),
  "19430": p("PA", "Creamery"),
  "19435": p("PA", "Frederick"),
  "19436": p("PA", "Gwynedd"),
  "19437": p("PA", "Gwynedd Valley"),
  "19438": p("PA", "Harleysville"),
  "19440": p("PA", "Hatfield"),
  "19441": p("PA", "Harleysville"),
  "19443": p("PA", "Kulpsville"),
  "19444": p("PA", "Lafayette Hill"),
  "19446": p("PA", "Lansdale"),
  "19450": p("PA", "Lederach"),
  "19451": p("PA", "Mainland"),
  "19453": p("PA", "Mont Clare"),
  "19454": p("PA", "North Wales"),
  "19455": p("PA", "North Wales"),
  "19456": p("PA", "Oaks"),
  "19462": p("PA", "Plymouth Meeting"),
  "19464": p("PA", "Pottstown"),
  "19468": p("PA", "Royersford"),
  "19472": p("PA", "Sassamansville"),
  "19473": p("PA", "Schwenksville"),
  "19474": p("PA", "Skippack"),
  "19477": p("PA", "Spring House"),
  "19478": p("PA", "Spring Mount"),
  "19484": p("PA", "Valley Forge"),
  "19486": p("PA", "West Point"),
  "19490": p("PA", "Worcester"),
  "19492": p("PA", "Zieglerville"),
  "19525": p("PA", "Gilbertsville"),
  "17821": p("PA", "Danville"),
  "17822": p("PA", "Danville"),
  "17884": p("PA", "Washingtonville"),
  "18001": p("PA", "Lehigh Valley"),
  "18002": p("PA", "Lehigh Valley"),
  "18003": p("PA", "Lehigh Valley"),
  "18013": p("PA", "Bangor"),
  "18014": p("PA", "Bath"),
  "18015": p("PA", "Bethlehem"),
  "18016": p("PA", "Bethlehem"),
  "18017": p("PA", "Bethlehem"),
  "18018": p("PA", "Bethlehem"),
  "18020": p("PA", "Bethlehem"),
  "18035": p("PA", "Cherryville"),
  "18038": p("PA", "Danielsville"),
  "18040": p("PA", "Easton"),
  "18042": p("PA", "Easton"),
  "18043": p("PA", "Easton"),
  "18044": p("PA", "Easton"),
  "18045": p("PA", "Easton"),
  "18055": p("PA", "Hellertown"),
  "18063": p("PA", "Martins Creek"),
  "18064": p("PA", "Nazareth"),
  "18067": p("PA", "Northampton"),
  "18072": p("PA", "Pen Argyl"),
  "18083": p("PA", "Stockertown"),
  "18085": p("PA", "Tatamy"),
  "18086": p("PA", "Treichlers"),
  "18088": p("PA", "Walnutport"),
  "18091": p("PA", "Wind Gap"),
  "18343": p("PA", "Mount Bethel"),
  "18351": p("PA", "Portland"),
  "17017": p("PA", "Dalmatia"),
  "17730": p("PA", "Dewart"),
  "17749": p("PA", "Mc Ewensville"),
  "17772": p("PA", "Turbotville"),
  "17777": p("PA", "Watsontown"),
  "17801": p("PA", "Sunbury"),
  "17823": p("PA", "Dornsife"),
  "17824": p("PA", "Elysburg"),
  "17830": p("PA", "Herndon"),
  "17832": p("PA", "Marion Heights"),
  "17834": p("PA", "Kulpmont"),
  "17836": p("PA", "Leck Kill"),
  "17840": p("PA", "Locust Gap"),
  "17847": p("PA", "Milton"),
  "17850": p("PA", "Montandon"),
  "17851": p("PA", "Mount Carmel"),
  "17857": p("PA", "Northumberland"),
  "17860": p("PA", "Paxinos"),
  "17865": p("PA", "Potts Grove"),
  "17866": p("PA", "Coal Township"),
  "17867": p("PA", "Rebuck"),
  "17868": p("PA", "Riverside"),
  "17872": p("PA", "Shamokin"),
  "17877": p("PA", "Snydertown"),
  "17881": p("PA", "Trevorton"),
  "17006": p("PA", "Blain"),
  "17020": p("PA", "Duncannon"),
  "17024": p("PA", "Elliottsburg"),
  "17037": p("PA", "Ickesburg"),
  "17040": p("PA", "Landisburg"),
  "17045": p("PA", "Liverpool"),
  "17047": p("PA", "Loysville"),
  "17053": p("PA", "Marysville"),
  "17062": p("PA", "Millerstown"),
  "17068": p("PA", "New Bloomfield"),
  "17069": p("PA", "New Buffalo"),
  "17071": p("PA", "New Germantown"),
  "17074": p("PA", "Newport"),
  "17090": p("PA", "Shermans Dale"),
  "19019": p("PA", "Philadelphia"),
  "19092": p("PA", "Philadelphia"),
  "19093": p("PA", "Philadelphia"),
  "19099": p("PA", "Philadelphia"),
  "19101": p("PA", "Philadelphia"),
  "19102": p("PA", "Philadelphia"),
  "19103": p("PA", "Philadelphia"),
  "19104": p("PA", "Philadelphia"),
  "19105": p("PA", "Philadelphia"),
  "19106": p("PA", "Philadelphia"),
  "19107": p("PA", "Philadelphia"),
  "19108": p("PA", "Philadelphia"),
  "19109": p("PA", "Philadelphia"),
  "19110": p("PA", "Philadelphia"),
  "19111": p("PA", "Philadelphia"),
  "19112": p("PA", "Philadelphia"),
  "19114": p("PA", "Philadelphia"),
  "19115": p("PA", "Philadelphia"),
  "19116": p("PA", "Philadelphia"),
  "19118": p("PA", "Philadelphia"),
  "19119": p("PA", "Philadelphia"),
  "19120": p("PA", "Philadelphia"),
  "19121": p("PA", "Philadelphia"),
  "19122": p("PA", "Philadelphia"),
  "19123": p("PA", "Philadelphia"),
  "19124": p("PA", "Philadelphia"),
  "19125": p("PA", "Philadelphia"),
  "19127": p("PA", "Philadelphia"),
  "19128": p("PA", "Philadelphia"),
  "19129": p("PA", "Philadelphia"),
  "19130": p("PA", "Philadelphia"),
  "19131": p("PA", "Philadelphia"),
  "19132": p("PA", "Philadelphia"),
  "19133": p("PA", "Philadelphia"),
  "19134": p("PA", "Philadelphia"),
  "19135": p("PA", "Philadelphia"),
  "19136": p("PA", "Philadelphia"),
  "19137": p("PA", "Philadelphia"),
  "19138": p("PA", "Philadelphia"),
  "19139": p("PA", "Philadelphia"),
  "19140": p("PA", "Philadelphia"),
  "19141": p("PA", "Philadelphia"),
  "19142": p("PA", "Philadelphia"),
  "19143": p("PA", "Philadelphia"),
  "19144": p("PA", "Philadelphia"),
  "19145": p("PA", "Philadelphia"),
  "19146": p("PA", "Philadelphia"),
  "19147": p("PA", "Philadelphia"),
  "19148": p("PA", "Philadelphia"),
  "19149": p("PA", "Philadelphia"),
  "19150": p("PA", "Philadelphia"),
  "19151": p("PA", "Philadelphia"),
  "19152": p("PA", "Philadelphia"),
  "19153": p("PA", "Philadelphia"),
  "19154": p("PA", "Philadelphia"),
  "19155": p("PA", "Philadelphia"),
  "19160": p("PA", "Philadelphia"),
  "19161": p("PA", "Philadelphia"),
  "19162": p("PA", "Philadelphia"),
  "19170": p("PA", "Philadelphia"),
  "19171": p("PA", "Philadelphia"),
  "19172": p("PA", "Philadelphia"),
  "19173": p("PA", "Philadelphia"),
  "19175": p("PA", "Philadelphia"),
  "19176": p("PA", "Philadelphia"),
  "19177": p("PA", "Philadelphia"),
  "19178": p("PA", "Philadelphia"),
  "19179": p("PA", "Philadelphia"),
  "19181": p("PA", "Philadelphia"),
  "19182": p("PA", "Philadelphia"),
  "19183": p("PA", "Philadelphia"),
  "19184": p("PA", "Philadelphia"),
  "19185": p("PA", "Philadelphia"),
  "19187": p("PA", "Philadelphia"),
  "19188": p("PA", "Philadelphia"),
  "19190": p("PA", "Philadelphia"),
  "19191": p("PA", "Philadelphia"),
  "19192": p("PA", "Philadelphia"),
  "19193": p("PA", "Philadelphia"),
  "19194": p("PA", "Philadelphia"),
  "19195": p("PA", "Philadelphia"),
  "19196": p("PA", "Philadelphia"),
  "19197": p("PA", "Philadelphia"),
  "19244": p("PA", "Philadelphia"),
  "19255": p("PA", "Philadelphia"),
  "18302": p("PA", "East Stroudsburg"),
  "18324": p("PA", "Bushkill"),
  "18328": p("PA", "Dingmans Ferry"),
  "18336": p("PA", "Matamoras"),
  "18337": p("PA", "Milford"),
  "18340": p("PA", "Millrift"),
  "18371": p("PA", "Tamiment"),
  "18425": p("PA", "Greeley"),
  "18426": p("PA", "Greentown"),
  "18435": p("PA", "Lackawaxen"),
  "18451": p("PA", "Paupack"),
  "18457": p("PA", "Rowland"),
  "18458": p("PA", "Shohola"),
  "18464": p("PA", "Tafton"),
  "16720": p("PA", "Austin"),
  "16746": p("PA", "Roulette"),
  "16748": p("PA", "Shinglehouse"),
  "16915": p("PA", "Coudersport"),
  "16922": p("PA", "Galeton"),
  "16923": p("PA", "Genesee"),
  "16927": p("PA", "Harrison Valley"),
  "16937": p("PA", "Mills"),
  "16941": p("PA", "Genesee"),
  "16948": p("PA", "Ulysses"),
  "17729": p("PA", "Cross Fork"),
  "17901": p("PA", "Pottsville"),
  "17921": p("PA", "Ashland"),
  "17922": p("PA", "Auburn"),
  "17923": p("PA", "Branchdale"),
  "17925": p("PA", "Brockton"),
  "17929": p("PA", "Cressona"),
  "17930": p("PA", "Cumbola"),
  "17931": p("PA", "Frackville"),
  "17932": p("PA", "Frackville"),
  "17933": p("PA", "Friedensburg"),
  "17934": p("PA", "Gilberton"),
  "17935": p("PA", "Girardville"),
  "17936": p("PA", "Gordon"),
  "17938": p("PA", "Hegins"),
  "17941": p("PA", "Klingerstown"),
  "17943": p("PA", "Lavelle"),
  "17944": p("PA", "Llewellyn"),
  "17945": p("PA", "Locustdale"),
  "17946": p("PA", "Lost Creek"),
  "17948": p("PA", "Mahanoy City"),
  "17949": p("PA", "Mahanoy Plane"),
  "17951": p("PA", "Mar Lin"),
  "17952": p("PA", "Mary D"),
  "17953": p("PA", "Middleport"),
  "17954": p("PA", "Minersville"),
  "17957": p("PA", "Muir"),
  "17959": p("PA", "New Philadelphia"),
  "17960": p("PA", "New Ringgold"),
  "17961": p("PA", "Orwigsburg"),
  "17963": p("PA", "Pine Grove"),
  "17964": p("PA", "Pitman"),
  "17965": p("PA", "Port Carbon"),
  "17966": p("PA", "Ravine"),
  "17967": p("PA", "Ringtown"),
  "17968": p("PA", "Sacramento"),
  "17970": p("PA", "Saint Clair"),
  "17972": p("PA", "Schuylkill Haven"),
  "17974": p("PA", "Seltzer"),
  "17976": p("PA", "Shenandoah"),
  "17978": p("PA", "Spring Glen"),
  "17979": p("PA", "Summit Station"),
  "17980": p("PA", "Tower City"),
  "17981": p("PA", "Tremont"),
  "17982": p("PA", "Tuscarora"),
  "17983": p("PA", "Valley View"),
  "17985": p("PA", "Zion Grove"),
  "18211": p("PA", "Andreas"),
  "18214": p("PA", "Barnesville"),
  "18218": p("PA", "Coaldale"),
  "18220": p("PA", "Delano"),
  "18231": p("PA", "Kelayres"),
  "18237": p("PA", "Mcadoo"),
  "18241": p("PA", "Nuremberg"),
  "18242": p("PA", "Oneida"),
  "18245": p("PA", "Quakake"),
  "18248": p("PA", "Sheppton"),
  "18252": p("PA", "Tamaqua"),
  "19549": p("PA", "Port Clinton"),
  "17812": p("PA", "Beaver Springs"),
  "17813": p("PA", "Beavertown"),
  "17827": p("PA", "Freeburg"),
  "17831": p("PA", "Hummels Wharf"),
  "17833": p("PA", "Kreamer"),
  "17841": p("PA", "Mc Clure"),
  "17842": p("PA", "Middleburg"),
  "17843": p("PA", "Beaver Springs"),
  "17853": p("PA", "Mount Pleasant Mills"),
  "17861": p("PA", "Paxtonville"),
  "17862": p("PA", "Penns Creek"),
  "17864": p("PA", "Port Trevorton"),
  "17870": p("PA", "Selinsgrove"),
  "17876": p("PA", "Shamokin Dam"),
  "17882": p("PA", "Troxelville"),
  "15411": p("PA", "Addison"),
  "15424": p("PA", "Confluence"),
  "15485": p("PA", "Ursina"),
  "15501": p("PA", "Somerset"),
  "15502": p("PA", "Hidden Valley"),
  "15510": p("PA", "Somerset"),
  "15520": p("PA", "Acosta"),
  "15530": p("PA", "Berlin"),
  "15531": p("PA", "Boswell"),
  "15532": p("PA", "Boynton"),
  "15538": p("PA", "Fairhope"),
  "15540": p("PA", "Fort Hill"),
  "15541": p("PA", "Friedens"),
  "15542": p("PA", "Garrett"),
  "15544": p("PA", "Gray"),
  "15546": p("PA", "Jenners"),
  "15547": p("PA", "Jennerstown"),
  "15548": p("PA", "Kantner"),
  "15549": p("PA", "Listie"),
  "15551": p("PA", "Markleton"),
  "15552": p("PA", "Meyersdale"),
  "15553": p("PA", "New Baltimore"),
  "15555": p("PA", "Quecreek"),
  "15557": p("PA", "Rockwood"),
  "15558": p("PA", "Salisbury"),
  "15560": p("PA", "Shanksville"),
  "15561": p("PA", "Sipesville"),
  "15562": p("PA", "Springs"),
  "15563": p("PA", "Stoystown"),
  "15564": p("PA", "Wellersburg"),
  "15565": p("PA", "West Salisbury"),
  "15924": p("PA", "Cairnbrook"),
  "15926": p("PA", "Central City"),
  "15928": p("PA", "Davidsville"),
  "15935": p("PA", "Hollsopple"),
  "15936": p("PA", "Hooversville"),
  "15937": p("PA", "Jerome"),
  "15953": p("PA", "Seanor"),
  "15959": p("PA", "Tire Hill"),
  "15963": p("PA", "Windber"),
  "17731": p("PA", "Eagles Mere"),
  "17758": p("PA", "Muncy Valley"),
  "17768": p("PA", "Shunk"),
  "18614": p("PA", "Dushore"),
  "18616": p("PA", "Forksville"),
  "18619": p("PA", "Hillsgrove"),
  "18626": p("PA", "Laporte"),
  "18628": p("PA", "Lopez"),
  "18632": p("PA", "Mildred"),
  "18413": p("PA", "Clifford"),
  "18421": p("PA", "Forest City"),
  "18430": p("PA", "Herrick Center"),
  "18441": p("PA", "Lenoxville"),
  "18465": p("PA", "Thompson"),
  "18470": p("PA", "Union Dale"),
  "18801": p("PA", "Montrose"),
  "18812": p("PA", "Brackney"),
  "18813": p("PA", "Brooklyn"),
  "18816": p("PA", "Dimock"),
  "18818": p("PA", "Friendsville"),
  "18820": p("PA", "Gibson"),
  "18821": p("PA", "Great Bend"),
  "18822": p("PA", "Hallstead"),
  "18823": p("PA", "Harford"),
  "18824": p("PA", "Hop Bottom"),
  "18825": p("PA", "Jackson"),
  "18826": p("PA", "Kingsley"),
  "18827": p("PA", "Lanesboro"),
  "18828": p("PA", "Lawton"),
  "18830": p("PA", "Little Meadows"),
  "18834": p("PA", "New Milford"),
  "18842": p("PA", "South Gibson"),
  "18843": p("PA", "South Montrose"),
  "18844": p("PA", "Springville"),
  "18847": p("PA", "Susquehanna"),
  "16901": p("PA", "Wellsboro"),
  "16911": p("PA", "Arnot"),
  "16912": p("PA", "Blossburg"),
  "16917": p("PA", "Covington"),
  "16920": p("PA", "Elkland"),
  "16921": p("PA", "Gaines"),
  "16928": p("PA", "Knoxville"),
  "16929": p("PA", "Lawrenceville"),
  "16930": p("PA", "Liberty"),
  "16932": p("PA", "Mainesburg"),
  "16933": p("PA", "Mansfield"),
  "16935": p("PA", "Middlebury Center"),
  "16936": p("PA", "Millerton"),
  "16938": p("PA", "Morris"),
  "16939": p("PA", "Morris Run"),
  "16940": p("PA", "Nelson"),
  "16942": p("PA", "Osceola"),
  "16943": p("PA", "Sabinsville"),
  "16946": p("PA", "Tioga"),
  "16950": p("PA", "Westfield"),
  "17765": p("PA", "Roaring Branch"),
  "17810": p("PA", "Allenwood"),
  "17829": p("PA", "Hartleton"),
  "17835": p("PA", "Laurelton"),
  "17837": p("PA", "Lewisburg"),
  "17844": p("PA", "Mifflinburg"),
  "17845": p("PA", "Millmont"),
  "17855": p("PA", "New Berlin"),
  "17856": p("PA", "New Columbia"),
  "17880": p("PA", "Swengel"),
  "17883": p("PA", "Vicksburg"),
  "17885": p("PA", "Weikert"),
  "17886": p("PA", "West Milton"),
  "17887": p("PA", "White Deer"),
  "17889": p("PA", "Winfield"),
  "16301": p("PA", "Oil City"),
  "16317": p("PA", "Cooperstown"),
  "16319": p("PA", "Cranberry"),
  "16323": p("PA", "Franklin"),
  "16341": p("PA", "Pleasantville"),
  "16342": p("PA", "Polk"),
  "16343": p("PA", "Reno"),
  "16344": p("PA", "Rouseville"),
  "16346": p("PA", "Seneca"),
  "16362": p("PA", "Utica"),
  "16364": p("PA", "Venus"),
  "16372": p("PA", "Clintonville"),
  "16373": p("PA", "Emlenton"),
  "16374": p("PA", "Kennerdell"),
  "16312": p("PA", "Chandlers Valley"),
  "16313": p("PA", "Clarendon"),
  "16329": p("PA", "Irvine"),
  "16340": p("PA", "Pittsfield"),
  "16345": p("PA", "Russell"),
  "16347": p("PA", "Sheffield"),
  "16350": p("PA", "Sugar Grove"),
  "16351": p("PA", "Tidioute"),
  "16352": p("PA", "Tiona"),
  "16365": p("PA", "Warren"),
  "16366": p("PA", "Warren"),
  "16367": p("PA", "Warren"),
  "16368": p("PA", "Irvine"),
  "16369": p("PA", "Irvine"),
  "16371": p("PA", "Youngsville"),
  "16402": p("PA", "Bear Lake"),
  "16405": p("PA", "Columbus"),
  "16416": p("PA", "Garland"),
  "16420": p("PA", "Grand Valley"),
  "16436": p("PA", "Spring Creek"),
  "15004": p("PA", "Atlasburg"),
  "15019": p("PA", "Bulger"),
  "15021": p("PA", "Burgettstown"),
  "15022": p("PA", "Charleroi"),
  "15033": p("PA", "Donora"),
  "15038": p("PA", "Elrama"),
  "15053": p("PA", "Joffre"),
  "15054": p("PA", "Langeloth"),
  "15055": p("PA", "Lawrence"),
  "15057": p("PA", "Mc Donald"),
  "15060": p("PA", "Midway"),
  "15063": p("PA", "Monongahela"),
  "15067": p("PA", "New Eagle"),
  "15078": p("PA", "Slovan"),
  "15301": p("PA", "Washington"),
  "15311": p("PA", "Amity"),
  "15312": p("PA", "Avella"),
  "15313": p("PA", "Beallsville"),
  "15314": p("PA", "Bentleyville"),
  "15317": p("PA", "Canonsburg"),
  "15321": p("PA", "Cecil"),
  "15323": p("PA", "Claysville"),
  "15324": p("PA", "Cokeburg"),
  "15329": p("PA", "Prosperity"),
  "15330": p("PA", "Eighty Four"),
  "15331": p("PA", "Ellsworth"),
  "15332": p("PA", "Finleyville"),
  "15333": p("PA", "Fredericktown"),
  "15336": p("PA", "Gastonville"),
  "15339": p("PA", "Hendersonville"),
  "15340": p("PA", "Hickory"),
  "15342": p("PA", "Houston"),
  "15345": p("PA", "Marianna"),
  "15347": p("PA", "Meadow Lands"),
  "15348": p("PA", "Millsboro"),
  "15350": p("PA", "Muse"),
  "15358": p("PA", "Richeyville"),
  "15360": p("PA", "Scenery Hill"),
  "15361": p("PA", "Southview"),
  "15363": p("PA", "Strabane"),
  "15365": p("PA", "Taylorstown"),
  "15366": p("PA", "Van Voorhis"),
  "15367": p("PA", "Venetia"),
  "15368": p("PA", "Vestaburg"),
  "15376": p("PA", "West Alexander"),
  "15377": p("PA", "West Finley"),
  "15378": p("PA", "Westland"),
  "15379": p("PA", "West Middletown"),
  "15412": p("PA", "Allenport"),
  "15419": p("PA", "California"),
  "15423": p("PA", "Coal Center"),
  "15427": p("PA", "Daisytown"),
  "15429": p("PA", "Denbo"),
  "15432": p("PA", "Dunlevy"),
  "15434": p("PA", "Elco"),
  "15477": p("PA", "Roscoe"),
  "15483": p("PA", "Stockdale"),
  "18405": p("PA", "Beach Lake"),
  "18415": p("PA", "Damascus"),
  "18417": p("PA", "Equinunk"),
  "18424": p("PA", "Gouldsboro"),
  "18427": p("PA", "Hamlin"),
  "18428": p("PA", "Hawley"),
  "18431": p("PA", "Honesdale"),
  "18436": p("PA", "Lake Ariel"),
  "18437": p("PA", "Lake Como"),
  "18438": p("PA", "Lakeville"),
  "18439": p("PA", "Lakewood"),
  "18443": p("PA", "Milanville"),
  "18445": p("PA", "Newfoundland"),
  "18449": p("PA", "Orson"),
  "18453": p("PA", "Pleasant Mount"),
  "18454": p("PA", "Poyntelle"),
  "18455": p("PA", "Preston Park"),
  "18456": p("PA", "Prompton"),
  "18459": p("PA", "South Canaan"),
  "18460": p("PA", "South Sterling"),
  "18461": p("PA", "Starlight"),
  "18462": p("PA", "Starrucca"),
  "18463": p("PA", "Sterling"),
  "18469": p("PA", "Tyler Hill"),
  "18472": p("PA", "Waymart"),
  "18473": p("PA", "White Mills"),
  "15062": p("PA", "Monessen"),
  "15068": p("PA", "New Kensington"),
  "15069": p("PA", "New Kensington"),
  "15072": p("PA", "Pricedale"),
  "15083": p("PA", "Sutersville"),
  "15085": p("PA", "Trafford"),
  "15087": p("PA", "Webster"),
  "15089": p("PA", "West Newton"),
  "15448": p("PA", "Jacobs Creek"),
  "15479": p("PA", "Smithton"),
  "15601": p("PA", "Greensburg"),
  "15605": p("PA", "Greensburg"),
  "15606": p("PA", "Greensburg"),
  "15610": p("PA", "Acme"),
  "15611": p("PA", "Adamsburg"),
  "15612": p("PA", "Alverton"),
  "15613": p("PA", "Apollo"),
  "15615": p("PA", "Ardara"),
  "15616": p("PA", "Armbrust"),
  "15617": p("PA", "Arona"),
  "15618": p("PA", "Avonmore"),
  "15619": p("PA", "Bovard"),
  "15620": p("PA", "Bradenville"),
  "15621": p("PA", "Calumet"),
  "15622": p("PA", "Champion"),
  "15623": p("PA", "Claridge"),
  "15624": p("PA", "Crabtree"),
  "15625": p("PA", "Darragh"),
  "15626": p("PA", "Delmont"),
  "15627": p("PA", "Derry"),
  "15628": p("PA", "Donegal"),
  "15629": p("PA", "East Vandergrift"),
  "15632": p("PA", "Export"),
  "15633": p("PA", "Forbes Road"),
  "15634": p("PA", "Grapeville"),
  "15635": p("PA", "Hannastown"),
  "15636": p("PA", "Harrison City"),
  "15637": p("PA", "Herminie"),
  "15638": p("PA", "Hostetter"),
  "15639": p("PA", "Hunker"),
  "15640": p("PA", "Hutchinson"),
  "15641": p("PA", "Hyde Park"),
  "15642": p("PA", "Irwin"),
  "15644": p("PA", "Jeannette"),
  "15646": p("PA", "Jones Mills"),
  "15647": p("PA", "Larimer"),
  "15650": p("PA", "Latrobe"),
  "15655": p("PA", "Laughlintown"),
  "15658": p("PA", "Ligonier"),
  "15660": p("PA", "Lowber"),
  "15661": p("PA", "Loyalhanna"),
  "15662": p("PA", "Luxor"),
  "15663": p("PA", "Madison"),
  "15664": p("PA", "Mammoth"),
  "15665": p("PA", "Manor"),
  "15666": p("PA", "Mount Pleasant"),
  "15668": p("PA", "Murrysville"),
  "15670": p("PA", "New Alexandria"),
  "15671": p("PA", "New Derry"),
  "15672": p("PA", "New Stanton"),
  "15674": p("PA", "Norvelt"),
  "15675": p("PA", "Penn"),
  "15676": p("PA", "Pleasant Unity"),
  "15677": p("PA", "Rector"),
  "15678": p("PA", "Rillton"),
  "15679": p("PA", "Ruffs Dale"),
  "15680": p("PA", "Salina"),
  "15683": p("PA", "Scottdale"),
  "15684": p("PA", "Slickville"),
  "15685": p("PA", "Southwest"),
  "15687": p("PA", "Stahlstown"),
  "15688": p("PA", "Tarrs"),
  "15689": p("PA", "United"),
  "15690": p("PA", "Vandergrift"),
  "15691": p("PA", "Wendel"),
  "15692": p("PA", "Westmoreland City"),
  "15693": p("PA", "Whitney"),
  "15695": p("PA", "Wyano"),
  "15696": p("PA", "Youngstown"),
  "15697": p("PA", "Youngwood"),
  "15698": p("PA", "Yukon"),
  "15779": p("PA", "Torrance"),
  "15923": p("PA", "Bolivar"),
  "15944": p("PA", "New Florence"),
  "15954": p("PA", "Seward"),
  "18419": p("PA", "Factoryville"),
  "18446": p("PA", "Nicholson"),
  "18615": p("PA", "Falls"),
  "18623": p("PA", "Laceyville"),
  "18625": p("PA", "Lake Winola"),
  "18629": p("PA", "Mehoopany"),
  "18630": p("PA", "Meshoppen"),
  "18636": p("PA", "Noxen"),
  "18657": p("PA", "Tunkhannock"),
  "17019": p("PA", "Dillsburg"),
  "17302": p("PA", "Airville"),
  "17309": p("PA", "Brogue"),
  "17311": p("PA", "Codorus"),
  "17312": p("PA", "Craley"),
  "17313": p("PA", "Dallastown"),
  "17314": p("PA", "Delta"),
  "17315": p("PA", "Dover"),
  "17317": p("PA", "East Prospect"),
  "17318": p("PA", "Emigsville"),
  "17319": p("PA", "Etters"),
  "17321": p("PA", "Fawn Grove"),
  "17322": p("PA", "Felton"),
  "17323": p("PA", "Franklintown"),
  "17327": p("PA", "Glen Rock"),
  "17329": p("PA", "Glenville"),
  "17331": p("PA", "Hanover"),
  "17332": p("PA", "Hanover"),
  "17333": p("PA", "Hanover"),
  "17334": p("PA", "Hanover"),
  "17335": p("PA", "Hanover"),
  "17339": p("PA", "Lewisberry"),
  "17342": p("PA", "Loganville"),
  "17345": p("PA", "Manchester"),
  "17347": p("PA", "Mount Wolf"),
  "17349": p("PA", "New Freedom"),
  "17352": p("PA", "New Park"),
  "17354": p("PA", "Porters Sideling"),
  "17355": p("PA", "Railroad"),
  "17356": p("PA", "Red Lion"),
  "17358": p("PA", "Rossville"),
  "17360": p("PA", "Seven Valleys"),
  "17361": p("PA", "Shrewsbury"),
  "17362": p("PA", "Spring Grove"),
  "17363": p("PA", "Stewartstown"),
  "17364": p("PA", "Thomasville"),
  "17365": p("PA", "Wellsville"),
  "17366": p("PA", "Windsor"),
  "17368": p("PA", "Wrightsville"),
  "17370": p("PA", "York Haven"),
  "17371": p("PA", "York New Salem"),
  "17401": p("PA", "York"),
  "17402": p("PA", "York"),
  "17403": p("PA", "York"),
  "17404": p("PA", "York"),
  "17405": p("PA", "York"),
  "17406": p("PA", "York"),
  "17407": p("PA", "York"),
  "17408": p("PA", "York"),
  "02806": p("RI", "Barrington"),
  "02809": p("RI", "Bristol"),
  "02872": p("RI", "Prudence Island"),
  "02885": p("RI", "Warren"),
  "02816": p("RI", "Coventry"),
  "02817": p("RI", "West Greenwich"),
  "02818": p("RI", "East Greenwich"),
  "02827": p("RI", "Greene"),
  "02886": p("RI", "Warwick"),
  "02887": p("RI", "Warwick"),
  "02888": p("RI", "Warwick"),
  "02889": p("RI", "Warwick"),
  "02893": p("RI", "West Warwick"),
  "02801": p("RI", "Adamsville"),
  "02835": p("RI", "Jamestown"),
  "02837": p("RI", "Little Compton"),
  "02840": p("RI", "Newport"),
  "02841": p("RI", "Newport"),
  "02842": p("RI", "Middletown"),
  "02871": p("RI", "Portsmouth"),
  "02878": p("RI", "Tiverton"),
  "02802": p("RI", "Albion"),
  "02814": p("RI", "Chepachet"),
  "02815": p("RI", "Clayville"),
  "02823": p("RI", "Fiskeville"),
  "02824": p("RI", "Forestdale"),
  "02825": p("RI", "Foster"),
  "02826": p("RI", "Glendale"),
  "02828": p("RI", "Greenville"),
  "02829": p("RI", "Harmony"),
  "02830": p("RI", "Harrisville"),
  "02831": p("RI", "Hope"),
  "02838": p("RI", "Manville"),
  "02839": p("RI", "Mapleville"),
  "02857": p("RI", "North Scituate"),
  "02858": p("RI", "Oakland"),
  "02859": p("RI", "Pascoag"),
  "02860": p("RI", "Pawtucket"),
  "02861": p("RI", "Pawtucket"),
  "02862": p("RI", "Pawtucket"),
  "02863": p("RI", "Central Falls"),
  "02864": p("RI", "Cumberland"),
  "02865": p("RI", "Lincoln"),
  "02876": p("RI", "Slatersville"),
  "02895": p("RI", "Woonsocket"),
  "02896": p("RI", "North Smithfield"),
  "02901": p("RI", "Providence"),
  "02902": p("RI", "Providence"),
  "02903": p("RI", "Providence"),
  "02904": p("RI", "Providence"),
  "02905": p("RI", "Providence"),
  "02906": p("RI", "Providence"),
  "02907": p("RI", "Providence"),
  "02908": p("RI", "Providence"),
  "02909": p("RI", "Providence"),
  "02910": p("RI", "Cranston"),
  "02911": p("RI", "North Providence"),
  "02912": p("RI", "Providence"),
  "02914": p("RI", "East Providence"),
  "02915": p("RI", "Riverside"),
  "02916": p("RI", "Rumford"),
  "02917": p("RI", "Smithfield"),
  "02918": p("RI", "Providence"),
  "02919": p("RI", "Johnston"),
  "02920": p("RI", "Cranston"),
  "02921": p("RI", "Cranston"),
  "02940": p("RI", "Providence"),
  "02804": p("RI", "Ashaway"),
  "02807": p("RI", "Block Island"),
  "02808": p("RI", "Bradford"),
  "02812": p("RI", "Carolina"),
  "02813": p("RI", "Charlestown"),
  "02822": p("RI", "Exeter"),
  "02832": p("RI", "Hope Valley"),
  "02833": p("RI", "Hopkinton"),
  "02836": p("RI", "Kenyon"),
  "02852": p("RI", "North Kingstown"),
  "02873": p("RI", "Rockville"),
  "02874": p("RI", "Saunderstown"),
  "02875": p("RI", "Shannock"),
  "02877": p("RI", "Slocum"),
  "02879": p("RI", "Wakefield"),
  "02880": p("RI", "Wakefield"),
  "02881": p("RI", "Kingston"),
  "02882": p("RI", "Narragansett"),
  "02883": p("RI", "Peace Dale"),
  "02891": p("RI", "Westerly"),
  "02892": p("RI", "West Kingston"),
  "02894": p("RI", "Wood River Junction"),
  "02898": p("RI", "Wyoming"),
  "29620": p("SC", "Abbeville"),
  "29628": p("SC", "Calhoun Falls"),
  "29638": p("SC", "Donalds"),
  "29639": p("SC", "Due West"),
  "29659": p("SC", "Lowndesville"),
  "29137": p("SC", "Salley"),
  "29164": p("SC", "Wagener"),
  "29801": p("SC", "Aiken"),
  "29802": p("SC", "Aiken"),
  "29803": p("SC", "Aiken"),
  "29804": p("SC", "Aiken"),
  "29805": p("SC", "Aiken"),
  "29808": p("SC", "Aiken"),
  "29809": p("SC", "New Ellenton"),
  "29816": p("SC", "Bath"),
  "29822": p("SC", "Clearwater"),
  "29828": p("SC", "Gloverville"),
  "29829": p("SC", "Graniteville"),
  "29831": p("SC", "Jackson"),
  "29834": p("SC", "Langley"),
  "29839": p("SC", "Montmorenci"),
  "29841": p("SC", "North Augusta"),
  "29842": p("SC", "Beech Island"),
  "29850": p("SC", "Vaucluse"),
  "29851": p("SC", "Warrenville"),
  "29856": p("SC", "Windsor"),
  "29860": p("SC", "North Augusta"),
  "29861": p("SC", "North Augusta"),
  "29810": p("SC", "Allendale"),
  "29827": p("SC", "Fairfax"),
  "29836": p("SC", "Martin"),
  "29846": p("SC", "Sycamore"),
  "29849": p("SC", "Ulmer"),
  "29621": p("SC", "Anderson"),
  "29622": p("SC", "Anderson"),
  "29623": p("SC", "Anderson"),
  "29624": p("SC", "Anderson"),
  "29625": p("SC", "Anderson"),
  "29626": p("SC", "Anderson"),
  "29627": p("SC", "Belton"),
  "29654": p("SC", "Honea Path"),
  "29655": p("SC", "Iva"),
  "29656": p("SC", "La France"),
  "29669": p("SC", "Pelzer"),
  "29670": p("SC", "Pendleton"),
  "29677": p("SC", "Sandy Springs"),
  "29684": p("SC", "Starr"),
  "29689": p("SC", "Townville"),
  "29697": p("SC", "Williamston"),
  "29003": p("SC", "Bamberg"),
  "29042": p("SC", "Denmark"),
  "29081": p("SC", "Ehrhardt"),
  "29843": p("SC", "Olar"),
  "29812": p("SC", "Barnwell"),
  "29813": p("SC", "Hilda"),
  "29817": p("SC", "Blackville"),
  "29826": p("SC", "Elko"),
  "29853": p("SC", "Williston"),
  "29901": p("SC", "Beaufort"),
  "29902": p("SC", "Beaufort"),
  "29903": p("SC", "Beaufort"),
  "29904": p("SC", "Beaufort"),
  "29905": p("SC", "Parris Island"),
  "29906": p("SC", "Beaufort"),
  "29907": p("SC", "Beaufort"),
  "29910": p("SC", "Bluffton"),
  "29914": p("SC", "Dale"),
  "29915": p("SC", "Daufuskie Island"),
  "29920": p("SC", "Saint Helena Island"),
  "29925": p("SC", "Hilton Head Island"),
  "29926": p("SC", "Hilton Head Island"),
  "29928": p("SC", "Hilton Head Island"),
  "29931": p("SC", "Lobeco"),
  "29935": p("SC", "Port Royal"),
  "29938": p("SC", "Hilton Head Island"),
  "29940": p("SC", "Seabrook"),
  "29941": p("SC", "Sheldon"),
  "29410": p("SC", "Hanahan"),
  "29431": p("SC", "Bonneau"),
  "29434": p("SC", "Cordesville"),
  "29436": p("SC", "Cross"),
  "29445": p("SC", "Goose Creek"),
  "29450": p("SC", "Huger"),
  "29453": p("SC", "Jamestown"),
  "29456": p("SC", "Ladson"),
  "29461": p("SC", "Moncks Corner"),
  "29468": p("SC", "Pineville"),
  "29469": p("SC", "Pinopolis"),
  "29476": p("SC", "Russellville"),
  "29479": p("SC", "Saint Stephen"),
  "29486": p("SC", "Summerville"),
  "29492": p("SC", "Charleston"),
  "29030": p("SC", "Cameron"),
  "29135": p("SC", "Saint Matthews"),
  "29401": p("SC", "Charleston"),
  "29402": p("SC", "Charleston"),
  "29403": p("SC", "Charleston"),
  "29404": p("SC", "Charleston Afb"),
  "29405": p("SC", "North Charleston"),
  "29406": p("SC", "Charleston"),
  "29407": p("SC", "Charleston"),
  "29409": p("SC", "Charleston"),
  "29412": p("SC", "Charleston"),
  "29413": p("SC", "Charleston"),
  "29414": p("SC", "Charleston"),
  "29415": p("SC", "North Charleston"),
  "29416": p("SC", "Charleston"),
  "29417": p("SC", "Charleston"),
  "29418": p("SC", "North Charleston"),
  "29419": p("SC", "North Charleston"),
  "29422": p("SC", "Charleston"),
  "29423": p("SC", "Charleston"),
  "29424": p("SC", "Charleston"),
  "29425": p("SC", "Charleston"),
  "29426": p("SC", "Adams Run"),
  "29429": p("SC", "Awendaw"),
  "29439": p("SC", "Folly Beach"),
  "29449": p("SC", "Hollywood"),
  "29451": p("SC", "Isle Of Palms"),
  "29455": p("SC", "Johns Island"),
  "29457": p("SC", "Johns Island"),
  "29458": p("SC", "Mc Clellanville"),
  "29464": p("SC", "Mount Pleasant"),
  "29465": p("SC", "Mount Pleasant"),
  "29466": p("SC", "Mount Pleasant"),
  "29470": p("SC", "Ravenel"),
  "29482": p("SC", "Sullivans Island"),
  "29487": p("SC", "Wadmalaw Island"),
  "29340": p("SC", "Gaffney"),
  "29341": p("SC", "Gaffney"),
  "29342": p("SC", "Gaffney"),
  "29702": p("SC", "Blacksburg"),
  "29014": p("SC", "Blackstock"),
  "29055": p("SC", "Great Falls"),
  "29706": p("SC", "Chester"),
  "29712": p("SC", "Edgemoor"),
  "29714": p("SC", "Fort Lawn"),
  "29724": p("SC", "Lando"),
  "29729": p("SC", "Richburg"),
  "29101": p("SC", "Mc Bee"),
  "29520": p("SC", "Cheraw"),
  "29584": p("SC", "Patrick"),
  "29709": p("SC", "Chesterfield"),
  "29718": p("SC", "Jefferson"),
  "29727": p("SC", "Mount Croghan"),
  "29728": p("SC", "Pageland"),
  "29741": p("SC", "Ruby"),
  "29001": p("SC", "Alcolu"),
  "29041": p("SC", "Davis Station"),
  "29051": p("SC", "Gable"),
  "29102": p("SC", "Manning"),
  "29111": p("SC", "New Zion"),
  "29143": p("SC", "Sardinia"),
  "29148": p("SC", "Summerton"),
  "29162": p("SC", "Turbeville"),
  "29082": p("SC", "Lodge"),
  "29433": p("SC", "Canadys"),
  "29435": p("SC", "Cottageville"),
  "29438": p("SC", "Edisto Island"),
  "29446": p("SC", "Green Pond"),
  "29452": p("SC", "Jacksonboro"),
  "29474": p("SC", "Round O"),
  "29475": p("SC", "Ruffin"),
  "29481": p("SC", "Smoaks"),
  "29488": p("SC", "Walterboro"),
  "29493": p("SC", "Williams"),
  "29929": p("SC", "Islandton"),
  "29069": p("SC", "Lamar"),
  "29079": p("SC", "Lydia"),
  "29532": p("SC", "Darlington"),
  "29540": p("SC", "Darlington"),
  "29550": p("SC", "Hartsville"),
  "29551": p("SC", "Hartsville"),
  "29593": p("SC", "Society Hill"),
  "29536": p("SC", "Dillon"),
  "29543": p("SC", "Fork"),
  "29547": p("SC", "Hamer"),
  "29563": p("SC", "Lake View"),
  "29565": p("SC", "Latta"),
  "29567": p("SC", "Little Rock"),
  "29420": p("SC", "North Charleston"),
  "29437": p("SC", "Dorchester"),
  "29447": p("SC", "Grover"),
  "29448": p("SC", "Harleyville"),
  "29471": p("SC", "Reevesville"),
  "29472": p("SC", "Ridgeville"),
  "29477": p("SC", "Saint George"),
  "29483": p("SC", "Summerville"),
  "29484": p("SC", "Summerville"),
  "29485": p("SC", "Summerville"),
  "29824": p("SC", "Edgefield"),
  "29832": p("SC", "Johnston"),
  "29847": p("SC", "Trenton"),
  "29015": p("SC", "Blair"),
  "29065": p("SC", "Jenkinsville"),
  "29130": p("SC", "Ridgeway"),
  "29132": p("SC", "Rion"),
  "29180": p("SC", "Winnsboro"),
  "29114": p("SC", "Olanta"),
  "29161": p("SC", "Timmonsville"),
  "29501": p("SC", "Florence"),
  "29502": p("SC", "Florence"),
  "29503": p("SC", "Florence"),
  "29504": p("SC", "Florence"),
  "29505": p("SC", "Florence"),
  "29506": p("SC", "Florence"),
  "29530": p("SC", "Coward"),
  "29541": p("SC", "Effingham"),
  "29555": p("SC", "Johnsonville"),
  "29560": p("SC", "Lake City"),
  "29583": p("SC", "Pamplico"),
  "29591": p("SC", "Scranton"),
  "29440": p("SC", "Georgetown"),
  "29442": p("SC", "Georgetown"),
  "29510": p("SC", "Andrews"),
  "29576": p("SC", "Murrells Inlet"),
  "29585": p("SC", "Pawleys Island"),
  "29601": p("SC", "Greenville"),
  "29602": p("SC", "Greenville"),
  "29603": p("SC", "Greenville"),
  "29604": p("SC", "Greenville"),
  "29605": p("SC", "Greenville"),
  "29606": p("SC", "Greenville"),
  "29607": p("SC", "Greenville"),
  "29608": p("SC", "Greenville"),
  "29609": p("SC", "Greenville"),
  "29610": p("SC", "Greenville"),
  "29611": p("SC", "Greenville"),
  "29612": p("SC", "Greenville"),
  "29613": p("SC", "Greenville"),
  "29614": p("SC", "Greenville"),
  "29615": p("SC", "Greenville"),
  "29616": p("SC", "Greenville"),
  "29617": p("SC", "Greenville"),
  "29635": p("SC", "Cleveland"),
  "29636": p("SC", "Conestee"),
  "29644": p("SC", "Fountain Inn"),
  "29650": p("SC", "Greer"),
  "29651": p("SC", "Greer"),
  "29652": p("SC", "Greer"),
  "29661": p("SC", "Marietta"),
  "29662": p("SC", "Mauldin"),
  "29673": p("SC", "Piedmont"),
  "29680": p("SC", "Simpsonville"),
  "29681": p("SC", "Simpsonville"),
  "29683": p("SC", "Slater"),
  "29687": p("SC", "Taylors"),
  "29688": p("SC", "Tigerville"),
  "29690": p("SC", "Travelers Rest"),
  "29646": p("SC", "Greenwood"),
  "29647": p("SC", "Greenwood"),
  "29648": p("SC", "Greenwood"),
  "29649": p("SC", "Greenwood"),
  "29653": p("SC", "Hodges"),
  "29666": p("SC", "Ninety Six"),
  "29692": p("SC", "Ware Shoals"),
  "29695": p("SC", "Hodges"),
  "29819": p("SC", "Bradley"),
  "29848": p("SC", "Troy"),
  "29911": p("SC", "Brunson"),
  "29913": p("SC", "Crocketville"),
  "29916": p("SC", "Early Branch"),
  "29918": p("SC", "Estill"),
  "29921": p("SC", "Furman"),
  "29922": p("SC", "Garnett"),
  "29923": p("SC", "Gifford"),
  "29924": p("SC", "Hampton"),
  "29932": p("SC", "Luray"),
  "29933": p("SC", "Miley"),
  "29939": p("SC", "Scotia"),
  "29944": p("SC", "Varnville"),
  "29945": p("SC", "Yemassee"),
  "29511": p("SC", "Aynor"),
  "29526": p("SC", "Conway"),
  "29527": p("SC", "Conway"),
  "29528": p("SC", "Conway"),
  "29544": p("SC", "Galivants Ferry"),
  "29545": p("SC", "Green Sea"),
  "29566": p("SC", "Little River"),
  "29568": p("SC", "Longs"),
  "29569": p("SC", "Loris"),
  "29572": p("SC", "Myrtle Beach"),
  "29575": p("SC", "Myrtle Beach"),
  "29577": p("SC", "Myrtle Beach"),
  "29578": p("SC", "Myrtle Beach"),
  "29579": p("SC", "Myrtle Beach"),
  "29581": p("SC", "Nichols"),
  "29582": p("SC", "North Myrtle Beach"),
  "29587": p("SC", "Myrtle Beach"),
  "29588": p("SC", "Myrtle Beach"),
  "29597": p("SC", "North Myrtle Beach"),
  "29598": p("SC", "North Myrtle Beach"),
  "29909": p("SC", "Okatie"),
  "29912": p("SC", "Coosawhatchie"),
  "29927": p("SC", "Hardeeville"),
  "29934": p("SC", "Pineland"),
  "29936": p("SC", "Ridgeland"),
  "29943": p("SC", "Tillman"),
  "29009": p("SC", "Bethune"),
  "29020": p("SC", "Camden"),
  "29021": p("SC", "Camden"),
  "29032": p("SC", "Cassatt"),
  "29045": p("SC", "Elgin"),
  "29074": p("SC", "Liberty Hill"),
  "29078": p("SC", "Lugoff"),
  "29175": p("SC", "Westville"),
  "29058": p("SC", "Heath Springs"),
  "29067": p("SC", "Kershaw"),
  "29707": p("SC", "Fort Mill"),
  "29720": p("SC", "Lancaster"),
  "29721": p("SC", "Lancaster"),
  "29722": p("SC", "Lancaster"),
  "29744": p("SC", "Van Wyck"),
  "29325": p("SC", "Clinton"),
  "29332": p("SC", "Cross Hill"),
  "29351": p("SC", "Joanna"),
  "29360": p("SC", "Laurens"),
  "29370": p("SC", "Mountville"),
  "29384": p("SC", "Waterloo"),
  "29645": p("SC", "Gray Court"),
  "29010": p("SC", "Bishopville"),
  "29046": p("SC", "Elliott"),
  "29080": p("SC", "Lynchburg"),
  "29006": p("SC", "Batesburg"),
  "29033": p("SC", "Cayce"),
  "29036": p("SC", "Chapin"),
  "29053": p("SC", "Gaston"),
  "29054": p("SC", "Gilbert"),
  "29070": p("SC", "Leesville"),
  "29071": p("SC", "Lexington"),
  "29072": p("SC", "Lexington"),
  "29073": p("SC", "Lexington"),
  "29123": p("SC", "Pelion"),
  "29160": p("SC", "Swansea"),
  "29169": p("SC", "West Columbia"),
  "29170": p("SC", "West Columbia"),
  "29171": p("SC", "West Columbia"),
  "29172": p("SC", "West Columbia"),
  "29212": p("SC", "Columbia"),
  "29228": p("SC", "Columbia"),
  "29821": p("SC", "Clarks Hill"),
  "29835": p("SC", "Mc Cormick"),
  "29838": p("SC", "Modoc"),
  "29840": p("SC", "Mount Carmel"),
  "29844": p("SC", "Parksville"),
  "29845": p("SC", "Plum Branch"),
  "29899": p("SC", "Mc Cormick"),
  "29519": p("SC", "Centenary"),
  "29546": p("SC", "Gresham"),
  "29571": p("SC", "Marion"),
  "29574": p("SC", "Mullins"),
  "29589": p("SC", "Rains"),
  "29592": p("SC", "Sellers"),
  "29512": p("SC", "Bennettsville"),
  "29516": p("SC", "Blenheim"),
  "29525": p("SC", "Clio"),
  "29570": p("SC", "Mc Coll"),
  "29594": p("SC", "Tatum"),
  "29596": p("SC", "Wallace"),
  "29037": p("SC", "Chappells"),
  "29075": p("SC", "Little Mountain"),
  "29108": p("SC", "Newberry"),
  "29122": p("SC", "Peak"),
  "29126": p("SC", "Pomaria"),
  "29127": p("SC", "Prosperity"),
  "29145": p("SC", "Silverstreet"),
  "29178": p("SC", "Whitmire"),
  "29355": p("SC", "Kinards"),
  "29643": p("SC", "Fair Play"),
  "29658": p("SC", "Long Creek"),
  "29664": p("SC", "Mountain Rest"),
  "29665": p("SC", "Newry"),
  "29672": p("SC", "Seneca"),
  "29675": p("SC", "Richland"),
  "29676": p("SC", "Salem"),
  "29678": p("SC", "Seneca"),
  "29679": p("SC", "Seneca"),
  "29686": p("SC", "Tamassee"),
  "29691": p("SC", "Walhalla"),
  "29693": p("SC", "Westminster"),
  "29696": p("SC", "West Union"),
  "29018": p("SC", "Bowman"),
  "29038": p("SC", "Cope"),
  "29039": p("SC", "Cordova"),
  "29047": p("SC", "Elloree"),
  "29048": p("SC", "Eutawville"),
  "29059": p("SC", "Holly Hill"),
  "29107": p("SC", "Neeses"),
  "29112": p("SC", "North"),
  "29113": p("SC", "Norway"),
  "29115": p("SC", "Orangeburg"),
  "29116": p("SC", "Orangeburg"),
  "29117": p("SC", "Orangeburg"),
  "29118": p("SC", "Orangeburg"),
  "29133": p("SC", "Rowesville"),
  "29142": p("SC", "Santee"),
  "29146": p("SC", "Springfield"),
  "29163": p("SC", "Vance"),
  "29432": p("SC", "Branchville"),
  "29630": p("SC", "Central"),
  "29631": p("SC", "Clemson"),
  "29632": p("SC", "Clemson"),
  "29633": p("SC", "Clemson"),
  "29634": p("SC", "Clemson"),
  "29640": p("SC", "Easley"),
  "29641": p("SC", "Easley"),
  "29642": p("SC", "Easley"),
  "29657": p("SC", "Liberty"),
  "29667": p("SC", "Norris"),
  "29671": p("SC", "Pickens"),
  "29682": p("SC", "Six Mile"),
  "29685": p("SC", "Sunset"),
  "29002": p("SC", "Ballentine"),
  "29016": p("SC", "Blythewood"),
  "29044": p("SC", "Eastover"),
  "29052": p("SC", "Gadsden"),
  "29061": p("SC", "Hopkins"),
  "29063": p("SC", "Irmo"),
  "29147": p("SC", "State Park"),
  "29177": p("SC", "White Rock"),
  "29201": p("SC", "Columbia"),
  "29202": p("SC", "Columbia"),
  "29203": p("SC", "Columbia"),
  "29204": p("SC", "Columbia"),
  "29205": p("SC", "Columbia"),
  "29206": p("SC", "Columbia"),
  "29207": p("SC", "Columbia"),
  "29208": p("SC", "Columbia"),
  "29209": p("SC", "Columbia"),
  "29210": p("SC", "Columbia"),
  "29211": p("SC", "Columbia"),
  "29214": p("SC", "Columbia"),
  "29215": p("SC", "Columbia"),
  "29216": p("SC", "Columbia"),
  "29217": p("SC", "Columbia"),
  "29218": p("SC", "Columbia"),
  "29219": p("SC", "Columbia"),
  "29220": p("SC", "Columbia"),
  "29221": p("SC", "Columbia"),
  "29222": p("SC", "Columbia"),
  "29223": p("SC", "Columbia"),
  "29224": p("SC", "Columbia"),
  "29225": p("SC", "Columbia"),
  "29226": p("SC", "Columbia"),
  "29227": p("SC", "Columbia"),
  "29229": p("SC", "Columbia"),
  "29230": p("SC", "Columbia"),
  "29240": p("SC", "Columbia"),
  "29250": p("SC", "Columbia"),
  "29260": p("SC", "Columbia"),
  "29290": p("SC", "Columbia"),
  "29292": p("SC", "Columbia"),
  "29105": p("SC", "Monetta"),
  "29129": p("SC", "Ridge Spring"),
  "29138": p("SC", "Saluda"),
  "29166": p("SC", "Ward"),
  "29301": p("SC", "Spartanburg"),
  "29302": p("SC", "Spartanburg"),
  "29303": p("SC", "Spartanburg"),
  "29304": p("SC", "Spartanburg"),
  "29305": p("SC", "Spartanburg"),
  "29306": p("SC", "Spartanburg"),
  "29307": p("SC", "Spartanburg"),
  "29316": p("SC", "Boiling Springs"),
  "29319": p("SC", "Spartanburg"),
  "29320": p("SC", "Arcadia"),
  "29322": p("SC", "Campobello"),
  "29323": p("SC", "Chesnee"),
  "29324": p("SC", "Clifton"),
  "29329": p("SC", "Converse"),
  "29330": p("SC", "Cowpens"),
  "29331": p("SC", "Cross Anchor"),
  "29333": p("SC", "Drayton"),
  "29334": p("SC", "Duncan"),
  "29335": p("SC", "Enoree"),
  "29336": p("SC", "Fairforest"),
  "29338": p("SC", "Fingerville"),
  "29346": p("SC", "Glendale"),
  "29348": p("SC", "Gramling"),
  "29349": p("SC", "Inman"),
  "29356": p("SC", "Landrum"),
  "29365": p("SC", "Lyman"),
  "29368": p("SC", "Mayo"),
  "29369": p("SC", "Moore"),
  "29372": p("SC", "Pacolet"),
  "29373": p("SC", "Pacolet Mills"),
  "29374": p("SC", "Pauline"),
  "29375": p("SC", "Reidville"),
  "29376": p("SC", "Roebuck"),
  "29377": p("SC", "Startex"),
  "29378": p("SC", "Una"),
  "29385": p("SC", "Wellford"),
  "29386": p("SC", "White Stone"),
  "29388": p("SC", "Woodruff"),
  "29040": p("SC", "Dalzell"),
  "29062": p("SC", "Horatio"),
  "29104": p("SC", "Mayesville"),
  "29125": p("SC", "Pinewood"),
  "29128": p("SC", "Rembert"),
  "29150": p("SC", "Sumter"),
  "29151": p("SC", "Sumter"),
  "29152": p("SC", "Shaw Afb"),
  "29153": p("SC", "Sumter"),
  "29154": p("SC", "Sumter"),
  "29168": p("SC", "Wedgefield"),
  "29031": p("SC", "Carlisle"),
  "29321": p("SC", "Buffalo"),
  "29353": p("SC", "Jonesville"),
  "29364": p("SC", "Lockhart"),
  "29379": p("SC", "Union"),
  "29395": p("SC", "Jonesville"),
  "29056": p("SC", "Greeleyville"),
  "29518": p("SC", "Cades"),
  "29554": p("SC", "Hemingway"),
  "29556": p("SC", "Kingstree"),
  "29564": p("SC", "Lane"),
  "29580": p("SC", "Nesmith"),
  "29590": p("SC", "Salters"),
  "29703": p("SC", "Bowling Green"),
  "29704": p("SC", "Catawba"),
  "29708": p("SC", "Fort Mill"),
  "29710": p("SC", "Clover"),
  "29715": p("SC", "Fort Mill"),
  "29716": p("SC", "Fort Mill"),
  "29717": p("SC", "Hickory Grove"),
  "29726": p("SC", "Mc Connells"),
  "29730": p("SC", "Rock Hill"),
  "29731": p("SC", "Rock Hill"),
  "29732": p("SC", "Rock Hill"),
  "29733": p("SC", "Rock Hill"),
  "29734": p("SC", "Rock Hill"),
  "29742": p("SC", "Sharon"),
  "29743": p("SC", "Smyrna"),
  "29745": p("SC", "York"),
  "57368": p("SD", "Plankinton"),
  "57375": p("SD", "Stickney"),
  "57383": p("SD", "White Lake"),
  "57324": p("SD", "Cavour"),
  "57348": p("SD", "Hitchcock"),
  "57350": p("SD", "Huron"),
  "57379": p("SD", "Virgil"),
  "57381": p("SD", "Wessington"),
  "57384": p("SD", "Wolsey"),
  "57386": p("SD", "Yale"),
  "57399": p("SD", "Huron"),
  "57551": p("SD", "Martin"),
  "57574": p("SD", "Tuthill"),
  "57714": p("SD", "Allen"),
  "57059": p("SD", "Scotland"),
  "57062": p("SD", "Springfield"),
  "57063": p("SD", "Tabor"),
  "57066": p("SD", "Tyndall"),
  "57315": p("SD", "Avon"),
  "57002": p("SD", "Aurora"),
  "57006": p("SD", "Brookings"),
  "57007": p("SD", "Brookings"),
  "57026": p("SD", "Elkton"),
  "57061": p("SD", "Sinai"),
  "57071": p("SD", "Volga"),
  "57220": p("SD", "Bruce"),
  "57276": p("SD", "White"),
  "57401": p("SD", "Aberdeen"),
  "57402": p("SD", "Aberdeen"),
  "57426": p("SD", "Barnard"),
  "57427": p("SD", "Bath"),
  "57432": p("SD", "Claremont"),
  "57433": p("SD", "Columbia"),
  "57439": p("SD", "Ferney"),
  "57441": p("SD", "Frederick"),
  "57445": p("SD", "Groton"),
  "57446": p("SD", "Hecla"),
  "57449": p("SD", "Houghton"),
  "57474": p("SD", "Stratford"),
  "57479": p("SD", "Warner"),
  "57481": p("SD", "Westport"),
  "57325": p("SD", "Chamberlain"),
  "57326": p("SD", "Chamberlain"),
  "57355": p("SD", "Kimball"),
  "57370": p("SD", "Pukwana"),
  "57339": p("SD", "Fort Thompson"),
  "57341": p("SD", "Gann Valley"),
  "57717": p("SD", "Belle Fourche"),
  "57760": p("SD", "Newell"),
  "57762": p("SD", "Nisland"),
  "57788": p("SD", "Vale"),
  "57632": p("SD", "Herreid"),
  "57646": p("SD", "Mound City"),
  "57648": p("SD", "Pollock"),
  "57329": p("SD", "Dante"),
  "57342": p("SD", "Geddes"),
  "57356": p("SD", "Lake Andes"),
  "57361": p("SD", "Marty"),
  "57367": p("SD", "Pickstown"),
  "57369": p("SD", "Platte"),
  "57380": p("SD", "Wagner"),
  "57217": p("SD", "Bradley"),
  "57225": p("SD", "Clark"),
  "57236": p("SD", "Garden City"),
  "57258": p("SD", "Raymond"),
  "57271": p("SD", "Vienna"),
  "57278": p("SD", "Willow Lake"),
  "57322": p("SD", "Carpenter"),
  "57010": p("SD", "Burbank"),
  "57037": p("SD", "Irene"),
  "57069": p("SD", "Vermillion"),
  "57073": p("SD", "Wakonda"),
  "57201": p("SD", "Watertown"),
  "57235": p("SD", "Florence"),
  "57243": p("SD", "Henry"),
  "57245": p("SD", "Kranzburg"),
  "57263": p("SD", "South Shore"),
  "57272": p("SD", "Wallace"),
  "57621": p("SD", "Bullhead"),
  "57634": p("SD", "Keldron"),
  "57639": p("SD", "Little Eagle"),
  "57641": p("SD", "Mc Intosh"),
  "57642": p("SD", "Mc Laughlin"),
  "57645": p("SD", "Morristown"),
  "57657": p("SD", "Trail City"),
  "57658": p("SD", "Wakpala"),
  "57659": p("SD", "Walker"),
  "57660": p("SD", "Watauga"),
  "57722": p("SD", "Buffalo Gap"),
  "57730": p("SD", "Custer"),
  "57738": p("SD", "Fairburn"),
  "57744": p("SD", "Hermosa"),
  "57773": p("SD", "Pringle"),
  "57301": p("SD", "Mitchell"),
  "57334": p("SD", "Ethan"),
  "57363": p("SD", "Mount Vernon"),
  "57219": p("SD", "Bristol"),
  "57239": p("SD", "Grenville"),
  "57261": p("SD", "Roslyn"),
  "57273": p("SD", "Waubay"),
  "57274": p("SD", "Webster"),
  "57422": p("SD", "Andover"),
  "57468": p("SD", "Pierpont"),
  "57213": p("SD", "Astoria"),
  "57218": p("SD", "Brandt"),
  "57226": p("SD", "Clear Lake"),
  "57237": p("SD", "Gary"),
  "57238": p("SD", "Goodwin"),
  "57268": p("SD", "Toronto"),
  "57625": p("SD", "Eagle Butte"),
  "57630": p("SD", "Glencross"),
  "57633": p("SD", "Isabel"),
  "57636": p("SD", "Lantry"),
  "57652": p("SD", "Ridgeview"),
  "57656": p("SD", "Timber Lake"),
  "57661": p("SD", "Whitehorse"),
  "57313": p("SD", "Armour"),
  "57328": p("SD", "Corsica"),
  "57330": p("SD", "Delmont"),
  "57344": p("SD", "Harrison"),
  "57364": p("SD", "New Holland"),
  "57428": p("SD", "Bowdle"),
  "57448": p("SD", "Hosmer"),
  "57451": p("SD", "Ipswich"),
  "57471": p("SD", "Roscoe"),
  "57735": p("SD", "Edgemont"),
  "57747": p("SD", "Hot Springs"),
  "57763": p("SD", "Oelrichs"),
  "57766": p("SD", "Oral"),
  "57782": p("SD", "Smithwick"),
  "57435": p("SD", "Cresbard"),
  "57438": p("SD", "Faulkton"),
  "57466": p("SD", "Onaka"),
  "57467": p("SD", "Orient"),
  "57470": p("SD", "Rockham"),
  "57473": p("SD", "Seneca"),
  "57216": p("SD", "Big Stone City"),
  "57246": p("SD", "Labolt"),
  "57251": p("SD", "Marvin"),
  "57252": p("SD", "Milbank"),
  "57259": p("SD", "Revillo"),
  "57264": p("SD", "Stockholm"),
  "57265": p("SD", "Strandburg"),
  "57269": p("SD", "Twin Brooks"),
  "57317": p("SD", "Bonesteel"),
  "57335": p("SD", "Fairfax"),
  "57523": p("SD", "Burke"),
  "57529": p("SD", "Dallas"),
  "57533": p("SD", "Gregory"),
  "57538": p("SD", "Herrick"),
  "57571": p("SD", "Saint Charles"),
  "57552": p("SD", "Midland"),
  "57553": p("SD", "Milesville"),
  "57567": p("SD", "Philip"),
  "57221": p("SD", "Bryant"),
  "57223": p("SD", "Castlewood"),
  "57234": p("SD", "Estelline"),
  "57241": p("SD", "Hayti"),
  "57242": p("SD", "Hazel"),
  "57248": p("SD", "Lake Norden"),
  "57362": p("SD", "Miller"),
  "57371": p("SD", "Ree Heights"),
  "57373": p("SD", "Saint Lawrence"),
  "57311": p("SD", "Alexandria"),
  "57332": p("SD", "Emery"),
  "57340": p("SD", "Fulton"),
  "57650": p("SD", "Ralph"),
  "57651": p("SD", "Reva"),
  "57720": p("SD", "Buffalo"),
  "57724": p("SD", "Camp Crook"),
  "57755": p("SD", "Ludlow"),
  "57776": p("SD", "Redig"),
  "57501": p("SD", "Pierre"),
  "57522": p("SD", "Blunt"),
  "57536": p("SD", "Harrold"),
  "57029": p("SD", "Freeman"),
  "57045": p("SD", "Menno"),
  "57052": p("SD", "Olivet"),
  "57331": p("SD", "Dimock"),
  "57354": p("SD", "Kaylor"),
  "57366": p("SD", "Parkston"),
  "57376": p("SD", "Tripp"),
  "57345": p("SD", "Highmore"),
  "57346": p("SD", "Stephan"),
  "57540": p("SD", "Holabird"),
  "57521": p("SD", "Belvidere"),
  "57543": p("SD", "Kadoka"),
  "57547": p("SD", "Long Valley"),
  "57577": p("SD", "Wanblee"),
  "57750": p("SD", "Interior"),
  "57312": p("SD", "Alpena"),
  "57358": p("SD", "Lane"),
  "57382": p("SD", "Wessington Springs"),
  "57531": p("SD", "Draper"),
  "57559": p("SD", "Murdo"),
  "57562": p("SD", "Okaton"),
  "57051": p("SD", "Oldham"),
  "57212": p("SD", "Arlington"),
  "57214": p("SD", "Badger"),
  "57231": p("SD", "De Smet"),
  "57233": p("SD", "Erwin"),
  "57249": p("SD", "Lake Preston"),
  "57353": p("SD", "Iroquois"),
  "57016": p("SD", "Chester"),
  "57042": p("SD", "Madison"),
  "57050": p("SD", "Nunda"),
  "57054": p("SD", "Ramona"),
  "57057": p("SD", "Rutland"),
  "57075": p("SD", "Wentworth"),
  "57076": p("SD", "Winfred"),
  "57732": p("SD", "Deadwood"),
  "57754": p("SD", "Lead"),
  "57759": p("SD", "Nemo"),
  "57779": p("SD", "Saint Onge"),
  "57783": p("SD", "Spearfish"),
  "57793": p("SD", "Whitewood"),
  "57799": p("SD", "Spearfish"),
  "57013": p("SD", "Canton"),
  "57027": p("SD", "Fairview"),
  "57032": p("SD", "Harrisburg"),
  "57034": p("SD", "Hudson"),
  "57039": p("SD", "Lennox"),
  "57064": p("SD", "Tea"),
  "57077": p("SD", "Worthing"),
  "57365": p("SD", "Oacoma"),
  "57544": p("SD", "Kennebec"),
  "57548": p("SD", "Lower Brule"),
  "57568": p("SD", "Presho"),
  "57569": p("SD", "Reliance"),
  "57576": p("SD", "Vivian"),
  "57012": p("SD", "Canistota"),
  "57048": p("SD", "Montrose"),
  "57058": p("SD", "Salem"),
  "57319": p("SD", "Bridgewater"),
  "57374": p("SD", "Spencer"),
  "57437": p("SD", "Eureka"),
  "57456": p("SD", "Leola"),
  "57457": p("SD", "Long Lake"),
  "57232": p("SD", "Eden"),
  "57247": p("SD", "Lake City"),
  "57270": p("SD", "Veblen"),
  "57421": p("SD", "Amherst"),
  "57430": p("SD", "Britton"),
  "57454": p("SD", "Langford"),
  "57626": p("SD", "Faith"),
  "57706": p("SD", "Ellsworth Afb"),
  "57718": p("SD", "Black Hawk"),
  "57737": p("SD", "Enning"),
  "57741": p("SD", "Fort Meade"),
  "57748": p("SD", "Howes"),
  "57758": p("SD", "Mud Butte"),
  "57769": p("SD", "Piedmont"),
  "57785": p("SD", "Sturgis"),
  "57787": p("SD", "Union Center"),
  "57792": p("SD", "White Owl"),
  "57560": p("SD", "Norris"),
  "57579": p("SD", "White River"),
  "57585": p("SD", "Wood"),
  "57321": p("SD", "Canova"),
  "57323": p("SD", "Carthage"),
  "57337": p("SD", "Fedora"),
  "57349": p("SD", "Howard"),
  "57003": p("SD", "Baltic"),
  "57005": p("SD", "Brandon"),
  "57018": p("SD", "Colton"),
  "57020": p("SD", "Crooks"),
  "57022": p("SD", "Dell Rapids"),
  "57030": p("SD", "Garretson"),
  "57033": p("SD", "Hartford"),
  "57035": p("SD", "Humboldt"),
  "57041": p("SD", "Lyons"),
  "57055": p("SD", "Renner"),
  "57068": p("SD", "Valley Springs"),
  "57101": p("SD", "Sioux Falls"),
  "57103": p("SD", "Sioux Falls"),
  "57104": p("SD", "Sioux Falls"),
  "57105": p("SD", "Sioux Falls"),
  "57106": p("SD", "Sioux Falls"),
  "57107": p("SD", "Sioux Falls"),
  "57108": p("SD", "Sioux Falls"),
  "57109": p("SD", "Sioux Falls"),
  "57110": p("SD", "Sioux Falls"),
  "57117": p("SD", "Sioux Falls"),
  "57118": p("SD", "Sioux Falls"),
  "57186": p("SD", "Sioux Falls"),
  "57193": p("SD", "Sioux Falls"),
  "57197": p("SD", "Sioux Falls"),
  "57198": p("SD", "Sioux Falls"),
  "57017": p("SD", "Colman"),
  "57024": p("SD", "Egan"),
  "57028": p("SD", "Flandreau"),
  "57065": p("SD", "Trent"),
  "57701": p("SD", "Rapid City"),
  "57702": p("SD", "Rapid City"),
  "57703": p("SD", "Rapid City"),
  "57709": p("SD", "Rapid City"),
  "57719": p("SD", "Box Elder"),
  "57725": p("SD", "Caputa"),
  "57745": p("SD", "Hill City"),
  "57751": p("SD", "Keystone"),
  "57761": p("SD", "New Underwood"),
  "57767": p("SD", "Owanka"),
  "57775": p("SD", "Quinn"),
  "57780": p("SD", "Scenic"),
  "57790": p("SD", "Wall"),
  "57791": p("SD", "Wasta"),
  "57620": p("SD", "Bison"),
  "57638": p("SD", "Lemmon"),
  "57640": p("SD", "Lodgepole"),
  "57644": p("SD", "Meadow"),
  "57649": p("SD", "Prairie City"),
  "57442": p("SD", "Gettysburg"),
  "57450": p("SD", "Hoven"),
  "57455": p("SD", "Lebanon"),
  "57475": p("SD", "Tolstoy"),
  "57224": p("SD", "Claire City"),
  "57227": p("SD", "Corona"),
  "57255": p("SD", "New Effington"),
  "57256": p("SD", "Ortley"),
  "57257": p("SD", "Peever"),
  "57260": p("SD", "Rosholt"),
  "57262": p("SD", "Sisseton"),
  "57266": p("SD", "Summit"),
  "57279": p("SD", "Wilmot"),
  "57314": p("SD", "Artesian"),
  "57359": p("SD", "Letcher"),
  "57385": p("SD", "Woonsocket"),
  "57716": p("SD", "Batesland"),
  "57752": p("SD", "Kyle"),
  "57756": p("SD", "Manderson"),
  "57764": p("SD", "Oglala"),
  "57770": p("SD", "Pine Ridge"),
  "57772": p("SD", "Porcupine"),
  "57794": p("SD", "Wounded Knee"),
  "57424": p("SD", "Ashton"),
  "57429": p("SD", "Brentford"),
  "57434": p("SD", "Conde"),
  "57436": p("SD", "Doland"),
  "57440": p("SD", "Frankfort"),
  "57460": p("SD", "Mansfield"),
  "57461": p("SD", "Mellette"),
  "57465": p("SD", "Northville"),
  "57469": p("SD", "Redfield"),
  "57476": p("SD", "Tulare"),
  "57477": p("SD", "Turton"),
  "57532": p("SD", "Fort Pierre"),
  "57537": p("SD", "Hayes"),
  "57520": p("SD", "Agar"),
  "57564": p("SD", "Onida"),
  "57555": p("SD", "Mission"),
  "57563": p("SD", "Okreek"),
  "57566": p("SD", "Parmelee"),
  "57570": p("SD", "Rosebud"),
  "57572": p("SD", "Saint Francis"),
  "57528": p("SD", "Colome"),
  "57534": p("SD", "Hamill"),
  "57541": p("SD", "Ideal"),
  "57580": p("SD", "Winner"),
  "57584": p("SD", "Witten"),
  "57014": p("SD", "Centerville"),
  "57015": p("SD", "Chancellor"),
  "57021": p("SD", "Davis"),
  "57036": p("SD", "Hurley"),
  "57043": p("SD", "Marion"),
  "57047": p("SD", "Monroe"),
  "57053": p("SD", "Parker"),
  "57070": p("SD", "Viborg"),
  "57001": p("SD", "Alcester"),
  "57004": p("SD", "Beresford"),
  "57025": p("SD", "Elk Point"),
  "57038": p("SD", "Jefferson"),
  "57049": p("SD", "North Sioux City"),
  "57420": p("SD", "Akaska"),
  "57452": p("SD", "Java"),
  "57472": p("SD", "Selby"),
  "57601": p("SD", "Mobridge"),
  "57631": p("SD", "Glenham"),
  "57031": p("SD", "Gayville"),
  "57040": p("SD", "Lesterville"),
  "57046": p("SD", "Mission Hill"),
  "57067": p("SD", "Utica"),
  "57072": p("SD", "Volin"),
  "57078": p("SD", "Yankton"),
  "57622": p("SD", "Cherry Creek"),
  "57623": p("SD", "Dupree"),
  "37705": p("TN", "Andersonville"),
  "37710": p("TN", "Briceville"),
  "37716": p("TN", "Clinton"),
  "37717": p("TN", "Clinton"),
  "37769": p("TN", "Lake City"),
  "37828": p("TN", "Norris"),
  "37830": p("TN", "Oak Ridge"),
  "37831": p("TN", "Oak Ridge"),
  "37020": p("TN", "Bell Buckle"),
  "37160": p("TN", "Shelbyville"),
  "37161": p("TN", "Shelbyville"),
  "37162": p("TN", "Shelbyville"),
  "37180": p("TN", "Unionville"),
  "37183": p("TN", "Wartrace"),
  "37360": p("TN", "Normandy"),
  "38221": p("TN", "Big Sandy"),
  "38320": p("TN", "Camden"),
  "38333": p("TN", "Eva"),
  "38341": p("TN", "Holladay"),
  "37367": p("TN", "Pikeville"),
  "37701": p("TN", "Alcoa"),
  "37737": p("TN", "Friendsville"),
  "37777": p("TN", "Louisville"),
  "37801": p("TN", "Maryville"),
  "37802": p("TN", "Maryville"),
  "37803": p("TN", "Maryville"),
  "37804": p("TN", "Maryville"),
  "37853": p("TN", "Rockford"),
  "37878": p("TN", "Tallassee"),
  "37882": p("TN", "Townsend"),
  "37886": p("TN", "Walland"),
  "37310": p("TN", "Charleston"),
  "37311": p("TN", "Cleveland"),
  "37312": p("TN", "Cleveland"),
  "37320": p("TN", "Cleveland"),
  "37323": p("TN", "Cleveland"),
  "37353": p("TN", "Mc Donald"),
  "37364": p("TN", "Cleveland"),
  "37714": p("TN", "Caryville"),
  "37729": p("TN", "Duff"),
  "37757": p("TN", "Jacksboro"),
  "37762": p("TN", "Jellico"),
  "37766": p("TN", "La Follette"),
  "37819": p("TN", "Newcomb"),
  "37847": p("TN", "Pioneer"),
  "37016": p("TN", "Auburntown"),
  "37026": p("TN", "Bradyville"),
  "37149": p("TN", "Readyville"),
  "37190": p("TN", "Woodbury"),
  "38201": p("TN", "Mc Kenzie"),
  "38220": p("TN", "Atwood"),
  "38235": p("TN", "Mc Lemoresville"),
  "38258": p("TN", "Trezevant"),
  "38317": p("TN", "Bruceton"),
  "38318": p("TN", "Buena Vista"),
  "38321": p("TN", "Cedar Grove"),
  "38324": p("TN", "Clarksburg"),
  "38342": p("TN", "Hollow Rock"),
  "38344": p("TN", "Huntingdon"),
  "38348": p("TN", "Lavinia"),
  "38387": p("TN", "Westport"),
  "38390": p("TN", "Yuma"),
  "37643": p("TN", "Elizabethton"),
  "37644": p("TN", "Elizabethton"),
  "37658": p("TN", "Hampton"),
  "37682": p("TN", "Milligan College"),
  "37687": p("TN", "Roan Mountain"),
  "37694": p("TN", "Watauga"),
  "37015": p("TN", "Ashland City"),
  "37035": p("TN", "Chapmansboro"),
  "37082": p("TN", "Kingston Springs"),
  "37143": p("TN", "Pegram"),
  "37146": p("TN", "Pleasant View"),
  "38332": p("TN", "Enville"),
  "38340": p("TN", "Henderson"),
  "38347": p("TN", "Jacks Creek"),
  "38352": p("TN", "Luray"),
  "37707": p("TN", "Arthur"),
  "37715": p("TN", "Clairfield"),
  "37724": p("TN", "Cumberland Gap"),
  "37730": p("TN", "Eagan"),
  "37752": p("TN", "Harrogate"),
  "37773": p("TN", "Lone Mountain"),
  "37824": p("TN", "New Tazewell"),
  "37825": p("TN", "New Tazewell"),
  "37851": p("TN", "Pruden"),
  "37867": p("TN", "Shawanee"),
  "37870": p("TN", "Speedwell"),
  "37879": p("TN", "Tazewell"),
  "38551": p("TN", "Celina"),
  "38575": p("TN", "Moss"),
  "37713": p("TN", "Bybee"),
  "37722": p("TN", "Cosby"),
  "37727": p("TN", "Del Rio"),
  "37753": p("TN", "Hartford"),
  "37821": p("TN", "Newport"),
  "37822": p("TN", "Newport"),
  "37843": p("TN", "Parrottsville"),
  "37018": p("TN", "Beechgrove"),
  "37342": p("TN", "Hillsboro"),
  "37349": p("TN", "Manchester"),
  "37355": p("TN", "Manchester"),
  "37382": p("TN", "Summitville"),
  "37388": p("TN", "Tullahoma"),
  "37389": p("TN", "Arnold Afb"),
  "38001": p("TN", "Alamo"),
  "38006": p("TN", "Bells"),
  "38021": p("TN", "Crockett Mills"),
  "38034": p("TN", "Friendship"),
  "38050": p("TN", "Maury City"),
  "38336": p("TN", "Fruitvale"),
  "38337": p("TN", "Gadsden"),
  "37723": p("TN", "Crab Orchard"),
  "38555": p("TN", "Crossville"),
  "38557": p("TN", "Crossville"),
  "38558": p("TN", "Crossville"),
  "38571": p("TN", "Crossville"),
  "38572": p("TN", "Crossville"),
  "38578": p("TN", "Pleasant Hill"),
  "37011": p("TN", "Antioch"),
  "37013": p("TN", "Antioch"),
  "37070": p("TN", "Goodlettsville"),
  "37072": p("TN", "Goodlettsville"),
  "37076": p("TN", "Hermitage"),
  "37080": p("TN", "Joelton"),
  "37115": p("TN", "Madison"),
  "37116": p("TN", "Madison"),
  "37138": p("TN", "Old Hickory"),
  "37189": p("TN", "Whites Creek"),
  "37201": p("TN", "Nashville"),
  "37202": p("TN", "Nashville"),
  "37203": p("TN", "Nashville"),
  "37204": p("TN", "Nashville"),
  "37205": p("TN", "Nashville"),
  "37206": p("TN", "Nashville"),
  "37207": p("TN", "Nashville"),
  "37208": p("TN", "Nashville"),
  "37209": p("TN", "Nashville"),
  "37210": p("TN", "Nashville"),
  "37211": p("TN", "Nashville"),
  "37212": p("TN", "Nashville"),
  "37213": p("TN", "Nashville"),
  "37214": p("TN", "Nashville"),
  "37215": p("TN", "Nashville"),
  "37216": p("TN", "Nashville"),
  "37217": p("TN", "Nashville"),
  "37218": p("TN", "Nashville"),
  "37219": p("TN", "Nashville"),
  "37220": p("TN", "Nashville"),
  "37221": p("TN", "Nashville"),
  "37222": p("TN", "Nashville"),
  "37224": p("TN", "Nashville"),
  "37227": p("TN", "Nashville"),
  "37228": p("TN", "Nashville"),
  "37229": p("TN", "Nashville"),
  "37230": p("TN", "Nashville"),
  "37232": p("TN", "Nashville"),
  "37234": p("TN", "Nashville"),
  "37235": p("TN", "Nashville"),
  "37236": p("TN", "Nashville"),
  "37238": p("TN", "Nashville"),
  "37240": p("TN", "Nashville"),
  "37241": p("TN", "Nashville"),
  "37242": p("TN", "Nashville"),
  "37243": p("TN", "Nashville"),
  "37244": p("TN", "Nashville"),
  "37246": p("TN", "Nashville"),
  "37250": p("TN", "Nashville"),
  "38311": p("TN", "Bath Springs"),
  "38329": p("TN", "Decaturville"),
  "38363": p("TN", "Parsons"),
  "38374": p("TN", "Scotts Hill"),
  "38380": p("TN", "Sugar Tree"),
  "37012": p("TN", "Alexandria"),
  "37059": p("TN", "Dowelltown"),
  "37095": p("TN", "Liberty"),
  "37166": p("TN", "Smithville"),
  "37029": p("TN", "Burns"),
  "37036": p("TN", "Charlotte"),
  "37051": p("TN", "Cumberland Furnace"),
  "37055": p("TN", "Dickson"),
  "37056": p("TN", "Dickson"),
  "37165": p("TN", "Slayden"),
  "37181": p("TN", "Vanleer"),
  "37187": p("TN", "White Bluff"),
  "38007": p("TN", "Bogota"),
  "38024": p("TN", "Dyersburg"),
  "38025": p("TN", "Dyersburg"),
  "38030": p("TN", "Finley"),
  "38047": p("TN", "Lenox"),
  "38059": p("TN", "Newbern"),
  "38070": p("TN", "Tigrett"),
  "38259": p("TN", "Trimble"),
  "38010": p("TN", "Braden"),
  "38036": p("TN", "Gallaway"),
  "38045": p("TN", "Laconia"),
  "38046": p("TN", "La Grange"),
  "38048": p("TN", "Macon"),
  "38057": p("TN", "Moscow"),
  "38060": p("TN", "Oakland"),
  "38066": p("TN", "Rossville"),
  "38068": p("TN", "Somerville"),
  "38076": p("TN", "Williston"),
  "38504": p("TN", "Allardt"),
  "38553": p("TN", "Clarkrange"),
  "38556": p("TN", "Jamestown"),
  "38565": p("TN", "Grimsley"),
  "38577": p("TN", "Pall Mall"),
  "38589": p("TN", "Wilder"),
  "37306": p("TN", "Belvidere"),
  "37318": p("TN", "Cowan"),
  "37324": p("TN", "Decherd"),
  "37330": p("TN", "Estill Springs"),
  "37345": p("TN", "Huntland"),
  "37375": p("TN", "Sewanee"),
  "37376": p("TN", "Sherwood"),
  "37383": p("TN", "Sewanee"),
  "37398": p("TN", "Winchester"),
  "38233": p("TN", "Kenton"),
  "38316": p("TN", "Bradford"),
  "38330": p("TN", "Dyer"),
  "38331": p("TN", "Eaton"),
  "38338": p("TN", "Gibson"),
  "38343": p("TN", "Humboldt"),
  "38346": p("TN", "Idlewild"),
  "38355": p("TN", "Medina"),
  "38358": p("TN", "Milan"),
  "38369": p("TN", "Rutherford"),
  "38382": p("TN", "Trenton"),
  "38389": p("TN", "Yorkville"),
  "38449": p("TN", "Ardmore"),
  "38455": p("TN", "Elkton"),
  "38459": p("TN", "Frankewing"),
  "38460": p("TN", "Goodspring"),
  "38472": p("TN", "Lynnville"),
  "38473": p("TN", "Minor Hill"),
  "38477": p("TN", "Prospect"),
  "38478": p("TN", "Pulaski"),
  "37708": p("TN", "Bean Station"),
  "37709": p("TN", "Blaine"),
  "37848": p("TN", "Powder Springs"),
  "37861": p("TN", "Rutledge"),
  "37881": p("TN", "Thorn Hill"),
  "37888": p("TN", "Washburn"),
  "37616": p("TN", "Afton"),
  "37641": p("TN", "Chuckey"),
  "37743": p("TN", "Greeneville"),
  "37744": p("TN", "Greeneville"),
  "37745": p("TN", "Greeneville"),
  "37809": p("TN", "Midway"),
  "37810": p("TN", "Mohawk"),
  "37818": p("TN", "Mosheim"),
  "37301": p("TN", "Altamont"),
  "37305": p("TN", "Beersheba Springs"),
  "37313": p("TN", "Coalmont"),
  "37339": p("TN", "Gruetli Laager"),
  "37356": p("TN", "Monteagle"),
  "37365": p("TN", "Palmer"),
  "37366": p("TN", "Pelham"),
  "37387": p("TN", "Tracy City"),
  "37778": p("TN", "Lowland"),
  "37813": p("TN", "Morristown"),
  "37814": p("TN", "Morristown"),
  "37815": p("TN", "Morristown"),
  "37816": p("TN", "Morristown"),
  "37860": p("TN", "Russellville"),
  "37877": p("TN", "Talbott"),
  "37891": p("TN", "Whitesburg"),
  "37302": p("TN", "Apison"),
  "37304": p("TN", "Bakewell"),
  "37308": p("TN", "Birchwood"),
  "37315": p("TN", "Collegedale"),
  "37341": p("TN", "Harrison"),
  "37343": p("TN", "Hixson"),
  "37350": p("TN", "Lookout Mountain"),
  "37351": p("TN", "Lupton City"),
  "37363": p("TN", "Ooltewah"),
  "37373": p("TN", "Sale Creek"),
  "37377": p("TN", "Signal Mountain"),
  "37379": p("TN", "Soddy Daisy"),
  "37384": p("TN", "Soddy Daisy"),
  "37401": p("TN", "Chattanooga"),
  "37402": p("TN", "Chattanooga"),
  "37403": p("TN", "Chattanooga"),
  "37404": p("TN", "Chattanooga"),
  "37405": p("TN", "Chattanooga"),
  "37406": p("TN", "Chattanooga"),
  "37407": p("TN", "Chattanooga"),
  "37408": p("TN", "Chattanooga"),
  "37409": p("TN", "Chattanooga"),
  "37410": p("TN", "Chattanooga"),
  "37411": p("TN", "Chattanooga"),
  "37412": p("TN", "Chattanooga"),
  "37414": p("TN", "Chattanooga"),
  "37415": p("TN", "Chattanooga"),
  "37416": p("TN", "Chattanooga"),
  "37419": p("TN", "Chattanooga"),
  "37421": p("TN", "Chattanooga"),
  "37422": p("TN", "Chattanooga"),
  "37424": p("TN", "Chattanooga"),
  "37450": p("TN", "Chattanooga"),
  "37765": p("TN", "Kyles Ford"),
  "37869": p("TN", "Sneedville"),
  "38008": p("TN", "Bolivar"),
  "38039": p("TN", "Grand Junction"),
  "38042": p("TN", "Hickory Valley"),
  "38044": p("TN", "Hornsby"),
  "38052": p("TN", "Middleton"),
  "38061": p("TN", "Pocahontas"),
  "38067": p("TN", "Saulsbury"),
  "38075": p("TN", "Whiteville"),
  "38377": p("TN", "Silerton"),
  "38381": p("TN", "Toone"),
  "38326": p("TN", "Counce"),
  "38327": p("TN", "Crump"),
  "38361": p("TN", "Morris Chapel"),
  "38365": p("TN", "Pickwick Dam"),
  "38370": p("TN", "Saltillo"),
  "38372": p("TN", "Savannah"),
  "38376": p("TN", "Shiloh"),
  "38475": p("TN", "Olivehill"),
  "37642": p("TN", "Church Hill"),
  "37645": p("TN", "Mount Carmel"),
  "37711": p("TN", "Bulls Gap"),
  "37731": p("TN", "Eidson"),
  "37811": p("TN", "Mooresburg"),
  "37857": p("TN", "Rogersville"),
  "37873": p("TN", "Surgoinsville"),
  "38012": p("TN", "Brownsville"),
  "38069": p("TN", "Stanton"),
  "38328": p("TN", "Darden"),
  "38345": p("TN", "Huron"),
  "38351": p("TN", "Lexington"),
  "38368": p("TN", "Reagan"),
  "38371": p("TN", "Sardis"),
  "38388": p("TN", "Wildersville"),
  "38222": p("TN", "Buchanan"),
  "38223": p("TN", "Como"),
  "38224": p("TN", "Cottage Grove"),
  "38231": p("TN", "Henry"),
  "38236": p("TN", "Mansfield"),
  "38242": p("TN", "Paris"),
  "38251": p("TN", "Puryear"),
  "38256": p("TN", "Springville"),
  "37025": p("TN", "Bon Aqua"),
  "37033": p("TN", "Centerville"),
  "37098": p("TN", "Lyles"),
  "37137": p("TN", "Nunnelly"),
  "37140": p("TN", "Only"),
  "38454": p("TN", "Duck River"),
  "38476": p("TN", "Primm Springs"),
  "37061": p("TN", "Erin"),
  "37175": p("TN", "Stewart"),
  "37178": p("TN", "Tennessee Ridge"),
  "37078": p("TN", "Hurricane Mills"),
  "37101": p("TN", "Mc Ewen"),
  "37134": p("TN", "New Johnsonville"),
  "37185": p("TN", "Waverly"),
  "38562": p("TN", "Gainesboro"),
  "38564": p("TN", "Granville"),
  "38588": p("TN", "Whitleyville"),
  "37725": p("TN", "Dandridge"),
  "37760": p("TN", "Jefferson City"),
  "37820": p("TN", "New Market"),
  "37871": p("TN", "Strawberry Plains"),
  "37890": p("TN", "White Pine"),
  "37640": p("TN", "Butler"),
  "37680": p("TN", "Laurel Bloomery"),
  "37683": p("TN", "Mountain City"),
  "37688": p("TN", "Shady Valley"),
  "37691": p("TN", "Trade"),
  "37721": p("TN", "Corryton"),
  "37754": p("TN", "Heiskell"),
  "37806": p("TN", "Mascot"),
  "37849": p("TN", "Powell"),
  "37901": p("TN", "Knoxville"),
  "37902": p("TN", "Knoxville"),
  "37909": p("TN", "Knoxville"),
  "37912": p("TN", "Knoxville"),
  "37914": p("TN", "Knoxville"),
  "37915": p("TN", "Knoxville"),
  "37916": p("TN", "Knoxville"),
  "37917": p("TN", "Knoxville"),
  "37918": p("TN", "Knoxville"),
  "37919": p("TN", "Knoxville"),
  "37920": p("TN", "Knoxville"),
  "37921": p("TN", "Knoxville"),
  "37922": p("TN", "Knoxville"),
  "37923": p("TN", "Knoxville"),
  "37924": p("TN", "Knoxville"),
  "37927": p("TN", "Knoxville"),
  "37928": p("TN", "Knoxville"),
  "37929": p("TN", "Knoxville"),
  "37930": p("TN", "Knoxville"),
  "37931": p("TN", "Knoxville"),
  "37932": p("TN", "Knoxville"),
  "37933": p("TN", "Knoxville"),
  "37934": p("TN", "Knoxville"),
  "37938": p("TN", "Knoxville"),
  "37939": p("TN", "Knoxville"),
  "37940": p("TN", "Knoxville"),
  "37950": p("TN", "Knoxville"),
  "37995": p("TN", "Knoxville"),
  "37996": p("TN", "Knoxville"),
  "37997": p("TN", "Knoxville"),
  "37998": p("TN", "Knoxville"),
  "38077": p("TN", "Wynnburg"),
  "38079": p("TN", "Tiptonville"),
  "38080": p("TN", "Ridgely"),
  "38037": p("TN", "Gates"),
  "38040": p("TN", "Halls"),
  "38041": p("TN", "Henning"),
  "38063": p("TN", "Ripley"),
  "38456": p("TN", "Ethridge"),
  "38457": p("TN", "Five Points"),
  "38463": p("TN", "Iron City"),
  "38464": p("TN", "Lawrenceburg"),
  "38468": p("TN", "Leoma"),
  "38469": p("TN", "Loretto"),
  "38481": p("TN", "Saint Joseph"),
  "38483": p("TN", "Summertown"),
  "38486": p("TN", "Westpoint"),
  "38462": p("TN", "Hohenwald"),
  "37144": p("TN", "Petersburg"),
  "37328": p("TN", "Elora"),
  "37334": p("TN", "Fayetteville"),
  "37335": p("TN", "Flintville"),
  "37348": p("TN", "Kelso"),
  "37359": p("TN", "Mulberry"),
  "38453": p("TN", "Dellrose"),
  "38488": p("TN", "Taft"),
  "37742": p("TN", "Greenback"),
  "37771": p("TN", "Lenoir City"),
  "37772": p("TN", "Lenoir City"),
  "37774": p("TN", "Loudon"),
  "37846": p("TN", "Philadelphia"),
  "37303": p("TN", "Athens"),
  "37309": p("TN", "Calhoun"),
  "37329": p("TN", "Englewood"),
  "37331": p("TN", "Etowah"),
  "37370": p("TN", "Riceville"),
  "37371": p("TN", "Athens"),
  "37826": p("TN", "Niota"),
  "38310": p("TN", "Adamsville"),
  "38315": p("TN", "Bethel Springs"),
  "38334": p("TN", "Finger"),
  "38339": p("TN", "Guys"),
  "38357": p("TN", "Michie"),
  "38359": p("TN", "Milledgeville"),
  "38367": p("TN", "Ramer"),
  "38375": p("TN", "Selmer"),
  "38379": p("TN", "Stantonville"),
  "38393": p("TN", "Chewalla"),
  "37083": p("TN", "Lafayette"),
  "37150": p("TN", "Red Boiling Springs"),
  "38301": p("TN", "Jackson"),
  "38302": p("TN", "Jackson"),
  "38303": p("TN", "Jackson"),
  "38305": p("TN", "Jackson"),
  "38308": p("TN", "Jackson"),
  "38313": p("TN", "Beech Bluff"),
  "38314": p("TN", "Jackson"),
  "38356": p("TN", "Medon"),
  "38362": p("TN", "Oakfield"),
  "38366": p("TN", "Pinson"),
  "38378": p("TN", "Spring Creek"),
  "38391": p("TN", "Denmark"),
  "38392": p("TN", "Mercer"),
  "37340": p("TN", "Guild"),
  "37347": p("TN", "Jasper"),
  "37374": p("TN", "Sequatchie"),
  "37380": p("TN", "South Pittsburg"),
  "37396": p("TN", "Whiteside"),
  "37397": p("TN", "Whitwell"),
  "37019": p("TN", "Belfast"),
  "37034": p("TN", "Chapel Hill"),
  "37047": p("TN", "Cornersville"),
  "37091": p("TN", "Lewisburg"),
  "37174": p("TN", "Spring Hill"),
  "38401": p("TN", "Columbia"),
  "38402": p("TN", "Columbia"),
  "38451": p("TN", "Culleoka"),
  "38461": p("TN", "Hampshire"),
  "38474": p("TN", "Mount Pleasant"),
  "38482": p("TN", "Santa Fe"),
  "38487": p("TN", "Williamsport"),
  "37322": p("TN", "Decatur"),
  "37336": p("TN", "Georgetown"),
  "37880": p("TN", "Ten Mile"),
  "37314": p("TN", "Cokercreek"),
  "37354": p("TN", "Madisonville"),
  "37385": p("TN", "Tellico Plains"),
  "37874": p("TN", "Sweetwater"),
  "37885": p("TN", "Vonore"),
  "37040": p("TN", "Clarksville"),
  "37041": p("TN", "Clarksville"),
  "37042": p("TN", "Clarksville"),
  "37043": p("TN", "Clarksville"),
  "37044": p("TN", "Clarksville"),
  "37052": p("TN", "Cunningham"),
  "37142": p("TN", "Palmyra"),
  "37171": p("TN", "Southside"),
  "37191": p("TN", "Woodlawn"),
  "37352": p("TN", "Lynchburg"),
  "37719": p("TN", "Coalfield"),
  "37726": p("TN", "Deer Lodge"),
  "37733": p("TN", "Rugby"),
  "37770": p("TN", "Lancing"),
  "37829": p("TN", "Oakdale"),
  "37840": p("TN", "Oliver Springs"),
  "37845": p("TN", "Petros"),
  "37872": p("TN", "Sunbright"),
  "37887": p("TN", "Wartburg"),
  "38232": p("TN", "Hornbeak"),
  "38240": p("TN", "Obion"),
  "38253": p("TN", "Rives"),
  "38254": p("TN", "Samburg"),
  "38257": p("TN", "South Fulton"),
  "38260": p("TN", "Troy"),
  "38261": p("TN", "Union City"),
  "38271": p("TN", "Woodland Mills"),
  "38281": p("TN", "Union City"),
  "38541": p("TN", "Allons"),
  "38542": p("TN", "Allred"),
  "38543": p("TN", "Alpine"),
  "38554": p("TN", "Crawford"),
  "38568": p("TN", "Hilham"),
  "38570": p("TN", "Livingston"),
  "38573": p("TN", "Monroe"),
  "38580": p("TN", "Rickman"),
  "37096": p("TN", "Linden"),
  "37097": p("TN", "Lobelville"),
  "38549": p("TN", "Byrdstown"),
  "37307": p("TN", "Benton"),
  "37316": p("TN", "Conasauga"),
  "37317": p("TN", "Copperhill"),
  "37325": p("TN", "Delano"),
  "37326": p("TN", "Ducktown"),
  "37333": p("TN", "Farner"),
  "37361": p("TN", "Ocoee"),
  "37362": p("TN", "Old Fort"),
  "37369": p("TN", "Reliance"),
  "37391": p("TN", "Turtletown"),
  "38501": p("TN", "Cookeville"),
  "38502": p("TN", "Cookeville"),
  "38503": p("TN", "Cookeville"),
  "38505": p("TN", "Cookeville"),
  "38506": p("TN", "Cookeville"),
  "38544": p("TN", "Baxter"),
  "38545": p("TN", "Bloomington Springs"),
  "38548": p("TN", "Buffalo Valley"),
  "38574": p("TN", "Monterey"),
  "38582": p("TN", "Silver Point"),
  "37321": p("TN", "Dayton"),
  "37332": p("TN", "Evensville"),
  "37337": p("TN", "Grandview"),
  "37338": p("TN", "Graysville"),
  "37381": p("TN", "Spring City"),
  "37748": p("TN", "Harriman"),
  "37763": p("TN", "Kingston"),
  "37854": p("TN", "Rockwood"),
  "37010": p("TN", "Adams"),
  "37032": p("TN", "Cedar Hill"),
  "37049": p("TN", "Cross Plains"),
  "37073": p("TN", "Greenbrier"),
  "37141": p("TN", "Orlinda"),
  "37152": p("TN", "Ridgetop"),
  "37172": p("TN", "Springfield"),
  "37188": p("TN", "White House"),
  "37037": p("TN", "Christiana"),
  "37060": p("TN", "Eagleville"),
  "37063": p("TN", "Fosterville"),
  "37085": p("TN", "Lascassas"),
  "37086": p("TN", "La Vergne"),
  "37089": p("TN", "La Vergne"),
  "37118": p("TN", "Milton"),
  "37127": p("TN", "Murfreesboro"),
  "37128": p("TN", "Murfreesboro"),
  "37129": p("TN", "Murfreesboro"),
  "37130": p("TN", "Murfreesboro"),
  "37131": p("TN", "Murfreesboro"),
  "37132": p("TN", "Murfreesboro"),
  "37133": p("TN", "Murfreesboro"),
  "37153": p("TN", "Rockvale"),
  "37167": p("TN", "Smyrna"),
  "37732": p("TN", "Elgin"),
  "37755": p("TN", "Helenwood"),
  "37756": p("TN", "Huntsville"),
  "37841": p("TN", "Oneida"),
  "37852": p("TN", "Robbins"),
  "37892": p("TN", "Winfield"),
  "37327": p("TN", "Dunlap"),
  "37738": p("TN", "Gatlinburg"),
  "37764": p("TN", "Kodak"),
  "37862": p("TN", "Sevierville"),
  "37863": p("TN", "Pigeon Forge"),
  "37864": p("TN", "Sevierville"),
  "37865": p("TN", "Seymour"),
  "37868": p("TN", "Pigeon Forge"),
  "37876": p("TN", "Sevierville"),
  "37501": p("TN", "Memphis"),
  "37544": p("TN", "Memphis"),
  "38002": p("TN", "Arlington"),
  "38014": p("TN", "Brunswick"),
  "38016": p("TN", "Cordova"),
  "38017": p("TN", "Collierville"),
  "38018": p("TN", "Cordova"),
  "38027": p("TN", "Collierville"),
  "38028": p("TN", "Eads"),
  "38029": p("TN", "Ellendale"),
  "38053": p("TN", "Millington"),
  "38054": p("TN", "Millington"),
  "38055": p("TN", "Millington"),
  "38083": p("TN", "Millington"),
  "38088": p("TN", "Cordova"),
  "38101": p("TN", "Memphis"),
  "38103": p("TN", "Memphis"),
  "38104": p("TN", "Memphis"),
  "38105": p("TN", "Memphis"),
  "38106": p("TN", "Memphis"),
  "38107": p("TN", "Memphis"),
  "38108": p("TN", "Memphis"),
  "38109": p("TN", "Memphis"),
  "38111": p("TN", "Memphis"),
  "38112": p("TN", "Memphis"),
  "38113": p("TN", "Memphis"),
  "38114": p("TN", "Memphis"),
  "38115": p("TN", "Memphis"),
  "38116": p("TN", "Memphis"),
  "38117": p("TN", "Memphis"),
  "38118": p("TN", "Memphis"),
  "38119": p("TN", "Memphis"),
  "38120": p("TN", "Memphis"),
  "38122": p("TN", "Memphis"),
  "38124": p("TN", "Memphis"),
  "38125": p("TN", "Memphis"),
  "38126": p("TN", "Memphis"),
  "38127": p("TN", "Memphis"),
  "38128": p("TN", "Memphis"),
  "38130": p("TN", "Memphis"),
  "38131": p("TN", "Memphis"),
  "38132": p("TN", "Memphis"),
  "38133": p("TN", "Memphis"),
  "38134": p("TN", "Memphis"),
  "38135": p("TN", "Memphis"),
  "38136": p("TN", "Memphis"),
  "38137": p("TN", "Memphis"),
  "38138": p("TN", "Germantown"),
  "38139": p("TN", "Germantown"),
  "38141": p("TN", "Memphis"),
  "38145": p("TN", "Memphis"),
  "38148": p("TN", "Memphis"),
  "38150": p("TN", "Memphis"),
  "38151": p("TN", "Memphis"),
  "38152": p("TN", "Memphis"),
  "38157": p("TN", "Memphis"),
  "38159": p("TN", "Memphis"),
  "38161": p("TN", "Memphis"),
  "38163": p("TN", "Memphis"),
  "38166": p("TN", "Memphis"),
  "38167": p("TN", "Memphis"),
  "38168": p("TN", "Memphis"),
  "38173": p("TN", "Memphis"),
  "38174": p("TN", "Memphis"),
  "38175": p("TN", "Memphis"),
  "38177": p("TN", "Memphis"),
  "38181": p("TN", "Memphis"),
  "38182": p("TN", "Memphis"),
  "38183": p("TN", "Germantown"),
  "38184": p("TN", "Memphis"),
  "38186": p("TN", "Memphis"),
  "38187": p("TN", "Memphis"),
  "38188": p("TN", "Memphis"),
  "38190": p("TN", "Memphis"),
  "38193": p("TN", "Memphis"),
  "38194": p("TN", "Memphis"),
  "38197": p("TN", "Memphis"),
  "37030": p("TN", "Carthage"),
  "37057": p("TN", "Dixon Springs"),
  "37145": p("TN", "Pleasant Shade"),
  "37151": p("TN", "Riddleton"),
  "38547": p("TN", "Brush Creek"),
  "38552": p("TN", "Chestnut Mound"),
  "38560": p("TN", "Elmwood"),
  "38563": p("TN", "Gordonsville"),
  "38567": p("TN", "Hickman"),
  "38569": p("TN", "Lancaster"),
  "37023": p("TN", "Big Rock"),
  "37028": p("TN", "Bumpus Mills"),
  "37050": p("TN", "Cumberland City"),
  "37058": p("TN", "Dover"),
  "37079": p("TN", "Indian Mound"),
  "37617": p("TN", "Blountville"),
  "37618": p("TN", "Bluff City"),
  "37620": p("TN", "Bristol"),
  "37621": p("TN", "Bristol"),
  "37625": p("TN", "Bristol"),
  "37660": p("TN", "Kingsport"),
  "37662": p("TN", "Kingsport"),
  "37663": p("TN", "Kingsport"),
  "37664": p("TN", "Kingsport"),
  "37665": p("TN", "Kingsport"),
  "37669": p("TN", "Kingsport"),
  "37686": p("TN", "Piney Flats"),
  "37699": p("TN", "Piney Flats"),
  "37022": p("TN", "Bethpage"),
  "37031": p("TN", "Castalian Springs"),
  "37048": p("TN", "Cottontown"),
  "37066": p("TN", "Gallatin"),
  "37075": p("TN", "Hendersonville"),
  "37077": p("TN", "Hendersonville"),
  "37119": p("TN", "Mitchellville"),
  "37148": p("TN", "Portland"),
  "37186": p("TN", "Westmoreland"),
  "38004": p("TN", "Atoka"),
  "38011": p("TN", "Brighton"),
  "38015": p("TN", "Burlison"),
  "38019": p("TN", "Covington"),
  "38023": p("TN", "Drummonds"),
  "38049": p("TN", "Mason"),
  "38058": p("TN", "Munford"),
  "38071": p("TN", "Tipton"),
  "37074": p("TN", "Hartsville"),
  "37650": p("TN", "Erwin"),
  "37657": p("TN", "Flag Pond"),
  "37692": p("TN", "Unicoi"),
  "37779": p("TN", "Luttrell"),
  "37807": p("TN", "Maynardville"),
  "37866": p("TN", "Sharps Chapel"),
  "38585": p("TN", "Spencer"),
  "37110": p("TN", "Mcminnville"),
  "37111": p("TN", "Mcminnville"),
  "37357": p("TN", "Morrison"),
  "37378": p("TN", "Smartt"),
  "37394": p("TN", "Viola"),
  "38550": p("TN", "Campaign"),
  "38581": p("TN", "Rock Island"),
  "37601": p("TN", "Johnson City"),
  "37602": p("TN", "Johnson City"),
  "37604": p("TN", "Johnson City"),
  "37605": p("TN", "Johnson City"),
  "37614": p("TN", "Johnson City"),
  "37615": p("TN", "Johnson City"),
  "37656": p("TN", "Fall Branch"),
  "37659": p("TN", "Jonesborough"),
  "37681": p("TN", "Limestone"),
  "37684": p("TN", "Mountain Home"),
  "37690": p("TN", "Telford"),
  "38425": p("TN", "Clifton"),
  "38450": p("TN", "Collinwood"),
  "38452": p("TN", "Cypress Inn"),
  "38471": p("TN", "Lutts"),
  "38485": p("TN", "Waynesboro"),
  "38225": p("TN", "Dresden"),
  "38226": p("TN", "Dukedom"),
  "38229": p("TN", "Gleason"),
  "38230": p("TN", "Greenfield"),
  "38237": p("TN", "Martin"),
  "38238": p("TN", "Martin"),
  "38241": p("TN", "Palmersville"),
  "38255": p("TN", "Sharon"),
  "38559": p("TN", "Doyle"),
  "38579": p("TN", "Quebeck"),
  "38583": p("TN", "Sparta"),
  "38587": p("TN", "Walling"),
  "37014": p("TN", "Arrington"),
  "37024": p("TN", "Brentwood"),
  "37027": p("TN", "Brentwood"),
  "37046": p("TN", "College Grove"),
  "37062": p("TN", "Fairview"),
  "37064": p("TN", "Franklin"),
  "37065": p("TN", "Franklin"),
  "37067": p("TN", "Franklin"),
  "37068": p("TN", "Franklin"),
  "37069": p("TN", "Franklin"),
  "37135": p("TN", "Nolensville"),
  "37179": p("TN", "Thompsons Station"),
  "37071": p("TN", "Gladeville"),
  "37087": p("TN", "Lebanon"),
  "37088": p("TN", "Lebanon"),
  "37090": p("TN", "Lebanon"),
  "37121": p("TN", "Mount Juliet"),
  "37122": p("TN", "Mount Juliet"),
  "37136": p("TN", "Norene"),
  "37184": p("TN", "Watertown"),
  "75763": p("TX", "Frankston"),
  "75779": p("TX", "Neches"),
  "75801": p("TX", "Palestine"),
  "75802": p("TX", "Palestine"),
  "75803": p("TX", "Palestine"),
  "75832": p("TX", "Cayuga"),
  "75839": p("TX", "Elkhart"),
  "75853": p("TX", "Montalba"),
  "75861": p("TX", "Tennessee Colony"),
  "75880": p("TX", "Tennessee Colony"),
  "75882": p("TX", "Palestine"),
  "75884": p("TX", "Tennessee Colony"),
  "75886": p("TX", "Tennessee Colony"),
  "79714": p("TX", "Andrews"),
  "75901": p("TX", "Lufkin"),
  "75902": p("TX", "Lufkin"),
  "75903": p("TX", "Lufkin"),
  "75904": p("TX", "Lufkin"),
  "75915": p("TX", "Lufkin"),
  "75941": p("TX", "Diboll"),
  "75949": p("TX", "Huntington"),
  "75969": p("TX", "Pollok"),
  "75980": p("TX", "Zavalla"),
  "78358": p("TX", "Fulton"),
  "78381": p("TX", "Rockport"),
  "78382": p("TX", "Rockport"),
  "76351": p("TX", "Archer City"),
  "76366": p("TX", "Holliday"),
  "76370": p("TX", "Megargel"),
  "76379": p("TX", "Scotland"),
  "76389": p("TX", "Windthorst"),
  "79019": p("TX", "Claude"),
  "79094": p("TX", "Wayside"),
  "78008": p("TX", "Campbellton"),
  "78011": p("TX", "Charlotte"),
  "78012": p("TX", "Christine"),
  "78026": p("TX", "Jourdanton"),
  "78050": p("TX", "Leming"),
  "78052": p("TX", "Lytle"),
  "78062": p("TX", "Peggy"),
  "78064": p("TX", "Pleasanton"),
  "78065": p("TX", "Poteet"),
  "77418": p("TX", "Bellville"),
  "77452": p("TX", "Kenney"),
  "77473": p("TX", "San Felipe"),
  "77474": p("TX", "Sealy"),
  "77485": p("TX", "Wallis"),
  "78931": p("TX", "Bleiblerville"),
  "78933": p("TX", "Cat Spring"),
  "78944": p("TX", "Industry"),
  "78950": p("TX", "New Ulm"),
  "79324": p("TX", "Enochs"),
  "79344": p("TX", "Maple"),
  "79347": p("TX", "Muleshoe"),
  "78003": p("TX", "Bandera"),
  "78055": p("TX", "Medina"),
  "78063": p("TX", "Pipe Creek"),
  "78883": p("TX", "Tarpley"),
  "78885": p("TX", "Vanderpool"),
  "78602": p("TX", "Bastrop"),
  "78612": p("TX", "Cedar Creek"),
  "78621": p("TX", "Elgin"),
  "78650": p("TX", "Mc Dade"),
  "78659": p("TX", "Paige"),
  "78662": p("TX", "Red Rock"),
  "78953": p("TX", "Rosanky"),
  "78957": p("TX", "Smithville"),
  "76380": p("TX", "Seymour"),
  "78102": p("TX", "Beeville"),
  "78104": p("TX", "Beeville"),
  "78125": p("TX", "Mineral"),
  "78142": p("TX", "Normanna"),
  "78145": p("TX", "Pawnee"),
  "78146": p("TX", "Pettus"),
  "78162": p("TX", "Tuleta"),
  "78389": p("TX", "Skidmore"),
  "78391": p("TX", "Tynan"),
  "76501": p("TX", "Temple"),
  "76502": p("TX", "Temple"),
  "76503": p("TX", "Temple"),
  "76504": p("TX", "Temple"),
  "76508": p("TX", "Temple"),
  "76511": p("TX", "Bartlett"),
  "76513": p("TX", "Belton"),
  "76533": p("TX", "Heidenheimer"),
  "76534": p("TX", "Holland"),
  "76540": p("TX", "Killeen"),
  "76541": p("TX", "Killeen"),
  "76542": p("TX", "Killeen"),
  "76543": p("TX", "Killeen"),
  "76544": p("TX", "Fort Hood"),
  "76547": p("TX", "Killeen"),
  "76548": p("TX", "Harker Heights"),
  "76549": p("TX", "Killeen"),
  "76554": p("TX", "Little River Academy"),
  "76559": p("TX", "Nolanville"),
  "76564": p("TX", "Pendleton"),
  "76569": p("TX", "Rogers"),
  "76571": p("TX", "Salado"),
  "76579": p("TX", "Troy"),
  "78002": p("TX", "Atascosa"),
  "78015": p("TX", "Boerne"),
  "78023": p("TX", "Helotes"),
  "78054": p("TX", "Macdona"),
  "78069": p("TX", "Somerset"),
  "78073": p("TX", "Von Ormy"),
  "78101": p("TX", "Adkins"),
  "78109": p("TX", "Converse"),
  "78112": p("TX", "Elmendorf"),
  "78148": p("TX", "Universal City"),
  "78150": p("TX", "Jbsa Randolph"),
  "78152": p("TX", "Saint Hedwig"),
  "78201": p("TX", "San Antonio"),
  "78202": p("TX", "San Antonio"),
  "78203": p("TX", "San Antonio"),
  "78204": p("TX", "San Antonio"),
  "78205": p("TX", "San Antonio"),
  "78206": p("TX", "San Antonio"),
  "78207": p("TX", "San Antonio"),
  "78208": p("TX", "San Antonio"),
  "78209": p("TX", "San Antonio"),
  "78210": p("TX", "San Antonio"),
  "78211": p("TX", "San Antonio"),
  "78212": p("TX", "San Antonio"),
  "78213": p("TX", "San Antonio"),
  "78214": p("TX", "San Antonio"),
  "78215": p("TX", "San Antonio"),
  "78216": p("TX", "San Antonio"),
  "78217": p("TX", "San Antonio"),
  "78218": p("TX", "San Antonio"),
  "78219": p("TX", "San Antonio"),
  "78220": p("TX", "San Antonio"),
  "78221": p("TX", "San Antonio"),
  "78222": p("TX", "San Antonio"),
  "78223": p("TX", "San Antonio"),
  "78224": p("TX", "San Antonio"),
  "78225": p("TX", "San Antonio"),
  "78226": p("TX", "San Antonio"),
  "78227": p("TX", "San Antonio"),
  "78228": p("TX", "San Antonio"),
  "78229": p("TX", "San Antonio"),
  "78230": p("TX", "San Antonio"),
  "78231": p("TX", "San Antonio"),
  "78232": p("TX", "San Antonio"),
  "78233": p("TX", "San Antonio"),
  "78234": p("TX", "Jbsa Ft Sam Houston"),
  "78235": p("TX", "San Antonio"),
  "78236": p("TX", "Jbsa Lackland"),
  "78237": p("TX", "San Antonio"),
  "78238": p("TX", "San Antonio"),
  "78239": p("TX", "San Antonio"),
  "78240": p("TX", "San Antonio"),
  "78241": p("TX", "San Antonio"),
  "78242": p("TX", "San Antonio"),
  "78243": p("TX", "San Antonio"),
  "78244": p("TX", "San Antonio"),
  "78245": p("TX", "San Antonio"),
  "78246": p("TX", "San Antonio"),
  "78247": p("TX", "San Antonio"),
  "78248": p("TX", "San Antonio"),
  "78249": p("TX", "San Antonio"),
  "78250": p("TX", "San Antonio"),
  "78251": p("TX", "San Antonio"),
  "78252": p("TX", "San Antonio"),
  "78253": p("TX", "San Antonio"),
  "78254": p("TX", "San Antonio"),
  "78255": p("TX", "San Antonio"),
  "78256": p("TX", "San Antonio"),
  "78257": p("TX", "San Antonio"),
  "78258": p("TX", "San Antonio"),
  "78259": p("TX", "San Antonio"),
  "78260": p("TX", "San Antonio"),
  "78261": p("TX", "San Antonio"),
  "78263": p("TX", "San Antonio"),
  "78264": p("TX", "San Antonio"),
  "78265": p("TX", "San Antonio"),
  "78268": p("TX", "San Antonio"),
  "78269": p("TX", "San Antonio"),
  "78270": p("TX", "San Antonio"),
  "78278": p("TX", "San Antonio"),
  "78279": p("TX", "San Antonio"),
  "78280": p("TX", "San Antonio"),
  "78283": p("TX", "San Antonio"),
  "78284": p("TX", "San Antonio"),
  "78285": p("TX", "San Antonio"),
  "78288": p("TX", "San Antonio"),
  "78289": p("TX", "San Antonio"),
  "78291": p("TX", "San Antonio"),
  "78292": p("TX", "San Antonio"),
  "78293": p("TX", "San Antonio"),
  "78294": p("TX", "San Antonio"),
  "78295": p("TX", "San Antonio"),
  "78296": p("TX", "San Antonio"),
  "78297": p("TX", "San Antonio"),
  "78298": p("TX", "San Antonio"),
  "78299": p("TX", "San Antonio"),
  "78606": p("TX", "Blanco"),
  "78635": p("TX", "Hye"),
  "78636": p("TX", "Johnson City"),
  "78663": p("TX", "Round Mountain"),
  "79738": p("TX", "Gail"),
  "76634": p("TX", "Clifton"),
  "76637": p("TX", "Cranfills Gap"),
  "76644": p("TX", "Laguna Park"),
  "76649": p("TX", "Iredell"),
  "76652": p("TX", "Kopperl"),
  "76665": p("TX", "Meridian"),
  "76671": p("TX", "Morgan"),
  "76689": p("TX", "Valley Mills"),
  "76690": p("TX", "Walnut Springs"),
  "75501": p("TX", "Texarkana"),
  "75503": p("TX", "Texarkana"),
  "75504": p("TX", "Texarkana"),
  "75505": p("TX", "Texarkana"),
  "75507": p("TX", "Texarkana"),
  "75559": p("TX", "De Kalb"),
  "75561": p("TX", "Hooks"),
  "75567": p("TX", "Maud"),
  "75569": p("TX", "Nash"),
  "75570": p("TX", "New Boston"),
  "75573": p("TX", "Redwater"),
  "75574": p("TX", "Simms"),
  "75599": p("TX", "Texarkana"),
  "77422": p("TX", "Brazoria"),
  "77430": p("TX", "Damon"),
  "77431": p("TX", "Danciger"),
  "77463": p("TX", "Old Ocean"),
  "77480": p("TX", "Sweeny"),
  "77486": p("TX", "West Columbia"),
  "77511": p("TX", "Alvin"),
  "77512": p("TX", "Alvin"),
  "77515": p("TX", "Angleton"),
  "77516": p("TX", "Angleton"),
  "77531": p("TX", "Clute"),
  "77534": p("TX", "Danbury"),
  "77541": p("TX", "Freeport"),
  "77542": p("TX", "Freeport"),
  "77566": p("TX", "Lake Jackson"),
  "77577": p("TX", "Liverpool"),
  "77578": p("TX", "Manvel"),
  "77581": p("TX", "Pearland"),
  "77583": p("TX", "Rosharon"),
  "77584": p("TX", "Pearland"),
  "77588": p("TX", "Pearland"),
  "77801": p("TX", "Bryan"),
  "77802": p("TX", "Bryan"),
  "77803": p("TX", "Bryan"),
  "77805": p("TX", "Bryan"),
  "77806": p("TX", "Bryan"),
  "77807": p("TX", "Bryan"),
  "77808": p("TX", "Bryan"),
  "77840": p("TX", "College Station"),
  "77841": p("TX", "College Station"),
  "77842": p("TX", "College Station"),
  "77843": p("TX", "College Station"),
  "77844": p("TX", "College Station"),
  "77845": p("TX", "College Station"),
  "77862": p("TX", "Kurten"),
  "77866": p("TX", "Millican"),
  "77881": p("TX", "Wellborn"),
  "79830": p("TX", "Alpine"),
  "79831": p("TX", "Alpine"),
  "79832": p("TX", "Alpine"),
  "79834": p("TX", "Big Bend National Park"),
  "79842": p("TX", "Marathon"),
  "79852": p("TX", "Terlingua"),
  "79255": p("TX", "Quitaque"),
  "79257": p("TX", "Silverton"),
  "78353": p("TX", "Encino"),
  "78355": p("TX", "Falfurrias"),
  "76432": p("TX", "Blanket"),
  "76801": p("TX", "Brownwood"),
  "76802": p("TX", "Early"),
  "76803": p("TX", "Early"),
  "76804": p("TX", "Brownwood"),
  "76823": p("TX", "Bangs"),
  "76827": p("TX", "Brookesmith"),
  "76857": p("TX", "May"),
  "76890": p("TX", "Zephyr"),
  "77836": p("TX", "Caldwell"),
  "77838": p("TX", "Chriesman"),
  "77852": p("TX", "Deanville"),
  "77863": p("TX", "Lyons"),
  "77878": p("TX", "Snook"),
  "77879": p("TX", "Somerville"),
  "78605": p("TX", "Bertram"),
  "78608": p("TX", "Briggs"),
  "78611": p("TX", "Burnet"),
  "78654": p("TX", "Marble Falls"),
  "78616": p("TX", "Dale"),
  "78622": p("TX", "Fentress"),
  "78644": p("TX", "Lockhart"),
  "78648": p("TX", "Luling"),
  "78655": p("TX", "Martindale"),
  "78656": p("TX", "Maxwell"),
  "78661": p("TX", "Prairie Lea"),
  "77978": p("TX", "Point Comfort"),
  "77979": p("TX", "Port Lavaca"),
  "77982": p("TX", "Port O Connor"),
  "77983": p("TX", "Seadrift"),
  "76443": p("TX", "Cross Plains"),
  "76469": p("TX", "Putnam"),
  "79504": p("TX", "Baird"),
  "79510": p("TX", "Clyde"),
  "78520": p("TX", "Brownsville"),
  "78521": p("TX", "Brownsville"),
  "78522": p("TX", "Brownsville"),
  "78523": p("TX", "Brownsville"),
  "78526": p("TX", "Brownsville"),
  "78535": p("TX", "Combes"),
  "78550": p("TX", "Harlingen"),
  "78551": p("TX", "Harlingen"),
  "78552": p("TX", "Harlingen"),
  "78553": p("TX", "Harlingen"),
  "78559": p("TX", "La Feria"),
  "78566": p("TX", "Los Fresnos"),
  "78567": p("TX", "Los Indios"),
  "78568": p("TX", "Lozano"),
  "78575": p("TX", "Olmito"),
  "78578": p("TX", "Port Isabel"),
  "78583": p("TX", "Rio Hondo"),
  "78586": p("TX", "San Benito"),
  "78592": p("TX", "Santa Maria"),
  "78593": p("TX", "Santa Rosa"),
  "78597": p("TX", "South Padre Island"),
  "75451": p("TX", "Leesburg"),
  "75686": p("TX", "Pittsburg"),
  "79039": p("TX", "Groom"),
  "79068": p("TX", "Panhandle"),
  "79080": p("TX", "Skellytown"),
  "79097": p("TX", "White Deer"),
  "75551": p("TX", "Atlanta"),
  "75555": p("TX", "Bivins"),
  "75556": p("TX", "Bloomburg"),
  "75560": p("TX", "Douglassville"),
  "75562": p("TX", "Kildare"),
  "75563": p("TX", "Linden"),
  "75565": p("TX", "Mc Leod"),
  "75566": p("TX", "Marietta"),
  "75572": p("TX", "Queen City"),
  "75630": p("TX", "Avinger"),
  "75656": p("TX", "Hughes Springs"),
  "79027": p("TX", "Dimmitt"),
  "79043": p("TX", "Hart"),
  "79063": p("TX", "Nazareth"),
  "79085": p("TX", "Summerfield"),
  "77514": p("TX", "Anahuac"),
  "77523": p("TX", "Baytown"),
  "77560": p("TX", "Hankamer"),
  "77580": p("TX", "Mont Belvieu"),
  "77597": p("TX", "Wallisville"),
  "77661": p("TX", "Stowell"),
  "77665": p("TX", "Winnie"),
  "75759": p("TX", "Cuney"),
  "75764": p("TX", "Gallatin"),
  "75766": p("TX", "Jacksonville"),
  "75772": p("TX", "Maydelle"),
  "75780": p("TX", "New Summerfield"),
  "75784": p("TX", "Reklaw"),
  "75785": p("TX", "Rusk"),
  "75925": p("TX", "Alto"),
  "75976": p("TX", "Wells"),
  "79201": p("TX", "Childress"),
  "79259": p("TX", "Tell"),
  "76228": p("TX", "Bellevue"),
  "76352": p("TX", "Bluegrove"),
  "76357": p("TX", "Byers"),
  "76365": p("TX", "Henrietta"),
  "76377": p("TX", "Petrolia"),
  "79314": p("TX", "Bledsoe"),
  "79346": p("TX", "Morton"),
  "79379": p("TX", "Whiteface"),
  "76933": p("TX", "Bronte"),
  "76945": p("TX", "Robert Lee"),
  "76949": p("TX", "Silver"),
  "76953": p("TX", "Tennyson"),
  "76828": p("TX", "Burkett"),
  "76834": p("TX", "Coleman"),
  "76845": p("TX", "Gouldbusk"),
  "76873": p("TX", "Rockwood"),
  "76878": p("TX", "Santa Anna"),
  "76882": p("TX", "Talpa"),
  "76884": p("TX", "Valera"),
  "76888": p("TX", "Voss"),
  "79519": p("TX", "Goldsboro"),
  "79538": p("TX", "Novice"),
  "75002": p("TX", "Allen"),
  "75009": p("TX", "Celina"),
  "75013": p("TX", "Allen"),
  "75023": p("TX", "Plano"),
  "75024": p("TX", "Plano"),
  "75025": p("TX", "Plano"),
  "75026": p("TX", "Plano"),
  "75033": p("TX", "Frisco"),
  "75034": p("TX", "Frisco"),
  "75035": p("TX", "Frisco"),
  "75036": p("TX", "Frisco"),
  "75069": p("TX", "Mckinney"),
  "75070": p("TX", "Mckinney"),
  "75071": p("TX", "Mckinney"),
  "75072": p("TX", "Mckinney"),
  "75074": p("TX", "Plano"),
  "75075": p("TX", "Plano"),
  "75078": p("TX", "Prosper"),
  "75086": p("TX", "Plano"),
  "75093": p("TX", "Plano"),
  "75094": p("TX", "Plano"),
  "75097": p("TX", "Weston"),
  "75121": p("TX", "Copeville"),
  "75164": p("TX", "Josephine"),
  "75166": p("TX", "Lavon"),
  "75173": p("TX", "Nevada"),
  "75407": p("TX", "Princeton"),
  "75409": p("TX", "Anna"),
  "75424": p("TX", "Blue Ridge"),
  "75442": p("TX", "Farmersville"),
  "75454": p("TX", "Melissa"),
  "75485": p("TX", "Westminster"),
  "79077": p("TX", "Samnorwood"),
  "79095": p("TX", "Wellington"),
  "79230": p("TX", "Dodson"),
  "79251": p("TX", "Quail"),
  "77412": p("TX", "Altair"),
  "77434": p("TX", "Eagle Lake"),
  "77442": p("TX", "Garwood"),
  "77460": p("TX", "Nada"),
  "77470": p("TX", "Rock Island"),
  "77475": p("TX", "Sheridan"),
  "78934": p("TX", "Columbus"),
  "78935": p("TX", "Alleyton"),
  "78943": p("TX", "Glidden"),
  "78951": p("TX", "Oakland"),
  "78962": p("TX", "Weimar"),
  "78070": p("TX", "Spring Branch"),
  "78130": p("TX", "New Braunfels"),
  "78131": p("TX", "New Braunfels"),
  "78132": p("TX", "New Braunfels"),
  "78133": p("TX", "Canyon Lake"),
  "78135": p("TX", "New Braunfels"),
  "78163": p("TX", "Bulverde"),
  "78266": p("TX", "San Antonio"),
  "78623": p("TX", "Fischer"),
  "76442": p("TX", "Comanche"),
  "76444": p("TX", "De Leon"),
  "76452": p("TX", "Energy"),
  "76455": p("TX", "Gustine"),
  "76468": p("TX", "Proctor"),
  "76474": p("TX", "Sidney"),
  "76837": p("TX", "Eden"),
  "76855": p("TX", "Lowake"),
  "76862": p("TX", "Millersview"),
  "76866": p("TX", "Paint Rock"),
  "76937": p("TX", "Eola"),
  "76238": p("TX", "Era"),
  "76240": p("TX", "Gainesville"),
  "76241": p("TX", "Gainesville"),
  "76250": p("TX", "Lindsay"),
  "76252": p("TX", "Muenster"),
  "76253": p("TX", "Myra"),
  "76263": p("TX", "Rosston"),
  "76272": p("TX", "Valley View"),
  "76522": p("TX", "Copperas Cove"),
  "76525": p("TX", "Evant"),
  "76526": p("TX", "Flat"),
  "76528": p("TX", "Gatesville"),
  "76538": p("TX", "Jonesboro"),
  "76558": p("TX", "Mound"),
  "76561": p("TX", "Oglesby"),
  "76566": p("TX", "Purmela"),
  "76596": p("TX", "Gatesville"),
  "76597": p("TX", "Gatesville"),
  "76598": p("TX", "Gatesville"),
  "76599": p("TX", "Gatesville"),
  "79223": p("TX", "Cee Vee"),
  "79248": p("TX", "Paducah"),
  "79731": p("TX", "Crane"),
  "76943": p("TX", "Ozona"),
  "79322": p("TX", "Crosbyton"),
  "79343": p("TX", "Lorenzo"),
  "79357": p("TX", "Ralls"),
  "79855": p("TX", "Van Horn"),
  "79022": p("TX", "Dalhart"),
  "79051": p("TX", "Kerrick"),
  "79087": p("TX", "Texline"),
  "75001": p("TX", "Addison"),
  "75006": p("TX", "Carrollton"),
  "75011": p("TX", "Carrollton"),
  "75014": p("TX", "Irving"),
  "75015": p("TX", "Irving"),
  "75016": p("TX", "Irving"),
  "75017": p("TX", "Irving"),
  "75019": p("TX", "Coppell"),
  "75030": p("TX", "Rowlett"),
  "75038": p("TX", "Irving"),
  "75039": p("TX", "Irving"),
  "75040": p("TX", "Garland"),
  "75041": p("TX", "Garland"),
  "75042": p("TX", "Garland"),
  "75043": p("TX", "Garland"),
  "75044": p("TX", "Garland"),
  "75045": p("TX", "Garland"),
  "75046": p("TX", "Garland"),
  "75047": p("TX", "Garland"),
  "75048": p("TX", "Sachse"),
  "75049": p("TX", "Garland"),
  "75050": p("TX", "Grand Prairie"),
  "75051": p("TX", "Grand Prairie"),
  "75052": p("TX", "Grand Prairie"),
  "75053": p("TX", "Grand Prairie"),
  "75054": p("TX", "Grand Prairie"),
  "75059": p("TX", "Irving"),
  "75060": p("TX", "Irving"),
  "75061": p("TX", "Irving"),
  "75062": p("TX", "Irving"),
  "75063": p("TX", "Irving"),
  "75064": p("TX", "Irving"),
  "75080": p("TX", "Richardson"),
  "75081": p("TX", "Richardson"),
  "75082": p("TX", "Richardson"),
  "75083": p("TX", "Richardson"),
  "75085": p("TX", "Richardson"),
  "75088": p("TX", "Rowlett"),
  "75089": p("TX", "Rowlett"),
  "75098": p("TX", "Wylie"),
  "75099": p("TX", "Coppell"),
  "75104": p("TX", "Cedar Hill"),
  "75106": p("TX", "Cedar Hill"),
  "75115": p("TX", "Desoto"),
  "75116": p("TX", "Duncanville"),
  "75123": p("TX", "Desoto"),
  "75134": p("TX", "Lancaster"),
  "75137": p("TX", "Duncanville"),
  "75138": p("TX", "Duncanville"),
  "75141": p("TX", "Hutchins"),
  "75146": p("TX", "Lancaster"),
  "75149": p("TX", "Mesquite"),
  "75150": p("TX", "Mesquite"),
  "75159": p("TX", "Seagoville"),
  "75172": p("TX", "Wilmer"),
  "75180": p("TX", "Balch Springs"),
  "75181": p("TX", "Mesquite"),
  "75182": p("TX", "Sunnyvale"),
  "75185": p("TX", "Mesquite"),
  "75187": p("TX", "Mesquite"),
  "75201": p("TX", "Dallas"),
  "75202": p("TX", "Dallas"),
  "75203": p("TX", "Dallas"),
  "75204": p("TX", "Dallas"),
  "75205": p("TX", "Dallas"),
  "75206": p("TX", "Dallas"),
  "75207": p("TX", "Dallas"),
  "75208": p("TX", "Dallas"),
  "75209": p("TX", "Dallas"),
  "75210": p("TX", "Dallas"),
  "75211": p("TX", "Dallas"),
  "75212": p("TX", "Dallas"),
  "75214": p("TX", "Dallas"),
  "75215": p("TX", "Dallas"),
  "75216": p("TX", "Dallas"),
  "75217": p("TX", "Dallas"),
  "75218": p("TX", "Dallas"),
  "75219": p("TX", "Dallas"),
  "75220": p("TX", "Dallas"),
  "75221": p("TX", "Dallas"),
  "75222": p("TX", "Dallas"),
  "75223": p("TX", "Dallas"),
  "75224": p("TX", "Dallas"),
  "75225": p("TX", "Dallas"),
  "75226": p("TX", "Dallas"),
  "75227": p("TX", "Dallas"),
  "75228": p("TX", "Dallas"),
  "75229": p("TX", "Dallas"),
  "75230": p("TX", "Dallas"),
  "75231": p("TX", "Dallas"),
  "75232": p("TX", "Dallas"),
  "75233": p("TX", "Dallas"),
  "75234": p("TX", "Dallas"),
  "75235": p("TX", "Dallas"),
  "75236": p("TX", "Dallas"),
  "75237": p("TX", "Dallas"),
  "75238": p("TX", "Dallas"),
  "75240": p("TX", "Dallas"),
  "75241": p("TX", "Dallas"),
  "75242": p("TX", "Dallas"),
  "75243": p("TX", "Dallas"),
  "75244": p("TX", "Dallas"),
  "75246": p("TX", "Dallas"),
  "75247": p("TX", "Dallas"),
  "75248": p("TX", "Dallas"),
  "75249": p("TX", "Dallas"),
  "75250": p("TX", "Dallas"),
  "75251": p("TX", "Dallas"),
  "75252": p("TX", "Dallas"),
  "75253": p("TX", "Dallas"),
  "75254": p("TX", "Dallas"),
  "75260": p("TX", "Dallas"),
  "75261": p("TX", "Dallas"),
  "75262": p("TX", "Dallas"),
  "75263": p("TX", "Dallas"),
  "75264": p("TX", "Dallas"),
  "75265": p("TX", "Dallas"),
  "75266": p("TX", "Dallas"),
  "75267": p("TX", "Dallas"),
  "75270": p("TX", "Dallas"),
  "75275": p("TX", "Dallas"),
  "75277": p("TX", "Dallas"),
  "75283": p("TX", "Dallas"),
  "75284": p("TX", "Dallas"),
  "75285": p("TX", "Dallas"),
  "75287": p("TX", "Dallas"),
  "75301": p("TX", "Dallas"),
  "75303": p("TX", "Dallas"),
  "75312": p("TX", "Dallas"),
  "75313": p("TX", "Dallas"),
  "75315": p("TX", "Dallas"),
  "75320": p("TX", "Dallas"),
  "75326": p("TX", "Dallas"),
  "75336": p("TX", "Dallas"),
  "75339": p("TX", "Dallas"),
  "75342": p("TX", "Dallas"),
  "75354": p("TX", "Dallas"),
  "75355": p("TX", "Dallas"),
  "75356": p("TX", "Dallas"),
  "75357": p("TX", "Dallas"),
  "75358": p("TX", "Dallas"),
  "75359": p("TX", "Dallas"),
  "75360": p("TX", "Dallas"),
  "75367": p("TX", "Dallas"),
  "75368": p("TX", "Dallas"),
  "75370": p("TX", "Dallas"),
  "75371": p("TX", "Dallas"),
  "75372": p("TX", "Dallas"),
  "75373": p("TX", "Dallas"),
  "75374": p("TX", "Dallas"),
  "75376": p("TX", "Dallas"),
  "75378": p("TX", "Dallas"),
  "75379": p("TX", "Dallas"),
  "75380": p("TX", "Dallas"),
  "75381": p("TX", "Dallas"),
  "75382": p("TX", "Dallas"),
  "75389": p("TX", "Dallas"),
  "75390": p("TX", "Dallas"),
  "75391": p("TX", "Dallas"),
  "75392": p("TX", "Dallas"),
  "75393": p("TX", "Dallas"),
  "75394": p("TX", "Dallas"),
  "75395": p("TX", "Dallas"),
  "75397": p("TX", "Dallas"),
  "75398": p("TX", "Dallas"),
  "79331": p("TX", "Lamesa"),
  "79377": p("TX", "Welch"),
  "79713": p("TX", "Ackerly"),
  "79025": p("TX", "Dawn"),
  "79045": p("TX", "Hereford"),
  "75415": p("TX", "Ben Franklin"),
  "75432": p("TX", "Cooper"),
  "75441": p("TX", "Enloe"),
  "75448": p("TX", "Klondike"),
  "75450": p("TX", "Lake Creek"),
  "75469": p("TX", "Pecan Gap"),
  "75007": p("TX", "Carrollton"),
  "75010": p("TX", "Carrollton"),
  "75022": p("TX", "Flower Mound"),
  "75027": p("TX", "Flower Mound"),
  "75028": p("TX", "Flower Mound"),
  "75029": p("TX", "Lewisville"),
  "75056": p("TX", "The Colony"),
  "75057": p("TX", "Lewisville"),
  "75065": p("TX", "Lake Dallas"),
  "75067": p("TX", "Lewisville"),
  "75068": p("TX", "Little Elm"),
  "75077": p("TX", "Lewisville"),
  "76201": p("TX", "Denton"),
  "76202": p("TX", "Denton"),
  "76203": p("TX", "Denton"),
  "76204": p("TX", "Denton"),
  "76205": p("TX", "Denton"),
  "76206": p("TX", "Denton"),
  "76207": p("TX", "Denton"),
  "76208": p("TX", "Denton"),
  "76209": p("TX", "Denton"),
  "76210": p("TX", "Denton"),
  "76226": p("TX", "Argyle"),
  "76227": p("TX", "Aubrey"),
  "76247": p("TX", "Justin"),
  "76249": p("TX", "Krum"),
  "76258": p("TX", "Pilot Point"),
  "76259": p("TX", "Ponder"),
  "76262": p("TX", "Roanoke"),
  "76266": p("TX", "Sanger"),
  "77954": p("TX", "Cuero"),
  "77967": p("TX", "Hochheim"),
  "77974": p("TX", "Meyersville"),
  "77989": p("TX", "Thomaston"),
  "77994": p("TX", "Westhoff"),
  "78141": p("TX", "Nordheim"),
  "78164": p("TX", "Yorktown"),
  "79220": p("TX", "Afton"),
  "79229": p("TX", "Dickens"),
  "79243": p("TX", "Mcadoo"),
  "79370": p("TX", "Spur"),
  "78827": p("TX", "Asherton"),
  "78830": p("TX", "Big Wells"),
  "78834": p("TX", "Carrizo Springs"),
  "78836": p("TX", "Catarina"),
  "79226": p("TX", "Clarendon"),
  "79237": p("TX", "Hedley"),
  "79240": p("TX", "Lelia Lake"),
  "78341": p("TX", "Benavides"),
  "78349": p("TX", "Concepcion"),
  "78357": p("TX", "Freer"),
  "78376": p("TX", "Realitos"),
  "78384": p("TX", "San Diego"),
  "76435": p("TX", "Carbon"),
  "76437": p("TX", "Cisco"),
  "76445": p("TX", "Desdemona"),
  "76448": p("TX", "Eastland"),
  "76454": p("TX", "Gorman"),
  "76466": p("TX", "Olden"),
  "76470": p("TX", "Ranger"),
  "76471": p("TX", "Rising Star"),
  "79741": p("TX", "Goldsmith"),
  "79758": p("TX", "Gardendale"),
  "79759": p("TX", "Notrees"),
  "79760": p("TX", "Odessa"),
  "79761": p("TX", "Odessa"),
  "79762": p("TX", "Odessa"),
  "79763": p("TX", "Odessa"),
  "79764": p("TX", "Odessa"),
  "79765": p("TX", "Odessa"),
  "79766": p("TX", "Odessa"),
  "79768": p("TX", "Odessa"),
  "79769": p("TX", "Odessa"),
  "79776": p("TX", "Penwell"),
  "76883": p("TX", "Telegraph"),
  "78828": p("TX", "Barksdale"),
  "78880": p("TX", "Rocksprings"),
  "75101": p("TX", "Bardwell"),
  "75119": p("TX", "Ennis"),
  "75120": p("TX", "Ennis"),
  "75125": p("TX", "Ferris"),
  "75152": p("TX", "Palmer"),
  "75154": p("TX", "Red Oak"),
  "75155": p("TX", "Rice"),
  "75165": p("TX", "Waxahachie"),
  "75167": p("TX", "Waxahachie"),
  "75168": p("TX", "Waxahachie"),
  "76041": p("TX", "Forreston"),
  "76064": p("TX", "Maypearl"),
  "76065": p("TX", "Midlothian"),
  "76623": p("TX", "Avalon"),
  "76651": p("TX", "Italy"),
  "76670": p("TX", "Milford"),
  "79821": p("TX", "Anthony"),
  "79835": p("TX", "Canutillo"),
  "79836": p("TX", "Clint"),
  "79838": p("TX", "Fabens"),
  "79849": p("TX", "San Elizario"),
  "79853": p("TX", "Tornillo"),
  "79901": p("TX", "El Paso"),
  "79902": p("TX", "El Paso"),
  "79903": p("TX", "El Paso"),
  "79904": p("TX", "El Paso"),
  "79905": p("TX", "El Paso"),
  "79906": p("TX", "El Paso"),
  "79907": p("TX", "El Paso"),
  "79908": p("TX", "El Paso"),
  "79910": p("TX", "El Paso"),
  "79911": p("TX", "El Paso"),
  "79912": p("TX", "El Paso"),
  "79913": p("TX", "El Paso"),
  "79914": p("TX", "El Paso"),
  "79915": p("TX", "El Paso"),
  "79916": p("TX", "Fort Bliss"),
  "79917": p("TX", "El Paso"),
  "79918": p("TX", "Fort Bliss"),
  "79920": p("TX", "El Paso"),
  "79922": p("TX", "El Paso"),
  "79923": p("TX", "El Paso"),
  "79924": p("TX", "El Paso"),
  "79925": p("TX", "El Paso"),
  "79926": p("TX", "El Paso"),
  "79927": p("TX", "El Paso"),
  "79928": p("TX", "El Paso"),
  "79929": p("TX", "El Paso"),
  "79930": p("TX", "El Paso"),
  "79931": p("TX", "El Paso"),
  "79932": p("TX", "El Paso"),
  "79934": p("TX", "El Paso"),
  "79935": p("TX", "El Paso"),
  "79936": p("TX", "El Paso"),
  "79937": p("TX", "El Paso"),
  "79938": p("TX", "El Paso"),
  "79940": p("TX", "El Paso"),
  "79941": p("TX", "El Paso"),
  "79942": p("TX", "El Paso"),
  "79943": p("TX", "El Paso"),
  "79944": p("TX", "El Paso"),
  "79945": p("TX", "El Paso"),
  "79946": p("TX", "El Paso"),
  "79947": p("TX", "El Paso"),
  "79948": p("TX", "El Paso"),
  "79949": p("TX", "El Paso"),
  "79950": p("TX", "El Paso"),
  "79951": p("TX", "El Paso"),
  "79952": p("TX", "El Paso"),
  "79953": p("TX", "El Paso"),
  "79954": p("TX", "El Paso"),
  "79955": p("TX", "El Paso"),
  "79958": p("TX", "El Paso"),
  "79960": p("TX", "El Paso"),
  "79961": p("TX", "El Paso"),
  "79968": p("TX", "El Paso"),
  "79976": p("TX", "El Paso"),
  "79978": p("TX", "El Paso"),
  "79980": p("TX", "El Paso"),
  "79990": p("TX", "El Paso"),
  "79995": p("TX", "El Paso"),
  "79996": p("TX", "El Paso"),
  "79997": p("TX", "El Paso"),
  "79998": p("TX", "El Paso"),
  "79999": p("TX", "El Paso"),
  "88510": p("TX", "El Paso"),
  "88511": p("TX", "El Paso"),
  "88512": p("TX", "El Paso"),
  "88513": p("TX", "El Paso"),
  "88514": p("TX", "El Paso"),
  "88515": p("TX", "El Paso"),
  "88517": p("TX", "El Paso"),
  "88518": p("TX", "El Paso"),
  "88519": p("TX", "El Paso"),
  "88520": p("TX", "El Paso"),
  "88521": p("TX", "El Paso"),
  "88523": p("TX", "El Paso"),
  "88524": p("TX", "El Paso"),
  "88525": p("TX", "El Paso"),
  "88526": p("TX", "El Paso"),
  "88527": p("TX", "El Paso"),
  "88528": p("TX", "El Paso"),
  "88529": p("TX", "El Paso"),
  "88530": p("TX", "El Paso"),
  "88531": p("TX", "El Paso"),
  "88532": p("TX", "El Paso"),
  "88533": p("TX", "El Paso"),
  "88534": p("TX", "El Paso"),
  "88535": p("TX", "El Paso"),
  "88536": p("TX", "El Paso"),
  "88538": p("TX", "El Paso"),
  "88539": p("TX", "El Paso"),
  "88540": p("TX", "El Paso"),
  "88541": p("TX", "El Paso"),
  "88542": p("TX", "El Paso"),
  "88543": p("TX", "El Paso"),
  "88544": p("TX", "El Paso"),
  "88545": p("TX", "El Paso"),
  "88546": p("TX", "El Paso"),
  "88547": p("TX", "El Paso"),
  "88548": p("TX", "El Paso"),
  "88549": p("TX", "El Paso"),
  "88550": p("TX", "El Paso"),
  "88553": p("TX", "El Paso"),
  "88554": p("TX", "El Paso"),
  "88555": p("TX", "El Paso"),
  "88556": p("TX", "El Paso"),
  "88557": p("TX", "El Paso"),
  "88558": p("TX", "El Paso"),
  "88559": p("TX", "El Paso"),
  "88560": p("TX", "El Paso"),
  "88561": p("TX", "El Paso"),
  "88562": p("TX", "El Paso"),
  "88563": p("TX", "El Paso"),
  "88565": p("TX", "El Paso"),
  "88566": p("TX", "El Paso"),
  "88567": p("TX", "El Paso"),
  "88568": p("TX", "El Paso"),
  "88569": p("TX", "El Paso"),
  "88570": p("TX", "El Paso"),
  "88571": p("TX", "El Paso"),
  "88572": p("TX", "El Paso"),
  "88573": p("TX", "El Paso"),
  "88574": p("TX", "El Paso"),
  "88575": p("TX", "El Paso"),
  "88576": p("TX", "El Paso"),
  "88577": p("TX", "El Paso"),
  "88578": p("TX", "El Paso"),
  "88579": p("TX", "El Paso"),
  "88580": p("TX", "El Paso"),
  "88581": p("TX", "El Paso"),
  "88582": p("TX", "El Paso"),
  "88583": p("TX", "El Paso"),
  "88584": p("TX", "El Paso"),
  "88585": p("TX", "El Paso"),
  "88586": p("TX", "El Paso"),
  "88587": p("TX", "El Paso"),
  "88588": p("TX", "El Paso"),
  "88589": p("TX", "El Paso"),
  "88590": p("TX", "El Paso"),
  "88595": p("TX", "El Paso"),
  "76401": p("TX", "Stephenville"),
  "76402": p("TX", "Stephenville"),
  "76433": p("TX", "Bluff Dale"),
  "76446": p("TX", "Dublin"),
  "76461": p("TX", "Lingleville"),
  "76465": p("TX", "Morgan Mill"),
  "76570": p("TX", "Rosebud"),
  "76632": p("TX", "Chilton"),
  "76656": p("TX", "Lott"),
  "76661": p("TX", "Marlin"),
  "76680": p("TX", "Reagan"),
  "76685": p("TX", "Satin"),
  "75413": p("TX", "Bailey"),
  "75418": p("TX", "Bonham"),
  "75438": p("TX", "Dodd City"),
  "75439": p("TX", "Ector"),
  "75443": p("TX", "Gober"),
  "75446": p("TX", "Honey Grove"),
  "75447": p("TX", "Ivanhoe"),
  "75449": p("TX", "Ladonia"),
  "75452": p("TX", "Leonard"),
  "75475": p("TX", "Randolph"),
  "75476": p("TX", "Ravenna"),
  "75479": p("TX", "Savoy"),
  "75488": p("TX", "Telephone"),
  "75490": p("TX", "Trenton"),
  "75492": p("TX", "Windom"),
  "78932": p("TX", "Carmine"),
  "78938": p("TX", "Ellinger"),
  "78940": p("TX", "Fayetteville"),
  "78941": p("TX", "Flatonia"),
  "78945": p("TX", "La Grange"),
  "78946": p("TX", "Ledbetter"),
  "78949": p("TX", "Muldoon"),
  "78952": p("TX", "Plum"),
  "78954": p("TX", "Round Top"),
  "78956": p("TX", "Schulenburg"),
  "78960": p("TX", "Warda"),
  "78961": p("TX", "Round Top"),
  "78963": p("TX", "West Point"),
  "79534": p("TX", "Mc Caulley"),
  "79543": p("TX", "Roby"),
  "79546": p("TX", "Rotan"),
  "79560": p("TX", "Sylvester"),
  "79221": p("TX", "Aiken"),
  "79231": p("TX", "Dougherty"),
  "79235": p("TX", "Floydada"),
  "79241": p("TX", "Lockney"),
  "79258": p("TX", "South Plains"),
  "79227": p("TX", "Crowell"),
  "77406": p("TX", "Richmond"),
  "77407": p("TX", "Richmond"),
  "77417": p("TX", "Beasley"),
  "77441": p("TX", "Fulshear"),
  "77444": p("TX", "Guy"),
  "77451": p("TX", "Kendleton"),
  "77459": p("TX", "Missouri City"),
  "77461": p("TX", "Needville"),
  "77464": p("TX", "Orchard"),
  "77469": p("TX", "Richmond"),
  "77471": p("TX", "Rosenberg"),
  "77476": p("TX", "Simonton"),
  "77477": p("TX", "Stafford"),
  "77478": p("TX", "Sugar Land"),
  "77479": p("TX", "Sugar Land"),
  "77481": p("TX", "Thompsons"),
  "77487": p("TX", "Sugar Land"),
  "77489": p("TX", "Missouri City"),
  "77496": p("TX", "Sugar Land"),
  "77497": p("TX", "Stafford"),
  "77498": p("TX", "Sugar Land"),
  "77545": p("TX", "Fresno"),
  "75457": p("TX", "Mount Vernon"),
  "75480": p("TX", "Scroggins"),
  "75487": p("TX", "Talco"),
  "75838": p("TX", "Donie"),
  "75840": p("TX", "Fairfield"),
  "75848": p("TX", "Kirvin"),
  "75859": p("TX", "Streetman"),
  "75860": p("TX", "Teague"),
  "76693": p("TX", "Wortham"),
  "78005": p("TX", "Bigfoot"),
  "78017": p("TX", "Dilley"),
  "78057": p("TX", "Moore"),
  "78061": p("TX", "Pearsall"),
  "79342": p("TX", "Loop"),
  "79359": p("TX", "Seagraves"),
  "79360": p("TX", "Seminole"),
  "77510": p("TX", "Santa Fe"),
  "77517": p("TX", "Santa Fe"),
  "77518": p("TX", "Bacliff"),
  "77539": p("TX", "Dickinson"),
  "77546": p("TX", "Friendswood"),
  "77549": p("TX", "Friendswood"),
  "77550": p("TX", "Galveston"),
  "77551": p("TX", "Galveston"),
  "77552": p("TX", "Galveston"),
  "77553": p("TX", "Galveston"),
  "77554": p("TX", "Galveston"),
  "77555": p("TX", "Galveston"),
  "77563": p("TX", "Hitchcock"),
  "77565": p("TX", "Kemah"),
  "77568": p("TX", "La Marque"),
  "77573": p("TX", "League City"),
  "77574": p("TX", "League City"),
  "77590": p("TX", "Texas City"),
  "77591": p("TX", "Texas City"),
  "77592": p("TX", "Texas City"),
  "77617": p("TX", "Gilchrist"),
  "77623": p("TX", "High Island"),
  "77650": p("TX", "Port Bolivar"),
  "79330": p("TX", "Justiceburg"),
  "79356": p("TX", "Post"),
  "78618": p("TX", "Doss"),
  "78624": p("TX", "Fredericksburg"),
  "78631": p("TX", "Harper"),
  "78671": p("TX", "Stonewall"),
  "78675": p("TX", "Willow City"),
  "79739": p("TX", "Garden City"),
  "77960": p("TX", "Fannin"),
  "77963": p("TX", "Goliad"),
  "77993": p("TX", "Weesatche"),
  "78107": p("TX", "Berclair"),
  "78122": p("TX", "Leesville"),
  "78140": p("TX", "Nixon"),
  "78159": p("TX", "Smiley"),
  "78604": p("TX", "Belmont"),
  "78614": p("TX", "Cost"),
  "78629": p("TX", "Gonzales"),
  "78632": p("TX", "Harwood"),
  "78658": p("TX", "Ottine"),
  "78677": p("TX", "Wrightsboro"),
  "78959": p("TX", "Waelder"),
  "79002": p("TX", "Alanreed"),
  "79054": p("TX", "Lefors"),
  "79057": p("TX", "Mclean"),
  "79065": p("TX", "Pampa"),
  "79066": p("TX", "Pampa"),
  "75020": p("TX", "Denison"),
  "75021": p("TX", "Denison"),
  "75058": p("TX", "Gunter"),
  "75076": p("TX", "Pottsboro"),
  "75090": p("TX", "Sherman"),
  "75091": p("TX", "Sherman"),
  "75092": p("TX", "Sherman"),
  "75414": p("TX", "Bells"),
  "75459": p("TX", "Howe"),
  "75489": p("TX", "Tom Bean"),
  "75491": p("TX", "Whitewright"),
  "75495": p("TX", "Van Alstyne"),
  "76233": p("TX", "Collinsville"),
  "76245": p("TX", "Gordonville"),
  "76264": p("TX", "Sadler"),
  "76268": p("TX", "Southmayd"),
  "76271": p("TX", "Tioga"),
  "76273": p("TX", "Whitesboro"),
  "75601": p("TX", "Longview"),
  "75602": p("TX", "Longview"),
  "75603": p("TX", "Longview"),
  "75604": p("TX", "Longview"),
  "75605": p("TX", "Longview"),
  "75606": p("TX", "Longview"),
  "75607": p("TX", "Longview"),
  "75608": p("TX", "Longview"),
  "75615": p("TX", "Longview"),
  "75641": p("TX", "Easton"),
  "75647": p("TX", "Gladewater"),
  "75660": p("TX", "Judson"),
  "75662": p("TX", "Kilgore"),
  "75663": p("TX", "Kilgore"),
  "75693": p("TX", "White Oak"),
  "77363": p("TX", "Plantersville"),
  "77830": p("TX", "Anderson"),
  "77831": p("TX", "Bedias"),
  "77861": p("TX", "Iola"),
  "77868": p("TX", "Navasota"),
  "77873": p("TX", "Richards"),
  "77875": p("TX", "Roans Prairie"),
  "77876": p("TX", "Shiro"),
  "78108": p("TX", "Cibolo"),
  "78115": p("TX", "Geronimo"),
  "78123": p("TX", "Mc Queeney"),
  "78124": p("TX", "Marion"),
  "78154": p("TX", "Schertz"),
  "78155": p("TX", "Seguin"),
  "78156": p("TX", "Seguin"),
  "78638": p("TX", "Kingsbury"),
  "78670": p("TX", "Staples"),
  "79021": p("TX", "Cotton Center"),
  "79032": p("TX", "Edmonson"),
  "79041": p("TX", "Hale Center"),
  "79072": p("TX", "Plainview"),
  "79073": p("TX", "Plainview"),
  "79250": p("TX", "Petersburg"),
  "79311": p("TX", "Abernathy"),
  "79233": p("TX", "Estelline"),
  "79239": p("TX", "Lakeview"),
  "79245": p("TX", "Memphis"),
  "79261": p("TX", "Turkey"),
  "76436": p("TX", "Carlton"),
  "76457": p("TX", "Hico"),
  "76531": p("TX", "Hamilton"),
  "76565": p("TX", "Pottsville"),
  "79040": p("TX", "Gruver"),
  "79062": p("TX", "Morse"),
  "79081": p("TX", "Spearman"),
  "79225": p("TX", "Chillicothe"),
  "79252": p("TX", "Quanah"),
  "77374": p("TX", "Thicket"),
  "77376": p("TX", "Votaw"),
  "77519": p("TX", "Batson"),
  "77585": p("TX", "Saratoga"),
  "77625": p("TX", "Kountze"),
  "77656": p("TX", "Silsbee"),
  "77657": p("TX", "Lumberton"),
  "77659": p("TX", "Sour Lake"),
  "77663": p("TX", "Village Mills"),
  "77001": p("TX", "Houston"),
  "77002": p("TX", "Houston"),
  "77003": p("TX", "Houston"),
  "77004": p("TX", "Houston"),
  "77005": p("TX", "Houston"),
  "77006": p("TX", "Houston"),
  "77007": p("TX", "Houston"),
  "77008": p("TX", "Houston"),
  "77009": p("TX", "Houston"),
  "77010": p("TX", "Houston"),
  "77011": p("TX", "Houston"),
  "77012": p("TX", "Houston"),
  "77013": p("TX", "Houston"),
  "77014": p("TX", "Houston"),
  "77015": p("TX", "Houston"),
  "77016": p("TX", "Houston"),
  "77017": p("TX", "Houston"),
  "77018": p("TX", "Houston"),
  "77019": p("TX", "Houston"),
  "77020": p("TX", "Houston"),
  "77021": p("TX", "Houston"),
  "77022": p("TX", "Houston"),
  "77023": p("TX", "Houston"),
  "77024": p("TX", "Houston"),
  "77025": p("TX", "Houston"),
  "77026": p("TX", "Houston"),
  "77027": p("TX", "Houston"),
  "77028": p("TX", "Houston"),
  "77029": p("TX", "Houston"),
  "77030": p("TX", "Houston"),
  "77031": p("TX", "Houston"),
  "77032": p("TX", "Houston"),
  "77033": p("TX", "Houston"),
  "77034": p("TX", "Houston"),
  "77035": p("TX", "Houston"),
  "77036": p("TX", "Houston"),
  "77037": p("TX", "Houston"),
  "77038": p("TX", "Houston"),
  "77039": p("TX", "Houston"),
  "77040": p("TX", "Houston"),
  "77041": p("TX", "Houston"),
  "77042": p("TX", "Houston"),
  "77043": p("TX", "Houston"),
  "77044": p("TX", "Houston"),
  "77045": p("TX", "Houston"),
  "77046": p("TX", "Houston"),
  "77047": p("TX", "Houston"),
  "77048": p("TX", "Houston"),
  "77049": p("TX", "Houston"),
  "77050": p("TX", "Houston"),
  "77051": p("TX", "Houston"),
  "77052": p("TX", "Houston"),
  "77053": p("TX", "Houston"),
  "77054": p("TX", "Houston"),
  "77055": p("TX", "Houston"),
  "77056": p("TX", "Houston"),
  "77057": p("TX", "Houston"),
  "77058": p("TX", "Houston"),
  "77059": p("TX", "Houston"),
  "77060": p("TX", "Houston"),
  "77061": p("TX", "Houston"),
  "77062": p("TX", "Houston"),
  "77063": p("TX", "Houston"),
  "77064": p("TX", "Houston"),
  "77065": p("TX", "Houston"),
  "77066": p("TX", "Houston"),
  "77067": p("TX", "Houston"),
  "77068": p("TX", "Houston"),
  "77069": p("TX", "Houston"),
  "77070": p("TX", "Houston"),
  "77071": p("TX", "Houston"),
  "77072": p("TX", "Houston"),
  "77073": p("TX", "Houston"),
  "77074": p("TX", "Houston"),
  "77075": p("TX", "Houston"),
  "77076": p("TX", "Houston"),
  "77077": p("TX", "Houston"),
  "77078": p("TX", "Houston"),
  "77079": p("TX", "Houston"),
  "77080": p("TX", "Houston"),
  "77081": p("TX", "Houston"),
  "77082": p("TX", "Houston"),
  "77083": p("TX", "Houston"),
  "77084": p("TX", "Houston"),
  "77085": p("TX", "Houston"),
  "77086": p("TX", "Houston"),
  "77087": p("TX", "Houston"),
  "77088": p("TX", "Houston"),
  "77089": p("TX", "Houston"),
  "77090": p("TX", "Houston"),
  "77091": p("TX", "Houston"),
  "77092": p("TX", "Houston"),
  "77093": p("TX", "Houston"),
  "77094": p("TX", "Houston"),
  "77095": p("TX", "Houston"),
  "77096": p("TX", "Houston"),
  "77098": p("TX", "Houston"),
  "77099": p("TX", "Houston"),
  "77201": p("TX", "Houston"),
  "77202": p("TX", "Houston"),
  "77203": p("TX", "Houston"),
  "77204": p("TX", "Houston"),
  "77205": p("TX", "Houston"),
  "77206": p("TX", "Houston"),
  "77207": p("TX", "Houston"),
  "77208": p("TX", "Houston"),
  "77209": p("TX", "Houston"),
  "77210": p("TX", "Houston"),
  "77212": p("TX", "Houston"),
  "77213": p("TX", "Houston"),
  "77215": p("TX", "Houston"),
  "77216": p("TX", "Houston"),
  "77217": p("TX", "Houston"),
  "77218": p("TX", "Houston"),
  "77219": p("TX", "Houston"),
  "77220": p("TX", "Houston"),
  "77221": p("TX", "Houston"),
  "77222": p("TX", "Houston"),
  "77223": p("TX", "Houston"),
  "77224": p("TX", "Houston"),
  "77225": p("TX", "Houston"),
  "77226": p("TX", "Houston"),
  "77227": p("TX", "Houston"),
  "77228": p("TX", "Houston"),
  "77229": p("TX", "Houston"),
  "77230": p("TX", "Houston"),
  "77231": p("TX", "Houston"),
  "77233": p("TX", "Houston"),
  "77234": p("TX", "Houston"),
  "77235": p("TX", "Houston"),
  "77236": p("TX", "Houston"),
  "77237": p("TX", "Houston"),
  "77238": p("TX", "Houston"),
  "77240": p("TX", "Houston"),
  "77241": p("TX", "Houston"),
  "77242": p("TX", "Houston"),
  "77243": p("TX", "Houston"),
  "77244": p("TX", "Houston"),
  "77245": p("TX", "Houston"),
  "77248": p("TX", "Houston"),
  "77249": p("TX", "Houston"),
  "77251": p("TX", "Houston"),
  "77252": p("TX", "Houston"),
  "77253": p("TX", "Houston"),
  "77254": p("TX", "Houston"),
  "77255": p("TX", "Houston"),
  "77256": p("TX", "Houston"),
  "77257": p("TX", "Houston"),
  "77258": p("TX", "Houston"),
  "77259": p("TX", "Houston"),
  "77261": p("TX", "Houston"),
  "77262": p("TX", "Houston"),
  "77263": p("TX", "Houston"),
  "77265": p("TX", "Houston"),
  "77266": p("TX", "Houston"),
  "77267": p("TX", "Houston"),
  "77268": p("TX", "Houston"),
  "77269": p("TX", "Houston"),
  "77270": p("TX", "Houston"),
  "77271": p("TX", "Houston"),
  "77272": p("TX", "Houston"),
  "77273": p("TX", "Houston"),
  "77274": p("TX", "Houston"),
  "77275": p("TX", "Houston"),
  "77277": p("TX", "Houston"),
  "77279": p("TX", "Houston"),
  "77280": p("TX", "Houston"),
  "77282": p("TX", "Houston"),
  "77284": p("TX", "Houston"),
  "77287": p("TX", "Houston"),
  "77288": p("TX", "Houston"),
  "77289": p("TX", "Houston"),
  "77290": p("TX", "Houston"),
  "77291": p("TX", "Houston"),
  "77292": p("TX", "Houston"),
  "77293": p("TX", "Houston"),
  "77297": p("TX", "Houston"),
  "77299": p("TX", "Houston"),
  "77315": p("TX", "North Houston"),
  "77325": p("TX", "Kingwood"),
  "77336": p("TX", "Huffman"),
  "77337": p("TX", "Hufsmith"),
  "77338": p("TX", "Humble"),
  "77339": p("TX", "Kingwood"),
  "77345": p("TX", "Kingwood"),
  "77346": p("TX", "Humble"),
  "77347": p("TX", "Humble"),
  "77373": p("TX", "Spring"),
  "77375": p("TX", "Tomball"),
  "77377": p("TX", "Tomball"),
  "77379": p("TX", "Spring"),
  "77382": p("TX", "Spring"),
  "77383": p("TX", "Spring"),
  "77388": p("TX", "Spring"),
  "77389": p("TX", "Spring"),
  "77391": p("TX", "Spring"),
  "77396": p("TX", "Humble"),
  "77401": p("TX", "Bellaire"),
  "77402": p("TX", "Bellaire"),
  "77410": p("TX", "Cypress"),
  "77411": p("TX", "Alief"),
  "77413": p("TX", "Barker"),
  "77429": p("TX", "Cypress"),
  "77433": p("TX", "Cypress"),
  "77447": p("TX", "Hockley"),
  "77449": p("TX", "Katy"),
  "77450": p("TX", "Katy"),
  "77491": p("TX", "Katy"),
  "77492": p("TX", "Katy"),
  "77493": p("TX", "Katy"),
  "77494": p("TX", "Katy"),
  "77501": p("TX", "Pasadena"),
  "77502": p("TX", "Pasadena"),
  "77503": p("TX", "Pasadena"),
  "77504": p("TX", "Pasadena"),
  "77505": p("TX", "Pasadena"),
  "77506": p("TX", "Pasadena"),
  "77507": p("TX", "Pasadena"),
  "77508": p("TX", "Pasadena"),
  "77520": p("TX", "Baytown"),
  "77521": p("TX", "Baytown"),
  "77522": p("TX", "Baytown"),
  "77530": p("TX", "Channelview"),
  "77532": p("TX", "Crosby"),
  "77536": p("TX", "Deer Park"),
  "77547": p("TX", "Galena Park"),
  "77562": p("TX", "Highlands"),
  "77571": p("TX", "La Porte"),
  "77572": p("TX", "La Porte"),
  "77586": p("TX", "Seabrook"),
  "77587": p("TX", "South Houston"),
  "77598": p("TX", "Webster"),
  "75642": p("TX", "Elysian Fields"),
  "75650": p("TX", "Hallsville"),
  "75651": p("TX", "Harleton"),
  "75659": p("TX", "Jonesville"),
  "75661": p("TX", "Karnack"),
  "75670": p("TX", "Marshall"),
  "75671": p("TX", "Marshall"),
  "75672": p("TX", "Marshall"),
  "75688": p("TX", "Scottsville"),
  "75692": p("TX", "Waskom"),
  "75694": p("TX", "Woodlawn"),
  "79018": p("TX", "Channing"),
  "79044": p("TX", "Hartley"),
  "76388": p("TX", "Weinert"),
  "79521": p("TX", "Haskell"),
  "79539": p("TX", "O Brien"),
  "79544": p("TX", "Rochester"),
  "79547": p("TX", "Rule"),
  "79548": p("TX", "Rule"),
  "78610": p("TX", "Buda"),
  "78619": p("TX", "Driftwood"),
  "78620": p("TX", "Dripping Springs"),
  "78640": p("TX", "Kyle"),
  "78666": p("TX", "San Marcos"),
  "78667": p("TX", "San Marcos"),
  "78676": p("TX", "Wimberley"),
  "79014": p("TX", "Canadian"),
  "75124": p("TX", "Eustace"),
  "75143": p("TX", "Kemp"),
  "75148": p("TX", "Malakoff"),
  "75163": p("TX", "Trinidad"),
  "75751": p("TX", "Athens"),
  "75752": p("TX", "Athens"),
  "75756": p("TX", "Brownsboro"),
  "75758": p("TX", "Chandler"),
  "75770": p("TX", "Larue"),
  "75778": p("TX", "Murchison"),
  "75782": p("TX", "Poynor"),
  "78501": p("TX", "Mcallen"),
  "78502": p("TX", "Mcallen"),
  "78503": p("TX", "Mcallen"),
  "78504": p("TX", "Mcallen"),
  "78505": p("TX", "Mcallen"),
  "78516": p("TX", "Alamo"),
  "78537": p("TX", "Donna"),
  "78538": p("TX", "Edcouch"),
  "78539": p("TX", "Edinburg"),
  "78540": p("TX", "Edinburg"),
  "78541": p("TX", "Edinburg"),
  "78542": p("TX", "Edinburg"),
  "78543": p("TX", "Elsa"),
  "78549": p("TX", "Hargill"),
  "78557": p("TX", "Hidalgo"),
  "78558": p("TX", "La Blanca"),
  "78560": p("TX", "La Joya"),
  "78562": p("TX", "La Villa"),
  "78563": p("TX", "Linn"),
  "78565": p("TX", "Los Ebanos"),
  "78570": p("TX", "Mercedes"),
  "78572": p("TX", "Mission"),
  "78573": p("TX", "Mission"),
  "78576": p("TX", "Penitas"),
  "78577": p("TX", "Pharr"),
  "78579": p("TX", "Progreso"),
  "78589": p("TX", "San Juan"),
  "78595": p("TX", "Sullivan City"),
  "78596": p("TX", "Weslaco"),
  "78599": p("TX", "Weslaco"),
  "76055": p("TX", "Itasca"),
  "76621": p("TX", "Abbott"),
  "76622": p("TX", "Aquilla"),
  "76627": p("TX", "Blum"),
  "76628": p("TX", "Brandon"),
  "76631": p("TX", "Bynum"),
  "76636": p("TX", "Covington"),
  "76645": p("TX", "Hillsboro"),
  "76648": p("TX", "Hubbard"),
  "76650": p("TX", "Irene"),
  "76660": p("TX", "Malone"),
  "76666": p("TX", "Mertens"),
  "76673": p("TX", "Mount Calm"),
  "76676": p("TX", "Penelope"),
  "76692": p("TX", "Whitney"),
  "79313": p("TX", "Anton"),
  "79336": p("TX", "Levelland"),
  "79338": p("TX", "Levelland"),
  "79353": p("TX", "Pep"),
  "79358": p("TX", "Ropesville"),
  "79367": p("TX", "Smyer"),
  "79372": p("TX", "Sundown"),
  "79380": p("TX", "Whitharral"),
  "76035": p("TX", "Cresson"),
  "76048": p("TX", "Granbury"),
  "76049": p("TX", "Granbury"),
  "76462": p("TX", "Lipan"),
  "76467": p("TX", "Paluxy"),
  "76476": p("TX", "Tolar"),
  "75420": p("TX", "Brashear"),
  "75431": p("TX", "Como"),
  "75433": p("TX", "Cumby"),
  "75437": p("TX", "Dike"),
  "75471": p("TX", "Pickton"),
  "75478": p("TX", "Saltillo"),
  "75481": p("TX", "Sulphur Bluff"),
  "75482": p("TX", "Sulphur Springs"),
  "75483": p("TX", "Sulphur Springs"),
  "75835": p("TX", "Crockett"),
  "75844": p("TX", "Grapeland"),
  "75847": p("TX", "Kennard"),
  "75849": p("TX", "Latexo"),
  "75851": p("TX", "Lovelady"),
  "75858": p("TX", "Ratcliff"),
  "79511": p("TX", "Coahoma"),
  "79720": p("TX", "Big Spring"),
  "79721": p("TX", "Big Spring"),
  "79733": p("TX", "Forsan"),
  "79748": p("TX", "Knott"),
  "79837": p("TX", "Dell City"),
  "79839": p("TX", "Fort Hancock"),
  "79847": p("TX", "Salt Flat"),
  "79851": p("TX", "Sierra Blanca"),
  "75135": p("TX", "Caddo Mills"),
  "75401": p("TX", "Greenville"),
  "75402": p("TX", "Greenville"),
  "75403": p("TX", "Greenville"),
  "75404": p("TX", "Greenville"),
  "75422": p("TX", "Campbell"),
  "75423": p("TX", "Celeste"),
  "75428": p("TX", "Commerce"),
  "75429": p("TX", "Commerce"),
  "75453": p("TX", "Lone Oak"),
  "75458": p("TX", "Merit"),
  "75474": p("TX", "Quinlan"),
  "75496": p("TX", "Wolfe City"),
  "79007": p("TX", "Borger"),
  "79008": p("TX", "Borger"),
  "79036": p("TX", "Fritch"),
  "79078": p("TX", "Sanford"),
  "79083": p("TX", "Stinnett"),
  "76930": p("TX", "Barnhart"),
  "76941": p("TX", "Mertzon"),
  "76427": p("TX", "Bryson"),
  "76458": p("TX", "Jacksboro"),
  "76459": p("TX", "Jermyn"),
  "76486": p("TX", "Perrin"),
  "77957": p("TX", "Edna"),
  "77961": p("TX", "Francitas"),
  "77962": p("TX", "Ganado"),
  "77969": p("TX", "La Salle"),
  "77970": p("TX", "La Ward"),
  "77971": p("TX", "Lolita"),
  "77991": p("TX", "Vanderbilt"),
  "75951": p("TX", "Jasper"),
  "75956": p("TX", "Kirbyville"),
  "77612": p("TX", "Buna"),
  "77615": p("TX", "Evadale"),
  "79734": p("TX", "Fort Davis"),
  "79854": p("TX", "Valentine"),
  "77613": p("TX", "China"),
  "77619": p("TX", "Groves"),
  "77622": p("TX", "Hamshire"),
  "77627": p("TX", "Nederland"),
  "77629": p("TX", "Nome"),
  "77640": p("TX", "Port Arthur"),
  "77641": p("TX", "Port Arthur"),
  "77642": p("TX", "Port Arthur"),
  "77643": p("TX", "Port Arthur"),
  "77651": p("TX", "Port Neches"),
  "77655": p("TX", "Sabine Pass"),
  "77701": p("TX", "Beaumont"),
  "77702": p("TX", "Beaumont"),
  "77703": p("TX", "Beaumont"),
  "77704": p("TX", "Beaumont"),
  "77705": p("TX", "Beaumont"),
  "77706": p("TX", "Beaumont"),
  "77707": p("TX", "Beaumont"),
  "77708": p("TX", "Beaumont"),
  "77710": p("TX", "Beaumont"),
  "77713": p("TX", "Beaumont"),
  "77720": p("TX", "Beaumont"),
  "77725": p("TX", "Beaumont"),
  "77726": p("TX", "Beaumont"),
  "78360": p("TX", "Guerra"),
  "78361": p("TX", "Hebbronville"),
  "78332": p("TX", "Alice"),
  "78333": p("TX", "Alice"),
  "78342": p("TX", "Ben Bolt"),
  "78372": p("TX", "Orange Grove"),
  "78375": p("TX", "Premont"),
  "78383": p("TX", "Sandia"),
  "76009": p("TX", "Alvarado"),
  "76028": p("TX", "Burleson"),
  "76031": p("TX", "Cleburne"),
  "76033": p("TX", "Cleburne"),
  "76044": p("TX", "Godley"),
  "76050": p("TX", "Grandview"),
  "76058": p("TX", "Joshua"),
  "76059": p("TX", "Keene"),
  "76061": p("TX", "Lillian"),
  "76084": p("TX", "Venus"),
  "76093": p("TX", "Rio Vista"),
  "76097": p("TX", "Burleson"),
  "79501": p("TX", "Anson"),
  "79503": p("TX", "Avoca"),
  "79520": p("TX", "Hamlin"),
  "79525": p("TX", "Hawley"),
  "79533": p("TX", "Lueders"),
  "79553": p("TX", "Stamford"),
  "78111": p("TX", "Ecleto"),
  "78113": p("TX", "Falls City"),
  "78116": p("TX", "Gillett"),
  "78117": p("TX", "Hobson"),
  "78118": p("TX", "Karnes City"),
  "78119": p("TX", "Kenedy"),
  "78144": p("TX", "Panna Maria"),
  "78151": p("TX", "Runge"),
  "75114": p("TX", "Crandall"),
  "75118": p("TX", "Elmo"),
  "75126": p("TX", "Forney"),
  "75142": p("TX", "Kaufman"),
  "75147": p("TX", "Mabank"),
  "75156": p("TX", "Mabank"),
  "75157": p("TX", "Rosser"),
  "75158": p("TX", "Scurry"),
  "75160": p("TX", "Terrell"),
  "75161": p("TX", "Terrell"),
  "78004": p("TX", "Bergheim"),
  "78006": p("TX", "Boerne"),
  "78013": p("TX", "Comfort"),
  "78027": p("TX", "Kendalia"),
  "78074": p("TX", "Waring"),
  "78338": p("TX", "Armstrong"),
  "78385": p("TX", "Sarita"),
  "79518": p("TX", "Girard"),
  "79528": p("TX", "Jayton"),
  "78010": p("TX", "Center Point"),
  "78024": p("TX", "Hunt"),
  "78025": p("TX", "Ingram"),
  "78028": p("TX", "Kerrville"),
  "78029": p("TX", "Kerrville"),
  "78058": p("TX", "Mountain Home"),
  "76849": p("TX", "Junction"),
  "76854": p("TX", "London"),
  "76874": p("TX", "Roosevelt"),
  "79236": p("TX", "Guthrie"),
  "78832": p("TX", "Brackettville"),
  "78363": p("TX", "Kingsville"),
  "78364": p("TX", "Kingsville"),
  "78379": p("TX", "Riviera"),
  "76363": p("TX", "Goree"),
  "76371": p("TX", "Munday"),
  "79505": p("TX", "Benjamin"),
  "79529": p("TX", "Knox City"),
  "75411": p("TX", "Arthur City"),
  "75416": p("TX", "Blossom"),
  "75421": p("TX", "Brookston"),
  "75425": p("TX", "Chicota"),
  "75434": p("TX", "Cunningham"),
  "75435": p("TX", "Deport"),
  "75460": p("TX", "Paris"),
  "75461": p("TX", "Paris"),
  "75462": p("TX", "Paris"),
  "75468": p("TX", "Pattonville"),
  "75470": p("TX", "Petty"),
  "75473": p("TX", "Powderly"),
  "75477": p("TX", "Roxton"),
  "75486": p("TX", "Sumner"),
  "79031": p("TX", "Earth"),
  "79064": p("TX", "Olton"),
  "79082": p("TX", "Springlake"),
  "79312": p("TX", "Amherst"),
  "79326": p("TX", "Fieldton"),
  "79339": p("TX", "Littlefield"),
  "79369": p("TX", "Spade"),
  "79371": p("TX", "Sudan"),
  "76539": p("TX", "Kempner"),
  "76550": p("TX", "Lampasas"),
  "76824": p("TX", "Bend"),
  "76853": p("TX", "Lometa"),
  "78001": p("TX", "Artesia Wells"),
  "78014": p("TX", "Cotulla"),
  "78019": p("TX", "Encinal"),
  "78021": p("TX", "Fowlerton"),
  "77964": p("TX", "Hallettsville"),
  "77975": p("TX", "Moulton"),
  "77984": p("TX", "Shiner"),
  "77986": p("TX", "Sublime"),
  "77987": p("TX", "Sweet Home"),
  "77995": p("TX", "Yoakum"),
  "77853": p("TX", "Dime Box"),
  "78942": p("TX", "Giddings"),
  "78947": p("TX", "Lexington"),
  "78948": p("TX", "Lincoln"),
  "75831": p("TX", "Buffalo"),
  "75833": p("TX", "Centerville"),
  "75846": p("TX", "Jewett"),
  "75850": p("TX", "Leona"),
  "75855": p("TX", "Oakwood"),
  "77850": p("TX", "Concord"),
  "77855": p("TX", "Flynn"),
  "77865": p("TX", "Marquez"),
  "77871": p("TX", "Normangee"),
  "77327": p("TX", "Cleveland"),
  "77328": p("TX", "Cleveland"),
  "77368": p("TX", "Romayor"),
  "77369": p("TX", "Rye"),
  "77533": p("TX", "Daisetta"),
  "77535": p("TX", "Dayton"),
  "77538": p("TX", "Devers"),
  "77561": p("TX", "Hardin"),
  "77564": p("TX", "Hull"),
  "77575": p("TX", "Liberty"),
  "77582": p("TX", "Raywood"),
  "76635": p("TX", "Coolidge"),
  "76642": p("TX", "Groesbeck"),
  "76653": p("TX", "Kosse"),
  "76667": p("TX", "Mexia"),
  "76678": p("TX", "Prairie Hill"),
  "76686": p("TX", "Tehuacana"),
  "76687": p("TX", "Thornton"),
  "79005": p("TX", "Booker"),
  "79024": p("TX", "Darrouzett"),
  "79034": p("TX", "Follett"),
  "79046": p("TX", "Higgins"),
  "79056": p("TX", "Lipscomb"),
  "78022": p("TX", "George West"),
  "78060": p("TX", "Oakville"),
  "78071": p("TX", "Three Rivers"),
  "78075": p("TX", "Whitsett"),
  "78350": p("TX", "Dinero"),
  "76831": p("TX", "Castell"),
  "76885": p("TX", "Valley Spring"),
  "78607": p("TX", "Bluffton"),
  "78609": p("TX", "Buchanan Dam"),
  "78639": p("TX", "Kingsland"),
  "78643": p("TX", "Llano"),
  "78657": p("TX", "Horseshoe Bay"),
  "78672": p("TX", "Tow"),
  "79754": p("TX", "Mentone"),
  "79329": p("TX", "Idalou"),
  "79350": p("TX", "New Deal"),
  "79363": p("TX", "Shallowater"),
  "79364": p("TX", "Slaton"),
  "79366": p("TX", "Ransom Canyon"),
  "79382": p("TX", "Wolfforth"),
  "79401": p("TX", "Lubbock"),
  "79402": p("TX", "Lubbock"),
  "79403": p("TX", "Lubbock"),
  "79404": p("TX", "Lubbock"),
  "79406": p("TX", "Lubbock"),
  "79407": p("TX", "Lubbock"),
  "79408": p("TX", "Lubbock"),
  "79409": p("TX", "Lubbock"),
  "79410": p("TX", "Lubbock"),
  "79411": p("TX", "Lubbock"),
  "79412": p("TX", "Lubbock"),
  "79413": p("TX", "Lubbock"),
  "79414": p("TX", "Lubbock"),
  "79415": p("TX", "Lubbock"),
  "79416": p("TX", "Lubbock"),
  "79423": p("TX", "Lubbock"),
  "79424": p("TX", "Lubbock"),
  "79430": p("TX", "Lubbock"),
  "79452": p("TX", "Lubbock"),
  "79453": p("TX", "Lubbock"),
  "79457": p("TX", "Lubbock"),
  "79464": p("TX", "Lubbock"),
  "79490": p("TX", "Lubbock"),
  "79491": p("TX", "Lubbock"),
  "79493": p("TX", "Lubbock"),
  "79499": p("TX", "Lubbock"),
  "79351": p("TX", "Odonnell"),
  "79373": p("TX", "Tahoka"),
  "79381": p("TX", "Wilson"),
  "79383": p("TX", "New Home"),
  "76825": p("TX", "Brady"),
  "76836": p("TX", "Doole"),
  "76852": p("TX", "Lohn"),
  "76858": p("TX", "Melvin"),
  "76872": p("TX", "Rochelle"),
  "76887": p("TX", "Voca"),
  "76524": p("TX", "Eddy"),
  "76557": p("TX", "Moody"),
  "76624": p("TX", "Axtell"),
  "76630": p("TX", "Bruceville"),
  "76633": p("TX", "China Spring"),
  "76638": p("TX", "Crawford"),
  "76640": p("TX", "Elm Mott"),
  "76643": p("TX", "Hewitt"),
  "76654": p("TX", "Leroy"),
  "76655": p("TX", "Lorena"),
  "76657": p("TX", "Mc Gregor"),
  "76664": p("TX", "Mart"),
  "76682": p("TX", "Riesel"),
  "76684": p("TX", "Ross"),
  "76691": p("TX", "West"),
  "76701": p("TX", "Waco"),
  "76702": p("TX", "Waco"),
  "76703": p("TX", "Waco"),
  "76704": p("TX", "Waco"),
  "76705": p("TX", "Waco"),
  "76706": p("TX", "Waco"),
  "76707": p("TX", "Waco"),
  "76708": p("TX", "Waco"),
  "76710": p("TX", "Waco"),
  "76711": p("TX", "Waco"),
  "76712": p("TX", "Woodway"),
  "76714": p("TX", "Waco"),
  "76715": p("TX", "Waco"),
  "76716": p("TX", "Waco"),
  "76797": p("TX", "Waco"),
  "76798": p("TX", "Waco"),
  "76799": p("TX", "Waco"),
  "78007": p("TX", "Calliham"),
  "78072": p("TX", "Tilden"),
  "75852": p("TX", "Midway"),
  "77864": p("TX", "Madisonville"),
  "77872": p("TX", "North Zulch"),
  "75564": p("TX", "Lodi"),
  "75657": p("TX", "Jefferson"),
  "79749": p("TX", "Lenorah"),
  "79782": p("TX", "Stanton"),
  "79783": p("TX", "Tarzan"),
  "76820": p("TX", "Art"),
  "76842": p("TX", "Fredonia"),
  "76856": p("TX", "Mason"),
  "76869": p("TX", "Pontotoc"),
  "77404": p("TX", "Bay City"),
  "77414": p("TX", "Bay City"),
  "77415": p("TX", "Cedar Lane"),
  "77419": p("TX", "Blessing"),
  "77428": p("TX", "Collegeport"),
  "77440": p("TX", "Elmaton"),
  "77456": p("TX", "Markham"),
  "77457": p("TX", "Matagorda"),
  "77458": p("TX", "Midfield"),
  "77465": p("TX", "Palacios"),
  "77468": p("TX", "Pledger"),
  "77482": p("TX", "Van Vleck"),
  "77483": p("TX", "Wadsworth"),
  "78852": p("TX", "Eagle Pass"),
  "78853": p("TX", "Eagle Pass"),
  "78860": p("TX", "El Indio"),
  "78877": p("TX", "Quemado"),
  "78009": p("TX", "Castroville"),
  "78016": p("TX", "Devine"),
  "78039": p("TX", "La Coste"),
  "78056": p("TX", "Mico"),
  "78059": p("TX", "Natalia"),
  "78066": p("TX", "Rio Medina"),
  "78850": p("TX", "D Hanis"),
  "78861": p("TX", "Hondo"),
  "78886": p("TX", "Yancey"),
  "76841": p("TX", "Fort Mc Kavett"),
  "76848": p("TX", "Hext"),
  "76859": p("TX", "Menard"),
  "79701": p("TX", "Midland"),
  "79702": p("TX", "Midland"),
  "79703": p("TX", "Midland"),
  "79704": p("TX", "Midland"),
  "79705": p("TX", "Midland"),
  "79706": p("TX", "Midland"),
  "79707": p("TX", "Midland"),
  "79708": p("TX", "Midland"),
  "79710": p("TX", "Midland"),
  "79711": p("TX", "Midland"),
  "79712": p("TX", "Midland"),
  "76518": p("TX", "Buckholts"),
  "76519": p("TX", "Burlington"),
  "76520": p("TX", "Cameron"),
  "76523": p("TX", "Davilla"),
  "76556": p("TX", "Milano"),
  "76567": p("TX", "Rockdale"),
  "76577": p("TX", "Thorndale"),
  "77857": p("TX", "Gause"),
  "76844": p("TX", "Goldthwaite"),
  "76864": p("TX", "Mullin"),
  "76870": p("TX", "Priddy"),
  "76880": p("TX", "Star"),
  "79512": p("TX", "Colorado City"),
  "79532": p("TX", "Loraine"),
  "79565": p("TX", "Westbrook"),
  "76230": p("TX", "Bowie"),
  "76239": p("TX", "Forestburg"),
  "76251": p("TX", "Montague"),
  "76255": p("TX", "Nocona"),
  "76261": p("TX", "Ringgold"),
  "76265": p("TX", "Saint Jo"),
  "76270": p("TX", "Sunset"),
  "77301": p("TX", "Conroe"),
  "77302": p("TX", "Conroe"),
  "77303": p("TX", "Conroe"),
  "77304": p("TX", "Conroe"),
  "77305": p("TX", "Conroe"),
  "77306": p("TX", "Conroe"),
  "77316": p("TX", "Montgomery"),
  "77318": p("TX", "Willis"),
  "77333": p("TX", "Dobbin"),
  "77353": p("TX", "Magnolia"),
  "77354": p("TX", "Magnolia"),
  "77355": p("TX", "Magnolia"),
  "77356": p("TX", "Montgomery"),
  "77357": p("TX", "New Caney"),
  "77362": p("TX", "Pinehurst"),
  "77365": p("TX", "Porter"),
  "77372": p("TX", "Splendora"),
  "77378": p("TX", "Willis"),
  "77380": p("TX", "Spring"),
  "77381": p("TX", "Spring"),
  "77384": p("TX", "Conroe"),
  "77385": p("TX", "Conroe"),
  "77386": p("TX", "Spring"),
  "77387": p("TX", "Spring"),
  "77393": p("TX", "Spring"),
  "79013": p("TX", "Cactus"),
  "79029": p("TX", "Dumas"),
  "79058": p("TX", "Masterson"),
  "79086": p("TX", "Sunray"),
  "75568": p("TX", "Naples"),
  "75571": p("TX", "Omaha"),
  "75636": p("TX", "Cason"),
  "75638": p("TX", "Daingerfield"),
  "75668": p("TX", "Lone Star"),
  "79234": p("TX", "Flomot"),
  "79244": p("TX", "Matador"),
  "79256": p("TX", "Roaring Springs"),
  "75760": p("TX", "Cushing"),
  "75788": p("TX", "Sacul"),
  "75937": p("TX", "Chireno"),
  "75943": p("TX", "Douglass"),
  "75944": p("TX", "Etoile"),
  "75946": p("TX", "Garrison"),
  "75958": p("TX", "Martinsville"),
  "75961": p("TX", "Nacogdoches"),
  "75962": p("TX", "Nacogdoches"),
  "75963": p("TX", "Nacogdoches"),
  "75964": p("TX", "Nacogdoches"),
  "75965": p("TX", "Nacogdoches"),
  "75978": p("TX", "Woden"),
  "75102": p("TX", "Barry"),
  "75105": p("TX", "Chatfield"),
  "75109": p("TX", "Corsicana"),
  "75110": p("TX", "Corsicana"),
  "75144": p("TX", "Kerens"),
  "75151": p("TX", "Corsicana"),
  "75153": p("TX", "Powell"),
  "76626": p("TX", "Blooming Grove"),
  "76639": p("TX", "Dawson"),
  "76641": p("TX", "Frost"),
  "76679": p("TX", "Purdon"),
  "76681": p("TX", "Richland"),
  "75928": p("TX", "Bon Wier"),
  "75932": p("TX", "Burkeville"),
  "75933": p("TX", "Call"),
  "75966": p("TX", "Newton"),
  "75977": p("TX", "Wiergate"),
  "77614": p("TX", "Deweyville"),
  "79506": p("TX", "Blackwell"),
  "79535": p("TX", "Maryneal"),
  "79537": p("TX", "Nolan"),
  "79545": p("TX", "Roscoe"),
  "79556": p("TX", "Sweetwater"),
  "78330": p("TX", "Agua Dulce"),
  "78339": p("TX", "Banquete"),
  "78343": p("TX", "Bishop"),
  "78347": p("TX", "Chapman Ranch"),
  "78351": p("TX", "Driscoll"),
  "78373": p("TX", "Port Aransas"),
  "78380": p("TX", "Robstown"),
  "78401": p("TX", "Corpus Christi"),
  "78402": p("TX", "Corpus Christi"),
  "78403": p("TX", "Corpus Christi"),
  "78404": p("TX", "Corpus Christi"),
  "78405": p("TX", "Corpus Christi"),
  "78406": p("TX", "Corpus Christi"),
  "78407": p("TX", "Corpus Christi"),
  "78408": p("TX", "Corpus Christi"),
  "78409": p("TX", "Corpus Christi"),
  "78410": p("TX", "Corpus Christi"),
  "78411": p("TX", "Corpus Christi"),
  "78412": p("TX", "Corpus Christi"),
  "78413": p("TX", "Corpus Christi"),
  "78414": p("TX", "Corpus Christi"),
  "78415": p("TX", "Corpus Christi"),
  "78416": p("TX", "Corpus Christi"),
  "78417": p("TX", "Corpus Christi"),
  "78418": p("TX", "Corpus Christi"),
  "78419": p("TX", "Corpus Christi"),
  "78426": p("TX", "Corpus Christi"),
  "78427": p("TX", "Corpus Christi"),
  "78460": p("TX", "Corpus Christi"),
  "78463": p("TX", "Corpus Christi"),
  "78465": p("TX", "Corpus Christi"),
  "78466": p("TX", "Corpus Christi"),
  "78467": p("TX", "Corpus Christi"),
  "78468": p("TX", "Corpus Christi"),
  "78469": p("TX", "Corpus Christi"),
  "78472": p("TX", "Corpus Christi"),
  "78480": p("TX", "Corpus Christi"),
  "79033": p("TX", "Farnsworth"),
  "79070": p("TX", "Perryton"),
  "79093": p("TX", "Waka"),
  "79001": p("TX", "Adrian"),
  "79010": p("TX", "Boys Ranch"),
  "79092": p("TX", "Vega"),
  "79098": p("TX", "Wildorado"),
  "77611": p("TX", "Bridge City"),
  "77626": p("TX", "Mauriceville"),
  "77630": p("TX", "Orange"),
  "77631": p("TX", "Orange"),
  "77632": p("TX", "Orange"),
  "77639": p("TX", "Orangefield"),
  "77662": p("TX", "Vidor"),
  "77670": p("TX", "Vidor"),
  "76067": p("TX", "Mineral Wells"),
  "76068": p("TX", "Mineral Wells"),
  "76449": p("TX", "Graford"),
  "76453": p("TX", "Gordon"),
  "76463": p("TX", "Mingus"),
  "76472": p("TX", "Santo"),
  "76475": p("TX", "Strawn"),
  "76484": p("TX", "Palo Pinto"),
  "75631": p("TX", "Beckville"),
  "75633": p("TX", "Carthage"),
  "75637": p("TX", "Clayton"),
  "75639": p("TX", "De Berry"),
  "75643": p("TX", "Gary"),
  "75669": p("TX", "Long Branch"),
  "75685": p("TX", "Panola"),
  "76008": p("TX", "Aledo"),
  "76066": p("TX", "Millsap"),
  "76082": p("TX", "Springtown"),
  "76085": p("TX", "Weatherford"),
  "76086": p("TX", "Weatherford"),
  "76087": p("TX", "Weatherford"),
  "76088": p("TX", "Weatherford"),
  "76098": p("TX", "Azle"),
  "76439": p("TX", "Dennis"),
  "76485": p("TX", "Peaster"),
  "76487": p("TX", "Poolville"),
  "76490": p("TX", "Whitt"),
  "79009": p("TX", "Bovina"),
  "79035": p("TX", "Friona"),
  "79053": p("TX", "Lazbuddie"),
  "79325": p("TX", "Farwell"),
  "79730": p("TX", "Coyanosa"),
  "79735": p("TX", "Fort Stockton"),
  "79740": p("TX", "Girvin"),
  "79743": p("TX", "Imperial"),
  "79744": p("TX", "Iraan"),
  "79781": p("TX", "Sheffield"),
  "75934": p("TX", "Camden"),
  "75939": p("TX", "Corrigan"),
  "75960": p("TX", "Moscow"),
  "77326": p("TX", "Ace"),
  "77332": p("TX", "Dallardsville"),
  "77335": p("TX", "Goodrich"),
  "77350": p("TX", "Leggett"),
  "77351": p("TX", "Livingston"),
  "77360": p("TX", "Onalaska"),
  "77399": p("TX", "Livingston"),
  "79012": p("TX", "Bushland"),
  "79101": p("TX", "Amarillo"),
  "79102": p("TX", "Amarillo"),
  "79103": p("TX", "Amarillo"),
  "79104": p("TX", "Amarillo"),
  "79105": p("TX", "Amarillo"),
  "79106": p("TX", "Amarillo"),
  "79107": p("TX", "Amarillo"),
  "79108": p("TX", "Amarillo"),
  "79111": p("TX", "Amarillo"),
  "79116": p("TX", "Amarillo"),
  "79117": p("TX", "Amarillo"),
  "79120": p("TX", "Amarillo"),
  "79124": p("TX", "Amarillo"),
  "79159": p("TX", "Amarillo"),
  "79166": p("TX", "Amarillo"),
  "79168": p("TX", "Amarillo"),
  "79172": p("TX", "Amarillo"),
  "79174": p("TX", "Amarillo"),
  "79178": p("TX", "Amarillo"),
  "79185": p("TX", "Amarillo"),
  "79189": p("TX", "Amarillo"),
  "79843": p("TX", "Marfa"),
  "79845": p("TX", "Presidio"),
  "79846": p("TX", "Redford"),
  "75410": p("TX", "Alba"),
  "75440": p("TX", "Emory"),
  "75472": p("TX", "Point"),
  "79015": p("TX", "Canyon"),
  "79016": p("TX", "Canyon"),
  "79091": p("TX", "Umbarger"),
  "79109": p("TX", "Amarillo"),
  "79110": p("TX", "Amarillo"),
  "79114": p("TX", "Amarillo"),
  "79118": p("TX", "Amarillo"),
  "79119": p("TX", "Amarillo"),
  "79121": p("TX", "Amarillo"),
  "76932": p("TX", "Big Lake"),
  "78833": p("TX", "Camp Wood"),
  "78873": p("TX", "Leakey"),
  "78879": p("TX", "Rio Frio"),
  "75412": p("TX", "Bagwell"),
  "75417": p("TX", "Bogata"),
  "75426": p("TX", "Clarksville"),
  "75436": p("TX", "Detroit"),
  "75550": p("TX", "Annona"),
  "75554": p("TX", "Avery"),
  "79718": p("TX", "Balmorhea"),
  "79770": p("TX", "Orla"),
  "79772": p("TX", "Pecos"),
  "79780": p("TX", "Saragosa"),
  "79785": p("TX", "Toyah"),
  "79786": p("TX", "Toyahvale"),
  "77950": p("TX", "Austwell"),
  "77990": p("TX", "Tivoli"),
  "78340": p("TX", "Bayside"),
  "78377": p("TX", "Refugio"),
  "78393": p("TX", "Woodsboro"),
  "79059": p("TX", "Miami"),
  "76629": p("TX", "Bremond"),
  "77837": p("TX", "Calvert"),
  "77856": p("TX", "Franklin"),
  "77859": p("TX", "Hearne"),
  "77867": p("TX", "Mumford"),
  "77870": p("TX", "New Baden"),
  "77882": p("TX", "Wheelock"),
  "75032": p("TX", "Rockwall"),
  "75087": p("TX", "Rockwall"),
  "75132": p("TX", "Fate"),
  "75189": p("TX", "Royse City"),
  "76821": p("TX", "Ballinger"),
  "76861": p("TX", "Miles"),
  "76865": p("TX", "Norton"),
  "76875": p("TX", "Rowena"),
  "79566": p("TX", "Wingate"),
  "79567": p("TX", "Winters"),
  "75652": p("TX", "Henderson"),
  "75653": p("TX", "Henderson"),
  "75654": p("TX", "Henderson"),
  "75658": p("TX", "Joinerville"),
  "75666": p("TX", "Laird Hill"),
  "75667": p("TX", "Laneville"),
  "75680": p("TX", "Minden"),
  "75681": p("TX", "Mount Enterprise"),
  "75682": p("TX", "New London"),
  "75684": p("TX", "Overton"),
  "75687": p("TX", "Price"),
  "75689": p("TX", "Selman City"),
  "75691": p("TX", "Tatum"),
  "75930": p("TX", "Bronson"),
  "75931": p("TX", "Brookeland"),
  "75948": p("TX", "Hemphill"),
  "75959": p("TX", "Milam"),
  "75968": p("TX", "Pineland"),
  "75929": p("TX", "Broaddus"),
  "75972": p("TX", "San Augustine"),
  "77331": p("TX", "Coldspring"),
  "77359": p("TX", "Oakhurst"),
  "77364": p("TX", "Pointblank"),
  "77371": p("TX", "Shepherd"),
  "78335": p("TX", "Aransas Pass"),
  "78336": p("TX", "Aransas Pass"),
  "78352": p("TX", "Edroy"),
  "78359": p("TX", "Gregory"),
  "78362": p("TX", "Ingleside"),
  "78368": p("TX", "Mathis"),
  "78370": p("TX", "Odem"),
  "78374": p("TX", "Portland"),
  "78387": p("TX", "Sinton"),
  "78390": p("TX", "Taft"),
  "76832": p("TX", "Cherokee"),
  "76871": p("TX", "Richland Springs"),
  "76877": p("TX", "San Saba"),
  "76936": p("TX", "Eldorado"),
  "79516": p("TX", "Dunn"),
  "79517": p("TX", "Fluvanna"),
  "79526": p("TX", "Hermleigh"),
  "79527": p("TX", "Ira"),
  "79549": p("TX", "Snyder"),
  "79550": p("TX", "Snyder"),
  "76430": p("TX", "Albany"),
  "76464": p("TX", "Moran"),
  "75935": p("TX", "Center"),
  "75954": p("TX", "Joaquin"),
  "75973": p("TX", "Shelbyville"),
  "75974": p("TX", "Tenaha"),
  "75975": p("TX", "Timpson"),
  "73960": p("TX", "Texhoma"),
  "79084": p("TX", "Stratford"),
  "75701": p("TX", "Tyler"),
  "75702": p("TX", "Tyler"),
  "75703": p("TX", "Tyler"),
  "75704": p("TX", "Tyler"),
  "75705": p("TX", "Tyler"),
  "75706": p("TX", "Tyler"),
  "75707": p("TX", "Tyler"),
  "75708": p("TX", "Tyler"),
  "75709": p("TX", "Tyler"),
  "75710": p("TX", "Tyler"),
  "75711": p("TX", "Tyler"),
  "75712": p("TX", "Tyler"),
  "75713": p("TX", "Tyler"),
  "75750": p("TX", "Arp"),
  "75757": p("TX", "Bullard"),
  "75762": p("TX", "Flint"),
  "75771": p("TX", "Lindale"),
  "75789": p("TX", "Troup"),
  "75791": p("TX", "Whitehouse"),
  "75792": p("TX", "Winona"),
  "75798": p("TX", "Tyler"),
  "75799": p("TX", "Tyler"),
  "76043": p("TX", "Glen Rose"),
  "76070": p("TX", "Nemo"),
  "76077": p("TX", "Rainbow"),
  "78536": p("TX", "Delmita"),
  "78545": p("TX", "Falcon Heights"),
  "78547": p("TX", "Garciasville"),
  "78548": p("TX", "Grulla"),
  "78582": p("TX", "Rio Grande City"),
  "78584": p("TX", "Roma"),
  "78585": p("TX", "Salineno"),
  "78588": p("TX", "San Isidro"),
  "78591": p("TX", "Santa Elena"),
  "76424": p("TX", "Breckenridge"),
  "76429": p("TX", "Caddo"),
  "76951": p("TX", "Sterling City"),
  "79502": p("TX", "Aspermont"),
  "79540": p("TX", "Old Glory"),
  "76950": p("TX", "Sonora"),
  "79042": p("TX", "Happy"),
  "79052": p("TX", "Kress"),
  "79088": p("TX", "Tulia"),
  "76001": p("TX", "Arlington"),
  "76002": p("TX", "Arlington"),
  "76003": p("TX", "Arlington"),
  "76004": p("TX", "Arlington"),
  "76005": p("TX", "Arlington"),
  "76006": p("TX", "Arlington"),
  "76007": p("TX", "Arlington"),
  "76010": p("TX", "Arlington"),
  "76011": p("TX", "Arlington"),
  "76012": p("TX", "Arlington"),
  "76013": p("TX", "Arlington"),
  "76014": p("TX", "Arlington"),
  "76015": p("TX", "Arlington"),
  "76016": p("TX", "Arlington"),
  "76017": p("TX", "Arlington"),
  "76018": p("TX", "Arlington"),
  "76019": p("TX", "Arlington"),
  "76020": p("TX", "Azle"),
  "76021": p("TX", "Bedford"),
  "76022": p("TX", "Bedford"),
  "76034": p("TX", "Colleyville"),
  "76036": p("TX", "Crowley"),
  "76039": p("TX", "Euless"),
  "76040": p("TX", "Euless"),
  "76051": p("TX", "Grapevine"),
  "76052": p("TX", "Haslet"),
  "76053": p("TX", "Hurst"),
  "76054": p("TX", "Hurst"),
  "76060": p("TX", "Kennedale"),
  "76063": p("TX", "Mansfield"),
  "76092": p("TX", "Southlake"),
  "76094": p("TX", "Arlington"),
  "76095": p("TX", "Bedford"),
  "76096": p("TX", "Arlington"),
  "76099": p("TX", "Grapevine"),
  "76101": p("TX", "Fort Worth"),
  "76102": p("TX", "Fort Worth"),
  "76103": p("TX", "Fort Worth"),
  "76104": p("TX", "Fort Worth"),
  "76105": p("TX", "Fort Worth"),
  "76106": p("TX", "Fort Worth"),
  "76107": p("TX", "Fort Worth"),
  "76108": p("TX", "Fort Worth"),
  "76109": p("TX", "Fort Worth"),
  "76110": p("TX", "Fort Worth"),
  "76111": p("TX", "Fort Worth"),
  "76112": p("TX", "Fort Worth"),
  "76113": p("TX", "Fort Worth"),
  "76114": p("TX", "Fort Worth"),
  "76115": p("TX", "Fort Worth"),
  "76116": p("TX", "Fort Worth"),
  "76117": p("TX", "Haltom City"),
  "76118": p("TX", "Fort Worth"),
  "76119": p("TX", "Fort Worth"),
  "76120": p("TX", "Fort Worth"),
  "76121": p("TX", "Fort Worth"),
  "76122": p("TX", "Fort Worth"),
  "76123": p("TX", "Fort Worth"),
  "76124": p("TX", "Fort Worth"),
  "76126": p("TX", "Fort Worth"),
  "76127": p("TX", "Naval Air Station Jrb"),
  "76129": p("TX", "Fort Worth"),
  "76130": p("TX", "Fort Worth"),
  "76131": p("TX", "Fort Worth"),
  "76132": p("TX", "Fort Worth"),
  "76133": p("TX", "Fort Worth"),
  "76134": p("TX", "Fort Worth"),
  "76135": p("TX", "Fort Worth"),
  "76136": p("TX", "Fort Worth"),
  "76137": p("TX", "Fort Worth"),
  "76140": p("TX", "Fort Worth"),
  "76147": p("TX", "Fort Worth"),
  "76148": p("TX", "Fort Worth"),
  "76150": p("TX", "Fort Worth"),
  "76155": p("TX", "Fort Worth"),
  "76161": p("TX", "Fort Worth"),
  "76162": p("TX", "Fort Worth"),
  "76163": p("TX", "Fort Worth"),
  "76164": p("TX", "Fort Worth"),
  "76166": p("TX", "Fort Worth"),
  "76177": p("TX", "Fort Worth"),
  "76179": p("TX", "Fort Worth"),
  "76180": p("TX", "North Richland Hills"),
  "76181": p("TX", "Fort Worth"),
  "76182": p("TX", "North Richland Hills"),
  "76185": p("TX", "Fort Worth"),
  "76190": p("TX", "Fort Worth"),
  "76191": p("TX", "Fort Worth"),
  "76192": p("TX", "Fort Worth"),
  "76193": p("TX", "Fort Worth"),
  "76195": p("TX", "Fort Worth"),
  "76196": p("TX", "Fort Worth"),
  "76197": p("TX", "Fort Worth"),
  "76198": p("TX", "Fort Worth"),
  "76199": p("TX", "Fort Worth"),
  "76244": p("TX", "Keller"),
  "76248": p("TX", "Keller"),
  "79508": p("TX", "Buffalo Gap"),
  "79530": p("TX", "Lawn"),
  "79536": p("TX", "Merkel"),
  "79541": p("TX", "Ovalo"),
  "79561": p("TX", "Trent"),
  "79562": p("TX", "Tuscola"),
  "79563": p("TX", "Tye"),
  "79601": p("TX", "Abilene"),
  "79602": p("TX", "Abilene"),
  "79603": p("TX", "Abilene"),
  "79604": p("TX", "Abilene"),
  "79605": p("TX", "Abilene"),
  "79606": p("TX", "Abilene"),
  "79607": p("TX", "Dyess Afb"),
  "79608": p("TX", "Abilene"),
  "79697": p("TX", "Abilene"),
  "79698": p("TX", "Abilene"),
  "79699": p("TX", "Abilene"),
  "78851": p("TX", "Dryden"),
  "79848": p("TX", "Sanderson"),
  "79316": p("TX", "Brownfield"),
  "79345": p("TX", "Meadow"),
  "79378": p("TX", "Wellman"),
  "76483": p("TX", "Throckmorton"),
  "76491": p("TX", "Woodson"),
  "75455": p("TX", "Mount Pleasant"),
  "75456": p("TX", "Mount Pleasant"),
  "75493": p("TX", "Winfield"),
  "75558": p("TX", "Cookville"),
  "76886": p("TX", "Veribest"),
  "76901": p("TX", "San Angelo"),
  "76902": p("TX", "San Angelo"),
  "76903": p("TX", "San Angelo"),
  "76904": p("TX", "San Angelo"),
  "76905": p("TX", "San Angelo"),
  "76906": p("TX", "San Angelo"),
  "76908": p("TX", "Goodfellow Afb"),
  "76909": p("TX", "San Angelo"),
  "76934": p("TX", "Carlsbad"),
  "76935": p("TX", "Christoval"),
  "76939": p("TX", "Knickerbocker"),
  "76940": p("TX", "Mereta"),
  "76955": p("TX", "Vancourt"),
  "76957": p("TX", "Wall"),
  "76958": p("TX", "Water Valley"),
  "73301": p("TX", "Austin"),
  "73344": p("TX", "Austin"),
  "78617": p("TX", "Del Valle"),
  "78645": p("TX", "Leander"),
  "78651": p("TX", "Mc Neil"),
  "78652": p("TX", "Manchaca"),
  "78653": p("TX", "Manor"),
  "78660": p("TX", "Pflugerville"),
  "78669": p("TX", "Spicewood"),
  "78691": p("TX", "Pflugerville"),
  "78701": p("TX", "Austin"),
  "78702": p("TX", "Austin"),
  "78703": p("TX", "Austin"),
  "78704": p("TX", "Austin"),
  "78705": p("TX", "Austin"),
  "78708": p("TX", "Austin"),
  "78709": p("TX", "Austin"),
  "78710": p("TX", "Austin"),
  "78711": p("TX", "Austin"),
  "78712": p("TX", "Austin"),
  "78713": p("TX", "Austin"),
  "78714": p("TX", "Austin"),
  "78715": p("TX", "Austin"),
  "78716": p("TX", "Austin"),
  "78718": p("TX", "Austin"),
  "78719": p("TX", "Austin"),
  "78720": p("TX", "Austin"),
  "78721": p("TX", "Austin"),
  "78722": p("TX", "Austin"),
  "78723": p("TX", "Austin"),
  "78724": p("TX", "Austin"),
  "78725": p("TX", "Austin"),
  "78726": p("TX", "Austin"),
  "78727": p("TX", "Austin"),
  "78728": p("TX", "Austin"),
  "78730": p("TX", "Austin"),
  "78731": p("TX", "Austin"),
  "78732": p("TX", "Austin"),
  "78733": p("TX", "Austin"),
  "78734": p("TX", "Austin"),
  "78735": p("TX", "Austin"),
  "78736": p("TX", "Austin"),
  "78737": p("TX", "Austin"),
  "78738": p("TX", "Austin"),
  "78739": p("TX", "Austin"),
  "78741": p("TX", "Austin"),
  "78742": p("TX", "Austin"),
  "78744": p("TX", "Austin"),
  "78745": p("TX", "Austin"),
  "78746": p("TX", "Austin"),
  "78747": p("TX", "Austin"),
  "78748": p("TX", "Austin"),
  "78749": p("TX", "Austin"),
  "78750": p("TX", "Austin"),
  "78751": p("TX", "Austin"),
  "78752": p("TX", "Austin"),
  "78753": p("TX", "Austin"),
  "78754": p("TX", "Austin"),
  "78755": p("TX", "Austin"),
  "78756": p("TX", "Austin"),
  "78757": p("TX", "Austin"),
  "78758": p("TX", "Austin"),
  "78759": p("TX", "Austin"),
  "78760": p("TX", "Austin"),
  "78761": p("TX", "Austin"),
  "78762": p("TX", "Austin"),
  "78763": p("TX", "Austin"),
  "78764": p("TX", "Austin"),
  "78765": p("TX", "Austin"),
  "78766": p("TX", "Austin"),
  "78767": p("TX", "Austin"),
  "78768": p("TX", "Austin"),
  "78769": p("TX", "Austin"),
  "78772": p("TX", "Austin"),
  "78773": p("TX", "Austin"),
  "78774": p("TX", "Austin"),
  "78778": p("TX", "Austin"),
  "78779": p("TX", "Austin"),
  "78783": p("TX", "Austin"),
  "78799": p("TX", "Austin"),
  "75834": p("TX", "Centralia"),
  "75845": p("TX", "Groveton"),
  "75856": p("TX", "Pennington"),
  "75862": p("TX", "Trinity"),
  "75865": p("TX", "Woodlake"),
  "75926": p("TX", "Apple Springs"),
  "75936": p("TX", "Chester"),
  "75938": p("TX", "Colmesneil"),
  "75942": p("TX", "Doucette"),
  "75979": p("TX", "Woodville"),
  "75990": p("TX", "Woodville"),
  "77616": p("TX", "Fred"),
  "77624": p("TX", "Hillister"),
  "77660": p("TX", "Spurger"),
  "77664": p("TX", "Warren"),
  "75640": p("TX", "Diana"),
  "75644": p("TX", "Gilmer"),
  "75645": p("TX", "Gilmer"),
  "75683": p("TX", "Ore City"),
  "75755": p("TX", "Big Sandy"),
  "75797": p("TX", "Big Sandy"),
  "79752": p("TX", "Mc Camey"),
  "79755": p("TX", "Midkiff"),
  "79778": p("TX", "Rankin"),
  "78801": p("TX", "Uvalde"),
  "78802": p("TX", "Uvalde"),
  "78838": p("TX", "Concan"),
  "78870": p("TX", "Knippa"),
  "78881": p("TX", "Sabinal"),
  "78884": p("TX", "Utopia"),
  "78837": p("TX", "Comstock"),
  "78840": p("TX", "Del Rio"),
  "78841": p("TX", "Del Rio"),
  "78842": p("TX", "Del Rio"),
  "78843": p("TX", "Laughlin Afb"),
  "78847": p("TX", "Del Rio"),
  "78871": p("TX", "Langtry"),
  "75103": p("TX", "Canton"),
  "75117": p("TX", "Edgewood"),
  "75127": p("TX", "Fruitvale"),
  "75140": p("TX", "Grand Saline"),
  "75169": p("TX", "Wills Point"),
  "75754": p("TX", "Ben Wheeler"),
  "75790": p("TX", "Van"),
  "77901": p("TX", "Victoria"),
  "77902": p("TX", "Victoria"),
  "77903": p("TX", "Victoria"),
  "77904": p("TX", "Victoria"),
  "77905": p("TX", "Victoria"),
  "77951": p("TX", "Bloomington"),
  "77968": p("TX", "Inez"),
  "77973": p("TX", "Mcfaddin"),
  "77976": p("TX", "Nursery"),
  "77977": p("TX", "Placedo"),
  "77988": p("TX", "Telferner"),
  "77320": p("TX", "Huntsville"),
  "77334": p("TX", "Dodge"),
  "77340": p("TX", "Huntsville"),
  "77341": p("TX", "Huntsville"),
  "77342": p("TX", "Huntsville"),
  "77343": p("TX", "Huntsville"),
  "77344": p("TX", "Huntsville"),
  "77348": p("TX", "Huntsville"),
  "77349": p("TX", "Huntsville"),
  "77358": p("TX", "New Waverly"),
  "77367": p("TX", "Riverside"),
  "77423": p("TX", "Brookshire"),
  "77445": p("TX", "Hempstead"),
  "77446": p("TX", "Prairie View"),
  "77466": p("TX", "Pattison"),
  "77484": p("TX", "Waller"),
  "79719": p("TX", "Barstow"),
  "79742": p("TX", "Grandfalls"),
  "79756": p("TX", "Monahans"),
  "79777": p("TX", "Pyote"),
  "79788": p("TX", "Wickett"),
  "77426": p("TX", "Chappell Hill"),
  "77833": p("TX", "Brenham"),
  "77834": p("TX", "Brenham"),
  "77835": p("TX", "Burton"),
  "77880": p("TX", "Washington"),
  "78040": p("TX", "Laredo"),
  "78041": p("TX", "Laredo"),
  "78042": p("TX", "Laredo"),
  "78043": p("TX", "Laredo"),
  "78044": p("TX", "Laredo"),
  "78045": p("TX", "Laredo"),
  "78046": p("TX", "Laredo"),
  "78344": p("TX", "Bruni"),
  "78369": p("TX", "Mirando City"),
  "78371": p("TX", "Oilton"),
  "77420": p("TX", "Boling"),
  "77432": p("TX", "Danevang"),
  "77435": p("TX", "East Bernard"),
  "77436": p("TX", "Egypt"),
  "77437": p("TX", "El Campo"),
  "77443": p("TX", "Glen Flora"),
  "77448": p("TX", "Hungerford"),
  "77453": p("TX", "Lane City"),
  "77454": p("TX", "Lissie"),
  "77455": p("TX", "Louise"),
  "77467": p("TX", "Pierce"),
  "77488": p("TX", "Wharton"),
  "79003": p("TX", "Allison"),
  "79011": p("TX", "Briscoe"),
  "79061": p("TX", "Mobeetie"),
  "79079": p("TX", "Shamrock"),
  "79096": p("TX", "Wheeler"),
  "76301": p("TX", "Wichita Falls"),
  "76302": p("TX", "Wichita Falls"),
  "76305": p("TX", "Wichita Falls"),
  "76306": p("TX", "Wichita Falls"),
  "76307": p("TX", "Wichita Falls"),
  "76308": p("TX", "Wichita Falls"),
  "76309": p("TX", "Wichita Falls"),
  "76310": p("TX", "Wichita Falls"),
  "76311": p("TX", "Sheppard Afb"),
  "76354": p("TX", "Burkburnett"),
  "76360": p("TX", "Electra"),
  "76367": p("TX", "Iowa Park"),
  "76369": p("TX", "Kamay"),
  "76364": p("TX", "Harrold"),
  "76373": p("TX", "Oklaunion"),
  "76384": p("TX", "Vernon"),
  "76385": p("TX", "Vernon"),
  "79247": p("TX", "Odell"),
  "78561": p("TX", "Lasara"),
  "78569": p("TX", "Lyford"),
  "78574": p("TX", "Mission"),
  "78580": p("TX", "Raymondville"),
  "78590": p("TX", "San Perlita"),
  "78594": p("TX", "Sebastian"),
  "78598": p("TX", "Port Mansfield"),
  "76527": p("TX", "Florence"),
  "76530": p("TX", "Granger"),
  "76537": p("TX", "Jarrell"),
  "76573": p("TX", "Schwertner"),
  "76574": p("TX", "Taylor"),
  "76578": p("TX", "Thrall"),
  "78613": p("TX", "Cedar Park"),
  "78615": p("TX", "Coupland"),
  "78626": p("TX", "Georgetown"),
  "78627": p("TX", "Georgetown"),
  "78628": p("TX", "Georgetown"),
  "78630": p("TX", "Cedar Park"),
  "78633": p("TX", "Georgetown"),
  "78634": p("TX", "Hutto"),
  "78641": p("TX", "Leander"),
  "78642": p("TX", "Liberty Hill"),
  "78646": p("TX", "Leander"),
  "78664": p("TX", "Round Rock"),
  "78665": p("TX", "Round Rock"),
  "78673": p("TX", "Walburg"),
  "78674": p("TX", "Weir"),
  "78680": p("TX", "Round Rock"),
  "78681": p("TX", "Round Rock"),
  "78682": p("TX", "Round Rock"),
  "78683": p("TX", "Round Rock"),
  "78717": p("TX", "Austin"),
  "78729": p("TX", "Austin"),
  "78114": p("TX", "Floresville"),
  "78121": p("TX", "La Vernia"),
  "78143": p("TX", "Pandora"),
  "78147": p("TX", "Poth"),
  "78160": p("TX", "Stockdale"),
  "78161": p("TX", "Sutherland Springs"),
  "79745": p("TX", "Kermit"),
  "79789": p("TX", "Wink"),
  "76023": p("TX", "Boyd"),
  "76071": p("TX", "Newark"),
  "76073": p("TX", "Paradise"),
  "76078": p("TX", "Rhome"),
  "76225": p("TX", "Alvord"),
  "76234": p("TX", "Decatur"),
  "76246": p("TX", "Greenwood"),
  "76267": p("TX", "Slidell"),
  "76426": p("TX", "Bridgeport"),
  "76431": p("TX", "Chico"),
  "75444": p("TX", "Golden"),
  "75494": p("TX", "Winnsboro"),
  "75497": p("TX", "Yantis"),
  "75765": p("TX", "Hawkins"),
  "75773": p("TX", "Mineola"),
  "75783": p("TX", "Quitman"),
  "79323": p("TX", "Denver City"),
  "79355": p("TX", "Plains"),
  "79376": p("TX", "Tokio"),
  "76372": p("TX", "Newcastle"),
  "76374": p("TX", "Olney"),
  "76450": p("TX", "Graham"),
  "76460": p("TX", "Loving"),
  "76481": p("TX", "South Bend"),
  "78067": p("TX", "San Ygnacio"),
  "78076": p("TX", "Zapata"),
  "78564": p("TX", "Lopeno"),
  "78829": p("TX", "Batesville"),
  "78839": p("TX", "Crystal City"),
  "78872": p("TX", "La Pryor"),
  "84713": p("UT", "Beaver"),
  "84731": p("UT", "Greenville"),
  "84751": p("UT", "Milford"),
  "84752": p("UT", "Minersville"),
  "84301": p("UT", "Bear River City"),
  "84302": p("UT", "Brigham City"),
  "84306": p("UT", "Collinston"),
  "84307": p("UT", "Corinne"),
  "84309": p("UT", "Deweyville"),
  "84311": p("UT", "Fielding"),
  "84312": p("UT", "Garland"),
  "84313": p("UT", "Grouse Creek"),
  "84314": p("UT", "Honeyville"),
  "84316": p("UT", "Howell"),
  "84324": p("UT", "Mantua"),
  "84329": p("UT", "Park Valley"),
  "84330": p("UT", "Plymouth"),
  "84331": p("UT", "Portage"),
  "84334": p("UT", "Riverside"),
  "84336": p("UT", "Snowville"),
  "84337": p("UT", "Tremonton"),
  "84340": p("UT", "Willard"),
  "84304": p("UT", "Cache Junction"),
  "84305": p("UT", "Clarkston"),
  "84308": p("UT", "Cornish"),
  "84318": p("UT", "Hyde Park"),
  "84319": p("UT", "Hyrum"),
  "84320": p("UT", "Lewiston"),
  "84321": p("UT", "Logan"),
  "84322": p("UT", "Logan"),
  "84323": p("UT", "Logan"),
  "84325": p("UT", "Mendon"),
  "84326": p("UT", "Millville"),
  "84327": p("UT", "Newton"),
  "84328": p("UT", "Paradise"),
  "84332": p("UT", "Providence"),
  "84333": p("UT", "Richmond"),
  "84335": p("UT", "Smithfield"),
  "84338": p("UT", "Trenton"),
  "84339": p("UT", "Wellsville"),
  "84341": p("UT", "Logan"),
  "84501": p("UT", "Price"),
  "84520": p("UT", "East Carbon"),
  "84526": p("UT", "Helper"),
  "84529": p("UT", "Kenilworth"),
  "84539": p("UT", "Sunnyside"),
  "84542": p("UT", "Wellington"),
  "84023": p("UT", "Dutch John"),
  "84046": p("UT", "Manila"),
  "84010": p("UT", "Bountiful"),
  "84011": p("UT", "Bountiful"),
  "84014": p("UT", "Centerville"),
  "84015": p("UT", "Clearfield"),
  "84016": p("UT", "Clearfield"),
  "84025": p("UT", "Farmington"),
  "84037": p("UT", "Kaysville"),
  "84040": p("UT", "Layton"),
  "84041": p("UT", "Layton"),
  "84054": p("UT", "North Salt Lake"),
  "84056": p("UT", "Hill Afb"),
  "84075": p("UT", "Syracuse"),
  "84087": p("UT", "Woods Cross"),
  "84089": p("UT", "Clearfield"),
  "84001": p("UT", "Altamont"),
  "84002": p("UT", "Altonah"),
  "84007": p("UT", "Bluebell"),
  "84021": p("UT", "Duchesne"),
  "84027": p("UT", "Fruitland"),
  "84031": p("UT", "Hanna"),
  "84051": p("UT", "Mountain Home"),
  "84052": p("UT", "Myton"),
  "84053": p("UT", "Neola"),
  "84066": p("UT", "Roosevelt"),
  "84072": p("UT", "Tabiona"),
  "84073": p("UT", "Talmage"),
  "84513": p("UT", "Castle Dale"),
  "84516": p("UT", "Clawson"),
  "84518": p("UT", "Cleveland"),
  "84521": p("UT", "Elmo"),
  "84522": p("UT", "Emery"),
  "84523": p("UT", "Ferron"),
  "84525": p("UT", "Green River"),
  "84528": p("UT", "Huntington"),
  "84537": p("UT", "Orangeville"),
  "84712": p("UT", "Antimony"),
  "84716": p("UT", "Boulder"),
  "84718": p("UT", "Cannonville"),
  "84726": p("UT", "Escalante"),
  "84735": p("UT", "Hatch"),
  "84736": p("UT", "Henrieville"),
  "84759": p("UT", "Panguitch"),
  "84764": p("UT", "Bryce"),
  "84776": p("UT", "Tropic"),
  "84515": p("UT", "Cisco"),
  "84532": p("UT", "Moab"),
  "84540": p("UT", "Thompson"),
  "84714": p("UT", "Beryl"),
  "84719": p("UT", "Brian Head"),
  "84720": p("UT", "Cedar City"),
  "84721": p("UT", "Cedar City"),
  "84742": p("UT", "Kanarraville"),
  "84753": p("UT", "Modena"),
  "84756": p("UT", "Newcastle"),
  "84760": p("UT", "Paragonah"),
  "84761": p("UT", "Parowan"),
  "84772": p("UT", "Summit"),
  "84628": p("UT", "Eureka"),
  "84639": p("UT", "Levan"),
  "84645": p("UT", "Mona"),
  "84648": p("UT", "Nephi"),
  "84710": p("UT", "Alton"),
  "84729": p("UT", "Glendale"),
  "84741": p("UT", "Kanab"),
  "84755": p("UT", "Mount Carmel"),
  "84758": p("UT", "Orderville"),
  "84762": p("UT", "Duck Creek Village"),
  "84624": p("UT", "Delta"),
  "84631": p("UT", "Fillmore"),
  "84635": p("UT", "Hinckley"),
  "84636": p("UT", "Holden"),
  "84637": p("UT", "Kanosh"),
  "84638": p("UT", "Leamington"),
  "84640": p("UT", "Lynndyl"),
  "84644": p("UT", "Meadow"),
  "84649": p("UT", "Oak City"),
  "84656": p("UT", "Scipio"),
  "84728": p("UT", "Garrison"),
  "84018": p("UT", "Croydon"),
  "84050": p("UT", "Morgan"),
  "84723": p("UT", "Circleville"),
  "84732": p("UT", "Greenwich"),
  "84740": p("UT", "Junction"),
  "84743": p("UT", "Kingston"),
  "84750": p("UT", "Marysvale"),
  "84028": p("UT", "Garden City"),
  "84038": p("UT", "Laketown"),
  "84064": p("UT", "Randolph"),
  "84086": p("UT", "Woodruff"),
  "84006": p("UT", "Bingham Canyon"),
  "84009": p("UT", "South Jordan"),
  "84020": p("UT", "Draper"),
  "84044": p("UT", "Magna"),
  "84047": p("UT", "Midvale"),
  "84065": p("UT", "Riverton"),
  "84070": p("UT", "Sandy"),
  "84081": p("UT", "West Jordan"),
  "84084": p("UT", "West Jordan"),
  "84088": p("UT", "West Jordan"),
  "84090": p("UT", "Sandy"),
  "84091": p("UT", "Sandy"),
  "84092": p("UT", "Sandy"),
  "84093": p("UT", "Sandy"),
  "84094": p("UT", "Sandy"),
  "84095": p("UT", "South Jordan"),
  "84096": p("UT", "Herriman"),
  "84101": p("UT", "Salt Lake City"),
  "84102": p("UT", "Salt Lake City"),
  "84103": p("UT", "Salt Lake City"),
  "84104": p("UT", "Salt Lake City"),
  "84105": p("UT", "Salt Lake City"),
  "84106": p("UT", "Salt Lake City"),
  "84107": p("UT", "Salt Lake City"),
  "84108": p("UT", "Salt Lake City"),
  "84109": p("UT", "Salt Lake City"),
  "84110": p("UT", "Salt Lake City"),
  "84111": p("UT", "Salt Lake City"),
  "84112": p("UT", "Salt Lake City"),
  "84113": p("UT", "Salt Lake City"),
  "84114": p("UT", "Salt Lake City"),
  "84115": p("UT", "Salt Lake City"),
  "84116": p("UT", "Salt Lake City"),
  "84117": p("UT", "Salt Lake City"),
  "84118": p("UT", "Salt Lake City"),
  "84119": p("UT", "West Valley City"),
  "84120": p("UT", "West Valley City"),
  "84121": p("UT", "Salt Lake City"),
  "84122": p("UT", "Salt Lake City"),
  "84123": p("UT", "Salt Lake City"),
  "84124": p("UT", "Salt Lake City"),
  "84125": p("UT", "Salt Lake City"),
  "84126": p("UT", "Salt Lake City"),
  "84127": p("UT", "Salt Lake City"),
  "84128": p("UT", "West Valley City"),
  "84129": p("UT", "Salt Lake City"),
  "84130": p("UT", "Salt Lake City"),
  "84131": p("UT", "Salt Lake City"),
  "84132": p("UT", "Salt Lake City"),
  "84133": p("UT", "Salt Lake City"),
  "84134": p("UT", "Salt Lake City"),
  "84136": p("UT", "Salt Lake City"),
  "84138": p("UT", "Salt Lake City"),
  "84139": p("UT", "Salt Lake City"),
  "84141": p("UT", "Salt Lake City"),
  "84143": p("UT", "Salt Lake City"),
  "84145": p("UT", "Salt Lake City"),
  "84147": p("UT", "Salt Lake City"),
  "84148": p("UT", "Salt Lake City"),
  "84150": p("UT", "Salt Lake City"),
  "84151": p("UT", "Salt Lake City"),
  "84152": p("UT", "Salt Lake City"),
  "84157": p("UT", "Salt Lake City"),
  "84158": p("UT", "Salt Lake City"),
  "84165": p("UT", "Salt Lake City"),
  "84170": p("UT", "Salt Lake City"),
  "84171": p("UT", "Salt Lake City"),
  "84180": p("UT", "Salt Lake City"),
  "84184": p("UT", "Salt Lake City"),
  "84189": p("UT", "Salt Lake City"),
  "84190": p("UT", "Salt Lake City"),
  "84199": p("UT", "Salt Lake City"),
  "84510": p("UT", "Aneth"),
  "84511": p("UT", "Blanding"),
  "84512": p("UT", "Bluff"),
  "84530": p("UT", "La Sal"),
  "84531": p("UT", "Mexican Hat"),
  "84533": p("UT", "Lake Powell"),
  "84534": p("UT", "Montezuma Creek"),
  "84535": p("UT", "Monticello"),
  "84536": p("UT", "Monument Valley"),
  "84621": p("UT", "Axtell"),
  "84622": p("UT", "Centerfield"),
  "84623": p("UT", "Chester"),
  "84627": p("UT", "Ephraim"),
  "84629": p("UT", "Fairview"),
  "84630": p("UT", "Fayette"),
  "84632": p("UT", "Fountain Green"),
  "84634": p("UT", "Gunnison"),
  "84642": p("UT", "Manti"),
  "84643": p("UT", "Mayfield"),
  "84646": p("UT", "Moroni"),
  "84647": p("UT", "Mount Pleasant"),
  "84662": p("UT", "Spring City"),
  "84665": p("UT", "Sterling"),
  "84667": p("UT", "Wales"),
  "84620": p("UT", "Aurora"),
  "84652": p("UT", "Redmond"),
  "84654": p("UT", "Salina"),
  "84657": p("UT", "Sigurd"),
  "84701": p("UT", "Richfield"),
  "84711": p("UT", "Annabella"),
  "84724": p("UT", "Elsinore"),
  "84730": p("UT", "Glenwood"),
  "84739": p("UT", "Joseph"),
  "84744": p("UT", "Koosharem"),
  "84754": p("UT", "Monroe"),
  "84766": p("UT", "Sevier"),
  "84017": p("UT", "Coalville"),
  "84024": p("UT", "Echo"),
  "84033": p("UT", "Henefer"),
  "84036": p("UT", "Kamas"),
  "84055": p("UT", "Oakley"),
  "84060": p("UT", "Park City"),
  "84061": p("UT", "Peoa"),
  "84068": p("UT", "Park City"),
  "84098": p("UT", "Park City"),
  "84022": p("UT", "Dugway"),
  "84029": p("UT", "Grantsville"),
  "84034": p("UT", "Ibapah"),
  "84069": p("UT", "Rush Valley"),
  "84071": p("UT", "Stockton"),
  "84074": p("UT", "Tooele"),
  "84080": p("UT", "Vernon"),
  "84083": p("UT", "Wendover"),
  "84008": p("UT", "Bonanza"),
  "84026": p("UT", "Fort Duchesne"),
  "84035": p("UT", "Jensen"),
  "84039": p("UT", "Lapoint"),
  "84063": p("UT", "Randlett"),
  "84076": p("UT", "Tridell"),
  "84078": p("UT", "Vernal"),
  "84079": p("UT", "Vernal"),
  "84085": p("UT", "Whiterocks"),
  "84003": p("UT", "American Fork"),
  "84004": p("UT", "Alpine"),
  "84005": p("UT", "Eagle Mountain"),
  "84013": p("UT", "Cedar Valley"),
  "84042": p("UT", "Lindon"),
  "84043": p("UT", "Lehi"),
  "84045": p("UT", "Saratoga Springs"),
  "84057": p("UT", "Orem"),
  "84058": p("UT", "Orem"),
  "84059": p("UT", "Orem"),
  "84062": p("UT", "Pleasant Grove"),
  "84097": p("UT", "Orem"),
  "84601": p("UT", "Provo"),
  "84602": p("UT", "Provo"),
  "84603": p("UT", "Provo"),
  "84604": p("UT", "Provo"),
  "84605": p("UT", "Provo"),
  "84606": p("UT", "Provo"),
  "84626": p("UT", "Elberta"),
  "84633": p("UT", "Goshen"),
  "84651": p("UT", "Payson"),
  "84653": p("UT", "Salem"),
  "84655": p("UT", "Santaquin"),
  "84660": p("UT", "Spanish Fork"),
  "84663": p("UT", "Springville"),
  "84664": p("UT", "Mapleton"),
  "84032": p("UT", "Heber City"),
  "84049": p("UT", "Midway"),
  "84082": p("UT", "Wallsburg"),
  "84722": p("UT", "Central"),
  "84725": p("UT", "Enterprise"),
  "84733": p("UT", "Gunlock"),
  "84737": p("UT", "Hurricane"),
  "84738": p("UT", "Ivins"),
  "84745": p("UT", "La Verkin"),
  "84746": p("UT", "Leeds"),
  "84757": p("UT", "New Harmony"),
  "84763": p("UT", "Rockville"),
  "84765": p("UT", "Santa Clara"),
  "84767": p("UT", "Springdale"),
  "84770": p("UT", "Saint George"),
  "84771": p("UT", "Saint George"),
  "84774": p("UT", "Toquerville"),
  "84779": p("UT", "Virgin"),
  "84780": p("UT", "Washington"),
  "84781": p("UT", "Pine Valley"),
  "84782": p("UT", "Veyo"),
  "84783": p("UT", "Dammeron Valley"),
  "84784": p("UT", "Hildale"),
  "84790": p("UT", "Saint George"),
  "84791": p("UT", "Saint George"),
  "84715": p("UT", "Bicknell"),
  "84734": p("UT", "Hanksville"),
  "84747": p("UT", "Loa"),
  "84749": p("UT", "Lyman"),
  "84773": p("UT", "Teasdale"),
  "84775": p("UT", "Torrey"),
  "84067": p("UT", "Roy"),
  "84201": p("UT", "Ogden"),
  "84244": p("UT", "Ogden"),
  "84310": p("UT", "Eden"),
  "84315": p("UT", "Hooper"),
  "84317": p("UT", "Huntsville"),
  "84401": p("UT", "Ogden"),
  "84402": p("UT", "Ogden"),
  "84403": p("UT", "Ogden"),
  "84404": p("UT", "Ogden"),
  "84405": p("UT", "Ogden"),
  "84407": p("UT", "Ogden"),
  "84408": p("UT", "Ogden"),
  "84409": p("UT", "Ogden"),
  "84412": p("UT", "Ogden"),
  "84414": p("UT", "Ogden"),
  "84415": p("UT", "Ogden"),
  "23301": p("VA", "Accomac"),
  "23302": p("VA", "Assawoman"),
  "23303": p("VA", "Atlantic"),
  "23306": p("VA", "Belle Haven"),
  "23308": p("VA", "Bloxom"),
  "23336": p("VA", "Chincoteague Island"),
  "23337": p("VA", "Wallops Island"),
  "23341": p("VA", "Craddockville"),
  "23345": p("VA", "Davis Wharf"),
  "23356": p("VA", "Greenbackville"),
  "23357": p("VA", "Greenbush"),
  "23358": p("VA", "Hacksneck"),
  "23359": p("VA", "Hallwood"),
  "23389": p("VA", "Harborton"),
  "23395": p("VA", "Horntown"),
  "23396": p("VA", "Oak Hall"),
  "23399": p("VA", "Jenkins Bridge"),
  "23401": p("VA", "Keller"),
  "23404": p("VA", "Locustville"),
  "23407": p("VA", "Mappsville"),
  "23409": p("VA", "Mears"),
  "23410": p("VA", "Melfa"),
  "23412": p("VA", "Modest Town"),
  "23414": p("VA", "Nelsonia"),
  "23415": p("VA", "New Church"),
  "23416": p("VA", "Oak Hall"),
  "23417": p("VA", "Onancock"),
  "23418": p("VA", "Onley"),
  "23420": p("VA", "Painter"),
  "23421": p("VA", "Parksley"),
  "23422": p("VA", "Pungoteague"),
  "23423": p("VA", "Quinby"),
  "23426": p("VA", "Sanford"),
  "23427": p("VA", "Saxis"),
  "23440": p("VA", "Tangier"),
  "23441": p("VA", "Tasley"),
  "23442": p("VA", "Temperanceville"),
  "23480": p("VA", "Wachapreague"),
  "23483": p("VA", "Wattsville"),
  "23488": p("VA", "Withams"),
  "22901": p("VA", "Charlottesville"),
  "22909": p("VA", "Charlottesville"),
  "22911": p("VA", "Charlottesville"),
  "22924": p("VA", "Batesville"),
  "22931": p("VA", "Covesville"),
  "22932": p("VA", "Crozet"),
  "22936": p("VA", "Earlysville"),
  "22937": p("VA", "Esmont"),
  "22940": p("VA", "Free Union"),
  "22943": p("VA", "Greenwood"),
  "22945": p("VA", "Ivy"),
  "22946": p("VA", "Keene"),
  "22947": p("VA", "Keswick"),
  "22959": p("VA", "North Garden"),
  "22987": p("VA", "White Hall"),
  "24562": p("VA", "Howardsville"),
  "24590": p("VA", "Scottsville"),
  "24422": p("VA", "Clifton Forge"),
  "24448": p("VA", "Iron Gate"),
  "24457": p("VA", "Low Moor"),
  "24474": p("VA", "Selma"),
  "23002": p("VA", "Amelia Court House"),
  "23083": p("VA", "Jetersville"),
  "23105": p("VA", "Mannboro"),
  "24521": p("VA", "Amherst"),
  "24533": p("VA", "Clifford"),
  "24572": p("VA", "Madison Heights"),
  "24574": p("VA", "Monroe"),
  "24595": p("VA", "Sweet Briar"),
  "23939": p("VA", "Evergreen"),
  "23958": p("VA", "Pamplin"),
  "24522": p("VA", "Appomattox"),
  "24593": p("VA", "Spout Spring"),
  "22201": p("VA", "Arlington"),
  "22202": p("VA", "Arlington"),
  "22203": p("VA", "Arlington"),
  "22204": p("VA", "Arlington"),
  "22205": p("VA", "Arlington"),
  "22206": p("VA", "Arlington"),
  "22207": p("VA", "Arlington"),
  "22209": p("VA", "Arlington"),
  "22210": p("VA", "Arlington"),
  "22211": p("VA", "Fort Myer"),
  "22212": p("VA", "Arlington"),
  "22213": p("VA", "Arlington"),
  "22214": p("VA", "Arlington"),
  "22215": p("VA", "Arlington"),
  "22216": p("VA", "Arlington"),
  "22217": p("VA", "Arlington"),
  "22219": p("VA", "Arlington"),
  "22225": p("VA", "Arlington"),
  "22226": p("VA", "Arlington"),
  "22227": p("VA", "Arlington"),
  "22230": p("VA", "Arlington"),
  "22240": p("VA", "Arlington"),
  "22241": p("VA", "Arlington"),
  "22242": p("VA", "Arlington"),
  "22243": p("VA", "Arlington"),
  "22244": p("VA", "Arlington"),
  "22245": p("VA", "Arlington"),
  "22246": p("VA", "Arlington"),
  "22843": p("VA", "Mount Solon"),
  "22939": p("VA", "Fishersville"),
  "22952": p("VA", "Lyndhurst"),
  "24411": p("VA", "Augusta Springs"),
  "24421": p("VA", "Churchville"),
  "24430": p("VA", "Craigsville"),
  "24431": p("VA", "Crimora"),
  "24432": p("VA", "Deerfield"),
  "24437": p("VA", "Fort Defiance"),
  "24440": p("VA", "Greenville"),
  "24459": p("VA", "Middlebrook"),
  "24463": p("VA", "Mint Spring"),
  "24467": p("VA", "Mount Sidney"),
  "24469": p("VA", "New Hope"),
  "24476": p("VA", "Steeles Tavern"),
  "24477": p("VA", "Stuarts Draft"),
  "24479": p("VA", "Swoope"),
  "24482": p("VA", "Verona"),
  "24485": p("VA", "West Augusta"),
  "24486": p("VA", "Weyers Cave"),
  "24412": p("VA", "Bacova"),
  "24445": p("VA", "Hot Springs"),
  "24460": p("VA", "Millboro"),
  "24484": p("VA", "Warm Springs"),
  "24487": p("VA", "Williamsville"),
  "24095": p("VA", "Goodview"),
  "24101": p("VA", "Hardy"),
  "24104": p("VA", "Huddleston"),
  "24121": p("VA", "Moneta"),
  "24122": p("VA", "Montvale"),
  "24174": p("VA", "Thaxton"),
  "24178": p("VA", "Villamont"),
  "24526": p("VA", "Big Island"),
  "24536": p("VA", "Coleman Falls"),
  "24551": p("VA", "Forest"),
  "24556": p("VA", "Goode"),
  "24570": p("VA", "Lowry"),
  "24314": p("VA", "Bastian"),
  "24315": p("VA", "Bland"),
  "24318": p("VA", "Ceres"),
  "24366": p("VA", "Rocky Gap"),
  "24019": p("VA", "Roanoke"),
  "24050": p("VA", "Roanoke"),
  "24064": p("VA", "Blue Ridge"),
  "24066": p("VA", "Buchanan"),
  "24077": p("VA", "Cloverdale"),
  "24083": p("VA", "Daleville"),
  "24085": p("VA", "Eagle Rock"),
  "24090": p("VA", "Fincastle"),
  "24130": p("VA", "Oriskany"),
  "24175": p("VA", "Troutville"),
  "24438": p("VA", "Glen Wilton"),
  "23821": p("VA", "Alberta"),
  "23843": p("VA", "Dolphin"),
  "23845": p("VA", "Ebony"),
  "23856": p("VA", "Freeman"),
  "23857": p("VA", "Gasburg"),
  "23868": p("VA", "Lawrenceville"),
  "23873": p("VA", "Meredithville"),
  "23876": p("VA", "Rawlings"),
  "23887": p("VA", "Valentines"),
  "23889": p("VA", "Warfield"),
  "23893": p("VA", "White Plains"),
  "23920": p("VA", "Brodnax"),
  "24239": p("VA", "Davenport"),
  "24603": p("VA", "Big Rock"),
  "24614": p("VA", "Grundy"),
  "24620": p("VA", "Hurley"),
  "24624": p("VA", "Keen Mountain"),
  "24627": p("VA", "Mavisdale"),
  "24628": p("VA", "Maxie"),
  "24631": p("VA", "Oakwood"),
  "24634": p("VA", "Pilgrims Knob"),
  "24639": p("VA", "Raven"),
  "24646": p("VA", "Rowe"),
  "24647": p("VA", "Shortt Gap"),
  "24656": p("VA", "Vansant"),
  "24657": p("VA", "Whitewood"),
  "24658": p("VA", "Wolford"),
  "23004": p("VA", "Arvonia"),
  "23123": p("VA", "New Canton"),
  "23921": p("VA", "Buckingham"),
  "23936": p("VA", "Dillwyn"),
  "24513": p("VA", "Lynchburg"),
  "24517": p("VA", "Altavista"),
  "24528": p("VA", "Brookneal"),
  "24538": p("VA", "Concord"),
  "24550": p("VA", "Evington"),
  "24554": p("VA", "Gladys"),
  "24569": p("VA", "Long Island"),
  "24571": p("VA", "Lynch Station"),
  "24576": p("VA", "Naruna"),
  "24588": p("VA", "Rustburg"),
  "22427": p("VA", "Bowling Green"),
  "22428": p("VA", "Bowling Green"),
  "22446": p("VA", "Corbin"),
  "22501": p("VA", "Ladysmith"),
  "22514": p("VA", "Milford"),
  "22535": p("VA", "Port Royal"),
  "22538": p("VA", "Rappahannock Academy"),
  "22546": p("VA", "Ruther Glen"),
  "22552": p("VA", "Sparta"),
  "22580": p("VA", "Woodford"),
  "24317": p("VA", "Cana"),
  "24325": p("VA", "Dugspur"),
  "24328": p("VA", "Fancy Gap"),
  "24343": p("VA", "Hillsville"),
  "24351": p("VA", "Lambsburg"),
  "24352": p("VA", "Laurel Fork"),
  "24381": p("VA", "Woodlawn"),
  "23030": p("VA", "Charles City"),
  "23147": p("VA", "Ruthville"),
  "23923": p("VA", "Charlotte Court House"),
  "23934": p("VA", "Cullen"),
  "23937": p("VA", "Drakes Branch"),
  "23947": p("VA", "Keysville"),
  "23959": p("VA", "Phenix"),
  "23962": p("VA", "Randolph"),
  "23963": p("VA", "Red House"),
  "23964": p("VA", "Red Oak"),
  "23967": p("VA", "Saxe"),
  "23976": p("VA", "Wylliesburg"),
  "23112": p("VA", "Midlothian"),
  "23113": p("VA", "Midlothian"),
  "23114": p("VA", "Midlothian"),
  "23120": p("VA", "Moseley"),
  "23234": p("VA", "Richmond"),
  "23235": p("VA", "Richmond"),
  "23236": p("VA", "Richmond"),
  "23237": p("VA", "Richmond"),
  "23297": p("VA", "Richmond"),
  "23831": p("VA", "Chester"),
  "23832": p("VA", "Chesterfield"),
  "23836": p("VA", "Chester"),
  "23838": p("VA", "Chesterfield"),
  "22611": p("VA", "Berryville"),
  "22620": p("VA", "Boyce"),
  "22646": p("VA", "Millwood"),
  "22663": p("VA", "White Post"),
  "24127": p("VA", "New Castle"),
  "24131": p("VA", "Paint Bank"),
  "22701": p("VA", "Culpeper"),
  "22713": p("VA", "Boston"),
  "22714": p("VA", "Brandy Station"),
  "22718": p("VA", "Elkwood"),
  "22724": p("VA", "Jeffersonton"),
  "22726": p("VA", "Lignum"),
  "22729": p("VA", "Mitchells"),
  "22733": p("VA", "Rapidan"),
  "22735": p("VA", "Reva"),
  "22736": p("VA", "Richardsville"),
  "22737": p("VA", "Rixeyville"),
  "22741": p("VA", "Stevensburg"),
  "23027": p("VA", "Cartersville"),
  "23040": p("VA", "Cumberland"),
  "24217": p("VA", "Bee"),
  "24220": p("VA", "Birchleaf"),
  "24226": p("VA", "Clinchco"),
  "24228": p("VA", "Clintwood"),
  "24256": p("VA", "Haysi"),
  "24269": p("VA", "Mc Clure"),
  "24272": p("VA", "Nora"),
  "24607": p("VA", "Breaks"),
  "23822": p("VA", "Ammon"),
  "23830": p("VA", "Carson"),
  "23833": p("VA", "Church Road"),
  "23840": p("VA", "Dewitt"),
  "23841": p("VA", "Dinwiddie"),
  "23850": p("VA", "Ford"),
  "23872": p("VA", "Mc Kenney"),
  "23885": p("VA", "Sutherland"),
  "23894": p("VA", "Wilsons"),
  "22436": p("VA", "Caret"),
  "22437": p("VA", "Center Cross"),
  "22438": p("VA", "Champlain"),
  "22454": p("VA", "Dunnsville"),
  "22476": p("VA", "Hustle"),
  "22504": p("VA", "Laneview"),
  "22509": p("VA", "Loretto"),
  "22560": p("VA", "Tappahannock"),
  "23115": p("VA", "Millers Tavern"),
  "20120": p("VA", "Centreville"),
  "20121": p("VA", "Centreville"),
  "20122": p("VA", "Centreville"),
  "20124": p("VA", "Clifton"),
  "20151": p("VA", "Chantilly"),
  "20153": p("VA", "Chantilly"),
  "20170": p("VA", "Herndon"),
  "20171": p("VA", "Herndon"),
  "20172": p("VA", "Herndon"),
  "20190": p("VA", "Reston"),
  "20191": p("VA", "Reston"),
  "20192": p("VA", "Herndon"),
  "20194": p("VA", "Reston"),
  "20195": p("VA", "Reston"),
  "20196": p("VA", "Reston"),
  "22003": p("VA", "Annandale"),
  "22009": p("VA", "Burke"),
  "22015": p("VA", "Burke"),
  "22027": p("VA", "Dunn Loring"),
  "22032": p("VA", "Fairfax"),
  "22033": p("VA", "Fairfax"),
  "22034": p("VA", "Fairfax"),
  "22035": p("VA", "Fairfax"),
  "22036": p("VA", "Fairfax"),
  "22037": p("VA", "Fairfax"),
  "22039": p("VA", "Fairfax Station"),
  "22041": p("VA", "Falls Church"),
  "22042": p("VA", "Falls Church"),
  "22043": p("VA", "Falls Church"),
  "22044": p("VA", "Falls Church"),
  "22060": p("VA", "Fort Belvoir"),
  "22066": p("VA", "Great Falls"),
  "22067": p("VA", "Greenway"),
  "22079": p("VA", "Lorton"),
  "22081": p("VA", "Merrifield"),
  "22082": p("VA", "Merrifield"),
  "22095": p("VA", "Herndon"),
  "22096": p("VA", "Reston"),
  "22101": p("VA", "Mc Lean"),
  "22102": p("VA", "Mc Lean"),
  "22103": p("VA", "West Mclean"),
  "22106": p("VA", "Mc Lean"),
  "22107": p("VA", "Mc Lean"),
  "22108": p("VA", "Mc Lean"),
  "22109": p("VA", "Mc Lean"),
  "22116": p("VA", "Merrifield"),
  "22118": p("VA", "Merrifield"),
  "22119": p("VA", "Merrifield"),
  "22121": p("VA", "Mount Vernon"),
  "22122": p("VA", "Newington"),
  "22124": p("VA", "Oakton"),
  "22150": p("VA", "Springfield"),
  "22151": p("VA", "Springfield"),
  "22152": p("VA", "Springfield"),
  "22153": p("VA", "Springfield"),
  "22156": p("VA", "Springfield"),
  "22158": p("VA", "Springfield"),
  "22159": p("VA", "Springfield"),
  "22160": p("VA", "Springfield"),
  "22161": p("VA", "Springfield"),
  "22180": p("VA", "Vienna"),
  "22181": p("VA", "Vienna"),
  "22182": p("VA", "Vienna"),
  "22183": p("VA", "Vienna"),
  "22185": p("VA", "Vienna"),
  "22199": p("VA", "Lorton"),
  "22303": p("VA", "Alexandria"),
  "22306": p("VA", "Alexandria"),
  "22307": p("VA", "Alexandria"),
  "22308": p("VA", "Alexandria"),
  "22309": p("VA", "Alexandria"),
  "22310": p("VA", "Alexandria"),
  "22312": p("VA", "Alexandria"),
  "22315": p("VA", "Alexandria"),
  "20115": p("VA", "Marshall"),
  "20116": p("VA", "Marshall"),
  "20119": p("VA", "Catlett"),
  "20128": p("VA", "Orlean"),
  "20130": p("VA", "Paris"),
  "20137": p("VA", "Broad Run"),
  "20138": p("VA", "Calverton"),
  "20139": p("VA", "Casanova"),
  "20140": p("VA", "Rectortown"),
  "20144": p("VA", "Delaplane"),
  "20184": p("VA", "Upperville"),
  "20185": p("VA", "Upperville"),
  "20186": p("VA", "Warrenton"),
  "20187": p("VA", "Warrenton"),
  "20188": p("VA", "Warrenton"),
  "20198": p("VA", "The Plains"),
  "22639": p("VA", "Hume"),
  "22643": p("VA", "Markham"),
  "22712": p("VA", "Bealeton"),
  "22720": p("VA", "Goldvein"),
  "22728": p("VA", "Midland"),
  "22734": p("VA", "Remington"),
  "22739": p("VA", "Somerville"),
  "22742": p("VA", "Sumerduck"),
  "24072": p("VA", "Check"),
  "24079": p("VA", "Copper Hill"),
  "24091": p("VA", "Floyd"),
  "24105": p("VA", "Indian Valley"),
  "24380": p("VA", "Willis"),
  "22963": p("VA", "Palmyra"),
  "22974": p("VA", "Troy"),
  "23022": p("VA", "Bremo Bluff"),
  "23055": p("VA", "Fork Union"),
  "23084": p("VA", "Kents Store"),
  "24065": p("VA", "Boones Mill"),
  "24067": p("VA", "Callaway"),
  "24088": p("VA", "Ferrum"),
  "24092": p("VA", "Glade Hill"),
  "24102": p("VA", "Henry"),
  "24137": p("VA", "Penhook"),
  "24146": p("VA", "Redwood"),
  "24151": p("VA", "Rocky Mount"),
  "24176": p("VA", "Union Hall"),
  "24184": p("VA", "Wirtz"),
  "22602": p("VA", "Winchester"),
  "22603": p("VA", "Winchester"),
  "22622": p("VA", "Brucetown"),
  "22624": p("VA", "Clear Brook"),
  "22625": p("VA", "Cross Junction"),
  "22637": p("VA", "Gore"),
  "22645": p("VA", "Middletown"),
  "22654": p("VA", "Star Tannery"),
  "22655": p("VA", "Stephens City"),
  "22656": p("VA", "Stephenson"),
  "24086": p("VA", "Eggleston"),
  "24093": p("VA", "Glen Lyn"),
  "24124": p("VA", "Narrows"),
  "24128": p("VA", "Newport"),
  "24134": p("VA", "Pearisburg"),
  "24136": p("VA", "Pembroke"),
  "24147": p("VA", "Rich Creek"),
  "24150": p("VA", "Ripplemead"),
  "24167": p("VA", "Staffordsville"),
  "23001": p("VA", "Achilles"),
  "23003": p("VA", "Ark"),
  "23018": p("VA", "Bena"),
  "23050": p("VA", "Dutton"),
  "23061": p("VA", "Gloucester"),
  "23062": p("VA", "Gloucester Point"),
  "23072": p("VA", "Hayes"),
  "23107": p("VA", "Maryus"),
  "23131": p("VA", "Ordinary"),
  "23154": p("VA", "Schley"),
  "23155": p("VA", "Severn"),
  "23178": p("VA", "Ware Neck"),
  "23183": p("VA", "White Marsh"),
  "23184": p("VA", "Wicomico"),
  "23190": p("VA", "Woods Cross Roads"),
  "23014": p("VA", "Beaumont"),
  "23038": p("VA", "Columbia"),
  "23039": p("VA", "Crozier"),
  "23063": p("VA", "Goochland"),
  "23065": p("VA", "Gum Spring"),
  "23067": p("VA", "Hadensville"),
  "23102": p("VA", "Maidens"),
  "23103": p("VA", "Manakin Sabot"),
  "23129": p("VA", "Oilville"),
  "23153": p("VA", "Sandy Hook"),
  "23160": p("VA", "State Farm"),
  "24292": p("VA", "Whitetop"),
  "24326": p("VA", "Elk Creek"),
  "24330": p("VA", "Fries"),
  "24348": p("VA", "Independence"),
  "24363": p("VA", "Mouth Of Wilson"),
  "24378": p("VA", "Troutdale"),
  "22935": p("VA", "Dyke"),
  "22965": p("VA", "Quinque"),
  "22968": p("VA", "Ruckersville"),
  "22973": p("VA", "Stanardsville"),
  "23870": p("VA", "Jarratt"),
  "23879": p("VA", "Skippers"),
  "24520": p("VA", "Alton"),
  "24534": p("VA", "Clover"),
  "24535": p("VA", "Cluster Springs"),
  "24539": p("VA", "Crystal Hill"),
  "24558": p("VA", "Halifax"),
  "24577": p("VA", "Nathalie"),
  "24589": p("VA", "Scottsburg"),
  "24592": p("VA", "South Boston"),
  "24597": p("VA", "Vernon Hill"),
  "24598": p("VA", "Virgilina"),
  "23005": p("VA", "Ashland"),
  "23015": p("VA", "Beaverdam"),
  "23047": p("VA", "Doswell"),
  "23059": p("VA", "Glen Allen"),
  "23069": p("VA", "Hanover"),
  "23111": p("VA", "Mechanicsville"),
  "23116": p("VA", "Mechanicsville"),
  "23146": p("VA", "Rockville"),
  "23162": p("VA", "Studley"),
  "23192": p("VA", "Montpelier"),
  "23058": p("VA", "Glen Allen"),
  "23060": p("VA", "Glen Allen"),
  "23075": p("VA", "Henrico"),
  "23150": p("VA", "Sandston"),
  "23226": p("VA", "Richmond"),
  "23227": p("VA", "Richmond"),
  "23228": p("VA", "Henrico"),
  "23229": p("VA", "Henrico"),
  "23230": p("VA", "Richmond"),
  "23231": p("VA", "Henrico"),
  "23233": p("VA", "Henrico"),
  "23238": p("VA", "Henrico"),
  "23242": p("VA", "Henrico"),
  "23250": p("VA", "Richmond"),
  "23255": p("VA", "Henrico"),
  "23288": p("VA", "Henrico"),
  "23289": p("VA", "Richmond"),
  "23294": p("VA", "Henrico"),
  "24054": p("VA", "Axton"),
  "24055": p("VA", "Bassett"),
  "24078": p("VA", "Collinsville"),
  "24089": p("VA", "Fieldale"),
  "24148": p("VA", "Ridgeway"),
  "24165": p("VA", "Spencer"),
  "24168": p("VA", "Stanleytown"),
  "24413": p("VA", "Blue Grass"),
  "24433": p("VA", "Doe Hill"),
  "24442": p("VA", "Head Waters"),
  "24458": p("VA", "Mc Dowell"),
  "24465": p("VA", "Monterey"),
  "24468": p("VA", "Mustoe"),
  "23304": p("VA", "Battery Park"),
  "23314": p("VA", "Carrollton"),
  "23315": p("VA", "Carrsville"),
  "23397": p("VA", "Isle Of Wight"),
  "23424": p("VA", "Rescue"),
  "23430": p("VA", "Smithfield"),
  "23431": p("VA", "Smithfield"),
  "23487": p("VA", "Windsor"),
  "23898": p("VA", "Zuni"),
  "23081": p("VA", "Jamestown"),
  "23127": p("VA", "Norge"),
  "23168": p("VA", "Toano"),
  "23185": p("VA", "Williamsburg"),
  "23188": p("VA", "Williamsburg"),
  "23023": p("VA", "Bruington"),
  "23085": p("VA", "King And Queen Court House"),
  "23091": p("VA", "Little Plymouth"),
  "23108": p("VA", "Mascot"),
  "23110": p("VA", "Mattaponi"),
  "23126": p("VA", "Newtown"),
  "23148": p("VA", "Saint Stephens Church"),
  "23156": p("VA", "Shacklefords"),
  "23161": p("VA", "Stevensville"),
  "23177": p("VA", "Walkerton"),
  "22448": p("VA", "Dahlgren"),
  "22451": p("VA", "Dogue"),
  "22481": p("VA", "Jersey"),
  "22485": p("VA", "King George"),
  "22526": p("VA", "Ninde"),
  "22544": p("VA", "Rollins Fork"),
  "22547": p("VA", "Sealston"),
  "23009": p("VA", "Aylett"),
  "23086": p("VA", "King William"),
  "23106": p("VA", "Manquin"),
  "23181": p("VA", "West Point"),
  "22480": p("VA", "Irvington"),
  "22482": p("VA", "Kilmarnock"),
  "22503": p("VA", "Lancaster"),
  "22507": p("VA", "Lively"),
  "22513": p("VA", "Merry Point"),
  "22517": p("VA", "Mollusk"),
  "22523": p("VA", "Morattico"),
  "22528": p("VA", "Nuttsville"),
  "22576": p("VA", "Weems"),
  "22578": p("VA", "White Stone"),
  "24218": p("VA", "Ben Hur"),
  "24221": p("VA", "Blackwater"),
  "24243": p("VA", "Dryden"),
  "24248": p("VA", "Ewing"),
  "24263": p("VA", "Jonesville"),
  "24265": p("VA", "Keokee"),
  "24277": p("VA", "Pennington Gap"),
  "24281": p("VA", "Rose Hill"),
  "24282": p("VA", "Saint Charles"),
  "20101": p("VA", "Dulles"),
  "20102": p("VA", "Dulles"),
  "20103": p("VA", "Dulles"),
  "20104": p("VA", "Dulles"),
  "20105": p("VA", "Aldie"),
  "20117": p("VA", "Middleburg"),
  "20118": p("VA", "Middleburg"),
  "20129": p("VA", "Paeonian Springs"),
  "20131": p("VA", "Philomont"),
  "20132": p("VA", "Purcellville"),
  "20134": p("VA", "Purcellville"),
  "20135": p("VA", "Bluemont"),
  "20141": p("VA", "Round Hill"),
  "20142": p("VA", "Round Hill"),
  "20146": p("VA", "Ashburn"),
  "20147": p("VA", "Ashburn"),
  "20148": p("VA", "Ashburn"),
  "20149": p("VA", "Ashburn"),
  "20152": p("VA", "Chantilly"),
  "20158": p("VA", "Hamilton"),
  "20159": p("VA", "Hamilton"),
  "20160": p("VA", "Lincoln"),
  "20163": p("VA", "Sterling"),
  "20164": p("VA", "Sterling"),
  "20165": p("VA", "Sterling"),
  "20166": p("VA", "Sterling"),
  "20167": p("VA", "Sterling"),
  "20175": p("VA", "Leesburg"),
  "20176": p("VA", "Leesburg"),
  "20177": p("VA", "Leesburg"),
  "20178": p("VA", "Leesburg"),
  "20180": p("VA", "Lovettsville"),
  "20189": p("VA", "Dulles"),
  "20197": p("VA", "Waterford"),
  "20598": p("VA", "Dhs"),
  "23024": p("VA", "Bumpass"),
  "23093": p("VA", "Louisa"),
  "23117": p("VA", "Mineral"),
  "23170": p("VA", "Trevilians"),
  "23938": p("VA", "Dundas"),
  "23941": p("VA", "Fort Mitchell"),
  "23944": p("VA", "Kenbridge"),
  "23952": p("VA", "Lunenburg"),
  "23974": p("VA", "Victoria"),
  "22709": p("VA", "Aroda"),
  "22711": p("VA", "Banco"),
  "22715": p("VA", "Brightwood"),
  "22719": p("VA", "Etlan"),
  "22722": p("VA", "Haywood"),
  "22723": p("VA", "Hood"),
  "22725": p("VA", "Leon"),
  "22727": p("VA", "Madison"),
  "22730": p("VA", "Oakpark"),
  "22731": p("VA", "Pratts"),
  "22732": p("VA", "Radiant"),
  "22738": p("VA", "Rochelle"),
  "22743": p("VA", "Syria"),
  "22748": p("VA", "Wolftown"),
  "22948": p("VA", "Locust Dale"),
  "22989": p("VA", "Woodberry Forest"),
  "23021": p("VA", "Bohannon"),
  "23025": p("VA", "Cardinal"),
  "23035": p("VA", "Cobbs Creek"),
  "23045": p("VA", "Diggs"),
  "23056": p("VA", "Foster"),
  "23064": p("VA", "Grimstead"),
  "23066": p("VA", "Gwynn"),
  "23068": p("VA", "Hallieford"),
  "23076": p("VA", "Hudgins"),
  "23109": p("VA", "Mathews"),
  "23119": p("VA", "Moon"),
  "23125": p("VA", "New Point"),
  "23128": p("VA", "North"),
  "23130": p("VA", "Onemo"),
  "23138": p("VA", "Port Haywood"),
  "23163": p("VA", "Susan"),
  "23915": p("VA", "Baskerville"),
  "23917": p("VA", "Boydton"),
  "23919": p("VA", "Bracey"),
  "23924": p("VA", "Chase City"),
  "23927": p("VA", "Clarksville"),
  "23950": p("VA", "La Crosse"),
  "23968": p("VA", "Skipwith"),
  "23970": p("VA", "South Hill"),
  "24529": p("VA", "Buffalo Junction"),
  "24580": p("VA", "Nelson"),
  "23031": p("VA", "Christchurch"),
  "23032": p("VA", "Church View"),
  "23043": p("VA", "Deltaville"),
  "23070": p("VA", "Hardyville"),
  "23071": p("VA", "Hartfield"),
  "23079": p("VA", "Jamaica"),
  "23092": p("VA", "Locust Hill"),
  "23149": p("VA", "Saluda"),
  "23169": p("VA", "Topping"),
  "23175": p("VA", "Urbanna"),
  "23176": p("VA", "Wake"),
  "23180": p("VA", "Water View"),
  "24023": p("VA", "Roanoke"),
  "24060": p("VA", "Blacksburg"),
  "24061": p("VA", "Blacksburg"),
  "24062": p("VA", "Blacksburg"),
  "24063": p("VA", "Blacksburg"),
  "24068": p("VA", "Christiansburg"),
  "24073": p("VA", "Christiansburg"),
  "24111": p("VA", "Mc Coy"),
  "24138": p("VA", "Pilot"),
  "24149": p("VA", "Riner"),
  "24162": p("VA", "Shawsville"),
  "22920": p("VA", "Afton"),
  "22922": p("VA", "Arrington"),
  "22938": p("VA", "Faber"),
  "22949": p("VA", "Lovingston"),
  "22958": p("VA", "Nellysford"),
  "22964": p("VA", "Piney River"),
  "22967": p("VA", "Roseland"),
  "22969": p("VA", "Schuyler"),
  "22971": p("VA", "Shipman"),
  "22976": p("VA", "Tyro"),
  "24464": p("VA", "Montebello"),
  "24553": p("VA", "Gladstone"),
  "24581": p("VA", "Norwood"),
  "24599": p("VA", "Wingina"),
  "23011": p("VA", "Barhamsville"),
  "23089": p("VA", "Lanexa"),
  "23124": p("VA", "New Kent"),
  "23140": p("VA", "Providence Forge"),
  "23141": p("VA", "Quinton"),
  "23307": p("VA", "Birdsnest"),
  "23310": p("VA", "Cape Charles"),
  "23313": p("VA", "Capeville"),
  "23316": p("VA", "Cheriton"),
  "23347": p("VA", "Eastville"),
  "23350": p("VA", "Exmore"),
  "23354": p("VA", "Franktown"),
  "23398": p("VA", "Jamesville"),
  "23405": p("VA", "Machipongo"),
  "23408": p("VA", "Marionville"),
  "23413": p("VA", "Nassawadox"),
  "23419": p("VA", "Oyster"),
  "23429": p("VA", "Seaview"),
  "23443": p("VA", "Townsend"),
  "23482": p("VA", "Wardtown"),
  "23486": p("VA", "Willis Wharf"),
  "22432": p("VA", "Burgess"),
  "22435": p("VA", "Callao"),
  "22456": p("VA", "Edwardsville"),
  "22473": p("VA", "Heathsville"),
  "22511": p("VA", "Lottsburg"),
  "22530": p("VA", "Ophelia"),
  "22539": p("VA", "Reedville"),
  "22579": p("VA", "Wicomico Church"),
  "23824": p("VA", "Blackstone"),
  "23922": p("VA", "Burkeville"),
  "23930": p("VA", "Crewe"),
  "23955": p("VA", "Nottoway"),
  "22433": p("VA", "Burr Hill"),
  "22508": p("VA", "Locust Grove"),
  "22542": p("VA", "Rhoadesville"),
  "22567": p("VA", "Unionville"),
  "22923": p("VA", "Barboursville"),
  "22942": p("VA", "Gordonsville"),
  "22957": p("VA", "Montpelier Station"),
  "22960": p("VA", "Orange"),
  "22972": p("VA", "Somerset"),
  "22650": p("VA", "Rileyville"),
  "22835": p("VA", "Luray"),
  "22849": p("VA", "Shenandoah"),
  "22851": p("VA", "Stanley"),
  "24053": p("VA", "Ararat"),
  "24076": p("VA", "Claudville"),
  "24082": p("VA", "Critz"),
  "24120": p("VA", "Meadows Of Dan"),
  "24133": p("VA", "Patrick Springs"),
  "24171": p("VA", "Stuart"),
  "24177": p("VA", "Vesta"),
  "24185": p("VA", "Woolwine"),
  "24069": p("VA", "Cascade"),
  "24139": p("VA", "Pittsville"),
  "24161": p("VA", "Sandy Level"),
  "24527": p("VA", "Blairs"),
  "24530": p("VA", "Callands"),
  "24531": p("VA", "Chatham"),
  "24549": p("VA", "Dry Fork"),
  "24557": p("VA", "Gretna"),
  "24563": p("VA", "Hurt"),
  "24565": p("VA", "Java"),
  "24566": p("VA", "Keeling"),
  "24586": p("VA", "Ringgold"),
  "24594": p("VA", "Sutherlin"),
  "23139": p("VA", "Powhatan"),
  "23901": p("VA", "Farmville"),
  "23909": p("VA", "Farmville"),
  "23942": p("VA", "Green Bay"),
  "23943": p("VA", "Hampden Sydney"),
  "23954": p("VA", "Meherrin"),
  "23960": p("VA", "Prospect"),
  "23966": p("VA", "Rice"),
  "23801": p("VA", "Fort Lee"),
  "23842": p("VA", "Disputanta"),
  "23875": p("VA", "Prince George"),
  "20136": p("VA", "Bristow"),
  "20143": p("VA", "Catharpin"),
  "20155": p("VA", "Gainesville"),
  "20156": p("VA", "Gainesville"),
  "20168": p("VA", "Haymarket"),
  "20169": p("VA", "Haymarket"),
  "20181": p("VA", "Nokesville"),
  "20182": p("VA", "Nokesville"),
  "22025": p("VA", "Dumfries"),
  "22026": p("VA", "Dumfries"),
  "22125": p("VA", "Occoquan"),
  "22134": p("VA", "Quantico"),
  "22135": p("VA", "Quantico"),
  "22172": p("VA", "Triangle"),
  "22191": p("VA", "Woodbridge"),
  "22192": p("VA", "Woodbridge"),
  "22193": p("VA", "Woodbridge"),
  "22194": p("VA", "Woodbridge"),
  "22195": p("VA", "Woodbridge"),
  "24058": p("VA", "Belspring"),
  "24084": p("VA", "Dublin"),
  "24126": p("VA", "Newbern"),
  "24129": p("VA", "New River"),
  "24132": p("VA", "Parrott"),
  "24301": p("VA", "Pulaski"),
  "24324": p("VA", "Draper"),
  "24347": p("VA", "Hiwassee"),
  "20106": p("VA", "Amissville"),
  "22623": p("VA", "Chester Gap"),
  "22627": p("VA", "Flint Hill"),
  "22640": p("VA", "Huntly"),
  "22716": p("VA", "Castleton"),
  "22740": p("VA", "Sperryville"),
  "22746": p("VA", "Viewtown"),
  "22747": p("VA", "Washington"),
  "22749": p("VA", "Woodville"),
  "22460": p("VA", "Farnham"),
  "22472": p("VA", "Haynesville"),
  "22548": p("VA", "Sharps"),
  "22570": p("VA", "Village"),
  "22572": p("VA", "Warsaw"),
  "24018": p("VA", "Roanoke"),
  "24020": p("VA", "Roanoke"),
  "24059": p("VA", "Bent Mountain"),
  "24070": p("VA", "Catawba"),
  "24087": p("VA", "Elliston"),
  "24179": p("VA", "Vinton"),
  "24415": p("VA", "Brownsburg"),
  "24435": p("VA", "Fairfield"),
  "24439": p("VA", "Goshen"),
  "24472": p("VA", "Raphine"),
  "24473": p("VA", "Rockbridge Baths"),
  "24483": p("VA", "Vesuvius"),
  "24555": p("VA", "Glasgow"),
  "24578": p("VA", "Natural Bridge"),
  "24579": p("VA", "Natural Bridge Station"),
  "22802": p("VA", "Harrisonburg"),
  "22811": p("VA", "Bergton"),
  "22812": p("VA", "Bridgewater"),
  "22815": p("VA", "Broadway"),
  "22820": p("VA", "Criders"),
  "22821": p("VA", "Dayton"),
  "22827": p("VA", "Elkton"),
  "22830": p("VA", "Fulks Run"),
  "22831": p("VA", "Hinton"),
  "22832": p("VA", "Keezletown"),
  "22833": p("VA", "Lacey Spring"),
  "22834": p("VA", "Linville"),
  "22840": p("VA", "Mc Gaheysville"),
  "22841": p("VA", "Mount Crawford"),
  "22846": p("VA", "Penn Laird"),
  "22848": p("VA", "Pleasant Valley"),
  "22850": p("VA", "Singers Glen"),
  "22853": p("VA", "Timberville"),
  "24441": p("VA", "Grottoes"),
  "24471": p("VA", "Port Republic"),
  "24224": p("VA", "Castlewood"),
  "24225": p("VA", "Cleveland"),
  "24237": p("VA", "Dante"),
  "24260": p("VA", "Honaker"),
  "24266": p("VA", "Lebanon"),
  "24280": p("VA", "Rosedale"),
  "24649": p("VA", "Swords Creek"),
  "24244": p("VA", "Duffield"),
  "24245": p("VA", "Dungannon"),
  "24250": p("VA", "Fort Blackmore"),
  "24251": p("VA", "Gate City"),
  "24258": p("VA", "Hiltons"),
  "24271": p("VA", "Nickelsville"),
  "24290": p("VA", "Weber City"),
  "22626": p("VA", "Fishers Hill"),
  "22641": p("VA", "Strasburg"),
  "22644": p("VA", "Maurertown"),
  "22652": p("VA", "Fort Valley"),
  "22657": p("VA", "Strasburg"),
  "22660": p("VA", "Toms Brook"),
  "22664": p("VA", "Woodstock"),
  "22810": p("VA", "Basye"),
  "22824": p("VA", "Edinburg"),
  "22842": p("VA", "Mount Jackson"),
  "22844": p("VA", "New Market"),
  "22845": p("VA", "Orkney Springs"),
  "22847": p("VA", "Quicksburg"),
  "24311": p("VA", "Atkins"),
  "24316": p("VA", "Broadford"),
  "24319": p("VA", "Chilhowie"),
  "24354": p("VA", "Marion"),
  "24370": p("VA", "Saltville"),
  "24375": p("VA", "Sugar Grove"),
  "23827": p("VA", "Boykins"),
  "23828": p("VA", "Branchville"),
  "23829": p("VA", "Capron"),
  "23837": p("VA", "Courtland"),
  "23844": p("VA", "Drewryville"),
  "23866": p("VA", "Ivor"),
  "23874": p("VA", "Newsoms"),
  "23878": p("VA", "Sedley"),
  "22407": p("VA", "Fredericksburg"),
  "22408": p("VA", "Fredericksburg"),
  "22412": p("VA", "Fredericksburg"),
  "22534": p("VA", "Partlow"),
  "22551": p("VA", "Spotsylvania"),
  "22553": p("VA", "Spotsylvania"),
  "22565": p("VA", "Thornburg"),
  "22403": p("VA", "Fredericksburg"),
  "22405": p("VA", "Fredericksburg"),
  "22406": p("VA", "Fredericksburg"),
  "22430": p("VA", "Brooke"),
  "22463": p("VA", "Garrisonville"),
  "22471": p("VA", "Hartwood"),
  "22545": p("VA", "Ruby"),
  "22554": p("VA", "Stafford"),
  "22555": p("VA", "Stafford"),
  "22556": p("VA", "Stafford"),
  "23839": p("VA", "Dendron"),
  "23846": p("VA", "Elberon"),
  "23881": p("VA", "Spring Grove"),
  "23883": p("VA", "Surry"),
  "23899": p("VA", "Claremont"),
  "23867": p("VA", "Jarratt"),
  "23882": p("VA", "Stony Creek"),
  "23884": p("VA", "Sussex"),
  "23888": p("VA", "Wakefield"),
  "23890": p("VA", "Waverly"),
  "23891": p("VA", "Waverly"),
  "23897": p("VA", "Yale"),
  "24377": p("VA", "Tannersville"),
  "24601": p("VA", "Amonate"),
  "24602": p("VA", "Bandy"),
  "24604": p("VA", "Bishop"),
  "24605": p("VA", "Bluefield"),
  "24606": p("VA", "Boissevain"),
  "24608": p("VA", "Burkes Garden"),
  "24609": p("VA", "Cedar Bluff"),
  "24612": p("VA", "Doran"),
  "24613": p("VA", "Falls Mills"),
  "24619": p("VA", "Horsepen"),
  "24622": p("VA", "Jewell Ridge"),
  "24630": p("VA", "North Tazewell"),
  "24635": p("VA", "Pocahontas"),
  "24637": p("VA", "Pounding Mill"),
  "24640": p("VA", "Red Ash"),
  "24641": p("VA", "Richlands"),
  "24651": p("VA", "Tazewell"),
  "22610": p("VA", "Bentonville"),
  "22630": p("VA", "Front Royal"),
  "22642": p("VA", "Linden"),
  "22649": p("VA", "Middletown"),
  "24210": p("VA", "Abingdon"),
  "24211": p("VA", "Abingdon"),
  "24212": p("VA", "Abingdon"),
  "24236": p("VA", "Damascus"),
  "24270": p("VA", "Mendota"),
  "24327": p("VA", "Emory"),
  "24340": p("VA", "Glade Spring"),
  "24361": p("VA", "Meadowview"),
  "22442": p("VA", "Coles Point"),
  "22443": p("VA", "Colonial Beach"),
  "22469": p("VA", "Hague"),
  "22488": p("VA", "Kinsale"),
  "22520": p("VA", "Montross"),
  "22524": p("VA", "Mount Holly"),
  "22529": p("VA", "Oldhams"),
  "22558": p("VA", "Stratford"),
  "22577": p("VA", "Sandy Point"),
  "22581": p("VA", "Zacata"),
  "24215": p("VA", "Andover"),
  "24216": p("VA", "Appalachia"),
  "24219": p("VA", "Big Stone Gap"),
  "24230": p("VA", "Coeburn"),
  "24246": p("VA", "East Stone Gap"),
  "24279": p("VA", "Pound"),
  "24283": p("VA", "Saint Paul"),
  "24293": p("VA", "Wise"),
  "24312": p("VA", "Austinville"),
  "24313": p("VA", "Barren Springs"),
  "24322": p("VA", "Cripple Creek"),
  "24323": p("VA", "Crockett"),
  "24350": p("VA", "Ivanhoe"),
  "24360": p("VA", "Max Meadows"),
  "24368": p("VA", "Rural Retreat"),
  "24374": p("VA", "Speedwell"),
  "24382": p("VA", "Wytheville"),
  "23090": p("VA", "Lightfoot"),
  "23690": p("VA", "Yorktown"),
  "23691": p("VA", "Yorktown"),
  "23692": p("VA", "Yorktown"),
  "23693": p("VA", "Yorktown"),
  "23694": p("VA", "Lackey"),
  "23696": p("VA", "Seaford"),
  "22301": p("VA", "Alexandria"),
  "22302": p("VA", "Alexandria"),
  "22304": p("VA", "Alexandria"),
  "22305": p("VA", "Alexandria"),
  "22311": p("VA", "Alexandria"),
  "22313": p("VA", "Alexandria"),
  "22314": p("VA", "Alexandria"),
  "22320": p("VA", "Alexandria"),
  "22331": p("VA", "Alexandria"),
  "22332": p("VA", "Alexandria"),
  "22333": p("VA", "Alexandria"),
  "22334": p("VA", "Alexandria"),
  "22350": p("VA", "Alexandria"),
  "24523": p("VA", "Bedford"),
  "24201": p("VA", "Bristol"),
  "24202": p("VA", "Bristol"),
  "24203": p("VA", "Bristol"),
  "24205": p("VA", "Bristol"),
  "24209": p("VA", "Bristol"),
  "24416": p("VA", "Buena Vista"),
  "22902": p("VA", "Charlottesville"),
  "22903": p("VA", "Charlottesville"),
  "22904": p("VA", "Charlottesville"),
  "22905": p("VA", "Charlottesville"),
  "22906": p("VA", "Charlottesville"),
  "22907": p("VA", "Charlottesville"),
  "22908": p("VA", "Charlottesville"),
  "22910": p("VA", "Charlottesville"),
  "23320": p("VA", "Chesapeake"),
  "23321": p("VA", "Chesapeake"),
  "23322": p("VA", "Chesapeake"),
  "23323": p("VA", "Chesapeake"),
  "23324": p("VA", "Chesapeake"),
  "23325": p("VA", "Chesapeake"),
  "23326": p("VA", "Chesapeake"),
  "23327": p("VA", "Chesapeake"),
  "23328": p("VA", "Chesapeake"),
  "23834": p("VA", "Colonial Heights"),
  "24426": p("VA", "Covington"),
  "24540": p("VA", "Danville"),
  "24541": p("VA", "Danville"),
  "24543": p("VA", "Danville"),
  "23847": p("VA", "Emporia"),
  "22030": p("VA", "Fairfax"),
  "22031": p("VA", "Fairfax"),
  "22038": p("VA", "Fairfax"),
  "22040": p("VA", "Falls Church"),
  "22046": p("VA", "Falls Church"),
  "23851": p("VA", "Franklin"),
  "22401": p("VA", "Fredericksburg"),
  "22402": p("VA", "Fredericksburg"),
  "22404": p("VA", "Fredericksburg"),
  "24333": p("VA", "Galax"),
  "23630": p("VA", "Hampton"),
  "23651": p("VA", "Fort Monroe"),
  "23661": p("VA", "Hampton"),
  "23663": p("VA", "Hampton"),
  "23664": p("VA", "Hampton"),
  "23665": p("VA", "Hampton"),
  "23666": p("VA", "Hampton"),
  "23667": p("VA", "Hampton"),
  "23668": p("VA", "Hampton"),
  "23669": p("VA", "Hampton"),
  "23670": p("VA", "Hampton"),
  "23681": p("VA", "Hampton"),
  "22801": p("VA", "Harrisonburg"),
  "22803": p("VA", "Harrisonburg"),
  "22807": p("VA", "Harrisonburg"),
  "23860": p("VA", "Hopewell"),
  "24450": p("VA", "Lexington"),
  "24501": p("VA", "Lynchburg"),
  "24502": p("VA", "Lynchburg"),
  "24503": p("VA", "Lynchburg"),
  "24504": p("VA", "Lynchburg"),
  "24505": p("VA", "Lynchburg"),
  "24506": p("VA", "Lynchburg"),
  "24514": p("VA", "Lynchburg"),
  "24515": p("VA", "Lynchburg"),
  "20108": p("VA", "Manassas"),
  "20109": p("VA", "Manassas"),
  "20110": p("VA", "Manassas"),
  "20111": p("VA", "Manassas"),
  "20112": p("VA", "Manassas"),
  "20113": p("VA", "Manassas"),
  "24112": p("VA", "Martinsville"),
  "24113": p("VA", "Martinsville"),
  "24114": p("VA", "Martinsville"),
  "24115": p("VA", "Martinsville"),
  "23601": p("VA", "Newport News"),
  "23602": p("VA", "Newport News"),
  "23603": p("VA", "Newport News"),
  "23604": p("VA", "Fort Eustis"),
  "23605": p("VA", "Newport News"),
  "23606": p("VA", "Newport News"),
  "23607": p("VA", "Newport News"),
  "23608": p("VA", "Newport News"),
  "23609": p("VA", "Newport News"),
  "23612": p("VA", "Newport News"),
  "23628": p("VA", "Newport News"),
  "23501": p("VA", "Norfolk"),
  "23502": p("VA", "Norfolk"),
  "23503": p("VA", "Norfolk"),
  "23504": p("VA", "Norfolk"),
  "23505": p("VA", "Norfolk"),
  "23506": p("VA", "Norfolk"),
  "23507": p("VA", "Norfolk"),
  "23508": p("VA", "Norfolk"),
  "23509": p("VA", "Norfolk"),
  "23510": p("VA", "Norfolk"),
  "23511": p("VA", "Norfolk"),
  "23513": p("VA", "Norfolk"),
  "23514": p("VA", "Norfolk"),
  "23515": p("VA", "Norfolk"),
  "23517": p("VA", "Norfolk"),
  "23518": p("VA", "Norfolk"),
  "23519": p("VA", "Norfolk"),
  "23523": p("VA", "Norfolk"),
  "23529": p("VA", "Norfolk"),
  "23541": p("VA", "Norfolk"),
  "23551": p("VA", "Norfolk"),
  "24273": p("VA", "Norton"),
  "23803": p("VA", "Petersburg"),
  "23804": p("VA", "Petersburg"),
  "23805": p("VA", "Petersburg"),
  "23806": p("VA", "Virginia State University"),
  "23662": p("VA", "Poquoson"),
  "23701": p("VA", "Portsmouth"),
  "23702": p("VA", "Portsmouth"),
  "23703": p("VA", "Portsmouth"),
  "23704": p("VA", "Portsmouth"),
  "23705": p("VA", "Portsmouth"),
  "23707": p("VA", "Portsmouth"),
  "23708": p("VA", "Portsmouth"),
  "23709": p("VA", "Portsmouth"),
  "24141": p("VA", "Radford"),
  "24142": p("VA", "Radford"),
  "24143": p("VA", "Radford"),
  "23173": p("VA", "Richmond"),
  "23218": p("VA", "Richmond"),
  "23219": p("VA", "Richmond"),
  "23220": p("VA", "Richmond"),
  "23221": p("VA", "Richmond"),
  "23222": p("VA", "Richmond"),
  "23223": p("VA", "Richmond"),
  "23224": p("VA", "Richmond"),
  "23225": p("VA", "Richmond"),
  "23232": p("VA", "Richmond"),
  "23241": p("VA", "Richmond"),
  "23249": p("VA", "Richmond"),
  "23260": p("VA", "Richmond"),
  "23261": p("VA", "Richmond"),
  "23269": p("VA", "Richmond"),
  "23273": p("VA", "Henrico"),
  "23274": p("VA", "Richmond"),
  "23276": p("VA", "Richmond"),
  "23278": p("VA", "Richmond"),
  "23279": p("VA", "Richmond"),
  "23282": p("VA", "Richmond"),
  "23284": p("VA", "Richmond"),
  "23285": p("VA", "Richmond"),
  "23286": p("VA", "Richmond"),
  "23290": p("VA", "Richmond"),
  "23291": p("VA", "Richmond"),
  "23292": p("VA", "Richmond"),
  "23293": p("VA", "Richmond"),
  "23295": p("VA", "Richmond"),
  "23298": p("VA", "Richmond"),
  "24001": p("VA", "Roanoke"),
  "24002": p("VA", "Roanoke"),
  "24003": p("VA", "Roanoke"),
  "24004": p("VA", "Roanoke"),
  "24005": p("VA", "Roanoke"),
  "24006": p("VA", "Roanoke"),
  "24007": p("VA", "Roanoke"),
  "24008": p("VA", "Roanoke"),
  "24009": p("VA", "Roanoke"),
  "24010": p("VA", "Roanoke"),
  "24011": p("VA", "Roanoke"),
  "24012": p("VA", "Roanoke"),
  "24013": p("VA", "Roanoke"),
  "24014": p("VA", "Roanoke"),
  "24015": p("VA", "Roanoke"),
  "24016": p("VA", "Roanoke"),
  "24017": p("VA", "Roanoke"),
  "24022": p("VA", "Roanoke"),
  "24024": p("VA", "Roanoke"),
  "24025": p("VA", "Roanoke"),
  "24026": p("VA", "Roanoke"),
  "24027": p("VA", "Roanoke"),
  "24028": p("VA", "Roanoke"),
  "24029": p("VA", "Roanoke"),
  "24030": p("VA", "Roanoke"),
  "24031": p("VA", "Roanoke"),
  "24032": p("VA", "Roanoke"),
  "24033": p("VA", "Roanoke"),
  "24034": p("VA", "Roanoke"),
  "24035": p("VA", "Roanoke"),
  "24036": p("VA", "Roanoke"),
  "24037": p("VA", "Roanoke"),
  "24038": p("VA", "Roanoke"),
  "24040": p("VA", "Roanoke"),
  "24042": p("VA", "Roanoke"),
  "24043": p("VA", "Roanoke"),
  "24153": p("VA", "Salem"),
  "24155": p("VA", "Salem"),
  "24157": p("VA", "Salem"),
  "24401": p("VA", "Staunton"),
  "24402": p("VA", "Staunton"),
  "23432": p("VA", "Suffolk"),
  "23433": p("VA", "Suffolk"),
  "23434": p("VA", "Suffolk"),
  "23435": p("VA", "Suffolk"),
  "23436": p("VA", "Suffolk"),
  "23437": p("VA", "Suffolk"),
  "23438": p("VA", "Suffolk"),
  "23439": p("VA", "Suffolk"),
  "23453": p("VA", "Virginia Beach"),
  "23450": p("VA", "Virginia Beach"),
  "23451": p("VA", "Virginia Beach"),
  "23452": p("VA", "Virginia Beach"),
  "23454": p("VA", "Virginia Beach"),
  "23455": p("VA", "Virginia Beach"),
  "23456": p("VA", "Virginia Beach"),
  "23457": p("VA", "Virginia Beach"),
  "23458": p("VA", "Virginia Beach"),
  "23459": p("VA", "Virginia Beach"),
  "23460": p("VA", "Virginia Beach"),
  "23461": p("VA", "Virginia Beach"),
  "23462": p("VA", "Virginia Beach"),
  "23463": p("VA", "Virginia Beach"),
  "23464": p("VA", "Virginia Beach"),
  "23465": p("VA", "Virginia Beach"),
  "23466": p("VA", "Virginia Beach"),
  "23467": p("VA", "Virginia Beach"),
  "23471": p("VA", "Virginia Beach"),
  "23479": p("VA", "Virginia Beach"),
  "22980": p("VA", "Waynesboro"),
  "23186": p("VA", "Williamsburg"),
  "23187": p("VA", "Williamsburg"),
  "22601": p("VA", "Winchester"),
  "22604": p("VA", "Winchester"),
  "05443": p("VT", "Bristol"),
  "05456": p("VT", "Ferrisburgh"),
  "05469": p("VT", "Monkton"),
  "05472": p("VT", "New Haven"),
  "05473": p("VT", "North Ferrisburgh"),
  "05487": p("VT", "Starksboro"),
  "05491": p("VT", "Vergennes"),
  "05669": p("VT", "Roxbury"),
  "05734": p("VT", "Bridport"),
  "05740": p("VT", "East Middlebury"),
  "05747": p("VT", "Granville"),
  "05748": p("VT", "Hancock"),
  "05753": p("VT", "Middlebury"),
  "05760": p("VT", "Orwell"),
  "05766": p("VT", "Ripton"),
  "05769": p("VT", "Salisbury"),
  "05770": p("VT", "Shoreham"),
  "05778": p("VT", "Whiting"),
  "05152": p("VT", "Peru"),
  "05201": p("VT", "Bennington"),
  "05250": p("VT", "Arlington"),
  "05251": p("VT", "Dorset"),
  "05252": p("VT", "East Arlington"),
  "05253": p("VT", "East Dorset"),
  "05254": p("VT", "Manchester"),
  "05255": p("VT", "Manchester Center"),
  "05257": p("VT", "North Bennington"),
  "05260": p("VT", "North Pownal"),
  "05261": p("VT", "Pownal"),
  "05262": p("VT", "Shaftsbury"),
  "05340": p("VT", "Bondville"),
  "05350": p("VT", "Readsboro"),
  "05352": p("VT", "Stamford"),
  "05768": p("VT", "Rupert"),
  "05776": p("VT", "West Rupert"),
  "05042": p("VT", "East Ryegate"),
  "05046": p("VT", "Groton"),
  "05050": p("VT", "Mc Indoe Falls"),
  "05069": p("VT", "South Ryegate"),
  "05819": p("VT", "Saint Johnsbury"),
  "05821": p("VT", "Barnet"),
  "05828": p("VT", "Danville"),
  "05832": p("VT", "East Burke"),
  "05836": p("VT", "East Hardwick"),
  "05838": p("VT", "East Saint Johnsbury"),
  "05843": p("VT", "Hardwick"),
  "05848": p("VT", "Lower Waterford"),
  "05849": p("VT", "Lyndon"),
  "05850": p("VT", "Lyndon Center"),
  "05851": p("VT", "Lyndonville"),
  "05861": p("VT", "Passumpsic"),
  "05862": p("VT", "Peacham"),
  "05863": p("VT", "Saint Johnsbury Center"),
  "05866": p("VT", "Sheffield"),
  "05867": p("VT", "Sutton"),
  "05871": p("VT", "West Burke"),
  "05873": p("VT", "West Danville"),
  "05401": p("VT", "Burlington"),
  "05402": p("VT", "Burlington"),
  "05403": p("VT", "South Burlington"),
  "05404": p("VT", "Winooski"),
  "05405": p("VT", "Burlington"),
  "05406": p("VT", "Burlington"),
  "05407": p("VT", "South Burlington"),
  "05408": p("VT", "Burlington"),
  "05439": p("VT", "Colchester"),
  "05445": p("VT", "Charlotte"),
  "05446": p("VT", "Colchester"),
  "05449": p("VT", "Colchester"),
  "05451": p("VT", "Essex"),
  "05452": p("VT", "Essex Junction"),
  "05453": p("VT", "Essex Junction"),
  "05461": p("VT", "Hinesburg"),
  "05462": p("VT", "Huntington"),
  "05465": p("VT", "Jericho"),
  "05466": p("VT", "Jonesville"),
  "05468": p("VT", "Milton"),
  "05477": p("VT", "Richmond"),
  "05482": p("VT", "Shelburne"),
  "05489": p("VT", "Underhill"),
  "05490": p("VT", "Underhill Center"),
  "05494": p("VT", "Westford"),
  "05495": p("VT", "Williston"),
  "05824": p("VT", "Concord"),
  "05837": p("VT", "East Haven"),
  "05840": p("VT", "Granby"),
  "05846": p("VT", "Island Pond"),
  "05858": p("VT", "North Concord"),
  "05901": p("VT", "Averill"),
  "05902": p("VT", "Beecher Falls"),
  "05903": p("VT", "Canaan"),
  "05904": p("VT", "Gilman"),
  "05905": p("VT", "Guildhall"),
  "05906": p("VT", "Lunenburg"),
  "05907": p("VT", "Norton"),
  "05441": p("VT", "Bakersfield"),
  "05447": p("VT", "East Berkshire"),
  "05448": p("VT", "East Fairfield"),
  "05450": p("VT", "Enosburg Falls"),
  "05454": p("VT", "Fairfax"),
  "05455": p("VT", "Fairfield"),
  "05457": p("VT", "Franklin"),
  "05459": p("VT", "Highgate Center"),
  "05460": p("VT", "Highgate Springs"),
  "05470": p("VT", "Montgomery"),
  "05471": p("VT", "Montgomery Center"),
  "05476": p("VT", "Richford"),
  "05478": p("VT", "Saint Albans"),
  "05479": p("VT", "Saint Albans"),
  "05481": p("VT", "Saint Albans Bay"),
  "05483": p("VT", "Sheldon"),
  "05485": p("VT", "Sheldon Springs"),
  "05488": p("VT", "Swanton"),
  "05440": p("VT", "Alburgh"),
  "05458": p("VT", "Grand Isle"),
  "05463": p("VT", "Isle La Motte"),
  "05474": p("VT", "North Hero"),
  "05486": p("VT", "South Hero"),
  "05442": p("VT", "Belvidere Center"),
  "05444": p("VT", "Cambridge"),
  "05464": p("VT", "Jeffersonville"),
  "05492": p("VT", "Waterville"),
  "05652": p("VT", "Eden"),
  "05653": p("VT", "Eden Mills"),
  "05655": p("VT", "Hyde Park"),
  "05656": p("VT", "Johnson"),
  "05657": p("VT", "Lake Elmore"),
  "05661": p("VT", "Morrisville"),
  "05662": p("VT", "Moscow"),
  "05665": p("VT", "North Hyde Park"),
  "05672": p("VT", "Stowe"),
  "05680": p("VT", "Wolcott"),
  "05033": p("VT", "Bradford"),
  "05036": p("VT", "Brookfield"),
  "05038": p("VT", "Chelsea"),
  "05039": p("VT", "Corinth"),
  "05040": p("VT", "East Corinth"),
  "05041": p("VT", "East Randolph"),
  "05043": p("VT", "East Thetford"),
  "05045": p("VT", "Fairlee"),
  "05051": p("VT", "Newbury"),
  "05054": p("VT", "North Thetford"),
  "05058": p("VT", "Post Mills"),
  "05060": p("VT", "Randolph"),
  "05061": p("VT", "Randolph Center"),
  "05070": p("VT", "South Strafford"),
  "05072": p("VT", "Strafford"),
  "05074": p("VT", "Thetford"),
  "05075": p("VT", "Thetford Center"),
  "05076": p("VT", "Topsham"),
  "05077": p("VT", "Tunbridge"),
  "05079": p("VT", "Vershire"),
  "05081": p("VT", "Wells River"),
  "05083": p("VT", "West Fairlee"),
  "05085": p("VT", "West Newbury"),
  "05086": p("VT", "West Topsham"),
  "05675": p("VT", "Washington"),
  "05679": p("VT", "Williamstown"),
  "05820": p("VT", "Albany"),
  "05822": p("VT", "Barton"),
  "05823": p("VT", "Beebe Plain"),
  "05825": p("VT", "Coventry"),
  "05826": p("VT", "Craftsbury"),
  "05827": p("VT", "Craftsbury Common"),
  "05829": p("VT", "Derby"),
  "05830": p("VT", "Derby Line"),
  "05833": p("VT", "East Charleston"),
  "05839": p("VT", "Glover"),
  "05841": p("VT", "Greensboro"),
  "05842": p("VT", "Greensboro Bend"),
  "05845": p("VT", "Irasburg"),
  "05847": p("VT", "Lowell"),
  "05853": p("VT", "Morgan"),
  "05855": p("VT", "Newport"),
  "05857": p("VT", "Newport Center"),
  "05859": p("VT", "North Troy"),
  "05860": p("VT", "Orleans"),
  "05868": p("VT", "Troy"),
  "05872": p("VT", "West Charleston"),
  "05874": p("VT", "Westfield"),
  "05875": p("VT", "Barton"),
  "05701": p("VT", "Rutland"),
  "05702": p("VT", "Rutland"),
  "05730": p("VT", "Belmont"),
  "05731": p("VT", "Benson"),
  "05732": p("VT", "Bomoseen"),
  "05733": p("VT", "Brandon"),
  "05735": p("VT", "Castleton"),
  "05736": p("VT", "Center Rutland"),
  "05737": p("VT", "Chittenden"),
  "05738": p("VT", "Cuttingsville"),
  "05739": p("VT", "Danby"),
  "05741": p("VT", "East Poultney"),
  "05742": p("VT", "East Wallingford"),
  "05743": p("VT", "Fair Haven"),
  "05744": p("VT", "Florence"),
  "05745": p("VT", "Forest Dale"),
  "05750": p("VT", "Hydeville"),
  "05751": p("VT", "Killington"),
  "05757": p("VT", "Middletown Springs"),
  "05758": p("VT", "Mount Holly"),
  "05759": p("VT", "North Clarendon"),
  "05761": p("VT", "Pawlet"),
  "05762": p("VT", "Pittsfield"),
  "05763": p("VT", "Pittsford"),
  "05764": p("VT", "Poultney"),
  "05765": p("VT", "Proctor"),
  "05773": p("VT", "Wallingford"),
  "05774": p("VT", "Wells"),
  "05775": p("VT", "West Pawlet"),
  "05777": p("VT", "West Rutland"),
  "05601": p("VT", "Montpelier"),
  "05602": p("VT", "Montpelier"),
  "05603": p("VT", "Montpelier"),
  "05604": p("VT", "Montpelier"),
  "05609": p("VT", "Montpelier"),
  "05620": p("VT", "Montpelier"),
  "05633": p("VT", "Montpelier"),
  "05640": p("VT", "Adamant"),
  "05641": p("VT", "Barre"),
  "05647": p("VT", "Cabot"),
  "05648": p("VT", "Calais"),
  "05649": p("VT", "East Barre"),
  "05650": p("VT", "East Calais"),
  "05651": p("VT", "East Montpelier"),
  "05654": p("VT", "Graniteville"),
  "05658": p("VT", "Marshfield"),
  "05660": p("VT", "Moretown"),
  "05663": p("VT", "Northfield"),
  "05664": p("VT", "Northfield Falls"),
  "05666": p("VT", "North Montpelier"),
  "05667": p("VT", "Plainfield"),
  "05670": p("VT", "South Barre"),
  "05671": p("VT", "Waterbury"),
  "05673": p("VT", "Waitsfield"),
  "05674": p("VT", "Warren"),
  "05676": p("VT", "Waterbury"),
  "05677": p("VT", "Waterbury Center"),
  "05678": p("VT", "Websterville"),
  "05681": p("VT", "Woodbury"),
  "05682": p("VT", "Worcester"),
  "05101": p("VT", "Bellows Falls"),
  "05141": p("VT", "Cambridgeport"),
  "05146": p("VT", "Grafton"),
  "05148": p("VT", "Londonderry"),
  "05154": p("VT", "Saxtons River"),
  "05155": p("VT", "South Londonderry"),
  "05158": p("VT", "Westminster"),
  "05159": p("VT", "Westminster Station"),
  "05301": p("VT", "Brattleboro"),
  "05302": p("VT", "Brattleboro"),
  "05303": p("VT", "Brattleboro"),
  "05304": p("VT", "Brattleboro"),
  "05341": p("VT", "East Dover"),
  "05342": p("VT", "Jacksonville"),
  "05343": p("VT", "Jamaica"),
  "05344": p("VT", "Marlboro"),
  "05345": p("VT", "Newfane"),
  "05346": p("VT", "Putney"),
  "05351": p("VT", "South Newfane"),
  "05353": p("VT", "Townshend"),
  "05354": p("VT", "Vernon"),
  "05355": p("VT", "Wardsboro"),
  "05356": p("VT", "West Dover"),
  "05357": p("VT", "West Dummerston"),
  "05358": p("VT", "West Halifax"),
  "05359": p("VT", "West Townshend"),
  "05360": p("VT", "West Wardsboro"),
  "05361": p("VT", "Whitingham"),
  "05362": p("VT", "Williamsville"),
  "05363": p("VT", "Wilmington"),
  "05001": p("VT", "White River Junction"),
  "05009": p("VT", "White River Junction"),
  "05030": p("VT", "Ascutney"),
  "05031": p("VT", "Barnard"),
  "05032": p("VT", "Bethel"),
  "05034": p("VT", "Bridgewater"),
  "05035": p("VT", "Bridgewater Corners"),
  "05037": p("VT", "Brownsville"),
  "05047": p("VT", "Hartford"),
  "05048": p("VT", "Hartland"),
  "05049": p("VT", "Hartland Four Corners"),
  "05052": p("VT", "North Hartland"),
  "05053": p("VT", "North Pomfret"),
  "05055": p("VT", "Norwich"),
  "05056": p("VT", "Plymouth"),
  "05059": p("VT", "Quechee"),
  "05062": p("VT", "Reading"),
  "05065": p("VT", "Sharon"),
  "05067": p("VT", "South Pomfret"),
  "05068": p("VT", "South Royalton"),
  "05071": p("VT", "South Woodstock"),
  "05073": p("VT", "Taftsville"),
  "05084": p("VT", "West Hartford"),
  "05088": p("VT", "Wilder"),
  "05089": p("VT", "Windsor"),
  "05091": p("VT", "Woodstock"),
  "05142": p("VT", "Cavendish"),
  "05143": p("VT", "Chester"),
  "05149": p("VT", "Ludlow"),
  "05150": p("VT", "North Springfield"),
  "05151": p("VT", "Perkinsville"),
  "05153": p("VT", "Proctorsville"),
  "05156": p("VT", "Springfield"),
  "05161": p("VT", "Weston"),
  "05746": p("VT", "Gaysville"),
  "05767": p("VT", "Rochester"),
  "05772": p("VT", "Stockbridge"),
  "99105": p("WA", "Benge"),
  "99169": p("WA", "Ritzville"),
  "99341": p("WA", "Lind"),
  "99344": p("WA", "Othello"),
  "99371": p("WA", "Washtucna"),
  "99401": p("WA", "Anatone"),
  "99402": p("WA", "Asotin"),
  "99403": p("WA", "Clarkston"),
  "99320": p("WA", "Benton City"),
  "99336": p("WA", "Kennewick"),
  "99337": p("WA", "Kennewick"),
  "99338": p("WA", "Kennewick"),
  "99345": p("WA", "Paterson"),
  "99346": p("WA", "Plymouth"),
  "99350": p("WA", "Prosser"),
  "99352": p("WA", "Richland"),
  "99353": p("WA", "West Richland"),
  "99354": p("WA", "Richland"),
  "98801": p("WA", "Wenatchee"),
  "98807": p("WA", "Wenatchee"),
  "98811": p("WA", "Ardenvoir"),
  "98815": p("WA", "Cashmere"),
  "98816": p("WA", "Chelan"),
  "98817": p("WA", "Chelan Falls"),
  "98821": p("WA", "Dryden"),
  "98822": p("WA", "Entiat"),
  "98826": p("WA", "Leavenworth"),
  "98828": p("WA", "Malaga"),
  "98831": p("WA", "Manson"),
  "98836": p("WA", "Monitor"),
  "98847": p("WA", "Peshastin"),
  "98852": p("WA", "Stehekin"),
  "98305": p("WA", "Beaver"),
  "98324": p("WA", "Carlsborg"),
  "98326": p("WA", "Clallam Bay"),
  "98331": p("WA", "Forks"),
  "98343": p("WA", "Joyce"),
  "98350": p("WA", "La Push"),
  "98357": p("WA", "Neah Bay"),
  "98362": p("WA", "Port Angeles"),
  "98363": p("WA", "Port Angeles"),
  "98381": p("WA", "Sekiu"),
  "98382": p("WA", "Sequim"),
  "98601": p("WA", "Amboy"),
  "98604": p("WA", "Battle Ground"),
  "98606": p("WA", "Brush Prairie"),
  "98607": p("WA", "Camas"),
  "98622": p("WA", "Heisson"),
  "98629": p("WA", "La Center"),
  "98642": p("WA", "Ridgefield"),
  "98660": p("WA", "Vancouver"),
  "98661": p("WA", "Vancouver"),
  "98662": p("WA", "Vancouver"),
  "98663": p("WA", "Vancouver"),
  "98664": p("WA", "Vancouver"),
  "98665": p("WA", "Vancouver"),
  "98666": p("WA", "Vancouver"),
  "98668": p("WA", "Vancouver"),
  "98671": p("WA", "Washougal"),
  "98675": p("WA", "Yacolt"),
  "98682": p("WA", "Vancouver"),
  "98683": p("WA", "Vancouver"),
  "98684": p("WA", "Vancouver"),
  "98685": p("WA", "Vancouver"),
  "98686": p("WA", "Vancouver"),
  "98687": p("WA", "Vancouver"),
  "99328": p("WA", "Dayton"),
  "99359": p("WA", "Starbuck"),
  "98581": p("WA", "Ryderwood"),
  "98603": p("WA", "Ariel"),
  "98609": p("WA", "Carrolls"),
  "98611": p("WA", "Castle Rock"),
  "98616": p("WA", "Cougar"),
  "98625": p("WA", "Kalama"),
  "98626": p("WA", "Kelso"),
  "98632": p("WA", "Longview"),
  "98645": p("WA", "Silverlake"),
  "98649": p("WA", "Toutle"),
  "98674": p("WA", "Woodland"),
  "98802": p("WA", "East Wenatchee"),
  "98813": p("WA", "Bridgeport"),
  "98830": p("WA", "Mansfield"),
  "98843": p("WA", "Orondo"),
  "98845": p("WA", "Palisades"),
  "98850": p("WA", "Rock Island"),
  "98858": p("WA", "Waterville"),
  "99107": p("WA", "Boyds"),
  "99118": p("WA", "Curlew"),
  "99121": p("WA", "Danville"),
  "99138": p("WA", "Inchelium"),
  "99140": p("WA", "Keller"),
  "99146": p("WA", "Laurier"),
  "99150": p("WA", "Malo"),
  "99160": p("WA", "Orient"),
  "99166": p("WA", "Republic"),
  "99301": p("WA", "Pasco"),
  "99302": p("WA", "Pasco"),
  "99326": p("WA", "Connell"),
  "99330": p("WA", "Eltopia"),
  "99335": p("WA", "Kahlotus"),
  "99343": p("WA", "Mesa"),
  "99347": p("WA", "Pomeroy"),
  "98823": p("WA", "Ephrata"),
  "98824": p("WA", "George"),
  "98832": p("WA", "Marlin"),
  "98837": p("WA", "Moses Lake"),
  "98848": p("WA", "Quincy"),
  "98851": p("WA", "Soap Lake"),
  "98853": p("WA", "Stratford"),
  "98857": p("WA", "Warden"),
  "98860": p("WA", "Wilson Creek"),
  "99115": p("WA", "Coulee City"),
  "99123": p("WA", "Electric City"),
  "99133": p("WA", "Grand Coulee"),
  "99135": p("WA", "Hartline"),
  "99321": p("WA", "Beverly"),
  "99349": p("WA", "Mattawa"),
  "99357": p("WA", "Royal City"),
  "98520": p("WA", "Aberdeen"),
  "98526": p("WA", "Amanda Park"),
  "98535": p("WA", "Copalis Beach"),
  "98536": p("WA", "Copalis Crossing"),
  "98537": p("WA", "Cosmopolis"),
  "98541": p("WA", "Elma"),
  "98547": p("WA", "Grayland"),
  "98550": p("WA", "Hoquiam"),
  "98552": p("WA", "Humptulips"),
  "98557": p("WA", "Mccleary"),
  "98559": p("WA", "Malone"),
  "98562": p("WA", "Moclips"),
  "98563": p("WA", "Montesano"),
  "98566": p("WA", "Neilton"),
  "98568": p("WA", "Oakville"),
  "98569": p("WA", "Ocean Shores"),
  "98571": p("WA", "Pacific Beach"),
  "98575": p("WA", "Quinault"),
  "98583": p("WA", "Satsop"),
  "98587": p("WA", "Taholah"),
  "98595": p("WA", "Westport"),
  "98236": p("WA", "Clinton"),
  "98239": p("WA", "Coupeville"),
  "98249": p("WA", "Freeland"),
  "98253": p("WA", "Greenbank"),
  "98260": p("WA", "Langley"),
  "98277": p("WA", "Oak Harbor"),
  "98278": p("WA", "Oak Harbor"),
  "98320": p("WA", "Brinnon"),
  "98325": p("WA", "Chimacum"),
  "98339": p("WA", "Port Hadlock"),
  "98358": p("WA", "Nordland"),
  "98365": p("WA", "Port Ludlow"),
  "98368": p("WA", "Port Townsend"),
  "98376": p("WA", "Quilcene"),
  "98001": p("WA", "Auburn"),
  "98002": p("WA", "Auburn"),
  "98003": p("WA", "Federal Way"),
  "98004": p("WA", "Bellevue"),
  "98005": p("WA", "Bellevue"),
  "98006": p("WA", "Bellevue"),
  "98007": p("WA", "Bellevue"),
  "98008": p("WA", "Bellevue"),
  "98009": p("WA", "Bellevue"),
  "98010": p("WA", "Black Diamond"),
  "98011": p("WA", "Bothell"),
  "98013": p("WA", "Burton"),
  "98014": p("WA", "Carnation"),
  "98015": p("WA", "Bellevue"),
  "98019": p("WA", "Duvall"),
  "98022": p("WA", "Enumclaw"),
  "98023": p("WA", "Federal Way"),
  "98024": p("WA", "Fall City"),
  "98025": p("WA", "Hobart"),
  "98027": p("WA", "Issaquah"),
  "98028": p("WA", "Kenmore"),
  "98029": p("WA", "Issaquah"),
  "98030": p("WA", "Kent"),
  "98031": p("WA", "Kent"),
  "98032": p("WA", "Kent"),
  "98033": p("WA", "Kirkland"),
  "98034": p("WA", "Kirkland"),
  "98035": p("WA", "Kent"),
  "98038": p("WA", "Maple Valley"),
  "98039": p("WA", "Medina"),
  "98040": p("WA", "Mercer Island"),
  "98041": p("WA", "Bothell"),
  "98042": p("WA", "Kent"),
  "98045": p("WA", "North Bend"),
  "98047": p("WA", "Pacific"),
  "98050": p("WA", "Preston"),
  "98051": p("WA", "Ravensdale"),
  "98052": p("WA", "Redmond"),
  "98053": p("WA", "Redmond"),
  "98055": p("WA", "Renton"),
  "98056": p("WA", "Renton"),
  "98057": p("WA", "Renton"),
  "98058": p("WA", "Renton"),
  "98059": p("WA", "Renton"),
  "98062": p("WA", "Seahurst"),
  "98063": p("WA", "Federal Way"),
  "98064": p("WA", "Kent"),
  "98065": p("WA", "Snoqualmie"),
  "98068": p("WA", "Snoqualmie Pass"),
  "98070": p("WA", "Vashon"),
  "98071": p("WA", "Auburn"),
  "98072": p("WA", "Woodinville"),
  "98073": p("WA", "Redmond"),
  "98074": p("WA", "Sammamish"),
  "98075": p("WA", "Sammamish"),
  "98083": p("WA", "Kirkland"),
  "98089": p("WA", "Kent"),
  "98092": p("WA", "Auburn"),
  "98093": p("WA", "Federal Way"),
  "98101": p("WA", "Seattle"),
  "98102": p("WA", "Seattle"),
  "98103": p("WA", "Seattle"),
  "98104": p("WA", "Seattle"),
  "98105": p("WA", "Seattle"),
  "98106": p("WA", "Seattle"),
  "98107": p("WA", "Seattle"),
  "98108": p("WA", "Seattle"),
  "98109": p("WA", "Seattle"),
  "98111": p("WA", "Seattle"),
  "98112": p("WA", "Seattle"),
  "98113": p("WA", "Seattle"),
  "98114": p("WA", "Seattle"),
  "98115": p("WA", "Seattle"),
  "98116": p("WA", "Seattle"),
  "98117": p("WA", "Seattle"),
  "98118": p("WA", "Seattle"),
  "98119": p("WA", "Seattle"),
  "98121": p("WA", "Seattle"),
  "98122": p("WA", "Seattle"),
  "98124": p("WA", "Seattle"),
  "98125": p("WA", "Seattle"),
  "98126": p("WA", "Seattle"),
  "98127": p("WA", "Seattle"),
  "98129": p("WA", "Seattle"),
  "98131": p("WA", "Seattle"),
  "98133": p("WA", "Seattle"),
  "98134": p("WA", "Seattle"),
  "98136": p("WA", "Seattle"),
  "98138": p("WA", "Seattle"),
  "98139": p("WA", "Seattle"),
  "98141": p("WA", "Seattle"),
  "98144": p("WA", "Seattle"),
  "98145": p("WA", "Seattle"),
  "98146": p("WA", "Seattle"),
  "98148": p("WA", "Seattle"),
  "98154": p("WA", "Seattle"),
  "98155": p("WA", "Seattle"),
  "98158": p("WA", "Seattle"),
  "98160": p("WA", "Seattle"),
  "98161": p("WA", "Seattle"),
  "98164": p("WA", "Seattle"),
  "98165": p("WA", "Seattle"),
  "98166": p("WA", "Seattle"),
  "98168": p("WA", "Seattle"),
  "98170": p("WA", "Seattle"),
  "98174": p("WA", "Seattle"),
  "98175": p("WA", "Seattle"),
  "98177": p("WA", "Seattle"),
  "98178": p("WA", "Seattle"),
  "98181": p("WA", "Seattle"),
  "98185": p("WA", "Seattle"),
  "98188": p("WA", "Seattle"),
  "98190": p("WA", "Seattle"),
  "98191": p("WA", "Seattle"),
  "98194": p("WA", "Seattle"),
  "98195": p("WA", "Seattle"),
  "98198": p("WA", "Seattle"),
  "98199": p("WA", "Seattle"),
  "98224": p("WA", "Baring"),
  "98288": p("WA", "Skykomish"),
  "98061": p("WA", "Rollingbay"),
  "98110": p("WA", "Bainbridge Island"),
  "98310": p("WA", "Bremerton"),
  "98311": p("WA", "Bremerton"),
  "98312": p("WA", "Bremerton"),
  "98314": p("WA", "Bremerton"),
  "98315": p("WA", "Silverdale"),
  "98322": p("WA", "Burley"),
  "98337": p("WA", "Bremerton"),
  "98340": p("WA", "Hansville"),
  "98342": p("WA", "Indianola"),
  "98345": p("WA", "Keyport"),
  "98346": p("WA", "Kingston"),
  "98353": p("WA", "Manchester"),
  "98359": p("WA", "Olalla"),
  "98364": p("WA", "Port Gamble"),
  "98366": p("WA", "Port Orchard"),
  "98367": p("WA", "Port Orchard"),
  "98370": p("WA", "Poulsbo"),
  "98378": p("WA", "Retsil"),
  "98380": p("WA", "Seabeck"),
  "98383": p("WA", "Silverdale"),
  "98384": p("WA", "South Colby"),
  "98386": p("WA", "Southworth"),
  "98392": p("WA", "Suquamish"),
  "98393": p("WA", "Tracyton"),
  "98922": p("WA", "Cle Elum"),
  "98925": p("WA", "Easton"),
  "98926": p("WA", "Ellensburg"),
  "98934": p("WA", "Kittitas"),
  "98940": p("WA", "Ronald"),
  "98941": p("WA", "Roslyn"),
  "98943": p("WA", "South Cle Elum"),
  "98946": p("WA", "Thorp"),
  "98950": p("WA", "Vantage"),
  "98602": p("WA", "Appleton"),
  "98605": p("WA", "Bingen"),
  "98613": p("WA", "Centerville"),
  "98617": p("WA", "Dallesport"),
  "98619": p("WA", "Glenwood"),
  "98620": p("WA", "Goldendale"),
  "98623": p("WA", "Husum"),
  "98628": p("WA", "Klickitat"),
  "98635": p("WA", "Lyle"),
  "98650": p("WA", "Trout Lake"),
  "98670": p("WA", "Wahkiacus"),
  "98672": p("WA", "White Salmon"),
  "98673": p("WA", "Wishram"),
  "99322": p("WA", "Bickleton"),
  "99356": p("WA", "Roosevelt"),
  "98336": p("WA", "Glenoma"),
  "98355": p("WA", "Mineral"),
  "98356": p("WA", "Morton"),
  "98361": p("WA", "Packwood"),
  "98377": p("WA", "Randle"),
  "98522": p("WA", "Adna"),
  "98531": p("WA", "Centralia"),
  "98532": p("WA", "Chehalis"),
  "98533": p("WA", "Cinebar"),
  "98538": p("WA", "Curtis"),
  "98539": p("WA", "Doty"),
  "98542": p("WA", "Ethel"),
  "98544": p("WA", "Galvin"),
  "98564": p("WA", "Mossyrock"),
  "98565": p("WA", "Napavine"),
  "98570": p("WA", "Onalaska"),
  "98572": p("WA", "Pe Ell"),
  "98582": p("WA", "Salkum"),
  "98585": p("WA", "Silver Creek"),
  "98591": p("WA", "Toledo"),
  "98593": p("WA", "Vader"),
  "98596": p("WA", "Winlock"),
  "99008": p("WA", "Edwall"),
  "99032": p("WA", "Sprague"),
  "99103": p("WA", "Almira"),
  "99117": p("WA", "Creston"),
  "99122": p("WA", "Davenport"),
  "99134": p("WA", "Harrington"),
  "99144": p("WA", "Lamona"),
  "99147": p("WA", "Lincoln"),
  "99154": p("WA", "Mohler"),
  "99159": p("WA", "Odessa"),
  "99185": p("WA", "Wilbur"),
  "98524": p("WA", "Allyn"),
  "98528": p("WA", "Belfair"),
  "98546": p("WA", "Grapeview"),
  "98548": p("WA", "Hoodsport"),
  "98555": p("WA", "Lilliwaup"),
  "98560": p("WA", "Matlock"),
  "98584": p("WA", "Shelton"),
  "98588": p("WA", "Tahuya"),
  "98592": p("WA", "Union"),
  "98812": p("WA", "Brewster"),
  "98814": p("WA", "Carlton"),
  "98819": p("WA", "Conconully"),
  "98827": p("WA", "Loomis"),
  "98829": p("WA", "Malott"),
  "98833": p("WA", "Mazama"),
  "98834": p("WA", "Methow"),
  "98840": p("WA", "Okanogan"),
  "98841": p("WA", "Omak"),
  "98844": p("WA", "Oroville"),
  "98846": p("WA", "Pateros"),
  "98849": p("WA", "Riverside"),
  "98855": p("WA", "Tonasket"),
  "98856": p("WA", "Twisp"),
  "98859": p("WA", "Wauconda"),
  "98862": p("WA", "Winthrop"),
  "99116": p("WA", "Coulee Dam"),
  "99124": p("WA", "Elmer City"),
  "99155": p("WA", "Nespelem"),
  "98527": p("WA", "Bay Center"),
  "98554": p("WA", "Lebam"),
  "98561": p("WA", "Menlo"),
  "98577": p("WA", "Raymond"),
  "98586": p("WA", "South Bend"),
  "98590": p("WA", "Tokeland"),
  "98614": p("WA", "Chinook"),
  "98624": p("WA", "Ilwaco"),
  "98631": p("WA", "Long Beach"),
  "98637": p("WA", "Nahcotta"),
  "98638": p("WA", "Naselle"),
  "98640": p("WA", "Ocean Park"),
  "98641": p("WA", "Oysterville"),
  "98644": p("WA", "Seaview"),
  "99119": p("WA", "Cusick"),
  "99139": p("WA", "Ione"),
  "99152": p("WA", "Metaline"),
  "99153": p("WA", "Metaline Falls"),
  "99156": p("WA", "Newport"),
  "99180": p("WA", "Usk"),
  "98303": p("WA", "Anderson Island"),
  "98304": p("WA", "Ashford"),
  "98321": p("WA", "Buckley"),
  "98323": p("WA", "Carbonado"),
  "98327": p("WA", "Dupont"),
  "98328": p("WA", "Eatonville"),
  "98329": p("WA", "Gig Harbor"),
  "98330": p("WA", "Elbe"),
  "98332": p("WA", "Gig Harbor"),
  "98333": p("WA", "Fox Island"),
  "98335": p("WA", "Gig Harbor"),
  "98338": p("WA", "Graham"),
  "98344": p("WA", "Kapowsin"),
  "98348": p("WA", "La Grande"),
  "98349": p("WA", "Lakebay"),
  "98351": p("WA", "Longbranch"),
  "98352": p("WA", "Sumner"),
  "98354": p("WA", "Milton"),
  "98360": p("WA", "Orting"),
  "98371": p("WA", "Puyallup"),
  "98372": p("WA", "Puyallup"),
  "98373": p("WA", "Puyallup"),
  "98374": p("WA", "Puyallup"),
  "98375": p("WA", "Puyallup"),
  "98385": p("WA", "South Prairie"),
  "98387": p("WA", "Spanaway"),
  "98388": p("WA", "Steilacoom"),
  "98390": p("WA", "Sumner"),
  "98391": p("WA", "Bonney Lake"),
  "98394": p("WA", "Vaughn"),
  "98395": p("WA", "Wauna"),
  "98396": p("WA", "Wilkeson"),
  "98397": p("WA", "Longmire"),
  "98398": p("WA", "Paradise Inn"),
  "98401": p("WA", "Tacoma"),
  "98402": p("WA", "Tacoma"),
  "98403": p("WA", "Tacoma"),
  "98404": p("WA", "Tacoma"),
  "98405": p("WA", "Tacoma"),
  "98406": p("WA", "Tacoma"),
  "98407": p("WA", "Tacoma"),
  "98408": p("WA", "Tacoma"),
  "98409": p("WA", "Tacoma"),
  "98411": p("WA", "Tacoma"),
  "98412": p("WA", "Tacoma"),
  "98413": p("WA", "Tacoma"),
  "98415": p("WA", "Tacoma"),
  "98416": p("WA", "Tacoma"),
  "98417": p("WA", "Tacoma"),
  "98418": p("WA", "Tacoma"),
  "98419": p("WA", "Tacoma"),
  "98421": p("WA", "Tacoma"),
  "98422": p("WA", "Tacoma"),
  "98424": p("WA", "Tacoma"),
  "98430": p("WA", "Camp Murray"),
  "98431": p("WA", "Tacoma"),
  "98433": p("WA", "Tacoma"),
  "98438": p("WA", "Mcchord Afb"),
  "98439": p("WA", "Lakewood"),
  "98443": p("WA", "Tacoma"),
  "98444": p("WA", "Tacoma"),
  "98445": p("WA", "Tacoma"),
  "98446": p("WA", "Tacoma"),
  "98447": p("WA", "Tacoma"),
  "98448": p("WA", "Tacoma"),
  "98464": p("WA", "Tacoma"),
  "98465": p("WA", "Tacoma"),
  "98466": p("WA", "Tacoma"),
  "98467": p("WA", "University Place"),
  "98471": p("WA", "Tacoma"),
  "98481": p("WA", "Tacoma"),
  "98490": p("WA", "Tacoma"),
  "98493": p("WA", "Tacoma"),
  "98496": p("WA", "Lakewood"),
  "98497": p("WA", "Lakewood"),
  "98498": p("WA", "Lakewood"),
  "98499": p("WA", "Lakewood"),
  "98558": p("WA", "Mckenna"),
  "98580": p("WA", "Roy"),
  "98222": p("WA", "Blakely Island"),
  "98243": p("WA", "Deer Harbor"),
  "98245": p("WA", "Eastsound"),
  "98250": p("WA", "Friday Harbor"),
  "98261": p("WA", "Lopez Island"),
  "98279": p("WA", "Olga"),
  "98280": p("WA", "Orcas"),
  "98286": p("WA", "Shaw Island"),
  "98297": p("WA", "Waldron"),
  "98221": p("WA", "Anacortes"),
  "98232": p("WA", "Bow"),
  "98233": p("WA", "Burlington"),
  "98235": p("WA", "Clearlake"),
  "98237": p("WA", "Concrete"),
  "98238": p("WA", "Conway"),
  "98255": p("WA", "Hamilton"),
  "98257": p("WA", "La Conner"),
  "98263": p("WA", "Lyman"),
  "98267": p("WA", "Marblemount"),
  "98273": p("WA", "Mount Vernon"),
  "98274": p("WA", "Mount Vernon"),
  "98283": p("WA", "Rockport"),
  "98284": p("WA", "Sedro Woolley"),
  "98610": p("WA", "Carson"),
  "98639": p("WA", "North Bonneville"),
  "98648": p("WA", "Stevenson"),
  "98651": p("WA", "Underwood"),
  "98012": p("WA", "Bothell"),
  "98020": p("WA", "Edmonds"),
  "98021": p("WA", "Bothell"),
  "98026": p("WA", "Edmonds"),
  "98036": p("WA", "Lynnwood"),
  "98037": p("WA", "Lynnwood"),
  "98043": p("WA", "Mountlake Terrace"),
  "98046": p("WA", "Lynnwood"),
  "98077": p("WA", "Woodinville"),
  "98082": p("WA", "Mill Creek"),
  "98087": p("WA", "Lynnwood"),
  "98201": p("WA", "Everett"),
  "98203": p("WA", "Everett"),
  "98204": p("WA", "Everett"),
  "98206": p("WA", "Everett"),
  "98207": p("WA", "Everett"),
  "98208": p("WA", "Everett"),
  "98213": p("WA", "Everett"),
  "98223": p("WA", "Arlington"),
  "98241": p("WA", "Darrington"),
  "98251": p("WA", "Gold Bar"),
  "98252": p("WA", "Granite Falls"),
  "98256": p("WA", "Index"),
  "98258": p("WA", "Lake Stevens"),
  "98259": p("WA", "North Lakewood"),
  "98270": p("WA", "Marysville"),
  "98271": p("WA", "Marysville"),
  "98272": p("WA", "Monroe"),
  "98275": p("WA", "Mukilteo"),
  "98282": p("WA", "Camano Island"),
  "98287": p("WA", "Silvana"),
  "98290": p("WA", "Snohomish"),
  "98291": p("WA", "Snohomish"),
  "98292": p("WA", "Stanwood"),
  "98293": p("WA", "Startup"),
  "98294": p("WA", "Sultan"),
  "98296": p("WA", "Snohomish"),
  "99001": p("WA", "Airway Heights"),
  "99003": p("WA", "Chattaroy"),
  "99004": p("WA", "Cheney"),
  "99005": p("WA", "Colbert"),
  "99006": p("WA", "Deer Park"),
  "99009": p("WA", "Elk"),
  "99011": p("WA", "Fairchild Air Force Base"),
  "99012": p("WA", "Fairfield"),
  "99014": p("WA", "Four Lakes"),
  "99016": p("WA", "Greenacres"),
  "99018": p("WA", "Latah"),
  "99019": p("WA", "Liberty Lake"),
  "99020": p("WA", "Marshall"),
  "99021": p("WA", "Mead"),
  "99022": p("WA", "Medical Lake"),
  "99023": p("WA", "Mica"),
  "99025": p("WA", "Newman Lake"),
  "99026": p("WA", "Nine Mile Falls"),
  "99027": p("WA", "Otis Orchards"),
  "99029": p("WA", "Reardan"),
  "99030": p("WA", "Rockford"),
  "99031": p("WA", "Spangle"),
  "99036": p("WA", "Valleyford"),
  "99037": p("WA", "Veradale"),
  "99039": p("WA", "Waverly"),
  "99201": p("WA", "Spokane"),
  "99202": p("WA", "Spokane"),
  "99203": p("WA", "Spokane"),
  "99204": p("WA", "Spokane"),
  "99205": p("WA", "Spokane"),
  "99206": p("WA", "Spokane"),
  "99207": p("WA", "Spokane"),
  "99208": p("WA", "Spokane"),
  "99209": p("WA", "Spokane"),
  "99210": p("WA", "Spokane"),
  "99211": p("WA", "Spokane"),
  "99212": p("WA", "Spokane"),
  "99213": p("WA", "Spokane"),
  "99214": p("WA", "Spokane"),
  "99215": p("WA", "Spokane"),
  "99216": p("WA", "Spokane"),
  "99217": p("WA", "Spokane"),
  "99218": p("WA", "Spokane"),
  "99219": p("WA", "Spokane"),
  "99220": p("WA", "Spokane"),
  "99223": p("WA", "Spokane"),
  "99224": p("WA", "Spokane"),
  "99228": p("WA", "Spokane"),
  "99251": p("WA", "Spokane"),
  "99252": p("WA", "Spokane"),
  "99256": p("WA", "Spokane"),
  "99258": p("WA", "Spokane"),
  "99260": p("WA", "Spokane"),
  "99013": p("WA", "Ford"),
  "99034": p("WA", "Tumtum"),
  "99040": p("WA", "Wellpinit"),
  "99101": p("WA", "Addy"),
  "99109": p("WA", "Chewelah"),
  "99110": p("WA", "Clayton"),
  "99114": p("WA", "Colville"),
  "99126": p("WA", "Evans"),
  "99129": p("WA", "Fruitland"),
  "99131": p("WA", "Gifford"),
  "99137": p("WA", "Hunters"),
  "99141": p("WA", "Kettle Falls"),
  "99148": p("WA", "Loon Lake"),
  "99151": p("WA", "Marcus"),
  "99157": p("WA", "Northport"),
  "99167": p("WA", "Rice"),
  "99173": p("WA", "Springdale"),
  "99181": p("WA", "Valley"),
  "98501": p("WA", "Olympia"),
  "98502": p("WA", "Olympia"),
  "98503": p("WA", "Lacey"),
  "98504": p("WA", "Olympia"),
  "98505": p("WA", "Olympia"),
  "98506": p("WA", "Olympia"),
  "98507": p("WA", "Olympia"),
  "98508": p("WA", "Olympia"),
  "98509": p("WA", "Lacey"),
  "98511": p("WA", "Tumwater"),
  "98512": p("WA", "Olympia"),
  "98513": p("WA", "Olympia"),
  "98516": p("WA", "Olympia"),
  "98530": p("WA", "Bucoda"),
  "98540": p("WA", "East Olympia"),
  "98556": p("WA", "Littlerock"),
  "98576": p("WA", "Rainier"),
  "98579": p("WA", "Rochester"),
  "98589": p("WA", "Tenino"),
  "98597": p("WA", "Yelm"),
  "98599": p("WA", "Olympia"),
  "98612": p("WA", "Cathlamet"),
  "98621": p("WA", "Grays River"),
  "98643": p("WA", "Rosburg"),
  "98647": p("WA", "Skamokawa"),
  "99323": p("WA", "Burbank"),
  "99324": p("WA", "College Place"),
  "99329": p("WA", "Dixie"),
  "99348": p("WA", "Prescott"),
  "99360": p("WA", "Touchet"),
  "99361": p("WA", "Waitsburg"),
  "99362": p("WA", "Walla Walla"),
  "99363": p("WA", "Wallula"),
  "98220": p("WA", "Acme"),
  "98225": p("WA", "Bellingham"),
  "98226": p("WA", "Bellingham"),
  "98227": p("WA", "Bellingham"),
  "98228": p("WA", "Bellingham"),
  "98229": p("WA", "Bellingham"),
  "98230": p("WA", "Blaine"),
  "98231": p("WA", "Blaine"),
  "98240": p("WA", "Custer"),
  "98244": p("WA", "Deming"),
  "98247": p("WA", "Everson"),
  "98248": p("WA", "Ferndale"),
  "98262": p("WA", "Lummi Island"),
  "98264": p("WA", "Lynden"),
  "98266": p("WA", "Maple Falls"),
  "98276": p("WA", "Nooksack"),
  "98281": p("WA", "Point Roberts"),
  "98295": p("WA", "Sumas"),
  "99017": p("WA", "Lamont"),
  "99033": p("WA", "Tekoa"),
  "99102": p("WA", "Albion"),
  "99104": p("WA", "Belmont"),
  "99111": p("WA", "Colfax"),
  "99113": p("WA", "Colton"),
  "99125": p("WA", "Endicott"),
  "99128": p("WA", "Farmington"),
  "99130": p("WA", "Garfield"),
  "99136": p("WA", "Hay"),
  "99143": p("WA", "Lacrosse"),
  "99149": p("WA", "Malden"),
  "99158": p("WA", "Oakesdale"),
  "99161": p("WA", "Palouse"),
  "99163": p("WA", "Pullman"),
  "99164": p("WA", "Pullman"),
  "99170": p("WA", "Rosalia"),
  "99171": p("WA", "Saint John"),
  "99174": p("WA", "Steptoe"),
  "99176": p("WA", "Thornton"),
  "99179": p("WA", "Uniontown"),
  "99333": p("WA", "Hooper"),
  "98901": p("WA", "Yakima"),
  "98902": p("WA", "Yakima"),
  "98903": p("WA", "Yakima"),
  "98904": p("WA", "Yakima"),
  "98907": p("WA", "Yakima"),
  "98908": p("WA", "Yakima"),
  "98909": p("WA", "Yakima"),
  "98920": p("WA", "Brownstown"),
  "98921": p("WA", "Buena"),
  "98923": p("WA", "Cowiche"),
  "98930": p("WA", "Grandview"),
  "98932": p("WA", "Granger"),
  "98933": p("WA", "Harrah"),
  "98935": p("WA", "Mabton"),
  "98936": p("WA", "Moxee"),
  "98937": p("WA", "Naches"),
  "98938": p("WA", "Outlook"),
  "98939": p("WA", "Parker"),
  "98942": p("WA", "Selah"),
  "98944": p("WA", "Sunnyside"),
  "98947": p("WA", "Tieton"),
  "98948": p("WA", "Toppenish"),
  "98951": p("WA", "Wapato"),
  "98952": p("WA", "White Swan"),
  "98953": p("WA", "Zillah"),
  "53910": p("WI", "Adams"),
  "53927": p("WI", "Dellwood"),
  "53934": p("WI", "Friendship"),
  "53936": p("WI", "Grand Marsh"),
  "54613": p("WI", "Arkdale"),
  "54514": p("WI", "Butternut"),
  "54517": p("WI", "Clam Lake"),
  "54527": p("WI", "Glidden"),
  "54546": p("WI", "Mellen"),
  "54806": p("WI", "Ashland"),
  "54846": p("WI", "High Bridge"),
  "54850": p("WI", "La Pointe"),
  "54855": p("WI", "Marengo"),
  "54861": p("WI", "Odanah"),
  "54728": p("WI", "Chetek"),
  "54733": p("WI", "Dallas"),
  "54762": p("WI", "Prairie Farm"),
  "54805": p("WI", "Almena"),
  "54812": p("WI", "Barron"),
  "54813": p("WI", "Barronett"),
  "54818": p("WI", "Brill"),
  "54822": p("WI", "Cameron"),
  "54826": p("WI", "Comstock"),
  "54829": p("WI", "Cumberland"),
  "54841": p("WI", "Haugen"),
  "54857": p("WI", "Mikana"),
  "54868": p("WI", "Rice Lake"),
  "54889": p("WI", "Turtle Lake"),
  "54814": p("WI", "Bayfield"),
  "54816": p("WI", "Benoit"),
  "54821": p("WI", "Cable"),
  "54827": p("WI", "Cornucopia"),
  "54832": p("WI", "Drummond"),
  "54839": p("WI", "Grand View"),
  "54844": p("WI", "Herbster"),
  "54847": p("WI", "Iron River"),
  "54856": p("WI", "Mason"),
  "54865": p("WI", "Port Wing"),
  "54891": p("WI", "Washburn"),
  "54115": p("WI", "De Pere"),
  "54126": p("WI", "Greenleaf"),
  "54162": p("WI", "Pulaski"),
  "54173": p("WI", "Suamico"),
  "54180": p("WI", "Wrightstown"),
  "54208": p("WI", "Denmark"),
  "54229": p("WI", "New Franken"),
  "54301": p("WI", "Green Bay"),
  "54302": p("WI", "Green Bay"),
  "54303": p("WI", "Green Bay"),
  "54304": p("WI", "Green Bay"),
  "54305": p("WI", "Green Bay"),
  "54306": p("WI", "Green Bay"),
  "54307": p("WI", "Green Bay"),
  "54308": p("WI", "Green Bay"),
  "54311": p("WI", "Green Bay"),
  "54313": p("WI", "Green Bay"),
  "54324": p("WI", "Green Bay"),
  "54344": p("WI", "Green Bay"),
  "54610": p("WI", "Alma"),
  "54622": p("WI", "Cochrane"),
  "54629": p("WI", "Fountain City"),
  "54743": p("WI", "Gilmanton"),
  "54755": p("WI", "Mondovi"),
  "54756": p("WI", "Nelson"),
  "54830": p("WI", "Danbury"),
  "54840": p("WI", "Grantsburg"),
  "54845": p("WI", "Hertel"),
  "54872": p("WI", "Siren"),
  "54893": p("WI", "Webster"),
  "53014": p("WI", "Chilton"),
  "53061": p("WI", "New Holstein"),
  "53062": p("WI", "New Holstein"),
  "53088": p("WI", "Stockbridge"),
  "54110": p("WI", "Brillion"),
  "54123": p("WI", "Forest Junction"),
  "54129": p("WI", "Hilbert"),
  "54160": p("WI", "Potter"),
  "54169": p("WI", "Sherwood"),
  "54724": p("WI", "Bloomer"),
  "54726": p("WI", "Boyd"),
  "54727": p("WI", "Cadott"),
  "54729": p("WI", "Chippewa Falls"),
  "54732": p("WI", "Cornell"),
  "54745": p("WI", "Holcombe"),
  "54748": p("WI", "Jim Falls"),
  "54757": p("WI", "New Auburn"),
  "54768": p("WI", "Stanley"),
  "54774": p("WI", "Chippewa Falls"),
  "54405": p("WI", "Abbotsford"),
  "54420": p("WI", "Chili"),
  "54421": p("WI", "Colby"),
  "54422": p("WI", "Curtiss"),
  "54425": p("WI", "Dorchester"),
  "54436": p("WI", "Granton"),
  "54437": p("WI", "Greenwood"),
  "54446": p("WI", "Loyal"),
  "54456": p("WI", "Neillsville"),
  "54460": p("WI", "Owen"),
  "54493": p("WI", "Willard"),
  "54498": p("WI", "Withee"),
  "54746": p("WI", "Humbird"),
  "54771": p("WI", "Thorp"),
  "53555": p("WI", "Lodi"),
  "53901": p("WI", "Portage"),
  "53911": p("WI", "Arlington"),
  "53923": p("WI", "Cambria"),
  "53925": p("WI", "Columbus"),
  "53928": p("WI", "Doylestown"),
  "53932": p("WI", "Fall River"),
  "53935": p("WI", "Friesland"),
  "53954": p("WI", "Pardeeville"),
  "53955": p("WI", "Poynette"),
  "53957": p("WI", "Randolph"),
  "53960": p("WI", "Rio"),
  "53965": p("WI", "Wisconsin Dells"),
  "53969": p("WI", "Wyocena"),
  "53821": p("WI", "Prairie Du Chien"),
  "53826": p("WI", "Wauzeka"),
  "54626": p("WI", "Eastman"),
  "54628": p("WI", "Ferryville"),
  "54631": p("WI", "Gays Mills"),
  "54640": p("WI", "Lynxville"),
  "54645": p("WI", "Mount Sterling"),
  "54654": p("WI", "Seneca"),
  "54655": p("WI", "Soldiers Grove"),
  "54657": p("WI", "Steuben"),
  "53508": p("WI", "Belleville"),
  "53515": p("WI", "Black Earth"),
  "53517": p("WI", "Blue Mounds"),
  "53523": p("WI", "Cambridge"),
  "53527": p("WI", "Cottage Grove"),
  "53528": p("WI", "Cross Plains"),
  "53529": p("WI", "Dane"),
  "53531": p("WI", "Deerfield"),
  "53532": p("WI", "Deforest"),
  "53558": p("WI", "Mc Farland"),
  "53559": p("WI", "Marshall"),
  "53560": p("WI", "Mazomanie"),
  "53562": p("WI", "Middleton"),
  "53571": p("WI", "Morrisonville"),
  "53572": p("WI", "Mount Horeb"),
  "53575": p("WI", "Oregon"),
  "53589": p("WI", "Stoughton"),
  "53590": p("WI", "Sun Prairie"),
  "53593": p("WI", "Verona"),
  "53596": p("WI", "Sun Prairie"),
  "53597": p("WI", "Waunakee"),
  "53598": p("WI", "Windsor"),
  "53701": p("WI", "Madison"),
  "53702": p("WI", "Madison"),
  "53703": p("WI", "Madison"),
  "53704": p("WI", "Madison"),
  "53705": p("WI", "Madison"),
  "53706": p("WI", "Madison"),
  "53707": p("WI", "Madison"),
  "53708": p("WI", "Madison"),
  "53711": p("WI", "Madison"),
  "53713": p("WI", "Madison"),
  "53714": p("WI", "Madison"),
  "53715": p("WI", "Madison"),
  "53716": p("WI", "Madison"),
  "53717": p("WI", "Madison"),
  "53718": p("WI", "Madison"),
  "53719": p("WI", "Madison"),
  "53725": p("WI", "Madison"),
  "53726": p("WI", "Madison"),
  "53744": p("WI", "Madison"),
  "53774": p("WI", "Madison"),
  "53777": p("WI", "Madison"),
  "53778": p("WI", "Madison"),
  "53779": p("WI", "Madison"),
  "53782": p("WI", "Madison"),
  "53783": p("WI", "Madison"),
  "53784": p("WI", "Madison"),
  "53785": p("WI", "Madison"),
  "53786": p("WI", "Madison"),
  "53788": p("WI", "Madison"),
  "53789": p("WI", "Madison"),
  "53790": p("WI", "Madison"),
  "53791": p("WI", "Madison"),
  "53792": p("WI", "Madison"),
  "53793": p("WI", "Madison"),
  "53794": p("WI", "Madison"),
  "53003": p("WI", "Ashippun"),
  "53006": p("WI", "Brownsville"),
  "53016": p("WI", "Clyman"),
  "53032": p("WI", "Horicon"),
  "53034": p("WI", "Hustisford"),
  "53035": p("WI", "Iron Ridge"),
  "53039": p("WI", "Juneau"),
  "53047": p("WI", "Lebanon"),
  "53048": p("WI", "Lomira"),
  "53050": p("WI", "Mayville"),
  "53059": p("WI", "Neosho"),
  "53078": p("WI", "Rubicon"),
  "53091": p("WI", "Theresa"),
  "53098": p("WI", "Watertown"),
  "53099": p("WI", "Woodland"),
  "53557": p("WI", "Lowell"),
  "53579": p("WI", "Reeseville"),
  "53916": p("WI", "Beaver Dam"),
  "53922": p("WI", "Burnett"),
  "53933": p("WI", "Fox Lake"),
  "53956": p("WI", "Randolph"),
  "53963": p("WI", "Waupun"),
  "54202": p("WI", "Baileys Harbor"),
  "54204": p("WI", "Brussels"),
  "54209": p("WI", "Egg Harbor"),
  "54210": p("WI", "Ellison Bay"),
  "54211": p("WI", "Ephraim"),
  "54212": p("WI", "Fish Creek"),
  "54213": p("WI", "Forestville"),
  "54226": p("WI", "Maplewood"),
  "54234": p("WI", "Sister Bay"),
  "54235": p("WI", "Sturgeon Bay"),
  "54246": p("WI", "Washington Island"),
  "54820": p("WI", "Brule"),
  "54836": p("WI", "Foxboro"),
  "54838": p("WI", "Gordon"),
  "54842": p("WI", "Hawthorne"),
  "54849": p("WI", "Lake Nebagamon"),
  "54854": p("WI", "Maple"),
  "54864": p("WI", "Poplar"),
  "54873": p("WI", "Solon Springs"),
  "54874": p("WI", "South Range"),
  "54880": p("WI", "Superior"),
  "54890": p("WI", "Wascott"),
  "54725": p("WI", "Boyceville"),
  "54730": p("WI", "Colfax"),
  "54734": p("WI", "Downing"),
  "54735": p("WI", "Downsville"),
  "54737": p("WI", "Eau Galle"),
  "54739": p("WI", "Elk Mound"),
  "54749": p("WI", "Knapp"),
  "54751": p("WI", "Menomonie"),
  "54763": p("WI", "Ridgeland"),
  "54764": p("WI", "Rock Falls"),
  "54765": p("WI", "Sand Creek"),
  "54772": p("WI", "Wheeler"),
  "54701": p("WI", "Eau Claire"),
  "54702": p("WI", "Eau Claire"),
  "54703": p("WI", "Eau Claire"),
  "54720": p("WI", "Altoona"),
  "54722": p("WI", "Augusta"),
  "54741": p("WI", "Fairchild"),
  "54742": p("WI", "Fall Creek"),
  "54120": p("WI", "Fence"),
  "54121": p("WI", "Florence"),
  "54542": p("WI", "Long Lake"),
  "53010": p("WI", "Campbellsport"),
  "53019": p("WI", "Eden"),
  "53049": p("WI", "Malone"),
  "53057": p("WI", "Mount Calvary"),
  "53065": p("WI", "Oakfield"),
  "53079": p("WI", "Saint Cloud"),
  "53919": p("WI", "Brandon"),
  "53931": p("WI", "Fairwater"),
  "54932": p("WI", "Eldorado"),
  "54935": p("WI", "Fond Du Lac"),
  "54936": p("WI", "Fond Du Lac"),
  "54937": p("WI", "Fond Du Lac"),
  "54971": p("WI", "Ripon"),
  "54974": p("WI", "Rosendale"),
  "54979": p("WI", "Van Dyne"),
  "54103": p("WI", "Armstrong Creek"),
  "54511": p("WI", "Argonne"),
  "54520": p("WI", "Crandon"),
  "54541": p("WI", "Laona"),
  "54566": p("WI", "Wabeno"),
  "53518": p("WI", "Blue River"),
  "53554": p("WI", "Livingston"),
  "53569": p("WI", "Montfort"),
  "53573": p("WI", "Muscoda"),
  "53801": p("WI", "Bagley"),
  "53802": p("WI", "Beetown"),
  "53804": p("WI", "Bloomington"),
  "53805": p("WI", "Boscobel"),
  "53806": p("WI", "Cassville"),
  "53807": p("WI", "Cuba City"),
  "53808": p("WI", "Dickeyville"),
  "53809": p("WI", "Fennimore"),
  "53810": p("WI", "Glen Haven"),
  "53811": p("WI", "Hazel Green"),
  "53812": p("WI", "Kieler"),
  "53813": p("WI", "Lancaster"),
  "53816": p("WI", "Mount Hope"),
  "53817": p("WI", "Patch Grove"),
  "53818": p("WI", "Platteville"),
  "53820": p("WI", "Potosi"),
  "53824": p("WI", "Sinsinawa"),
  "53825": p("WI", "Stitzer"),
  "53827": p("WI", "Woodman"),
  "53502": p("WI", "Albany"),
  "53520": p("WI", "Brodhead"),
  "53521": p("WI", "Brooklyn"),
  "53522": p("WI", "Browntown"),
  "53550": p("WI", "Juda"),
  "53566": p("WI", "Monroe"),
  "53570": p("WI", "Monticello"),
  "53574": p("WI", "New Glarus"),
  "53926": p("WI", "Dalton"),
  "53939": p("WI", "Kingston"),
  "53946": p("WI", "Markesan"),
  "53947": p("WI", "Marquette"),
  "54923": p("WI", "Berlin"),
  "54941": p("WI", "Green Lake"),
  "54968": p("WI", "Princeton"),
  "53503": p("WI", "Arena"),
  "53506": p("WI", "Avoca"),
  "53507": p("WI", "Barneveld"),
  "53526": p("WI", "Cobb"),
  "53533": p("WI", "Dodgeville"),
  "53535": p("WI", "Edmund"),
  "53543": p("WI", "Highland"),
  "53544": p("WI", "Hollandale"),
  "53553": p("WI", "Linden"),
  "53565": p("WI", "Mineral Point"),
  "53580": p("WI", "Rewey"),
  "53582": p("WI", "Ridgeway"),
  "53595": p("WI", "Dodgeville"),
  "54525": p("WI", "Gile"),
  "54534": p("WI", "Hurley"),
  "54536": p("WI", "Iron Belt"),
  "54547": p("WI", "Mercer"),
  "54550": p("WI", "Montreal"),
  "54559": p("WI", "Saxon"),
  "54565": p("WI", "Upson"),
  "54611": p("WI", "Alma Center"),
  "54615": p("WI", "Black River Falls"),
  "54635": p("WI", "Hixton"),
  "54642": p("WI", "Melrose"),
  "54643": p("WI", "Millston"),
  "54659": p("WI", "Taylor"),
  "54754": p("WI", "Merrillan"),
  "53036": p("WI", "Ixonia"),
  "53038": p("WI", "Johnson Creek"),
  "53094": p("WI", "Watertown"),
  "53137": p("WI", "Helenville"),
  "53156": p("WI", "Palmyra"),
  "53178": p("WI", "Sullivan"),
  "53538": p("WI", "Fort Atkinson"),
  "53549": p("WI", "Jefferson"),
  "53551": p("WI", "Lake Mills"),
  "53594": p("WI", "Waterloo"),
  "53929": p("WI", "Elroy"),
  "53944": p("WI", "Lyndon Station"),
  "53948": p("WI", "Mauston"),
  "53950": p("WI", "New Lisbon"),
  "53962": p("WI", "Union Center"),
  "53968": p("WI", "Wonewoc"),
  "54618": p("WI", "Camp Douglas"),
  "54637": p("WI", "Hustler"),
  "54641": p("WI", "Mather"),
  "54646": p("WI", "Necedah"),
  "53101": p("WI", "Bassett"),
  "53102": p("WI", "Benet Lake"),
  "53104": p("WI", "Bristol"),
  "53109": p("WI", "Camp Lake"),
  "53140": p("WI", "Kenosha"),
  "53141": p("WI", "Kenosha"),
  "53142": p("WI", "Kenosha"),
  "53143": p("WI", "Kenosha"),
  "53144": p("WI", "Kenosha"),
  "53152": p("WI", "New Munster"),
  "53158": p("WI", "Pleasant Prairie"),
  "53159": p("WI", "Powers Lake"),
  "53168": p("WI", "Salem"),
  "53170": p("WI", "Silver Lake"),
  "53171": p("WI", "Somers"),
  "53179": p("WI", "Trevor"),
  "53181": p("WI", "Twin Lakes"),
  "53192": p("WI", "Wilmot"),
  "53194": p("WI", "Woodworth"),
  "54201": p("WI", "Algoma"),
  "54205": p("WI", "Casco"),
  "54216": p("WI", "Kewaunee"),
  "54217": p("WI", "Luxemburg"),
  "54601": p("WI", "La Crosse"),
  "54602": p("WI", "La Crosse"),
  "54603": p("WI", "La Crosse"),
  "54614": p("WI", "Bangor"),
  "54636": p("WI", "Holmen"),
  "54644": p("WI", "Mindoro"),
  "54650": p("WI", "Onalaska"),
  "54653": p("WI", "Rockland"),
  "54669": p("WI", "West Salem"),
  "53504": p("WI", "Argyle"),
  "53510": p("WI", "Belmont"),
  "53516": p("WI", "Blanchardville"),
  "53530": p("WI", "Darlington"),
  "53541": p("WI", "Gratiot"),
  "53586": p("WI", "Shullsburg"),
  "53587": p("WI", "South Wayne"),
  "53599": p("WI", "Woodford"),
  "53803": p("WI", "Benton"),
  "54409": p("WI", "Antigo"),
  "54418": p("WI", "Bryant"),
  "54424": p("WI", "Deerbrook"),
  "54428": p("WI", "Elcho"),
  "54430": p("WI", "Elton"),
  "54462": p("WI", "Pearson"),
  "54464": p("WI", "Phlox"),
  "54465": p("WI", "Pickerel"),
  "54485": p("WI", "Summit Lake"),
  "54491": p("WI", "White Lake"),
  "54435": p("WI", "Gleason"),
  "54442": p("WI", "Irma"),
  "54452": p("WI", "Merrill"),
  "54487": p("WI", "Tomahawk"),
  "54532": p("WI", "Heafford Junction"),
  "53015": p("WI", "Cleveland"),
  "53042": p("WI", "Kiel"),
  "53063": p("WI", "Newton"),
  "54207": p("WI", "Collins"),
  "54214": p("WI", "Francis Creek"),
  "54215": p("WI", "Kellnersville"),
  "54220": p("WI", "Manitowoc"),
  "54221": p("WI", "Manitowoc"),
  "54227": p("WI", "Maribel"),
  "54228": p("WI", "Mishicot"),
  "54230": p("WI", "Reedsville"),
  "54232": p("WI", "Saint Nazianz"),
  "54240": p("WI", "Tisch Mills"),
  "54241": p("WI", "Two Rivers"),
  "54245": p("WI", "Valders"),
  "54247": p("WI", "Whitelaw"),
  "54401": p("WI", "Wausau"),
  "54402": p("WI", "Wausau"),
  "54403": p("WI", "Wausau"),
  "54408": p("WI", "Aniwa"),
  "54411": p("WI", "Athens"),
  "54417": p("WI", "Brokaw"),
  "54426": p("WI", "Edgar"),
  "54427": p("WI", "Eland"),
  "54429": p("WI", "Elderon"),
  "54432": p("WI", "Galloway"),
  "54440": p("WI", "Hatley"),
  "54448": p("WI", "Marathon"),
  "54455": p("WI", "Mosinee"),
  "54471": p("WI", "Ringle"),
  "54474": p("WI", "Rothschild"),
  "54476": p("WI", "Schofield"),
  "54479": p("WI", "Spencer"),
  "54484": p("WI", "Stratford"),
  "54488": p("WI", "Unity"),
  "54102": p("WI", "Amberg"),
  "54104": p("WI", "Athelstane"),
  "54112": p("WI", "Coleman"),
  "54114": p("WI", "Crivitz"),
  "54119": p("WI", "Dunbar"),
  "54125": p("WI", "Goodman"),
  "54143": p("WI", "Marinette"),
  "54151": p("WI", "Niagara"),
  "54156": p("WI", "Pembine"),
  "54157": p("WI", "Peshtigo"),
  "54159": p("WI", "Porterfield"),
  "54161": p("WI", "Pound"),
  "54177": p("WI", "Wausaukee"),
  "53920": p("WI", "Briggsville"),
  "53930": p("WI", "Endeavor"),
  "53949": p("WI", "Montello"),
  "53952": p("WI", "Oxford"),
  "53953": p("WI", "Packwaukee"),
  "53964": p("WI", "Westfield"),
  "54960": p("WI", "Neshkoro"),
  "54135": p("WI", "Keshena"),
  "54150": p("WI", "Neopit"),
  "53110": p("WI", "Cudahy"),
  "53129": p("WI", "Greendale"),
  "53130": p("WI", "Hales Corners"),
  "53132": p("WI", "Franklin"),
  "53154": p("WI", "Oak Creek"),
  "53172": p("WI", "South Milwaukee"),
  "53201": p("WI", "Milwaukee"),
  "53202": p("WI", "Milwaukee"),
  "53203": p("WI", "Milwaukee"),
  "53204": p("WI", "Milwaukee"),
  "53205": p("WI", "Milwaukee"),
  "53206": p("WI", "Milwaukee"),
  "53207": p("WI", "Milwaukee"),
  "53208": p("WI", "Milwaukee"),
  "53209": p("WI", "Milwaukee"),
  "53210": p("WI", "Milwaukee"),
  "53211": p("WI", "Milwaukee"),
  "53212": p("WI", "Milwaukee"),
  "53213": p("WI", "Milwaukee"),
  "53214": p("WI", "Milwaukee"),
  "53215": p("WI", "Milwaukee"),
  "53216": p("WI", "Milwaukee"),
  "53217": p("WI", "Milwaukee"),
  "53218": p("WI", "Milwaukee"),
  "53219": p("WI", "Milwaukee"),
  "53220": p("WI", "Milwaukee"),
  "53221": p("WI", "Milwaukee"),
  "53222": p("WI", "Milwaukee"),
  "53223": p("WI", "Milwaukee"),
  "53224": p("WI", "Milwaukee"),
  "53225": p("WI", "Milwaukee"),
  "53226": p("WI", "Milwaukee"),
  "53227": p("WI", "Milwaukee"),
  "53228": p("WI", "Milwaukee"),
  "53233": p("WI", "Milwaukee"),
  "53234": p("WI", "Milwaukee"),
  "53235": p("WI", "Saint Francis"),
  "53237": p("WI", "Milwaukee"),
  "53259": p("WI", "Milwaukee"),
  "53263": p("WI", "Milwaukee"),
  "53267": p("WI", "Milwaukee"),
  "53268": p("WI", "Milwaukee"),
  "53274": p("WI", "Milwaukee"),
  "53278": p("WI", "Milwaukee"),
  "53288": p("WI", "Milwaukee"),
  "53290": p("WI", "Milwaukee"),
  "53293": p("WI", "Milwaukee"),
  "53295": p("WI", "Milwaukee"),
  "54619": p("WI", "Cashton"),
  "54620": p("WI", "Cataract"),
  "54638": p("WI", "Kendall"),
  "54648": p("WI", "Norwalk"),
  "54649": p("WI", "Oakdale"),
  "54656": p("WI", "Sparta"),
  "54660": p("WI", "Tomah"),
  "54662": p("WI", "Tunnel City"),
  "54666": p("WI", "Warrens"),
  "54670": p("WI", "Wilton"),
  "54101": p("WI", "Abrams"),
  "54124": p("WI", "Gillett"),
  "54138": p("WI", "Lakewood"),
  "54139": p("WI", "Lena"),
  "54141": p("WI", "Little Suamico"),
  "54149": p("WI", "Mountain"),
  "54153": p("WI", "Oconto"),
  "54154": p("WI", "Oconto Falls"),
  "54171": p("WI", "Sobieski"),
  "54174": p("WI", "Suring"),
  "54175": p("WI", "Townsend"),
  "54463": p("WI", "Pelican Lake"),
  "54501": p("WI", "Rhinelander"),
  "54529": p("WI", "Harshaw"),
  "54531": p("WI", "Hazelhurst"),
  "54539": p("WI", "Lake Tomahawk"),
  "54543": p("WI", "Mc Naughton"),
  "54548": p("WI", "Minocqua"),
  "54562": p("WI", "Three Lakes"),
  "54564": p("WI", "Tripoli"),
  "54568": p("WI", "Woodruff"),
  "54106": p("WI", "Black Creek"),
  "54113": p("WI", "Combined Locks"),
  "54130": p("WI", "Kaukauna"),
  "54131": p("WI", "Freedom"),
  "54136": p("WI", "Kimberly"),
  "54140": p("WI", "Little Chute"),
  "54152": p("WI", "Nichols"),
  "54155": p("WI", "Oneida"),
  "54165": p("WI", "Seymour"),
  "54170": p("WI", "Shiocton"),
  "54911": p("WI", "Appleton"),
  "54912": p("WI", "Appleton"),
  "54913": p("WI", "Appleton"),
  "54914": p("WI", "Appleton"),
  "54915": p("WI", "Appleton"),
  "54919": p("WI", "Appleton"),
  "54922": p("WI", "Bear Creek"),
  "54931": p("WI", "Dale"),
  "54942": p("WI", "Greenville"),
  "54944": p("WI", "Hortonville"),
  "53004": p("WI", "Belgium"),
  "53012": p("WI", "Cedarburg"),
  "53021": p("WI", "Fredonia"),
  "53024": p("WI", "Grafton"),
  "53074": p("WI", "Port Washington"),
  "53080": p("WI", "Saukville"),
  "53092": p("WI", "Mequon"),
  "53097": p("WI", "Mequon"),
  "54721": p("WI", "Arkansaw"),
  "54736": p("WI", "Durand"),
  "54759": p("WI", "Pepin"),
  "54769": p("WI", "Stockholm"),
  "54003": p("WI", "Beldenville"),
  "54010": p("WI", "East Ellsworth"),
  "54011": p("WI", "Ellsworth"),
  "54014": p("WI", "Hager City"),
  "54021": p("WI", "Prescott"),
  "54022": p("WI", "River Falls"),
  "54723": p("WI", "Bay City"),
  "54740": p("WI", "Elmwood"),
  "54750": p("WI", "Maiden Rock"),
  "54761": p("WI", "Plum City"),
  "54767": p("WI", "Spring Valley"),
  "54001": p("WI", "Amery"),
  "54004": p("WI", "Clayton"),
  "54005": p("WI", "Clear Lake"),
  "54006": p("WI", "Cushing"),
  "54009": p("WI", "Dresser"),
  "54020": p("WI", "Osceola"),
  "54024": p("WI", "Saint Croix Falls"),
  "54026": p("WI", "Star Prairie"),
  "54810": p("WI", "Balsam Lake"),
  "54824": p("WI", "Centuria"),
  "54837": p("WI", "Frederic"),
  "54853": p("WI", "Luck"),
  "54858": p("WI", "Milltown"),
  "54406": p("WI", "Amherst"),
  "54407": p("WI", "Amherst Junction"),
  "54423": p("WI", "Custer"),
  "54443": p("WI", "Junction City"),
  "54458": p("WI", "Nelsonville"),
  "54467": p("WI", "Plover"),
  "54473": p("WI", "Rosholt"),
  "54481": p("WI", "Stevens Point"),
  "54482": p("WI", "Stevens Point"),
  "54492": p("WI", "Stevens Point"),
  "54909": p("WI", "Almond"),
  "54921": p("WI", "Bancroft"),
  "54459": p("WI", "Ogema"),
  "54513": p("WI", "Brantwood"),
  "54515": p("WI", "Catawba"),
  "54524": p("WI", "Fifield"),
  "54537": p("WI", "Kennan"),
  "54552": p("WI", "Park Falls"),
  "54555": p("WI", "Phillips"),
  "54556": p("WI", "Prentice"),
  "53105": p("WI", "Burlington"),
  "53108": p("WI", "Caledonia"),
  "53126": p("WI", "Franksville"),
  "53139": p("WI", "Kansasville"),
  "53167": p("WI", "Rochester"),
  "53177": p("WI", "Sturtevant"),
  "53182": p("WI", "Union Grove"),
  "53185": p("WI", "Waterford"),
  "53401": p("WI", "Racine"),
  "53402": p("WI", "Racine"),
  "53403": p("WI", "Racine"),
  "53404": p("WI", "Racine"),
  "53405": p("WI", "Racine"),
  "53406": p("WI", "Racine"),
  "53407": p("WI", "Racine"),
  "53408": p("WI", "Racine"),
  "53540": p("WI", "Gotham"),
  "53556": p("WI", "Lone Rock"),
  "53581": p("WI", "Richland Center"),
  "53584": p("WI", "Sextonville"),
  "53924": p("WI", "Cazenovia"),
  "53501": p("WI", "Afton"),
  "53505": p("WI", "Avalon"),
  "53511": p("WI", "Beloit"),
  "53512": p("WI", "Beloit"),
  "53525": p("WI", "Clinton"),
  "53534": p("WI", "Edgerton"),
  "53536": p("WI", "Evansville"),
  "53537": p("WI", "Footville"),
  "53542": p("WI", "Hanover"),
  "53545": p("WI", "Janesville"),
  "53546": p("WI", "Janesville"),
  "53547": p("WI", "Janesville"),
  "53548": p("WI", "Janesville"),
  "53563": p("WI", "Milton"),
  "53576": p("WI", "Orfordville"),
  "54526": p("WI", "Glen Flora"),
  "54530": p("WI", "Hawkins"),
  "54563": p("WI", "Tony"),
  "54731": p("WI", "Conrath"),
  "54766": p("WI", "Sheldon"),
  "54819": p("WI", "Bruce"),
  "54848": p("WI", "Ladysmith"),
  "54895": p("WI", "Weyerhaeuser"),
  "54002": p("WI", "Baldwin"),
  "54007": p("WI", "Deer Park"),
  "54013": p("WI", "Glenwood City"),
  "54015": p("WI", "Hammond"),
  "54016": p("WI", "Hudson"),
  "54017": p("WI", "New Richmond"),
  "54023": p("WI", "Roberts"),
  "54025": p("WI", "Somerset"),
  "54027": p("WI", "Wilson"),
  "54028": p("WI", "Woodville"),
  "54082": p("WI", "Houlton"),
  "53561": p("WI", "Merrimac"),
  "53577": p("WI", "Plain"),
  "53578": p("WI", "Prairie Du Sac"),
  "53583": p("WI", "Sauk City"),
  "53588": p("WI", "Spring Green"),
  "53913": p("WI", "Baraboo"),
  "53937": p("WI", "Hillpoint"),
  "53940": p("WI", "Lake Delton"),
  "53941": p("WI", "La Valle"),
  "53942": p("WI", "Lime Ridge"),
  "53943": p("WI", "Loganville"),
  "53951": p("WI", "North Freedom"),
  "53958": p("WI", "Reedsburg"),
  "53959": p("WI", "Reedsburg"),
  "53961": p("WI", "Rock Springs"),
  "54828": p("WI", "Couderay"),
  "54834": p("WI", "Edgewater"),
  "54835": p("WI", "Exeland"),
  "54843": p("WI", "Hayward"),
  "54862": p("WI", "Ojibwa"),
  "54867": p("WI", "Radisson"),
  "54876": p("WI", "Stone Lake"),
  "54896": p("WI", "Winter"),
  "54107": p("WI", "Bonduel"),
  "54111": p("WI", "Cecil"),
  "54127": p("WI", "Green Valley"),
  "54128": p("WI", "Gresham"),
  "54137": p("WI", "Krakow"),
  "54166": p("WI", "Shawano"),
  "54182": p("WI", "Zachow"),
  "54414": p("WI", "Birnamwood"),
  "54416": p("WI", "Bowler"),
  "54450": p("WI", "Mattoon"),
  "54486": p("WI", "Tigerton"),
  "54499": p("WI", "Wittenberg"),
  "54928": p("WI", "Caroline"),
  "54948": p("WI", "Leopolis"),
  "54978": p("WI", "Tilleda"),
  "53001": p("WI", "Adell"),
  "53011": p("WI", "Cascade"),
  "53013": p("WI", "Cedar Grove"),
  "53020": p("WI", "Elkhart Lake"),
  "53023": p("WI", "Glenbeulah"),
  "53026": p("WI", "Greenbush"),
  "53031": p("WI", "Hingham"),
  "53044": p("WI", "Kohler"),
  "53070": p("WI", "Oostburg"),
  "53073": p("WI", "Plymouth"),
  "53075": p("WI", "Random Lake"),
  "53081": p("WI", "Sheboygan"),
  "53082": p("WI", "Sheboygan"),
  "53083": p("WI", "Sheboygan"),
  "53085": p("WI", "Sheboygan Falls"),
  "53093": p("WI", "Waldo"),
  "54433": p("WI", "Gilman"),
  "54434": p("WI", "Jump River"),
  "54439": p("WI", "Hannibal"),
  "54447": p("WI", "Lublin"),
  "54451": p("WI", "Medford"),
  "54470": p("WI", "Rib Lake"),
  "54480": p("WI", "Stetsonville"),
  "54490": p("WI", "Westboro"),
  "54612": p("WI", "Arcadia"),
  "54616": p("WI", "Blair"),
  "54625": p("WI", "Dodge"),
  "54627": p("WI", "Ettrick"),
  "54630": p("WI", "Galesville"),
  "54661": p("WI", "Trempealeau"),
  "54738": p("WI", "Eleva"),
  "54747": p("WI", "Independence"),
  "54758": p("WI", "Osseo"),
  "54760": p("WI", "Pigeon Falls"),
  "54770": p("WI", "Strum"),
  "54773": p("WI", "Whitehall"),
  "54621": p("WI", "Chaseburg"),
  "54623": p("WI", "Coon Valley"),
  "54624": p("WI", "De Soto"),
  "54632": p("WI", "Genoa"),
  "54634": p("WI", "Hillsboro"),
  "54639": p("WI", "La Farge"),
  "54651": p("WI", "Ontario"),
  "54652": p("WI", "Readstown"),
  "54658": p("WI", "Stoddard"),
  "54664": p("WI", "Viola"),
  "54665": p("WI", "Viroqua"),
  "54667": p("WI", "Westby"),
  "54512": p("WI", "Boulder Junction"),
  "54519": p("WI", "Conover"),
  "54521": p("WI", "Eagle River"),
  "54538": p("WI", "Lac Du Flambeau"),
  "54540": p("WI", "Land O Lakes"),
  "54545": p("WI", "Manitowish Waters"),
  "54554": p("WI", "Phelps"),
  "54557": p("WI", "Presque Isle"),
  "54558": p("WI", "Saint Germain"),
  "54560": p("WI", "Sayner"),
  "54561": p("WI", "Star Lake"),
  "53114": p("WI", "Darien"),
  "53115": p("WI", "Delavan"),
  "53120": p("WI", "East Troy"),
  "53121": p("WI", "Elkhorn"),
  "53125": p("WI", "Fontana"),
  "53128": p("WI", "Genoa City"),
  "53138": p("WI", "Honey Creek"),
  "53147": p("WI", "Lake Geneva"),
  "53148": p("WI", "Lyons"),
  "53157": p("WI", "Pell Lake"),
  "53176": p("WI", "Springfield"),
  "53184": p("WI", "Walworth"),
  "53190": p("WI", "Whitewater"),
  "53191": p("WI", "Williams Bay"),
  "53195": p("WI", "Zenda"),
  "53585": p("WI", "Sharon"),
  "54801": p("WI", "Spooner"),
  "54817": p("WI", "Birchwood"),
  "54859": p("WI", "Minong"),
  "54870": p("WI", "Sarona"),
  "54871": p("WI", "Shell Lake"),
  "54875": p("WI", "Springbrook"),
  "54888": p("WI", "Trego"),
  "53002": p("WI", "Allenton"),
  "53017": p("WI", "Colgate"),
  "53022": p("WI", "Germantown"),
  "53027": p("WI", "Hartford"),
  "53033": p("WI", "Hubertus"),
  "53037": p("WI", "Jackson"),
  "53040": p("WI", "Kewaskum"),
  "53060": p("WI", "Newburg"),
  "53076": p("WI", "Richfield"),
  "53086": p("WI", "Slinger"),
  "53090": p("WI", "West Bend"),
  "53095": p("WI", "West Bend"),
  "53005": p("WI", "Brookfield"),
  "53007": p("WI", "Butler"),
  "53008": p("WI", "Brookfield"),
  "53018": p("WI", "Delafield"),
  "53029": p("WI", "Hartland"),
  "53045": p("WI", "Brookfield"),
  "53046": p("WI", "Lannon"),
  "53051": p("WI", "Menomonee Falls"),
  "53052": p("WI", "Menomonee Falls"),
  "53056": p("WI", "Merton"),
  "53058": p("WI", "Nashotah"),
  "53064": p("WI", "North Lake"),
  "53066": p("WI", "Oconomowoc"),
  "53069": p("WI", "Okauchee"),
  "53072": p("WI", "Pewaukee"),
  "53089": p("WI", "Sussex"),
  "53103": p("WI", "Big Bend"),
  "53118": p("WI", "Dousman"),
  "53119": p("WI", "Eagle"),
  "53122": p("WI", "Elm Grove"),
  "53127": p("WI", "Genesee Depot"),
  "53146": p("WI", "New Berlin"),
  "53149": p("WI", "Mukwonago"),
  "53150": p("WI", "Muskego"),
  "53151": p("WI", "New Berlin"),
  "53153": p("WI", "North Prairie"),
  "53183": p("WI", "Wales"),
  "53186": p("WI", "Waukesha"),
  "53187": p("WI", "Waukesha"),
  "53188": p("WI", "Waukesha"),
  "53189": p("WI", "Waukesha"),
  "54926": p("WI", "Big Falls"),
  "54929": p("WI", "Clintonville"),
  "54933": p("WI", "Embarrass"),
  "54940": p("WI", "Fremont"),
  "54945": p("WI", "Iola"),
  "54946": p("WI", "King"),
  "54949": p("WI", "Manawa"),
  "54950": p("WI", "Marion"),
  "54961": p("WI", "New London"),
  "54962": p("WI", "Ogdensburg"),
  "54969": p("WI", "Readfield"),
  "54977": p("WI", "Scandinavia"),
  "54981": p("WI", "Waupaca"),
  "54983": p("WI", "Weyauwega"),
  "54990": p("WI", "Iola"),
  "54930": p("WI", "Coloma"),
  "54943": p("WI", "Hancock"),
  "54965": p("WI", "Pine River"),
  "54966": p("WI", "Plainfield"),
  "54967": p("WI", "Poy Sippi"),
  "54970": p("WI", "Redgranite"),
  "54976": p("WI", "Saxeville"),
  "54982": p("WI", "Wautoma"),
  "54984": p("WI", "Wild Rose"),
  "54901": p("WI", "Oshkosh"),
  "54902": p("WI", "Oshkosh"),
  "54903": p("WI", "Oshkosh"),
  "54904": p("WI", "Oshkosh"),
  "54906": p("WI", "Oshkosh"),
  "54927": p("WI", "Butte Des Morts"),
  "54934": p("WI", "Eureka"),
  "54947": p("WI", "Larsen"),
  "54952": p("WI", "Menasha"),
  "54956": p("WI", "Neenah"),
  "54957": p("WI", "Neenah"),
  "54963": p("WI", "Omro"),
  "54964": p("WI", "Pickett"),
  "54980": p("WI", "Waukau"),
  "54985": p("WI", "Winnebago"),
  "54986": p("WI", "Winneconne"),
  "54404": p("WI", "Marshfield"),
  "54410": p("WI", "Arpin"),
  "54412": p("WI", "Auburndale"),
  "54413": p("WI", "Babcock"),
  "54415": p("WI", "Blenker"),
  "54441": p("WI", "Hewitt"),
  "54449": p("WI", "Marshfield"),
  "54454": p("WI", "Milladore"),
  "54457": p("WI", "Nekoosa"),
  "54466": p("WI", "Pittsville"),
  "54469": p("WI", "Port Edwards"),
  "54472": p("WI", "Marshfield"),
  "54475": p("WI", "Rudolph"),
  "54489": p("WI", "Vesper"),
  "54494": p("WI", "Wisconsin Rapids"),
  "54495": p("WI", "Wisconsin Rapids"),
  "26238": p("WV", "Volga"),
  "26250": p("WV", "Belington"),
  "26275": p("WV", "Junior"),
  "26349": p("WV", "Galloway"),
  "26405": p("WV", "Moatsville"),
  "26416": p("WV", "Philippi"),
  "25401": p("WV", "Martinsburg"),
  "25402": p("WV", "Martinsburg"),
  "25403": p("WV", "Martinsburg"),
  "25404": p("WV", "Martinsburg"),
  "25405": p("WV", "Martinsburg"),
  "25413": p("WV", "Bunker Hill"),
  "25419": p("WV", "Falling Waters"),
  "25420": p("WV", "Gerrardstown"),
  "25421": p("WV", "Glengary"),
  "25427": p("WV", "Hedgesville"),
  "25428": p("WV", "Inwood"),
  "25440": p("WV", "Ridgeway"),
  "25009": p("WV", "Ashford"),
  "25021": p("WV", "Bim"),
  "25024": p("WV", "Bloomingrose"),
  "25028": p("WV", "Bob White"),
  "25049": p("WV", "Comfort"),
  "25051": p("WV", "Costa"),
  "25053": p("WV", "Danville"),
  "25081": p("WV", "Foster"),
  "25093": p("WV", "Gordon"),
  "25108": p("WV", "Hewett"),
  "25114": p("WV", "Jeffrey"),
  "25130": p("WV", "Madison"),
  "25142": p("WV", "Nellis"),
  "25148": p("WV", "Orgas"),
  "25149": p("WV", "Ottawa"),
  "25154": p("WV", "Peytona"),
  "25165": p("WV", "Racine"),
  "25169": p("WV", "Ridgeview"),
  "25181": p("WV", "Seth"),
  "25193": p("WV", "Sylvester"),
  "25203": p("WV", "Turtle Creek"),
  "25204": p("WV", "Twilight"),
  "25205": p("WV", "Uneeda"),
  "25206": p("WV", "Van"),
  "25208": p("WV", "Wharton"),
  "25209": p("WV", "Whitesville"),
  "25529": p("WV", "Julian"),
  "26335": p("WV", "Burnsville"),
  "26601": p("WV", "Sutton"),
  "26615": p("WV", "Copen"),
  "26619": p("WV", "Exchange"),
  "26621": p("WV", "Flatwoods"),
  "26623": p("WV", "Frametown"),
  "26624": p("WV", "Gassaway"),
  "26627": p("WV", "Heaters"),
  "26629": p("WV", "Little Birch"),
  "26631": p("WV", "Napier"),
  "26030": p("WV", "Beech Bottom"),
  "26032": p("WV", "Bethany"),
  "26035": p("WV", "Colliers"),
  "26037": p("WV", "Follansbee"),
  "26058": p("WV", "Short Creek"),
  "26070": p("WV", "Wellsburg"),
  "26075": p("WV", "Windsor Heights"),
  "25504": p("WV", "Barboursville"),
  "25510": p("WV", "Culloden"),
  "25537": p("WV", "Lesage"),
  "25541": p("WV", "Milton"),
  "25545": p("WV", "Ona"),
  "25559": p("WV", "Salt Rock"),
  "25701": p("WV", "Huntington"),
  "25702": p("WV", "Huntington"),
  "25703": p("WV", "Huntington"),
  "25704": p("WV", "Huntington"),
  "25705": p("WV", "Huntington"),
  "25706": p("WV", "Huntington"),
  "25707": p("WV", "Huntington"),
  "25708": p("WV", "Huntington"),
  "25710": p("WV", "Huntington"),
  "25711": p("WV", "Huntington"),
  "25712": p("WV", "Huntington"),
  "25713": p("WV", "Huntington"),
  "25714": p("WV", "Huntington"),
  "25715": p("WV", "Huntington"),
  "25716": p("WV", "Huntington"),
  "25717": p("WV", "Huntington"),
  "25718": p("WV", "Huntington"),
  "25719": p("WV", "Huntington"),
  "25720": p("WV", "Huntington"),
  "25721": p("WV", "Huntington"),
  "25722": p("WV", "Huntington"),
  "25723": p("WV", "Huntington"),
  "25724": p("WV", "Huntington"),
  "25725": p("WV", "Huntington"),
  "25726": p("WV", "Huntington"),
  "25727": p("WV", "Huntington"),
  "25728": p("WV", "Huntington"),
  "25729": p("WV", "Huntington"),
  "25755": p("WV", "Huntington"),
  "25770": p("WV", "Huntington"),
  "25771": p("WV", "Huntington"),
  "25772": p("WV", "Huntington"),
  "25773": p("WV", "Huntington"),
  "25774": p("WV", "Huntington"),
  "25775": p("WV", "Huntington"),
  "25776": p("WV", "Huntington"),
  "25777": p("WV", "Huntington"),
  "25778": p("WV", "Huntington"),
  "25779": p("WV", "Huntington"),
  "25234": p("WV", "Arnoldsburg"),
  "25235": p("WV", "Chloe"),
  "25261": p("WV", "Millstone"),
  "25268": p("WV", "Orma"),
  "26136": p("WV", "Big Bend"),
  "26137": p("WV", "Big Springs"),
  "26147": p("WV", "Grantsville"),
  "26151": p("WV", "Mount Zion"),
  "25019": p("WV", "Bickmore"),
  "25030": p("WV", "Bomont"),
  "25043": p("WV", "Clay"),
  "25063": p("WV", "Duck"),
  "25088": p("WV", "Glen"),
  "25111": p("WV", "Indore"),
  "25113": p("WV", "Ivydale"),
  "25125": p("WV", "Lizemores"),
  "25133": p("WV", "Maysel"),
  "25141": p("WV", "Nebo"),
  "25164": p("WV", "Procious"),
  "25211": p("WV", "Widen"),
  "25285": p("WV", "Wallback"),
  "26617": p("WV", "Dille"),
  "26339": p("WV", "Center Point"),
  "26411": p("WV", "New Milton"),
  "26436": p("WV", "Smithburg"),
  "26456": p("WV", "West Union"),
  "25002": p("WV", "Alloy"),
  "25031": p("WV", "Boomer"),
  "25036": p("WV", "Cannelton"),
  "25040": p("WV", "Charlton Heights"),
  "25057": p("WV", "Deep Water"),
  "25085": p("WV", "Gauley Bridge"),
  "25090": p("WV", "Glen Ferris"),
  "25115": p("WV", "Kanawha Falls"),
  "25118": p("WV", "Kimberly"),
  "25119": p("WV", "Kincaid"),
  "25136": p("WV", "Montgomery"),
  "25139": p("WV", "Mount Carbon"),
  "25152": p("WV", "Page"),
  "25161": p("WV", "Powellton"),
  "25173": p("WV", "Robson"),
  "25185": p("WV", "Mount Olive"),
  "25186": p("WV", "Smithers"),
  "25812": p("WV", "Ansted"),
  "25831": p("WV", "Danese"),
  "25833": p("WV", "Dothan"),
  "25837": p("WV", "Edmond"),
  "25840": p("WV", "Fayetteville"),
  "25846": p("WV", "Glen Jean"),
  "25854": p("WV", "Hico"),
  "25855": p("WV", "Hilltop"),
  "25862": p("WV", "Lansing"),
  "25864": p("WV", "Layland"),
  "25866": p("WV", "Lochgelly"),
  "25868": p("WV", "Lookout"),
  "25879": p("WV", "Minden"),
  "25880": p("WV", "Mount Hope"),
  "25888": p("WV", "Mount Hope"),
  "25901": p("WV", "Oak Hill"),
  "25904": p("WV", "Pax"),
  "25907": p("WV", "Prince"),
  "25917": p("WV", "Scarbro"),
  "25936": p("WV", "Thurmond"),
  "25938": p("WV", "Victor"),
  "25942": p("WV", "Winona"),
  "25976": p("WV", "Meadow Bridge"),
  "25986": p("WV", "Spring Dale"),
  "26680": p("WV", "Nallen"),
  "25267": p("WV", "Normantown"),
  "26342": p("WV", "Coxs Mills"),
  "26351": p("WV", "Glenville"),
  "26384": p("WV", "Linn"),
  "26430": p("WV", "Sand Fork"),
  "26443": p("WV", "Troy"),
  "26611": p("WV", "Cedarville"),
  "26636": p("WV", "Rosedale"),
  "26638": p("WV", "Shock"),
  "26707": p("WV", "Bayard"),
  "26720": p("WV", "Gormania"),
  "26731": p("WV", "Lahmansville"),
  "26739": p("WV", "Mount Storm"),
  "26833": p("WV", "Maysville"),
  "26847": p("WV", "Petersburg"),
  "26855": p("WV", "Cabins"),
  "24901": p("WV", "Lewisburg"),
  "24902": p("WV", "Fairlea"),
  "24910": p("WV", "Alderson"),
  "24916": p("WV", "Asbury"),
  "24925": p("WV", "Caldwell"),
  "24931": p("WV", "Crawley"),
  "24938": p("WV", "Frankford"),
  "24943": p("WV", "Grassy Meadows"),
  "24957": p("WV", "Maxwelton"),
  "24966": p("WV", "Renick"),
  "24970": p("WV", "Ronceverte"),
  "24977": p("WV", "Smoot"),
  "24986": p("WV", "White Sulphur Springs"),
  "24991": p("WV", "Williamsburg"),
  "25958": p("WV", "Charmco"),
  "25962": p("WV", "Rainelle"),
  "25972": p("WV", "Leslie"),
  "25981": p("WV", "Quinwood"),
  "25984": p("WV", "Rupert"),
  "25431": p("WV", "Levels"),
  "25437": p("WV", "Points"),
  "25444": p("WV", "Slanesville"),
  "26704": p("WV", "Augusta"),
  "26711": p("WV", "Capon Bridge"),
  "26714": p("WV", "Delray"),
  "26722": p("WV", "Green Spring"),
  "26755": p("WV", "Rio"),
  "26757": p("WV", "Romney"),
  "26761": p("WV", "Shanks"),
  "26763": p("WV", "Springfield"),
  "26808": p("WV", "High View"),
  "26817": p("WV", "Bloomery"),
  "26823": p("WV", "Capon Springs"),
  "26852": p("WV", "Purgitsville"),
  "26865": p("WV", "Yellow Spring"),
  "26034": p("WV", "Chester"),
  "26047": p("WV", "New Cumberland"),
  "26050": p("WV", "Newell"),
  "26056": p("WV", "New Manchester"),
  "26062": p("WV", "Weirton"),
  "26801": p("WV", "Baker"),
  "26810": p("WV", "Lost City"),
  "26812": p("WV", "Mathias"),
  "26818": p("WV", "Fisher"),
  "26836": p("WV", "Moorefield"),
  "26838": p("WV", "Milam"),
  "26845": p("WV", "Old Fields"),
  "26851": p("WV", "Wardensville"),
  "26301": p("WV", "Clarksburg"),
  "26302": p("WV", "Clarksburg"),
  "26306": p("WV", "Clarksburg"),
  "26323": p("WV", "Anmoore"),
  "26330": p("WV", "Bridgeport"),
  "26361": p("WV", "Gypsy"),
  "26366": p("WV", "Haywood"),
  "26369": p("WV", "Hepzibah"),
  "26385": p("WV", "Lost Creek"),
  "26386": p("WV", "Lumberport"),
  "26404": p("WV", "Meadowbrook"),
  "26408": p("WV", "Mount Clare"),
  "26422": p("WV", "Reynoldsville"),
  "26426": p("WV", "Salem"),
  "26431": p("WV", "Shinnston"),
  "26438": p("WV", "Spelter"),
  "26448": p("WV", "Wallace"),
  "26451": p("WV", "West Milford"),
  "26463": p("WV", "Wyatt"),
  "26568": p("WV", "Enterprise"),
  "25231": p("WV", "Advent"),
  "25239": p("WV", "Cottageville"),
  "25241": p("WV", "Evans"),
  "25244": p("WV", "Gay"),
  "25245": p("WV", "Given"),
  "25248": p("WV", "Kenna"),
  "25252": p("WV", "Le Roy"),
  "25262": p("WV", "Millwood"),
  "25264": p("WV", "Mount Alto"),
  "25271": p("WV", "Ripley"),
  "25275": p("WV", "Sandyville"),
  "26164": p("WV", "Ravenswood"),
  "25410": p("WV", "Bakerton"),
  "25414": p("WV", "Charles Town"),
  "25423": p("WV", "Halltown"),
  "25425": p("WV", "Harpers Ferry"),
  "25430": p("WV", "Kearneysville"),
  "25432": p("WV", "Millville"),
  "25438": p("WV", "Ranson"),
  "25441": p("WV", "Rippon"),
  "25442": p("WV", "Shenandoah Junction"),
  "25443": p("WV", "Shepherdstown"),
  "25446": p("WV", "Summit Point"),
  "25003": p("WV", "Alum Creek"),
  "25015": p("WV", "Belle"),
  "25025": p("WV", "Blount"),
  "25026": p("WV", "Blue Creek"),
  "25035": p("WV", "Cabin Creek"),
  "25039": p("WV", "Cedar Grove"),
  "25045": p("WV", "Clendenin"),
  "25054": p("WV", "Dawes"),
  "25061": p("WV", "Drybranch"),
  "25064": p("WV", "Dunbar"),
  "25067": p("WV", "East Bank"),
  "25071": p("WV", "Elkview"),
  "25075": p("WV", "Eskdale"),
  "25079": p("WV", "Falling Rock"),
  "25083": p("WV", "Gallagher"),
  "25086": p("WV", "Glasgow"),
  "25102": p("WV", "Handley"),
  "25103": p("WV", "Hansford"),
  "25107": p("WV", "Hernshaw"),
  "25110": p("WV", "Hugheston"),
  "25112": p("WV", "Institute"),
  "25126": p("WV", "London"),
  "25132": p("WV", "Mammoth"),
  "25134": p("WV", "Miami"),
  "25143": p("WV", "Nitro"),
  "25156": p("WV", "Pinch"),
  "25160": p("WV", "Pond Gap"),
  "25162": p("WV", "Pratt"),
  "25177": p("WV", "Saint Albans"),
  "25201": p("WV", "Tad"),
  "25202": p("WV", "Tornado"),
  "25214": p("WV", "Winifrede"),
  "25301": p("WV", "Charleston"),
  "25302": p("WV", "Charleston"),
  "25303": p("WV", "South Charleston"),
  "25304": p("WV", "Charleston"),
  "25305": p("WV", "Charleston"),
  "25306": p("WV", "Charleston"),
  "25309": p("WV", "South Charleston"),
  "25311": p("WV", "Charleston"),
  "25312": p("WV", "Charleston"),
  "25313": p("WV", "Charleston"),
  "25314": p("WV", "Charleston"),
  "25315": p("WV", "Charleston"),
  "25317": p("WV", "Charleston"),
  "25320": p("WV", "Charleston"),
  "25321": p("WV", "Charleston"),
  "25322": p("WV", "Charleston"),
  "25323": p("WV", "Charleston"),
  "25324": p("WV", "Charleston"),
  "25325": p("WV", "Charleston"),
  "25326": p("WV", "Charleston"),
  "25327": p("WV", "Charleston"),
  "25328": p("WV", "Charleston"),
  "25329": p("WV", "Charleston"),
  "25330": p("WV", "Charleston"),
  "25331": p("WV", "Charleston"),
  "25332": p("WV", "Charleston"),
  "25333": p("WV", "Charleston"),
  "25334": p("WV", "Charleston"),
  "25335": p("WV", "Charleston"),
  "25336": p("WV", "Charleston"),
  "25337": p("WV", "Charleston"),
  "25338": p("WV", "Charleston"),
  "25339": p("WV", "Charleston"),
  "25350": p("WV", "Charleston"),
  "25356": p("WV", "Charleston"),
  "25357": p("WV", "Charleston"),
  "25358": p("WV", "Charleston"),
  "25360": p("WV", "Charleston"),
  "25361": p("WV", "Charleston"),
  "25362": p("WV", "Charleston"),
  "25364": p("WV", "Charleston"),
  "25365": p("WV", "Charleston"),
  "25375": p("WV", "Charleston"),
  "25387": p("WV", "Charleston"),
  "25389": p("WV", "Charleston"),
  "25392": p("WV", "Charleston"),
  "25396": p("WV", "Charleston"),
  "26321": p("WV", "Alum Bridge"),
  "26338": p("WV", "Camden"),
  "26343": p("WV", "Crawford"),
  "26372": p("WV", "Horner"),
  "26376": p("WV", "Ireland"),
  "26378": p("WV", "Jane Lew"),
  "26412": p("WV", "Orlando"),
  "26447": p("WV", "Walkersville"),
  "26452": p("WV", "Weston"),
  "25501": p("WV", "Alkol"),
  "25506": p("WV", "Branchland"),
  "25521": p("WV", "Griffithsville"),
  "25523": p("WV", "Hamlin"),
  "25524": p("WV", "Harts"),
  "25540": p("WV", "Midkiff"),
  "25544": p("WV", "Myra"),
  "25557": p("WV", "Ranger"),
  "25564": p("WV", "Sod"),
  "25565": p("WV", "Spurlockville"),
  "25567": p("WV", "Sumerco"),
  "25571": p("WV", "West Hamlin"),
  "25572": p("WV", "Woodville"),
  "25573": p("WV", "Yawkey"),
  "25022": p("WV", "Blair"),
  "25047": p("WV", "Clothier"),
  "25076": p("WV", "Ethel"),
  "25121": p("WV", "Lake"),
  "25183": p("WV", "Sharples"),
  "25505": p("WV", "Big Creek"),
  "25508": p("WV", "Chapmanville"),
  "25547": p("WV", "Pecks Mill"),
  "25601": p("WV", "Logan"),
  "25606": p("WV", "Accoville"),
  "25607": p("WV", "Amherstdale"),
  "25611": p("WV", "Bruno"),
  "25612": p("WV", "Chauncey"),
  "25614": p("WV", "Cora"),
  "25617": p("WV", "Davin"),
  "25624": p("WV", "Henlawson"),
  "25625": p("WV", "Holden"),
  "25628": p("WV", "Kistler"),
  "25630": p("WV", "Lorado"),
  "25632": p("WV", "Lyburn"),
  "25634": p("WV", "Mallory"),
  "25635": p("WV", "Man"),
  "25637": p("WV", "Mount Gay"),
  "25638": p("WV", "Omar"),
  "25639": p("WV", "Peach Creek"),
  "25644": p("WV", "Sarah Ann"),
  "25646": p("WV", "Stollings"),
  "25647": p("WV", "Switzer"),
  "25649": p("WV", "Verdunville"),
  "25652": p("WV", "Whitman"),
  "25653": p("WV", "Wilkinson"),
  "25654": p("WV", "Yolyn"),
  "24801": p("WV", "Welch"),
  "24808": p("WV", "Anawalt"),
  "24811": p("WV", "Avondale"),
  "24813": p("WV", "Bartley"),
  "24815": p("WV", "Berwind"),
  "24816": p("WV", "Big Sandy"),
  "24817": p("WV", "Bradshaw"),
  "24826": p("WV", "Cucumber"),
  "24828": p("WV", "Davy"),
  "24829": p("WV", "Eckman"),
  "24830": p("WV", "Elbert"),
  "24831": p("WV", "Elkhorn"),
  "24836": p("WV", "Gary"),
  "24843": p("WV", "Hensley"),
  "24844": p("WV", "Iaeger"),
  "24846": p("WV", "Isaban"),
  "24848": p("WV", "Jenkinjones"),
  "24850": p("WV", "Jolo"),
  "24853": p("WV", "Kimball"),
  "24855": p("WV", "Kyle"),
  "24861": p("WV", "Maybeury"),
  "24862": p("WV", "Mohawk"),
  "24866": p("WV", "Newhall"),
  "24868": p("WV", "Northfork"),
  "24871": p("WV", "Pageton"),
  "24872": p("WV", "Panther"),
  "24873": p("WV", "Paynesville"),
  "24878": p("WV", "Premier"),
  "24879": p("WV", "Raysal"),
  "24881": p("WV", "Roderfield"),
  "24884": p("WV", "Squire"),
  "24887": p("WV", "Switchback"),
  "24888": p("WV", "Thorpe"),
  "24892": p("WV", "War"),
  "24894": p("WV", "Warriormine"),
  "24895": p("WV", "Wilcoe"),
  "26554": p("WV", "Fairmont"),
  "26555": p("WV", "Fairmont"),
  "26559": p("WV", "Barrackville"),
  "26560": p("WV", "Baxter"),
  "26563": p("WV", "Carolina"),
  "26566": p("WV", "Colfax"),
  "26570": p("WV", "Fairview"),
  "26571": p("WV", "Farmington"),
  "26572": p("WV", "Four States"),
  "26574": p("WV", "Grant Town"),
  "26576": p("WV", "Idamay"),
  "26578": p("WV", "Kingmont"),
  "26582": p("WV", "Mannington"),
  "26585": p("WV", "Metz"),
  "26586": p("WV", "Montana Mines"),
  "26587": p("WV", "Rachel"),
  "26588": p("WV", "Rivesville"),
  "26591": p("WV", "Worthington"),
  "26031": p("WV", "Benwood"),
  "26033": p("WV", "Cameron"),
  "26036": p("WV", "Dallas"),
  "26038": p("WV", "Glen Dale"),
  "26039": p("WV", "Glen Easton"),
  "26040": p("WV", "Mcmechen"),
  "26041": p("WV", "Moundsville"),
  "26055": p("WV", "Proctor"),
  "25106": p("WV", "Henderson"),
  "25123": p("WV", "Leon"),
  "25187": p("WV", "Southside"),
  "25247": p("WV", "Hartford"),
  "25253": p("WV", "Letart"),
  "25260": p("WV", "Mason"),
  "25265": p("WV", "New Haven"),
  "25287": p("WV", "West Columbia"),
  "25502": p("WV", "Apple Grove"),
  "25503": p("WV", "Ashton"),
  "25515": p("WV", "Gallipolis Ferry"),
  "25520": p("WV", "Glenwood"),
  "25550": p("WV", "Point Pleasant"),
  "24701": p("WV", "Bluefield"),
  "24712": p("WV", "Athens"),
  "24714": p("WV", "Beeson"),
  "24715": p("WV", "Bramwell"),
  "24724": p("WV", "Freeman"),
  "24729": p("WV", "Hiawatha"),
  "24731": p("WV", "Kegley"),
  "24732": p("WV", "Kellysville"),
  "24733": p("WV", "Lashmeet"),
  "24736": p("WV", "Matoaka"),
  "24737": p("WV", "Montcalm"),
  "24738": p("WV", "Nemours"),
  "24739": p("WV", "Princeton"),
  "24740": p("WV", "Princeton"),
  "24747": p("WV", "Rock"),
  "24751": p("WV", "Wolfe"),
  "25820": p("WV", "Camp Creek"),
  "25841": p("WV", "Flat Top"),
  "25922": p("WV", "Spanishburg"),
  "25971": p("WV", "Lerona"),
  "26710": p("WV", "Burlington"),
  "26717": p("WV", "Elk Garden"),
  "26719": p("WV", "Fort Ashby"),
  "26726": p("WV", "Keyser"),
  "26743": p("WV", "New Creek"),
  "26750": p("WV", "Piedmont"),
  "26753": p("WV", "Ridgeley"),
  "26767": p("WV", "Wiley Ford"),
  "24851": p("WV", "Justice"),
  "25608": p("WV", "Baisden"),
  "25621": p("WV", "Gilbert"),
  "25650": p("WV", "Verner"),
  "25651": p("WV", "Wharncliffe"),
  "25661": p("WV", "Williamson"),
  "25665": p("WV", "Borderland"),
  "25666": p("WV", "Breeden"),
  "25667": p("WV", "Chattaroy"),
  "25670": p("WV", "Delbarton"),
  "25671": p("WV", "Dingess"),
  "25672": p("WV", "Edgarton"),
  "25674": p("WV", "Kermit"),
  "25676": p("WV", "Lenore"),
  "25678": p("WV", "Matewan"),
  "25685": p("WV", "Naugatuck"),
  "25686": p("WV", "Newtown"),
  "25688": p("WV", "North Matewan"),
  "25690": p("WV", "Ragland"),
  "25691": p("WV", "Rawl"),
  "25692": p("WV", "Red Jacket"),
  "25696": p("WV", "Varney"),
  "26501": p("WV", "Morgantown"),
  "26502": p("WV", "Morgantown"),
  "26504": p("WV", "Morgantown"),
  "26505": p("WV", "Morgantown"),
  "26506": p("WV", "Morgantown"),
  "26507": p("WV", "Morgantown"),
  "26508": p("WV", "Morgantown"),
  "26521": p("WV", "Blacksville"),
  "26527": p("WV", "Cassville"),
  "26531": p("WV", "Dellslow"),
  "26534": p("WV", "Granville"),
  "26541": p("WV", "Maidsville"),
  "26543": p("WV", "Osage"),
  "26544": p("WV", "Pentress"),
  "26546": p("WV", "Pursglove"),
  "26590": p("WV", "Wana"),
  "24918": p("WV", "Ballard"),
  "24941": p("WV", "Gap Mills"),
  "24945": p("WV", "Greenville"),
  "24951": p("WV", "Lindside"),
  "24963": p("WV", "Peterstown"),
  "24974": p("WV", "Secondcreek"),
  "24976": p("WV", "Sinks Grove"),
  "24983": p("WV", "Union"),
  "24984": p("WV", "Waiteville"),
  "24985": p("WV", "Wayside"),
  "24993": p("WV", "Wolfcreek"),
  "25411": p("WV", "Berkeley Springs"),
  "25422": p("WV", "Great Cacapon"),
  "25434": p("WV", "Paw Paw"),
  "25059": p("WV", "Dixie"),
  "26202": p("WV", "Fenwick"),
  "26205": p("WV", "Craigsville"),
  "26261": p("WV", "Richwood"),
  "26610": p("WV", "Birch River"),
  "26651": p("WV", "Summersville"),
  "26656": p("WV", "Belva"),
  "26660": p("WV", "Calvin"),
  "26662": p("WV", "Canvas"),
  "26667": p("WV", "Drennen"),
  "26671": p("WV", "Gilboa"),
  "26675": p("WV", "Keslers Cross Lanes"),
  "26676": p("WV", "Leivasy"),
  "26678": p("WV", "Mount Lookout"),
  "26679": p("WV", "Mount Nebo"),
  "26681": p("WV", "Nettie"),
  "26684": p("WV", "Pool"),
  "26690": p("WV", "Swiss"),
  "26691": p("WV", "Tioga"),
  "26003": p("WV", "Wheeling"),
  "26059": p("WV", "Triadelphia"),
  "26060": p("WV", "Valley Grove"),
  "26074": p("WV", "West Liberty"),
  "26802": p("WV", "Brandywine"),
  "26804": p("WV", "Circleville"),
  "26807": p("WV", "Franklin"),
  "26814": p("WV", "Riverton"),
  "26815": p("WV", "Sugar Grove"),
  "26866": p("WV", "Upper Tract"),
  "26884": p("WV", "Seneca Rocks"),
  "26886": p("WV", "Onego"),
  "26134": p("WV", "Belmont"),
  "26170": p("WV", "Saint Marys"),
  "24915": p("WV", "Arbovale"),
  "24920": p("WV", "Bartow"),
  "24924": p("WV", "Buckeye"),
  "24927": p("WV", "Cass"),
  "24934": p("WV", "Dunmore"),
  "24944": p("WV", "Green Bank"),
  "24946": p("WV", "Hillsboro"),
  "24954": p("WV", "Marlinton"),
  "26209": p("WV", "Snowshoe"),
  "26264": p("WV", "Durbin"),
  "26291": p("WV", "Slatyfork"),
  "26374": p("WV", "Independence"),
  "26410": p("WV", "Newburg"),
  "26425": p("WV", "Rowlesburg"),
  "26444": p("WV", "Tunnelton"),
  "26519": p("WV", "Albright"),
  "26520": p("WV", "Arthurdale"),
  "26524": p("WV", "Bretz"),
  "26525": p("WV", "Bruceton Mills"),
  "26537": p("WV", "Kingwood"),
  "26542": p("WV", "Masontown"),
  "26547": p("WV", "Reedsville"),
  "26705": p("WV", "Aurora"),
  "26716": p("WV", "Eglon"),
  "26764": p("WV", "Terra Alta"),
  "25011": p("WV", "Bancroft"),
  "25033": p("WV", "Buffalo"),
  "25070": p("WV", "Eleanor"),
  "25082": p("WV", "Fraziers Bottom"),
  "25109": p("WV", "Hometown"),
  "25124": p("WV", "Liberty"),
  "25159": p("WV", "Poca"),
  "25168": p("WV", "Red House"),
  "25213": p("WV", "Winfield"),
  "25526": p("WV", "Hurricane"),
  "25560": p("WV", "Scott Depot"),
  "25569": p("WV", "Teays"),
  "25007": p("WV", "Arnett"),
  "25008": p("WV", "Artie"),
  "25044": p("WV", "Clear Creek"),
  "25048": p("WV", "Colcord"),
  "25060": p("WV", "Dorothy"),
  "25062": p("WV", "Dry Creek"),
  "25140": p("WV", "Naoma"),
  "25174": p("WV", "Rock Creek"),
  "25180": p("WV", "Saxon"),
  "25801": p("WV", "Beckley"),
  "25802": p("WV", "Beckley"),
  "25813": p("WV", "Beaver"),
  "25817": p("WV", "Bolt"),
  "25818": p("WV", "Bradley"),
  "25823": p("WV", "Coal City"),
  "25825": p("WV", "Cool Ridge"),
  "25827": p("WV", "Crab Orchard"),
  "25832": p("WV", "Daniels"),
  "25836": p("WV", "Eccles"),
  "25839": p("WV", "Fairdale"),
  "25843": p("WV", "Ghent"),
  "25844": p("WV", "Glen Daniel"),
  "25849": p("WV", "Glen White"),
  "25851": p("WV", "Harper"),
  "25853": p("WV", "Helen"),
  "25857": p("WV", "Josephine"),
  "25860": p("WV", "Lanark"),
  "25865": p("WV", "Lester"),
  "25871": p("WV", "Mabscott"),
  "25873": p("WV", "Mac Arthur"),
  "25878": p("WV", "Midway"),
  "25902": p("WV", "Odd"),
  "25906": p("WV", "Piney View"),
  "25908": p("WV", "Princewick"),
  "25909": p("WV", "Prosperity"),
  "25911": p("WV", "Raleigh"),
  "25915": p("WV", "Rhodell"),
  "25918": p("WV", "Shady Spring"),
  "25919": p("WV", "Skelton"),
  "25920": p("WV", "Slab Fork"),
  "25921": p("WV", "Sophia"),
  "25927": p("WV", "Stanaford"),
  "25932": p("WV", "Surveyor"),
  "25989": p("WV", "White Oak"),
  "26224": p("WV", "Helvetia"),
  "26230": p("WV", "Pickens"),
  "26241": p("WV", "Elkins"),
  "26253": p("WV", "Beverly"),
  "26254": p("WV", "Bowden"),
  "26257": p("WV", "Coalton"),
  "26259": p("WV", "Dailey"),
  "26263": p("WV", "Dryfork"),
  "26267": p("WV", "Ellamore"),
  "26268": p("WV", "Glady"),
  "26270": p("WV", "Harman"),
  "26273": p("WV", "Huttonsville"),
  "26276": p("WV", "Kerens"),
  "26278": p("WV", "Mabie"),
  "26280": p("WV", "Mill Creek"),
  "26282": p("WV", "Monterville"),
  "26283": p("WV", "Montrose"),
  "26285": p("WV", "Norton"),
  "26293": p("WV", "Valley Bend"),
  "26294": p("WV", "Valley Head"),
  "26296": p("WV", "Whitmer"),
  "26148": p("WV", "Macfarlan"),
  "26161": p("WV", "Petroleum"),
  "26178": p("WV", "Smithville"),
  "26325": p("WV", "Auburn"),
  "26327": p("WV", "Berea"),
  "26337": p("WV", "Cairo"),
  "26346": p("WV", "Ellenboro"),
  "26362": p("WV", "Harrisville"),
  "26415": p("WV", "Pennsboro"),
  "26421": p("WV", "Pullman"),
  "25005": p("WV", "Amma"),
  "25243": p("WV", "Gandeeville"),
  "25251": p("WV", "Left Hand"),
  "25259": p("WV", "Looneyville"),
  "25266": p("WV", "Newton"),
  "25270": p("WV", "Reedy"),
  "25276": p("WV", "Spencer"),
  "25286": p("WV", "Walton"),
  "24935": p("WV", "Forest Hill"),
  "24962": p("WV", "Pence Springs"),
  "24981": p("WV", "Talcott"),
  "25951": p("WV", "Hinton"),
  "25966": p("WV", "Green Sulphur Springs"),
  "25969": p("WV", "Jumping Branch"),
  "25977": p("WV", "Meadow Creek"),
  "25978": p("WV", "Nimitz"),
  "25979": p("WV", "Pipestem"),
  "25985": p("WV", "Sandstone"),
  "26347": p("WV", "Flemington"),
  "26354": p("WV", "Grafton"),
  "26424": p("WV", "Rosemont"),
  "26435": p("WV", "Simpson"),
  "26440": p("WV", "Thornton"),
  "26260": p("WV", "Davis"),
  "26269": p("WV", "Hambleton"),
  "26271": p("WV", "Hendricks"),
  "26287": p("WV", "Parsons"),
  "26289": p("WV", "Red Creek"),
  "26292": p("WV", "Thomas"),
  "26146": p("WV", "Friendly"),
  "26149": p("WV", "Middlebourne"),
  "26175": p("WV", "Sistersville"),
  "26320": p("WV", "Alma"),
  "26434": p("WV", "Shirley"),
  "26201": p("WV", "Buckhannon"),
  "26210": p("WV", "Adrian"),
  "26215": p("WV", "Cleveland"),
  "26218": p("WV", "French Creek"),
  "26219": p("WV", "Frenchton"),
  "26228": p("WV", "Kanawha Head"),
  "26229": p("WV", "Lorentz"),
  "26234": p("WV", "Rock Cave"),
  "26236": p("WV", "Selbyville"),
  "26237": p("WV", "Tallmansville"),
  "25507": p("WV", "Ceredo"),
  "25511": p("WV", "Dunlow"),
  "25512": p("WV", "East Lynn"),
  "25514": p("WV", "Fort Gay"),
  "25517": p("WV", "Genoa"),
  "25530": p("WV", "Kenova"),
  "25534": p("WV", "Kiahsville"),
  "25535": p("WV", "Lavalette"),
  "25555": p("WV", "Prichard"),
  "25562": p("WV", "Shoals"),
  "25570": p("WV", "Wayne"),
  "25669": p("WV", "Crum"),
  "25699": p("WV", "Wilsondale"),
  "25709": p("WV", "Huntington"),
  "26203": p("WV", "Erbacon"),
  "26206": p("WV", "Cowen"),
  "26208": p("WV", "Camden On Gauley"),
  "26217": p("WV", "Diana"),
  "26222": p("WV", "Hacker Valley"),
  "26266": p("WV", "Upperglade"),
  "26288": p("WV", "Webster Springs"),
  "26298": p("WV", "Bergoo"),
  "26155": p("WV", "New Martinsville"),
  "26159": p("WV", "Paden City"),
  "26162": p("WV", "Porters Falls"),
  "26167": p("WV", "Reader"),
  "26348": p("WV", "Folsom"),
  "26377": p("WV", "Jacksonburg"),
  "26419": p("WV", "Pine Grove"),
  "26437": p("WV", "Smithfield"),
  "26561": p("WV", "Big Run"),
  "26562": p("WV", "Burton"),
  "26575": p("WV", "Hundred"),
  "26581": p("WV", "Littleton"),
  "26138": p("WV", "Brohard"),
  "26141": p("WV", "Creston"),
  "26143": p("WV", "Elizabeth"),
  "26152": p("WV", "Munday"),
  "26160": p("WV", "Palestine"),
  "26101": p("WV", "Parkersburg"),
  "26102": p("WV", "Parkersburg"),
  "26103": p("WV", "Parkersburg"),
  "26104": p("WV", "Parkersburg"),
  "26105": p("WV", "Vienna"),
  "26106": p("WV", "Parkersburg"),
  "26120": p("WV", "Mineral Wells"),
  "26121": p("WV", "Mineral Wells"),
  "26133": p("WV", "Belleville"),
  "26142": p("WV", "Davisville"),
  "26150": p("WV", "Mineral Wells"),
  "26169": p("WV", "Rockport"),
  "26180": p("WV", "Walker"),
  "26181": p("WV", "Washington"),
  "26184": p("WV", "Waverly"),
  "26187": p("WV", "Williamstown"),
  "24716": p("WV", "Bud"),
  "24719": p("WV", "Covel"),
  "24726": p("WV", "Herndon"),
  "24818": p("WV", "Brenton"),
  "24822": p("WV", "Clear Fork"),
  "24823": p("WV", "Coal Mountain"),
  "24827": p("WV", "Cyclone"),
  "24834": p("WV", "Fanrock"),
  "24839": p("WV", "Hanover"),
  "24845": p("WV", "Ikes Fork"),
  "24847": p("WV", "Itmann"),
  "24849": p("WV", "Jesse"),
  "24854": p("WV", "Kopperston"),
  "24857": p("WV", "Lynco"),
  "24859": p("WV", "Marianna"),
  "24860": p("WV", "Matheny"),
  "24867": p("WV", "New Richmond"),
  "24869": p("WV", "North Spring"),
  "24870": p("WV", "Oceana"),
  "24874": p("WV", "Pineville"),
  "24880": p("WV", "Rock View"),
  "24882": p("WV", "Simon"),
  "24898": p("WV", "Wyoming"),
  "25810": p("WV", "Allen Junction"),
  "25811": p("WV", "Amigo"),
  "25826": p("WV", "Corinne"),
  "25845": p("WV", "Glen Fork"),
  "25848": p("WV", "Glen Rogers"),
  "25870": p("WV", "Maben"),
  "25875": p("WV", "Mc Graws"),
  "25876": p("WV", "Saulsville"),
  "25882": p("WV", "Mullens"),
  "25913": p("WV", "Ravencliff"),
  "25916": p("WV", "Sabine"),
  "25928": p("WV", "Stephenson"),
  "25943": p("WV", "Wyco"),
  "82051": p("WY", "Bosler"),
  "82052": p("WY", "Buford"),
  "82055": p("WY", "Centennial"),
  "82058": p("WY", "Garrett"),
  "82063": p("WY", "Jelm"),
  "82070": p("WY", "Laramie"),
  "82071": p("WY", "Laramie"),
  "82072": p("WY", "Laramie"),
  "82073": p("WY", "Laramie"),
  "82083": p("WY", "Rock River"),
  "82084": p("WY", "Tie Siding"),
  "82410": p("WY", "Basin"),
  "82411": p("WY", "Burlington"),
  "82412": p("WY", "Byron"),
  "82420": p("WY", "Cowley"),
  "82421": p("WY", "Deaver"),
  "82422": p("WY", "Emblem"),
  "82426": p("WY", "Greybull"),
  "82428": p("WY", "Hyattville"),
  "82431": p("WY", "Lovell"),
  "82432": p("WY", "Manderson"),
  "82434": p("WY", "Otto"),
  "82441": p("WY", "Shell"),
  "82716": p("WY", "Gillette"),
  "82717": p("WY", "Gillette"),
  "82718": p("WY", "Gillette"),
  "82725": p("WY", "Recluse"),
  "82727": p("WY", "Rozet"),
  "82731": p("WY", "Weston"),
  "82732": p("WY", "Wright"),
  "82301": p("WY", "Rawlins"),
  "82321": p("WY", "Baggs"),
  "82323": p("WY", "Dixon"),
  "82324": p("WY", "Elk Mountain"),
  "82325": p("WY", "Encampment"),
  "82327": p("WY", "Hanna"),
  "82329": p("WY", "Medicine Bow"),
  "82331": p("WY", "Saratoga"),
  "82332": p("WY", "Savery"),
  "82334": p("WY", "Sinclair"),
  "82335": p("WY", "Walcott"),
  "82615": p("WY", "Shirley Basin"),
  "82224": p("WY", "Lost Springs"),
  "82229": p("WY", "Shawnee"),
  "82633": p("WY", "Douglas"),
  "82637": p("WY", "Glenrock"),
  "82710": p("WY", "Aladdin"),
  "82711": p("WY", "Alva"),
  "82712": p("WY", "Beulah"),
  "82714": p("WY", "Devils Tower"),
  "82720": p("WY", "Hulett"),
  "82721": p("WY", "Moorcroft"),
  "82729": p("WY", "Sundance"),
  "82310": p("WY", "Jeffrey City"),
  "82501": p("WY", "Riverton"),
  "82510": p("WY", "Arapahoe"),
  "82512": p("WY", "Crowheart"),
  "82513": p("WY", "Dubois"),
  "82514": p("WY", "Fort Washakie"),
  "82515": p("WY", "Hudson"),
  "82516": p("WY", "Kinnear"),
  "82520": p("WY", "Lander"),
  "82523": p("WY", "Pavillion"),
  "82524": p("WY", "Saint Stephens"),
  "82642": p("WY", "Lysite"),
  "82649": p("WY", "Shoshoni"),
  "82212": p("WY", "Fort Laramie"),
  "82217": p("WY", "Hawk Springs"),
  "82218": p("WY", "Huntley"),
  "82219": p("WY", "Jay Em"),
  "82221": p("WY", "Lagrange"),
  "82223": p("WY", "Lingle"),
  "82240": p("WY", "Torrington"),
  "82243": p("WY", "Veteran"),
  "82244": p("WY", "Yoder"),
  "82430": p("WY", "Kirby"),
  "82443": p("WY", "Thermopolis"),
  "82639": p("WY", "Kaycee"),
  "82640": p("WY", "Linch"),
  "82834": p("WY", "Buffalo"),
  "82840": p("WY", "Saddlestring"),
  "82001": p("WY", "Cheyenne"),
  "82002": p("WY", "Cheyenne"),
  "82003": p("WY", "Cheyenne"),
  "82005": p("WY", "Fe Warren Afb"),
  "82006": p("WY", "Cheyenne"),
  "82007": p("WY", "Cheyenne"),
  "82008": p("WY", "Cheyenne"),
  "82009": p("WY", "Cheyenne"),
  "82010": p("WY", "Cheyenne"),
  "82050": p("WY", "Albin"),
  "82053": p("WY", "Burns"),
  "82054": p("WY", "Carpenter"),
  "82059": p("WY", "Granite Canon"),
  "82060": p("WY", "Hillsdale"),
  "82061": p("WY", "Horse Creek"),
  "82081": p("WY", "Meriden"),
  "82082": p("WY", "Pine Bluffs"),
  "83101": p("WY", "Kemmerer"),
  "83110": p("WY", "Afton"),
  "83111": p("WY", "Auburn"),
  "83112": p("WY", "Bedford"),
  "83114": p("WY", "Cokeville"),
  "83116": p("WY", "Diamondville"),
  "83118": p("WY", "Etna"),
  "83119": p("WY", "Fairview"),
  "83120": p("WY", "Freedom"),
  "83121": p("WY", "Frontier"),
  "83122": p("WY", "Grover"),
  "83123": p("WY", "La Barge"),
  "83124": p("WY", "Opal"),
  "83126": p("WY", "Smoot"),
  "83127": p("WY", "Thayne"),
  "83128": p("WY", "Alpine"),
  "82601": p("WY", "Casper"),
  "82602": p("WY", "Casper"),
  "82604": p("WY", "Casper"),
  "82605": p("WY", "Casper"),
  "82609": p("WY", "Casper"),
  "82620": p("WY", "Alcova"),
  "82630": p("WY", "Arminto"),
  "82635": p("WY", "Edgerton"),
  "82636": p("WY", "Evansville"),
  "82638": p("WY", "Hiland"),
  "82643": p("WY", "Midwest"),
  "82644": p("WY", "Mills"),
  "82646": p("WY", "Natrona"),
  "82648": p("WY", "Powder River"),
  "82222": p("WY", "Lance Creek"),
  "82225": p("WY", "Lusk"),
  "82227": p("WY", "Manville"),
  "82242": p("WY", "Van Tassell"),
  "82190": p("WY", "Yellowstone National Park"),
  "82414": p("WY", "Cody"),
  "82423": p("WY", "Frannie"),
  "82433": p("WY", "Meeteetse"),
  "82435": p("WY", "Powell"),
  "82440": p("WY", "Ralston"),
  "82450": p("WY", "Wapiti"),
  "82201": p("WY", "Wheatland"),
  "82210": p("WY", "Chugwater"),
  "82213": p("WY", "Glendo"),
  "82214": p("WY", "Guernsey"),
  "82215": p("WY", "Hartville"),
  "82801": p("WY", "Sheridan"),
  "82831": p("WY", "Arvada"),
  "82832": p("WY", "Banner"),
  "82833": p("WY", "Big Horn"),
  "82835": p("WY", "Clearmont"),
  "82836": p("WY", "Dayton"),
  "82837": p("WY", "Leiter"),
  "82838": p("WY", "Parkman"),
  "82839": p("WY", "Ranchester"),
  "82842": p("WY", "Story"),
  "82844": p("WY", "Wolf"),
  "82845": p("WY", "Wyarno"),
  "82922": p("WY", "Bondurant"),
  "82923": p("WY", "Boulder"),
  "82925": p("WY", "Cora"),
  "82941": p("WY", "Pinedale"),
  "83113": p("WY", "Big Piney"),
  "83115": p("WY", "Daniel"),
  "82322": p("WY", "Bairoil"),
  "82336": p("WY", "Wamsutter"),
  "82901": p("WY", "Rock Springs"),
  "82902": p("WY", "Rock Springs"),
  "82929": p("WY", "Little America"),
  "82932": p("WY", "Farson"),
  "82934": p("WY", "Granger"),
  "82935": p("WY", "Green River"),
  "82938": p("WY", "Mc Kinnon"),
  "82942": p("WY", "Point Of Rocks"),
  "82943": p("WY", "Reliance"),
  "82945": p("WY", "Superior"),
  "83001": p("WY", "Jackson"),
  "83002": p("WY", "Jackson"),
  "83011": p("WY", "Kelly"),
  "83012": p("WY", "Moose"),
  "83013": p("WY", "Moran"),
  "83014": p("WY", "Wilson"),
  "83025": p("WY", "Teton Village"),
  "83414": p("WY", "Alta"),
  "82930": p("WY", "Evanston"),
  "82931": p("WY", "Evanston"),
  "82933": p("WY", "Fort Bridger"),
  "82936": p("WY", "Lonetree"),
  "82937": p("WY", "Lyman"),
  "82939": p("WY", "Mountain View"),
  "82944": p("WY", "Robertson"),
  "82401": p("WY", "Worland"),
  "82442": p("WY", "Ten Sleep"),
  "82701": p("WY", "Newcastle"),
  "82715": p("WY", "Four Corners"),
  "82723": p("WY", "Osage"),
  "82730": p("WY", "Upton"),
  "09001": p("", "APO AA"),
  "09007": p("", "APO AE"),
  "09008": p("", "APO AE"),
  "09009": p("", "APO AE"),
  "09012": p("", "APO AE"),
  "09014": p("", "APO AE"),
  "09021": p("", "APO AE"),
  "09025": p("", "APO AE"),
  "09026": p("", "APO AE"),
  "09028": p("", "APO AE"),
  "09031": p("", "APO AE"),
  "09033": p("", "APO AE"),
  "09034": p("", "APO AE"),
  "09036": p("", "APO AE"),
  "09039": p("", "APO AE"),
  "09041": p("", "APO AE"),
  "09044": p("", "APO AE"),
  "09046": p("", "APO AE"),
  "09047": p("", "APO AE"),
  "09050": p("", "APO AE"),
  "09052": p("", "APO AE"),
  "09053": p("", "APO AE"),
  "09054": p("", "APO AE"),
  "09056": p("", "APO AE"),
  "09057": p("", "APO AE"),
  "09058": p("", "APO AE"),
  "09059": p("", "APO AE"),
  "09060": p("", "APO AE"),
  "09063": p("", "APO AE"),
  "09064": p("", "APO AE"),
  "09066": p("", "APO AE"),
  "09067": p("", "APO AE"),
  "09068": p("", "APO AE"),
  "09069": p("", "APO AE"),
  "09070": p("", "APO AE"),
  "09071": p("", "APO AE"),
  "09072": p("", "APO AE"),
  "09073": p("", "APO AE"),
  "09074": p("", "APO AE"),
  "09077": p("", "APO AE"),
  "09078": p("", "APO AE"),
  "09079": p("", "APO AE"),
  "09080": p("", "APO AE"),
  "09081": p("", "APO AE"),
  "09082": p("", "APO AE"),
  "09086": p("", "APO AE"),
  "09089": p("", "APO AE"),
  "09090": p("", "APO AE"),
  "09091": p("", "APO AE"),
  "09094": p("", "APO AE"),
  "09095": p("", "APO AE"),
  "09096": p("", "APO AE"),
  "09097": p("", "APO AE"),
  "09098": p("", "APO AE"),
  "09099": p("", "APO AE"),
  "09100": p("", "APO AE"),
  "09102": p("", "APO AE"),
  "09103": p("", "APO AE"),
  "09104": p("", "APO AE"),
  "09107": p("", "APO AE"),
  "09108": p("", "APO AE"),
  "09110": p("", "APO AE"),
  "09111": p("", "APO AE"),
  "09112": p("", "APO AE"),
  "09114": p("", "APO AE"),
  "09123": p("", "APO AE"),
  "09126": p("", "APO AE"),
  "09128": p("", "APO AE"),
  "09130": p("", "APO AE"),
  "09131": p("", "APO AE"),
  "09132": p("", "APO AE"),
  "09136": p("", "APO AE"),
  "09137": p("", "APO AE"),
  "09138": p("", "APO AE"),
  "09139": p("", "APO AE"),
  "09140": p("", "APO AE"),
  "09141": p("", "APO AE"),
  "09142": p("", "APO AE"),
  "09143": p("", "APO AE"),
  "09144": p("", "APO AE"),
  "09154": p("", "APO AE"),
  "09156": p("", "APO AE"),
  "09157": p("", "APO AE"),
  "09160": p("", "APO AE"),
  "09162": p("", "APO AE"),
  "09164": p("", "APO AE"),
  "09165": p("", "APO AE"),
  "09166": p("", "APO AE"),
  "09169": p("", "APO AE"),
  "09171": p("", "APO AE"),
  "09172": p("", "APO AE"),
  "09173": p("", "APO AE"),
  "09175": p("", "APO AE"),
  "09176": p("", "APO AE"),
  "09177": p("", "APO AE"),
  "09178": p("", "APO AE"),
  "09180": p("", "APO AE"),
  "09182": p("", "APO AE"),
  "09183": p("", "APO AE"),
  "09184": p("", "APO AE"),
  "09185": p("", "APO AE"),
  "09186": p("", "APO AE"),
  "09187": p("", "APO AE"),
  "09189": p("", "APO AE"),
  "09192": p("", "APO AE"),
  "09196": p("", "APO AE"),
  "09202": p("", "APO AE"),
  "09205": p("", "APO AE"),
  "09211": p("", "APO AE"),
  "09212": p("", "APO AE"),
  "09213": p("", "APO AE"),
  "09214": p("", "APO AE"),
  "09215": p("", "APO AE"),
  "09216": p("", "APO AE"),
  "09220": p("", "APO AE"),
  "09222": p("", "APO AE"),
  "09225": p("", "APO AE"),
  "09226": p("", "APO AE"),
  "09227": p("", "APO AE"),
  "09228": p("", "APO AE"),
  "09229": p("", "APO AE"),
  "09233": p("", "APO AE"),
  "09235": p("", "APO AE"),
  "09237": p("", "APO AE"),
  "09239": p("", "APO AE"),
  "09242": p("", "APO AE"),
  "09244": p("", "APO AE"),
  "09245": p("", "APO AE"),
  "09248": p("", "APO AE"),
  "09249": p("", "APO AE"),
  "09250": p("", "APO AE"),
  "09251": p("", "APO AE"),
  "09252": p("", "APO AE"),
  "09258": p("", "APO AE"),
  "09259": p("", "APO AE"),
  "09261": p("", "APO AE"),
  "09262": p("", "APO AE"),
  "09263": p("", "APO AE"),
  "09264": p("", "APO AE"),
  "09265": p("", "APO AE"),
  "09279": p("", "APO AE"),
  "09281": p("", "APO AE"),
  "09305": p("", "APO AE"),
  "09333": p("", "APO AE"),
  "09351": p("", "APO AE"),
  "09352": p("", "APO AE"),
  "09353": p("", "APO AE"),
  "09354": p("", "APO AE"),
  "09355": p("", "APO AE"),
  "09358": p("", "APO AE"),
  "09359": p("", "APO AE"),
  "09360": p("", "APO AE"),
  "09405": p("", "APO AE"),
  "09415": p("", "FPO AE"),
  "09418": p("", "FPO AE"),
  "09419": p("", "FPO AE"),
  "09420": p("", "FPO AE"),
  "09421": p("", "FPO AE"),
  "09422": p("", "FPO AE"),
  "09447": p("", "APO AE"),
  "09448": p("", "APO AE"),
  "09449": p("", "APO AE"),
  "09450": p("", "APO AE"),
  "09456": p("", "APO AE"),
  "09459": p("", "APO AE"),
  "09461": p("", "APO AE"),
  "09462": p("", "APO AE"),
  "09463": p("", "APO AE"),
  "09464": p("", "APO AE"),
  "09467": p("", "APO AE"),
  "09468": p("", "APO AE"),
  "09469": p("", "APO AE"),
  "09470": p("", "APO AE"),
  "09471": p("", "APO AE"),
  "09472": p("", "APO AE"),
  "09494": p("", "APO AE"),
  "09495": p("", "APO AE"),
  "09497": p("", "APO AE"),
  "09498": p("", "APO AE"),
  "09499": p("", "APO AE"),
  "09508": p("", "FPO AE"),
  "09593": p("", "FPO AE"),
  "09596": p("", "FPO AE"),
  "09601": p("", "APO AE"),
  "09602": p("", "APO AE"),
  "09604": p("", "APO AE"),
  "09605": p("", "APO AE"),
  "09606": p("", "APO AE"),
  "09609": p("", "FPO AE"),
  "09610": p("", "APO AE"),
  "09613": p("", "APO AE"),
  "09618": p("", "APO AE"),
  "09619": p("", "FPO AE"),
  "09620": p("", "FPO AE"),
  "09621": p("", "FPO AE"),
  "09622": p("", "FPO AE"),
  "09624": p("", "APO AE"),
  "09625": p("", "FPO AE"),
  "09626": p("", "FPO AE"),
  "09627": p("", "FPO AE"),
  "09628": p("", "APO AE"),
  "09629": p("", "APO AE"),
  "09630": p("", "APO AE"),
  "09641": p("", "APO AE"),
  "09642": p("", "APO AE"),
  "09643": p("", "APO AE"),
  "09644": p("", "FPO AE"),
  "09645": p("", "FPO AE"),
  "09646": p("", "APO AE"),
  "09647": p("", "APO AE"),
  "09648": p("", "APO AE"),
  "09655": p("", "APO AE"),
  "09658": p("", "APO AE"),
  "09670": p("", "FPO AE"),
  "09680": p("", "APO AE"),
  "09681": p("", "APO AE"),
  "09682": p("", "APO AE"),
  "09683": p("", "APO AE"),
  "09694": p("", "APO AE"),
  "09703": p("", "APO AE"),
  "09704": p("", "APO AE"),
  "09705": p("", "APO AE"),
  "09706": p("", "APO AE"),
  "09707": p("", "APO AE"),
  "09708": p("", "APO AE"),
  "09709": p("", "APO AE"),
  "09713": p("", "APO AE"),
  "09714": p("", "APO AE"),
  "09715": p("", "APO AE"),
  "09716": p("", "APO AE"),
  "09717": p("", "APO AE"),
  "09718": p("", "APO AE"),
  "09719": p("", "APO AE"),
  "09720": p("", "APO AE"),
  "09721": p("", "APO AE"),
  "09722": p("", "APO AE"),
  "09723": p("", "APO AE"),
  "09724": p("", "APO AE"),
  "09725": p("", "APO AE"),
  "09726": p("", "APO AE"),
  "09727": p("", "FPO AE"),
  "09728": p("", "FPO AE"),
  "09729": p("", "FPO AE"),
  "09730": p("", "FPO AE"),
  "09731": p("", "FPO AE"),
  "09732": p("", "APO AE"),
  "09734": p("", "APO AE"),
  "09738": p("", "APO AE"),
  "09740": p("", "APO AE"),
  "09745": p("", "APO AE"),
  "09746": p("", "APO AE"),
  "09747": p("", "APO AE"),
  "09749": p("", "APO AE"),
  "09754": p("", "APO AE"),
  "09760": p("", "APO AE"),
  "09762": p("", "APO AE"),
  "09765": p("", "APO AE"),
  "09766": p("", "APO AE"),
  "09767": p("", "APO AE"),
  "09768": p("", "APO AE"),
  "09770": p("", "APO AE"),
  "09772": p("", "APO AE"),
  "09774": p("", "APO AE"),
  "09775": p("", "APO AE"),
  "09777": p("", "FPO AE"),
  "09802": p("", "APO AE"),
  "09803": p("", "APO AE"),
  "09804": p("", "APO AE"),
  "09805": p("", "APO AE"),
  "09806": p("", "APO AE"),
  "09808": p("", "APO AE"),
  "09809": p("", "APO AE"),
  "09810": p("", "APO AE"),
  "09811": p("", "APO AE"),
  "09812": p("", "APO AE"),
  "09813": p("", "APO AE"),
  "09814": p("", "APO AE"),
  "09815": p("", "APO AE"),
  "09816": p("", "APO AE"),
  "09817": p("", "APO AE"),
  "09818": p("", "APO AE"),
  "09819": p("", "APO AE"),
  "09820": p("", "APO AE"),
  "09821": p("", "APO AE"),
  "09822": p("", "APO AE"),
  "09823": p("", "APO AE"),
  "09824": p("", "APO AE"),
  "09825": p("", "APO AE"),
  "09826": p("", "APO AE"),
  "09827": p("", "APO AE"),
  "09828": p("", "APO AE"),
  "09829": p("", "APO AE"),
  "09830": p("", "APO AE"),
  "09831": p("", "APO AE"),
  "09832": p("", "APO AE"),
  "09833": p("", "APO AE"),
  "09834": p("", "FPO AE"),
  "09835": p("", "FPO AE"),
  "09836": p("", "FPO AE"),
  "09837": p("", "FPO AE"),
  "09838": p("", "FPO AE"),
  "09839": p("", "APO AE"),
  "09840": p("", "APO AE"),
  "09841": p("", "APO AE"),
  "09842": p("", "APO AE"),
  "09843": p("", "FPO AE"),
  "09844": p("", "APO AE"),
  "09845": p("", "APO AE"),
  "09846": p("", "APO AE"),
  "09847": p("", "FPO AE"),
  "09848": p("", "APO AE"),
  "09850": p("", "APO AE"),
  "09851": p("", "APO AE"),
  "09852": p("", "APO AE"),
  "09853": p("", "APO AE"),
  "09855": p("", "APO AE"),
  "09858": p("", "APO AE"),
  "09861": p("", "APO AE"),
  "09864": p("", "APO AE"),
  "09865": p("", "FPO AE"),
  "09866": p("", "APO AE"),
  "09873": p("", "APO AA"),
  "09874": p("", "APO AA"),
  "09875": p("", "APO AA"),
  "09876": p("", "APO AA"),
  "09877": p("", "APO AA"),
  "09878": p("", "APO AE"),
  "09879": p("", "APO AA"),
  "09880": p("", "APO AE"),
  "09881": p("", "APO AA"),
  "09882": p("", "APO AA"),
  "09883": p("", "APO AA"),
  "09884": p("", "APO AA"),
  "09886": p("", "APO AA"),
  "09887": p("", "APO AA"),
  "09888": p("", "APO AA"),
  "09889": p("", "APO AA"),
  "09890": p("", "APO AE"),
  "09891": p("", "APO AA"),
  "09892": p("", "FPO AE"),
  "09893": p("", "APO AE"),
  "09894": p("", "APO AE"),
  "09895": p("", "APO AE"),
  "09896": p("", "APO AE"),
  "09897": p("", "APO AE"),
  "09898": p("", "APO AE"),
  "34002": p("", "APO AA"),
  "34003": p("", "APO AA"),
  "34004": p("", "APO AA"),
  "34005": p("", "APO AA"),
  "34006": p("", "APO AA"),
  "34007": p("", "APO AA"),
  "34008": p("", "APO AA"),
  "34009": p("", "APO AA"),
  "34010": p("", "APO AA"),
  "34011": p("", "APO AA"),
  "34020": p("", "APO AA"),
  "34021": p("", "APO AA"),
  "34022": p("", "APO AA"),
  "34023": p("", "APO AA"),
  "34024": p("", "APO AA"),
  "34030": p("", "APO AA"),
  "34031": p("", "APO AA"),
  "34032": p("", "APO AA"),
  "34033": p("", "APO AA"),
  "34034": p("", "APO AA"),
  "34035": p("", "APO AA"),
  "34036": p("", "APO AA"),
  "34037": p("", "APO AA"),
  "34038": p("", "APO AA"),
  "34039": p("", "APO AA"),
  "34040": p("", "APO AA"),
  "34041": p("", "APO AA"),
  "34042": p("", "APO AA"),
  "34045": p("", "APO AA"),
  "34046": p("", "APO AA"),
  "34050": p("", "FPO AA"),
  "34051": p("", "FPO AA"),
  "34053": p("", "FPO AA"),
  "34054": p("", "FPO AA"),
  "34058": p("", "FPO AA"),
  "34059": p("", "FPO AA"),
  "34060": p("", "FPO AA"),
  "34061": p("", "FPO AA"),
  "96201": p("", "APO AA"),
  "96202": p("", "APO AA"),
  "96203": p("", "APO AA"),
  "96204": p("", "APO AA"),
  "96205": p("", "APO AA"),
  "96206": p("", "APO AA"),
  "96207": p("", "APO AA"),
  "96208": p("", "APO AA"),
  "96212": p("", "APO AA"),
  "96213": p("", "APO AA"),
  "96214": p("", "APO AA"),
  "96216": p("", "APO AA"),
  "96218": p("", "APO AA"),
  "96220": p("", "APO AA"),
  "96224": p("", "APO AA"),
  "96231": p("", "APO AA"),
  "96236": p("", "APO AA"),
  "96257": p("", "APO AA"),
  "96258": p("", "APO AA"),
  "96259": p("", "APO AA"),
  "96260": p("", "APO AA"),
  "96261": p("", "APO AA"),
  "96264": p("", "APO AA"),
  "96266": p("", "APO AA"),
  "96267": p("", "APO AA"),
  "96269": p("", "FPO AA"),
  "96271": p("", "APO AA"),
  "96272": p("", "APO AA"),
  "96276": p("", "APO AA"),
  "96278": p("", "APO AA"),
  "96283": p("", "APO AA"),
  "96284": p("", "APO AA"),
  "96306": p("", "FPO AA"),
  "96310": p("", "FPO AA"),
  "96313": p("", "FPO AA"),
  "96318": p("", "APO AA"),
  "96319": p("", "APO AA"),
  "96321": p("", "FPO AA"),
  "96322": p("", "FPO AA"),
  "96323": p("", "APO AA"),
  "96325": p("", "APO AA"),
  "96326": p("", "APO AA"),
  "96328": p("", "APO AA"),
  "96330": p("", "APO AA"),
  "96336": p("", "APO AA"),
  "96337": p("", "APO AA"),
  "96338": p("", "APO AA"),
  "96339": p("", "APO AA"),
  "96343": p("", "APO AA"),
  "96347": p("", "FPO AA"),
  "96348": p("", "FPO AA"),
  "96349": p("", "FPO AA"),
  "96350": p("", "FPO AA"),
  "96362": p("", "FPO AA"),
  "96364": p("", "APO AA"),
  "96365": p("", "APO STA"),
  "96367": p("", "APO AA"),
  "96368": p("", "APO AA"),
  "96370": p("", "FPO AA"),
  "96372": p("", "FPO AA"),
  "96373": p("", "FPO AA"),
  "96374": p("", "APO AA"),
  "96375": p("", "FPO AA"),
  "96376": p("", "APO AA"),
  "96377": p("", "FPO AA"),
  "96378": p("", "APO AA"),
  "96379": p("", "FPO AA"),
  "96382": p("", "FPO AA"),
  "96390": p("", "APO AA"),
  "96407": p("", "APO AA"),
  "96408": p("", "APO AA"),
  "96409": p("", "APO AA"),
  "96410": p("", "APO AA"),
  "96411": p("", "APO AA"),
  "96415": p("", "FPO AA"),
  "96419": p("", "FPO AA"),
  "96428": p("", "APO AA"),
  "96431": p("", "APO AA"),
  "96432": p("", "APO AA"),
  "96434": p("", "APO AA"),
  "96440": p("", "APO AA"),
  "96445": p("", "FPO AA"),
  "96447": p("", "APO AA"),
  "96450": p("", "FPO AA"),
  "96451": p("", "FPO AA"),
  "96452": p("", "FPO AA"),
  "96454": p("", "FPO AA"),
  "96456": p("", "FPO AA"),
  "96468": p("", "APO AA"),
  "96498": p("", "APO AA"),
  "96505": p("", "FPO AA"),
  "96506": p("", "FPO AA"),
  "96507": p("", "FPO AA"),
  "96508": p("", "APO AA"),
  "96509": p("", "APO AA"),
  "96510": p("", "APO AA"),
  "96511": p("", "FPO AA"),
  "96512": p("", "APO AA"),
  "96513": p("", "APO AA"),
  "96514": p("", "FPO AA"),
  "96516": p("", "FPO AA"),
  "96517": p("", "FPO AA"),
  "96518": p("", "APO AA"),
  "96520": p("", "APO AA"),
  "96521": p("", "FPO AA"),
  "96522": p("", "FPO AA"),
  "96531": p("", "FPO AA"),
  "96534": p("", "FPO AA"),
  "96539": p("", "FPO AA"),
  "96540": p("", "FPO AA"),
  "96541": p("", "APO AA"),
  "96542": p("", "APO AA"),
  "96543": p("", "APO AA"),
  "96546": p("", "APO AA"),
  "96548": p("", "APO AA"),
  "96549": p("", "APO AA"),
  "96550": p("", "FPO AA"),
  "96551": p("", "APO AA"),
  "96552": p("", "APO AA"),
  "96553": p("", "APO AA"),
  "96554": p("", "APO AA"),
  "96556": p("", "APO AA"),
  "96558": p("", "APO AA"),
  "96598": p("", "FPO AA"),
  "96599": p("", "FPO AA"),
};
export default map;
